
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6834"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6834"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $jN4Ph = parcelRequire("jN4Ph");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $jN4Ph.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $jN4Ph.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $jN4Ph.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $jN4Ph.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $jN4Ph.unstable_now, $0b2e6adb871a3b94$var$ec = $jN4Ph.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $jN4Ph.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $jN4Ph.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $jN4Ph.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $jN4Ph.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $jN4Ph.unstable_scheduleCallback($jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("jN4Ph", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2ZUhe"));

});
parcelRegister("2ZUhe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $22eceeba251b2de5$export$c4744153514ff05d, (v) => $22eceeba251b2de5$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $22eceeba251b2de5$export$3e506c1ccc9cc1a7, (v) => $22eceeba251b2de5$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $22eceeba251b2de5$export$e26fe2ed2fa76875, (v) => $22eceeba251b2de5$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $22eceeba251b2de5$export$502329bbf4b505b1, (v) => $22eceeba251b2de5$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $22eceeba251b2de5$export$6e3807111c4874c4, (v) => $22eceeba251b2de5$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $22eceeba251b2de5$export$c27134553091fb3a, (v) => $22eceeba251b2de5$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $22eceeba251b2de5$export$33ee1acdc04fd2a2, (v) => $22eceeba251b2de5$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $22eceeba251b2de5$export$b00a404bbd5edef2, (v) => $22eceeba251b2de5$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $22eceeba251b2de5$export$8352ce38b91d0c62, (v) => $22eceeba251b2de5$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $22eceeba251b2de5$export$d66a1c1c77bd778b, (v) => $22eceeba251b2de5$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $22eceeba251b2de5$export$d3dfb8e4810cb555, (v) => $22eceeba251b2de5$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $22eceeba251b2de5$export$839f9183b0465a69, (v) => $22eceeba251b2de5$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $22eceeba251b2de5$export$72fdf0e06517287b, (v) => $22eceeba251b2de5$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $22eceeba251b2de5$export$4b844e58a3e414b4, (v) => $22eceeba251b2de5$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $22eceeba251b2de5$export$816d2913ae6b83b1, (v) => $22eceeba251b2de5$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $22eceeba251b2de5$export$61bcfe829111a1d0, (v) => $22eceeba251b2de5$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $22eceeba251b2de5$export$7ee8c9beb337bc3f, (v) => $22eceeba251b2de5$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $22eceeba251b2de5$export$b5836b71941fa3ed, (v) => $22eceeba251b2de5$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $22eceeba251b2de5$export$cf845f2c119da08a, (v) => $22eceeba251b2de5$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22eceeba251b2de5$export$c4744153514ff05d;
var $22eceeba251b2de5$export$3e506c1ccc9cc1a7;
var $22eceeba251b2de5$export$e26fe2ed2fa76875;
var $22eceeba251b2de5$export$502329bbf4b505b1;
var $22eceeba251b2de5$export$6e3807111c4874c4;
var $22eceeba251b2de5$export$c27134553091fb3a;
var $22eceeba251b2de5$export$33ee1acdc04fd2a2;
var $22eceeba251b2de5$export$b00a404bbd5edef2;
var $22eceeba251b2de5$export$8352ce38b91d0c62;
var $22eceeba251b2de5$export$d66a1c1c77bd778b;
var $22eceeba251b2de5$export$d3dfb8e4810cb555;
var $22eceeba251b2de5$export$839f9183b0465a69;
var $22eceeba251b2de5$export$72fdf0e06517287b;
var $22eceeba251b2de5$export$4b844e58a3e414b4;
var $22eceeba251b2de5$export$816d2913ae6b83b1;
var $22eceeba251b2de5$export$61bcfe829111a1d0;
var $22eceeba251b2de5$export$7ee8c9beb337bc3f;
var $22eceeba251b2de5$export$b5836b71941fa3ed;
var $22eceeba251b2de5$export$cf845f2c119da08a;
'use strict';
function $22eceeba251b2de5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $22eceeba251b2de5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $22eceeba251b2de5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $22eceeba251b2de5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $22eceeba251b2de5$var$g(C, c)) n < e && 0 > $22eceeba251b2de5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $22eceeba251b2de5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $22eceeba251b2de5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $22eceeba251b2de5$var$l = performance;
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$l.now();
    };
} else {
    var $22eceeba251b2de5$var$p = Date, $22eceeba251b2de5$var$q = $22eceeba251b2de5$var$p.now();
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$p.now() - $22eceeba251b2de5$var$q;
    };
}
var $22eceeba251b2de5$var$r = [], $22eceeba251b2de5$var$t = [], $22eceeba251b2de5$var$u = 1, $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = 3, $22eceeba251b2de5$var$z = !1, $22eceeba251b2de5$var$A = !1, $22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$D = "function" === typeof setTimeout ? setTimeout : null, $22eceeba251b2de5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $22eceeba251b2de5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $22eceeba251b2de5$var$G(a) {
    for(var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t); null !== b;){
        if (null === b.callback) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t);
        else if (b.startTime <= a) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t), b.sortIndex = b.expirationTime, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, b);
        else break;
        b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
    }
}
function $22eceeba251b2de5$var$H(a) {
    $22eceeba251b2de5$var$B = !1;
    $22eceeba251b2de5$var$G(a);
    if (!$22eceeba251b2de5$var$A) {
        if (null !== $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r)) $22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J);
        else {
            var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== b && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, b.startTime - a);
        }
    }
}
function $22eceeba251b2de5$var$J(a, b) {
    $22eceeba251b2de5$var$A = !1;
    $22eceeba251b2de5$var$B && ($22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1);
    $22eceeba251b2de5$var$z = !0;
    var c = $22eceeba251b2de5$var$y;
    try {
        $22eceeba251b2de5$var$G(b);
        for($22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r); null !== $22eceeba251b2de5$var$v && (!($22eceeba251b2de5$var$v.expirationTime > b) || a && !$22eceeba251b2de5$var$M());){
            var d = $22eceeba251b2de5$var$v.callback;
            if ("function" === typeof d) {
                $22eceeba251b2de5$var$v.callback = null;
                $22eceeba251b2de5$var$y = $22eceeba251b2de5$var$v.priorityLevel;
                var e = d($22eceeba251b2de5$var$v.expirationTime <= b);
                b = $22eceeba251b2de5$export$c4744153514ff05d();
                "function" === typeof e ? $22eceeba251b2de5$var$v.callback = e : $22eceeba251b2de5$var$v === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
                $22eceeba251b2de5$var$G(b);
            } else $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
            $22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
        }
        if (null !== $22eceeba251b2de5$var$v) var w = !0;
        else {
            var m = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== m && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = c, $22eceeba251b2de5$var$z = !1;
    }
}
var $22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null, $22eceeba251b2de5$var$L = -1, $22eceeba251b2de5$var$P = 5, $22eceeba251b2de5$var$Q = -1;
function $22eceeba251b2de5$var$M() {
    return $22eceeba251b2de5$export$c4744153514ff05d() - $22eceeba251b2de5$var$Q < $22eceeba251b2de5$var$P ? !1 : !0;
}
function $22eceeba251b2de5$var$R() {
    if (null !== $22eceeba251b2de5$var$O) {
        var a = $22eceeba251b2de5$export$c4744153514ff05d();
        $22eceeba251b2de5$var$Q = a;
        var b = !0;
        try {
            b = $22eceeba251b2de5$var$O(!0, a);
        } finally{
            b ? $22eceeba251b2de5$var$S() : ($22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null);
        }
    } else $22eceeba251b2de5$var$N = !1;
}
var $22eceeba251b2de5$var$S;
if ("function" === typeof $22eceeba251b2de5$var$F) $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$F($22eceeba251b2de5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $22eceeba251b2de5$var$T = new MessageChannel, $22eceeba251b2de5$var$U = $22eceeba251b2de5$var$T.port2;
    $22eceeba251b2de5$var$T.port1.onmessage = $22eceeba251b2de5$var$R;
    $22eceeba251b2de5$var$S = function() {
        $22eceeba251b2de5$var$U.postMessage(null);
    };
} else $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$D($22eceeba251b2de5$var$R, 0);
};
function $22eceeba251b2de5$var$I(a) {
    $22eceeba251b2de5$var$O = a;
    $22eceeba251b2de5$var$N || ($22eceeba251b2de5$var$N = !0, $22eceeba251b2de5$var$S());
}
function $22eceeba251b2de5$var$K(a, b) {
    $22eceeba251b2de5$var$L = $22eceeba251b2de5$var$D(function() {
        a($22eceeba251b2de5$export$c4744153514ff05d());
    }, b);
}
$22eceeba251b2de5$export$3e506c1ccc9cc1a7 = 5;
$22eceeba251b2de5$export$e26fe2ed2fa76875 = 1;
$22eceeba251b2de5$export$502329bbf4b505b1 = 4;
$22eceeba251b2de5$export$6e3807111c4874c4 = 3;
$22eceeba251b2de5$export$c27134553091fb3a = null;
$22eceeba251b2de5$export$33ee1acdc04fd2a2 = 2;
$22eceeba251b2de5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$22eceeba251b2de5$export$8352ce38b91d0c62 = function() {
    $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J));
};
$22eceeba251b2de5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $22eceeba251b2de5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$22eceeba251b2de5$export$d3dfb8e4810cb555 = function() {
    return $22eceeba251b2de5$var$y;
};
$22eceeba251b2de5$export$839f9183b0465a69 = function() {
    return $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
};
$22eceeba251b2de5$export$72fdf0e06517287b = function(a) {
    switch($22eceeba251b2de5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $22eceeba251b2de5$var$y;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = b;
    try {
        return a();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$4b844e58a3e414b4 = function() {};
$22eceeba251b2de5$export$816d2913ae6b83b1 = function() {};
$22eceeba251b2de5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = a;
    try {
        return b();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $22eceeba251b2de5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $22eceeba251b2de5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$t, a), null === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && a === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t) && ($22eceeba251b2de5$var$B ? ($22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1) : $22eceeba251b2de5$var$B = !0, $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, c - d))) : (a.sortIndex = e, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, a), $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J)));
    return a;
};
$22eceeba251b2de5$export$b5836b71941fa3ed = $22eceeba251b2de5$var$M;
$22eceeba251b2de5$export$cf845f2c119da08a = function(a) {
    var b = $22eceeba251b2de5$var$y;
    return function() {
        var c = $22eceeba251b2de5$var$y;
        $22eceeba251b2de5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $22eceeba251b2de5$var$y = c;
        }
    };
};

});



parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("fYgYF", function(module, exports) {

$parcel$export(module.exports, "Button", () => $f196df716a850340$export$353f5b6fc5456de1);
$parcel$export(module.exports, "Primary", () => $f196df716a850340$export$f82f6251c48c818a);
$parcel$export(module.exports, "Secondary", () => $f196df716a850340$export$fe115c0fdaabaa29);
$parcel$export(module.exports, "Outline", () => $f196df716a850340$export$5beeae30d1389e5);
$parcel$export(module.exports, "Ghost", () => $f196df716a850340$export$c0bd6680a351a7b4);
$parcel$export(module.exports, "Danger", () => $f196df716a850340$export$95d05bdc75950145);
$parcel$export(module.exports, "Success", () => $f196df716a850340$export$ffa3d9fee6fd705a);

var $ayMG0 = parcelRequire("ayMG0");


var $9QePP = parcelRequire("9QePP");
parcelRequire("acw62");
const $f196df716a850340$var$styles = {
    base: [
        // Base
        'relative isolate inline-flex items-center justify-center gap-x-2 rounded-lg border text-base/6 font-semibold',
        // Sizing
        'px-[calc(theme(spacing.3.5)-1px)] py-[calc(theme(spacing.2.5)-1px)] sm:px-[calc(theme(spacing.3)-1px)] sm:py-[calc(theme(spacing.1.5)-1px)] sm:text-sm/6',
        // Focus
        'focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
        // Disabled
        'disabled:opacity-50 disabled:cursor-not-allowed',
        // Icon
        '*:data-[slot=icon]:-mx-0.5 *:data-[slot=icon]:my-0.5 *:data-[slot=icon]:size-5 *:data-[slot=icon]:shrink-0'
    ],
    solid: [
        // Optical border, implemented as the button background to avoid corner artifacts
        'border-transparent',
        // Button background
        'bg-[#004d40]',
        // Dark mode: Subtle white outline is applied using a border
        'dark:border-white/5',
        // Hover state
        'hover:bg-[#00695c] active:bg-[#00695c]',
        // Text color
        'text-white',
        // Disabled
        'disabled:opacity-70'
    ],
    outline: [
        // Base
        'border-zinc-950/10 text-zinc-950 hover:bg-zinc-950/[2.5%] active:bg-zinc-950/[2.5%]',
        // Dark mode
        'dark:border-white/15 dark:text-white dark:hover:bg-white/5 dark:active:bg-white/5'
    ],
    ghost: [
        // Base
        'border-transparent text-zinc-950 hover:bg-zinc-950/5 active:bg-zinc-950/5',
        // Dark mode
        'dark:text-white dark:hover:bg-white/10 dark:active:bg-white/10'
    ],
    danger: [
        'bg-red-600 text-white border-red-700/90 hover:bg-red-500'
    ],
    success: [
        'bg-green-600 text-white border-green-700/90 hover:bg-green-500'
    ],
    colors: {
        primary: [
            'bg-[#004d40] text-white border-[#005d50]/90 hover:bg-[#00695c]'
        ],
        secondary: [
            'bg-zinc-600 text-white border-zinc-700/90 hover:bg-zinc-500'
        ],
        blue: [
            'bg-blue-600 text-white border-blue-700/90 hover:bg-blue-500'
        ]
    },
    sizes: {
        xs: 'px-2.5 py-1.5 text-xs',
        sm: 'px-3 py-2 text-sm',
        md: 'px-4 py-2 text-base',
        lg: 'px-5 py-2.5 text-lg',
        xl: 'px-6 py-3 text-xl'
    }
};
/**
 * Expand the hit area to at least 44×44px on touch devices
 */ function $f196df716a850340$var$TouchTarget({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "absolute top-1/2 left-1/2 size-[max(100%,2.75rem)] -translate-x-1/2 -translate-y-1/2 [@media(pointer:fine)]:hidden",
                "aria-hidden": "true"
            }),
            children
        ]
    });
}
const $f196df716a850340$export$353f5b6fc5456de1 = ({ children: children, className: className = '', variant: variant = 'primary', size: size = 'md', fullWidth: fullWidth = false, loading: loading = false, disabled: disabled = false, icon: icon = null, iconPosition: iconPosition = 'left', as: Component = 'button', ...props })=>{
    // Map variant to appropriate style
    let buttonStyle;
    if (variant === 'primary') buttonStyle = (0, $9QePP.default)($f196df716a850340$var$styles.solid, $f196df716a850340$var$styles.colors.primary);
    else if (variant === 'secondary') buttonStyle = (0, $9QePP.default)($f196df716a850340$var$styles.solid, $f196df716a850340$var$styles.colors.secondary);
    else if (variant === 'outline') buttonStyle = $f196df716a850340$var$styles.outline;
    else if (variant === 'ghost') buttonStyle = $f196df716a850340$var$styles.ghost;
    else if (variant === 'danger') buttonStyle = (0, $9QePP.default)($f196df716a850340$var$styles.solid, $f196df716a850340$var$styles.danger);
    else if (variant === 'success') buttonStyle = (0, $9QePP.default)($f196df716a850340$var$styles.solid, $f196df716a850340$var$styles.success);
    else if (variant === 'blue') buttonStyle = (0, $9QePP.default)($f196df716a850340$var$styles.solid, $f196df716a850340$var$styles.colors.blue);
    else buttonStyle = (0, $9QePP.default)($f196df716a850340$var$styles.solid, $f196df716a850340$var$styles.colors.primary);
    // Combine all classes
    const classes = (0, $9QePP.default)($f196df716a850340$var$styles.base, buttonStyle, $f196df716a850340$var$styles.sizes[size], fullWidth && 'w-full', className);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: classes,
        disabled: disabled || loading,
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f196df716a850340$var$TouchTarget, {
            children: [
                icon && iconPosition === 'left' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "mr-2",
                    children: icon
                }),
                loading ? 'Loading...' : children,
                icon && iconPosition === 'right' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "ml-2",
                    children: icon
                })
            ]
        })
    });
};
const $f196df716a850340$export$f82f6251c48c818a = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "primary",
        ...props
    });
const $f196df716a850340$export$fe115c0fdaabaa29 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "secondary",
        ...props
    });
const $f196df716a850340$export$5beeae30d1389e5 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "outline",
        ...props
    });
const $f196df716a850340$export$c0bd6680a351a7b4 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "ghost",
        ...props
    });
const $f196df716a850340$export$95d05bdc75950145 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "danger",
        ...props
    });
const $f196df716a850340$export$ffa3d9fee6fd705a = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "success",
        ...props
    });
const $f196df716a850340$export$c9cacf6069bed432 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f196df716a850340$export$353f5b6fc5456de1, {
        variant: "blue",
        ...props
    });

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});

parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});


parcelRegister("67mnf", function(module, exports) {

$parcel$export(module.exports, "Card", () => $816c0645f86a8e36$export$60332b2344f7fe41);
$parcel$export(module.exports, "CardHeader", () => $816c0645f86a8e36$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardTitle", () => $816c0645f86a8e36$export$474db65c3c394e1c);
$parcel$export(module.exports, "CardDescription", () => $816c0645f86a8e36$export$16e0ed4cb97c00d4);
$parcel$export(module.exports, "CardContent", () => $816c0645f86a8e36$export$64ef9b8c11710c47);
$parcel$export(module.exports, "CardFooter", () => $816c0645f86a8e36$export$e9897d434e0741ee);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $816c0645f86a8e36$var$styles = {
    base: [
        'relative overflow-hidden rounded-xl border bg-white shadow-sm',
        'dark:bg-zinc-900 dark:border-white/10 dark:shadow-zinc-950/50'
    ],
    padding: {
        none: '',
        sm: 'p-3 sm:p-4',
        md: 'p-4 sm:p-6',
        lg: 'p-6 sm:p-8'
    }
};
const $816c0645f86a8e36$export$60332b2344f7fe41 = ({ className: className = '', children: children, padding: padding = 'md', elevated: elevated = false, noBorder: noBorder = false, as: Component = 'div', ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)($816c0645f86a8e36$var$styles.base, $816c0645f86a8e36$var$styles.padding[padding], elevated && 'shadow-md', noBorder && 'border-0', className),
        ...props,
        children: children
    });
};
const $816c0645f86a8e36$export$5665775b26e26c5d = ({ className: className = '', children: children, divided: divided = false, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('mb-4', divided && 'pb-4 border-b border-gray-200 dark:border-zinc-800', className),
        ...props,
        children: children
    });
const $816c0645f86a8e36$export$474db65c3c394e1c = ({ className: className = '', children: children, as: Component = 'h3', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('text-lg font-semibold leading-tight text-gray-900 dark:text-white', className),
        ...props,
        children: children
    });
const $816c0645f86a8e36$export$16e0ed4cb97c00d4 = ({ className: className = '', children: children, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: (0, $9QePP.default)('mt-1 text-sm text-gray-500 dark:text-gray-400', className),
        ...props,
        children: children
    });
const $816c0645f86a8e36$export$64ef9b8c11710c47 = ({ className: className = '', children: children, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('', className),
        ...props,
        children: children
    });
const $816c0645f86a8e36$export$e9897d434e0741ee = ({ className: className = '', children: children, divided: divided = false, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('mt-4', divided && 'pt-4 border-t border-gray-200 dark:border-zinc-800', className),
        ...props,
        children: children
    });
const $816c0645f86a8e36$export$408776bb88ffa78b = ({ children: children, className: className = '', divider: divider = true })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `
    ${divider ? 'border-t border-gray-200 mt-6 pt-6 first:border-0 first:mt-0 first:pt-0' : ''}
    ${className}
  `,
        children: children
    });

});

parcelRegister("2Q0xG", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $0969129631e2415c$export$a8a3e93435678ff9);
$parcel$export(module.exports, "H1", () => $0969129631e2415c$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $0969129631e2415c$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $0969129631e2415c$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $0969129631e2415c$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $0969129631e2415c$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $0969129631e2415c$export$a559fb8039b06400);
$parcel$export(module.exports, "Text", () => $0969129631e2415c$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Lead", () => $0969129631e2415c$export$ba4d7ae5fb67789e);
$parcel$export(module.exports, "Muted", () => $0969129631e2415c$export$6088f516e809593c);
$parcel$export(module.exports, "Small", () => $0969129631e2415c$export$148e312beb132853);
$parcel$export(module.exports, "Link", () => $0969129631e2415c$export$a6c7ac8248d6e38a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $0969129631e2415c$var$headingStyles = {
    h1: 'text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl',
    h2: 'text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl',
    h3: 'text-2xl font-bold tracking-tight text-gray-900 dark:text-white',
    h4: 'text-xl font-bold tracking-tight text-gray-900 dark:text-white',
    h5: 'text-lg font-semibold tracking-tight text-gray-900 dark:text-white',
    h6: 'text-base font-semibold tracking-tight text-gray-900 dark:text-white'
};
const $0969129631e2415c$var$textStyles = {
    body: 'text-base text-gray-600 dark:text-gray-400',
    lead: 'text-lg text-gray-600 dark:text-gray-400 leading-relaxed',
    muted: 'text-sm text-gray-500 dark:text-gray-500',
    small: 'text-xs text-gray-500 dark:text-gray-500'
};
const $0969129631e2415c$export$a8a3e93435678ff9 = ({ level: level = 'h2', children: children, className: className = '', as: as, ...props })=>{
    const Component = as || level;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)($0969129631e2415c$var$headingStyles[level], className),
        ...props,
        children: children
    });
};
const $0969129631e2415c$export$5523b16adee8048 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$a8a3e93435678ff9, {
        level: "h1",
        ...props
    });
const $0969129631e2415c$export$cb94397127ac9363 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$a8a3e93435678ff9, {
        level: "h2",
        ...props
    });
const $0969129631e2415c$export$746be9e3a3dfff1f = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$a8a3e93435678ff9, {
        level: "h3",
        ...props
    });
const $0969129631e2415c$export$cc5e069d64fda823 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$a8a3e93435678ff9, {
        level: "h4",
        ...props
    });
const $0969129631e2415c$export$88ef9fdaf11f7a1f = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$a8a3e93435678ff9, {
        level: "h5",
        ...props
    });
const $0969129631e2415c$export$a559fb8039b06400 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$a8a3e93435678ff9, {
        level: "h6",
        ...props
    });
const $0969129631e2415c$export$5f1af8db9871e1d6 = ({ variant: variant = 'body', children: children, className: className = '', as: as = 'p', ...props })=>{
    const Component = as;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)($0969129631e2415c$var$textStyles[variant], className),
        ...props,
        children: children
    });
};
const $0969129631e2415c$export$ba4d7ae5fb67789e = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$5f1af8db9871e1d6, {
        variant: "lead",
        ...props
    });
const $0969129631e2415c$export$6088f516e809593c = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$5f1af8db9871e1d6, {
        variant: "muted",
        ...props
    });
const $0969129631e2415c$export$148e312beb132853 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$5f1af8db9871e1d6, {
        variant: "small",
        ...props
    });
const $0969129631e2415c$export$358a232cca1ab2ac = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$5f1af8db9871e1d6, {
        ...props
    });
const $0969129631e2415c$export$4b2c32e08f77ff18 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0969129631e2415c$export$5f1af8db9871e1d6, {
        variant: "body",
        ...props
    });
const $0969129631e2415c$export$a6c7ac8248d6e38a = ({ children: children, className: className = '', href: href = '#', underline: underline = true, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: href,
        className: (0, $9QePP.default)('text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300', underline && 'underline underline-offset-2', className),
        ...props,
        children: children
    });
};

});

parcelRegister("e5fs2", function(module, exports) {

$parcel$export(module.exports, "Input", () => $64357bedc4c47385$export$f5b8910cec6cf069);
$parcel$export(module.exports, "TextField", () => $64357bedc4c47385$export$2c73285ae9390cec);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $64357bedc4c47385$var$styles = {
    base: [
        'block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6',
        'dark:bg-zinc-900 dark:text-white dark:placeholder:text-gray-500'
    ],
    variants: {
        default: [
            'ring-gray-300 focus:ring-blue-600',
            'dark:ring-gray-700 dark:focus:ring-blue-500'
        ],
        error: [
            'ring-red-500 focus:ring-red-600 text-red-900 placeholder:text-red-400',
            'dark:text-red-400 dark:placeholder:text-red-400'
        ],
        success: [
            'ring-green-500 focus:ring-green-600 text-green-900 placeholder:text-green-400',
            'dark:text-green-400 dark:placeholder:text-green-400'
        ]
    },
    sizes: {
        sm: 'px-2 py-1 text-sm',
        md: 'px-3 py-2',
        lg: 'px-4 py-3 text-lg'
    },
    disabled: 'opacity-50 cursor-not-allowed bg-gray-100 dark:bg-zinc-800',
    icon: 'pl-10'
};
const $64357bedc4c47385$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, value: value, onChange: onChange, placeholder: placeholder, type: type = 'text', className: className = '', error: error = '', helperText: helperText = '', required: required = false, disabled: disabled = false, name: name = '', variant: variant = 'default', size: size = 'md', icon: icon = null, fullWidth: fullWidth = true }, ref)=>{
    // Determine variant based on props
    let variantToUse = variant;
    if (error) variantToUse = 'error';
    const errorTextColor = 'text-red-600 dark:text-red-400';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)('relative', fullWidth ? 'w-full' : 'w-auto'),
        children: [
            label && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: (0, $9QePP.default)('block text-sm font-medium mb-1 text-gray-900 dark:text-gray-200', error && errorTextColor),
                children: [
                    label,
                    required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-red-500 ml-1",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: ref,
                        type: type,
                        value: value,
                        onChange: onChange,
                        placeholder: placeholder,
                        disabled: disabled,
                        name: name,
                        required: required,
                        className: (0, $9QePP.default)($64357bedc4c47385$var$styles.base, $64357bedc4c47385$var$styles.variants[variantToUse], $64357bedc4c47385$var$styles.sizes[size], icon && $64357bedc4c47385$var$styles.icon, disabled && $64357bedc4c47385$var$styles.disabled, className)
                    })
                ]
            }),
            (error || helperText) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)('mt-1 text-sm', error && errorTextColor, !error && 'text-gray-500 dark:text-gray-400'),
                id: `${name}-description`,
                children: error || helperText
            })
        ]
    });
});
$64357bedc4c47385$export$f5b8910cec6cf069.displayName = 'Input';
const $64357bedc4c47385$export$2c73285ae9390cec = $64357bedc4c47385$export$f5b8910cec6cf069;

});

parcelRegister("h4Kcn", function(module, exports) {

$parcel$export(module.exports, "Select", () => $226ff5c0d8468172$export$ef9b1a59e592288f);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $j9H4k = parcelRequire("j9H4k");
var $iymfR = parcelRequire("iymfR");

var $9QePP = parcelRequire("9QePP");
// SVG icons for the component
const $226ff5c0d8468172$var$ChevronDownIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-5 w-5",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
            clipRule: "evenodd"
        })
    });
const $226ff5c0d8468172$var$CheckIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-5 w-5",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
            clipRule: "evenodd"
        })
    });
const $226ff5c0d8468172$var$styles = {
    button: [
        'relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6',
        'dark:bg-zinc-900 dark:ring-gray-700 dark:text-white dark:focus:ring-blue-500'
    ],
    options: [
        'absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10',
        'dark:bg-zinc-800 dark:ring-gray-700'
    ],
    option: [
        'relative cursor-default select-none py-2 pl-10 pr-4',
        'ui-active:bg-blue-600 ui-active:text-white ui-not-active:text-gray-900',
        'dark:ui-not-active:text-white'
    ],
    icon: 'absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none',
    checkIcon: 'absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600 dark:text-blue-400',
    disabled: 'opacity-50 cursor-not-allowed bg-gray-100 dark:bg-zinc-800',
    sizes: {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg'
    },
    error: [
        'ring-red-500 focus:ring-red-600 text-red-900',
        'dark:text-red-400'
    ]
};
const $226ff5c0d8468172$export$ef9b1a59e592288f = ({ options: options = [], value: value = null, onChange: onChange, label: label = '', placeholder: placeholder = 'Select an option', className: className = '', disabled: disabled = false, error: error = false, helperText: helperText = '', size: size = 'md', valueKey: valueKey = 'value', labelKey: labelKey = 'label', fullWidth: fullWidth = true, ...props })=>{
    // Find the selected option object
    const selectedOption = options.find((option)=>typeof option === 'object' ? option[valueKey] === value : option === value);
    // Create a function to get label from option
    const getOptionLabel = (option)=>{
        if (option === null) return placeholder;
        return typeof option === 'object' ? option[labelKey] : option;
    };
    // Create a function to get value from option
    const getOptionValue = (option)=>{
        return typeof option === 'object' ? option[valueKey] : option;
    };
    const handleChange = (option)=>{
        onChange(getOptionValue(option));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $9QePP.default)('relative', fullWidth ? 'w-full' : 'w-auto'),
        children: [
            label && /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                className: "block text-sm font-medium mb-1 text-gray-900 dark:text-gray-200",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox), {
                value: selectedOption || null,
                onChange: handleChange,
                disabled: disabled,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "relative mt-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j9H4k.Listbox).Button, {
                            className: (0, $9QePP.default)($226ff5c0d8468172$var$styles.button, $226ff5c0d8468172$var$styles.sizes[size], disabled && $226ff5c0d8468172$var$styles.disabled, error && $226ff5c0d8468172$var$styles.error, className),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: (0, $9QePP.default)('block truncate', !selectedOption && 'text-gray-500'),
                                    children: selectedOption ? getOptionLabel(selectedOption) : placeholder
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: $226ff5c0d8468172$var$styles.icon,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($226ff5c0d8468172$var$ChevronDownIcon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                            as: (0, $acw62.Fragment),
                            leave: "transition ease-in duration-100",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox).Options, {
                                className: $226ff5c0d8468172$var$styles.options,
                                children: options.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $j9H4k.Listbox).Option, {
                                        className: ({ active: active })=>$226ff5c0d8468172$var$styles.option,
                                        value: option,
                                        children: ({ selected: selected })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: (0, $9QePP.default)('block truncate', selected ? 'font-medium' : 'font-normal'),
                                                        children: getOptionLabel(option)
                                                    }),
                                                    selected && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: $226ff5c0d8468172$var$styles.checkIcon,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($226ff5c0d8468172$var$CheckIcon, {})
                                                    })
                                                ]
                                            })
                                    }, index))
                            })
                        })
                    ]
                })
            }),
            (error || helperText) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: (0, $9QePP.default)('mt-1 text-sm', error ? 'text-red-600 dark:text-red-400' : 'text-gray-500 dark:text-gray-400'),
                children: error || helperText
            })
        ]
    });
};

});
parcelRegister("j9H4k", function(module, exports) {

$parcel$export(module.exports, "Listbox", () => $df20442161b20eb0$export$8bad31ff872c7659);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cE9hP = parcelRequire("cE9hP");

var $ePQFN = parcelRequire("ePQFN");

var $h26ct = parcelRequire("h26ct");

var $3X9lW = parcelRequire("3X9lW");

var $hd1nN = parcelRequire("hd1nN");

var $5Ai9V = parcelRequire("5Ai9V");

var $dfvrc = parcelRequire("dfvrc");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $gm4XX = parcelRequire("gm4XX");

var $hZodg = parcelRequire("hZodg");

var $6mpbl = parcelRequire("6mpbl");

var $jN7sP = parcelRequire("jN7sP");

var $ipity = parcelRequire("ipity");

var $bdknl = parcelRequire("bdknl");

var $brAF4 = parcelRequire("brAF4");

var $34Str = parcelRequire("34Str");

var $dBJH0 = parcelRequire("dBJH0");

var $9UPTU = parcelRequire("9UPTU");

var $jpbxo = parcelRequire("jpbxo");

var $auuNT = parcelRequire("auuNT");

var $5fYEB = parcelRequire("5fYEB");

var $fLrGx = parcelRequire("fLrGx");

var $1COYr = parcelRequire("1COYr");

var $hsQxB = parcelRequire("hsQxB");

var $7FnlJ = parcelRequire("7FnlJ");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $6AKlm = parcelRequire("6AKlm");

var $5qg9U = parcelRequire("5qg9U");

var $e9NTc = parcelRequire("e9NTc");
"use client";
var $df20442161b20eb0$var$gt = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($df20442161b20eb0$var$gt || {}), $df20442161b20eb0$var$Lt = ((o)=>(o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))($df20442161b20eb0$var$Lt || {}), $df20442161b20eb0$var$St = ((o)=>(o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))($df20442161b20eb0$var$St || {}), $df20442161b20eb0$var$Et = ((n)=>(n[n.OpenListbox = 0] = "OpenListbox", n[n.CloseListbox = 1] = "CloseListbox", n[n.GoToOption = 2] = "GoToOption", n[n.Search = 3] = "Search", n[n.ClearSearch = 4] = "ClearSearch", n[n.RegisterOption = 5] = "RegisterOption", n[n.UnregisterOption = 6] = "UnregisterOption", n[n.SetButtonElement = 7] = "SetButtonElement", n[n.SetOptionsElement = 8] = "SetOptionsElement", n))($df20442161b20eb0$var$Et || {});
function $df20442161b20eb0$var$be(e, i = (o)=>o) {
    let o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = (0, $hsQxB.sortByDomNode)(i(e.options.slice()), (m)=>m.dataRef.current.domRef.current), a = o ? r.indexOf(o) : null;
    return a === -1 && (a = null), {
        options: r,
        activeOptionIndex: a
    };
}
let $df20442161b20eb0$var$Pt = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
            ...e,
            activeOptionIndex: null,
            listboxState: 1,
            __demoMode: !1
        };
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let i = e.activeOptionIndex, { isSelected: o } = e.dataRef.current, r = e.options.findIndex((a)=>o(a.dataRef.current.value));
        return r !== -1 && (i = r), {
            ...e,
            listboxState: 0,
            activeOptionIndex: i,
            __demoMode: !1
        };
    },
    [2] (e, i) {
        var m, x, d, p, n;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let o = {
            ...e,
            searchQuery: "",
            activationTrigger: (m = i.trigger) != null ? m : 1,
            __demoMode: !1
        };
        if (i.focus === (0, $fLrGx.Focus).Nothing) return {
            ...o,
            activeOptionIndex: null
        };
        if (i.focus === (0, $fLrGx.Focus).Specific) return {
            ...o,
            activeOptionIndex: e.options.findIndex((u)=>u.id === i.id)
        };
        if (i.focus === (0, $fLrGx.Focus).Previous) {
            let u = e.activeOptionIndex;
            if (u !== null) {
                let P = e.options[u].dataRef.current.domRef, t = (0, $fLrGx.calculateActiveIndex)(i, {
                    resolveItems: ()=>e.options,
                    resolveActiveIndex: ()=>e.activeOptionIndex,
                    resolveId: (s)=>s.id,
                    resolveDisabled: (s)=>s.dataRef.current.disabled
                });
                if (t !== null) {
                    let s = e.options[t].dataRef.current.domRef;
                    if (((x = P.current) == null ? void 0 : x.previousElementSibling) === s.current || ((d = s.current) == null ? void 0 : d.previousElementSibling) === null) return {
                        ...o,
                        activeOptionIndex: t
                    };
                }
            }
        } else if (i.focus === (0, $fLrGx.Focus).Next) {
            let u = e.activeOptionIndex;
            if (u !== null) {
                let P = e.options[u].dataRef.current.domRef, t = (0, $fLrGx.calculateActiveIndex)(i, {
                    resolveItems: ()=>e.options,
                    resolveActiveIndex: ()=>e.activeOptionIndex,
                    resolveId: (s)=>s.id,
                    resolveDisabled: (s)=>s.dataRef.current.disabled
                });
                if (t !== null) {
                    let s = e.options[t].dataRef.current.domRef;
                    if (((p = P.current) == null ? void 0 : p.nextElementSibling) === s.current || ((n = s.current) == null ? void 0 : n.nextElementSibling) === null) return {
                        ...o,
                        activeOptionIndex: t
                    };
                }
            }
        }
        let r = $df20442161b20eb0$var$be(e), a = (0, $fLrGx.calculateActiveIndex)(i, {
            resolveItems: ()=>r.options,
            resolveActiveIndex: ()=>r.activeOptionIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return {
            ...o,
            ...r,
            activeOptionIndex: a
        };
    },
    [3]: (e, i)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let r = e.searchQuery !== "" ? 0 : 1, a = e.searchQuery + i.value.toLowerCase(), x = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((p)=>{
            var n;
            return !p.dataRef.current.disabled && ((n = p.dataRef.current.textValue) == null ? void 0 : n.startsWith(a));
        }), d = x ? e.options.indexOf(x) : -1;
        return d === -1 || d === e.activeOptionIndex ? {
            ...e,
            searchQuery: a
        } : {
            ...e,
            searchQuery: a,
            activeOptionIndex: d,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
            ...e,
            searchQuery: ""
        };
    },
    [5]: (e, i)=>{
        let o = {
            id: i.id,
            dataRef: i.dataRef
        }, r = $df20442161b20eb0$var$be(e, (a)=>[
                ...a,
                o
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(i.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(o)), {
            ...e,
            ...r
        };
    },
    [6]: (e, i)=>{
        let o = $df20442161b20eb0$var$be(e, (r)=>{
            let a = r.findIndex((m)=>m.id === i.id);
            return a !== -1 && r.splice(a, 1), r;
        });
        return {
            ...e,
            ...o,
            activationTrigger: 1
        };
    },
    [7]: (e, i)=>e.buttonElement === i.element ? e : {
            ...e,
            buttonElement: i.element
        },
    [8]: (e, i)=>e.optionsElement === i.element ? e : {
            ...e,
            optionsElement: i.element
        }
}, $df20442161b20eb0$var$Te = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$Te.displayName = "ListboxActionsContext";
function $df20442161b20eb0$var$Z(e) {
    let i = (0, $acw62.useContext)($df20442161b20eb0$var$Te);
    if (i === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $df20442161b20eb0$var$Z), o;
    }
    return i;
}
let $df20442161b20eb0$var$ee = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$ee.displayName = "ListboxDataContext";
function $df20442161b20eb0$var$Q(e) {
    let i = (0, $acw62.useContext)($df20442161b20eb0$var$ee);
    if (i === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $df20442161b20eb0$var$Q), o;
    }
    return i;
}
function $df20442161b20eb0$var$Rt(e, i) {
    return (0, $6Ngq1.match)(i.type, $df20442161b20eb0$var$Pt, e, i);
}
let $df20442161b20eb0$var$At = (0, $acw62.Fragment);
function $df20442161b20eb0$var$ht(e, i) {
    var me;
    let o = (0, $brAF4.useDisabled)(), { value: r, defaultValue: a, form: m, name: x, onChange: d, by: p, invalid: n = !1, disabled: u = o || !1, horizontal: P = !1, multiple: t = !1, __demoMode: s = !1, ...F } = e;
    const M = P ? "horizontal" : "vertical";
    let h = (0, $6mpbl.useSyncRefs)(i), D = (0, $3X9lW.useDefaultValue)(a), [O = t ? [] : void 0, g] = (0, $h26ct.useControllable)(r, d, D), [R, y] = (0, $acw62.useReducer)($df20442161b20eb0$var$Rt, {
        dataRef: (0, $acw62.createRef)(),
        listboxState: s ? 0 : 1,
        options: [],
        searchQuery: "",
        activeOptionIndex: null,
        activationTrigger: 1,
        optionsVisible: !1,
        buttonElement: null,
        optionsElement: null,
        __demoMode: s
    }), B = (0, $acw62.useRef)({
        static: !1,
        hold: !1
    }), w = (0, $acw62.useRef)(new Map), _ = (0, $ePQFN.useByComparator)(p), b = (0, $acw62.useCallback)((f)=>(0, $6Ngq1.match)(c.mode, {
            [1]: ()=>O.some((S)=>_(S, f)),
            [0]: ()=>_(O, f)
        }), [
        O
    ]), c = (0, $acw62.useMemo)(()=>({
            ...R,
            value: O,
            disabled: u,
            invalid: n,
            mode: t ? 1 : 0,
            orientation: M,
            compare: _,
            isSelected: b,
            optionsPropsRef: B,
            listRef: w
        }), [
        O,
        u,
        n,
        t,
        R,
        w
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        R.dataRef.current = c;
    }, [
        c
    ]);
    let N = c.listboxState === 0;
    (0, $23pTr.useOutsideClick)(N, [
        c.buttonElement,
        c.optionsElement
    ], (f, S)=>{
        var C;
        y({
            type: 1
        }), (0, $hsQxB.isFocusableElement)(S, (0, $hsQxB.FocusableMode).Loose) || (f.preventDefault(), (C = c.buttonElement) == null || C.focus());
    });
    let L = (0, $acw62.useMemo)(()=>({
            open: c.listboxState === 0,
            disabled: u,
            invalid: n,
            value: O
        }), [
        c,
        u,
        O,
        n
    ]), H = (0, $114Mg.useEvent)((f)=>{
        let S = c.options.find((C)=>C.id === f);
        S && K(S.dataRef.current.value);
    }), te = (0, $114Mg.useEvent)(()=>{
        if (c.activeOptionIndex !== null) {
            let { dataRef: f, id: S } = c.options[c.activeOptionIndex];
            K(f.current.value), y({
                type: 2,
                focus: (0, $fLrGx.Focus).Specific,
                id: S
            });
        }
    }), oe = (0, $114Mg.useEvent)(()=>y({
            type: 0
        })), X = (0, $114Mg.useEvent)(()=>y({
            type: 1
        })), J = (0, $5Ai9V.useDisposables)(), ne = (0, $114Mg.useEvent)((f, S, C)=>{
        J.dispose(), J.microTask(()=>f === (0, $fLrGx.Focus).Specific ? y({
                type: 2,
                focus: (0, $fLrGx.Focus).Specific,
                id: S,
                trigger: C
            }) : y({
                type: 2,
                focus: f,
                trigger: C
            }));
    }), ie = (0, $114Mg.useEvent)((f, S)=>(y({
            type: 5,
            id: f,
            dataRef: S
        }), ()=>y({
                type: 6,
                id: f
            }))), K = (0, $114Mg.useEvent)((f)=>(0, $6Ngq1.match)(c.mode, {
            [0] () {
                return g == null ? void 0 : g(f);
            },
            [1] () {
                let S = c.value.slice(), C = S.findIndex((Re)=>_(Re, f));
                return C === -1 ? S.push(f) : S.splice(C, 1), g == null ? void 0 : g(S);
            }
        })), re = (0, $114Mg.useEvent)((f)=>y({
            type: 3,
            value: f
        })), $ = (0, $114Mg.useEvent)(()=>y({
            type: 4
        })), q = (0, $114Mg.useEvent)((f)=>{
        y({
            type: 7,
            element: f
        });
    }), l = (0, $114Mg.useEvent)((f)=>{
        y({
            type: 8,
            element: f
        });
    }), I = (0, $acw62.useMemo)(()=>({
            onChange: K,
            registerOption: ie,
            goToOption: ne,
            closeListbox: X,
            openListbox: oe,
            selectActiveOption: te,
            selectOption: H,
            search: re,
            clearSearch: $,
            setButtonElement: q,
            setOptionsElement: l
        }), []), [G, le] = (0, $5qg9U.useLabels)({
        inherit: !0
    }), Se = {
        ref: h
    }, Ee = (0, $acw62.useCallback)(()=>{
        if (D !== void 0) return g == null ? void 0 : g(D);
    }, [
        g,
        D
    ]), Pe = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(le, {
        value: G,
        props: {
            htmlFor: (me = c.buttonElement) == null ? void 0 : me.id
        },
        slot: {
            open: c.listboxState === 0,
            disabled: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34Str.FloatingProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$Te.Provider, {
        value: I
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$ee.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(c.listboxState, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, x != null && O != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dBJH0.FormFields), {
        disabled: u,
        data: {
            [x]: O
        },
        form: m,
        onReset: Ee
    }), Pe({
        ourProps: Se,
        theirProps: F,
        slot: L,
        defaultTag: $df20442161b20eb0$var$At,
        name: "Listbox"
    }))))));
}
let $df20442161b20eb0$var$Dt = "button";
function $df20442161b20eb0$var$_t(e, i) {
    var N;
    let o = $df20442161b20eb0$var$Q("Listbox.Button"), r = $df20442161b20eb0$var$Z("Listbox.Button"), a = (0, $acw62.useId)(), m = (0, $jpbxo.useProvidedId)(), { id: x = m || `headlessui-listbox-button-${a}`, disabled: d = o.disabled || !1, autoFocus: p = !1, ...n } = e, u = (0, $6mpbl.useSyncRefs)(i, (0, $34Str.useFloatingReference)(), r.setButtonElement), P = (0, $34Str.useFloatingReferenceProps)(), t = (0, $114Mg.useEvent)((L)=>{
        switch(L.key){
            case (0, $6AKlm.Keys).Enter:
                (0, $7FnlJ.attemptSubmit)(L.currentTarget);
                break;
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).ArrowDown:
                L.preventDefault(), (0, $1u0KT.flushSync)(()=>r.openListbox()), o.value || r.goToOption((0, $fLrGx.Focus).First);
                break;
            case (0, $6AKlm.Keys).ArrowUp:
                L.preventDefault(), (0, $1u0KT.flushSync)(()=>r.openListbox()), o.value || r.goToOption((0, $fLrGx.Focus).Last);
                break;
        }
    }), s = (0, $114Mg.useEvent)((L)=>{
        switch(L.key){
            case (0, $6AKlm.Keys).Space:
                L.preventDefault();
                break;
        }
    }), F = (0, $114Mg.useEvent)((L)=>{
        var H;
        if ((0, $5fYEB.isDisabledReactIssue7711)(L.currentTarget)) return L.preventDefault();
        o.listboxState === 0 ? ((0, $1u0KT.flushSync)(()=>r.closeListbox()), (H = o.buttonElement) == null || H.focus({
            preventScroll: !0
        })) : (L.preventDefault(), r.openListbox());
    }), M = (0, $114Mg.useEvent)((L)=>L.preventDefault()), h = (0, $5qg9U.useLabelledBy)([
        x
    ]), D = (0, $iGb09.useDescribedBy)(), { isFocusVisible: O, focusProps: g } = (0, $kd7LS.useFocusRing)({
        autoFocus: p
    }), { isHovered: R, hoverProps: y } = (0, $6o6B3.useHover)({
        isDisabled: d
    }), { pressed: B, pressProps: w } = (0, $cE9hP.useActivePress)({
        disabled: d
    }), _ = (0, $acw62.useMemo)(()=>({
            open: o.listboxState === 0,
            active: B || o.listboxState === 0,
            disabled: d,
            invalid: o.invalid,
            value: o.value,
            hover: R,
            focus: O,
            autofocus: p
        }), [
        o.listboxState,
        o.value,
        d,
        R,
        O,
        B,
        o.invalid,
        p
    ]), b = (0, $ebRQH.mergeProps)(P(), {
        ref: u,
        id: x,
        type: (0, $gm4XX.useResolveButtonType)(e, o.buttonElement),
        "aria-haspopup": "listbox",
        "aria-controls": (N = o.optionsElement) == null ? void 0 : N.id,
        "aria-expanded": o.listboxState === 0,
        "aria-labelledby": h,
        "aria-describedby": D,
        disabled: d || void 0,
        autoFocus: p,
        onKeyDown: t,
        onKeyUp: s,
        onKeyPress: M,
        onClick: F
    }, g, y, w);
    return (0, $ebRQH.useRender)()({
        ourProps: b,
        theirProps: n,
        slot: _,
        defaultTag: $df20442161b20eb0$var$Dt,
        name: "Listbox.Button"
    });
}
let $df20442161b20eb0$var$Le = (0, $acw62.createContext)(!1), $df20442161b20eb0$var$It = "div", $df20442161b20eb0$var$Ct = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $df20442161b20eb0$var$Ft(e, i) {
    var $, q;
    let o = (0, $acw62.useId)(), { id: r = `headlessui-listbox-options-${o}`, anchor: a, portal: m = !1, modal: x = !0, transition: d = !1, ...p } = e, n = (0, $34Str.useResolvedAnchor)(a), [u, P] = (0, $acw62.useState)(null);
    n && (m = !0);
    let t = $df20442161b20eb0$var$Q("Listbox.Options"), s = $df20442161b20eb0$var$Z("Listbox.Options"), F = (0, $5IEAk.useOwnerDocument)(t.optionsElement), M = (0, $auuNT.useOpenClosed)(), [h, D] = (0, $bdknl.useTransition)(d, u, M !== null ? (M & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : t.listboxState === 0);
    (0, $dcp2r.useOnDisappear)(h, t.buttonElement, s.closeListbox);
    let O = t.__demoMode ? !1 : x && t.listboxState === 0;
    (0, $hZodg.useScrollLock)(O, F);
    let g = t.__demoMode ? !1 : x && t.listboxState === 0;
    (0, $keKjn.useInertOthers)(g, {
        allowed: (0, $acw62.useCallback)(()=>[
                t.buttonElement,
                t.optionsElement
            ], [
            t.buttonElement,
            t.optionsElement
        ])
    });
    let R = t.listboxState !== 0, B = (0, $hd1nN.useDidElementMove)(R, t.buttonElement) ? !1 : h, w = h && t.listboxState === 1, _ = (0, $9UPTU.useFrozenData)(w, t.value), b = (0, $114Mg.useEvent)((l)=>t.compare(_, l)), c = (0, $acw62.useMemo)(()=>{
        var I;
        if (n == null || !((I = n == null ? void 0 : n.to) != null && I.includes("selection"))) return null;
        let l = t.options.findIndex((G)=>b(G.dataRef.current.value));
        return l === -1 && (l = 0), l;
    }, [
        n,
        t.options
    ]), N = (()=>{
        if (n == null) return;
        if (c === null) return {
            ...n,
            inner: void 0
        };
        let l = Array.from(t.listRef.current.values());
        return {
            ...n,
            inner: {
                listRef: {
                    current: l
                },
                index: c
            }
        };
    })(), [L, H] = (0, $34Str.useFloatingPanel)(N), te = (0, $34Str.useFloatingPanelProps)(), oe = (0, $6mpbl.useSyncRefs)(i, n ? L : null, s.setOptionsElement, P), X = (0, $5Ai9V.useDisposables)();
    (0, $acw62.useEffect)(()=>{
        var I;
        let l = t.optionsElement;
        l && t.listboxState === 0 && l !== ((I = (0, $gxwGc.getOwnerDocument)(l)) == null ? void 0 : I.activeElement) && (l == null || l.focus({
            preventScroll: !0
        }));
    }, [
        t.listboxState,
        t.optionsElement
    ]);
    let J = (0, $114Mg.useEvent)((l)=>{
        var I, G;
        switch(X.dispose(), l.key){
            case (0, $6AKlm.Keys).Space:
                if (t.searchQuery !== "") return l.preventDefault(), l.stopPropagation(), s.search(l.key);
            case (0, $6AKlm.Keys).Enter:
                if (l.preventDefault(), l.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: le } = t.options[t.activeOptionIndex];
                    s.onChange(le.current.value);
                }
                t.mode === 0 && ((0, $1u0KT.flushSync)(()=>s.closeListbox()), (I = t.buttonElement) == null || I.focus({
                    preventScroll: !0
                }));
                break;
            case (0, $6Ngq1.match)(t.orientation, {
                vertical: (0, $6AKlm.Keys).ArrowDown,
                horizontal: (0, $6AKlm.Keys).ArrowRight
            }):
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).Next);
            case (0, $6Ngq1.match)(t.orientation, {
                vertical: (0, $6AKlm.Keys).ArrowUp,
                horizontal: (0, $6AKlm.Keys).ArrowLeft
            }):
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).Previous);
            case (0, $6AKlm.Keys).Home:
            case (0, $6AKlm.Keys).PageUp:
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).First);
            case (0, $6AKlm.Keys).End:
            case (0, $6AKlm.Keys).PageDown:
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $fLrGx.Focus).Last);
            case (0, $6AKlm.Keys).Escape:
                l.preventDefault(), l.stopPropagation(), (0, $1u0KT.flushSync)(()=>s.closeListbox()), (G = t.buttonElement) == null || G.focus({
                    preventScroll: !0
                });
                return;
            case (0, $6AKlm.Keys).Tab:
                l.preventDefault(), l.stopPropagation(), (0, $1u0KT.flushSync)(()=>s.closeListbox()), (0, $hsQxB.focusFrom)(t.buttonElement, l.shiftKey ? (0, $hsQxB.Focus).Previous : (0, $hsQxB.Focus).Next);
                break;
            default:
                l.key.length === 1 && (s.search(l.key), X.setTimeout(()=>s.clearSearch(), 350));
                break;
        }
    }), ne = ($ = t.buttonElement) == null ? void 0 : $.id, ie = (0, $acw62.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t.listboxState
    ]), K = (0, $ebRQH.mergeProps)(n ? te() : {}, {
        id: r,
        ref: oe,
        "aria-activedescendant": t.activeOptionIndex === null || (q = t.options[t.activeOptionIndex]) == null ? void 0 : q.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": ne,
        "aria-orientation": t.orientation,
        onKeyDown: J,
        role: "listbox",
        tabIndex: t.listboxState === 0 ? 0 : void 0,
        style: {
            ...p.style,
            ...H,
            "--button-width": (0, $dfvrc.useElementSize)(t.buttonElement, !0).width
        },
        ...(0, $bdknl.transitionDataAttributes)(D)
    }), re = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), {
        enabled: m ? e.static || h : !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$ee.Provider, {
        value: t.mode === 1 ? t : {
            ...t,
            isSelected: b
        }
    }, re({
        ourProps: K,
        theirProps: p,
        slot: ie,
        defaultTag: $df20442161b20eb0$var$It,
        features: $df20442161b20eb0$var$Ct,
        visible: B,
        name: "Listbox.Options"
    })));
}
let $df20442161b20eb0$var$Mt = "div";
function $df20442161b20eb0$var$Bt(e, i) {
    let o = (0, $acw62.useId)(), { id: r = `headlessui-listbox-option-${o}`, disabled: a = !1, value: m, ...x } = e, d = (0, $acw62.useContext)($df20442161b20eb0$var$Le) === !0, p = $df20442161b20eb0$var$Q("Listbox.Option"), n = $df20442161b20eb0$var$Z("Listbox.Option"), u = p.activeOptionIndex !== null ? p.options[p.activeOptionIndex].id === r : !1, P = p.isSelected(m), t = (0, $acw62.useRef)(null), s = (0, $jN7sP.useTextValue)(t), F = (0, $ltgxC.useLatestValue)({
        disabled: a,
        value: m,
        domRef: t,
        get textValue () {
            return s();
        }
    }), M = (0, $6mpbl.useSyncRefs)(i, t, (b)=>{
        b ? p.listRef.current.set(r, b) : p.listRef.current.delete(r);
    });
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!p.__demoMode && p.listboxState === 0 && u && p.activationTrigger !== 0) return (0, $1COYr.disposables)().requestAnimationFrame(()=>{
            var b, c;
            (c = (b = t.current) == null ? void 0 : b.scrollIntoView) == null || c.call(b, {
                block: "nearest"
            });
        });
    }, [
        t,
        u,
        p.__demoMode,
        p.listboxState,
        p.activationTrigger,
        p.activeOptionIndex
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!d) return n.registerOption(r, F);
    }, [
        F,
        r,
        d
    ]);
    let h = (0, $114Mg.useEvent)((b)=>{
        var c;
        if (a) return b.preventDefault();
        n.onChange(m), p.mode === 0 && ((0, $1u0KT.flushSync)(()=>n.closeListbox()), (c = p.buttonElement) == null || c.focus({
            preventScroll: !0
        }));
    }), D = (0, $114Mg.useEvent)(()=>{
        if (a) return n.goToOption((0, $fLrGx.Focus).Nothing);
        n.goToOption((0, $fLrGx.Focus).Specific, r);
    }), O = (0, $ipity.useTrackedPointer)(), g = (0, $114Mg.useEvent)((b)=>{
        O.update(b), !a && (u || n.goToOption((0, $fLrGx.Focus).Specific, r, 0));
    }), R = (0, $114Mg.useEvent)((b)=>{
        O.wasMoved(b) && (a || u || n.goToOption((0, $fLrGx.Focus).Specific, r, 0));
    }), y = (0, $114Mg.useEvent)((b)=>{
        O.wasMoved(b) && (a || u && n.goToOption((0, $fLrGx.Focus).Nothing));
    }), B = (0, $acw62.useMemo)(()=>({
            active: u,
            focus: u,
            selected: P,
            disabled: a,
            selectedOption: P && d
        }), [
        u,
        P,
        a,
        d
    ]), w = d ? {} : {
        id: r,
        ref: M,
        role: "option",
        tabIndex: a === !0 ? void 0 : -1,
        "aria-disabled": a === !0 ? !0 : void 0,
        "aria-selected": P,
        disabled: void 0,
        onClick: h,
        onFocus: D,
        onPointerEnter: g,
        onMouseEnter: g,
        onPointerMove: R,
        onMouseMove: R,
        onPointerLeave: y,
        onMouseLeave: y
    }, _ = (0, $ebRQH.useRender)();
    return !P && d ? null : _({
        ourProps: w,
        theirProps: x,
        slot: B,
        defaultTag: $df20442161b20eb0$var$Mt,
        name: "Listbox.Option"
    });
}
let $df20442161b20eb0$var$wt = (0, $acw62.Fragment);
function $df20442161b20eb0$var$kt(e, i) {
    let { options: o, placeholder: r, ...a } = e, x = {
        ref: (0, $6mpbl.useSyncRefs)(i)
    }, d = $df20442161b20eb0$var$Q("ListboxSelectedOption"), p = (0, $acw62.useMemo)(()=>({}), []), n = d.value === void 0 || d.value === null || d.mode === 1 && Array.isArray(d.value) && d.value.length === 0, u = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$Le.Provider, {
        value: !0
    }, u({
        ourProps: x,
        theirProps: {
            ...a,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, r && n ? r : o)
        },
        slot: p,
        defaultTag: $df20442161b20eb0$var$wt,
        name: "ListboxSelectedOption"
    }));
}
let $df20442161b20eb0$var$Ut = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$ht), $df20442161b20eb0$export$1e1e59bb4b882447 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$_t), $df20442161b20eb0$export$3b435d19b0be2a59 = (0, $5qg9U.Label), $df20442161b20eb0$export$ea8d88fc73d4fb81 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$Ft), $df20442161b20eb0$export$68e891bae1a5b917 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$Bt), $df20442161b20eb0$export$867366afc1aaaf63 = (0, $ebRQH.forwardRefWithAs)($df20442161b20eb0$var$kt), $df20442161b20eb0$export$8bad31ff872c7659 = Object.assign($df20442161b20eb0$var$Ut, {
    Button: $df20442161b20eb0$export$1e1e59bb4b882447,
    Label: $df20442161b20eb0$export$3b435d19b0be2a59,
    Options: $df20442161b20eb0$export$ea8d88fc73d4fb81,
    Option: $df20442161b20eb0$export$68e891bae1a5b917,
    SelectedOption: $df20442161b20eb0$export$867366afc1aaaf63
});

});
parcelRegister("kd7LS", function(module, exports) {

$parcel$export(module.exports, "useFocusRing", () => $eb6b0cc1c3f8613d$export$4e328f61c538687f);

var $fVRQv = parcelRequire("fVRQv");
var $jexLh = parcelRequire("jexLh");
var $3oYR0 = parcelRequire("3oYR0");

var $acw62 = parcelRequire("acw62");
function $eb6b0cc1c3f8613d$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $fVRQv.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $fVRQv.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $jexLh.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $3oYR0.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

});
parcelRegister("fVRQv", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", () => $b995f28c9a72ee4c$export$b9b3dfddab17db27);
$parcel$export(module.exports, "useFocusVisibleListener", () => $b995f28c9a72ee4c$export$ec71b4b83ac08ec3);

var $kvYeA = parcelRequire("kvYeA");
var $fOgJj = parcelRequire("fOgJj");
var $dS2bP = parcelRequire("dS2bP");

var $acw62 = parcelRequire("acw62");

var $bVPQr = parcelRequire("bVPQr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = null;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b995f28c9a72ee4c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $fOgJj.isMac)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = 'keyboard';
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $dS2bP.isVirtualClick)(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === 'undefined' || $b995f28c9a72ee4c$export$d90243b58daecda7.get((0, $kvYeA.getOwnerWindow)(element))) return;
    const windowObject = (0, $kvYeA.getOwnerWindow)(element);
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener('mousedown', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('mousemove', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('mouseup', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b995f28c9a72ee4c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $kvYeA.getOwnerWindow)(element);
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$b995f28c9a72ee4c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b995f28c9a72ee4c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener('mousedown', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('mousemove', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('mouseup', $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b995f28c9a72ee4c$export$d90243b58daecda7.delete(windowObject);
};
function $b995f28c9a72ee4c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $b995f28c9a72ee4c$export$2f1888112f558a7d();
function $b995f28c9a72ee4c$export$b9b3dfddab17db27() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $b995f28c9a72ee4c$export$630ff653c5ada6a9() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality;
}
function $b995f28c9a72ee4c$export$8397ddfc504fdb9a(modality) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b995f28c9a72ee4c$export$98e20ec92f614cfe() {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $bVPQr.useIsSSR)() ? null : modality;
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== 'undefined' ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== 'undefined' ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== 'undefined' ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== 'undefined' ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b995f28c9a72ee4c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $b995f28c9a72ee4c$export$b9b3dfddab17db27());
    $b995f28c9a72ee4c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b995f28c9a72ee4c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b995f28c9a72ee4c$export$b9b3dfddab17db27());
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("kvYeA", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $eef56d26e56a84a0$export$b204af158042fbac);
$parcel$export(module.exports, "getOwnerWindow", () => $eef56d26e56a84a0$export$f21a1ffae260145a);
const $eef56d26e56a84a0$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $eef56d26e56a84a0$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $eef56d26e56a84a0$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

});

parcelRegister("fOgJj", function(module, exports) {

$parcel$export(module.exports, "isMac", () => $b82880ba168cba95$export$9ac100e40613ea10);
$parcel$export(module.exports, "isAndroid", () => $b82880ba168cba95$export$a11b0059900ceec8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $b82880ba168cba95$export$9ac100e40613ea10 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $b82880ba168cba95$export$186c6964ca17d99 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $b82880ba168cba95$export$7bef049ce92e4224 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b82880ba168cba95$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $b82880ba168cba95$export$fedb369cb70207f1 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$export$186c6964ca17d99() || $b82880ba168cba95$export$7bef049ce92e4224();
});
const $b82880ba168cba95$export$e1865c3bedcd822b = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$export$9ac100e40613ea10() || $b82880ba168cba95$export$fedb369cb70207f1();
});
const $b82880ba168cba95$export$78551043582a6a98 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$b82880ba168cba95$export$6446a186d09e379e();
});
const $b82880ba168cba95$export$6446a186d09e379e = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $b82880ba168cba95$export$a11b0059900ceec8 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $b82880ba168cba95$export$b7d78993b74f766d = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});

});

parcelRegister("dS2bP", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", () => $a192045deeaea2b6$export$60278871457622de);

var $fOgJj = parcelRequire("fOgJj");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a192045deeaea2b6$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $fOgJj.isAndroid)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $a192045deeaea2b6$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $fOgJj.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}

});

parcelRegister("bVPQr", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", () => $8afd3bdc2bd65163$export$535bd6ca7f90a273);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function') {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function' ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore']($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("jexLh", function(module, exports) {

$parcel$export(module.exports, "useFocus", () => $e009837ee384a76a$export$f8168d8dd8fd66e6);

var $1s9dc = parcelRequire("1s9dc");

var $acw62 = parcelRequire("acw62");

var $kvYeA = parcelRequire("kvYeA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e009837ee384a76a$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $1s9dc.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $kvYeA.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("1s9dc", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", () => $10ef8d441d7454cf$export$715c682d09d639cc);

var $acw62 = parcelRequire("acw62");

var $369I5 = parcelRequire("369I5");
var $4AOPT = parcelRequire("4AOPT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $10ef8d441d7454cf$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $10ef8d441d7454cf$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $4AOPT.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $369I5.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $10ef8d441d7454cf$export$905e7fc544a71f36('blur', e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});
parcelRegister("369I5", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $241976d88b767e6b$export$7f54fc3180508a52);

var $4AOPT = parcelRequire("4AOPT");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $241976d88b767e6b$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    (0, $4AOPT.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

});
parcelRegister("4AOPT", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $3581f530a27f457c$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3581f530a27f457c$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};

});




parcelRegister("3oYR0", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", () => $27a2d14f8c063b81$export$420e68273165f4ec);

var $1s9dc = parcelRequire("1s9dc");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $27a2d14f8c063b81$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $1s9dc.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});


parcelRegister("6o6B3", function(module, exports) {

$parcel$export(module.exports, "useHover", () => $4a6a19e952a3e910$export$ae780daf29e6d456);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount = 0;
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener('touchend', $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount--;
        if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener('touchend', $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $4a6a19e952a3e910$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $acw62.useEffect)($4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, 'mouse');
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, 'mouse');
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});

parcelRegister("cE9hP", function(module, exports) {

$parcel$export(module.exports, "useActivePress", () => $93506c8f84360949$export$73224eeef4bbe873);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");
function $93506c8f84360949$var$E(e) {
    let t = e.width / 2, n = e.height / 2;
    return {
        top: e.clientY - n,
        right: e.clientX + t,
        bottom: e.clientY + n,
        left: e.clientX - t
    };
}
function $93506c8f84360949$var$P(e, t) {
    return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function $93506c8f84360949$export$73224eeef4bbe873({ disabled: e = !1 } = {}) {
    let t = (0, $acw62.useRef)(null), [n, l] = (0, $acw62.useState)(!1), r = (0, $5Ai9V.useDisposables)(), o = (0, $114Mg.useEvent)(()=>{
        t.current = null, l(!1), r.dispose();
    }), f = (0, $114Mg.useEvent)((s)=>{
        if (r.dispose(), t.current === null) {
            t.current = s.currentTarget, l(!0);
            {
                let i = (0, $gxwGc.getOwnerDocument)(s.currentTarget);
                r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", (c)=>{
                    if (t.current) {
                        let p = $93506c8f84360949$var$E(c);
                        l($93506c8f84360949$var$P(p, t.current.getBoundingClientRect()));
                    }
                }, !1), r.addEventListener(i, "pointercancel", o, !1);
            }
        }
    });
    return {
        pressed: n,
        pressProps: e ? {} : {
            onPointerDown: f,
            onPointerUp: o,
            onClick: o
        }
    };
}

});
parcelRegister("gxwGc", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $c0a913ecfa4bf5e5$export$b204af158042fbac);

var $Iy8e1 = parcelRequire("Iy8e1");
function $c0a913ecfa4bf5e5$export$b204af158042fbac(r) {
    return (0, $Iy8e1.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

});
parcelRegister("Iy8e1", function(module, exports) {

$parcel$export(module.exports, "env", () => $085e96034c813fbf$export$a7b6bc01c63cdfc3);
var $085e96034c813fbf$var$i = Object.defineProperty;
var $085e96034c813fbf$var$d = (t, e, n)=>e in t ? $085e96034c813fbf$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $085e96034c813fbf$var$r = (t, e, n)=>($085e96034c813fbf$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $085e96034c813fbf$var$o {
    constructor(){
        $085e96034c813fbf$var$r(this, "current", this.detect());
        $085e96034c813fbf$var$r(this, "handoffState", "pending");
        $085e96034c813fbf$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $085e96034c813fbf$export$a7b6bc01c63cdfc3 = new $085e96034c813fbf$var$o;

});


parcelRegister("5Ai9V", function(module, exports) {

$parcel$export(module.exports, "useDisposables", () => $410e668b7f520622$export$fd183955ff4b45d9);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");
function $410e668b7f520622$export$fd183955ff4b45d9() {
    let [e] = (0, $acw62.useState)((0, $1COYr.disposables));
    return (0, $acw62.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}

});
parcelRegister("1COYr", function(module, exports) {

$parcel$export(module.exports, "disposables", () => $12f0e1633d904536$export$12b26c28a05aa001);

var $eJKgu = parcelRequire("eJKgu");
function $12f0e1633d904536$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $eJKgu.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $12f0e1633d904536$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.includes(e) || n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}

});
parcelRegister("eJKgu", function(module, exports) {

$parcel$export(module.exports, "microTask", () => $aba927e9b3929756$export$a5ff0d6a738703ca);
function $aba927e9b3929756$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

});



parcelRegister("114Mg", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $0bd9972698c32399$export$90fc3a17d93f704c);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
let $0bd9972698c32399$export$90fc3a17d93f704c = function(t) {
    let e = (0, $ltgxC.useLatestValue)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

});
parcelRegister("ltgxC", function(module, exports) {

$parcel$export(module.exports, "useLatestValue", () => $fa1923261638cacc$export$86c4283a11f23f95);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $fa1923261638cacc$export$86c4283a11f23f95(e) {
    let r = (0, $acw62.useRef)(e);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}

});
parcelRegister("8KgIp", function(module, exports) {

$parcel$export(module.exports, "useIsoMorphicEffect", () => $65df95ec9b1bb6a8$export$ce5ed857c741fd71);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");
let $65df95ec9b1bb6a8$export$ce5ed857c741fd71 = (e, t)=>{
    (0, $Iy8e1.env).isServer ? (0, $acw62.useEffect)(e, t) : (0, $acw62.useLayoutEffect)(e, t);
};

});




parcelRegister("ePQFN", function(module, exports) {

$parcel$export(module.exports, "useByComparator", () => $acceafe1d565f09b$export$988f0cf1b37580ae);

var $acw62 = parcelRequire("acw62");
function $acceafe1d565f09b$var$l(e, r) {
    return e !== null && r !== null && typeof e == "object" && typeof r == "object" && "id" in e && "id" in r ? e.id === r.id : e === r;
}
function $acceafe1d565f09b$export$988f0cf1b37580ae(e = $acceafe1d565f09b$var$l) {
    return (0, $acw62.useCallback)((r, t)=>{
        if (typeof e == "string") {
            let o = e;
            return (r == null ? void 0 : r[o]) === (t == null ? void 0 : t[o]);
        }
        return e(r, t);
    }, [
        e
    ]);
}

});

parcelRegister("h26ct", function(module, exports) {

$parcel$export(module.exports, "useControllable", () => $c6676ed1f400443a$export$454217e89aea72b);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $c6676ed1f400443a$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $acw62.useState)(c), e = l !== void 0, t = (0, $acw62.useRef)(e), u = (0, $acw62.useRef)(!1), d = (0, $acw62.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $114Mg.useEvent)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}

});

parcelRegister("3X9lW", function(module, exports) {

$parcel$export(module.exports, "useDefaultValue", () => $2e0e230f066909d2$export$8a91ee242b6d0fe3);

var $acw62 = parcelRequire("acw62");
function $2e0e230f066909d2$export$8a91ee242b6d0fe3(e) {
    let [t] = (0, $acw62.useState)(e);
    return t;
}

});

parcelRegister("hd1nN", function(module, exports) {

$parcel$export(module.exports, "useDidElementMove", () => $c874b9231cf882e4$export$d0b9dbca977c73d5);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $c874b9231cf882e4$export$d0b9dbca977c73d5(n, t) {
    let e = (0, $acw62.useRef)({
        left: 0,
        top: 0
    });
    if ((0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!t) return;
        let r = t.getBoundingClientRect();
        r && (e.current = r);
    }, [
        n,
        t
    ]), t == null || !n || t === document.activeElement) return !1;
    let o = t.getBoundingClientRect();
    return o.top !== e.current.top || o.left !== e.current.left;
}

});

parcelRegister("dfvrc", function(module, exports) {

$parcel$export(module.exports, "useElementSize", () => $9a550ff5f236cb70$export$2b86bedf890eab8);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $9a550ff5f236cb70$var$f(e) {
    if (e === null) return {
        width: 0,
        height: 0
    };
    let { width: t, height: r } = e.getBoundingClientRect();
    return {
        width: t,
        height: r
    };
}
function $9a550ff5f236cb70$export$2b86bedf890eab8(e, t = !1) {
    let [r, u] = (0, $acw62.useReducer)(()=>({}), {}), i = (0, $acw62.useMemo)(()=>$9a550ff5f236cb70$var$f(e), [
        e,
        r
    ]);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        let n = new ResizeObserver(u);
        return n.observe(e), ()=>{
            n.disconnect();
        };
    }, [
        e
    ]), t ? {
        width: `${i.width}px`,
        height: `${i.height}px`
    } : i;
}

});

parcelRegister("keKjn", function(module, exports) {

$parcel$export(module.exports, "useInertOthers", () => $ebb909f7f690e57e$export$af489fa7e5283cc3);

var $1COYr = parcelRequire("1COYr");

var $gxwGc = parcelRequire("gxwGc");

var $g6SeH = parcelRequire("g6SeH");

var $8KgIp = parcelRequire("8KgIp");
let $ebb909f7f690e57e$var$f = new Map, $ebb909f7f690e57e$var$u = new Map;
function $ebb909f7f690e57e$var$h(t) {
    var e;
    let r = (e = $ebb909f7f690e57e$var$u.get(t)) != null ? e : 0;
    return $ebb909f7f690e57e$var$u.set(t, r + 1), r !== 0 ? ()=>$ebb909f7f690e57e$var$m(t) : ($ebb909f7f690e57e$var$f.set(t, {
        "aria-hidden": t.getAttribute("aria-hidden"),
        inert: t.inert
    }), t.setAttribute("aria-hidden", "true"), t.inert = !0, ()=>$ebb909f7f690e57e$var$m(t));
}
function $ebb909f7f690e57e$var$m(t) {
    var i;
    let r = (i = $ebb909f7f690e57e$var$u.get(t)) != null ? i : 1;
    if (r === 1 ? $ebb909f7f690e57e$var$u.delete(t) : $ebb909f7f690e57e$var$u.set(t, r - 1), r !== 1) return;
    let e = $ebb909f7f690e57e$var$f.get(t);
    e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, $ebb909f7f690e57e$var$f.delete(t));
}
function $ebb909f7f690e57e$export$af489fa7e5283cc3(t, { allowed: r, disallowed: e } = {}) {
    let i = (0, $g6SeH.useIsTopLayer)(t, "inert-others");
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var d, c;
        if (!i) return;
        let a = (0, $1COYr.disposables)();
        for (let n of (d = e == null ? void 0 : e()) != null ? d : [])n && a.add($ebb909f7f690e57e$var$h(n));
        let s = (c = r == null ? void 0 : r()) != null ? c : [];
        for (let n of s){
            if (!n) continue;
            let l = (0, $gxwGc.getOwnerDocument)(n);
            if (!l) continue;
            let o = n.parentElement;
            for(; o && o !== l.body;){
                for (let p of o.children)s.some((E)=>p.contains(E)) || a.add($ebb909f7f690e57e$var$h(p));
                o = o.parentElement;
            }
        }
        return a.dispose;
    }, [
        i,
        r,
        e
    ]);
}

});
parcelRegister("g6SeH", function(module, exports) {

$parcel$export(module.exports, "useIsTopLayer", () => $bba7470f70c82a20$export$5f5dd115998e0b80);

var $acw62 = parcelRequire("acw62");

var $8SQCc = parcelRequire("8SQCc");

var $7AV3X = parcelRequire("7AV3X");

var $8KgIp = parcelRequire("8KgIp");

var $gCqoX = parcelRequire("gCqoX");
let $bba7470f70c82a20$var$p = new (0, $8SQCc.DefaultMap)(()=>(0, $7AV3X.createStore)(()=>[], {
        ADD (r) {
            return this.includes(r) ? this : [
                ...this,
                r
            ];
        },
        REMOVE (r) {
            let e = this.indexOf(r);
            if (e === -1) return this;
            let t = this.slice();
            return t.splice(e, 1), t;
        }
    }));
function $bba7470f70c82a20$export$5f5dd115998e0b80(r, e) {
    let t = $bba7470f70c82a20$var$p.get(e), i = (0, $acw62.useId)(), h = (0, $gCqoX.useStore)(t);
    if ((0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (r) return t.dispatch("ADD", i), ()=>t.dispatch("REMOVE", i);
    }, [
        t,
        r
    ]), !r) return !1;
    let s = h.indexOf(i), o = h.length;
    return s === -1 && (s = o, o += 1), s === o - 1;
}

});
parcelRegister("8SQCc", function(module, exports) {

$parcel$export(module.exports, "DefaultMap", () => $677c2e1e5f56d429$export$674cd7dcb504ac5c);
class $677c2e1e5f56d429$export$674cd7dcb504ac5c extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let e = super.get(t);
        return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
}

});

parcelRegister("7AV3X", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $587828ac89f0168d$export$f51a9068ac82ea43);
function $587828ac89f0168d$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

});

parcelRegister("gCqoX", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $c194acc02d991b55$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");
function $c194acc02d991b55$export$6ccbb43953eebf8(t) {
    return (0, $acw62.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}

});



parcelRegister("dcp2r", function(module, exports) {

$parcel$export(module.exports, "useOnDisappear", () => $99bfd16f3cd33a1b$export$b41b9097915aa006);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");

var $ltgxC = parcelRequire("ltgxC");
function $99bfd16f3cd33a1b$export$b41b9097915aa006(s, n, l) {
    let i = (0, $ltgxC.useLatestValue)((t)=>{
        let e = t.getBoundingClientRect();
        e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && l();
    });
    (0, $acw62.useEffect)(()=>{
        if (!s) return;
        let t = n === null ? null : n instanceof HTMLElement ? n : n.current;
        if (!t) return;
        let e = (0, $1COYr.disposables)();
        if (typeof ResizeObserver != "undefined") {
            let r = new ResizeObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        if (typeof IntersectionObserver != "undefined") {
            let r = new IntersectionObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        return ()=>e.dispose();
    }, [
        n,
        i,
        s
    ]);
}

});

parcelRegister("23pTr", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", () => $17eff26b89e4b024$export$71b2224f1ce5e08e);

var $acw62 = parcelRequire("acw62");

var $hsQxB = parcelRequire("hsQxB");

var $8UjaS = parcelRequire("8UjaS");

var $fA3F6 = parcelRequire("fA3F6");

var $g6SeH = parcelRequire("g6SeH");

var $ltgxC = parcelRequire("ltgxC");

var $5vI4D = parcelRequire("5vI4D");
const $17eff26b89e4b024$var$E = 30;
function $17eff26b89e4b024$export$71b2224f1ce5e08e(p, f, C) {
    let u = (0, $g6SeH.useIsTopLayer)(p, "outside-click"), m = (0, $ltgxC.useLatestValue)(C), s = (0, $acw62.useCallback)(function(e, n) {
        if (e.defaultPrevented) return;
        let r = n(e);
        if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
        let h = function l(o) {
            return typeof o == "function" ? l(o()) : Array.isArray(o) || o instanceof Set ? o : [
                o
            ];
        }(f);
        for (let l of h)if (l !== null && (l.contains(r) || e.composed && e.composedPath().includes(l))) return;
        return !(0, $hsQxB.isFocusableElement)(r, (0, $hsQxB.FocusableMode).Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
    }, [
        m,
        f
    ]), i = (0, $acw62.useRef)(null);
    (0, $fA3F6.useDocumentEvent)(u, "pointerdown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "mousedown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "click", (t)=>{
        (0, $8UjaS.isMobile)() || i.current && (s(t, ()=>i.current), i.current = null);
    }, !0);
    let a = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    (0, $fA3F6.useDocumentEvent)(u, "touchstart", (t)=>{
        a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "touchend", (t)=>{
        let e = {
            x: t.changedTouches[0].clientX,
            y: t.changedTouches[0].clientY
        };
        if (!(Math.abs(e.x - a.current.x) >= $17eff26b89e4b024$var$E || Math.abs(e.y - a.current.y) >= $17eff26b89e4b024$var$E)) return s(t, ()=>t.target instanceof HTMLElement ? t.target : null);
    }, !0), (0, $5vI4D.useWindowEvent)(u, "blur", (t)=>s(t, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("hsQxB", function(module, exports) {

$parcel$export(module.exports, "focusableSelector", () => $cb6dceb64e6c0606$export$acea64b1933eb668);
$parcel$export(module.exports, "Focus", () => $cb6dceb64e6c0606$export$807a7eae502106e7);
$parcel$export(module.exports, "FocusResult", () => $cb6dceb64e6c0606$export$abf286375dfa6dbd);
$parcel$export(module.exports, "FocusableMode", () => $cb6dceb64e6c0606$export$27112a34f2f8402d);
$parcel$export(module.exports, "isFocusableElement", () => $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5);
$parcel$export(module.exports, "focusElement", () => $cb6dceb64e6c0606$export$5fed9cc43865dc7e);
$parcel$export(module.exports, "sortByDomNode", () => $cb6dceb64e6c0606$export$20305e96f91bf103);
$parcel$export(module.exports, "focusFrom", () => $cb6dceb64e6c0606$export$7fb6c844b485e870);
$parcel$export(module.exports, "focusIn", () => $cb6dceb64e6c0606$export$82e1f4f412218a1d);

var $1COYr = parcelRequire("1COYr");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");
let $cb6dceb64e6c0606$export$acea64b1933eb668 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(","), $cb6dceb64e6c0606$var$p = [
    "[data-autofocus]"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $cb6dceb64e6c0606$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n[n.AutoFocus = 64] = "AutoFocus", n))($cb6dceb64e6c0606$export$807a7eae502106e7 || {}), $cb6dceb64e6c0606$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($cb6dceb64e6c0606$export$abf286375dfa6dbd || {}), $cb6dceb64e6c0606$var$y = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($cb6dceb64e6c0606$var$y || {});
function $cb6dceb64e6c0606$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$export$acea64b1933eb668)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function $cb6dceb64e6c0606$export$89622d0e8d475962(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$var$p)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $cb6dceb64e6c0606$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($cb6dceb64e6c0606$export$27112a34f2f8402d || {});
function $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $gxwGc.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, $6Ngq1.match)(r, {
        [0] () {
            return e.matches($cb6dceb64e6c0606$export$acea64b1933eb668);
        },
        [1] () {
            let u = e;
            for(; u !== null;){
                if (u.matches($cb6dceb64e6c0606$export$acea64b1933eb668)) return !0;
                u = u.parentElement;
            }
            return !1;
        }
    });
}
function $cb6dceb64e6c0606$export$46388676ec35ab85(e) {
    let r = (0, $gxwGc.getOwnerDocument)(e);
    (0, $1COYr.disposables)().nextFrame(()=>{
        r && !$cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e);
    });
}
var $cb6dceb64e6c0606$var$H = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($cb6dceb64e6c0606$var$H || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $cb6dceb64e6c0606$var$w = [
    "textarea",
    "input"
].join(",");
function $cb6dceb64e6c0606$var$O(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $cb6dceb64e6c0606$var$w)) != null ? t : !1;
}
function $cb6dceb64e6c0606$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, u)=>{
        let o = r(t), c = r(u);
        if (o === null || c === null) return 0;
        let l = o.compareDocumentPosition(c);
        return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $cb6dceb64e6c0606$export$7fb6c844b485e870(e, r) {
    return $cb6dceb64e6c0606$export$82e1f4f412218a1d($cb6dceb64e6c0606$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $cb6dceb64e6c0606$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: u = null, skipElements: o = [] } = {}) {
    let c = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, l = Array.isArray(e) ? t ? $cb6dceb64e6c0606$export$20305e96f91bf103(e) : e : r & 64 ? $cb6dceb64e6c0606$export$89622d0e8d475962(e) : $cb6dceb64e6c0606$export$433aaa1f216cf32d(e);
    o.length > 0 && l.length > 1 && (l = l.filter((s)=>!o.some((a)=>a != null && "current" in a ? (a == null ? void 0 : a.current) === s : a === s))), u = u != null ? u : c.activeElement;
    let n = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, l.indexOf(u)) - 1;
        if (r & 4) return Math.max(0, l.indexOf(u)) + 1;
        if (r & 8) return l.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), M = r & 32 ? {
        preventScroll: !0
    } : {}, m = 0, d = l.length, i;
    do {
        if (m >= d || m + d <= 0) return 0;
        let s = x + m;
        if (r & 16) s = (s + d) % d;
        else {
            if (s < 0) return 3;
            if (s >= d) return 1;
        }
        i = l[s], i == null || i.focus(M), m += n;
    }while (i !== c.activeElement);
    return r & 6 && $cb6dceb64e6c0606$var$O(i) && i.select(), 2;
}

});
parcelRegister("6Ngq1", function(module, exports) {

$parcel$export(module.exports, "match", () => $4f240e1aafd2c298$export$4659b591c19bdf3d);
function $4f240e1aafd2c298$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $4f240e1aafd2c298$export$4659b591c19bdf3d), t;
}

});


parcelRegister("8UjaS", function(module, exports) {

$parcel$export(module.exports, "isIOS", () => $67c26d51fee0b51a$export$fedb369cb70207f1);
$parcel$export(module.exports, "isMobile", () => $67c26d51fee0b51a$export$d0a8044dce8ff2fc);
function $67c26d51fee0b51a$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $67c26d51fee0b51a$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $67c26d51fee0b51a$export$d0a8044dce8ff2fc() {
    return $67c26d51fee0b51a$export$fedb369cb70207f1() || $67c26d51fee0b51a$export$a11b0059900ceec8();
}

});

parcelRegister("fA3F6", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", () => $b57d0f015e93db3a$export$55d2b5df396a097b);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $b57d0f015e93db3a$export$55d2b5df396a097b(t, e, o, n) {
    let u = (0, $ltgxC.useLatestValue)(o);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        function r(m) {
            u.current(m);
        }
        return document.addEventListener(e, r, n), ()=>document.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}

});

parcelRegister("5vI4D", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", () => $40320926a37dc1cc$export$ee579bb285b8d4aa);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $40320926a37dc1cc$export$ee579bb285b8d4aa(t, e, o, n) {
    let i = (0, $ltgxC.useLatestValue)(o);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        function r(d) {
            i.current(d);
        }
        return window.addEventListener(e, r, n), ()=>window.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}

});


parcelRegister("5IEAk", function(module, exports) {

$parcel$export(module.exports, "useOwnerDocument", () => $42a08b28a285ca8e$export$dd9fbcea3de0ae36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");
function $42a08b28a285ca8e$export$dd9fbcea3de0ae36(...e) {
    return (0, $acw62.useMemo)(()=>(0, $gxwGc.getOwnerDocument)(...e), [
        ...e
    ]);
}

});

parcelRegister("gm4XX", function(module, exports) {

$parcel$export(module.exports, "useResolveButtonType", () => $be828d8bf9bb25ca$export$53652b2b272efe9c);

var $acw62 = parcelRequire("acw62");
function $be828d8bf9bb25ca$export$53652b2b272efe9c(t, u) {
    return (0, $acw62.useMemo)(()=>{
        var n;
        if (t.type) return t.type;
        let r = (n = t.as) != null ? n : "button";
        if (typeof r == "string" && r.toLowerCase() === "button" || (u == null ? void 0 : u.tagName) === "BUTTON" && !u.hasAttribute("type")) return "button";
    }, [
        t.type,
        t.as,
        u
    ]);
}

});

parcelRegister("hZodg", function(module, exports) {

$parcel$export(module.exports, "useScrollLock", () => $d18aea5eab300f7b$export$e47ba1b900da5d3b);

var $cfajG = parcelRequire("cfajG");

var $g6SeH = parcelRequire("g6SeH");
function $d18aea5eab300f7b$export$e47ba1b900da5d3b(e, c, n = ()=>[
        document.body
    ]) {
    let r = (0, $g6SeH.useIsTopLayer)(e, "scroll-lock");
    (0, $cfajG.useDocumentOverflowLockedEffect)(r, c, (t)=>{
        var o;
        return {
            containers: [
                ...(o = t.containers) != null ? o : [],
                n
            ]
        };
    });
}

});
parcelRegister("cfajG", function(module, exports) {

$parcel$export(module.exports, "useDocumentOverflowLockedEffect", () => $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0);

var $gCqoX = parcelRequire("gCqoX");

var $8KgIp = parcelRequire("8KgIp");

var $270j5 = parcelRequire("270j5");
function $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0(r, e, n = ()=>({
        containers: []
    })) {
    let f = (0, $gCqoX.useStore)((0, $270j5.overflows)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!(!e || !r)) return (0, $270j5.overflows).dispatch("PUSH", e, n), ()=>(0, $270j5.overflows).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}

});
parcelRegister("270j5", function(module, exports) {

$parcel$export(module.exports, "overflows", () => $189c7921f80dd74a$export$a4161f418919b5aa);

var $1COYr = parcelRequire("1COYr");

var $7AV3X = parcelRequire("7AV3X");

var $g695P = parcelRequire("g695P");

var $g4l2L = parcelRequire("g4l2L");

var $imLcn = parcelRequire("imLcn");
function $189c7921f80dd74a$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $189c7921f80dd74a$export$a4161f418919b5aa = (0, $7AV3X.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $1COYr.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $189c7921f80dd74a$var$m(t)
        }, c = [
            (0, $g4l2L.handleIOSLocking)(),
            (0, $g695P.adjustScrollbarPadding)(),
            (0, $imLcn.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$189c7921f80dd74a$export$a4161f418919b5aa.subscribe(()=>{
    let e = $189c7921f80dd74a$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});

});
parcelRegister("g695P", function(module, exports) {

$parcel$export(module.exports, "adjustScrollbarPadding", () => $bb844292a519e22f$export$110627fb35ef9205);
function $bb844292a519e22f$export$110627fb35ef9205() {
    let r;
    return {
        before ({ doc: e }) {
            var l;
            let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
            r = Math.max(0, t.innerWidth - o.clientWidth);
        },
        after ({ doc: e, d: o }) {
            let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
            o.style(t, "paddingRight", `${n}px`);
        }
    };
}

});

parcelRegister("g4l2L", function(module, exports) {

$parcel$export(module.exports, "handleIOSLocking", () => $bb2d57db10996691$export$e3a523dfabf27286);

var $1COYr = parcelRequire("1COYr");

var $8UjaS = parcelRequire("8UjaS");
function $bb2d57db10996691$export$e3a523dfabf27286() {
    return (0, $8UjaS.isIOS)() ? {
        before ({ doc: r, d: n, meta: c }) {
            function o(a) {
                return c.containers.flatMap((l)=>l()).some((l)=>l.contains(a));
            }
            n.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $1COYr.disposables)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), n.add(()=>n.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
                n.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (l = i);
                    } catch  {}
                }, !0), n.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            n.style(e, "overscrollBehavior", "contain");
                        } else n.style(t.target, "touchAction", "none");
                    }
                }), n.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (t.target.tagName === "INPUT") return;
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), n.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}

});

parcelRegister("imLcn", function(module, exports) {

$parcel$export(module.exports, "preventScroll", () => $d5eee4b72f55118b$export$d8b6ff28805e84e9);
function $d5eee4b72f55118b$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

});




parcelRegister("6mpbl", function(module, exports) {

$parcel$export(module.exports, "optionalRef", () => $4a1854c6a3ad5196$export$7029785b750eb74);
$parcel$export(module.exports, "useSyncRefs", () => $4a1854c6a3ad5196$export$f6a25a78204acc7e);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
let $4a1854c6a3ad5196$var$u = Symbol();
function $4a1854c6a3ad5196$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$4a1854c6a3ad5196$var$u]: n
    });
}
function $4a1854c6a3ad5196$export$f6a25a78204acc7e(...t) {
    let n = (0, $acw62.useRef)(t);
    (0, $acw62.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $114Mg.useEvent)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$4a1854c6a3ad5196$var$u])) ? void 0 : c;
}

});

parcelRegister("jN7sP", function(module, exports) {

$parcel$export(module.exports, "useTextValue", () => $e688621b6eb177ca$export$f6862afd851a1cf4);

var $acw62 = parcelRequire("acw62");

var $dAaur = parcelRequire("dAaur");

var $114Mg = parcelRequire("114Mg");
function $e688621b6eb177ca$export$f6862afd851a1cf4(c) {
    let t = (0, $acw62.useRef)(""), r = (0, $acw62.useRef)("");
    return (0, $114Mg.useEvent)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $dAaur.getTextValue)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}

});
parcelRegister("dAaur", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $9e36c641751eb2c7$export$6ca03cb7b75bfa13);
let $9e36c641751eb2c7$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $9e36c641751eb2c7$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $9e36c641751eb2c7$var$a.test(l) && (l = l.replace($9e36c641751eb2c7$var$a, "")), l;
}
function $9e36c641751eb2c7$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $9e36c641751eb2c7$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $9e36c641751eb2c7$var$o(e).trim();
}

});


parcelRegister("ipity", function(module, exports) {

$parcel$export(module.exports, "useTrackedPointer", () => $d668e4b1d0c2f85c$export$24ebee078bde85c3);

var $acw62 = parcelRequire("acw62");
function $d668e4b1d0c2f85c$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d668e4b1d0c2f85c$export$24ebee078bde85c3() {
    let e = (0, $acw62.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d668e4b1d0c2f85c$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d668e4b1d0c2f85c$var$t(r);
        }
    };
}

});

parcelRegister("bdknl", function(module, exports) {

$parcel$export(module.exports, "transitionDataAttributes", () => $82a0b6c20b323075$export$c291d481c40a2fc3);
$parcel$export(module.exports, "useTransition", () => $82a0b6c20b323075$export$7b286972b8d8ccbf);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");

var $5Ai9V = parcelRequire("5Ai9V");

var $b1fZr = parcelRequire("b1fZr");

var $8KgIp = parcelRequire("8KgIp");
var $82a0b6c20b323075$var$T, $82a0b6c20b323075$var$b;
var $82a0b6c20b323075$var$L = ((r)=>(r[r.None = 0] = "None", r[r.Closed = 1] = "Closed", r[r.Enter = 2] = "Enter", r[r.Leave = 4] = "Leave", r))($82a0b6c20b323075$var$L || {});
function $82a0b6c20b323075$export$c291d481c40a2fc3(t) {
    let n = {};
    for(let e in t)t[e] === !0 && (n[`data-${e}`] = "");
    return n;
}
function $82a0b6c20b323075$export$7b286972b8d8ccbf(t, n, e, i) {
    let [r, o] = (0, $acw62.useState)(e), { hasFlag: s, addFlag: a, removeFlag: l } = (0, $b1fZr.useFlags)(t && r ? 3 : 0), u = (0, $acw62.useRef)(!1), f = (0, $acw62.useRef)(!1), E = (0, $5Ai9V.useDisposables)();
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var d;
        if (t) {
            if (e && o(!0), !n) {
                e && a(3);
                return;
            }
            return (d = i == null ? void 0 : i.start) == null || d.call(i, e), $82a0b6c20b323075$var$C(n, {
                inFlight: u,
                prepare () {
                    f.current ? f.current = !1 : f.current = u.current, u.current = !0, !f.current && (e ? (a(3), l(4)) : (a(4), l(2)));
                },
                run () {
                    f.current ? e ? (l(3), a(4)) : (l(4), a(3)) : e ? l(1) : a(1);
                },
                done () {
                    var p;
                    f.current && typeof n.getAnimations == "function" && n.getAnimations().length > 0 || (u.current = !1, l(7), e || o(!1), (p = i == null ? void 0 : i.end) == null || p.call(i, e));
                }
            });
        }
    }, [
        t,
        e,
        n,
        E
    ]), t ? [
        r,
        {
            closed: s(1),
            enter: s(2),
            leave: s(4),
            transition: s(2) || s(4)
        }
    ] : [
        e,
        {
            closed: void 0,
            enter: void 0,
            leave: void 0,
            transition: void 0
        }
    ];
}
function $82a0b6c20b323075$var$C(t, { prepare: n, run: e, done: i, inFlight: r }) {
    let o = (0, $1COYr.disposables)();
    return $82a0b6c20b323075$var$j(t, {
        prepare: n,
        inFlight: r
    }), o.nextFrame(()=>{
        e(), o.requestAnimationFrame(()=>{
            o.add($82a0b6c20b323075$var$M(t, i));
        });
    }), o.dispose;
}
function $82a0b6c20b323075$var$M(t, n) {
    var o, s;
    let e = (0, $1COYr.disposables)();
    if (!t) return e.dispose;
    let i = !1;
    e.add(()=>{
        i = !0;
    });
    let r = (s = (o = t.getAnimations) == null ? void 0 : o.call(t).filter((a)=>a instanceof CSSTransition)) != null ? s : [];
    return r.length === 0 ? (n(), e.dispose) : (Promise.allSettled(r.map((a)=>a.finished)).then(()=>{
        i || n();
    }), e.dispose);
}
function $82a0b6c20b323075$var$j(t, { inFlight: n, prepare: e }) {
    if (n != null && n.current) {
        e();
        return;
    }
    let i = t.style.transition;
    t.style.transition = "none", e(), t.offsetHeight, t.style.transition = i;
}

});
parcelRegister("b1fZr", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $805c30fc151c4831$export$2879604e6aec4ab);

var $acw62 = parcelRequire("acw62");
function $805c30fc151c4831$export$2879604e6aec4ab(u = 0) {
    let [t, l] = (0, $acw62.useState)(u), g = (0, $acw62.useCallback)((e)=>l(e), [
        t
    ]), s = (0, $acw62.useCallback)((e)=>l((a)=>a | e), [
        t
    ]), m = (0, $acw62.useCallback)((e)=>(t & e) === e, [
        t
    ]), n = (0, $acw62.useCallback)((e)=>l((a)=>a & ~e), [
        l
    ]), F = (0, $acw62.useCallback)((e)=>l((a)=>a ^ e), [
        l
    ]);
    return {
        flags: t,
        setFlag: g,
        addFlag: s,
        hasFlag: m,
        removeFlag: n,
        toggleFlag: F
    };
}

});


parcelRegister("brAF4", function(module, exports) {

$parcel$export(module.exports, "useDisabled", () => $854ea7886afe8ac8$export$c763bb7a184a0f11);

var $acw62 = parcelRequire("acw62");
let $854ea7886afe8ac8$var$e = (0, $acw62.createContext)(void 0);
function $854ea7886afe8ac8$export$c763bb7a184a0f11() {
    return (0, $acw62.useContext)($854ea7886afe8ac8$var$e);
}
function $854ea7886afe8ac8$export$a4d3bd77f4efe5ad({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($854ea7886afe8ac8$var$e.Provider, {
        value: t
    }, o);
}

});

parcelRegister("34Str", function(module, exports) {

$parcel$export(module.exports, "useResolvedAnchor", () => $23dc003753f08df2$export$ee5342e485f0bdb0);
$parcel$export(module.exports, "useFloatingReference", () => $23dc003753f08df2$export$916a28f343467e85);
$parcel$export(module.exports, "useFloatingReferenceProps", () => $23dc003753f08df2$export$c7931d5027a8ead4);
$parcel$export(module.exports, "useFloatingPanelProps", () => $23dc003753f08df2$export$106e71f938eae412);
$parcel$export(module.exports, "useFloatingPanel", () => $23dc003753f08df2$export$aff4be9ef2a28e43);
$parcel$export(module.exports, "FloatingProvider", () => $23dc003753f08df2$export$e473aa84737d3250);

var $618j3 = parcelRequire("618j3");
var $33OG6 = parcelRequire("33OG6");
var $5rxG7 = parcelRequire("5rxG7");
var $33OG6 = parcelRequire("33OG6");

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $8KgIp = parcelRequire("8KgIp");
let $23dc003753f08df2$var$y = (0, $acw62.createContext)({
    styles: void 0,
    setReference: ()=>{},
    setFloating: ()=>{},
    getReferenceProps: ()=>({}),
    getFloatingProps: ()=>({}),
    slot: {}
});
$23dc003753f08df2$var$y.displayName = "FloatingContext";
let $23dc003753f08df2$var$H = (0, $acw62.createContext)(null);
$23dc003753f08df2$var$H.displayName = "PlacementContext";
function $23dc003753f08df2$export$ee5342e485f0bdb0(e) {
    return (0, $acw62.useMemo)(()=>e ? typeof e == "string" ? {
            to: e
        } : e : null, [
        e
    ]);
}
function $23dc003753f08df2$export$916a28f343467e85() {
    return (0, $acw62.useContext)($23dc003753f08df2$var$y).setReference;
}
function $23dc003753f08df2$export$c7931d5027a8ead4() {
    return (0, $acw62.useContext)($23dc003753f08df2$var$y).getReferenceProps;
}
function $23dc003753f08df2$export$106e71f938eae412() {
    let { getFloatingProps: e, slot: t } = (0, $acw62.useContext)($23dc003753f08df2$var$y);
    return (0, $acw62.useCallback)((...n)=>Object.assign({}, e(...n), {
            "data-anchor": t.anchor
        }), [
        e,
        t
    ]);
}
function $23dc003753f08df2$export$aff4be9ef2a28e43(e = null) {
    e === !1 && (e = null), typeof e == "string" && (e = {
        to: e
    });
    let t = (0, $acw62.useContext)($23dc003753f08df2$var$H), n = (0, $acw62.useMemo)(()=>e, [
        JSON.stringify(e, (r, o)=>{
            var u;
            return (u = o == null ? void 0 : o.outerHTML) != null ? u : o;
        })
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        t == null || t(n != null ? n : null);
    }, [
        t,
        n
    ]);
    let l = (0, $acw62.useContext)($23dc003753f08df2$var$y);
    return (0, $acw62.useMemo)(()=>[
            l.setFloating,
            e ? l.styles : {}
        ], [
        l.setFloating,
        e,
        l.styles
    ]);
}
let $23dc003753f08df2$var$q = 4;
function $23dc003753f08df2$export$e473aa84737d3250({ children: e, enabled: t = !0 }) {
    let [n, l] = (0, $acw62.useState)(null), [r, o] = (0, $acw62.useState)(0), u = (0, $acw62.useRef)(null), [f, s] = (0, $acw62.useState)(null);
    $23dc003753f08df2$var$pe(f);
    let i = t && n !== null && f !== null, { to: F = "bottom", gap: E = 0, offset: v = 0, padding: c = 0, inner: P } = $23dc003753f08df2$var$ce(n, f), [a, p = "center"] = F.split(" ");
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        i && o(0);
    }, [
        i
    ]);
    let { refs: b, floatingStyles: w, context: g } = (0, $5rxG7.useFloating)({
        open: i,
        placement: a === "selection" ? p === "center" ? "bottom" : `bottom-${p}` : p === "center" ? `${a}` : `${a}-${p}`,
        strategy: "absolute",
        transform: !1,
        middleware: [
            (0, $33OG6.offset)({
                mainAxis: a === "selection" ? 0 : E,
                crossAxis: v
            }),
            (0, $33OG6.shift)({
                padding: c
            }),
            a !== "selection" && (0, $33OG6.flip)({
                padding: c
            }),
            a === "selection" && P ? (0, $5rxG7.inner)({
                ...P,
                padding: c,
                overflowRef: u,
                offset: r,
                minItemsVisible: $23dc003753f08df2$var$q,
                referenceOverflowThreshold: c,
                onFallbackChange (h) {
                    var O, W;
                    if (!h) return;
                    let d = g.elements.floating;
                    if (!d) return;
                    let T = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, $ = Math.min($23dc003753f08df2$var$q, d.childElementCount), L = 0, N = 0;
                    for (let m of (W = (O = g.elements.floating) == null ? void 0 : O.childNodes) != null ? W : [])if (m instanceof HTMLElement) {
                        let x = m.offsetTop, k = x + m.clientHeight + T, S = d.scrollTop, U = S + d.clientHeight;
                        if (x >= S && k <= U) $--;
                        else {
                            N = Math.max(0, Math.min(k, U) - Math.max(x, S)), L = m.clientHeight;
                            break;
                        }
                    }
                    $ >= 1 && o((m)=>{
                        let x = L * $ - N + T;
                        return m >= x ? m : x;
                    });
                }
            }) : null,
            (0, $33OG6.size)({
                padding: c,
                apply ({ availableWidth: h, availableHeight: d, elements: T }) {
                    Object.assign(T.floating.style, {
                        overflow: "auto",
                        maxWidth: `${h}px`,
                        maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)`
                    });
                }
            })
        ].filter(Boolean),
        whileElementsMounted: (0, $618j3.autoUpdate)
    }), [I = a, B = p] = g.placement.split("-");
    a === "selection" && (I = "selection");
    let G = (0, $acw62.useMemo)(()=>({
            anchor: [
                I,
                B
            ].filter(Boolean).join(" ")
        }), [
        I,
        B
    ]), K = (0, $5rxG7.useInnerOffset)(g, {
        overflowRef: u,
        onChange: o
    }), { getReferenceProps: Q, getFloatingProps: X } = (0, $5rxG7.useInteractions)([
        K
    ]), Y = (0, $114Mg.useEvent)((h)=>{
        s(h), b.setFloating(h);
    });
    return $acw62.createElement($23dc003753f08df2$var$H.Provider, {
        value: l
    }, $acw62.createElement($23dc003753f08df2$var$y.Provider, {
        value: {
            setFloating: Y,
            setReference: b.setReference,
            styles: w,
            getReferenceProps: Q,
            getFloatingProps: X,
            slot: G
        }
    }, e));
}
function $23dc003753f08df2$var$pe(e) {
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        let t = new MutationObserver(()=>{
            let n = window.getComputedStyle(e).maxHeight, l = parseFloat(n);
            if (isNaN(l)) return;
            let r = parseInt(n);
            isNaN(r) || l !== r && (e.style.maxHeight = `${Math.ceil(l)}px`);
        });
        return t.observe(e, {
            attributes: !0,
            attributeFilter: [
                "style"
            ]
        }), ()=>{
            t.disconnect();
        };
    }, [
        e
    ]);
}
function $23dc003753f08df2$var$ce(e, t) {
    var o, u, f;
    let n = $23dc003753f08df2$var$V((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t), l = $23dc003753f08df2$var$V((u = e == null ? void 0 : e.offset) != null ? u : "var(--anchor-offset, 0)", t), r = $23dc003753f08df2$var$V((f = e == null ? void 0 : e.padding) != null ? f : "var(--anchor-padding, 0)", t);
    return {
        ...e,
        gap: n,
        offset: l,
        padding: r
    };
}
function $23dc003753f08df2$var$V(e, t, n) {
    let l = (0, $5Ai9V.useDisposables)(), r = (0, $114Mg.useEvent)((s, i)=>{
        if (s == null) return [
            n,
            null
        ];
        if (typeof s == "number") return [
            s,
            null
        ];
        if (typeof s == "string") {
            if (!i) return [
                n,
                null
            ];
            let F = $23dc003753f08df2$var$J(s, i);
            return [
                F,
                (E)=>{
                    let v = $23dc003753f08df2$var$D(s);
                    {
                        let c = v.map((P)=>window.getComputedStyle(i).getPropertyValue(P));
                        l.requestAnimationFrame(function P() {
                            l.nextFrame(P);
                            let a = !1;
                            for (let [b, w] of v.entries()){
                                let g = window.getComputedStyle(i).getPropertyValue(w);
                                if (c[b] !== g) {
                                    c[b] = g, a = !0;
                                    break;
                                }
                            }
                            if (!a) return;
                            let p = $23dc003753f08df2$var$J(s, i);
                            F !== p && (E(p), F = p);
                        });
                    }
                    return l.dispose;
                }
            ];
        }
        return [
            n,
            null
        ];
    }), o = (0, $acw62.useMemo)(()=>r(e, t)[0], [
        e,
        t
    ]), [u = o, f] = (0, $acw62.useState)();
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        let [s, i] = r(e, t);
        if (f(s), !!i) return i(f);
    }, [
        e,
        t
    ]), u;
}
function $23dc003753f08df2$var$D(e) {
    let t = /var\((.*)\)/.exec(e);
    if (t) {
        let n = t[1].indexOf(",");
        if (n === -1) return [
            t[1]
        ];
        let l = t[1].slice(0, n).trim(), r = t[1].slice(n + 1).trim();
        return r ? [
            l,
            ...$23dc003753f08df2$var$D(r)
        ] : [
            l
        ];
    }
    return [];
}
function $23dc003753f08df2$var$J(e, t) {
    let n = document.createElement("div");
    t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
    let l = parseFloat(window.getComputedStyle(n).marginTop) || 0;
    return t.removeChild(n), l;
}

});
parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $461947879dcdbcd4$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $461947879dcdbcd4$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $461947879dcdbcd4$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $461947879dcdbcd4$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $461947879dcdbcd4$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $461947879dcdbcd4$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $461947879dcdbcd4$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $461947879dcdbcd4$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $461947879dcdbcd4$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $461947879dcdbcd4$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $461947879dcdbcd4$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $33bLr.getNodeScroll)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $33bLr.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if ((0, $33bLr.isHTMLElement)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, true) : (0, $1obCQ.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === 'rtl') x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $33bLr.isTopLayer)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1obCQ.max)(rect.top, accRect.top);
        accRect.right = (0, $1obCQ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1obCQ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1obCQ.max)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $33bLr.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ((0, $33bLr.isTopLayer)(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...(0, $33bLr.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const initialSideAxis = (0, $1obCQ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1obCQ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === 'left';
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $238ac70369f38756$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $238ac70369f38756$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $238ac70369f38756$export$7bf1f8740e3e34af);
function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("33OG6", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $23a8f689f1d4c3be$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $23a8f689f1d4c3be$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $23a8f689f1d4c3be$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $23a8f689f1d4c3be$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $23a8f689f1d4c3be$export$346677f925de839c);

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $23a8f689f1d4c3be$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const openRef = $23a8f689f1d4c3be$var$useLatestRef(open);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $618j3.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $618j3.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $618j3.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23a8f689f1d4c3be$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $618j3.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23a8f689f1d4c3be$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $618j3.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23a8f689f1d4c3be$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $618j3.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23a8f689f1d4c3be$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $618j3.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23a8f689f1d4c3be$export$346677f925de839c = (options, deps)=>({
        ...(0, $618j3.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23a8f689f1d4c3be$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $618j3.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23a8f689f1d4c3be$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $618j3.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23a8f689f1d4c3be$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $618j3.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$23a8f689f1d4c3be$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});

parcelRegister("5rxG7", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $3f69993268aa5b7a$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useInteractions", () => $3f69993268aa5b7a$export$a519f7794e446ddd);
$parcel$export(module.exports, "inner", () => $3f69993268aa5b7a$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $3f69993268aa5b7a$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "offset", () => (parcelRequire("33OG6")).offset);

var $acw62 = parcelRequire("acw62");

var $4wHOx = parcelRequire("4wHOx");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");

var $e8HHX = parcelRequire("e8HHX");

var $1u0KT = parcelRequire("1u0KT");

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");
var $33OG6 = parcelRequire("33OG6");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $3f69993268aa5b7a$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $3f69993268aa5b7a$var$SafeReact = {
    ...$acw62
};
const $3f69993268aa5b7a$var$useInsertionEffect = $3f69993268aa5b7a$var$SafeReact.useInsertionEffect;
const $3f69993268aa5b7a$var$useSafeInsertionEffect = $3f69993268aa5b7a$var$useInsertionEffect || ((fn)=>fn());
function $3f69993268aa5b7a$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $3f69993268aa5b7a$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $3f69993268aa5b7a$var$ARROW_UP = 'ArrowUp';
const $3f69993268aa5b7a$var$ARROW_DOWN = 'ArrowDown';
const $3f69993268aa5b7a$var$ARROW_LEFT = 'ArrowLeft';
const $3f69993268aa5b7a$var$ARROW_RIGHT = 'ArrowRight';
function $3f69993268aa5b7a$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $3f69993268aa5b7a$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $3f69993268aa5b7a$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $3f69993268aa5b7a$var$ARROW_UP) {
        stop && (0, $4wHOx.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $3f69993268aa5b7a$var$ARROW_DOWN) {
        stop && (0, $4wHOx.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $1obCQ.floor)(prevIndex / cols);
        if (event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_LEFT : $3f69993268aa5b7a$var$ARROW_RIGHT)) {
            stop && (0, $4wHOx.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_RIGHT : $3f69993268aa5b7a$var$ARROW_LEFT)) {
            stop && (0, $4wHOx.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $1obCQ.floor)(maxIndex / cols) === prevRow;
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_RIGHT : $3f69993268aa5b7a$var$ARROW_LEFT) ? maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $3f69993268aa5b7a$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $3f69993268aa5b7a$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $3f69993268aa5b7a$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $3f69993268aa5b7a$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $3f69993268aa5b7a$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $3f69993268aa5b7a$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $3f69993268aa5b7a$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $3f69993268aa5b7a$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($3f69993268aa5b7a$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$3f69993268aa5b7a$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $3f69993268aa5b7a$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($3f69993268aa5b7a$var$FloatingListContext);
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $3f69993268aa5b7a$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ $acw62.createElement("div", computedProps);
}
const $3f69993268aa5b7a$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $3f69993268aa5b7a$var$horizontalKeys = [
    $3f69993268aa5b7a$var$ARROW_LEFT,
    $3f69993268aa5b7a$var$ARROW_RIGHT
];
const $3f69993268aa5b7a$var$verticalKeys = [
    $3f69993268aa5b7a$var$ARROW_UP,
    $3f69993268aa5b7a$var$ARROW_DOWN
];
const $3f69993268aa5b7a$var$allKeys = [
    ...$3f69993268aa5b7a$var$horizontalKeys,
    ...$3f69993268aa5b7a$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$3f69993268aa5b7a$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $3f69993268aa5b7a$var$ARROW_LEFT : $3f69993268aa5b7a$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $3f69993268aa5b7a$var$ARROW_RIGHT : $3f69993268aa5b7a$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $3f69993268aa5b7a$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $3f69993268aa5b7a$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $3f69993268aa5b7a$var$allKeys : ({
            horizontal: $3f69993268aa5b7a$var$horizontalKeys,
            vertical: $3f69993268aa5b7a$var$verticalKeys,
            both: $3f69993268aa5b7a$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $3f69993268aa5b7a$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($3f69993268aa5b7a$var$CompositeContext);
    const { ref: ref, index: index } = $3f69993268aa5b7a$export$dcdc7ff5149f7d1a();
    const mergedRef = $3f69993268aa5b7a$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $3f69993268aa5b7a$var$renderJsx(render, computedProps);
});
function $3f69993268aa5b7a$var$_extends() {
    $3f69993268aa5b7a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f69993268aa5b7a$var$_extends.apply(this, arguments);
}
let $3f69993268aa5b7a$var$serverHandoffComplete = false;
let $3f69993268aa5b7a$var$count = 0;
const $3f69993268aa5b7a$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $3f69993268aa5b7a$var$count++;
function $3f69993268aa5b7a$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$3f69993268aa5b7a$var$serverHandoffComplete ? $3f69993268aa5b7a$var$genId() : undefined);
    $3f69993268aa5b7a$var$index(()=>{
        if (id == null) setId($3f69993268aa5b7a$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $3f69993268aa5b7a$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $3f69993268aa5b7a$var$useReactId = $3f69993268aa5b7a$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $3f69993268aa5b7a$export$f680877a34711e37 = $3f69993268aa5b7a$var$useReactId || $3f69993268aa5b7a$var$useFloatingId;
let $3f69993268aa5b7a$var$devMessageSet;
function $3f69993268aa5b7a$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $3f69993268aa5b7a$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $3f69993268aa5b7a$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $3f69993268aa5b7a$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $acw62.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $33bLr.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $acw62.createElement("svg", $3f69993268aa5b7a$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $acw62.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $3f69993268aa5b7a$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $3f69993268aa5b7a$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $3f69993268aa5b7a$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($3f69993268aa5b7a$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $3f69993268aa5b7a$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$9b136e0e758a42f4(customParentId) {
    const id = $3f69993268aa5b7a$export$f680877a34711e37();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const reactParentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3f69993268aa5b7a$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $3f69993268aa5b7a$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $3f69993268aa5b7a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $3f69993268aa5b7a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3f69993268aa5b7a$var$safePolygonIdentifier = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute('safe-polygon');
function $3f69993268aa5b7a$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $4wHOx.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $3f69993268aa5b7a$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const handleCloseRef = $3f69993268aa5b7a$var$useLatestRef(handleClose);
    const delayRef = $3f69993268aa5b7a$var$useLatestRef(delay);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const restTimeoutPendingRef = $acw62.useRef(false);
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $4wHOx.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $4wHOx.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($3f69993268aa5b7a$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$3f69993268aa5b7a$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $4wHOx.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $4wHOx.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $33bLr.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3f69993268aa5b7a$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $33bLr.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $4wHOx.getDocument)(elements.floating).body;
                body.setAttribute($3f69993268aa5b7a$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $acw62.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $3f69993268aa5b7a$var$NOOP = ()=>{};
const $3f69993268aa5b7a$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $3f69993268aa5b7a$var$NOOP,
    setState: $3f69993268aa5b7a$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $3f69993268aa5b7a$export$e2411914b150383d = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $3f69993268aa5b7a$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $3f69993268aa5b7a$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $3f69993268aa5b7a$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $3f69993268aa5b7a$var$rafId = 0;
function $3f69993268aa5b7a$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3f69993268aa5b7a$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3f69993268aa5b7a$var$rafId = requestAnimationFrame(exec);
}
function $3f69993268aa5b7a$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3f69993268aa5b7a$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3f69993268aa5b7a$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $3f69993268aa5b7a$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $3f69993268aa5b7a$var$counterMap = /*#__PURE__*/ new WeakMap();
let $3f69993268aa5b7a$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $3f69993268aa5b7a$var$markerMap = {};
let $3f69993268aa5b7a$var$lockCount$1 = 0;
const $3f69993268aa5b7a$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $3f69993268aa5b7a$var$unwrapHost = (node)=>node && (node.host || $3f69993268aa5b7a$var$unwrapHost(node.parentNode));
const $3f69993268aa5b7a$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $3f69993268aa5b7a$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $3f69993268aa5b7a$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $3f69993268aa5b7a$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$3f69993268aa5b7a$var$markerMap[markerName]) $3f69993268aa5b7a$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $3f69993268aa5b7a$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $33bLr.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($3f69993268aa5b7a$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $3f69993268aa5b7a$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $3f69993268aa5b7a$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $3f69993268aa5b7a$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($3f69993268aa5b7a$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $3f69993268aa5b7a$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$3f69993268aa5b7a$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $3f69993268aa5b7a$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $3f69993268aa5b7a$var$lockCount$1--;
        if (!$3f69993268aa5b7a$var$lockCount$1) {
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$uncontrolledElementsSet = new WeakSet();
            $3f69993268aa5b7a$var$markerMap = {};
        }
    };
}
function $3f69993268aa5b7a$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $4wHOx.getDocument)(avoidElements[0]).body;
    return $3f69993268aa5b7a$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $3f69993268aa5b7a$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $3f69993268aa5b7a$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3f69993268aa5b7a$var$getNextTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, 'next');
}
function $3f69993268aa5b7a$var$getPreviousTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, 'prev');
}
function $3f69993268aa5b7a$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $4wHOx.contains)(containerElement, relatedTarget);
}
function $3f69993268aa5b7a$var$disableFocusInside(container) {
    const tabbableElements = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $3f69993268aa5b7a$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $3f69993268aa5b7a$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $3f69993268aa5b7a$var$timeoutId;
function $3f69993268aa5b7a$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($3f69993268aa5b7a$var$timeoutId);
    }
}
const $3f69993268aa5b7a$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $3f69993268aa5b7a$var$index(()=>{
        if ((0, $4wHOx.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $3f69993268aa5b7a$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $3f69993268aa5b7a$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$3f69993268aa5b7a$var$createAttribute('focus-guard')]: '',
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $acw62.createElement("span", $3f69993268aa5b7a$var$_extends({}, props, restProps));
});
const $3f69993268aa5b7a$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$attr = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $3f69993268aa5b7a$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $3f69993268aa5b7a$export$f680877a34711e37();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    $3f69993268aa5b7a$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $33bLr.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $3f69993268aa5b7a$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $3f69993268aa5b7a$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3f69993268aa5b7a$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $3f69993268aa5b7a$var$enableFocusInside : $3f69993268aa5b7a$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $acw62.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $3f69993268aa5b7a$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $1u0KT.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $3f69993268aa5b7a$var$usePortalContext = ()=>$acw62.useContext($3f69993268aa5b7a$var$PortalContext);
const $3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $3f69993268aa5b7a$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $3f69993268aa5b7a$var$LIST_LIMIT = 20;
let $3f69993268aa5b7a$var$previouslyFocusedElements = [];
function $3f69993268aa5b7a$var$addPreviouslyFocusedElement(element) {
    $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $33bLr.getNodeName)(tabbableEl) === 'body') return;
    if (!(0, $e8HHX.isTabbable)(tabbableEl, $3f69993268aa5b7a$var$getTabbableOptions())) {
        const tabbableChild = (0, $e8HHX.tabbable)(tabbableEl, $3f69993268aa5b7a$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $3f69993268aa5b7a$var$previouslyFocusedElements.push(tabbableEl);
    if ($3f69993268aa5b7a$var$previouslyFocusedElements.length > $3f69993268aa5b7a$var$LIST_LIMIT) $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.slice(-$3f69993268aa5b7a$var$LIST_LIMIT);
}
function $3f69993268aa5b7a$var$getPreviouslyFocusedElement() {
    return $3f69993268aa5b7a$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $3f69993268aa5b7a$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $3f69993268aa5b7a$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3f69993268aa5b7a$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $4wHOx.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $3f69993268aa5b7a$var$supportsInert() ? _guards : true;
    const orderRef = $3f69993268aa5b7a$var$useLatestRef(order);
    const initialFocusRef = $3f69993268aa5b7a$var$useLatestRef(initialFocus);
    const returnFocusRef = $3f69993268aa5b7a$var$useLatestRef(returnFocus);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const tabbableIndexRef = $acw62.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $3f69993268aa5b7a$var$getFloatingFocusElement(floating);
    const getTabbableContent = $3f69993268aa5b7a$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $3f69993268aa5b7a$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $4wHOx.contains)(floatingFocusElement, (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $4wHOx.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $4wHOx.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $4wHOx.stopEvent)(event);
                    if (event.shiftKey) $3f69993268aa5b7a$var$enqueueFocus(els[els.length - 1]);
                    else $3f69993268aa5b7a$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $4wHOx.stopEvent)(event);
                    $3f69993268aa5b7a$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $4wHOx.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $4wHOx.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $4wHOx.contains)(domReference, relatedTarget) || (0, $4wHOx.contains)(floating, relatedTarget) || (0, $4wHOx.contains)(relatedTarget, floating) || (0, $4wHOx.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute('focus-guard')) || tree && ($3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $4wHOx.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $4wHOx.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $3f69993268aa5b7a$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floatingFocusElement)) === (0, $4wHOx.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $33bLr.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $33bLr.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $3f69993268aa5b7a$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $33bLr.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $3f69993268aa5b7a$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $3f69993268aa5b7a$var$markOthers(insideElements, guards, !guards) : $3f69993268aa5b7a$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !(0, $33bLr.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $4wHOx.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4wHOx.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $4wHOx.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $3f69993268aa5b7a$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $4wHOx.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4wHOx.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $3f69993268aa5b7a$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $4wHOx.isVirtualClick)(event) || (0, $4wHOx.isVirtualPointerEvent)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $3f69993268aa5b7a$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $3f69993268aa5b7a$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $4wHOx.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $4wHOx.contains)(floating, activeEl) || tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $4wHOx.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $33bLr.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $acw62.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $3f69993268aa5b7a$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $3f69993268aa5b7a$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $3f69993268aa5b7a$var$lockCount = 0;
function $3f69993268aa5b7a$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $4wHOx.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $3f69993268aa5b7a$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3f69993268aa5b7a$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $3f69993268aa5b7a$var$index(()=>{
        if (!lockScroll) return;
        $3f69993268aa5b7a$var$lockCount++;
        if ($3f69993268aa5b7a$var$lockCount === 1) $3f69993268aa5b7a$var$cleanup = $3f69993268aa5b7a$var$enableScrollLock();
        return ()=>{
            $3f69993268aa5b7a$var$lockCount--;
            if ($3f69993268aa5b7a$var$lockCount === 0) $3f69993268aa5b7a$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $3f69993268aa5b7a$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $3f69993268aa5b7a$var$isButtonTarget(event) {
    return (0, $33bLr.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $3f69993268aa5b7a$var$isSpaceIgnored(element) {
    return (0, $4wHOx.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $3f69993268aa5b7a$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $4wHOx.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $4wHOx.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$3f69993268aa5b7a$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event) || $3f69993268aa5b7a$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $3f69993268aa5b7a$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $3f69993268aa5b7a$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $3f69993268aa5b7a$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $3f69993268aa5b7a$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($3f69993268aa5b7a$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $4wHOx.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $33bLr.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $4wHOx.getTarget)(event);
            if (!(0, $4wHOx.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3f69993268aa5b7a$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $3f69993268aa5b7a$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $3f69993268aa5b7a$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $3f69993268aa5b7a$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $3f69993268aa5b7a$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $3f69993268aa5b7a$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $3f69993268aa5b7a$var$normalizeProp(capture);
    const isComposingRef = $acw62.useRef(false);
    const closeOnEscapeKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $4wHOx.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $4wHOx.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $4wHOx.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $4wHOx.getTarget)(event);
        const inertSelector = "[" + $3f69993268aa5b7a$var$createAttribute('inert') + "]";
        const markers = (0, $4wHOx.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $33bLr.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $33bLr.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $33bLr.getParentNode)(targetRootAncestor);
            if ((0, $33bLr.isLastTraversableNode)(nextParent) || !(0, $33bLr.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $33bLr.isElement)(target) && !(0, $4wHOx.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $4wHOx.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $4wHOx.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $33bLr.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $33bLr.getComputedStyle)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $4wHOx.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $4wHOx.isEventTargetWithin)(event, elements.floating) || (0, $4wHOx.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $4wHOx.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $4wHOx.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $33bLr.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $4wHOx.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $33bLr.isElement)(elements.domReference)) ancestors = (0, $33bLr.getOverflowAncestors)(elements.domReference);
            if ((0, $33bLr.isElement)(elements.floating)) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(elements.floating));
            if (!(0, $33bLr.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$3f69993268aa5b7a$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$3f69993268aa5b7a$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3f69993268aa5b7a$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $3f69993268aa5b7a$export$f680877a34711e37();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub());
    const nested = $3f69993268aa5b7a$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = $3f69993268aa5b7a$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3f69993268aa5b7a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $3f69993268aa5b7a$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    $3f69993268aa5b7a$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $33OG6.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $33bLr.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $33bLr.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $33bLr.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $33bLr.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $3f69993268aa5b7a$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $33bLr.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $33bLr.isHTMLElement)(elements.domReference) && elements.domReference === (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $4wHOx.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $4wHOx.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $33bLr.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $4wHOx.isSafari)() && (0, $4wHOx.isMac)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $4wHOx.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $33bLr.isElement)(relatedTarget) && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $4wHOx.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $4wHOx.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $4wHOx.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3f69993268aa5b7a$var$ACTIVE_KEY = 'active';
const $3f69993268aa5b7a$var$SELECTED_KEY = 'selected';
function $3f69993268aa5b7a$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$3f69993268aa5b7a$var$ACTIVE_KEY]: _, [$3f69993268aa5b7a$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $3f69993268aa5b7a$var$ACTIVE_KEY,
                    $3f69993268aa5b7a$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $3f69993268aa5b7a$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $3f69993268aa5b7a$var$isPreventScrollSupported = false;
function $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3f69993268aa5b7a$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_UP || key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_LEFT || key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $3f69993268aa5b7a$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_RIGHT : key === $3f69993268aa5b7a$var$ARROW_LEFT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_UP;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $3f69993268aa5b7a$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $3f69993268aa5b7a$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $3f69993268aa5b7a$var$useLatestRef(floatingFocusElement);
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $4wHOx.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!elements.floating);
    const previousOpenRef = $acw62.useRef(open);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $3f69993268aa5b7a$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3f69993268aa5b7a$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $3f69993268aa5b7a$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = $3f69993268aa5b7a$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $3f69993268aa5b7a$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $4wHOx.isMac)() && (0, $4wHOx.isSafari)() ? $3f69993268aa5b7a$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $3f69993268aa5b7a$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $3f69993268aa5b7a$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $3f69993268aa5b7a$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current) : $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3f69993268aa5b7a$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $4wHOx.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $3f69993268aa5b7a$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $4wHOx.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $33bLr.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $4wHOx.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $4wHOx.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3f69993268aa5b7a$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3f69993268aa5b7a$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$3f69993268aa5b7a$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_LEFT : $3f69993268aa5b7a$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
            (0, $4wHOx.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $4wHOx.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $acw62.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $4wHOx.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $acw62.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $4wHOx.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $4wHOx.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $3f69993268aa5b7a$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $3f69993268aa5b7a$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $4wHOx.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $4wHOx.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $4wHOx.stopEvent)(event);
                        if (open) {
                            indexRef.current = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $4wHOx.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $3f69993268aa5b7a$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $3f69993268aa5b7a$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $3f69993268aa5b7a$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $3f69993268aa5b7a$export$f680877a34711e37();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $acw62.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $acw62.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3f69993268aa5b7a$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $3f69993268aa5b7a$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $3f69993268aa5b7a$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3f69993268aa5b7a$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $acw62.useState('unmounted');
    const isMounted = $3f69993268aa5b7a$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3f69993268aa5b7a$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $3f69993268aa5b7a$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3f69993268aa5b7a$var$useLatestRef(unstable_initial);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(unstable_open);
    const closeRef = $3f69993268aa5b7a$var$useLatestRef(unstable_close);
    const commonRef = $3f69993268aa5b7a$var$useLatestRef(unstable_common);
    $3f69993268aa5b7a$var$index(()=>{
        const initialStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $3f69993268aa5b7a$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef('');
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $3f69993268aa5b7a$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $3f69993268aa5b7a$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3f69993268aa5b7a$var$useLatestRef(ignoreKeys);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $3f69993268aa5b7a$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $4wHOx.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $4wHOx.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $acw62.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $3f69993268aa5b7a$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $33OG6.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $618j3.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $1obCQ.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $1obCQ.round);
            const maxHeight = rounder((0, $1obCQ.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $1obCQ.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $1obCQ.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $1u0KT.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $3f69993268aa5b7a$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $1u0KT.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $4wHOx.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $1u0KT.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $3f69993268aa5b7a$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3f69993268aa5b7a$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $3f69993268aa5b7a$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $4wHOx.getTarget)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $4wHOx.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $4wHOx.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3f69993268aa5b7a$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $33bLr.isElement)(event.relatedTarget) && (0, $4wHOx.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("4wHOx", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $34bc2325b4db944b$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $34bc2325b4db944b$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $34bc2325b4db944b$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $34bc2325b4db944b$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $34bc2325b4db944b$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $34bc2325b4db944b$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $34bc2325b4db944b$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $34bc2325b4db944b$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $34bc2325b4db944b$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $34bc2325b4db944b$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $34bc2325b4db944b$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $34bc2325b4db944b$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $34bc2325b4db944b$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $34bc2325b4db944b$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $34bc2325b4db944b$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $34bc2325b4db944b$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $34bc2325b4db944b$export$259ba5ae38188551);

var $33bLr = parcelRequire("33bLr");
function $34bc2325b4db944b$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $34bc2325b4db944b$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $33bLr.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $34bc2325b4db944b$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $34bc2325b4db944b$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $34bc2325b4db944b$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($34bc2325b4db944b$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $34bc2325b4db944b$export$29bf1b5f2c56cf63(event) {
    if ($34bc2325b4db944b$export$c8f880a2d81914c4()) return false;
    return !$34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $34bc2325b4db944b$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $34bc2325b4db944b$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($34bc2325b4db944b$export$867a782338812cb4()) || re.test($34bc2325b4db944b$export$7935961ef7719cb0());
}
function $34bc2325b4db944b$export$9ac100e40613ea10() {
    return $34bc2325b4db944b$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $34bc2325b4db944b$export$c8f880a2d81914c4() {
    return $34bc2325b4db944b$export$7935961ef7719cb0().includes('jsdom/');
}
function $34bc2325b4db944b$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $34bc2325b4db944b$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $34bc2325b4db944b$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $34bc2325b4db944b$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $34bc2325b4db944b$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $34bc2325b4db944b$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $34bc2325b4db944b$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $34bc2325b4db944b$export$42ad131c32f0fb8d(element) {
    return (0, $33bLr.isHTMLElement)(element) && element.matches($34bc2325b4db944b$export$78b3d091ff376bc);
}
function $34bc2325b4db944b$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $34bc2325b4db944b$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $34bc2325b4db944b$export$42ad131c32f0fb8d(element);
}

});

parcelRegister("e8HHX", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $a4b3b7902c9a987d$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $a4b3b7902c9a987d$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(',');
var $a4b3b7902c9a987d$var$NoElement = typeof Element === 'undefined';
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'hidden';
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'radio';
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat('iframe').join(',');
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};

});



parcelRegister("dBJH0", function(module, exports) {

$parcel$export(module.exports, "FormFields", () => $9e822caca6037577$export$125d0b248abd3e88);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $5Ai9V = parcelRequire("5Ai9V");

var $7FnlJ = parcelRequire("7FnlJ");

var $ebRQH = parcelRequire("ebRQH");

var $k9Al5 = parcelRequire("k9Al5");
let $9e822caca6037577$var$f = (0, $acw62.createContext)(null);
function $9e822caca6037577$export$172bce5caea3d96f(t) {
    let [e, r] = (0, $acw62.useState)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$var$f.Provider, {
        value: {
            target: e
        }
    }, t.children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        ref: r
    }));
}
function $9e822caca6037577$export$ddeacde93f925346({ children: t }) {
    let e = (0, $acw62.useContext)($9e822caca6037577$var$f);
    if (!e) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t);
    let { target: r } = e;
    return r ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t), r) : null;
}
function $9e822caca6037577$export$125d0b248abd3e88({ data: t, form: e, disabled: r, onReset: n, overrides: F }) {
    let [i, a] = (0, $acw62.useState)(null), p = (0, $5Ai9V.useDisposables)();
    return (0, $acw62.useEffect)(()=>{
        if (n && i) return p.addEventListener(i, "reset", n);
    }, [
        i,
        e,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$export$ddeacde93f925346, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$var$C, {
        setForm: a,
        formId: e
    }), (0, $7FnlJ.objectToFormEntries)(t).map(([s, v])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
            features: (0, $k9Al5.HiddenFeatures).Hidden,
            ...(0, $ebRQH.compact)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: e,
                disabled: r,
                name: s,
                value: v,
                ...F
            })
        })));
}
function $9e822caca6037577$var$C({ setForm: t, formId: e }) {
    return (0, $acw62.useEffect)(()=>{
        if (e) {
            let r = document.getElementById(e);
            r && t(r);
        }
    }, [
        t,
        e
    ]), e ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        ref: (r)=>{
            if (!r) return;
            let n = r.closest("form");
            n && t(n);
        }
    });
}

});
parcelRegister("7FnlJ", function(module, exports) {

$parcel$export(module.exports, "objectToFormEntries", () => $594e79751740d704$export$bc22b3e852574dab);
$parcel$export(module.exports, "attemptSubmit", () => $594e79751740d704$export$ee02894bdc79dd36);
function $594e79751740d704$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$594e79751740d704$var$o(t, $594e79751740d704$var$f(s, r), n);
    return t;
}
function $594e79751740d704$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $594e79751740d704$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$594e79751740d704$var$o(i, $594e79751740d704$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $594e79751740d704$export$bc22b3e852574dab(t, s, i);
}
function $594e79751740d704$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}

});

parcelRegister("ebRQH", function(module, exports) {

$parcel$export(module.exports, "RenderFeatures", () => $a54bdd13402af126$export$ba0ea3f20e7bf777);
$parcel$export(module.exports, "RenderStrategy", () => $a54bdd13402af126$export$80c0a745e59f7989);
$parcel$export(module.exports, "useRender", () => $a54bdd13402af126$export$e25bb1e5b53cbdff);
$parcel$export(module.exports, "compact", () => $a54bdd13402af126$export$8e16b83750b44988);
$parcel$export(module.exports, "mergeProps", () => $a54bdd13402af126$export$9d1611c77c2fe928);
$parcel$export(module.exports, "forwardRefWithAs", () => $a54bdd13402af126$export$e43f39796049410c);

var $acw62 = parcelRequire("acw62");

var $4Mkm0 = parcelRequire("4Mkm0");

var $6Ngq1 = parcelRequire("6Ngq1");
var $a54bdd13402af126$export$ba0ea3f20e7bf777 = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($a54bdd13402af126$export$ba0ea3f20e7bf777 || {}), $a54bdd13402af126$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a54bdd13402af126$export$80c0a745e59f7989 || {});
function $a54bdd13402af126$export$e25bb1e5b53cbdff() {
    let n = $a54bdd13402af126$var$U();
    return (0, $acw62.useCallback)((r)=>$a54bdd13402af126$var$C({
            mergeRefs: n,
            ...r
        }), [
        n
    ]);
}
function $a54bdd13402af126$var$C({ ourProps: n, theirProps: r, slot: e, defaultTag: a, features: s, visible: t = !0, name: l, mergeRefs: i }) {
    i = i != null ? i : $a54bdd13402af126$var$$;
    let o = $a54bdd13402af126$var$P(r, n);
    if (t) return $a54bdd13402af126$var$F(o, e, a, l, i);
    let y = s != null ? s : 0;
    if (y & 2) {
        let { static: f = !1, ...u } = o;
        if (f) return $a54bdd13402af126$var$F(u, e, a, l, i);
    }
    if (y & 1) {
        let { unmount: f = !0, ...u } = o;
        return (0, $6Ngq1.match)(f ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a54bdd13402af126$var$F({
                    ...u,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, l, i);
            }
        });
    }
    return $a54bdd13402af126$var$F(o, e, a, l, i);
}
function $a54bdd13402af126$var$F(n, r = {}, e, a, s) {
    let { as: t = e, children: l, refName: i = "ref", ...o } = $a54bdd13402af126$var$h(n, [
        "unmount",
        "static"
    ]), y = n.ref !== void 0 ? {
        [i]: n.ref
    } : {}, f = typeof l == "function" ? l(r) : l;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(r)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
    let u = {};
    if (r) {
        let d = !1, p = [];
        for (let [c, T] of Object.entries(r))typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, (g)=>`-${g.toLowerCase()}`));
        if (d) {
            u["data-headlessui-state"] = p.join(" ");
            for (let c of p)u[`data-${c}`] = "";
        }
    }
    if (t === (0, $acw62.Fragment) && (Object.keys($a54bdd13402af126$export$8e16b83750b44988(o)).length > 0 || Object.keys($a54bdd13402af126$export$8e16b83750b44988(u)).length > 0)) {
        if (!(0, $acw62.isValidElement)(f) || Array.isArray(f) && f.length > 1) {
            if (Object.keys($a54bdd13402af126$export$8e16b83750b44988(o)).length > 0) throw new Error([
                'Passing props on "Fragment"!',
                "",
                `The current component <${a} /> is rendering a "Fragment".`,
                "However we need to passthrough the following props:",
                Object.keys($a54bdd13402af126$export$8e16b83750b44988(o)).concat(Object.keys($a54bdd13402af126$export$8e16b83750b44988(u))).map((d)=>`  - ${d}`).join(`
`),
                "",
                "You can apply a few solutions:",
                [
                    'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                    "Render a single element as the child so that we can forward the props onto that element."
                ].map((d)=>`  - ${d}`).join(`
`)
            ].join(`
`));
        } else {
            let d = f.props, p = d == null ? void 0 : d.className, c = typeof p == "function" ? (...R)=>(0, $4Mkm0.classNames)(p(...R), o.className) : (0, $4Mkm0.classNames)(p, o.className), T = c ? {
                className: c
            } : {}, g = $a54bdd13402af126$var$P(f.props, $a54bdd13402af126$export$8e16b83750b44988($a54bdd13402af126$var$h(o, [
                "ref"
            ])));
            for(let R in u)R in g && delete u[R];
            return (0, $acw62.cloneElement)(f, Object.assign({}, g, u, y, {
                ref: s($a54bdd13402af126$var$H(f), y.ref)
            }, T));
        }
    }
    return (0, $acw62.createElement)(t, Object.assign({}, $a54bdd13402af126$var$h(o, [
        "ref"
    ]), t !== (0, $acw62.Fragment) && y, t !== (0, $acw62.Fragment) && u), f);
}
function $a54bdd13402af126$var$U() {
    let n = (0, $acw62.useRef)([]), r = (0, $acw62.useCallback)((e)=>{
        for (let a of n.current)a != null && (typeof a == "function" ? a(e) : a.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((a)=>a == null)) return n.current = e, r;
    };
}
function $a54bdd13402af126$var$$(...n) {
    return n.every((r)=>r == null) ? void 0 : (r)=>{
        for (let e of n)e != null && (typeof e == "function" ? e(r) : e.current = r);
    };
}
function $a54bdd13402af126$var$P(...n) {
    var a;
    if (n.length === 0) return {};
    if (n.length === 1) return n[0];
    let r = {}, e = {};
    for (let s of n)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
    if (r.disabled || r["aria-disabled"]) for(let s in e)/^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s) && (e[s] = [
        (t)=>{
            var l;
            return (l = t == null ? void 0 : t.preventDefault) == null ? void 0 : l.call(t);
        }
    ]);
    for(let s in e)Object.assign(r, {
        [s] (t, ...l) {
            let i = e[s];
            for (let o of i){
                if ((t instanceof Event || (t == null ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
                o(t, ...l);
            }
        }
    });
    return r;
}
function $a54bdd13402af126$export$9d1611c77c2fe928(...n) {
    var a;
    if (n.length === 0) return {};
    if (n.length === 1) return n[0];
    let r = {}, e = {};
    for (let s of n)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
    for(let s in e)Object.assign(r, {
        [s] (...t) {
            let l = e[s];
            for (let i of l)i == null || i(...t);
        }
    });
    return r;
}
function $a54bdd13402af126$export$e43f39796049410c(n) {
    var r;
    return Object.assign((0, $acw62.forwardRef)(n), {
        displayName: (r = n.displayName) != null ? r : n.name
    });
}
function $a54bdd13402af126$export$8e16b83750b44988(n) {
    let r = Object.assign({}, n);
    for(let e in r)r[e] === void 0 && delete r[e];
    return r;
}
function $a54bdd13402af126$var$h(n, r = []) {
    let e = Object.assign({}, n);
    for (let a of r)a in e && delete e[a];
    return e;
}
function $a54bdd13402af126$var$H(n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.split(".")[0] >= "19" ? n.props.ref : n.ref;
}

});
parcelRegister("4Mkm0", function(module, exports) {

$parcel$export(module.exports, "classNames", () => $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff);
function $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}

});


parcelRegister("k9Al5", function(module, exports) {

$parcel$export(module.exports, "HiddenFeatures", () => $eac0d614a77ee96b$export$4e7f8864c6a16d8a);
$parcel$export(module.exports, "Hidden", () => $eac0d614a77ee96b$export$8dc98ba7eadeaa56);

var $ebRQH = parcelRequire("ebRQH");
let $eac0d614a77ee96b$var$a = "span";
var $eac0d614a77ee96b$export$4e7f8864c6a16d8a = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($eac0d614a77ee96b$export$4e7f8864c6a16d8a || {});
function $eac0d614a77ee96b$var$l(t, r) {
    var n;
    let { features: d = 1, ...e } = t, o = {
        ref: r,
        "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $ebRQH.useRender)()({
        ourProps: o,
        theirProps: e,
        slot: {},
        defaultTag: $eac0d614a77ee96b$var$a,
        name: "Hidden"
    });
}
let $eac0d614a77ee96b$export$8dc98ba7eadeaa56 = (0, $ebRQH.forwardRefWithAs)($eac0d614a77ee96b$var$l);

});


parcelRegister("9UPTU", function(module, exports) {

$parcel$export(module.exports, "useFrozenData", () => $73819a70e276dbaa$export$1a771eb6e04a3c48);

var $acw62 = parcelRequire("acw62");
function $73819a70e276dbaa$export$824932a86c309819({ children: o, freeze: e }) {
    let n = $73819a70e276dbaa$export$1a771eb6e04a3c48(e, o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, n);
}
function $73819a70e276dbaa$export$1a771eb6e04a3c48(o, e) {
    let [n, t] = (0, $acw62.useState)(e);
    return !o && n !== e && t(e), o ? n : e;
}

});

parcelRegister("jpbxo", function(module, exports) {

$parcel$export(module.exports, "useProvidedId", () => $e2094d3f1733ff55$export$6ba3910d268310db);

var $acw62 = parcelRequire("acw62");
let $e2094d3f1733ff55$var$e = (0, $acw62.createContext)(void 0);
function $e2094d3f1733ff55$export$6ba3910d268310db() {
    return (0, $acw62.useContext)($e2094d3f1733ff55$var$e);
}
function $e2094d3f1733ff55$export$6be90bcb437e928f({ id: t, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e2094d3f1733ff55$var$e.Provider, {
        value: t
    }, r);
}

});

parcelRegister("auuNT", function(module, exports) {

$parcel$export(module.exports, "State", () => $7a3499b4b3c6f184$export$7254cc27399e90bd);
$parcel$export(module.exports, "useOpenClosed", () => $7a3499b4b3c6f184$export$fc6fdf0ecf360e);
$parcel$export(module.exports, "OpenClosedProvider", () => $7a3499b4b3c6f184$export$2a0ed818b175f558);
$parcel$export(module.exports, "ResetOpenClosedProvider", () => $7a3499b4b3c6f184$export$6748feed729c7cf3);

var $acw62 = parcelRequire("acw62");
let $7a3499b4b3c6f184$var$n = (0, $acw62.createContext)(null);
$7a3499b4b3c6f184$var$n.displayName = "OpenClosedContext";
var $7a3499b4b3c6f184$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($7a3499b4b3c6f184$export$7254cc27399e90bd || {});
function $7a3499b4b3c6f184$export$fc6fdf0ecf360e() {
    return (0, $acw62.useContext)($7a3499b4b3c6f184$var$n);
}
function $7a3499b4b3c6f184$export$2a0ed818b175f558({ value: o, children: t }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: o
    }, t);
}
function $7a3499b4b3c6f184$export$6748feed729c7cf3({ children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: null
    }, o);
}

});

parcelRegister("5fYEB", function(module, exports) {

$parcel$export(module.exports, "isDisabledReactIssue7711", () => $3d3d670dbe2ceed6$export$db61f031a278447c);
function $3d3d670dbe2ceed6$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3d3d670dbe2ceed6$var$i(l) ? !1 : t;
}
function $3d3d670dbe2ceed6$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

});

parcelRegister("fLrGx", function(module, exports) {

$parcel$export(module.exports, "Focus", () => $b7a0b87cd8a0fa3d$export$807a7eae502106e7);
$parcel$export(module.exports, "calculateActiveIndex", () => $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e);
function $b7a0b87cd8a0fa3d$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $b7a0b87cd8a0fa3d$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($b7a0b87cd8a0fa3d$export$807a7eae502106e7 || {});
function $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            s === -1 && (s = t.length);
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $b7a0b87cd8a0fa3d$var$u(l);
    }
}

});

parcelRegister("iGb09", function(module, exports) {

$parcel$export(module.exports, "useDescribedBy", () => $d994aee5798540d7$export$899851af1363628);
$parcel$export(module.exports, "useDescriptions", () => $d994aee5798540d7$export$babde88292020af7);
$parcel$export(module.exports, "Description", () => $d994aee5798540d7$export$393edc798c47379d);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $ebRQH = parcelRequire("ebRQH");
"use client";
let $d994aee5798540d7$var$a = (0, $acw62.createContext)(null);
$d994aee5798540d7$var$a.displayName = "DescriptionContext";
function $d994aee5798540d7$var$f() {
    let r = (0, $acw62.useContext)($d994aee5798540d7$var$a);
    if (r === null) {
        let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(e, $d994aee5798540d7$var$f), e;
    }
    return r;
}
function $d994aee5798540d7$export$899851af1363628() {
    var r, e;
    return (e = (r = (0, $acw62.useContext)($d994aee5798540d7$var$a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function $d994aee5798540d7$export$babde88292020af7() {
    let [r, e] = (0, $acw62.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(t) {
                let i = (0, $114Mg.useEvent)((n)=>(e((s)=>[
                            ...s,
                            n
                        ]), ()=>e((s)=>{
                            let o = s.slice(), p = o.indexOf(n);
                            return p !== -1 && o.splice(p, 1), o;
                        }))), l = (0, $acw62.useMemo)(()=>({
                        register: i,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    i,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d994aee5798540d7$var$a.Provider, {
                    value: l
                }, t.children);
            }, [
            e
        ])
    ];
}
let $d994aee5798540d7$var$S = "p";
function $d994aee5798540d7$var$C(r, e) {
    let d = (0, $acw62.useId)(), t = (0, $brAF4.useDisabled)(), { id: i = `headlessui-description-${d}`, ...l } = r, n = $d994aee5798540d7$var$f(), s = (0, $6mpbl.useSyncRefs)(e);
    (0, $8KgIp.useIsoMorphicEffect)(()=>n.register(i), [
        i,
        n.register
    ]);
    let o = t || !1, p = (0, $acw62.useMemo)(()=>({
            ...n.slot,
            disabled: o
        }), [
        n.slot,
        o
    ]), D = {
        ref: s,
        ...n.props,
        id: i
    };
    return (0, $ebRQH.useRender)()({
        ourProps: D,
        theirProps: l,
        slot: p,
        defaultTag: $d994aee5798540d7$var$S,
        name: n.name || "Description"
    });
}
let $d994aee5798540d7$var$_ = (0, $ebRQH.forwardRefWithAs)($d994aee5798540d7$var$C), $d994aee5798540d7$export$393edc798c47379d = Object.assign($d994aee5798540d7$var$_, {});

});

parcelRegister("6AKlm", function(module, exports) {

$parcel$export(module.exports, "Keys", () => $4cca0dbc68b0507a$export$4b0075e5ea5e1f26);
var $4cca0dbc68b0507a$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($4cca0dbc68b0507a$export$4b0075e5ea5e1f26 || {});

});

parcelRegister("5qg9U", function(module, exports) {

$parcel$export(module.exports, "useLabelledBy", () => $3f2bea42b2459559$export$1f86aee6764cddb2);
$parcel$export(module.exports, "useLabels", () => $3f2bea42b2459559$export$d6875122194c7b44);
$parcel$export(module.exports, "Label", () => $3f2bea42b2459559$export$b04be29aa201d4f5);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $jpbxo = parcelRequire("jpbxo");

var $ebRQH = parcelRequire("ebRQH");
"use client";
let $3f2bea42b2459559$var$c = (0, $acw62.createContext)(null);
$3f2bea42b2459559$var$c.displayName = "LabelContext";
function $3f2bea42b2459559$export$feddbbf47baabdb9() {
    let r = (0, $acw62.useContext)($3f2bea42b2459559$var$c);
    if (r === null) {
        let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(l, $3f2bea42b2459559$export$feddbbf47baabdb9), l;
    }
    return r;
}
function $3f2bea42b2459559$export$1f86aee6764cddb2(r) {
    var a, e, o;
    let l = (e = (a = (0, $acw62.useContext)($3f2bea42b2459559$var$c)) == null ? void 0 : a.value) != null ? e : void 0;
    return ((o = r == null ? void 0 : r.length) != null ? o : 0) > 0 ? [
        l,
        ...r
    ].filter(Boolean).join(" ") : l;
}
function $3f2bea42b2459559$export$d6875122194c7b44({ inherit: r = !1 } = {}) {
    let l = $3f2bea42b2459559$export$1f86aee6764cddb2(), [a, e] = (0, $acw62.useState)([]), o = r ? [
        l,
        ...a
    ].filter(Boolean) : a;
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(t) {
                let s = (0, $114Mg.useEvent)((i)=>(e((p)=>[
                            ...p,
                            i
                        ]), ()=>e((p)=>{
                            let u = p.slice(), d = u.indexOf(i);
                            return d !== -1 && u.splice(d, 1), u;
                        }))), m = (0, $acw62.useMemo)(()=>({
                        register: s,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    s,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f2bea42b2459559$var$c.Provider, {
                    value: m
                }, t.children);
            }, [
            e
        ])
    ];
}
let $3f2bea42b2459559$var$N = "label";
function $3f2bea42b2459559$var$G(r, l) {
    var y;
    let a = (0, $acw62.useId)(), e = $3f2bea42b2459559$export$feddbbf47baabdb9(), o = (0, $jpbxo.useProvidedId)(), g = (0, $brAF4.useDisabled)(), { id: t = `headlessui-label-${a}`, htmlFor: s = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor, passive: m = !1, ...i } = r, p = (0, $6mpbl.useSyncRefs)(l);
    (0, $8KgIp.useIsoMorphicEffect)(()=>e.register(t), [
        t,
        e.register
    ]);
    let u = (0, $114Mg.useEvent)((L)=>{
        let b = L.currentTarget;
        if (b instanceof HTMLLabelElement && L.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(L), b instanceof HTMLLabelElement) {
            let n = document.getElementById(b.htmlFor);
            if (n) {
                let E = n.getAttribute("disabled");
                if (E === "true" || E === "") return;
                let x = n.getAttribute("aria-disabled");
                if (x === "true" || x === "") return;
                (n instanceof HTMLInputElement && (n.type === "radio" || n.type === "checkbox") || n.role === "radio" || n.role === "checkbox" || n.role === "switch") && n.click(), n.focus({
                    preventScroll: !0
                });
            }
        }
    }), d = g || !1, C = (0, $acw62.useMemo)(()=>({
            ...e.slot,
            disabled: d
        }), [
        e.slot,
        d
    ]), f = {
        ref: p,
        ...e.props,
        id: t,
        htmlFor: s,
        onClick: u
    };
    return m && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in i && delete i.onClick), (0, $ebRQH.useRender)()({
        ourProps: f,
        theirProps: i,
        slot: C,
        defaultTag: s ? $3f2bea42b2459559$var$N : "div",
        name: e.name || "Label"
    });
}
let $3f2bea42b2459559$var$U = (0, $ebRQH.forwardRefWithAs)($3f2bea42b2459559$var$G), $3f2bea42b2459559$export$b04be29aa201d4f5 = Object.assign($3f2bea42b2459559$var$U, {});

});

parcelRegister("e9NTc", function(module, exports) {

$parcel$export(module.exports, "useNestedPortals", () => $a4e89ae9835d0556$export$26b8c35244a70b37);
$parcel$export(module.exports, "PortalGroup", () => $a4e89ae9835d0556$export$84c667e5e4409848);
$parcel$export(module.exports, "Portal", () => $a4e89ae9835d0556$export$602eac185826482c);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $114Mg = parcelRequire("114Mg");

var $8KgIp = parcelRequire("8KgIp");

var $3XIoH = parcelRequire("3XIoH");

var $5IEAk = parcelRequire("5IEAk");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $aQyzu = parcelRequire("aQyzu");

var $Iy8e1 = parcelRequire("Iy8e1");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $a4e89ae9835d0556$var$N(u) {
    let r = (0, $aQyzu.usePortalRoot)(), n = (0, $acw62.useContext)($a4e89ae9835d0556$var$v), e = (0, $5IEAk.useOwnerDocument)(u), [o, l] = (0, $acw62.useState)(()=>{
        var t;
        if (!r && n !== null) return (t = n.current) != null ? t : null;
        if ((0, $Iy8e1.env).isServer) return null;
        let p = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (p) return p;
        if (e === null) return null;
        let a = e.createElement("div");
        return a.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(a);
    });
    return (0, $acw62.useEffect)(()=>{
        o !== null && (e != null && e.body.contains(o) || e == null || e.body.appendChild(o));
    }, [
        o,
        e
    ]), (0, $acw62.useEffect)(()=>{
        r || n !== null && l(n.current);
    }, [
        n,
        l,
        r
    ]), o;
}
let $a4e89ae9835d0556$var$M = (0, $acw62.Fragment), $a4e89ae9835d0556$var$S = (0, $ebRQH.forwardRefWithAs)(function(r, n) {
    let e = r, o = (0, $acw62.useRef)(null), l = (0, $6mpbl.useSyncRefs)((0, $6mpbl.optionalRef)((i)=>{
        o.current = i;
    }), n), p = (0, $5IEAk.useOwnerDocument)(o), a = $a4e89ae9835d0556$var$N(o), [t] = (0, $acw62.useState)(()=>{
        var i;
        return (0, $Iy8e1.env).isServer ? null : (i = p == null ? void 0 : p.createElement("div")) != null ? i : null;
    }), s = (0, $acw62.useContext)($a4e89ae9835d0556$var$y), b = (0, $b8md9.useServerHandoffComplete)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        !a || !t || a.contains(t) || (t.setAttribute("data-headlessui-portal", ""), a.appendChild(t));
    }, [
        a,
        t
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (t && s) return s.register(t);
    }, [
        s,
        t
    ]), (0, $3XIoH.useOnUnmount)(()=>{
        var i;
        !a || !t || (t instanceof Node && a.contains(t) && a.removeChild(t), a.childNodes.length <= 0 && ((i = a.parentElement) == null || i.removeChild(a)));
    });
    let H = (0, $ebRQH.useRender)();
    return b ? !a || !t ? null : (0, $1u0KT.createPortal)(H({
        ourProps: {
            ref: l
        },
        theirProps: e,
        slot: {},
        defaultTag: $a4e89ae9835d0556$var$M,
        name: "Portal"
    }), t) : null;
});
function $a4e89ae9835d0556$var$j(u, r) {
    let n = (0, $6mpbl.useSyncRefs)(r), { enabled: e = !0, ...o } = u, l = (0, $ebRQH.useRender)();
    return e ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$S, {
        ...o,
        ref: n
    }) : l({
        ourProps: {
            ref: n
        },
        theirProps: o,
        slot: {},
        defaultTag: $a4e89ae9835d0556$var$M,
        name: "Portal"
    });
}
let $a4e89ae9835d0556$var$W = (0, $acw62.Fragment), $a4e89ae9835d0556$var$v = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$var$I(u, r) {
    let { target: n, ...e } = u, l = {
        ref: (0, $6mpbl.useSyncRefs)(r)
    }, p = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$v.Provider, {
        value: n
    }, p({
        ourProps: l,
        theirProps: e,
        defaultTag: $a4e89ae9835d0556$var$W,
        name: "Popover.Group"
    }));
}
let $a4e89ae9835d0556$var$y = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$export$26b8c35244a70b37() {
    let u = (0, $acw62.useContext)($a4e89ae9835d0556$var$y), r = (0, $acw62.useRef)([]), n = (0, $114Mg.useEvent)((l)=>(r.current.push(l), u && u.register(l), ()=>e(l))), e = (0, $114Mg.useEvent)((l)=>{
        let p = r.current.indexOf(l);
        p !== -1 && r.current.splice(p, 1), u && u.unregister(l);
    }), o = (0, $acw62.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: r
        }), [
        n,
        e,
        r
    ]);
    return [
        r,
        (0, $acw62.useMemo)(()=>function({ children: p }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$y.Provider, {
                    value: o
                }, p);
            }, [
            o
        ])
    ];
}
let $a4e89ae9835d0556$var$J = (0, $ebRQH.forwardRefWithAs)($a4e89ae9835d0556$var$j), $a4e89ae9835d0556$export$84c667e5e4409848 = (0, $ebRQH.forwardRefWithAs)($a4e89ae9835d0556$var$I), $a4e89ae9835d0556$export$602eac185826482c = Object.assign($a4e89ae9835d0556$var$J, {
    Group: $a4e89ae9835d0556$export$84c667e5e4409848
});

});
parcelRegister("3XIoH", function(module, exports) {

$parcel$export(module.exports, "useOnUnmount", () => $2e29522f6fc857e9$export$cd059ee7fd0e9f3d);

var $acw62 = parcelRequire("acw62");

var $eJKgu = parcelRequire("eJKgu");

var $114Mg = parcelRequire("114Mg");
function $2e29522f6fc857e9$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $114Mg.useEvent)(t), e = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $eJKgu.microTask)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}

});

parcelRegister("b8md9", function(module, exports) {

$parcel$export(module.exports, "useServerHandoffComplete", () => $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");
function $81b1abbf8717f9cc$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $acw62 ? ((o)=>o.useSyncExternalStore)($acw62)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa() {
    let r = $81b1abbf8717f9cc$var$s(), [e, n] = $acw62.useState((0, $Iy8e1.env).isHandoffComplete);
    return e && (0, $Iy8e1.env).isHandoffComplete === !1 && n(!1), $acw62.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $acw62.useEffect(()=>(0, $Iy8e1.env).handoff(), []), r ? !1 : e;
}

});

parcelRegister("aQyzu", function(module, exports) {

$parcel$export(module.exports, "usePortalRoot", () => $7e5993dca17d6628$export$6ecd3efa4eebe261);
$parcel$export(module.exports, "ForcePortalRoot", () => $7e5993dca17d6628$export$8f2af6644e3a3c93);

var $acw62 = parcelRequire("acw62");
let $7e5993dca17d6628$var$e = (0, $acw62.createContext)(!1);
function $7e5993dca17d6628$export$6ecd3efa4eebe261() {
    return (0, $acw62.useContext)($7e5993dca17d6628$var$e);
}
function $7e5993dca17d6628$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e5993dca17d6628$var$e.Provider, {
        value: o.force
    }, o.children);
}

});



parcelRegister("iymfR", function(module, exports) {

$parcel$export(module.exports, "TransitionChild", () => $d81caa4f4b5ad364$export$b8acc0f6b9e8ca5d);
$parcel$export(module.exports, "Transition", () => $d81caa4f4b5ad364$export$be58926105124dd4);

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $brBI7 = parcelRequire("brBI7");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $bdknl = parcelRequire("bdknl");

var $auuNT = parcelRequire("auuNT");

var $4Mkm0 = parcelRequire("4Mkm0");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $d81caa4f4b5ad364$var$ue(e) {
    var t;
    return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : $d81caa4f4b5ad364$var$de) !== (0, $acw62.Fragment) || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(e.children) === 1;
}
let $d81caa4f4b5ad364$var$w = (0, $acw62.createContext)(null);
$d81caa4f4b5ad364$var$w.displayName = "TransitionContext";
var $d81caa4f4b5ad364$var$_e = ((n)=>(n.Visible = "visible", n.Hidden = "hidden", n))($d81caa4f4b5ad364$var$_e || {});
function $d81caa4f4b5ad364$var$De() {
    let e = (0, $acw62.useContext)($d81caa4f4b5ad364$var$w);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $d81caa4f4b5ad364$var$He() {
    let e = (0, $acw62.useContext)($d81caa4f4b5ad364$var$M);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $d81caa4f4b5ad364$var$M = (0, $acw62.createContext)(null);
$d81caa4f4b5ad364$var$M.displayName = "NestingContext";
function $d81caa4f4b5ad364$var$U(e) {
    return "children" in e ? $d81caa4f4b5ad364$var$U(e.children) : e.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $d81caa4f4b5ad364$var$Te(e, t) {
    let n = (0, $ltgxC.useLatestValue)(e), l = (0, $acw62.useRef)([]), S = (0, $brBI7.useIsMounted)(), R = (0, $5Ai9V.useDisposables)(), d = (0, $114Mg.useEvent)((o, i = (0, $ebRQH.RenderStrategy).Hidden)=>{
        let a = l.current.findIndex(({ el: s })=>s === o);
        a !== -1 && ((0, $6Ngq1.match)(i, {
            [(0, $ebRQH.RenderStrategy).Unmount] () {
                l.current.splice(a, 1);
            },
            [(0, $ebRQH.RenderStrategy).Hidden] () {
                l.current[a].state = "hidden";
            }
        }), R.microTask(()=>{
            var s;
            !$d81caa4f4b5ad364$var$U(l) && S.current && ((s = n.current) == null || s.call(n));
        }));
    }), y = (0, $114Mg.useEvent)((o)=>{
        let i = l.current.find(({ el: a })=>a === o);
        return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
            el: o,
            state: "visible"
        }), ()=>d(o, (0, $ebRQH.RenderStrategy).Unmount);
    }), p = (0, $acw62.useRef)([]), c = (0, $acw62.useRef)(Promise.resolve()), C = (0, $acw62.useRef)({
        enter: [],
        leave: []
    }), h = (0, $114Mg.useEvent)((o, i, a)=>{
        p.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(([s])=>s !== o)), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                p.current.push(s);
            })
        ]), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                Promise.all(C.current[i].map(([r, f])=>f)).then(()=>s());
            })
        ]), i === "enter" ? c.current = c.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(i)) : a(i);
    }), g = (0, $114Mg.useEvent)((o, i, a)=>{
        Promise.all(C.current[i].splice(0).map(([s, r])=>r)).then(()=>{
            var s;
            (s = p.current.shift()) == null || s();
        }).then(()=>a(i));
    });
    return (0, $acw62.useMemo)(()=>({
            children: l,
            register: y,
            unregister: d,
            onStart: h,
            onStop: g,
            wait: c,
            chains: C
        }), [
        y,
        d,
        l,
        h,
        g,
        C,
        c
    ]);
}
let $d81caa4f4b5ad364$var$de = (0, $acw62.Fragment), $d81caa4f4b5ad364$var$fe = (0, $ebRQH.RenderFeatures).RenderStrategy;
function $d81caa4f4b5ad364$var$Ae(e, t) {
    var ee, te;
    let { transition: n = !0, beforeEnter: l, afterEnter: S, beforeLeave: R, afterLeave: d, enter: y, enterFrom: p, enterTo: c, entered: C, leave: h, leaveFrom: g, leaveTo: o, ...i } = e, [a, s] = (0, $acw62.useState)(null), r = (0, $acw62.useRef)(null), f = $d81caa4f4b5ad364$var$ue(e), j = (0, $6mpbl.useSyncRefs)(...f ? [
        r,
        t,
        s
    ] : t === null ? [] : [
        t
    ]), H = (ee = i.unmount) == null || ee ? (0, $ebRQH.RenderStrategy).Unmount : (0, $ebRQH.RenderStrategy).Hidden, { show: u, appear: z, initial: K } = $d81caa4f4b5ad364$var$De(), [v, G] = (0, $acw62.useState)(u ? "visible" : "hidden"), Q = $d81caa4f4b5ad364$var$He(), { register: A, unregister: I } = Q;
    (0, $8KgIp.useIsoMorphicEffect)(()=>A(r), [
        A,
        r
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (H === (0, $ebRQH.RenderStrategy).Hidden && r.current) {
            if (u && v !== "visible") {
                G("visible");
                return;
            }
            return (0, $6Ngq1.match)(v, {
                ["hidden"]: ()=>I(r),
                ["visible"]: ()=>A(r)
            });
        }
    }, [
        v,
        r,
        A,
        I,
        u,
        H
    ]);
    let B = (0, $b8md9.useServerHandoffComplete)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (f && B && v === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        r,
        v,
        B,
        f
    ]);
    let ce = K && !z, Y = z && u && K, W = (0, $acw62.useRef)(!1), L = $d81caa4f4b5ad364$var$Te(()=>{
        W.current || (G("hidden"), I(r));
    }, Q), Z = (0, $114Mg.useEvent)((k)=>{
        W.current = !0;
        let F = k ? "enter" : "leave";
        L.onStart(r, F, (_)=>{
            _ === "enter" ? l == null || l() : _ === "leave" && (R == null || R());
        });
    }), $ = (0, $114Mg.useEvent)((k)=>{
        let F = k ? "enter" : "leave";
        W.current = !1, L.onStop(r, F, (_)=>{
            _ === "enter" ? S == null || S() : _ === "leave" && (d == null || d());
        }), F === "leave" && !$d81caa4f4b5ad364$var$U(L) && (G("hidden"), I(r));
    });
    (0, $acw62.useEffect)(()=>{
        f && n || (Z(u), $(u));
    }, [
        u,
        f,
        n
    ]);
    let pe = (()=>!(!n || !f || !B || ce))(), [, T] = (0, $bdknl.useTransition)(pe, a, u, {
        start: Z,
        end: $
    }), Ce = (0, $ebRQH.compact)({
        ref: j,
        className: ((te = (0, $4Mkm0.classNames)(i.className, Y && y, Y && p, T.enter && y, T.enter && T.closed && p, T.enter && !T.closed && c, T.leave && h, T.leave && !T.closed && g, T.leave && T.closed && o, !T.transition && u && C)) == null ? void 0 : te.trim()) || void 0,
        ...(0, $bdknl.transitionDataAttributes)(T)
    }), N = 0;
    v === "visible" && (N |= (0, $auuNT.State).Open), v === "hidden" && (N |= (0, $auuNT.State).Closed), T.enter && (N |= (0, $auuNT.State).Opening), T.leave && (N |= (0, $auuNT.State).Closing);
    let he = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$M.Provider, {
        value: L
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: N
    }, he({
        ourProps: Ce,
        theirProps: i,
        defaultTag: $d81caa4f4b5ad364$var$de,
        features: $d81caa4f4b5ad364$var$fe,
        visible: v === "visible",
        name: "Transition.Child"
    })));
}
function $d81caa4f4b5ad364$var$Ie(e, t) {
    let { show: n, appear: l = !1, unmount: S = !0, ...R } = e, d = (0, $acw62.useRef)(null), y = $d81caa4f4b5ad364$var$ue(e), p = (0, $6mpbl.useSyncRefs)(...y ? [
        d,
        t
    ] : t === null ? [] : [
        t
    ]);
    (0, $b8md9.useServerHandoffComplete)();
    let c = (0, $auuNT.useOpenClosed)();
    if (n === void 0 && c !== null && (n = (c & (0, $auuNT.State).Open) === (0, $auuNT.State).Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [C, h] = (0, $acw62.useState)(n ? "visible" : "hidden"), g = $d81caa4f4b5ad364$var$Te(()=>{
        n || h("hidden");
    }), [o, i] = (0, $acw62.useState)(!0), a = (0, $acw62.useRef)([
        n
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
    }, [
        a,
        n
    ]);
    let s = (0, $acw62.useMemo)(()=>({
            show: n,
            appear: l,
            initial: o
        }), [
        n,
        l,
        o
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        n ? h("visible") : !$d81caa4f4b5ad364$var$U(g) && d.current !== null && h("hidden");
    }, [
        n,
        g
    ]);
    let r = {
        unmount: S
    }, f = (0, $114Mg.useEvent)(()=>{
        var u;
        o && i(!1), (u = e.beforeEnter) == null || u.call(e);
    }), j = (0, $114Mg.useEvent)(()=>{
        var u;
        o && i(!1), (u = e.beforeLeave) == null || u.call(e);
    }), H = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$w.Provider, {
        value: s
    }, H({
        ourProps: {
            ...r,
            as: (0, $acw62.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$me, {
                ref: p,
                ...r,
                ...R,
                beforeEnter: f,
                beforeLeave: j
            })
        },
        theirProps: {},
        defaultTag: (0, $acw62.Fragment),
        features: $d81caa4f4b5ad364$var$fe,
        visible: C === "visible",
        name: "Transition"
    })));
}
function $d81caa4f4b5ad364$var$Le(e, t) {
    let n = (0, $acw62.useContext)($d81caa4f4b5ad364$var$w) !== null, l = (0, $auuNT.useOpenClosed)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !n && l ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$X, {
        ref: t,
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d81caa4f4b5ad364$var$me, {
        ref: t,
        ...e
    }));
}
let $d81caa4f4b5ad364$var$X = (0, $ebRQH.forwardRefWithAs)($d81caa4f4b5ad364$var$Ie), $d81caa4f4b5ad364$var$me = (0, $ebRQH.forwardRefWithAs)($d81caa4f4b5ad364$var$Ae), $d81caa4f4b5ad364$export$b8acc0f6b9e8ca5d = (0, $ebRQH.forwardRefWithAs)($d81caa4f4b5ad364$var$Le), $d81caa4f4b5ad364$export$be58926105124dd4 = Object.assign($d81caa4f4b5ad364$var$X, {
    Child: $d81caa4f4b5ad364$export$b8acc0f6b9e8ca5d,
    Root: $d81caa4f4b5ad364$var$X
});

});
parcelRegister("brBI7", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $854f77de70ff8db2$export$80c2a3957bcb42ea);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $854f77de70ff8db2$export$80c2a3957bcb42ea() {
    let e = (0, $acw62.useRef)(!1);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}

});



parcelRegister("3oCiM", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $9ed694ecb85bc409$export$37acb3580601e69a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $9ed694ecb85bc409$var$styles = {
    base: [
        'inline-flex items-center rounded-full font-medium'
    ],
    sizes: {
        xs: 'px-1.5 py-0.5 text-xs',
        sm: 'px-2 py-1 text-xs',
        md: 'px-2.5 py-1 text-sm',
        lg: 'px-3 py-1.5 text-sm'
    },
    variants: {
        default: [
            'bg-gray-100 text-gray-800',
            'dark:bg-gray-800 dark:text-gray-300'
        ],
        primary: [
            'bg-emerald-100 text-emerald-800',
            'dark:bg-emerald-900/20 dark:text-emerald-400'
        ],
        secondary: [
            'bg-zinc-100 text-zinc-800',
            'dark:bg-zinc-800 dark:text-zinc-300'
        ],
        success: [
            'bg-green-100 text-green-800',
            'dark:bg-green-900/20 dark:text-green-400'
        ],
        danger: [
            'bg-red-100 text-red-800',
            'dark:bg-red-900/20 dark:text-red-400'
        ],
        warning: [
            'bg-yellow-100 text-yellow-800',
            'dark:bg-yellow-900/20 dark:text-yellow-400'
        ],
        info: [
            'bg-blue-100 text-blue-800',
            'dark:bg-blue-900/20 dark:text-blue-400'
        ],
        outline: [
            'bg-transparent border border-current text-gray-500',
            'dark:text-gray-400'
        ]
    },
    dotVariants: {
        default: 'bg-gray-500',
        primary: 'bg-emerald-500',
        secondary: 'bg-zinc-500',
        success: 'bg-green-500',
        danger: 'bg-red-500',
        warning: 'bg-yellow-500',
        info: 'bg-blue-500',
        outline: 'bg-gray-500'
    }
};
const $9ed694ecb85bc409$export$37acb3580601e69a = ({ children: children, className: className = '', variant: variant = 'default', size: size = 'md', dot: dot = false, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: (0, $9QePP.default)($9ed694ecb85bc409$var$styles.base, $9ed694ecb85bc409$var$styles.sizes[size], $9ed694ecb85bc409$var$styles.variants[variant], className),
        ...props,
        children: [
            dot && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)('mr-1.5 h-1.5 w-1.5 rounded-full', $9ed694ecb85bc409$var$styles.dotVariants[variant])
            }),
            children
        ]
    });
};
const $9ed694ecb85bc409$export$401785ebd8128d14 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "default",
        ...props
    });
const $9ed694ecb85bc409$export$ab7237f69d8f4b1c = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "primary",
        ...props
    });
const $9ed694ecb85bc409$export$aecfe88729ba23da = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "secondary",
        ...props
    });
const $9ed694ecb85bc409$export$633dc980dac0f601 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "success",
        ...props
    });
const $9ed694ecb85bc409$export$4432cae03cf05c60 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "danger",
        ...props
    });
const $9ed694ecb85bc409$export$b284786b20e9e660 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "warning",
        ...props
    });
const $9ed694ecb85bc409$export$1e25182326ee1e2e = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "info",
        ...props
    });
const $9ed694ecb85bc409$export$e8bd2f07ee1f8006 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9ed694ecb85bc409$export$37acb3580601e69a, {
        variant: "outline",
        ...props
    });

});

parcelRegister("9a5LV", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $8474870a7fd7b79b$export$2b77a92f1a5ad772);
$parcel$export(module.exports, "SmallModal", () => $8474870a7fd7b79b$export$5253215acd3226db);
$parcel$export(module.exports, "MediumModal", () => $8474870a7fd7b79b$export$91f85dd5d1820641);
$parcel$export(module.exports, "LargeModal", () => $8474870a7fd7b79b$export$47aa6c68d3388075);
$parcel$export(module.exports, "ExtraLargeModal", () => $8474870a7fd7b79b$export$a3589509bd1546d7);
$parcel$export(module.exports, "ModalContent", () => $8474870a7fd7b79b$export$6da19a24bf249f17);
$parcel$export(module.exports, "ModalFooter", () => $8474870a7fd7b79b$export$519437715052e656);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $9QePP = parcelRequire("9QePP");
// X mark icon for close button
const $8474870a7fd7b79b$var$XMarkIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        className: "w-6 h-6",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18L18 6M6 6l12 12"
        })
    });
const $8474870a7fd7b79b$var$styles = {
    backdrop: 'fixed inset-0 bg-black/50 backdrop-blur-sm',
    container: 'fixed inset-0 z-50 overflow-y-auto',
    panel: [
        'relative w-full max-w-md p-6 mx-auto mt-8 mb-8 overflow-hidden rounded-xl bg-white shadow-lg',
        'dark:bg-zinc-900 dark:ring-1 dark:ring-white/10',
        'transform transition-all'
    ],
    closeButton: [
        'absolute top-3 right-3 flex h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:text-gray-500',
        'dark:text-gray-500 dark:hover:text-gray-400'
    ],
    title: 'text-lg font-semibold leading-6 text-gray-900 dark:text-white',
    description: 'mt-2 text-sm text-gray-600 dark:text-gray-400',
    sizes: {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        full: 'max-w-full mx-4'
    }
};
const $8474870a7fd7b79b$export$2b77a92f1a5ad772 = ({ isOpen: isOpen = false, onClose: onClose, title: title, description: description, children: children, className: className = '', size: size = 'md', closeOnOverlayClick: closeOnOverlayClick = true, closeButton: closeButton = true, initialFocus: initialFocus, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition), {
        appear: true,
        show: isOpen,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
            as: "div",
            className: $8474870a7fd7b79b$var$styles.container,
            onClose: closeOnOverlayClick ? onClose : ()=>{},
            initialFocus: initialFocus,
            ...props,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Child, {
                    as: (0, $acw62.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: $8474870a7fd7b79b$var$styles.backdrop,
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iymfR.Transition).Child, {
                            as: (0, $acw62.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lLzDP.Dialog).Panel, {
                                className: (0, $9QePP.default)($8474870a7fd7b79b$var$styles.panel, $8474870a7fd7b79b$var$styles.sizes[size], className),
                                children: [
                                    closeButton && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: $8474870a7fd7b79b$var$styles.closeButton,
                                        onClick: onClose,
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($8474870a7fd7b79b$var$XMarkIcon, {})
                                    }),
                                    title && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lLzDP.Dialog).Title, {
                                        className: $8474870a7fd7b79b$var$styles.title,
                                        children: title
                                    }),
                                    description && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lLzDP.Dialog).Description, {
                                        className: $8474870a7fd7b79b$var$styles.description,
                                        children: description
                                    }),
                                    title || description ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mt-4",
                                        children: children
                                    }) : children
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
const $8474870a7fd7b79b$export$5253215acd3226db = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8474870a7fd7b79b$export$2b77a92f1a5ad772, {
        size: "sm",
        ...props
    });
const $8474870a7fd7b79b$export$91f85dd5d1820641 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8474870a7fd7b79b$export$2b77a92f1a5ad772, {
        size: "md",
        ...props
    });
const $8474870a7fd7b79b$export$47aa6c68d3388075 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8474870a7fd7b79b$export$2b77a92f1a5ad772, {
        size: "lg",
        ...props
    });
const $8474870a7fd7b79b$export$a3589509bd1546d7 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8474870a7fd7b79b$export$2b77a92f1a5ad772, {
        size: "xl",
        ...props
    });
const $8474870a7fd7b79b$export$6da19a24bf249f17 = ({ children: children, className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('mt-6', className),
        ...props,
        children: children
    });
const $8474870a7fd7b79b$export$519437715052e656 = ({ children: children, className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('mt-6 flex justify-end gap-3', className),
        ...props,
        children: children
    });

});
parcelRegister("lLzDP", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $fd89a26ac969b4f3$export$3ddf2d174ce01153);

var $acw62 = parcelRequire("acw62");

var $jYrXf = parcelRequire("jYrXf");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $6QXOx = parcelRequire("6QXOx");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $jbIlv = parcelRequire("jbIlv");

var $hZodg = parcelRequire("hZodg");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $5ETDl = parcelRequire("5ETDl");

var $auuNT = parcelRequire("auuNT");

var $aQyzu = parcelRequire("aQyzu");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $4T0AR = parcelRequire("4T0AR");

var $e9NTc = parcelRequire("e9NTc");

var $iymfR = parcelRequire("iymfR");
"use client";
var $fd89a26ac969b4f3$var$Oe = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($fd89a26ac969b4f3$var$Oe || {}), $fd89a26ac969b4f3$var$he = ((t)=>(t[t.SetTitleId = 0] = "SetTitleId", t))($fd89a26ac969b4f3$var$he || {});
let $fd89a26ac969b4f3$var$Se = {
    [0] (e, t) {
        return e.titleId === t.id ? e : {
            ...e,
            titleId: t.id
        };
    }
}, $fd89a26ac969b4f3$var$k = (0, $acw62.createContext)(null);
$fd89a26ac969b4f3$var$k.displayName = "DialogContext";
function $fd89a26ac969b4f3$var$O(e) {
    let t = (0, $acw62.useContext)($fd89a26ac969b4f3$var$k);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $fd89a26ac969b4f3$var$O), o;
    }
    return t;
}
function $fd89a26ac969b4f3$var$Ie(e, t) {
    return (0, $6Ngq1.match)(t.type, $fd89a26ac969b4f3$var$Se, e, t);
}
let $fd89a26ac969b4f3$var$V = (0, $ebRQH.forwardRefWithAs)(function(t, o) {
    let a = (0, $acw62.useId)(), { id: l = `headlessui-dialog-${a}`, open: i, onClose: p, initialFocus: d, role: s = "dialog", autoFocus: f = !0, __demoMode: u = !1, unmount: P = !1, ...h } = t, R = (0, $acw62.useRef)(!1);
    s = function() {
        return s === "dialog" || s === "alertdialog" ? s : (R.current || (R.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let c = (0, $auuNT.useOpenClosed)();
    i === void 0 && c !== null && (i = (c & (0, $auuNT.State).Open) === (0, $auuNT.State).Open);
    let T = (0, $acw62.useRef)(null), S = (0, $6mpbl.useSyncRefs)(T, o), F = (0, $5IEAk.useOwnerDocument)(T), g = i ? 0 : 1, [b, q] = (0, $acw62.useReducer)($fd89a26ac969b4f3$var$Ie, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $acw62.createRef)()
    }), m = (0, $114Mg.useEvent)(()=>p(!1)), w = (0, $114Mg.useEvent)((r)=>q({
            type: 0,
            id: r
        })), D = (0, $b8md9.useServerHandoffComplete)() ? g === 0 : !1, [z, Q] = (0, $e9NTc.useNestedPortals)(), Z = {
        get current () {
            var r;
            return (r = b.panelRef.current) != null ? r : T.current;
        }
    }, v = (0, $jbIlv.useMainTreeNode)(), { resolveContainers: I } = (0, $jbIlv.useRootContainers)({
        mainTreeNode: v,
        portals: z,
        defaultContainers: [
            Z
        ]
    }), B = c !== null ? (c & (0, $auuNT.State).Closing) === (0, $auuNT.State).Closing : !1;
    (0, $keKjn.useInertOthers)(u || B ? !1 : D, {
        allowed: (0, $114Mg.useEvent)(()=>{
            var r, H;
            return [
                (H = (r = T.current) == null ? void 0 : r.closest("[data-headlessui-portal]")) != null ? H : null
            ];
        }),
        disallowed: (0, $114Mg.useEvent)(()=>{
            var r;
            return [
                (r = v == null ? void 0 : v.closest("body > *:not(#headlessui-portal-root)")) != null ? r : null
            ];
        })
    }), (0, $23pTr.useOutsideClick)(D, I, (r)=>{
        r.preventDefault(), m();
    }), (0, $jYrXf.useEscape)(D, F == null ? void 0 : F.defaultView, (r)=>{
        r.preventDefault(), r.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), m();
    }), (0, $hZodg.useScrollLock)(u || B ? !1 : D, F, I), (0, $dcp2r.useOnDisappear)(D, T, m);
    let [ee, te] = (0, $iGb09.useDescriptions)(), oe = (0, $acw62.useMemo)(()=>[
            {
                dialogState: g,
                close: m,
                setTitleId: w,
                unmount: P
            },
            b
        ], [
        g,
        b,
        m,
        w,
        P
    ]), U = (0, $acw62.useMemo)(()=>({
            open: g === 0
        }), [
        g
    ]), ne = {
        ref: S,
        id: l,
        role: s,
        tabIndex: -1,
        "aria-modal": u ? void 0 : g === 0 ? !0 : void 0,
        "aria-labelledby": b.titleId,
        "aria-describedby": ee,
        unmount: P
    }, re = !(0, $6QXOx.useIsTouchDevice)(), y = (0, $4T0AR.FocusTrapFeatures).None;
    D && !u && (y |= (0, $4T0AR.FocusTrapFeatures).RestoreFocus, y |= (0, $4T0AR.FocusTrapFeatures).TabLock, f && (y |= (0, $4T0AR.FocusTrapFeatures).AutoFocus), re && (y |= (0, $4T0AR.FocusTrapFeatures).InitialFocus));
    let le = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.ResetOpenClosedProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQyzu.ForcePortalRoot), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$k.Provider, {
        value: oe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.PortalGroup), {
        target: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQyzu.ForcePortalRoot), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(te, {
        slot: U
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Q, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4T0AR.FocusTrap), {
        initialFocus: d,
        initialFocusFallback: T,
        containers: I,
        features: y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5ETDl.CloseProvider), {
        value: m
    }, le({
        ourProps: ne,
        theirProps: h,
        slot: U,
        defaultTag: $fd89a26ac969b4f3$var$Me,
        features: $fd89a26ac969b4f3$var$Ge,
        visible: g === 0,
        name: "Dialog"
    })))))))))));
}), $fd89a26ac969b4f3$var$Me = "div", $fd89a26ac969b4f3$var$Ge = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $fd89a26ac969b4f3$var$ke(e, t) {
    let { transition: o = !1, open: a, ...l } = e, i = (0, $auuNT.useOpenClosed)(), p = e.hasOwnProperty("open") || i !== null, d = e.hasOwnProperty("onClose");
    if (!p && !d) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!p) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!d) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (!i && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
    if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
    return (a !== void 0 || o) && !l.static ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iymfR.Transition), {
        show: a,
        transition: o,
        unmount: l.unmount
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$V, {
        ref: t,
        ...l
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$V, {
        ref: t,
        open: a,
        ...l
    }));
}
let $fd89a26ac969b4f3$var$we = "div";
function $fd89a26ac969b4f3$var$Be(e, t) {
    let o = (0, $acw62.useId)(), { id: a = `headlessui-dialog-panel-${o}`, transition: l = !1, ...i } = e, [{ dialogState: p, unmount: d }, s] = $fd89a26ac969b4f3$var$O("Dialog.Panel"), f = (0, $6mpbl.useSyncRefs)(t, s.panelRef), u = (0, $acw62.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), P = (0, $114Mg.useEvent)((S)=>{
        S.stopPropagation();
    }), h = {
        ref: f,
        id: a,
        onClick: P
    }, R = l ? (0, $iymfR.TransitionChild) : (0, $acw62.Fragment), c = l ? {
        unmount: d
    } : {}, T = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(R, {
        ...c
    }, T({
        ourProps: h,
        theirProps: i,
        slot: u,
        defaultTag: $fd89a26ac969b4f3$var$we,
        name: "Dialog.Panel"
    }));
}
let $fd89a26ac969b4f3$var$Ue = "div";
function $fd89a26ac969b4f3$var$He(e, t) {
    let { transition: o = !1, ...a } = e, [{ dialogState: l, unmount: i }] = $fd89a26ac969b4f3$var$O("Dialog.Backdrop"), p = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), d = {
        ref: t,
        "aria-hidden": !0
    }, s = o ? (0, $iymfR.TransitionChild) : (0, $acw62.Fragment), f = o ? {
        unmount: i
    } : {}, u = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(s, {
        ...f
    }, u({
        ourProps: d,
        theirProps: a,
        slot: p,
        defaultTag: $fd89a26ac969b4f3$var$Ue,
        name: "Dialog.Backdrop"
    }));
}
let $fd89a26ac969b4f3$var$Ne = "h2";
function $fd89a26ac969b4f3$var$We(e, t) {
    let o = (0, $acw62.useId)(), { id: a = `headlessui-dialog-title-${o}`, ...l } = e, [{ dialogState: i, setTitleId: p }] = $fd89a26ac969b4f3$var$O("Dialog.Title"), d = (0, $6mpbl.useSyncRefs)(t);
    (0, $acw62.useEffect)(()=>(p(a), ()=>p(null)), [
        a,
        p
    ]);
    let s = (0, $acw62.useMemo)(()=>({
            open: i === 0
        }), [
        i
    ]), f = {
        ref: d,
        id: a
    };
    return (0, $ebRQH.useRender)()({
        ourProps: f,
        theirProps: l,
        slot: s,
        defaultTag: $fd89a26ac969b4f3$var$Ne,
        name: "Dialog.Title"
    });
}
let $fd89a26ac969b4f3$var$$e = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$ke), $fd89a26ac969b4f3$export$46512663428d955a = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$Be), $fd89a26ac969b4f3$export$91fffd879a9415f4 = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$He), $fd89a26ac969b4f3$export$16f7638e4a34b909 = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$We), $fd89a26ac969b4f3$export$94e94c2ec2c954d5 = (0, $iGb09.Description), $fd89a26ac969b4f3$export$3ddf2d174ce01153 = Object.assign($fd89a26ac969b4f3$var$$e, {
    Panel: $fd89a26ac969b4f3$export$46512663428d955a,
    Title: $fd89a26ac969b4f3$export$16f7638e4a34b909,
    Description: (0, $iGb09.Description)
});

});
parcelRegister("jYrXf", function(module, exports) {

$parcel$export(module.exports, "useEscape", () => $e8a94e1c7fcf4260$export$3875fddb67014c13);

var $6AKlm = parcelRequire("6AKlm");

var $lwoRo = parcelRequire("lwoRo");

var $g6SeH = parcelRequire("g6SeH");
function $e8a94e1c7fcf4260$export$3875fddb67014c13(o, r = typeof document != "undefined" ? document.defaultView : null, t) {
    let n = (0, $g6SeH.useIsTopLayer)(o, "escape");
    (0, $lwoRo.useEventListener)(r, "keydown", (e)=>{
        n && (e.defaultPrevented || e.key === (0, $6AKlm.Keys).Escape && t(e));
    });
}

});
parcelRegister("lwoRo", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $faafded37f338b1b$export$7080b3e976bc91ab);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $faafded37f338b1b$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $ltgxC.useLatestValue)(a);
    (0, $acw62.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}

});


parcelRegister("6QXOx", function(module, exports) {

$parcel$export(module.exports, "useIsTouchDevice", () => $4fd5ff3f074a68f3$export$2706b359107dd58d);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $4fd5ff3f074a68f3$export$2706b359107dd58d() {
    var t;
    let [e] = (0, $acw62.useState)(()=>typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [o, c] = (0, $acw62.useState)((t = e == null ? void 0 : e.matches) != null ? t : !1);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        function n(r) {
            c(r.matches);
        }
        return e.addEventListener("change", n), ()=>e.removeEventListener("change", n);
    }, [
        e
    ]), o;
}

});

parcelRegister("jbIlv", function(module, exports) {

$parcel$export(module.exports, "useRootContainers", () => $df81719180936f93$export$445f2d1a3d9b1b9f);
$parcel$export(module.exports, "MainTreeProvider", () => $df81719180936f93$export$61c2c570df73dc80);
$parcel$export(module.exports, "useMainTreeNode", () => $df81719180936f93$export$64db24433d7f4942);

var $acw62 = parcelRequire("acw62");

var $k9Al5 = parcelRequire("k9Al5");

var $gxwGc = parcelRequire("gxwGc");

var $114Mg = parcelRequire("114Mg");

var $5IEAk = parcelRequire("5IEAk");
function $df81719180936f93$export$445f2d1a3d9b1b9f({ defaultContainers: l = [], portals: n, mainTreeNode: o } = {}) {
    let r = (0, $5IEAk.useOwnerDocument)(o), u = (0, $114Mg.useEvent)(()=>{
        var i, c;
        let t = [];
        for (let e of l)e !== null && (e instanceof HTMLElement ? t.push(e) : "current" in e && e.current instanceof HTMLElement && t.push(e.current));
        if (n != null && n.current) for (let e of n.current)t.push(e);
        for (let e of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (o && (e.contains(o) || e.contains((c = o == null ? void 0 : o.getRootNode()) == null ? void 0 : c.host)) || t.some((m)=>e.contains(m)) || t.push(e));
        return t;
    });
    return {
        resolveContainers: u,
        contains: (0, $114Mg.useEvent)((t)=>u().some((i)=>i.contains(t)))
    };
}
let $df81719180936f93$var$a = (0, $acw62.createContext)(null);
function $df81719180936f93$export$61c2c570df73dc80({ children: l, node: n }) {
    let [o, r] = (0, $acw62.useState)(null), u = $df81719180936f93$export$64db24433d7f4942(n != null ? n : o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df81719180936f93$var$a.Provider, {
        value: u
    }, l, u === null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        ref: (t)=>{
            var i, c;
            if (t) {
                for (let e of (c = (i = (0, $gxwGc.getOwnerDocument)(t)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : [])if (e !== document.body && e !== document.head && e instanceof HTMLElement && e != null && e.contains(t)) {
                    r(e);
                    break;
                }
            }
        }
    }));
}
function $df81719180936f93$export$64db24433d7f4942(l = null) {
    var n;
    return (n = (0, $acw62.useContext)($df81719180936f93$var$a)) != null ? n : l;
}

});

parcelRegister("5ETDl", function(module, exports) {

$parcel$export(module.exports, "CloseProvider", () => $41ebd7de5602bb69$export$dd2a80b78bebbe1d);

var $acw62 = parcelRequire("acw62");
"use client";
let $41ebd7de5602bb69$var$e = (0, $acw62.createContext)(()=>{});
function $41ebd7de5602bb69$export$4e99330e6f37bca2() {
    return (0, $acw62.useContext)($41ebd7de5602bb69$var$e);
}
function $41ebd7de5602bb69$export$dd2a80b78bebbe1d({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41ebd7de5602bb69$var$e.Provider, {
        value: t
    }, o);
}

});

parcelRegister("4T0AR", function(module, exports) {

$parcel$export(module.exports, "FocusTrapFeatures", () => $38ecc25572962dee$export$a5e9a012c73650bd);
$parcel$export(module.exports, "FocusTrap", () => $38ecc25572962dee$export$34eba2437817a67b);

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $lwoRo = parcelRequire("lwoRo");

var $brBI7 = parcelRequire("brBI7");

var $g6SeH = parcelRequire("g6SeH");

var $3XIoH = parcelRequire("3XIoH");

var $5IEAk = parcelRequire("5IEAk");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $3nJyP = parcelRequire("3nJyP");

var $lEQT2 = parcelRequire("lEQT2");

var $k9Al5 = parcelRequire("k9Al5");

var $2C9FE = parcelRequire("2C9FE");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $eJKgu = parcelRequire("eJKgu");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $38ecc25572962dee$var$U(o) {
    if (!o) return new Set;
    if (typeof o == "function") return new Set(o());
    let e = new Set;
    for (let t of o.current)t.current instanceof HTMLElement && e.add(t.current);
    return e;
}
let $38ecc25572962dee$var$Z = "div";
var $38ecc25572962dee$export$a5e9a012c73650bd = ((n)=>(n[n.None = 0] = "None", n[n.InitialFocus = 1] = "InitialFocus", n[n.TabLock = 2] = "TabLock", n[n.FocusLock = 4] = "FocusLock", n[n.RestoreFocus = 8] = "RestoreFocus", n[n.AutoFocus = 16] = "AutoFocus", n))($38ecc25572962dee$export$a5e9a012c73650bd || {});
function $38ecc25572962dee$var$$(o, e) {
    let t = (0, $acw62.useRef)(null), r = (0, $6mpbl.useSyncRefs)(t, e), { initialFocus: s, initialFocusFallback: a, containers: n, features: u = 15, ...f } = o;
    (0, $b8md9.useServerHandoffComplete)() || (u = 0);
    let l = (0, $5IEAk.useOwnerDocument)(t);
    $38ecc25572962dee$var$ee(u, {
        ownerDocument: l
    });
    let i = $38ecc25572962dee$var$te(u, {
        ownerDocument: l,
        container: t,
        initialFocus: s,
        initialFocusFallback: a
    });
    $38ecc25572962dee$var$re(u, {
        ownerDocument: l,
        container: t,
        containers: n,
        previousActiveElement: i
    });
    let R = (0, $3nJyP.useTabDirection)(), g = (0, $114Mg.useEvent)((c)=>{
        let m = t.current;
        if (!m) return;
        ((G)=>G())(()=>{
            (0, $6Ngq1.match)(R.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>{
                    (0, $hsQxB.focusIn)(m, (0, $hsQxB.Focus).First, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                },
                [(0, $3nJyP.Direction).Backwards]: ()=>{
                    (0, $hsQxB.focusIn)(m, (0, $hsQxB.Focus).Last, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                }
            });
        });
    }), v = (0, $g6SeH.useIsTopLayer)(!!(u & 2), "focus-trap#tab-lock"), N = (0, $5Ai9V.useDisposables)(), F = (0, $acw62.useRef)(!1), k = {
        ref: r,
        onKeyDown (c) {
            c.key == "Tab" && (F.current = !0, N.requestAnimationFrame(()=>{
                F.current = !1;
            }));
        },
        onBlur (c) {
            if (!(u & 4)) return;
            let m = $38ecc25572962dee$var$U(n);
            t.current instanceof HTMLElement && m.add(t.current);
            let d = c.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($38ecc25572962dee$var$I(m, d) || (F.current ? (0, $hsQxB.focusIn)(t.current, (0, $6Ngq1.match)(R.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>(0, $hsQxB.Focus).Next,
                [(0, $3nJyP.Direction).Backwards]: ()=>(0, $hsQxB.Focus).Previous
            }) | (0, $hsQxB.Focus).WrapAround, {
                relativeTo: c.target
            }) : c.target instanceof HTMLElement && (0, $hsQxB.focusElement)(c.target)));
        }
    }, B = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, v && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $k9Al5.HiddenFeatures).Focusable
    }), B({
        ourProps: k,
        theirProps: f,
        defaultTag: $38ecc25572962dee$var$Z,
        name: "FocusTrap"
    }), v && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $k9Al5.HiddenFeatures).Focusable
    }));
}
let $38ecc25572962dee$var$D = (0, $ebRQH.forwardRefWithAs)($38ecc25572962dee$var$$), $38ecc25572962dee$export$34eba2437817a67b = Object.assign($38ecc25572962dee$var$D, {
    features: $38ecc25572962dee$export$a5e9a012c73650bd
});
function $38ecc25572962dee$var$w(o = !0) {
    let e = (0, $acw62.useRef)((0, $2C9FE.history).slice());
    return (0, $lEQT2.useWatch)(([t], [r])=>{
        r === !0 && t === !1 && (0, $eJKgu.microTask)(()=>{
            e.current.splice(0);
        }), r === !1 && t === !0 && (e.current = (0, $2C9FE.history).slice());
    }, [
        o,
        (0, $2C9FE.history),
        e
    ]), (0, $114Mg.useEvent)(()=>{
        var t;
        return (t = e.current.find((r)=>r != null && r.isConnected)) != null ? t : null;
    });
}
function $38ecc25572962dee$var$ee(o, { ownerDocument: e }) {
    let t = !!(o & 8), r = $38ecc25572962dee$var$w(t);
    (0, $lEQT2.useWatch)(()=>{
        t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && (0, $hsQxB.focusElement)(r());
    }, [
        t
    ]), (0, $3XIoH.useOnUnmount)(()=>{
        t && (0, $hsQxB.focusElement)(r());
    });
}
function $38ecc25572962dee$var$te(o, { ownerDocument: e, container: t, initialFocus: r, initialFocusFallback: s }) {
    let a = (0, $acw62.useRef)(null), n = (0, $g6SeH.useIsTopLayer)(!!(o & 1), "focus-trap#initial-focus"), u = (0, $brBI7.useIsMounted)();
    return (0, $lEQT2.useWatch)(()=>{
        if (o === 0) return;
        if (!n) {
            s != null && s.current && (0, $hsQxB.focusElement)(s.current);
            return;
        }
        let f = t.current;
        f && (0, $eJKgu.microTask)(()=>{
            if (!u.current) return;
            let l = e == null ? void 0 : e.activeElement;
            if (r != null && r.current) {
                if ((r == null ? void 0 : r.current) === l) {
                    a.current = l;
                    return;
                }
            } else if (f.contains(l)) {
                a.current = l;
                return;
            }
            if (r != null && r.current) (0, $hsQxB.focusElement)(r.current);
            else {
                if (o & 16) {
                    if ((0, $hsQxB.focusIn)(f, (0, $hsQxB.Focus).First | (0, $hsQxB.Focus).AutoFocus) !== (0, $hsQxB.FocusResult).Error) return;
                } else if ((0, $hsQxB.focusIn)(f, (0, $hsQxB.Focus).First) !== (0, $hsQxB.FocusResult).Error) return;
                if (s != null && s.current && ((0, $hsQxB.focusElement)(s.current), (e == null ? void 0 : e.activeElement) === s.current)) return;
                console.warn("There are no focusable elements inside the <FocusTrap />");
            }
            a.current = e == null ? void 0 : e.activeElement;
        });
    }, [
        s,
        n,
        o
    ]), a;
}
function $38ecc25572962dee$var$re(o, { ownerDocument: e, container: t, containers: r, previousActiveElement: s }) {
    let a = (0, $brBI7.useIsMounted)(), n = !!(o & 4);
    (0, $lwoRo.useEventListener)(e == null ? void 0 : e.defaultView, "focus", (u)=>{
        if (!n || !a.current) return;
        let f = $38ecc25572962dee$var$U(r);
        t.current instanceof HTMLElement && f.add(t.current);
        let l = s.current;
        if (!l) return;
        let i = u.target;
        i && i instanceof HTMLElement ? $38ecc25572962dee$var$I(f, i) ? (s.current = i, (0, $hsQxB.focusElement)(i)) : (u.preventDefault(), u.stopPropagation(), (0, $hsQxB.focusElement)(l)) : (0, $hsQxB.focusElement)(s.current);
    }, !0);
}
function $38ecc25572962dee$var$I(o, e) {
    for (let t of o)if (t.contains(e)) return !0;
    return !1;
}

});
parcelRegister("3nJyP", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $2766dc79ae4166c9$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "useTabDirection", () => $2766dc79ae4166c9$export$19b797546aece48f);

var $acw62 = parcelRequire("acw62");

var $5vI4D = parcelRequire("5vI4D");
var $2766dc79ae4166c9$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($2766dc79ae4166c9$export$cacd6541cfeeb6c1 || {});
function $2766dc79ae4166c9$export$19b797546aece48f() {
    let e = (0, $acw62.useRef)(0);
    return (0, $5vI4D.useWindowEvent)(!0, "keydown", (r)=>{
        r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
    }, !0), e;
}

});

parcelRegister("lEQT2", function(module, exports) {

$parcel$export(module.exports, "useWatch", () => $fc465b9f88c2456a$export$3c773aa2b84f29e0);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $fc465b9f88c2456a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $acw62.useRef)([]), r = (0, $114Mg.useEvent)(u);
    (0, $acw62.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [a, l] of t.entries())if (e.current[a] !== l) {
            let n = r(t, o);
            return e.current = t, n;
        }
    }, [
        r,
        ...t
    ]);
}

});

parcelRegister("2C9FE", function(module, exports) {

$parcel$export(module.exports, "history", () => $1e76a1cad0cb58a8$export$55abd4691b317664);

var $ixVas = parcelRequire("ixVas");

var $hsQxB = parcelRequire("hsQxB");
let $1e76a1cad0cb58a8$export$55abd4691b317664 = [];
(0, $ixVas.onDocumentReady)(()=>{
    function e(t) {
        if (!(t.target instanceof HTMLElement) || t.target === document.body || $1e76a1cad0cb58a8$export$55abd4691b317664[0] === t.target) return;
        let n = t.target;
        n = n.closest((0, $hsQxB.focusableSelector)), $1e76a1cad0cb58a8$export$55abd4691b317664.unshift(n != null ? n : t.target), $1e76a1cad0cb58a8$export$55abd4691b317664 = $1e76a1cad0cb58a8$export$55abd4691b317664.filter((o)=>o != null && o.isConnected), $1e76a1cad0cb58a8$export$55abd4691b317664.splice(10);
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

});
parcelRegister("ixVas", function(module, exports) {

$parcel$export(module.exports, "onDocumentReady", () => $d807a76564ed2203$export$a6a2315df743a26b);
function $d807a76564ed2203$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

});





parcelRegister("knNQ8", function(module, exports) {

$parcel$export(module.exports, "Container", () => $05c5c3339c8cc5a1$export$42a852a2b6b56249);
$parcel$export(module.exports, "Stack", () => $05c5c3339c8cc5a1$export$694e0d28c7ffc90c);
$parcel$export(module.exports, "Grid", () => $05c5c3339c8cc5a1$export$ef2184bd89960b14);
$parcel$export(module.exports, "Flex", () => $05c5c3339c8cc5a1$export$f51f4c4ede09e011);
$parcel$export(module.exports, "Divider", () => $05c5c3339c8cc5a1$export$2e0a83ec2e27ecbb);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $05c5c3339c8cc5a1$export$42a852a2b6b56249 = ({ children: children, className: className = '', size: size = 'md', as: Component = 'div', ...props })=>{
    const sizes = {
        sm: 'max-w-3xl',
        md: 'max-w-5xl',
        lg: 'max-w-7xl',
        xl: 'max-w-screen-2xl',
        full: 'max-w-full'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('mx-auto px-4 sm:px-6 lg:px-8', sizes[size], className),
        ...props,
        children: children
    });
};
const $05c5c3339c8cc5a1$export$694e0d28c7ffc90c = ({ children: children, className: className = '', space: space = 'md', as: Component = 'div', divider: divider = false, ...props })=>{
    const spaces = {
        xs: 'space-y-2',
        sm: 'space-y-4',
        md: 'space-y-6',
        lg: 'space-y-8',
        xl: 'space-y-12'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('flex flex-col', spaces[space], divider && 'divide-y divide-gray-200 dark:divide-gray-800', className),
        ...props,
        children: children
    });
};
const $05c5c3339c8cc5a1$export$ef2184bd89960b14 = ({ children: children, className: className = '', cols: cols = {
    default: 1,
    sm: 2,
    md: 3,
    lg: 4
}, gap: gap = 'md', as: Component = 'div', ...props })=>{
    // Construct responsive column classes
    const colClasses = Object.entries(cols).map(([breakpoint, count])=>{
        if (breakpoint === 'default') return `grid-cols-${count}`;
        return `${breakpoint}:grid-cols-${count}`;
    }).join(' ');
    const gaps = {
        xs: 'gap-2',
        sm: 'gap-4',
        md: 'gap-6',
        lg: 'gap-8',
        xl: 'gap-12'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('grid', colClasses, gaps[gap], className),
        ...props,
        children: children
    });
};
const $05c5c3339c8cc5a1$export$f51f4c4ede09e011 = ({ children: children, className: className = '', direction: direction = 'row', wrap: wrap = false, justify: justify = 'start', items: items = 'start', gap: gap = 'md', as: Component = 'div', ...props })=>{
    const directions = {
        row: 'flex-row',
        'row-reverse': 'flex-row-reverse',
        col: 'flex-col',
        'col-reverse': 'flex-col-reverse'
    };
    const justifyOptions = {
        start: 'justify-start',
        end: 'justify-end',
        center: 'justify-center',
        between: 'justify-between',
        around: 'justify-around',
        evenly: 'justify-evenly'
    };
    const itemsOptions = {
        start: 'items-start',
        end: 'items-end',
        center: 'items-center',
        baseline: 'items-baseline',
        stretch: 'items-stretch'
    };
    const gaps = {
        xs: 'gap-2',
        sm: 'gap-4',
        md: 'gap-6',
        lg: 'gap-8',
        xl: 'gap-12'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('flex', directions[direction], wrap && 'flex-wrap', justifyOptions[justify], itemsOptions[items], gaps[gap], className),
        ...props,
        children: children
    });
};
const $05c5c3339c8cc5a1$export$2e0a83ec2e27ecbb = ({ className: className = '', ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
        className: (0, $9QePP.default)('border-t border-gray-200 dark:border-gray-800', className),
        ...props
    });
};

});


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


/**
 * Frontend Telemetry Service
 * Uses Application Insights for error tracking, performance monitoring, and analytics
 */ /*
 * Application Insights JavaScript SDK - Web, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/*! https://github.com/nevware21/ts-utils v0.12.5 */ /*
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */ /*#__NO_SIDE_EFFECTS__*/ var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


function $5831ddb3a0caf7c7$var$_pureAssign(func1, func2) {
    return func1 || func2;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_pureRef(value, name) {
    return value[name];
}
var $5831ddb3a0caf7c7$var$UNDEF_VALUE = undefined;
var $5831ddb3a0caf7c7$var$NULL_VALUE = null;
var $5831ddb3a0caf7c7$var$EMPTY = "";
var $5831ddb3a0caf7c7$var$FUNCTION = "function";
var $5831ddb3a0caf7c7$var$OBJECT = "object";
var $5831ddb3a0caf7c7$var$PROTOTYPE = "prototype";
var $5831ddb3a0caf7c7$var$__PROTO__ = "__proto__";
var $5831ddb3a0caf7c7$var$UNDEFINED = "undefined";
var $5831ddb3a0caf7c7$var$CONSTRUCTOR = "constructor";
var $5831ddb3a0caf7c7$var$SYMBOL = "Symbol";
var $5831ddb3a0caf7c7$var$LENGTH = "length";
var $5831ddb3a0caf7c7$var$NAME = "name";
var $5831ddb3a0caf7c7$var$CALL = "call";
var $5831ddb3a0caf7c7$var$TO_STRING = "toString";
var $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_DESCRIPTOR = "getOwnPropertyDescriptor";
var $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_NAMES = "getOwnPropertyNames";
var $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_SYMBOLS = "getOwnPropertySymbols";
var $5831ddb3a0caf7c7$var$ObjClass = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Object);
var $5831ddb3a0caf7c7$var$ObjProto = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$PROTOTYPE);
var $5831ddb3a0caf7c7$var$StrCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(String);
var $5831ddb3a0caf7c7$var$StrProto = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$StrCls, $5831ddb3a0caf7c7$var$PROTOTYPE);
var $5831ddb3a0caf7c7$var$MathCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Math);
var $5831ddb3a0caf7c7$var$ArrCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Array);
var $5831ddb3a0caf7c7$var$ArrProto = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrCls, $5831ddb3a0caf7c7$var$PROTOTYPE);
var $5831ddb3a0caf7c7$var$ArrSlice = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrProto, "slice");
var $5831ddb3a0caf7c7$var$NumberCls = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(Number);
var $5831ddb3a0caf7c7$var$POLYFILL_TAG = "_polyfill";
var $5831ddb3a0caf7c7$var$POLYFILL_TYPE_NAME = "__nw21$polytype__";
function $5831ddb3a0caf7c7$var$_isPolyfill(obj) {
    return !!(obj && obj[$5831ddb3a0caf7c7$var$POLYFILL_TAG]);
}
function $5831ddb3a0caf7c7$var$_isPolyfillType(obj, polyfillTypeName) {
    return !!(obj && obj[$5831ddb3a0caf7c7$var$POLYFILL_TYPE_NAME] === polyfillTypeName);
}
function $5831ddb3a0caf7c7$export$170b8c323eee7bec(func, argArray) {
    try {
        return {
            v: func.apply(this, argArray)
        };
    } catch (e) {
        return {
            e: e
        };
    }
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$e51ae4db7b428f67(cb, defValue, argArray) {
    var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb, argArray);
    return result.e ? defValue : result.v;
}
var $5831ddb3a0caf7c7$var$_primitiveTypes;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createIs(theType) {
    return function(value) {
        return typeof value === theType;
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createIsWithPoly(theType) {
    return function(value) {
        return typeof value === theType || $5831ddb3a0caf7c7$var$_isPolyfillType(value, theType);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createObjIs(theName) {
    var theType = "[object " + theName + "]";
    return function(value) {
        return !!(value && $5831ddb3a0caf7c7$export$3cbb80dec8953997(value) === theType);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3cbb80dec8953997(value) {
    return $5831ddb3a0caf7c7$var$ObjProto[$5831ddb3a0caf7c7$var$TO_STRING].call(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$aa336f94d74d9e02(value, theType) {
    return typeof value === theType;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$fce6876652108ab(value) {
    return typeof value === $5831ddb3a0caf7c7$var$UNDEFINED || value === $5831ddb3a0caf7c7$var$UNDEFINED;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$565ef2e4233b16ad(arg) {
    return arg === $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$bedb7023a7733221(value) {
    return value === $5831ddb3a0caf7c7$var$NULL_VALUE || $5831ddb3a0caf7c7$export$fce6876652108ab(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3388cdee8977b866(value) {
    return value === $5831ddb3a0caf7c7$var$NULL_VALUE || value === $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4e62c701997796c1(arg) {
    return !!arg || arg !== $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c3825b437cbdea5c(value) {
    return value === $5831ddb3a0caf7c7$var$NULL_VALUE || $5831ddb3a0caf7c7$export$1f3b27a0956fac0e(typeof value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1f3b27a0956fac0e(theType) {
    !$5831ddb3a0caf7c7$var$_primitiveTypes && ($5831ddb3a0caf7c7$var$_primitiveTypes = [
        "string",
        "number",
        "boolean",
        $5831ddb3a0caf7c7$var$UNDEFINED,
        "symbol",
        "bigint"
    ]);
    return !!(theType !== $5831ddb3a0caf7c7$var$OBJECT && $5831ddb3a0caf7c7$var$_primitiveTypes.indexOf(theType) !== -1);
}
var $5831ddb3a0caf7c7$export$844ec244b1367d54 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("string");
var $5831ddb3a0caf7c7$export$f6e2535fb5126e54 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs($5831ddb3a0caf7c7$var$FUNCTION);
var $5831ddb3a0caf7c7$export$cb3f0f7ea9814480 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("AsyncFunction");
var $5831ddb3a0caf7c7$export$6ab7812f1bac68be = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("GeneratorFunction");
var $5831ddb3a0caf7c7$export$92bd080471bc30f1 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("AsyncGeneratorFunction");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(value) {
    if (!value && $5831ddb3a0caf7c7$export$bedb7023a7733221(value)) return false;
    return !!value && typeof value === $5831ddb3a0caf7c7$var$OBJECT;
}
var $5831ddb3a0caf7c7$export$43bee75e5e14138e = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrCls, "isArray");
var $5831ddb3a0caf7c7$export$871608497c498473 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Date");
var $5831ddb3a0caf7c7$export$7e4aa119212bc614 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("number");
var $5831ddb3a0caf7c7$export$f9ce7b637dfbe238 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIs("boolean");
var $5831ddb3a0caf7c7$export$49841c62b9eff15 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("RegExp");
var $5831ddb3a0caf7c7$export$be78b3111c50efdd = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("File");
var $5831ddb3a0caf7c7$export$67a42df2b7ab73bc = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("FormData");
var $5831ddb3a0caf7c7$export$5bcd6e94ed871c88 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Blob");
var $5831ddb3a0caf7c7$export$9dd3754ae86f0017 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("ArrayBuffer");
var $5831ddb3a0caf7c7$export$e6127cc7fe7395c3 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Error");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ae936b9d47e5870e(value) {
    return !!(value && value.then && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.then));
}
var $5831ddb3a0caf7c7$export$f5b060c2914b97c8 = $5831ddb3a0caf7c7$export$ae936b9d47e5870e;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4369c812aac99591(value) {
    return !!(value && value.then && value.catch && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.then) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.catch));
}
var $5831ddb3a0caf7c7$export$5c90113a285f2241 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Map");
var $5831ddb3a0caf7c7$export$45e3ca7880506f6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("WeakMap");
var $5831ddb3a0caf7c7$export$6750766a7c7ec627 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("Set");
var $5831ddb3a0caf7c7$export$6001bf5c91b8444 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createObjIs("WeakSet");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$313ce3f19588c7e8(value) {
    return !!(value && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.get) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.set) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.has) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.delete) && $5831ddb3a0caf7c7$export$7e4aa119212bc614(value.size));
}
function $5831ddb3a0caf7c7$export$246c46e3eb4af8c1(value) {
    return !!(value && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.add) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.has) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.delete) && $5831ddb3a0caf7c7$export$7e4aa119212bc614(value.size));
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$5f2b986706b25721(value) {
    return !value || !$5831ddb3a0caf7c7$export$8f9cae6546f97a9f(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$8f9cae6546f97a9f(value) {
    return !(!value || $5831ddb3a0caf7c7$export$e51ae4db7b428f67(function() {
        return !(value && 0 + value);
    }, !value));
}
var $5831ddb3a0caf7c7$export$c4c1bdb0d1c7cfc7 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIsWithPoly("bigint");
function $5831ddb3a0caf7c7$var$_returnNothing() {
    return;
}
function $5831ddb3a0caf7c7$var$_returnEmptyArray() {
    return [];
}
function $5831ddb3a0caf7c7$var$_returnFalse() {
    return false;
}
var $5831ddb3a0caf7c7$export$590567be997858b6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$var$StrCls);
var $5831ddb3a0caf7c7$var$ERROR_TYPE = "[object Error]";
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(object, format) {
    var propertyValueDump = $5831ddb3a0caf7c7$var$EMPTY;
    var objType = $5831ddb3a0caf7c7$var$ObjProto[$5831ddb3a0caf7c7$var$TO_STRING][$5831ddb3a0caf7c7$var$CALL](object);
    if (objType === $5831ddb3a0caf7c7$var$ERROR_TYPE) object = {
        stack: $5831ddb3a0caf7c7$export$590567be997858b6(object.stack),
        message: $5831ddb3a0caf7c7$export$590567be997858b6(object.message),
        name: $5831ddb3a0caf7c7$export$590567be997858b6(object.name)
    };
    try {
        propertyValueDump = JSON.stringify(object, $5831ddb3a0caf7c7$var$NULL_VALUE, format ? typeof format === "number" ? format : 4 : $5831ddb3a0caf7c7$var$UNDEF_VALUE);
        propertyValueDump = (propertyValueDump ? propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : $5831ddb3a0caf7c7$var$NULL_VALUE) || $5831ddb3a0caf7c7$export$590567be997858b6(object);
    } catch (e) {
        propertyValueDump = " - " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(e, format);
    }
    return objType + ": " + propertyValueDump;
}
function $5831ddb3a0caf7c7$export$8bf7aba4a9e09055(message) {
    throw new Error(message);
}
function $5831ddb3a0caf7c7$export$3f7738bd7dcba681(message) {
    throw new TypeError(message);
}
function $5831ddb3a0caf7c7$export$462e4d432290318e(message) {
    throw new RangeError(message);
}
function $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(obj) {
    if ($5831ddb3a0caf7c7$export$3388cdee8977b866(obj)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("Cannot convert undefined or null to object");
}
function $5831ddb3a0caf7c7$var$_throwIfNotString(value) {
    if (!$5831ddb3a0caf7c7$export$844ec244b1367d54(value)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("'" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "' is not a string");
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$d76937f5d45b7158(obj, prop) {
    return !!obj && $5831ddb3a0caf7c7$var$ObjProto.hasOwnProperty[$5831ddb3a0caf7c7$var$CALL](obj, prop);
}
var $5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor$2 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_DESCRIPTOR), $5831ddb3a0caf7c7$var$_returnNothing);
var $5831ddb3a0caf7c7$export$34e6b98f73578a9c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "hasOwn"), $5831ddb3a0caf7c7$export$9a4df78208de965f);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9a4df78208de965f(obj, prop) {
    $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(obj);
    return $5831ddb3a0caf7c7$export$d76937f5d45b7158(obj, prop) || !!$5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor$2(obj, prop);
}
function $5831ddb3a0caf7c7$export$aa0705d5774c95d1(theObject, callbackfn, thisArg) {
    if (theObject && ($5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(theObject) || $5831ddb3a0caf7c7$export$f6e2535fb5126e54(theObject))) {
        for(var prop in theObject)if ($5831ddb3a0caf7c7$export$34e6b98f73578a9c(theObject, prop)) {
            if (callbackfn[$5831ddb3a0caf7c7$var$CALL](thisArg || theObject, prop, theObject[prop]) === -1) break;
        }
    }
}
function $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[$5831ddb3a0caf7c7$var$LENGTH] >>> 0;
        for(var idx = 0; idx < len; idx++)if (idx in theArray) {
            if (callbackfn[$5831ddb3a0caf7c7$var$CALL](thisArg || theArray, theArray[idx], idx, theArray) === -1) break;
        }
    }
}
var $5831ddb3a0caf7c7$var$_unwrapFunction = $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
    var clsFn = clsProto ? clsProto[funcName] : $5831ddb3a0caf7c7$var$NULL_VALUE;
    return function(thisArg) {
        var theFunc = (thisArg ? thisArg[funcName] : $5831ddb3a0caf7c7$var$NULL_VALUE) || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](theArgs, 1) : theArgs);
        }
        $5831ddb3a0caf7c7$export$3f7738bd7dcba681("\"" + $5831ddb3a0caf7c7$export$590567be997858b6(funcName) + "\" not defined for " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(thisArg));
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_unwrapProp(propName) {
    return function(thisArg) {
        return thisArg[propName];
    };
}
function $5831ddb3a0caf7c7$var$_objPropertyIsEnum(obj, propKey) {
    var desc;
    var fn = $5831ddb3a0caf7c7$var$ObjClass.getOwnPropertyDescriptor;
    if (!$5831ddb3a0caf7c7$export$3388cdee8977b866(obj) && fn) desc = $5831ddb3a0caf7c7$export$170b8c323eee7bec(fn, [
        obj,
        propKey
    ]).v || $5831ddb3a0caf7c7$var$NULL_VALUE;
    if (!desc) desc = $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
        for(var key in obj){
            if (key === propKey) return {
                enumerable: true
            };
        }
    }).v;
    return desc && desc.enumerable || false;
}
var $5831ddb3a0caf7c7$export$c98bbeea9e6fbd87 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("propertyIsEnumerable", $5831ddb3a0caf7c7$var$NULL_VALUE, $5831ddb3a0caf7c7$var$_objPropertyIsEnum);
var $5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor$1 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_DESCRIPTOR), $5831ddb3a0caf7c7$var$_returnNothing);
var $5831ddb3a0caf7c7$var$_objGetOwnPropertySymbols = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_SYMBOLS), $5831ddb3a0caf7c7$var$_returnEmptyArray);
var $5831ddb3a0caf7c7$var$propMap = {
    e: "enumerable",
    c: "configurable",
    v: "value",
    w: "writable",
    g: "get",
    s: "set"
};
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createProp(value) {
    var prop = {};
    prop[$5831ddb3a0caf7c7$var$propMap["c"]] = true;
    prop[$5831ddb3a0caf7c7$var$propMap["e"]] = true;
    if (value.l) {
        prop.get = function() {
            return value.l.v;
        };
        var desc = $5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor$1(value.l, "v");
        if (desc && desc.set) prop.set = function(newValue) {
            value.l.v = newValue;
        };
    }
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(value, function(key, value) {
        prop[$5831ddb3a0caf7c7$var$propMap[key]] = $5831ddb3a0caf7c7$export$565ef2e4233b16ad(value) ? prop[$5831ddb3a0caf7c7$var$propMap[key]] : value;
    });
    return prop;
}
var $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "defineProperty");
var $5831ddb3a0caf7c7$export$aa4c975d12edd698 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "defineProperties");
function $5831ddb3a0caf7c7$export$4f97e7dc4bb3c3bb(target, key, value, configurable, enumerable) {
    var _a;
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(target, key, $5831ddb3a0caf7c7$var$_createProp((_a = {
        e: enumerable,
        c: configurable
    }, _a[$5831ddb3a0caf7c7$export$f6e2535fb5126e54(value) ? "g" : "v"] = value, _a)));
}
function $5831ddb3a0caf7c7$export$5525b807dcec3e1b(target, prop, getProp, setProp, configurable, enumerable) {
    var desc = {
        e: enumerable,
        c: configurable
    };
    if (getProp) desc.g = getProp;
    if (setProp) desc.s = setProp;
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(target, prop, $5831ddb3a0caf7c7$var$_createProp(desc));
}
function $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(target, key, propDesc) {
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(target, key, $5831ddb3a0caf7c7$var$_createProp(propDesc));
}
function $5831ddb3a0caf7c7$export$343685e498f18ed2(target, propDescMap) {
    var props = {};
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(propDescMap, function(key, value) {
        props[key] = $5831ddb3a0caf7c7$var$_createProp(value);
    });
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586($5831ddb3a0caf7c7$var$_objGetOwnPropertySymbols(propDescMap), function(sym) {
        if ($5831ddb3a0caf7c7$export$c98bbeea9e6fbd87(propDescMap, sym)) props[sym] = $5831ddb3a0caf7c7$var$_createProp(propDescMap[sym]);
    });
    return $5831ddb3a0caf7c7$export$aa4c975d12edd698(target, props);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createKeyValueMap(values, keyType, valueType, completeFn, writable) {
    var theMap = {};
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(values, function(key, value) {
        $5831ddb3a0caf7c7$var$_assignMapValue(theMap, key, keyType ? value : key);
        $5831ddb3a0caf7c7$var$_assignMapValue(theMap, value, valueType ? value : key);
    });
    return completeFn ? completeFn(theMap) : theMap;
}
function $5831ddb3a0caf7c7$var$_assignMapValue(theMap, key, value, writable) {
    $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theMap, key, {
        value: value,
        enumerable: true,
        writable: false
    });
}
function $5831ddb3a0caf7c7$var$_objIterateEntries(obj, mapper) {
    var result = [];
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(obj, function(key, val) {
        result.push(mapper(key, val));
    });
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$43fe3a9b30d28d1e(obj) {
    $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(obj);
    if (!$5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(obj)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("non-object " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(obj));
    return $5831ddb3a0caf7c7$var$_objIterateEntries(obj, function(k, _) {
        return k;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$aba5bd6a473725e4(value) {
    return $5831ddb3a0caf7c7$var$_objIterateEntries(value, function(k, v) {
        return [
            k,
            v
        ];
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyObjValues(value) {
    return $5831ddb3a0caf7c7$var$_objIterateEntries(value, function(_, v) {
        return v;
    });
}
function $5831ddb3a0caf7c7$export$dccab8e56e1e1ebf(value1, value2) {
    if (value1 !== value1) return value2 !== value2;
    if (value1 === 0 && value2 === 0) return 1 / value1 === 1 / value2;
    return value1 === value2;
}
var $5831ddb3a0caf7c7$export$22308d67ffa4a0da = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "isFrozen"), $5831ddb3a0caf7c7$var$_returnFalse);
var $5831ddb3a0caf7c7$export$7abf79cebb37c00d = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "isSealed"), $5831ddb3a0caf7c7$var$_returnFalse);
var $5831ddb3a0caf7c7$var$_objFreeze = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "freeze");
function $5831ddb3a0caf7c7$var$_doNothing(value) {
    return value;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getProto(value) {
    $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(value);
    return value[$5831ddb3a0caf7c7$var$__PROTO__] || $5831ddb3a0caf7c7$var$NULL_VALUE;
}
var $5831ddb3a0caf7c7$export$afe328edc487dcfe = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "assign");
var $5831ddb3a0caf7c7$export$f7628dc18f4211e5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "keys");
function $5831ddb3a0caf7c7$var$_deepFreeze(val, visited) {
    if (($5831ddb3a0caf7c7$export$43bee75e5e14138e(val) || $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(val) || $5831ddb3a0caf7c7$export$f6e2535fb5126e54(val)) && !$5831ddb3a0caf7c7$export$22308d67ffa4a0da(val)) {
        for(var lp = 0; lp < visited.length; lp++){
            if (visited[lp] === val) return val;
        }
        visited.push(val);
        $5831ddb3a0caf7c7$export$aa0705d5774c95d1(val, function(_key, propValue) {
            $5831ddb3a0caf7c7$var$_deepFreeze(propValue, visited);
        });
        $5831ddb3a0caf7c7$export$5da24d7703175bc5(val);
    }
    return val;
}
function $5831ddb3a0caf7c7$export$a15782d21797da4c(value) {
    return $5831ddb3a0caf7c7$var$_objFreeze ? $5831ddb3a0caf7c7$var$_deepFreeze(value, []) : value;
}
var $5831ddb3a0caf7c7$export$5da24d7703175bc5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$var$_objFreeze, $5831ddb3a0caf7c7$var$_doNothing);
var $5831ddb3a0caf7c7$export$8bbd42c2bec875c8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "seal"), $5831ddb3a0caf7c7$var$_doNothing);
var $5831ddb3a0caf7c7$export$743454acee35f1d4 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "getPrototypeOf"), $5831ddb3a0caf7c7$var$_getProto);
var $5831ddb3a0caf7c7$export$5359e3134992ffd2 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "entries"), $5831ddb3a0caf7c7$export$aba5bd6a473725e4);
var $5831ddb3a0caf7c7$export$91c2df05d37a1ffb = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "values"), $5831ddb3a0caf7c7$var$polyObjValues);
var $5831ddb3a0caf7c7$export$56bfe2eec434e54a = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "is"), $5831ddb3a0caf7c7$export$dccab8e56e1e1ebf);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$37b2eedf6b7b231a(values) {
    return $5831ddb3a0caf7c7$var$_createKeyValueMap(values, 1, 0, $5831ddb3a0caf7c7$export$5da24d7703175bc5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$db29bd6ce1af3f68(values) {
    return $5831ddb3a0caf7c7$var$_createKeyValueMap(values, 0, 0, $5831ddb3a0caf7c7$export$5da24d7703175bc5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$dbf89c68f5157b55(values) {
    return $5831ddb3a0caf7c7$var$_createKeyValueMap(values, 1, 1, $5831ddb3a0caf7c7$export$5da24d7703175bc5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4cf8c4bb9ca98f0b(values) {
    var mapClass = {};
    $5831ddb3a0caf7c7$export$aa0705d5774c95d1(values, function(key, value) {
        $5831ddb3a0caf7c7$var$_assignMapValue(mapClass, key, value[1]);
        $5831ddb3a0caf7c7$var$_assignMapValue(mapClass, value[0], value[1]);
    });
    return $5831ddb3a0caf7c7$export$5da24d7703175bc5(mapClass);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a6025b6424227e7e(values) {
    return $5831ddb3a0caf7c7$export$4cf8c4bb9ca98f0b(values);
}
var $5831ddb3a0caf7c7$var$_wellKnownSymbolMap = /*#__PURE__*/ $5831ddb3a0caf7c7$export$db29bd6ce1af3f68({
    asyncIterator: 0,
    hasInstance: 1,
    isConcatSpreadable: 2,
    iterator: 3,
    match: 4,
    matchAll: 5,
    replace: 6,
    search: 7,
    species: 8,
    split: 9,
    toPrimitive: 10,
    toStringTag: 11,
    unscopables: 12
});
var $5831ddb3a0caf7c7$var$GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var $5831ddb3a0caf7c7$var$_globalCfg;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getGlobalValue() {
    var result;
    if (typeof globalThis !== $5831ddb3a0caf7c7$var$UNDEFINED) result = globalThis;
    if (!result && typeof self !== $5831ddb3a0caf7c7$var$UNDEFINED) result = self;
    if (!result && typeof window !== $5831ddb3a0caf7c7$var$UNDEFINED) result = window;
    if (!result && typeof $parcel$global !== $5831ddb3a0caf7c7$var$UNDEFINED) result = $parcel$global;
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getGlobalConfig() {
    if (!$5831ddb3a0caf7c7$var$_globalCfg) {
        var gbl = $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getGlobalValue).v || {};
        $5831ddb3a0caf7c7$var$_globalCfg = gbl[$5831ddb3a0caf7c7$var$GLOBAL_CONFIG_KEY] = gbl[$5831ddb3a0caf7c7$var$GLOBAL_CONFIG_KEY] || {};
    }
    return $5831ddb3a0caf7c7$var$_globalCfg;
}
var $5831ddb3a0caf7c7$export$e411eeaf23dccbe8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "min");
var $5831ddb3a0caf7c7$export$2ca8010d037f830f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "max");
var $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("slice", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("substring", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$25b2a9bb66b0078d = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("substr", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$5e0a36ccb324041a);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$5e0a36ccb324041a(value, start, length) {
    $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(value);
    if (length < 0) return $5831ddb3a0caf7c7$var$EMPTY;
    start = start || 0;
    if (start < 0) start = $5831ddb3a0caf7c7$export$2ca8010d037f830f(start + value[$5831ddb3a0caf7c7$var$LENGTH], 0);
    if ($5831ddb3a0caf7c7$export$fce6876652108ab(length)) return $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3(value, start);
    return $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3(value, start, start + length);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a1120f14ec6f7ada(value, count) {
    return $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(value, 0, count);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9fa3d612c59f0874(value, count) {
    return count <= 0 ? $5831ddb3a0caf7c7$var$EMPTY : value[$5831ddb3a0caf7c7$var$LENGTH] > count ? $5831ddb3a0caf7c7$export$aaf2ac896f62f2c3(value, -count) : value;
}
function $5831ddb3a0caf7c7$var$_tagAsPolyfill(target, polyfillTypeName) {
    if (target) {
        $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
            target[$5831ddb3a0caf7c7$var$POLYFILL_TAG] = true;
            target[$5831ddb3a0caf7c7$var$POLYFILL_TYPE_NAME] = polyfillTypeName;
        });
        $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2, [
            target,
            $5831ddb3a0caf7c7$var$POLYFILL_TAG,
            {
                v: true,
                w: false,
                e: false
            }
        ]);
        $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2, [
            target,
            $5831ddb3a0caf7c7$var$POLYFILL_TYPE_NAME,
            {
                v: polyfillTypeName,
                w: false,
                e: false
            }
        ]);
    }
    return target;
}
var $5831ddb3a0caf7c7$export$c09f2411a4ae511b = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "create"), $5831ddb3a0caf7c7$var$polyObjCreate);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyObjCreate(obj, properties) {
    var newObj = null;
    function tempFunc() {}
    if (!$5831ddb3a0caf7c7$export$3388cdee8977b866(obj)) {
        var type = typeof obj;
        if (type !== $5831ddb3a0caf7c7$var$OBJECT && type !== $5831ddb3a0caf7c7$var$FUNCTION) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("Prototype must be an Object or function: " + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(obj));
        tempFunc[$5831ddb3a0caf7c7$var$PROTOTYPE] = obj;
        $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
            tempFunc[$5831ddb3a0caf7c7$var$__PROTO__] = obj;
        });
        newObj = new tempFunc();
    } else newObj = {};
    if (properties) $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$aa4c975d12edd698, [
        newObj,
        properties
    ]);
    return newObj;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a56f095995763cca() {
    return (Date.now || $5831ddb3a0caf7c7$export$dc8a201911902710)();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$dc8a201911902710() {
    return new Date().getTime();
}
function $5831ddb3a0caf7c7$export$2801572b9d3736b5(fn, thisArg, argArray) {
    return fn.apply(thisArg, argArray);
}
function $5831ddb3a0caf7c7$export$4b40e215736a9426(fn, thisArg) {
    return fn.apply(thisArg, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 2));
}
function $5831ddb3a0caf7c7$export$af9753654a45407f(fn, thisArg) {
    return fn.bind.apply(fn, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
var $5831ddb3a0caf7c7$var$_globalLazyTestHooks;
function $5831ddb3a0caf7c7$var$_initTestHooks() {
    $5831ddb3a0caf7c7$var$_globalLazyTestHooks = $5831ddb3a0caf7c7$var$_getGlobalConfig();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$db98eae15987454c(cb, argArray) {
    var lazyValue = {};
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    lazyValue.b = $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy;
    $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(lazyValue, "v", {
        configurable: true,
        get: function() {
            var result = $5831ddb3a0caf7c7$export$2801572b9d3736b5(cb, null, argArray);
            if (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(lazyValue, "v", {
                value: result
            });
            lazyValue.b = $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy;
            return result;
        }
    });
    return lazyValue;
}
function $5831ddb3a0caf7c7$export$31f2f77e19969b63(newValue) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy = newValue;
}
function $5831ddb3a0caf7c7$export$5405f984434b2087(cb, argArray) {
    var lazyValue = {};
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    lazyValue.b = $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy;
    var _setValue = function(newValue) {
        $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(lazyValue, "v", {
            value: newValue,
            writable: true
        });
        if (lazyValue.b) delete lazyValue.b;
    };
    $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(lazyValue, "v", {
        configurable: true,
        get: function() {
            var result = $5831ddb3a0caf7c7$export$2801572b9d3736b5(cb, null, argArray);
            if (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) _setValue(result);
            if ($5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy && lazyValue.b !== $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) lazyValue.b = $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy;
            return result;
        },
        set: _setValue
    });
    return lazyValue;
}
var $5831ddb3a0caf7c7$export$9b2865e267c5db1d = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "random");
var $5831ddb3a0caf7c7$var$_uniqueInstanceId = /*#__PURE__*/ $5831ddb3a0caf7c7$export$db98eae15987454c(function() {
    var value = $5831ddb3a0caf7c7$export$a56f095995763cca().toString(36).slice(2);
    while(value.length < 16)value += $5831ddb3a0caf7c7$export$9b2865e267c5db1d().toString(36).slice(2);
    value = value.substring(0, 16);
    return value;
});
var $5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID = "_urid";
var $5831ddb3a0caf7c7$var$POLY_SYM = "$nw21sym";
var $5831ddb3a0caf7c7$var$_polySymbols;
var $5831ddb3a0caf7c7$var$_polyId = 0;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_globalSymbolRegistry() {
    if (!$5831ddb3a0caf7c7$var$_polySymbols) {
        var gblCfg = $5831ddb3a0caf7c7$var$_getGlobalConfig();
        $5831ddb3a0caf7c7$var$_polySymbols = gblCfg.gblSym = gblCfg.gblSym || {
            k: {},
            s: {}
        };
    }
    return $5831ddb3a0caf7c7$var$_polySymbols;
}
var $5831ddb3a0caf7c7$var$_wellKnownSymbolCache;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1e4b0b24415108a8(description) {
    var uniqueId = "_" + $5831ddb3a0caf7c7$var$_polyId++ + "_" + $5831ddb3a0caf7c7$var$_uniqueInstanceId.v;
    var symString = $5831ddb3a0caf7c7$var$SYMBOL + "(" + description + ")";
    function _setProp(name, value) {
        $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(theSymbol, name, {
            v: value,
            e: false,
            w: false
        });
    }
    var theSymbol = $5831ddb3a0caf7c7$export$c09f2411a4ae511b(null);
    _setProp("description", $5831ddb3a0caf7c7$export$590567be997858b6(description));
    _setProp($5831ddb3a0caf7c7$var$TO_STRING, function() {
        return symString + $5831ddb3a0caf7c7$var$POLY_SYM + uniqueId;
    });
    _setProp("valueOf", function() {
        return theSymbol;
    });
    _setProp("v", symString);
    _setProp("_uid", uniqueId);
    return $5831ddb3a0caf7c7$var$_tagAsPolyfill(theSymbol, "symbol");
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c35d76cf82622c51(key) {
    var registry = $5831ddb3a0caf7c7$var$_globalSymbolRegistry();
    if (!$5831ddb3a0caf7c7$export$34e6b98f73578a9c(registry.k, key)) {
        var newSymbol_1 = $5831ddb3a0caf7c7$export$1e4b0b24415108a8(key);
        var regId_1 = $5831ddb3a0caf7c7$export$f7628dc18f4211e5(registry.s).length;
        newSymbol_1[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID] = function() {
            return regId_1 + "_" + newSymbol_1[$5831ddb3a0caf7c7$var$TO_STRING]();
        };
        registry.k[key] = newSymbol_1;
        registry.s[newSymbol_1[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID]()] = $5831ddb3a0caf7c7$export$590567be997858b6(key);
    }
    return registry.k[key];
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$205212be62415f78(sym) {
    if (!sym || !sym[$5831ddb3a0caf7c7$var$TO_STRING] || $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(sym[$5831ddb3a0caf7c7$var$TO_STRING](), 0, 6) != $5831ddb3a0caf7c7$var$SYMBOL) $5831ddb3a0caf7c7$export$3f7738bd7dcba681(sym + " is not a symbol");
    var regId = $5831ddb3a0caf7c7$var$_isPolyfill(sym) && sym[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID] && sym[$5831ddb3a0caf7c7$var$UNIQUE_REGISTRY_ID]();
    return regId ? $5831ddb3a0caf7c7$var$_globalSymbolRegistry().s[regId] : undefined;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$b9abc24179dacbc5(name) {
    !$5831ddb3a0caf7c7$var$_wellKnownSymbolCache && ($5831ddb3a0caf7c7$var$_wellKnownSymbolCache = {});
    var result;
    var knownName = $5831ddb3a0caf7c7$var$_wellKnownSymbolMap[name];
    if (knownName) result = $5831ddb3a0caf7c7$var$_wellKnownSymbolCache[knownName] = $5831ddb3a0caf7c7$var$_wellKnownSymbolCache[knownName] || $5831ddb3a0caf7c7$export$1e4b0b24415108a8($5831ddb3a0caf7c7$var$SYMBOL + "." + knownName);
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$469f6b7560342b84(value) {
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81({
        toJSON: function() {
            return value;
        }
    }, "v", {
        value: value
    });
}
var $5831ddb3a0caf7c7$export$56002f94d10e4cfd = $5831ddb3a0caf7c7$export$c267b25be8105889;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c267b25be8105889(cb, argArray) {
    var theValue = {
        toJSON: function() {
            return theValue.v;
        }
    };
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theValue, "v", {
        get: function() {
            var result = $5831ddb3a0caf7c7$export$2801572b9d3736b5(cb, null, argArray);
            cb = $5831ddb3a0caf7c7$var$NULL_VALUE;
            $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theValue, "v", {
                value: result
            });
            return result;
        },
        configurable: true
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ec3ff6a41704225(cb, argArray) {
    var theValue = {
        toJSON: function() {
            return theValue.v;
        }
    };
    var _setValue = function(newValue) {
        $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theValue, "v", {
            value: newValue,
            writable: true
        });
    };
    return $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theValue, "v", {
        get: function() {
            var result = $5831ddb3a0caf7c7$export$2801572b9d3736b5(cb, null, argArray);
            _setValue(result);
            cb = $5831ddb3a0caf7c7$var$NULL_VALUE;
            return result;
        },
        set: _setValue,
        configurable: true
    });
}
var $5831ddb3a0caf7c7$var$WINDOW = "window";
var $5831ddb3a0caf7c7$var$_cachedGlobal;
function $5831ddb3a0caf7c7$var$_getGlobalInstFn(getFn, theArgs) {
    var cachedValue;
    return function() {
        !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
        if (!cachedValue || $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) cachedValue = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec(getFn, theArgs).v);
        return cachedValue.v;
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$45fd08e1bc14fe1c(name) {
    return $5831ddb3a0caf7c7$export$db98eae15987454c(function() {
        return $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$3df6e51375017edd, [
            name
        ]).v || $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    });
}
function $5831ddb3a0caf7c7$export$a4e55266d2135a7f(useCached) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    if (!$5831ddb3a0caf7c7$var$_cachedGlobal || useCached === false || $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) $5831ddb3a0caf7c7$var$_cachedGlobal = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getGlobalValue).v || $5831ddb3a0caf7c7$var$NULL_VALUE);
    return $5831ddb3a0caf7c7$var$_cachedGlobal.v;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3df6e51375017edd(name, useCached) {
    var gbl;
    if (!$5831ddb3a0caf7c7$var$_cachedGlobal || useCached === false) gbl = $5831ddb3a0caf7c7$export$a4e55266d2135a7f(useCached);
    else gbl = $5831ddb3a0caf7c7$var$_cachedGlobal.v;
    if (gbl && gbl[name]) return gbl[name];
    if (name === $5831ddb3a0caf7c7$var$WINDOW) try {
        return window;
    } catch (e) {}
    return $5831ddb3a0caf7c7$var$NULL_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c4372eca9c56fe99() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$f65ca476c09acec0();
}
var $5831ddb3a0caf7c7$export$f65ca476c09acec0 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "document"
]);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$fef62134eea24008() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$38b2d434cce3ea22();
}
var $5831ddb3a0caf7c7$export$38b2d434cce3ea22 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    $5831ddb3a0caf7c7$var$WINDOW
]);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$bd82d106260417bf() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$a56241c767c1d89f();
}
var $5831ddb3a0caf7c7$export$a56241c767c1d89f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "navigator"
]);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$b79afd6d47f11781() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$f9582a3c130d9538();
}
var $5831ddb3a0caf7c7$export$f9582a3c130d9538 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "history"
]);
var $5831ddb3a0caf7c7$export$8ee0fc9ee280b4ee = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn(function() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
        return $cfae44f0dfdf62c0$exports && ($cfae44f0dfdf62c0$exports.versions || {}).node;
    }).v;
});
var $5831ddb3a0caf7c7$export$97b87b8868ff7a3c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn(function() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$170b8c323eee7bec(function() {
        return self && self instanceof WorkerGlobalScope;
    }).v;
});
var $5831ddb3a0caf7c7$var$_symbol;
var $5831ddb3a0caf7c7$var$_symbolFor;
var $5831ddb3a0caf7c7$var$_symbolKeyFor;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_initSymbol() {
    $5831ddb3a0caf7c7$var$_symbol = /*#__PURE__*/ $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$3df6e51375017edd, [
        $5831ddb3a0caf7c7$var$SYMBOL
    ]).v);
    return $5831ddb3a0caf7c7$var$_symbol;
}
function $5831ddb3a0caf7c7$var$_getSymbolKey(key) {
    var gblSym = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol();
    return gblSym.v ? gblSym.v[key] : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
var $5831ddb3a0caf7c7$export$a244864fd9645c7f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createIsWithPoly("symbol");
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1e6e45ea4c3f892c() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$57af67db727bc7c7();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$57af67db727bc7c7() {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    return ((!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol()).v;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3a9aefdadea26115(name, noPoly) {
    var knownName = $5831ddb3a0caf7c7$var$_wellKnownSymbolMap[name];
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    var sym = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol();
    return sym.v ? sym.v[knownName || name] : !noPoly ? $5831ddb3a0caf7c7$export$b9abc24179dacbc5(name) : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$70503d621eee7e7b(description, noPoly) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    var sym = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbol : 0) || $5831ddb3a0caf7c7$var$_initSymbol();
    return sym.v ? sym.v(description) : !noPoly ? $5831ddb3a0caf7c7$export$1e4b0b24415108a8(description) : $5831ddb3a0caf7c7$var$NULL_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4d0ba04d25a41f31(key) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    $5831ddb3a0caf7c7$var$_symbolFor = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbolFor : 0) || /*#__PURE__*/ $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getSymbolKey, [
        "for"
    ]).v);
    return ($5831ddb3a0caf7c7$var$_symbolFor.v || $5831ddb3a0caf7c7$export$c35d76cf82622c51)(key);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$5cc35ecfe266eba7(sym) {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    $5831ddb3a0caf7c7$var$_symbolKeyFor = (!$5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy ? $5831ddb3a0caf7c7$var$_symbolKeyFor : 0) || /*#__PURE__*/ $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_getSymbolKey, [
        "keyFor"
    ]).v);
    return ($5831ddb3a0caf7c7$var$_symbolKeyFor.v || $5831ddb3a0caf7c7$export$205212be62415f78)(sym);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$50db6e277db66ea0(value) {
    return !!value && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.next);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9652023d9040757(value) {
    return !$5831ddb3a0caf7c7$export$3388cdee8977b866(value) && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(value[$5831ddb3a0caf7c7$export$3a9aefdadea26115(3)]);
}
var $5831ddb3a0caf7c7$var$_iterSymbol$1;
function $5831ddb3a0caf7c7$export$1180a64ad833b902(iter, callbackfn, thisArg) {
    if (iter) {
        if (!$5831ddb3a0caf7c7$export$50db6e277db66ea0(iter)) {
            !$5831ddb3a0caf7c7$var$_iterSymbol$1 && ($5831ddb3a0caf7c7$var$_iterSymbol$1 = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$3a9aefdadea26115(3)));
            iter = iter[$5831ddb3a0caf7c7$var$_iterSymbol$1.v] ? iter[$5831ddb3a0caf7c7$var$_iterSymbol$1.v]() : $5831ddb3a0caf7c7$var$NULL_VALUE;
        }
        if ($5831ddb3a0caf7c7$export$50db6e277db66ea0(iter)) {
            var err = $5831ddb3a0caf7c7$var$UNDEF_VALUE;
            var iterResult = $5831ddb3a0caf7c7$var$UNDEF_VALUE;
            try {
                var count = 0;
                while(!(iterResult = iter.next()).done){
                    if (callbackfn[$5831ddb3a0caf7c7$var$CALL](thisArg || iter, iterResult.value, count, iter) === -1) break;
                    count++;
                }
            } catch (failed) {
                err = {
                    e: failed
                };
                if (iter.throw) {
                    iterResult = $5831ddb3a0caf7c7$var$NULL_VALUE;
                    iter.throw(err);
                }
            } finally{
                try {
                    if (iterResult && !iterResult.done) iter.return && iter.return(iterResult);
                } finally{
                    if (err) // eslint-disable-next-line no-unsafe-finally
                    throw err.e;
                }
            }
        }
    }
}
function $5831ddb3a0caf7c7$export$69c7b96f216fdf7b(target, elms) {
    if (!$5831ddb3a0caf7c7$export$fce6876652108ab(elms) && target) {
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(elms)) $5831ddb3a0caf7c7$export$2801572b9d3736b5(target.push, target, elms);
        else if ($5831ddb3a0caf7c7$export$50db6e277db66ea0(elms) || $5831ddb3a0caf7c7$export$9652023d9040757(elms)) $5831ddb3a0caf7c7$export$1180a64ad833b902(elms, function(elm) {
            target.push(elm);
        });
        else target.push(elms);
    }
    return target;
}
var $5831ddb3a0caf7c7$export$a456dfa2a32ba463 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("every", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$4028a8780eeac59b = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("filter", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$9f3b3ffa84393d30 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("indexOf", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$ef8741fcdb4b04c8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("lastIndexOf", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$76f1a28030e24fa6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("map", $5831ddb3a0caf7c7$var$ArrProto);
function $5831ddb3a0caf7c7$export$1bea104a0e2567f0(theArray, start, end) {
    return ((theArray ? theArray["slice"] : $5831ddb3a0caf7c7$var$NULL_VALUE) || $5831ddb3a0caf7c7$var$ArrSlice).apply(theArray, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$cc916d431d083b34(value) {
    if ($5831ddb3a0caf7c7$export$bedb7023a7733221(value)) return false;
    return $5831ddb3a0caf7c7$export$3cbb80dec8953997(value) === "[object Array]";
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$736940c79a4f6caa(theArray, searchElement, fromIndex) {
    return $5831ddb3a0caf7c7$export$9f3b3ffa84393d30(theArray, searchElement, fromIndex) !== -1;
}
function $5831ddb3a0caf7c7$export$dcd90af2789cc4fb(theArray, callbackFn, thisArg) {
    var result;
    var idx = $5831ddb3a0caf7c7$export$76dacc098dca1b23(theArray, callbackFn, thisArg);
    return idx !== -1 ? theArray[idx] : result;
}
function $5831ddb3a0caf7c7$export$76dacc098dca1b23(theArray, callbackFn, thisArg) {
    var result = -1;
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(theArray, function(value, index) {
        if (callbackFn[$5831ddb3a0caf7c7$var$CALL](thisArg | theArray, value, index, theArray)) {
            result = index;
            return -1;
        }
    });
    return result;
}
function $5831ddb3a0caf7c7$export$9d4e32e380b66a8e(theArray, callbackFn, thisArg) {
    var result;
    var idx = $5831ddb3a0caf7c7$export$cef06c5d5cf144f1(theArray, callbackFn, thisArg);
    return idx !== -1 ? theArray[idx] : result;
}
function $5831ddb3a0caf7c7$export$cef06c5d5cf144f1(theArray, callbackFn, thisArg) {
    var result = -1;
    var len = theArray[$5831ddb3a0caf7c7$var$LENGTH] >>> 0;
    for(var idx = len - 1; idx >= 0; idx--)if (idx in theArray && callbackFn[$5831ddb3a0caf7c7$var$CALL](thisArg | theArray, theArray[idx], idx, theArray)) {
        result = idx;
        break;
    }
    return result;
}
function $5831ddb3a0caf7c7$export$f12f44c17d4fb318(theValue, mapFn, thisArg) {
    if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(theValue)) {
        var result_1 = $5831ddb3a0caf7c7$export$1bea104a0e2567f0(theValue);
        return mapFn ? $5831ddb3a0caf7c7$export$76f1a28030e24fa6(result_1, mapFn, thisArg) : result_1;
    }
    var result = [];
    $5831ddb3a0caf7c7$export$1180a64ad833b902(theValue, function(value, cnt) {
        return result.push(mapFn ? mapFn[$5831ddb3a0caf7c7$var$CALL](thisArg, value, cnt) : value);
    });
    return result;
}
var $5831ddb3a0caf7c7$export$3cb758d993f67d76 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("find", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$dcd90af2789cc4fb);
var $5831ddb3a0caf7c7$export$62c3fd54f456ac05 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("findIndex", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$76dacc098dca1b23);
var $5831ddb3a0caf7c7$export$cde52e8eba9adf83 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("findLast", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$9d4e32e380b66a8e);
var $5831ddb3a0caf7c7$export$8ca1e4aa314ced30 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("findLastIndex", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$cef06c5d5cf144f1);
var $5831ddb3a0caf7c7$export$7b9440edbb83caa4 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ArrCls, "from"), $5831ddb3a0caf7c7$export$f12f44c17d4fb318);
var $5831ddb3a0caf7c7$export$fa3af84817874a27 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("includes", $5831ddb3a0caf7c7$var$ArrProto, $5831ddb3a0caf7c7$export$736940c79a4f6caa);
var $5831ddb3a0caf7c7$export$fb75cfad7c4b6a08 = $5831ddb3a0caf7c7$export$fa3af84817874a27;
var $5831ddb3a0caf7c7$export$a16e2b23dbd5466c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("reduce", $5831ddb3a0caf7c7$var$ArrProto);
var $5831ddb3a0caf7c7$export$dff8f5be8b2ae7a2 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("some", $5831ddb3a0caf7c7$var$ArrProto);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$d9e878335f2ef4a7(hostFn, funcName) {
    return function() {
        var theArgs = $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments);
        var theHost = hostFn();
        return $5831ddb3a0caf7c7$export$2801572b9d3736b5(theHost[funcName], theHost, theArgs);
    };
}
function $5831ddb3a0caf7c7$export$9bf51b747c7699ea(target, host, funcDefs) {
    if (target && host && $5831ddb3a0caf7c7$export$43bee75e5e14138e(funcDefs)) {
        var isDeferred_1 = $5831ddb3a0caf7c7$export$f6e2535fb5126e54(host);
        $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(funcDefs, function(funcDef) {
            var targetName = funcDef.as || funcDef.n;
            if (funcDef.rp === false && target[targetName]) return;
            target[targetName] = isDeferred_1 ? $5831ddb3a0caf7c7$export$d9e878335f2ef4a7(host, funcDef.n) : $5831ddb3a0caf7c7$export$af9753654a45407f(host[funcDef.n], host);
        });
    }
    return target;
}
var $5831ddb3a0caf7c7$var$_iterSymbol;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3c428921980810ca(theArgs, start, end) {
    if (!$5831ddb3a0caf7c7$export$34e6b98f73578a9c(theArgs, $5831ddb3a0caf7c7$var$LENGTH)) {
        !$5831ddb3a0caf7c7$var$_iterSymbol && ($5831ddb3a0caf7c7$var$_iterSymbol = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$1e6e45ea4c3f892c() && $5831ddb3a0caf7c7$export$3a9aefdadea26115(3)));
        var iterFn = void 0;
        if ($5831ddb3a0caf7c7$var$_iterSymbol.v) iterFn = theArgs[$5831ddb3a0caf7c7$var$_iterSymbol.v];
        if (iterFn) {
            var values_1 = [];
            var from_1 = start === $5831ddb3a0caf7c7$var$UNDEF_VALUE || start < 0 ? 0 : start;
            var to_1 = end < 0 || start < 0 ? $5831ddb3a0caf7c7$var$UNDEF_VALUE : end;
            $5831ddb3a0caf7c7$export$1180a64ad833b902(iterFn[$5831ddb3a0caf7c7$var$CALL](theArgs), function(value, cnt) {
                if (to_1 !== $5831ddb3a0caf7c7$var$UNDEF_VALUE && cnt >= to_1) return -1;
                if (cnt >= from_1) values_1.push(value);
            });
            if ((start === $5831ddb3a0caf7c7$var$UNDEF_VALUE || start >= 0) && (end === $5831ddb3a0caf7c7$var$UNDEF_VALUE || end >= 0)) return values_1;
            theArgs = values_1;
        }
    }
    return $5831ddb3a0caf7c7$export$1bea104a0e2567f0(theArgs, start, end);
}
var $5831ddb3a0caf7c7$var$_isProtoArray;
var $5831ddb3a0caf7c7$export$97268f64d317ba65 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "setPrototypeOf"), $5831ddb3a0caf7c7$var$_polyObjSetPrototypeOf);
function $5831ddb3a0caf7c7$var$_polyObjSetPrototypeOf(obj, proto) {
    var _a;
    !$5831ddb3a0caf7c7$var$_isProtoArray && ($5831ddb3a0caf7c7$var$_isProtoArray = $5831ddb3a0caf7c7$export$469f6b7560342b84((_a = {}, _a[$5831ddb3a0caf7c7$var$__PROTO__] = [], _a) instanceof Array));
    $5831ddb3a0caf7c7$var$_isProtoArray.v ? obj[$5831ddb3a0caf7c7$var$__PROTO__] = proto : $5831ddb3a0caf7c7$export$aa0705d5774c95d1(proto, function(key, value) {
        return obj[key] = value;
    });
    return obj;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createCustomError(name, d, b) {
    $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2, [
        d,
        $5831ddb3a0caf7c7$var$NAME,
        {
            v: name,
            c: true,
            e: false
        }
    ]);
    d = $5831ddb3a0caf7c7$export$97268f64d317ba65(d, b);
    function __() {
        this[$5831ddb3a0caf7c7$var$CONSTRUCTOR] = d;
        $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2, [
            this,
            $5831ddb3a0caf7c7$var$NAME,
            {
                v: name,
                c: true,
                e: false
            }
        ]);
    }
    d[$5831ddb3a0caf7c7$var$PROTOTYPE] = b === $5831ddb3a0caf7c7$var$NULL_VALUE ? $5831ddb3a0caf7c7$export$c09f2411a4ae511b(b) : (__[$5831ddb3a0caf7c7$var$PROTOTYPE] = b[$5831ddb3a0caf7c7$var$PROTOTYPE], new __());
    return d;
}
function $5831ddb3a0caf7c7$var$_setName(baseClass, name) {
    name && (baseClass[$5831ddb3a0caf7c7$var$NAME] = name);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$435492119a21bab3(name, constructCb, errorBase) {
    var theBaseClass = errorBase || Error;
    var orgName = theBaseClass[$5831ddb3a0caf7c7$var$PROTOTYPE][$5831ddb3a0caf7c7$var$NAME];
    var captureFn = Error.captureStackTrace;
    return $5831ddb3a0caf7c7$var$_createCustomError(name, function() {
        var _this = this;
        var theArgs = arguments;
        try {
            $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_setName, [
                theBaseClass,
                name
            ]);
            var _self = $5831ddb3a0caf7c7$export$2801572b9d3736b5(theBaseClass, _this, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](theArgs)) || _this;
            if (_self !== _this) {
                var orgProto = $5831ddb3a0caf7c7$export$743454acee35f1d4(_this);
                if (orgProto !== $5831ddb3a0caf7c7$export$743454acee35f1d4(_self)) $5831ddb3a0caf7c7$export$97268f64d317ba65(_self, orgProto);
            }
            captureFn && captureFn(_self, _this[$5831ddb3a0caf7c7$var$CONSTRUCTOR]);
            constructCb && constructCb(_self, theArgs);
            return _self;
        } finally{
            $5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$var$_setName, [
                theBaseClass,
                orgName
            ]);
        }
    }, theBaseClass);
}
var $5831ddb3a0caf7c7$var$_unsupportedError;
function $5831ddb3a0caf7c7$export$6523a1bd3b6e3128(message) {
    if (!$5831ddb3a0caf7c7$var$_unsupportedError) $5831ddb3a0caf7c7$var$_unsupportedError = $5831ddb3a0caf7c7$export$435492119a21bab3("UnsupportedError");
    throw new $5831ddb3a0caf7c7$var$_unsupportedError(message);
}
function $5831ddb3a0caf7c7$export$45a5e7f76e0caa8d(value) {
    return !!value && value.nodeType === 1 && !!value.nodeName && !!(typeof Element !== "undefined" && value instanceof Element);
}
function $5831ddb3a0caf7c7$export$5673007d93a684ea(value) {
    return !!value && value.nodeType === 1 && !!value.nodeName;
}
function $5831ddb3a0caf7c7$export$dd1bc94b04021eeb(value) {
    var result = $5831ddb3a0caf7c7$export$3388cdee8977b866(value);
    if (!result) {
        if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value) || $5831ddb3a0caf7c7$export$43bee75e5e14138e(value)) result = value.length === 0;
        else if ($5831ddb3a0caf7c7$export$313ce3f19588c7e8(value) || $5831ddb3a0caf7c7$export$246c46e3eb4af8c1(value)) result = value.size === 0;
        else if ($5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(value)) result = $5831ddb3a0caf7c7$export$f7628dc18f4211e5(value).length === 0;
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createTrimFn(exp) {
    return function _doTrim(value) {
        $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(value);
        if (value && value.replace) value = value.replace(exp, $5831ddb3a0caf7c7$var$EMPTY);
        return value;
    };
}
var $5831ddb3a0caf7c7$export$f662cd8e6ce31dc2 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createTrimFn(/^\s+|(?=\s)\s+$/g);
var $5831ddb3a0caf7c7$export$bb2565d3c45fa8e8 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createTrimFn(/^\s+/g);
var $5831ddb3a0caf7c7$export$78c6fe435b4cfdc5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_createTrimFn(/(?=\s)\s+$/g);
var $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("trim", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$f662cd8e6ce31dc2);
var $5831ddb3a0caf7c7$export$cc516ea7d6f0e796 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("trimStart", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$bb2565d3c45fa8e8);
var $5831ddb3a0caf7c7$export$54a8ea2dce045d2d = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$export$cc516ea7d6f0e796);
var $5831ddb3a0caf7c7$export$2f86eefb8e93fce1 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("trimEnd", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$78c6fe435b4cfdc5);
var $5831ddb3a0caf7c7$export$9c947579c164a1bf = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$export$2f86eefb8e93fce1);
var $5831ddb3a0caf7c7$export$f719256e30f2ebe5 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("toUpperCase", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$389a34274c2f7137 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("toLowerCase", $5831ddb3a0caf7c7$var$StrProto);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_convertCase(value, newPrefix, upperWord) {
    return $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7($5831ddb3a0caf7c7$export$590567be997858b6(value)).replace(/((_|\W)+(\w){0,1}|([a-z])([A-Z]))/g, function(_match, _g1, _g2, wordStart, upperPrefix, upperLetter) {
        var convertMatch = wordStart || upperLetter || $5831ddb3a0caf7c7$var$EMPTY;
        if (upperWord) convertMatch = $5831ddb3a0caf7c7$export$f719256e30f2ebe5(convertMatch);
        return (upperPrefix || $5831ddb3a0caf7c7$var$EMPTY) + newPrefix + convertMatch;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9d31ddd596700d21(value) {
    return $5831ddb3a0caf7c7$export$590567be997858b6(value).replace(/(_|\b)\w/g, $5831ddb3a0caf7c7$export$f719256e30f2ebe5);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$fca2281e8ae838f(value, upperFirst) {
    var result = $5831ddb3a0caf7c7$var$_convertCase(value, "", true);
    return result.replace(/^\w/, upperFirst ? $5831ddb3a0caf7c7$export$f719256e30f2ebe5 : $5831ddb3a0caf7c7$export$389a34274c2f7137);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4b115658c011a193(value, scream) {
    var result = $5831ddb3a0caf7c7$var$_convertCase(value, "-");
    return (scream ? $5831ddb3a0caf7c7$export$f719256e30f2ebe5 : $5831ddb3a0caf7c7$export$389a34274c2f7137)(result);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$e48063a1e49453b7(value, scream) {
    var result = $5831ddb3a0caf7c7$var$_convertCase(value, "_");
    return (scream ? $5831ddb3a0caf7c7$export$f719256e30f2ebe5 : $5831ddb3a0caf7c7$export$389a34274c2f7137)(result);
}
var $5831ddb3a0caf7c7$export$c6301bc99a7f80a7 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "floor");
var $5831ddb3a0caf7c7$export$cf129980c996e186 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "ceil");
var $5831ddb3a0caf7c7$export$faee793222d6047e = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "trunc"), $5831ddb3a0caf7c7$var$polyMathTrunc);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyMathTrunc(value) {
    var theValue = +value;
    return (theValue > 0 ? $5831ddb3a0caf7c7$export$c6301bc99a7f80a7 : $5831ddb3a0caf7c7$export$cf129980c996e186)(theValue);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$930e69fac432072(value, throwInfinity) {
    var result = +value;
    if (throwInfinity && (result === Infinity || result == Infinity)) $5831ddb3a0caf7c7$export$462e4d432290318e("invalid value [" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(value) + "]");
    return result !== result || result === 0 ? 0 : $5831ddb3a0caf7c7$export$faee793222d6047e(result);
}
var $5831ddb3a0caf7c7$export$e944713c974c3850 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("repeat", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrRepeat);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrRepeat(value, count) {
    $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(value);
    count = $5831ddb3a0caf7c7$export$930e69fac432072(count, true);
    if (count < 0) $5831ddb3a0caf7c7$export$462e4d432290318e("invalid count must be >= 0 && < Infinity");
    var pad = $5831ddb3a0caf7c7$export$844ec244b1367d54(value) ? value : $5831ddb3a0caf7c7$export$590567be997858b6(value);
    var result = $5831ddb3a0caf7c7$var$EMPTY;
    for(; count > 0; (count >>>= 1) && (pad += pad))if (count & 1) result += pad;
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_padValue(value, targetLength, padString) {
    var result = $5831ddb3a0caf7c7$var$EMPTY;
    targetLength = $5831ddb3a0caf7c7$export$930e69fac432072(targetLength, true);
    targetLength >>= 0;
    var len = value[$5831ddb3a0caf7c7$var$LENGTH];
    if (len < targetLength) {
        result = $5831ddb3a0caf7c7$export$bedb7023a7733221(padString) ? " " : $5831ddb3a0caf7c7$export$590567be997858b6(padString);
        targetLength = targetLength - len;
        if (targetLength > result[$5831ddb3a0caf7c7$var$LENGTH]) result = $5831ddb3a0caf7c7$export$e944713c974c3850(result, $5831ddb3a0caf7c7$export$cf129980c996e186(targetLength / result[$5831ddb3a0caf7c7$var$LENGTH]));
        if (result[$5831ddb3a0caf7c7$var$LENGTH] > targetLength) result = $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(result, 0, targetLength);
    }
    return result;
}
var $5831ddb3a0caf7c7$export$5883ba0f525e6e64 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("padStart", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrPadStart);
var $5831ddb3a0caf7c7$export$1679063bd52155c = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("padEnd", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrPadEnd);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrPadStart(value, targetLength, padString) {
    return $5831ddb3a0caf7c7$var$_padValue(value, targetLength, padString) + value;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrPadEnd(value, targetLength, padString) {
    return value + $5831ddb3a0caf7c7$var$_padValue(value, targetLength, padString);
}
var $5831ddb3a0caf7c7$var$DBL_QUOTE = "\"";
var $5831ddb3a0caf7c7$var$INVALID_JS_NAME = /([^\w\d_$])/g;
var $5831ddb3a0caf7c7$var$_htmlEntityCache;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$f60443f194e40bc2(jsName, camelCase) {
    var result = $5831ddb3a0caf7c7$export$590567be997858b6(jsName).replace($5831ddb3a0caf7c7$var$INVALID_JS_NAME, "_");
    return !$5831ddb3a0caf7c7$export$fce6876652108ab(camelCase) ? $5831ddb3a0caf7c7$export$fca2281e8ae838f(result, !camelCase) : result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$bc8dd9487ff4d994(value, format) {
    var result;
    if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value)) result = $5831ddb3a0caf7c7$var$DBL_QUOTE + value.replace(/[^\w .,\-!@#$%\^&*\(\)_+={}\[\]:;|<>?]/g, function(match) {
        if (match === $5831ddb3a0caf7c7$var$DBL_QUOTE || match === "\\") return "\\" + match;
        var hex = match.charCodeAt(0)[$5831ddb3a0caf7c7$var$TO_STRING](16);
        return "\\u" + $5831ddb3a0caf7c7$export$5883ba0f525e6e64($5831ddb3a0caf7c7$export$f719256e30f2ebe5(hex), 4, "0");
    }) + $5831ddb3a0caf7c7$var$DBL_QUOTE;
    else try {
        result = JSON.stringify(value, $5831ddb3a0caf7c7$var$NULL_VALUE, format ? $5831ddb3a0caf7c7$export$7e4aa119212bc614(format) ? format : 4 : $5831ddb3a0caf7c7$var$UNDEF_VALUE);
    } catch (e) {
        result = $5831ddb3a0caf7c7$var$DBL_QUOTE + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(e) + $5831ddb3a0caf7c7$var$DBL_QUOTE;
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c41e0bfda0ab0f0d(value) {
    !$5831ddb3a0caf7c7$var$_htmlEntityCache && ($5831ddb3a0caf7c7$var$_htmlEntityCache = {
        "&": "amp",
        "<": "lt",
        ">": "gt",
        "\"": "quot",
        "'": "#39"
    });
    return $5831ddb3a0caf7c7$export$590567be997858b6(value).replace(/[&<>"']/g, function(match) {
        return "&" + $5831ddb3a0caf7c7$var$_htmlEntityCache[match] + ";";
    });
}
var $5831ddb3a0caf7c7$var$_fnToString;
var $5831ddb3a0caf7c7$var$_objCtrFnString;
var $5831ddb3a0caf7c7$var$_gblWindow;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$53b83ca8eaab0383(value) {
    if (!value || typeof value !== $5831ddb3a0caf7c7$var$OBJECT) return false;
    if (!$5831ddb3a0caf7c7$var$_gblWindow) $5831ddb3a0caf7c7$var$_gblWindow = $5831ddb3a0caf7c7$export$fef62134eea24008() ? $5831ddb3a0caf7c7$export$38b2d434cce3ea22() : true;
    var result = false;
    if (value !== $5831ddb3a0caf7c7$var$_gblWindow) {
        if (!$5831ddb3a0caf7c7$var$_objCtrFnString) {
            $5831ddb3a0caf7c7$var$_fnToString = Function[$5831ddb3a0caf7c7$var$PROTOTYPE][$5831ddb3a0caf7c7$var$TO_STRING];
            $5831ddb3a0caf7c7$var$_objCtrFnString = $5831ddb3a0caf7c7$var$_fnToString[$5831ddb3a0caf7c7$var$CALL]($5831ddb3a0caf7c7$var$ObjClass);
        }
        try {
            var proto = $5831ddb3a0caf7c7$export$743454acee35f1d4(value);
            result = !proto;
            if (!result) {
                if ($5831ddb3a0caf7c7$export$d76937f5d45b7158(proto, $5831ddb3a0caf7c7$var$CONSTRUCTOR)) proto = proto[$5831ddb3a0caf7c7$var$CONSTRUCTOR];
                result = !!(proto && typeof proto === $5831ddb3a0caf7c7$var$FUNCTION && $5831ddb3a0caf7c7$var$_fnToString[$5831ddb3a0caf7c7$var$CALL](proto) === $5831ddb3a0caf7c7$var$_objCtrFnString);
            }
        } catch (ex) {}
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_defaultDeepCopyHandler(details) {
    details.value && $5831ddb3a0caf7c7$export$7d1ebb7d4f033054(details);
    return true;
}
var $5831ddb3a0caf7c7$var$defaultDeepCopyHandlers = [
    $5831ddb3a0caf7c7$export$cc4db57f4a8fbdc7,
    $5831ddb3a0caf7c7$export$7d1ebb7d4f033054,
    $5831ddb3a0caf7c7$export$56ca4b82c6e32658,
    $5831ddb3a0caf7c7$export$2b6207be55b7460b
];
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(visitMap, function(entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        theEntry = {
            k: source,
            v: source
        };
        visitMap.push(theEntry);
        cb(theEntry);
    }
    return theEntry.v;
}
function $5831ddb3a0caf7c7$var$_deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? key ? ctx.path.concat(key) : ctx.path : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = value === $5831ddb3a0caf7c7$var$NULL_VALUE;
    if (!isPrim) {
        if (value && theType === $5831ddb3a0caf7c7$var$OBJECT) isPlain = $5831ddb3a0caf7c7$export$53b83ca8eaab0383(value);
        else isPrim = $5831ddb3a0caf7c7$export$1f3b27a0956fac0e(theType);
    }
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function(source, newKey) {
            return $5831ddb3a0caf7c7$var$_deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function(target, source) {
            return $5831ddb3a0caf7c7$var$_copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) return $5831ddb3a0caf7c7$var$_getSetVisited(visitMap, value, newPath, function(newEntry) {
        $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(details, "result", {
            g: function() {
                return newEntry.v;
            },
            s: function(newValue) {
                newEntry.v = newValue;
            }
        });
        var idx = 0;
        var handler = userHandler;
        while(!(handler || (idx < $5831ddb3a0caf7c7$var$defaultDeepCopyHandlers.length ? $5831ddb3a0caf7c7$var$defaultDeepCopyHandlers[idx++] : $5831ddb3a0caf7c7$var$_defaultDeepCopyHandler))[$5831ddb3a0caf7c7$var$CALL](ctx, details))handler = $5831ddb3a0caf7c7$var$NULL_VALUE;
    });
    if (userHandler && userHandler[$5831ddb3a0caf7c7$var$CALL](ctx, details)) return details.result;
    return value;
}
function $5831ddb3a0caf7c7$var$_copyProps(visitMap, target, source, ctx) {
    if (!$5831ddb3a0caf7c7$export$bedb7023a7733221(source)) for(var key in source)target[key] = $5831ddb3a0caf7c7$var$_deepCopy(visitMap, source[key], ctx, key);
    return target;
}
function $5831ddb3a0caf7c7$export$eee89407658fa201(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return $5831ddb3a0caf7c7$var$_copyProps([], target, source, ctx);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ee1b2e0d6501c954(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return $5831ddb3a0caf7c7$var$_deepCopy([], source, ctx);
}
function $5831ddb3a0caf7c7$export$cc4db57f4a8fbdc7(details) {
    var value = details.value;
    if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(value)) {
        var target = details.result = [];
        target.length = value.length;
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function $5831ddb3a0caf7c7$export$2b6207be55b7460b(details) {
    var value = details.value;
    if ($5831ddb3a0caf7c7$export$871608497c498473(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
function $5831ddb3a0caf7c7$export$56ca4b82c6e32658(details) {
    if (details.type === $5831ddb3a0caf7c7$var$FUNCTION) return true;
    return false;
}
function $5831ddb3a0caf7c7$export$7d1ebb7d4f033054(details) {
    var value = details.value;
    if (value && details.isPlain) {
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function $5831ddb3a0caf7c7$var$_doExtend(target, theArgs) {
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(theArgs, function(theArg) {
        $5831ddb3a0caf7c7$export$eee89407658fa201(target, theArg);
    });
    return target;
}
function $5831ddb3a0caf7c7$export$54e9fb29908872fa(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return $5831ddb3a0caf7c7$var$_doExtend($5831ddb3a0caf7c7$export$ee1b2e0d6501c954(target) || {}, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
function $5831ddb3a0caf7c7$export$a7f7e50f928053df(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return $5831ddb3a0caf7c7$var$_doExtend(target || {}, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$662922279874f264(value, splitter, limit) {
    var splitFn = splitter ? splitter[$5831ddb3a0caf7c7$export$3a9aefdadea26115(9)] : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    return splitFn ? splitFn(value, limit) : [
        value
    ];
}
var $5831ddb3a0caf7c7$export$c07560e259c81ec6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("split", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$c2a2794de8b8ee4e = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("split", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$662922279874f264);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a81fc8ab8c0b1254(target, path, defValue) {
    if (!path || !target) return defValue;
    var parts = $5831ddb3a0caf7c7$export$c07560e259c81ec6(path, ".");
    var cnt = parts.length;
    for(var lp = 0; lp < cnt && !$5831ddb3a0caf7c7$export$bedb7023a7733221(target); lp++)target = target[parts[lp]];
    return !$5831ddb3a0caf7c7$export$bedb7023a7733221(target) ? target : defValue;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9054a6f0ccd5e6fd(target, iter, defValue) {
    if (!iter || !target) return defValue;
    $5831ddb3a0caf7c7$export$1180a64ad833b902(iter, function(value) {
        if ($5831ddb3a0caf7c7$export$bedb7023a7733221(target)) return -1;
        target = target[value];
    });
    return !$5831ddb3a0caf7c7$export$bedb7023a7733221(target) ? target : defValue;
}
function $5831ddb3a0caf7c7$export$7dee18238d098123(target, path, value) {
    if (target && path) {
        var parts = $5831ddb3a0caf7c7$export$c07560e259c81ec6(path, ".");
        var lastKey = parts.pop();
        $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(parts, function(key) {
            if ($5831ddb3a0caf7c7$export$bedb7023a7733221(target[key])) target[key] = {};
            target = target[key];
        });
        target[lastKey] = value;
    }
}
function $5831ddb3a0caf7c7$export$4eaf2d2fdfc0ba46(target, iter, value) {
    if (target && iter) {
        var lastKey_1;
        $5831ddb3a0caf7c7$export$1180a64ad833b902(iter, function(key) {
            if (lastKey_1) {
                if ($5831ddb3a0caf7c7$export$bedb7023a7733221(target[lastKey_1])) target[lastKey_1] = {};
                target = target[lastKey_1];
            }
            lastKey_1 = key;
        });
        target[lastKey_1] = value;
    }
}
var $5831ddb3a0caf7c7$export$f0d11c074a923179 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapProp($5831ddb3a0caf7c7$var$LENGTH);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1bc10eefc0289e0a(value, defValue) {
    try {
        var theValue = value;
        if (!$5831ddb3a0caf7c7$export$7e4aa119212bc614(value)) theValue = parseInt($5831ddb3a0caf7c7$export$590567be997858b6(value), 10);
        return $5831ddb3a0caf7c7$export$bedb7023a7733221(value) || isNaN(theValue) ? defValue : theValue;
    } catch (e) {}
    return defValue;
}
var $5831ddb3a0caf7c7$export$a287f47fed4544b8 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$NumberCls, "isInteger"), $5831ddb3a0caf7c7$var$_polyNumberIsInteger);
function $5831ddb3a0caf7c7$var$_polyNumberIsInteger(value) {
    return $5831ddb3a0caf7c7$export$7e4aa119212bc614(value) && !isNaN(value) && isFinite(value) && $5831ddb3a0caf7c7$export$c6301bc99a7f80a7(value) === value;
}
function $5831ddb3a0caf7c7$export$cf6c09818bd7035a(value) {
    return $5831ddb3a0caf7c7$export$7e4aa119212bc614(value) && !isNaN(value) && isFinite(value);
}
var $5831ddb3a0caf7c7$var$_perf;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$581add2462e763c2() {
    return !!$5831ddb3a0caf7c7$export$28a0276e10aa78d7();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$28a0276e10aa78d7() {
    !$5831ddb3a0caf7c7$var$_globalLazyTestHooks && $5831ddb3a0caf7c7$var$_initTestHooks();
    if (!$5831ddb3a0caf7c7$var$_perf || $5831ddb3a0caf7c7$var$_globalLazyTestHooks.lzy) $5831ddb3a0caf7c7$var$_perf = $5831ddb3a0caf7c7$export$469f6b7560342b84($5831ddb3a0caf7c7$export$170b8c323eee7bec($5831ddb3a0caf7c7$export$3df6e51375017edd, [
        "performance"
    ]).v);
    return $5831ddb3a0caf7c7$var$_perf.v;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$ba2b1ec760f018ed() {
    var perf = $5831ddb3a0caf7c7$export$28a0276e10aa78d7();
    if (perf && perf.now) return perf.now();
    return $5831ddb3a0caf7c7$export$a56f095995763cca();
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$1ea91570c695dfb2(startTime) {
    return $5831ddb3a0caf7c7$export$ba2b1ec760f018ed() - startTime;
}
var $5831ddb3a0caf7c7$var$MATCH_ANY = "(.*)";
var $5831ddb3a0caf7c7$var$MATCH_SINGLE = "(.)";
function $5831ddb3a0caf7c7$var$_createRegExp(value, escapeRgx, replaceFn, ignoreCase, fullMatch) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    return new RegExp((fullMatch ? "^" : $5831ddb3a0caf7c7$var$EMPTY) + replaceFn(value.replace(escapeRgx, "\\$1")) + (fullMatch ? "$" : $5831ddb3a0caf7c7$var$EMPTY), ignoreCase ? "i" : "");
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$81333aadf7b6e1f7(value, ignoreCase, fullMatch) {
    return $5831ddb3a0caf7c7$var$_createRegExp($5831ddb3a0caf7c7$export$590567be997858b6(value), /([-+|^$#\.\?{}()\[\]\\\/\"\'])/g, function(value) {
        return value.replace(/\*/g, $5831ddb3a0caf7c7$var$MATCH_ANY);
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$d5a6cf2d39a760ca(value, ignoreCase, fullMatch) {
    return $5831ddb3a0caf7c7$var$_createRegExp($5831ddb3a0caf7c7$export$590567be997858b6(value), /([-+|^$#\.{}()\\\/\[\]\"\'])/g, function(value) {
        return value.replace(/(\\\\|\\\/|\*|\?)/g, function(_all, g1) {
            if (g1 == "\\/" || g1 == "\\\\") return "[\\\\\\/]{1}";
            return g1 == "*" ? $5831ddb3a0caf7c7$var$MATCH_ANY : $5831ddb3a0caf7c7$var$MATCH_SINGLE;
        });
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$3dedd7e7feca328f(value, ignoreCase, fullMatch) {
    return $5831ddb3a0caf7c7$var$_createRegExp($5831ddb3a0caf7c7$export$590567be997858b6(value), /([-+|^$#\.{}()\\\/\[\]\"\'])/g, function(value) {
        return value.replace(/(\*\*\\[\\\/]|\\\\|\\\/|\*\*|\*|\?)/g, function(_all, g1) {
            if (g1 == "**\\/" || g1 == "**\\\\") return "(.*[\\\\\\/])*";
            if (g1 === "\\/" || g1 == "\\\\") return "[\\\\\\/]{1}";
            if (g1 === "**") return $5831ddb3a0caf7c7$var$MATCH_ANY;
            return g1 === "*" ? "([^\\\\\\/]*)" : "([^\\\\\\/]{1})";
        });
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$c6675fd9042172d2(cb, defValue, argArray) {
    return $5831ddb3a0caf7c7$export$db98eae15987454c(function() {
        var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$37fac4fdc951562(cb, defValue, argArray) {
    return $5831ddb3a0caf7c7$export$5405f984434b2087(function() {
        var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$4a5a20adf283cce8(cb, defValue, argArray) {
    return $5831ddb3a0caf7c7$export$c267b25be8105889(function() {
        var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$31bbba9103996d33(cb, defValue, argArray) {
    return $5831ddb3a0caf7c7$export$ec3ff6a41704225(function() {
        var result = $5831ddb3a0caf7c7$export$170b8c323eee7bec(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_checkLength(value, props) {
    var result;
    $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(props, function(prop) {
        if (prop in value) {
            var propValue = value[prop];
            result = ($5831ddb3a0caf7c7$export$f6e2535fb5126e54(propValue) ? propValue() : propValue) > 0;
            return -1;
        }
    });
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_hasValue(value, depth) {
    var result = value === false || value === 0;
    if (!result && !$5831ddb3a0caf7c7$export$bedb7023a7733221(value)) {
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(value)) result = value[$5831ddb3a0caf7c7$var$LENGTH] > 0;
        else if ($5831ddb3a0caf7c7$export$871608497c498473(value)) result = !isNaN(value.getTime());
        else if ($5831ddb3a0caf7c7$export$f9ce7b637dfbe238(value)) return true;
        else if ($5831ddb3a0caf7c7$export$a6cdc56e425d0d0a(value)) {
            try {
                var chkValue = $5831ddb3a0caf7c7$var$_checkLength(value, [
                    $5831ddb3a0caf7c7$var$LENGTH,
                    "byteLength",
                    "size",
                    "count"
                ]);
                if ($5831ddb3a0caf7c7$export$f9ce7b637dfbe238(chkValue)) return chkValue;
                if ($5831ddb3a0caf7c7$export$f6e2535fb5126e54(value.valueOf) && depth < 5) return $5831ddb3a0caf7c7$var$_hasValue(value.valueOf(), ++depth);
            } catch (e) {}
            return !!$5831ddb3a0caf7c7$export$f7628dc18f4211e5(value)[$5831ddb3a0caf7c7$var$LENGTH];
        } else result = $5831ddb3a0caf7c7$export$8f9cae6546f97a9f(value);
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$96bdbc84526f3739(value) {
    return $5831ddb3a0caf7c7$var$_hasValue(value, 0);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$f9c2f07d6e2a6221(ctx) {
    return $5831ddb3a0caf7c7$export$a110d95e992bd193({}, ctx);
}
function $5831ddb3a0caf7c7$export$a110d95e992bd193(target, ctx) {
    var itSymbol = $5831ddb3a0caf7c7$export$3a9aefdadea26115(3);
    function _createIterator() {
        return $5831ddb3a0caf7c7$export$7342c78d7e13e778(ctx);
    }
    target[itSymbol] = _createIterator;
    return target;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$7342c78d7e13e778(ctx) {
    var isDone = false;
    function _value() {
        return ctx.v;
    }
    function _next() {
        if (!isDone) isDone = ctx.n ? ctx.n(arguments) : true;
        var result = {
            done: isDone
        };
        if (!isDone) $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(result, "value", {
            g: _value
        });
        return result;
    }
    function _return(value) {
        isDone = true;
        return {
            done: true,
            value: ctx.r && ctx.r(value)
        };
    }
    function _throw(e) {
        isDone = true;
        return {
            done: true,
            value: ctx.t && ctx.t(e)
        };
    }
    var theIterator = {
        next: _next
    };
    if (ctx.r) theIterator.return = _return;
    if (ctx.t) theIterator.throw = _throw;
    return theIterator;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$347cf8d764bc2c7d(values) {
    var idx = -1;
    var theValues = values ? values.slice() : [];
    var len = theValues[$5831ddb3a0caf7c7$var$LENGTH];
    function _value() {
        if (idx >= 0 && idx < len) return theValues[idx];
    }
    function _getNext() {
        idx++;
        return idx >= len;
    }
    var ctx = {
        n: _getNext
    };
    $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2(ctx, "v", {
        g: _value
    });
    return $5831ddb3a0caf7c7$export$7342c78d7e13e778(ctx);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$9164d977cc95ce6f(start, end, step) {
    var nextValue = start;
    var theValue = $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    if ($5831ddb3a0caf7c7$export$bedb7023a7733221(end)) end = start;
    var theStep = step;
    if (!theStep) theStep = start <= end ? 1 : -1;
    function _value() {
        return theValue;
    }
    function _getNext() {
        var isDone = theStep > 0 ? nextValue > end : nextValue < end;
        if (!isDone) {
            theValue = nextValue;
            nextValue += theStep;
        }
        return isDone;
    }
    return $5831ddb3a0caf7c7$export$7342c78d7e13e778($5831ddb3a0caf7c7$export$d0d2ebf910ad6e2({
        n: _getNext
    }, "v", {
        g: _value
    }));
}
var $5831ddb3a0caf7c7$export$5860c226b237d9a6 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "abs");
var $5831ddb3a0caf7c7$export$85eb35976b2c6830 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "exp");
var $5831ddb3a0caf7c7$export$f0e980411e05f912 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "log");
var $5831ddb3a0caf7c7$export$c1ce5fcc4898f0f1 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "asin");
var $5831ddb3a0caf7c7$export$a54ffc8c0d889817 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "acos");
var $5831ddb3a0caf7c7$export$7b8ff40f4d648149 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "atan");
var $5831ddb3a0caf7c7$export$5effd1f4b4dc5f3a = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "atan2");
var $5831ddb3a0caf7c7$export$858b42c97efc7084 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "pow");
var $5831ddb3a0caf7c7$export$29dff617fb34ca08 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "sqrt");
var $5831ddb3a0caf7c7$export$42cacde8c45786ff = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "round");
var $5831ddb3a0caf7c7$export$3cd07ab3f9f615eb = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "sin");
var $5831ddb3a0caf7c7$export$3ec76e03312ceac9 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "cos");
var $5831ddb3a0caf7c7$export$f77a35dc60c0c41e = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$MathCls, "tan");
var $5831ddb3a0caf7c7$var$_recursionCheckOwnDescriptors;
var $5831ddb3a0caf7c7$var$_recursionCheckOwnSymbols;
var $5831ddb3a0caf7c7$var$_objGetOwnPropertyNames = /* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_NAMES), $5831ddb3a0caf7c7$var$_returnEmptyArray);
var $5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor = /* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_DESCRIPTOR), $5831ddb3a0caf7c7$var$_returnNothing);
function $5831ddb3a0caf7c7$var$polyObjGetOwnPropertyDescriptors(obj) {
    var result = {};
    $5831ddb3a0caf7c7$var$_throwIfNullOrUndefined(obj);
    if (!$5831ddb3a0caf7c7$var$_recursionCheckOwnDescriptors) try {
        $5831ddb3a0caf7c7$var$_recursionCheckOwnDescriptors = true;
        $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586($5831ddb3a0caf7c7$var$_objGetOwnPropertyNames(obj), function(propName) {
            var descriptor = $5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor(obj, propName);
            if (descriptor !== undefined) result[propName] = descriptor;
        });
        $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586($5831ddb3a0caf7c7$var$_polyObjGetOwnPropertySymbols(obj), function(sym) {
            var descriptor = $5831ddb3a0caf7c7$var$_objGetOwnPropertyDescriptor(obj, sym);
            if (descriptor !== undefined) result[sym] = descriptor;
        });
    } finally{
        $5831ddb3a0caf7c7$var$_recursionCheckOwnDescriptors = false;
    }
    return result;
}
function $5831ddb3a0caf7c7$var$_polyObjGetOwnPropertySymbols(obj) {
    var result = [];
    var objHasOwn = $5831ddb3a0caf7c7$var$ObjClass.hasOwn || $5831ddb3a0caf7c7$export$9a4df78208de965f;
    if (!$5831ddb3a0caf7c7$var$_recursionCheckOwnSymbols) try {
        $5831ddb3a0caf7c7$var$_recursionCheckOwnSymbols = true;
        var symEnum = 0;
        while(symEnum <= 12){
            var sym = $5831ddb3a0caf7c7$export$3a9aefdadea26115(symEnum);
            if (sym && objHasOwn(obj, sym)) result.push(sym);
            symEnum++;
        }
    } finally{
        $5831ddb3a0caf7c7$var$_recursionCheckOwnSymbols = false;
    }
    return result;
}
var $5831ddb3a0caf7c7$export$1bd5e8b059facbe9 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_DESCRIPTOR), $5831ddb3a0caf7c7$var$_returnNothing);
var $5831ddb3a0caf7c7$export$cd9360ab33f809ef = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "getOwnPropertyDescriptors"), $5831ddb3a0caf7c7$var$polyObjGetOwnPropertyDescriptors);
var $5831ddb3a0caf7c7$export$81bfb4674422159a = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_NAMES), $5831ddb3a0caf7c7$var$_returnEmptyArray);
var $5831ddb3a0caf7c7$export$fe6197bba23c29d3 = /* #__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/* #__PURE__ */ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, $5831ddb3a0caf7c7$var$GET_OWN_PROPERTY_SYMBOLS), $5831ddb3a0caf7c7$var$_returnEmptyArray);
function $5831ddb3a0caf7c7$var$polyObjFromEntries(entries) {
    var result = {};
    function addEntry(entry) {
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(entry) && entry.length >= 2) result[entry[0]] = entry[1];
    }
    if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(entries)) $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586(entries, addEntry);
    else if ($5831ddb3a0caf7c7$export$9652023d9040757(entries)) $5831ddb3a0caf7c7$export$1180a64ad833b902(entries, addEntry);
    return result;
}
var $5831ddb3a0caf7c7$export$d5e31f3115a37a11 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "fromEntries"), $5831ddb3a0caf7c7$var$polyObjFromEntries);
var $5831ddb3a0caf7c7$export$3cfcc62fbeb3f812 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "preventExtensions"), $5831ddb3a0caf7c7$var$_doNothing);
var $5831ddb3a0caf7c7$export$571c0a3d5a001c0a = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign(/*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureRef($5831ddb3a0caf7c7$var$ObjClass, "isExtensible"), $5831ddb3a0caf7c7$var$_returnFalse);
var $5831ddb3a0caf7c7$export$5222b9460f3ddbec = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("endsWith", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrEndsWith);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrEndsWith(value, searchString, length) {
    $5831ddb3a0caf7c7$var$_throwIfNotString(value);
    var searchValue = $5831ddb3a0caf7c7$export$844ec244b1367d54(searchString) ? searchString : $5831ddb3a0caf7c7$export$590567be997858b6(searchString);
    var end = !$5831ddb3a0caf7c7$export$fce6876652108ab(length) && length < value[$5831ddb3a0caf7c7$var$LENGTH] ? length : value[$5831ddb3a0caf7c7$var$LENGTH];
    return $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(value, end - searchValue[$5831ddb3a0caf7c7$var$LENGTH], end) === searchValue;
}
var $5831ddb3a0caf7c7$export$7c0888b0c4641088 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("indexOf", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$107c6a87f2040ede = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunction("lastIndexOf", $5831ddb3a0caf7c7$var$StrProto);
var $5831ddb3a0caf7c7$export$58605e31a7a30d86 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("includes", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$export$524f0a69f7e45237);
var $5831ddb3a0caf7c7$export$3185d777c612e61f = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_pureAssign($5831ddb3a0caf7c7$export$58605e31a7a30d86);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$524f0a69f7e45237(value, searchString, position) {
    if ($5831ddb3a0caf7c7$export$49841c62b9eff15(searchString)) $5831ddb3a0caf7c7$export$3f7738bd7dcba681("'searchString' must not be a regular expression" + $5831ddb3a0caf7c7$export$21fce7cbd4dc679f(searchString));
    return $5831ddb3a0caf7c7$export$7c0888b0c4641088(value, $5831ddb3a0caf7c7$export$590567be997858b6(searchString), position) !== -1;
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$e042a3f6c540f833(value) {
    if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value)) return value.replace(/[\s\t\r\n\f]+/g, $5831ddb3a0caf7c7$var$EMPTY) === $5831ddb3a0caf7c7$var$EMPTY;
    return $5831ddb3a0caf7c7$export$bedb7023a7733221(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$a610cc6364f8352(value) {
    if ($5831ddb3a0caf7c7$export$844ec244b1367d54(value)) return value === $5831ddb3a0caf7c7$var$EMPTY;
    return $5831ddb3a0caf7c7$export$bedb7023a7733221(value);
}
var $5831ddb3a0caf7c7$export$da061769d961e150 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_unwrapFunctionWithPoly("startsWith", $5831ddb3a0caf7c7$var$StrProto, $5831ddb3a0caf7c7$var$polyStrStartsWith);
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$polyStrStartsWith(value, searchString, position) {
    $5831ddb3a0caf7c7$var$_throwIfNotString(value);
    var searchValue = $5831ddb3a0caf7c7$export$844ec244b1367d54(searchString) ? searchString : $5831ddb3a0caf7c7$export$590567be997858b6(searchString);
    var pos = position > 0 ? position : 0;
    return $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87(value, pos, pos + searchValue[$5831ddb3a0caf7c7$var$LENGTH]) === searchValue;
}
var $5831ddb3a0caf7c7$var$REF = "ref";
var $5831ddb3a0caf7c7$var$UNREF = "unref";
var $5831ddb3a0caf7c7$var$HAS_REF = "hasRef";
var $5831ddb3a0caf7c7$var$ENABLED = "enabled";
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$var$_createTimerHandler(startTimer, refreshFn, cancelFn) {
    var ref = true;
    var timerId = startTimer ? refreshFn($5831ddb3a0caf7c7$var$NULL_VALUE) : $5831ddb3a0caf7c7$var$NULL_VALUE;
    var theTimerHandler;
    function _unref() {
        ref = false;
        timerId && timerId[$5831ddb3a0caf7c7$var$UNREF] && timerId[$5831ddb3a0caf7c7$var$UNREF]();
        return theTimerHandler;
    }
    function _cancel() {
        timerId && cancelFn(timerId);
        timerId = $5831ddb3a0caf7c7$var$NULL_VALUE;
    }
    function _refresh() {
        timerId = refreshFn(timerId);
        if (!ref) _unref();
        return theTimerHandler;
    }
    function _setEnabled(value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    }
    theTimerHandler = {
        cancel: _cancel,
        refresh: _refresh
    };
    theTimerHandler[$5831ddb3a0caf7c7$var$HAS_REF] = function() {
        if (timerId && timerId[$5831ddb3a0caf7c7$var$HAS_REF]) return timerId[$5831ddb3a0caf7c7$var$HAS_REF]();
        return ref;
    };
    theTimerHandler[$5831ddb3a0caf7c7$var$REF] = function() {
        ref = true;
        timerId && timerId[$5831ddb3a0caf7c7$var$REF] && timerId[$5831ddb3a0caf7c7$var$REF]();
        return theTimerHandler;
    };
    theTimerHandler[$5831ddb3a0caf7c7$var$UNREF] = _unref;
    theTimerHandler = $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81(theTimerHandler, $5831ddb3a0caf7c7$var$ENABLED, {
        get: function() {
            return !!timerId;
        },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function() {
            timerId = $5831ddb3a0caf7c7$var$NULL_VALUE;
        }
    };
}
var $5831ddb3a0caf7c7$var$_setTimeoutFn;
var $5831ddb3a0caf7c7$var$_clearTimeoutFn;
function $5831ddb3a0caf7c7$var$_resolveTimeoutFn(timeoutFn) {
    var result = $5831ddb3a0caf7c7$export$f6e2535fb5126e54(timeoutFn) ? timeoutFn : $5831ddb3a0caf7c7$var$_setTimeoutFn;
    if (!result) {
        var globalOverrides = $5831ddb3a0caf7c7$var$_getGlobalConfig().tmOut || [];
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(globalOverrides) && globalOverrides.length > 0 && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(globalOverrides[0])) result = globalOverrides[0];
    }
    return result || setTimeout;
}
function $5831ddb3a0caf7c7$var$_resolveClearTimeoutFn(timeoutFn) {
    var result = $5831ddb3a0caf7c7$export$f6e2535fb5126e54(timeoutFn) ? timeoutFn : $5831ddb3a0caf7c7$var$_clearTimeoutFn;
    if (!result) {
        var globalOverrides = $5831ddb3a0caf7c7$var$_getGlobalConfig().tmOut || [];
        if ($5831ddb3a0caf7c7$export$43bee75e5e14138e(globalOverrides) && globalOverrides.length > 1 && $5831ddb3a0caf7c7$export$f6e2535fb5126e54(globalOverrides[1])) result = globalOverrides[1];
    }
    return result || clearTimeout;
}
function $5831ddb3a0caf7c7$var$_createTimeoutWith(startTimer, overrideFn, theArgs) {
    var isArr = $5831ddb3a0caf7c7$export$43bee75e5e14138e(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = $5831ddb3a0caf7c7$var$_resolveTimeoutFn(len > 0 ? overrideFn[0] : !isArr ? overrideFn : $5831ddb3a0caf7c7$var$UNDEF_VALUE);
    var clearFn = $5831ddb3a0caf7c7$var$_resolveClearTimeoutFn(len > 1 ? overrideFn[1] : $5831ddb3a0caf7c7$var$UNDEF_VALUE);
    var timerFn = theArgs[0];
    theArgs[0] = function() {
        handler.dn();
        $5831ddb3a0caf7c7$export$2801572b9d3736b5(timerFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
    };
    var handler = $5831ddb3a0caf7c7$var$_createTimerHandler(startTimer, function(timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            $5831ddb3a0caf7c7$export$2801572b9d3736b5(clearFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, [
                timerId
            ]);
        }
        return $5831ddb3a0caf7c7$export$2801572b9d3736b5(setFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, theArgs);
    }, function(timerId) {
        $5831ddb3a0caf7c7$export$2801572b9d3736b5(clearFn, $5831ddb3a0caf7c7$var$UNDEF_VALUE, [
            timerId
        ]);
    });
    return handler.h;
}
function $5831ddb3a0caf7c7$export$f1d0ab8fca46da06(overrideFn) {
    var isArr = $5831ddb3a0caf7c7$export$43bee75e5e14138e(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    $5831ddb3a0caf7c7$var$_setTimeoutFn = len > 0 ? overrideFn[0] : !isArr ? overrideFn : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
    $5831ddb3a0caf7c7$var$_clearTimeoutFn = len > 1 ? overrideFn[1] : $5831ddb3a0caf7c7$var$UNDEF_VALUE;
}
function $5831ddb3a0caf7c7$export$3fe0ed76a4a6f1fc(overrideFn) {
    var isArr = $5831ddb3a0caf7c7$export$43bee75e5e14138e(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var globalCfg = $5831ddb3a0caf7c7$var$_getGlobalConfig();
    if (!overrideFn) globalCfg.tmOut = undefined;
    else globalCfg.tmOut = [
        len > 0 ? overrideFn[0] : !isArr ? overrideFn : null,
        len > 1 ? overrideFn[1] : null
    ];
}
function $5831ddb3a0caf7c7$export$5f4d6617421d489b(callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(true, $5831ddb3a0caf7c7$var$UNDEF_VALUE, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
function $5831ddb3a0caf7c7$export$9e7e48cc39f2a8d3(overrideFn, callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(true, overrideFn, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
function $5831ddb3a0caf7c7$export$6eae7cf7a129a986(callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(false, $5831ddb3a0caf7c7$var$UNDEF_VALUE, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments));
}
function $5831ddb3a0caf7c7$export$320dbce2ee83dc77(overrideFn, callback, timeout) {
    return $5831ddb3a0caf7c7$var$_createTimeoutWith(false, overrideFn, $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments, 1));
}
var $5831ddb3a0caf7c7$var$_defaultIdleTimeout = 100;
var $5831ddb3a0caf7c7$var$_maxExecutionTime = 50;
/*#__NO_SIDE_EFFECTS__*/ function $5831ddb3a0caf7c7$export$b9301f2c5b7c2533() {
    return !!/*#__PURE__*/ $5831ddb3a0caf7c7$export$6cb38458be4b5644();
}
var $5831ddb3a0caf7c7$export$6cb38458be4b5644 = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "requestIdleCallback"
]);
var $5831ddb3a0caf7c7$export$2a4da33a3741682a = /*#__PURE__*/ $5831ddb3a0caf7c7$var$_getGlobalInstFn($5831ddb3a0caf7c7$export$3df6e51375017edd, [
    "cancelIdleCallback"
]);
function $5831ddb3a0caf7c7$export$b588248e012cdf5c(timeout) {
    $5831ddb3a0caf7c7$var$_defaultIdleTimeout = timeout;
}
function $5831ddb3a0caf7c7$export$b062c6607588fb47(maxTime) {
    $5831ddb3a0caf7c7$var$_maxExecutionTime = maxTime;
}
function $5831ddb3a0caf7c7$export$553e359f3bef3995(callback, options) {
    function _createDeadline(timedOut) {
        var startTime = $5831ddb3a0caf7c7$export$ba2b1ec760f018ed();
        return {
            didTimeout: timedOut,
            timeRemaining: function() {
                return $5831ddb3a0caf7c7$var$_maxExecutionTime - $5831ddb3a0caf7c7$export$1ea91570c695dfb2(startTime);
            }
        };
    }
    if ($5831ddb3a0caf7c7$export$b9301f2c5b7c2533()) {
        var handler_1 = $5831ddb3a0caf7c7$var$_createTimerHandler(true, function(idleId) {
            idleId && $5831ddb3a0caf7c7$export$2a4da33a3741682a()(idleId);
            return $5831ddb3a0caf7c7$export$6cb38458be4b5644()(function(deadline) {
                handler_1.dn();
                callback(deadline || _createDeadline(false));
            }, options);
        }, function(idleId) {
            $5831ddb3a0caf7c7$export$2a4da33a3741682a()(idleId);
        });
        return handler_1.h;
    }
    var timeout = (options || {}).timeout;
    if ($5831ddb3a0caf7c7$export$fce6876652108ab(timeout)) timeout = $5831ddb3a0caf7c7$var$_defaultIdleTimeout;
    return $5831ddb3a0caf7c7$export$5f4d6617421d489b(function() {
        callback(_createDeadline(true));
    }, timeout);
}
function $5831ddb3a0caf7c7$export$b093775e872b0dcd(callback, timeout) {
    var theArguments = $5831ddb3a0caf7c7$var$ArrSlice[$5831ddb3a0caf7c7$var$CALL](arguments);
    var handler = $5831ddb3a0caf7c7$var$_createTimerHandler(true, function(intervalId) {
        intervalId && clearInterval(intervalId);
        return $5831ddb3a0caf7c7$export$2801572b9d3736b5(setInterval, $5831ddb3a0caf7c7$var$UNDEF_VALUE, theArguments);
    }, function(intervalId) {
        $5831ddb3a0caf7c7$export$2801572b9d3736b5(clearInterval, $5831ddb3a0caf7c7$var$UNDEF_VALUE, [
            intervalId
        ]);
    });
    return handler.h;
}


var $1e9ef78f0556a404$var$_a;
var $1e9ef78f0556a404$var$UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */ var $1e9ef78f0556a404$var$DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */ var $1e9ef78f0556a404$var$DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */ var $1e9ef78f0556a404$var$DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */ var $1e9ef78f0556a404$var$DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */ var $1e9ef78f0556a404$var$DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */ var $1e9ef78f0556a404$var$DynAllowInstChkTag = $1e9ef78f0556a404$var$DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */ var $1e9ef78f0556a404$var$DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */ var $1e9ef78f0556a404$var$UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */ var $1e9ef78f0556a404$var$DynProtoBaseProto = "_dyn" + $1e9ef78f0556a404$var$str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */ var $1e9ef78f0556a404$var$DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */ var $1e9ef78f0556a404$var$DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $1e9ef78f0556a404$var$strSetInstFuncs = 'setInstFuncs';
var $1e9ef78f0556a404$var$Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $1e9ef78f0556a404$var$_objGetPrototypeOf = $1e9ef78f0556a404$var$Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */ var $1e9ef78f0556a404$var$_objGetOwnProps = $1e9ef78f0556a404$var$Obj["getOwnPropertyNames"];
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var $1e9ef78f0556a404$var$_gbl = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
var $1e9ef78f0556a404$var$_gblInst = $1e9ef78f0556a404$var$_gbl[$1e9ef78f0556a404$var$DynProtoGlobalSettings] || ($1e9ef78f0556a404$var$_gbl[$1e9ef78f0556a404$var$DynProtoGlobalSettings] = {
    o: ($1e9ef78f0556a404$var$_a = {}, $1e9ef78f0556a404$var$_a[$1e9ef78f0556a404$var$strSetInstFuncs] = true, $1e9ef78f0556a404$var$_a[$1e9ef78f0556a404$var$strUseBaseInst] = true, $1e9ef78f0556a404$var$_a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */ function $1e9ef78f0556a404$var$_isObjectOrArrayPrototype(target) {
    return target && (target === $1e9ef78f0556a404$var$Obj[$1e9ef78f0556a404$var$Prototype] || target === Array[$1e9ef78f0556a404$var$Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */ function $1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(target) {
    return $1e9ef78f0556a404$var$_isObjectOrArrayPrototype(target) || target === Function[$1e9ef78f0556a404$var$Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */ function $1e9ef78f0556a404$var$_getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if ($1e9ef78f0556a404$var$_objGetPrototypeOf) return $1e9ef78f0556a404$var$_objGetPrototypeOf(target);
        var curProto = target[$1e9ef78f0556a404$var$str__Proto] || target[$1e9ef78f0556a404$var$Prototype] || (target[$1e9ef78f0556a404$var$Constructor] ? target[$1e9ef78f0556a404$var$Constructor][$1e9ef78f0556a404$var$Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[$1e9ef78f0556a404$var$DynProtoBaseProto] || curProto;
        if (!(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, $1e9ef78f0556a404$var$DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[$1e9ef78f0556a404$var$DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[$1e9ef78f0556a404$var$DynProtoBaseProto] = target[$1e9ef78f0556a404$var$DynProtoCurrent] || target[$1e9ef78f0556a404$var$DynProtoBaseProto];
            target[$1e9ef78f0556a404$var$DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */ function $1e9ef78f0556a404$var$_forEachProp(target, func) {
    var props = [];
    if ($1e9ef78f0556a404$var$_objGetOwnProps) props = $1e9ef78f0556a404$var$_objGetOwnProps(target);
    else {
        for(var name_1 in target)if (typeof name_1 === "string" && (0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, name_1)) props.push(name_1);
    }
    if (props && props.length > 0) for(var lp = 0; lp < props.length; lp++)func(props[lp]);
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */ function $1e9ef78f0556a404$var$_isDynamicCandidate(target, funcName, skipOwn) {
    return funcName !== $1e9ef78f0556a404$var$Constructor && typeof target[funcName] === $1e9ef78f0556a404$var$strFunction && (skipOwn || (0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, funcName)) && funcName !== $1e9ef78f0556a404$var$str__Proto && funcName !== $1e9ef78f0556a404$var$Prototype;
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */ function $1e9ef78f0556a404$var$_throwTypeError(message) {
    (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */ function $1e9ef78f0556a404$var$_getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
    // Save any existing instance functions
    $1e9ef78f0556a404$var$_forEachProp(thisTarget, function(name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && $1e9ef78f0556a404$var$_isDynamicCandidate(thisTarget, name, false)) // Create an instance callback for passing the base function to the caller
        instFuncs[name] = thisTarget[name];
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */ function $1e9ef78f0556a404$var$_hasVisited(values, value) {
    for(var lp = values.length - 1; lp >= 0; lp--){
        if (values[lp] === value) return true;
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */ function $1e9ef78f0556a404$var$_getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[$1e9ef78f0556a404$var$DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[$1e9ef78f0556a404$var$DynInstFuncTable] || {};
            if (instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[$1e9ef78f0556a404$var$DynClassName]] || {})[funcName] || theFunc;
        }
        return function() {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
    $1e9ef78f0556a404$var$_forEachProp(instFuncs, function(name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = $1e9ef78f0556a404$var$_getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while(baseProto && !$1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(baseProto) && !$1e9ef78f0556a404$var$_hasVisited(visited, baseProto)){
        // look for prototype functions
        $1e9ef78f0556a404$var$_forEachProp(baseProto, function(name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && $1e9ef78f0556a404$var$_isDynamicCandidate(baseProto, name, !$1e9ef78f0556a404$var$_objGetPrototypeOf)) // Create an instance callback for passing the base function to the caller
            baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = $1e9ef78f0556a404$var$_getObjProto(baseProto);
    }
    return baseFuncs;
}
function $1e9ef78f0556a404$var$_getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && (0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(proto, $1e9ef78f0556a404$var$DynClassName)) {
        var instFuncTable = target[$1e9ef78f0556a404$var$DynInstFuncTable] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
        instFunc = (instFuncTable[proto[$1e9ef78f0556a404$var$DynClassName]] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null))[funcName];
        if (!instFunc) // Avoid stack overflow from recursive calling the same function
        $1e9ef78f0556a404$var$_throwTypeError("Missing [" + funcName + "] " + $1e9ef78f0556a404$var$strFunction);
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[$1e9ef78f0556a404$var$DynInstChkTag] && instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, funcName);
            // Get current prototype
            var objProto = $1e9ef78f0556a404$var$_getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while(canAddInst && objProto && !$1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(objProto) && !$1e9ef78f0556a404$var$_hasVisited(visited, objProto)){
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = protoFunc === currentDynProtoProxy;
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = $1e9ef78f0556a404$var$_getObjProto(objProto);
            }
            try {
                if (canAddInst) // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                // so it's safe to directly assign for any subsequent calls (for better performance)
                target[funcName] = instFunc;
                // Block further attempts to set the instance function for any
                instFunc[$1e9ef78f0556a404$var$DynInstChkTag] = 1;
            } catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function $1e9ef78f0556a404$var$_getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) // It is so lookup the base prototype
    protoFunc = $1e9ef78f0556a404$var$_getObjProto(proto)[funcName];
    if (typeof protoFunc !== $1e9ef78f0556a404$var$strFunction) $1e9ef78f0556a404$var$_throwTypeError("[" + funcName + "] is not a " + $1e9ef78f0556a404$var$strFunction);
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */ function $1e9ef78f0556a404$var$_populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function() {
            // Use the instance or prototype function
            var instFunc = $1e9ef78f0556a404$var$_getInstFunc(this, funcName, proto, dynProtoProxy) || $1e9ef78f0556a404$var$_getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[$1e9ef78f0556a404$var$DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!$1e9ef78f0556a404$var$_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[$1e9ef78f0556a404$var$DynInstFuncTable] = target[$1e9ef78f0556a404$var$DynInstFuncTable] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null);
        if (!$1e9ef78f0556a404$var$_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(null); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] !== false) instFuncTable[$1e9ef78f0556a404$var$DynAllowInstChkTag] = !!setInstanceFunc;
            if (!$1e9ef78f0556a404$var$_isObjectOrArrayPrototype(instFuncs_1)) $1e9ef78f0556a404$var$_forEachProp(target, function(name) {
                // Only add overridden functions
                if ($1e9ef78f0556a404$var$_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                    // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                    instFuncs_1[name] = target[name];
                    delete target[name];
                    // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                    if (!(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(proto, name) || proto[name] && !proto[name][$1e9ef78f0556a404$var$DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
                }
            });
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */ function $1e9ef78f0556a404$var$_checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if ($1e9ef78f0556a404$var$_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = $1e9ef78f0556a404$var$_getObjProto(thisTarget);
        while(thisProto && !$1e9ef78f0556a404$var$_isObjectArrayOrFunctionPrototype(thisProto) && !$1e9ef78f0556a404$var$_hasVisited(visited, thisProto)){
            if (thisProto === classProto) return true;
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = $1e9ef78f0556a404$var$_getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */ function $1e9ef78f0556a404$var$_getObjName(target, unknownValue) {
    if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, $1e9ef78f0556a404$var$Prototype)) // Look like a prototype
    return target.name || unknownValue || $1e9ef78f0556a404$var$UnknownValue;
    return ((target || {})[$1e9ef78f0556a404$var$Constructor] || {}).name || unknownValue || $1e9ef78f0556a404$var$UnknownValue;
}
function $1e9ef78f0556a404$export$2e2bcd8739ae039(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(theClass, $1e9ef78f0556a404$var$Prototype)) $1e9ef78f0556a404$var$_throwTypeError("theClass is an invalid class definition.");
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[$1e9ef78f0556a404$var$Prototype];
    if (!$1e9ef78f0556a404$var$_checkPrototype(classProto, target)) $1e9ef78f0556a404$var$_throwTypeError("[" + $1e9ef78f0556a404$var$_getObjName(theClass) + "] not in hierarchy of [" + $1e9ef78f0556a404$var$_getObjName(target) + "]");
    var className = null;
    if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(classProto, $1e9ef78f0556a404$var$DynClassName)) // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
    className = classProto[$1e9ef78f0556a404$var$DynClassName];
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = $1e9ef78f0556a404$var$DynClassNamePrefix + $1e9ef78f0556a404$var$_getObjName(theClass, "_") + "$" + $1e9ef78f0556a404$var$_gblInst.n;
        $1e9ef78f0556a404$var$_gblInst.n++;
        classProto[$1e9ef78f0556a404$var$DynClassName] = className;
    }
    var perfOptions = $1e9ef78f0556a404$export$2e2bcd8739ae039[$1e9ef78f0556a404$var$DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[$1e9ef78f0556a404$var$strUseBaseInst];
    if (useBaseInst && options && options[$1e9ef78f0556a404$var$strUseBaseInst] !== undefined) useBaseInst = !!options[$1e9ef78f0556a404$var$strUseBaseInst];
    // Get the current instance functions
    var instFuncs = $1e9ef78f0556a404$var$_getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = $1e9ef78f0556a404$var$_getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!$1e9ef78f0556a404$var$_objGetPrototypeOf && !!perfOptions[$1e9ef78f0556a404$var$strSetInstFuncs];
    if (setInstanceFunc && options) setInstanceFunc = !!options[$1e9ef78f0556a404$var$strSetInstFuncs];
    // Populate the Prototype for any overridden instance functions
    $1e9ef78f0556a404$var$_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */ $1e9ef78f0556a404$export$2e2bcd8739ae039[$1e9ef78f0556a404$var$DynProtoDefaultOptions] = $1e9ef78f0556a404$var$_gblInst.o;


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $042f611b66f4fd6f$export$327014e6dfd5ba11 = "function";
var $042f611b66f4fd6f$export$127e9c2439c2ee16 = "object";
var $042f611b66f4fd6f$export$9b7d2d86cf58b987 = "undefined";
var $042f611b66f4fd6f$export$ecddaaeb55ecf049 = "prototype";
var $042f611b66f4fd6f$export$b39d4edf23d6f14c = "default";
var $042f611b66f4fd6f$export$9ec954dd81c90a5d = Object;
var $042f611b66f4fd6f$export$e77bb59b5e655b3d = $042f611b66f4fd6f$export$9ec954dd81c90a5d[$042f611b66f4fd6f$export$ecddaaeb55ecf049];


var $dc463ff9724142dd$export$3a8d60327f425095 = ((0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)() || {})["Symbol"];
var $dc463ff9724142dd$export$904e7a8ad467688a = ((0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)() || {})["Reflect"];
var $dc463ff9724142dd$export$9f6bdf37c7d86dfe = !!$dc463ff9724142dd$export$904e7a8ad467688a;
var $dc463ff9724142dd$var$strDecorate = "decorate";
var $dc463ff9724142dd$var$strMetadata = "metadata";
var $dc463ff9724142dd$var$strGetOwnPropertySymbols = "getOwnPropertySymbols";
var $dc463ff9724142dd$var$strIterator = "iterator";
var $dc463ff9724142dd$var$strHasOwnProperty = "hasOwnProperty";
var $dc463ff9724142dd$export$64ecba31e1fc6f1e = function(t) {
    // tslint:disable-next-line: ban-comma-operator
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if ((0, $042f611b66f4fd6f$export$e77bb59b5e655b3d)[$dc463ff9724142dd$var$strHasOwnProperty].call(s, p)) t[p] = s[p];
    }
    return t;
};
var $dc463ff9724142dd$export$b3cf7a802e578501 = (0, $5831ddb3a0caf7c7$export$afe328edc487dcfe) || $dc463ff9724142dd$export$64ecba31e1fc6f1e;
// tslint:disable-next-line: only-arrow-functions
var $dc463ff9724142dd$var$extendStaticsFn = function(d, b) {
    $dc463ff9724142dd$var$extendStaticsFn = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)["setPrototypeOf"] || // tslint:disable-next-line: only-arrow-functions
    ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || // tslint:disable-next-line: only-arrow-functions
    function(d, b) {
        for(var p in b)if (b[$dc463ff9724142dd$var$strHasOwnProperty](p)) d[p] = b[p];
    };
    return $dc463ff9724142dd$var$extendStaticsFn(d, b);
};
function $dc463ff9724142dd$export$1f9c32e3fbfb8e62(d, b) {
    if (typeof b !== (0, $042f611b66f4fd6f$export$327014e6dfd5ba11) && b !== null) (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Class extends value " + String(b) + " is not a constructor or null");
    $dc463ff9724142dd$var$extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049] = b === null ? (0, $5831ddb3a0caf7c7$export$c09f2411a4ae511b)(b) : (__[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049] = b[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049], new __());
}
function $dc463ff9724142dd$export$b0e1e04064f2edd0(s, e) {
    var t = {};
    for(var k in s)if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(s, k) && e.indexOf(k) < 0) t[k] = s[k];
    if (s != null && typeof (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)[$dc463ff9724142dd$var$strGetOwnPropertySymbols] === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) {
        for(var i = 0, p = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)[$dc463ff9724142dd$var$strGetOwnPropertySymbols](s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && (0, $042f611b66f4fd6f$export$e77bb59b5e655b3d)["propertyIsEnumerable"].call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $dc463ff9724142dd$export$1f334cb233663b35(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)["getOwnPropertyDescriptor"](target, key) : desc, d;
    if ($dc463ff9724142dd$export$9f6bdf37c7d86dfe && typeof $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strDecorate] === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) r = $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strDecorate](decorators, target, key, desc);
    else {
        for(var i = decorators.length - 1; i >= 0; i--)// eslint-disable-next-line no-cond-assign
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(target, key, r), r;
}
function $dc463ff9724142dd$export$a862c09c17c00454(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $dc463ff9724142dd$export$652131891efe9c32(metadataKey, metadataValue) {
    if ($dc463ff9724142dd$export$9f6bdf37c7d86dfe && $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strMetadata] === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) return $dc463ff9724142dd$export$904e7a8ad467688a[$dc463ff9724142dd$var$strMetadata](metadataKey, metadataValue);
}
function $dc463ff9724142dd$export$11150685fa6930db(m, o) {
    for(var p in m)if (p !== (0, $042f611b66f4fd6f$export$b39d4edf23d6f14c) && !(0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(o, p)) $dc463ff9724142dd$export$1ea27411cf67499d(o, m, p);
}
function $dc463ff9724142dd$export$1ea27411cf67499d(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    if (!!(0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)) (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
    else o[k2] = m[k];
}
function $dc463ff9724142dd$export$19cc45bf4f6ae179(o) {
    var s = typeof $dc463ff9724142dd$export$3a8d60327f425095 === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11) && $dc463ff9724142dd$export$3a8d60327f425095[$dc463ff9724142dd$var$strIterator], m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $dc463ff9724142dd$export$18637e2f1e451a15(o, n) {
    var m = typeof $dc463ff9724142dd$export$3a8d60327f425095 === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11) && o[$dc463ff9724142dd$export$3a8d60327f425095[$dc463ff9724142dd$var$strIterator]];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) // eslint-disable-next-line no-unsafe-finally
            throw e.error;
        }
    }
    return ar;
}
function $dc463ff9724142dd$export$e4572e1e87bd3458() {
    var theArgs = arguments;
    // Calculate new total size
    for(var s = 0, i = 0, il = theArgs.length; i < il; i++)s += theArgs[i].length;
    // Create new full array
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $dc463ff9724142dd$export$643fbb7023bc1942(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}
function $dc463ff9724142dd$export$b4774f2d9ed4def4(cooked, raw) {
    if (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81) (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $dc463ff9724142dd$export$8f42f3b1d1cb5f6d(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== (0, $042f611b66f4fd6f$export$b39d4edf23d6f14c) && Object.prototype.hasOwnProperty.call(mod, k)) $dc463ff9724142dd$export$1ea27411cf67499d(result, mod, k);
    }
    // Set default module
    if (!!(0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)) (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(result, (0, $042f611b66f4fd6f$export$b39d4edf23d6f14c), {
        enumerable: true,
        value: mod
    });
    else result[0, $042f611b66f4fd6f$export$b39d4edf23d6f14c] = mod;
    return result;
}
function $dc463ff9724142dd$export$b2781524d4888cea(mod) {
    return mod && mod.__esModule ? mod : {
        strDefault: mod
    };
}



/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Licensed under the
/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $45806013ed348c93$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 11
var $45806013ed348c93$export$6eae51590aaea43 = "length"; // Count: 64
var $45806013ed348c93$export$667d3cd09d258d38 = "warnToConsole"; // Count: 4
var $45806013ed348c93$export$6c078c21a0c6c1ce = "throwInternal"; // Count: 5
var $45806013ed348c93$export$fc59eec8d77f3766 = "watch"; // Count: 7
var $45806013ed348c93$export$2f85ca6962b15ff8 = "apply"; // Count: 7
var $45806013ed348c93$export$a0a330e7fa1e278c = "push"; // Count: 42
var $45806013ed348c93$export$84020a2e4fe863b0 = "splice"; // Count: 9
var $45806013ed348c93$export$e6a243fe757439f9 = "logger"; // Count: 20
var $45806013ed348c93$export$bd01c5e3f12db01c = "cancel"; // Count: 9
var $45806013ed348c93$export$65cd33bb52d04675 = "initialize"; // Count: 5
var $45806013ed348c93$export$f001befbf8417151 = "identifier"; // Count: 8
var $45806013ed348c93$export$fc3403fa6f2894ab = "removeNotificationListener"; // Count: 4
var $45806013ed348c93$export$5c8bcfab4f42ca62 = "addNotificationListener"; // Count: 4
var $45806013ed348c93$export$2e2716e9c35a66a8 = "isInitialized"; // Count: 11
var $45806013ed348c93$export$3a09068de032bb32 = "getNotifyMgr"; // Count: 5
var $45806013ed348c93$export$37717a508eca6e2d = "getPlugin"; // Count: 5
var $45806013ed348c93$export$9734b0a24bf02e93 = "name"; // Count: 9
var $45806013ed348c93$export$5c220169317cd6de = "processNext"; // Count: 15
var $45806013ed348c93$export$474081342bc4baf4 = "getProcessTelContext"; // Count: 2
var $45806013ed348c93$export$1805af0fa2230c20 = "value"; // Count: 7
var $45806013ed348c93$export$c9b1609f2b84393a = "enabled"; // Count: 6
var $45806013ed348c93$export$8d1c48dba7ad83a = "stopPollingInternalLogs"; // Count: 2
var $45806013ed348c93$export$7eb85b5cba77a43d = "unload"; // Count: 7
var $45806013ed348c93$export$8693bdba21bfca93 = "onComplete"; // Count: 4
var $45806013ed348c93$export$568c4302d11f2b22 = "version"; // Count: 4
var $45806013ed348c93$export$e53d8cae4d527530 = "loggingLevelConsole"; // Count: 2
var $45806013ed348c93$export$1e6514b499ba4d34 = "createNew"; // Count: 7
var $45806013ed348c93$export$7176fb2a7d11927e = "teardown"; // Count: 9
var $45806013ed348c93$export$2cc5b49df2eed261 = "messageId"; // Count: 4
var $45806013ed348c93$export$923606b70907833e = "message"; // Count: 7
var $45806013ed348c93$export$c7ff2c36e5c78421 = "diagLog"; // Count: 9
var $45806013ed348c93$export$458d234b616d0745 = "_doTeardown"; // Count: 5
var $45806013ed348c93$export$c9f4bebf02f459de = "update"; // Count: 5
var $45806013ed348c93$export$36754a48de7fd714 = "getNext"; // Count: 10
var $45806013ed348c93$export$55d672a1dc4d50c1 = "setNextPlugin"; // Count: 5
var $45806013ed348c93$export$2e850152cb3355e2 = "userAgent"; // Count: 5
var $45806013ed348c93$export$b889f1d4cb07c706 = "split"; // Count: 8
var $45806013ed348c93$export$ef9ef3ed86c4485 = "replace"; // Count: 9
var $45806013ed348c93$export$20dce058fdd3c573 = "substring"; // Count: 4
var $45806013ed348c93$export$a3d3f936db372b4b = "indexOf"; // Count: 5
var $45806013ed348c93$export$8fdcd26070ec159 = "type"; // Count: 17
var $45806013ed348c93$export$d3d43a248cb67414 = "evtName"; // Count: 4
var $45806013ed348c93$export$f8d169088a01f6f2 = "status"; // Count: 9
var $45806013ed348c93$export$78104a8e57e406f7 = "getAllResponseHeaders"; // Count: 2
var $45806013ed348c93$export$3a89026537e5dfec = "isChildEvt"; // Count: 3
var $45806013ed348c93$export$2f5ff0b46814907e = "data"; // Count: 11
var $45806013ed348c93$export$c405fd80acb80a5b = "getCtx"; // Count: 6
var $45806013ed348c93$export$2ec27a3df8fa4130 = "setCtx"; // Count: 10
var $45806013ed348c93$export$746df81af2cb9d94 = "itemsReceived"; // Count: 3
var $45806013ed348c93$export$829ed22a43b4aada = "headers"; // Count: 6
var $45806013ed348c93$export$4babcb0997150ae4 = "urlString"; // Count: 5
var $45806013ed348c93$export$4a1d5ee7f477d201 = "timeout"; // Count: 6
var $45806013ed348c93$export$15be0e404fd287ca = "totalRequest"; // Count: 4
var $45806013ed348c93$export$3df3b31b6d712ef1 = "requestDuration"; // Count: 3
var $45806013ed348c93$export$f63470528b82a828 = "failure"; // Count: 4
var $45806013ed348c93$export$4852fd87b68a6e1f = "exception"; // Count: 4
var $45806013ed348c93$export$24d38586de7bc7a0 = "throttle"; // Count: 4
var $45806013ed348c93$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 5
var $45806013ed348c93$export$d66b96c7c1022a2e = "getAttribute"; // Count: 3


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var $aa96917b132802ee$export$a43287864529b8fd = undefined;
var $aa96917b132802ee$export$5e8607ab26634759 = "";
var $aa96917b132802ee$export$829012af4b2055a2 = "channels";
var $aa96917b132802ee$export$3094ace9cd82ff99 = "core";
var $aa96917b132802ee$export$1cf3476332da55b3 = "createPerfMgr";
var $aa96917b132802ee$export$49e9417944569ae8 = "disabled";
var $aa96917b132802ee$export$ffb2356587263734 = "extensionConfig";
var $aa96917b132802ee$export$a077ce616a1ab4ee = "extensions";
var $aa96917b132802ee$export$820a3bce4a265606 = "processTelemetry";
var $aa96917b132802ee$export$58efcc07763b37be = "priority";
var $aa96917b132802ee$export$bb3c4bc1b1175d3d = "eventsSent";
var $aa96917b132802ee$export$bacb5b2f4c1081b9 = "eventsDiscarded";
var $aa96917b132802ee$export$d75e063cb88a1c25 = "eventsSendRequest";
var $aa96917b132802ee$export$5d265841733c97c3 = "perfEvent";
var $aa96917b132802ee$export$43f876a058c28ba5 = "offlineEventsStored";
var $aa96917b132802ee$export$ae269b8bbb49e700 = "offlineBatchSent";
var $aa96917b132802ee$export$38d218365ccbd2ec = "offlineBatchDrop";
var $aa96917b132802ee$export$f8b08c7de64edfbf = "getPerfMgr";
var $aa96917b132802ee$export$8f3e5386cefa231e = "domain";
var $aa96917b132802ee$export$bdba10701e0ccff3 = "path";
var $aa96917b132802ee$export$80c7dcdabc53a7db = "Not dynamic - ";
var $aa96917b132802ee$export$fa81f2f64b793e1c = "REDACTED";
var $aa96917b132802ee$export$71e2ecd7d7e7d395 = [
    "sig",
    "Signature",
    "AWSAccessKeyId",
    "X-Goog-Signature"
];


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var $ede407819d2d28c9$var$strGetPrototypeOf = "getPrototypeOf";
var $ede407819d2d28c9$var$rCamelCase = /-([a-z])/g;
var $ede407819d2d28c9$var$rNormalizeInvalid = /([^\w\d_$])/g;
var $ede407819d2d28c9$var$rLeadingNumeric = /^(\d+[\w\d_$])/;
var $ede407819d2d28c9$export$821e81707b1677f9 = Object[$ede407819d2d28c9$var$strGetPrototypeOf];
function $ede407819d2d28c9$export$e7321bf46d18757f(value) {
    return !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(value);
}
function $ede407819d2d28c9$export$71fc1ee3e76bc1fe(value) {
    return !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(value);
}
function $ede407819d2d28c9$export$f60443f194e40bc2(name) {
    var value = name;
    if (value && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($ede407819d2d28c9$var$rCamelCase, function(_all, letter) {
            return letter.toUpperCase();
        });
        value = value[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($ede407819d2d28c9$var$rNormalizeInvalid, "_");
        value = value[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]($ede407819d2d28c9$var$rLeadingNumeric, function(_all, match) {
            return "_" + match;
        });
    }
    return value;
}
function $ede407819d2d28c9$export$3185d777c612e61f(value, search) {
    if (value && search) return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(value, search) !== -1;
    return false;
}
function $ede407819d2d28c9$export$dfaaa8705752128f(date) {
    return date && date.toISOString() || "";
}
var $ede407819d2d28c9$export$7e32b29e1cb162e1 = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c);
function $ede407819d2d28c9$export$39c4487b36c98fec(object) {
    if ((0, $5831ddb3a0caf7c7$export$e6127cc7fe7395c3)(object)) return object[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    return 0, $aa96917b132802ee$export$5e8607ab26634759;
}
function $ede407819d2d28c9$export$80746c6bc6142fc8(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
function $ede407819d2d28c9$export$51417ccc212471e(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue)) {
            // Supports having the default as null
            theValue = !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(defValue) ? defValue : {};
            target[field] = theValue;
        }
    } else // Expanded for performance so we only check defValue if required
    theValue = !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(defValue) ? defValue : {};
    return theValue;
}
function $ede407819d2d28c9$var$_createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(source)) srcFunc = source;
    else src = source;
    return function() {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) src = srcFunc();
        if (src) return src[funcName][0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](src, originalArguments);
    };
}
function $ede407819d2d28c9$export$21c1f632458708da(target, source, chkSet) {
    if (target && source && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(target) && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(source)) {
        var _loop_1 = function(field) {
            if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(field)) {
                var value = source[field];
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                    target[field] = $ede407819d2d28c9$var$_createProxyFunction(source, field);
                } else if (!chkSet || chkSet(field, false, source, target)) {
                    if ((0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(target, field)) // Remove any previous instance property
                    delete target[field];
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(target, field, {
                        g: function() {
                            return source[field];
                        },
                        s: function(theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for(var field in source)_loop_1(field);
    }
    return target;
}
function $ede407819d2d28c9$export$5dd8d245f6f94a18(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(target[name])) target[name] = $ede407819d2d28c9$var$_createProxyFunction(source, theFunc);
    }
}
function $ede407819d2d28c9$export$94f4c7fb7e7d8dc7(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(target) && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(functionsToProxy)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(functionsToProxy, function(theFuncName) {
        if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(theFuncName)) $ede407819d2d28c9$export$5dd8d245f6f94a18(target, theFuncName, source, theFuncName, overwriteTarget);
    });
    return target;
}
function $ede407819d2d28c9$export$f0facb5bce2741f0(defaults) {
    return /** @class */ function() {
        function class_1() {
            var _this = this;
            if (defaults) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defaults, function(field, value) {
                _this[field] = value;
            });
        }
        return class_1;
    }();
}
function $ede407819d2d28c9$export$3e03fa3fc3e422d7(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && (0, $5831ddb3a0caf7c7$export$afe328edc487dcfe)) theObject = (0, $042f611b66f4fd6f$export$9ec954dd81c90a5d)((0, $5831ddb3a0caf7c7$export$afe328edc487dcfe)({}, theObject));
    return theObject;
}
function $ede407819d2d28c9$export$a7f7e50f928053df(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && (0, $5831ddb3a0caf7c7$export$f9ce7b637dfbe238)(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!(0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(extended)) extended = {};
    // Loop through each remaining object and conduct a merge
    for(; idx < argLen; idx++){
        var arg = theArgs[idx];
        var isArgArray = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(arg);
        var isArgObj = (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(arg);
        for(var prop in arg){
            var propOk = isArgArray && prop in arg || isArgObj && (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(arg, prop);
            if (!propOk) continue;
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(newValue)) || (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(clone)) // We can't "merge" an array with a non-array so overwrite the original
                    clone = [];
                } else if (!(0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(clone)) // We can't "merge" an object with a non-object
                clone = {};
                // Never move the original objects always clone them
                newValue = $ede407819d2d28c9$export$a7f7e50f928053df(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) extended[prop] = newValue;
        }
    }
    return extended;
}
var $ede407819d2d28c9$export$590567be997858b6 = (0, $5831ddb3a0caf7c7$export$590567be997858b6);
function $ede407819d2d28c9$export$87e0f7dd6dec932f(feature, cfg, sdkDefaultState) {
    var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
    if (feature && ft) {
        var mode = ft.mode;
        // NOTE: None will be considered as true
        if (mode === 3 /* FeatureOptInMode.enable */ ) return true;
        else if (mode === 2 /* FeatureOptInMode.disable */ ) return false;
    }
    // Return the default state if provided or undefined
    return sdkDefaultState;
}
function $ede407819d2d28c9$export$43a870850da980b4(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function $ede407819d2d28c9$export$404d535171315d86(xdr, message) {
    if (xdr) return "XDomainRequest,Response:" + $ede407819d2d28c9$export$43a870850da980b4(xdr);
    return message;
}
function $ede407819d2d28c9$export$f826fdf8bca00592(xhr, message) {
    if (xhr) return "XMLHttpRequest,Status:" + xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ] + ",Response:" + $ede407819d2d28c9$export$43a870850da980b4(xhr) || xhr.response || "";
    return message;
}
function $ede407819d2d28c9$export$d435c252bc2524f(theTransports, newTransports) {
    if (newTransports) {
        if ((0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(newTransports)) theTransports = [
            newTransports
        ].concat(theTransports);
        else if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(newTransports)) theTransports = newTransports.concat(theTransports);
    }
    return theTransports;
}
var $ede407819d2d28c9$var$strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $ede407819d2d28c9$var$strWithCredentials = "withCredentials";
var $ede407819d2d28c9$var$strTimeout = "timeout";
function $ede407819d2d28c9$export$b028e759972c6d09(method, urlString, withCredentials, disabled, isSync, timeout) {
    if (disabled === void 0) disabled = false;
    if (isSync === void 0) isSync = false;
    function _wrapSetXhrProp(xhr, prop, value) {
        try {
            xhr[prop] = value;
        } catch (e) {
        // - Wrapping as depending on the environment setting the property may fail (non-terminally)
        }
    }
    var xhr = new XMLHttpRequest();
    if (disabled) // Tag the instance so it's not tracked (trackDependency)
    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
    // cause the request to fail and we no telemetry would be sent
    _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strDisabledPropertyName, disabled);
    if (withCredentials) // Some libraries require that the withCredentials flag is set "before" open and
    // - Wrapping as IE 10 has started throwing when setting before open
    _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strWithCredentials, withCredentials);
    xhr.open(method, urlString, !isSync);
    if (withCredentials) // withCredentials should be set AFTER open (https://xhr.spec.whatwg.org/#the-withcredentials-attribute)
    // And older firefox instances from 11+ will throw for sync events (current versions don't) which happens during unload processing
    _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strWithCredentials, withCredentials);
    // Only set the timeout for asynchronous requests as
    // "Timeout shouldn't be used for synchronous XMLHttpRequests requests used in a document environment or it will throw an InvalidAccessError exception.""
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (!isSync && timeout) _wrapSetXhrProp(xhr, $ede407819d2d28c9$var$strTimeout, timeout);
    return xhr;
}
function $ede407819d2d28c9$export$cc1b6e60efb8c361(headersString) {
    var headers = {};
    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(headersString)) {
        var headersArray = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headersString)[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](/[\r\n]+/);
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(headersArray, function(headerEntry) {
            if (headerEntry) {
                var idx = headerEntry[0, $45806013ed348c93$export$a3d3f936db372b4b /* @min:%2eindexOf */ ](": ");
                if (idx !== -1) {
                    // The new spec has the headers returning all as lowercase -- but not all browsers do this yet
                    var header = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headerEntry.substring(0, idx))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                    var value = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headerEntry[0, $45806013ed348c93$export$20dce058fdd3c573 /* @min:%2esubstring */ ](idx + 1));
                    headers[header] = value;
                } else headers[(0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headerEntry)] = 1;
            }
        });
    }
    return headers;
}
function $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, name) {
    if (!theHeaders[name] && xhr && xhr.getResponseHeader) {
        var value = xhr.getResponseHeader(name);
        if (value) theHeaders[name] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(value);
    }
    return theHeaders;
}
var $ede407819d2d28c9$var$STR_KILL_DURATION_HEADER = "kill-duration";
var $ede407819d2d28c9$var$STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
var $ede407819d2d28c9$var$STR_TIME_DELTA_HEADER = "time-delta-millis";
function $ede407819d2d28c9$export$801009daa428ec44(xhr, isOneDs) {
    var theHeaders = {};
    if (!xhr[0, $45806013ed348c93$export$78104a8e57e406f7 /* @min:%2egetAllResponseHeaders */ ]) // Firefox 2-63 doesn't have getAllResponseHeaders function but it does have getResponseHeader
    // Only call these if getAllResponseHeaders doesn't exist, otherwise we can get invalid response errors
    // as collector is not currently returning the correct header to allow JS to access these headers
    {
        if (!!isOneDs) {
            theHeaders = $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, $ede407819d2d28c9$var$STR_TIME_DELTA_HEADER);
            theHeaders = $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, $ede407819d2d28c9$var$STR_KILL_DURATION_HEADER);
            theHeaders = $ede407819d2d28c9$export$862e212d6324d005(theHeaders, xhr, $ede407819d2d28c9$var$STR_KILL_DURATION_SECONDS_HEADER);
        }
    } else theHeaders = $ede407819d2d28c9$export$cc1b6e60efb8c361(xhr[0, $45806013ed348c93$export$78104a8e57e406f7 /* @min:%2egetAllResponseHeaders */ ]());
    return theHeaders;
}



"use strict";
/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */ var $0d2c2fb24388dcf8$var$strDocumentMode = "documentMode";
var $0d2c2fb24388dcf8$var$strLocation = "location";
var $0d2c2fb24388dcf8$var$strConsole = "console";
var $0d2c2fb24388dcf8$var$strJSON = "JSON";
var $0d2c2fb24388dcf8$var$strCrypto = "crypto";
var $0d2c2fb24388dcf8$var$strMsCrypto = "msCrypto";
var $0d2c2fb24388dcf8$var$strReactNative = "ReactNative";
var $0d2c2fb24388dcf8$var$strMsie = "msie";
var $0d2c2fb24388dcf8$var$strTrident = "trident/";
var $0d2c2fb24388dcf8$var$strXMLHttpRequest = "XMLHttpRequest";
var $0d2c2fb24388dcf8$var$_isTrident = null;
var $0d2c2fb24388dcf8$var$_navUserAgentCheck = null;
var $0d2c2fb24388dcf8$var$_enableMocks = false;
var $0d2c2fb24388dcf8$var$_useXDomainRequest = null;
var $0d2c2fb24388dcf8$var$_beaconsSupported = null;
function $0d2c2fb24388dcf8$var$_hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049];
                if (proto) supported = property in proto;
            }
        } catch (e) {
        // Do Nothing
        }
        if (!supported) try {
            var tmp = new theClass();
            supported = !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(tmp[property]);
        } catch (e) {
        // Do Nothing
        }
    }
    return supported;
}
function $0d2c2fb24388dcf8$export$6b8934f3c937d22f(enabled) {
    $0d2c2fb24388dcf8$var$_enableMocks = enabled;
}
function $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f(checkForMock) {
    if (checkForMock && $0d2c2fb24388dcf8$var$_enableMocks) {
        var mockLocation = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("__mockLocation");
        if (mockLocation) return mockLocation;
    }
    if (typeof location === (0, $042f611b66f4fd6f$export$127e9c2439c2ee16) && location) return location;
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strLocation);
}
function $0d2c2fb24388dcf8$export$bbe488cec1edd401() {
    if (typeof console !== (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987)) return console;
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strConsole);
}
function $0d2c2fb24388dcf8$export$a2856ab6913b9fff() {
    return Boolean(typeof JSON === (0, $042f611b66f4fd6f$export$127e9c2439c2ee16) && JSON || (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strJSON) !== null);
}
function $0d2c2fb24388dcf8$export$d047a7c56db64af4() {
    if ($0d2c2fb24388dcf8$export$a2856ab6913b9fff()) return JSON || (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strJSON);
    return null;
}
function $0d2c2fb24388dcf8$export$e003cc239f955cb6() {
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strCrypto);
}
function $0d2c2fb24388dcf8$export$6bc5093edbd2ea6() {
    return (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strMsCrypto);
}
function $0d2c2fb24388dcf8$export$f7a1e23e542d38e3() {
    // If running in React Native, navigator.product will be populated
    var nav = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)();
    if (nav && nav.product) return nav.product === $0d2c2fb24388dcf8$var$strReactNative;
    return false;
}
function $0d2c2fb24388dcf8$export$7e7b1a9668aaed8() {
    var nav = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)();
    if (nav && (nav[0, $45806013ed348c93$export$2e850152cb3355e2 /* @min:%2euserAgent */ ] !== $0d2c2fb24388dcf8$var$_navUserAgentCheck || $0d2c2fb24388dcf8$var$_isTrident === null)) {
        // Added to support test mocking of the user agent
        $0d2c2fb24388dcf8$var$_navUserAgentCheck = nav[0, $45806013ed348c93$export$2e850152cb3355e2 /* @min:%2euserAgent */ ];
        var userAgent = ($0d2c2fb24388dcf8$var$_navUserAgentCheck || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
        $0d2c2fb24388dcf8$var$_isTrident = (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, $0d2c2fb24388dcf8$var$strMsie) || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, $0d2c2fb24388dcf8$var$strTrident);
    }
    return $0d2c2fb24388dcf8$var$_isTrident;
}
function $0d2c2fb24388dcf8$export$eb7ff627fa81c42e(userAgentStr) {
    if (userAgentStr === void 0) userAgentStr = null;
    if (!userAgentStr) {
        var navigator_1 = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() : (0, $aa96917b132802ee$export$5e8607ab26634759);
    }
    var ua = (userAgentStr || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(ua, $0d2c2fb24388dcf8$var$strMsie)) {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)() || {};
        return (0, $5831ddb3a0caf7c7$export$2ca8010d037f830f)(parseInt(ua[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($0d2c2fb24388dcf8$var$strMsie)[1]), doc[$0d2c2fb24388dcf8$var$strDocumentMode] || 0);
    } else if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(ua, $0d2c2fb24388dcf8$var$strTrident)) {
        var tridentVer = parseInt(ua[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($0d2c2fb24388dcf8$var$strTrident)[1]);
        if (tridentVer) return tridentVer + 4;
    }
    return null;
}
function $0d2c2fb24388dcf8$export$95df08bae54cb4df(userAgentStr) {
    if (!userAgentStr || !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(userAgentStr)) {
        var navigator_2 = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() : (0, $aa96917b132802ee$export$5e8607ab26634759);
    }
    var ua = (userAgentStr || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(ua, "safari") >= 0;
}
function $0d2c2fb24388dcf8$export$cf496c79c05967a0(useCached) {
    if ($0d2c2fb24388dcf8$var$_beaconsSupported === null || useCached === false) $0d2c2fb24388dcf8$var$_beaconsSupported = (0, $5831ddb3a0caf7c7$export$bd82d106260417bf)() && Boolean((0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)().sendBeacon);
    return $0d2c2fb24388dcf8$var$_beaconsSupported;
}
function $0d2c2fb24388dcf8$export$f8c1c61350d9749(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!(0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("fetch");
        var request = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("Request");
        if (isSupported && withKeepAlive && request) isSupported = $0d2c2fb24388dcf8$var$_hasProperty(request, "keepalive");
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $0d2c2fb24388dcf8$export$b9f2bc09e5ac0fa5() {
    if ($0d2c2fb24388dcf8$var$_useXDomainRequest === null) {
        $0d2c2fb24388dcf8$var$_useXDomainRequest = typeof XDomainRequest !== (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987);
        if ($0d2c2fb24388dcf8$var$_useXDomainRequest && $0d2c2fb24388dcf8$export$cfeac9aa070f0108()) $0d2c2fb24388dcf8$var$_useXDomainRequest = $0d2c2fb24388dcf8$var$_useXDomainRequest && !$0d2c2fb24388dcf8$var$_hasProperty((0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strXMLHttpRequest), "withCredentials");
    }
    return $0d2c2fb24388dcf8$var$_useXDomainRequest;
}
function $0d2c2fb24388dcf8$export$cfeac9aa070f0108() {
    var isSupported = false;
    try {
        var xmlHttpRequest = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)($0d2c2fb24388dcf8$var$strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $0d2c2fb24388dcf8$var$_getNamedValue(values, name) {
    if (values) for(var i = 0; i < values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var value = values[i];
        if (value[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ]) {
            if (value[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] === name) return value;
        }
    }
    return {};
}
function $0d2c2fb24388dcf8$export$cdb9869d6805c74f(name) {
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    if (doc && name) // Look for a meta-tag
    return $0d2c2fb24388dcf8$var$_getNamedValue(doc.querySelectorAll("meta"), name).content;
    return null;
}
function $0d2c2fb24388dcf8$export$a25efeeb107534e6(name) {
    var value;
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    if (perf) {
        // Try looking for a server-timing header
        var navPerf = perf.getEntriesByType("navigation") || [];
        value = $0d2c2fb24388dcf8$var$_getNamedValue((navPerf[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0 ? navPerf[0] : {}).serverTiming, name).description;
    }
    return value;
}
function $0d2c2fb24388dcf8$export$716a11175c03fb4e(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function $0d2c2fb24388dcf8$export$8e16c003644f99f2(eventName, details) {
    var event = null;
    var detail = {
        detail: details || null
    };
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(CustomEvent)) event = new CustomEvent(eventName, detail);
    else {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function $0d2c2fb24388dcf8$export$af531f0ca2964c96(evtName, cfg, customDetails) {
    var global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
    if (global && global.CustomEvent) try {
        var details = {
            cfg: cfg || null,
            customDetails: customDetails || null
        };
        return $0d2c2fb24388dcf8$export$716a11175c03fb4e(global, $0d2c2fb24388dcf8$export$8e16c003644f99f2(evtName, details));
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return false;
}
/**
 * Redacts user information from a URL
 * @param url - The URL string to redact
 * @returns The URL with user information redacted
 */ function $0d2c2fb24388dcf8$var$redactUserInfo(url) {
    return url.replace(/^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)([^:@]{1,200}):([^@]{1,200})@(.*)$/, "$1REDACTED:REDACTED@$4");
}
/**
 * Redacts sensitive query parameters from a URL
 * @param url - The URL string to redact
 * @returns The URL with sensitive query parameters redacted
 */ function $0d2c2fb24388dcf8$var$redactQueryParameters(url, config) {
    var sensitiveParams;
    var questionMarkIndex = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url, "?");
    if (questionMarkIndex === -1) return url;
    if (config && config.redactQueryParams) sensitiveParams = (0, $aa96917b132802ee$export$71e2ecd7d7e7d395).concat(config.redactQueryParams);
    else sensitiveParams = (0, $aa96917b132802ee$export$71e2ecd7d7e7d395);
    var baseUrl = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(url, 0, questionMarkIndex + 1);
    var queryString = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(url, questionMarkIndex + 1);
    var fragment = (0, $aa96917b132802ee$export$5e8607ab26634759);
    var hashIndex = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(queryString, "#");
    if (hashIndex !== -1) {
        fragment = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(queryString, hashIndex);
        queryString = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(queryString, 0, hashIndex);
    }
    var hasPotentialSensitiveParam = false;
    for(var i = 0; i < sensitiveParams[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var paramCheck = sensitiveParams[i] + "=";
        if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(queryString, paramCheck) !== -1) {
            hasPotentialSensitiveParam = true;
            break;
        }
    }
    if (!hasPotentialSensitiveParam) return url;
    var resultParts = [];
    var anyParamRedacted = false;
    if (queryString && queryString[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) {
        var pairs = queryString[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("&");
        for(var i = 0; i < pairs[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
            var pair = pairs[i];
            if (!pair) continue;
            var equalsIndex = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(pair, "=");
            if (equalsIndex === -1) // Parameter without value
            resultParts[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](pair);
            else {
                var paramName = pair[0, $45806013ed348c93$export$20dce058fdd3c573 /* @min:%2esubstring */ ](0, equalsIndex);
                var paramValue = pair[0, $45806013ed348c93$export$20dce058fdd3c573 /* @min:%2esubstring */ ](equalsIndex + 1);
                if (paramValue === (0, $aa96917b132802ee$export$5e8607ab26634759)) resultParts[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](pair);
                else {
                    var shouldRedact = false;
                    for(var j = 0; j < sensitiveParams[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; j++)if (paramName === sensitiveParams[j]) {
                        shouldRedact = true;
                        anyParamRedacted = true;
                        break;
                    }
                    if (shouldRedact) resultParts[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](paramName + "=" + (0, $aa96917b132802ee$export$fa81f2f64b793e1c));
                    else resultParts[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](pair);
                }
            }
        }
    }
    // If no parameters were redacted, return the original URL
    if (!anyParamRedacted) return url;
    return baseUrl + resultParts.join("&") + fragment;
}
function $0d2c2fb24388dcf8$export$96efba388500ac9c(input, config) {
    if (!input || input[0, $45806013ed348c93$export$a3d3f936db372b4b /* @min:%2eindexOf */ ](" ") !== -1) return input;
    var isRedactionDisabled = config && config.redactUrls === false;
    if (isRedactionDisabled) return input;
    var hasCredentials = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(input, "@") !== -1;
    var hasQueryParams = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(input, "?") !== -1;
    // If no credentials and no query params, return original
    if (!hasCredentials && !hasQueryParams) return input;
    try {
        var result = input;
        if (hasCredentials) result = $0d2c2fb24388dcf8$var$redactUserInfo(input);
        if (hasQueryParams) result = $0d2c2fb24388dcf8$var$redactQueryParameters(result, config);
        return result;
    } catch (e) {
        return input;
    }
}



var $dfdef4661b59546e$var$UInt32Mask = 0x100000000;
var $dfdef4661b59546e$var$MaxUInt32 = 0xffffffff;
var $dfdef4661b59546e$var$SEED1 = 123456789;
var $dfdef4661b59546e$var$SEED2 = 987654321;
// MWC based Random generator (for IE)
var $dfdef4661b59546e$var$_mwcSeeded = false;
var $dfdef4661b59546e$var$_mwcW = $dfdef4661b59546e$var$SEED1;
var $dfdef4661b59546e$var$_mwcZ = $dfdef4661b59546e$var$SEED2;
// Takes any integer
function $dfdef4661b59546e$var$_mwcSeed(seedValue) {
    if (seedValue < 0) // Make sure we end up with a positive number and not -ve one.
    seedValue >>>= 0;
    $dfdef4661b59546e$var$_mwcW = $dfdef4661b59546e$var$SEED1 + seedValue & $dfdef4661b59546e$var$MaxUInt32;
    $dfdef4661b59546e$var$_mwcZ = $dfdef4661b59546e$var$SEED2 - seedValue & $dfdef4661b59546e$var$MaxUInt32;
    $dfdef4661b59546e$var$_mwcSeeded = true;
}
function $dfdef4661b59546e$var$_autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)() & 0x7fffffff;
        $dfdef4661b59546e$var$_mwcSeed((Math.random() * $dfdef4661b59546e$var$UInt32Mask ^ now) + now);
    } catch (e) {
    // Don't crash if something goes wrong
    }
}
function $dfdef4661b59546e$export$b2cfcb5c32671fa4(maxValue) {
    if (maxValue > 0) return (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)($dfdef4661b59546e$export$aec042b223b6f5f9() / $dfdef4661b59546e$var$MaxUInt32 * (maxValue + 1)) >>> 0;
    return 0;
}
function $dfdef4661b59546e$export$aec042b223b6f5f9(signed) {
    var value = 0;
    var c = (0, $0d2c2fb24388dcf8$export$e003cc239f955cb6)() || (0, $0d2c2fb24388dcf8$export$6bc5093edbd2ea6)();
    if (c && c.getRandomValues) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = c.getRandomValues(new Uint32Array(1))[0] & $dfdef4661b59546e$var$MaxUInt32;
    if (value === 0 && (0, $0d2c2fb24388dcf8$export$7e7b1a9668aaed8)()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!$dfdef4661b59546e$var$_mwcSeeded) // Set the seed for the Mwc algorithm
        $dfdef4661b59546e$var$_autoSeedMwc();
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = $dfdef4661b59546e$export$3ffb74f7babdd68f() & $dfdef4661b59546e$var$MaxUInt32;
    }
    if (value === 0) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)($dfdef4661b59546e$var$UInt32Mask * Math.random() | 0);
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $dfdef4661b59546e$export$195aff7adbfe974f(value) {
    if (!value) $dfdef4661b59546e$var$_autoSeedMwc();
    else $dfdef4661b59546e$var$_mwcSeed(value);
}
function $dfdef4661b59546e$export$3ffb74f7babdd68f(signed) {
    $dfdef4661b59546e$var$_mwcZ = 36969 * ($dfdef4661b59546e$var$_mwcZ & 0xFFFF) + ($dfdef4661b59546e$var$_mwcZ >> 16) & $dfdef4661b59546e$var$MaxUInt32;
    $dfdef4661b59546e$var$_mwcW = 18000 * ($dfdef4661b59546e$var$_mwcW & 0xFFFF) + ($dfdef4661b59546e$var$_mwcW >> 16) & $dfdef4661b59546e$var$MaxUInt32;
    var value = ($dfdef4661b59546e$var$_mwcZ << 16) + ($dfdef4661b59546e$var$_mwcW & 0xFFFF) >>> 0 & $dfdef4661b59546e$var$MaxUInt32 | 0;
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $dfdef4661b59546e$export$9ffd10a3fbdc175b(maxLength) {
    if (maxLength === void 0) maxLength = 22;
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = $dfdef4661b59546e$export$aec042b223b6f5f9() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = (0, $aa96917b132802ee$export$5e8607ab26634759);
    while(result[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] < maxLength){
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = ($dfdef4661b59546e$export$aec042b223b6f5f9() << 2 & 0xFFFFFFFF | number & 0x03) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}


"use strict";
var $61bcf5b470259c00$export$3bac393b8225adab = (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987);
function $61bcf5b470259c00$export$665eeb3ced5fba0b() {
    var uuid = $61bcf5b470259c00$export$58d1fad45f39d957();
    return (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 0, 8) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 8, 12) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 12, 16) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 16, 20) + "-" + (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(uuid, 20);
}
function $61bcf5b470259c00$export$5222b9460f3ddbec(value, search) {
    if (value && search) {
        var len = value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        var start = len - search[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        return (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, start >= 0 ? start : 0, len) === search;
    }
    return false;
}
function $61bcf5b470259c00$export$58d1fad45f39d957() {
    var hexValues = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
    ];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = (0, $aa96917b132802ee$export$5e8607ab26634759), tmp;
    for(var a = 0; a < 4; a++){
        tmp = (0, $dfdef4661b59546e$export$aec042b223b6f5f9)();
        oct += hexValues[tmp & 0xF] + hexValues[tmp >> 4 & 0xF] + hexValues[tmp >> 8 & 0xF] + hexValues[tmp >> 12 & 0xF] + hexValues[tmp >> 16 & 0xF] + hexValues[tmp >> 20 & 0xF] + hexValues[tmp >> 24 & 0xF] + hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + ((0, $dfdef4661b59546e$export$aec042b223b6f5f9)() & 0x03) | 0];
    return (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 0, 8) + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 9, 4) + "4" + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 13, 3) + clockSequenceHi + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 16, 3) + (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(oct, 19, 12);
}




// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var $4726195e2d737947$var$TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var $4726195e2d737947$var$DEFAULT_VERSION = "00";
var $4726195e2d737947$var$INVALID_VERSION = "ff";
var $4726195e2d737947$var$INVALID_TRACE_ID = "00000000000000000000000000000000";
var $4726195e2d737947$var$INVALID_SPAN_ID = "0000000000000000";
var $4726195e2d737947$var$SAMPLED_FLAG = 0x01;
function $4726195e2d737947$var$_isValid(value, len, invalidValue) {
    if (value && value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
    return false;
}
function $4726195e2d737947$var$_formatValue(value, len, defValue) {
    if ($4726195e2d737947$var$_isValid(value, len)) return value;
    return defValue;
}
function $4726195e2d737947$var$_formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) value = 0x01;
    var result = value.toString(16);
    while(result[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] < 2)result = "0" + result;
    return result;
}
function $4726195e2d737947$export$2f21fe23413fe96b(traceId, spanId, flags, version) {
    return {
        version: $4726195e2d737947$var$_isValid(version, 2, $4726195e2d737947$var$INVALID_VERSION) ? version : $4726195e2d737947$var$DEFAULT_VERSION,
        traceId: $4726195e2d737947$export$29dd34cf1269f6da(traceId) ? traceId : (0, $61bcf5b470259c00$export$58d1fad45f39d957)(),
        spanId: $4726195e2d737947$export$8e51c6d8f0586aff(spanId) ? spanId : (0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)((0, $61bcf5b470259c00$export$58d1fad45f39d957)(), 16),
        traceFlags: flags >= 0 && flags <= 0xFF ? flags : 1
    };
}
function $4726195e2d737947$export$f4d87f8901a93f5d(value, selectIdx) {
    if (!value) // Don't pass a null/undefined or empty string
    return null;
    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value)) // The value may have been encoded on the page into an array so handle this automatically
    value = value[0] || "";
    if (!value || !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(value) || value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 8192) // limit potential processing based on total length
    return null;
    if (value[0, $45806013ed348c93$export$a3d3f936db372b4b /* @min:%2eindexOf */ ](",") !== -1) {
        var values = value[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](",");
        value = values[selectIdx > 0 && values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > selectIdx ? selectIdx : 0];
    }
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    var match = $4726195e2d737947$var$TRACE_PARENT_REGEX.exec((0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(value));
    if (!match || // No match
    match[1] === $4726195e2d737947$var$INVALID_VERSION || // version ff is forbidden
    match[2] === $4726195e2d737947$var$INVALID_TRACE_ID || // All zeros is considered to be invalid
    match[3] === $4726195e2d737947$var$INVALID_SPAN_ID) return null;
    return {
        version: (match[1] || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        traceId: (match[2] || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        spanId: (match[3] || (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](),
        traceFlags: parseInt(match[4], 16)
    };
}
function $4726195e2d737947$export$29dd34cf1269f6da(value) {
    return $4726195e2d737947$var$_isValid(value, 32, $4726195e2d737947$var$INVALID_TRACE_ID);
}
function $4726195e2d737947$export$8e51c6d8f0586aff(value) {
    return $4726195e2d737947$var$_isValid(value, 16, $4726195e2d737947$var$INVALID_SPAN_ID);
}
function $4726195e2d737947$export$a210ed246a03bbf(value) {
    if (!value || !$4726195e2d737947$var$_isValid(value[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ], 2, $4726195e2d737947$var$INVALID_VERSION) || !$4726195e2d737947$var$_isValid(value.traceId, 32, $4726195e2d737947$var$INVALID_TRACE_ID) || !$4726195e2d737947$var$_isValid(value.spanId, 16, $4726195e2d737947$var$INVALID_SPAN_ID) || !$4726195e2d737947$var$_isValid($4726195e2d737947$var$_formatFlags(value[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ]), 2)) // Each known field must contain a valid value
    return false;
    return true;
}
function $4726195e2d737947$export$8577d514cd55191e(value) {
    if ($4726195e2d737947$export$a210ed246a03bbf(value)) return (value[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] & $4726195e2d737947$var$SAMPLED_FLAG) === $4726195e2d737947$var$SAMPLED_FLAG;
    return false;
}
function $4726195e2d737947$export$55f8c39d2c902d0d(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = $4726195e2d737947$var$_formatFlags(value[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ]);
        if (!$4726195e2d737947$var$_isValid(flags, 2)) flags = "01";
        var version = value[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ] || $4726195e2d737947$var$DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") // Reduce version to "00"
        version = $4726195e2d737947$var$DEFAULT_VERSION;
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat($4726195e2d737947$var$_formatValue(value.traceId, 32, $4726195e2d737947$var$INVALID_TRACE_ID).toLowerCase(), "-").concat($4726195e2d737947$var$_formatValue(value.spanId, 16, $4726195e2d737947$var$INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}
function $4726195e2d737947$export$2a00dfdbe257ef74(selectIdx) {
    var name = "traceparent";
    var traceParent = $4726195e2d737947$export$f4d87f8901a93f5d((0, $0d2c2fb24388dcf8$export$cdb9869d6805c74f)(name), selectIdx);
    if (!traceParent) traceParent = $4726195e2d737947$export$f4d87f8901a93f5d((0, $0d2c2fb24388dcf8$export$a25efeeb107534e6)(name), selectIdx);
    return traceParent;
}
function $4726195e2d737947$export$1329d5a456df56f(doc) {
    var scripts = doc.getElementsByTagName("script");
    var result = [];
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(scripts, function(script) {
        var src = script[0, $45806013ed348c93$export$d66b96c7c1022a2e /* @min:%2egetAttribute */ ]("src");
        if (src) {
            var crossOrigin = script[0, $45806013ed348c93$export$d66b96c7c1022a2e /* @min:%2egetAttribute */ ]("crossorigin");
            var async = script.hasAttribute("async") === true;
            var defer = script.hasAttribute("defer") === true;
            var referrerPolicy = script[0, $45806013ed348c93$export$d66b96c7c1022a2e /* @min:%2egetAttribute */ ]("referrerpolicy");
            var info = {
                url: src
            };
            if (crossOrigin) info.crossOrigin = crossOrigin;
            if (async) info.async = async;
            if (defer) info.defer = defer;
            if (referrerPolicy) info.referrerPolicy = referrerPolicy;
            result[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](info);
        }
    });
    return result;
}



/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */ var $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $8ac3b4fe9182f568$export$dc288b6444e20c04 = "sampleRate";
var $8ac3b4fe9182f568$export$ea8a69bf327def66 = "ProcessLegacy";
var $8ac3b4fe9182f568$export$8343e6f32f5246de = "http.method";
var $8ac3b4fe9182f568$export$5c9ec0fce655ebcf = "https://dc.services.visualstudio.com";
var $8ac3b4fe9182f568$export$e6c0f3431c6cd728 = "/v2/track";
var $8ac3b4fe9182f568$export$4003f5e1672d759 = "not_specified";
var $8ac3b4fe9182f568$export$7d566319b90dbb26 = "iKey";


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $b49c449a24f657f6$export$fd52abd0b2703048 = (0, $5831ddb3a0caf7c7$export$37b2eedf6b7b231a);
var $b49c449a24f657f6$export$8980fe7abaa99712 = (0, $5831ddb3a0caf7c7$export$a6025b6424227e7e);


var $921552b7fb658c3b$export$e499e02a1fe05177 = /* @__PURE__ */ (0, $b49c449a24f657f6$export$8980fe7abaa99712)({
    requestContextHeader: [
        0 /* eRequestHeaders.requestContextHeader */ ,
        "Request-Context"
    ],
    requestContextTargetKey: [
        1 /* eRequestHeaders.requestContextTargetKey */ ,
        "appId"
    ],
    requestContextAppIdFormat: [
        2 /* eRequestHeaders.requestContextAppIdFormat */ ,
        "appId=cid-v1:"
    ],
    requestIdHeader: [
        3 /* eRequestHeaders.requestIdHeader */ ,
        "Request-Id"
    ],
    traceParentHeader: [
        4 /* eRequestHeaders.traceParentHeader */ ,
        "traceparent"
    ],
    traceStateHeader: [
        5 /* eRequestHeaders.traceStateHeader */ ,
        "tracestate"
    ],
    sdkContextHeader: [
        6 /* eRequestHeaders.sdkContextHeader */ ,
        "Sdk-Context"
    ],
    sdkContextHeaderAppIdRequest: [
        7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ,
        "appId"
    ],
    requestContextHeaderLowerCase: [
        8 /* eRequestHeaders.requestContextHeaderLowerCase */ ,
        "request-context"
    ]
});


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $0e058b881c0798ff$var$version = '3.3.10';
var $0e058b881c0798ff$var$instanceName = "." + (0, $dfdef4661b59546e$export$9ffd10a3fbdc175b)(6);
var $0e058b881c0798ff$var$_dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function $0e058b881c0798ff$var$_canAcceptData(target) {
    return target.nodeType === 1 || target.nodeType === 9 || !+target.nodeType;
}
function $0e058b881c0798ff$var$_getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if ($0e058b881c0798ff$var$_canAcceptData(target)) (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(target, data.id, {
                e: false,
                v: theCache
            });
        } catch (e) {
        // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function $0e058b881c0798ff$export$eb4a6badb18ead04(name, includeVersion) {
    if (includeVersion === void 0) includeVersion = false;
    return (0, $ede407819d2d28c9$export$f60443f194e40bc2)(name + $0e058b881c0798ff$var$_dataUid++ + (includeVersion ? "." + $0e058b881c0798ff$var$version : (0, $aa96917b132802ee$export$5e8607ab26634759)) + $0e058b881c0798ff$var$instanceName);
}
function $0e058b881c0798ff$export$b95c3438408d78aa(name) {
    var data = {
        id: $0e058b881c0798ff$export$eb4a6badb18ead04("_aiData-" + (name || (0, $aa96917b132802ee$export$5e8607ab26634759)) + "." + $0e058b881c0798ff$var$version),
        accept: function(target) {
            return $0e058b881c0798ff$var$_canAcceptData(target);
        },
        get: function(target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = $0e058b881c0798ff$var$_getCache(data, target);
                    theCache[(0, $ede407819d2d28c9$export$f60443f194e40bc2)(name)] = defValue;
                }
                return defValue;
            }
            return theCache[(0, $ede407819d2d28c9$export$f60443f194e40bc2)(name)];
        },
        kill: function(target, name) {
            if (target && target[name]) try {
                delete target[name];
            } catch (e) {
            // Just cleaning up, so if this fails -- ignore
            }
        }
    };
    return data;
}




/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $2858d2db0bf490e5$var$_isConfigDefaults(value) {
    return value && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value) && !(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value) && (value.isVal || value.fb || (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(value, "v") || (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(value, "mrg") || (0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(value, "ref") || value.set);
}
function $2858d2db0bf490e5$var$_getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || (0, $5831ddb3a0caf7c7$export$4e62c701997796c1);
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(fallbacks)) fallbacks = [
            fallbacks
        ];
        for(var lp = 0; lp < fallbacks[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) defValue = fbValue;
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) defValue = fbValue;
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, (0, $5831ddb3a0caf7c7$export$590567be997858b6)(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) break;
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) defValue = cfgDefaults.v;
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */ function $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && $2858d2db0bf490e5$var$_isConfigDefaults(cfgDefaults)) theValue = $2858d2db0bf490e5$var$_getDefault(dynamicHandler, theConfig, cfgDefaults);
    if (theValue) {
        if ($2858d2db0bf490e5$var$_isConfigDefaults(theValue)) theValue = $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, theValue);
        var newValue_1;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(theValue)) {
            newValue_1 = [];
            newValue_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] = theValue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        } else if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(theValue)) newValue_1 = {};
        if (newValue_1) {
            (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(theValue, function(key, value) {
                if (value && $2858d2db0bf490e5$var$_isConfigDefaults(value)) value = $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, value);
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
function $2858d2db0bf490e5$export$f11b7d3a4617b9e9(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if ($2858d2db0bf490e5$var$_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults.rdOnly;
        blkDynamicValue = cfgDefaults.blkVal;
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(reference)) reference = !!mergeDf;
        defValue = $2858d2db0bf490e5$var$_getDefault(dynamicHandler, theConfig, cfgDefaults);
    } else defValue = defaultValue;
    if (blkDynamicValue) // Mark the property so that any value assigned will be blocked from conversion, we need to do this
    // before assigning or fetching the value to ensure it's not converted
    dynamicHandler.blkVal(theConfig, name);
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(theValue) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(defValue)) // we are using the user supplied value and it's an object
        {
            if (mergeDf && defValue && ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(defValue) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(defValue))) // Resolve/apply the defaults
            (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defValue, function(dfName, dfValue) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                $2858d2db0bf490e5$export$f11b7d3a4617b9e9(dynamicHandler, theValue, dfName, dfValue);
            });
        }
    } else if (defValue) // Just resolve the default
    theValue = $2858d2db0bf490e5$var$_resolveDefaultValue(dynamicHandler, theConfig, defValue);
    else theValue = defValue;
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) dynamicHandler.ref(theConfig, name);
    if (readOnly) dynamicHandler.rdOnly(theConfig, name);
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $d3c38d6d6e53b9ed$export$3af51e1f665d1d72 = (0, $5831ddb3a0caf7c7$export$4d0ba04d25a41f31)("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */ var $d3c38d6d6e53b9ed$var$BLOCK_DYNAMIC = (0, $5831ddb3a0caf7c7$export$4d0ba04d25a41f31)("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */ var $d3c38d6d6e53b9ed$var$FORCE_DYNAMIC = (0, $5831ddb3a0caf7c7$export$4d0ba04d25a41f31)("[[ai_frcDynCfg_1]]");
function $d3c38d6d6e53b9ed$export$36c4765ffcb8ffc1(source) {
    if (source) {
        var target_1;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(source)) {
            target_1 = [];
            target_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] = source[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
        } else if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(source)) target_1 = {};
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(source, function(key, value) {
                // Perform a deep copy of the object
                target_1[key] = $d3c38d6d6e53b9ed$export$36c4765ffcb8ffc1(value);
            });
            return target_1;
        }
    }
    return source;
}
function $d3c38d6d6e53b9ed$export$ebfc7adde882cbe6(value) {
    if (value) {
        var handler = value[$d3c38d6d6e53b9ed$export$3af51e1f665d1d72] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[$d3c38d6d6e53b9ed$export$3af51e1f665d1d72] === handler)) return handler;
    }
    return null;
}
function $d3c38d6d6e53b9ed$export$9ab6a1069e1e797e(value) {
    if (value && ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value))) try {
        value[$d3c38d6d6e53b9ed$var$BLOCK_DYNAMIC] = true;
    } catch (e) {
    // Don't throw for this case as it's an ask only
    }
    return value;
}
function $d3c38d6d6e53b9ed$export$89d2831ef182f832(value) {
    if (value) try {
        value[$d3c38d6d6e53b9ed$var$FORCE_DYNAMIC] = true;
    } catch (e) {
    // Don't throw for this case as it's an ask only
    }
    return value;
}
function $d3c38d6d6e53b9ed$export$d4b814eca8f802e7(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[$d3c38d6d6e53b9ed$var$FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[$d3c38d6d6e53b9ed$var$BLOCK_DYNAMIC]) // Only convert plain objects or arrays by default
        result = (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) || (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(value);
    }
    return result;
}
function $d3c38d6d6e53b9ed$export$e2aa058b2c3c7959(message) {
    (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("InvalidAccess:" + message);
}


var $20d06ced4f112551$var$arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var $20d06ced4f112551$export$6103ab389f3208de = function(logger, name, desc, e) {
    logger && logger[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](3 /* eLoggingSeverity.DEBUG */ , 108 /* _eInternalMessageId.DynamicConfigException */ , "".concat(desc, " [").concat(name, "] failed - ") + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
};
function $20d06ced4f112551$var$_patchArray(state, target, name) {
    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(target)) // Monkey Patch the methods that might change the array
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)($20d06ced4f112551$var$arrayMethodsToPatch, function(method) {
        var orgMethod = target[method];
        target[method] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var result = orgMethod[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](this, args);
            // items may be added, removed or moved so need to make some new dynamic properties
            $20d06ced4f112551$export$f24b4ed0a40d3d27(state, target, name, "Patching");
            return result;
        };
    });
}
function $20d06ced4f112551$var$_getOwnPropGetter(target, name) {
    var propDesc = (0, $5831ddb3a0caf7c7$export$1bd5e8b059facbe9)(target, name);
    return propDesc && propDesc.get;
}
function $20d06ced4f112551$var$_createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function(handler) {
            if (handler && handler.fn) {
                if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(detail.h, handler) === -1) // Add this handler to the collection that should be notified when the value changes
                detail.h[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
                state.trk(handler, detail);
            }
        },
        clr: function(handler) {
            var idx = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(detail.h, handler);
            if (idx !== -1) detail.h[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || (0, $d3c38d6d6e53b9ed$export$d4b814eca8f802e7)(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72] && isObjectOrArray) // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
            value = $20d06ced4f112551$export$f24b4ed0a40d3d27(state, value, name, "Converting");
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) detail.trk(activeHandler);
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function() {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) // field is marked as readonly so return false
            (0, $d3c38d6d6e53b9ed$export$e2aa058b2c3c7959)("[" + name + "] is read-only:" + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(theConfig));
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || (0, $d3c38d6d6e53b9ed$export$d4b814eca8f802e7)(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(value, function(key) {
                        value[key] = newValue ? newValue[key] : (0, $aa96917b132802ee$export$a43287864529b8fd);
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(newValue, function(key, theValue) {
                            $20d06ced4f112551$export$7d85a661fa08a14d(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    } catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                } else if (value && value[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72]) // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                // for every property it has already
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(value, function(key) {
                    // Check if the value is dynamic
                    var getter = $20d06ced4f112551$var$_getOwnPropGetter(value, key);
                    if (getter) {
                        // And if it is tell it's listeners that the value has changed
                        var valueState = getter[state.prop];
                        valueState && valueState.chng();
                    }
                });
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && (0, $d3c38d6d6e53b9ed$export$d4b814eca8f802e7)(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) // As the newValue is an object/array lets preemptively make it dynamic
                newValue = $20d06ced4f112551$export$f24b4ed0a40d3d27(state, newValue, name, "Converting");
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(theConfig, detail.n, {
        g: _getProperty,
        s: _setProperty
    });
}
function $20d06ced4f112551$export$7d85a661fa08a14d(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = $20d06ced4f112551$var$_getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) $20d06ced4f112551$var$_createDynamicProperty(state, target, name, value);
        else // Looks like it's already dynamic just assign the new value
        target[name] = value;
    }
    return target;
}
function $20d06ced4f112551$export$945b6f6a011a9f7a(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = $20d06ced4f112551$var$_getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */ ];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */ ];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */ ];
        if (!isDynamic) {
            if (blkProp) try {
                // Attempt to mark the target as blocked from conversion
                (0, $d3c38d6d6e53b9ed$export$9ab6a1069e1e797e)(target);
            } catch (e) {
                $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "Blocking", e);
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                $20d06ced4f112551$export$7d85a661fa08a14d(state, target, name, target[name]);
                getter = $20d06ced4f112551$var$_getOwnPropGetter(target, name);
            } catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) getter[state.rf] = inPlace;
        if (rdOnly) getter[state.ro] = rdOnly;
        if (blkProp) getter[state.blkVal] = true;
    }
    return target;
}
function $20d06ced4f112551$export$f24b4ed0a40d3d27(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(target, function(key, value) {
            // Assign and/or make the property dynamic
            $20d06ced4f112551$export$7d85a661fa08a14d(state, target, key, value);
        });
        if (!target[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72]) {
            // Link the config back to the dynamic config details
            (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(target, (0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72), {
                get: function() {
                    return state.hdlr;
                }
            });
            $20d06ced4f112551$var$_patchArray(state, target, name);
        }
    } catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        $20d06ced4f112551$export$6103ab389f3208de((state.hdlr || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], name, desc, e);
    }
    return target;
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $5fcb42e6bd7b9b68$var$aggregationErrorType;
function $5fcb42e6bd7b9b68$export$a2765bc4230e591f(message, sourceErrors) {
    if (!$5fcb42e6bd7b9b68$var$aggregationErrorType) $5fcb42e6bd7b9b68$var$aggregationErrorType = (0, $5831ddb3a0caf7c7$export$435492119a21bab3)("AggregationError", function(self, args) {
        if (args[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) // Save the provided errors
        self.errors = args[1];
    });
    var theMessage = message || "One or more errors occurred.";
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(sourceErrors, function(srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(srcError));
    });
    throw new $5fcb42e6bd7b9b68$var$aggregationErrorType(theMessage, sourceErrors || []);
}



var $4845cb9b52e402e2$var$symPrefix = "[[ai_";
var $4845cb9b52e402e2$var$symPostfix = "]]";
function $4845cb9b52e402e2$export$8b125ae28a27d4c(cfgHandler) {
    var dynamicPropertySymbol = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "get" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyReadOnly = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "ro" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyReferenced = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "rf" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyBlockValue = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "blkVal" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var dynamicPropertyDetail = (0, $5831ddb3a0caf7c7$export$70503d621eee7e7b)($4845cb9b52e402e2$var$symPrefix + "dtl" + cfgHandler.uid + $4845cb9b52e402e2$var$symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(activeHandler[dynamicPropertyDetail], function(detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler.setDf.bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler.rdOnly.bind(cfgHandler)
            });
        } catch (e) {
            var logger = cfgHandler[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ];
            if (logger) // Don't let one individual failure break everyone
            logger[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](1 /* eLoggingSeverity.CRITICAL */ , 107 /* _eInternalMessageId.ConfigWatcherException */ , (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        } finally{
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(notifyHandlers, function(handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(handler[dynamicPropertyDetail], function(detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) try {
                        _useHandler(handler, handler.fn);
                    } catch (e) {
                        // Don't let a single failing watcher cause other watches to fail
                        watcherFailures_1[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](e);
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) try {
                _notifyWatchers();
            } catch (e) {
                watcherFailures_1[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](e);
            }
            if (watcherFailures_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5fcb42e6bd7b9b68$export$a2765bc4230e591f)("Watcher error(s): ", watcherFailures_1);
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
            if (!_waitingHandlers) _waitingHandlers = [];
            if (!_watcherTimer) _watcherTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                _watcherTimer = null;
                _notifyWatchers();
            }, 0);
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for(var idx = 0; idx < detail.h[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; idx++){
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(_waitingHandlers, handler) === -1) _waitingHandlers[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(details, detail) === -1) // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
            details[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](detail);
        }
    }
    theState = {
        prop: dynamicPropertySymbol,
        ro: dynamicPropertyReadOnly,
        rf: dynamicPropertyReferenced,
        blkVal: dynamicPropertyBlockValue,
        hdlr: cfgHandler,
        add: _addWatcher,
        notify: _notifyWatchers,
        use: _useHandler,
        trk: _trackHandler
    };
    return theState;
}



/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */ function $6387583e0b25820c$var$_createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function() {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(handler, "toJSON", {
        v: function() {
            return "WatcherHandler" + (handler.fn ? "" : "[X]");
        }
    });
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */ function $6387583e0b25820c$var$_createDynamicHandler(logger, target, inPlace) {
    var dynamicHandler = (0, $d3c38d6d6e53b9ed$export$ebfc7adde882cbe6)(target);
    if (dynamicHandler) // The passed config is already dynamic so return it's tracker
    return dynamicHandler;
    var uid = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("dyncfg", true);
    var newTarget = target && inPlace !== false ? target : (0, $d3c38d6d6e53b9ed$export$36c4765ffcb8ffc1)(target);
    var theState;
    function _notifyWatchers() {
        theState.notify();
    }
    function _setValue(target, name, value) {
        try {
            target = (0, $20d06ced4f112551$export$7d85a661fa08a14d)(theState, target, name, value);
        } catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            (0, $20d06ced4f112551$export$6103ab389f3208de)(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return $6387583e0b25820c$var$_createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function(details) {
            var prevUpd = theState.upd;
            try {
                if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(allowUpdate)) theState.upd = allowUpdate;
                configHandler(details);
            } finally{
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return (0, $20d06ced4f112551$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */ ] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return (0, $20d06ced4f112551$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */ ] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return (0, $20d06ced4f112551$export$945b6f6a011a9f7a)(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */ ] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) // Resolve/apply the defaults
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defaultValues, function(name, value) {
            // Sets the value and makes it dynamic (if it doesn't already exist)
            (0, $2858d2db0bf490e5$export$f11b7d3a4617b9e9)(cfgHandler, theConfig, name, value);
        });
        return theConfig;
    }
    var cfgHandler = {
        uid: null,
        cfg: newTarget,
        logger: logger,
        notify: _notifyWatchers,
        set: _setValue,
        setDf: _applyDefaults,
        watch: _watch,
        ref: _ref,
        rdOnly: _rdOnly,
        blkVal: _blkPropValue,
        _block: _block
    };
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = (0, $4845cb9b52e402e2$export$8b125ae28a27d4c)(cfgHandler);
    // Setup tracking for all defined default keys
    (0, $20d06ced4f112551$export$f24b4ed0a40d3d27)(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 */ function $6387583e0b25820c$var$_logInvalidAccess(logger, message) {
    if (logger) {
        logger[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](message);
        logger[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](2 /* eLoggingSeverity.WARNING */ , 108 /* _eInternalMessageId.DynamicConfigException */ , message);
    } else // We don't have a logger so just throw an exception
    (0, $d3c38d6d6e53b9ed$export$e2aa058b2c3c7959)(message);
}
function $6387583e0b25820c$export$3a9e9180c14487fd(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = $6387583e0b25820c$var$_createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) dynamicHandler.setDf(dynamicHandler.cfg, defaultConfig);
    return dynamicHandler;
}
function $6387583e0b25820c$export$454a433e4deb244f(config, configHandler, logger) {
    var handler = config[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[0, $d3c38d6d6e53b9ed$export$3af51e1f665d1d72] === handler)) return handler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](configHandler);
    $6387583e0b25820c$var$_logInvalidAccess(logger, (0, $aa96917b132802ee$export$80c7dcdabc53a7db) + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(config));
    return $6387583e0b25820c$export$3a9e9180c14487fd(config, null, logger)[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](configHandler);
}



/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $2662e05d52c419bb$var$listenerFuncs = [
    (0, $aa96917b132802ee$export$bb3c4bc1b1175d3d),
    (0, $aa96917b132802ee$export$bacb5b2f4c1081b9),
    (0, $aa96917b132802ee$export$d75e063cb88a1c25),
    (0, $aa96917b132802ee$export$5d265841733c97c3)
];
var $2662e05d52c419bb$var$_aiNamespace = null;
var $2662e05d52c419bb$var$_debugListener;
function $2662e05d52c419bb$var$_listenerProxyFunc(name, config) {
    return function() {
        var args = arguments;
        var dbgExt = $2662e05d52c419bb$export$a0b1f407ae6b45dc(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) listener[name][0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](listener, args);
        }
    };
}
function $2662e05d52c419bb$var$_getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("Microsoft");
    if (target) $2662e05d52c419bb$var$_aiNamespace = target["ApplicationInsights"];
    return $2662e05d52c419bb$var$_aiNamespace;
}
function $2662e05d52c419bb$export$a0b1f407ae6b45dc(config) {
    var ns = $2662e05d52c419bb$var$_aiNamespace;
    if (!ns && config.disableDbgExt !== true) ns = $2662e05d52c419bb$var$_aiNamespace || $2662e05d52c419bb$var$_getExtensionNamespace();
    return ns ? ns["ChromeDbgExt"] : null;
}
function $2662e05d52c419bb$export$dae5ac50a0df0f5f(config) {
    if (!$2662e05d52c419bb$var$_debugListener) {
        $2662e05d52c419bb$var$_debugListener = {};
        for(var lp = 0; lp < $2662e05d52c419bb$var$listenerFuncs[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)$2662e05d52c419bb$var$_debugListener[$2662e05d52c419bb$var$listenerFuncs[lp]] = $2662e05d52c419bb$var$_listenerProxyFunc($2662e05d52c419bb$var$listenerFuncs[lp], config);
    }
    return $2662e05d52c419bb$var$_debugListener;
}




"use strict";
var $bacca83328a730a7$var$_a;
var $bacca83328a730a7$var$STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */ var $bacca83328a730a7$var$AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */ var $bacca83328a730a7$var$AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */ var $bacca83328a730a7$var$AIInternalMessagePrefix = "AITR_";
var $bacca83328a730a7$var$defaultValues = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var $bacca83328a730a7$var$_logFuncs = ($bacca83328a730a7$var$_a = {}, $bacca83328a730a7$var$_a[0 /* eLoggingSeverity.DISABLED */ ] = null, $bacca83328a730a7$var$_a[1 /* eLoggingSeverity.CRITICAL */ ] = "errorToConsole", $bacca83328a730a7$var$_a[2 /* eLoggingSeverity.WARNING */ ] = $bacca83328a730a7$var$STR_WARN_TO_CONSOLE, $bacca83328a730a7$var$_a[3 /* eLoggingSeverity.DEBUG */ ] = "debugToConsole", $bacca83328a730a7$var$_a);
function $bacca83328a730a7$var$_sanitizeDiagnosticText(text) {
    if (text) return "\"" + text[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/\"/g, (0, $aa96917b132802ee$export$5e8607ab26634759)) + "\"";
    return 0, $aa96917b132802ee$export$5e8607ab26634759;
}
function $bacca83328a730a7$var$_logToConsole(func, message) {
    var theConsole = (0, $0d2c2fb24388dcf8$export$bbe488cec1edd401)();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) logFunc = func;
        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(theConsole[logFunc])) theConsole[logFunc](message);
    }
}
var $bacca83328a730a7$export$70ef838ed08aad47 = /** @class */ function() {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) isUserAct = false;
        var _self = this;
        _self[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ] = msgId;
        _self[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ] = (isUserAct ? $bacca83328a730a7$var$AiUserActionablePrefix : $bacca83328a730a7$var$AiNonUserActionablePrefix) + msgId;
        var strProps = (0, $aa96917b132802ee$export$5e8607ab26634759);
        if ((0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) strProps = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().stringify(properties);
        var diagnosticText = (msg ? " message:" + $bacca83328a730a7$var$_sanitizeDiagnosticText(msg) : (0, $aa96917b132802ee$export$5e8607ab26634759)) + (properties ? " props:" + $bacca83328a730a7$var$_sanitizeDiagnosticText(strProps) : (0, $aa96917b132802ee$export$5e8607ab26634759));
        _self[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}();
function $bacca83328a730a7$export$5102d32ea1d740a(core, config) {
    return (core || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] || new $bacca83328a730a7$export$4f80edb2e10dc14c(config);
}
var $bacca83328a730a7$export$4f80edb2e10dc14c = /** @class */ function() {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */ this.queue = [];
        /**
         * Count of internal messages sent
         */ var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */ var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(DiagnosticLogger, this, function(_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function() {
                return _loggingLevelConsole;
            };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - The severity of the log message
             * @param message  - The log message.
             */ _self[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ] = function(severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) isUserAct = false;
                var message = new $bacca83328a730a7$export$70ef838ed08aad47(msgId, msg, isUserAct, properties);
                if (_enableDebug) throw (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(message);
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = $bacca83328a730a7$var$_logFuncs[severity] || $bacca83328a730a7$var$STR_WARN_TO_CONSOLE;
                    if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(message[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]);
                                _messageLogged[messageKey] = true;
                            }
                        } else // Only log traces if the console Logging Level is >= the throwInternal severity level
                        if (_loggingLevelConsole >= severity) _self[logFunc](message[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]);
                        _logInternalMessage(severity, message);
                    } else _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */  ? "Critical" : "Warning"), message);
                }
            };
            _self.debugToConsole = function(message) {
                $bacca83328a730a7$var$_logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ] = function(message) {
                $bacca83328a730a7$var$_logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function(message) {
                $bacca83328a730a7$var$_logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function() {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self.logInternalMessage = _logInternalMessage;
            _self[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) return;
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = $bacca83328a730a7$var$AIInternalMessagePrefix + message[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) logMessage = false;
                else _messageLogged[messageKey] = true;
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](message);
                        _messageCount++;
                        _debugExtMsg(severity === 1 /* eLoggingSeverity.CRITICAL */  ? "error" : "warn", message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new $bacca83328a730a7$export$70ef838ed08aad47(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */ , throttleLimitMessage, false);
                        _self.queue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */ ) _self.errorToConsole(throttleLimitMessage);
                        else _self[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](throttleLimitMessage);
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return (0, $6387583e0b25820c$export$454a433e4deb244f)((0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $bacca83328a730a7$var$defaultValues, _self).cfg, function(details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[0, $45806013ed348c93$export$e53d8cae4d527530 /* @min:%2eloggingLevelConsole */ ];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = (0, $2662e05d52c419bb$export$a0b1f407ae6b45dc)(config || {});
                if (dbgExt && dbgExt[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]) dbgExt[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](name, data);
            }
        });
    }
    // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.throwInternal.
    // Removed Stub for DiagnosticLogger.prototype.debugToConsole.
    // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
    // Removed Stub for DiagnosticLogger.prototype.errorToConsole.
    // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
    // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    // Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn = 1;
    return DiagnosticLogger;
}();
function $bacca83328a730a7$var$_getLogger(logger) {
    return logger || new $bacca83328a730a7$export$4f80edb2e10dc14c();
}
function $bacca83328a730a7$export$c7ca1fcbf1d310c4(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) isUserAct = false;
    $bacca83328a730a7$var$_getLogger(logger)[0, $45806013ed348c93$export$6c078c21a0c6c1ce /* @min:%2ethrowInternal */ ](severity, msgId, msg, properties, isUserAct);
}
function $bacca83328a730a7$export$25fb4cb97863f0a8(logger, message) {
    $bacca83328a730a7$var$_getLogger(logger)[0, $45806013ed348c93$export$667d3cd09d258d38 /* @min:%2ewarnToConsole */ ](message);
}
function $bacca83328a730a7$export$e15fbe42d9bc9d3d(logger, severity, message) {
    $bacca83328a730a7$var$_getLogger(logger).logInternalMessage(severity, message);
}



/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $b863566731035422$export$b889f1d4cb07c706 = "split"; // Count: 6
var $b863566731035422$export$6eae51590aaea43 = "length"; // Count: 46
var $b863566731035422$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $b863566731035422$export$3960f2eafedb8f1 = "ingestionendpoint"; // Count: 6
var $b863566731035422$export$e2818d11505fa034 = "toString"; // Count: 8
var $b863566731035422$export$596e0e0dc14a1e9b = "removeItem"; // Count: 3
var $b863566731035422$export$923606b70907833e = "message"; // Count: 5
var $b863566731035422$export$e9679ef501b0d1 = "count"; // Count: 6
var $b863566731035422$export$89a9ed6e0f1c703a = "preTriggerDate"; // Count: 4
var $b863566731035422$export$44cd8e854cee592d = "getUTCDate"; // Count: 3
var $b863566731035422$export$a318a8141fc98747 = "stringify"; // Count: 4
var $b863566731035422$export$34ec22d747521ad = "pathname"; // Count: 4
var $b863566731035422$export$859e8a055798d1af = "match"; // Count: 5
var $b863566731035422$export$89ce3552c03e8ec9 = "correlationHeaderExcludePatterns"; // Count: 2
var $b863566731035422$export$9734b0a24bf02e93 = "name"; // Count: 10
var $b863566731035422$export$e298802ab42a3b7f = "extensionConfig"; // Count: 4
var $b863566731035422$export$14814e6f9bf337b4 = "properties"; // Count: 10
var $b863566731035422$export$32fc64677eb5b7a2 = "measurements"; // Count: 9
var $b863566731035422$export$59a1581bc81a9aae = "sizeInBytes"; // Count: 4
var $b863566731035422$export$6008dba8ea08a587 = "typeName"; // Count: 5
var $b863566731035422$export$967696d490ed5a4a = "exceptions"; // Count: 5
var $b863566731035422$export$2675b0014c60aa10 = "severityLevel"; // Count: 5
var $b863566731035422$export$5bc84cbcfe97e161 = "problemGroup"; // Count: 3
var $b863566731035422$export$4b848bcab7cafe5d = "parsedStack"; // Count: 6
var $b863566731035422$export$b1b7551538b2085 = "hasFullStack"; // Count: 5
var $b863566731035422$export$7e3ee7b01672f321 = "assembly"; // Count: 4
var $b863566731035422$export$8ea03ef8a4bcfeeb = "fileName"; // Count: 9
var $b863566731035422$export$138215f6c1f0eedf = "line"; // Count: 6
var $b863566731035422$export$4fbe9901e03250d8 = "aiDataContract"; // Count: 4
var $b863566731035422$export$aa395e58f404db90 = "duration"; // Count: 4


function $3ad7e6398fcf0cbb$export$1e3742b0a5fad0e9(logger, key, map) {
    var origLength = key[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
    var field = $3ad7e6398fcf0cbb$export$100c3b44eeb2bd0b(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while(map[uniqueField] !== undefined){
            i++;
            uniqueField = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(field, 0, 147) + $3ad7e6398fcf0cbb$export$d924cb9df01a6484(i);
        }
        field = uniqueField;
    }
    return field;
}
function $3ad7e6398fcf0cbb$export$100c3b44eeb2bd0b(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$590567be997858b6)(name));
        // truncate the string to 150 chars
        if (name[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ) {
            nameTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ );
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 57 /* _eInternalMessageId.NameTooLong */ , "name is too long.  It has been truncated to 150 characters.", {
                name: name
            }, true);
        }
    }
    return nameTrunc || name;
}
function $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8(logger, value, maxLength) {
    if (maxLength === void 0) maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ;
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ; // in case default parameters dont work
        value = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$590567be997858b6)(value));
        if (value[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > maxLength) {
            valueTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, 0, maxLength);
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 61 /* _eInternalMessageId.StringValueTooLong */ , "string value is too long. It has been truncated to " + maxLength + " characters.", {
                value: value
            }, true);
        }
    }
    return valueTrunc || value;
}
function $3ad7e6398fcf0cbb$export$356146502a9f860c(logger, url, config) {
    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(url)) url = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(url, config);
    return $3ad7e6398fcf0cbb$export$8860beb3484248f1(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ , 66 /* _eInternalMessageId.UrlTooLong */ );
}
function $3ad7e6398fcf0cbb$export$dff84a9939b48dc0(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ) {
            messageTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ );
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 56 /* _eInternalMessageId.MessageTruncated */ , "message is too long, it has been truncated to 32768 characters.", {
                message: message
            }, true);
        }
    }
    return messageTrunc || message;
}
function $3ad7e6398fcf0cbb$export$e47d8a961052f8bc(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ ) {
            exceptionTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ );
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 52 /* _eInternalMessageId.ExceptionTruncated */ , "exception is too long, it has been truncated to 32768 characters.", {
                exception: exception
            }, true);
        }
    }
    return exceptionTrunc || exception;
}
function $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(properties, function(prop, value) {
            if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value) && (0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) // Stringify any part C properties
            try {
                value = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
            } catch (e) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "custom property is not valid", {
                    exception: e
                }, true);
            }
            value = $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ );
            prop = $3ad7e6398fcf0cbb$export$1e3742b0a5fad0e9(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function $3ad7e6398fcf0cbb$export$3f0e10abe91e800b(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(measurements, function(measure, value) {
            measure = $3ad7e6398fcf0cbb$export$1e3742b0a5fad0e9(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function $3ad7e6398fcf0cbb$export$808d3905d3d31f01(logger, id) {
    return id ? $3ad7e6398fcf0cbb$export$8860beb3484248f1(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */ , 69 /* _eInternalMessageId.IdTooLong */ )[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]() : id;
}
function $3ad7e6398fcf0cbb$export$8860beb3484248f1(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$590567be997858b6)(input));
        if (input[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > maxLength) {
            inputTrunc = (0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(input, 0, maxLength);
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", {
                data: input
            }, true);
        }
    }
    return inputTrunc || input;
}
function $3ad7e6398fcf0cbb$export$d924cb9df01a6484(num) {
    var s = "00" + num;
    return (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)(s, s[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] - 3);
}


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $b5e9e2ed66fb6b5a$var$_document = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)() || {};
var $b5e9e2ed66fb6b5a$var$_htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var $b5e9e2ed66fb6b5a$var$_htmlAnchorElement = [
    null,
    null,
    null,
    null,
    null
];
function $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2(url) {
    var anchorIdx = $b5e9e2ed66fb6b5a$var$_htmlAnchorIdx;
    var anchorCache = $b5e9e2ed66fb6b5a$var$_htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!$b5e9e2ed66fb6b5a$var$_document.createElement) // Always create the temp instance if createElement is not available
    tempAnchor = {
        host: $b5e9e2ed66fb6b5a$export$ff1d1b7a9bae98f(url, true)
    };
    else if (!anchorCache[anchorIdx]) // Create and cache the unattached anchor instance
    tempAnchor = anchorCache[anchorIdx] = $b5e9e2ed66fb6b5a$var$_document.createElement("a");
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]) anchorIdx = 0;
    $b5e9e2ed66fb6b5a$var$_htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function $b5e9e2ed66fb6b5a$export$a98678973ebe2123(url) {
    var result;
    var a = $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2(url);
    if (a) result = a.href;
    return result;
}
function $b5e9e2ed66fb6b5a$export$d19e0ccf7100cfb3(url) {
    var result;
    var a = $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2(url);
    if (a) result = a[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ];
    return result;
}
function $b5e9e2ed66fb6b5a$export$b959f3bc0a239498(method, absoluteUrl) {
    if (method) return method.toUpperCase() + " " + absoluteUrl;
    return absoluteUrl;
}
function $b5e9e2ed66fb6b5a$export$ff1d1b7a9bae98f(url, inclPort) {
    var fullHost = $b5e9e2ed66fb6b5a$export$eac70d47569302de(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost[0, $b863566731035422$export$859e8a055798d1af /* @min:%2ematch */ ](/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 3 && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(match[2]) && match[2][0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) return match[2] + (match[3] || "");
    }
    return fullHost;
}
function $b5e9e2ed66fb6b5a$export$eac70d47569302de(url, inclPort) {
    var result = null;
    if (url) {
        var match = url[0, $b863566731035422$export$859e8a055798d1af /* @min:%2ematch */ ](/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 2 && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(match[2]) && match[2][0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
            result = match[2] || "";
            if (inclPort && match[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 2) {
                var protocol = (match[1] || "")[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") port = "";
                else if (protocol === "https" && port === ":443") port = "";
                result += port;
            }
        }
    }
    return result;
}



// listing only non-geo specific locations
var $d98f9809e5d6a7c7$var$_internalEndpoints = [
    (0, $8ac3b4fe9182f568$export$5c9ec0fce655ebcf) + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728),
    "https://breeze.aimon.applicationinsights.io" + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728),
    "https://dc-int.services.visualstudio.com" + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728)
];
var $d98f9809e5d6a7c7$var$_correlationIdPrefix = "cid-v1:";
function $d98f9809e5d6a7c7$export$edade5317663baa4(endpointUrl) {
    return (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)($d98f9809e5d6a7c7$var$_internalEndpoints, endpointUrl[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()) !== -1;
}
function $d98f9809e5d6a7c7$export$11cd7bb42a058181(prefix) {
    $d98f9809e5d6a7c7$var$_correlationIdPrefix = prefix;
}
function $d98f9809e5d6a7c7$export$34b74e57304d137() {
    return $d98f9809e5d6a7c7$var$_correlationIdPrefix;
}
function $d98f9809e5d6a7c7$export$a62d10d7f896c08c(config, requestUrl, currentHost) {
    if (!requestUrl || config && config.disableCorrelationHeaders) return false;
    if (config && config[0, $b863566731035422$export$89ce3552c03e8ec9 /* @min:%2ecorrelationHeaderExcludePatterns */ ]) for(var i = 0; i < config.correlationHeaderExcludePatterns[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        if (config[0, $b863566731035422$export$89ce3552c03e8ec9 /* @min:%2ecorrelationHeaderExcludePatterns */ ][i].test(requestUrl)) return false;
    }
    var requestHost = (0, $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2)(requestUrl).host[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    if (requestHost && ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(requestHost, ":443") !== -1 || (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(requestHost, ":80") !== -1)) // [Bug #1260] IE can include the port even for http and https URLs so if present
    // try and parse it to remove if it matches the default protocol port
    requestHost = ((0, $b5e9e2ed66fb6b5a$export$eac70d47569302de)(requestUrl, true) || "")[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
    if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(includedDomains, function(domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) return false;
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) return true;
    for(var i = 0; i < excludedDomains[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) return false;
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
}
function $d98f9809e5d6a7c7$export$dbaf37203f788583(responseHeader) {
    if (responseHeader) {
        var correlationId = $d98f9809e5d6a7c7$export$23620a0eaa22fb00(responseHeader, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[1 /* eRequestHeaders.requestContextTargetKey */ ]);
        if (correlationId && correlationId !== $d98f9809e5d6a7c7$var$_correlationIdPrefix) return correlationId;
    }
}
function $d98f9809e5d6a7c7$export$23620a0eaa22fb00(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ](",");
        for(var i = 0; i < keyValues[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; ++i){
            var keyValue = keyValues[i][0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("=");
            if (keyValue[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 2 && keyValue[0] === key) return keyValue[1];
        }
    }
}
function $d98f9809e5d6a7c7$export$92b0aba7cb1d0e30(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        var parsedUrl = (0, $b5e9e2ed66fb6b5a$export$7121b8cb971a9df2)(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ] != null) {
                var pathName = parsedUrl.pathname[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 0 ? "/" : parsedUrl[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ];
                if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
                data = parsedUrl[0, $b863566731035422$export$34ec22d747521ad /* @min:%2epathname */ ];
                name = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, method ? method + " " + pathName : pathName);
            } else name = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, absoluteUrl);
        }
    } else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function $d98f9809e5d6a7c7$export$30a447e32c58a836() {
    // returns the window or webworker performance object
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) return now;
    }
    return (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
}
function $d98f9809e5d6a7c7$export$bfc7deb7f4f00987(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(start) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(end)) result = end - start;
    return result;
}
function $d98f9809e5d6a7c7$export$847d5dabba5fabb9(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function() {
            return trace[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace.traceID;
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $4726195e2d737947$export$29dd34cf1269f6da)(newValue)) trace.traceID = newValue;
        },
        getSpanId: function() {
            return trace.parentID;
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $4726195e2d737947$export$8e51c6d8f0586aff)(newValue)) trace.parentID = newValue;
        },
        getTraceFlags: function() {
            return trace.traceFlags;
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $21d2736f26313761$export$d5f3ec63cad061d9 = /* @__PURE__ */ (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    LocalStorage: 0 /* eStorageType.LocalStorage */ ,
    SessionStorage: 1 /* eStorageType.SessionStorage */ 
});
var $21d2736f26313761$export$29bb472f6d62625c = /* @__PURE__ */ (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    AI: 0 /* eDistributedTracingModes.AI */ ,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
    W3C: 2 /* eDistributedTracingModes.W3C */ 
});
var $21d2736f26313761$export$a34b2dc7368de4d3 = /* @__PURE__ */ (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    /**
     * Normal persistence.
     */ Normal: 1 /* EventPersistenceValue.Normal */ ,
    /**
     * Critical persistence.
     */ Critical: 2 /* EventPersistenceValue.Critical */ 
});



var $3fab9bbcce274f86$var$_canUseLocalStorage = undefined;
var $3fab9bbcce274f86$var$_canUseSessionStorage = undefined;
var $3fab9bbcce274f86$var$_storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @returns {Storage} - Returns the storage object if available else returns null
 */ function $3fab9bbcce274f86$var$_getLocalStorageObject() {
    if ($3fab9bbcce274f86$export$f28746933126d63f()) return $3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).LocalStorage);
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType - Type of storage
 * @returns {Storage} Returns storage object verified that it is usable
 */ function $3fab9bbcce274f86$var$_getVerifiedStorageObject(storageType) {
    try {
        if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)((0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)())) return null;
        var uid = (new Date)[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]();
        var storage = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)(storageType === (0, $21d2736f26313761$export$d5f3ec63cad061d9).LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = $3fab9bbcce274f86$var$_storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[0, $b863566731035422$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name_1);
        if (!fail) return storage;
    } catch (exception) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @returns {Storage} - Returns the storage object if available else returns null
 */ function $3fab9bbcce274f86$var$_getSessionStorageObject() {
    if ($3fab9bbcce274f86$export$c81985c4209bac26()) return $3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).SessionStorage);
    return null;
}
function $3fab9bbcce274f86$export$53ddd0ab7db9403() {
    $3fab9bbcce274f86$var$_canUseLocalStorage = false;
    $3fab9bbcce274f86$var$_canUseSessionStorage = false;
}
function $3fab9bbcce274f86$export$a08dccf4adbf6df9(storagePrefix) {
    $3fab9bbcce274f86$var$_storagePrefix = storagePrefix || "";
}
function $3fab9bbcce274f86$export$f08cf9bcd292b981() {
    $3fab9bbcce274f86$var$_canUseLocalStorage = $3fab9bbcce274f86$export$f28746933126d63f(true);
    $3fab9bbcce274f86$var$_canUseSessionStorage = $3fab9bbcce274f86$export$c81985c4209bac26(true);
}
function $3fab9bbcce274f86$export$f28746933126d63f(reset) {
    if (reset || $3fab9bbcce274f86$var$_canUseLocalStorage === undefined) $3fab9bbcce274f86$var$_canUseLocalStorage = !!$3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).LocalStorage);
    return $3fab9bbcce274f86$var$_canUseLocalStorage;
}
function $3fab9bbcce274f86$export$c3876355f131c85c(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getLocalStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseLocalStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */ , "Browser failed read of local storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return null;
}
function $3fab9bbcce274f86$export$631bce20500dc098(logger, name, data) {
    var storage = $3fab9bbcce274f86$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseLocalStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */ , "Browser failed write to local storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $3fab9bbcce274f86$export$63137c65c2cc6743(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage[0, $b863566731035422$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseLocalStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */ , "Browser failed removal of local storage item. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $3fab9bbcce274f86$export$c81985c4209bac26(reset) {
    if (reset || $3fab9bbcce274f86$var$_canUseSessionStorage === undefined) $3fab9bbcce274f86$var$_canUseSessionStorage = !!$3fab9bbcce274f86$var$_getVerifiedStorageObject((0, $21d2736f26313761$export$d5f3ec63cad061d9).SessionStorage);
    return $3fab9bbcce274f86$var$_canUseSessionStorage;
}
function $3fab9bbcce274f86$export$42f95336fa01d38e() {
    var keys = [];
    if ($3fab9bbcce274f86$export$c81985c4209bac26()) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("sessionStorage"), function(key) {
        keys.push(key);
    });
    return keys;
}
function $3fab9bbcce274f86$export$a398bd2f40e2eb6e(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getSessionStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseSessionStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */ , "Browser failed read of session storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return null;
}
function $3fab9bbcce274f86$export$21abea3a85fee3f5(logger, name, data) {
    var storage = $3fab9bbcce274f86$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseSessionStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */ , "Browser failed write to session storage. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}
function $3fab9bbcce274f86$export$9f411b4ea05fb92a(logger, name) {
    var storage = $3fab9bbcce274f86$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage[0, $b863566731035422$export$596e0e0dc14a1e9b /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $3fab9bbcce274f86$var$_canUseSessionStorage = false;
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */ , "Browser failed removal of session storage item. " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return false;
}



var $855be7931ba802b6$var$THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var $855be7931ba802b6$export$a6e7e472befd3464 = /** @class */ function() {
    function ThrottleMgr(core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
        _self["_getDbgPlgTargets"] = function() {
            return [
                _queue
            ];
        };
        _self.getConfig = function() {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */ _self.canThrottle = function(msgId) {
            var localObj = _getLocalStorageObjByKey(msgId);
            var cfg = _getCfgByKey(msgId);
            return _canThrottle(cfg, _canUseLocalStorage, localObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */ _self.isTriggered = function(msgId) {
            return _isTrigger(msgId);
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */ _self.isReady = function() {
            return _isReady;
        };
        /**
         * Flush all message with given message key in queue with isReady state set to true.
         * @returns if message queue is flushed
         */ _self.flush = function(msgId) {
            try {
                var queue = _getQueueByKey(msgId);
                if (queue && queue[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var items = queue.slice(0);
                    _queue[msgId] = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(items, function(item) {
                        _flushMessage(item.msgID, item[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ], item.severity, false);
                    });
                    return true;
                }
            } catch (err) {
            // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */ _self.flushAll = function() {
            try {
                if (_queue) {
                    var result_1 = true;
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(_queue, function(key) {
                        var isFlushed = _self.flush(parseInt(key));
                        result_1 = result_1 && isFlushed;
                    });
                    return result_1;
                }
            } catch (err) {
            // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady - isReady State
         * @pa
         * @returns if message queue is flushed
         */ _self.onReadyState = function(isReady, flushAll) {
            if (flushAll === void 0) flushAll = true;
            _isReady = (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(isReady) ? true : isReady;
            if (_isReady && flushAll) return _self.flushAll();
            return null;
        };
        _self.sendMessage = function(msgID, message, severity) {
            return _flushMessage(msgID, message, severity, true);
        };
        function _flushMessage(msgID, message, severity, saveUnsentMsg) {
            if (_isReady) {
                var isSampledIn = _canSampledIn(msgID);
                if (!isSampledIn) return;
                var cfg = _getCfgByKey(msgID);
                var localStorageObj = _getLocalStorageObjByKey(msgID);
                var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
                var throttled = false;
                var number = 0;
                var isTriggered = _isTrigger(msgID);
                try {
                    if (canThrottle && !isTriggered) {
                        number = (0, $5831ddb3a0caf7c7$export$e411eeaf23dccbe8)(cfg.limit.maxSendNumber, localStorageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] + 1);
                        localStorageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] = 0;
                        throttled = true;
                        _isTriggered[msgID] = true;
                        localStorageObj[0, $b863566731035422$export$89a9ed6e0f1c703a /* @min:%2epreTriggerDate */ ] = new Date();
                    } else {
                        _isTriggered[msgID] = canThrottle;
                        localStorageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] += 1;
                    }
                    var localStorageName = _getLocalStorageName(msgID);
                    _resetLocalStorage(_logger, localStorageName, localStorageObj);
                    for(var i = 0; i < number; i++)_sendMessage(msgID, _logger, message, severity);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            } else if (!!saveUnsentMsg) {
                var queue = _getQueueByKey(msgID);
                queue.push({
                    msgID: msgID,
                    message: message,
                    severity: severity
                });
            }
            return null;
        }
        function _initConfig() {
            _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
            _isTriggered = {};
            _localStorageObj = {};
            _queue = {};
            _config = {};
            _setCfgByKey(109 /* _eInternalMessageId.DefaultThrottleMsgKey */ );
            _namePrefix = (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(namePrefix) ? namePrefix : "";
            core.addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(core.config, function(details) {
                var coreConfig = details.cfg;
                _canUseLocalStorage = (0, $3fab9bbcce274f86$export$f28746933126d63f)();
                var configMgr = coreConfig.throttleMgrCfg || {};
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(configMgr, function(key, cfg) {
                    _setCfgByKey(parseInt(key), cfg);
                });
            }));
        }
        function _getCfgByKey(msgID) {
            return _config[msgID] || _config[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ];
        }
        function _setCfgByKey(msgID, config) {
            var _a, _b;
            try {
                var cfg = config || {};
                var curCfg = {};
                curCfg.disabled = !!cfg.disabled;
                var configInterval = cfg.interval || {};
                _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]) > 0;
                curCfg.interval = _getIntervalConfig(configInterval);
                var limit = {
                    samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                    // dafault: every time sent only 1 event
                    maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
                };
                curCfg.limit = limit;
                _config[msgID] = curCfg;
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
            var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
            // default: send data every 3 month each year
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(monthInterval) && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval.daysOfMonth = [
                        28
                    ];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
                dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
                daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (config && !config.disabled && canUseLocalStorage && (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj.date;
                var interval = config.interval;
                var monthCheck = 1;
                if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) dayCheck = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(interval.daysOfMonth, curDate[0, $b863566731035422$export$44cd8e854cee592d /* @min:%2egetUTCDate */ ]());
                else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
                    var daySpan = (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(prefix) ? prefix : "";
            if (msgKey) return $855be7931ba802b6$var$THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() && preTriggerDate.getUTCMonth() === curDate.getUTCMonth() && preTriggerDate[0, $b863566731035422$export$44cd8e854cee592d /* @min:%2egetUTCDate */ ]() === curDate[0, $b863566731035422$export$44cd8e854cee592d /* @min:%2egetUTCDate */ ]();
                }
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    var curObj = {
                        date: _getThrottleDate(obj.date) || storageObj.date,
                        count: obj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] || storageObj[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[0, $b863566731035422$export$89a9ed6e0f1c703a /* @min:%2epreTriggerDate */ ]) : undefined
                    };
                    return curObj;
                } else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) return date;
                } else return new Date();
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return (0, $3fab9bbcce274f86$export$631bce20500dc098)(logger, storageName, (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(JSON[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ](obj)));
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            if (interval <= 0) return 1;
            // count from start year
            return current >= start && (current - start) % interval == 0 ? (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, severity || 1 /* eLoggingSeverity.CRITICAL */ , msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn(msgID) {
            try {
                var cfg = _getCfgByKey(msgID);
                return (0, $dfdef4661b59546e$export$b2cfcb5c32671fa4)(1000000) <= cfg.limit.samplingRate;
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _getLocalStorageObjByKey(key) {
            try {
                var curObj = _localStorageObj[key];
                if (!curObj) {
                    var localStorageName = _getLocalStorageName(key, _namePrefix);
                    curObj = _getLocalStorageObj((0, $3fab9bbcce274f86$export$c3876355f131c85c)(_logger, localStorageName), _logger, localStorageName);
                    _localStorageObj[key] = curObj;
                }
                return _localStorageObj[key];
            } catch (e) {
            // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _isTrigger(key) {
            var isTrigger = _isTriggered[key];
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(isTrigger)) {
                isTrigger = false;
                var localStorageObj = _getLocalStorageObjByKey(key);
                if (localStorageObj) isTrigger = _isTriggeredOnCurDate(localStorageObj[0, $b863566731035422$export$89a9ed6e0f1c703a /* @min:%2epreTriggerDate */ ]);
                _isTriggered[key] = isTrigger;
            }
            return _isTriggered[key];
        }
        function _getQueueByKey(key) {
            _queue = _queue || {};
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_queue[key])) _queue[key] = [];
            return _queue[key];
        }
    }
    return ThrottleMgr;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $ca7f93f92bf1443c$var$_FIELDS_SEPARATOR = ";";
var $ca7f93f92bf1443c$var$_FIELD_KEY_VALUE_SEPARATOR = "=";
function $ca7f93f92bf1443c$export$6369f286b474466d(connectionString) {
    if (!connectionString) return {};
    var kvPairs = connectionString[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($ca7f93f92bf1443c$var$_FIELDS_SEPARATOR);
    var result = (0, $5831ddb3a0caf7c7$export$a16e2b23dbd5466c)(kvPairs, function(fields, kv) {
        var kvParts = kv[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]($ca7f93f92bf1443c$var$_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 2) {
            var key = kvParts[0][0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(result)[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // apply the default endpoints
            var locationPrefix = result.location ? result.location + "." : "";
            result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
        }
        // apply user override endpoint or the default endpoints
        result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] || (0, $8ac3b4fe9182f568$export$5c9ec0fce655ebcf);
        if ((0, $5831ddb3a0caf7c7$export$5222b9460f3ddbec)(result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ], "/")) result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ] = result[0, $b863566731035422$export$3960f2eafedb8f1 /* @min:%2eingestionendpoint */ ].slice(0, -1);
    }
    return result;
}
var $ca7f93f92bf1443c$export$9fc8be9be2105769 = {
    parse: $ca7f93f92bf1443c$export$6369f286b474466d
};




/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $9a1ea820994e6e6d$export$4e2d65a9843399df = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self.data = data;
        _self.time = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date());
        _self[0, $b863566731035422$export$4fbe9901e03250d8 /* @min:%2eaiDataContract */ ] = {
            time: 1 /* FieldType.Required */ ,
            iKey: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            sampleRate: function() {
                return _this.sampleRate === 100 ? 4 /* FieldType.Hidden */  : 1 /* FieldType.Required */ ;
            },
            tags: 1 /* FieldType.Required */ ,
            data: 1 /* FieldType.Required */ 
        };
    }
    return Envelope;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $62713924cc3cd966$export$d61e24a684f9e51 = /** @class */ function() {
    /**
     * Constructs a new instance of the EventTelemetry object
     */ function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 





// These Regex covers the following patterns
// 1. Chrome/Firefox/IE/Edge:
//    at functionName (filename:lineNumber:columnNumber)
//    at functionName (filename:lineNumber)
//    at filename:lineNumber:columnNumber
//    at filename:lineNumber
//    at functionName@filename:lineNumber:columnNumber
// 2. Safari / Opera:
//    functionName@filename:lineNumber:columnNumber
//    functionName@filename:lineNumber
//    filename:lineNumber:columnNumber
//    filename:lineNumber
//    Line ## of scriptname script filename:lineNumber:columnNumber
//    Line ## of scriptname script filename
// 3. IE/Edge (Additional formats)
//    at functionName@filename:lineNumber
var $a35c931c4df783c8$var$STACKFRAME_BASE_SIZE = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
/**
 * Check if the string conforms to what looks like a stack frame line and not just a general message
 * comment or other non-stack related info.
 *
 * This  should be used to filter out any leading "message" lines from a stack trace, before attempting to parse
 * the individual stack frames. Once you have estabilsted the start of the stack frames you can then use the
 * FULL_STACK_FRAME_1, FULL_STACK_FRAME_2, FULL_STACK_FRAME_3, and EXTRACT_FILENAME to parse the individual
 * stack frames to extract the method, filename, line number, and column number.
 * These may still provide invalid matches, so the sequence of execution is important to avoid providing
 * an invalid parsed stack.
 */ var $a35c931c4df783c8$var$IS_FRAME = /^\s{0,50}(from\s|at\s|Line\s{1,5}\d{1,10}\s{1,5}of|\w{1,50}@\w{1,80}|[^\(\s\n]+:[0-9\?]+(?::[0-9\?]+)?)/;
/**
 * Parse a well formed stack frame with both the line and column numbers
 * ----------------------------------
 * **Primary focus of the matching**
 * - at functionName (filename:lineNumber:columnNumber)
 * - at filename:lineNumber:columnNumber
 * - at functionName@filename:lineNumber:columnNumber
 * - functionName (filename:lineNumber:columnNumber)
 * - filename:lineNumber:columnNumber
 * - functionName@filename:lineNumber:columnNumber
 */ var $a35c931c4df783c8$var$FULL_STACK_FRAME_1 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+):([0-9\?]+)\)?$/;
/**
 * Parse a well formed stack frame with only a line number.
 * ----------------------------------
 * > Note: this WILL also match with line and column number, but the line number is included with the filename
 * > you should attempt to match with FULL_STACK_FRAME_1 first.
 *
 * **Primary focus of the matching (run FULL_STACK_FRAME_1 first)**
 * - at functionName (filename:lineNumber)
 * - at filename:lineNumber
 * - at functionName@filename:lineNumber
 * - functionName (filename:lineNumber)
 * - filename:lineNumber
 * - functionName@filename:lineNumber
 *
 * **Secondary matches**
 * - at functionName (filename:lineNumber:columnNumber)
 * - at filename:lineNumber:columnNumber
 * - at functionName@filename:lineNumber:columnNumber
 * - functionName (filename:lineNumber:columnNumber)
 * - filename:lineNumber:columnNumber
 * - functionName@filename:lineNumber:columnNumber
 */ var $a35c931c4df783c8$var$FULL_STACK_FRAME_2 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+)\)?$/;
/**
 * Attempt to Parse a frame that doesn't include a line or column number.
 * ----------------------------------
 * > Note: this WILL also match lines with a line or line and column number, you should attempt to match with
 * both FULL_STACK_FRAME_1 and FULL_STACK_FRAME_2 first to avoid false positives.
 *
 * **Unexpected Invalid Matches** (Matches that should be avoided -- by using the FULL_STACK_FRAME_1 and FULL_STACK_FRAME_2 first)
 * - at https://localhost:44365/static/node_bundles/@microsoft/blah/js/bundle.js:144112:27
 * - at https://localhost:44365/static/node_bundles/@microsoft/blah/js/bundle.js:144112:27
 *
 * **Primary focus of the matching (run FULL_STACK_FRAME_1 first)**
 * - at functionName@filename
 * - at functionName (filename)
 * - at functionName filename
 * - at filename  <- Will actuall match this as the "method" and not the filename (care should be taken to avoid this)
 * - functionName@filename
 * - functionName (filename)
 * - functionName filename
 * - functionName
 *
 * **Secondary matches** (The line and column numbers will be included with the matched filename)
 * - at functionName (filename:lineNumber:columnNumber)
 * - at functionName (filename:lineNumber)
 * - at filename:lineNumber:columnNumber
 * - at filename:lineNumber
 * - at functionName@filename:lineNumber:columnNumber
 * - at functionName@filename:lineNumber
 * - functionName (filename:lineNumber:columnNumber)
 * - functionName (filename:lineNumber)
 * - filename:lineNumber:columnNumber
 * - filename:lineNumber
 * - functionName@filename:lineNumber:columnNumber
 * - functionName@filename:lineNumber
  */ var $a35c931c4df783c8$var$FULL_STACK_FRAME_3 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\)\]]+)\)?$/;
/**
 * Attempt to extract the filename (with or without line and column numbers) from a string.
 * ----------------------------------
 * > Note: this will only match the filename (with any line or column numbers) and will
 * > return what looks like the filename, however, it will also match random strings that
 * > look like a filename, so care should be taken to ensure that the filename is actually
 * > a filename before using it.
 * >
 * > It is recommended to use this in conjunction with the FULL_STACK_FRAME_1, FULL_STACK_FRAME_2, and FULL_STACK_FRAME_3
 * > to ensure first to reduce false matches, if all of these fail then you can use this to extract the filename from a random
 * > strings to identify any potential filename from a known stack frame line.
 *
 * **Known Invalid matching**
 *
 * This regex will basically match any "final" string of a line or one that is trailed by a comma, so this should not
 * be used as the "only" matching regex, but rather as a final fallback to extract the filename from a string.
 * If you are certain that the string line is a stack frame and not part of the exception message (lines before the stack)
 * or trailing comments, then you can use this to extract the filename and then further parse with PARSE_FILENAME_LINE_COL
 * and PARSE_FILENAME_LINE_ONLY to extract any potential the line and column numbers.
 *
 * **Primary focus of the matching**
 * - at (anonymous) @ VM60:1
 * - Line 21 of linked script file://localhost/C:/Temp/stacktrace.js
 * - Line 11 of inline#1 script in http://localhost:3000/static/js/main.206f4846.js:2:296748
 * - Line 68 of inline#2 script in file://localhost/teststack.html
 * - at Global code (http://example.com/stacktrace.js:11:1)
 */ var $a35c931c4df783c8$var$EXTRACT_FILENAME = /(?:^|\(|\s{0,10}[\w\)]+\@)?([^\(\n\s\]\)]+)(?:\:([0-9]+)(?:\:([0-9]+))?)?\)?(?:,|$)/;
/**
 * Attempt to extract the filename, line number, and column number from a string.
 */ var $a35c931c4df783c8$var$PARSE_FILENAME_LINE_COL = /([^\(\s\n]+):([0-9]+):([0-9]+)$/;
/**
 * Attempt to extract the filename and line number from a string.
 */ var $a35c931c4df783c8$var$PARSE_FILENAME_LINE_ONLY = /([^\(\s\n]+):([0-9]+)$/;
var $a35c931c4df783c8$var$NoMethod = "<no_method>";
var $a35c931c4df783c8$var$strError = "error";
var $a35c931c4df783c8$var$strStack = "stack";
var $a35c931c4df783c8$var$strStackDetails = "stackDetails";
var $a35c931c4df783c8$var$strErrorSrc = "errorSrc";
var $a35c931c4df783c8$var$strMessage = "message";
var $a35c931c4df783c8$var$strDescription = "description";
var $a35c931c4df783c8$var$_parseSequence = [
    {
        re: $a35c931c4df783c8$var$FULL_STACK_FRAME_1,
        len: 5,
        m: 1,
        fn: 2,
        ln: 3,
        col: 4
    },
    {
        chk: $a35c931c4df783c8$var$_ignoreNative,
        pre: $a35c931c4df783c8$var$_scrubAnonymous,
        re: $a35c931c4df783c8$var$FULL_STACK_FRAME_2,
        len: 4,
        m: 1,
        fn: 2,
        ln: 3
    },
    {
        re: $a35c931c4df783c8$var$FULL_STACK_FRAME_3,
        len: 3,
        m: 1,
        fn: 2,
        hdl: $a35c931c4df783c8$var$_handleFilename
    },
    {
        re: $a35c931c4df783c8$var$EXTRACT_FILENAME,
        len: 2,
        fn: 1,
        hdl: $a35c931c4df783c8$var$_handleFilename
    }
];
function $a35c931c4df783c8$var$_scrubAnonymous(frame) {
    return frame.replace(/(\(anonymous\))/, "<anonymous>");
}
function $a35c931c4df783c8$var$_ignoreNative(frame) {
    return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(frame, "[native") < 0;
}
function $a35c931c4df783c8$var$_stringify(value, convertToString) {
    var result = value;
    if (result && !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(result)) {
        if (JSON && JSON[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ]) {
            result = JSON[0, $b863566731035422$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
            if (convertToString && (!result || result === "{}")) {
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ])) result = value[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                else result = "" + value;
            }
        } else result = "" + value + " - (Missing JSON.stringify)";
    }
    return result || "";
}
function $a35c931c4df783c8$var$_formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(evtMessage)) evtMessage = theEvent[$a35c931c4df783c8$var$strMessage] || theEvent[$a35c931c4df783c8$var$strDescription] || evtMessage;
        // Make sure the message is a string
        if (evtMessage && !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(evtMessage)) // tslint:disable-next-line: prefer-conditional-expression
        evtMessage = $a35c931c4df783c8$var$_stringify(evtMessage, true);
        if (theEvent["filename"]) // Looks like an event object with filename
        evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(evtMessage || "", errorType) === -1) evtMessage = errorType + ": " + evtMessage;
    return evtMessage || "";
}
function $a35c931c4df783c8$var$_isExceptionDetailsInternal(value) {
    try {
        if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value)) return "hasFullStack" in value && "typeName" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $a35c931c4df783c8$var$_isExceptionInternal(value) {
    try {
        if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(value)) return "ver" in value && "exceptions" in value && "properties" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $a35c931c4df783c8$var$_isStackDetails(details) {
    return details && details.src && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(details.src) && details.obj && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(details.obj);
}
function $a35c931c4df783c8$var$_convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(src)) {
        if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(src[$a35c931c4df783c8$var$strStack])) src = src[$a35c931c4df783c8$var$strStack];
        else src = "" + src;
    }
    var items = src[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("\n");
    return {
        src: src,
        obj: items
    };
}
function $a35c931c4df783c8$var$_getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[0, $b863566731035422$export$b889f1d4cb07c706 /* @min:%2esplit */ ]("\n");
    for(var lp = 0; lp < lines[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function $a35c931c4df783c8$var$_getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) try {
        /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */ if (errorObj[$a35c931c4df783c8$var$strStack]) // Chrome/Firefox
        details = $a35c931c4df783c8$var$_convertStackObj(errorObj[$a35c931c4df783c8$var$strStack]);
        else if (errorObj[$a35c931c4df783c8$var$strError] && errorObj[$a35c931c4df783c8$var$strError][$a35c931c4df783c8$var$strStack]) // Edge error event provides the stack and error object
        details = $a35c931c4df783c8$var$_convertStackObj(errorObj[$a35c931c4df783c8$var$strError][$a35c931c4df783c8$var$strStack]);
        else if (errorObj["exception"] && errorObj.exception[$a35c931c4df783c8$var$strStack]) details = $a35c931c4df783c8$var$_convertStackObj(errorObj.exception[$a35c931c4df783c8$var$strStack]);
        else if ($a35c931c4df783c8$var$_isStackDetails(errorObj)) details = errorObj;
        else if ($a35c931c4df783c8$var$_isStackDetails(errorObj[$a35c931c4df783c8$var$strStackDetails])) details = errorObj[$a35c931c4df783c8$var$strStackDetails];
        else if ((0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)() && (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)()["opera"] && errorObj[$a35c931c4df783c8$var$strMessage]) // Opera
        details = $a35c931c4df783c8$var$_getOperaStack(errorObj[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ]);
        else if (errorObj["reason"] && errorObj.reason[$a35c931c4df783c8$var$strStack]) // UnhandledPromiseRejection
        details = $a35c931c4df783c8$var$_convertStackObj(errorObj.reason[$a35c931c4df783c8$var$strStack]);
        else if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(errorObj)) details = $a35c931c4df783c8$var$_convertStackObj(errorObj);
        else {
            var evtMessage = errorObj[$a35c931c4df783c8$var$strMessage] || errorObj[$a35c931c4df783c8$var$strDescription] || "";
            if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(errorObj[$a35c931c4df783c8$var$strErrorSrc])) {
                if (evtMessage) evtMessage += "\n";
                evtMessage += " from " + errorObj[$a35c931c4df783c8$var$strErrorSrc];
            }
            if (evtMessage) details = $a35c931c4df783c8$var$_convertStackObj(evtMessage);
        }
    } catch (e) {
        // something unexpected happened so to avoid failing to report any error lets swallow the exception
        // and fallback to the callee/caller method
        details = $a35c931c4df783c8$var$_convertStackObj(e);
    }
    return details || {
        src: "",
        obj: null
    };
}
function $a35c931c4df783c8$var$_formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) stack = stackDetails.obj.join("\n");
        else stack = stackDetails.src || "";
    }
    return stack;
}
function $a35c931c4df783c8$var$_parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var foundStackStart_1 = false;
        var totalSizeInBytes_1 = 0;
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(frames, function(frame) {
            if (foundStackStart_1 || $a35c931c4df783c8$var$_isStackFrame(frame)) {
                var theFrame = (0, $5831ddb3a0caf7c7$export$590567be997858b6)(frame);
                // Once we have found the first stack frame we treat the rest of the lines as part of the stack
                foundStackStart_1 = true;
                var parsedFrame = $a35c931c4df783c8$export$678b545205753cf6(theFrame, level_1);
                if (parsedFrame) {
                    totalSizeInBytes_1 += parsedFrame[0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                    parsedStack.push(parsedFrame);
                    level_1++;
                }
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32768;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while(left < right){
                // check size
                var lSize = parsedStack[left][0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                var rSize = parsedStack[right][0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function $a35c931c4df783c8$var$_getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] || "";
        if (!typeName) try {
            var funcNameRegex = /function (.{1,200})\(/;
            var results = funcNameRegex.exec(errorType.constructor[0, $b863566731035422$export$e2818d11505fa034 /* @min:%2etoString */ ]());
            typeName = results && results[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 1 ? results[1] : "";
        } catch (e) {
        // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    return typeName;
}
function $a35c931c4df783c8$export$7eb96e918bb60d21(errorObj) {
    if (errorObj) try {
        if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(errorObj)) {
            var errorType = $a35c931c4df783c8$var$_getErrorType(errorObj);
            var result = $a35c931c4df783c8$var$_stringify(errorObj, false);
            if (!result || result === "{}") {
                if (errorObj[$a35c931c4df783c8$var$strError]) {
                    // Looks like an MS Error Event
                    errorObj = errorObj[$a35c931c4df783c8$var$strError];
                    errorType = $a35c931c4df783c8$var$_getErrorType(errorObj);
                }
                result = $a35c931c4df783c8$var$_stringify(errorObj, true);
            }
            if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(result, errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
            return result;
        }
    } catch (e) {
    // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var $a35c931c4df783c8$export$e2f174de097e0bcd = /** @class */ function() {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */ function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            exceptions: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!$a35c931c4df783c8$var$_isExceptionInternal(exception)) {
            if (!properties) properties = {};
            if (id) properties.id = id;
            _self[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] = [
                $a35c931c4df783c8$export$a816c6f88f6bf844(logger, exception, properties)
            ];
            _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
            _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
            if (severityLevel) _self[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = severityLevel;
            if (id) _self.id = id;
        } else {
            _self[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] = exception[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] || [];
            _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = exception[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ];
            _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = exception[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ];
            if (exception[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ]) _self[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = exception[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ];
            if (exception.id) {
                _self.id = exception.id;
                exception[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ].id = exception.id;
            }
            if (exception[0, $b863566731035422$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ]) _self[0, $b863566731035422$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ] = exception[0, $b863566731035422$export$5bc84cbcfe97e161 /* @min:%2eproblemGroup */ ];
            // bool/int types, use isNullOrUndefined
            if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(exception.isManual)) _self.isManual = exception.isManual;
        }
    }
    Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = $a35c931c4df783c8$var$_getErrorType(error || evt || message);
        return {
            message: $a35c931c4df783c8$var$_formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: $a35c931c4df783c8$export$7eb96e918bb60d21(error || evt || message),
            evt: $a35c931c4df783c8$export$7eb96e918bb60d21(evt || message),
            typeName: errorType,
            stackDetails: $a35c931c4df783c8$var$_getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
        var exceptions = exception[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ] && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(exception[0, $b863566731035422$export$967696d490ed5a4a /* @min:%2eexceptions */ ], function(ex) {
            return $a35c931c4df783c8$export$fa1546fec9d4582(logger, ex);
        });
        var exceptionData = new Exception(logger, (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, exception), {
            exceptions: exceptions
        }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function() {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(exceptions, function(exception) {
            return exception.toInterface();
        }) || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */ Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {}, _a[0, $b863566731035422$export$b1b7551538b2085 /* @min:hasFullStack */ ] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = $a35c931c4df783c8$export$7eb96e918bb60d21;
    return Exception;
}();
var $a35c931c4df783c8$var$exDetailsAiDataContract = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)({
    id: 0 /* FieldType.Default */ ,
    outerId: 0 /* FieldType.Default */ ,
    typeName: 1 /* FieldType.Required */ ,
    message: 1 /* FieldType.Required */ ,
    hasFullStack: 0 /* FieldType.Default */ ,
    stack: 0 /* FieldType.Default */ ,
    parsedStack: 2 /* FieldType.Array */ 
});
function $a35c931c4df783c8$var$_toInterface() {
    var _self = this;
    var parsedStack = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(_self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ]) && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(_self[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
        return $a35c931c4df783c8$export$b94f11a3f27f4b2a(frame);
    });
    var exceptionDetailsInterface = {
        id: _self.id,
        outerId: _self.outerId,
        typeName: _self[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ],
        message: _self[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ],
        hasFullStack: _self[0, $b863566731035422$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ],
        stack: _self[$a35c931c4df783c8$var$strStack],
        parsedStack: parsedStack || undefined
    };
    return exceptionDetailsInterface;
}
function $a35c931c4df783c8$export$a816c6f88f6bf844(logger, exception, properties) {
    var _a;
    var id;
    var outerId;
    var typeName;
    var message;
    var hasFullStack;
    var theStack;
    var parsedStack;
    if (!$a35c931c4df783c8$var$_isExceptionDetailsInternal(exception)) {
        var error = exception;
        var evt = error && error.evt;
        if (!(0, $5831ddb3a0caf7c7$export$e6127cc7fe7395c3)(error)) error = error[$a35c931c4df783c8$var$strError] || evt || error;
        typeName = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, $a35c931c4df783c8$var$_getErrorType(error)) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        message = (0, $3ad7e6398fcf0cbb$export$dff84a9939b48dc0)(logger, $a35c931c4df783c8$var$_formatMessage(exception || error, typeName)) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        var stack = exception[$a35c931c4df783c8$var$strStackDetails] || $a35c931c4df783c8$var$_getStackFromErrorObj(exception);
        parsedStack = $a35c931c4df783c8$var$_parseStack(stack);
        // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(parsedStack)) (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(parsedStack, function(frame) {
            frame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, frame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ]);
            frame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, frame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ]);
        });
        theStack = (0, $3ad7e6398fcf0cbb$export$e47d8a961052f8bc)(logger, $a35c931c4df783c8$var$_formatStackTrace(stack));
        hasFullStack = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(parsedStack) && parsedStack[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
        if (properties) properties[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ] = properties[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ] || typeName;
    } else {
        typeName = exception[0, $b863566731035422$export$6008dba8ea08a587 /* @min:%2etypeName */ ];
        message = exception[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ];
        theStack = exception[$a35c931c4df783c8$var$strStack];
        parsedStack = exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ] || [];
        hasFullStack = exception[0, $b863566731035422$export$b1b7551538b2085 /* @min:%2ehasFullStack */ ];
    }
    return _a = {}, _a[0, $b863566731035422$export$4fbe9901e03250d8 /* @min:aiDataContract */ ] = $a35c931c4df783c8$var$exDetailsAiDataContract, _a.id = id, _a.outerId = outerId, _a.typeName = typeName, _a.message = message, _a[0, $b863566731035422$export$b1b7551538b2085 /* @min:hasFullStack */ ] = hasFullStack, _a.stack = theStack, _a.parsedStack = parsedStack, _a.toInterface = $a35c931c4df783c8$var$_toInterface, _a;
}
function $a35c931c4df783c8$export$fa1546fec9d4582(logger, exception) {
    var parsedStack = (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ]) && (0, $5831ddb3a0caf7c7$export$76f1a28030e24fa6)(exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ], function(frame) {
        return $a35c931c4df783c8$var$_stackFrameFromInterface(frame);
    }) || exception[0, $b863566731035422$export$4b848bcab7cafe5d /* @min:%2eparsedStack */ ];
    var exceptionDetails = $a35c931c4df783c8$export$a816c6f88f6bf844(logger, (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, exception), {
        parsedStack: parsedStack
    }));
    return exceptionDetails;
}
function $a35c931c4df783c8$var$_parseFilename(theFrame, fileName) {
    var lineCol = fileName[0, $b863566731035422$export$859e8a055798d1af /* @min:%2ematch */ ]($a35c931c4df783c8$var$PARSE_FILENAME_LINE_COL);
    if (lineCol && lineCol[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] >= 4) {
        theFrame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = lineCol[1];
        theFrame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = parseInt(lineCol[2]);
    } else {
        var lineNo = fileName[0, $b863566731035422$export$859e8a055798d1af /* @min:%2ematch */ ]($a35c931c4df783c8$var$PARSE_FILENAME_LINE_ONLY);
        if (lineNo && lineNo[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] >= 3) {
            theFrame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = lineNo[1];
            theFrame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = parseInt(lineNo[2]);
        } else theFrame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = fileName;
    }
}
function $a35c931c4df783c8$var$_handleFilename(theFrame, sequence, matches) {
    var filename = theFrame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ];
    if (sequence.fn && matches && matches[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > sequence.fn) {
        if (sequence.ln && matches[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] > sequence.ln) {
            filename = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[sequence.fn] || "");
            theFrame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = parseInt((0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[sequence.ln] || "")) || 0;
        } else filename = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[sequence.fn] || "");
    }
    if (filename) $a35c931c4df783c8$var$_parseFilename(theFrame, filename);
}
function $a35c931c4df783c8$var$_isStackFrame(frame) {
    var result = false;
    if (frame && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(frame)) {
        var trimmedFrame = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(frame);
        if (trimmedFrame) result = $a35c931c4df783c8$var$IS_FRAME.test(trimmedFrame);
    }
    return result;
}
var $a35c931c4df783c8$var$stackFrameAiDataContract = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)({
    level: 1 /* FieldType.Required */ ,
    method: 1 /* FieldType.Required */ ,
    assembly: 0 /* FieldType.Default */ ,
    fileName: 0 /* FieldType.Default */ ,
    line: 0 /* FieldType.Default */ 
});
function $a35c931c4df783c8$export$678b545205753cf6(frame, level) {
    var _a;
    var theFrame;
    if (frame && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(frame) && (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(frame)) {
        theFrame = (_a = {}, _a[0, $b863566731035422$export$4fbe9901e03250d8 /* @min:aiDataContract */ ] = $a35c931c4df783c8$var$stackFrameAiDataContract, _a.level = level, _a.assembly = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(frame), _a.method = $a35c931c4df783c8$var$NoMethod, _a.fileName = "", _a.line = 0, _a.sizeInBytes = 0, _a);
        var idx = 0;
        while(idx < $a35c931c4df783c8$var$_parseSequence[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ]){
            var sequence = $a35c931c4df783c8$var$_parseSequence[idx];
            if (sequence.chk && !sequence.chk(frame)) break;
            if (sequence.pre) frame = sequence.pre(frame);
            // Attempt to "parse" the stack frame
            var matches = frame[0, $b863566731035422$export$859e8a055798d1af /* @min:%2ematch */ ](sequence.re);
            if (matches && matches[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] >= sequence.len) {
                if (sequence.m) theFrame.method = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[sequence.m] || $a35c931c4df783c8$var$NoMethod);
                if (sequence.hdl) // Run any custom handler
                sequence.hdl(theFrame, sequence, matches);
                else if (sequence.fn) {
                    if (sequence.ln) {
                        theFrame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[sequence.fn] || "");
                        theFrame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ] = parseInt((0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(matches[sequence.ln] || "")) || 0;
                    } else $a35c931c4df783c8$var$_parseFilename(theFrame, matches[sequence.fn] || "");
                }
                break;
            }
            idx++;
        }
    }
    return $a35c931c4df783c8$var$_populateFrameSizeInBytes(theFrame);
}
function $a35c931c4df783c8$var$_stackFrameFromInterface(frame) {
    var _a;
    var parsedFrame = (_a = {}, _a[0, $b863566731035422$export$4fbe9901e03250d8 /* @min:aiDataContract */ ] = $a35c931c4df783c8$var$stackFrameAiDataContract, _a.level = frame.level, _a.method = frame.method, _a.assembly = frame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ], _a.fileName = frame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ], _a.line = frame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ], _a.sizeInBytes = 0, _a);
    return $a35c931c4df783c8$var$_populateFrameSizeInBytes(parsedFrame);
}
function $a35c931c4df783c8$var$_populateFrameSizeInBytes(frame) {
    var sizeInBytes = $a35c931c4df783c8$var$STACKFRAME_BASE_SIZE;
    if (frame) {
        sizeInBytes += frame.method[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        sizeInBytes += frame.assembly[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        sizeInBytes += frame.fileName[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        sizeInBytes += frame.level.toString()[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        sizeInBytes += frame.line.toString()[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ];
        frame[0, $b863566731035422$export$59a1581bc81a9aae /* @min:%2esizeInBytes */ ] = sizeInBytes;
    }
    return frame;
}
function $a35c931c4df783c8$export$b94f11a3f27f4b2a(frame) {
    return {
        level: frame.level,
        method: frame.method,
        assembly: frame[0, $b863566731035422$export$7e3ee7b01672f321 /* @min:%2eassembly */ ],
        fileName: frame[0, $b863566731035422$export$8ea03ef8a4bcfeeb /* @min:%2efileName */ ],
        line: frame[0, $b863566731035422$export$138215f6c1f0eedf /* @min:%2eline */ ]
    };
}


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1b80a12d00de7474$export$7e0232b0f089a6b8 = /** @class */ function() {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            name: 1 /* FieldType.Required */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 1 /* FieldType.Required */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ 
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */ this.kind = 0 /* DataPointType.Measurement */ ;
    }
    return DataPoint;
}();



var $5db807982a2eef93$export$efdd3e096bc27746 = /** @class */ function() {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */ function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            metrics: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new (0, $1b80a12d00de7474$export$7e0232b0f089a6b8)();
        dataPoint[0, $b863566731035422$export$e9679ef501b0d1 /* @min:%2ecount */ ] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [
            dataPoint
        ];
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $7c0ecef5df4b34f7$var$strEmpty = "";
function $7c0ecef5df4b34f7$export$4e47185aa280358c(str, defaultValue) {
    if (defaultValue === void 0) defaultValue = false;
    if (str === undefined || str === null) return defaultValue;
    return str.toString()[0, $b863566731035422$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "true";
}
function $7c0ecef5df4b34f7$export$4460ed97e7c4a927(totalms) {
    if (isNaN(totalms) || totalms < 0) totalms = 0;
    totalms = (0, $5831ddb3a0caf7c7$export$42cacde8c45786ff)(totalms);
    var ms = $7c0ecef5df4b34f7$var$strEmpty + totalms % 1000;
    var sec = $7c0ecef5df4b34f7$var$strEmpty + (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(totalms / 1000) % 60;
    var min = $7c0ecef5df4b34f7$var$strEmpty + (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(totalms / 60000) % 60;
    var hour = $7c0ecef5df4b34f7$var$strEmpty + (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(totalms / 3600000) % 24;
    var days = (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(totalms / 86400000);
    ms = ms[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 1 ? "00" + ms : ms[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] === 2 ? "0" + ms : ms;
    sec = sec[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + sec : sec;
    min = min[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + min : min;
    hour = hour[0, $b863566731035422$export$6eae51590aaea43 /* @min:%2elength */ ] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : $7c0ecef5df4b34f7$var$strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function $7c0ecef5df4b34f7$export$80a37ba429dff231(extensions, identifier) {
    var extension = null;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(extensions, function(value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function $7c0ecef5df4b34f7$export$8c465f5f14327ccd(message, url, lineNumber, columnNumber, error) {
    return !error && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(message) && (message === "Script error." || message === "Script error");
}




var $3e77672805d15946$export$12c0fdede1c6bc6c = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            id: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = (0, $3ad7e6398fcf0cbb$export$808d3905d3d31f01)(logger, id);
        _self.url = (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(logger, url);
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        if (!isNaN(durationMs)) _self[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(durationMs);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $97ca5e424f1910ef$export$a7b48490930dbffa = /** @class */ function() {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */ function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) requestAPI = "Ajax";
        this.aiDataContract = {
            id: 1 /* FieldType.Required */ ,
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            resultCode: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            success: 0 /* FieldType.Default */ ,
            data: 0 /* FieldType.Default */ ,
            target: 0 /* FieldType.Default */ ,
            type: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 0 /* FieldType.Default */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ ,
            dependencyKind: 0 /* FieldType.Default */ ,
            dependencySource: 0 /* FieldType.Default */ ,
            commandName: 0 /* FieldType.Default */ ,
            dependencyTypeName: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, requestAPI);
        var dependencyFields = (0, $d98f9809e5d6a7c7$export$92b0aba7cb1d0e30)(logger, absoluteUrl, method, commandName);
        _self.data = (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, dependencyFields.target);
        if (correlationContext) _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, dependencyFields[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $adb0678ebd5d1780$export$78e1bea9036f120f = /** @class */ function() {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */ function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        message = message || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self[0, $b863566731035422$export$923606b70907833e /* @min:%2emessage */ ] = (0, $3ad7e6398fcf0cbb$export$dff84a9939b48dc0)(logger, message);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
        if (severityLevel) _self[0, $b863566731035422$export$2675b0014c60aa10 /* @min:%2eseverityLevel */ ] = severityLevel;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $03ee94b6fff0696e$export$709aae57ec681346 = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            perfTotal: 0 /* FieldType.Default */ ,
            networkConnect: 0 /* FieldType.Default */ ,
            sentRequest: 0 /* FieldType.Default */ ,
            receivedResponse: 0 /* FieldType.Default */ ,
            domProcessing: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.url = (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(logger, url);
        _self[0, $b863566731035422$export$9734b0a24bf02e93 /* @min:%2ename */ ] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
        _self[0, $b863566731035422$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] = (0, $3ad7e6398fcf0cbb$export$efba9e468fe3b2cf)(logger, properties);
        _self[0, $b863566731035422$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] = (0, $3ad7e6398fcf0cbb$export$3f0e10abe91e800b)(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ] = cs4BaseData[0, $b863566731035422$export$aa395e58f404db90 /* @min:%2eduration */ ];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self.receivedResponse = cs4BaseData.receivedResponse;
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1b13bacff23d2e52$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            baseType: 1 /* FieldType.Required */ ,
            baseData: 1 /* FieldType.Required */ 
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}();




/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

function $24e80801a3d6c8ab$var$_aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function(name) {
        return aiName + name;
    };
}
var $24e80801a3d6c8ab$var$_aiApplication = $24e80801a3d6c8ab$var$_aiNameFunc("application");
var $24e80801a3d6c8ab$var$_aiDevice = $24e80801a3d6c8ab$var$_aiNameFunc("device");
var $24e80801a3d6c8ab$var$_aiLocation = $24e80801a3d6c8ab$var$_aiNameFunc("location");
var $24e80801a3d6c8ab$var$_aiOperation = $24e80801a3d6c8ab$var$_aiNameFunc("operation");
var $24e80801a3d6c8ab$var$_aiSession = $24e80801a3d6c8ab$var$_aiNameFunc("session");
var $24e80801a3d6c8ab$var$_aiUser = $24e80801a3d6c8ab$var$_aiNameFunc("user");
var $24e80801a3d6c8ab$var$_aiCloud = $24e80801a3d6c8ab$var$_aiNameFunc("cloud");
var $24e80801a3d6c8ab$var$_aiInternal = $24e80801a3d6c8ab$var$_aiNameFunc("internal");
var $24e80801a3d6c8ab$export$8e2bcdf18620784a = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}((0, $ede407819d2d28c9$export$f0facb5bce2741f0)({
    applicationVersion: $24e80801a3d6c8ab$var$_aiApplication("ver"),
    applicationBuild: $24e80801a3d6c8ab$var$_aiApplication("build"),
    applicationTypeId: $24e80801a3d6c8ab$var$_aiApplication("typeId"),
    applicationId: $24e80801a3d6c8ab$var$_aiApplication("applicationId"),
    applicationLayer: $24e80801a3d6c8ab$var$_aiApplication("layer"),
    deviceId: $24e80801a3d6c8ab$var$_aiDevice("id"),
    deviceIp: $24e80801a3d6c8ab$var$_aiDevice("ip"),
    deviceLanguage: $24e80801a3d6c8ab$var$_aiDevice("language"),
    deviceLocale: $24e80801a3d6c8ab$var$_aiDevice("locale"),
    deviceModel: $24e80801a3d6c8ab$var$_aiDevice("model"),
    deviceFriendlyName: $24e80801a3d6c8ab$var$_aiDevice("friendlyName"),
    deviceNetwork: $24e80801a3d6c8ab$var$_aiDevice("network"),
    deviceNetworkName: $24e80801a3d6c8ab$var$_aiDevice("networkName"),
    deviceOEMName: $24e80801a3d6c8ab$var$_aiDevice("oemName"),
    deviceOS: $24e80801a3d6c8ab$var$_aiDevice("os"),
    deviceOSVersion: $24e80801a3d6c8ab$var$_aiDevice("osVersion"),
    deviceRoleInstance: $24e80801a3d6c8ab$var$_aiDevice("roleInstance"),
    deviceRoleName: $24e80801a3d6c8ab$var$_aiDevice("roleName"),
    deviceScreenResolution: $24e80801a3d6c8ab$var$_aiDevice("screenResolution"),
    deviceType: $24e80801a3d6c8ab$var$_aiDevice("type"),
    deviceMachineName: $24e80801a3d6c8ab$var$_aiDevice("machineName"),
    deviceVMName: $24e80801a3d6c8ab$var$_aiDevice("vmName"),
    deviceBrowser: $24e80801a3d6c8ab$var$_aiDevice("browser"),
    deviceBrowserVersion: $24e80801a3d6c8ab$var$_aiDevice("browserVersion"),
    locationIp: $24e80801a3d6c8ab$var$_aiLocation("ip"),
    locationCountry: $24e80801a3d6c8ab$var$_aiLocation("country"),
    locationProvince: $24e80801a3d6c8ab$var$_aiLocation("province"),
    locationCity: $24e80801a3d6c8ab$var$_aiLocation("city"),
    operationId: $24e80801a3d6c8ab$var$_aiOperation("id"),
    operationName: $24e80801a3d6c8ab$var$_aiOperation("name"),
    operationParentId: $24e80801a3d6c8ab$var$_aiOperation("parentId"),
    operationRootId: $24e80801a3d6c8ab$var$_aiOperation("rootId"),
    operationSyntheticSource: $24e80801a3d6c8ab$var$_aiOperation("syntheticSource"),
    operationCorrelationVector: $24e80801a3d6c8ab$var$_aiOperation("correlationVector"),
    sessionId: $24e80801a3d6c8ab$var$_aiSession("id"),
    sessionIsFirst: $24e80801a3d6c8ab$var$_aiSession("isFirst"),
    sessionIsNew: $24e80801a3d6c8ab$var$_aiSession("isNew"),
    userAccountAcquisitionDate: $24e80801a3d6c8ab$var$_aiUser("accountAcquisitionDate"),
    userAccountId: $24e80801a3d6c8ab$var$_aiUser("accountId"),
    userAgent: $24e80801a3d6c8ab$var$_aiUser("userAgent"),
    userId: $24e80801a3d6c8ab$var$_aiUser("id"),
    userStoreRegion: $24e80801a3d6c8ab$var$_aiUser("storeRegion"),
    userAuthUserId: $24e80801a3d6c8ab$var$_aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: $24e80801a3d6c8ab$var$_aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: $24e80801a3d6c8ab$var$_aiUser("authUserAcquisitionDate"),
    cloudName: $24e80801a3d6c8ab$var$_aiCloud("name"),
    cloudRole: $24e80801a3d6c8ab$var$_aiCloud("role"),
    cloudRoleVer: $24e80801a3d6c8ab$var$_aiCloud("roleVer"),
    cloudRoleInstance: $24e80801a3d6c8ab$var$_aiCloud("roleInstance"),
    cloudEnvironment: $24e80801a3d6c8ab$var$_aiCloud("environment"),
    cloudLocation: $24e80801a3d6c8ab$var$_aiCloud("location"),
    cloudDeploymentUnit: $24e80801a3d6c8ab$var$_aiCloud("deploymentUnit"),
    internalNodeName: $24e80801a3d6c8ab$var$_aiInternal("nodeName"),
    internalSdkVersion: $24e80801a3d6c8ab$var$_aiInternal("sdkVersion"),
    internalAgentVersion: $24e80801a3d6c8ab$var$_aiInternal("agentVersion"),
    internalSnippet: $24e80801a3d6c8ab$var$_aiInternal("snippet"),
    internalSdkSrc: $24e80801a3d6c8ab$var$_aiInternal("sdkSrc")
}));



/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


function $f5d319867b0979c9$export$2dc41327de8d98f1(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    envelopeName = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, envelopeName) || (0, $8ac3b4fe9182f568$export$4003f5e1672d759);
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(item) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseType) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(envelopeName)) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Input doesn't contain all required fields");
    var iKey = "";
    if (item[0, $8ac3b4fe9182f568$export$7d566319b90dbb26]) {
        iKey = item[0, $8ac3b4fe9182f568$export$7d566319b90dbb26];
        delete item[0, $8ac3b4fe9182f568$export$7d566319b90dbb26];
    }
    var telemetryItem = {
        name: envelopeName,
        time: (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date()),
        iKey: iKey,
        ext: systemProperties ? systemProperties : {},
        tags: [],
        data: {},
        baseType: baseType,
        baseData: item // Part B
    };
    // Part C
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customProperties)) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(customProperties, function(prop, value) {
        telemetryItem.data[prop] = value;
    });
    return telemetryItem;
}
var $f5d319867b0979c9$export$7af32501561f3b4a = /** @class */ function() {
    function TelemetryItemCreator() {}
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item - domain specific properties; part B
     * @param baseType - telemetry item type. ie PageViewData
     * @param envelopeName - Name of the envelope (e.g., Microsoft.ApplicationInsights.[instrumentationKey].PageView).
     * @param customProperties - user defined custom properties; part C
     * @param systemProperties - system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */ TelemetryItemCreator.create = $f5d319867b0979c9$export$2dc41327de8d98f1;
    return TelemetryItemCreator;
}();


/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $6e37c6a219f9960f$export$152f4bb29f8263d0 = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var $6e37c6a219f9960f$export$ebc7727f2a4272f6 = new (0, $24e80801a3d6c8ab$export$8e2bcdf18620784a)();





/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
function $26e033f7638321e5$export$58aa8b47bf337bc8(eventName) {
    var event = null;
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(Event)) event = new Event(eventName);
    else {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}




/*
 * Application Insights JavaScript SDK - Common, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



// Added to help with minfication
var $02f0ede5277c99cd$var$strOnPrefix = "on";
var $02f0ede5277c99cd$var$strAttachEvent = "attachEvent";
var $02f0ede5277c99cd$var$strAddEventHelper = "addEventListener";
var $02f0ede5277c99cd$var$strDetachEvent = "detachEvent";
var $02f0ede5277c99cd$var$strRemoveEventListener = "removeEventListener";
var $02f0ede5277c99cd$var$strEvents = "events";
var $02f0ede5277c99cd$var$strVisibilityChangeEvt = "visibilitychange";
var $02f0ede5277c99cd$var$strPageHide = "pagehide";
var $02f0ede5277c99cd$var$strPageShow = "pageshow";
var $02f0ede5277c99cd$var$strUnload = "unload";
var $02f0ede5277c99cd$var$strBeforeUnload = "beforeunload";
var $02f0ede5277c99cd$var$strPageHideNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("aiEvtPageHide");
var $02f0ede5277c99cd$var$strPageShowNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("aiEvtPageShow");
var $02f0ede5277c99cd$var$rRemoveEmptyNs = /\.[\.]+/g;
var $02f0ede5277c99cd$var$rRemoveTrailingEmptyNs = /[\.]+$/;
var $02f0ede5277c99cd$var$_guid = 1;
var $02f0ede5277c99cd$var$elmNodeData = (0, $0e058b881c0798ff$export$b95c3438408d78aa)("events");
var $02f0ede5277c99cd$var$eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function $02f0ede5277c99cd$var$_normalizeNamespace(name) {
    if (name && name[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ]) return name[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, (0, $aa96917b132802ee$export$5e8607ab26634759));
    return name;
}
function $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace) {
    if (evtNamespace) {
        var theNamespace_1 = (0, $aa96917b132802ee$export$5e8607ab26634759);
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(evtNamespace)) {
            theNamespace_1 = (0, $aa96917b132802ee$export$5e8607ab26634759);
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(evtNamespace, function(name) {
                name = $02f0ede5277c99cd$var$_normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") name = "." + name;
                    theNamespace_1 += name;
                }
            });
        } else theNamespace_1 = $02f0ede5277c99cd$var$_normalizeNamespace(evtNamespace);
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
            // We may only have the namespace and not an eventName
            eventName = (eventName || (0, $aa96917b132802ee$export$5e8607ab26634759)) + theNamespace_1;
        }
    }
    var parsedEvent = $02f0ede5277c99cd$var$eventNamespace.exec(eventName || (0, $aa96917b132802ee$export$5e8607ab26634759)) || [];
    return {
        type: parsedEvent[1],
        ns: (parsedEvent[2] || (0, $aa96917b132802ee$export$5e8607ab26634759)).replace($02f0ede5277c99cd$var$rRemoveEmptyNs, ".").replace($02f0ede5277c99cd$var$rRemoveTrailingEmptyNs, (0, $aa96917b132802ee$export$5e8607ab26634759))[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](".").sort().join(".")
    };
}
function $02f0ede5277c99cd$export$e2bcc16f65e2a5d2(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = $02f0ede5277c99cd$var$elmNodeData.get(target, $02f0ede5277c99cd$var$strEvents, {}, false);
    var evtName = $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace);
    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(eventCache, function(evtType, registeredEvents) {
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(registeredEvents, function(value) {
            if (!evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] || evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] === value[0, $45806013ed348c93$export$d3d43a248cb67414 /* @min:%2eevtName */ ][0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]) {
                if (!evtName.ns || evtName.ns === evtName.ns) theEvents[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
                    name: value.evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] + (value[0, $45806013ed348c93$export$d3d43a248cb67414 /* @min:%2eevtName */ ].ns ? "." + value[0, $45806013ed348c93$export$d3d43a248cb67414 /* @min:%2eevtName */ ].ns : (0, $aa96917b132802ee$export$5e8607ab26634759)),
                    handler: value.handler
                });
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
function $02f0ede5277c99cd$var$_getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) addDefault = true;
    var aiEvts = $02f0ede5277c99cd$var$elmNodeData.get(target, $02f0ede5277c99cd$var$strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
    return registeredEvents;
}
function $02f0ede5277c99cd$var$_doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]) {
        if (obj[$02f0ede5277c99cd$var$strRemoveEventListener]) obj[$02f0ede5277c99cd$var$strRemoveEventListener](evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef, useCapture);
        else if (obj[$02f0ede5277c99cd$var$strDetachEvent]) obj[$02f0ede5277c99cd$var$strDetachEvent]($02f0ede5277c99cd$var$strOnPrefix + evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef);
    }
}
function $02f0ede5277c99cd$var$_doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ] && handlerRef) {
        if (obj[$02f0ede5277c99cd$var$strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[$02f0ede5277c99cd$var$strAddEventHelper](evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef, useCapture);
            result = true;
        } else if (obj[$02f0ede5277c99cd$var$strAttachEvent]) {
            // IE before version 9
            obj[$02f0ede5277c99cd$var$strAttachEvent]($02f0ede5277c99cd$var$strOnPrefix + evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ], handlerRef);
            result = true;
        }
    }
    return result;
}
function $02f0ede5277c99cd$var$_doUnregister(target, events, evtName, unRegFn) {
    var idx = events[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
    while(idx--){
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent[0, $45806013ed348c93$export$d3d43a248cb67414 /* @min:%2eevtName */ ].ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    $02f0ede5277c99cd$var$_doDetach(target, theEvent[0, $45806013ed348c93$export$d3d43a248cb67414 /* @min:%2eevtName */ ], theEvent.handler, theEvent.capture);
                    // Remove the registered event
                    events[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                }
            }
        }
    }
}
function $02f0ede5277c99cd$var$_unregisterEvents(target, evtName, unRegFn) {
    if (evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]) $02f0ede5277c99cd$var$_doUnregister(target, $02f0ede5277c99cd$var$_getRegisteredEvents(target, evtName[0, $45806013ed348c93$export$8fdcd26070ec159 /* @min:%2etype */ ]), evtName, unRegFn);
    else {
        var eventCache = $02f0ede5277c99cd$var$elmNodeData.get(target, $02f0ede5277c99cd$var$strEvents, {});
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(eventCache, function(evtType, events) {
            $02f0ede5277c99cd$var$_doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(eventCache)[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) $02f0ede5277c99cd$var$elmNodeData.kill(target, $02f0ede5277c99cd$var$strEvents);
    }
}
function $02f0ede5277c99cd$export$3f37a50e0edde3be(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(namespaces)) newNamespaces = [
            theNamespace
        ].concat(namespaces);
        else newNamespaces = [
            theNamespace,
            namespaces
        ];
        // resort the namespaces so they are always in order
        newNamespaces = $02f0ede5277c99cd$var$_getEvtNamespace("xx", newNamespaces).ns[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](".");
    } else newNamespaces = theNamespace;
    return newNamespaces;
}
function $02f0ede5277c99cd$export$324ab159353a60a9(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) useCapture = false;
    var result = false;
    if (target) try {
        var evtName = $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace);
        result = $02f0ede5277c99cd$var$_doAttach(target, evtName, handlerRef, useCapture);
        if (result && $02f0ede5277c99cd$var$elmNodeData.accept(target)) {
            var registeredEvent = {
                guid: $02f0ede5277c99cd$var$_guid++,
                evtName: evtName,
                handler: handlerRef,
                capture: useCapture
            };
            $02f0ede5277c99cd$var$_getRegisteredEvents(target, evtName.type)[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](registeredEvent);
        }
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
    return result;
}
function $02f0ede5277c99cd$export$51dedceb7c784eff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) useCapture = false;
    if (target) try {
        var evtName_1 = $02f0ede5277c99cd$var$_getEvtNamespace(eventName, evtNamespace);
        var found_1 = false;
        $02f0ede5277c99cd$var$_unregisterEvents(target, evtName_1, function(regEvent) {
            if (evtName_1.ns && !handlerRef || regEvent.handler === handlerRef) {
                found_1 = true;
                return true;
            }
            return false;
        });
        if (!found_1) // fallback to try and remove as requested
        $02f0ede5277c99cd$var$_doDetach(target, evtName_1, handlerRef, useCapture);
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
}
function $02f0ede5277c99cd$export$c7861dcba2385fcd(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    return $02f0ede5277c99cd$export$324ab159353a60a9(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $02f0ede5277c99cd$export$647f6b935c1d6b6(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    $02f0ede5277c99cd$export$51dedceb7c784eff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $02f0ede5277c99cd$export$3b37be979ee3303a(eventName, callback, evtNamespace) {
    var result = false;
    var w = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
    if (w) {
        result = $02f0ede5277c99cd$export$324ab159353a60a9(w, eventName, callback, evtNamespace);
        result = $02f0ede5277c99cd$export$324ab159353a60a9(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    if (doc) result = $02f0ede5277c99cd$export$324ab159353a60a9(doc, eventName, callback, evtNamespace) || result;
    return result;
}
function $02f0ede5277c99cd$export$546f5991fce5bf06(eventName, callback, evtNamespace) {
    var w = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
    if (w) {
        $02f0ede5277c99cd$export$51dedceb7c784eff(w, eventName, callback, evtNamespace);
        $02f0ede5277c99cd$export$51dedceb7c784eff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    if (doc) $02f0ede5277c99cd$export$51dedceb7c784eff(doc, eventName, callback, evtNamespace);
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */ function $02f0ede5277c99cd$var$_addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(events, function(name) {
        if (name) {
            if (!excludeEvents || (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(excludeEvents, name) === -1) added = $02f0ede5277c99cd$export$3b37be979ee3303a(name, listener, evtNamespace) || added;
        }
    });
    return added;
}
function $02f0ede5277c99cd$export$40a4ed63e5cb7043(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(events)) {
        added = $02f0ede5277c99cd$var$_addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
        added = $02f0ede5277c99cd$var$_addEventListeners(events, listener, null, evtNamespace);
    }
    return added;
}
function $02f0ede5277c99cd$export$8c7b13b21690651d(events, listener, evtNamespace) {
    if (events && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(events)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(events, function(name) {
        if (name) $02f0ede5277c99cd$export$546f5991fce5bf06(name, listener, evtNamespace);
    });
}
function $02f0ede5277c99cd$export$f16ce149aca77fdd(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return $02f0ede5277c99cd$export$40a4ed63e5cb7043([
        $02f0ede5277c99cd$var$strBeforeUnload,
        $02f0ede5277c99cd$var$strUnload,
        $02f0ede5277c99cd$var$strPageHide
    ], listener, excludeEvents, evtNamespace);
}
function $02f0ede5277c99cd$export$272dc813b0b2654c(listener, evtNamespace) {
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strBeforeUnload,
        $02f0ede5277c99cd$var$strUnload,
        $02f0ede5277c99cd$var$strPageHide
    ], listener, evtNamespace);
}
function $02f0ede5277c99cd$export$46744aee53e5e558(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (listener && doc && doc.visibilityState === "hidden") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strPageHide
    ], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(excludeEvents, $02f0ede5277c99cd$var$strVisibilityChangeEvt) === -1) pageUnloadAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    if (!pageUnloadAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageUnloadAdded = $02f0ede5277c99cd$export$46744aee53e5e558(listener, null, evtNamespace);
    return pageUnloadAdded;
}
function $02f0ede5277c99cd$export$6aca6ee3a147169f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageHideNamespace, evtNamespace);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strPageHide
    ], listener, newNamespaces);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}
function $02f0ede5277c99cd$export$cce4a6563c734c0(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
        if (listener && doc && doc.visibilityState === "visible") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageShowNamespace, evtNamespace);
    var pageShowAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strPageShow
    ], listener, excludeEvents, newNamespaces);
    pageShowAdded = $02f0ede5277c99cd$var$_addEventListeners([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageShowAdded = $02f0ede5277c99cd$export$cce4a6563c734c0(listener, null, evtNamespace);
    return pageShowAdded;
}
function $02f0ede5277c99cd$export$c49093a8bd06690f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = $02f0ede5277c99cd$export$3f37a50e0edde3be($02f0ede5277c99cd$var$strPageShowNamespace, evtNamespace);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strPageShow
    ], listener, newNamespaces);
    $02f0ede5277c99cd$export$8c7b13b21690651d([
        $02f0ede5277c99cd$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}


function $f77eaff1f963d24b$var$_disableEvents(target, evtNamespace) {
    (0, $02f0ede5277c99cd$export$51dedceb7c784eff)(target, null, null, evtNamespace);
}
function $f77eaff1f963d24b$export$798b7fe42d5e3d06(parentEvtNamespace) {
    var _document = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    var _navigator = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var listenerList = [];
    // Set the initial state
    // rState is changed by the browser, both via events and when we check the navigator.onLine property
    var rState = 1 /* eOfflineValue.Online */ ;
    if (_navigator && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_navigator.onLine) && !_navigator.onLine) rState = 2 /* eOfflineValue.Offline */ ;
    // ustate is changed by the user calling setOnlineState
    var uState = 0 /* eOfflineValue.Unknown */ ;
    // current state would be updated each time rState or uState is changed
    // it is a resolved value of rState and uState
    var _currentState = calCurrentState();
    var _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents((0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)())) _isListening = true;
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) _isListening = true;
            }
        }
    } catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = (0, $02f0ede5277c99cd$export$324ab159353a60a9)(target, "online", _setOnline, _evtNamespace);
            if (enabled) (0, $02f0ede5277c99cd$export$324ab159353a60a9)(target, "offline", _setOffline, _evtNamespace);
        }
        return enabled;
    }
    function _isOnline() {
        return _currentState;
    }
    function calCurrentState() {
        if (uState === 2 /* eOfflineValue.Offline */  || rState === 2 /* eOfflineValue.Offline */ ) return false;
        return true; // if both unknown, then we assume the network is good
    }
    function listnerNoticeCheck() {
        // we were offline and are now online or we were online and now offline
        var newState = calCurrentState();
        if (_currentState !== newState) {
            _currentState = newState; // use the resolved state to update
            // send all the callbacks with the current state
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listenerList, function(callback) {
                var offlineState = {
                    isOnline: _currentState,
                    rState: rState,
                    uState: uState
                };
                try {
                    callback(offlineState);
                } catch (e) {
                // Do nothing, just making sure we run all of the callbacks
                }
            });
        }
    }
    function setOnlineState(newState) {
        uState = newState;
        listnerNoticeCheck();
    }
    function _setOnline() {
        rState = 1 /* eOfflineValue.Online */ ;
        listnerNoticeCheck();
    }
    function _setOffline() {
        rState = 2 /* eOfflineValue.Offline */ ;
        listnerNoticeCheck();
    }
    function _unload() {
        var win = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
        if (win && _isListening) {
            $f77eaff1f963d24b$var$_disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(target.ononline)) $f77eaff1f963d24b$var$_disableEvents(target, _evtNamespace);
            }
            _isListening = false;
        }
    }
    function addListener(callback) {
        listenerList.push(callback);
        // Define rm as an instance of IUnloadHook
        return {
            rm: function() {
                var index = listenerList.indexOf(callback);
                if (index > -1) return listenerList.splice(index, 1);
                else return;
            }
        };
    }
    return {
        isOnline: _isOnline,
        isListening: function() {
            return _isListening;
        },
        unload: _unload,
        addListener: addListener,
        setOnlineState: setOnlineState
    };
}


var $5343a490b8ca01c7$export$2268e69a6d93b7cc = "AppInsightsPropertiesPlugin";
var $5343a490b8ca01c7$export$a714a094d3058c99 = "AppInsightsChannelPlugin";
var $5343a490b8ca01c7$export$862d858b0002f352 = "ApplicationInsightsAnalytics";


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 






/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 






/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $67947f06182dbd51$var$strExecutionContextKey = "ctx";
var $67947f06182dbd51$var$strParentContextKey = "ParentContextKey";
var $67947f06182dbd51$var$strChildrenContextKey = "ChildrenContextKey";
var $67947f06182dbd51$var$_defaultPerfManager = null;
var $67947f06182dbd51$export$e3556d2ce46cdae0 = /** @class */ function() {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        _self.start = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
        _self[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] = name;
        _self.isAsync = isAsync;
        _self[0, $45806013ed348c93$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ] = function() {
            return false;
        };
        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "payload", {
                g: function() {
                    // Delay the execution of the payloadDetails until needed
                    if (!theDetails_1 && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        // clear it out now so the referenced objects can be garbage collected
                        payloadDetails = null;
                    }
                    return theDetails_1;
                }
            });
        }
        _self[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] = function(key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$67947f06182dbd51$var$strParentContextKey] || key === PerfEvent[$67947f06182dbd51$var$strChildrenContextKey]) return _self[key];
                return (_self[$67947f06182dbd51$var$strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ] = function(key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$67947f06182dbd51$var$strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) _self[0, $45806013ed348c93$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ] = function() {
                        return true;
                    };
                    _self[key] = value;
                } else if (key === PerfEvent[$67947f06182dbd51$var$strChildrenContextKey]) _self[key] = value;
                else {
                    var ctx = _self[$67947f06182dbd51$var$strExecutionContextKey] = _self[$67947f06182dbd51$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function() {
            var childTime = 0;
            var childEvts = _self[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ](PerfEvent[$67947f06182dbd51$var$strChildrenContextKey]);
            if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(childEvts)) for(var lp = 0; lp < childEvts[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
                var childEvt = childEvts[lp];
                if (childEvt) childTime += childEvt.time;
            }
            _self.time = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)() - _self.start;
            _self.exTime = _self.time - childTime;
            _self.complete = function() {};
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}();
var $67947f06182dbd51$export$cbeb6df2e8e9b5ae = /** @class */ function() {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */ this.ctx = {};
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PerfManager, this, function(_self) {
            _self.create = function(src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new $67947f06182dbd51$export$e3556d2ce46cdae0(src, payloadDetails, isAsync);
            };
            _self.fire = function(perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(manager[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ])) manager[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                }
            };
            _self[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ] = function(key, value) {
                if (key) {
                    var ctx = _self[$67947f06182dbd51$var$strExecutionContextKey] = _self[$67947f06182dbd51$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] = function(key) {
                return (_self[$67947f06182dbd51$var$strExecutionContextKey] || {})[key];
            };
        });
    }
    // Removed Stub for PerfManager.prototype.create.
    // Removed Stub for PerfManager.prototype.fire.
    // Removed Stub for PerfManager.prototype.setCtx.
    // Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfManager.__ieDyn = 1;
    return PerfManager;
}();
var $67947f06182dbd51$var$doPerfActiveKey = "CoreUtils.doPerf";
function $67947f06182dbd51$export$c6fbeb260600c482(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[0, $aa96917b132802ee$export$f8b08c7de64edfbf]) // Looks like a perf manager provider object
        perfMgr = perfMgr[0, $aa96917b132802ee$export$f8b08c7de64edfbf]();
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ]($67947f06182dbd51$var$doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) {
                        perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$export$e3556d2ce46cdae0[$67947f06182dbd51$var$strParentContextKey], currentActive);
                        if (currentActive[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ] && currentActive[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) {
                            var children = currentActive[0, $45806013ed348c93$export$c405fd80acb80a5b /* @min:%2egetCtx */ ]($67947f06182dbd51$export$e3556d2ce46cdae0[$67947f06182dbd51$var$strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$export$e3556d2ce46cdae0[$67947f06182dbd51$var$strChildrenContextKey], children);
                            }
                            children[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$var$doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            } catch (ex) {
                if (perfEvt && perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]) perfEvt[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]("exception", ex);
            } finally{
                // fire the perf event
                if (perfEvt) perfMgr.fire(perfEvt);
                // Reset the active event to the previous value
                perfMgr[0, $45806013ed348c93$export$2ec27a3df8fa4130 /* @min:%2esetCtx */ ]($67947f06182dbd51$var$doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
function $67947f06182dbd51$export$1e94af82fd6977f1(perfManager) {
    $67947f06182dbd51$var$_defaultPerfManager = perfManager;
}
function $67947f06182dbd51$export$6cdbf3f34ace6568() {
    return $67947f06182dbd51$var$_defaultPerfManager;
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $e144361666ed071d$var$pluginStateData = (0, $0e058b881c0798ff$export$b95c3438408d78aa)("plugin");
function $e144361666ed071d$export$37cfaecb9b4b1b3b(plugin) {
    return $e144361666ed071d$var$pluginStateData.get(plugin, "state", {}, true);
}
function $e144361666ed071d$export$be211df7b1eeb33e(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
    var pluginState;
    while(proxy){
        var thePlugin = proxy[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ] && thePlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ]) // Set this plugin as the next for the previous one
            lastPlugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ](thePlugin);
            pluginState = $e144361666ed071d$export$37cfaecb9b4b1b3b(thePlugin);
            var isInitialized = !!pluginState[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ];
            if (thePlugin[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]) isInitialized = thePlugin[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]();
            if (!isInitialized) initPlugins[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](thePlugin);
            lastPlugin = thePlugin;
            proxy = proxy[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
        }
    }
    // Now initialize the plugins
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(initPlugins, function(thePlugin) {
        var core = processContext[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]();
        thePlugin[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ](processContext.getCfg(), core, extensions, processContext[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]());
        pluginState = $e144361666ed071d$export$37cfaecb9b4b1b3b(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[0, $aa96917b132802ee$export$3094ace9cd82ff99] && !pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99]) pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99] = core;
        pluginState[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = true;
        delete pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ];
    });
}
function $e144361666ed071d$export$478771939b7b39a2(plugins) {
    // Sort by priority
    return plugins.sort(function(extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[0, $aa96917b132802ee$export$820a3bce4a265606];
            if (extA[0, $aa96917b132802ee$export$820a3bce4a265606]) result = bHasProcess ? extA[0, $aa96917b132802ee$export$58efcc07763b37be] - extB[0, $aa96917b132802ee$export$58efcc07763b37be] : 1;
            else if (bHasProcess) result = -1;
        } else result = extA ? 1 : -1;
        return result;
    });
// sort complete
}
function $e144361666ed071d$export$24978f1b175640d9(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while(idx < components[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]){
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ];
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(func)) {
                    if (func.call(component, unloadCtx, unloadState, _doUnload) === true) return true;
                }
            }
        }
    }
    return _doUnload();
}
function $e144361666ed071d$export$10fa4480433f402c(parentCtx) {
    var trace = {};
    return {
        getName: function() {
            return trace[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace.traceId;
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $4726195e2d737947$export$29dd34cf1269f6da)(newValue)) trace.traceId = newValue;
        },
        getSpanId: function() {
            return trace.spanId;
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $4726195e2d737947$export$8e51c6d8f0586aff)(newValue)) trace.spanId = newValue;
        },
        getTraceFlags: function() {
            return trace[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[0, $45806013ed348c93$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = newTraceFlags;
        }
    };
}


"use strict";
var $21bc92e23804c647$var$strTelemetryPluginChain = "TelemetryPluginChain";
var $21bc92e23804c647$var$strHasRunFlags = "_hasRun";
var $21bc92e23804c647$var$strGetTelCtx = "_getTelCtx";
var $21bc92e23804c647$var$_chainId = 0;
function $21bc92e23804c647$var$_getNextProxyStart(proxy, core, startAt) {
    while(proxy){
        if (proxy[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]() === startAt) return proxy;
        proxy = proxy[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return $21bc92e23804c647$export$107e639207cdf742([
        startAt
    ], core.config || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */ function $21bc92e23804c647$var$_createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) dynamicHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)({}, null, core[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
    if (startAt !== null) // There is no next element (null) vs not defined (undefined) so use the full chain
    _nextProxy = startAt ? $21bc92e23804c647$var$_getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    var context = {
        _next: _moveNext,
        ctx: {
            core: function() {
                return core;
            },
            diagLog: function() {
                return (0, $bacca83328a730a7$export$5102d32ea1d740a)(core, dynamicHandler.cfg);
            },
            getCfg: function() {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function() {
                return !!_nextProxy;
            },
            getNext: function() {
                return _nextProxy;
            },
            setNext: function(nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        if (onComplete) _onComplete[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
            func: onComplete,
            self: !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(that) ? that : context.ctx,
            args: args
        });
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(onComplete, function(completeDetails) {
                    try {
                        completeDetails.func.call(completeDetails.self, completeDetails.args);
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(core[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected Exception during onComplete - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var cfg = dynamicHandler.cfg;
        if (cfg && identifier) {
            var extCfg = cfg[0, $aa96917b132802ee$export$ffb2356587263734 /* @min:%2eextensionConfig */ ];
            if (!extCfg && createIfMissing) extCfg = {};
            // Always set the value so that the property always exists
            cfg[0, $aa96917b132802ee$export$ffb2356587263734] = extCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            extCfg = dynamicHandler.ref(cfg, (0, $aa96917b132802ee$export$ffb2356587263734));
            if (extCfg) {
                idCfg = extCfg[identifier];
                if (!idCfg && createIfMissing) idCfg = {};
                // Always set the value so that the property always exists
                extCfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
                // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
                idCfg = dynamicHandler.ref(extCfg, identifier);
            }
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues) {
        var newConfig = _getExtCfg(identifier, true);
        if (defaultValues) // Enumerate over the defaultValues and if not already populated attempt to
        // find a value from the root config or use the default value
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(defaultValues, function(field, defaultValue) {
            // for each unspecified field, set the default value
            if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(newConfig[field])) {
                var cfgValue = dynamicHandler.cfg[field];
                if (cfgValue || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(cfgValue)) newConfig[field] = cfgValue;
            }
            (0, $2858d2db0bf490e5$export$f11b7d3a4617b9e9)(dynamicHandler, newConfig, field, defaultValue);
        });
        return dynamicHandler.setDf(newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(extConfig[field]))) theValue = extConfig[field];
        else if (rootConfig[field] || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(rootConfig[field])) theValue = rootConfig[field];
        return theValue || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while(!!(nextPlugin = context._next())){
            var plugin = nextPlugin[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]();
            if (plugin) // callback with the current on
            cb(plugin);
        }
    }
    return context;
}
function $21bc92e23804c647$export$ca98f11e981bcfd6(telemetryChain, cfg, core, startAt) {
    var config = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(cfg);
    var internalContext = $21bc92e23804c647$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) // Run the next plugin which will call "processNext()"
        nextPlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, context);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins)) plugins = $21bc92e23804c647$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $21bc92e23804c647$export$ca98f11e981bcfd6(plugins || context[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ](), config.cfg, core, startAt);
    }
    context[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $21bc92e23804c647$export$91bbbd4999751948(telemetryChain, core, startAt) {
    var config = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(core.config);
    var internalContext = $21bc92e23804c647$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins)) plugins = $21bc92e23804c647$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $21bc92e23804c647$export$91bbbd4999751948(plugins || context[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $21bc92e23804c647$export$e4c32b40c4fbf98a(telemetryChain, core, startAt) {
    var config = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(core.config);
    var internalContext = $21bc92e23804c647$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function(plugin) {
            if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ])) plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ](context, updateState);
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins)) plugins = $21bc92e23804c647$export$107e639207cdf742(plugins, config.cfg, core, startAt);
        return $21bc92e23804c647$export$e4c32b40c4fbf98a(plugins || context[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $21bc92e23804c647$export$107e639207cdf742(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(plugins) && plugins[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(plugins, function(thePlugin) {
            if (!add && startAt === thePlugin) add = true;
            if (add && thePlugin && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(thePlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ])) {
                // Only add plugins that are processors
                var newProxy = $21bc92e23804c647$export$7f7b955927f4ae5e(thePlugin, config, core);
                if (!firstProxy) firstProxy = newProxy;
                if (lastProxy_1) // Set this new proxy as the next for the previous one
                lastProxy_1._setNext(newProxy);
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) // Special case where the "startAt" was not in the original list of plugins
    return $21bc92e23804c647$export$107e639207cdf742([
        startAt
    ], config, core);
    return firstProxy;
}
function $21bc92e23804c647$export$7f7b955927f4ae5e(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ]);
    var hasSetNext = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ]);
    var chainId;
    if (plugin) chainId = plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "-" + plugin[0, $aa96917b132802ee$export$58efcc07763b37be /* @min:%2epriority */ ] + "-" + $21bc92e23804c647$var$_chainId++;
    else chainId = "Unknown-0-" + $21bc92e23804c647$var$_chainId++;
    var proxyChain = {
        getPlugin: function() {
            return plugin;
        },
        getNext: function() {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function(nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(plugin[$21bc92e23804c647$var$strGetTelCtx])) // This plugin extends from the BaseTelemetryPlugin so lets use it
        itemCtx = plugin[$21bc92e23804c647$var$strGetTelCtx]();
        if (!itemCtx) // Create a temporary one
        itemCtx = $21bc92e23804c647$export$ca98f11e981bcfd6(proxyChain, config, core);
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] : $21bc92e23804c647$var$strTelemetryPluginChain;
        var hasRunContext = itemCtx[$21bc92e23804c647$var$strHasRunFlags];
        if (!hasRunContext) // Assign and populate
        hasRunContext = itemCtx[$21bc92e23804c647$var$strHasRunFlags] = {};
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) (0, $67947f06182dbd51$export$c6fbeb260600c482)(itemCtx[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ](), function() {
            return identifier + ":" + name;
        }, function() {
            // Mark this component as having run
            hasRunContext[chainId] = true;
            try {
                // Set a flag on the next plugin so we know if it was attempted to be executed
                var nextId = nextProxy ? nextProxy._id : (0, $aa96917b132802ee$export$5e8607ab26634759);
                if (nextId) hasRunContext[nextId] = false;
                hasRun = processPluginFn(itemCtx);
            } catch (error) {
                var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                if (hasNextRun) // The next plugin after us has already run so set this one as complete
                hasRun = true;
                if (!nextProxy || !hasNextRun) // Either we have no next plugin or the current one did not attempt to call the next plugin
                // Which means the current one is the root of the failure so log/report this failure
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(itemCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 73 /* _eInternalMessageId.PluginException */ , "Plugin [" + identifier + "] failed during " + name + " - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(error) + ", run flags: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(hasRunContext));
            }
        }, details, isAsync);
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) return false;
            var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(plugin);
            if (pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] || pluginState[0, $aa96917b132802ee$export$49e9417944569ae8]) return false;
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) // Backward compatibility setting the next plugin on the instance
            plugin[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ](nextProxy);
            plugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
            return {
                item: env
            };
        }, !env.sync)) // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
        // so we still want the next plugin to be executed.
        itemCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](env);
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(plugin);
                var pluginCore = plugin[0, $aa96917b132802ee$export$3094ace9cd82ff99] || pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = null;
                    pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] = true;
                    pluginState[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = false;
                    if (plugin[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] && plugin[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ](unloadCtx, unloadState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function() {}, unloadState.isAsync)) // Only called if we hasRun was not true
        unloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(plugin);
                var pluginCore = plugin[0, $aa96917b132802ee$export$3094ace9cd82ff99] || pluginState[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ]) {
                    if (plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ] && plugin[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ](updateCtx, updateState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function() {}, false)) // Only called if we hasRun was not true
        updateCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](updateState);
    }
    return (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */ var $21bc92e23804c647$export$7c2ac74a00234af1 = /** @class */ function() {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */ function ProcessTelemetryContext(pluginChain, config, core, startAt) {
        var _self = this;
        var context = $21bc92e23804c647$export$ca98f11e981bcfd6(pluginChain, config, core, startAt);
        // Proxy all functions of the context to this object
        (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, context, (0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(context));
    }
    return ProcessTelemetryContext;
}();


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


function $0af4a0f2b45a17f9$export$1dd1604aeaf8cfed() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) handlers[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](handler);
    }
    function _runHandlers(unloadCtx, unloadState) {
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(handlers, function(handler) {
            try {
                handler(unloadCtx, unloadState);
            } catch (e) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(unloadCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected error calling unload handler - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $10c5f1b2f69c7ec4$var$_maxHooks;
var $10c5f1b2f69c7ec4$var$_hookAddMonitor;
function $10c5f1b2f69c7ec4$export$53f204aaf3e08551(maxHooks, addMonitor) {
    $10c5f1b2f69c7ec4$var$_maxHooks = maxHooks;
    $10c5f1b2f69c7ec4$var$_hookAddMonitor = addMonitor;
}
function $10c5f1b2f69c7ec4$export$31fa167f9d342989() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(oldHooks, function(fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove).call(fn);
            } catch (e) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unloading:" + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
            }
        });
        if ($10c5f1b2f69c7ec4$var$_maxHooks && oldHooks[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > $10c5f1b2f69c7ec4$var$_maxHooks) $10c5f1b2f69c7ec4$var$_hookAddMonitor ? $10c5f1b2f69c7ec4$var$_hookAddMonitor("doUnload", oldHooks) : (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(null, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.MaxUnloadHookExceeded */ , "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
    }
    function _addHook(hooks) {
        if (hooks) {
            (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(_hooks, hooks);
            if ($10c5f1b2f69c7ec4$var$_maxHooks && _hooks[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > $10c5f1b2f69c7ec4$var$_maxHooks) $10c5f1b2f69c7ec4$var$_hookAddMonitor ? $10c5f1b2f69c7ec4$var$_hookAddMonitor("Add", _hooks) : (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(null, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.MaxUnloadHookExceeded */ , "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}


"use strict";
var $dc0100a6f2a9749a$var$_a;
var $dc0100a6f2a9749a$var$strGetPlugin = "getPlugin";
var $dc0100a6f2a9749a$var$defaultValues = ($dc0100a6f2a9749a$var$_a = {}, $dc0100a6f2a9749a$var$_a[0, $aa96917b132802ee$export$ffb2356587263734] = {
    isVal: (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe),
    v: {}
}, $dc0100a6f2a9749a$var$_a);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */ var $dc0100a6f2a9749a$export$64a11c2f90e6766c = /** @class */ function() {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(BaseTelemetryPlugin, _self, function(_self) {
            _self[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] = function(unloadCtx, unloadState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                if (!core || unloadCtx && core !== unloadCtx[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]()) // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                return;
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || (0, $21bc92e23804c647$export$91bbbd4999751948)(null, core, _nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin] ? _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || {
                    reason: 0 /* TelemetryUnloadReason.ManualTeardown */ ,
                    isAsync: false
                };
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]());
                        if (result === true) theUnloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](theUnloadState);
                        _initDefaults();
                    }
                }
                if (!_self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] || _self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
                else // Tell the caller that we will be calling processNext()
                result = true;
                return result;
            };
            _self[0, $45806013ed348c93$export$c9f4bebf02f459de /* @min:%2eupdate */ ] = function(updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ];
                if (!core || updateCtx && core !== updateCtx[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]()) // Do Nothing
                return;
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || (0, $21bc92e23804c647$export$e4c32b40c4fbf98a)(null, core, _nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin] ? _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */ 
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
                else result = true;
                return result;
            };
            (0, $ede407819d2d28c9$export$5dd8d245f6f94a18)(_self, "_addUnloadCb", function() {
                return _unloadHandlerContainer;
            }, "add");
            (0, $ede407819d2d28c9$export$5dd8d245f6f94a18)(_self, "_addHook", function() {
                return _hookContainer;
            }, "add");
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_unloadHooks", {
                g: function() {
                    return _hookContainer;
                }
            });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ] = function(itemCtx) {
            return _getTelCtx(itemCtx)[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
        };
        _self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = function() {
            return _isinitialized;
        };
        _self.setInitialized = function(isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[0, $45806013ed348c93$export$55d672a1dc4d50c1 /* @min:%2esetNextPlugin */ ] = function(next) {
            _nextPlugin = next;
        };
        _self[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ] = function(env, itemCtx) {
            if (itemCtx) // Normal core execution sequence
            itemCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](env);
            else if (_nextPlugin && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_nextPlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ])) // Looks like backward compatibility or out of band processing. And as it looks
            // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
            _nextPlugin[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ](env, null);
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) currentCtx = null;
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, {}, _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]) // Looks like a chain object
                itemCtx = rootCtx[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](null, _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]);
                else itemCtx = rootCtx[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](null, _nextPlugin);
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            (0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $dc0100a6f2a9749a$var$defaultValues, (0, $bacca83328a730a7$export$5102d32ea1d740a)(core));
            if (!pluginChain && core) // Get the first plugin from the core
            pluginChain = core[0, $45806013ed348c93$export$474081342bc4baf4 /* @min:%2egetProcessTelContext */ ]()[0, $45806013ed348c93$export$36754a48de7fd714 /* @min:%2egetNext */ ]();
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]) // If it looks like a proxy/chain then get the plugin
            nextPlugin = _nextPlugin[$dc0100a6f2a9749a$var$strGetPlugin]();
            // Support legacy plugins where core was defined as a property
            _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = core;
            _rootCtx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = (0, $10c5f1b2f69c7ec4$export$31fa167f9d342989)();
            _unloadHandlerContainer = (0, $0af4a0f2b45a17f9$export$1dd1604aeaf8cfed)();
        }
    }
    // Removed Stub for BaseTelemetryPlugin.prototype.initialize.
    // Removed Stub for BaseTelemetryPlugin.prototype.teardown.
    // Removed Stub for BaseTelemetryPlugin.prototype.update.
    // Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
    // Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn = 1;
    return BaseTelemetryPlugin;
}();

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */ function $3b63eef6ee7529a9$var$_stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue)) return defaultValue;
    if ((0, $5831ddb3a0caf7c7$export$f9ce7b637dfbe238)(theValue)) return theValue;
    return (0, $5831ddb3a0caf7c7$export$590567be997858b6)(theValue)[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "true";
}
function $3b63eef6ee7529a9$export$5d17fe34e1e248ba(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
function $3b63eef6ee7529a9$export$e86b712d02676c90(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
function $3b63eef6ee7529a9$export$d0884590a6a82e6c(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
function $3b63eef6ee7529a9$export$bad0d7bace730ae(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: $3b63eef6ee7529a9$var$_stringToBoolOrDefault,
        v: !!defaultValue
    };
}
function $3b63eef6ee7529a9$export$4308728f2256db2f(defaultValue) {
    return {
        isVal: (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54),
        v: defaultValue || null
    };
}
function $3b63eef6ee7529a9$export$75965e1022d5969a(defaultValue) {
    return {
        isVal: (0, $5831ddb3a0caf7c7$export$844ec244b1367d54),
        v: (0, $5831ddb3a0caf7c7$export$590567be997858b6)(defaultValue || (0, $aa96917b132802ee$export$5e8607ab26634759))
    };
}
function $3b63eef6ee7529a9$export$4ebeffd29cffbfb(defaultValue) {
    return {
        blkVal: true,
        v: defaultValue
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



var $b3babfece552aa67$var$aiInstrumentHooks = "_aiHooks";
var $b3babfece552aa67$var$cbNames = [
    "req",
    "rsp",
    "hkErr",
    "fnErr"
];
/** @ignore */ function $b3babfece552aa67$var$_arrLoop(arr, fn) {
    if (arr) for(var lp = 0; lp < arr[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
        if (fn(arr[lp], lp)) break;
    }
}
/** @ignore */ function $b3babfece552aa67$var$_doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */  && type <= 2 /* CallbackType.HookError */ ) $b3babfece552aa67$var$_arrLoop(hooks, function(hook, idx) {
        var cbks = hook.cbks;
        var cb = cbks[$b3babfece552aa67$var$cbNames[type]];
        if (cb) {
            // Set the specific hook context implementation using a lazy creation pattern
            callDetails.ctx = function() {
                var ctx = hookCtx[idx] = hookCtx[idx] || {};
                return ctx;
            };
            try {
                cb[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](callDetails.inst, cbArgs);
            } catch (err) {
                var orgEx = callDetails.err;
                try {
                    // Report Hook error via the callback
                    var hookErrorCb = cbks[$b3babfece552aa67$var$cbNames[2 /* CallbackType.HookError */ ]];
                    if (hookErrorCb) {
                        callDetails.err = err;
                        hookErrorCb[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](callDetails.inst, cbArgs);
                    }
                } catch (e) {
                // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                } finally{
                    // restore the original exception (if any)
                    callDetails.err = orgEx;
                }
            }
        }
    });
}
/** @ignore */ function $b3babfece552aa67$var$_createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function() {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([
            funcArgs
        ], orgArgs);
        funcArgs.evt = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("event");
        function _createArgs(target, theArgs) {
            $b3babfece552aa67$var$_arrLoop(theArgs, function(arg) {
                target[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([
                funcArgs
            ], orgArgs);
        }
        // Call the pre-request hooks
        $b3babfece552aa67$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */ );
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) try {
            funcArgs.rslt = theFunc[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](funcThis, orgArgs);
        } catch (err) {
            // Report the request callback
            funcArgs.err = err;
            $b3babfece552aa67$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */ );
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        $b3babfece552aa67$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */ );
        return funcArgs.rslt;
    };
}
/** @ignore */ function $b3babfece552aa67$var$_getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if ((0, $5831ddb3a0caf7c7$export$d76937f5d45b7158)(target, name)) owner = target;
        else if (checkPrototype) owner = $b3babfece552aa67$var$_getOwner((0, $ede407819d2d28c9$export$821e81707b1677f9)(target), name, checkParentProto, false);
    }
    return owner;
}
function $b3babfece552aa67$export$6b32104a5f4313f6(target, funcName, callbacks) {
    if (target) return $b3babfece552aa67$export$152e6c4c396a57a(target[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049], funcName, callbacks, false);
    return null;
}
function $b3babfece552aa67$export$aaa214566a8b50d(target, funcNames, callbacks) {
    if (target) return $b3babfece552aa67$export$3bccad25f6aafea4(target[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049], funcNames, callbacks, false);
    return null;
}
function $b3babfece552aa67$var$_createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[$b3babfece552aa67$var$aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = $b3babfece552aa67$var$_createFunctionHook(aiHook);
        newFunc[$b3babfece552aa67$var$aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function() {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            $b3babfece552aa67$var$_arrLoop(aiHook.h, function(hook, idx) {
                if (hook.id === id) {
                    aiHook.h[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                    return 1;
                }
            });
        }
    };
    aiHook.i++;
    aiHook.h[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](theHook);
    return theHook;
}
function $b3babfece552aa67$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    if (target && funcName && callbacks) {
        var owner = $b3babfece552aa67$var$_getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === (0, $042f611b66f4fd6f$export$327014e6dfd5ba11)) return $b3babfece552aa67$var$_createInstrumentHook(owner, funcName, fn, callbacks);
        }
    }
    return null;
}
function $b3babfece552aa67$export$3bccad25f6aafea4(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    var hooks = null;
    $b3babfece552aa67$var$_arrLoop(funcNames, function(funcName) {
        var hook = $b3babfece552aa67$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) hooks = [];
            hooks[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](hook);
        }
    });
    return hooks;
}
function $b3babfece552aa67$export$b96f6cbe9b035430(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = $b3babfece552aa67$var$_getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) return $b3babfece552aa67$var$_createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 







var $aaa64f3935d14265$var$_a, $aaa64f3935d14265$var$_b;
var $aaa64f3935d14265$var$strToGMTString = "toGMTString";
var $aaa64f3935d14265$var$strToUTCString = "toUTCString";
var $aaa64f3935d14265$var$strCookie = "cookie";
var $aaa64f3935d14265$var$strExpires = "expires";
var $aaa64f3935d14265$var$strIsCookieUseDisabled = "isCookieUseDisabled";
var $aaa64f3935d14265$var$strDisableCookiesUsage = "disableCookiesUsage";
var $aaa64f3935d14265$var$strConfigCookieMgr = "_ckMgr";
var $aaa64f3935d14265$var$_supportsCookies = null;
var $aaa64f3935d14265$var$_allowUaSameSite = null;
var $aaa64f3935d14265$var$_parsedCookieValue = null;
var $aaa64f3935d14265$var$_doc;
var $aaa64f3935d14265$var$_cookieCache = {};
var $aaa64f3935d14265$var$_globalCookieConfig = {};
// // `isCookieUseDisabled` is deprecated, so explicitly casting as a key of IConfiguration to avoid typing error
// // when both isCookieUseDisabled and disableCookiesUsage are used disableCookiesUsage will take precedent, which is
// // why its listed first
/**
 * Set the supported dynamic config values as undefined (or an empty object) so that
 * any listeners will be informed of any changes.
 * Explicitly NOT including the deprecated `isCookieUseDisabled` as we don't want to support
 * the v1 deprecated field as dynamic for updates
 */ var $aaa64f3935d14265$var$rootDefaultConfig = ($aaa64f3935d14265$var$_a = {
    cookieCfg: (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)(($aaa64f3935d14265$var$_b = {}, $aaa64f3935d14265$var$_b[0, $aa96917b132802ee$export$8f3e5386cefa231e] = {
        fb: "cookieDomain",
        dfVal: (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)
    }, $aaa64f3935d14265$var$_b.path = {
        fb: "cookiePath",
        dfVal: (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)
    }, $aaa64f3935d14265$var$_b.enabled = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_b.ignoreCookies = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_b.blockedCookies = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_b.disableCookieDefer = false, $aaa64f3935d14265$var$_b)),
    cookieDomain: (0, $aa96917b132802ee$export$a43287864529b8fd),
    cookiePath: (0, $aa96917b132802ee$export$a43287864529b8fd)
}, $aaa64f3935d14265$var$_a[$aaa64f3935d14265$var$strDisableCookiesUsage] = (0, $aa96917b132802ee$export$a43287864529b8fd), $aaa64f3935d14265$var$_a);
function $aaa64f3935d14265$var$_getDoc() {
    !$aaa64f3935d14265$var$_doc && ($aaa64f3935d14265$var$_doc = (0, $5831ddb3a0caf7c7$export$db98eae15987454c)(function() {
        return (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    }));
}
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */ function $aaa64f3935d14265$var$_gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = $aaa64f3935d14265$export$2ae082191ac44e5a[$aaa64f3935d14265$var$strConfigCookieMgr] || $aaa64f3935d14265$var$_globalCookieConfig[$aaa64f3935d14265$var$strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = $aaa64f3935d14265$export$2ae082191ac44e5a[$aaa64f3935d14265$var$strConfigCookieMgr] = $aaa64f3935d14265$export$2ae082191ac44e5a(config, logger);
        $aaa64f3935d14265$var$_globalCookieConfig[$aaa64f3935d14265$var$strConfigCookieMgr] = inst;
    }
    return inst;
}
function $aaa64f3935d14265$var$_isMgrEnabled(cookieMgr) {
    if (cookieMgr) return cookieMgr.isEnabled();
    return true;
}
function $aaa64f3935d14265$var$_isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(cookieMgrCfg.ignoreCookies)) return (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(cookieMgrCfg.ignoreCookies, name) !== -1;
    return false;
}
function $aaa64f3935d14265$var$_isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(cookieMgrCfg.blockedCookies)) {
        if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(cookieMgrCfg.blockedCookies, name) !== -1) return true;
    }
    return $aaa64f3935d14265$var$_isIgnoredCookie(cookieMgrCfg, name);
}
function $aaa64f3935d14265$var$_isCfgEnabled(rootConfig, cookieMgrConfig) {
    var isCfgEnabled = cookieMgrConfig[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ];
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(isCfgEnabled)) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        // This field is deprecated and dynamic updates will not be fully supported
        if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(rootConfig[$aaa64f3935d14265$var$strIsCookieUseDisabled])) cookieEnabled = !rootConfig[$aaa64f3935d14265$var$strIsCookieUseDisabled];
        // If this value is defined it takes precedent over the above
        if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(rootConfig[$aaa64f3935d14265$var$strDisableCookiesUsage])) cookieEnabled = !rootConfig[$aaa64f3935d14265$var$strDisableCookiesUsage];
        // Not setting the cookieMgrConfig.enabled as that will update (set) the global dynamic config
        // So future "updates" then may not be as expected
        isCfgEnabled = cookieEnabled;
    }
    return isCfgEnabled;
}
function $aaa64f3935d14265$export$76c0b273586c25c7(core, config) {
    var cookieMgr;
    if (core) // Always returns an instance
    cookieMgr = core.getCookieMgr();
    else if (config) {
        var cookieCfg = config.cookieCfg;
        if (cookieCfg && cookieCfg[$aaa64f3935d14265$var$strConfigCookieMgr]) cookieMgr = cookieCfg[$aaa64f3935d14265$var$strConfigCookieMgr];
        else cookieMgr = $aaa64f3935d14265$export$2ae082191ac44e5a(config);
    }
    if (!cookieMgr) // Get or initialize the default global (legacy) cookie manager if we couldn't find one
    cookieMgr = $aaa64f3935d14265$var$_gblCookieMgr(config, (core || {})[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
    return cookieMgr;
}
function $aaa64f3935d14265$export$2ae082191ac44e5a(rootConfig, logger) {
    var cookieMgrConfig;
    var _path;
    var _domain;
    var unloadHandler;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled;
    var _getCookieFn;
    var _setCookieFn;
    var _delCookieFn;
    // Buffer for storing cookie operations when cookies are disabled
    // null = deferral disabled, array = deferral enabled with pending operations
    var _pendingCookies = [];
    // Helper function to format deletion cookie value
    function _formatDeletionValue(path) {
        var _a;
        var values = (_a = {}, _a[0, $aa96917b132802ee$export$bdba10701e0ccff3] = path ? path : "/", _a[$aaa64f3935d14265$var$strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
        if (!(0, $0d2c2fb24388dcf8$export$7e7b1a9668aaed8)()) // Set max age to expire now
        values["max-age"] = "0";
        return $aaa64f3935d14265$var$_formatCookieValue((0, $aa96917b132802ee$export$5e8607ab26634759), values);
    }
    // Helper function to format a cookie value with all attributes
    function _formatSetCookieValue(value, maxAgeSec, domain, path) {
        var values = {};
        var theValue = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(value || (0, $aa96917b132802ee$export$5e8607ab26634759));
        var idx = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(theValue, ";");
        if (idx !== -1) {
            theValue = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)(value, idx));
            values = $aaa64f3935d14265$var$_extractParts((0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(value, idx + 1));
        }
        // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
        (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, (0, $aa96917b132802ee$export$8f3e5386cefa231e), domain || _domain, (0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f), (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
        if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(maxAgeSec)) {
            var _isIE = (0, $0d2c2fb24388dcf8$export$7e7b1a9668aaed8)();
            if ((0, $5831ddb3a0caf7c7$export$fce6876652108ab)(values[$aaa64f3935d14265$var$strExpires])) {
                var nowMs = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
                // Only add expires if not already present
                var expireMs = nowMs + maxAgeSec * 1000;
                // Sanity check, if zero or -ve then ignore
                if (expireMs > 0) {
                    var expiry = new Date();
                    expiry.setTime(expireMs);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, $aaa64f3935d14265$var$strExpires, $aaa64f3935d14265$var$_formatDate(expiry, !_isIE ? $aaa64f3935d14265$var$strToUTCString : $aaa64f3935d14265$var$strToGMTString) || $aaa64f3935d14265$var$_formatDate(expiry, _isIE ? $aaa64f3935d14265$var$strToGMTString : $aaa64f3935d14265$var$strToUTCString) || (0, $aa96917b132802ee$export$5e8607ab26634759), (0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f));
                }
            }
            if (!_isIE) // Only replace if not already present
            (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, "max-age", (0, $aa96917b132802ee$export$5e8607ab26634759) + maxAgeSec, null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
        }
        var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
        if (location && location.protocol === "https:") {
            (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, "secure", null, null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
            // Only set same site if not also secure
            if ($aaa64f3935d14265$var$_allowUaSameSite === null) $aaa64f3935d14265$var$_allowUaSameSite = !$aaa64f3935d14265$export$e44499c7a8a6a268(((0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {})[0, $45806013ed348c93$export$2e850152cb3355e2 /* @min:%2euserAgent */ ]);
            if ($aaa64f3935d14265$var$_allowUaSameSite) (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, "SameSite", "None", null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
        }
        (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(values, (0, $aa96917b132802ee$export$bdba10701e0ccff3), path || _path, null, (0, $5831ddb3a0caf7c7$export$fce6876652108ab));
        return $aaa64f3935d14265$var$_formatCookieValue(theValue, values);
    }
    // Helper function to remove any existing pending operations for a cookie name
    function _removePendingCookie(name) {
        if (_pendingCookies) {
            // Remove all existing entries for this cookie name (iterate backwards to handle multiple entries safely)
            for(var i = _pendingCookies[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; i >= 0; i--)if (_pendingCookies[i].n === name) _pendingCookies[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](i, 1);
        }
    }
    // Helper function to flush pending cookies when cookies become enabled
    function _flushPendingCookies() {
        if ($aaa64f3935d14265$export$25d06da9c29ef62a(logger) && _pendingCookies) {
            // Process all pending cookie operations in order
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_pendingCookies, function(pendingData) {
                if (!$aaa64f3935d14265$var$_isBlockedCookie(cookieMgrConfig, pendingData.n)) {
                    if (pendingData.o === 0 /* ePendingOp.Set */ ) // Apply the cached cookie value directly
                    _setCookieFn(pendingData.n, pendingData.v);
                    else if (pendingData.o === 1 /* ePendingOp.Purge */ ) // Apply the cached deletion
                    _delCookieFn(pendingData.n, pendingData.v);
                }
            });
            // Clear the cache after flushing
            _pendingCookies = [];
        }
    }
    // Make sure the root config is dynamic as it may be the global config
    rootConfig = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(rootConfig || $aaa64f3935d14265$var$_globalCookieConfig, null, logger).cfg;
    // Will get recalled if the referenced configuration is changed
    unloadHandler = (0, $6387583e0b25820c$export$454a433e4deb244f)(rootConfig, function(details) {
        // Make sure the root config has all of the the defaults to the root config to ensure they are dynamic
        details.setDf(details.cfg, $aaa64f3935d14265$var$rootDefaultConfig);
        // Create and apply the defaults to the cookieCfg element
        cookieMgrConfig = details.ref(details.cfg, "cookieCfg"); // details.setDf(details.cfg.cookieCfg, defaultConfig);
        _path = cookieMgrConfig[0, $aa96917b132802ee$export$bdba10701e0ccff3 /* @min:%2epath */ ] || "/";
        _domain = cookieMgrConfig[0, $aa96917b132802ee$export$8f3e5386cefa231e /* @min:%2edomain */ ];
        // Handle deferral state changes based on disableCookieDefer setting
        if (cookieMgrConfig.disableCookieDefer) // When deferral is disabled, set to null to disable any deferral behavior
        // All pending operations are dropped
        _pendingCookies = null;
        else if (_pendingCookies === null) // When deferral is enabled and was previously disabled, initialize empty buffer
        _pendingCookies = [];
        // Check if enabled state is changing
        var wasEnabled = _enabled;
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = $aaa64f3935d14265$var$_isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
        _getCookieFn = cookieMgrConfig.getCookie || $aaa64f3935d14265$var$_getCookieValue;
        _setCookieFn = cookieMgrConfig.setCookie || $aaa64f3935d14265$var$_setCookieValue;
        _delCookieFn = cookieMgrConfig.delCookie || $aaa64f3935d14265$var$_setCookieValue;
        // If cookies were just enabled via config change and we have pending cookies, flush them
        if (!wasEnabled && _enabled && _pendingCookies) _flushPendingCookies();
    }, logger);
    var cookieMgr = {
        isEnabled: function() {
            var enabled = $aaa64f3935d14265$var$_isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && $aaa64f3935d14265$export$25d06da9c29ef62a(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = $aaa64f3935d14265$var$_globalCookieConfig[$aaa64f3935d14265$var$strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
            // As the global (deprecated) functions may have been called (for backward compatibility)
            enabled = $aaa64f3935d14265$var$_isMgrEnabled(gblManager);
            return enabled;
        },
        setEnabled: function(value) {
            // Change the default config and allow the asynchronous dynamic config logic
            // to process all of the changes at once (like handling change to the enabled and
            // disabling caching at the same time)
            cookieMgrConfig[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = value;
            // If this value is defined someone else might be listening to it so also update it,
            // this also handles the edge case if the default above is not dynamic
            if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(rootConfig[$aaa64f3935d14265$var$strDisableCookiesUsage])) rootConfig[$aaa64f3935d14265$var$strDisableCookiesUsage] = !value;
        },
        set: function(name, value, maxAgeSec, domain, path) {
            var result = false;
            var isBlocked = $aaa64f3935d14265$var$_isBlockedCookie(cookieMgrConfig, name);
            if (!isBlocked) {
                var cookieValue = _formatSetCookieValue(value, maxAgeSec, domain, path);
                if ($aaa64f3935d14265$var$_isMgrEnabled(cookieMgr)) {
                    _setCookieFn(name, cookieValue);
                    result = true;
                } else if (_pendingCookies) {
                    // Defer the fully formatted cookie value if cookies are disabled and deferral is enabled
                    // Remove any previous operation for this cookie name (latest operation wins)
                    _removePendingCookie(name);
                    // Append new operation to the array
                    _pendingCookies[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
                        n: name,
                        o: 0 /* ePendingOp.Set */ ,
                        v: cookieValue
                    });
                    result = true; // Return true to indicate the operation was "successful" (deferred)
                }
            }
            return result;
        },
        get: function(name) {
            var value = (0, $aa96917b132802ee$export$5e8607ab26634759);
            var isIgnored = $aaa64f3935d14265$var$_isIgnoredCookie(cookieMgrConfig, name);
            if (!isIgnored) {
                if ($aaa64f3935d14265$var$_isMgrEnabled(cookieMgr)) value = _getCookieFn(name);
                else if (_pendingCookies) // Search for the most recent operation for this cookie (search backwards through array)
                for(var i = _pendingCookies[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; i >= 0; i--){
                    var pendingData = _pendingCookies[i];
                    if (pendingData.n === name) {
                        // Found the most recent operation for this cookie name
                        if (pendingData.o === 0 /* ePendingOp.Set */ ) {
                            // Return deferred value if it was a set operation
                            // Extract the value part from the formatted cookie string (before first semicolon)
                            var cookieValue = pendingData.v;
                            var idx = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(cookieValue, ";");
                            value = idx !== -1 ? (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)(cookieValue, idx)) : (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(cookieValue);
                        }
                        break;
                    }
                }
            }
            return value;
        },
        del: function(name, path) {
            var result = false;
            if ($aaa64f3935d14265$var$_isMgrEnabled(cookieMgr)) // Only remove the cookie if the manager and cookie support has not been disabled
            result = cookieMgr.purge(name, path);
            else if (_pendingCookies) {
                // Defer the deletion operation when cookies are disabled and deferral is enabled
                // Remove any previous operation for this cookie name (latest operation wins)
                _removePendingCookie(name);
                // Append new deletion operation to the array
                _pendingCookies[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
                    n: name,
                    o: 1 /* ePendingOp.Purge */ ,
                    v: _formatDeletionValue(path)
                });
                result = true;
            }
            return result;
        },
        purge: function(name, path) {
            var result = false;
            if ($aaa64f3935d14265$export$25d06da9c29ef62a(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                _delCookieFn(name, _formatDeletionValue(path));
                result = true;
            }
            return result;
        },
        unload: function(isAsync) {
            unloadHandler && unloadHandler.rm();
            unloadHandler = null;
            // Clear any pending cookies on unload
            _pendingCookies = null;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[$aaa64f3935d14265$var$strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
function $aaa64f3935d14265$export$25d06da9c29ef62a(logger) {
    if ($aaa64f3935d14265$var$_supportsCookies === null) {
        $aaa64f3935d14265$var$_supportsCookies = false;
        !$aaa64f3935d14265$var$_doc && $aaa64f3935d14265$var$_getDoc();
        try {
            var doc = $aaa64f3935d14265$var$_doc.v || {};
            $aaa64f3935d14265$var$_supportsCookies = doc[$aaa64f3935d14265$var$strCookie] !== undefined;
        } catch (e) {
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 68 /* _eInternalMessageId.CannotAccessCookie */ , "Cannot access document.cookie - " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
            });
        }
    }
    return $aaa64f3935d14265$var$_supportsCookies;
}
function $aaa64f3935d14265$var$_extractParts(theValue) {
    var values = {};
    if (theValue && theValue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) {
        var parts = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(theValue)[0, $45806013ed348c93$export$b889f1d4cb07c706 /* @min:%2esplit */ ](";");
        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(parts, function(thePart) {
            thePart = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(thePart || (0, $aa96917b132802ee$export$5e8607ab26634759));
            if (thePart) {
                var idx = (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(thePart, "=");
                if (idx === -1) values[thePart] = null;
                else values[(0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$a1120f14ec6f7ada)(thePart, idx))] = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)((0, $5831ddb3a0caf7c7$export$9d1aa7361d7a6e87)(thePart, idx + 1));
            }
        });
    }
    return values;
}
function $aaa64f3935d14265$var$_formatDate(theDate, func) {
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(theDate[func])) return theDate[func]();
    return null;
}
function $aaa64f3935d14265$var$_formatCookieValue(value, values) {
    var cookieValue = value || (0, $aa96917b132802ee$export$5e8607ab26634759);
    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(values, function(name, theValue) {
        cookieValue += "; " + name + (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(theValue) ? "=" + theValue : (0, $aa96917b132802ee$export$5e8607ab26634759));
    });
    return cookieValue;
}
function $aaa64f3935d14265$var$_getCookieValue(name) {
    var cookieValue = (0, $aa96917b132802ee$export$5e8607ab26634759);
    !$aaa64f3935d14265$var$_doc && $aaa64f3935d14265$var$_getDoc();
    if ($aaa64f3935d14265$var$_doc.v) {
        var theCookie = $aaa64f3935d14265$var$_doc.v[$aaa64f3935d14265$var$strCookie] || (0, $aa96917b132802ee$export$5e8607ab26634759);
        if ($aaa64f3935d14265$var$_parsedCookieValue !== theCookie) {
            $aaa64f3935d14265$var$_cookieCache = $aaa64f3935d14265$var$_extractParts(theCookie);
            $aaa64f3935d14265$var$_parsedCookieValue = theCookie;
        }
        cookieValue = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)($aaa64f3935d14265$var$_cookieCache[name] || (0, $aa96917b132802ee$export$5e8607ab26634759));
    }
    return cookieValue;
}
function $aaa64f3935d14265$var$_setCookieValue(name, cookieValue) {
    !$aaa64f3935d14265$var$_doc && $aaa64f3935d14265$var$_getDoc();
    if ($aaa64f3935d14265$var$_doc.v) $aaa64f3935d14265$var$_doc.v[$aaa64f3935d14265$var$strCookie] = name + "=" + cookieValue;
}
function $aaa64f3935d14265$export$e44499c7a8a6a268(userAgent) {
    if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(userAgent)) return false;
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "CPU iPhone OS 12") || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "iPad; CPU OS 12")) return true;
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Version/") && (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Safari")) return true;
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $5831ddb3a0caf7c7$export$5222b9460f3ddbec)(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Chrome/5") || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Chrome/6")) return true;
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "UnrealEngine") && !(0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "Chrome")) return true;
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if ((0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "UCBrowser/12") || (0, $ede407819d2d28c9$export$3185d777c612e61f)(userAgent, "UCBrowser/11")) return true;
    return false;
}



/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $771c93189b0d88d2$export$e2818d11505fa034 = "toString"; // Count: 4
var $771c93189b0d88d2$export$f357d96937d91514 = "isStorageUseDisabled"; // Count: 3
var $771c93189b0d88d2$export$3b3afe26ca0e015c = "_addHook"; // Count: 6
var $771c93189b0d88d2$export$f9ae8d0acf86503e = "core"; // Count: 14
var $771c93189b0d88d2$export$9e16762ab4f2648 = "dataType"; // Count: 8
var $771c93189b0d88d2$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $771c93189b0d88d2$export$c7ff2c36e5c78421 = "diagLog"; // Count: 13
var $771c93189b0d88d2$export$548634e98b3af9c4 = "track"; // Count: 7
var $771c93189b0d88d2$export$ab1a8669316b7a02 = "trackPageView"; // Count: 4
var $771c93189b0d88d2$export$25fc8bd3fb7f1e5a = "config"; // Count: 12
var $771c93189b0d88d2$export$5b63a890d51a5194 = "trackPreviousPageVisit"; // Count: 3
var $771c93189b0d88d2$export$e4d43b697816aae1 = "sendPageViewInternal"; // Count: 7
var $771c93189b0d88d2$export$e5e85cad974dcc3e = "refUri"; // Count: 5
var $771c93189b0d88d2$export$69cac26425c8ea23 = "startTime"; // Count: 6
var $771c93189b0d88d2$export$14814e6f9bf337b4 = "properties"; // Count: 5
var $771c93189b0d88d2$export$aa395e58f404db90 = "duration"; // Count: 12
var $771c93189b0d88d2$export$fe3039bd0e70dd3f = "sendPageViewPerformanceInternal"; // Count: 3
var $771c93189b0d88d2$export$20270e2265c2a185 = "populatePageViewPerformanceEvent"; // Count: 3
var $771c93189b0d88d2$export$8d0bd9d006f3ecea = "href"; // Count: 6
var $771c93189b0d88d2$export$5414b86ab837cb07 = "sendExceptionInternal"; // Count: 2
var $771c93189b0d88d2$export$ff0a0f80c43edd37 = "error"; // Count: 5
var $771c93189b0d88d2$export$4d19a8ea486d5967 = "lineNumber"; // Count: 4
var $771c93189b0d88d2$export$91a182df12726bcd = "columnNumber"; // Count: 5
var $771c93189b0d88d2$export$3dedbd38aa3b0c11 = "CreateAutoException"; // Count: 3
var $771c93189b0d88d2$export$935b759388157821 = "addTelemetryInitializer"; // Count: 4
var $771c93189b0d88d2$export$c653a2fea2d8252a = "overridePageViewDuration"; // Count: 2
var $771c93189b0d88d2$export$9e0ed8af39ae8738 = "autoExceptionInstrumented"; // Count: 3
var $771c93189b0d88d2$export$c1f17e781e48369e = "autoTrackPageVisitTime"; // Count: 2
var $771c93189b0d88d2$export$c9f80c3a383cb550 = "isBrowserLinkTrackingEnabled"; // Count: 2
var $771c93189b0d88d2$export$6eae51590aaea43 = "length"; // Count: 5
var $771c93189b0d88d2$export$3ef99e7e473f5074 = "enableAutoRouteTracking"; // Count: 2
var $771c93189b0d88d2$export$58fc531fa5b69a19 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var $771c93189b0d88d2$export$598019645af4acbc = "autoUnhandledPromiseInstrumented"; // Count: 3
var $771c93189b0d88d2$export$96ba0dffa6c93bb1 = "getEntriesByType"; // Count: 5
var $771c93189b0d88d2$export$e5e0853aee05b6f1 = "isPerformanceTimingSupported"; // Count: 2
var $771c93189b0d88d2$export$33cffefcaeb637ee = "getPerformanceTiming"; // Count: 2
var $771c93189b0d88d2$export$f8670e269dbf7411 = "navigationStart"; // Count: 4
var $771c93189b0d88d2$export$c117ef31798b5bf3 = "shouldCollectDuration"; // Count: 3
var $771c93189b0d88d2$export$cf7e3f7d4eb87181 = "isPerformanceTimingDataReady"; // Count: 2
var $771c93189b0d88d2$export$efd7bea2390142dc = "responseStart"; // Count: 5
var $771c93189b0d88d2$export$2a979904ebe4c805 = "requestStart"; // Count: 3
var $771c93189b0d88d2$export$3e2743adb5050880 = "loadEventEnd"; // Count: 4
var $771c93189b0d88d2$export$cb472b94f03785cf = "responseEnd"; // Count: 5
var $771c93189b0d88d2$export$ade5c25ec120f74e = "connectEnd"; // Count: 4


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/**
 * Class encapsulates sending page views and page view performance telemetry.
 */ var $89593731a05de0fb$export$5bb8d6768724bf86 = /** @class */ function() {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PageViewManager, this, function(_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var firstPageViewSent = false;
            var _logger;
            if (core) _logger = core.logger;
            function _flushChannels(isAsync) {
                if (core) core.flush(isAsync, function() {
                // Event flushed, callback added to prevent promise creation
                });
            }
            function _startTimer() {
                if (!queueTimer) queueTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush = false;
                    itemQueue = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(allItems, function(item) {
                        if (!item()) // Not processed so rescheduled
                        itemQueue.push(item);
                        else doFlush = true;
                    });
                    if (itemQueue[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _startTimer();
                    if (doFlush) // We process at least one item so flush the queue
                    _flushChannels(true);
                }, 100);
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                var name = pageView.name;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(name) || typeof name !== "string") {
                    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(uri) || typeof uri !== "string") {
                    var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                    uri = pageView.uri = location_1 && location_1[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                }
                if (core && core[0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]) uri = pageView.uri = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(pageView.uri, core[0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]);
                if (!firstPageViewSent) {
                    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
                    // Access the performance timing object
                    var navigationEntries = perf && perf[0, $771c93189b0d88d2$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ] && perf[0, $771c93189b0d88d2$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ]("navigation");
                    // Edge Case the navigation Entries may return an empty array and the timeOrigin is not supported on IE
                    if (navigationEntries && navigationEntries[0] && !(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(perf.timeOrigin)) {
                        // Get the value of loadEventStart
                        var loadEventStart = navigationEntries[0].loadEventStart;
                        pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date(perf.timeOrigin + loadEventStart);
                    } else {
                        // calculate the start time manually
                        var duration_1 = (customProperties || pageView[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] || {})[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] || 0;
                        pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date(new Date().getTime() - duration_1);
                    }
                    firstPageViewSent = true;
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[0, $771c93189b0d88d2$export$e5e0853aee05b6f1 /* @min:%2eisPerformanceTimingSupported */ ]()) {
                    appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    if (!(0, $5831ddb3a0caf7c7$export$97b87b8868ff7a3c)()) // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 25 /* _eInternalMessageId.NavigationTimingNotSupported */ , "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[0, $771c93189b0d88d2$export$33cffefcaeb637ee /* @min:%2egetPerformanceTiming */ ]()[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ];
                if (start > 0) {
                    customDuration = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(start, +new Date);
                    if (!pageViewPerformanceManager[0, $771c93189b0d88d2$export$c117ef31798b5bf3 /* @min:%2eshouldCollectDuration */ ](customDuration)) customDuration = undefined;
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customProperties) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ])) duration = customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ];
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) customProperties = {};
                        customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = customDuration;
                    }
                    // case 2
                    appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) customProperties = {};
                // Queue the event for processing
                _addQueue(function() {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[0, $771c93189b0d88d2$export$cf7e3f7d4eb87181 /* @min:%2eisPerformanceTimingDataReady */ ]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[0, $771c93189b0d88d2$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = customDuration;
                                appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            } else {
                                if (!pageViewSent) {
                                    customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = pageViewPerformance.durationMs;
                                    appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[0, $771c93189b0d88d2$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        } else if (start > 0 && (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = maxDurationLimit;
                                appInsights[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            }
                        }
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 38 /* _eInternalMessageId.TrackPVFailedCalc */ , "trackPageView failed on page load calculation: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                        });
                    }
                    return processed;
                });
            };
            _self.teardown = function(unloadCtx, unloadState) {
                if (queueTimer) {
                    queueTimer.cancel();
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush_1 = false;
                    itemQueue = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(allItems, function(item) {
                        if (item()) doFlush_1 = true;
                    });
                }
            };
        });
    }
    // Removed Stub for PageViewManager.prototype.trackPageView.
    // Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewManager.__ieDyn = 1;
    return PageViewManager;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $b9c3d156d6cc38c0$var$MAX_DURATION_ALLOWED = 3600000; // 1h
var $b9c3d156d6cc38c0$var$botAgentNames = [
    "googlebot",
    "adsbot-google",
    "apis-google",
    "mediapartners-google"
];
function $b9c3d156d6cc38c0$var$_isPerformanceTimingSupported() {
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    return perf && !!perf.timing;
}
function $b9c3d156d6cc38c0$var$_isPerformanceNavigationTimingSupported() {
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
}
function $b9c3d156d6cc38c0$var$_isPerformanceTimingDataReady() {
    var perf = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
    var timing = perf ? perf.timing : 0;
    return timing && timing.domainLookupStart > 0 && timing[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ] > 0 && timing[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ] > 0 && timing[0, $771c93189b0d88d2$export$2a979904ebe4c805 /* @min:%2erequestStart */ ] > 0 && timing[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ] > 0 && timing[0, $771c93189b0d88d2$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ] > 0 && timing[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ] > 0 && timing.domLoading > 0;
}
function $b9c3d156d6cc38c0$var$_getPerformanceTiming() {
    if ($b9c3d156d6cc38c0$var$_isPerformanceTimingSupported()) return (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)().timing;
    return null;
}
function $b9c3d156d6cc38c0$var$_getPerformanceNavigationTiming() {
    if ($b9c3d156d6cc38c0$var$_isPerformanceNavigationTimingSupported()) return (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)()[0, $771c93189b0d88d2$export$96ba0dffa6c93bb1 /* @min:%2egetEntriesByType */ ]("navigation")[0];
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/ function $b9c3d156d6cc38c0$var$_shouldCollectDuration() {
    var durations = [];
    for(var _i = 0; _i < arguments.length; _i++)durations[_i] = arguments[_i];
    var _navigator = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) for(var i = 0; i < $b9c3d156d6cc38c0$var$botAgentNames[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ]; i++)isGoogleBot = isGoogleBot || (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(userAgent.toLowerCase(), $b9c3d156d6cc38c0$var$botAgentNames[i]) !== -1;
    if (isGoogleBot) // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
    return false;
    else // for other page views, don't report if it's outside of a reasonable range
    for(var i = 0; i < durations[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
        if (durations[i] < 0 || durations[i] >= $b9c3d156d6cc38c0$var$MAX_DURATION_ALLOWED) return false;
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */ var $b9c3d156d6cc38c0$export$da80ef98bc1bafa6 = /** @class */ function() {
    function PageViewPerformanceManager(core) {
        var _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PageViewPerformanceManager, this, function(_self) {
            _self[0, $771c93189b0d88d2$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ] = function(pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */ var navigationTiming = $b9c3d156d6cc38c0$var$_getPerformanceNavigationTiming();
                var timing = $b9c3d156d6cc38c0$var$_getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */ network = navigationTiming[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] === 0 ? navigationTiming[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ] : (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ], navigationTiming[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ]);
                        request = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming.requestStart, navigationTiming[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ]);
                        response = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ], navigationTiming[0, $771c93189b0d88d2$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ]);
                        dom = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(navigationTiming.responseEnd, navigationTiming[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                    } else {
                        total = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ], timing[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                        network = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing[0, $771c93189b0d88d2$export$f8670e269dbf7411 /* @min:%2enavigationStart */ ], timing[0, $771c93189b0d88d2$export$ade5c25ec120f74e /* @min:%2econnectEnd */ ]);
                        request = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing.requestStart, timing[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ]);
                        response = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing[0, $771c93189b0d88d2$export$efd7bea2390142dc /* @min:%2eresponseStart */ ], timing[0, $771c93189b0d88d2$export$cb472b94f03785cf /* @min:%2eresponseEnd */ ]);
                        dom = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(timing.responseEnd, timing[0, $771c93189b0d88d2$export$3e2743adb5050880 /* @min:%2eloadEventEnd */ ]);
                    }
                    if (total === 0) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 10 /* _eInternalMessageId.ErrorPVCalc */ , "error calculating page view performance.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (!_self[0, $771c93189b0d88d2$export$c117ef31798b5bf3 /* @min:%2eshouldCollectDuration */ ](total, network, request, response, dom)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 45 /* _eInternalMessageId.InvalidDurationValue */ , "Invalid page load duration value. Browser perf data won't be sent.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (total < (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(network) + (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(request) + (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(response) + (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(dom)) // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                    // in this case, don't report client performance from this page
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 8 /* _eInternalMessageId.ClientPerformanceMathError */ , "client performance math error.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(total);
                        pageViewPerformance.networkConnect = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(network);
                        pageViewPerformance.sentRequest = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(request);
                        pageViewPerformance.receivedResponse = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(response);
                        pageViewPerformance.domProcessing = (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[0, $771c93189b0d88d2$export$33cffefcaeb637ee /* @min:%2egetPerformanceTiming */ ] = $b9c3d156d6cc38c0$var$_getPerformanceTiming;
            _self[0, $771c93189b0d88d2$export$e5e0853aee05b6f1 /* @min:%2eisPerformanceTimingSupported */ ] = $b9c3d156d6cc38c0$var$_isPerformanceTimingSupported;
            _self[0, $771c93189b0d88d2$export$cf7e3f7d4eb87181 /* @min:%2eisPerformanceTimingDataReady */ ] = $b9c3d156d6cc38c0$var$_isPerformanceTimingDataReady;
            _self[0, $771c93189b0d88d2$export$c117ef31798b5bf3 /* @min:%2eshouldCollectDuration */ ] = $b9c3d156d6cc38c0$var$_shouldCollectDuration;
        });
    }
    // Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
    // Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
    // Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewPerformanceManager.__ieDyn = 1;
    return PageViewPerformanceManager;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/**
 * Used to track page visit durations
 */ var $1e4790eb1573bab6$export$f6fdd81afb2fe76 = /** @class */ function() {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */ function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PageVisitTimeManager, this, function(_self) {
            _self[0, $771c93189b0d88d2$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ] = function(currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                } catch (e) {
                    (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Auto track page visit time failed, metric will not be collected: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName - Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */ function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    if ((0, $3fab9bbcce274f86$export$c81985c4209bac26)()) {
                        if ((0, $3fab9bbcce274f86$export$a398bd2f40e2eb6e)(logger, prevPageVisitDataKeyName) != null) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        var currPageVisitDataStr = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().stringify(new $1e4790eb1573bab6$export$513202441432a369(pageName, pageUrl));
                        (0, $3fab9bbcce274f86$export$21abea3a85fee3f5)(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Call to restart failed: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */ function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if ((0, $3fab9bbcce274f86$export$c81985c4209bac26)()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = (0, $3fab9bbcce274f86$export$a398bd2f40e2eb6e)(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && (0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData.pageVisitStartTime;
                            // Remove data from storage since we already used it
                            (0, $3fab9bbcce274f86$export$9f411b4ea05fb92a)(logger, prevPageVisitDataKeyName);
                        }
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Stop page visit timer failed: " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_logger", {
                g: function() {
                    return logger;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "pageVisitTimeTrackingHandler", {
                g: function() {
                    return pageVisitTimeTrackingHandler;
                }
            });
        });
    }
    // Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageVisitTimeManager.__ieDyn = 1;
    return PageVisitTimeManager;
}();
var $1e4790eb1573bab6$export$513202441432a369 = /** @class */ function() {
    function PageVisitData(pageName, pageUrl) {
        this.pageVisitStartTime = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}();


/*
 * Application Insights JavaScript SDK - Web Analytics, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/**
 * Used to record timed events and page views.
 */ var $a8a86e0b8e3fa866$export$ef1e5872612852d1 = /** @class */ function() {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function(name) {
            if (typeof _events[name] !== "undefined") (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 62 /* _eInternalMessageId.StartCalledMoreThanOnce */ , "start was called more than once for this event without calling stop.", {
                name: name,
                key: name
            }, true);
            _events[name] = +new Date;
        };
        _self.stop = function(name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 63 /* _eInternalMessageId.StopCalledWithoutStart */ , "stop was called without a corresponding start.", {
                name: name,
                key: name
            }, true);
            else {
                var end = +new Date;
                var duration = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}();


var $f8c459c2dab16ec4$var$_a;
var $f8c459c2dab16ec4$var$strEvent = "event";
function $f8c459c2dab16ec4$var$_dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) target.dispatchEvent(evnt);
}
function $f8c459c2dab16ec4$var$_getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(reason) && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(reason[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ])) return reason[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ]();
        return (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var $f8c459c2dab16ec4$var$MinMilliSeconds = 60000;
var $f8c459c2dab16ec4$var$defaultValues = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($f8c459c2dab16ec4$var$_a = {
    sessionRenewalMs: (0, $3b63eef6ee7529a9$export$e86b712d02676c90)($f8c459c2dab16ec4$var$_chkConfigMilliseconds, 1800000),
    sessionExpirationMs: (0, $3b63eef6ee7529a9$export$e86b712d02676c90)($f8c459c2dab16ec4$var$_chkConfigMilliseconds, 86400000),
    disableExceptionTracking: (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)()
}, $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$c1f17e781e48369e /* @min:autoTrackPageVisitTime */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$c653a2fea2d8252a /* @min:overridePageViewDuration */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$58fc531fa5b69a19 /* @min:enableUnhandledPromiseRejectionTracking */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$598019645af4acbc /* @min:autoUnhandledPromiseInstrumented */ ] = false, $f8c459c2dab16ec4$var$_a.samplingPercentage = (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)($f8c459c2dab16ec4$var$_chkSampling, 100), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$f357d96937d91514 /* @min:isStorageUseDisabled */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$c9f80c3a383cb550 /* @min:isBrowserLinkTrackingEnabled */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a[0, $771c93189b0d88d2$export$3ef99e7e473f5074 /* @min:enableAutoRouteTracking */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a.namePrefix = (0, $3b63eef6ee7529a9$export$75965e1022d5969a)(), $f8c459c2dab16ec4$var$_a.enableDebug = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a.disableFlushOnBeforeUnload = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $f8c459c2dab16ec4$var$_a.disableFlushOnUnload = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(false, "disableFlushOnBeforeUnload"), $f8c459c2dab16ec4$var$_a.expCfg = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)({
    inclScripts: false,
    expLog: undefined,
    maxLogs: 50
}), $f8c459c2dab16ec4$var$_a));
function $f8c459c2dab16ec4$var$_chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < $f8c459c2dab16ec4$var$MinMilliSeconds) value = $f8c459c2dab16ec4$var$MinMilliSeconds;
    return +value;
}
function $f8c459c2dab16ec4$var$_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function $f8c459c2dab16ec4$var$_updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(extConfig[0, $771c93189b0d88d2$export$f357d96937d91514 /* @min:%2eisStorageUseDisabled */ ])) {
        if (extConfig[0, $771c93189b0d88d2$export$f357d96937d91514 /* @min:%2eisStorageUseDisabled */ ]) (0, $3fab9bbcce274f86$export$53ddd0ab7db9403)();
        else (0, $3fab9bbcce274f86$export$f08cf9bcd292b981)();
    }
}
var $f8c459c2dab16ec4$export$ca681bfeb2cf0fca = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = (0, $5343a490b8ca01c7$export$862d858b0002f352); // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        var _expCfg;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        // For testing error hooks only
        var _errorHookCnt;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AnalyticsPlugin, _this, function(_self, _base) {
            var _addHook = _base[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ];
            _initDefaults();
            _self.getCookieMgr = function() {
                return (0, $aaa64f3935d14265$export$76c0b273586c25c7)(_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
            };
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function(event, customProperties) {
                try {
                    var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(event, (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param name - A string that identifies this event uniquely within the document.
             */ _self.startTrackEvent = function(name) {
                try {
                    _eventTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 29 /* _eInternalMessageId.StartTrackEventFailed */ , "startTrackEvent failed, event will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param name - The string you used to identify this event in `startTrackEvent`.
             * @param properties - map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param measurements - map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackEvent = function(name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 30 /* _eInternalMessageId.StopTrackEventFailed */ , "stopTrackEvent failed, event will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace - the trace message
             * @param customProperties - Additional custom properties to include in the event
             */ _self.trackTrace = function(trace, customProperties) {
                try {
                    var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(trace, (0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             */ _self.trackMetric = function(metric, customProperties) {
                try {
                    var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(metric, (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 36 /* _eInternalMessageId.TrackMetricFailed */ , "trackMetric failed, metric will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */ _self[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]) inPv.uri = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(inPv.uri, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]);
                    _pageViewManager[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ](inPv, (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) _pageVisitTimeManager[0, $771c93189b0d88d2$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ](inPv.name, inPv.uri);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageView failed, page view will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */ _self[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ] = function(pageView, properties, systemProperties) {
                var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                if (doc) pageView[0, $771c93189b0d88d2$export$e5e85cad974dcc3e /* @min:%2erefUri */ ] = pageView[0, $771c93189b0d88d2$export$e5e85cad974dcc3e /* @min:%2erefUri */ ] === undefined ? doc.referrer : pageView[0, $771c93189b0d88d2$export$e5e85cad974dcc3e /* @min:%2erefUri */ ];
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]) pageView.refUri = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(pageView.refUri, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]);
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ])) {
                    // calculate the start time manually
                    var duration = (properties || pageView[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] || {})[0, $771c93189b0d88d2$export$aa395e58f404db90 /* @min:%2eduration */ ] || 0;
                    pageView[0, $771c93189b0d88d2$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date(new Date().getTime() - duration);
                }
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(pageView, (0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
                // reset ajaxes counter
                _resetAjaxAttempts();
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */ _self[0, $771c93189b0d88d2$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ] = function(pageViewPerformance, properties, systemProperties) {
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(pageViewPerformance, (0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */ _self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[0, $771c93189b0d88d2$export$20270e2265c2a185 /* @min:%2epopulatePageViewPerformanceEvent */ ](inPvp);
                    _self[0, $771c93189b0d88d2$export$fe3039bd0e70dd3f /* @min:%2esendPageViewPerformanceInternal */ ](inPvp, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageViewPerformance failed, page view will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */ _self.startTrackPage = function(name) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 31 /* _eInternalMessageId.StartTrackFailed */ , "startTrackPage failed, page view may not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param name - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param url - String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param properties - map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param measurements - map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackPage = function(name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                        url = loc && loc[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    }
                    if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]) url = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(url, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]);
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) _pageVisitTimeManager[0, $771c93189b0d88d2$export$5b63a890d51a5194 /* @min:%2etrackPreviousPageVisit */ ](name, url);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 32 /* _eInternalMessageId.StopTrackFailed */ , "stopTrackPage failed, page view will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */ _self[0, $771c93189b0d88d2$export$5414b86ab837cb07 /* @min:%2esendExceptionInternal */ ] = function(exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = exception && (exception.exception || exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
                (0, $5831ddb3a0caf7c7$export$e6127cc7fe7395c3)(exception) && exception || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                //   is preserved and does not list ApplicationInsights code as the source
                {
                    name: exception && typeof exception,
                    message: exception || (0, $8ac3b4fe9182f568$export$4003f5e1672d759)
                };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new (0, $a35c931c4df783c8$export$e2f174de097e0bcd)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), theError, exception[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ] || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
                if (doc && (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.inclScripts)) {
                    var scriptsInfo = (0, $4726195e2d737947$export$1329d5a456df56f)(doc);
                    exceptionPartB[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ]["exceptionScripts"] = JSON.stringify(scriptsInfo);
                }
                if (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.expLog) {
                    var logs = _expCfg.expLog();
                    if (logs && logs.logs && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(logs.logs)) exceptionPartB[0, $771c93189b0d88d2$export$14814e6f9bf337b4 /* @min:%2eproperties */ ]["exceptionLog"] = logs.logs.slice(0, _expCfg.maxLogs).join("\n");
                }
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(exceptionPartB, (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), customProperties, systemProperties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             */ _self.trackException = function(exception, customProperties) {
                if (exception && !exception.exception && exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ]) exception.exception = exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ];
                try {
                    _self[0, $771c93189b0d88d2$export$5414b86ab837cb07 /* @min:%2esendExceptionInternal */ ](exception, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 35 /* _eInternalMessageId.TrackExceptionFailed */ , "trackException failed, exception will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             */ _self._onerror = function(exception) {
                var error = exception && exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                        if (_window) evt = _window[$f8c459c2dab16ec4$var$strEvent];
                    }
                    var url = exception && exception.url || ((0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception.errorSrc || "window.onerror@" + url + ":" + (exception[0, $771c93189b0d88d2$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0) + ":" + (exception[0, $771c93189b0d88d2$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[0, $771c93189b0d88d2$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0,
                        columnNumber: exception[0, $771c93189b0d88d2$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0,
                        message: exception.message
                    };
                    if ((0, $7c0ecef5df4b34f7$export$8c465f5f14327ccd)(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[0, $771c93189b0d88d2$export$ff0a0f80c43edd37 /* @min:%2eerror */ ])) _sendCORSException((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[0, $771c93189b0d88d2$export$4d19a8ea486d5967 /* @min:%2elineNumber */ ] || 0, exception[0, $771c93189b0d88d2$export$91a182df12726bcd /* @min:%2ecolumnNumber */ ] || 0, error, evt, null, errorSrc), properties);
                    else {
                        if (!exception.errorSrc) exception.errorSrc = errorSrc;
                        _self.trackException({
                            exception: exception,
                            severityLevel: 3 /* eSeverityLevel.Error */ 
                        }, properties);
                    }
                } catch (e) {
                    var errorString = error ? error.name + ", " + error.message : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 11 /* _eInternalMessageId.ExceptionWhileLoggingError */ , "_onError threw exception while logging error, error will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e),
                        errorString: errorString
                    });
                }
            };
            _self[0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ] = function(telemetryInitializer) {
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]) // Just add to the core
                return _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](telemetryInitializer);
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) _preInitTelemetryInitializers = [];
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) return;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(core)) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Error initializing");
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_preInitTelemetryInitializers, function(initializer) {
                            core[0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = new (0, $b9c3d156d6cc38c0$export$da80ef98bc1bafa6)(_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
                    _pageViewManager = new (0, $89593731a05de0fb$export$5bb8d6768724bf86)(_self, _extConfig.overridePageViewDuration, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new (0, $1e4790eb1573bab6$export$f6fdd81afb2fe76)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), function(pageName, pageUrl, pageVisitTime) {
                        return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
                    });
                    _eventTracking = new (0, $a8a86e0b8e3fa866$export$ef1e5872612852d1)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), "trackEvent");
                    _eventTracking.action = function(name, url, duration, properties, measurements) {
                        if (!properties) properties = {};
                        if (!measurements) measurements = {};
                        properties.duration = duration[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        _self.trackEvent({
                            name: name,
                            properties: properties,
                            measurements: measurements
                        });
                    };
                    // initialize page view timing
                    _pageTracking = new (0, $a8a86e0b8e3fa866$export$ef1e5872612852d1)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), "trackPageView");
                    _pageTracking.action = function(name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(properties)) properties = {};
                        properties.duration = duration[0, $771c93189b0d88d2$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[0, $771c93189b0d88d2$export$e4d43b697816aae1 /* @min:%2esendPageViewInternal */ ](pageViewItem, properties);
                    };
                    if ((0, $5831ddb3a0caf7c7$export$fef62134eea24008)()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                } catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                (0, $02f0ede5277c99cd$export$51dedceb7c784eff)(window, null, null, _evtNamespace);
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _errorHookCnt,
                    _autoExceptionInstrumented
                ];
            };
            function _resetAjaxAttempts() {
                // Reset ajax attempts counter for the new page view
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ]) {
                    var ajaxPlugin = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin("AjaxDependencyPlugin");
                    if (ajaxPlugin && ajaxPlugin.plugin && ajaxPlugin.plugin.resetAjaxAttempts) ajaxPlugin.plugin.resetAjaxAttempts();
                }
            }
            function _populateDefaults(config) {
                // it is used for 1DS as well, so config type should be IConfiguration only
                var identifier = _self.identifier;
                var core = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ];
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, $f8c459c2dab16ec4$var$defaultValues);
                    // make sure auto exception is instrumented only once and it won't be overriden by the following config changes
                    _autoExceptionInstrumented = _autoExceptionInstrumented || config[0, $771c93189b0d88d2$export$9e0ed8af39ae8738 /* @min:%2eautoExceptionInstrumented */ ] || _extConfig[0, $771c93189b0d88d2$export$9e0ed8af39ae8738 /* @min:%2eautoExceptionInstrumented */ ];
                    _expCfg = _extConfig.expCfg;
                    _autoTrackPageVisitTime = _extConfig[0, $771c93189b0d88d2$export$c1f17e781e48369e /* @min:%2eautoTrackPageVisitTime */ ];
                    if (config.storagePrefix) (0, $3fab9bbcce274f86$export$a08dccf4adbf6df9)(config.storagePrefix);
                    $f8c459c2dab16ec4$var$_updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[0, $771c93189b0d88d2$export$c9f80c3a383cb550 /* @min:%2eisBrowserLinkTrackingEnabled */ ];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param pageName - Name of page
             * @param pageVisitDuration - Duration of visit to the page in milliseconds
             */ function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = {
                    PageName: pageName,
                    PageUrl: pageUrl
                };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = [
                        "/browserLinkSignalR/",
                        "/__browserLink/"
                    ];
                    var dropBrowserLinkRequests = function(envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === (0, $97ca5e424f1910ef$export$a7b48490930dbffa)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) for(var i = 0; i < browserLinkPaths_1[0, $771c93189b0d88d2$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
                                if (remoteData.target && (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(remoteData.target, browserLinkPaths_1[i]) >= 0) return false;
                            }
                        }
                        return true;
                    };
                    _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ](_self[0, $771c93189b0d88d2$export$935b759388157821 /* @min:%2eaddTelemetryInitializer */ ](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(exception, (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$9e16762ab4f2648 /* @min:%2edataType */ ], (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), properties);
                _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$548634e98b3af9c4 /* @min:%2etrack */ ](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                var locn = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)(true);
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extConfig, function() {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig[0, $771c93189b0d88d2$export$9e0ed8af39ae8738 /* @min:%2eautoExceptionInstrumented */ ]) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) _self._onerror((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ](message, url, lineNumber, columnNumber, error, callDetails.evt));
                            }
                        }, false));
                        _errorHookCnt++;
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                var locn = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)(true);
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extConfig, function() {
                    _enableAutoRouteTracking = _extConfig[0, $771c93189b0d88d2$export$3ef99e7e473f5074 /* @min:%2eenableAutoRouteTracking */ ] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */ if (win && _enableAutoRouteTracking && !_historyListenerAdded && (0, $5831ddb3a0caf7c7$export$b79afd6d47f11781)()) {
                        var _history = (0, $5831ddb3a0caf7c7$export$f9582a3c130d9538)();
                        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_history.pushState) && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_history.replaceState) && typeof Event !== (0, $042f611b66f4fd6f$export$9b7d2d86cf58b987)) _addHistoryListener(win, _history, locn);
                    }
                }));
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx(false);
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin((0, $5343a490b8ca01c7$export$2268e69a6d93b7cc));
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) distributedTraceCtx = (0, $d98f9809e5d6a7c7$export$847d5dabba5fabb9)(context.telemetryTrace);
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */ function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) return;
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    } else _currUri = locn && locn[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                    if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]) _currUri = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(_currUri, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]);
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId((0, $61bcf5b470259c00$export$58d1fad45f39d957)());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) traceLocationName = locn.pathname + (locn.hash || "");
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName((0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(_self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), traceLocationName));
                        }
                        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)((function(uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[0, $771c93189b0d88d2$export$ab1a8669316b7a02 /* @min:%2etrackPageView */ ]({
                                refUri: uri,
                                properties: {
                                    duration: 0
                                }
                            }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function() {
                        if (_enableAutoRouteTracking) {
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "pushState"));
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function() {
                        if (_enableAutoRouteTracking) {
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "replaceState"));
                            $f8c459c2dab16ec4$var$_dispatchEvent(win, (0, $26e033f7638321e5$export$58aa8b47bf337bc8)(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                (0, $02f0ede5277c99cd$export$324ab159353a60a9)(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                (0, $02f0ede5277c99cd$export$324ab159353a60a9)(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[0, $771c93189b0d88d2$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extConfig, function() {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[0, $771c93189b0d88d2$export$58fc531fa5b69a19 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[0, $771c93189b0d88d2$export$598019645af4acbc /* @min:%2eautoUnhandledPromiseInstrumented */ ];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook((0, $b3babfece552aa67$export$b96f6cbe9b035430)(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function(callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) _self._onerror((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $771c93189b0d88d2$export$3dedbd38aa3b0c11 /* @min:%2eCreateAutoException */ ]($f8c459c2dab16ec4$var$_getReason(error), _location ? _location[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] : "", 0, 0, error, callDetails.evt));
                            }
                        }, false));
                        _errorHookCnt++;
                        _extConfig[0, $771c93189b0d88d2$export$598019645af4acbc /* @min:%2eautoUnhandledPromiseInstrumented */ ] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - The severity of the log message
             * @param msgId - The log message.
             */ function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[0, $771c93189b0d88d2$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // Reset ajax attempts counter
                _resetAjaxAttempts();
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)(true);
                _prevUri = location && location[0, $771c93189b0d88d2$export$8d0bd9d006f3ecea /* @min:%2ehref */ ] || "";
                if (_self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]) _prevUri = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(_prevUri, _self[0, $771c93189b0d88d2$export$f9ae8d0acf86503e /* @min:%2ecore */ ][0, $771c93189b0d88d2$export$25fc8bd3fb7f1e5a /* @min:%2econfig */ ]);
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                _errorHookCnt = 0;
                // Define _self.config
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                    g: function() {
                        return _extConfig;
                    }
                });
            }
            // For backward compatibility
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_pageViewManager", {
                g: function() {
                    return _pageViewManager;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_pageViewPerformanceManager", {
                g: function() {
                    return _pageViewPerformanceManager;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_pageVisitTimeManager", {
                g: function() {
                    return _pageVisitTimeManager;
                }
            });
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_evtNamespace", {
                g: function() {
                    return "." + _evtNamespace;
                }
            });
        });
        return _this;
    }
    // Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
    // Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
    // Removed Stub for AnalyticsPlugin.prototype.trackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.trackTrace.
    // Removed Stub for AnalyticsPlugin.prototype.trackMetric.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageView.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackException.
    // Removed Stub for AnalyticsPlugin.prototype._onerror.
    // Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = '3.3.10'; // Not currently used anywhere
    return AnalyticsPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* CfgSyncPlugin.ts
* @copyright Microsoft 2018
*/ 



/*!
 * NevWare21 Solutions LLC - ts-async, 0.5.4
 * https://github.com/nevware21/ts-async
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */ 

var $4121df0a705d038e$var$STR_PROMISE = "Promise";
var $4121df0a705d038e$var$DONE = "done";
var $4121df0a705d038e$var$VALUE = "value";
var $4121df0a705d038e$var$RETURN = "return";
var $4121df0a705d038e$var$REJECTED = "rejected";
function $4121df0a705d038e$export$856fe465480fa77a(value, cb) {
    return $4121df0a705d038e$export$96acbd3e4fcaef01(value, function(value) {
        return cb ? cb({
            status: "fulfilled",
            rejected: false,
            value: value
        }) : value;
    }, function(reason) {
        return cb ? cb({
            status: $4121df0a705d038e$var$REJECTED,
            rejected: true,
            reason: reason
        }) : reason;
    });
}
function $4121df0a705d038e$export$96acbd3e4fcaef01(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    try {
        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) {
            if (resolveFn || rejectFn) result = value.then(resolveFn, rejectFn);
        } else try {
            if (resolveFn) result = resolveFn(value);
        } catch (err) {
            if (rejectFn) result = rejectFn(err);
            else throw err;
        }
    } finally{
        if (finallyFn) $4121df0a705d038e$export$8a7042cf3f497261(result, finallyFn);
    }
    return result;
}
function $4121df0a705d038e$export$8a7042cf3f497261(value, finallyFn) {
    var result = value;
    if (finallyFn) {
        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) {
            if (value.finally) result = value.finally(finallyFn);
            else result = value.then(function(value) {
                finallyFn();
                return value;
            }, function(reason) {
                finallyFn();
                throw reason;
            });
        } else finallyFn();
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_pureAssign(func1, func2) {
    return func1 || func2;
}
var $4121df0a705d038e$var$_debugState;
var $4121df0a705d038e$var$_debugResult;
var $4121df0a705d038e$var$_debugHandled;
var $4121df0a705d038e$var$_promiseDebugEnabled = false;
function $4121df0a705d038e$var$_addDebugState$1(thePromise, stateFn, resultFn, handledFn) {
    $4121df0a705d038e$var$_debugState = $4121df0a705d038e$var$_debugState || {
        toString: function() {
            return "[[PromiseState]]";
        }
    };
    $4121df0a705d038e$var$_debugResult = $4121df0a705d038e$var$_debugResult || {
        toString: function() {
            return "[[PromiseResult]]";
        }
    };
    $4121df0a705d038e$var$_debugHandled = $4121df0a705d038e$var$_debugHandled || {
        toString: function() {
            return "[[PromiseIsHandled]]";
        }
    };
    var props = {};
    props[$4121df0a705d038e$var$_debugState] = {
        get: stateFn
    };
    props[$4121df0a705d038e$var$_debugResult] = {
        get: resultFn
    };
    props[$4121df0a705d038e$var$_debugHandled] = {
        get: handledFn
    };
    (0, $5831ddb3a0caf7c7$export$aa4c975d12edd698)(thePromise, props);
}
function $4121df0a705d038e$export$8e8a3d6691d8254(enabled, logger) {
    $4121df0a705d038e$var$_promiseDebugEnabled = enabled;
}
var $4121df0a705d038e$var$STRING_STATES = [
    "pending",
    "resolving",
    "resolved",
    $4121df0a705d038e$var$REJECTED
];
var $4121df0a705d038e$var$DISPATCH_EVENT = "dispatchEvent";
var $4121df0a705d038e$var$_hasInitEvent;
function $4121df0a705d038e$var$_hasInitEventFn(doc) {
    var evt;
    if (doc && doc.createEvent) evt = doc.createEvent("Event");
    return !!evt && evt.initEvent;
}
function $4121df0a705d038e$var$emitEvent(target, evtName, populateEvent, useNewEvent) {
    var doc = (0, $5831ddb3a0caf7c7$export$f65ca476c09acec0)();
    !$4121df0a705d038e$var$_hasInitEvent && ($4121df0a705d038e$var$_hasInitEvent = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(!!(0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)($4121df0a705d038e$var$_hasInitEventFn, [
        doc
    ]).v));
    var theEvt = $4121df0a705d038e$var$_hasInitEvent.v ? doc.createEvent("Event") : useNewEvent ? new Event(evtName) : {};
    populateEvent && populateEvent(theEvt);
    if ($4121df0a705d038e$var$_hasInitEvent.v) theEvt.initEvent(evtName, false, true);
    if (theEvt && target[$4121df0a705d038e$var$DISPATCH_EVENT]) target[$4121df0a705d038e$var$DISPATCH_EVENT](theEvt);
    else {
        var handler = target["on" + evtName];
        if (handler) handler(theEvt);
        else {
            var theConsole = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(theEvt));
        }
    }
}
var $4121df0a705d038e$var$NODE_UNHANDLED_REJECTION = "unhandledRejection";
var $4121df0a705d038e$var$UNHANDLED_REJECTION = $4121df0a705d038e$var$NODE_UNHANDLED_REJECTION.toLowerCase();
var $4121df0a705d038e$var$_currentPromiseId = [];
var $4121df0a705d038e$var$_uniquePromiseId = 0;
var $4121df0a705d038e$var$_unhandledRejectionTimeout = 10;
var $4121df0a705d038e$var$_aggregationError;
var $4121df0a705d038e$var$_hasPromiseRejectionEvent;
function $4121df0a705d038e$var$dumpFnObj(value) {
    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value)) return value.toString();
    return (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(value);
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAggregationError(values) {
    !$4121df0a705d038e$var$_aggregationError && ($4121df0a705d038e$var$_aggregationError = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
        "AggregationError"
    ]).v || (0, $5831ddb3a0caf7c7$export$435492119a21bab3)("AggregationError", function(self, args) {
        self.errors = args[0];
    })));
    return new $4121df0a705d038e$var$_aggregationError.v(values);
}
function $4121df0a705d038e$var$_createPromise(newPromise, processor, executor) {
    var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 3);
    var _state = 0;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _id = $4121df0a705d038e$var$_uniquePromiseId++;
    var _parentId = $4121df0a705d038e$var$_currentPromiseId.length > 0 ? $4121df0a705d038e$var$_currentPromiseId[$4121df0a705d038e$var$_currentPromiseId.length - 1] : undefined;
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    function _then(onResolved, onRejected) {
        try {
            $4121df0a705d038e$var$_currentPromiseId.push(_id);
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            var thenPromise = newPromise(function(resolve, reject) {
                _queue.push(function() {
                    try {
                        var handler = _state === 2 ? onResolved : onRejected;
                        var value = (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(handler) ? _settledValue : (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(handler) ? handler(_settledValue) : handler;
                        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) value.then(resolve, reject);
                        else if (handler) resolve(value);
                        else if (_state === 3) reject(value);
                        else resolve(value);
                    } catch (e) {
                        reject(e);
                    }
                });
                if (_hasResolved) _processQueue();
            }, additionalArgs);
            return thenPromise;
        } finally{
            $4121df0a705d038e$var$_currentPromiseId.pop();
        }
    }
    function _catch(onRejected) {
        return _then(undefined, onRejected);
    }
    function _finally(onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onFinally)) {
            thenFinally = function(value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function(reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    }
    function _strState() {
        return $4121df0a705d038e$var$STRING_STATES[_state];
    }
    function _processQueue() {
        if (_queue.length > 0) {
            var pending = _queue.slice();
            _queue = [];
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            processor(pending);
        }
    }
    function _createSettleIfFn(newState, allowState) {
        return function(theValue) {
            if (_state === allowState) {
                if (newState === 2 && (0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(theValue)) {
                    _state = 1;
                    theValue.then(_createSettleIfFn(2, 1), _createSettleIfFn(3, 1));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                _processQueue();
                if (!_handled && newState === 3 && !_unHandledRejectionHandler) _unHandledRejectionHandler = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(_notifyUnhandledRejection, $4121df0a705d038e$var$_unhandledRejectionTimeout);
            }
        };
    }
    function _notifyUnhandledRejection() {
        if (!_handled) {
            _handled = true;
            if ((0, $5831ddb3a0caf7c7$export$8ee0fc9ee280b4ee)()) $cfae44f0dfdf62c0$exports.emit($4121df0a705d038e$var$NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            else {
                var gbl = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)() || (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                !$4121df0a705d038e$var$_hasPromiseRejectionEvent && ($4121df0a705d038e$var$_hasPromiseRejectionEvent = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
                    $4121df0a705d038e$var$STR_PROMISE + "RejectionEvent"
                ]).v));
                $4121df0a705d038e$var$emitEvent(gbl, $4121df0a705d038e$var$UNHANDLED_REJECTION, function(theEvt) {
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(theEvt, "promise", {
                        g: function() {
                            return _thePromise;
                        }
                    });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!$4121df0a705d038e$var$_hasPromiseRejectionEvent.v);
            }
        }
    }
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(_thePromise, "state", {
        get: _strState
    });
    if ($4121df0a705d038e$var$_promiseDebugEnabled) $4121df0a705d038e$var$_addDebugState$1(_thePromise, _strState, function() {
        return (0, $5831ddb3a0caf7c7$export$3cbb80dec8953997)(_settledValue);
    }, function() {
        return _handled;
    });
    if ((0, $5831ddb3a0caf7c7$export$1e6e45ea4c3f892c)()) _thePromise[(0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(11)] = "IPromise";
    function _toString() {
        return "IPromise" + ($4121df0a705d038e$var$_promiseDebugEnabled ? "[" + _id + (!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(_parentId) ? ":" + _parentId : "") + "]" : "") + " " + _strState() + (_hasResolved ? " - " + $4121df0a705d038e$var$dumpFnObj(_settledValue) : "") + "";
    }
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(executor)) (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)($4121df0a705d038e$var$STR_PROMISE + ": executor is not a function - " + $4121df0a705d038e$var$dumpFnObj(executor));
        var _rejectFn = _createSettleIfFn(3, 0);
        try {
            executor.call(_thePromise, _createSettleIfFn(2, 0), _rejectFn);
        } catch (e) {
            _rejectFn(e);
        }
    })();
    return _thePromise;
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAllPromise(newPromise) {
    return function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1;
                (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, function(item, idx) {
                    if (item) {
                        pending_1++;
                        $4121df0a705d038e$export$96acbd3e4fcaef01(item, function(value) {
                            values_1[idx] = value;
                            if (--pending_1 === 0) resolve(values_1);
                        }, reject);
                    }
                });
                pending_1--;
                if (pending_1 === 0) resolve(values_1);
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createResolvedPromise(newPromise) {
    return function(value) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(value)) return value;
        return newPromise(function(resolve) {
            resolve(value);
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createRejectedPromise(newPromise) {
    return function(reason) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(_resolve, reject) {
            reject(reason);
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAllSettledPromise(newPromise) {
    return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            var values = [];
            var pending = 1;
            function processItem(item, idx) {
                pending++;
                $4121df0a705d038e$export$856fe465480fa77a(item, function(value) {
                    if (value.rejected) values[idx] = {
                        status: $4121df0a705d038e$var$REJECTED,
                        reason: value.reason
                    };
                    else values[idx] = {
                        status: "fulfilled",
                        value: value.value
                    };
                    if (--pending === 0) resolve(values);
                });
            }
            try {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(input)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(input, processItem);
                else if ((0, $5831ddb3a0caf7c7$export$9652023d9040757)(input)) (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, processItem);
                else (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Input is not an iterable");
                pending--;
                if (pending === 0) resolve(values);
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createRacePromise(newPromise) {
    return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            var isDone = false;
            function processItem(item) {
                $4121df0a705d038e$export$856fe465480fa77a(item, function(value) {
                    if (!isDone) {
                        isDone = true;
                        if (value.rejected) reject(value.reason);
                        else resolve(value.value);
                    }
                });
            }
            try {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(input)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(input, processItem);
                else if ((0, $5831ddb3a0caf7c7$export$9652023d9040757)(input)) (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, processItem);
                else (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Input is not an iterable");
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createAnyPromise(newPromise) {
    return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input) {
        var additionalArgs = (0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(arguments, 1);
        return newPromise(function(resolve, reject) {
            var theErros = [];
            var pending = 1;
            var isDone = false;
            function processItem(item, idx) {
                pending++;
                $4121df0a705d038e$export$856fe465480fa77a(item, function(value) {
                    if (!value.rejected) {
                        isDone = true;
                        resolve(value.value);
                        return;
                    } else theErros[idx] = value.reason;
                    if (--pending === 0 && !isDone) reject($4121df0a705d038e$var$_createAggregationError(theErros));
                });
            }
            try {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(input)) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(input, processItem);
                else if ((0, $5831ddb3a0caf7c7$export$9652023d9040757)(input)) (0, $5831ddb3a0caf7c7$export$1180a64ad833b902)(input, processItem);
                else (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)("Input is not an iterable");
                pending--;
                if (pending === 0 && !isDone) reject($4121df0a705d038e$var$_createAggregationError(theErros));
            } catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
function $4121df0a705d038e$var$syncItemProcessor(pending) {
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(pending, function(fn) {
        try {
            fn();
        } catch (e) {}
    });
}
function $4121df0a705d038e$var$timeoutItemProcessor(timeout) {
    var callbackTimeout = (0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(timeout) ? timeout : 0;
    return function(pending) {
        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
            $4121df0a705d038e$var$syncItemProcessor(pending);
        }, callbackTimeout);
    };
}
function $4121df0a705d038e$var$idleItemProcessor(timeout) {
    var options;
    if (timeout >= 0) options = {
        timeout: +timeout
    };
    return function(pending) {
        (0, $5831ddb3a0caf7c7$export$553e359f3bef3995)(function(deadline) {
            $4121df0a705d038e$var$syncItemProcessor(pending);
        }, options);
    };
}
var $4121df0a705d038e$var$_allAsyncSettledCreator;
var $4121df0a705d038e$var$_raceAsyncCreator;
var $4121df0a705d038e$var$_anyAsyncCreator;
function $4121df0a705d038e$export$74d26603c0c38da8(executor, timeout) {
    return $4121df0a705d038e$var$_createPromise($4121df0a705d038e$export$74d26603c0c38da8, $4121df0a705d038e$var$timeoutItemProcessor(timeout), executor, timeout);
}
var $4121df0a705d038e$export$1735e21d720f8bc0 = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$74d26603c0c38da8);
var $4121df0a705d038e$export$f2163a387efd1843 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$74d26603c0c38da8);
var $4121df0a705d038e$export$adb3940d4617f918 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$74d26603c0c38da8);
function $4121df0a705d038e$export$56c0d8a059168096(input, timeout) {
    !$4121df0a705d038e$var$_allAsyncSettledCreator && ($4121df0a705d038e$var$_allAsyncSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$74d26603c0c38da8));
    return $4121df0a705d038e$var$_allAsyncSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$600e257dfd344b6d(values, timeout) {
    !$4121df0a705d038e$var$_raceAsyncCreator && ($4121df0a705d038e$var$_raceAsyncCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$74d26603c0c38da8));
    return $4121df0a705d038e$var$_raceAsyncCreator.v(values, timeout);
}
function $4121df0a705d038e$export$26906e5a78118d20(values, timeout) {
    !$4121df0a705d038e$var$_anyAsyncCreator && ($4121df0a705d038e$var$_anyAsyncCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$74d26603c0c38da8));
    return $4121df0a705d038e$var$_anyAsyncCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_promiseCls;
var $4121df0a705d038e$var$_allCreator;
var $4121df0a705d038e$var$_allNativeSettledCreator;
var $4121df0a705d038e$var$_raceNativeCreator;
var $4121df0a705d038e$var$_anyNativeCreator;
/*#__NO_SIDE_EFFECTS__*/ function $4121df0a705d038e$var$_createNativePromiseHelper(name, func) {
    !$4121df0a705d038e$var$_promiseCls && ($4121df0a705d038e$var$_promiseCls = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
        $4121df0a705d038e$var$STR_PROMISE
    ]).v || null));
    if ($4121df0a705d038e$var$_promiseCls.v && $4121df0a705d038e$var$_promiseCls.v[name]) return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(function(input, timeout) {
        return $4121df0a705d038e$export$7edeaca5327f34ec(function(resolve, reject) {
            $4121df0a705d038e$var$_promiseCls.v[name](input).then(resolve, reject);
        });
    });
    return func();
}
function $4121df0a705d038e$export$7edeaca5327f34ec(executor, timeout) {
    !$4121df0a705d038e$var$_promiseCls && ($4121df0a705d038e$var$_promiseCls = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)((0, $5831ddb3a0caf7c7$export$3df6e51375017edd), [
        $4121df0a705d038e$var$STR_PROMISE
    ]).v || null));
    var PrmCls = $4121df0a705d038e$var$_promiseCls.v;
    if (!PrmCls) return $4121df0a705d038e$export$74d26603c0c38da8(executor);
    if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(executor)) (0, $5831ddb3a0caf7c7$export$3f7738bd7dcba681)($4121df0a705d038e$var$STR_PROMISE + ": executor is not a function - " + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(executor));
    var _state = 0;
    function _strState() {
        return $4121df0a705d038e$var$STRING_STATES[_state];
    }
    var thePromise = new PrmCls(function(resolve, reject) {
        function _resolve(value) {
            _state = 2;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}
function $4121df0a705d038e$export$9eb857118f5fb9d3(input, timeout) {
    !$4121df0a705d038e$var$_allCreator && ($4121df0a705d038e$var$_allCreator = $4121df0a705d038e$var$_createNativePromiseHelper("all", function() {
        return (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)($4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$7edeaca5327f34ec));
    }));
    return $4121df0a705d038e$var$_allCreator.v(input, timeout);
}
var $4121df0a705d038e$export$c6f7d656137b22c7 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$7edeaca5327f34ec);
var $4121df0a705d038e$export$ff6e17a8cb47ba93 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$7edeaca5327f34ec);
function $4121df0a705d038e$export$8713c23077300cc8(input, timeout) {
    !$4121df0a705d038e$var$_allNativeSettledCreator && ($4121df0a705d038e$var$_allNativeSettledCreator = $4121df0a705d038e$var$_createNativePromiseHelper("allSettled", function() {
        return $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$7edeaca5327f34ec);
    }));
    return $4121df0a705d038e$var$_allNativeSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$8ed049fd905f1727(values, timeout) {
    !$4121df0a705d038e$var$_raceNativeCreator && ($4121df0a705d038e$var$_raceNativeCreator = $4121df0a705d038e$var$_createNativePromiseHelper("race", function() {
        return $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$7edeaca5327f34ec);
    }));
    return $4121df0a705d038e$var$_raceNativeCreator.v(values, timeout);
}
function $4121df0a705d038e$export$6fedbe2aec1ec46e(values, timeout) {
    !$4121df0a705d038e$var$_anyNativeCreator && ($4121df0a705d038e$var$_anyNativeCreator = $4121df0a705d038e$var$_createNativePromiseHelper("any", function() {
        return $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$7edeaca5327f34ec);
    }));
    return $4121df0a705d038e$var$_anyNativeCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_allSyncSettledCreator;
var $4121df0a705d038e$var$_raceSyncCreator;
var $4121df0a705d038e$var$_anySyncCreator;
function $4121df0a705d038e$export$87a90c443c3ca3ef(executor) {
    return $4121df0a705d038e$var$_createPromise($4121df0a705d038e$export$87a90c443c3ca3ef, $4121df0a705d038e$var$syncItemProcessor, executor);
}
var $4121df0a705d038e$export$a24f68ae71d4e00c = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$87a90c443c3ca3ef);
var $4121df0a705d038e$export$59c8ba01697b2799 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$87a90c443c3ca3ef);
var $4121df0a705d038e$export$30a7efd4e673586 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$87a90c443c3ca3ef);
function $4121df0a705d038e$export$c235d06856522848(input, timeout) {
    !$4121df0a705d038e$var$_allSyncSettledCreator && ($4121df0a705d038e$var$_allSyncSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$87a90c443c3ca3ef));
    return $4121df0a705d038e$var$_allSyncSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$480418a4f5b8e503(values, timeout) {
    !$4121df0a705d038e$var$_raceSyncCreator && ($4121df0a705d038e$var$_raceSyncCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$87a90c443c3ca3ef));
    return $4121df0a705d038e$var$_raceSyncCreator.v(values, timeout);
}
function $4121df0a705d038e$export$99acc8d1bfcb0209(values, timeout) {
    !$4121df0a705d038e$var$_anySyncCreator && ($4121df0a705d038e$var$_anySyncCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$87a90c443c3ca3ef));
    return $4121df0a705d038e$var$_anySyncCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_defaultIdleTimeout;
var $4121df0a705d038e$var$_allIdleSettledCreator;
var $4121df0a705d038e$var$_raceIdleCreator;
var $4121df0a705d038e$var$_anyIdleCreator;
function $4121df0a705d038e$export$fd5c05c29ab034ec(idleDeadline) {
    $4121df0a705d038e$var$_defaultIdleTimeout = idleDeadline;
}
var $4121df0a705d038e$export$b588248e012cdf5c = /*#__PURE__*/ $4121df0a705d038e$var$_pureAssign($4121df0a705d038e$export$fd5c05c29ab034ec);
function $4121df0a705d038e$export$4e33ded44831dd3d(executor, timeout) {
    var theTimeout = (0, $5831ddb3a0caf7c7$export$fce6876652108ab)(timeout) ? $4121df0a705d038e$var$_defaultIdleTimeout : timeout;
    return $4121df0a705d038e$var$_createPromise($4121df0a705d038e$export$4e33ded44831dd3d, $4121df0a705d038e$var$idleItemProcessor(theTimeout), executor, theTimeout);
}
var $4121df0a705d038e$export$2c25fa87b8ad2dc0 = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$4e33ded44831dd3d);
var $4121df0a705d038e$export$ebba556db12b8de2 = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$4e33ded44831dd3d);
var $4121df0a705d038e$export$c0cc0d7545d2f2ac = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$4e33ded44831dd3d);
function $4121df0a705d038e$export$dcc8ce90289bfb19(input, timeout) {
    !$4121df0a705d038e$var$_allIdleSettledCreator && ($4121df0a705d038e$var$_allIdleSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$4e33ded44831dd3d));
    return $4121df0a705d038e$var$_allIdleSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$dd8eeb7df534942(values, timeout) {
    !$4121df0a705d038e$var$_raceIdleCreator && ($4121df0a705d038e$var$_raceIdleCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$4e33ded44831dd3d));
    return $4121df0a705d038e$var$_raceIdleCreator.v(values, timeout);
}
function $4121df0a705d038e$export$42b449f8b2be4a2d(values, timeout) {
    !$4121df0a705d038e$var$_anyIdleCreator && ($4121df0a705d038e$var$_anyIdleCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$4e33ded44831dd3d));
    return $4121df0a705d038e$var$_anyIdleCreator.v(values, timeout);
}
var $4121df0a705d038e$var$_promiseCreator;
var $4121df0a705d038e$var$_allSettledCreator;
var $4121df0a705d038e$var$_raceCreator;
var $4121df0a705d038e$var$_anyCreator;
function $4121df0a705d038e$export$c6c514c2f7329b79(creator) {
    $4121df0a705d038e$var$_promiseCreator = creator ? (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)(creator) : null;
}
function $4121df0a705d038e$export$5a1eb20c68656e88(executor, timeout) {
    !$4121df0a705d038e$var$_promiseCreator && ($4121df0a705d038e$var$_promiseCreator = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)($4121df0a705d038e$export$7edeaca5327f34ec));
    return $4121df0a705d038e$var$_promiseCreator.v.call(this, executor, timeout);
}
var $4121df0a705d038e$export$1ed2fd8fe9f5c6 = /*#__PURE__*/ $4121df0a705d038e$var$_createAllPromise($4121df0a705d038e$export$5a1eb20c68656e88);
var $4121df0a705d038e$export$c6056e052f93dbce = /*#__PURE__*/ $4121df0a705d038e$var$_createResolvedPromise($4121df0a705d038e$export$5a1eb20c68656e88);
var $4121df0a705d038e$export$d22877ef6074ba31 = /*#__PURE__*/ $4121df0a705d038e$var$_createRejectedPromise($4121df0a705d038e$export$5a1eb20c68656e88);
function $4121df0a705d038e$export$18e9f1dec14b409f(input, timeout) {
    !$4121df0a705d038e$var$_allSettledCreator && ($4121df0a705d038e$var$_allSettledCreator = $4121df0a705d038e$var$_createAllSettledPromise($4121df0a705d038e$export$5a1eb20c68656e88));
    return $4121df0a705d038e$var$_allSettledCreator.v(input, timeout);
}
function $4121df0a705d038e$export$ed7d6046dc702a09(values, timeout) {
    !$4121df0a705d038e$var$_raceCreator && ($4121df0a705d038e$var$_raceCreator = $4121df0a705d038e$var$_createRacePromise($4121df0a705d038e$export$5a1eb20c68656e88));
    return $4121df0a705d038e$var$_raceCreator.v(values, timeout);
}
function $4121df0a705d038e$export$28d4602081696f5(values, timeout) {
    !$4121df0a705d038e$var$_anyCreator && ($4121df0a705d038e$var$_anyCreator = $4121df0a705d038e$var$_createAnyPromise($4121df0a705d038e$export$5a1eb20c68656e88));
    return $4121df0a705d038e$var$_anyCreator.v(values, timeout);
}
function $4121df0a705d038e$export$a0da96ad278b0532(timeout, resolveReject, message) {
    return $4121df0a705d038e$export$5a1eb20c68656e88(function(resolve, reject) {
        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
            (resolveReject ? resolve : reject)(!(0, $5831ddb3a0caf7c7$export$fce6876652108ab)(message) ? message : "Timeout of " + timeout + "ms exceeded");
        }, timeout);
    });
}
function $4121df0a705d038e$var$_doneChk(isDone, state, value, thisArg) {
    var result = isDone;
    state.res = value;
    if (!result) {
        if (state.isDone && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(state.isDone)) return $4121df0a705d038e$export$96acbd3e4fcaef01(state.isDone.call(thisArg, state), function(done) {
            state.iter++;
            return !!done;
        });
        else result = !!state.isDone;
    }
    state.iter++;
    return result;
}
function $4121df0a705d038e$export$a3cbfee43e77c4e7(callbackFn, isDoneFn, thisArg) {
    var promise;
    var resolve;
    var reject = function(reason) {
        isDone = true;
        throw reason;
    };
    var isDone = false;
    var state = {
        st: (0, $5831ddb3a0caf7c7$export$a56f095995763cca)(),
        iter: 0,
        isDone: isDoneFn || false
    };
    if (callbackFn) {
        var _createPromise_1 = function() {
            return $4121df0a705d038e$export$5a1eb20c68656e88(function(res, rej) {
                resolve = res;
                reject = rej;
            });
        };
        var _handleAsyncDone_1 = function(done) {
            isDone = !!done;
            if (!isDone) _processNext_1();
            else resolve(state.res);
        };
        var _processNext_1 = function() {
            while(!isDone)try {
                var cbResult = callbackFn.call(thisArg, state);
                if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(cbResult)) {
                    promise = promise || _createPromise_1();
                    $4121df0a705d038e$export$96acbd3e4fcaef01(cbResult, function(res) {
                        try {
                            $4121df0a705d038e$export$96acbd3e4fcaef01($4121df0a705d038e$var$_doneChk(isDone, state, res, thisArg), _handleAsyncDone_1, reject);
                        } catch (e) {
                            reject(e);
                        }
                    }, reject);
                    return promise;
                } else {
                    var dnRes = $4121df0a705d038e$var$_doneChk(isDone, state, cbResult, thisArg);
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(dnRes)) {
                        promise = promise || _createPromise_1();
                        $4121df0a705d038e$export$96acbd3e4fcaef01(dnRes, _handleAsyncDone_1, reject);
                        return promise;
                    } else isDone = !!dnRes;
                }
            } catch (e) {
                reject(e);
                return promise;
            }
            if (isDone && resolve) resolve(state.res);
            return promise || state.res;
        };
        return _processNext_1();
    }
}
function $4121df0a705d038e$export$3b1f331280179db8(theArray, callbackFn, thisArg) {
    if (theArray) {
        var len_1 = (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(theArray);
        if (len_1) {
            var isDone = function(state) {
                if (state.iter >= len_1 || state.res === -1) return true;
            };
            return $4121df0a705d038e$export$a3cbfee43e77c4e7(function(state) {
                var idx = state.iter;
                if (idx in theArray) return callbackFn.call(thisArg || theArray, theArray[idx], idx, theArray);
            }, isDone);
        }
    }
}
var $4121df0a705d038e$var$_iterSymbol;
var $4121df0a705d038e$var$_iterAsyncSymbol;
function $4121df0a705d038e$export$2c3e4cf1b08124bc(iter, callbackFn, thisArg) {
    var err;
    var iterResult;
    var theIter = iter;
    function onFailed(failed) {
        err = {
            e: failed
        };
        if (theIter.throw) {
            iterResult = null;
            theIter.throw(err);
        }
        throw failed;
    }
    function onFinally() {
        try {
            if (iterResult && !iterResult[$4121df0a705d038e$var$DONE]) theIter[$4121df0a705d038e$var$RETURN] && theIter[$4121df0a705d038e$var$RETURN](iterResult);
        } finally{
            if (err) throw err.e;
        }
    }
    if (iter) {
        if (!(0, $5831ddb3a0caf7c7$export$50db6e277db66ea0)(iter)) {
            !$4121df0a705d038e$var$_iterAsyncSymbol && ($4121df0a705d038e$var$_iterAsyncSymbol = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(0)));
            theIter = iter[$4121df0a705d038e$var$_iterAsyncSymbol.v] ? iter[$4121df0a705d038e$var$_iterAsyncSymbol.v]() : null;
            if (!theIter) {
                !$4121df0a705d038e$var$_iterSymbol && ($4121df0a705d038e$var$_iterSymbol = (0, $5831ddb3a0caf7c7$export$469f6b7560342b84)((0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(3)));
                theIter = iter[$4121df0a705d038e$var$_iterSymbol.v] ? iter[$4121df0a705d038e$var$_iterSymbol.v]() : null;
            }
        }
        if (theIter && (0, $5831ddb3a0caf7c7$export$50db6e277db66ea0)(theIter)) {
            var result = void 0;
            try {
                result = $4121df0a705d038e$export$a3cbfee43e77c4e7(function(state) {
                    return $4121df0a705d038e$export$96acbd3e4fcaef01(theIter.next(), function(res) {
                        iterResult = res;
                        if (!res[$4121df0a705d038e$var$DONE]) return (0, $5831ddb3a0caf7c7$export$4b40e215736a9426)(callbackFn, thisArg || theIter, iterResult[$4121df0a705d038e$var$VALUE], state.iter, theIter);
                    }, function(reason) {
                        state.isDone = true;
                        onFailed(reason);
                    });
                }, function(state) {
                    if (!iterResult || iterResult[$4121df0a705d038e$var$DONE] || state.res === -1) {
                        onFinally();
                        return true;
                    }
                }, thisArg || theIter);
                if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(result)) result = $4121df0a705d038e$export$8a7042cf3f497261(result.catch(onFailed), onFinally);
                return result;
            } catch (failed) {
                onFailed(failed);
            } finally{
                if (result && !(0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(result)) onFinally();
            }
        }
    }
}
var $4121df0a705d038e$var$REJECT = "reject";
var $4121df0a705d038e$var$REJECTED_ERROR = "Rejected";
var $4121df0a705d038e$var$_schedulerId = 0;
var $4121df0a705d038e$var$_debugName;
var $4121df0a705d038e$var$_debugIntState;
var $4121df0a705d038e$var$_customErrors = {};
function $4121df0a705d038e$var$_rejectDone() {}
function $4121df0a705d038e$var$_createError(type, evt, message) {
    !$4121df0a705d038e$var$_customErrors[type] && ($4121df0a705d038e$var$_customErrors[type] = (0, $5831ddb3a0caf7c7$export$435492119a21bab3)(type));
    var now = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
    return new $4121df0a705d038e$var$_customErrors[type]("Task [".concat(evt.id, "] ").concat(message || "", "- ").concat(evt.st ? "Running" : "Waiting", ": ").concat($4121df0a705d038e$var$_calcTime(now, evt.st || evt.cr)));
}
function $4121df0a705d038e$var$_calcTime(now, start) {
    return (now - start || "0") + " ms";
}
function $4121df0a705d038e$var$_abortStaleTasks(taskQueue, staleTimeoutPeriod) {
    var now = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
    var expired = now - staleTimeoutPeriod;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(taskQueue, function(evt) {
        if (evt && !evt.rj && evt.st && evt.st < expired || !evt.st && evt.cr && evt.cr < expired) evt && evt[$4121df0a705d038e$var$REJECT](evt.rj || $4121df0a705d038e$var$_createError("Aborted", evt, "Stale "));
    });
}
function $4121df0a705d038e$var$_removeTask(queue, taskDetail) {
    var idx = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(queue, taskDetail);
    if (idx !== -1) queue.splice(idx, 1);
}
function $4121df0a705d038e$var$_addDebugState(theScheduler, nameFn, stateFn) {
    $4121df0a705d038e$var$_debugName = $4121df0a705d038e$var$_debugName || {
        toString: function() {
            return "[[SchedulerName]]";
        }
    };
    $4121df0a705d038e$var$_debugIntState = $4121df0a705d038e$var$_debugIntState || {
        toString: function() {
            return "[[SchedulerState]]";
        }
    };
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(theScheduler, $4121df0a705d038e$var$_debugName, {
        get: nameFn
    });
    (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(theScheduler, $4121df0a705d038e$var$_debugIntState, {
        get: stateFn
    });
}
function $4121df0a705d038e$export$b8e809f247dcf830(newPromise, name) {
    var _theTask;
    var _running = [];
    var _waiting = [];
    var _staleTimeoutPeriod = 600000;
    var _staleTimeoutCheckPeriod = _staleTimeoutPeriod / 10;
    var _taskCount = 0;
    var _schedulerName = (name ? name + "." : "") + $4121df0a705d038e$var$_schedulerId++;
    var _blockedTimer;
    newPromise = newPromise || $4121df0a705d038e$export$5a1eb20c68656e88;
    var _startBlockedTimer = function() {
        var hasTasks = (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) > 0;
        if (_staleTimeoutPeriod > 0) {
            if (!_blockedTimer) {
                _blockedTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                    $4121df0a705d038e$var$_abortStaleTasks(_running, _staleTimeoutPeriod);
                    $4121df0a705d038e$var$_abortStaleTasks(_waiting, _staleTimeoutPeriod);
                    _blockedTimer && (_blockedTimer.enabled = (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) > 0);
                }, _staleTimeoutCheckPeriod);
                _blockedTimer.unref();
            }
            _blockedTimer && (_blockedTimer.enabled = hasTasks);
        }
    };
    var _queueTask = function(startAction, taskName, timeout) {
        var _a;
        var taskId = _schedulerName + "." + _taskCount++;
        if (taskName) taskId += "-(" + taskName + ")";
        var newTask = (_a = {
            id: taskId,
            cr: (0, $5831ddb3a0caf7c7$export$a56f095995763cca)(),
            to: timeout
        }, _a[$4121df0a705d038e$var$REJECT] = function(reason) {
            newTask.rj = reason || $4121df0a705d038e$var$_createError($4121df0a705d038e$var$REJECTED_ERROR, newTask);
            newTask[$4121df0a705d038e$var$REJECT] = $4121df0a705d038e$var$_rejectDone;
        }, _a);
        if (!_theTask) newTask.p = newPromise(_runTask(newTask, startAction));
        else newTask.p = _waitForPreviousTask(newTask, _theTask, startAction);
        _theTask = newTask;
        return newTask.p;
    };
    var _runTask = function(taskDetail, startAction) {
        taskDetail.st = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
        _running.push(taskDetail);
        _startBlockedTimer();
        return function(onTaskResolve, onTaskReject) {
            var _promiseReject = function(reason) {
                taskDetail.rj = taskDetail.rj || reason || $4121df0a705d038e$var$_createError($4121df0a705d038e$var$REJECTED_ERROR, taskDetail);
                taskDetail[$4121df0a705d038e$var$REJECT] = $4121df0a705d038e$var$_rejectDone;
                _doCleanup(taskDetail);
                onTaskResolve = null;
                onTaskReject && onTaskReject(reason);
                onTaskReject = null;
            };
            var taskId = taskDetail.id;
            if (taskDetail.rj) _promiseReject(taskDetail.rj);
            else {
                taskDetail[$4121df0a705d038e$var$REJECT] = _promiseReject;
                try {
                    var startResult = startAction(taskId);
                    if (taskDetail.to && (0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(startResult)) taskDetail.t = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                        _promiseReject($4121df0a705d038e$var$_createError("Timeout", taskDetail));
                    }, taskDetail.to);
                    $4121df0a705d038e$export$96acbd3e4fcaef01(startResult, function(theResult) {
                        _doCleanup(taskDetail);
                        try {
                            onTaskResolve && onTaskResolve(theResult);
                        } catch (e) {
                            onTaskReject && onTaskReject(e);
                        }
                        onTaskReject = null;
                        onTaskResolve = null;
                    }, _promiseReject);
                } catch (e) {
                    _promiseReject(e);
                }
            }
        };
    };
    var _waitForPreviousTask = function(taskDetail, prevTask, startAction) {
        _waiting.push(taskDetail);
        _startBlockedTimer();
        return newPromise(function(onWaitResolve, onWaitReject) {
            $4121df0a705d038e$export$856fe465480fa77a(prevTask.p, function() {
                $4121df0a705d038e$var$_removeTask(_waiting, taskDetail);
                _runTask(taskDetail, startAction)(onWaitResolve, onWaitReject);
            });
        });
    };
    var _doCleanup = function(taskDetail) {
        $4121df0a705d038e$var$_removeTask(_running, taskDetail);
        taskDetail.t && taskDetail.t.cancel();
        taskDetail.t = null;
        if (_theTask && _theTask === taskDetail) {
            _theTask = null;
            if ((0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) === 0) {
                _blockedTimer && _blockedTimer.cancel();
                _blockedTimer = null;
            }
        }
    };
    var theScheduler = {
        idle: true,
        queue: _queueTask,
        setStaleTimeout: function(staleTimeout, staleCheckPeriod) {
            _blockedTimer && _blockedTimer.cancel();
            _blockedTimer = null;
            _staleTimeoutPeriod = staleTimeout;
            _staleTimeoutCheckPeriod = staleCheckPeriod || staleTimeout / 10;
            _startBlockedTimer();
        }
    };
    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(theScheduler, "idle", {
        g: function() {
            return (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_running) + (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(_waiting) === 0;
        }
    });
    $4121df0a705d038e$var$_addDebugState(theScheduler, function() {
        return _schedulerName;
    }, function() {
        return {
            l: _theTask,
            r: _running,
            w: _waiting
        };
    });
    return theScheduler;
}
var $4121df0a705d038e$var$toStringTagSymbol = (0, $5831ddb3a0caf7c7$export$3a9aefdadea26115)(11);
var $4121df0a705d038e$export$66bd3447b1c9a4ff = /*#__PURE__*/ function() {
    function PolyPromiseImpl(executor) {
        this._$ = $4121df0a705d038e$export$74d26603c0c38da8(executor);
        if ($4121df0a705d038e$var$toStringTagSymbol) this[$4121df0a705d038e$var$toStringTagSymbol] = "Promise";
        (0, $5831ddb3a0caf7c7$export$8b8fd4dfd45f6b81)(this, "state", {
            get: function() {
                return this._$.state;
            }
        });
    }
    PolyPromiseImpl.all = $4121df0a705d038e$export$1735e21d720f8bc0;
    PolyPromiseImpl.race = $4121df0a705d038e$export$600e257dfd344b6d;
    PolyPromiseImpl.any = $4121df0a705d038e$export$26906e5a78118d20;
    PolyPromiseImpl.reject = $4121df0a705d038e$export$adb3940d4617f918;
    PolyPromiseImpl.resolve = $4121df0a705d038e$export$f2163a387efd1843;
    PolyPromiseImpl.allSettled = $4121df0a705d038e$export$56c0d8a059168096;
    var theProto = PolyPromiseImpl.prototype;
    theProto.then = function(onResolved, onRejected) {
        return this._$.then(onResolved, onRejected);
    };
    theProto.catch = function(onRejected) {
        return this._$.catch(onRejected);
    };
    theProto.finally = function(onfinally) {
        return this._$.finally(onfinally);
    };
    return PolyPromiseImpl;
}();



/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $b2bb8b1c98486f95$export$fecb95562bb928a0 = "featureOptIn"; // Count: 4
var $b2bb8b1c98486f95$export$36340d61e6e2eeff = "scheduleFetchTimeout"; // Count: 2


function $dc26cd3b06f2c35c$export$b4df6e888f21a5d1(cfg, nonOverrideConfigs, curLevel, maxLevel) {
    try {
        var exceedMaxLevel = curLevel > maxLevel;
        if (exceedMaxLevel) cfg = null;
        var curCfg_1 = curLevel == 0 ? (0, $5831ddb3a0caf7c7$export$a7f7e50f928053df)({}, cfg) : cfg; // only copy cfg at the begining level
        if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(curCfg_1, function(key) {
            var nonOverrideVal = nonOverrideConfigs[key];
            if (!!nonOverrideVal) {
                if ((0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(curCfg_1[key]) && (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(nonOverrideVal)) curCfg_1[key] = $dc26cd3b06f2c35c$export$b4df6e888f21a5d1(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
                else delete curCfg_1[key];
            }
        });
        return curCfg_1;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    // if errors happen, do nothing
    return cfg;
}
//                                                     CDN Mode, value = B (CDN value = B)
//                                |--------------------------------------------------------------------------|-----------|
//                                |                    | none        | disabled    | enabled     | forceOn   | forceOff  |
//                                | ------------------ | ----------- | ----------- | ----------- | --------- | --------- |
// | User Mode, value = A         | none               | none        | disabled    | enabled     | enabled   | disabled  |
// (user Value = A)               | disabled           | disabled    | disabled    | disabled    | enabled   | disabled  |
//                                | enabled            | enabled     | disabled    | enabled     | enabled   | disabled  |
//                                | none(blockCdn)     | none        | none        | none        | none      | none      |
//                                | disabled(blockCdn) | disabled    | disabled    | disabled    | disabled  | disabled  |
//                                | enabled(blockCdn)  | enabled     | enabled     | enabled     | enabled   | enabled   |
// This matrix identifies how feature based overrides are selected (if present)
//                                cdn Mode (cdn Value = B)
//                   |---------------------------------------------------------------------------|
//                   |                    | none     | disabled | enabled  | forceOn  | forceOff |
//                   | ------------------ | ---------| ---------| ---------| ---------|----------|
// | User Mode       | none               | A        | A        | A || B   | B || A   | B || A   |
// (user Value = A)  | disabled           | A        | A        | A        | B || A   | B || A   |
//                   | enabled            | A        | A        | A || B   | B || A   | B || A   |
//                   | none(blockCdn)     | A        | A        | A        | A        | A        |
//                   | disabled(blockCdn) | A        | A        | A        | A        | A        |
//                   | enabled(blockCdn)  | A        | A        | A        | A        | A        |
// Note:
// Where the "value" is an object (map) of encoded key/values which will be used to override the real configuration
// A = either the user supplied enable/disable value (via the `config.featureOptIn[name]`) or if not defined by the user the SDK defaults of the same.
// B = The enable/disable value obtained from the CDN for the named feature
// These are evaluated based on the above matrix to either
// - A (Always the user/sdk value)
// - B (Always the value from the CDN)
// - A || B (If A is null or undefined use the value from the CDN (B) otherwise A)
// - B || A (If B is null or undefined use the user/SDK value otherwise use the value from the CDN)
//
// The result of the value may also be null / undefined, which means there are no overrides to apply when the feature is enabled
var $dc26cd3b06f2c35c$var$F = "featureOptIn.";
var $dc26cd3b06f2c35c$var$M = ".mode";
var $dc26cd3b06f2c35c$var$ON = ".onCfg";
var $dc26cd3b06f2c35c$var$OFF = ".offCfg";
function $dc26cd3b06f2c35c$export$767059b9bcd02c8(field, cdnCfg, userOptInDetails) {
    var _a;
    // cdn conifg value
    if (!cdnCfg || !cdnCfg.enabled) return null;
    var cdnFt = (cdnCfg[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ] || {})[field] || {
        mode: 1 /* CdnFeatureMode.none */ 
    };
    var cdnM = cdnFt.mode;
    var cdnOnV = cdnFt.onCfg;
    var cdnOffV = cdnFt.offCfg;
    var userFt = (userOptInDetails || {})[field] || {
        mode: 2 /* FeatureOptInMode.disable */ 
    }; // default user mode is disable
    var userM = userFt.mode;
    var userOnV = userFt.onCfg;
    var userOffV = userFt.offCfg;
    var blockCdn = !!userFt.blockCdnCfg;
    var mFld = $dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$M;
    var onFld = $dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$ON;
    var offFld = $dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$OFF;
    var mode = userM;
    var onV = userOnV;
    var offV = userOffV;
    if (!blockCdn) {
        if (cdnM === 4 /* CdnFeatureMode.forceOn */  || cdnM === 5 /* CdnFeatureMode.forceOff */ ) {
            mode = cdnM == 4 /* CdnFeatureMode.forceOn */  ? 3 /* FeatureOptInMode.enable */  : 2 /* FeatureOptInMode.disable */ ;
            onV = cdnOnV || userOnV;
            offV = cdnOffV || userOffV;
        } else if (cdnM === 2 /* CdnFeatureMode.disable */  || userM === 2 /* FeatureOptInMode.disable */ ) {
            mode = 2 /* FeatureOptInMode.disable */ ;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        } else if (cdnM === 3 /* CdnFeatureMode.enable */ ) {
            mode = 3 /* FeatureOptInMode.enable */ ;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        } else if (cdnM === 1 /* CdnFeatureMode.none */  && userM === 1 /* FeatureOptInMode.none */ ) mode = 1 /* FeatureOptInMode.none */ ;
    }
    return _a = {}, _a[mFld] = mode, _a[onFld] = onV, _a[offFld] = offV, _a;
}
function $dc26cd3b06f2c35c$export$fdfda4484470ef4d(cdnCfg, core) {
    try {
        if (!cdnCfg || !cdnCfg.enabled) return null;
        if (!cdnCfg[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ]) return cdnCfg.config;
        var optInMap = cdnCfg[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ];
        var cdnConfig_1 = cdnCfg.config || {};
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(optInMap, function(key) {
            var featureVal = $dc26cd3b06f2c35c$export$767059b9bcd02c8(key, cdnCfg, core.config[0, $b2bb8b1c98486f95$export$fecb95562bb928a0 /* @min:%2efeatureOptIn */ ]);
            if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(featureVal)) {
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(featureVal, function(config, val) {
                    (0, $5831ddb3a0caf7c7$export$7dee18238d098123)(cdnConfig_1, config, val);
                });
                $dc26cd3b06f2c35c$var$_overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
            }
        });
        return cdnConfig_1;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
function $dc26cd3b06f2c35c$var$_overrideCdnCfgByFeature(field, ftVal, config) {
    var mode = ftVal[$dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$M];
    var val = ftVal[$dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$ON];
    var dVal = ftVal[$dc26cd3b06f2c35c$var$F + field + $dc26cd3b06f2c35c$var$OFF];
    var target = null;
    if (mode === 3 /* FeatureOptInMode.enable */ ) target = val;
    if (mode === 2 /* FeatureOptInMode.disable */ ) target = dVal;
    if (target) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(target, function(key, cfg) {
        (0, $5831ddb3a0caf7c7$export$7dee18238d098123)(config, key, cfg);
    });
}



var $c0d1696c8c7ba142$var$_a;
var $c0d1696c8c7ba142$var$EVENT_NAME = "ai_cfgsync";
var $c0d1696c8c7ba142$var$STR_GET_METHOD = "GET";
var $c0d1696c8c7ba142$var$FETCH_TIMEOUT = 1800000; // 30 minutes
var $c0d1696c8c7ba142$var$udfVal = undefined;
var $c0d1696c8c7ba142$var$defaultNonOverrideCfg = {
    instrumentationKey: true,
    connectionString: true,
    endpointUrl: true
};
var $c0d1696c8c7ba142$var$_defaultConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($c0d1696c8c7ba142$var$_a = {
    syncMode: 1 /* ICfgSyncMode.Broadcast */ ,
    blkCdnCfg: $c0d1696c8c7ba142$var$udfVal,
    customEvtName: $c0d1696c8c7ba142$var$udfVal,
    cfgUrl: $c0d1696c8c7ba142$var$udfVal,
    overrideSyncFn: $c0d1696c8c7ba142$var$udfVal,
    overrideFetchFn: $c0d1696c8c7ba142$var$udfVal,
    onCfgChangeReceive: $c0d1696c8c7ba142$var$udfVal
}, $c0d1696c8c7ba142$var$_a[0, $b2bb8b1c98486f95$export$36340d61e6e2eeff /* @min:scheduleFetchTimeout */ ] = $c0d1696c8c7ba142$var$FETCH_TIMEOUT, $c0d1696c8c7ba142$var$_a.nonOverrideConfigs = $c0d1696c8c7ba142$var$defaultNonOverrideCfg, $c0d1696c8c7ba142$var$_a.enableAjax = false, $c0d1696c8c7ba142$var$_a));
var $c0d1696c8c7ba142$export$30ebafc03af98b74 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(CfgSyncPlugin, _super);
    function CfgSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 198;
        _this.identifier = "AppInsightsCfgSyncPlugin";
        var _extensionConfig;
        var _mainConfig; // throttle config should be wrapped in IConfiguration
        var _evtName;
        var _evtNamespace;
        var _cfgUrl;
        var _timeoutHandle;
        var _receiveChanges;
        var _broadcastChanges;
        var _blkCdnCfg;
        var _fetchTimeout;
        var _retryCnt;
        var _onCfgChangeReceive;
        var _nonOverrideConfigs;
        var _fetchFn;
        var _overrideFetchFn;
        var _overrideSyncFn;
        var _paused = false;
        var _enableAjax;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(CfgSyncPlugin, _this, function(_self, _base) {
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)(_self.identifier), core.evtNamespace && core.evtNamespace());
                _populateDefaults(config);
            };
            _self.getCfg = function() {
                return _mainConfig;
            };
            _self.pause = function() {
                _paused = true;
                _clearScheduledTimer();
            };
            _self.resume = function() {
                _paused = false;
                _setupTimer();
            };
            // used for V2 to manaully trigger config udpate
            _self.setCfg = function(config) {
                return _setCfg(config);
            };
            _self.sync = function(customDetails) {
                return _sendCfgsyncEvents(customDetails);
            };
            _self.updateEventListenerName = function(eventName) {
                return _updateEventListenerName(eventName);
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _eventOff();
                _clearScheduledTimer();
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _broadcastChanges,
                    _receiveChanges,
                    _evtName,
                    _blkCdnCfg,
                    _nonOverrideConfigs
                ];
            };
            function _initDefaults() {
                _mainConfig = null;
                _evtName = null;
                _evtNamespace = null;
                _cfgUrl = null;
                _receiveChanges = null;
                _broadcastChanges = null;
                _nonOverrideConfigs = null;
                _timeoutHandle = null;
                _fetchTimeout = null;
                _retryCnt = null;
                _blkCdnCfg = null;
                _enableAjax = false;
                _overrideFetchFn = null;
                _overrideSyncFn = null;
                _onCfgChangeReceive = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    _extensionConfig = ctx.getExtCfg(identifier, $c0d1696c8c7ba142$var$_defaultConfig);
                    var preBlkCdn = _blkCdnCfg;
                    _blkCdnCfg = !!_extensionConfig.blkCdnCfg;
                    _enableAjax = !!_extensionConfig.enableAjax;
                    // avoid initial call
                    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(preBlkCdn) && preBlkCdn !== _blkCdnCfg) {
                        if (!_blkCdnCfg && _cfgUrl) _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                        else _clearScheduledTimer();
                    }
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_receiveChanges)) _receiveChanges = _extensionConfig.syncMode === 2 /* ICfgSyncMode.Receive */ ;
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_broadcastChanges)) _broadcastChanges = _extensionConfig.syncMode === 1 /* ICfgSyncMode.Broadcast */ ;
                    var newEvtName = _extensionConfig.customEvtName || $c0d1696c8c7ba142$var$EVENT_NAME;
                    if (_evtName !== newEvtName) {
                        if (_receiveChanges) _updateEventListenerName(newEvtName);
                        else {
                            _eventOff();
                            _evtName = newEvtName;
                        }
                    }
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_cfgUrl)) _cfgUrl = _extensionConfig.cfgUrl;
                    // if cfgUrl is set, we will ignore core config change
                    if (!_cfgUrl) {
                        _mainConfig = config;
                        if (_broadcastChanges) _sendCfgsyncEvents();
                    }
                }));
                _overrideSyncFn = _extensionConfig.overrideSyncFn;
                _overrideFetchFn = _extensionConfig.overrideFetchFn;
                _onCfgChangeReceive = _extensionConfig.onCfgChangeReceive;
                _nonOverrideConfigs = _extensionConfig.nonOverrideConfigs; // override values should not be changed
                _fetchTimeout = _extensionConfig[0, $b2bb8b1c98486f95$export$36340d61e6e2eeff /* @min:%2escheduleFetchTimeout */ ];
                _fetchFn = _getFetchFnInterface();
                _retryCnt = 0;
                // NOT support cfgURL change to avoid mutiple fetch calls
                if (_cfgUrl && !_blkCdnCfg) _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
            }
            function _setCfg(config, isAutoSync) {
                if (config) {
                    _mainConfig = config;
                    if (!!isAutoSync && !_paused) return _sendCfgsyncEvents();
                    if (_receiveChanges && !_paused) {
                        _self.core.updateCfg(config);
                        return true;
                    }
                }
                return false;
            }
            function _eventOff() {
                try {
                    var global_1 = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                    if (global_1) (0, $02f0ede5277c99cd$export$51dedceb7c784eff)(global_1, null, null, _evtNamespace);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _sendCfgsyncEvents(customDetails) {
                try {
                    if (!!_overrideSyncFn && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_overrideSyncFn)) return _overrideSyncFn(_mainConfig, customDetails);
                    return (0, $0d2c2fb24388dcf8$export$af531f0ca2964c96)(_evtName, _mainConfig, customDetails);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _updateEventListenerName(name) {
                try {
                    _eventOff();
                    if (name) {
                        _evtName = name;
                        _addEventListener();
                    }
                    return true;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _getFetchFnInterface() {
                var _fetchFn = _overrideFetchFn;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_fetchFn)) {
                    if ((0, $0d2c2fb24388dcf8$export$f8c1c61350d9749)()) _fetchFn = _fetchSender;
                    else if ((0, $0d2c2fb24388dcf8$export$cfeac9aa070f0108)()) _fetchFn = _xhrSender;
                }
                return _fetchFn;
            }
            function _fetchSender(url, oncomplete, isAutoSync) {
                var global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                var fetchFn = global && global.fetch || null;
                if (url && fetchFn && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(fetchFn)) try {
                    var init = {
                        method: $c0d1696c8c7ba142$var$STR_GET_METHOD
                    };
                    if (!_enableAjax) init[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] = true;
                    var request = new Request(url, init);
                    if (!_enableAjax) try {
                        // Also try and tag the request (just in case the value in init is not copied over)
                        request[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] = true;
                    } catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                    }
                    (0, $4121df0a705d038e$export$856fe465480fa77a)(fetch(request), function(result) {
                        var response = result.value;
                        if (!result.rejected) {
                            if (response.ok) (0, $4121df0a705d038e$export$856fe465480fa77a)(response.text(), function(res) {
                                _doOnComplete(oncomplete, response.status, res.value, isAutoSync);
                            });
                            else _doOnComplete(oncomplete, response.status, null, isAutoSync);
                        } else _doOnComplete(oncomplete, 400);
                    });
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _xhrSender(url, oncomplete, isAutoSync) {
                try {
                    var xhr_1 = new XMLHttpRequest();
                    if (!_enableAjax) xhr_1[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] = true;
                    xhr_1.open($c0d1696c8c7ba142$var$STR_GET_METHOD, url);
                    xhr_1.onreadystatechange = function() {
                        if (xhr_1.readyState === XMLHttpRequest.DONE) _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
                    };
                    xhr_1.onerror = function() {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.ontimeout = function() {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.send();
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _onFetchComplete(status, response, isAutoSync) {
                try {
                    if (status >= 200 && status < 400 && response) {
                        _retryCnt = 0; // any successful response will reset retry count to 0
                        var JSON_1 = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)();
                        if (JSON_1) {
                            var cdnCfg = JSON_1.parse(response); //comments are not allowed
                            var cfg = (0, $dc26cd3b06f2c35c$export$fdfda4484470ef4d)(cdnCfg, _self.core);
                            var newCfg = cfg && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(cfg) && _replaceTartgetByKeys(cfg);
                            newCfg && _setCfg(newCfg, isAutoSync);
                        //cfg && _setCfg(cfg, isAutoSync);
                        }
                    } else _retryCnt++;
                    if (_retryCnt < 3) _setupTimer();
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _doOnComplete(oncomplete, status, response, isAutoSync) {
                try {
                    oncomplete(status, response, isAutoSync);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _addEventListener() {
                if (_receiveChanges) {
                    var global_2 = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                    if (global_2) try {
                        (0, $02f0ede5277c99cd$export$324ab159353a60a9)(global_2, _evtName, function(event) {
                            // TODO: add more validation here
                            // may include a "name" or some other features to check
                            var cfgEvent = event && event.detail;
                            if (_onCfgChangeReceive && cfgEvent) _onCfgChangeReceive(cfgEvent);
                            else {
                                var cfg = cfgEvent && cfgEvent.cfg;
                                var newCfg = cfg && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(cfg) && _replaceTartgetByKeys(cfg);
                                newCfg && _setCfg(newCfg);
                            }
                        }, _evtNamespace, true);
                    } catch (e) {
                    // eslint-disable-next-line no-empty
                    }
                }
            }
            // 4 levels
            function _replaceTartgetByKeys(cfg, level) {
                var _cfg = null;
                try {
                    if (cfg) _cfg = (0, $dc26cd3b06f2c35c$export$b4df6e888f21a5d1)(cfg, _nonOverrideConfigs, 0, 5);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return _cfg;
            }
            /**
             * Sets up the timer which triggers fetching cdn every 30mins after inital call
             */ function _setupTimer() {
                if (!_timeoutHandle && _fetchTimeout) {
                    _timeoutHandle = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                        _timeoutHandle = null;
                        _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                    }, _fetchTimeout);
                    _timeoutHandle.unref();
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryCnt = 0;
            }
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
        });
        return _this;
    }
    // Removed Stub for CfgSyncPlugin.prototype.initialize.
    // Removed Stub for CfgSyncPlugin.prototype.getCfg.
    // Removed Stub for CfgSyncPlugin.prototype.setCfg.
    // Removed Stub for CfgSyncPlugin.prototype.sync.
    // Removed Stub for CfgSyncPlugin.prototype.updateEventListenerName.
    // Removed Stub for CfgSyncPlugin.prototype.pause.
    // Removed Stub for CfgSyncPlugin.prototype.resume.
    //// Removed Stub for CfgSyncPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    CfgSyncPlugin.__ieDyn = 1;
    return CfgSyncPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $452a7a5f1b634188$export$bc7f1ae22a2680b3 = /* @__PURE__ */ (0, $b49c449a24f657f6$export$fd52abd0b2703048)({
    NONE: 0 /* eActiveStatus.NONE */ ,
    PENDING: 3 /* eActiveStatus.PENDING */ ,
    INACTIVE: 1 /* eActiveStatus.INACTIVE */ ,
    ACTIVE: 2 /* eActiveStatus.ACTIVE */ 
});

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



function $248db41a83147c13$export$ba14d9a5a581e827(response, diagLog) {
    try {
        if (response && response !== "") {
            var result = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(response);
            if (result && result[0, $45806013ed348c93$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] && result[0, $45806013ed348c93$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] >= result.itemsAccepted && result.itemsReceived - result.itemsAccepted === result.errors[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) return result;
        }
    } catch (e) {
        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 43 /* _eInternalMessageId.InvalidBackendResponse */ , "Cannot parse the response. " + (e[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] || (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)), {
            response: response
        });
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


function $59a25debd846dee6$export$86347c3dd68c03f6(target, isAsync) {
    if (target && target[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ]) return target[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ](isAsync);
}
function $59a25debd846dee6$export$bc81824d13c51ef3(targets, isAsync, done) {
    var result;
    if (!done) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolved) {
        done = resolved;
    });
    if (targets && (0, $5831ddb3a0caf7c7$export$f0d11c074a923179)(targets) > 0) (0, $4121df0a705d038e$export$856fe465480fa77a)($59a25debd846dee6$export$86347c3dd68c03f6(targets[0], isAsync), function() {
        $59a25debd846dee6$export$bc81824d13c51ef3((0, $5831ddb3a0caf7c7$export$1bea104a0e2567f0)(targets, 1), isAsync, done);
    });
    else done();
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 



/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $585383ffe353022e$export$a1373ad9f192f374 = 500;
var $585383ffe353022e$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation"; // export const SampleRate = "sampleRate";
 // export const ProcessLegacy = "ProcessLegacy";
 // export const HttpMethod = "http.method";
 // export const DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
 // export const DEFAULT_BREEZE_PATH = "/v2/track";
 // export const strNotSpecified = "not_specified";
 // export const strIkey = "iKey";





var $7928109a8e3dfbfa$var$STR_EMPTY = "";
var $7928109a8e3dfbfa$var$STR_NO_RESPONSE_BODY = "NoResponseBody";
var $7928109a8e3dfbfa$var$_noResponseQs = "&" + $7928109a8e3dfbfa$var$STR_NO_RESPONSE_BODY + "=true";
var $7928109a8e3dfbfa$var$STR_POST_METHOD = "POST";
/**
 * This Internal component
 * Manager SendPost functions
 * SendPostManger
 * @internal for internal use only
 */ var $7928109a8e3dfbfa$export$e3388bef22319dfd = /** @class */ function() {
    function SenderPostManager() {
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _enableSendPromise;
        var _isInitialized;
        var _diagLog;
        var _isOneDs;
        var _onCompleteFuncs;
        var _disableCredentials;
        var _fetchCredentials;
        var _fallbackInst;
        var _disableXhr;
        var _disableBeacon;
        var _disableBeaconSync;
        var _disableFetchKeepAlive;
        var _addNoResponse;
        var _timeoutWrapper;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(SenderPostManager, this, function(_self, _base) {
            var _sendCredentials = true; // for 1ds
            _initDefaults();
            _self[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, diagLog) {
                _diagLog = diagLog;
                if (_isInitialized) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _self.SetConfig(config);
                _isInitialized = true;
            };
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _isInitialized,
                    _isOneDs,
                    _disableCredentials,
                    _enableSendPromise
                ];
            };
            // This componet might get its config from sender, offline sender, 1ds post
            // so set this function to mock dynamic changes
            _self.SetConfig = function(config) {
                try {
                    _onCompleteFuncs = config.senderOnCompleteCallBack || {};
                    _disableCredentials = !!config.disableCredentials;
                    _fetchCredentials = config.fetchCredentials;
                    _isOneDs = !!config.isOneDs;
                    _enableSendPromise = !!config.enableSendPromise;
                    _disableXhr = !!config.disableXhr;
                    _disableBeacon = !!config.disableBeacon;
                    _disableBeaconSync = !!config.disableBeaconSync;
                    _timeoutWrapper = config.timeWrapper;
                    _addNoResponse = !!config.addNoResponse;
                    _disableFetchKeepAlive = !!config.disableFetchKeepAlive;
                    _fallbackInst = {
                        sendPOST: _xhrSender
                    };
                    if (!_isOneDs) _sendCredentials = false; // for appInsights, set it to false always
                    if (_disableCredentials) {
                        var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                        if (location_1 && location_1.protocol && location_1.protocol[0, $45806013ed348c93$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === "file:") // Special case where a local html file fails with a CORS error on Chromium browsers
                        _sendCredentials = false;
                    }
                    return true;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return false;
            };
            _self.getSyncFetchPayload = function() {
                return _syncFetchPayload;
            };
            _self.getSenderInst = function(transports, sync) {
                if (transports && transports[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) return _getSenderInterface(transports, sync);
                return null;
            };
            _self.getFallbackInst = function() {
                return _fallbackInst;
            };
            _self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] = function(unloadCtx, unloadState) {
                _initDefaults();
            };
            _self.preparePayload = function(callback, zipPayload, payload, isSync) {
                if (!zipPayload || isSync || !payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]) {
                    // If the request is synchronous, the body is null or undefined or Compression is not supported, we don't need to compress it
                    callback(payload);
                    return;
                }
                try {
                    var csStream = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("CompressionStream");
                    if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(csStream)) {
                        callback(payload);
                        return;
                    }
                    // Create a readable stream from the uint8 data
                    var body = new ReadableStream({
                        start: function(controller) {
                            controller.enqueue((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]) ? new TextEncoder().encode(payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]) : payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]);
                            controller.close();
                        }
                    });
                    var compressedStream = body.pipeThrough(new csStream("gzip"));
                    var reader_1 = compressedStream.getReader();
                    var chunks_1 = [];
                    var totalLength_1 = 0;
                    var callbackCalled_1 = false;
                    // Process each chunk from the compressed stream reader
                    (0, $4121df0a705d038e$export$856fe465480fa77a)(reader_1.read(), function processChunk(response) {
                        if (!callbackCalled_1 && !response.rejected) {
                            // Process the chunk and continue reading
                            var result = response[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                            if (!result.done) {
                                // Add current chunk and continue reading
                                chunks_1[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](result[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ]);
                                totalLength_1 += result.value[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
                                return (0, $4121df0a705d038e$export$856fe465480fa77a)(reader_1.read(), processChunk);
                            }
                            // We are complete so combine all chunks
                            var combined = new Uint8Array(totalLength_1);
                            var offset = 0;
                            for(var _i = 0, chunks_2 = chunks_1; _i < chunks_2.length; _i++){
                                var chunk = chunks_2[_i];
                                combined.set(chunk, offset);
                                offset += chunk[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
                            }
                            // Update payload with compressed data
                            payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ] = combined;
                            payload[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ]["Content-Encoding"] = "gzip";
                            payload._chunkCount = chunks_1[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
                        }
                        if (!callbackCalled_1) {
                            // Send the processed payload to the callback, if not already called
                            // If the response was rejected, we will call the callback with the original payload
                            // As it only gets "replaced" if the compression was successful
                            callbackCalled_1 = true;
                            callback(payload);
                        }
                    // We don't need to return anything as this will cause the calling chain to be resolved and closed
                    });
                    // returning the reader to allow the caller to cancel the stream if needed
                    // This is not a requirement but allows for better control over the stream, like if we detect that we are unloading
                    // we could use reader.cancel() to stop the stream and avoid sending the request, but this may still be an asynchronous operation
                    // and may not be possible to cancel the stream in time
                    return reader_1;
                } catch (error) {
                    // CompressionStream is not available at all
                    callback(payload);
                    return;
                }
            };
            /**
             * success handler
             */ function _onSuccess(res, onComplete) {
                _doOnComplete(onComplete, 200, {}, res);
            }
            /**
             * error handler
             */ function _onError(message, onComplete) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _doOnComplete(onComplete, 400, {});
            }
            function _onNoPayloadUrl(onComplete) {
                _onError("No endpoint url is provided for the batch", onComplete);
            }
            function _getSenderInterface(transports, syncSupport) {
                var transportType = 0 /* TransportType.NotSet */ ;
                var sendPostFunc = null;
                var lp = 0;
                while(sendPostFunc == null && lp < transports[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]){
                    transportType = transports[lp];
                    if (!_disableXhr && transportType === 1 /* TransportType.Xhr */ ) {
                        if ((0, $0d2c2fb24388dcf8$export$b9f2bc09e5ac0fa5)()) // IE 8 and 9
                        sendPostFunc = _xdrSender;
                        else if ((0, $0d2c2fb24388dcf8$export$cfeac9aa070f0108)()) sendPostFunc = _xhrSender;
                    } else if (transportType === 2 /* TransportType.Fetch */  && (0, $0d2c2fb24388dcf8$export$f8c1c61350d9749)(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) sendPostFunc = _doFetchSender;
                    else if (transportType === 3 /* TransportType.Beacon */  && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) sendPostFunc = _beaconSender;
                    lp++;
                }
                if (sendPostFunc) return {
                    _transport: transportType,
                    _isSync: syncSupport,
                    sendPOST: sendPostFunc
                };
                return null;
            }
            function _doOnComplete(oncomplete, status, headers, response) {
                try {
                    oncomplete && oncomplete(status, headers, response);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
            }
            function _doBeaconSend(payload, oncomplete) {
                var nav = (0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)();
                var url = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                if (!url) {
                    _onNoPayloadUrl(oncomplete);
                    // return true here, because we don't want to retry it with fallback sender
                    return true;
                }
                url = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ] + (_addNoResponse ? $7928109a8e3dfbfa$var$_noResponseQs : $7928109a8e3dfbfa$var$STR_EMPTY);
                var data = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = _isOneDs ? data : new Blob([
                    data
                ], {
                    type: "text/plain;charset=UTF-8"
                });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - The data payload to be sent.
             * @param sync - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _beaconSender(payload, oncomplete, sync) {
                var data = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                try {
                    if (data) {
                        // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                        if (!_doBeaconSend(payload, oncomplete)) {
                            var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
                            if (onRetry && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onRetry)) onRetry(payload, oncomplete, _doBeaconSend);
                            else {
                                _fallbackInst && _fallbackInst.sendPOST(payload, oncomplete, true);
                                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                            }
                        } else // if can send
                        _onSuccess($7928109a8e3dfbfa$var$STR_EMPTY, oncomplete); // if success, onComplete is called with status code 200
                    }
                } catch (e) {
                    _isOneDs && (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e));
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, $7928109a8e3dfbfa$var$STR_EMPTY);
                }
                return;
            }
            /**
             * Send XMLHttpRequest
             * @param payload - The data payload to be sent.
             * @param sync - Indicates if the request should be sent synchronously
             */ function _xhrSender(payload, oncomplete, sync) {
                //let  internalPayload = payload as IInternalPayloadData;
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var headers = payload[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {};
                if (!sync && _enableSendPromise) thePromise = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                if (_isOneDs && sync && payload.disableXhrSync) sync = false;
                //const xhr = new XMLHttpRequest();
                var endPointUrl = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                var xhr = (0, $ede407819d2d28c9$export$b028e759972c6d09)($7928109a8e3dfbfa$var$STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ]);
                if (!_isOneDs) // application/json should NOT add to 1ds post by default
                xhr.setRequestHeader("Content-type", "application/json");
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(headers), function(headerName) {
                    xhr.setRequestHeader(headerName, headers[headerName]);
                });
                xhr.onreadystatechange = function() {
                    if (!_isOneDs) {
                        _doOnReadyFunc(xhr);
                        if (xhr.readyState === 4) resolveFunc && resolveFunc(true);
                    }
                };
                xhr.onload = function() {
                    if (_isOneDs) _doOnReadyFunc(xhr);
                };
                function _doOnReadyFunc(xhr) {
                    var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
                    var onReadyFuncExist = onReadyFunc && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onReadyFunc);
                    if (onReadyFuncExist) onReadyFunc(xhr, oncomplete, payload);
                    else {
                        var response = (0, $ede407819d2d28c9$export$43a870850da980b4)(xhr);
                        _doOnComplete(oncomplete, xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ], (0, $ede407819d2d28c9$export$801009daa428ec44)(xhr, _isOneDs), response);
                    }
                }
                xhr.onerror = function(event) {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ] : 400, (0, $ede407819d2d28c9$export$801009daa428ec44)(xhr, _isOneDs), _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : (0, $ede407819d2d28c9$export$f826fdf8bca00592)(xhr));
                    rejectFunc && rejectFunc(event);
                };
                xhr.ontimeout = function() {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ] : 500, (0, $ede407819d2d28c9$export$801009daa428ec44)(xhr, _isOneDs), _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : (0, $ede407819d2d28c9$export$f826fdf8bca00592)(xhr));
                    resolveFunc && resolveFunc(false);
                };
                xhr.send(payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]);
                return thePromise;
            }
            /**
             * Send fetch API request
             * @param payload - The data payload to be sent.
             * @param sync - For fetch this identifies whether we are "unloading" (false) or a normal request
             */ function _doFetchSender(payload, oncomplete, sync) {
                var _a;
                var endPointUrl = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                var batch = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                var plainTextBatch = _isOneDs ? batch : new Blob([
                    batch
                ], {
                    type: "application/json"
                });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
                var ignoreResponse = false;
                var responseHandled = false;
                var headers = payload[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {};
                //TODO: handle time out for 1ds
                var init = (_a = {
                    method: $7928109a8e3dfbfa$var$STR_POST_METHOD,
                    body: plainTextBatch
                }, _a[0, $585383ffe353022e$export$7c6abff2f2bdd9c0] = true // Mark so we don't attempt to track this request
                , _a);
                // Only add headers if there are headers to add, due to issue with some polyfills
                if (payload.headers && (0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(payload.headers)[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(headers), function(headerName) {
                        requestHeaders.append(headerName, headers[headerName]);
                    });
                    init[0, $45806013ed348c93$export$829ed22a43b4aada /* @min:%2eheaders */ ] = requestHeaders;
                }
                if (_fetchCredentials) init.credentials = _fetchCredentials;
                else if (_sendCredentials && _isOneDs) // for 1ds, Don't send credentials when URL is file://
                init.credentials = "include";
                if (sync) {
                    init.keepalive = true;
                    _syncFetchPayload += batchLength;
                    if (_isOneDs) {
                        if (payload["_sendReason"] === 2 /* SendRequestReason.Unload */ ) {
                            // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                            // just like beacon send assume that the events have been accepted and processed
                            ignoreResponse = true;
                            if (_addNoResponse) endPointUrl += $7928109a8e3dfbfa$var$_noResponseQs;
                        }
                    } else // for appinsights, set to true for all sync request
                    ignoreResponse = true;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[0, $585383ffe353022e$export$7c6abff2f2bdd9c0] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                if (!sync && _enableSendPromise) thePromise = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                function _handleError(res, statusCode) {
                    // In case there is an error in the request. Set the status to 0 for 1ds and 400 for appInsights
                    // so that the events can be retried later.
                    if (statusCode) _doOnComplete(oncomplete, _isOneDs ? 0 : statusCode, {}, _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : res);
                    else _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : res);
                }
                function _onFetchComplete(response, payload, value) {
                    var status = response[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ];
                    var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
                    if (onCompleteFunc && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onCompleteFunc)) onCompleteFunc(response, oncomplete, value || $7928109a8e3dfbfa$var$STR_EMPTY, payload);
                    else _doOnComplete(oncomplete, status, {}, value || $7928109a8e3dfbfa$var$STR_EMPTY);
                }
                try {
                    (0, $4121df0a705d038e$export$856fe465480fa77a)(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function(result) {
                        if (sync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                try {
                                    /**
                                     * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                     * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                     * or if anything prevented the request from completing.
                                     */ if (!_isOneDs && !response_1.ok) {
                                        // this is for appInsights only
                                        if (response_1[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ]) _handleError(response_1.statusText, response_1[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ]);
                                        else _handleError(response_1.statusText, 499);
                                        resolveFunc && resolveFunc(false);
                                    } else if (_isOneDs && !response_1.body) {
                                        _onFetchComplete(response_1, null, $7928109a8e3dfbfa$var$STR_EMPTY);
                                        resolveFunc && resolveFunc(true);
                                    } else (0, $4121df0a705d038e$export$856fe465480fa77a)(response_1.text(), function(resp) {
                                        _onFetchComplete(response_1, payload, resp[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ]);
                                        resolveFunc && resolveFunc(true);
                                    });
                                } catch (e) {
                                    if (response_1 && response_1[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ]) _handleError((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), response_1[0, $45806013ed348c93$export$f8d169088a01f6f2 /* @min:%2estatus */ ]);
                                    else _handleError((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), 499);
                                    rejectFunc && rejectFunc(e);
                                }
                            } else {
                                _handleError(result.reason && result.reason[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ], 499);
                                rejectFunc && rejectFunc(result.reason);
                            }
                        }
                    });
                } catch (e) {
                    if (!responseHandled) {
                        _handleError((0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), 499);
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _doOnComplete(oncomplete, 200, {});
                    resolveFunc && resolveFunc(true);
                }
                if (_isOneDs && !responseHandled && payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ] > 0) // Simulate timeout
                _timeoutWrapper && _timeoutWrapper.set(function() {
                    if (!responseHandled) {
                        // Assume a 500 response (which will cause a retry)
                        responseHandled = true;
                        _doOnComplete(oncomplete, 500, {});
                        resolveFunc && resolveFunc(true);
                    }
                }, payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ]);
                return thePromise;
            }
            /**
             * Send XDomainRequest
             * @param payload - The data payload to be sent.
             * @param sync - Indicates if the request should be sent synchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _xdrSender(payload, oncomplete, sync) {
                // It doesn't support custom headers, so no action is taken with current requestHeaders
                var _window = (0, $5831ddb3a0caf7c7$export$38b2d434cce3ea22)();
                var xdr = new XDomainRequest();
                var data = payload[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ];
                xdr.onload = function() {
                    var response = (0, $ede407819d2d28c9$export$43a870850da980b4)(xdr);
                    var onloadFunc = _onCompleteFuncs && _onCompleteFuncs.xdrOnComplete;
                    if (onloadFunc && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(onloadFunc)) onloadFunc(xdr, oncomplete, payload);
                    else _doOnComplete(oncomplete, 200, {}, response);
                };
                xdr.onerror = function() {
                    _doOnComplete(oncomplete, 400, {}, _isOneDs ? $7928109a8e3dfbfa$var$STR_EMPTY : (0, $ede407819d2d28c9$export$404d535171315d86)(xdr));
                };
                xdr.ontimeout = function() {
                    _doOnComplete(oncomplete, 500, {});
                };
                xdr.onprogress = function() {};
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                var endpoint = payload[0, $45806013ed348c93$export$4babcb0997150ae4 /* @min:%2eurlString */ ];
                if (!endpoint) {
                    _onNoPayloadUrl(oncomplete);
                    return;
                }
                if (!_isOneDs && endpoint.lastIndexOf(hostingProtocol, 0) !== 0) {
                    var msg = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_diagLog, 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". " + msg);
                    _onError(msg, oncomplete);
                    return;
                }
                var endpointUrl = _isOneDs ? endpoint : endpoint[0, $45806013ed348c93$export$ef9ef3ed86c4485 /* @min:%2ereplace */ ](/^(https?:)/, "");
                xdr.open($7928109a8e3dfbfa$var$STR_POST_METHOD, endpointUrl);
                if (payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ]) xdr[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ] = payload[0, $45806013ed348c93$export$4a1d5ee7f477d201 /* @min:%2etimeout */ ];
                xdr.send(data);
                if (_isOneDs && sync) _timeoutWrapper && _timeoutWrapper.set(function() {
                    xdr.send(data);
                }, 0);
                else xdr.send(data);
            }
            function _initDefaults() {
                _syncFetchPayload = 0;
                _isInitialized = false;
                _enableSendPromise = false;
                _diagLog = null;
                _isOneDs = null;
                _onCompleteFuncs = null;
                _disableCredentials = null;
                _fetchCredentials = null;
                _fallbackInst = null;
                _disableXhr = false;
                _disableBeacon = false;
                _disableBeaconSync = false;
                _disableFetchKeepAlive = false;
                _addNoResponse = false;
                _timeoutWrapper = null;
            }
        });
    }
    // Removed Stub for SenderPostManager.prototype.initialize.
    // Removed Stub for SenderPostManager.prototype.getSyncFetchPayload.
    // Removed Stub for SenderPostManager.prototype.SetConfig.
    // Removed Stub for SenderPostManager.prototype.getSenderInst.
    // Removed Stub for SenderPostManager.prototype.getFallbackInst.
    // Removed Stub for SenderPostManager.prototype._doTeardown.
    // Removed Stub for SenderPostManager.prototype.preparePayload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    SenderPostManager.__ieDyn = 1;
    return SenderPostManager;
}();




/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $7fa712059cae73d1$export$be41298b7716c698 = "duration";


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $07716e087fcf5bbc$export$d0f526aa8043f6d7 = "tags"; // Count: 17
var $07716e087fcf5bbc$export$f393dda3e1c87f59 = "deviceType"; // Count: 3
var $07716e087fcf5bbc$export$2f5ff0b46814907e = "data"; // Count: 13
var $07716e087fcf5bbc$export$9734b0a24bf02e93 = "name"; // Count: 8
var $07716e087fcf5bbc$export$a5eb52c53bba8560 = "traceID"; // Count: 5
var $07716e087fcf5bbc$export$6eae51590aaea43 = "length"; // Count: 38
var $07716e087fcf5bbc$export$a318a8141fc98747 = "stringify"; // Count: 5
var $07716e087fcf5bbc$export$32fc64677eb5b7a2 = "measurements"; // Count: 7
var $07716e087fcf5bbc$export$9e16762ab4f2648 = "dataType"; // Count: 10
var $07716e087fcf5bbc$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $07716e087fcf5bbc$export$e2818d11505fa034 = "toString"; // Count: 7
var $07716e087fcf5bbc$export$4aae77f3ba3c48b4 = "enqueue"; // Count: 7
var $07716e087fcf5bbc$export$e9679ef501b0d1 = "count"; // Count: 7
var $07716e087fcf5bbc$export$a0a330e7fa1e278c = "push"; // Count: 9
var $07716e087fcf5bbc$export$b18aabdfc0aaf6b = "emitLineDelimitedJson"; // Count: 3
var $07716e087fcf5bbc$export$5eeb73fac03da74a = "clear"; // Count: 6
var $07716e087fcf5bbc$export$52e50651d87300e3 = "markAsSent"; // Count: 4
var $07716e087fcf5bbc$export$13da1b5a005ef035 = "clearSent"; // Count: 5
var $07716e087fcf5bbc$export$4637bcb72c509e60 = "bufferOverride"; // Count: 3
var $07716e087fcf5bbc$export$63ab2dad6d8a60ed = "BUFFER_KEY"; // Count: 5
var $07716e087fcf5bbc$export$d03f333763905c89 = "SENT_BUFFER_KEY"; // Count: 8
var $07716e087fcf5bbc$export$706142eb912dc2a = "concat"; // Count: 6
var $07716e087fcf5bbc$export$20d3a25105cda3b1 = "MAX_BUFFER_SIZE"; // Count: 5
var $07716e087fcf5bbc$export$df21ab0de9057cc4 = "triggerSend"; // Count: 5
var $07716e087fcf5bbc$export$c7ff2c36e5c78421 = "diagLog"; // Count: 16
var $07716e087fcf5bbc$export$65cd33bb52d04675 = "initialize"; // Count: 3
var $07716e087fcf5bbc$export$e5390b88ba6f1b04 = "_sender"; // Count: 5
var $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 5
var $07716e087fcf5bbc$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 5
var $07716e087fcf5bbc$export$dbe59923e879fdc5 = "customHeaders"; // Count: 3
var $07716e087fcf5bbc$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 2
var $07716e087fcf5bbc$export$6b8e1dc9b77f253c = "onunloadDisableBeacon"; // Count: 3
var $07716e087fcf5bbc$export$f5629284a6f7ec3d = "isBeaconApiDisabled"; // Count: 3
var $07716e087fcf5bbc$export$87044a2824fddfb0 = "alwaysUseXhrOverride"; // Count: 2
var $07716e087fcf5bbc$export$c9210d86ca1dd637 = "enableSessionStorageBuffer"; // Count: 2
var $07716e087fcf5bbc$export$3f8a6394c5f7e7be = "_buffer"; // Count: 9
var $07716e087fcf5bbc$export$fa88a131053c3501 = "onunloadDisableFetch"; // Count: 2
var $07716e087fcf5bbc$export$78c7449d94867b7f = "disableSendBeaconSplit"; // Count: 2
var $07716e087fcf5bbc$export$f8d641d56432a4fc = "getSenderInst"; // Count: 4
var $07716e087fcf5bbc$export$fd0c91d4da43d71b = "_onError"; // Count: 7
var $07716e087fcf5bbc$export$689c49d56ac33585 = "_onPartialSuccess"; // Count: 3
var $07716e087fcf5bbc$export$82a109ffee49e423 = "_onSuccess"; // Count: 6
var $07716e087fcf5bbc$export$746df81af2cb9d94 = "itemsReceived"; // Count: 3
var $07716e087fcf5bbc$export$fb8523c8667e286a = "itemsAccepted"; // Count: 3
var $07716e087fcf5bbc$export$aa558e99f83347cf = "baseType"; // Count: 4
var $07716e087fcf5bbc$export$c2afe23fa18f9dff = "sampleRate"; // Count: 4
var $07716e087fcf5bbc$export$d676f8c50f371355 = "getHashCodeScore"; // Count: 4


// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var $53141cdecfc05483$var$strBaseType = "baseType";
var $53141cdecfc05483$var$strBaseData = "baseData";
var $53141cdecfc05483$var$strProperties = "properties";
var $53141cdecfc05483$var$strTrue = "true";
function $53141cdecfc05483$var$_setValueIf(target, field, value) {
    return (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(target, field, value, (0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f));
}
/*
 * Maps Part A data from CS 4.0
 */ function $53141cdecfc05483$var$_extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = env[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || [];
    var extUser = itmExt.user;
    if (extUser) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).userAuthUserId, extUser.authId);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).sessionId, extApp.sesId);
    var extDevice = itmExt.device;
    if (extDevice) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceId, extDevice.id || extDevice.localId);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6)[0, $07716e087fcf5bbc$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ], extDevice.deviceClass);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceIp, extDevice.ip);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceModel, extDevice.model);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6)[0, $07716e087fcf5bbc$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ], extDevice[0, $07716e087fcf5bbc$export$f393dda3e1c87f59 /* @min:%2edeviceType */ ]);
    }
    var web = item.ext.web;
    if (web) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceLanguage, web.browserLang);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceBrowserVersion, web.browserVer);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceBrowser, web.browser);
        var envData = env[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ] = env[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ] || {};
        var envBaseData = envData[$53141cdecfc05483$var$strBaseData] = envData[$53141cdecfc05483$var$strBaseData] || {};
        var envProps = envBaseData[$53141cdecfc05483$var$strProperties] = envBaseData[$53141cdecfc05483$var$strProperties] || {};
        $53141cdecfc05483$var$_setValueIf(envProps, "domain", web.domain);
        $53141cdecfc05483$var$_setValueIf(envProps, "isManual", web.isManual ? $53141cdecfc05483$var$strTrue : null);
        $53141cdecfc05483$var$_setValueIf(envProps, "screenRes", web.screenRes);
        $53141cdecfc05483$var$_setValueIf(envProps, "userConsent", web.userConsent ? $53141cdecfc05483$var$strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceOS, extOs[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ]);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).deviceOSVersion, extOs.osVer);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).operationParentId, extTrace.parentID);
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).operationName, (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, extTrace[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ]));
        $53141cdecfc05483$var$_setValueIf(envTags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).operationId, extTrace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for(var i = itmTags[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; i >= 0; i--){
        var tg = itmTags[i];
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(tg, function(key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(itmTags, function(tg, value) {
        tgs[tg] = value;
    });
    var theTags = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, envTags), tgs);
    if (!theTags[(0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkVersion]) // Append a version in case it is not already set
    theTags[(0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkVersion] = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, "javascript:".concat($53141cdecfc05483$export$3f11c9a3e644970c.Version), 64);
    env[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = (0, $ede407819d2d28c9$export$3e03fa3fc3e422d7)(theTags);
}
function $53141cdecfc05483$var$_extractPropsAndMeasurements(data, properties, measurements) {
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(data)) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(data, function(key, value) {
        if ((0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(value)) measurements[key] = value;
        else if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(value)) properties[key] = value;
        else if ((0, $0d2c2fb24388dcf8$export$a2856ab6913b9fff)()) properties[key] = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](value);
    });
}
function $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(properties)) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(properties, function(key, value) {
        properties[key] = value || customUndefinedValue;
    });
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function $53141cdecfc05483$var$_createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new (0, $9a1ea820994e6e6d$export$4e2d65a9843399df)(logger, data, envelopeType);
    $53141cdecfc05483$var$_setValueIf(envelope, "sampleRate", telemetryItem[0, $8ac3b4fe9182f568$export$dc288b6444e20c04]);
    if ((telemetryItem[$53141cdecfc05483$var$strBaseData] || {}).startTime) // Starting from Version 3.0.3, the time property will be assigned by the startTime value,
    // which records the loadEvent time for the pageView event.
    envelope.time = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(telemetryItem[$53141cdecfc05483$var$strBaseData].startTime);
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ] = envelope[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    $53141cdecfc05483$var$_extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] = telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] || [];
    return (0, $ede407819d2d28c9$export$3e03fa3fc3e422d7)(envelope);
}
function $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem) {
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[$53141cdecfc05483$var$strBaseData])) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */ , "telemetryItem.baseData cannot be null.");
}
var $53141cdecfc05483$export$3f11c9a3e644970c = {
    Version: '3.3.10'
};
function $53141cdecfc05483$export$74e603a08a7deabe(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd)) {
        (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[$53141cdecfc05483$var$strProperties] && bd[$53141cdecfc05483$var$strProperties][0, $8ac3b4fe9182f568$export$8343e6f32f5246de] ? bd[$53141cdecfc05483$var$strProperties][0, $8ac3b4fe9182f568$export$8343e6f32f5246de] : "GET";
    var remoteDepData = new (0, $97ca5e424f1910ef$export$a7b48490930dbffa)(logger, bd.id, bd.target, bd[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ], bd[0, $7fa712059cae73d1$export$be41298b7716c698 /* @min:%2eduration */ ], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $97ca5e424f1910ef$export$a7b48490930dbffa)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], remoteDepData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $97ca5e424f1910ef$export$a7b48490930dbffa)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$b74153364c2066d1(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[$53141cdecfc05483$var$strBaseType] !== (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ]) customProperties["baseTypeSource"] = telemetryItem[$53141cdecfc05483$var$strBaseType]; // save the passed in base type as a property
    if (telemetryItem[$53141cdecfc05483$var$strBaseType] === (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ]) {
        customProperties = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
        customMeasurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    } else if (telemetryItem[$53141cdecfc05483$var$strBaseData]) $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[$53141cdecfc05483$var$strBaseData], customProperties, customMeasurements);
    // Extract root level properties from part C telemetryItem.data
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var eventName = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var eventData = new (0, $62713924cc3cd966$export$d61e24a684f9e51)(logger, eventName, customProperties, customMeasurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], eventData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $62713924cc3cd966$export$d61e24a684f9e51)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$eca78b65eeb356ed(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    var exData = (0, $a35c931c4df783c8$export$e2f174de097e0bcd).CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], exData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $a35c931c4df783c8$export$e2f174de097e0bcd)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$bb5bee4039a2e495(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[$53141cdecfc05483$var$strBaseData];
    var props = baseData[$53141cdecfc05483$var$strProperties] || {};
    var measurements = baseData[0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], props, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseMetricData = new (0, $5db807982a2eef93$export$efdd3e096bc27746)(logger, baseData[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseMetricData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$edbb8a2c6529947a(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[$53141cdecfc05483$var$strBaseData];
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseData) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseData[$53141cdecfc05483$var$strProperties]) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(baseData[$53141cdecfc05483$var$strProperties][0, $7fa712059cae73d1$export$be41298b7716c698])) {
        duration = baseData[$53141cdecfc05483$var$strProperties][0, $7fa712059cae73d1$export$be41298b7716c698];
        delete baseData[$53141cdecfc05483$var$strProperties][0, $7fa712059cae73d1$export$be41298b7716c698];
    } else if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ]) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $7fa712059cae73d1$export$be41298b7716c698])) {
        duration = telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $7fa712059cae73d1$export$be41298b7716c698];
        delete telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ][0, $7fa712059cae73d1$export$be41298b7716c698];
    }
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]) currentContextId = telemetryItem.ext.trace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ];
    var id = bd.id || currentContextId;
    var name = bd[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var url = bd.uri;
    var properties = bd[$53141cdecfc05483$var$strProperties] || {};
    var measurements = bd[0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd.refUri)) properties["refUri"] = bd.refUri;
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd.pageType)) properties["pageType"] = bd.pageType;
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd.isLoggedIn)) properties["isLoggedIn"] = bd.isLoggedIn[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]();
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(bd[$53141cdecfc05483$var$strProperties])) {
        var pageTags = bd[$53141cdecfc05483$var$strProperties];
        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(pageTags, function(key, value) {
            properties[key] = value;
        });
    }
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], properties, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var pageViewData = new (0, $3e77672805d15946$export$12c0fdede1c6bc6c)(logger, name, url, duration, properties, measurements, id);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], pageViewData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $3e77672805d15946$export$12c0fdede1c6bc6c)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$bb801863268e7049(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[$53141cdecfc05483$var$strBaseData];
    var name = bd[0, $07716e087fcf5bbc$export$9734b0a24bf02e93 /* @min:%2ename */ ];
    var url = bd.uri || bd.url;
    var properties = bd[$53141cdecfc05483$var$strProperties] || {};
    var measurements = bd[0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], properties, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var baseData = new (0, $03ee94b6fff0696e$export$709aae57ec681346)(logger, name, url, undefined, properties, measurements, bd);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $03ee94b6fff0696e$export$709aae57ec681346)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $53141cdecfc05483$export$bc9e843f2eb8a61c(logger, telemetryItem, customUndefinedValue) {
    $53141cdecfc05483$var$EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[$53141cdecfc05483$var$strBaseData].message;
    var severityLevel = telemetryItem[$53141cdecfc05483$var$strBaseData].severityLevel;
    var props = telemetryItem[$53141cdecfc05483$var$strBaseData][$53141cdecfc05483$var$strProperties] || {};
    var measurements = telemetryItem[$53141cdecfc05483$var$strBaseData][0, $07716e087fcf5bbc$export$32fc64677eb5b7a2 /* @min:%2emeasurements */ ] || {};
    $53141cdecfc05483$var$_extractPropsAndMeasurements(telemetryItem[0, $07716e087fcf5bbc$export$2f5ff0b46814907e /* @min:%2edata */ ], props, measurements);
    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(customUndefinedValue)) $53141cdecfc05483$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseData = new (0, $adb0678ebd5d1780$export$78e1bea9036f120f)(logger, message, severityLevel, props, measurements);
    var data = new (0, $1b13bacff23d2e52$export$2d0294657ab35f1b)((0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ], baseData);
    return $53141cdecfc05483$var$_createEnvelope(logger, (0, $adb0678ebd5d1780$export$78e1bea9036f120f)[0, $07716e087fcf5bbc$export$2672d4f7ccc80348 /* @min:%2eenvelopeType */ ], telemetryItem, data);
}


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




var $1fa48c075af358bb$var$BaseSendBuffer = /** @class */ function() {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        var _maxRetryCnt = config.maxRetryCnt;
        this._get = function() {
            return _buffer;
        };
        this._set = function(buffer) {
            _buffer = buffer;
            return _buffer;
        };
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(BaseSendBuffer, this, function(_self) {
            _self[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() >= config.eventsLimitInMem) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 105 /* _eInternalMessageId.InMemoryStorageBufferFull */ , "Maximum in-memory buffer size reached: " + _self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                payload.cnt = payload.cnt || 0;
                // max retry is defined, and max retry is reached, do not add the payload to buffer
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_maxRetryCnt)) {
                    if (payload.cnt > _maxRetryCnt) // TODO: add log here on dropping payloads
                    // will log statsbeat exception later here
                    return;
                }
                _buffer[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload);
                return;
            };
            _self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ] = function() {
                return _buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
            };
            _self.size = function() {
                var size = _buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                for(var lp = 0; lp < _buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)size += _buffer[lp].item[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                if (!config[0, $07716e087fcf5bbc$export$b18aabdfc0aaf6b /* @min:%2eemitLineDelimitedJson */ ]) size += 2;
                return size;
            };
            _self[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ] = function() {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function() {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function(payloads) {
                if (payloads && payloads[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var payloadStr_1 = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(payloads, function(payload) {
                        payloadStr_1[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload.item);
                    });
                    var batch = config[0, $07716e087fcf5bbc$export$b18aabdfc0aaf6b /* @min:%2eemitLineDelimitedJson */ ] ? payloadStr_1.join("\n") : "[" + payloadStr_1.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self.createNew = function(newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new $1fa48c075af358bb$export$dcb776947c16915f(newLogger, newConfig) : new $1fa48c075af358bb$export$d706e5fd60d36d56(newLogger, newConfig);
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(items, function(payload) {
                    newBuffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                });
                return newBuffer;
            };
        });
    }
    // Removed Stub for BaseSendBuffer.prototype.enqueue.
    // Removed Stub for BaseSendBuffer.prototype.count.
    // Removed Stub for BaseSendBuffer.prototype.size.
    // Removed Stub for BaseSendBuffer.prototype.clear.
    // Removed Stub for BaseSendBuffer.prototype.getItems.
    // Removed Stub for BaseSendBuffer.prototype.batchPayloads.
    // Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn = 1;
    return BaseSendBuffer;
}();
/*
 * An array based send buffer.
 */ var $1fa48c075af358bb$export$d706e5fd60d36d56 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(ArraySendBuffer, _this, function(_self, _base) {
            _self[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ] = function(payload) {
                _base[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
            };
            _self[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ] = function(payload) {
            // not supported
            };
        });
        return _this;
    }
    // Removed Stub for ArraySendBuffer.prototype.markAsSent.
    // Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn = 1;
    return ArraySendBuffer;
}($1fa48c075af358bb$var$BaseSendBuffer);
var $1fa48c075af358bb$var$PREVIOUS_KEYS = [
    "AI_buffer",
    "AI_sentBuffer"
];
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */ var $1fa48c075af358bb$export$dcb776947c16915f = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
        // TODO: add remove buffer override as well
        var _b = config[0, $07716e087fcf5bbc$export$4637bcb72c509e60 /* @min:%2ebufferOverride */ ] || {
            getItem: (0, $3fab9bbcce274f86$export$a398bd2f40e2eb6e),
            setItem: (0, $3fab9bbcce274f86$export$21abea3a85fee3f5)
        }, getItem = _b.getItem, setItem = _b.setItem;
        var _maxRetryCnt = config.maxRetryCnt;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(SessionStorageSendBuffer, _this, function(_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ]);
            var itemsInSentBuffer = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
            var previousItems = _getPreviousEvents();
            var notDeliveredItems = itemsInSentBuffer[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](previousItems);
            var buffer = _self._set(bufferItems[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) buffer[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ];
            _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], []);
            _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], buffer);
            _self[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() >= SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Maximum buffer size reached: " + _self[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                payload.cnt = payload.cnt || 0;
                // max retry is defined, and max retry is reached, do not add the payload to buffer
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_maxRetryCnt)) {
                    if (payload.cnt > _maxRetryCnt) // TODO: add log here on dropping payloads
                    return;
                }
                _base[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], _self._get());
            };
            _self[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ] = function() {
                _base[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], _self._get());
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], []);
                _bufferFullMessageSent = false;
            };
            _self[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ] = function(payload) {
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$63ab2dad6d8a60ed /* @min:%2eBUFFER_KEY */ ], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](payload);
                    if (sentElements[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Sent buffer reached its maximum size: " + sentElements[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ], true);
                        sentElements[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$20d3a25105cda3b1 /* @min:%2eMAX_BUFFER_SIZE */ ];
                    }
                    _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
                }
            };
            _self[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ] = function(payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
            };
            _self.createNew = function(newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self._get().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[0, $07716e087fcf5bbc$export$d03f333763905c89 /* @min:%2eSENT_BUFFER_KEY */ ]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new $1fa48c075af358bb$export$d706e5fd60d36d56(newLogger, newConfig);
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(unsentItems, function(payload) {
                    newBuffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payload);
                });
                if (canUseSessionStorage) // arr buffer will clear all payloads if markAsSent() is called
                newBuffer[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](sentItems);
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                var payloadStr = [];
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(payloads, function(payload) {
                    payloadStr[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](payload.item);
                });
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(buffer, function(value) {
                    if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value) && (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(payloadStr, value.item) === -1) remaining[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](value);
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                return _getBufferBase(prefixedKey);
            }
            function _getBufferBase(key) {
                try {
                    var bufferJson = getItem(logger, key);
                    if (bufferJson) {
                        var buffer_1 = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(bufferJson);
                        if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(buffer_1)) // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                        buffer_1 = (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)().parse(buffer_1);
                        if (buffer_1 && (0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(buffer_1)) return buffer_1;
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */ , " storage key: " + key + ", " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                } catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ]([]));
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e) + ". Buffer cleared", {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
            // this removes buffer with prefix+key
            function _getPreviousEvents() {
                var items = [];
                try {
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)($1fa48c075af358bb$var$PREVIOUS_KEYS, function(key) {
                        var events = _getItemsFromPreviousKey(key);
                        items = items[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](events);
                        // to make sure that we also transfer items from old prefixed + key buffer
                        if (_namePrefix) {
                            var prefixedKey = _namePrefix + "_" + key;
                            var prefixEvents = _getItemsFromPreviousKey(prefixedKey);
                            items = items[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](prefixEvents);
                        }
                    });
                    return items;
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , "Transfer events from previous buffers: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e) + ". previous Buffer items can not be removed", {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return [];
            }
            // transform string[] to IInternalStorageItem[]
            function _getItemsFromPreviousKey(key) {
                try {
                    var items = _getBufferBase(key);
                    var transFormedItems_1 = [];
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(items, function(item) {
                        var internalItem = {
                            item: item,
                            cnt: 0 // previous events will be default to 0 count
                        };
                        transFormedItems_1[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](internalItem);
                    });
                    // remove the session storage if we can add events back
                    (0, $3fab9bbcce274f86$export$9f411b4ea05fb92a)(logger, key);
                    return transFormedItems_1;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return [];
            }
        });
        return _this;
    }
    // Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
    // Removed Stub for SessionStorageSendBuffer.prototype.clear.
    // Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    var _a;
    _a = SessionStorageSendBuffer;
    SessionStorageSendBuffer.VERSION = "_1";
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer" + _a.VERSION;
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer" + _a.VERSION;
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}($1fa48c075af358bb$var$BaseSendBuffer);


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


var $ffeedac495e2c7a7$export$ef852775387a0be7 = /** @class */ function() {
    function Serializer(logger) {
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(Serializer, this, function(_self) {
            /**
             * Serializes the current object to a JSON string.
             */ _self.serialize = function(input) {
                var output = _serializeObject(input, "root");
                try {
                    return (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](output);
                } catch (e) {
                    // if serialization fails return an empty string
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]) ? e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , "cannot serialize object because it is null or undefined", {
                        name: name
                    }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 50 /* _eInternalMessageId.CircularReferenceDetected */ , "Circular reference detected while serializing object", {
                        name: name
                    }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") output = _serializeStringMap(source, "number", name);
                    else if (name === "properties") output = _serializeStringMap(source, "string", name);
                    else if (name === "tags") output = _serializeStringMap(source, "string", name);
                    else if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(source)) output = _serializeArray(source, name);
                    else {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "Attempting to serialize an object which does not implement ISerializable", {
                            name: name
                        }, true);
                        try {
                            // verify that the object can be stringified
                            (0, $0d2c2fb24388dcf8$export$d047a7c56db64af4)()[0, $07716e087fcf5bbc$export$a318a8141fc98747 /* @min:%2estringify */ ](source);
                            output = source;
                        } catch (e) {
                            // if serialization fails return an empty string
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]) ? e[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(source.aiDataContract, function(field, contract) {
                    var isRequired = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(contract) ? contract() & 1 /* FieldType.Required */  : contract & 1 /* FieldType.Required */ ;
                    var isHidden = (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(contract) ? contract() & 4 /* FieldType.Hidden */  : contract & 4 /* FieldType.Hidden */ ;
                    var isArray = contract & 2 /* FieldType.Array */ ;
                    var isPresent = source[field] !== undefined;
                    var isObj = (0, $5831ddb3a0caf7c7$export$a6cdc56e425d0d0a)(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */ , "Missing required field specification. The field is required but not present on source", {
                        field: field,
                        name: name
                    });
                    else if (!isHidden) {
                        var value = void 0;
                        if (isObj) {
                            if (isArray) // special case; recurse on each object in the source array
                            value = _serializeArray(source[field], field);
                            else // recurse on the source object in this field
                            value = _serializeObject(source[field], field);
                        } else // assign the source field to the output even if undefined or required
                        value = source[field];
                        // only emit this field if the value is defined
                        if (value !== undefined) output[field] = value;
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!(0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(sources)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 54 /* _eInternalMessageId.ItemNotInArray */ , "This field was specified as an array in the contract but the item is not an array.\r\n", {
                        name: name
                    }, true);
                    else {
                        output = [];
                        for(var i = 0; i < sources[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; i++){
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(map, function(field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else if (!value[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]) output[field] = "invalid field: toString() is not defined.";
                            else output[field] = value[0, $07716e087fcf5bbc$export$e2818d11505fa034 /* @min:%2etoString */ ]();
                        } else if (expectedType === "number") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else {
                                var num = parseFloat(value);
                                output[field] = num;
                            }
                        } else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 1 /* eLoggingSeverity.CRITICAL */ , output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
    // Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn = 1;
    return Serializer;
}();


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

/*
 * Application Insights JavaScript SDK - Channel, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var $861a98abcb781c4a$var$MIN_INPUT_LENGTH = 8;
var $861a98abcb781c4a$export$e2bdf7ff70742e42 = /** @class */ function() {
    function HashCodeScoreGenerator() {}
    HashCodeScoreGenerator.prototype.getHashCodeScore = function(key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function(input) {
        if (input === "") return 0;
        while(input[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] < $861a98abcb781c4a$var$MIN_INPUT_LENGTH)input = input[0, $07716e087fcf5bbc$export$706142eb912dc2a /* @min:%2econcat */ ](input);
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for(var i = 0; i < input[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; ++i){
            hash = (hash << 5) + hash + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}();


var $ef3ed600da8dd282$export$4526db980ad5b8a1 = /** @class */ function() {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new (0, $861a98abcb781c4a$export$e2bdf7ff70742e42)();
        var keys = new (0, $24e80801a3d6c8ab$export$8e2bcdf18620784a)();
        _self.getSamplingScore = function(item) {
            var score = 0;
            if (item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.userId]) score = hashCodeGenerator.getHashCodeScore(item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.userId]);
            else if (item.ext && item.ext.user && item.ext.user.id) score = hashCodeGenerator[0, $07716e087fcf5bbc$export$d676f8c50f371355 /* @min:%2egetHashCodeScore */ ](item.ext.user.id);
            else if (item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.operationId]) score = hashCodeGenerator.getHashCodeScore(item[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][keys.operationId]);
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]) score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[0, $07716e087fcf5bbc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ]);
            else // tslint:disable-next-line:insecure-random
            score = Math.random() * 100;
            return score;
        };
    }
    return SamplingScoreGenerator;
}();


var $be1c115b9b440698$export$21a3eccb8a1780eb = /** @class */ function() {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || (0, $bacca83328a730a7$export$5102d32ea1d740a)(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */ , 58 /* _eInternalMessageId.SampleRateOutOfRange */ , "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", {
                samplingRate: sampleRate
            }, true);
            sampleRate = 100;
        }
        this[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ] = sampleRate;
        this.samplingScoreGenerator = new (0, $ef3ed600da8dd282$export$4526db980ad5b8a1)();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */ Sample.prototype.isSampledIn = function(envelope) {
        var samplingPercentage = this[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) return true;
        else if (envelope.baseType === (0, $5db807982a2eef93$export$efdd3e096bc27746)[0, $07716e087fcf5bbc$export$9e16762ab4f2648 /* @min:%2edataType */ ]) // exclude MetricData telemetry from sampling
        return true;
        isSampledIn = this.samplingScoreGenerator.getSamplingScore(envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}();



var $7f068950e30577d3$var$_a, $7f068950e30577d3$var$_b;
var $7f068950e30577d3$var$UNDEFINED_VALUE = undefined;
var $7f068950e30577d3$var$EMPTY_STR = "";
var $7f068950e30577d3$var$FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function $7f068950e30577d3$var$_getResponseText(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function $7f068950e30577d3$var$isOverrideFn(httpXHROverride) {
    return httpXHROverride && httpXHROverride.sendPOST;
}
var $7f068950e30577d3$var$defaultAppInsightsChannelConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($7f068950e30577d3$var$_a = {
    // Use the default value (handles empty string in the configuration)
    endpointUrl: (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)((0, $5831ddb3a0caf7c7$export$8f9cae6546f97a9f), (0, $8ac3b4fe9182f568$export$5c9ec0fce655ebcf) + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728))
}, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$b18aabdfc0aaf6b /* @min:emitLineDelimitedJson */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a.maxBatchInterval = 15000, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$803d432e48ba5ceb /* @min:maxBatchSizeInBytes */ ] = 102400, $7f068950e30577d3$var$_a.disableTelemetry = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$c9210d86ca1dd637 /* @min:enableSessionStorageBuffer */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(true), $7f068950e30577d3$var$_a.isRetryDisabled = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$f5629284a6f7ec3d /* @min:isBeaconApiDisabled */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(true), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$78c7449d94867b7f /* @min:disableSendBeaconSplit */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(true), $7f068950e30577d3$var$_a.disableXhr = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$fa88a131053c3501 /* @min:onunloadDisableFetch */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$6b8e1dc9b77f253c /* @min:onunloadDisableBeacon */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:instrumentationKey */ ] = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.namePrefix = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.samplingPercentage = (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)($7f068950e30577d3$var$_chkSampling, 100), $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$dbe59923e879fdc5 /* @min:customHeaders */ ] = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.convertUndefined = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.eventsLimitInMem = 10000, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$4637bcb72c509e60 /* @min:bufferOverride */ ] = false, $7f068950e30577d3$var$_a.httpXHROverride = {
    isVal: $7f068950e30577d3$var$isOverrideFn,
    v: $7f068950e30577d3$var$UNDEFINED_VALUE
}, $7f068950e30577d3$var$_a[0, $07716e087fcf5bbc$export$87044a2824fddfb0 /* @min:alwaysUseXhrOverride */ ] = (0, $3b63eef6ee7529a9$export$bad0d7bace730ae)(), $7f068950e30577d3$var$_a.transports = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.retryCodes = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.corsPolicy = $7f068950e30577d3$var$UNDEFINED_VALUE, $7f068950e30577d3$var$_a.maxRetryCnt = {
    isVal: (0, $5831ddb3a0caf7c7$export$7e4aa119212bc614),
    v: 10
}, $7f068950e30577d3$var$_a));
var $7f068950e30577d3$var$CrossOriginResourcePolicyHeader = "X-Set-Cross-Origin-Resource-Policy";
function $7f068950e30577d3$var$_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var $7f068950e30577d3$var$EnvelopeTypeCreator = ($7f068950e30577d3$var$_b = {}, $7f068950e30577d3$var$_b[(0, $62713924cc3cd966$export$d61e24a684f9e51).dataType] = (0, $53141cdecfc05483$export$b74153364c2066d1), $7f068950e30577d3$var$_b[(0, $adb0678ebd5d1780$export$78e1bea9036f120f).dataType] = (0, $53141cdecfc05483$export$bc9e843f2eb8a61c), $7f068950e30577d3$var$_b[(0, $3e77672805d15946$export$12c0fdede1c6bc6c).dataType] = (0, $53141cdecfc05483$export$edbb8a2c6529947a), $7f068950e30577d3$var$_b[(0, $03ee94b6fff0696e$export$709aae57ec681346).dataType] = (0, $53141cdecfc05483$export$bb801863268e7049), $7f068950e30577d3$var$_b[(0, $a35c931c4df783c8$export$e2f174de097e0bcd).dataType] = (0, $53141cdecfc05483$export$eca78b65eeb356ed), $7f068950e30577d3$var$_b[(0, $5db807982a2eef93$export$efdd3e096bc27746).dataType] = (0, $53141cdecfc05483$export$bb5bee4039a2e495), $7f068950e30577d3$var$_b[(0, $97ca5e424f1910ef$export$a7b48490930dbffa).dataType] = (0, $53141cdecfc05483$export$74e603a08a7deabe), $7f068950e30577d3$var$_b);
var $7f068950e30577d3$export$c5a96f3e01fb6582 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = (0, $5343a490b8ca01c7$export$a714a094d3058c99);
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _beaconOnUnloadSupported;
        var _beaconNormalSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        var _alwaysUseCustomSend;
        var _disableXhr;
        var _fetchKeepAlive;
        var _xhrSend;
        var _fallbackSend;
        var _disableBeaconSplit;
        var _sendPostMgr;
        var _retryCodes;
        var _zipPayload;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(Sender, _this, function(_self, _base) {
            _initDefaults();
            _self.pause = function() {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function() {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function(isAsync, callBack, sendReason) {
                if (isAsync === void 0) isAsync = true;
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        var result_1 = _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */ );
                        // Handles non-promise and always called if the returned promise resolves or rejects
                        return (0, $4121df0a705d038e$export$856fe465480fa77a)(result_1, function(rsp) {
                            if (callBack) {
                                callBack(!rsp.rejected);
                                return true;
                            }
                            // When async=true and no callback, return a promise
                            if (isAsync) return (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                                resolve(!rsp.rejected);
                            });
                            return result_1;
                        });
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 22 /* _eInternalMessageId.FlushFailed */ , "flush failed, telemetry will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                        });
                    }
                }
            };
            _self.onunloadFlush = function() {
                if (!_paused) {
                    if (_beaconSupported || _alwaysUseCustomSend) try {
                        return _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, _doUnloadSend, 2 /* SendRequestReason.Unload */ );
                    } catch (e) {
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "failed to flush with beacon sender on page unload, telemetry will not be collected: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                        });
                    }
                    else _self.flush(false);
                }
            };
            _self.addHeader = function(name, value) {
                _headers[name] = value;
            };
            _self[0, $07716e087fcf5bbc$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _base[0, $07716e087fcf5bbc$export$65cd33bb52d04675 /* @min:%2einitialize */ ](config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new (0, $ffeedac495e2c7a7$export$ef852775387a0be7)(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = (0, $f77eaff1f963d24b$export$798b7fe42d5e3d06)(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                    var config = details.cfg;
                    if (config.storagePrefix) (0, $3fab9bbcce274f86$export$a08dccf4adbf6df9)(config.storagePrefix);
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    // getExtCfg only finds undefined values from core
                    var senderConfig = ctx.getExtCfg(identifier, $7f068950e30577d3$var$defaultAppInsightsChannelConfig);
                    var curExtUrl = senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                    // if it is not inital change (_endpointUrl has value)
                    // if current sender endpoint url is not changed directly
                    // means ExtCfg is not changed directly
                    // then we need to monitor endpoint url changes from core
                    if (_endpointUrl && curExtUrl === _endpointUrl) {
                        var coreUrl = config[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                        // if core endpoint url is changed
                        if (coreUrl && coreUrl !== curExtUrl) // and endpoint promise changes is handled by this as well
                        senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ] = coreUrl;
                    }
                    var csStream = (0, $5831ddb3a0caf7c7$export$3df6e51375017edd)("CompressionStream");
                    // Determine whether to enable payload compression (zipping).
                    _zipPayload = (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)("zipPayload", config, false);
                    if (!(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(csStream)) _zipPayload = false;
                    var corsPolicy = senderConfig.corsPolicy;
                    if (corsPolicy) {
                        if (corsPolicy === "same-origin" || corsPolicy === "same-site" || corsPolicy === "cross-origin") _this.addHeader($7f068950e30577d3$var$CrossOriginResourcePolicyHeader, corsPolicy);
                    } else delete _headers[$7f068950e30577d3$var$CrossOriginResourcePolicyHeader];
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(senderConfig[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ])) // if it is promise, means the endpoint url is from core.endpointurl
                    senderConfig[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = config[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_senderConfig", {
                        g: function() {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ]) {
                        _orgEndpointUrl;
                        _endpointUrl = _orgEndpointUrl = senderConfig[0, $07716e087fcf5bbc$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                    }
                    // or is not string
                    if (core.activeStatus() === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).PENDING) // waiting for core promises to be resolved
                    // NOTE: if active status is set to pending, stop sending, clear timer here
                    _self.pause();
                    else if (core.activeStatus() === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE) // core status changed from pending to other status
                    _self.resume();
                    if (_customHeaders && _customHeaders !== senderConfig[0, $07716e087fcf5bbc$export$dbe59923e879fdc5 /* @min:%2ecustomHeaders */ ]) // Removing any previously defined custom headers as they have changed
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_customHeaders, function(customHeader) {
                        delete _headers[customHeader.header];
                    });
                    _maxBatchSizeInBytes = senderConfig[0, $07716e087fcf5bbc$export$803d432e48ba5ceb /* @min:%2emaxBatchSizeInBytes */ ];
                    _beaconSupported = (senderConfig[0, $07716e087fcf5bbc$export$6b8e1dc9b77f253c /* @min:%2eonunloadDisableBeacon */ ] === false || senderConfig[0, $07716e087fcf5bbc$export$f5629284a6f7ec3d /* @min:%2eisBeaconApiDisabled */ ] === false) && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)();
                    _beaconOnUnloadSupported = senderConfig[0, $07716e087fcf5bbc$export$6b8e1dc9b77f253c /* @min:%2eonunloadDisableBeacon */ ] === false && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)();
                    _beaconNormalSupported = senderConfig[0, $07716e087fcf5bbc$export$f5629284a6f7ec3d /* @min:%2eisBeaconApiDisabled */ ] === false && (0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)();
                    _alwaysUseCustomSend = senderConfig[0, $07716e087fcf5bbc$export$87044a2824fddfb0 /* @min:%2ealwaysUseXhrOverride */ ];
                    _disableXhr = !!senderConfig.disableXhr;
                    _retryCodes = senderConfig.retryCodes;
                    var bufferOverride = senderConfig[0, $07716e087fcf5bbc$export$4637bcb72c509e60 /* @min:%2ebufferOverride */ ];
                    var canUseSessionStorage = !!senderConfig[0, $07716e087fcf5bbc$export$c9210d86ca1dd637 /* @min:%2eenableSessionStorageBuffer */ ] && (!!bufferOverride || (0, $3fab9bbcce274f86$export$c81985c4209bac26)());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = canUseSessionStorage !== _sessionStorageUsed || canUseSessionStorage && _namePrefix !== namePrefix // prefixName is only used in session storage
                     || canUseSessionStorage && _bufferOverrideUsed !== bufferOverride;
                    if (_self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) try {
                            _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ].createNew(diagLog, senderConfig, canUseSessionStorage);
                        } catch (e) {
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                            });
                        }
                        _checkMaxSize();
                    } else _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = canUseSessionStorage ? new (0, $1fa48c075af358bb$export$dcb776947c16915f)(diagLog, senderConfig) : new (0, $1fa48c075af358bb$export$d706e5fd60d36d56)(diagLog, senderConfig);
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _fetchKeepAlive = !senderConfig[0, $07716e087fcf5bbc$export$fa88a131053c3501 /* @min:%2eonunloadDisableFetch */ ] && (0, $0d2c2fb24388dcf8$export$f8c1c61350d9749)(true);
                    _disableBeaconSplit = !!senderConfig[0, $07716e087fcf5bbc$export$78c7449d94867b7f /* @min:%2edisableSendBeaconSplit */ ];
                    _self._sample = new (0, $be1c115b9b440698$export$21a3eccb8a1780eb)(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[0, $07716e087fcf5bbc$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                    if (!(0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(_instrumentationKey) && !_validateInstrumentationKey(_instrumentationKey, config)) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , "Invalid Instrumentation key " + _instrumentationKey);
                    _customHeaders = senderConfig[0, $07716e087fcf5bbc$export$dbe59923e879fdc5 /* @min:%2ecustomHeaders */ ];
                    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(_endpointUrl) && !(0, $d98f9809e5d6a7c7$export$edade5317663baa4)(_endpointUrl) && _customHeaders && _customHeaders[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_customHeaders, function(customHeader) {
                        _this.addHeader(customHeader.header, customHeader.value);
                    });
                    else _customHeaders = null;
                    _enableSendPromise = senderConfig.enableSendPromise;
                    var sendPostConfig = _getSendPostMgrConfig();
                    // only init it once
                    if (!_sendPostMgr) {
                        _sendPostMgr = new (0, $7928109a8e3dfbfa$export$e3388bef22319dfd)();
                        _sendPostMgr[0, $07716e087fcf5bbc$export$65cd33bb52d04675 /* @min:%2einitialize */ ](sendPostConfig, diagLog);
                    } else _sendPostMgr.SetConfig(sendPostConfig);
                    var customInterface = senderConfig.httpXHROverride;
                    var httpInterface = null;
                    var syncInterface = null;
                    // User requested transport(s) values > Beacon > Fetch > XHR
                    // Beacon would be filtered out if user has set disableBeaconApi to true at _getSenderInterface
                    var theTransports = (0, $ede407819d2d28c9$export$d435c252bc2524f)([
                        3 /* TransportType.Beacon */ ,
                        1 /* TransportType.Xhr */ ,
                        2 /* TransportType.Fetch */ 
                    ], senderConfig.transports);
                    httpInterface = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ](theTransports, false);
                    var xhrInterface = _sendPostMgr && _sendPostMgr.getFallbackInst();
                    _xhrSend = function(payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync);
                    };
                    _fallbackSend = function(payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync, false);
                    };
                    httpInterface = _alwaysUseCustomSend ? customInterface : httpInterface || customInterface || xhrInterface;
                    _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = function(payload, isAsync) {
                        return _doSend(httpInterface, payload, isAsync);
                    };
                    if (_fetchKeepAlive) // Try and use the fetch with keepalive
                    _syncUnloadSender = _fetchKeepAliveSender;
                    var syncTransports = (0, $ede407819d2d28c9$export$d435c252bc2524f)([
                        3 /* TransportType.Beacon */ ,
                        1 /* TransportType.Xhr */ 
                    ], senderConfig.unloadTransports);
                    if (!_fetchKeepAlive) // remove fetch from theTransports
                    syncTransports = syncTransports.filter(function(transport) {
                        return transport !== 2 /* TransportType.Fetch */ ;
                    });
                    syncInterface = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ](syncTransports, true);
                    syncInterface = _alwaysUseCustomSend ? customInterface : syncInterface || customInterface;
                    if ((_alwaysUseCustomSend || senderConfig.unloadTransports || !_syncUnloadSender) && syncInterface) _syncUnloadSender = function(payload, isAsync) {
                        return _doSend(syncInterface, payload, isAsync);
                    };
                    if (!_syncUnloadSender) _syncUnloadSender = _xhrSend;
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig.convertUndefined || $7f068950e30577d3$var$UNDEFINED_VALUE;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig.maxBatchInterval;
                }));
            };
            _self.processTelemetry = function(telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                try {
                    var isValidate = _validate(telemetryItem, diagLogger);
                    if (!isValidate) return;
                    var aiEnvelope = _getEnvelope(telemetryItem, diagLogger);
                    if (!aiEnvelope) return;
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                    _checkMaxSize(payload);
                    var payloadItem = {
                        item: payload,
                        cnt: 0 // inital cnt will always be 0
                    };
                    // enqueue the payload
                    buffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](payloadItem);
                    // ensure an invocation timeout is set
                    _setupTimer();
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            _self.isCompletelyIdle = function() {
                return !_paused && _syncFetchPayload === 0 && _self._buffer[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() === 0;
            };
            _self.getOfflineListener = function() {
                return _offlineListener;
            };
            /**
             * xhr state changes
             */ _self._xhrReadyStateChange = function(xhr, payload, countOfItemsInPayload) {
                // since version 3.2.0, this function is no-op
                if (_isStringArr(payload)) return;
                return _xhrReadyStateChange(xhr, payload, countOfItemsInPayload);
            };
            /**
             * Immediately send buffered data
             * @param isAsync - Indicates if the events should be sent asynchronously
             * @param forcedSender - Indicates the forcedSender, undefined if not passed
             */ _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ] = function(isAsync, forcedSender, sendReason) {
                if (isAsync === void 0) isAsync = true;
                var result;
                if (!_paused) try {
                    var buffer = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                    // Send data only if disableTelemetry is false
                    if (!_disableTelemetry) {
                        if (buffer[0, $07716e087fcf5bbc$export$e9679ef501b0d1 /* @min:%2ecount */ ]() > 0) {
                            var payload = buffer.getItems();
                            _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */ , isAsync);
                            // invoke send
                            if (forcedSender) result = forcedSender.call(_self, payload, isAsync);
                            else result = _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ](payload, isAsync);
                        }
                        // update lastSend time to enable throttling
                        _lastSend = +new Date;
                    } else buffer[0, $07716e087fcf5bbc$export$5eeb73fac03da74a /* @min:%2eclear */ ]();
                    _clearScheduledTimer();
                } catch (e) {
                    /* Ignore this error for IE under v10 */ var ieVer = (0, $0d2c2fb24388dcf8$export$eb7ff627fa81c42e)();
                    if (!ieVer || ieVer > 9) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Telemetry transmission failed, some telemetry will be lost: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                // potential place to call countException q3
                }
                return result;
            };
            _self.getOfflineSupport = function() {
                return {
                    getUrl: function() {
                        return _endpointUrl;
                    },
                    createPayload: _createPayload,
                    serialize: _serialize,
                    batch: _batch,
                    shouldProcess: function(evt) {
                        return !!_validate(evt);
                    }
                };
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _self.onunloadFlush();
                (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */ _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ] = function(payload, message, event) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _onError(payload, message, event);
            };
            /**
             * partial success handler
             */ _self[0, $07716e087fcf5bbc$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ] = function(payload, results) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _onPartialSuccess(payload, results);
            };
            /**
             * success handler
             */ _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ] = function(payload, countOfItemsInPayload) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _onSuccess(payload, countOfItemsInPayload);
            //_self._buffer && _self._buffer.clearSent(payload);
            };
            /**
             * xdr state changes
             */ _self._xdrOnLoad = function(xdr, payload) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) return;
                return _xdrOnLoad(xdr, payload);
            };
            // function _getStatsBeat() {
            //     let statsBeatConfig: IStatsBeatState = {
            //         cKey: _self._senderConfig.instrumentationKey,
            //         endpoint: _endpointUrl,
            //         sdkVer: EnvelopeCreator.Version,
            //         type: eStatsType.SDK
            //     };
            //     let core = _self.core;
            //     // During page unload the core may have been cleared and some async events may not have been sent yet
            //     // resulting in the core being null. In this case we don't want to create a statsbeat instance
            //     return core ? core.getStatsBeat(statsBeatConfig) : null;
            // }
            function _xdrOnLoad(xdr, payload) {
                var responseText = $7f068950e30577d3$var$_getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, 0);
                } else {
                    var results = (0, $248db41a83147c13$export$ba14d9a5a581e827)(responseText);
                    if (results && results[0, $07716e087fcf5bbc$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] && results[0, $07716e087fcf5bbc$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] > results[0, $07716e087fcf5bbc$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ] && !_isRetryDisabled) _self[0, $07716e087fcf5bbc$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ](payload, results);
                    else _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, (0, $ede407819d2d28c9$export$404d535171315d86)(xdr));
                }
            }
            function _getSendPostMgrConfig() {
                try {
                    var onCompleteFuncs = {
                        xdrOnComplete: function(xdr, oncomplete, payload) {
                            var payloadArr = _getPayloadArr(payload);
                            if (!payloadArr) return;
                            //const responseText = _getResponseText(xdr);
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat) {
                            //     if (xdr && (responseText + "" === "200" || responseText === "")) {
                            //         _consecutiveErrors = 0;
                            //         statsbeat.count(200, payload, _endpointUrl);
                            //     } else {
                            //         const results = parseResponse(responseText);
                            //         if (results && results.itemsReceived && results.itemsReceived > results.itemsAccepted
                            //             && !_isRetryDisabled) {
                            //             statsbeat.count(206, payload, _endpointUrl);
                            //         } else {
                            //             statsbeat.count(499, payload, _endpointUrl);
                            //         }
                            //     }
                            // }
                            return _xdrOnLoad(xdr, payloadArr);
                        },
                        fetchOnComplete: function(response, onComplete, resValue, payload) {
                            var payloadArr = _getPayloadArr(payload);
                            if (!payloadArr) return;
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat) {
                            //     statsbeat.count(response.status, payload, _endpointUrl);
                            // }
                            return _checkResponsStatus(response.status, payloadArr, response.url, payloadArr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ], response.statusText, resValue || "");
                        },
                        xhrOnComplete: function(request, oncomplete, payload) {
                            var payloadArr = _getPayloadArr(payload);
                            if (!payloadArr) return;
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat && request.readyState === 4) {
                            //     statsbeat.count(request.status, payload, _endpointUrl);
                            // }
                            return _xhrReadyStateChange(request, payloadArr, payloadArr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                        },
                        beaconOnRetry: function(data, onComplete, canSend) {
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat) {
                            //     statsbeat.count(499, data, _endpointUrl);
                            // }
                            return _onBeaconRetry(data, onComplete, canSend);
                        }
                    };
                    var config = {
                        enableSendPromise: _enableSendPromise,
                        isOneDs: false,
                        disableCredentials: false,
                        disableXhr: _disableXhr,
                        disableBeacon: !_beaconNormalSupported,
                        disableBeaconSync: !_beaconOnUnloadSupported,
                        senderOnCompleteCallBack: onCompleteFuncs
                    };
                    return config;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return null;
            }
            /**
             * xhr state changes
             */ function _xhrReadyStateChange(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, (0, $ede407819d2d28c9$export$f826fdf8bca00592)(xhr), $7f068950e30577d3$var$_getResponseText(xhr) || xhr.response);
            }
            /**
             * error handler
             */ function _onError(payload, message, event) {
                (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _self._buffer && _self._buffer[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
            }
            /**
             * partial success handler
             */ function _onPartialSuccess(payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) retry[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](extracted);
                    else // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                    failed[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](extracted);
                }
                if (payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, results[0, $07716e087fcf5bbc$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ]);
                if (failed[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](failed, (0, $ede407819d2d28c9$export$f826fdf8bca00592)(null, [
                    "partial success",
                    results[0, $07716e087fcf5bbc$export$fb8523c8667e286a /* @min:%2eitemsAccepted */ ],
                    "of",
                    results.itemsReceived
                ].join(" ")));
                if (retry[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    _resendPayload(retry);
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Partial success. Delivered: " + payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + ", Failed: " + failed[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + ". Will retry to send " + retry[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + " our of " + results[0, $07716e087fcf5bbc$export$746df81af2cb9d94 /* @min:%2eitemsReceived */ ] + " items");
                }
            }
            /**
             * success handler
             */ function _onSuccess(payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
            }
            function _getPayloadArr(payload) {
                try {
                    if (payload) {
                        var internalPayload = payload;
                        var arr = internalPayload.oriPayload;
                        if (arr && arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]) return arr;
                        return null;
                    }
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _validate(telemetryItem, diagLogger) {
                if (_disableTelemetry) // Do not send/save data
                return false;
                // validate input
                if (!telemetryItem) {
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */ , "Cannot send empty telemetry");
                    return false;
                }
                // validate event
                if (telemetryItem.baseData && !telemetryItem[0, $07716e087fcf5bbc$export$aa558e99f83347cf /* @min:%2ebaseType */ ]) {
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 70 /* _eInternalMessageId.InvalidEvent */ , "Cannot send telemetry without baseData and baseType");
                    return false;
                }
                if (!telemetryItem[0, $07716e087fcf5bbc$export$aa558e99f83347cf /* @min:%2ebaseType */ ]) // Default
                telemetryItem[0, $07716e087fcf5bbc$export$aa558e99f83347cf /* @min:%2ebaseType */ ] = "EventData";
                // ensure a sender was constructed
                if (!_self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ]) {
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender was not initialized");
                    return false;
                }
                // check if this item should be sampled in, else add sampleRate tag
                if (!_isSampledIn(telemetryItem)) {
                    // Item is sampled out, do not send it
                    diagLogger && (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */ , "Telemetry item was sampled out and not sent", {
                        SampleRate: _self._sample[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ]
                    });
                    return false;
                } else telemetryItem[0, $8ac3b4fe9182f568$export$dc288b6444e20c04] = _self._sample[0, $07716e087fcf5bbc$export$c2afe23fa18f9dff /* @min:%2esampleRate */ ];
                return true;
            }
            function _getEnvelope(telemetryItem, diagLogger) {
                // construct an envelope that Application Insights endpoint can understand
                // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                var aiEnvelope = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                if (!aiEnvelope) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 47 /* _eInternalMessageId.CreateEnvelopeError */ , "Unable to create an AppInsights envelope");
                    return;
                }
                var doNotSendItem = false;
                // this is for running in legacy mode, where customer may already have a custom initializer present
                if (telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ] && telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $8ac3b4fe9182f568$export$ea8a69bf327def66]) {
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $8ac3b4fe9182f568$export$ea8a69bf327def66], function(callBack) {
                        try {
                            if (callBack && callBack(aiEnvelope) === false) {
                                doNotSendItem = true;
                                (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(diagLogger, "Telemetry processor check returns false");
                            }
                        } catch (e) {
                            // log error but dont stop executing rest of the telemetry initializers
                            // doNotSendItem = true;
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                            }, true);
                        }
                    });
                    delete telemetryItem[0, $07716e087fcf5bbc$export$d0f526aa8043f6d7 /* @min:%2etags */ ][0, $8ac3b4fe9182f568$export$ea8a69bf327def66];
                }
                if (doNotSendItem) return; // do not send, no need to execute next plugin
                return aiEnvelope;
            }
            function _serialize(item) {
                var rlt = $7f068950e30577d3$var$EMPTY_STR;
                var diagLogger = _self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]();
                try {
                    var valid = _validate(item, diagLogger);
                    var envelope = null;
                    if (valid) envelope = _getEnvelope(item, diagLogger);
                    if (envelope) rlt = _serializer.serialize(envelope);
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return rlt;
            }
            function _batch(arr) {
                var rlt = $7f068950e30577d3$var$EMPTY_STR;
                if (arr && arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]) rlt = "[" + arr.join(",") + "]";
                return rlt;
            }
            function _createPayload(data) {
                var headers = _getHeaders();
                return {
                    urlString: _endpointUrl,
                    data: data,
                    headers: headers
                };
            }
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _getOnComplete(payload, status, headers, response) {
                // ***********************************************************************************************
                //TODO: handle other status codes
                if (status === 200 && payload) _self._onSuccess(payload, payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                else response && _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, response);
            }
            function _doSend(sendInterface, payload, isAsync, markAsSent) {
                if (markAsSent === void 0) markAsSent = true;
                var onComplete = function(status, headers, response) {
                    // let statsbeat = _getStatsBeat();
                    // if (statsbeat) {
                    //     statsbeat.count(status, payloadData, _endpointUrl);
                    // }
                    return _getOnComplete(payload, status, headers, response);
                };
                var payloadData = _getPayload(payload);
                // if (payloadData) {
                //     payloadData.statsBeatData = {startTime: dateNow()};
                // }
                var sendPostFunc = sendInterface && sendInterface.sendPOST;
                if (sendPostFunc && payloadData) {
                    // ***********************************************************************************************
                    // mark payload as sent at the beginning of calling each send function
                    if (markAsSent) _self._buffer[0, $07716e087fcf5bbc$export$52e50651d87300e3 /* @min:%2emarkAsSent */ ](payload);
                    var result_2;
                    var callbackExecuted_1 = false;
                    var resolveFn_1;
                    var rejectFn_1;
                    _sendPostMgr.preparePayload(function(processedPayload) {
                        result_2 = sendPostFunc(processedPayload, onComplete, !isAsync);
                        callbackExecuted_1 = true;
                        if (resolveFn_1) (0, $4121df0a705d038e$export$96acbd3e4fcaef01)(result_2, resolveFn_1, rejectFn_1);
                    }, _zipPayload, payloadData, !isAsync);
                    if (callbackExecuted_1) return result_2;
                    // Callback was not executed synchronously, so we need to return a promise
                    return (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve, reject) {
                        resolveFn_1 = resolve;
                        rejectFn_1 = reject;
                    });
                }
                return null;
            }
            function _getPayload(payload) {
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(payload) && payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var batch = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ].batchPayloads(payload);
                    var headers = _getHeaders();
                    var payloadData = {
                        data: batch,
                        urlString: _endpointUrl,
                        headers: headers,
                        disableXhrSync: _disableXhr,
                        disableFetchKeepAlive: !_fetchKeepAlive,
                        oriPayload: payload
                    };
                    return payloadData;
                }
                return null;
            }
            function _getHeaders() {
                try {
                    var headers = _headers || {};
                    if ((0, $d98f9809e5d6a7c7$export$edade5317663baa4)(_endpointUrl)) headers[(0, $921552b7fb658c3b$export$e499e02a1fe05177)[6 /* eRequestHeaders.sdkContextHeader */ ]] = (0, $921552b7fb658c3b$export$e499e02a1fe05177)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ];
                    return headers;
                } catch (e) {
                // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] : 0;
                if (_self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ].size() + incomingSize > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener.isOnline()) _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = (0, $248db41a83147c13$export$ba14d9a5a581e827)(res);
                    if (response && response.appId) _self._appId = response.appId;
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                            return;
                        }
                    }
                    if (_offlineListener && !_offlineListener.isOnline()) {
                        // Note: Don't check for status == 0, since adblock gives this code
                        if (!_isRetryDisabled) {
                            var offlineBackOffMultiplier = 10; // arbritrary number
                            _resendPayload(payload, offlineBackOffMultiplier);
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                        }
                        return;
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Response code " + status + ". Will retry to send " + payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] + " items.");
                    } else _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                } else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) response = (0, $248db41a83147c13$export$ba14d9a5a581e827)(res);
                        if (response && !_isRetryDisabled) _self[0, $07716e087fcf5bbc$export$689c49d56ac33585 /* @min:%2e_onPartialSuccess */ ](payload, response);
                        else _self[0, $07716e087fcf5bbc$export$fd0c91d4da43d71b /* @min:%2e_onError */ ](payload, errorMessage);
                    } else {
                        _consecutiveErrors = 0;
                        _self[0, $07716e087fcf5bbc$export$82a109ffee49e423 /* @min:%2e_onSuccess */ ](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                //  _stamp_specific_redirects = 0;
                return false;
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) // We are unloading so always call the sender with sync set to false
                _syncUnloadSender(payload, false);
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    var beaconInst = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ]([
                        3 /* TransportType.Beacon */ 
                    ], true);
                    return _doSend(beaconInst, payload, isAsync);
                }
            }
            function _onBeaconRetry(payload, onComplete, canSend) {
                var internalPayload = payload;
                var data = internalPayload && internalPayload.oriPayload;
                if (!_disableBeaconSplit) {
                    // Failed to send entire payload so try and split data and try to send as much events as possible
                    var droppedPayload = [];
                    for(var lp = 0; lp < data[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++){
                        var thePayload = data[lp];
                        var arr = [
                            thePayload
                        ];
                        var item = _getPayload(arr);
                        if (!canSend(item, onComplete)) // Can't send anymore, so split the batch and drop the rest
                        droppedPayload[0, $07716e087fcf5bbc$export$a0a330e7fa1e278c /* @min:%2epush */ ](thePayload);
                        else _self._onSuccess(arr, arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]);
                    }
                    if (droppedPayload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                        _fallbackSend && _fallbackSend(droppedPayload, true);
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                    }
                } else {
                    _fallbackSend && _fallbackSend(data, true);
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                }
            }
            function _isStringArr(arr) {
                try {
                    if (arr && arr[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]) return (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(arr[0]);
                } catch (e) {
                //TODO: log, sender use IInternalStorageItem instead of string since 3.1.3
                }
                return null;
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                var transport = null;
                if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(payload)) {
                    var payloadSize = payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                    for(var lp = 0; lp < payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ]; lp++)payloadSize += payload[lp].item[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ];
                    var syncFetchPayload = _sendPostMgr.getSyncFetchPayload();
                    if (syncFetchPayload + payloadSize <= $7f068950e30577d3$var$FetchSyncRequestSizeLimitBytes) transport = 2 /* TransportType.Fetch */ ;
                    else if ((0, $0d2c2fb24388dcf8$export$cf496c79c05967a0)()) // Fallback to beacon sender as we at least get told which events can't be scheduled
                    transport = 3 /* TransportType.Beacon */ ;
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        transport = 1 /* TransportType.Xhr */ ;
                        (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                    var inst = _sendPostMgr && _sendPostMgr[0, $07716e087fcf5bbc$export$f8d641d56432a4fc /* @min:%2egetSenderInst */ ]([
                        transport
                    ], true);
                    return _doSend(inst, payload, isAsync);
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */ function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) linearFactor = 1;
                if (!payload || payload[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) return;
                var buffer = _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ];
                buffer[0, $07716e087fcf5bbc$export$13da1b5a005ef035 /* @min:%2eclearSent */ ](payload);
                _consecutiveErrors++;
                for(var _i = 0, payload_1 = payload; _i < payload_1.length; _i++){
                    var item = payload_1[_i];
                    item.cnt = item.cnt || 0; // to make sure we have cnt for each payload
                    item.cnt++; // when resend, increase cnt
                    buffer[0, $07716e087fcf5bbc$export$4aae77f3ba3c48b4 /* @min:%2eenqueue */ ](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */ function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) delayInSeconds = SlotDelayInSeconds;
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = (0, $5831ddb3a0caf7c7$export$c6301bc99a7f80a7)(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = (0, $5831ddb3a0caf7c7$export$2ca8010d037f830f)((0, $5831ddb3a0caf7c7$export$e411eeaf23dccbe8)(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)() + delayInSeconds * 1000;
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */ function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? (0, $5831ddb3a0caf7c7$export$2ca8010d037f830f)(0, _retryAt - (0, $5831ddb3a0caf7c7$export$a56f095995763cca)()) : 0;
                    var timerValue = (0, $5831ddb3a0caf7c7$export$2ca8010d037f830f)(_maxBatchInterval, retryInterval);
                    _timeoutHandle = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                        _timeoutHandle = null;
                        _self[0, $07716e087fcf5bbc$export$df21ab0de9057cc4 /* @min:%2etriggerSend */ ](true, null, 1 /* SendRequestReason.NormalSchedule */ );
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */ function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_retryCodes)) return _retryCodes[0, $07716e087fcf5bbc$export$6eae51590aaea43 /* @min:%2elength */ ] && _retryCodes.indexOf(statusCode) > -1;
                return statusCode === 401 // Unauthorized
                 || statusCode === 408 // Timeout
                 || statusCode === 429 // Too many requests.
                 || statusCode === 500 // Internal server error.
                 || statusCode === 502 // Bad Gateway.
                 || statusCode === 503 // Service unavailable.
                 || statusCode === 504; // Gateway timeout.
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                var result;
                var core = _self.core;
                if (core) {
                    // During page unload the core may have been cleared and some async events may not have been sent yet
                    // resulting in the core being null. In this case we don't want to create a statsbeat instance
                    if (core[func]) result = core[func]();
                    else // using _self.core['_notificationManager'] for backward compatibility
                    result = core["_notificationManager"];
                }
                return result;
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager.eventsSendRequest) try {
                    manager.eventsSendRequest(sendRequest, isAsync);
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self[0, $07716e087fcf5bbc$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 74 /* _eInternalMessageId.NotificationException */ , "send request notification failed: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */ function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) return true;
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[0, $07716e087fcf5bbc$export$e5390b88ba6f1b04 /* @min:%2e_sender */ ] = null;
                _self[0, $07716e087fcf5bbc$export$3f8a6394c5f7e7be /* @min:%2e_buffer */ ] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = $7f068950e30577d3$var$UNDEFINED_VALUE;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = $7f068950e30577d3$var$UNDEFINED_VALUE;
                _disableXhr = false;
                _fetchKeepAlive = false;
                _disableBeaconSplit = false;
                _xhrSend = null;
                _fallbackSend = null;
                _sendPostMgr = null;
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "_senderConfig", {
                    g: function() {
                        return (0, $ede407819d2d28c9$export$a7f7e50f928053df)({}, $7f068950e30577d3$var$defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(iKey)) envelope = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, orig), {
            iKey: iKey
        });
        else envelope = orig;
        var creator = $7f068950e30577d3$var$EnvelopeTypeCreator[envelope.baseType] || (0, $53141cdecfc05483$export$b74153364c2066d1);
        return creator(logger, envelope, convertUndefined);
    };
    // Removed Stub for Sender.prototype.pause.
    // Removed Stub for Sender.prototype.resume.
    // Removed Stub for Sender.prototype.flush.
    // Removed Stub for Sender.prototype.onunloadFlush.
    // Removed Stub for Sender.prototype.initialize.
    // Removed Stub for Sender.prototype.processTelemetry.
    // Removed Stub for Sender.prototype._xhrReadyStateChange.
    // Removed Stub for Sender.prototype.triggerSend.
    // Removed Stub for Sender.prototype._onError.
    // Removed Stub for Sender.prototype._onPartialSuccess.
    // Removed Stub for Sender.prototype._onSuccess.
    // Removed Stub for Sender.prototype._xdrOnLoad.
    // Removed Stub for Sender.prototype.addHeader.
    // Removed Stub for Sender.prototype.isCompletelyIdle.
    // Removed Stub for Sender.prototype.getOfflineSupport.
    // Removed Stub for Sender.prototype.getOfflineListener.
    return Sender;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));



/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 














/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 





var $0dd57305094095f6$var$defaultValues = {
    perfEvtsSendAll: false
};
function $0dd57305094095f6$var$_runScheduledListeners(asyncNotifications) {
    asyncNotifications.h = null;
    var callbacks = asyncNotifications.cb;
    asyncNotifications.cb = [];
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(callbacks, function(cb) {
        // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
        (0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)(cb.fn, [
            cb.arg
        ]);
    });
}
// This function is used to combine the logic of running the listeners and handling the async notifications so that they don't
// create multiple timers if there are multiple async listeners.
function $0dd57305094095f6$var$_runListeners(listeners, name, asyncNotifications, callback) {
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listeners, function(listener) {
        if (listener && listener[name]) {
            if (asyncNotifications) {
                // Schedule the callback to be called after the current call stack has cleared.
                asyncNotifications.cb[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ]({
                    fn: callback,
                    arg: listener
                });
                asyncNotifications.h = asyncNotifications.h || (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)($0dd57305094095f6$var$_runScheduledListeners, 0, asyncNotifications);
            } else // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
            (0, $5831ddb3a0caf7c7$export$170b8c323eee7bec)(callback, [
                listener
            ]);
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */ var $0dd57305094095f6$export$dfa1f14b6290f8c5 = /** @class */ function() {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var _asyncNotifications = {
            h: null,
            cb: []
        };
        var cfgHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $0dd57305094095f6$var$defaultValues);
        unloadHandler = cfgHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(NotificationManager, this, function(_self) {
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "listeners", {
                g: function() {
                    return _listeners;
                }
            });
            _self[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _listeners[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */ _self[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                var index = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(_listeners, listener);
                while(index > -1){
                    _listeners[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](index, 1);
                    index = (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */ _self[0, $aa96917b132802ee$export$bb3c4bc1b1175d3d /* @min:%2eeventsSent */ ] = function(events) {
                $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$bb3c4bc1b1175d3d), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$bb3c4bc1b1175d3d /* @min:%2eeventsSent */ ](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */ _self[0, $aa96917b132802ee$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ] = function(events, reason) {
                $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$bacb5b2f4c1081b9), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */ _self[0, $aa96917b132802ee$export$d75e063cb88a1c25 /* @min:%2eeventsSendRequest */ ] = function(sendReason, isAsync) {
                $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$d75e063cb88a1c25), isAsync ? _asyncNotifications : null, function(listener) {
                    listener[0, $aa96917b132802ee$export$d75e063cb88a1c25 /* @min:%2eeventsSendRequest */ ](sendReason, isAsync);
                });
            };
            _self[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ] = function(perfEvent) {
                if (perfEvent) // Send all events or only parent events
                {
                    if (perfEvtsSendAll || !perfEvent[0, $45806013ed348c93$export$3a89026537e5dfec /* @min:%2eisChildEvt */ ]()) $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$5d265841733c97c3), null, function(listener) {
                        if (perfEvent.isAsync) (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                            return listener[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                        }, 0);
                        else listener[0, $aa96917b132802ee$export$5d265841733c97c3 /* @min:%2eperfEvent */ ](perfEvent);
                    });
                }
            };
            _self[0, $aa96917b132802ee$export$43f876a058c28ba5 /* @min:%2eofflineEventsStored */ ] = function(events) {
                if (events && events[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$43f876a058c28ba5), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$43f876a058c28ba5 /* @min:%2eofflineEventsStored */ ](events);
                });
            };
            _self[0, $aa96917b132802ee$export$ae269b8bbb49e700 /* @min:%2eofflineBatchSent */ ] = function(batch) {
                if (batch && batch[0, $45806013ed348c93$export$2f5ff0b46814907e /* @min:%2edata */ ]) $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$ae269b8bbb49e700), _asyncNotifications, function(listener) {
                    listener[0, $aa96917b132802ee$export$ae269b8bbb49e700 /* @min:%2eofflineBatchSent */ ](batch);
                });
            };
            _self[0, $aa96917b132802ee$export$38d218365ccbd2ec /* @min:%2eofflineBatchDrop */ ] = function(cnt, reason) {
                if (cnt > 0) {
                    var rn_1 = reason || 0; // default is unknown
                    $0dd57305094095f6$var$_runListeners(_listeners, (0, $aa96917b132802ee$export$38d218365ccbd2ec), _asyncNotifications, function(listener) {
                        listener[0, $aa96917b132802ee$export$38d218365ccbd2ec /* @min:%2eofflineBatchDrop */ ](cnt, rn_1);
                    });
                }
            };
            _self[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync) {
                var _finishUnload = function() {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                    // Clear any async listener
                    _asyncNotifications.h && _asyncNotifications.h[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                    _asyncNotifications.h = null;
                    _asyncNotifications.cb = [];
                };
                var waiting;
                $0dd57305094095f6$var$_runListeners(_listeners, "unload", null, function(listener) {
                    var asyncUnload = listener[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ](isAsync);
                    if (asyncUnload) {
                        if (!waiting) waiting = [];
                        waiting[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](asyncUnload);
                    }
                });
                if (waiting) return (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                    return (0, $4121df0a705d038e$export$856fe465480fa77a)((0, $4121df0a705d038e$export$1ed2fd8fe9f5c6)(waiting), function() {
                        _finishUnload();
                        resolve();
                    });
                });
                else _finishUnload();
            };
        });
    }
    // Removed Stub for NotificationManager.prototype.addNotificationListener.
    // Removed Stub for NotificationManager.prototype.removeNotificationListener.
    // Removed Stub for NotificationManager.prototype.eventsSent.
    // Removed Stub for NotificationManager.prototype.eventsDiscarded.
    // Removed Stub for NotificationManager.prototype.eventsSendRequest.
    // Removed Stub for NotificationManager.prototype.perfEvent.
    // Removed Stub for NotificationManager.prototype.unload.
    // Removed Stub for NotificationManager.prototype.offlineEventsStored.
    // Removed Stub for NotificationManager.prototype.offlineBatchSent.
    // Removed Stub for NotificationManager.prototype.offlineBatchDrop.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn = 1;
    return NotificationManager;
}();





/*
 * Application Insights JavaScript SDK - Core, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 
// 








function $7b82afd5e1b31923$var$_addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(_initializers, theInitializer);
    var handler = {
        remove: function() {
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_initializers, function(initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function $7b82afd5e1b31923$var$_runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
    for(var i = 0; i < telemetryInitializersCount; ++i){
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) try {
            if (telemetryInitializer.fn[0, $45806013ed348c93$export$2f85ca6962b15ff8 /* @min:%2eapply */ ](null, [
                item
            ]) === false) {
                doNotSendItem = true;
                break;
            }
        } catch (e) {
            // log error but dont stop executing rest of the telemetry initializers
            // doNotSendItem = true;
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Telemetry initializer failed: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
            }, true);
        }
    }
    return !doNotSendItem;
}
var $7b82afd5e1b31923$export$5da7f32cc3b89dc1 = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(TelemetryInitializerPlugin, _this, function(_self, _base) {
            _self.addTelemetryInitializer = function(telemetryInitializer) {
                return $7b82afd5e1b31923$var$_addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[0, $aa96917b132802ee$export$820a3bce4a265606 /* @min:%2eprocessTelemetry */ ] = function(item, itemCtx) {
                if ($7b82afd5e1b31923$var$_runInitializers(_initializers, item, itemCtx ? itemCtx[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]() : _self[0, $45806013ed348c93$export$c7ff2c36e5c78421 /* @min:%2ediagLog */ ]())) _self[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](item, itemCtx);
            };
            _self[0, $45806013ed348c93$export$458d234b616d0745 /* @min:%2e_doTeardown */ ] = function() {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
    // Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn = 1;
    return TelemetryInitializerPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));




var $125d8f3d04332ece$var$_a;
// import { IStatsBeat, IStatsBeatConfig, IStatsBeatState } from "../JavaScriptSDK.Interfaces/IStatsBeat";
// import { IStatsMgr } from "../JavaScriptSDK.Interfaces/IStatsMgr";
var $125d8f3d04332ece$var$strValidationError = "Plugins must provide initialize method";
var $125d8f3d04332ece$var$strNotificationManager = "_notificationManager";
var $125d8f3d04332ece$var$strSdkUnloadingError = "SDK is still unloading...";
var $125d8f3d04332ece$var$strSdkNotInitialized = "SDK is not initialized";
var $125d8f3d04332ece$var$maxInitQueueSize = 100;
var $125d8f3d04332ece$var$maxInitTimeout = 50000;
// const strPluginUnloadFailed = "Failed to unload plugin";
// /**
//  * Default StatsBeatMgr configuration
//  * @internal
//  */
// const defaultStatsCfg: IConfigDefaults<IStatsBeatConfig> = objDeepFreeze({
//     shrtInt: UNDEFINED_VALUE,
//     endCfg: cfgDfMerge([])
// });
// /**
//  * Default SDK initialization configuration
//  * @internal
//  */
// const defaultSdkConfig: IConfigDefaults<IInternalSdkConfiguration> = objDeepFreeze({
//     stats: { rdOnly: true, mrg: true, v: defaultStatsCfg }
// });
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */ var $125d8f3d04332ece$var$defaultConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($125d8f3d04332ece$var$_a = {
    cookieCfg: {}
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$a077ce616a1ab4ee] = {
    rdOnly: true,
    ref: true,
    v: []
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$829012af4b2055a2] = {
    rdOnly: true,
    ref: true,
    v: []
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$ffb2356587263734] = {
    ref: true,
    v: {}
}, $125d8f3d04332ece$var$_a[0, $aa96917b132802ee$export$1cf3476332da55b3] = (0, $aa96917b132802ee$export$a43287864529b8fd), $125d8f3d04332ece$var$_a.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */ , $125d8f3d04332ece$var$_a.diagnosticLogInterval = (0, $aa96917b132802ee$export$a43287864529b8fd), $125d8f3d04332ece$var$_a));
/**
 * Helper to create the default performance manager
 * @param core - The AppInsightsCore instance
 * @param notificationMgr - The notification manager
 */ function $125d8f3d04332ece$var$_createPerfManager(core, notificationMgr) {
    return new (0, $67947f06182dbd51$export$cbeb6df2e8e9b5ae)(notificationMgr);
}
function $125d8f3d04332ece$var$_validateExtensions(logger, channelPriority, allExtensions) {
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(allExtensions, function(ext) {
        // Check for ext.initialize
        if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ext) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ext[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ])) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strValidationError);
        var extPriority = ext[0, $aa96917b132802ee$export$58efcc07763b37be /* @min:%2epriority */ ];
        var identifier = ext[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ];
        if (ext && extPriority) {
            if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(extPriorities[extPriority])) (0, $bacca83328a730a7$export$25fb4cb97863f0a8)(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            else // set a value
            extPriorities[extPriority] = identifier;
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) // Add to core extension that will be managed by AppInsightsCore
        coreExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
        else channels[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
    });
    return {
        core: coreExtensions,
        channels: channels
    };
}
function $125d8f3d04332ece$var$_isPluginPresent(thePlugin, plugins) {
    var exists = false;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(plugins, function(plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function $125d8f3d04332ece$var$_deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(newValues, function(key, value) {
        if (merge) {
            if ((0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(target[key])) // The target is an object and it has a value
            $125d8f3d04332ece$var$_deepMergeConfig(details, target[key], value, merge);
        }
        if (merge && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(value) && (0, $5831ddb3a0caf7c7$export$53b83ca8eaab0383)(target[key])) // The target is an object and it has a value
        $125d8f3d04332ece$var$_deepMergeConfig(details, target[key], value, merge);
        else // Just Assign (replace) and/or make the property dynamic
        details.set(target, key, value);
    });
}
function $125d8f3d04332ece$var$_findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listeners, function(listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return {
        i: idx,
        l: theListener
    };
}
function $125d8f3d04332ece$var$_addDelayedCfgListener(listeners, newWatcher) {
    var theListener = $125d8f3d04332ece$var$_findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function() {
                var fnd = $125d8f3d04332ece$var$_findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) listeners[0, $45806013ed348c93$export$84020a2e4fe863b0 /* @min:%2esplice */ ](fnd.i, 1);
            }
        };
        listeners[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](theListener);
    }
    return theListener;
}
function $125d8f3d04332ece$var$_registerDelayedCfgListener(config, listeners, logger) {
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(listeners, function(listener) {
        var unloadHdl = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function() {
            unloadHdl.rm();
        };
    });
}
// Moved this outside of the closure to reduce the retained memory footprint
function $125d8f3d04332ece$var$_initDebugListener(configHandler, unloadContainer, notificationManager, debugListener) {
    // Will get recalled if any referenced config values are changed
    unloadContainer.add(configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
        var disableDbgExt = details.cfg.disableDbgExt;
        if (disableDbgExt === true && debugListener) {
            // Remove any previously loaded debug listener
            notificationManager[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ](debugListener);
            debugListener = null;
        }
        if (notificationManager && !debugListener && disableDbgExt !== true) {
            debugListener = (0, $2662e05d52c419bb$export$dae5ac50a0df0f5f)(details.cfg);
            notificationManager[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ](debugListener);
        }
    }));
    return debugListener;
}
// Moved this outside of the closure to reduce the retained memory footprint
function $125d8f3d04332ece$var$_createUnloadHook(unloadHook) {
    return (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)({
        rm: function() {
            unloadHook.rm();
        }
    }, "toJSON", {
        v: function() {
            return "aicore::onCfgChange<" + JSON.stringify(unloadHook) + ">";
        }
    });
}
/**
 * @group Classes
 * @group Entrypoint
 */ var $125d8f3d04332ece$export$e7ac25a6828d23bf = /** @class */ function() {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        // let _statsBeat: IStatsBeat | null;
        // let _statsMgr: IStatsMgr | null;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        var _activeStatus; // to indicate if ikey or endpoint url promised is resolved or not
        var _endpoint;
        var _initInMemoMaxSize; // max event count limit during wait for init promises to be resolved
        var _isStatusSet; // track if active status is set in case of init timeout and init promises setting the status twice
        var _initTimer;
        /**
         * Internal log poller
         */ var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AppInsightsCore, this, function(_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function() {
                return [
                    _extensions,
                    _eventQueue
                ];
            };
            _self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ] = function() {
                return _isInitialized;
            };
            // since version 3.3.0
            _self.activeStatus = function() {
                return _activeStatus;
            };
            // since version 3.3.0
            // internal
            _self._setPendingStatus = function() {
                _activeStatus = 3 /* eActiveStatus.PENDING */ ;
            };
            // Creating the self.initialize = ()
            _self[0, $45806013ed348c93$export$65cd33bb52d04675 /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                if (_isUnloading) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strSdkUnloadingError);
                // Make sure core is only initialized once
                if (_self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Core cannot be initialized more than once");
                _configHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(config, $125d8f3d04332ece$var$defaultConfig, logger || _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    var rootCfg = details.cfg;
                    _initInMemoMaxSize = rootCfg.initInMemoMaxSize || $125d8f3d04332ece$var$maxInitQueueSize;
                    _handleIKeyEndpointPromises(rootCfg);
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, (0, $aa96917b132802ee$export$ffb2356587263734));
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(extCfg, function(key) {
                        details.ref(extCfg, key);
                    });
                }));
                _notificationManager = notificationManager;
                // Initialize the debug listener outside of the closure to reduce the retained memory footprint
                _debugListener = $125d8f3d04332ece$var$_initDebugListener(_configHandler, _hookContainer, _notificationManager && _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ](), _debugListener);
                _initPerfManager();
                _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = logger;
                var cfgExtensions = config[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ];
                // Extension validation
                _configExtensions = [];
                _configExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ].apply(_configExtensions, (0, $dc463ff9724142dd$export$643fbb7023bc1942)((0, $dc463ff9724142dd$export$643fbb7023bc1942)([], extensions, false), cfgExtensions, false));
                _channelConfig = config[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ];
                _initPluginChain(null);
                if (!_channels || _channels[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] === 0) (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("No " + (0, $aa96917b132802ee$export$829012af4b2055a2) + " available");
                if (_channelConfig && _channelConfig[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) {
                    var teeController = _self[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ]("TeeChannelController");
                    if (!teeController || !teeController.plugin) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "TeeChannel required");
                }
                $125d8f3d04332ece$var$_registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                if (_activeStatus === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE) _releaseQueues();
            };
            _self.getChannels = function() {
                var controls = [];
                if (_channels) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_channels, function(channel) {
                    controls[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](channel);
                });
                return (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(controls);
            };
            _self.track = function(telemetryItem) {
                (0, $67947f06182dbd51$export$c6fbeb260600c482)(_self[0, $aa96917b132802ee$export$f8b08c7de64edfbf /* @min:%2egetPerfMgr */ ](), function() {
                    return "AppInsightsCore:track";
                }, function() {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ] && (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(telemetryItem[0, $45806013ed348c93$export$9734b0a24bf02e93 /* @min:%2ename */ ])) {
                        _notifyInvalidEvent(telemetryItem);
                        (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem.iKey = telemetryItem.iKey || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem.time = telemetryItem.time || (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]() && _activeStatus === (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE) // Process the telemetry plugin chain
                    _createTelCtx()[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](telemetryItem);
                    else if (_activeStatus !== (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).INACTIVE) // Queue events until all extensions are initialized
                    {
                        if (_eventQueue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] <= _initInMemoMaxSize) // set limit, if full, stop adding new events
                        _eventQueue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](telemetryItem);
                    }
                }, function() {
                    return {
                        item: telemetryItem
                    };
                }, !telemetryItem.sync);
            };
            _self[0, $45806013ed348c93$export$474081342bc4baf4 /* @min:%2egetProcessTelContext */ ] = _createTelCtx;
            _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ] = function() {
                if (!_notificationManager) {
                    _notificationManager = new (0, $0dd57305094095f6$export$dfa1f14b6290f8c5)(_configHandler.cfg);
                    // For backward compatibility only
                    _self[$125d8f3d04332ece$var$strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */ _self[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _self.getNotifyMgr()[0, $45806013ed348c93$export$5c8bcfab4f42ca62 /* @min:%2eaddNotificationListener */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */ _self[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $45806013ed348c93$export$fc3403fa6f2894ab /* @min:%2eremoveNotificationListener */ ](listener);
            };
            _self.getCookieMgr = function() {
                if (!_cookieManager) _cookieManager = (0, $aaa64f3935d14265$export$2ae082191ac44e5a)(_configHandler.cfg, _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                return _cookieManager;
            };
            _self.setCookieMgr = function(cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[0, $aa96917b132802ee$export$f8b08c7de64edfbf /* @min:%2egetPerfMgr */ ] = function() {
                return _perfManager || _cfgPerfManager || (0, $67947f06182dbd51$export$6cdbf3f34ace6568)();
            };
            _self.setPerfMgr = function(perfMgr) {
                _perfManager = perfMgr;
            };
            // _self.getStatsBeat = (statsBeatState: IStatsBeatState) => {
            //     // create a new statsbeat if not initialize yet or the endpoint is different
            //     // otherwise, return the existing one, or null
            //     if (statsBeatState) {
            //         if (_statsMgr && _statsMgr.enabled) {
            //             if (_statsBeat && _statsBeat.endpoint !== statsBeatState.endpoint) {
            //                 // Different endpoint, so unload the existing and create a new one
            //                 _statsBeat.enabled = false;
            //                 _statsBeat = null;
            //             }
            //             if (!_statsBeat) {
            //                 // Create a new statsbeat instance
            //                 _statsBeat = _statsMgr.newInst(statsBeatState);
            //             }
            //         } else if (_statsBeat) {
            //             // Disable and remove any previously created statsbeat instance
            //             _statsBeat.enabled = false;
            //             _statsBeat = null;
            //         }
            //         // Return the current statsbeat instance or null if not created
            //         return _statsBeat;
            //     }
            //     // Return null as no statsbeat state was provided
            //     return null;
            // };
            // _self.setStatsMgr = (statsMgr: IStatsMgr) => {
            //     if (_statsMgr && _statsMgr !== statsMgr) {
            //         // Disable any previously created statsbeat instance
            //         if (_statsBeat) {
            //             _statsBeat.enabled = false;
            //             _statsBeat = null;
            //         }
            //     }
            //     _statsMgr = statsMgr;
            // };
            _self.eventCnt = function() {
                return _eventQueue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ];
            };
            _self.releaseQueue = function() {
                if (_isInitialized && _eventQueue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    if (_activeStatus === 2 /* eActiveStatus.ACTIVE */ ) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(eventQueue, function(event) {
                        event.iKey = event.iKey || _instrumentationKey;
                        _createTelCtx()[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](event);
                    });
                    else // new one for msg ikey
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "core init status is not active");
                }
            };
            _self.pollInternalLogs = function(eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                return _startLogPoller(true);
            };
            function _handleIKeyEndpointPromises(theConfig) {
                // app Insights core only handle ikey and endpointurl, aisku will handle cs
                // But we want to reference these config values so that if any future changes are made
                // this will trigger the re-run of the watch function
                // and the ikey and endpointUrl will be set to the new values
                var ikey = theConfig.instrumentationKey;
                var endpointUrl = theConfig.endpointUrl; // do not need to validate endpoint url, if it is null, default one will be set by sender
                // Check if we are waiting for previous promises to be resolved, won't apply new changes
                if (_activeStatus !== 3 /* eActiveStatus.PENDING */ ) {
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ikey)) {
                        _instrumentationKey = null;
                        // if new ikey is null, set status to be inactive, all new events will be saved in memory or dropped
                        _activeStatus = (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).INACTIVE;
                        var msg = "Please provide instrumentation key";
                        if (!_isInitialized) // only throw error during initialization
                        (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)(msg);
                        else {
                            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , msg);
                            _releaseQueues();
                        }
                        return;
                    }
                    var promises = [];
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(ikey)) {
                        promises[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ikey);
                        _instrumentationKey = null; // reset current local ikey variable (otherwise it will always be the previous ikeys if timeout is called before promise cb)
                    } else // string
                    _instrumentationKey = ikey;
                    if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(endpointUrl)) {
                        promises[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](endpointUrl);
                        _endpoint = null; // reset current local endpoint variable (otherwise it will always be the previous urls if timeout is called before promise cb)
                    } else // string or null
                    _endpoint = endpointUrl;
                    // at least have one promise
                    if (promises[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) _waitForInitPromises(theConfig, promises);
                    else // means no promises
                    _setStatus();
                }
            }
            function _waitForInitPromises(theConfig, promises) {
                // reset to false for new dynamic changes
                _isStatusSet = false;
                _activeStatus = 3 /* eActiveStatus.PENDING */ ;
                var initTimeout = (0, $ede407819d2d28c9$export$71fc1ee3e76bc1fe)(theConfig.initTimeOut) ? theConfig.initTimeOut : $125d8f3d04332ece$var$maxInitTimeout; // theConfig.initTimeOut could be 0
                var allPromises = (0, $4121df0a705d038e$export$c235d06856522848)(promises);
                if (_initTimer) // Stop any previous timer
                _initTimer[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                _initTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                    // set _isStatusSet to true
                    // set active status
                    // release queues
                    _initTimer = null;
                    if (!_isStatusSet) _setStatus();
                }, initTimeout);
                (0, $4121df0a705d038e$export$856fe465480fa77a)(allPromises, function(response) {
                    try {
                        if (_isStatusSet) // promises take too long to resolve, ignore them
                        // active status should be set by timeout already
                        return;
                        if (!response.rejected) {
                            var values = response[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                            if (values && values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]) {
                                // ikey
                                var ikeyRes = values[0];
                                _instrumentationKey = ikeyRes && ikeyRes[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                // endpoint
                                if (values[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 1) {
                                    var endpointRes = values[1];
                                    _endpoint = endpointRes && endpointRes[0, $45806013ed348c93$export$1805af0fa2230c20 /* @min:%2evalue */ ];
                                }
                            }
                            if (_instrumentationKey) {
                                // if ikey is null, no need to trigger extra dynamic changes for extensions
                                theConfig.instrumentationKey = _instrumentationKey; // set config.instrumentationKey for extensions to consume
                                theConfig.endpointUrl = _endpoint; // set config.endpointUrl for extensions to consume
                            }
                        }
                        // set _isStatusSet to true
                        // set active status
                        // release queues
                        _setStatus();
                    } catch (e) {
                        if (!_isStatusSet) _setStatus();
                    }
                });
            }
            function _setStatus() {
                _isStatusSet = true;
                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_instrumentationKey)) {
                    _activeStatus = (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).INACTIVE;
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 112 /* _eInternalMessageId.InitPromiseException */ , "ikey can't be resolved from promises");
                } else _activeStatus = (0, $452a7a5f1b634188$export$bc7f1ae22a2680b3).ACTIVE;
                _releaseQueues();
            }
            function _releaseQueues() {
                if (_isInitialized) {
                    _self.releaseQueue();
                    _self.pollInternalLogs();
                }
            }
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || _logger && _logger.queue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0;
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) interval = 10000;
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ];
                                    _internalLogPoller[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = (0, $5831ddb3a0caf7c7$export$6eae7cf7a129a986)(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = isRunning;
                            }));
                        }
                        _internalLogPoller[0, $45806013ed348c93$export$c9b1609f2b84393a /* @min:%2eenabled */ ] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[0, $45806013ed348c93$export$8d1c48dba7ad83a /* @min:%2estopPollingInternalLogs */ ] = function() {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, function() {
                return _telemetryInitializerPlugin;
            }, [
                "addTelemetryInitializer"
            ]);
            _self[0, $45806013ed348c93$export$7eb85b5cba77a43d /* @min:%2eunload */ ] = function(isAsync, unloadComplete, cbTimeout) {
                if (isAsync === void 0) isAsync = true;
                if (!_isInitialized) // The SDK is not initialized
                (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strSdkNotInitialized);
                // Check if the SDK still unloading so throw
                if (_isUnloading) // The SDK is already unloading
                (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)($125d8f3d04332ece$var$strSdkUnloadingError);
                var unloadState = {
                    reason: 50 /* TelemetryUnloadReason.SdkUnload */ ,
                    isAsync: isAsync,
                    flushComplete: false
                };
                var result;
                if (isAsync && !unloadComplete) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                    // Set the callback to the promise resolve callback
                    unloadComplete = resolve;
                });
                var processUnloadCtx = (0, $21bc92e23804c647$export$91bbbd4999751948)(_getPluginChain(), _self);
                processUnloadCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](function() {
                    // if (_statsBeat) {
                    //     // Disable any statsbeat instance
                    //     _statsBeat.enabled = false;
                    //     _statsBeat = null;
                    // }
                    _hookContainer.run(_self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    (0, $59a25debd846dee6$export$bc81824d13c51ef3)([
                        _cookieManager,
                        _notificationManager,
                        _logger
                    ], isAsync, function() {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[0, $45806013ed348c93$export$8d1c48dba7ad83a /* @min:%2estopPollingInternalLogs */ ]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */ , cbTimeout)) _doUnload(false);
                return result;
            };
            _self[0, $45806013ed348c93$export$37717a508eca6e2d /* @min:%2egetPlugin */ ] = _getPlugin;
            _self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError($125d8f3d04332ece$var$strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */ 
                };
                function _addPlugin(removed) {
                    _configExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](plugin);
                    updateState.added = [
                        plugin
                    ];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [
                        existingPlugin.plugin
                    ];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */ ,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function(removed) {
                        if (!removed) // Previous plugin was successfully removed or was not installed
                        addCb && addCb(false);
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */ ;
                            _addPlugin(true);
                        }
                    });
                } else _addPlugin(false);
            };
            _self.updateCfg = function(newConfig, mergeExisting) {
                if (mergeExisting === void 0) mergeExisting = true;
                var updateState;
                if (_self[0, $45806013ed348c93$export$2e2716e9c35a66a8 /* @min:%2eisInitialized */ ]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */ ,
                        cfg: _configHandler.cfg,
                        oldCfg: (0, $5831ddb3a0caf7c7$export$54e9fb29908872fa)({}, _configHandler.cfg),
                        newConfig: (0, $5831ddb3a0caf7c7$export$54e9fb29908872fa)({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] = cfg[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ];
                    newConfig[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ] = cfg[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function(details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    $125d8f3d04332ece$var$_deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                    (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(theConfig, function(key) {
                        if (!(0, $5831ddb3a0caf7c7$export$34e6b98f73578a9c)(newConfig, key)) // Set the value to undefined
                        details.set(theConfig, key, (0, $aa96917b132802ee$export$a43287864529b8fd));
                    });
                    // Apply defaults to the new config
                    details.setDf(theConfig, $125d8f3d04332ece$var$defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler.notify();
                if (updateState) _doUpdate(updateState);
            };
            _self.evtNamespace = function() {
                return _evtNamespace;
            };
            _self.flush = _flushChannels;
            _self.getTraceCtx = function(createNew) {
                if (!_traceCtx) _traceCtx = (0, $e144361666ed071d$export$10fa4480433f402c)();
                return _traceCtx;
            };
            _self.setTraceCtx = function(traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            (0, $ede407819d2d28c9$export$5dd8d245f6f94a18)(_self, "addUnloadCb", function() {
                return _unloadHandlers;
            }, "add");
            _self.onCfgChange = function(handler) {
                var unloadHook;
                if (!_isInitialized) unloadHook = $125d8f3d04332ece$var$_addDelayedCfgListener(_cfgListeners, handler);
                else unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(_configHandler.cfg, handler, _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                return $125d8f3d04332ece$var$_createUnloadHook(unloadHook);
            };
            _self.getWParam = function() {
                return (0, $5831ddb3a0caf7c7$export$c4372eca9c56fe99)() || !!_configHandler.cfg.enableWParam ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function(plugins) {
                    if (plugins) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(plugins, function(plugin) {
                        if (plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] && plugin[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ] && !thePlugins[plugin.identifier]) {
                            var ver = plugin[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] + "=" + plugin[0, $45806013ed348c93$export$568c4302d11f2b22 /* @min:%2eversion */ ];
                            _pluginVersionStringArr[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ver);
                            thePlugins[plugin.identifier] = plugin;
                        }
                    });
                };
                _addPluginVersions(_channels);
                if (_channelConfig) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_channelConfig, function(channels) {
                    _addPluginVersions(channels);
                });
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)({}, $125d8f3d04332ece$var$defaultConfig, _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[0, $45806013ed348c93$export$e53d8cae4d527530 /* @min:%2eloggingLevelConsole */ ] = 1 /* eLoggingSeverity.CRITICAL */ ;
                // Define _self.config
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                    g: function() {
                        return _configHandler.cfg;
                    },
                    s: function(newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "pluginVersionStringArr", {
                    g: function() {
                        if (!_pluginVersionStringArr) _setPluginVersions();
                        return _pluginVersionStringArr;
                    }
                });
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "pluginVersionString", {
                    g: function() {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) _setPluginVersions();
                            _pluginVersionString = _pluginVersionStringArr.join(";");
                        }
                        return _pluginVersionString || (0, $aa96917b132802ee$export$5e8607ab26634759);
                    }
                });
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "logger", {
                    g: function() {
                        if (!_logger) {
                            _logger = new (0, $bacca83328a730a7$export$4f80edb2e10dc14c)(_configHandler.cfg);
                            _configHandler[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = _logger;
                        }
                        return _logger;
                    },
                    s: function(newLogger) {
                        _configHandler[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = newLogger;
                        if (_logger !== newLogger) {
                            (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ] = new (0, $bacca83328a730a7$export$4f80edb2e10dc14c)(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self.config[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] || [];
                cfgExtensions.splice(0, cfgExtensions[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]);
                (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new (0, $7b82afd5e1b31923$export$5da7f32cc3b89dc1)();
                _eventQueue = [];
                (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                // _statsBeat = null;
                _cfgPerfManager = null;
                (0, $59a25debd846dee6$export$86347c3dd68c03f6)(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("AIBaseCore", true);
                _unloadHandlers = (0, $0af4a0f2b45a17f9$export$1dd1604aeaf8cfed)();
                _traceCtx = null;
                _instrumentationKey = null;
                _hookContainer = (0, $10c5f1b2f69c7ec4$export$31fa167f9d342989)();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller = null;
                _internalLogPollerListening = false;
                _activeStatus = 0 /* eActiveStatus.NONE */ ; // default is None
                _endpoint = null;
                _initInMemoMaxSize = null;
                _isStatusSet = false;
                _initTimer = null;
            // if (_statsBeat) {
            //     // Unload and disable any statsbeat instance
            //     _statsBeat.enabled = false;
            // }
            // _statsBeat = null;
            }
            function _createTelCtx() {
                var theCtx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = $125d8f3d04332ece$var$_validateExtensions(_self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ], (0, $585383ffe353022e$export$a1373ad9f192f374), _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = (0, $e144361666ed071d$export$478771939b7b39a2)((0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(_channels, theExtensions[0, $aa96917b132802ee$export$829012af4b2055a2 /* @min:%2echannels */ ]));
                // Create an array of all extensions, including the _channels
                var allExtensions = (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)((0, $e144361666ed071d$export$478771939b7b39a2)(theExtensions[0, $aa96917b132802ee$export$3094ace9cd82ff99 /* @min:%2ecore */ ]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self.config[0, $aa96917b132802ee$export$a077ce616a1ab4ee /* @min:%2eextensions */ ] || [];
                cfgExtensions.splice(0, cfgExtensions[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ]);
                (0, $5831ddb3a0caf7c7$export$69c7b96f216fdf7b)(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $e144361666ed071d$export$be211df7b1eeb33e)(rootCtx[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](_channels), allExtensions);
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                (0, $e144361666ed071d$export$be211df7b1eeb33e)(rootCtx, allExtensions);
                if (updateState) _doUpdate(updateState);
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_extensions, function(ext) {
                    if (ext[0, $45806013ed348c93$export$f001befbf8417151 /* @min:%2eidentifier */ ] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) channelHosts[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](ext);
                });
                if (!thePlugin && channelHosts[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(channelHosts, function(host) {
                    thePlugin = host.getChannel(pluginIdentifier);
                    if (!thePlugin) return -1;
                });
                if (thePlugin) theExt = {
                    plugin: thePlugin,
                    setEnabled: function(enabled) {
                        (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(thePlugin)[0, $aa96917b132802ee$export$49e9417944569ae8] = !enabled;
                    },
                    isEnabled: function() {
                        var pluginState = (0, $e144361666ed071d$export$37cfaecb9b4b1b3b)(thePlugin);
                        return !pluginState[0, $45806013ed348c93$export$7176fb2a7d11927e /* @min:%2eteardown */ ] && !pluginState[0, $aa96917b132802ee$export$49e9417944569ae8];
                    },
                    remove: function(isAsync, removeCb) {
                        if (isAsync === void 0) isAsync = true;
                        var pluginsToRemove = [
                            thePlugin
                        ];
                        var unloadState = {
                            reason: 1 /* TelemetryUnloadReason.PluginUnload */ ,
                            isAsync: isAsync
                        };
                        _removePlugins(pluginsToRemove, unloadState, function(removed) {
                            if (removed) // Re-Initialize the plugin chain
                            _initPluginChain({
                                reason: 32 /* TelemetryUpdateReason.PluginRemoved */ ,
                                removed: pluginsToRemove
                            });
                            removeCb && removeCb(removed);
                        });
                    }
                };
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if ((0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)(extensions, _telemetryInitializerPlugin) === -1) extensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](_telemetryInitializerPlugin);
                    _pluginChain = (0, $21bc92e23804c647$export$107e639207cdf742)((0, $e144361666ed071d$export$478771939b7b39a2)(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var unloadChain = (0, $21bc92e23804c647$export$107e639207cdf742)(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = (0, $21bc92e23804c647$export$91bbbd4999751948)(unloadChain, _self);
                    unloadCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](function() {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_configExtensions, function(plugin, idx) {
                            if (!$125d8f3d04332ece$var$_isPluginPresent(plugin, thePlugins)) newConfigExtensions[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](plugin);
                            else removed = true;
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_channelConfig, function(queue, idx) {
                                var newQueue = [];
                                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(queue, function(channel) {
                                    if (!$125d8f3d04332ece$var$_isPluginPresent(channel, thePlugins)) newQueue[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](channel);
                                    else removed = true;
                                });
                                newChannelConfig[0, $45806013ed348c93$export$a0a330e7fa1e278c /* @min:%2epush */ ](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](unloadState);
                } else removeComplete(false);
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] = 0;
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(queue, function(logMessage) {
                        var item = {
                            name: _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[0, $45806013ed348c93$export$2cc5b49df2eed261 /* @min:%2emessageId */ ],
                            iKey: _instrumentationKey,
                            time: (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date()),
                            baseType: (0, $bacca83328a730a7$export$70ef838ed08aad47).dataType,
                            baseData: {
                                message: logMessage[0, $45806013ed348c93$export$923606b70907833e /* @min:%2emessage */ ]
                            }
                        };
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[0, $45806013ed348c93$export$bd01c5e3f12db01c /* @min:%2ecancel */ ]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[0, $45806013ed348c93$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) {
                    var flushCtx = _createTelCtx()[0, $45806013ed348c93$export$1e6514b499ba4d34 /* @min:%2ecreateNew */ ](_channels);
                    flushCtx.iterate(function(plugin) {
                        if (plugin.flush) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin.flush(isAsync, function() {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) cbTimer = (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(function() {
                                        cbTimer = null;
                                        doCallback();
                                    }, cbTimeout);
                                    else doCallback();
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initPerfManager() {
                // Save the previous config based performance manager creator to avoid creating new perf manager instances if unchanged
                var prevCfgPerfMgr;
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[0, $45806013ed348c93$export$fc59eec8d77f3766 /* @min:%2ewatch */ ](function(details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (enablePerfMgr) {
                        var createPerfMgr = details.cfg[0, $aa96917b132802ee$export$1cf3476332da55b3 /* @min:%2ecreatePerfMgr */ ];
                        // for preCfgPerfMgr = createPerfMgr = null
                        // initial createPerfMgr function should be _createPerfManager
                        if (prevCfgPerfMgr !== createPerfMgr || !prevCfgPerfMgr) {
                            if (!createPerfMgr) createPerfMgr = $125d8f3d04332ece$var$_createPerfManager;
                            // Set the performance manager creation function if not defined
                            (0, $ede407819d2d28c9$export$51417ccc212471e)(details.cfg, (0, $aa96917b132802ee$export$1cf3476332da55b3), createPerfMgr);
                            prevCfgPerfMgr = createPerfMgr;
                            // Remove any existing config based performance manager
                            _cfgPerfManager = null;
                        }
                        // Only create the performance manager if it's not already created or manually set
                        if (!_perfManager && !_cfgPerfManager && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(createPerfMgr)) // Create a new config based performance manager
                        _cfgPerfManager = createPerfMgr(_self, _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]());
                    } else {
                        // Remove any existing config based performance manager
                        _cfgPerfManager = null;
                        // Clear the previous cached value so it can be GC'd
                        prevCfgPerfMgr = null;
                    }
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = (0, $21bc92e23804c647$export$e4c32b40c4fbf98a)(_getPluginChain(), _self);
                updateCtx[0, $45806013ed348c93$export$8693bdba21bfca93 /* @min:%2eonComplete */ ](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[0, $45806013ed348c93$export$5c220169317cd6de /* @min:%2eprocessNext */ ](updateState);
            }
            function _logOrThrowError(message) {
                var logger = _self[0, $45806013ed348c93$export$e6a243fe757439f9 /* @min:%2elogger */ ];
                if (logger) {
                    // there should always be a logger
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , message);
                    _startLogPoller();
                } else (0, $5831ddb3a0caf7c7$export$8bf7aba4a9e09055)(message);
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[0, $45806013ed348c93$export$3a09068de032bb32 /* @min:%2egetNotifyMgr */ ]();
                if (manager) manager[0, $aa96917b132802ee$export$bacb5b2f4c1081b9 /* @min:%2eeventsDiscarded */ ]([
                    telemetryItem
                ], 2 /* eEventsDiscardedReason.InvalidEvent */ );
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
    // Removed Stub for AppInsightsCore.prototype.initialize.
    // Removed Stub for AppInsightsCore.prototype.getChannels.
    // Removed Stub for AppInsightsCore.prototype.track.
    // Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
    // Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
    // Removed Stub for AppInsightsCore.prototype.addNotificationListener.
    // Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
    // Removed Stub for AppInsightsCore.prototype.getCookieMgr.
    // Removed Stub for AppInsightsCore.prototype.setCookieMgr.
    // Removed Stub for AppInsightsCore.prototype.getPerfMgr.
    // public getStatsBeat(statsBeatState: IStatsBeatState): IStatsBeat {
    //     // @ DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    //     return null;
    // }
    // public setStatsMgr(statsMgr?: IStatsMgr): void {
    //     // @ DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    // }
    // Removed Stub for AppInsightsCore.prototype.setPerfMgr.
    // Removed Stub for AppInsightsCore.prototype.eventCnt.
    // Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    // Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
    // Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
    // Removed Stub for AppInsightsCore.prototype.unload.
    // Removed Stub for AppInsightsCore.prototype.getPlugin.
    // Removed Stub for AppInsightsCore.prototype.addPlugin.
    // Removed Stub for AppInsightsCore.prototype.updateCfg.
    // Removed Stub for AppInsightsCore.prototype.evtNamespace.
    // Removed Stub for AppInsightsCore.prototype.addUnloadCb.
    // Removed Stub for AppInsightsCore.prototype.flush.
    // Removed Stub for AppInsightsCore.prototype.getTraceCtx.
    // Removed Stub for AppInsightsCore.prototype.setTraceCtx.
    // Removed Stub for AppInsightsCore.prototype.addUnloadHook.
    // Removed Stub for AppInsightsCore.prototype.onCfgChange.
    // Removed Stub for AppInsightsCore.prototype.activeStatus.
    // Removed Stub for AppInsightsCore.prototype._setPendingStatus.
    // Removed Stub for AppInsightsCore.prototype.releaseQueue.
    // Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn = 1;
    return AppInsightsCore;
}();


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $8291b597e9a6dfe3$export$be41298b7716c698 = "duration";
var $8291b597e9a6dfe3$export$400e70f2a2ecb5aa = "properties";


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $83680ca0bbc253cc$export$8ff033ecd75b66c3 = "requestUrl"; // Count: 11
var $83680ca0bbc253cc$export$6eae51590aaea43 = "length"; // Count: 8
var $83680ca0bbc253cc$export$a5eb52c53bba8560 = "traceID"; // Count: 8
var $83680ca0bbc253cc$export$c105b94efa183847 = "spanID"; // Count: 8
var $83680ca0bbc253cc$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 11
var $83680ca0bbc253cc$export$fdcd48959e13aba7 = "context"; // Count: 5
var $83680ca0bbc253cc$export$fcf18cee9ee41961 = "aborted"; // Count: 6
var $83680ca0bbc253cc$export$3b3afe26ca0e015c = "_addHook"; // Count: 4
var $83680ca0bbc253cc$export$f9ae8d0acf86503e = "core"; // Count: 8
var $83680ca0bbc253cc$export$b8b43933cebcc44 = "includeCorrelationHeaders"; // Count: 4
var $83680ca0bbc253cc$export$de5be3709039b9b0 = "getAbsoluteUrl"; // Count: 3
var $83680ca0bbc253cc$export$829ed22a43b4aada = "headers"; // Count: 7
var $83680ca0bbc253cc$export$b58618e731cdb301 = "requestHeaders"; // Count: 13
var $83680ca0bbc253cc$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $83680ca0bbc253cc$export$606539098555a7e0 = "trackDependencyDataInternal"; // Count: 2
var $83680ca0bbc253cc$export$69cac26425c8ea23 = "startTime"; // Count: 5
var $83680ca0bbc253cc$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $83680ca0bbc253cc$export$8b281196cba76bb8 = "enableRequestHeaderTracking"; // Count: 3
var $83680ca0bbc253cc$export$5300fb185e41f85f = "enableAjaxErrorStatusText"; // Count: 2
var $83680ca0bbc253cc$export$c78ea26ccf911077 = "enableAjaxPerfTracking"; // Count: 2
var $83680ca0bbc253cc$export$5a06e86b4597590a = "maxAjaxCallsPerView"; // Count: 2
var $83680ca0bbc253cc$export$2606d0740ec53d91 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var $83680ca0bbc253cc$export$741be082275da668 = "disableAjaxTracking"; // Count: 3
var $83680ca0bbc253cc$export$3bf8a918dbb82278 = "ajaxPerfLookupDelay"; // Count: 2
var $83680ca0bbc253cc$export$499c10e17a654f31 = "disableFetchTracking"; // Count: 2
var $83680ca0bbc253cc$export$650df8a93357784d = "enableResponseHeaderTracking"; // Count: 2
var $83680ca0bbc253cc$export$f8d169088a01f6f2 = "status"; // Count: 11
var $83680ca0bbc253cc$export$e44f43b238a0c7f0 = "statusText"; // Count: 7
var $83680ca0bbc253cc$export$422ea83a60e3414b = "headerMap"; // Count: 5
var $83680ca0bbc253cc$export$b3507d39ae3f3e22 = "requestSentTime"; // Count: 9
var $83680ca0bbc253cc$export$90dab0fe9b2b7158 = "getTraceId"; // Count: 3
var $83680ca0bbc253cc$export$1fd22cf8d803736f = "getTraceFlags"; // Count: 3
var $83680ca0bbc253cc$export$47d30bd816d62bdc = "method"; // Count: 8
var $83680ca0bbc253cc$export$cce28811c9041832 = "errorStatusText"; // Count: 3
var $83680ca0bbc253cc$export$3f654a505433af43 = "stateChangeAttached"; // Count: 2
var $83680ca0bbc253cc$export$d9f76b3afffa4e88 = "responseText"; // Count: 6
var $83680ca0bbc253cc$export$e73fbfb501e27fb9 = "responseFinishedTime"; // Count: 7
var $83680ca0bbc253cc$export$e31aceb60e1b3a1a = "CreateTrackItem"; // Count: 3
var $83680ca0bbc253cc$export$f5d99abda983253b = "getAllResponseHeaders"; // Count: 2
var $83680ca0bbc253cc$export$e2e640c31408a88f = "getPartAProps"; // Count: 3
var $83680ca0bbc253cc$export$9e85e7b326182790 = "perfMark"; // Count: 4
var $83680ca0bbc253cc$export$6bec4987b5d3526c = "perfTiming"; // Count: 3
var $83680ca0bbc253cc$export$7918362d3a562ff8 = "ajaxDiagnosticsMessage"; // Count: 3
var $83680ca0bbc253cc$export$c4a9b5c39c7409f7 = "correlationContext"; // Count: 3
var $83680ca0bbc253cc$export$7820e90f0eaab413 = "ajaxTotalDuration"; // Count: 3
var $83680ca0bbc253cc$export$c050ff25390a2bce = "eventTraceCtx"; // Count: 3


/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 





/** @ignore */ function $48c7b9d8e3de1826$var$_calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) result = (0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(from, to);
    return result;
}
/** @ignore */ function $48c7b9d8e3de1826$var$_setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = $48c7b9d8e3de1826$var$_calcPerfDuration(resourceEntry, start, end);
    if (value) result = $48c7b9d8e3de1826$var$_setPerfValue(props, name, (0, $7c0ecef5df4b34f7$export$4460ed97e7c4a927)(value));
    return result;
}
/** @ignore */ function $48c7b9d8e3de1826$var$_setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = props[strPerf] || {};
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */ function $48c7b9d8e3de1826$var$_populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */ var resourceEntry = ajaxData[0, $83680ca0bbc253cc$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ];
    var props = dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= $48c7b9d8e3de1826$var$_setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[0, $8291b597e9a6dfe3$export$be41298b7716c698 /* @min:%2eduration */ ];
        if (!duration) duration = $48c7b9d8e3de1826$var$_calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, (0, $8291b597e9a6dfe3$export$be41298b7716c698), duration);
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(serverTiming, function(value, idx) {
                var name = (0, $ede407819d2d28c9$export$f60443f194e40bc2)(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(value, function(key, val) {
                    if (key !== strName && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(val) || (0, $5831ddb3a0caf7c7$export$7e4aa119212bc614)(val)) {
                        if (newValue[key]) val = newValue[key] + ";" + val;
                        if (val || !(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(val)) // Only set the value if it has a value and it's not an empty string
                        newValue[key] = val;
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    } else if (ajaxData[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ]) propsSet |= $48c7b9d8e3de1826$var$_setPerfValue(props, "missing", ajaxData.perfAttempts);
    if (propsSet) dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = props;
}
var $48c7b9d8e3de1826$export$79f098456caec6e7 = /** @class */ function() {
    function XHRMonitoringState() {
        var self = this;
        self.openDone = false;
        self.setRequestHeaderDone = false;
        self.sendDone = false;
        self.abortDone = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[0, $83680ca0bbc253cc$export$3f654a505433af43 /* @min:%2estateChangeAttached */ ] = false;
    }
    return XHRMonitoringState;
}();
var $48c7b9d8e3de1826$export$3391d178758cbbb1 = /** @class */ function() {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[0, $83680ca0bbc253cc$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ] = null;
        self[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = 0;
        self.pageUrl = null;
        self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = null;
        self.requestSize = 0;
        self[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ] = null;
        self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = null;
        self[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = null;
        self.responseStartedTime = null;
        self[0, $83680ca0bbc253cc$export$e73fbfb501e27fb9 /* @min:%2eresponseFinishedTime */ ] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new $48c7b9d8e3de1826$export$79f098456caec6e7();
        self.clientFailure = 0;
        self[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] = traceId;
        self[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ] = spanId;
        self[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) self[0, $83680ca0bbc253cc$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ] = {
            traceId: traceCtx[0, $83680ca0bbc253cc$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ](),
            spanId: traceCtx.getSpanId(),
            traceFlags: traceCtx[0, $83680ca0bbc253cc$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]()
        };
        else self[0, $83680ca0bbc253cc$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ] = null;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(ajaxRecord, self, function(self) {
            self.getAbsoluteUrl = function() {
                return self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] ? (0, $b5e9e2ed66fb6b5a$export$a98678973ebe2123)(self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ]) : null;
            };
            self.getPathName = function() {
                return self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] ? (0, $3ad7e6398fcf0cbb$export$356146502a9f860c)(_logger, (0, $b5e9e2ed66fb6b5a$export$b959f3bc0a239498)(self[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ], self[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ])) : null;
            };
            self[0, $83680ca0bbc253cc$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = (0, $5831ddb3a0caf7c7$export$42cacde8c45786ff)((0, $d98f9809e5d6a7c7$export$bfc7deb7f4f00987)(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[0, $83680ca0bbc253cc$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ] < 0) return null;
                var dependency = (_a = {
                    id: "|" + self[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + self[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ],
                    target: self[0, $83680ca0bbc253cc$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](),
                    name: self.getPathName(),
                    type: ajaxType,
                    startTime: null,
                    duration: self[0, $83680ca0bbc253cc$export$7820e90f0eaab413 /* @min:%2eajaxTotalDuration */ ],
                    success: +self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] >= 200 && +self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] < 400,
                    responseCode: +self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ]
                }, _a[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa] = {
                    HttpMethod: self[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ]
                }, _a);
                var props = dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa];
                if (self[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ]) props[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = true;
                if (self[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ]) {
                    // Set the correct dependency start time
                    dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date();
                    dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ].setTime(self[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ]);
                }
                // Add Ajax perf details if available
                $48c7b9d8e3de1826$var$_populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(self.requestHeaders)[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) props[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = self[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ];
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[0, $83680ca0bbc253cc$export$c4a9b5c39c7409f7 /* @min:%2ecorrelationContext */ ];
                        if (correlationContext) dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        if (response[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ]) {
                            if ((0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(response.headerMap)[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] > 0) props.responseHeaders = response[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ];
                        }
                        if (self[0, $83680ca0bbc253cc$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ]) {
                            if (self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") props.responseText = response.responseText ? response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] + " - " + response[strResponseText] : response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ];
                                if (responseType === "json") props.responseText = response.response ? response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] + " - " + JSON.stringify(response.response) : response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ];
                            } else if (self[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] === 0) props.responseText = response[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ] || "";
                        }
                    }
                }
                return dependency;
            };
            self[0, $83680ca0bbc253cc$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ] = function() {
                var partA = null;
                var traceCtx = self[0, $83680ca0bbc253cc$export$c050ff25390a2bce /* @min:%2eeventTraceCtx */ ];
                if (traceCtx && (traceCtx.traceId || traceCtx.spanId)) {
                    partA = {};
                    var traceExt = partA[(0, $6e37c6a219f9960f$export$152f4bb29f8263d0).TraceExt] = {
                        traceID: traceCtx.traceId,
                        parentID: traceCtx.spanId
                    };
                    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(traceCtx[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ])) traceExt[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = traceCtx[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                }
                return partA;
            };
        });
    }
    // Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
    // Removed Stub for ajaxRecord.prototype.getPathName.
    // Removed Stub for ajaxRecord.prototype.CreateTrackItem.
    // Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ajaxRecord.__ieDyn = 1;
    return ajaxRecord;
}();


var $fa5a8e720c6a6dfc$var$_a;
// const AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var $fa5a8e720c6a6dfc$var$strDiagLog = "diagLog";
var $fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER = "_ajaxData";
var $fa5a8e720c6a6dfc$var$STR_FETCH = "fetch";
var $fa5a8e720c6a6dfc$var$ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var $fa5a8e720c6a6dfc$var$ERROR_PREFIX = ", monitoring data for this ajax call ";
var $fa5a8e720c6a6dfc$var$ERROR_POSTFIX = $fa5a8e720c6a6dfc$var$ERROR_PREFIX + "may be incorrect.";
var $fa5a8e720c6a6dfc$var$ERROR_NOT_SENT = $fa5a8e720c6a6dfc$var$ERROR_PREFIX + "won't be sent.";
var $fa5a8e720c6a6dfc$var$CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var $fa5a8e720c6a6dfc$var$CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var $fa5a8e720c6a6dfc$var$FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var $fa5a8e720c6a6dfc$var$_markCount = 0;
/** @Ignore */ function $fa5a8e720c6a6dfc$var$_supportsFetch() {
    var _global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
    if (!_global || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_global.Request) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_global.Request[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049]) || (0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_global[$fa5a8e720c6a6dfc$var$STR_FETCH])) return null;
    return _global[$fa5a8e720c6a6dfc$var$STR_FETCH];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */ function $fa5a8e720c6a6dfc$var$_supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a;
    var result = false;
    if ((0, $0d2c2fb24388dcf8$export$cfeac9aa070f0108)()) {
        var proto = XMLHttpRequest[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049];
        result = !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
        !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto.send) && !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(proto.abort);
    }
    var ieVer = (0, $0d2c2fb24388dcf8$export$eb7ff627fa81c42e)();
    if (ieVer && ieVer < 9) result = false;
    if (result) // Disable if the XmlHttpRequest can't be extended or hooked
    try {
        var xhr = new XMLHttpRequest();
        var xhrData = {
            xh: [],
            i: (_a = {}, _a[ajaxDataId] = {}, _a)
        };
        xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] = xhrData;
        // Check that we can update the prototype
        var theOpen = XMLHttpRequest[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049].open;
        XMLHttpRequest[0, $042f611b66f4fd6f$export$ecddaaeb55ecf049].open = theOpen;
    } catch (e) {
        // We can't decorate the xhr object so disable monitoring
        result = false;
        $fa5a8e720c6a6dfc$var$_throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
            exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
        });
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */ var $fa5a8e720c6a6dfc$var$_getAjaxData = function(xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER]) return (xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */ var $fa5a8e720c6a6dfc$var$_addSharedXhrHeaders = function(xhr, name, value) {
    if (xhr) {
        var headers = (xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) headers.push({
            n: name,
            v: value
        });
    }
};
var $fa5a8e720c6a6dfc$var$_isHeaderSet = function(xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(headers, function(header) {
            if (header.n === name) {
                isPresent = true;
                return -1;
            }
        });
    }
    return isPresent;
};
/** @Ignore */ function $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ]) result += "(url: '" + ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] + "')";
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */ function $fa5a8e720c6a6dfc$var$_throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(ajaxMonitorInstance[$fa5a8e720c6a6dfc$var$strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */ , msgId, message, properties, isUserAct);
}
/** @ignore */ function $fa5a8e720c6a6dfc$var$_throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(ajaxMonitorInstance[$fa5a8e720c6a6dfc$var$strDiagLog](), 2 /* eLoggingSeverity.WARNING */ , msgId, message, properties, isUserAct);
}
/** @Ignore */ function $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function(callDetails) {
        var _a;
        $fa5a8e720c6a6dfc$var$_throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {}, _a[0, $83680ca0bbc253cc$export$7918362d3a562ff8 /* @min:ajaxDiagnosticsMessage */ ] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(callDetails.inst, ajaxMonitorInstance._ajaxDataId), _a.exception = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(callDetails.err), _a));
    };
}
function $fa5a8e720c6a6dfc$var$_indexOf(value, match) {
    if (value && match) return (0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(value, match);
    return -1;
}
function $fa5a8e720c6a6dfc$var$_addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function() {
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(container, function(initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function $fa5a8e720c6a6dfc$var$_processDependencyContainer(core, container, details, message) {
    var result = true;
    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(container, function(theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) result = false;
        } catch (e) {
            (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Dependency " + message + " [#" + idx + "] failed: " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
            }, true);
        }
    });
    return result;
}
function $fa5a8e720c6a6dfc$var$_processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var initializersCount = listeners[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ];
    var result = true;
    if (initializersCount > 0) {
        var details = {
            core: core,
            xhr: xhr,
            input: input,
            init: init,
            traceId: ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ],
            spanId: ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ],
            traceFlags: ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ],
            context: ajaxData[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ] || {},
            aborted: !!ajaxData[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ]
        };
        result = $fa5a8e720c6a6dfc$var$_processDependencyContainer(core, listeners, details, "listener");
        ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] = details.traceId;
        ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ] = details.spanId;
        ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = details[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
        ajaxData[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ] = details[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
    }
    return result;
}
var $fa5a8e720c6a6dfc$var$BLOB_CORE = "*.blob.core.";
var $fa5a8e720c6a6dfc$export$ae1f7dcb3278b8bb = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)([
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "windows.net",
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "chinacloudapi.cn",
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "cloudapi.de",
    $fa5a8e720c6a6dfc$var$BLOB_CORE + "usgovcloudapi.net"
]);
var $fa5a8e720c6a6dfc$var$_internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var $fa5a8e720c6a6dfc$var$_defaultConfig = (0, $5831ddb3a0caf7c7$export$5da24d7703175bc5)(($fa5a8e720c6a6dfc$var$_a = {}, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$5a06e86b4597590a /* @min:maxAjaxCallsPerView */ ] = 500, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$741be082275da668 /* @min:disableAjaxTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$499c10e17a654f31 /* @min:disableFetchTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$2606d0740ec53d91 /* @min:excludeRequestFromAutoTrackingPatterns */ ] = undefined, $fa5a8e720c6a6dfc$var$_a.disableCorrelationHeaders = false, $fa5a8e720c6a6dfc$var$_a.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */ , $fa5a8e720c6a6dfc$var$_a.correlationHeaderExcludedDomains = $fa5a8e720c6a6dfc$export$ae1f7dcb3278b8bb, $fa5a8e720c6a6dfc$var$_a.correlationHeaderDomains = undefined, $fa5a8e720c6a6dfc$var$_a.correlationHeaderExcludePatterns = undefined, $fa5a8e720c6a6dfc$var$_a.appId = undefined, $fa5a8e720c6a6dfc$var$_a.enableCorsCorrelation = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$8b281196cba76bb8 /* @min:enableRequestHeaderTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$650df8a93357784d /* @min:enableResponseHeaderTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$5300fb185e41f85f /* @min:enableAjaxErrorStatusText */ ] = false, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$c78ea26ccf911077 /* @min:enableAjaxPerfTracking */ ] = false, $fa5a8e720c6a6dfc$var$_a.maxAjaxPerfLookupAttempts = 3, $fa5a8e720c6a6dfc$var$_a[0, $83680ca0bbc253cc$export$3bf8a918dbb82278 /* @min:ajaxPerfLookupDelay */ ] = 25, $fa5a8e720c6a6dfc$var$_a.ignoreHeaders = [
    "Authorization",
    "X-API-Key",
    "WWW-Authenticate"
], $fa5a8e720c6a6dfc$var$_a.addRequestContext = undefined, $fa5a8e720c6a6dfc$var$_a.addIntEndpoints = true, $fa5a8e720c6a6dfc$var$_a));
var $fa5a8e720c6a6dfc$export$d9a50c4d1eb2475f = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _extensionConfig;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        var _ignoreHeaders;
        var _maxAjaxPerfLookupAttempts;
        var _ajaxPerfLookupDelay;
        var _distributedTracingMode;
        var _appId;
        var _polyfillInitialized;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AjaxMonitor, _this, function(_self, _base) {
            var _addHook = _base[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ];
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)((0, $0e058b881c0798ff$export$eb4a6badb18ead04)("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function() {
                _initDefaults();
            };
            _self.trackDependencyData = function(dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], null, dependency, properties);
            };
            _self.resetAjaxAttempts = function() {
                _trackAjaxAttempts = 0;
            };
            _self[0, $83680ca0bbc253cc$export$b8b43933cebcc44 /* @min:%2eincludeCorrelationHeaders */ ] = function(ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                if ($fa5a8e720c6a6dfc$var$_processDependencyListeners(_dependencyListeners, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, xhr, input, init)) {
                    if (input || input === "") {
                        if ((0, $d98f9809e5d6a7c7$export$a62d10d7f896c08c)(_extensionConfig, ajaxData[0, $83680ca0bbc253cc$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                            if (!init) init = {};
                            // init headers override original request headers
                            // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                            // not using original request headers will result in them being lost
                            var headers = new Headers(init[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] || (input instanceof Request ? input[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {} : {}));
                            if (_isUsingAIHeaders) {
                                var id = "|" + ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ];
                                headers.set((0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                                if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                            }
                            var appId = _appId || _context && _context.appId();
                            if (appId) {
                                headers.set((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                                if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                            }
                            if (_isUsingW3CHeaders) {
                                var traceFlags = ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(traceFlags)) traceFlags = 0x01;
                                var traceParent = (0, $4726195e2d737947$export$55f8c39d2c902d0d)((0, $4726195e2d737947$export$2f21fe23413fe96b)(ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ], traceFlags));
                                headers.set((0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                                if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                            }
                            init[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] = headers;
                        }
                    } else if (xhr) {
                        if ((0, $d98f9809e5d6a7c7$export$a62d10d7f896c08c)(_extensionConfig, ajaxData[0, $83680ca0bbc253cc$export$de5be3709039b9b0 /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                            if (_isUsingAIHeaders) {
                                if (!$fa5a8e720c6a6dfc$var$_isHeaderSet(xhr, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ])) {
                                    var id = "|" + ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ] + "." + ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ];
                                    xhr[0, $83680ca0bbc253cc$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                                    if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                                } else $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $921552b7fb658c3b$export$e499e02a1fe05177)[3 /* eRequestHeaders.requestIdHeader */ ] + "] as it has already been set by another instance");
                            }
                            var appId = _appId || _context && _context.appId();
                            if (appId) {
                                if (!$fa5a8e720c6a6dfc$var$_isHeaderSet(xhr, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ])) {
                                    xhr[0, $83680ca0bbc253cc$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                                    if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $921552b7fb658c3b$export$e499e02a1fe05177)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                                } else $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ] + "] as it has already been set by another instance");
                            }
                            if (_isUsingW3CHeaders) {
                                var traceFlags = ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ];
                                if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(traceFlags)) traceFlags = 0x01;
                                if (!$fa5a8e720c6a6dfc$var$_isHeaderSet(xhr, (0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ])) {
                                    var traceParent = (0, $4726195e2d737947$export$55f8c39d2c902d0d)((0, $4726195e2d737947$export$2f21fe23413fe96b)(ajaxData[0, $83680ca0bbc253cc$export$a5eb52c53bba8560 /* @min:%2etraceID */ ], ajaxData[0, $83680ca0bbc253cc$export$c105b94efa183847 /* @min:%2espanID */ ], traceFlags));
                                    xhr[0, $83680ca0bbc253cc$export$84ecd29f369f5b1d /* @min:%2esetRequestHeader */ ]((0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                                    if (_enableRequestHeaderTracking) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][(0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                                } else $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $921552b7fb658c3b$export$e499e02a1fe05177)[4 /* eRequestHeaders.traceParentHeader */ ] + "] as it has already been set by another instance");
                            }
                        }
                    }
                }
                return xhr || init;
            };
            _self[0, $83680ca0bbc253cc$export$606539098555a7e0 /* @min:%2etrackDependencyDataInternal */ ] = function(dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_distributedTracingMode === 2 /* eDistributedTracingModes.W3C */  || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ) && typeof dependency.id === "string" && dependency.id[dependency.id[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] - 1] !== ".") dependency.id += ".";
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ])) dependency[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] = new Date();
                    var item = (0, $f5d319867b0979c9$export$2dc41327de8d98f1)(dependency, (0, $97ca5e424f1910ef$export$a7b48490930dbffa).dataType, (0, $97ca5e424f1910ef$export$a7b48490930dbffa).envelopeType, _self[$fa5a8e720c6a6dfc$var$strDiagLog](), properties, systemProperties);
                    _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].track(item);
                } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) $fa5a8e720c6a6dfc$var$_throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */ , "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function(dependencyListener) {
                return $fa5a8e720c6a6dfc$var$_addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function(dependencyInitializer) {
                return $fa5a8e720c6a6dfc$var$_addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _polyfillInitialized = false; // polyfill monitoring initialized
                _currentWindowHost = location && location.host && location.host[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                _extensionConfig = null;
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
                _ignoreHeaders = null;
                _maxAjaxPerfLookupAttempts = 1;
                _ajaxPerfLookupDelay = 1;
                _distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                _appId = null;
            }
            function _populateDefaults(config) {
                _self[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                    var config = details.cfg;
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ]);
                    _extensionConfig = ctx.getExtCfg(AjaxMonitor.identifier, $fa5a8e720c6a6dfc$var$_defaultConfig);
                    _distributedTracingMode = _extensionConfig.distributedTracingMode;
                    _enableRequestHeaderTracking = _extensionConfig[0, $83680ca0bbc253cc$export$8b281196cba76bb8 /* @min:%2eenableRequestHeaderTracking */ ];
                    _enableAjaxErrorStatusText = _extensionConfig[0, $83680ca0bbc253cc$export$5300fb185e41f85f /* @min:%2eenableAjaxErrorStatusText */ ];
                    _enableAjaxPerfTracking = _extensionConfig[0, $83680ca0bbc253cc$export$c78ea26ccf911077 /* @min:%2eenableAjaxPerfTracking */ ];
                    _maxAjaxCallsPerView = _extensionConfig[0, $83680ca0bbc253cc$export$5a06e86b4597590a /* @min:%2emaxAjaxCallsPerView */ ];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[0, $83680ca0bbc253cc$export$2606d0740ec53d91 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */ ] || [], _extensionConfig.addIntEndpoints !== false ? $fa5a8e720c6a6dfc$var$_internalExcludeEndpoints : []);
                    _addRequestContext = _extensionConfig.addRequestContext;
                    _isUsingAIHeaders = _distributedTracingMode === 0 /* eDistributedTracingModes.AI */  || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                    _isUsingW3CHeaders = _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */  || _distributedTracingMode === 2 /* eDistributedTracingModes.W3C */ ;
                    if (_enableAjaxPerfTracking) _markPrefix = _ajaxDataId;
                    _disableAjaxTracking = !!_extensionConfig[0, $83680ca0bbc253cc$export$741be082275da668 /* @min:%2edisableAjaxTracking */ ];
                    _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
                    _ajaxPerfLookupDelay = _extensionConfig[0, $83680ca0bbc253cc$export$3bf8a918dbb82278 /* @min:%2eajaxPerfLookupDelay */ ];
                    _ignoreHeaders = _extensionConfig.ignoreHeaders;
                    _appId = _extensionConfig.appId;
                }));
            }
            function _populateContext() {
                var propExt = _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getPlugin((0, $5343a490b8ca01c7$export$2268e69a6d93b7cc));
                if (propExt) _context = propExt.plugin[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ]; // we could move IPropertiesPlugin to common as well
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _ignoreHeaders) (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_ignoreHeaders, function(key) {
                    if (key[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]() === header[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]()) {
                        rlt = false;
                        return -1;
                    }
                });
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = $fa5a8e720c6a6dfc$var$_supportsFetch();
                if (!fetch) return;
                var global = (0, $5831ddb3a0caf7c7$export$a4e55266d2135a7f)();
                var isPolyfill = fetch.polyfill;
                _self[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extensionConfig, function() {
                    _disableFetchTracking = !!_extensionConfig[0, $83680ca0bbc253cc$export$499c10e17a654f31 /* @min:%2edisableFetchTracking */ ];
                    _enableResponseHeaderTracking = _extensionConfig[0, $83680ca0bbc253cc$export$650df8a93357784d /* @min:%2eenableResponseHeaderTracking */ ];
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook((0, $b3babfece552aa67$export$152e6c4c396a57a)(global, $fa5a8e720c6a6dfc$var$STR_FETCH, {
                            ns: _evtNamespace,
                            // Add request hook
                            req: function(callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[0, $83680ca0bbc253cc$export$b8b43933cebcc44 /* @min:%2eincludeCorrelationHeaders */ ](fetchData, input, init);
                                    if (newInit !== init) callDetails.set(1, newInit);
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function(callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) // Replace the result with the new promise from this code
                                    callDetails.rslt = callDetails.rslt.then(function(response) {
                                        _reportFetchMetrics(callDetails, (response || {})[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ], input, response, fetchData_1, function() {
                                            var _a;
                                            var ajaxResponse = (_a = {
                                                statusText: (response || {})[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ],
                                                headerMap: null
                                            }, _a[0, $83680ca0bbc253cc$export$c4a9b5c39c7409f7 /* @min:correlationContext */ ] = _getFetchCorrelationContext(response), _a);
                                            if (_enableResponseHeaderTracking && response) {
                                                var responseHeaderMap_1 = {};
                                                response.headers.forEach(function(value, name) {
                                                    if (_canIncludeHeaders(name)) responseHeaderMap_1[name] = value;
                                                });
                                                ajaxResponse[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ] = responseHeaderMap_1;
                                            }
                                            return ajaxResponse;
                                        });
                                        return response;
                                    }).catch(function(reason) {
                                        _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, {
                                            error: reason.message || (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(reason)
                                        });
                                        throw reason;
                                    });
                                }
                            },
                            // Create an error callback to report any hook errors
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to monitor Window.fetch" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        }, true, (0, $5831ddb3a0caf7c7$export$97b87b8868ff7a3c)()));
                        _fetchInitialized = true;
                    } else if (isPolyfill && !_polyfillInitialized) {
                        // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                        // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                        // of reporting ourselves, for example React Native uses a polyfill for fetch
                        // Note: Polyfill implementations that don't support the "polyfill" tag are not supported
                        // the workaround is to add a polyfill property to your fetch implementation before initializing
                        // App Insights
                        _addHook((0, $b3babfece552aa67$export$152e6c4c396a57a)(global, $fa5a8e720c6a6dfc$var$STR_FETCH, {
                            ns: _evtNamespace,
                            req: function(callDetails, input, init) {
                                // Just call so that we record any disabled URL
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                        _polyfillInitialized = true;
                    }
                }));
                if (isPolyfill) // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                // But also supports multiple App Insights usages
                global[$fa5a8e720c6a6dfc$var$STR_FETCH].polyfill = isPolyfill;
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook((0, $b3babfece552aa67$export$6b32104a5f4313f6)(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (!$fa5a8e720c6a6dfc$var$_supportsAjaxMonitoring(_self, _ajaxDataId)) return;
                _self[0, $83680ca0bbc253cc$export$3b3afe26ca0e015c /* @min:%2e_addHook */ ]((0, $6387583e0b25820c$export$454a433e4deb244f)(_extensionConfig, function() {
                    _disableAjaxTracking = !!_extensionConfig[0, $83680ca0bbc253cc$export$741be082275da668 /* @min:%2edisableAjaxTracking */ ];
                    _enableRequestHeaderTracking = _extensionConfig[0, $83680ca0bbc253cc$export$8b281196cba76bb8 /* @min:%2eenableRequestHeaderTracking */ ];
                    if (!_disableAjaxTracking && !_xhrInitialized) {
                        // Instrument open
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function(callDetails, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState.openDone) // Only create a single ajaxData (even when multiple AI instances are running)
                                        ajaxData = _openHandler(xhr, method, url, async);
                                        // always attach to the on ready state change (required for handling multiple instances)
                                        _attachToOnReadyStateChange(xhr, ajaxData);
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + ".open" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        // Instrument send
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function(callDetails, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState.sendDone) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                                        _self[0, $83680ca0bbc253cc$export$b8b43933cebcc44 /* @min:%2eincludeCorrelationHeaders */ ](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState.sendDone = true;
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        // Instrument abort
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function(callDetails) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState.abortDone) {
                                        ajaxData[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] = 1;
                                        ajaxData.xhrMonitoringState.abortDone = true;
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + ".abort" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        // Instrument setRequestHeader
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function(callDetails, header, value) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                                    if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                        $fa5a8e720c6a6dfc$var$_addSharedXhrHeaders(xhr, header, value);
                                        if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ][header] = value;
                                    }
                                }
                            },
                            hkErr: $fa5a8e720c6a6dfc$var$_createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + ".setRequestHeader" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }));
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!(0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(request) ? (request || {}).url || "" : request) || "")[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_excludeRequestFromAutoTrackingPatterns, function(regex) {
                    var theRegex = regex;
                    if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(regex)) theRegex = new RegExp(regex);
                    if (!isDisabled) isDisabled = theRegex.test(theUrl);
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) return isDisabled;
                var idx = $fa5a8e720c6a6dfc$var$_indexOf(theUrl, "?");
                var idx2 = $fa5a8e720c6a6dfc$var$_indexOf(theUrl, "#");
                if (idx === -1 || idx2 !== -1 && idx2 < idx) idx = idx2;
                if (idx !== -1) // Strip off any Query string
                theUrl = theUrl.substring(0, idx);
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(xhr)) // Look on the XMLHttpRequest of the URL string value
                isDisabled = xhr[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true || theUrl[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true;
                else if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(request)) // Look for DisabledPropertyName in either Request or RequestInit
                isDisabled = (typeof request === "object" ? request[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true : false) || (init ? init[0, $8ac3b4fe9182f568$export$7c6abff2f2bdd9c0] === true : false);
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && (0, $d98f9809e5d6a7c7$export$edade5317663baa4)(theUrl)) isDisabled = true;
                if (isDisabled) // Add the disabled url if not present
                {
                    if (!_disabledUrls[theUrl]) _disabledUrls[theUrl] = 1;
                } else // Check to see if the url is listed as disabled
                if (_disabledUrls[theUrl]) isDisabled = true;
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(xhr)) ajaxValidation = excludeAjaxDataValidation === true || !(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(ajaxData);
                // checking to see that all interested functions on xhr were instrumented
                return initialized && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].getTraceCtx(false);
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) distributedTraceCtx = (0, $d98f9809e5d6a7c7$export$847d5dabba5fabb9)(_context.telemetryTrace);
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ]() || (0, $61bcf5b470259c00$export$58d1fad45f39d957)();
                var spanID = (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)((0, $61bcf5b470259c00$export$58d1fad45f39d957)(), 0, 16);
                var xhrRequestData = xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] = xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {
                    xh: [],
                    i: {}
                };
                var ajaxDataCntr = xhrRequestData.i = xhrRequestData.i || {};
                var ajaxData = ajaxDataCntr[_ajaxDataId] = ajaxDataCntr[_ajaxDataId] || new (0, $48c7b9d8e3de1826$export$3391d178758cbbb1)(traceID, spanID, _self[$fa5a8e720c6a6dfc$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ] = method;
                ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = url;
                ajaxData.xhrMonitoringState.openDone = true;
                ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = {};
                ajaxData.async = async;
                ajaxData[0, $83680ca0bbc253cc$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[0, $83680ca0bbc253cc$export$3f654a505433af43 /* @min:%2estateChangeAttached */ ] = (0, $02f0ede5277c99cd$export$324ab159353a60a9)(xhr, "readystatechange", function() {
                    var _a;
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) _onAjaxComplete(xhr);
                    } catch (e) {
                        var exceptionText = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || $fa5a8e720c6a6dfc$var$_indexOf(exceptionText[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](), "c00c023f") === -1) $fa5a8e720c6a6dfc$var$_throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */ , $fa5a8e720c6a6dfc$var$ERROR_HEADER + " 'readystatechange' event handler" + $fa5a8e720c6a6dfc$var$ERROR_POSTFIX, (_a = {}, _a[0, $83680ca0bbc253cc$export$7918362d3a562ff8 /* @min:ajaxDiagnosticsMessage */ ] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a.exception = exceptionText, _a));
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") // As per the specification responseText is only valid if the type is an empty string or "text"
                    return xhr[0, $83680ca0bbc253cc$export$d9f76b3afffa4e88 /* @min:%2eresponseText */ ];
                } catch (e) {
                // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = $fa5a8e720c6a6dfc$var$_getAjaxData(xhr, _ajaxDataId);
                ajaxData[0, $83680ca0bbc253cc$export$e73fbfb501e27fb9 /* @min:%2eresponseFinishedTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                ajaxData[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = xhr[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) errorProps["exception"] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e);
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , $fa5a8e720c6a6dfc$var$FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + $fa5a8e720c6a6dfc$var$ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
                    try {
                        var dependency = ajaxData[0, $83680ca0bbc253cc$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ]("Ajax", _enableRequestHeaderTracking, function() {
                            var _a;
                            var ajaxResponse = (_a = {
                                statusText: xhr[0, $83680ca0bbc253cc$export$e44f43b238a0c7f0 /* @min:%2estatusText */ ],
                                headerMap: null
                            }, _a[0, $83680ca0bbc253cc$export$c4a9b5c39c7409f7 /* @min:correlationContext */ ] = _getAjaxCorrelationContext(xhr), _a.type = xhr.responseType, _a[0, $83680ca0bbc253cc$export$d9f76b3afffa4e88 /* @min:responseText */ ] = _getResponseText(xhr), _a.response = xhr.response, _a);
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[0, $83680ca0bbc253cc$export$f5d99abda983253b /* @min:%2egetAllResponseHeaders */ ]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = (0, $5831ddb3a0caf7c7$export$ef0e11c5f5f351f7)(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(arr, function(line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) responseHeaderMap_2[header] = value;
                                    });
                                    ajaxResponse[0, $83680ca0bbc253cc$export$422ea83a60e3414b /* @min:%2eheaderMap */ ] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) properties = _addRequestContext({
                                status: xhr[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ],
                                xhr: xhr
                            });
                        } catch (e) {
                            $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $fa5a8e720c6a6dfc$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, dependency.properties), properties);
                            var sysProperties = ajaxData[0, $83680ca0bbc253cc$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ]();
                            _reportDependencyInternal(_dependencyInitializers, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                        } else _reportXhrError(null, {
                            requestSentTime: ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ],
                            responseFinishedTime: ajaxData[0, $83680ca0bbc253cc$export$e73fbfb501e27fb9 /* @min:%2eresponseFinishedTime */ ]
                        });
                    } finally{
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = xhr[$fa5a8e720c6a6dfc$var$AJAX_DATA_CONTAINER] || {
                                i: {}
                            };
                            var ajaxDataCntr = xhrRequestData.i || {};
                            if (ajaxDataCntr[_ajaxDataId]) ajaxDataCntr[_ajaxDataId] = null;
                        } catch (e) {
                        // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function(e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                var _a;
                try {
                    var responseHeadersString = xhr[0, $83680ca0bbc253cc$export$f5d99abda983253b /* @min:%2egetAllResponseHeaders */ ]();
                    if (responseHeadersString !== null) {
                        var index = $fa5a8e720c6a6dfc$var$_indexOf(responseHeadersString[0, $83680ca0bbc253cc$export$e4eaee9e01d9baaa /* @min:%2etoLowerCase */ ](), (0, $921552b7fb658c3b$export$e499e02a1fe05177)[8 /* eRequestHeaders.requestContextHeaderLowerCase */ ]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]);
                            return (0, $d98f9809e5d6a7c7$export$dbaf37203f788583)(responseHeader);
                        }
                    }
                } catch (e) {
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $fa5a8e720c6a6dfc$var$CORRELATION_HEADER_ERROR, (_a = {}, _a[0, $83680ca0bbc253cc$export$7918362d3a562ff8 /* @min:ajaxDiagnosticsMessage */ ] = $fa5a8e720c6a6dfc$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a.exception = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e), _a));
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
                    if (performance_1 && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(performance_1.mark)) {
                        $fa5a8e720c6a6dfc$var$_markCount++;
                        var markId = _markPrefix + type + "#" + $fa5a8e720c6a6dfc$var$_markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] === 1) ajaxData[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ] = entries[0];
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[0, $83680ca0bbc253cc$export$9e85e7b326182790 /* @min:%2eperfMark */ ];
                var performance = (0, $5831ddb3a0caf7c7$export$28a0276e10aa78d7)();
                var maxAttempts = _maxAjaxPerfLookupAttempts;
                var retryDelay = _ajaxPerfLookupDelay;
                var requestUrl = ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for(var lp = entries[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ] - 1; lp >= 0; lp--){
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType && ($fa5a8e720c6a6dfc$var$_indexOf(entry.name, requestUrl) !== -1 || $fa5a8e720c6a6dfc$var$_indexOf(requestUrl, entry.name) !== -1)) perfTiming = entry;
                                    } else if (entry.entryType === "mark" && entry.name === perfMark.name) {
                                        // We hit the start event
                                        ajaxData[0, $83680ca0bbc253cc$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ] = perfTiming;
                                        break;
                                    }
                                    if (entry[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] < perfMark[0, $83680ca0bbc253cc$export$69cac26425c8ea23 /* @min:%2estartTime */ ] - 1000) break;
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                        ajaxData[0, $83680ca0bbc253cc$export$6bec4987b5d3526c /* @min:%2eperfTiming */ ] || // - we have not found the perf entry or
                        attempt >= maxAttempts || // - we have tried too many attempts or
                        ajaxData.async === false) {
                            if (perfMark && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(performance.clearMarks)) // Remove the mark so we don't fill up the performance resources too much
                            performance.clearMarks(perfMark.name);
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        } else // We need to wait for the browser to populate the window.performance entry
                        // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                        // this is a scheduling issue for the browser implementation
                        (0, $5831ddb3a0caf7c7$export$5f4d6617421d489b)(locateResourceTiming, retryDelay);
                    } catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$90dab0fe9b2b7158 /* @min:%2egetTraceId */ ]() || (0, $61bcf5b470259c00$export$58d1fad45f39d957)();
                var spanID = (0, $5831ddb3a0caf7c7$export$25b2a9bb66b0078d)((0, $61bcf5b470259c00$export$58d1fad45f39d957)(), 0, 16);
                var ajaxData = new (0, $48c7b9d8e3de1826$export$3391d178758cbbb1)(traceID, spanID, _self[$fa5a8e720c6a6dfc$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $83680ca0bbc253cc$export$4e92e4b92b41ba2d /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $83680ca0bbc253cc$export$1fd22cf8d803736f /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                ajaxData[0, $83680ca0bbc253cc$export$cce28811c9041832 /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                var requestUrl;
                if (input instanceof Request) requestUrl = (input || {}).url || "";
                else requestUrl = input;
                if (requestUrl === "") {
                    var location_1 = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
                    if (location_1 && location_1.href) requestUrl = (0, $5831ddb3a0caf7c7$export$c07560e259c81ec6)(location_1.href, "#")[0];
                }
                if (_self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ] && _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].config) requestUrl = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(requestUrl, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ].config);
                ajaxData[0, $83680ca0bbc253cc$export$8ff033ecd75b66c3 /* @min:%2erequestUrl */ ] = requestUrl;
                var method = "GET";
                if (init && init[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ]) method = init[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                else if (input && input instanceof Request) method = input[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ];
                ajaxData[0, $83680ca0bbc253cc$export$47d30bd816d62bdc /* @min:%2emethod */ ] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] : 0) || (input instanceof Request ? input[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ] || {} : {}));
                    headers.forEach(function(value, key) {
                        if (_canIncludeHeaders(key)) requestHeaders[key] = value;
                    });
                }
                ajaxData[0, $83680ca0bbc253cc$export$b58618e731cdb301 /* @min:%2erequestHeaders */ ] = requestHeaders;
                _createMarkId($fa5a8e720c6a6dfc$var$STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(input)) {
                        if (typeof input === "string") result += "(url: '".concat(input, "')");
                        else result += "(url: '".concat(input.url, "')");
                    }
                } catch (e) {
                    $fa5a8e720c6a6dfc$var$_throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to grab failed fetch diagnostics message", {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) return;
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) errorProps["exception"] = (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e);
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, msgId, $fa5a8e720c6a6dfc$var$FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + $fa5a8e720c6a6dfc$var$ERROR_NOT_SENT, errorProps);
                }
                ajaxData[0, $83680ca0bbc253cc$export$e73fbfb501e27fb9 /* @min:%2eresponseFinishedTime */ ] = (0, $d98f9809e5d6a7c7$export$30a447e32c58a836)();
                ajaxData[0, $83680ca0bbc253cc$export$f8d169088a01f6f2 /* @min:%2estatus */ ] = status;
                _findPerfResourceEntry($fa5a8e720c6a6dfc$var$STR_FETCH, ajaxData, function() {
                    var dependency = ajaxData[0, $83680ca0bbc253cc$export$e31aceb60e1b3a1a /* @min:%2eCreateTrackItem */ ]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) properties = _addRequestContext({
                            status: status,
                            request: input,
                            response: response
                        });
                    } catch (e) {
                        $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $fa5a8e720c6a6dfc$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) dependency[0, $8291b597e9a6dfe3$export$400e70f2a2ecb5aa /* @min:%2eproperties */ ] = (0, $dc463ff9724142dd$export$b3cf7a802e578501)((0, $dc463ff9724142dd$export$b3cf7a802e578501)({}, dependency.properties), properties);
                        var sysProperties = ajaxData[0, $83680ca0bbc253cc$export$e2e640c31408a88f /* @min:%2egetPartAProps */ ]();
                        _reportDependencyInternal(_dependencyInitializers, _self[0, $83680ca0bbc253cc$export$f9ae8d0acf86503e /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                    } else _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , null, {
                        requestSentTime: ajaxData[0, $83680ca0bbc253cc$export$b3507d39ae3f3e22 /* @min:%2erequestSentTime */ ],
                        responseFinishedTime: ajaxData[0, $83680ca0bbc253cc$export$e73fbfb501e27fb9 /* @min:%2eresponseFinishedTime */ ]
                    });
                }, function(e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                if (response && response[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ]) try {
                    var responseHeader = response[0, $83680ca0bbc253cc$export$829ed22a43b4aada /* @min:%2eheaders */ ].get((0, $921552b7fb658c3b$export$e499e02a1fe05177)[0 /* eRequestHeaders.requestContextHeader */ ]);
                    return (0, $d98f9809e5d6a7c7$export$dbaf37203f788583)(responseHeader);
                } catch (e) {
                    $fa5a8e720c6a6dfc$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $fa5a8e720c6a6dfc$var$CORRELATION_HEADER_ERROR, {
                        fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var result = true;
                var initializersCount = initializers[0, $83680ca0bbc253cc$export$6eae51590aaea43 /* @min:%2elength */ ];
                if (initializersCount > 0) {
                    var details = {
                        item: dependency,
                        properties: properties,
                        sysProperties: systemProperties,
                        context: ajaxData ? ajaxData[0, $83680ca0bbc253cc$export$fdcd48959e13aba7 /* @min:%2econtext */ ] : null,
                        aborted: ajaxData ? !!ajaxData[0, $83680ca0bbc253cc$export$fcf18cee9ee41961 /* @min:%2eaborted */ ] : false
                    };
                    result = $fa5a8e720c6a6dfc$var$_processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) _self[0, $83680ca0bbc253cc$export$606539098555a7e0 /* @min:%2etrackDependencyDataInternal */ ](dependency, properties, systemProperties);
            }
        });
        return _this;
    }
    // Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function(item, itemCtx) {
        this.processNext(item, itemCtx);
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyData.
    // Removed Stub for AjaxMonitor.prototype.resetAjaxAttempts.
    // Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
    // Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AjaxMonitor.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/ 




/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/ 


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1b92b75e30847feb$export$16975c34e60e1e61 = /** @class */ function() {
    function Application() {}
    return Application;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $885938404d9e4878$export$8215d14a63d9fb10 = /** @class */ function() {
    /**
     * Constructs a new instance of the Device class
     */ function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $5ff137899dd4083e$var$Version = '3.3.10';
var $5ff137899dd4083e$export$81742925a72ee8f2 = /** @class */ function() {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */ function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + $5ff137899dd4083e$var$Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $1f89f396e0e70995$export$18a2be9195644f38 = /** @class */ function() {
    function Location() {}
    return Location;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $55134f1c835b6d44$export$b721048bdae49e48 = "session"; // Count: 4
var $55134f1c835b6d44$export$1c39d669bde62767 = "sessionManager"; // Count: 3
var $55134f1c835b6d44$export$52b1fe3e70f4c699 = "isUserCookieSet"; // Count: 4
var $55134f1c835b6d44$export$e8019acdc6dfe227 = "isNewUser"; // Count: 4
var $55134f1c835b6d44$export$2d15b9b0e9d1daaa = "getTraceCtx"; // Count: 3
var $55134f1c835b6d44$export$805965d0d38cc4a5 = "telemetryTrace"; // Count: 3
var $55134f1c835b6d44$export$585a4eb45f8043ec = "applySessionContext"; // Count: 2
var $55134f1c835b6d44$export$5c833c29ed72a760 = "applyApplicationContext"; // Count: 2
var $55134f1c835b6d44$export$a6c599a5c1ab6761 = "applyOperationContext"; // Count: 2
var $55134f1c835b6d44$export$dddc87038d37bcef = "applyOperatingSystemContxt"; // Count: 2
var $55134f1c835b6d44$export$4768decfd4f15bcf = "applyLocationContext"; // Count: 2
var $55134f1c835b6d44$export$348ac062a116e27c = "applyInternalContext"; // Count: 2
var $55134f1c835b6d44$export$3af04f76fec134a = "getSessionId"; // Count: 4
var $55134f1c835b6d44$export$d2109757a25c372a = "sessionCookiePostfix"; // Count: 2
var $55134f1c835b6d44$export$4d608086992f55c7 = "automaticSession"; // Count: 6
var $55134f1c835b6d44$export$f251a1587d4aac90 = "accountId"; // Count: 6
var $55134f1c835b6d44$export$574ff42e0e7ce0c = "authenticatedId"; // Count: 6
var $55134f1c835b6d44$export$8c9471ee03377604 = "acquisitionDate"; // Count: 5
var $55134f1c835b6d44$export$7254663b30b11264 = "renewalDate"; // Count: 4
var $55134f1c835b6d44$export$57599fb6aa598bd4 = "cookieSeparator"; // Count: 5
var $55134f1c835b6d44$export$7bdc84f949b24ffd = "authUserCookieName"; // Count: 3


var $f111a398d037d42b$var$SESSION_COOKIE_NAME = "ai_session";
var $f111a398d037d42b$var$ACQUISITION_SPAN = 86400000; // 24 hours in ms
var $f111a398d037d42b$var$RENEWAL_SPAN = 1800000; // 30 minutes in ms
var $f111a398d037d42b$var$COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var $f111a398d037d42b$export$1fb4852a55678982 = /** @class */ function() {
    function Session() {}
    return Session;
}();
var $f111a398d037d42b$export$9a3efd42578d1f11 = /** @class */ function() {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
        var _cookieManager = (0, $aaa64f3935d14265$export$76c0b273586c25c7)(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(_SessionManager, self, function(_self) {
            if (!config) config = {};
            var unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                _sessionExpirationMs = config.sessionExpirationMs || $f111a398d037d42b$var$ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || $f111a398d037d42b$var$RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config[0, $55134f1c835b6d44$export$d2109757a25c372a /* @min:%2esessionCookiePostfix */ ] || config.namePrefix || "";
                _storageNamePrefix = $f111a398d037d42b$var$SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ] = new $f111a398d037d42b$export$1fb4852a55678982();
            _self.update = function() {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = (0, $5831ddb3a0caf7c7$export$a56f095995763cca)();
                var isExpired = false;
                var session = _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                if (!session.id) isExpired = !_initializeAutomaticSession(session, nowMs);
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ];
                    var timeSinceRenewalMs = nowMs - session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) // update automaticSession so session state has correct id
                _renew(nowMs);
                else // do not update the cookie more often than cookieUpdateInterval
                if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > $f111a398d037d42b$var$COOKIE_UPDATE_INTERVAL) _setCookie(session, nowMs);
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */ _self.backup = function() {
                var session = _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                _setStorage(session.id, session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ], session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(cookieValue.split)) isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = (0, $3fab9bbcce274f86$export$c3876355f131c85c)(_logger, _storageNamePrefix);
                    if (storageValue) isValid = _initializeAutomaticSessionWithData(session, storageValue);
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens.length >= 2) try {
                    var acqMs = +tokens[1] || 0;
                    var renewalMs = +tokens[2] || 0;
                    if (isNaN(acqMs) || acqMs <= 0) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session acquisition date is 0" + sessionReset);
                    else if (isNaN(renewalMs) || renewalMs <= 0) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session renewal date is 0" + sessionReset);
                    else if (tokens[0]) {
                        // Everything looks valid so set the values
                        session.id = tokens[0];
                        session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ] = acqMs;
                        session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ] = renewalMs;
                        isValid = true;
                    }
                } catch (e) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */ , "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + (0, $ede407819d2d28c9$export$39c4487b36c98fec)(e), {
                        exception: (0, $5831ddb3a0caf7c7$export$21fce7cbd4dc679f)(e)
                    });
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config.getNewId || (0, $dfdef4661b59546e$export$9ffd10a3fbdc175b);
                _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ].id = getNewId(config.idLength || 22);
                _self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ][0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ] = nowMs;
                _setCookie(_self[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!(0, $3fab9bbcce274f86$export$f28746933126d63f)()) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */ , "Browser does not support local storage. Session durations will be inaccurate.");
            }
            function _setCookie(session, nowMs) {
                var acq = session[0, $55134f1c835b6d44$export$8c9471ee03377604 /* @min:%2eacquisitionDate */ ];
                session[0, $55134f1c835b6d44$export$7254663b30b11264 /* @min:%2erenewalDate */ ] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = acq + _sessionExpirationMs - nowMs;
                var cookie = [
                    session.id,
                    acq,
                    nowMs
                ];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) maxAgeSec = acqTimeLeftMs / 1000;
                else maxAgeSec = renewalPeriodMs / 1000;
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie.join("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                (0, $3fab9bbcce274f86$export$631bce20500dc098)(_logger, _storageNamePrefix, [
                    guid,
                    acq,
                    renewal
                ].join("|"));
            }
        });
    }
    // Removed Stub for _SessionManager.prototype.update.
    // Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn = 1;
    return _SessionManager;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 

var $9696d76715c00784$export$d65492b1f626b9ec = /** @class */ function() {
    function TelemetryTrace(id, parentId, name, logger, config) {
        var _self = this;
        _self.traceID = id || (0, $61bcf5b470259c00$export$58d1fad45f39d957)();
        _self.parentID = parentId;
        var location = (0, $0d2c2fb24388dcf8$export$e7fd20fad3cf4b5f)();
        if (!name && location && location.pathname) {
            name = location.pathname;
            if (config) name = (0, $0d2c2fb24388dcf8$export$96efba388500ac9c)(name, config);
        }
        _self.name = (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, name);
    }
    return TelemetryTrace;
}();


/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 




function $78e506bf511dec78$var$_validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) return false;
    return true;
}
var $78e506bf511dec78$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */ this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */ this.isUserCookieSet = false;
        var _logger = (0, $bacca83328a730a7$export$5102d32ea1d740a)(core);
        var _cookieManager = (0, $aaa64f3935d14265$export$76c0b273586c25c7)(core);
        var _storageNamePrefix;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(User, this, function(_self) {
            // Define _self.config
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                g: function() {
                    return config;
                }
            });
            var unloadHook = (0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                var userCookiePostfix = config.userCookiePostfix || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = false;
                    var params = cookie.split(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                    if (params.length > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie.join(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config.namePrefix || "") + "ai_session";
                    (0, $3fab9bbcce274f86$export$63137c65c2cc6743)(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = config[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[0, $55134f1c835b6d44$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                    if (authCookieString[0]) _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = authCookieString[0];
                    if (authCookieString.length > 1 && authCookieString[1]) _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = authCookieString[1];
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = config || {};
                var getNewId = theConfig.getNewId || (0, $dfdef4661b59546e$export$9ffd10a3fbdc175b);
                var id = getNewId(theConfig.idLength ? config.idLength : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = (0, $ede407819d2d28c9$export$dfaaa8705752128f)(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = true;
                var newCookie = [
                    userId,
                    acqStr
                ];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) storeInCookie = false;
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !$78e506bf511dec78$var$_validateUserInput(authenticatedUserId) || accountId && !$78e506bf511dec78$var$_validateUserInput(accountId);
                if (isInvalidInput) {
                    (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_logger, 2 /* eLoggingSeverity.WARNING */ , 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */ , "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = authenticatedUserId;
                var authCookie = _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ];
                if (accountId) {
                    _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = accountId;
                    authCookie = [
                        _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ],
                        _self.accountId
                    ].join(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]);
                }
                if (storeInCookie) // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                // Encoding the cookie to handle unexpected unicode characters.
                _cookieManager.set(User[0, $55134f1c835b6d44$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ], encodeURI(authCookie));
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */ _self.clearAuthenticatedUserContext = function() {
                _self[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ] = null;
                _self[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ] = null;
                _cookieManager.del(User[0, $55134f1c835b6d44$export$7bdc84f949b24ffd /* @min:%2eauthUserCookieName */ ]);
            };
            _self.update = function(userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie.join(User[0, $55134f1c835b6d44$export$57599fb6aa598bd4 /* @min:%2ecookieSeparator */ ]));
                }
            };
        });
    }
    // Removed Stub for User.prototype.setAuthenticatedUserContext.
    // Removed Stub for User.prototype.clearAuthenticatedUserContext.
    // Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}();



var $979b887352d12f37$var$strExt = "ext";
var $979b887352d12f37$var$strTags = "tags";
function $979b887352d12f37$var$_removeEmpty(target, name) {
    if (target && target[name] && (0, $5831ddb3a0caf7c7$export$f7628dc18f4211e5)(target[name]).length === 0) delete target[name];
}
function $979b887352d12f37$var$_nullResult() {
    return null;
}
var $979b887352d12f37$export$7b6b7bc4acb29126 = /** @class */ function() {
    function TelemetryContext(core, defaultConfig, previousTraceCtx, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(TelemetryContext, this, function(_self) {
            _self.appId = $979b887352d12f37$var$_nullResult;
            _self[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:%2egetSessionId */ ] = $979b887352d12f37$var$_nullResult;
            _self.application = new (0, $1b92b75e30847feb$export$16975c34e60e1e61)();
            _self.internal = new (0, $5ff137899dd4083e$export$81742925a72ee8f2)(defaultConfig, unloadHookContainer);
            if ((0, $5831ddb3a0caf7c7$export$fef62134eea24008)()) {
                _self[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ] = new (0, $f111a398d037d42b$export$9a3efd42578d1f11)(defaultConfig, core, unloadHookContainer);
                _self.device = new (0, $885938404d9e4878$export$8215d14a63d9fb10)();
                _self.location = new (0, $1f89f396e0e70995$export$18a2be9195644f38)();
                _self.user = new (0, $78e506bf511dec78$export$1f44aaf2ec115b54)(defaultConfig, core, unloadHookContainer);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[0, $55134f1c835b6d44$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ] = new (0, $9696d76715c00784$export$d65492b1f626b9ec)(traceId, parentId, name_1, logger);
                _self[0, $55134f1c835b6d44$export$b721048bdae49e48 /* @min:%2esession */ ] = new (0, $f111a398d037d42b$export$1fb4852a55678982)();
            }
            _self[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:%2egetSessionId */ ] = function() {
                var session = _self[0, $55134f1c835b6d44$export$b721048bdae49e48 /* @min:%2esession */ ];
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(session.id)) sesId = session.id;
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ] || {})[0, $55134f1c835b6d44$export$4d608086992f55c7 /* @min:%2eautomaticSession */ ];
                    sesId = autoSession && (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[0, $55134f1c835b6d44$export$585a4eb45f8043ec /* @min:%2eapplySessionContext */ ] = function(evt, itemCtx) {
                (0, $ede407819d2d28c9$export$80746c6bc6142fc8)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt.ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).AppExt), "sesId", _self[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:%2egetSessionId */ ](), (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
            };
            _self[0, $55134f1c835b6d44$export$dddc87038d37bcef /* @min:%2eapplyOperatingSystemContxt */ ] = function(evt, itemCtx) {
                (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(evt.ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).OSExt, _self.os);
            };
            _self[0, $55134f1c835b6d44$export$5c833c29ed72a760 /* @min:%2eapplyApplicationContext */ ] = function(evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).applicationVersion, application.ver, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).applicationBuild, application.build, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                }
            };
            _self.applyDeviceContext = function(evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = (0, $ede407819d2d28c9$export$51417ccc212471e)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).DeviceExt);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "localId", device.id, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "ip", device.ip, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "model", device.model, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extDevice, "deviceClass", device.deviceClass, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                }
            };
            _self[0, $55134f1c835b6d44$export$348ac062a116e27c /* @min:%2eapplyInternalContext */ ] = function(evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalAgentVersion, internal.agentVersion, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54)); // not mapped in CS 4.0
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkVersion, (0, $3ad7e6398fcf0cbb$export$4e25b1d4bcd67eb8)(logger, internal.sdkVersion, 64), (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    if (evt.baseType === (0, $bacca83328a730a7$export$70ef838ed08aad47).dataType || evt.baseType === (0, $3e77672805d15946$export$12c0fdede1c6bc6c).dataType) {
                        (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSnippet, internal.snippetVer, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                        (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).internalSdkSrc, internal.sdkSrc, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    }
                }
            };
            _self[0, $55134f1c835b6d44$export$4768decfd4f15bcf /* @min:%2eapplyLocationContext */ ] = function(evt, itemCtx) {
                var location = _this.location;
                if (location) (0, $ede407819d2d28c9$export$80746c6bc6142fc8)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags, []), (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).locationIp, location.ip, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
            };
            _self[0, $55134f1c835b6d44$export$a6c599a5c1ab6761 /* @min:%2eapplyOperationContext */ ] = function(evt, itemCtx) {
                var telemetryTrace = _self[0, $55134f1c835b6d44$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ];
                if (telemetryTrace) {
                    var extTrace = (0, $ede407819d2d28c9$export$51417ccc212471e)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).TraceExt, {
                        traceID: undefined,
                        parentID: undefined
                    });
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extTrace, "traceID", telemetryTrace.traceID, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54), (0, $5831ddb3a0caf7c7$export$bedb7023a7733221));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extTrace, "name", telemetryTrace.name, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54), (0, $5831ddb3a0caf7c7$export$bedb7023a7733221));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extTrace, "parentID", telemetryTrace.parentID, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54), (0, $5831ddb3a0caf7c7$export$bedb7023a7733221));
                }
            };
            _self.applyWebContext = function(evt, itemCtx) {
                var web = _this.web;
                if (web) (0, $ede407819d2d28c9$export$80746c6bc6142fc8)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).WebExt, web);
            };
            _self.applyUserContext = function(evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strTags, []);
                    // stays in tags
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(tags, (0, $6e37c6a219f9960f$export$ebc7727f2a4272f6).userAccountId, user[0, $55134f1c835b6d44$export$f251a1587d4aac90 /* @min:%2eaccountId */ ], (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    // CS 4.0
                    var extUser = (0, $ede407819d2d28c9$export$51417ccc212471e)((0, $ede407819d2d28c9$export$51417ccc212471e)(evt, $979b887352d12f37$var$strExt), (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).UserExt);
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extUser, "id", user.id, (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                    (0, $ede407819d2d28c9$export$80746c6bc6142fc8)(extUser, "authId", user[0, $55134f1c835b6d44$export$574ff42e0e7ce0c /* @min:%2eauthenticatedId */ ], (0, $5831ddb3a0caf7c7$export$844ec244b1367d54));
                }
            };
            _self.cleanUp = function(evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).DeviceExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).UserExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).WebExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).OSExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).AppExt);
                    $979b887352d12f37$var$_removeEmpty(ext, (0, $6e37c6a219f9960f$export$152f4bb29f8263d0).TraceExt);
                }
            };
        });
    }
    // Removed Stub for TelemetryContext.prototype.applySessionContext.
    // Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
    // Removed Stub for TelemetryContext.prototype.applyApplicationContext.
    // Removed Stub for TelemetryContext.prototype.applyDeviceContext.
    // Removed Stub for TelemetryContext.prototype.applyInternalContext.
    // Removed Stub for TelemetryContext.prototype.applyLocationContext.
    // Removed Stub for TelemetryContext.prototype.applyOperationContext.
    // Removed Stub for TelemetryContext.prototype.applyWebContext.
    // Removed Stub for TelemetryContext.prototype.applyUserContext.
    // Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn = 1;
    return TelemetryContext;
}();



var $23e243b798ea743c$var$_a;
var $23e243b798ea743c$var$undefString;
var $23e243b798ea743c$var$nullValue = null;
var $23e243b798ea743c$var$_defaultConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)(($23e243b798ea743c$var$_a = {
    accountId: $23e243b798ea743c$var$nullValue,
    sessionRenewalMs: 1800000,
    samplingPercentage: 100,
    sessionExpirationMs: 86400000,
    cookieDomain: $23e243b798ea743c$var$nullValue,
    sdkExtension: $23e243b798ea743c$var$nullValue,
    isBrowserLinkTrackingEnabled: false,
    appId: $23e243b798ea743c$var$nullValue
}, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$3af04f76fec134a /* @min:getSessionId */ ] = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a.namePrefix = $23e243b798ea743c$var$undefString, $23e243b798ea743c$var$_a[0, $55134f1c835b6d44$export$d2109757a25c372a /* @min:sessionCookiePostfix */ ] = $23e243b798ea743c$var$undefString, $23e243b798ea743c$var$_a.userCookiePostfix = $23e243b798ea743c$var$undefString, $23e243b798ea743c$var$_a.idLength = 22, $23e243b798ea743c$var$_a.getNewId = $23e243b798ea743c$var$nullValue, $23e243b798ea743c$var$_a));
var $23e243b798ea743c$var$PropertiesPlugin = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = (0, $5343a490b8ca01c7$export$2268e69a6d93b7cc);
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        var _context;
        var _disableUserInitMessage;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(PropertiesPlugin, _this, function(_self, _base) {
            _initDefaults();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "context", {
                g: function() {
                    return _context;
                }
            });
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */ _self.processTelemetry = function(event, itemCtx) {
                if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === (0, $3e77672805d15946$export$12c0fdede1c6bc6c).envelopeType) itemCtx.diagLog().resetInternalMessageCount();
                    var theContext = _context || {};
                    if (theContext[0, $55134f1c835b6d44$export$b721048bdae49e48 /* @min:%2esession */ ]) // If customer did not provide custom session id update the session manager
                    {
                        if (typeof _context[0, $55134f1c835b6d44$export$b721048bdae49e48 /* @min:%2esession */ ].id !== "string" && theContext[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ]) theContext[0, $55134f1c835b6d44$export$1c39d669bde62767 /* @min:%2esessionManager */ ].update();
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[0, $55134f1c835b6d44$export$52b1fe3e70f4c699 /* @min:%2eisUserCookieSet */ ]) userCtx.update(theContext.user.id);
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ]) {
                        userCtx[0, $55134f1c835b6d44$export$e8019acdc6dfe227 /* @min:%2eisNewUser */ ] = false;
                        if (!_disableUserInitMessage) {
                            var message = new (0, $bacca83328a730a7$export$70ef838ed08aad47)(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */ , ((0, $5831ddb3a0caf7c7$export$a56241c767c1d89f)() || {}).userAgent || "");
                            (0, $bacca83328a730a7$export$e15fbe42d9bc9d3d)(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */ , message);
                        }
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[0, $55134f1c835b6d44$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ]) {
                    var traceCtx = core[0, $55134f1c835b6d44$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ](false);
                    if (traceCtx === _distributedTraceCtx) core.setTraceCtx(_previousTraceCtx);
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
                _context = null;
                _disableUserInitMessage = true;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function() {
                    var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, config, core);
                    if (config.storagePrefix) (0, $3fab9bbcce274f86$export$a08dccf4adbf6df9)(config.storagePrefix);
                    _disableUserInitMessage = config.disableUserInitMessage === false ? false : true;
                    _extensionConfig = ctx.getExtCfg(identifier, $23e243b798ea743c$var$_defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _previousTraceCtx = core[0, $55134f1c835b6d44$export$2d15b9b0e9d1daaa /* @min:%2egetTraceCtx */ ](false);
                _context = new (0, $979b887352d12f37$export$7b6b7bc4acb29126)(core, _extensionConfig, _previousTraceCtx, _self._unloadHooks);
                _distributedTraceCtx = (0, $d98f9809e5d6a7c7$export$847d5dabba5fabb9)(_self.context[0, $55134f1c835b6d44$export$805965d0d38cc4a5 /* @min:%2etelemetryTrace */ ], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function() {
                    var breezeChannel = core.getPlugin((0, $5343a490b8ca01c7$export$a714a094d3058c99));
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, "tags", []);
                (0, $ede407819d2d28c9$export$51417ccc212471e)(evt, "ext", {});
                var ctx = _self.context;
                ctx[0, $55134f1c835b6d44$export$585a4eb45f8043ec /* @min:%2eapplySessionContext */ ](evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$5c833c29ed72a760 /* @min:%2eapplyApplicationContext */ ](evt, itemCtx);
                ctx.applyDeviceContext(evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$a6c599a5c1ab6761 /* @min:%2eapplyOperationContext */ ](evt, itemCtx);
                ctx.applyUserContext(evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$dddc87038d37bcef /* @min:%2eapplyOperatingSystemContxt */ ](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[0, $55134f1c835b6d44$export$4768decfd4f15bcf /* @min:%2eapplyLocationContext */ ](evt, itemCtx); // legacy tags
                ctx[0, $55134f1c835b6d44$export$348ac062a116e27c /* @min:%2eapplyInternalContext */ ](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    // Removed Stub for PropertiesPlugin.prototype.initialize.
    // Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn = 1;
    return PropertiesPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));
var $23e243b798ea743c$export$2e2bcd8739ae039 = $23e243b798ea743c$var$PropertiesPlugin;




/*
 * Application Insights JavaScript SDK - Web, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $b3f475366d0d8052$var$_AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var $b3f475366d0d8052$var$_TRACK = "track";
var $b3f475366d0d8052$export$5e8607ab26634759 = "";
var $b3f475366d0d8052$export$c40a95bd1f19a04a = "snippet";
var $b3f475366d0d8052$export$da4182b670dc48ff = "getCookieMgr";
var $b3f475366d0d8052$export$4dff843ac2d49cae = "startTrackPage";
var $b3f475366d0d8052$export$83ac403ed0121674 = "stopTrackPage";
var $b3f475366d0d8052$export$36b97ab40aae74fe = "flush";
var $b3f475366d0d8052$export$5ac4d387b85102 = "startTrackEvent";
var $b3f475366d0d8052$export$7895813056375cb = "stopTrackEvent";
var $b3f475366d0d8052$export$40f0bd7f5212655f = "addTelemetryInitializer";
var $b3f475366d0d8052$export$98706f009830c697 = $b3f475366d0d8052$export$40f0bd7f5212655f + "s";
var $b3f475366d0d8052$export$6030ed320bde556b = "pollInternalLogs";
var $b3f475366d0d8052$export$59cf80c2878d98fc = "getPlugin";
var $b3f475366d0d8052$export$657de6e6c53d3d4b = "evtNamespace";
var $b3f475366d0d8052$export$2a937c908483aaba = $b3f475366d0d8052$var$_TRACK + "Event";
var $b3f475366d0d8052$export$6a76308d410f3214 = $b3f475366d0d8052$var$_TRACK + "Trace";
var $b3f475366d0d8052$export$f73efacb9b6b9a35 = $b3f475366d0d8052$var$_TRACK + "Metric";
var $b3f475366d0d8052$export$96dcb75b34c1a4 = $b3f475366d0d8052$var$_TRACK + "PageView";
var $b3f475366d0d8052$export$5a8b50b634878942 = $b3f475366d0d8052$var$_TRACK + "Exception";
var $b3f475366d0d8052$export$ab9c6dcf6c4e2bbc = $b3f475366d0d8052$var$_TRACK + "DependencyData";
var $b3f475366d0d8052$export$94666ce386bd4f64 = "set" + $b3f475366d0d8052$var$_AUTHENTICATED_USER_CONTEXT;
var $b3f475366d0d8052$export$f920535c288b298f = "clear" + $b3f475366d0d8052$var$_AUTHENTICATED_USER_CONTEXT;
var $b3f475366d0d8052$export$3d96e9cd6640c426 = "https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json";


/*
 * Application Insights JavaScript SDK - Web, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $15293b9a79d9f5bb$export$1160203e21ea532 = "connectionString"; // Count: 4
var $15293b9a79d9f5bb$export$568c4302d11f2b22 = "version"; // Count: 6
var $15293b9a79d9f5bb$export$a1c208448cc1b3be = "queue"; // Count: 6
var $15293b9a79d9f5bb$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 5
var $15293b9a79d9f5bb$export$94c19de246c88ec = "userOverrideEndpointUrl"; // Count: 6
var $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 5
var $15293b9a79d9f5bb$export$f30bfb116278d530 = "onunloadFlush"; // Count: 6
var $15293b9a79d9f5bb$export$fdcd48959e13aba7 = "context"; // Count: 5
var $15293b9a79d9f5bb$export$1005ab001db54adc = "addHousekeepingBeforeUnload"; // Count: 2
var $15293b9a79d9f5bb$export$b6508117e9f77f7f = "sendMessage"; // Count: 3
var $15293b9a79d9f5bb$export$e8d1780b2404d6a2 = "updateSnippetDefinitions"; // Count: 2


"use strict";
var $c39992e8a81e1e47$var$_a, $c39992e8a81e1e47$var$_b, $c39992e8a81e1e47$var$_c, $c39992e8a81e1e47$var$_d;
var $c39992e8a81e1e47$var$_internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var $c39992e8a81e1e47$var$_ignoreUpdateSnippetProperties = [
    (0, $b3f475366d0d8052$export$c40a95bd1f19a04a),
    "dependencies",
    "properties",
    "_snippetVersion",
    "appInsightsNew",
    "getSKUDefaults"
];
var $c39992e8a81e1e47$var$IKEY_USAGE = "iKeyUsage";
var $c39992e8a81e1e47$var$CDN_USAGE = "CdnUsage";
var $c39992e8a81e1e47$var$SDK_LOADER_VER = "SdkLoaderVer";
var $c39992e8a81e1e47$var$ZIP_PAYLOAD = "zipPayload";
var $c39992e8a81e1e47$var$UNDEFINED_VALUE = undefined;
var $c39992e8a81e1e47$var$default_limit = {
    samplingRate: 100,
    maxSendNumber: 1
};
var $c39992e8a81e1e47$var$default_interval = {
    monthInterval: 3,
    daysOfMonth: [
        28
    ]
};
var $c39992e8a81e1e47$var$default_throttle_config = {
    disabled: true,
    limit: (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_limit),
    interval: (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_interval)
};
// We need to include all properties that we only reference that we want to be dynamically updatable here
// So they are converted even when not specified in the passed configuration
var $c39992e8a81e1e47$var$defaultConfigValues = ($c39992e8a81e1e47$var$_a = {}, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:connectionString */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a.endpointUrl = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:instrumentationKey */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a[0, $15293b9a79d9f5bb$export$94c19de246c88ec /* @min:userOverrideEndpointUrl */ ] = $c39992e8a81e1e47$var$UNDEFINED_VALUE, $c39992e8a81e1e47$var$_a.diagnosticLogInterval = (0, $3b63eef6ee7529a9$export$d0884590a6a82e6c)($c39992e8a81e1e47$var$_chkDiagLevel, 10000), $c39992e8a81e1e47$var$_a.featureOptIn = ($c39992e8a81e1e47$var$_b = {}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$IKEY_USAGE] = {
    mode: 3 /* FeatureOptInMode.enable */ 
}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$CDN_USAGE] = {
    mode: 2 /* FeatureOptInMode.disable */ 
}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$SDK_LOADER_VER] = {
    mode: 2 /* FeatureOptInMode.disable */ 
}, $c39992e8a81e1e47$var$_b[$c39992e8a81e1e47$var$ZIP_PAYLOAD] = {
    mode: 1 /* FeatureOptInMode.none */ 
}, $c39992e8a81e1e47$var$_b), $c39992e8a81e1e47$var$_a.throttleMgrCfg = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)(($c39992e8a81e1e47$var$_c = {}, $c39992e8a81e1e47$var$_c[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c[106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c[111 /* _eInternalMessageId.SdkLdrUpdate */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c[110 /* _eInternalMessageId.CdnDeprecation */ ] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)($c39992e8a81e1e47$var$default_throttle_config), $c39992e8a81e1e47$var$_c)), $c39992e8a81e1e47$var$_a.extensionConfig = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)(($c39992e8a81e1e47$var$_d = {}, $c39992e8a81e1e47$var$_d["AppInsightsCfgSyncPlugin"] = (0, $3b63eef6ee7529a9$export$5d17fe34e1e248ba)({
    cfgUrl: (0, $b3f475366d0d8052$export$3d96e9cd6640c426),
    syncMode: 2 /* ICfgSyncMode.Receive */ 
}), $c39992e8a81e1e47$var$_d)), $c39992e8a81e1e47$var$_a);
function $c39992e8a81e1e47$var$_chkDiagLevel(value) {
    // Make sure we have a value > 0
    return value && value > 0;
}
function $c39992e8a81e1e47$var$_parseCs(config, configCs) {
    return (0, $4121df0a705d038e$export$87a90c443c3ca3ef)(function(resolve, reject) {
        (0, $4121df0a705d038e$export$856fe465480fa77a)(configCs, function(res) {
            var curCs = res && res.value;
            var parsedCs = null;
            if (!res.rejected && curCs) {
                // replace cs with resolved values in case of circular promises
                config[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:%2econnectionString */ ] = curCs;
                parsedCs = (0, $ca7f93f92bf1443c$export$6369f286b474466d)(curCs);
            }
            // if can't resolve cs promise, null will be returned
            resolve(parsedCs);
        });
    });
}
/**
 * Application Insights API
 * @group Entrypoint
 * @group Classes
 */ var $c39992e8a81e1e47$export$e8021799dbedb971 = /** @class */ function() {
    function AppInsightsSku(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        var _config;
        var _analyticsPlugin;
        var _cfgSyncPlugin;
        var _throttleMgr;
        var _iKeySentMessage;
        var _cdnSentMessage;
        var _sdkVerSentMessage;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(AppInsightsSku, this, function(_self) {
            _initDefaults();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "config", {
                g: function() {
                    return _config;
                }
            });
            (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)([
                "pluginVersionStringArr",
                "pluginVersionString"
            ], function(key) {
                (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, key, {
                    g: function() {
                        if (_core) return _core[key];
                        return null;
                    }
                });
            });
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[0, $15293b9a79d9f5bb$export$568c4302d11f2b22 /* @min:%2eversion */ ] || "");
            snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ] = snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ] || [];
            snippet[0, $15293b9a79d9f5bb$export$568c4302d11f2b22 /* @min:%2eversion */ ] = snippet[0, $15293b9a79d9f5bb$export$568c4302d11f2b22 /* @min:%2eversion */ ] || 2.0; // Default to new version
            var cfgHandler = (0, $6387583e0b25820c$export$3a9e9180c14487fd)(snippet.config || {}, $c39992e8a81e1e47$var$defaultConfigValues);
            _config = cfgHandler.cfg;
            _analyticsPlugin = new (0, $f8c459c2dab16ec4$export$ca681bfeb2cf0fca)();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "appInsights", {
                g: function() {
                    return _analyticsPlugin;
                }
            });
            properties = new (0, $23e243b798ea743c$export$2e2bcd8739ae039)();
            dependencies = new (0, $fa5a8e720c6a6dfc$export$d9a50c4d1eb2475f)();
            _sender = new (0, $7f068950e30577d3$export$c5a96f3e01fb6582)();
            _core = new (0, $125d8f3d04332ece$export$e7ac25a6828d23bf)();
            (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "core", {
                g: function() {
                    return _core;
                }
            });
            // Will get recalled if any referenced values are changed
            _addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(cfgHandler, function() {
                var configCs = _config[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:%2econnectionString */ ];
                if ((0, $5831ddb3a0caf7c7$export$ae936b9d47e5870e)(configCs)) {
                    var ikeyPromise = (0, $4121df0a705d038e$export$87a90c443c3ca3ef)(function(resolve, reject) {
                        (0, $4121df0a705d038e$export$856fe465480fa77a)($c39992e8a81e1e47$var$_parseCs(_config, configCs), function(rsp) {
                            if (!rsp.rejected) {
                                var ikey = _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                                var cs = rsp.value;
                                ikey = cs && cs.instrumentationkey || ikey;
                                resolve(ikey);
                            } else // parseCs will always resolve(unless timeout)
                            // return null in case any error happens
                            resolve(null);
                        });
                    });
                    var url = _config[0, $15293b9a79d9f5bb$export$94c19de246c88ec /* @min:%2euserOverrideEndpointUrl */ ];
                    if ((0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(url)) url = (0, $4121df0a705d038e$export$87a90c443c3ca3ef)(function(resolve, reject) {
                        (0, $4121df0a705d038e$export$856fe465480fa77a)($c39992e8a81e1e47$var$_parseCs(_config, configCs), function(rsp) {
                            if (!rsp.rejected) {
                                var url_1 = _config[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
                                var cs = rsp.value;
                                var ingest = cs && cs.ingestionendpoint;
                                url_1 = ingest ? ingest + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728) : url_1;
                                resolve(url_1);
                            } else // parseCs will always resolve(unless timeout)
                            // return null in case any error happens
                            resolve(null);
                        });
                    });
                    _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = ikeyPromise;
                    _config[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ] = url;
                }
                if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(configCs) && configCs) {
                    // confirm if promiselike function present
                    // handle cs promise here
                    // add cases to oneNote
                    var cs = (0, $ca7f93f92bf1443c$export$6369f286b474466d)(configCs);
                    var ingest = cs.ingestionendpoint;
                    _config.endpointUrl = _config[0, $15293b9a79d9f5bb$export$94c19de246c88ec /* @min:%2euserOverrideEndpointUrl */ ] ? _config[0, $15293b9a79d9f5bb$export$94c19de246c88ec /* @min:%2euserOverrideEndpointUrl */ ] : ingest + (0, $8ac3b4fe9182f568$export$e6c0f3431c6cd728); // add /v2/track
                    _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ] = cs.instrumentationkey || _config[0, $15293b9a79d9f5bb$export$81cfd43387c8dbcc /* @min:%2einstrumentationKey */ ];
                }
                // userOverrideEndpointUrl have the highest priority
                _config.endpointUrl = _config[0, $15293b9a79d9f5bb$export$94c19de246c88ec /* @min:%2euserOverrideEndpointUrl */ ] ? _config[0, $15293b9a79d9f5bb$export$94c19de246c88ec /* @min:%2euserOverrideEndpointUrl */ ] : _config[0, $15293b9a79d9f5bb$export$bfa1c9e5dcf1e78 /* @min:%2eendpointUrl */ ];
            }));
            _self[0, $b3f475366d0d8052$export$c40a95bd1f19a04a /* @min:%2esnippet */ ] = snippet;
            _self[0, $b3f475366d0d8052$export$36b97ab40aae74fe /* @min:%2eflush */ ] = function(isAsync, callBack) {
                if (isAsync === void 0) isAsync = true;
                var result;
                (0, $67947f06182dbd51$export$c6fbeb260600c482)(_core, function() {
                    return "AISKU.flush";
                }, function() {
                    if (isAsync && !callBack) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                        callBack = resolve;
                    });
                    var waiting = 1;
                    var flushDone = function() {
                        waiting--;
                        if (waiting === 0) callBack();
                    };
                    (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_core.getChannels(), function(channel) {
                        if (channel) {
                            waiting++;
                            channel[0, $b3f475366d0d8052$export$36b97ab40aae74fe /* @min:%2eflush */ ](isAsync, flushDone);
                        }
                    });
                    // decrement the initial "waiting"
                    flushDone();
                }, null, isAsync);
                return result;
            };
            _self[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ] = function(isAsync) {
                if (isAsync === void 0) isAsync = true;
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(_core.getChannels(), function(channel) {
                    if (channel[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ]) channel[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ]();
                    else channel[0, $b3f475366d0d8052$export$36b97ab40aae74fe /* @min:%2eflush */ ](isAsync);
                });
            };
            _self.loadAppInsights = function(legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) legacyMode = false;
                if (legacyMode) (0, $5831ddb3a0caf7c7$export$6523a1bd3b6e3128)("Legacy Mode is no longer supported");
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!(0, $5831ddb3a0caf7c7$export$bedb7023a7733221)(_snippetVersion)) snippetVer += _snippetVersion;
                        if (_self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ] && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal) _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.snippetVer = snippetVer || "-";
                        // apply updated properties to the global instance (snippet)
                        (0, $5831ddb3a0caf7c7$export$aa0705d5774c95d1)(_self, function(field, value) {
                            if ((0, $5831ddb3a0caf7c7$export$844ec244b1367d54)(field) && !(0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(value) && field && field[0] !== "_" && // Don't copy "internal" values
                            (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)($c39992e8a81e1e47$var$_ignoreUpdateSnippetProperties, field) === -1) {
                                if (snippet[field] !== value) snippet[field] = value;
                            }
                        });
                    }
                }
                (0, $67947f06182dbd51$export$c6fbeb260600c482)(_self.core, function() {
                    return "AISKU.loadAppInsights";
                }, function() {
                    // initialize core
                    _core.initialize(_config, [
                        _sender,
                        properties,
                        dependencies,
                        _analyticsPlugin,
                        _cfgSyncPlugin
                    ], logger, notificationManager);
                    (0, $5831ddb3a0caf7c7$export$d0d2ebf910ad6e2)(_self, "context", {
                        g: function() {
                            return properties[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
                        }
                    });
                    if (!_throttleMgr) _throttleMgr = new (0, $855be7931ba802b6$export$a6e7e472befd3464)(_core);
                    var sdkSrc = $c39992e8a81e1e47$export$62f75e89e888afb6();
                    if (sdkSrc && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ]) _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc = sdkSrc;
                    _updateSnippetProperties(_self[0, $b3f475366d0d8052$export$c40a95bd1f19a04a /* @min:%2esnippet */ ]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[0, $b3f475366d0d8052$export$6030ed320bde556b /* @min:%2epollInternalLogs */ ]();
                    _self[0, $15293b9a79d9f5bb$export$1005ab001db54adc /* @min:%2eaddHousekeepingBeforeUnload */ ](_self);
                    _addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(cfgHandler, function() {
                        var defaultEnable = false;
                        if (_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ]) defaultEnable = !_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */ ].disabled;
                        if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) // set ready state to true will automatically trigger flush()
                        _throttleMgr.onReadyState(true);
                        if (!_iKeySentMessage && !_config[0, $15293b9a79d9f5bb$export$1160203e21ea532 /* @min:%2econnectionString */ ] && (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)($c39992e8a81e1e47$var$IKEY_USAGE, _config, true)) {
                            _throttleMgr[0, $15293b9a79d9f5bb$export$b6508117e9f77f7f /* @min:%2esendMessage */ ](106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ , "See Instrumentation key support at aka.ms/IkeyMigrate");
                            _iKeySentMessage = true;
                        }
                        if (!_cdnSentMessage && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc && _self[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ].internal.sdkSrc.indexOf("az416426") != -1 && (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)($c39992e8a81e1e47$var$CDN_USAGE, _config, true)) {
                            _throttleMgr[0, $15293b9a79d9f5bb$export$b6508117e9f77f7f /* @min:%2esendMessage */ ](110 /* _eInternalMessageId.CdnDeprecation */ , "See Cdn support notice at aka.ms/JsActiveCdn");
                            _cdnSentMessage = true;
                        }
                        if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && (0, $ede407819d2d28c9$export$87e0f7dd6dec932f)($c39992e8a81e1e47$var$SDK_LOADER_VER, _config, true)) {
                            _throttleMgr[0, $15293b9a79d9f5bb$export$b6508117e9f77f7f /* @min:%2esendMessage */ ](111 /* _eInternalMessageId.SdkLdrUpdate */ , "An updated Sdk Loader is available, see aka.ms/SnippetVer");
                            _sdkVerSentMessage = true;
                        }
                    }));
                });
                return _self;
            };
            _self[0, $15293b9a79d9f5bb$export$e8d1780b2404d6a2 /* @min:%2eupdateSnippetDefinitions */ ] = function(snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                (0, $ede407819d2d28c9$export$21c1f632458708da)(snippet, _self, function(name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && (0, $5831ddb3a0caf7c7$export$9f3b3ffa84393d30)($c39992e8a81e1e47$var$_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function() {
                // call functions that were queued before the main script was loaded
                try {
                    if ((0, $5831ddb3a0caf7c7$export$43bee75e5e14138e)(_self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ].length;
                        for(var i = 0; i < length_1; i++){
                            var call = _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ][i];
                            call();
                        }
                        _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ] = undefined;
                        delete _self.snippet[0, $15293b9a79d9f5bb$export$a1c208448cc1b3be /* @min:%2equeue */ ];
                    }
                } catch (exception) {
                    var properties_1 = {};
                    if (exception && (0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(exception.toString)) properties_1.exception = exception.toString();
                // need from core
                // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                //     eLoggingSeverity.WARNING,
                //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                //     "Failed to send queued telemetry",
                //     properties);
                }
            };
            _self[0, $15293b9a79d9f5bb$export$1005ab001db54adc /* @min:%2eaddHousekeepingBeforeUnload */ ] = function(appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if ((0, $5831ddb3a0caf7c7$export$fef62134eea24008)() || (0, $5831ddb3a0caf7c7$export$c4372eca9c56fe99)()) {
                    var performHousekeeping_1 = function() {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_self.core[0, $b3f475366d0d8052$export$59cf80c2878d98fc /* @min:%2egetPlugin */ ])) {
                            var loadedPlugin = _this.core[0, $b3f475366d0d8052$export$59cf80c2878d98fc /* @min:%2egetPlugin */ ]((0, $5343a490b8ca01c7$export$2268e69a6d93b7cc));
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ] && propertiesPlugin[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ]._sessionManager) propertiesPlugin[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ]._sessionManager.backup();
                            }
                        }
                    };
                    var added_1 = false;
                    if (!_houseKeepingNamespace) _houseKeepingNamespace = (0, $02f0ede5277c99cd$export$3f37a50e0edde3be)(_evtNamespace, _core[0, $b3f475366d0d8052$export$657de6e6c53d3d4b /* @min:%2eevtNamespace */ ] && _core[0, $b3f475366d0d8052$export$657de6e6c53d3d4b /* @min:%2eevtNamespace */ ]());
                    // Will be recalled if any referenced config properties change
                    _addUnloadHook((0, $6387583e0b25820c$export$454a433e4deb244f)(_config, function(details) {
                        var coreConfig = details.cfg;
                        var analyticsPlugin = appInsightsInstance.appInsights;
                        var ctx = (0, $21bc92e23804c647$export$ca98f11e981bcfd6)(null, coreConfig, analyticsPlugin.core);
                        var extConfig = ctx.getExtCfg(analyticsPlugin.identifier || (0, $5343a490b8ca01c7$export$862d858b0002f352));
                        // As we could get recalled, remove any previously registered event handlers first
                        _removePageEventHandlers();
                        var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
                        if (!extConfig.disableFlushOnBeforeUnload) {
                            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                            // As just hooking the window does not always fire (on chrome) for page navigation's.
                            if ((0, $02f0ede5277c99cd$export$f16ce149aca77fdd)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
                            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                            if ((0, $02f0ede5277c99cd$export$46744aee53e5e558)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
                            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                            // log the failure in this case
                            if (!added_1 && !(0, $0d2c2fb24388dcf8$export$f7a1e23e542d38e3)()) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */ , "Could not add handler for beforeunload and pagehide");
                        }
                        if (!added_1 && !extConfig.disableFlushOnUnload) // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                        (0, $02f0ede5277c99cd$export$46744aee53e5e558)(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
                    }));
                }
            };
            _self.getSender = function() {
                return _sender;
            };
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                var unloadDone = false;
                var result;
                if (isAsync && !unloadComplete) result = (0, $4121df0a705d038e$export$5a1eb20c68656e88)(function(resolve) {
                    // Set the callback to the promise resolve callback
                    unloadComplete = resolve;
                });
                function _unloadCallback(unloadState) {
                    if (!unloadDone) {
                        unloadDone = true;
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }
                }
                _self[0, $15293b9a79d9f5bb$export$f30bfb116278d530 /* @min:%2eonunloadFlush */ ](isAsync);
                _removePageEventHandlers();
                _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
                return result;
            };
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _analyticsPlugin, [
                (0, $b3f475366d0d8052$export$da4182b670dc48ff),
                (0, $b3f475366d0d8052$export$2a937c908483aaba),
                (0, $b3f475366d0d8052$export$96dcb75b34c1a4),
                "trackPageViewPerformance",
                (0, $b3f475366d0d8052$export$5a8b50b634878942),
                "_onerror",
                (0, $b3f475366d0d8052$export$6a76308d410f3214),
                (0, $b3f475366d0d8052$export$f73efacb9b6b9a35),
                (0, $b3f475366d0d8052$export$4dff843ac2d49cae),
                (0, $b3f475366d0d8052$export$83ac403ed0121674),
                (0, $b3f475366d0d8052$export$5ac4d387b85102),
                (0, $b3f475366d0d8052$export$7895813056375cb)
            ]);
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _getCurrentDependencies, [
                (0, $b3f475366d0d8052$export$ab9c6dcf6c4e2bbc),
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _core, [
                (0, $b3f475366d0d8052$export$40f0bd7f5212655f),
                (0, $b3f475366d0d8052$export$6030ed320bde556b),
                "stopPollingInternalLogs",
                (0, $b3f475366d0d8052$export$59cf80c2878d98fc),
                "addPlugin",
                (0, $b3f475366d0d8052$export$657de6e6c53d3d4b),
                "addUnloadCb",
                "getTraceCtx",
                "updateCfg",
                "onCfgChange"
            ]);
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, function() {
                var context = properties[0, $15293b9a79d9f5bb$export$fdcd48959e13aba7 /* @min:%2econtext */ ];
                return context ? context.user : null;
            }, [
                (0, $b3f475366d0d8052$export$94666ce386bd4f64),
                (0, $b3f475366d0d8052$export$f920535c288b298f)
            ]);
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = (0, $0e058b881c0798ff$export$eb4a6badb18ead04)("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
                _throttleMgr = null;
                _iKeySentMessage = false;
                _cdnSentMessage = false;
                _sdkVerSentMessage = false;
                _cfgSyncPlugin = new (0, $c0d1696c8c7ba142$export$30ebafc03af98b74)();
            }
            function _removePageEventHandlers() {
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    (0, $02f0ede5277c99cd$export$272dc813b0b2654c)(null, _houseKeepingNamespace);
                    (0, $02f0ede5277c99cd$export$6aca6ee3a147169f)(null, _houseKeepingNamespace);
                }
            }
            function _addUnloadHook(hooks) {
                _core.addUnloadHook(hooks);
            }
        });
    }
    // Analytics Plugin
    // Removed Stub for AppInsightsSku.prototype.getCookieMgr.
    // Removed Stub for AppInsightsSku.prototype.trackEvent.
    // Removed Stub for AppInsightsSku.prototype.trackPageView.
    // Removed Stub for AppInsightsSku.prototype.trackPageViewPerformance.
    // Removed Stub for AppInsightsSku.prototype.trackException.
    // Removed Stub for AppInsightsSku.prototype._onerror.
    // Removed Stub for AppInsightsSku.prototype.trackTrace.
    // Removed Stub for AppInsightsSku.prototype.trackMetric.
    // Removed Stub for AppInsightsSku.prototype.startTrackPage.
    // Removed Stub for AppInsightsSku.prototype.stopTrackPage.
    // Removed Stub for AppInsightsSku.prototype.startTrackEvent.
    // Removed Stub for AppInsightsSku.prototype.stopTrackEvent.
    // Removed Stub for AppInsightsSku.prototype.addTelemetryInitializer.
    // Properties Plugin
    // Removed Stub for AppInsightsSku.prototype.setAuthenticatedUserContext.
    // Removed Stub for AppInsightsSku.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
    // Removed Stub for AppInsightsSku.prototype.trackDependencyData.
    // Misc
    // Removed Stub for AppInsightsSku.prototype.flush.
    // Removed Stub for AppInsightsSku.prototype.onunloadFlush.
    // Removed Stub for AppInsightsSku.prototype.loadAppInsights.
    // Removed Stub for AppInsightsSku.prototype.updateSnippetDefinitions.
    // Removed Stub for AppInsightsSku.prototype.emptyQueue.
    // Removed Stub for AppInsightsSku.prototype.pollInternalLogs.
    // Removed Stub for AppInsightsSku.prototype.stopPollingInternalLogs.
    // Removed Stub for AppInsightsSku.prototype.addHousekeepingBeforeUnload.
    // Removed Stub for AppInsightsSku.prototype.getSender.
    // Removed Stub for AppInsightsSku.prototype.unload.
    // Removed Stub for AppInsightsSku.prototype.getPlugin.
    // Removed Stub for AppInsightsSku.prototype.addPlugin.
    // Removed Stub for AppInsightsSku.prototype.updateCfg.
    // Removed Stub for AppInsightsSku.prototype.evtNamespace.
    // Removed Stub for AppInsightsSku.prototype.addUnloadCb.
    // Removed Stub for AppInsightsSku.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AppInsightsSku.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AppInsightsSku.prototype.getTraceCtx.
    // Removed Stub for AppInsightsSku.prototype.onCfgChange.
    return AppInsightsSku;
}();
function $c39992e8a81e1e47$export$62f75e89e888afb6() {
    if ($c39992e8a81e1e47$var$_internalSdkSrc) // Use the cached value
    return $c39992e8a81e1e47$var$_internalSdkSrc;
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) sdkSrc = scrpt.src;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url_2 = sdkSrc.toLowerCase();
            if (url_2) {
                var src_1 = "";
                (0, $5831ddb3a0caf7c7$export$e2e5bcdbdc49c586)(cdns, function(value, idx) {
                    if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_2, value) !== -1) {
                        src_1 = "cdn" + (idx + 1);
                        if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_2, "/scripts/") === -1) {
                            if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_2, "/next/") !== -1) src_1 += "-next";
                            else if ((0, $5831ddb3a0caf7c7$export$7c0888b0c4641088)(url_2, "/beta/") !== -1) src_1 += "-beta";
                        }
                        $c39992e8a81e1e47$var$_internalSdkSrc = src_1 + (isModule ? ".mod" : "");
                        return -1;
                    }
                });
            }
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        // Cache the found value so we don't have to look it up again
        $c39992e8a81e1e47$var$_internalSdkSrc = sdkSrc;
    }
    return $c39992e8a81e1e47$var$_internalSdkSrc;
}


/*
 * Application Insights JavaScript SDK - React Plugin, 17.3.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* ReactPlugin.ts
* @copyright Microsoft 2019
*/ 




var $fea02f834373c8d5$var$defaultReactExtensionConfig = (0, $5831ddb3a0caf7c7$export$a15782d21797da4c)({
    history: {
        blkVal: true,
        v: undefined
    }
});
var $fea02f834373c8d5$var$ReactPlugin = /** @class */ function(_super) {
    (0, $dc463ff9724142dd$export$1f9c32e3fbfb8e62)(ReactPlugin, _super);
    function ReactPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 185;
        _this.identifier = 'ReactPlugin';
        var _analyticsPlugin;
        var _extensionConfig;
        var _unlisten;
        var _pageViewTimer;
        var _pageViewTracked;
        (0, $1e9ef78f0556a404$export$2e2bcd8739ae039)(ReactPlugin, _this, function(_self, _base) {
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                _super.prototype.initialize.call(_this, config, core, extensions, pluginChain);
                _self._addHook((0, $6387583e0b25820c$export$454a433e4deb244f)(config, function(details) {
                    var _a;
                    var ctx = _self._getTelCtx();
                    _extensionConfig = ctx.getExtCfg(_this.identifier, $fea02f834373c8d5$var$defaultReactExtensionConfig);
                    _analyticsPlugin = (_a = core.getPlugin((0, $5343a490b8ca01c7$export$862d858b0002f352))) === null || _a === void 0 ? void 0 : _a.plugin;
                    if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_unlisten)) {
                        _unlisten();
                        _unlisten = null;
                    }
                    if (_extensionConfig.history) {
                        _addHistoryListener(_extensionConfig.history);
                        if (!_pageViewTracked) {
                            var pageViewTelemetry = {
                                uri: _extensionConfig.history.location.pathname
                            };
                            _self.trackPageView(pageViewTelemetry);
                            _pageViewTracked = true;
                        }
                    }
                }));
            };
            _self.getCookieMgr = function() {
                return (0, $aaa64f3935d14265$export$76c0b273586c25c7)(_self.core);
            };
            _self.getAppInsights = _getAnalytics;
            _self.processTelemetry = function(event, itemCtx) {
                _self.processNext(event, itemCtx);
            };
            _self._doTeardown = function(unloadCtx, unloadState, asyncCallback) {
                if ((0, $5831ddb3a0caf7c7$export$f6e2535fb5126e54)(_unlisten)) _unlisten();
                if (_pageViewTimer) clearTimeout(_pageViewTimer);
                _initDefaults();
            };
            // Proxy the analytics functions
            (0, $ede407819d2d28c9$export$94f4c7fb7e7d8dc7)(_self, _getAnalytics, [
                "trackMetric",
                "trackPageView",
                "trackEvent",
                "trackException",
                "trackTrace"
            ]);
            function _initDefaults() {
                _analyticsPlugin = null;
                _extensionConfig = null;
                _unlisten = null;
                _pageViewTimer = null;
                _pageViewTracked = false;
            }
            function _getAnalytics() {
                if (!_analyticsPlugin) (0, $bacca83328a730a7$export$c7ca1fcbf1d310c4)(_self.diagLog(), 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Analytics plugin is not available, React plugin telemetry will not be sent: ");
                return _analyticsPlugin;
            }
            function _addHistoryListener(history) {
                var locationListener = function(arg) {
                    // v4 of the history API passes "location" as the first argument, while v5 passes an object that contains location and action 
                    var locn = null;
                    if ("location" in arg) // Looks like v5
                    locn = arg["location"];
                    else locn = arg;
                    // Timeout to ensure any changes to the DOM made by route changes get included in pageView telemetry
                    _pageViewTimer = setTimeout(function() {
                        _pageViewTimer = null;
                        var pageViewTelemetry = {
                            uri: locn.pathname
                        };
                        _self.trackPageView(pageViewTelemetry);
                    }, 500);
                };
                _unlisten = history.listen(locationListener);
            }
            (0, $5831ddb3a0caf7c7$export$5525b807dcec3e1b)(_self, "_extensionConfig", function() {
                return _extensionConfig;
            });
        });
        return _this;
    }
    // Removed Stub for ReactPlugin.prototype.initialize.
    // Removed Stub for ReactPlugin.prototype.getCookieMgr.
    // Removed Stub for ReactPlugin.prototype.getAppInsights.
    // Removed Stub for ReactPlugin.prototype.processTelemetry.
    // Removed Stub for ReactPlugin.prototype.trackMetric.
    // Removed Stub for ReactPlugin.prototype.trackPageView.
    // Removed Stub for ReactPlugin.prototype.trackEvent.
    // Removed Stub for ReactPlugin.prototype.trackException.
    // Removed Stub for ReactPlugin.prototype.trackTrace.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ReactPlugin.__ieDyn = 1;
    return ReactPlugin;
}((0, $dc0100a6f2a9749a$export$64a11c2f90e6766c));
var $fea02f834373c8d5$export$2e2bcd8739ae039 = $fea02f834373c8d5$var$ReactPlugin;


// Application Insights configuration
const $dcc07888711c910b$var$connectionString = "InstrumentationKey=b32576d3-4be9-4e57-8529-fee00b4d0a62;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/;ApplicationId=02468e14-6dd6-41b0-9938-aaa4213cf623";
// React plugin for component tracking
const $dcc07888711c910b$var$reactPlugin = new (0, $fea02f834373c8d5$export$2e2bcd8739ae039)();
// Application Insights instance
let $dcc07888711c910b$var$appInsights = null;
function $dcc07888711c910b$export$f96764aa1ab48e76(history = null) {
    if (!$dcc07888711c910b$var$connectionString) {
        console.log('[Telemetry] Application Insights not configured - using console logging only');
        return;
    }
    try {
        $dcc07888711c910b$var$appInsights = new (0, $c39992e8a81e1e47$export$e8021799dbedb971)({
            config: {
                connectionString: $dcc07888711c910b$var$connectionString,
                extensions: [
                    $dcc07888711c910b$var$reactPlugin
                ],
                extensionConfig: {
                    [$dcc07888711c910b$var$reactPlugin.identifier]: {
                        history: history
                    }
                },
                enableAutoRouteTracking: true,
                enableCorsCorrelation: true,
                correlationHeaderExcludedDomains: [
                    '*.clerk.accounts.dev',
                    '*.clerk.com',
                    'clerk.com',
                    '*.stripe.com',
                    'stripe.com'
                ],
                enableRequestHeaderTracking: true,
                enableResponseHeaderTracking: true,
                enableAjaxPerfTracking: true,
                isBrowserLinkTrackingEnabled: true,
                enableUnhandledPromiseRejectionTracking: true,
                disableFetchTracking: false,
                autoTrackPageVisitTime: true,
                disableExceptionTracking: false
            }
        });
        $dcc07888711c910b$var$appInsights.loadAppInsights();
        $dcc07888711c910b$var$appInsights.trackPageView();
        console.log('[Telemetry] Application Insights initialized');
    } catch (error) {
        console.error('[Telemetry] Failed to initialize Application Insights:', error);
    }
}
function $dcc07888711c910b$export$7e08fa800d6a62dc() {
    return $dcc07888711c910b$var$reactPlugin;
}
function $dcc07888711c910b$export$b82680446e9a1074() {
    return $dcc07888711c910b$var$appInsights;
}
const $dcc07888711c910b$export$22e71493230620ce = {
    /**
   * Track a page view
   */ trackPageView (name, uri, properties = {}) {
        console.log('[Telemetry] Page view:', name, uri);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.trackPageView({
            name: name,
            uri: uri,
            properties: properties
        });
    },
    /**
   * Track a custom event
   */ trackEvent (name, properties = {}, measurements = {}) {
        console.log('[Telemetry] Event:', name, properties);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.trackEvent({
            name: name,
            properties: properties,
            measurements: measurements
        });
    },
    /**
   * Track an exception/error
   */ trackException (error, properties = {}) {
        console.error('[Telemetry] Exception:', error.message, properties);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.trackException({
            exception: error,
            properties: properties
        });
    },
    /**
   * Track a trace/log message
   */ trackTrace (message, severity = 'info', properties = {}) {
        const severityMap = {
            verbose: 0,
            info: 1,
            warning: 2,
            error: 3,
            critical: 4
        };
        console.log(`[Telemetry] Trace (${severity}):`, message);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.trackTrace({
            message: message,
            severityLevel: severityMap[severity] || 1,
            properties: properties
        });
    },
    /**
   * Track a metric
   */ trackMetric (name, value, properties = {}) {
        console.log('[Telemetry] Metric:', name, value);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.trackMetric({
            name: name,
            average: value,
            properties: properties
        });
    },
    /**
   * Track dependency call (API requests)
   */ trackDependency (name, duration, success, properties = {}) {
        console.log('[Telemetry] Dependency:', name, duration, success);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.trackDependencyData({
            name: name,
            duration: duration,
            success: success,
            responseCode: success ? 200 : 500,
            type: 'HTTP',
            properties: properties
        });
    },
    /**
   * Set the authenticated user context
   */ setAuthenticatedUser (userId, accountId = null) {
        console.log('[Telemetry] Setting user context:', userId);
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.setAuthenticatedUserContext(userId, accountId, true);
    },
    /**
   * Clear the authenticated user context
   */ clearAuthenticatedUser () {
        console.log('[Telemetry] Clearing user context');
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.clearAuthenticatedUserContext();
    },
    /**
   * Flush all pending telemetry
   */ flush () {
        if ($dcc07888711c910b$var$appInsights) $dcc07888711c910b$var$appInsights.flush();
    }
};
const $dcc07888711c910b$export$8321f7adb8c682ab = {
    // Authentication events
    signInStarted: ()=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('auth_sign_in_started'),
    signInCompleted: (userId)=>{
        $dcc07888711c910b$export$22e71493230620ce.trackEvent('auth_sign_in_completed', {
            userId: userId
        });
        $dcc07888711c910b$export$22e71493230620ce.setAuthenticatedUser(userId);
    },
    signInFailed: (error)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('auth_sign_in_failed', {
            error: error.message
        }),
    signOut: ()=>{
        $dcc07888711c910b$export$22e71493230620ce.trackEvent('auth_sign_out');
        $dcc07888711c910b$export$22e71493230620ce.clearAuthenticatedUser();
    },
    // Application flow events
    applicationCreated: (applicationId)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('application_created', {
            applicationId: applicationId
        }),
    applicationUpdated: (applicationId, field)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('application_updated', {
            applicationId: applicationId,
            field: field
        }),
    applicationDeleted: (applicationId)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('application_deleted', {
            applicationId: applicationId
        }),
    // Trademark events
    trademarkUploaded: (applicationId, type)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('trademark_uploaded', {
            applicationId: applicationId,
            type: type
        }),
    trademarkAnalysisStarted: (applicationId)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('trademark_analysis_started', {
            applicationId: applicationId
        }),
    trademarkAnalysisCompleted: (applicationId, duration)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('trademark_analysis_completed', {
            applicationId: applicationId
        }, {
            duration: duration
        }),
    // AI Chat events
    chatMessageSent: (applicationId, messageLength)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('chat_message_sent', {
            applicationId: applicationId
        }, {
            messageLength: messageLength
        }),
    chatResponseReceived: (applicationId, duration)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('chat_response_received', {
            applicationId: applicationId
        }, {
            duration: duration
        }),
    // Payment events
    checkoutStarted: (applicationId, amount)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('checkout_started', {
            applicationId: applicationId
        }, {
            amount: amount
        }),
    checkoutCompleted: (applicationId, amount)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('checkout_completed', {
            applicationId: applicationId
        }, {
            amount: amount
        }),
    checkoutFailed: (applicationId, error)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('checkout_failed', {
            applicationId: applicationId,
            error: error
        }),
    // Country selection events
    countrySelected: (applicationId, countryCode)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('country_selected', {
            applicationId: applicationId,
            countryCode: countryCode
        }),
    countryDeselected: (applicationId, countryCode)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('country_deselected', {
            applicationId: applicationId,
            countryCode: countryCode
        }),
    // UI interactions
    tabChanged: (tabName)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('tab_changed', {
            tabName: tabName
        }),
    modalOpened: (modalName)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('modal_opened', {
            modalName: modalName
        }),
    modalClosed: (modalName)=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('modal_closed', {
            modalName: modalName
        }),
    buttonClicked: (buttonName, context = {})=>$dcc07888711c910b$export$22e71493230620ce.trackEvent('button_clicked', {
            buttonName: buttonName,
            ...context
        })
};
const $dcc07888711c910b$export$f2d2284f5fec51f8 = {
    /**
   * Measure and track the duration of an operation
   */ async measure (name, operation, properties = {}) {
        const startTime = Date.now();
        try {
            const result = await operation();
            const duration = Date.now() - startTime;
            $dcc07888711c910b$export$22e71493230620ce.trackMetric(`${name}_duration`, duration, properties);
            $dcc07888711c910b$export$22e71493230620ce.trackEvent(`${name}_completed`, {
                ...properties,
                success: true
            }, {
                duration: duration
            });
            return result;
        } catch (error) {
            const duration = Date.now() - startTime;
            $dcc07888711c910b$export$22e71493230620ce.trackEvent(`${name}_failed`, {
                ...properties,
                error: error.message
            }, {
                duration: duration
            });
            $dcc07888711c910b$export$22e71493230620ce.trackException(error, {
                operation: name,
                ...properties
            });
            throw error;
        }
    },
    /**
   * Track page load performance
   */ trackPageLoad () {
        if (typeof window !== 'undefined' && window.performance) {
            const timing = window.performance.timing;
            const pageLoadTime = timing.loadEventEnd - timing.navigationStart;
            const domReadyTime = timing.domContentLoadedEventEnd - timing.navigationStart;
            const dnsTime = timing.domainLookupEnd - timing.domainLookupStart;
            const tcpTime = timing.connectEnd - timing.connectStart;
            const serverTime = timing.responseEnd - timing.requestStart;
            $dcc07888711c910b$export$22e71493230620ce.trackMetric('page_load_time', pageLoadTime);
            $dcc07888711c910b$export$22e71493230620ce.trackMetric('dom_ready_time', domReadyTime);
            $dcc07888711c910b$export$22e71493230620ce.trackMetric('dns_lookup_time', dnsTime);
            $dcc07888711c910b$export$22e71493230620ce.trackMetric('tcp_connect_time', tcpTime);
            $dcc07888711c910b$export$22e71493230620ce.trackMetric('server_response_time', serverTime);
        }
    }
};
function $dcc07888711c910b$export$557b152cb4c56eea(error, errorInfo) {
    $dcc07888711c910b$export$22e71493230620ce.trackException(error, {
        componentStack: errorInfo?.componentStack,
        type: 'react_error_boundary'
    });
}
var $dcc07888711c910b$export$2e2bcd8739ae039 = $dcc07888711c910b$export$22e71493230620ce;


/**
 * Error Boundary Component
 * Catches React errors and reports them to Application Insights
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

class $aa7071e0f713f419$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            errorInfo: errorInfo
        });
        // Log to Application Insights
        (0, $dcc07888711c910b$export$557b152cb4c56eea)(error, errorInfo);
        // Also log to console for development
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    handleRetry = ()=>{
        (0, $dcc07888711c910b$export$22e71493230620ce).trackEvent('error_boundary_retry');
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null
        });
    };
    handleReload = ()=>{
        (0, $dcc07888711c910b$export$22e71493230620ce).trackEvent('error_boundary_reload');
        window.location.reload();
    };
    render() {
        if (this.state.hasError) {
            // Custom fallback UI
            if (this.props.fallback) return this.props.fallback;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "min-h-screen flex items-center justify-center bg-gray-50 px-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                className: "w-8 h-8 text-red-600",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-xl font-semibold text-gray-900 mb-2",
                            children: "Something went wrong"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-600 mb-6",
                            children: "We're sorry, but something unexpected happened. Our team has been notified."
                        }),
                        false,
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-3 justify-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: this.handleRetry,
                                    className: "px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors",
                                    children: "Try Again"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: this.handleReload,
                                    className: "px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors",
                                    children: "Reload Page"
                                })
                            ]
                        })
                    ]
                })
            });
        }
        return this.props.children;
    }
}
var $aa7071e0f713f419$export$2e2bcd8739ae039 = $aa7071e0f713f419$var$ErrorBoundary;


var $8fcdbf2d7a4660c6$exports = {};
"use strict";
var $8fcdbf2d7a4660c6$var$__create = Object.create;
var $8fcdbf2d7a4660c6$var$__defProp = Object.defineProperty;
var $8fcdbf2d7a4660c6$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $8fcdbf2d7a4660c6$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $8fcdbf2d7a4660c6$var$__getProtoOf = Object.getPrototypeOf;
var $8fcdbf2d7a4660c6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8fcdbf2d7a4660c6$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $8fcdbf2d7a4660c6$var$__export = (target, all)=>{
    for(var name in all)$8fcdbf2d7a4660c6$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $8fcdbf2d7a4660c6$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $8fcdbf2d7a4660c6$var$__getOwnPropNames(from))if (!$8fcdbf2d7a4660c6$var$__hasOwnProp.call(to, key) && key !== except) $8fcdbf2d7a4660c6$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $8fcdbf2d7a4660c6$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $8fcdbf2d7a4660c6$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $8fcdbf2d7a4660c6$var$__create($8fcdbf2d7a4660c6$var$__getProtoOf(mod)) : {}, $8fcdbf2d7a4660c6$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $8fcdbf2d7a4660c6$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $8fcdbf2d7a4660c6$var$__toCommonJS = (mod)=>$8fcdbf2d7a4660c6$var$__copyProps($8fcdbf2d7a4660c6$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $8fcdbf2d7a4660c6$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $8fcdbf2d7a4660c6$var$__typeError("Cannot " + msg);
var $8fcdbf2d7a4660c6$var$__privateGet = (obj, member, getter)=>($8fcdbf2d7a4660c6$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $8fcdbf2d7a4660c6$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $8fcdbf2d7a4660c6$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $8fcdbf2d7a4660c6$var$__privateSet = (obj, member, value, setter)=>($8fcdbf2d7a4660c6$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $8fcdbf2d7a4660c6$var$__privateMethod = (obj, member, method)=>($8fcdbf2d7a4660c6$var$__accessCheck(obj, member, "access private method"), method);
// src/index.ts
var $8fcdbf2d7a4660c6$var$src_exports = {};
$8fcdbf2d7a4660c6$var$__export($8fcdbf2d7a4660c6$var$src_exports, {
    APIKeys: ()=>$8fcdbf2d7a4660c6$var$APIKeys,
    AuthenticateWithRedirectCallback: ()=>$8fcdbf2d7a4660c6$var$AuthenticateWithRedirectCallback,
    ClerkDegraded: ()=>$8fcdbf2d7a4660c6$var$ClerkDegraded,
    ClerkFailed: ()=>$8fcdbf2d7a4660c6$var$ClerkFailed,
    ClerkLoaded: ()=>$8fcdbf2d7a4660c6$var$ClerkLoaded,
    ClerkLoading: ()=>$8fcdbf2d7a4660c6$var$ClerkLoading,
    ClerkProvider: ()=>$8fcdbf2d7a4660c6$var$ClerkProvider,
    CreateOrganization: ()=>$8fcdbf2d7a4660c6$var$CreateOrganization,
    GoogleOneTap: ()=>$8fcdbf2d7a4660c6$var$GoogleOneTap,
    OrganizationList: ()=>$8fcdbf2d7a4660c6$var$OrganizationList,
    OrganizationProfile: ()=>$8fcdbf2d7a4660c6$var$OrganizationProfile,
    OrganizationSwitcher: ()=>$8fcdbf2d7a4660c6$var$OrganizationSwitcher,
    PricingTable: ()=>$8fcdbf2d7a4660c6$var$PricingTable,
    Protect: ()=>$8fcdbf2d7a4660c6$var$Protect,
    RedirectToCreateOrganization: ()=>$8fcdbf2d7a4660c6$var$RedirectToCreateOrganization,
    RedirectToOrganizationProfile: ()=>$8fcdbf2d7a4660c6$var$RedirectToOrganizationProfile,
    RedirectToSignIn: ()=>$8fcdbf2d7a4660c6$var$RedirectToSignIn,
    RedirectToSignUp: ()=>$8fcdbf2d7a4660c6$var$RedirectToSignUp,
    RedirectToTasks: ()=>$8fcdbf2d7a4660c6$var$RedirectToTasks,
    RedirectToUserProfile: ()=>$8fcdbf2d7a4660c6$var$RedirectToUserProfile,
    SignIn: ()=>$8fcdbf2d7a4660c6$var$SignIn,
    SignInButton: ()=>$8fcdbf2d7a4660c6$var$SignInButton,
    SignInWithMetamaskButton: ()=>$8fcdbf2d7a4660c6$var$SignInWithMetamaskButton,
    SignOutButton: ()=>$8fcdbf2d7a4660c6$var$SignOutButton,
    SignUp: ()=>$8fcdbf2d7a4660c6$var$SignUp,
    SignUpButton: ()=>$8fcdbf2d7a4660c6$var$SignUpButton,
    SignedIn: ()=>$8fcdbf2d7a4660c6$var$SignedIn,
    SignedOut: ()=>$8fcdbf2d7a4660c6$var$SignedOut,
    TaskChooseOrganization: ()=>$8fcdbf2d7a4660c6$var$TaskChooseOrganization,
    TaskResetPassword: ()=>$8fcdbf2d7a4660c6$var$TaskResetPassword,
    TaskSetupMFA: ()=>$8fcdbf2d7a4660c6$var$TaskSetupMFA,
    UserAvatar: ()=>$8fcdbf2d7a4660c6$var$UserAvatar,
    UserButton: ()=>$8fcdbf2d7a4660c6$var$UserButton,
    UserProfile: ()=>$8fcdbf2d7a4660c6$var$UserProfile,
    Waitlist: ()=>$8fcdbf2d7a4660c6$var$Waitlist,
    __experimental_CheckoutProvider: ()=>$a0ea147aab9dedc4$export$7e97d07504ce6dd0,
    __experimental_PaymentElement: ()=>$a0ea147aab9dedc4$export$cfeb6784afb9ebba,
    __experimental_PaymentElementProvider: ()=>$a0ea147aab9dedc4$export$2341d27b29acefb0,
    __experimental_useCheckout: ()=>$a0ea147aab9dedc4$export$88df2e7b0f32010b,
    __experimental_usePaymentElement: ()=>$a0ea147aab9dedc4$export$4e9381da774c24d3,
    useAuth: ()=>$8fcdbf2d7a4660c6$var$useAuth,
    useClerk: ()=>$a0ea147aab9dedc4$export$1d7a12f28cf01e2e,
    useEmailLink: ()=>$8fcdbf2d7a4660c6$var$useEmailLink,
    useOrganization: ()=>$a0ea147aab9dedc4$export$ae85931d305e13b1,
    useOrganizationCreationDefaults: ()=>$a0ea147aab9dedc4$export$98614501febd5535,
    useOrganizationList: ()=>$a0ea147aab9dedc4$export$70272151be64739d,
    useReverification: ()=>$a0ea147aab9dedc4$export$9497b92f9bd92d3e,
    useSession: ()=>$a0ea147aab9dedc4$export$ad0a340bf97d63d5,
    useSessionList: ()=>$a0ea147aab9dedc4$export$14add875417b9a72,
    useSignIn: ()=>$8fcdbf2d7a4660c6$var$useSignIn,
    useSignUp: ()=>$8fcdbf2d7a4660c6$var$useSignUp,
    useUser: ()=>$a0ea147aab9dedc4$export$23bbbc4533528f03
});
$8fcdbf2d7a4660c6$exports = $8fcdbf2d7a4660c6$var$__toCommonJS($8fcdbf2d7a4660c6$var$src_exports);
// src/polyfills.ts
if (typeof window !== "undefined" && !window.global) window.global = typeof $parcel$global === "undefined" ? window : $parcel$global;
var $3aa9b7204540f02e$export$1dfd3eba1fb8c8a7;
var $3aa9b7204540f02e$export$900dd1fdd9dbe2cc;
var $3aa9b7204540f02e$export$4236f1a239719b87;
var $3aa9b7204540f02e$export$b09f006ee485e599;
var $98c33c808473ee85$exports = {};
//#region src/constants.ts
const $98c33c808473ee85$var$LEGACY_DEV_INSTANCE_SUFFIXES = [
    ".lcl.dev",
    ".lclstage.dev",
    ".lclclerk.com"
];
const $98c33c808473ee85$var$CURRENT_DEV_INSTANCE_SUFFIXES = [
    ".accounts.dev",
    ".accountsstage.dev",
    ".accounts.lclclerk.com"
];
const $98c33c808473ee85$var$DEV_OR_STAGING_SUFFIXES = [
    ".lcl.dev",
    ".stg.dev",
    ".lclstage.dev",
    ".stgstage.dev",
    ".dev.lclclerk.com",
    ".stg.lclclerk.com",
    ".accounts.lclclerk.com",
    "accountsstage.dev",
    "accounts.dev"
];
const $98c33c808473ee85$var$LOCAL_ENV_SUFFIXES = [
    ".lcl.dev",
    "lclstage.dev",
    ".lclclerk.com",
    ".accounts.lclclerk.com"
];
const $98c33c808473ee85$var$STAGING_ENV_SUFFIXES = [
    ".accountsstage.dev"
];
const $98c33c808473ee85$var$LOCAL_API_URL = "https://api.lclclerk.com";
const $98c33c808473ee85$var$STAGING_API_URL = "https://api.clerkstage.dev";
const $98c33c808473ee85$var$PROD_API_URL = "https://api.clerk.com";
/**
* Returns the URL for a static image
* using the new img.clerk.com service
*/ function $98c33c808473ee85$var$iconImageUrl(id, format = "svg") {
    return `https://img.clerk.com/static/${id}.${format}`;
}
//#endregion
Object.defineProperty($98c33c808473ee85$exports, 'CURRENT_DEV_INSTANCE_SUFFIXES', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$CURRENT_DEV_INSTANCE_SUFFIXES;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'DEV_OR_STAGING_SUFFIXES', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$DEV_OR_STAGING_SUFFIXES;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'LEGACY_DEV_INSTANCE_SUFFIXES', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$LEGACY_DEV_INSTANCE_SUFFIXES;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'LOCAL_API_URL', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$LOCAL_API_URL;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'LOCAL_ENV_SUFFIXES', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$LOCAL_ENV_SUFFIXES;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'PROD_API_URL', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$PROD_API_URL;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'STAGING_API_URL', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$STAGING_API_URL;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'STAGING_ENV_SUFFIXES', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$STAGING_ENV_SUFFIXES;
    }
});
Object.defineProperty($98c33c808473ee85$exports, 'iconImageUrl', {
    enumerable: true,
    get: function() {
        return $98c33c808473ee85$var$iconImageUrl;
    }
});


var $c506dc46ccf13bc3$exports = {};
//#region src/isomorphicAtob.ts
/**
* A function that decodes a string of data which has been encoded using base-64 encoding.
* Uses `atob` if available, otherwise uses `Buffer` from `global`. If neither are available, returns the data as-is.
*/ const $c506dc46ccf13bc3$var$isomorphicAtob = (data)=>{
    if (typeof atob !== "undefined" && typeof atob === "function") return atob(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data, "base64").toString();
    return data;
};
//#endregion
Object.defineProperty($c506dc46ccf13bc3$exports, 'isomorphicAtob', {
    enumerable: true,
    get: function() {
        return $c506dc46ccf13bc3$var$isomorphicAtob;
    }
});


var $59bb0624532448ca$exports = {};
//#region src/isomorphicBtoa.ts
const $59bb0624532448ca$var$isomorphicBtoa = (data)=>{
    if (typeof btoa !== "undefined" && typeof btoa === "function") return btoa(data);
    else if (typeof $parcel$global !== "undefined" && $parcel$global.Buffer) return new $parcel$global.Buffer(data).toString("base64");
    return data;
};
//#endregion
Object.defineProperty($59bb0624532448ca$exports, 'isomorphicBtoa', {
    enumerable: true,
    get: function() {
        return $59bb0624532448ca$var$isomorphicBtoa;
    }
});


var $6fcb8ff7a3b82d27$exports = {};



//#region src/keys.ts
/** Prefix used for production publishable keys */ const $6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_LIVE_PREFIX = "pk_live_";
/** Prefix used for development publishable keys */ const $6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_TEST_PREFIX = "pk_test_";
/**
* Regular expression that matches development frontend API keys.
* Matches patterns like: foo-bar-13.clerk.accounts.dev.
*/ const $6fcb8ff7a3b82d27$var$PUBLISHABLE_FRONTEND_API_DEV_REGEX = /^(([a-z]+)-){2}([0-9]{1,2})\.clerk\.accounts([a-z.]*)(dev|com)$/i;
/**
* Converts a frontend API URL into a base64-encoded publishable key.
*
* @param frontendApi - The frontend API URL (e.g., 'clerk.example.com').
* @returns A base64-encoded publishable key with appropriate prefix (pk_live_ or pk_test_).
*/ function $6fcb8ff7a3b82d27$var$buildPublishableKey(frontendApi) {
    return `${$6fcb8ff7a3b82d27$var$PUBLISHABLE_FRONTEND_API_DEV_REGEX.test(frontendApi) || frontendApi.startsWith("clerk.") && $98c33c808473ee85$exports.LEGACY_DEV_INSTANCE_SUFFIXES.some((s)=>frontendApi.endsWith(s)) ? $6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_TEST_PREFIX : $6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_LIVE_PREFIX}${$59bb0624532448ca$exports.isomorphicBtoa(`${frontendApi}$`)}`;
}
/**
* Validates that a decoded publishable key has the correct format.
* The decoded value should be a frontend API followed by exactly one '$' at the end.
*
* @param decoded - The decoded publishable key string to validate.
* @returns `true` if the decoded key has valid format, `false` otherwise.
*/ function $6fcb8ff7a3b82d27$var$isValidDecodedPublishableKey(decoded) {
    if (!decoded.endsWith("$")) return false;
    const withoutTrailing = decoded.slice(0, -1);
    if (withoutTrailing.includes("$")) return false;
    return withoutTrailing.includes(".");
}
/**
* Parses and validates a publishable key, extracting the frontend API and instance type.
*
* @param key - The publishable key to parse.
* @param options - Configuration options for parsing.
* @param options.fatal
* @param options.domain
* @param options.proxyUrl
* @param options.isSatellite
* @returns Parsed publishable key object with instanceType and frontendApi, or null if invalid.
*
* @throws {Error} When options.fatal is true and key is missing or invalid.
*/ function $6fcb8ff7a3b82d27$var$parsePublishableKey(key, options = {}) {
    key = key || "";
    if (!key || !$6fcb8ff7a3b82d27$var$isPublishableKey(key)) {
        if (options.fatal && !key) throw new Error("Publishable key is missing. Ensure that your publishable key is correctly configured. Double-check your environment configuration for your keys, or access them here: https://dashboard.clerk.com/last-active?path=api-keys");
        if (options.fatal && !$6fcb8ff7a3b82d27$var$isPublishableKey(key)) throw new Error("Publishable key not valid.");
        return null;
    }
    const instanceType = key.startsWith($6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_LIVE_PREFIX) ? "production" : "development";
    let decodedFrontendApi;
    try {
        decodedFrontendApi = $c506dc46ccf13bc3$exports.isomorphicAtob(key.split("_")[2]);
    } catch  {
        if (options.fatal) throw new Error("Publishable key not valid: Failed to decode key.");
        return null;
    }
    if (!$6fcb8ff7a3b82d27$var$isValidDecodedPublishableKey(decodedFrontendApi)) {
        if (options.fatal) throw new Error("Publishable key not valid: Decoded key has invalid format.");
        return null;
    }
    let frontendApi = decodedFrontendApi.slice(0, -1);
    if (options.proxyUrl) frontendApi = options.proxyUrl;
    else if (instanceType !== "development" && options.domain && options.isSatellite) frontendApi = `clerk.${options.domain}`;
    return {
        instanceType: instanceType,
        frontendApi: frontendApi
    };
}
/**
* Checks if the provided key is a valid publishable key.
*
* @param key - The key to be checked. Defaults to an empty string if not provided.
* @returns `true` if 'key' is a valid publishable key, `false` otherwise.
*/ function $6fcb8ff7a3b82d27$var$isPublishableKey(key = "") {
    try {
        if (!(key.startsWith($6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_LIVE_PREFIX) || key.startsWith($6fcb8ff7a3b82d27$var$PUBLISHABLE_KEY_TEST_PREFIX))) return false;
        const parts = key.split("_");
        if (parts.length !== 3) return false;
        const encodedPart = parts[2];
        if (!encodedPart) return false;
        return $6fcb8ff7a3b82d27$var$isValidDecodedPublishableKey($c506dc46ccf13bc3$exports.isomorphicAtob(encodedPart));
    } catch  {
        return false;
    }
}
/**
* Creates a memoized cache for checking if URLs are development or staging environments.
* Uses a Map to cache results for better performance on repeated checks.
*
* @returns An object with an isDevOrStagingUrl method that checks if a URL is dev/staging.
*/ function $6fcb8ff7a3b82d27$var$createDevOrStagingUrlCache() {
    const devOrStagingUrlCache = /* @__PURE__ */ new Map();
    return {
        isDevOrStagingUrl: (url)=>{
            if (!url) return false;
            const hostname = typeof url === "string" ? url : url.hostname;
            let res = devOrStagingUrlCache.get(hostname);
            if (res === void 0) {
                res = $98c33c808473ee85$exports.DEV_OR_STAGING_SUFFIXES.some((s)=>hostname.endsWith(s));
                devOrStagingUrlCache.set(hostname, res);
            }
            return res;
        }
    };
}
/**
* Checks if a publishable key is for a development environment.
* Supports both legacy format (test_) and new format (pk_test_).
*
* @param apiKey - The API key to check.
* @returns `true` if the key is for development, `false` otherwise.
*/ function $6fcb8ff7a3b82d27$var$isDevelopmentFromPublishableKey(apiKey) {
    return apiKey.startsWith("test_") || apiKey.startsWith("pk_test_");
}
/**
* Checks if a publishable key is for a production environment.
* Supports both legacy format (live_) and new format (pk_live_).
*
* @param apiKey - The API key to check.
* @returns `true` if the key is for production, `false` otherwise.
*/ function $6fcb8ff7a3b82d27$var$isProductionFromPublishableKey(apiKey) {
    return apiKey.startsWith("live_") || apiKey.startsWith("pk_live_");
}
/**
* Checks if a secret key is for a development environment.
* Supports both legacy format (test_) and new format (sk_test_).
*
* @param apiKey - The secret key to check.
* @returns `true` if the key is for development, `false` otherwise.
*/ function $6fcb8ff7a3b82d27$var$isDevelopmentFromSecretKey(apiKey) {
    return apiKey.startsWith("test_") || apiKey.startsWith("sk_test_");
}
/**
* Checks if a secret key is for a production environment.
* Supports both legacy format (live_) and new format (sk_live_).
*
* @param apiKey - The secret key to check.
* @returns `true` if the key is for production, `false` otherwise.
*/ function $6fcb8ff7a3b82d27$var$isProductionFromSecretKey(apiKey) {
    return apiKey.startsWith("live_") || apiKey.startsWith("sk_live_");
}
/**
* Generates a unique cookie suffix based on the publishable key using SHA-1 hashing.
* The suffix is base64-encoded and URL-safe (+ and / characters are replaced).
*
* @param publishableKey - The publishable key to generate suffix from.
* @param subtle - The SubtleCrypto interface to use for hashing (defaults to globalThis.crypto.subtle).
* @returns A promise that resolves to an 8-character URL-safe base64 string.
*/ async function $6fcb8ff7a3b82d27$var$getCookieSuffix(publishableKey, subtle = globalThis.crypto.subtle) {
    const data = new TextEncoder().encode(publishableKey);
    const digest = await subtle.digest("sha-1", data);
    return $59bb0624532448ca$exports.isomorphicBtoa(String.fromCharCode(...new Uint8Array(digest))).replace(/\+/gi, "-").replace(/\//gi, "_").substring(0, 8);
}
/**
* Creates a suffixed cookie name by appending the cookie suffix to the base name.
* Used to create unique cookie names based on the publishable key.
*
* @param cookieName - The base cookie name.
* @param cookieSuffix - The suffix to append (typically generated by getCookieSuffix).
* @returns The suffixed cookie name in format: `${cookieName}_${cookieSuffix}`.
*/ const $6fcb8ff7a3b82d27$var$getSuffixedCookieName = (cookieName, cookieSuffix)=>{
    return `${cookieName}_${cookieSuffix}`;
};
//#endregion
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'buildPublishableKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$buildPublishableKey;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'createDevOrStagingUrlCache', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$createDevOrStagingUrlCache;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'getCookieSuffix', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$getCookieSuffix;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'getSuffixedCookieName', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$getSuffixedCookieName;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'isDevelopmentFromPublishableKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$isDevelopmentFromPublishableKey;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'isDevelopmentFromSecretKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$isDevelopmentFromSecretKey;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'isProductionFromPublishableKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$isProductionFromPublishableKey;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'isProductionFromSecretKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$isProductionFromSecretKey;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'isPublishableKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$isPublishableKey;
    }
});
Object.defineProperty($6fcb8ff7a3b82d27$exports, 'parsePublishableKey', {
    enumerable: true,
    get: function() {
        return $6fcb8ff7a3b82d27$var$parsePublishableKey;
    }
});


var $1f2575dc6adb407c$exports = {};
//#region src/errors/createErrorTypeGuard.ts
/**
* Creates a type guard function for any error class.
* The returned function can be called as a standalone function or as a method on an error object.
*
* @example
* ```typescript
* class MyError extends Error {}
* const isMyError = createErrorTypeGuard(MyError);
*
* // As a standalone function
* if (isMyError(error)) { ... }
*
* // As a method (when attached to error object)
* if (error.isMyError()) { ... }
* ```
*/ function $1f2575dc6adb407c$var$createErrorTypeGuard(ErrorClass) {
    function typeGuard(error) {
        const target = error ?? this;
        if (!target) throw new TypeError(`${ErrorClass.kind || ErrorClass.name} type guard requires an error object`);
        if (ErrorClass.kind && typeof target === "object" && target !== null && "constructor" in target) {
            if (target.constructor?.kind === ErrorClass.kind) return true;
        }
        return target instanceof ErrorClass;
    }
    return typeGuard;
}
//#endregion
//#region src/errors/clerkApiError.ts
/**
* This error contains the specific error message, code, and any additional metadata that was returned by the Clerk API.
*/ var $1f2575dc6adb407c$var$ClerkAPIError = class {
    static kind = "ClerkApiError";
    code;
    message;
    longMessage;
    meta;
    constructor(json){
        const parsedError = {
            code: json.code,
            message: json.message,
            longMessage: json.long_message,
            meta: {
                paramName: json.meta?.param_name,
                sessionId: json.meta?.session_id,
                emailAddresses: json.meta?.email_addresses,
                identifiers: json.meta?.identifiers,
                zxcvbn: json.meta?.zxcvbn,
                plan: json.meta?.plan,
                isPlanUpgradePossible: json.meta?.is_plan_upgrade_possible
            }
        };
        this.code = parsedError.code;
        this.message = parsedError.message;
        this.longMessage = parsedError.longMessage;
        this.meta = parsedError.meta;
    }
};
/**
* Type guard to check if a value is a ClerkAPIError instance.
*/ const $1f2575dc6adb407c$var$isClerkAPIError = $1f2575dc6adb407c$var$createErrorTypeGuard($1f2575dc6adb407c$var$ClerkAPIError);
//#endregion
//#region src/errors/parseError.ts
/**
* Parses an array of ClerkAPIErrorJSON objects into an array of ClerkAPIError objects.
*
* @internal
*/ function $1f2575dc6adb407c$var$parseErrors(data = []) {
    return data.length > 0 ? data.map((e)=>new $1f2575dc6adb407c$var$ClerkAPIError(e)) : [];
}
/**
* Parses a ClerkAPIErrorJSON object into a ClerkAPIError object.
*
* @deprecated Use `ClerkAPIError` class instead
*
* @internal
*/ function $1f2575dc6adb407c$var$parseError(error) {
    return new $1f2575dc6adb407c$var$ClerkAPIError(error);
}
/**
* Converts a ClerkAPIError object into a ClerkAPIErrorJSON object.
*
* @internal
*/ function $1f2575dc6adb407c$var$errorToJSON(error) {
    return {
        code: error?.code || "",
        message: error?.message || "",
        long_message: error?.longMessage,
        meta: {
            param_name: error?.meta?.paramName,
            session_id: error?.meta?.sessionId,
            email_addresses: error?.meta?.emailAddresses,
            identifiers: error?.meta?.identifiers,
            zxcvbn: error?.meta?.zxcvbn,
            plan: error?.meta?.plan,
            is_plan_upgrade_possible: error?.meta?.isPlanUpgradePossible
        }
    };
}
//#endregion
//#region src/errors/clerkError.ts
var $1f2575dc6adb407c$var$ClerkError = class ClerkError extends Error {
    static kind = "ClerkError";
    clerkError = true;
    code;
    longMessage;
    docsUrl;
    cause;
    get name() {
        return this.constructor.name;
    }
    constructor(opts){
        super(new.target.formatMessage(new.target.kind, opts.message, opts.code, opts.docsUrl), {
            cause: opts.cause
        });
        Object.setPrototypeOf(this, ClerkError.prototype);
        this.code = opts.code;
        this.docsUrl = opts.docsUrl;
        this.longMessage = opts.longMessage;
        this.cause = opts.cause;
    }
    toString() {
        return `[${this.name}]\nMessage:${this.message}`;
    }
    static formatMessage(name, msg, code, docsUrl) {
        const prefix = "Clerk:";
        const regex = new RegExp(prefix.replace(" ", "\\s*"), "i");
        msg = msg.replace(regex, "");
        msg = `${prefix} ${msg.trim()}\n\n(code="${code}")\n\n`;
        if (docsUrl) msg += `\n\nDocs: ${docsUrl}`;
        return msg;
    }
};
/**
* Type guard to check if a value is a ClerkError instance.
*/ function $1f2575dc6adb407c$var$isClerkError(val) {
    return $1f2575dc6adb407c$var$createErrorTypeGuard($1f2575dc6adb407c$var$ClerkError)(val) || !!val && typeof val === "object" && "clerkError" in val && val.clerkError === true;
}
//#endregion
//#region src/errors/clerkApiResponseError.ts
var $1f2575dc6adb407c$var$ClerkAPIResponseError = class ClerkAPIResponseError extends $1f2575dc6adb407c$var$ClerkError {
    static kind = "ClerkAPIResponseError";
    status;
    clerkTraceId;
    retryAfter;
    errors;
    constructor(message, options){
        const { data: errorsJson, status: status, clerkTraceId: clerkTraceId, retryAfter: retryAfter } = options;
        super({
            ...options,
            message: message,
            code: "api_response_error"
        });
        Object.setPrototypeOf(this, ClerkAPIResponseError.prototype);
        this.status = status;
        this.clerkTraceId = clerkTraceId;
        this.retryAfter = retryAfter;
        this.errors = (errorsJson || []).map((e)=>new $1f2575dc6adb407c$var$ClerkAPIError(e));
    }
    toString() {
        let message = `[${this.name}]\nMessage:${this.message}\nStatus:${this.status}\nSerialized errors: ${this.errors.map((e)=>JSON.stringify(e))}`;
        if (this.clerkTraceId) message += `\nClerk Trace ID: ${this.clerkTraceId}`;
        return message;
    }
    static formatMessage(name, msg, _, __) {
        return msg;
    }
};
/**
* Type guard to check if an error is a ClerkAPIResponseError.
* Can be called as a standalone function or as a method on an error object.
*
* @example
* // As a standalone function
* if (isClerkAPIResponseError(error)) { ... }
*
* // As a method (when attached to error object)
* if (error.isClerkAPIResponseError()) { ... }
*/ const $1f2575dc6adb407c$var$isClerkAPIResponseError = $1f2575dc6adb407c$var$createErrorTypeGuard($1f2575dc6adb407c$var$ClerkAPIResponseError);
//#endregion
//#region src/errors/missingExpiredTokenError.ts
/**
* Error class representing a missing expired token error from the API.
* This error occurs when the server requires an expired token to mint a new session token.
*
* Use the static `is` method to check if a ClerkAPIResponseError matches this error type.
*
* @example
* ```typescript
* if (MissingExpiredTokenError.is(error)) {
*   // Handle the missing expired token error
* }
* ```
*/ var $1f2575dc6adb407c$var$MissingExpiredTokenError = class MissingExpiredTokenError extends $1f2575dc6adb407c$var$ClerkAPIResponseError {
    static kind = "MissingExpiredTokenError";
    static ERROR_CODE = "missing_expired_token";
    static STATUS = 422;
    /**
	* Type guard to check if an error is a MissingExpiredTokenError.
	* This checks the error's properties (status and error code) rather than instanceof,
	* allowing it to work with ClerkAPIResponseError instances thrown from the API layer.
	*
	* @example
	* ```typescript
	* try {
	*   await someApiCall();
	* } catch (e) {
	*   if (MissingExpiredTokenError.is(e)) {
	*     // e is typed as ClerkAPIResponseError with the specific error properties
	*   }
	* }
	* ```
	*/ static is(err) {
        return $1f2575dc6adb407c$var$isClerkAPIResponseError(err) && err.status === MissingExpiredTokenError.STATUS && err.errors.length > 0 && err.errors[0].code === MissingExpiredTokenError.ERROR_CODE;
    }
};
//#endregion
//#region src/errors/errorThrower.ts
const $1f2575dc6adb407c$var$DefaultMessages = Object.freeze({
    InvalidProxyUrlErrorMessage: `The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})`,
    InvalidPublishableKeyErrorMessage: `The publishableKey passed to Clerk is invalid. You can get your Publishable key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})`,
    MissingPublishableKeyErrorMessage: `Missing publishableKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingSecretKeyErrorMessage: `Missing secretKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.`,
    MissingClerkProvider: `{{source}} can only be used within the <ClerkProvider /> component. Learn more: https://clerk.com/docs/components/clerk-provider`
});
/**
* Builds an error thrower.
*
* @internal
*/ function $1f2575dc6adb407c$var$buildErrorThrower({ packageName: packageName, customMessages: customMessages }) {
    let pkg = packageName;
    /**
	* Builds a message from a raw message and replacements.
	*
	* @internal
	*/ function buildMessage(rawMessage, replacements) {
        if (!replacements) return `${pkg}: ${rawMessage}`;
        let msg = rawMessage;
        const matches = rawMessage.matchAll(/{{([a-zA-Z0-9-_]+)}}/g);
        for (const match of matches){
            const replacement = (replacements[match[1]] || "").toString();
            msg = msg.replace(`{{${match[1]}}}`, replacement);
        }
        return `${pkg}: ${msg}`;
    }
    const messages = {
        ...$1f2575dc6adb407c$var$DefaultMessages,
        ...customMessages
    };
    return {
        setPackageName ({ packageName: packageName$1 }) {
            if (typeof packageName$1 === "string") pkg = packageName$1;
            return this;
        },
        setMessages ({ customMessages: customMessages$1 }) {
            Object.assign(messages, customMessages$1 || {});
            return this;
        },
        throwInvalidPublishableKeyError (params) {
            throw new Error(buildMessage(messages.InvalidPublishableKeyErrorMessage, params));
        },
        throwInvalidProxyUrl (params) {
            throw new Error(buildMessage(messages.InvalidProxyUrlErrorMessage, params));
        },
        throwMissingPublishableKeyError () {
            throw new Error(buildMessage(messages.MissingPublishableKeyErrorMessage));
        },
        throwMissingSecretKeyError () {
            throw new Error(buildMessage(messages.MissingSecretKeyErrorMessage));
        },
        throwMissingClerkProviderError (params) {
            throw new Error(buildMessage(messages.MissingClerkProvider, params));
        },
        throw (message) {
            throw new Error(buildMessage(message));
        }
    };
}
//#endregion
//#region src/errors/emailLinkError.ts
var $1f2575dc6adb407c$var$EmailLinkError = class EmailLinkError extends Error {
    code;
    constructor(code){
        super(code);
        this.code = code;
        this.name = "EmailLinkError";
        Object.setPrototypeOf(this, EmailLinkError.prototype);
    }
};
/**
* @deprecated Use `EmailLinkErrorCodeStatus` instead.
*
* @internal
*/ const $1f2575dc6adb407c$var$EmailLinkErrorCode = {
    Expired: "expired",
    Failed: "failed",
    ClientMismatch: "client_mismatch"
};
const $1f2575dc6adb407c$var$EmailLinkErrorCodeStatus = {
    Expired: "expired",
    Failed: "failed",
    ClientMismatch: "client_mismatch"
};
//#endregion
//#region src/errors/clerkRuntimeError.ts
/**
* Custom error class for representing Clerk runtime errors.
*
* @class ClerkRuntimeError
*
* @example
*   throw new ClerkRuntimeError('An error occurred', { code: 'password_invalid' });
*/ var $1f2575dc6adb407c$var$ClerkRuntimeError = class ClerkRuntimeError extends $1f2575dc6adb407c$var$ClerkError {
    static kind = "ClerkRuntimeError";
    /**
	* @deprecated Use `clerkError` property instead. This property is maintained for backward compatibility.
	*/ clerkRuntimeError = true;
    constructor(message, options){
        super({
            ...options,
            message: message
        });
        Object.setPrototypeOf(this, ClerkRuntimeError.prototype);
    }
};
/**
* Type guard to check if an error is a ClerkRuntimeError.
* Can be called as a standalone function or as a method on an error object.
*
* @example
* // As a standalone function
* if (isClerkRuntimeError(error)) { ... }
*
* // As a method (when attached to error object)
* if (error.isClerkRuntimeError()) { ... }
*/ const $1f2575dc6adb407c$var$isClerkRuntimeError = $1f2575dc6adb407c$var$createErrorTypeGuard($1f2575dc6adb407c$var$ClerkRuntimeError);
//#endregion
//#region src/errors/webAuthNError.ts
var $1f2575dc6adb407c$var$ClerkWebAuthnError = class extends $1f2575dc6adb407c$var$ClerkRuntimeError {
    /**
	* A unique code identifying the error, can be used for localization.
	*/ code;
    constructor(message, { code: code }){
        super(message, {
            code: code
        });
        this.code = code;
    }
};
//#endregion
//#region src/errors/helpers.ts
/**
* Checks if the provided error object is an unauthorized error.
*
* @internal
*
* @deprecated This is no longer used, and will be removed in the next major version.
*/ function $1f2575dc6adb407c$var$isUnauthorizedError(e) {
    const status = e?.status;
    return e?.errors?.[0]?.code === "authentication_invalid" && status === 401;
}
/**
* Checks if the provided error object is a captcha error.
*
* @internal
*/ function $1f2575dc6adb407c$var$isCaptchaError(e) {
    return [
        "captcha_invalid",
        "captcha_not_enabled",
        "captcha_missing_token"
    ].includes(e.errors[0].code);
}
/**
* Checks if the provided error is a 4xx error.
*
* @internal
*/ function $1f2575dc6adb407c$var$is4xxError(e) {
    const status = e?.status;
    return !!status && status >= 400 && status < 500;
}
/**
* Checks if the provided error is a network error.
*
* @internal
*/ function $1f2575dc6adb407c$var$isNetworkError(e) {
    return (`${e.message}${e.name}` || "").toLowerCase().replace(/\s+/g, "").includes("networkerror");
}
/**
* Checks if the provided error is either a ClerkAPIResponseError, a ClerkRuntimeError, or a MetamaskError.
*
* @internal
*/ function $1f2575dc6adb407c$var$isKnownError(error) {
    return $1f2575dc6adb407c$var$isClerkAPIResponseError(error) || $1f2575dc6adb407c$var$isMetamaskError(error) || $1f2575dc6adb407c$var$isClerkRuntimeError(error);
}
/**
* Checks if the provided error is a Clerk runtime error indicating a reverification was cancelled.
*
* @internal
*/ function $1f2575dc6adb407c$var$isReverificationCancelledError(err) {
    return $1f2575dc6adb407c$var$isClerkRuntimeError(err) && err.code === "reverification_cancelled";
}
/**
* Checks if the provided error is a Metamask error.
*
* @internal
*/ function $1f2575dc6adb407c$var$isMetamaskError(err) {
    return "code" in err && [
        4001,
        32602,
        32603
    ].includes(err.code) && "message" in err;
}
/**
* Checks if the provided error is clerk api response error indicating a user is locked.
*
* @internal
*/ function $1f2575dc6adb407c$var$isUserLockedError(err) {
    return $1f2575dc6adb407c$var$isClerkAPIResponseError(err) && err.errors?.[0]?.code === "user_locked";
}
/**
* Checks if the provided error is a clerk api response error indicating a password was pwned.
*
* @internal
*/ function $1f2575dc6adb407c$var$isPasswordPwnedError(err) {
    return $1f2575dc6adb407c$var$isClerkAPIResponseError(err) && err.errors?.[0]?.code === "form_password_pwned";
}
/**
* Checks if the provided error is a clerk api response error indicating a password was compromised.
*
* @internal
*/ function $1f2575dc6adb407c$var$isPasswordCompromisedError(err) {
    return $1f2575dc6adb407c$var$isClerkAPIResponseError(err) && err.errors?.[0]?.code === "form_password_compromised";
}
/**
* Checks if the provided error is an EmailLinkError.
*
* @internal
*/ function $1f2575dc6adb407c$var$isEmailLinkError(err) {
    return err.name === "EmailLinkError";
}
//#endregion
//#region src/errors/globalHookError.ts
/**
* Creates a ClerkGlobalHookError object from a ClerkError instance.
* It's a wrapper for all the different instances of Clerk errors that can
* be returned when using Clerk hooks.
*/ function $1f2575dc6adb407c$var$createClerkGlobalHookError(error) {
    const predicates = {
        isClerkAPIResponseError: $1f2575dc6adb407c$var$isClerkAPIResponseError,
        isClerkRuntimeError: $1f2575dc6adb407c$var$isClerkRuntimeError
    };
    for (const [name, fn] of Object.entries(predicates))Object.assign(error, {
        [name]: fn
    });
    return error;
}
//#endregion
Object.defineProperty($1f2575dc6adb407c$exports, 'ClerkAPIError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$ClerkAPIError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'ClerkAPIResponseError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$ClerkAPIResponseError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'ClerkError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$ClerkError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'ClerkRuntimeError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$ClerkRuntimeError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'ClerkWebAuthnError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$ClerkWebAuthnError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'EmailLinkError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$EmailLinkError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'EmailLinkErrorCode', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$EmailLinkErrorCode;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'EmailLinkErrorCodeStatus', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$EmailLinkErrorCodeStatus;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'MissingExpiredTokenError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$MissingExpiredTokenError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'buildErrorThrower', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$buildErrorThrower;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'createClerkGlobalHookError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$createClerkGlobalHookError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'errorToJSON', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$errorToJSON;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'is4xxError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$is4xxError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isCaptchaError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isCaptchaError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isClerkAPIError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isClerkAPIError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isClerkAPIResponseError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isClerkAPIResponseError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isClerkError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isClerkError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isClerkRuntimeError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isClerkRuntimeError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isEmailLinkError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isEmailLinkError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isKnownError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isKnownError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isMetamaskError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isMetamaskError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isNetworkError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isNetworkError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isPasswordCompromisedError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isPasswordCompromisedError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isPasswordPwnedError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isPasswordPwnedError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isReverificationCancelledError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isReverificationCancelledError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isUnauthorizedError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isUnauthorizedError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'isUserLockedError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$isUserLockedError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'parseError', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$parseError;
    }
});
Object.defineProperty($1f2575dc6adb407c$exports, 'parseErrors', {
    enumerable: true,
    get: function() {
        return $1f2575dc6adb407c$var$parseErrors;
    }
});


var $0cf95eb7430458f3$exports = {};
//#region src/utils/instance.ts
/**
* Check if the frontendApi ends with a staging domain
*/ function $0cf95eb7430458f3$var$isStaging(frontendApi) {
    return frontendApi.endsWith(".lclstage.dev") || frontendApi.endsWith(".stgstage.dev") || frontendApi.endsWith(".clerkstage.dev") || frontendApi.endsWith(".accountsstage.dev");
}
//#endregion
Object.defineProperty($0cf95eb7430458f3$exports, 'isStaging', {
    enumerable: true,
    get: function() {
        return $0cf95eb7430458f3$var$isStaging;
    }
});


var $67d08262db6342b1$exports = {};
//#region src/retry.ts
const $67d08262db6342b1$var$defaultOptions = {
    initialDelay: 125,
    maxDelayBetweenRetries: 0,
    factor: 2,
    shouldRetry: (_, iteration)=>iteration < 5,
    retryImmediately: false,
    jitter: true
};
const $67d08262db6342b1$var$RETRY_IMMEDIATELY_DELAY = 100;
const $67d08262db6342b1$var$sleep = async (ms)=>new Promise((s)=>setTimeout(s, ms));
const $67d08262db6342b1$var$applyJitter = (delay, jitter)=>{
    return jitter ? delay * (1 + Math.random()) : delay;
};
const $67d08262db6342b1$var$createExponentialDelayAsyncFn = (opts)=>{
    let timesCalled = 0;
    const calculateDelayInMs = ()=>{
        const constant = opts.initialDelay;
        const base = opts.factor;
        let delay = constant * Math.pow(base, timesCalled);
        delay = $67d08262db6342b1$var$applyJitter(delay, opts.jitter);
        return Math.min(opts.maxDelayBetweenRetries || delay, delay);
    };
    return async ()=>{
        await $67d08262db6342b1$var$sleep(calculateDelayInMs());
        timesCalled++;
    };
};
/**
* Retries a callback until it succeeds or the shouldRetry function returns false.
* See {@link RetryOptions} for the available options.
*/ const $67d08262db6342b1$var$retry = async (callback, options = {})=>{
    let iterations = 0;
    const { shouldRetry: shouldRetry, initialDelay: initialDelay, maxDelayBetweenRetries: maxDelayBetweenRetries, factor: factor, retryImmediately: retryImmediately, jitter: jitter, onBeforeRetry: onBeforeRetry } = {
        ...$67d08262db6342b1$var$defaultOptions,
        ...options
    };
    const delay = $67d08262db6342b1$var$createExponentialDelayAsyncFn({
        initialDelay: initialDelay,
        maxDelayBetweenRetries: maxDelayBetweenRetries,
        factor: factor,
        jitter: jitter
    });
    while(true)try {
        return await callback();
    } catch (e) {
        iterations++;
        if (!shouldRetry(e, iterations)) throw e;
        if (onBeforeRetry) await onBeforeRetry(iterations);
        if (retryImmediately && iterations === 1) await $67d08262db6342b1$var$sleep($67d08262db6342b1$var$applyJitter($67d08262db6342b1$var$RETRY_IMMEDIATELY_DELAY, jitter));
        else await delay();
    }
};
//#endregion
Object.defineProperty($67d08262db6342b1$exports, 'retry', {
    enumerable: true,
    get: function() {
        return $67d08262db6342b1$var$retry;
    }
});


var $f98df02ba0a2b1a2$exports = {};

//#region src/loadScript.ts
const $f98df02ba0a2b1a2$var$NO_DOCUMENT_ERROR = "loadScript cannot be called when document does not exist";
const $f98df02ba0a2b1a2$var$NO_SRC_ERROR = "loadScript cannot be called without a src";
async function $f98df02ba0a2b1a2$var$loadScript(src = "", opts) {
    const { async: async, defer: defer, beforeLoad: beforeLoad, crossOrigin: crossOrigin, nonce: nonce } = opts || {};
    const load = ()=>{
        return new Promise((resolve, reject)=>{
            if (!src) reject(new Error($f98df02ba0a2b1a2$var$NO_SRC_ERROR));
            if (!document || !document.body) reject(new Error($f98df02ba0a2b1a2$var$NO_DOCUMENT_ERROR));
            const script = document.createElement("script");
            if (crossOrigin) script.setAttribute("crossorigin", crossOrigin);
            script.async = async || false;
            script.defer = defer || false;
            script.addEventListener("load", ()=>{
                script.remove();
                resolve(script);
            });
            script.addEventListener("error", (event)=>{
                script.remove();
                reject(event.error ?? /* @__PURE__ */ new Error(`failed to load script: ${src}`));
            });
            script.src = src;
            script.nonce = nonce;
            beforeLoad?.(script);
            document.body.appendChild(script);
        });
    };
    return $67d08262db6342b1$exports.retry(load, {
        shouldRetry: (_, iterations)=>iterations <= 5
    });
}
//#endregion
Object.defineProperty($f98df02ba0a2b1a2$exports, 'loadScript', {
    enumerable: true,
    get: function() {
        return $f98df02ba0a2b1a2$var$loadScript;
    }
});


var $c1f09affc3e59803$exports = {};
//#region src/proxy.ts
function $c1f09affc3e59803$var$isValidProxyUrl(key) {
    if (!key) return true;
    return $c1f09affc3e59803$var$isHttpOrHttps(key) || $c1f09affc3e59803$var$isProxyUrlRelative(key);
}
function $c1f09affc3e59803$var$isHttpOrHttps(key) {
    return /^http(s)?:\/\//.test(key || "");
}
function $c1f09affc3e59803$var$isProxyUrlRelative(key) {
    return key.startsWith("/");
}
function $c1f09affc3e59803$var$proxyUrlToAbsoluteURL(url) {
    if (!url) return "";
    return $c1f09affc3e59803$var$isProxyUrlRelative(url) ? new URL(url, window.location.origin).toString() : url;
}
//#endregion
Object.defineProperty($c1f09affc3e59803$exports, 'isHttpOrHttps', {
    enumerable: true,
    get: function() {
        return $c1f09affc3e59803$var$isHttpOrHttps;
    }
});
Object.defineProperty($c1f09affc3e59803$exports, 'isProxyUrlRelative', {
    enumerable: true,
    get: function() {
        return $c1f09affc3e59803$var$isProxyUrlRelative;
    }
});
Object.defineProperty($c1f09affc3e59803$exports, 'isValidProxyUrl', {
    enumerable: true,
    get: function() {
        return $c1f09affc3e59803$var$isValidProxyUrl;
    }
});
Object.defineProperty($c1f09affc3e59803$exports, 'proxyUrlToAbsoluteURL', {
    enumerable: true,
    get: function() {
        return $c1f09affc3e59803$var$proxyUrlToAbsoluteURL;
    }
});


var $ff3ed2ea5d08745b$exports = {};


//#region src/url.ts
function $ff3ed2ea5d08745b$var$parseSearchParams(queryString = "") {
    if (queryString.startsWith("?")) queryString = queryString.slice(1);
    return new URLSearchParams(queryString);
}
function $ff3ed2ea5d08745b$var$stripScheme(url = "") {
    return (url || "").replace(/^.+:\/\//, "");
}
function $ff3ed2ea5d08745b$var$addClerkPrefix(str) {
    if (!str) return "";
    let regex;
    if (str.match(/^(clerk\.)+\w*$/)) regex = /(clerk\.)*(?=clerk\.)/;
    else if (str.match(/\.clerk.accounts/)) return str;
    else regex = /^(clerk\.)*/gi;
    return `clerk.${str.replace(regex, "")}`;
}
/**
*
* Retrieve the clerk-js major tag using the major version from the pkgVersion
* param or use the frontendApi to determine if the canary tag should be used.
* The default tag is `latest`.
*/ const $ff3ed2ea5d08745b$var$getClerkJsMajorVersionOrTag = (frontendApi, version)=>{
    if (!version && $0cf95eb7430458f3$exports.isStaging(frontendApi)) return "canary";
    if (!version) return "latest";
    return version.split(".")[0] || "latest";
};
/**
*
* Retrieve the clerk-js script url from the frontendApi and the major tag
* using the {@link getClerkJsMajorVersionOrTag} or a provided clerkJSVersion tag.
*/ const $ff3ed2ea5d08745b$var$getScriptUrl = (frontendApi, { clerkJSVersion: clerkJSVersion })=>{
    const noSchemeFrontendApi = frontendApi.replace(/http(s)?:\/\//, "");
    const major = $ff3ed2ea5d08745b$var$getClerkJsMajorVersionOrTag(frontendApi, clerkJSVersion);
    return `https://${noSchemeFrontendApi}/npm/@clerk/clerk-js@${clerkJSVersion || major}/dist/clerk.browser.js`;
};
function $ff3ed2ea5d08745b$var$isLegacyDevAccountPortalOrigin(host) {
    return $98c33c808473ee85$exports.LEGACY_DEV_INSTANCE_SUFFIXES.some((legacyDevSuffix)=>{
        return host.startsWith("accounts.") && host.endsWith(legacyDevSuffix);
    });
}
function $ff3ed2ea5d08745b$var$isCurrentDevAccountPortalOrigin(host) {
    return $98c33c808473ee85$exports.CURRENT_DEV_INSTANCE_SUFFIXES.some((currentDevSuffix)=>{
        return host.endsWith(currentDevSuffix) && !host.endsWith(".clerk" + currentDevSuffix);
    });
}
const $ff3ed2ea5d08745b$var$TRAILING_SLASH_RE = /\/$|\/\?|\/#/;
function $ff3ed2ea5d08745b$var$hasTrailingSlash(input = "", respectQueryAndFragment) {
    if (!respectQueryAndFragment) return input.endsWith("/");
    return $ff3ed2ea5d08745b$var$TRAILING_SLASH_RE.test(input);
}
function $ff3ed2ea5d08745b$var$withTrailingSlash(input = "", respectQueryAndFragment) {
    if (!respectQueryAndFragment) return input.endsWith("/") ? input : input + "/";
    if ($ff3ed2ea5d08745b$var$hasTrailingSlash(input, true)) return input || "/";
    let path = input;
    let fragment = "";
    const fragmentIndex = input.indexOf("#");
    if (fragmentIndex >= 0) {
        path = input.slice(0, fragmentIndex);
        fragment = input.slice(fragmentIndex);
        if (!path) return fragment;
    }
    const [s0, ...s] = path.split("?");
    return s0 + "/" + (s.length > 0 ? `?${s.join("?")}` : "") + fragment;
}
function $ff3ed2ea5d08745b$var$withoutTrailingSlash(input = "", respectQueryAndFragment) {
    if (!respectQueryAndFragment) return ($ff3ed2ea5d08745b$var$hasTrailingSlash(input) ? input.slice(0, -1) : input) || "/";
    if (!$ff3ed2ea5d08745b$var$hasTrailingSlash(input, true)) return input || "/";
    let path = input;
    let fragment = "";
    const fragmentIndex = input.indexOf("#");
    if (fragmentIndex >= 0) {
        path = input.slice(0, fragmentIndex);
        fragment = input.slice(fragmentIndex);
    }
    const [s0, ...s] = path.split("?");
    return (s0.slice(0, -1) || "/") + (s.length > 0 ? `?${s.join("?")}` : "") + fragment;
}
function $ff3ed2ea5d08745b$var$hasLeadingSlash(input = "") {
    return input.startsWith("/");
}
function $ff3ed2ea5d08745b$var$withoutLeadingSlash(input = "") {
    return ($ff3ed2ea5d08745b$var$hasLeadingSlash(input) ? input.slice(1) : input) || "/";
}
function $ff3ed2ea5d08745b$var$withLeadingSlash(input = "") {
    return $ff3ed2ea5d08745b$var$hasLeadingSlash(input) ? input : "/" + input;
}
function $ff3ed2ea5d08745b$var$cleanDoubleSlashes(input = "") {
    return input.split("://").map((string_)=>string_.replace(/\/{2,}/g, "/")).join("://");
}
function $ff3ed2ea5d08745b$var$isNonEmptyURL(url) {
    return url && url !== "/";
}
const $ff3ed2ea5d08745b$var$JOIN_LEADING_SLASH_RE = /^\.?\//;
function $ff3ed2ea5d08745b$var$joinURL(base, ...input) {
    let url = base || "";
    for (const segment of input.filter((url$1)=>$ff3ed2ea5d08745b$var$isNonEmptyURL(url$1)))if (url) {
        const _segment = segment.replace($ff3ed2ea5d08745b$var$JOIN_LEADING_SLASH_RE, "");
        url = $ff3ed2ea5d08745b$var$withTrailingSlash(url) + _segment;
    } else url = segment;
    return url;
}
const $ff3ed2ea5d08745b$var$ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;
const $ff3ed2ea5d08745b$var$isAbsoluteUrl = (url)=>$ff3ed2ea5d08745b$var$ABSOLUTE_URL_REGEX.test(url);
//#endregion
Object.defineProperty($ff3ed2ea5d08745b$exports, 'addClerkPrefix', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$addClerkPrefix;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'cleanDoubleSlashes', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$cleanDoubleSlashes;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'getClerkJsMajorVersionOrTag', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$getClerkJsMajorVersionOrTag;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'getScriptUrl', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$getScriptUrl;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'hasLeadingSlash', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$hasLeadingSlash;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'hasTrailingSlash', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$hasTrailingSlash;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'isAbsoluteUrl', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$isAbsoluteUrl;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'isCurrentDevAccountPortalOrigin', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$isCurrentDevAccountPortalOrigin;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'isLegacyDevAccountPortalOrigin', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$isLegacyDevAccountPortalOrigin;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'isNonEmptyURL', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$isNonEmptyURL;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'joinURL', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$joinURL;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'parseSearchParams', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$parseSearchParams;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'stripScheme', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$stripScheme;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'withLeadingSlash', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$withLeadingSlash;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'withTrailingSlash', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$withTrailingSlash;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'withoutLeadingSlash', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$withoutLeadingSlash;
    }
});
Object.defineProperty($ff3ed2ea5d08745b$exports, 'withoutTrailingSlash', {
    enumerable: true,
    get: function() {
        return $ff3ed2ea5d08745b$var$withoutTrailingSlash;
    }
});


var $b3de32a49b5f9eb5$exports = {};
//#region src/versionSelector.ts
/**
* This version selector is a bit complicated, so here is the flow:
* 1. Use the clerkJSVersion prop on the provider
* 2. Use the exact `@clerk/clerk-js` version if it is a `@snapshot` prerelease
* 3. Use the prerelease tag of `@clerk/clerk-js` or the packageVersion provided
* 4. Fallback to the major version of `@clerk/clerk-js` or the packageVersion provided
* @param clerkJSVersion - The optional clerkJSVersion prop on the provider
* @param packageVersion - The version of `@clerk/clerk-js` that will be used if an explicit version is not provided
* @returns The npm tag, version or major version to use
*/ const $b3de32a49b5f9eb5$var$versionSelector = (clerkJSVersion, packageVersion = "5.125.10")=>{
    if (clerkJSVersion) return clerkJSVersion;
    const prereleaseTag = $b3de32a49b5f9eb5$var$getPrereleaseTag(packageVersion);
    if (prereleaseTag) {
        if (prereleaseTag === "snapshot") return "5.125.10";
        return prereleaseTag;
    }
    return $b3de32a49b5f9eb5$var$getMajorVersion(packageVersion);
};
const $b3de32a49b5f9eb5$var$getPrereleaseTag = (packageVersion)=>packageVersion.trim().replace(/^v/, "").match(/-(.+?)(\.|$)/)?.[1];
const $b3de32a49b5f9eb5$var$getMajorVersion = (packageVersion)=>packageVersion.trim().replace(/^v/, "").split(".")[0];
//#endregion
Object.defineProperty($b3de32a49b5f9eb5$exports, 'getMajorVersion', {
    enumerable: true,
    get: function() {
        return $b3de32a49b5f9eb5$var$getMajorVersion;
    }
});
Object.defineProperty($b3de32a49b5f9eb5$exports, 'versionSelector', {
    enumerable: true,
    get: function() {
        return $b3de32a49b5f9eb5$var$versionSelector;
    }
});


var $7362bf93b3a8d97e$exports = {};






//#region src/loadClerkJsScript.ts
const $7362bf93b3a8d97e$var$ERROR_CODE = "failed_to_load_clerk_js";
const $7362bf93b3a8d97e$var$ERROR_CODE_TIMEOUT = "failed_to_load_clerk_js_timeout";
const $7362bf93b3a8d97e$var$FAILED_TO_LOAD_ERROR = "Failed to load Clerk";
const { isDevOrStagingUrl: $7362bf93b3a8d97e$var$isDevOrStagingUrl } = $6fcb8ff7a3b82d27$exports.createDevOrStagingUrlCache();
const $7362bf93b3a8d97e$var$errorThrower = $1f2575dc6adb407c$exports.buildErrorThrower({
    packageName: "@clerk/shared"
});
/**
* Sets the package name for error messages during ClerkJS script loading.
*
* @param packageName - The name of the package to use in error messages (e.g., '@clerk/clerk-react').
* @example
* ```typescript
* setClerkJsLoadingErrorPackageName('@clerk/clerk-react');
* ```
*/ function $7362bf93b3a8d97e$var$setClerkJsLoadingErrorPackageName(packageName) {
    $7362bf93b3a8d97e$var$errorThrower.setPackageName({
        packageName: packageName
    });
}
/**
* Validates that window.Clerk exists and is properly initialized.
* This ensures we don't have false positives where the script loads but Clerk is malformed.
*
* @returns `true` if window.Clerk exists and has the expected structure with a load method.
*/ function $7362bf93b3a8d97e$var$isClerkProperlyLoaded() {
    if (typeof window === "undefined" || !window.Clerk) return false;
    const clerk = window.Clerk;
    return typeof clerk === "object" && typeof clerk.load === "function";
}
/**
* Checks if an existing script has a request error using Performance API.
*
* @param scriptUrl - The URL of the script to check.
* @returns True if the script has failed to load due to a network/HTTP error.
*/ function $7362bf93b3a8d97e$var$hasScriptRequestError(scriptUrl) {
    if (typeof window === "undefined" || !window.performance) return false;
    const entries = performance.getEntriesByName(scriptUrl, "resource");
    if (entries.length === 0) return false;
    const scriptEntry = entries[entries.length - 1];
    if (scriptEntry.transferSize === 0 && scriptEntry.decodedBodySize === 0) {
        if (scriptEntry.responseEnd === 0) return true;
        if (scriptEntry.responseEnd > 0 && scriptEntry.responseStart > 0) return true;
        if ("responseStatus" in scriptEntry) {
            if (scriptEntry.responseStatus >= 400) return true;
            if (scriptEntry.responseStatus === 0) return true;
        }
    }
    return false;
}
/**
* Waits for Clerk to be properly loaded with a timeout mechanism.
* Uses polling to check if Clerk becomes available within the specified timeout.
*
* @param timeoutMs - Maximum time to wait in milliseconds.
* @param existingScript - The existing script element to wait for. Optional, for existing scripts.
* @returns Promise that resolves with null if Clerk loads successfully, or rejects with an error if timeout is reached.
*/ function $7362bf93b3a8d97e$var$waitForClerkWithTimeout(timeoutMs, existingScript) {
    return new Promise((resolve, reject)=>{
        let resolved = false;
        const cleanup = (timeoutId$1, pollInterval$1)=>{
            clearTimeout(timeoutId$1);
            clearInterval(pollInterval$1);
        };
        existingScript?.addEventListener("error", ()=>{
            cleanup(timeoutId, pollInterval);
            reject(new $1f2575dc6adb407c$exports.ClerkRuntimeError($7362bf93b3a8d97e$var$FAILED_TO_LOAD_ERROR, {
                code: $7362bf93b3a8d97e$var$ERROR_CODE
            }));
        });
        const checkAndResolve = ()=>{
            if (resolved) return;
            if ($7362bf93b3a8d97e$var$isClerkProperlyLoaded()) {
                resolved = true;
                cleanup(timeoutId, pollInterval);
                resolve(null);
            }
        };
        const handleTimeout = ()=>{
            if (resolved) return;
            resolved = true;
            cleanup(timeoutId, pollInterval);
            if (!$7362bf93b3a8d97e$var$isClerkProperlyLoaded()) reject(new $1f2575dc6adb407c$exports.ClerkRuntimeError($7362bf93b3a8d97e$var$FAILED_TO_LOAD_ERROR, {
                code: $7362bf93b3a8d97e$var$ERROR_CODE_TIMEOUT
            }));
            else resolve(null);
        };
        const timeoutId = setTimeout(handleTimeout, timeoutMs);
        checkAndResolve();
        const pollInterval = setInterval(()=>{
            if (resolved) {
                clearInterval(pollInterval);
                return;
            }
            checkAndResolve();
        }, 100);
    });
}
/**
* Hotloads the Clerk JS script with robust failure detection and retry logic.
*
* For existing scripts:
* - If no request error detected: waits for timeout, then retries with loadScript if timeout expires
* - If request error detected: immediately retries with loadScript.
*
* For new scripts: uses loadScript which has built-in retry logic via the retry utility.
*
* @param opts - The options used to build the Clerk JS script URL and load the script.
*               Must include a `publishableKey` if no existing script is found.
* @returns Promise that resolves with null if Clerk loads successfully, or rejects with an error.
*
* @example
* ```typescript
* try {
*   await loadClerkJsScript({ publishableKey: 'pk_test_...' });
*   console.log('Clerk loaded successfully');
* } catch (error) {
*   console.error('Failed to load Clerk:', error.message);
* }
* ```
*/ const $7362bf93b3a8d97e$var$loadClerkJsScript = async (opts)=>{
    const timeout = opts?.scriptLoadTimeout ?? 15e3;
    if ($7362bf93b3a8d97e$var$isClerkProperlyLoaded()) return null;
    if (!opts?.publishableKey) {
        $7362bf93b3a8d97e$var$errorThrower.throwMissingPublishableKeyError();
        return null;
    }
    const scriptUrl = $7362bf93b3a8d97e$var$clerkJsScriptUrl(opts);
    const existingScript = document.querySelector("script[data-clerk-js-script]");
    if (existingScript) {
        if ($7362bf93b3a8d97e$var$hasScriptRequestError(scriptUrl)) existingScript.remove();
        else try {
            await $7362bf93b3a8d97e$var$waitForClerkWithTimeout(timeout, existingScript);
            return null;
        } catch  {
            existingScript.remove();
        }
    }
    const loadPromise = $7362bf93b3a8d97e$var$waitForClerkWithTimeout(timeout);
    $f98df02ba0a2b1a2$exports.loadScript(scriptUrl, {
        async: true,
        crossOrigin: "anonymous",
        nonce: opts.nonce,
        beforeLoad: $7362bf93b3a8d97e$var$applyClerkJsScriptAttributes(opts)
    }).catch((error)=>{
        throw new $1f2575dc6adb407c$exports.ClerkRuntimeError($7362bf93b3a8d97e$var$FAILED_TO_LOAD_ERROR + (error.message ? `, ${error.message}` : ""), {
            code: $7362bf93b3a8d97e$var$ERROR_CODE,
            cause: error
        });
    });
    return loadPromise;
};
/**
* Generates a Clerk JS script URL based on the provided options.
*
* @param opts - The options to use when building the Clerk JS script URL.
* @returns The complete URL to the Clerk JS script.
*
* @example
* ```typescript
* const url = clerkJsScriptUrl({ publishableKey: 'pk_test_...' });
* // Returns: "https://example.clerk.accounts.dev/npm/@clerk/clerk-js@5/dist/clerk.browser.js"
* ```
*/ const $7362bf93b3a8d97e$var$clerkJsScriptUrl = (opts)=>{
    const { clerkJSUrl: clerkJSUrl, clerkJSVariant: clerkJSVariant, clerkJSVersion: clerkJSVersion, proxyUrl: proxyUrl, domain: domain, publishableKey: publishableKey } = opts;
    if (clerkJSUrl) return clerkJSUrl;
    let scriptHost = "";
    if (!!proxyUrl && $c1f09affc3e59803$exports.isValidProxyUrl(proxyUrl)) scriptHost = $c1f09affc3e59803$exports.proxyUrlToAbsoluteURL(proxyUrl).replace(/http(s)?:\/\//, "");
    else if (domain && !$7362bf93b3a8d97e$var$isDevOrStagingUrl($6fcb8ff7a3b82d27$exports.parsePublishableKey(publishableKey)?.frontendApi || "")) scriptHost = $ff3ed2ea5d08745b$exports.addClerkPrefix(domain);
    else scriptHost = $6fcb8ff7a3b82d27$exports.parsePublishableKey(publishableKey)?.frontendApi || "";
    const variant = clerkJSVariant ? `${clerkJSVariant.replace(/\.+$/, "")}.` : "";
    const version = $b3de32a49b5f9eb5$exports.versionSelector(clerkJSVersion);
    return `https://${scriptHost}/npm/@clerk/clerk-js@${version}/dist/clerk.${variant}browser.js`;
};
/**
* Builds an object of Clerk JS script attributes based on the provided options.
*
* @param options - The options containing the values for script attributes.
* @returns An object containing data attributes to be applied to the script element.
*/ const $7362bf93b3a8d97e$var$buildClerkJsScriptAttributes = (options)=>{
    const obj = {};
    if (options.publishableKey) obj["data-clerk-publishable-key"] = options.publishableKey;
    if (options.proxyUrl) obj["data-clerk-proxy-url"] = options.proxyUrl;
    if (options.domain) obj["data-clerk-domain"] = options.domain;
    if (options.nonce) obj.nonce = options.nonce;
    return obj;
};
/**
* Returns a function that applies Clerk JS script attributes to a script element.
*
* @param options - The options containing the values for script attributes.
* @returns A function that accepts a script element and applies the attributes to it.
*/ const $7362bf93b3a8d97e$var$applyClerkJsScriptAttributes = (options)=>(script)=>{
        const attributes = $7362bf93b3a8d97e$var$buildClerkJsScriptAttributes(options);
        for(const attribute in attributes)script.setAttribute(attribute, attributes[attribute]);
    };
//#endregion
Object.defineProperty($7362bf93b3a8d97e$exports, 'buildClerkJsScriptAttributes', {
    enumerable: true,
    get: function() {
        return $7362bf93b3a8d97e$var$buildClerkJsScriptAttributes;
    }
});
Object.defineProperty($7362bf93b3a8d97e$exports, 'clerkJsScriptUrl', {
    enumerable: true,
    get: function() {
        return $7362bf93b3a8d97e$var$clerkJsScriptUrl;
    }
});
Object.defineProperty($7362bf93b3a8d97e$exports, 'loadClerkJsScript', {
    enumerable: true,
    get: function() {
        return $7362bf93b3a8d97e$var$loadClerkJsScript;
    }
});
Object.defineProperty($7362bf93b3a8d97e$exports, 'setClerkJsLoadingErrorPackageName', {
    enumerable: true,
    get: function() {
        return $7362bf93b3a8d97e$var$setClerkJsLoadingErrorPackageName;
    }
});


$3aa9b7204540f02e$export$1dfd3eba1fb8c8a7 = $7362bf93b3a8d97e$exports.buildClerkJsScriptAttributes;
$3aa9b7204540f02e$export$900dd1fdd9dbe2cc = $7362bf93b3a8d97e$exports.clerkJsScriptUrl;
$3aa9b7204540f02e$export$4236f1a239719b87 = $7362bf93b3a8d97e$exports.loadClerkJsScript;
$3aa9b7204540f02e$export$b09f006ee485e599 = $7362bf93b3a8d97e$exports.setClerkJsLoadingErrorPackageName;


var $346d18b83b22cab1$export$2004df0451102cf0;
var $346d18b83b22cab1$export$39be4f26d79b784e;
var $346d18b83b22cab1$export$df1513f902d76e7d;
var $346d18b83b22cab1$export$fe2ceda099eabbcf;
var $346d18b83b22cab1$export$bbb5f5265da33e0b;
var $346d18b83b22cab1$export$b4b32666f27c1301;
var $346d18b83b22cab1$export$7d76380c82685e4e;
var $346d18b83b22cab1$export$c3c6f97c81081e35;
var $346d18b83b22cab1$export$c71510c907399d1a;
var $346d18b83b22cab1$export$d6149cfe10ecbed3;
var $346d18b83b22cab1$export$f87041bdc85d12d6;
var $346d18b83b22cab1$export$31a9e05bd028d3d;
var $346d18b83b22cab1$export$94c4b26e937da69;
var $346d18b83b22cab1$export$1c520bd9f290ecaf;
var $346d18b83b22cab1$export$14943dd9f5f923c9;
var $346d18b83b22cab1$export$58b182cd5231a30;
var $346d18b83b22cab1$export$1b169b30ce325e12;
var $346d18b83b22cab1$export$f27b1e207a84a83b;
var $346d18b83b22cab1$export$213edfafdcc95f87;
var $346d18b83b22cab1$export$7b2954b19590b40a;
var $346d18b83b22cab1$export$56baa804d948aaa2;
var $346d18b83b22cab1$export$476aa014e2fd89d5;
var $346d18b83b22cab1$export$658e0f295ee4069c;
var $346d18b83b22cab1$export$50193223a8dfaf6c;
var $346d18b83b22cab1$export$abdf6cfea807c6a2;
var $346d18b83b22cab1$export$55152de1f925fd05;
var $346d18b83b22cab1$export$bf69e6e5d315bf4;
var $346d18b83b22cab1$export$e80a9284539c1797;
var $346d18b83b22cab1$export$45fc6b2d335e3c39;

$346d18b83b22cab1$export$2004df0451102cf0 = $1f2575dc6adb407c$exports.ClerkAPIError;
$346d18b83b22cab1$export$39be4f26d79b784e = $1f2575dc6adb407c$exports.ClerkAPIResponseError;
$346d18b83b22cab1$export$df1513f902d76e7d = $1f2575dc6adb407c$exports.ClerkError;
$346d18b83b22cab1$export$fe2ceda099eabbcf = $1f2575dc6adb407c$exports.ClerkRuntimeError;
$346d18b83b22cab1$export$bbb5f5265da33e0b = $1f2575dc6adb407c$exports.ClerkWebAuthnError;
$346d18b83b22cab1$export$b4b32666f27c1301 = $1f2575dc6adb407c$exports.EmailLinkError;
$346d18b83b22cab1$export$7d76380c82685e4e = $1f2575dc6adb407c$exports.EmailLinkErrorCode;
$346d18b83b22cab1$export$c3c6f97c81081e35 = $1f2575dc6adb407c$exports.EmailLinkErrorCodeStatus;
$346d18b83b22cab1$export$c71510c907399d1a = $1f2575dc6adb407c$exports.MissingExpiredTokenError;
$346d18b83b22cab1$export$d6149cfe10ecbed3 = $1f2575dc6adb407c$exports.buildErrorThrower;
$346d18b83b22cab1$export$f87041bdc85d12d6 = $1f2575dc6adb407c$exports.createClerkGlobalHookError;
$346d18b83b22cab1$export$31a9e05bd028d3d = $1f2575dc6adb407c$exports.errorToJSON;
$346d18b83b22cab1$export$94c4b26e937da69 = $1f2575dc6adb407c$exports.is4xxError;
$346d18b83b22cab1$export$1c520bd9f290ecaf = $1f2575dc6adb407c$exports.isCaptchaError;
$346d18b83b22cab1$export$14943dd9f5f923c9 = $1f2575dc6adb407c$exports.isClerkAPIError;
$346d18b83b22cab1$export$58b182cd5231a30 = $1f2575dc6adb407c$exports.isClerkAPIResponseError;
$346d18b83b22cab1$export$1b169b30ce325e12 = $1f2575dc6adb407c$exports.isClerkError;
$346d18b83b22cab1$export$f27b1e207a84a83b = $1f2575dc6adb407c$exports.isClerkRuntimeError;
$346d18b83b22cab1$export$213edfafdcc95f87 = $1f2575dc6adb407c$exports.isEmailLinkError;
$346d18b83b22cab1$export$7b2954b19590b40a = $1f2575dc6adb407c$exports.isKnownError;
$346d18b83b22cab1$export$56baa804d948aaa2 = $1f2575dc6adb407c$exports.isMetamaskError;
$346d18b83b22cab1$export$476aa014e2fd89d5 = $1f2575dc6adb407c$exports.isNetworkError;
$346d18b83b22cab1$export$658e0f295ee4069c = $1f2575dc6adb407c$exports.isPasswordCompromisedError;
$346d18b83b22cab1$export$50193223a8dfaf6c = $1f2575dc6adb407c$exports.isPasswordPwnedError;
$346d18b83b22cab1$export$abdf6cfea807c6a2 = $1f2575dc6adb407c$exports.isReverificationCancelledError;
$346d18b83b22cab1$export$55152de1f925fd05 = $1f2575dc6adb407c$exports.isUnauthorizedError;
$346d18b83b22cab1$export$bf69e6e5d315bf4 = $1f2575dc6adb407c$exports.isUserLockedError;
$346d18b83b22cab1$export$e80a9284539c1797 = $1f2575dc6adb407c$exports.parseError;
$346d18b83b22cab1$export$45fc6b2d335e3c39 = $1f2575dc6adb407c$exports.parseErrors;


var $8fcdbf2d7a4660c6$var$errorThrower = (0, $346d18b83b22cab1$export$d6149cfe10ecbed3)({
    packageName: "@clerk/clerk-react"
});
function $8fcdbf2d7a4660c6$var$setErrorThrowerOptions(options) {
    $8fcdbf2d7a4660c6$var$errorThrower.setMessages(options).setPackageName(options);
}
var $52b16e2619eaae81$export$bcf8c46c380b2b4c;
var $52b16e2619eaae81$export$87a845ded7190bfc;
var $52b16e2619eaae81$export$cb9aa75be728b8f4;
var $52b16e2619eaae81$export$fc0998bfe9486aa1;
var $52b16e2619eaae81$export$af80d780caaebdea;
var $52b16e2619eaae81$export$987dd53eec1f61cf;
var $52b16e2619eaae81$export$9c0c5d1f8a7fb19a;
var $52b16e2619eaae81$export$23da1d24a38b0bde;
var $52b16e2619eaae81$export$43ea16ac36fe59f1;
var $52b16e2619eaae81$export$dcbd8d97225896c0;
var $52b16e2619eaae81$export$8793edee2d425525;
var $66268821e8eb5cee$exports = {};
//#region src/utils/runtimeEnvironment.ts
const $66268821e8eb5cee$var$isDevelopmentEnvironment = ()=>{
    try {
        return false;
    } catch  {}
    return false;
};
const $66268821e8eb5cee$var$isTestEnvironment = ()=>{
    try {
        return false;
    } catch  {}
    return false;
};
const $66268821e8eb5cee$var$isProductionEnvironment = ()=>{
    try {
        return true;
    } catch  {}
    return false;
};
//#endregion
Object.defineProperty($66268821e8eb5cee$exports, 'isDevelopmentEnvironment', {
    enumerable: true,
    get: function() {
        return $66268821e8eb5cee$var$isDevelopmentEnvironment;
    }
});
Object.defineProperty($66268821e8eb5cee$exports, 'isProductionEnvironment', {
    enumerable: true,
    get: function() {
        return $66268821e8eb5cee$var$isProductionEnvironment;
    }
});
Object.defineProperty($66268821e8eb5cee$exports, 'isTestEnvironment', {
    enumerable: true,
    get: function() {
        return $66268821e8eb5cee$var$isTestEnvironment;
    }
});


var $46f571b77c6575f4$exports = {};
//#region src/utils/handleValueOrFn.ts
function $46f571b77c6575f4$var$handleValueOrFn(value, url, defaultValue) {
    if (typeof value === "function") return value(url);
    if (typeof value !== "undefined") return value;
    if (typeof defaultValue !== "undefined") return defaultValue;
}
//#endregion
Object.defineProperty($46f571b77c6575f4$exports, 'handleValueOrFn', {
    enumerable: true,
    get: function() {
        return $46f571b77c6575f4$var$handleValueOrFn;
    }
});


var $34fb500c9a5c29b0$exports = {};
//#region src/utils/noop.ts
const $34fb500c9a5c29b0$var$noop = (..._args)=>{};
//#endregion
Object.defineProperty($34fb500c9a5c29b0$exports, 'noop', {
    enumerable: true,
    get: function() {
        return $34fb500c9a5c29b0$var$noop;
    }
});


var $c4d1cec7f47d93b5$exports = {};

//#region src/utils/createDeferredPromise.ts
/**
* Create a promise that can be resolved or rejected from
* outside the Promise constructor callback
* A ES6 compatible utility that implements `Promise.withResolvers`
* @internal
*/ const $c4d1cec7f47d93b5$var$createDeferredPromise = ()=>{
    let resolve = $34fb500c9a5c29b0$exports.noop;
    let reject = $34fb500c9a5c29b0$exports.noop;
    return {
        promise: new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        }),
        resolve: resolve,
        reject: reject
    };
};
//#endregion
Object.defineProperty($c4d1cec7f47d93b5$exports, 'createDeferredPromise', {
    enumerable: true,
    get: function() {
        return $c4d1cec7f47d93b5$var$createDeferredPromise;
    }
});


var $966aee6ec203f372$exports = {};

//#region src/utils/allSettled.ts
/**
* A ES6 compatible utility that implements `Promise.allSettled`
* @internal
*/ function $966aee6ec203f372$var$allSettled(iterable) {
    const promises = Array.from(iterable).map((p)=>p.then((value)=>({
                status: "fulfilled",
                value: value
            }), (reason)=>({
                status: "rejected",
                reason: reason
            })));
    return Promise.all(promises);
}
//#endregion
//#region src/utils/logErrorInDevMode.ts
const $966aee6ec203f372$var$logErrorInDevMode = (message)=>{
    if ($66268821e8eb5cee$exports.isDevelopmentEnvironment()) console.error(`Clerk: ${message}`);
};
//#endregion
//#region src/utils/fastDeepMerge.ts
const $966aee6ec203f372$var$DANGEROUS_KEYS = new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
/**
* Merges 2 objects without creating new object references
* The merged props will appear on the `target` object
* If `target` already has a value for a given key it will not be overwritten
*/ const $966aee6ec203f372$var$fastDeepMergeAndReplace = (source, target)=>{
    if (!source || !target) return;
    for(const key in source){
        if ($966aee6ec203f372$var$DANGEROUS_KEYS.has(key)) continue;
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== null && typeof source[key] === `object`) {
            if (target[key] === void 0) target[key] = new (Object.getPrototypeOf(source[key])).constructor();
            $966aee6ec203f372$var$fastDeepMergeAndReplace(source[key], target[key]);
        } else if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== void 0) target[key] = source[key];
    }
};
const $966aee6ec203f372$var$fastDeepMergeAndKeep = (source, target)=>{
    if (!source || !target) return;
    for(const key in source){
        if ($966aee6ec203f372$var$DANGEROUS_KEYS.has(key)) continue;
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== null && typeof source[key] === `object`) {
            if (target[key] === void 0) target[key] = new (Object.getPrototypeOf(source[key])).constructor();
            $966aee6ec203f372$var$fastDeepMergeAndKeep(source[key], target[key]);
        } else if (Object.prototype.hasOwnProperty.call(source, key) && target[key] === void 0) target[key] = source[key];
    }
};
//#endregion
Object.defineProperty($966aee6ec203f372$exports, 'allSettled', {
    enumerable: true,
    get: function() {
        return $966aee6ec203f372$var$allSettled;
    }
});
Object.defineProperty($966aee6ec203f372$exports, 'fastDeepMergeAndKeep', {
    enumerable: true,
    get: function() {
        return $966aee6ec203f372$var$fastDeepMergeAndKeep;
    }
});
Object.defineProperty($966aee6ec203f372$exports, 'fastDeepMergeAndReplace', {
    enumerable: true,
    get: function() {
        return $966aee6ec203f372$var$fastDeepMergeAndReplace;
    }
});
Object.defineProperty($966aee6ec203f372$exports, 'logErrorInDevMode', {
    enumerable: true,
    get: function() {
        return $966aee6ec203f372$var$logErrorInDevMode;
    }
});



$52b16e2619eaae81$export$bcf8c46c380b2b4c = $966aee6ec203f372$exports.allSettled;
$52b16e2619eaae81$export$87a845ded7190bfc = $c4d1cec7f47d93b5$exports.createDeferredPromise;
$52b16e2619eaae81$export$cb9aa75be728b8f4 = $966aee6ec203f372$exports.fastDeepMergeAndKeep;
$52b16e2619eaae81$export$fc0998bfe9486aa1 = $966aee6ec203f372$exports.fastDeepMergeAndReplace;
$52b16e2619eaae81$export$af80d780caaebdea = $46f571b77c6575f4$exports.handleValueOrFn;
$52b16e2619eaae81$export$987dd53eec1f61cf = $66268821e8eb5cee$exports.isDevelopmentEnvironment;
$52b16e2619eaae81$export$9c0c5d1f8a7fb19a = $66268821e8eb5cee$exports.isProductionEnvironment;
$52b16e2619eaae81$export$23da1d24a38b0bde = $0cf95eb7430458f3$exports.isStaging;
$52b16e2619eaae81$export$43ea16ac36fe59f1 = $66268821e8eb5cee$exports.isTestEnvironment;
$52b16e2619eaae81$export$dcbd8d97225896c0 = $966aee6ec203f372$exports.logErrorInDevMode;
$52b16e2619eaae81$export$8793edee2d425525 = $34fb500c9a5c29b0$exports.noop;



var $8fcdbf2d7a4660c6$var$import_react13 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
// src/errors/messages.ts
var $8fcdbf2d7a4660c6$var$multipleClerkProvidersError = "You've added multiple <ClerkProvider> components in your React component tree. Wrap your components in a single <ClerkProvider>.";
var $8fcdbf2d7a4660c6$var$multipleChildrenInButtonComponent = (name)=>`You've passed multiple children components to <${name}/>. You can only pass a single child component or text.`;
var $8fcdbf2d7a4660c6$var$invalidStateError = "Invalid state. Feel free to submit a bug or reach out to support here: https://clerk.com/support";
var $8fcdbf2d7a4660c6$var$unsupportedNonBrowserDomainOrProxyUrlFunction = "Unsupported usage of isSatellite, domain or proxyUrl. The usage of isSatellite, domain or proxyUrl as function is not supported in non-browser environments.";
var $8fcdbf2d7a4660c6$var$userProfilePageRenderedError = "<UserProfile.Page /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.";
var $8fcdbf2d7a4660c6$var$userProfileLinkRenderedError = "<UserProfile.Link /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.";
var $8fcdbf2d7a4660c6$var$organizationProfilePageRenderedError = "<OrganizationProfile.Page /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.";
var $8fcdbf2d7a4660c6$var$organizationProfileLinkRenderedError = "<OrganizationProfile.Link /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.";
var $8fcdbf2d7a4660c6$var$customPagesIgnoredComponent = (componentName)=>`<${componentName} /> can only accept <${componentName}.Page /> and <${componentName}.Link /> as its children. Any other provided component will be ignored. Additionally, please ensure that the component is rendered in a client component.`;
var $8fcdbf2d7a4660c6$var$customPageWrongProps = (componentName)=>`Missing props. <${componentName}.Page /> component requires the following props: url, label, labelIcon, alongside with children to be rendered inside the page.`;
var $8fcdbf2d7a4660c6$var$customLinkWrongProps = (componentName)=>`Missing props. <${componentName}.Link /> component requires the following props: url, label and labelIcon.`;
var $8fcdbf2d7a4660c6$var$userButtonIgnoredComponent = `<UserButton /> can only accept <UserButton.UserProfilePage />, <UserButton.UserProfileLink /> and <UserButton.MenuItems /> as its children. Any other provided component will be ignored. Additionally, please ensure that the component is rendered in a client component.`;
var $8fcdbf2d7a4660c6$var$customMenuItemsIgnoredComponent = "<UserButton.MenuItems /> component can only accept <UserButton.Action /> and <UserButton.Link /> as its children. Any other provided component will be ignored. Additionally, please ensure that the component is rendered in a client component.";
var $8fcdbf2d7a4660c6$var$userButtonMenuItemsRenderedError = "<UserButton.MenuItems /> component needs to be a direct child of `<UserButton />`.";
var $8fcdbf2d7a4660c6$var$userButtonMenuActionRenderedError = "<UserButton.Action /> component needs to be a direct child of `<UserButton.MenuItems />`.";
var $8fcdbf2d7a4660c6$var$userButtonMenuLinkRenderedError = "<UserButton.Link /> component needs to be a direct child of `<UserButton.MenuItems />`.";
var $8fcdbf2d7a4660c6$var$userButtonMenuItemLinkWrongProps = "Missing props. <UserButton.Link /> component requires the following props: href, label and labelIcon.";
var $8fcdbf2d7a4660c6$var$userButtonMenuItemsActionWrongsProps = "Missing props. <UserButton.Action /> component requires the following props: label.";

// src/utils/childrenUtils.tsx
var $8fcdbf2d7a4660c6$var$import_react = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$assertSingleChild = (children)=>(name)=>{
        try {
            return $8fcdbf2d7a4660c6$var$import_react.default.Children.only(children);
        } catch  {
            return $8fcdbf2d7a4660c6$var$errorThrower.throw($8fcdbf2d7a4660c6$var$multipleChildrenInButtonComponent(name));
        }
    };
var $8fcdbf2d7a4660c6$var$normalizeWithDefaultValue = (children, defaultText)=>{
    if (!children) children = defaultText;
    if (typeof children === "string") children = /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react.default.createElement("button", null, children);
    return children;
};
var $8fcdbf2d7a4660c6$var$safeExecute = (cb)=>(...args)=>{
        if (cb && typeof cb === "function") return cb(...args);
    };
// src/utils/isConstructor.ts
function $8fcdbf2d7a4660c6$var$isConstructor(f) {
    return typeof f === "function";
}

// src/utils/useMaxAllowedInstancesGuard.tsx
var $8fcdbf2d7a4660c6$var$import_react2 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$counts = /* @__PURE__ */ new Map();
function $8fcdbf2d7a4660c6$var$useMaxAllowedInstancesGuard(name, error, maxCount = 1) {
    $8fcdbf2d7a4660c6$var$import_react2.default.useEffect(()=>{
        const count = $8fcdbf2d7a4660c6$var$counts.get(name) || 0;
        if (count == maxCount) return $8fcdbf2d7a4660c6$var$errorThrower.throw(error);
        $8fcdbf2d7a4660c6$var$counts.set(name, count + 1);
        return ()=>{
            $8fcdbf2d7a4660c6$var$counts.set(name, ($8fcdbf2d7a4660c6$var$counts.get(name) || 1) - 1);
        };
    }, []);
}
function $8fcdbf2d7a4660c6$var$withMaxAllowedInstancesGuard(WrappedComponent, name, error) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || name || "Component";
    const Hoc = (props)=>{
        $8fcdbf2d7a4660c6$var$useMaxAllowedInstancesGuard(name, error);
        return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react2.default.createElement(WrappedComponent, {
            ...props
        });
    };
    Hoc.displayName = `withMaxAllowedInstancesGuard(${displayName})`;
    return Hoc;
}


var $1u0KT = parcelRequire("1u0KT");
var $8fcdbf2d7a4660c6$var$useCustomElementPortal = (elements)=>{
    const [nodeMap, setNodeMap] = (0, (parcelRequire("acw62")).useState)(/* @__PURE__ */ new Map());
    return elements.map((el)=>({
            id: el.id,
            mount: (node)=>setNodeMap((prev)=>new Map(prev).set(String(el.id), node)),
            unmount: ()=>setNodeMap((prev)=>{
                    const newMap = new Map(prev);
                    newMap.set(String(el.id), null);
                    return newMap;
                }),
            portal: ()=>{
                const node = nodeMap.get(String(el.id));
                return node ? (0, $1u0KT.createPortal)(el.component, node) : null;
            }
        }));
};


var $8fcdbf2d7a4660c6$var$import_react5 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));

// src/utils/componentValidation.ts
var $8fcdbf2d7a4660c6$var$import_react4 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$isThatComponent = (v, component)=>{
    return !!v && $8fcdbf2d7a4660c6$var$import_react4.default.isValidElement(v) && (v == null ? void 0 : v.type) === component;
};
// src/utils/useCustomPages.tsx
var $8fcdbf2d7a4660c6$var$useUserProfileCustomPages = (children, options)=>{
    const reorderItemsLabels = [
        "account",
        "security",
        "billing",
        "apiKeys"
    ];
    return $8fcdbf2d7a4660c6$var$useCustomPages({
        children: children,
        reorderItemsLabels: reorderItemsLabels,
        LinkComponent: $8fcdbf2d7a4660c6$var$UserProfileLink,
        PageComponent: $8fcdbf2d7a4660c6$var$UserProfilePage,
        MenuItemsComponent: $8fcdbf2d7a4660c6$var$MenuItems,
        componentName: "UserProfile"
    }, options);
};
var $8fcdbf2d7a4660c6$var$useOrganizationProfileCustomPages = (children, options)=>{
    const reorderItemsLabels = [
        "general",
        "members",
        "billing",
        "apiKeys"
    ];
    return $8fcdbf2d7a4660c6$var$useCustomPages({
        children: children,
        reorderItemsLabels: reorderItemsLabels,
        LinkComponent: $8fcdbf2d7a4660c6$var$OrganizationProfileLink,
        PageComponent: $8fcdbf2d7a4660c6$var$OrganizationProfilePage,
        componentName: "OrganizationProfile"
    }, options);
};
var $8fcdbf2d7a4660c6$var$useSanitizedChildren = (children)=>{
    const sanitizedChildren = [];
    const excludedComponents = [
        $8fcdbf2d7a4660c6$var$OrganizationProfileLink,
        $8fcdbf2d7a4660c6$var$OrganizationProfilePage,
        $8fcdbf2d7a4660c6$var$MenuItems,
        $8fcdbf2d7a4660c6$var$UserProfilePage,
        $8fcdbf2d7a4660c6$var$UserProfileLink
    ];
    $8fcdbf2d7a4660c6$var$import_react5.default.Children.forEach(children, (child)=>{
        if (!excludedComponents.some((component)=>$8fcdbf2d7a4660c6$var$isThatComponent(child, component))) sanitizedChildren.push(child);
    });
    return sanitizedChildren;
};
var $8fcdbf2d7a4660c6$var$useCustomPages = (params, options)=>{
    const { children: children, LinkComponent: LinkComponent, PageComponent: PageComponent, MenuItemsComponent: MenuItemsComponent, reorderItemsLabels: reorderItemsLabels, componentName: componentName } = params;
    const { allowForAnyChildren: allowForAnyChildren = false } = options || {};
    const validChildren = [];
    $8fcdbf2d7a4660c6$var$import_react5.default.Children.forEach(children, (child)=>{
        if (!$8fcdbf2d7a4660c6$var$isThatComponent(child, PageComponent) && !$8fcdbf2d7a4660c6$var$isThatComponent(child, LinkComponent) && !$8fcdbf2d7a4660c6$var$isThatComponent(child, MenuItemsComponent)) {
            if (child && !allowForAnyChildren) (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$customPagesIgnoredComponent(componentName));
            return;
        }
        const { props: props } = child;
        const { children: children2, label: label, url: url, labelIcon: labelIcon } = props;
        if ($8fcdbf2d7a4660c6$var$isThatComponent(child, PageComponent)) {
            if ($8fcdbf2d7a4660c6$var$isReorderItem(props, reorderItemsLabels)) validChildren.push({
                label: label
            });
            else if ($8fcdbf2d7a4660c6$var$isCustomPage(props)) validChildren.push({
                label: label,
                labelIcon: labelIcon,
                children: children2,
                url: url
            });
            else {
                (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$customPageWrongProps(componentName));
                return;
            }
        }
        if ($8fcdbf2d7a4660c6$var$isThatComponent(child, LinkComponent)) {
            if ($8fcdbf2d7a4660c6$var$isExternalLink(props)) validChildren.push({
                label: label,
                labelIcon: labelIcon,
                url: url
            });
            else {
                (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$customLinkWrongProps(componentName));
                return;
            }
        }
    });
    const customPageContents = [];
    const customPageLabelIcons = [];
    const customLinkLabelIcons = [];
    validChildren.forEach((cp, index)=>{
        if ($8fcdbf2d7a4660c6$var$isCustomPage(cp)) {
            customPageContents.push({
                component: cp.children,
                id: index
            });
            customPageLabelIcons.push({
                component: cp.labelIcon,
                id: index
            });
            return;
        }
        if ($8fcdbf2d7a4660c6$var$isExternalLink(cp)) customLinkLabelIcons.push({
            component: cp.labelIcon,
            id: index
        });
    });
    const customPageContentsPortals = $8fcdbf2d7a4660c6$var$useCustomElementPortal(customPageContents);
    const customPageLabelIconsPortals = $8fcdbf2d7a4660c6$var$useCustomElementPortal(customPageLabelIcons);
    const customLinkLabelIconsPortals = $8fcdbf2d7a4660c6$var$useCustomElementPortal(customLinkLabelIcons);
    const customPages = [];
    const customPagesPortals = [];
    validChildren.forEach((cp, index)=>{
        if ($8fcdbf2d7a4660c6$var$isReorderItem(cp, reorderItemsLabels)) {
            customPages.push({
                label: cp.label
            });
            return;
        }
        if ($8fcdbf2d7a4660c6$var$isCustomPage(cp)) {
            const { portal: contentPortal, mount: mount, unmount: unmount } = customPageContentsPortals.find((p)=>p.id === index);
            const { portal: labelPortal, mount: mountIcon, unmount: unmountIcon } = customPageLabelIconsPortals.find((p)=>p.id === index);
            customPages.push({
                label: cp.label,
                url: cp.url,
                mount: mount,
                unmount: unmount,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            });
            customPagesPortals.push(contentPortal);
            customPagesPortals.push(labelPortal);
            return;
        }
        if ($8fcdbf2d7a4660c6$var$isExternalLink(cp)) {
            const { portal: labelPortal, mount: mountIcon, unmount: unmountIcon } = customLinkLabelIconsPortals.find((p)=>p.id === index);
            customPages.push({
                label: cp.label,
                url: cp.url,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            });
            customPagesPortals.push(labelPortal);
            return;
        }
    });
    return {
        customPages: customPages,
        customPagesPortals: customPagesPortals
    };
};
var $8fcdbf2d7a4660c6$var$isReorderItem = (childProps, validItems)=>{
    const { children: children, label: label, url: url, labelIcon: labelIcon } = childProps;
    return !children && !url && !labelIcon && validItems.some((v)=>v === label);
};
var $8fcdbf2d7a4660c6$var$isCustomPage = (childProps)=>{
    const { children: children, label: label, url: url, labelIcon: labelIcon } = childProps;
    return !!children && !!url && !!labelIcon && !!label;
};
var $8fcdbf2d7a4660c6$var$isExternalLink = (childProps)=>{
    const { children: children, label: label, url: url, labelIcon: labelIcon } = childProps;
    return !children && !!url && !!labelIcon && !!label;
};


var $8fcdbf2d7a4660c6$var$import_react6 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$useUserButtonCustomMenuItems = (children, options)=>{
    var _a;
    const reorderItemsLabels = [
        "manageAccount",
        "signOut"
    ];
    return $8fcdbf2d7a4660c6$var$useCustomMenuItems({
        children: children,
        reorderItemsLabels: reorderItemsLabels,
        MenuItemsComponent: $8fcdbf2d7a4660c6$var$MenuItems,
        MenuActionComponent: $8fcdbf2d7a4660c6$var$MenuAction,
        MenuLinkComponent: $8fcdbf2d7a4660c6$var$MenuLink,
        UserProfileLinkComponent: $8fcdbf2d7a4660c6$var$UserProfileLink,
        UserProfilePageComponent: $8fcdbf2d7a4660c6$var$UserProfilePage,
        allowForAnyChildren: (_a = options == null ? void 0 : options.allowForAnyChildren) != null ? _a : false
    });
};
var $8fcdbf2d7a4660c6$var$useCustomMenuItems = ({ children: children, MenuItemsComponent: MenuItemsComponent, MenuActionComponent: MenuActionComponent, MenuLinkComponent: MenuLinkComponent, UserProfileLinkComponent: UserProfileLinkComponent, UserProfilePageComponent: UserProfilePageComponent, reorderItemsLabels: reorderItemsLabels, allowForAnyChildren: allowForAnyChildren = false })=>{
    const validChildren = [];
    const customMenuItems = [];
    const customMenuItemsPortals = [];
    $8fcdbf2d7a4660c6$var$import_react6.default.Children.forEach(children, (child)=>{
        if (!$8fcdbf2d7a4660c6$var$isThatComponent(child, MenuItemsComponent) && !$8fcdbf2d7a4660c6$var$isThatComponent(child, UserProfileLinkComponent) && !$8fcdbf2d7a4660c6$var$isThatComponent(child, UserProfilePageComponent)) {
            if (child && !allowForAnyChildren) (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userButtonIgnoredComponent);
            return;
        }
        if ($8fcdbf2d7a4660c6$var$isThatComponent(child, UserProfileLinkComponent) || $8fcdbf2d7a4660c6$var$isThatComponent(child, UserProfilePageComponent)) return;
        const { props: props } = child;
        $8fcdbf2d7a4660c6$var$import_react6.default.Children.forEach(props.children, (child2)=>{
            if (!$8fcdbf2d7a4660c6$var$isThatComponent(child2, MenuActionComponent) && !$8fcdbf2d7a4660c6$var$isThatComponent(child2, MenuLinkComponent)) {
                if (child2) (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$customMenuItemsIgnoredComponent);
                return;
            }
            const { props: props2 } = child2;
            const { label: label, labelIcon: labelIcon, href: href, onClick: onClick, open: open } = props2;
            if ($8fcdbf2d7a4660c6$var$isThatComponent(child2, MenuActionComponent)) {
                if ($8fcdbf2d7a4660c6$var$isReorderItem2(props2, reorderItemsLabels)) validChildren.push({
                    label: label
                });
                else if ($8fcdbf2d7a4660c6$var$isCustomMenuItem(props2)) {
                    const baseItem = {
                        label: label,
                        labelIcon: labelIcon
                    };
                    if (onClick !== void 0) validChildren.push({
                        ...baseItem,
                        onClick: onClick
                    });
                    else if (open !== void 0) validChildren.push({
                        ...baseItem,
                        open: open.startsWith("/") ? open : `/${open}`
                    });
                    else {
                        (0, $52b16e2619eaae81$export$dcbd8d97225896c0)("Custom menu item must have either onClick or open property");
                        return;
                    }
                } else {
                    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userButtonMenuItemsActionWrongsProps);
                    return;
                }
            }
            if ($8fcdbf2d7a4660c6$var$isThatComponent(child2, MenuLinkComponent)) {
                if ($8fcdbf2d7a4660c6$var$isExternalLink2(props2)) validChildren.push({
                    label: label,
                    labelIcon: labelIcon,
                    href: href
                });
                else {
                    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userButtonMenuItemLinkWrongProps);
                    return;
                }
            }
        });
    });
    const customMenuItemLabelIcons = [];
    const customLinkLabelIcons = [];
    validChildren.forEach((mi, index)=>{
        if ($8fcdbf2d7a4660c6$var$isCustomMenuItem(mi)) customMenuItemLabelIcons.push({
            component: mi.labelIcon,
            id: index
        });
        if ($8fcdbf2d7a4660c6$var$isExternalLink2(mi)) customLinkLabelIcons.push({
            component: mi.labelIcon,
            id: index
        });
    });
    const customMenuItemLabelIconsPortals = $8fcdbf2d7a4660c6$var$useCustomElementPortal(customMenuItemLabelIcons);
    const customLinkLabelIconsPortals = $8fcdbf2d7a4660c6$var$useCustomElementPortal(customLinkLabelIcons);
    validChildren.forEach((mi, index)=>{
        if ($8fcdbf2d7a4660c6$var$isReorderItem2(mi, reorderItemsLabels)) customMenuItems.push({
            label: mi.label
        });
        if ($8fcdbf2d7a4660c6$var$isCustomMenuItem(mi)) {
            const { portal: iconPortal, mount: mountIcon, unmount: unmountIcon } = customMenuItemLabelIconsPortals.find((p)=>p.id === index);
            const menuItem = {
                label: mi.label,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            };
            if ("onClick" in mi) menuItem.onClick = mi.onClick;
            else if ("open" in mi) menuItem.open = mi.open;
            customMenuItems.push(menuItem);
            customMenuItemsPortals.push(iconPortal);
        }
        if ($8fcdbf2d7a4660c6$var$isExternalLink2(mi)) {
            const { portal: iconPortal, mount: mountIcon, unmount: unmountIcon } = customLinkLabelIconsPortals.find((p)=>p.id === index);
            customMenuItems.push({
                label: mi.label,
                href: mi.href,
                mountIcon: mountIcon,
                unmountIcon: unmountIcon
            });
            customMenuItemsPortals.push(iconPortal);
        }
    });
    return {
        customMenuItems: customMenuItems,
        customMenuItemsPortals: customMenuItemsPortals
    };
};
var $8fcdbf2d7a4660c6$var$isReorderItem2 = (childProps, validItems)=>{
    const { children: children, label: label, onClick: onClick, labelIcon: labelIcon } = childProps;
    return !children && !onClick && !labelIcon && validItems.some((v)=>v === label);
};
var $8fcdbf2d7a4660c6$var$isCustomMenuItem = (childProps)=>{
    const { label: label, labelIcon: labelIcon, onClick: onClick, open: open } = childProps;
    return !!labelIcon && !!label && (typeof onClick === "function" || typeof open === "string");
};
var $8fcdbf2d7a4660c6$var$isExternalLink2 = (childProps)=>{
    const { label: label, href: href, labelIcon: labelIcon } = childProps;
    return !!href && !!labelIcon && !!label;
};

var $8fcdbf2d7a4660c6$var$createAwaitableMutationObserver = (globalOptions)=>{
    const isReady = globalOptions == null ? void 0 : globalOptions.isReady;
    return (options)=>new Promise((resolve, reject)=>{
            const { root: root = document == null ? void 0 : document.body, selector: selector, timeout: timeout = 0 } = options;
            if (!root) {
                reject(new Error("No root element provided"));
                return;
            }
            let elementToWatch = root;
            if (selector) elementToWatch = root == null ? void 0 : root.querySelector(selector);
            if (isReady(elementToWatch, selector)) {
                resolve();
                return;
            }
            const observer = new MutationObserver((mutationsList)=>{
                for (const mutation of mutationsList){
                    if (!elementToWatch && selector) elementToWatch = root == null ? void 0 : root.querySelector(selector);
                    if (globalOptions.childList && mutation.type === "childList" || globalOptions.attributes && mutation.type === "attributes") {
                        if (isReady(elementToWatch, selector)) {
                            observer.disconnect();
                            resolve();
                            return;
                        }
                    }
                }
            });
            observer.observe(root, globalOptions);
            if (timeout > 0) setTimeout(()=>{
                observer.disconnect();
                reject(new Error(`Timeout waiting for ${selector}`));
            }, timeout);
        });
};
var $8fcdbf2d7a4660c6$var$waitForElementChildren = $8fcdbf2d7a4660c6$var$createAwaitableMutationObserver({
    childList: true,
    subtree: true,
    isReady: (el, selector)=>{
        var _a;
        return !!(el == null ? void 0 : el.childElementCount) && ((_a = el == null ? void 0 : el.matches) == null ? void 0 : _a.call(el, selector)) && el.childElementCount > 0;
    }
});
function $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component, options) {
    const watcherRef = (0, (parcelRequire("acw62")).useRef)();
    const [status, setStatus] = (0, (parcelRequire("acw62")).useState)("rendering");
    (0, (parcelRequire("acw62")).useEffect)(()=>{
        if (!component) throw new Error("Clerk: no component name provided, unable to detect mount.");
        if (typeof window !== "undefined" && !watcherRef.current) {
            const defaultSelector = `[data-clerk-component="${component}"]`;
            const selector = options == null ? void 0 : options.selector;
            watcherRef.current = $8fcdbf2d7a4660c6$var$waitForElementChildren({
                selector: selector ? // Allows for `[data-clerk-component="xxxx"][data-some-attribute="123"] .my-class`
                defaultSelector + selector : defaultSelector
            }).then(()=>{
                setStatus("rendered");
            }).catch(()=>{
                setStatus("error");
            });
        }
    }, [
        component,
        options == null ? void 0 : options.selector
    ]);
    return status;
}
var $92dfd5d5ab50d7d9$export$3ac8aa99a036a17;
var $92dfd5d5ab50d7d9$export$d697c39a2985a4c;
var $92dfd5d5ab50d7d9$export$c499305a875a8ee9;
var $92dfd5d5ab50d7d9$export$5d14bf425b37f49e;
var $e10cbe9b861e0798$exports = {};
//#region src/object.ts
const $e10cbe9b861e0798$var$without = (obj, ...props)=>{
    const copy = {
        ...obj
    };
    for (const prop of props)delete copy[prop];
    return copy;
};
const $e10cbe9b861e0798$var$removeUndefined = (obj)=>{
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== void 0 && value !== null) acc[key] = value;
        return acc;
    }, {});
};
const $e10cbe9b861e0798$var$applyFunctionToObj = (obj, fn)=>{
    const result = {};
    for(const key in obj)result[key] = fn(obj[key], key);
    return result;
};
const $e10cbe9b861e0798$var$filterProps = (obj, filter)=>{
    const result = {};
    for(const key in obj)if (obj[key] && filter(obj[key])) result[key] = obj[key];
    return result;
};
//#endregion
Object.defineProperty($e10cbe9b861e0798$exports, 'applyFunctionToObj', {
    enumerable: true,
    get: function() {
        return $e10cbe9b861e0798$var$applyFunctionToObj;
    }
});
Object.defineProperty($e10cbe9b861e0798$exports, 'filterProps', {
    enumerable: true,
    get: function() {
        return $e10cbe9b861e0798$var$filterProps;
    }
});
Object.defineProperty($e10cbe9b861e0798$exports, 'removeUndefined', {
    enumerable: true,
    get: function() {
        return $e10cbe9b861e0798$var$removeUndefined;
    }
});
Object.defineProperty($e10cbe9b861e0798$exports, 'without', {
    enumerable: true,
    get: function() {
        return $e10cbe9b861e0798$var$without;
    }
});


$92dfd5d5ab50d7d9$export$3ac8aa99a036a17 = $e10cbe9b861e0798$exports.applyFunctionToObj;
$92dfd5d5ab50d7d9$export$d697c39a2985a4c = $e10cbe9b861e0798$exports.filterProps;
$92dfd5d5ab50d7d9$export$c499305a875a8ee9 = $e10cbe9b861e0798$exports.removeUndefined;
$92dfd5d5ab50d7d9$export$5d14bf425b37f49e = $e10cbe9b861e0798$exports.without;


//#endregion
var $a0ea147aab9dedc4$export$8aa96e0f8b054cda;
var $a0ea147aab9dedc4$export$56e68f8f57ecfde4;
var $a0ea147aab9dedc4$export$b709306b005c3ef;
var $a0ea147aab9dedc4$export$4ca575904f5d942;
var $a0ea147aab9dedc4$export$3285420c698bc605;
var $a0ea147aab9dedc4$export$38ee920e59704589;
var $a0ea147aab9dedc4$export$7e97d07504ce6dd0;
var $a0ea147aab9dedc4$export$cfeb6784afb9ebba;
var $a0ea147aab9dedc4$export$2341d27b29acefb0;
var $a0ea147aab9dedc4$export$d327cc281423078f;
var $a0ea147aab9dedc4$export$88df2e7b0f32010b;
var $a0ea147aab9dedc4$export$e815511d4ebcb06;
var $a0ea147aab9dedc4$export$4e9381da774c24d3;
var $a0ea147aab9dedc4$export$38f75eca50e9fd7d;
var $a0ea147aab9dedc4$export$ea1f369b2d9cc9f0;
var $a0ea147aab9dedc4$export$550bdccf43dc8f35;
var $a0ea147aab9dedc4$export$3854fde325b71e8a;
var $a0ea147aab9dedc4$export$25f1ad233bf5fd25;
var $a0ea147aab9dedc4$export$e79b0a7479712bef;
var $a0ea147aab9dedc4$export$81cdd837749204ba;
var $a0ea147aab9dedc4$export$9f6298504fcd4ed;
var $a0ea147aab9dedc4$export$b4f021037e6d7d3f;
var $a0ea147aab9dedc4$export$fbab93d9e79c77b7;
var $a0ea147aab9dedc4$export$5c869da50c3fb50;
var $a0ea147aab9dedc4$export$3526686d04c8ecc8;
var $a0ea147aab9dedc4$export$1d7a12f28cf01e2e;
var $a0ea147aab9dedc4$export$5ebbb6ccfffc7393;
var $a0ea147aab9dedc4$export$6627e187bf6ba3fd;
var $a0ea147aab9dedc4$export$adf542e9f67b17f;
var $a0ea147aab9dedc4$export$47309e171cbac7d;
var $a0ea147aab9dedc4$export$ae85931d305e13b1;
var $a0ea147aab9dedc4$export$7305fb39264bef77;
var $a0ea147aab9dedc4$export$98614501febd5535;
var $a0ea147aab9dedc4$export$70272151be64739d;
var $a0ea147aab9dedc4$export$9497b92f9bd92d3e;
var $a0ea147aab9dedc4$export$deebe11a338de063;
var $a0ea147aab9dedc4$export$ad0a340bf97d63d5;
var $a0ea147aab9dedc4$export$a3931362f3958630;
var $a0ea147aab9dedc4$export$14add875417b9a72;
var $a0ea147aab9dedc4$export$23bbbc4533528f03;
var $a0ea147aab9dedc4$export$87c54b525b914dab;
var $32b1ea291a9463bc$exports = {};
//#region rolldown:runtime
var $32b1ea291a9463bc$var$__create = Object.create;
var $32b1ea291a9463bc$var$__defProp = Object.defineProperty;
var $32b1ea291a9463bc$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $32b1ea291a9463bc$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $32b1ea291a9463bc$var$__getProtoOf = Object.getPrototypeOf;
var $32b1ea291a9463bc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $32b1ea291a9463bc$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = $32b1ea291a9463bc$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$32b1ea291a9463bc$var$__hasOwnProp.call(to, key) && key !== except) $32b1ea291a9463bc$var$__defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = $32b1ea291a9463bc$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $32b1ea291a9463bc$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $32b1ea291a9463bc$var$__create($32b1ea291a9463bc$var$__getProtoOf(mod)) : {}, $32b1ea291a9463bc$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $32b1ea291a9463bc$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
Object.defineProperty($32b1ea291a9463bc$exports, '__toESM', {
    enumerable: true,
    get: function() {
        return $32b1ea291a9463bc$var$__toESM;
    }
});






var $886ddc52c18ced79$exports = {};
//#region src/authorization-errors.ts
const $886ddc52c18ced79$var$REVERIFICATION_REASON = "reverification-error";
const $886ddc52c18ced79$var$reverificationError = (missingConfig)=>({
        clerk_error: {
            type: "forbidden",
            reason: $886ddc52c18ced79$var$REVERIFICATION_REASON,
            metadata: {
                reverification: missingConfig
            }
        }
    });
const $886ddc52c18ced79$var$reverificationErrorResponse = (...args)=>new Response(JSON.stringify($886ddc52c18ced79$var$reverificationError(...args)), {
        status: 403
    });
const $886ddc52c18ced79$var$isReverificationHint = (result)=>{
    return result && typeof result === "object" && "clerk_error" in result && result.clerk_error?.type === "forbidden" && result.clerk_error?.reason === $886ddc52c18ced79$var$REVERIFICATION_REASON;
};
//#endregion
Object.defineProperty($886ddc52c18ced79$exports, 'isReverificationHint', {
    enumerable: true,
    get: function() {
        return $886ddc52c18ced79$var$isReverificationHint;
    }
});
Object.defineProperty($886ddc52c18ced79$exports, 'reverificationError', {
    enumerable: true,
    get: function() {
        return $886ddc52c18ced79$var$reverificationError;
    }
});
Object.defineProperty($886ddc52c18ced79$exports, 'reverificationErrorResponse', {
    enumerable: true,
    get: function() {
        return $886ddc52c18ced79$var$reverificationErrorResponse;
    }
});


var $c9f343945e2fea5f$exports = {};
//#region src/authorization.ts
const $c9f343945e2fea5f$var$TYPES_TO_OBJECTS = {
    strict_mfa: {
        afterMinutes: 10,
        level: "multi_factor"
    },
    strict: {
        afterMinutes: 10,
        level: "second_factor"
    },
    moderate: {
        afterMinutes: 60,
        level: "second_factor"
    },
    lax: {
        afterMinutes: 1440,
        level: "second_factor"
    }
};
const $c9f343945e2fea5f$var$ALLOWED_LEVELS = new Set([
    "first_factor",
    "second_factor",
    "multi_factor"
]);
const $c9f343945e2fea5f$var$ALLOWED_TYPES = new Set([
    "strict_mfa",
    "strict",
    "moderate",
    "lax"
]);
const $c9f343945e2fea5f$var$isValidMaxAge = (maxAge)=>typeof maxAge === "number" && maxAge > 0;
const $c9f343945e2fea5f$var$isValidLevel = (level)=>$c9f343945e2fea5f$var$ALLOWED_LEVELS.has(level);
const $c9f343945e2fea5f$var$isValidVerificationType = (type)=>$c9f343945e2fea5f$var$ALLOWED_TYPES.has(type);
const $c9f343945e2fea5f$var$isValidFactorAge = (x)=>typeof x === "number" && Number.isFinite(x) && (x === -1 || x >= 0);
const $c9f343945e2fea5f$var$prefixWithOrg = (value)=>value.replace(/^(org:)*/, "org:");
/**
* Checks if a user has the required organization-level authorization.
* If both role and permission are provided, both must match (AND).
*/ const $c9f343945e2fea5f$var$checkOrgAuthorization = (params, options)=>{
    const { orgId: orgId, orgRole: orgRole, orgPermissions: orgPermissions } = options;
    const roleAsked = params.role !== void 0;
    const permissionAsked = params.permission !== void 0;
    if (!roleAsked && !permissionAsked) return "skip";
    if (roleAsked && typeof params.role !== "string") return "fail";
    if (permissionAsked && typeof params.permission !== "string") return "fail";
    if (!orgId) return "fail";
    if (roleAsked) {
        if (typeof orgRole !== "string" || !orgRole) return "fail";
        if ($c9f343945e2fea5f$var$prefixWithOrg(orgRole) !== $c9f343945e2fea5f$var$prefixWithOrg(params.role)) return "fail";
    }
    if (permissionAsked) {
        if (!Array.isArray(orgPermissions)) return "fail";
        if (!orgPermissions.includes($c9f343945e2fea5f$var$prefixWithOrg(params.permission))) return "fail";
    }
    return "pass";
};
const $c9f343945e2fea5f$var$checkForFeatureOrPlan = (claim, featureOrPlan)=>{
    const { org: orgFeatures, user: userFeatures } = $c9f343945e2fea5f$var$splitByScope(claim);
    const [scope, _id] = featureOrPlan.split(":");
    const id = _id || scope;
    if (scope === "org") return orgFeatures.includes(id);
    else if (scope === "user") return userFeatures.includes(id);
    else return [
        ...orgFeatures,
        ...userFeatures
    ].includes(id);
};
/**
* Checks if a user is entitled to the requested feature or plan.
* If both feature and plan are provided, both must match (AND).
*/ const $c9f343945e2fea5f$var$checkBillingAuthorization = (params, options)=>{
    const { features: features, plans: plans } = options;
    const featureAsked = params.feature !== void 0;
    const planAsked = params.plan !== void 0;
    if (!featureAsked && !planAsked) return "skip";
    if (featureAsked && typeof params.feature !== "string") return "fail";
    if (planAsked && typeof params.plan !== "string") return "fail";
    if (featureAsked) {
        if (typeof features !== "string" || !features) return "fail";
        try {
            if (!$c9f343945e2fea5f$var$checkForFeatureOrPlan(features, params.feature)) return "fail";
        } catch  {
            return "fail";
        }
    }
    if (planAsked) {
        if (typeof plans !== "string" || !plans) return "fail";
        try {
            if (!$c9f343945e2fea5f$var$checkForFeatureOrPlan(plans, params.plan)) return "fail";
        } catch  {
            return "fail";
        }
    }
    return "pass";
};
const $c9f343945e2fea5f$var$splitByScope = (fea)=>{
    const features = fea ? fea.split(",").map((f)=>f.trim()) : [];
    return {
        org: features.filter((f)=>f.split(":")[0].includes("o")).map((f)=>f.split(":")[1]),
        user: features.filter((f)=>f.split(":")[0].includes("u")).map((f)=>f.split(":")[1])
    };
};
const $c9f343945e2fea5f$var$validateReverificationConfig = (config)=>{
    if (!config) return false;
    const convertConfigToObject = (config$1)=>{
        if (typeof config$1 === "string") return $c9f343945e2fea5f$var$TYPES_TO_OBJECTS[config$1];
        return config$1;
    };
    const isValidStringValue = typeof config === "string" && $c9f343945e2fea5f$var$isValidVerificationType(config);
    const isValidObjectValue = typeof config === "object" && $c9f343945e2fea5f$var$isValidLevel(config.level) && $c9f343945e2fea5f$var$isValidMaxAge(config.afterMinutes);
    if (isValidStringValue || isValidObjectValue) return convertConfigToObject.bind(null, config);
    return false;
};
/**
* Evaluates if the user meets re-verification authentication requirements.
* Handles different verification levels (first factor, second factor, multi-factor).
*/ const $c9f343945e2fea5f$var$checkReverificationAuthorization = (params, { factorVerificationAge: factorVerificationAge })=>{
    if (params.reverification === void 0) return "skip";
    if (!factorVerificationAge) return "fail";
    if (!Array.isArray(factorVerificationAge) || factorVerificationAge.length !== 2 || !$c9f343945e2fea5f$var$isValidFactorAge(factorVerificationAge[0]) || !$c9f343945e2fea5f$var$isValidFactorAge(factorVerificationAge[1])) return "fail";
    const getConfig = $c9f343945e2fea5f$var$validateReverificationConfig(params.reverification);
    if (!getConfig) return "fail";
    const { level: level, afterMinutes: afterMinutes } = getConfig();
    const [factor1Age, factor2Age] = factorVerificationAge;
    if (factor1Age === -1 && factor2Age === -1) return "fail";
    const factor1FreshEnough = factor1Age !== -1 && afterMinutes > factor1Age;
    const factor2FreshEnough = factor2Age !== -1 && afterMinutes > factor2Age;
    switch(level){
        case "first_factor":
            return factor1FreshEnough ? "pass" : "fail";
        case "second_factor":
            if (factor2Age === -1) return factor1FreshEnough ? "pass" : "fail";
            if (factor1Age === -1) return factor2FreshEnough ? "pass" : "fail";
            return factor2FreshEnough ? "pass" : "fail";
        case "multi_factor":
            if (factor2Age === -1) return factor1FreshEnough ? "pass" : "fail";
            if (factor1Age === -1) return "fail";
            return factor1FreshEnough && factor2FreshEnough ? "pass" : "fail";
    }
};
const $c9f343945e2fea5f$var$combine = (results)=>results.some((r)=>r === "pass") && results.every((r)=>r === "pass" || r === "skip");
/**
* Creates a function for comprehensive user authorization checks.
* Combines organization, billing, and reverification checks. The returned function
* authorizes only when every requested dimension passes; any requested dimension
* that cannot be satisfied (including missing or malformed session data) denies
* the request. Fails if `userId` is missing.
*/ const $c9f343945e2fea5f$var$createCheckAuthorization = (options)=>{
    return (params)=>{
        if (!options.userId) return false;
        return $c9f343945e2fea5f$var$combine([
            $c9f343945e2fea5f$var$checkOrgAuthorization(params, options),
            $c9f343945e2fea5f$var$checkBillingAuthorization(params, options),
            $c9f343945e2fea5f$var$checkReverificationAuthorization(params, options)
        ]);
    };
};
/**
* Shared utility function that centralizes auth state resolution logic,
* preventing duplication across different packages.
* @internal
*/ const $c9f343945e2fea5f$var$resolveAuthState = ({ authObject: { sessionId: sessionId, sessionStatus: sessionStatus, userId: userId, actor: actor, orgId: orgId, orgRole: orgRole, orgSlug: orgSlug, signOut: signOut, getToken: getToken, has: has, sessionClaims: sessionClaims }, options: { treatPendingAsSignedOut: treatPendingAsSignedOut = true } })=>{
    if (sessionId === void 0 && userId === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        sessionId: sessionId,
        sessionClaims: void 0,
        userId: userId,
        actor: void 0,
        orgId: void 0,
        orgRole: void 0,
        orgSlug: void 0,
        has: void 0,
        signOut: signOut,
        getToken: getToken
    };
    if (sessionId === null && userId === null) return {
        isLoaded: true,
        isSignedIn: false,
        sessionId: sessionId,
        userId: userId,
        sessionClaims: null,
        actor: null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: ()=>false,
        signOut: signOut,
        getToken: getToken
    };
    if (treatPendingAsSignedOut && sessionStatus === "pending") return {
        isLoaded: true,
        isSignedIn: false,
        sessionId: null,
        userId: null,
        sessionClaims: null,
        actor: null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: ()=>false,
        signOut: signOut,
        getToken: getToken
    };
    if (!!sessionId && !!sessionClaims && !!userId && !!orgId && !!orgRole) return {
        isLoaded: true,
        isSignedIn: true,
        sessionId: sessionId,
        sessionClaims: sessionClaims,
        userId: userId,
        actor: actor || null,
        orgId: orgId,
        orgRole: orgRole,
        orgSlug: orgSlug || null,
        has: has,
        signOut: signOut,
        getToken: getToken
    };
    if (!!sessionId && !!sessionClaims && !!userId && !orgId) return {
        isLoaded: true,
        isSignedIn: true,
        sessionId: sessionId,
        sessionClaims: sessionClaims,
        userId: userId,
        actor: actor || null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: has,
        signOut: signOut,
        getToken: getToken
    };
};
//#endregion
Object.defineProperty($c9f343945e2fea5f$exports, 'createCheckAuthorization', {
    enumerable: true,
    get: function() {
        return $c9f343945e2fea5f$var$createCheckAuthorization;
    }
});
Object.defineProperty($c9f343945e2fea5f$exports, 'resolveAuthState', {
    enumerable: true,
    get: function() {
        return $c9f343945e2fea5f$var$resolveAuthState;
    }
});
Object.defineProperty($c9f343945e2fea5f$exports, 'splitByScope', {
    enumerable: true,
    get: function() {
        return $c9f343945e2fea5f$var$splitByScope;
    }
});
Object.defineProperty($c9f343945e2fea5f$exports, 'validateReverificationConfig', {
    enumerable: true,
    get: function() {
        return $c9f343945e2fea5f$var$validateReverificationConfig;
    }
});





var $05508b9b9ac75808$exports = {};
//#region src/underscore.ts
/**
* Convert words to a sentence.
*
* @param items - An array of words to be joined.
* @returns A string with the items joined by a comma and the last item joined by ", or".
*/ const $05508b9b9ac75808$var$toSentence = (items)=>{
    if (items.length == 0) return "";
    if (items.length == 1) return items[0];
    let sentence = items.slice(0, -1).join(", ");
    sentence += `, or ${items.slice(-1)}`;
    return sentence;
};
const $05508b9b9ac75808$var$IP_V4_ADDRESS_REGEX = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
/**
* Checks if a string is a valid IPv4 address.
*
* @returns True if the string is a valid IPv4 address, false otherwise.
*/ function $05508b9b9ac75808$var$isIPV4Address(str) {
    return $05508b9b9ac75808$var$IP_V4_ADDRESS_REGEX.test(str || "");
}
/**
* Converts the first character of a string to uppercase.
*
* @param str - The string to be converted.
* @returns The modified string with the rest of the string unchanged.
*
* @example
* ```ts
* titleize('hello world') // 'Hello world'
* ```
*/ function $05508b9b9ac75808$var$titleize(str) {
    const s = str || "";
    return s.charAt(0).toUpperCase() + s.slice(1);
}
/**
* Converts a string from snake_case to camelCase.
*/ function $05508b9b9ac75808$var$snakeToCamel(str) {
    return str ? str.replace(/([-_][a-z])/g, (match)=>match.toUpperCase().replace(/-|_/, "")) : "";
}
/**
* Converts a string from camelCase to snake_case.
*/ function $05508b9b9ac75808$var$camelToSnake(str) {
    return str ? str.replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`) : "";
}
const $05508b9b9ac75808$var$createDeepObjectTransformer = (transform)=>{
    const deepTransform = (obj)=>{
        if (!obj) return obj;
        if (Array.isArray(obj)) return obj.map((el)=>{
            if (typeof el === "object" || Array.isArray(el)) return deepTransform(el);
            return el;
        });
        const copy = {
            ...obj
        };
        const keys = Object.keys(copy);
        for (const oldName of keys){
            const newName = transform(oldName.toString());
            if (newName !== oldName) {
                copy[newName] = copy[oldName];
                delete copy[oldName];
            }
            if (typeof copy[newName] === "object") copy[newName] = deepTransform(copy[newName]);
        }
        return copy;
    };
    return deepTransform;
};
/**
* Transforms camelCased objects/ arrays to snake_cased.
* This function recursively traverses all objects and arrays of the passed value
* camelCased keys are removed.
*
* @function
*/ const $05508b9b9ac75808$var$deepCamelToSnake = $05508b9b9ac75808$var$createDeepObjectTransformer($05508b9b9ac75808$var$camelToSnake);
/**
* Transforms snake_cased objects/ arrays to camelCased.
* This function recursively traverses all objects and arrays of the passed value
* camelCased keys are removed.
*
* @function
*/ const $05508b9b9ac75808$var$deepSnakeToCamel = $05508b9b9ac75808$var$createDeepObjectTransformer($05508b9b9ac75808$var$snakeToCamel);
/**
* A function to determine if a value is truthy.
*
* @returns True for `true`, true, positive numbers. False for `false`, false, 0, negative integers and anything else.
*/ function $05508b9b9ac75808$var$isTruthy(value) {
    if (typeof value === `boolean`) return value;
    if (value === void 0 || value === null) return false;
    if (typeof value === `string`) {
        if (value.toLowerCase() === `true`) return true;
        if (value.toLowerCase() === `false`) return false;
    }
    const number = parseInt(value, 10);
    if (isNaN(number)) return false;
    if (number > 0) return true;
    return false;
}
/**
* Get all non-undefined values from an object.
*/ function $05508b9b9ac75808$var$getNonUndefinedValues(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== void 0) acc[key] = value;
        return acc;
    }, {});
}
//#endregion
Object.defineProperty($05508b9b9ac75808$exports, 'camelToSnake', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$camelToSnake;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'deepCamelToSnake', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$deepCamelToSnake;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'deepSnakeToCamel', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$deepSnakeToCamel;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'getNonUndefinedValues', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$getNonUndefinedValues;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'isIPV4Address', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$isIPV4Address;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'isTruthy', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$isTruthy;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'snakeToCamel', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$snakeToCamel;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'titleize', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$titleize;
    }
});
Object.defineProperty($05508b9b9ac75808$exports, 'toSentence', {
    enumerable: true,
    get: function() {
        return $05508b9b9ac75808$var$toSentence;
    }
});


var $01f5f7558c5f2b61$exports = {};
//#region src/organization.ts
/**
* Finds the Organization membership for a given Organization ID from a list of memberships
* @param organizationMemberships - Array of Organization memberships to search through
* @param organizationId - ID of the Organization to find the membership for
* @returns The matching Organization membership or undefined if not found
*/ function $01f5f7558c5f2b61$var$getCurrentOrganizationMembership(organizationMemberships, organizationId) {
    return organizationMemberships.find((organizationMembership)=>organizationMembership.organization.id === organizationId);
}
//#endregion
Object.defineProperty($01f5f7558c5f2b61$exports, 'getCurrentOrganizationMembership', {
    enumerable: true,
    get: function() {
        return $01f5f7558c5f2b61$var$getCurrentOrganizationMembership;
    }
});


var $77d689860cf967c8$exports = {};


//#region src/telemetry/throttler.ts
const $77d689860cf967c8$var$DEFAULT_CACHE_TTL_MS = 864e5;
/**
* Manages throttling for telemetry events using a configurable cache implementation
* to mitigate event flooding in frequently executed code paths.
*/ var $77d689860cf967c8$var$TelemetryEventThrottler = class {
    #cache;
    #cacheTtl = $77d689860cf967c8$var$DEFAULT_CACHE_TTL_MS;
    constructor(cache){
        this.#cache = cache;
    }
    isEventThrottled(payload) {
        const now = Date.now();
        const key = this.#generateKey(payload);
        const entry = this.#cache.getItem(key);
        if (!entry) {
            this.#cache.setItem(key, now);
            return false;
        }
        if (now - entry > this.#cacheTtl) {
            this.#cache.setItem(key, now);
            return false;
        }
        return true;
    }
    /**
	* Generates a consistent unique key for telemetry events by sorting payload properties.
	* This ensures that payloads with identical content in different orders produce the same key.
	*/ #generateKey(event) {
        const { sk: _sk, pk: _pk, payload: payload, ...rest } = event;
        const sanitizedEvent = {
            ...payload,
            ...rest
        };
        return JSON.stringify(Object.keys({
            ...payload,
            ...rest
        }).sort().map((key)=>sanitizedEvent[key]));
    }
};
/**
* LocalStorage-based cache implementation for browser environments.
*/ var $77d689860cf967c8$var$LocalStorageThrottlerCache = class {
    #storageKey = "clerk_telemetry_throttler";
    getItem(key) {
        return this.#getCache()[key];
    }
    setItem(key, value) {
        try {
            const cache = this.#getCache();
            cache[key] = value;
            localStorage.setItem(this.#storageKey, JSON.stringify(cache));
        } catch (err) {
            if (err instanceof DOMException && (err.name === "QuotaExceededError" || err.name === "NS_ERROR_DOM_QUOTA_REACHED") && localStorage.length > 0) localStorage.removeItem(this.#storageKey);
        }
    }
    removeItem(key) {
        try {
            const cache = this.#getCache();
            delete cache[key];
            localStorage.setItem(this.#storageKey, JSON.stringify(cache));
        } catch  {}
    }
    #getCache() {
        try {
            const cacheString = localStorage.getItem(this.#storageKey);
            if (!cacheString) return {};
            return JSON.parse(cacheString);
        } catch  {
            return {};
        }
    }
    static isSupported() {
        return typeof window !== "undefined" && !!window.localStorage;
    }
};
/**
* In-memory cache implementation for non-browser environments (e.g., React Native).
*/ var $77d689860cf967c8$var$InMemoryThrottlerCache = class {
    #cache = /* @__PURE__ */ new Map();
    #maxSize = 1e4;
    getItem(key) {
        if (this.#cache.size > this.#maxSize) {
            this.#cache.clear();
            return;
        }
        return this.#cache.get(key);
    }
    setItem(key, value) {
        this.#cache.set(key, value);
    }
    removeItem(key) {
        this.#cache.delete(key);
    }
};
//#endregion
//#region src/telemetry/collector.ts
/**
* Type guard to check if window.Clerk exists and has the expected structure.
*/ function $77d689860cf967c8$var$isWindowClerkWithMetadata(clerk) {
    return typeof clerk === "object" && clerk !== null && "constructor" in clerk && typeof clerk.constructor === "function";
}
const $77d689860cf967c8$var$VALID_LOG_LEVELS = new Set([
    "error",
    "warn",
    "info",
    "debug",
    "trace"
]);
const $77d689860cf967c8$var$DEFAULT_CONFIG = {
    samplingRate: 1,
    maxBufferSize: 5,
    endpoint: "https://clerk-telemetry.com"
};
var $77d689860cf967c8$var$TelemetryCollector = class {
    #config;
    #eventThrottler;
    #metadata = {};
    #buffer = [];
    #pendingFlush = null;
    constructor(options){
        this.#config = {
            maxBufferSize: options.maxBufferSize ?? $77d689860cf967c8$var$DEFAULT_CONFIG.maxBufferSize,
            samplingRate: options.samplingRate ?? $77d689860cf967c8$var$DEFAULT_CONFIG.samplingRate,
            perEventSampling: options.perEventSampling ?? true,
            disabled: options.disabled ?? false,
            debug: options.debug ?? false,
            endpoint: $77d689860cf967c8$var$DEFAULT_CONFIG.endpoint
        };
        if (!options.clerkVersion && typeof window === "undefined") this.#metadata.clerkVersion = "";
        else this.#metadata.clerkVersion = options.clerkVersion ?? "";
        this.#metadata.sdk = options.sdk;
        this.#metadata.sdkVersion = options.sdkVersion;
        this.#metadata.publishableKey = options.publishableKey ?? "";
        const parsedKey = $6fcb8ff7a3b82d27$exports.parsePublishableKey(options.publishableKey);
        if (parsedKey) this.#metadata.instanceType = parsedKey.instanceType;
        if (options.secretKey) this.#metadata.secretKey = options.secretKey.substring(0, 16);
        this.#eventThrottler = new $77d689860cf967c8$var$TelemetryEventThrottler($77d689860cf967c8$var$LocalStorageThrottlerCache.isSupported() ? new $77d689860cf967c8$var$LocalStorageThrottlerCache() : new $77d689860cf967c8$var$InMemoryThrottlerCache());
    }
    get isEnabled() {
        if (this.#metadata.instanceType !== "development") return false;
        if (this.#config.disabled || false) return false;
        if (typeof window !== "undefined" && !!window?.navigator?.webdriver) return false;
        return true;
    }
    get isDebug() {
        return this.#config.debug || false;
    }
    record(event) {
        try {
            const preparedPayload = this.#preparePayload(event.event, event.payload);
            this.#logEvent(preparedPayload.event, preparedPayload);
            if (!this.#shouldRecord(preparedPayload, event.eventSamplingRate)) return;
            this.#buffer.push({
                kind: "event",
                value: preparedPayload
            });
            this.#scheduleFlush();
        } catch (error) {
            console.error("[clerk/telemetry] Error recording telemetry event", error);
        }
    }
    /**
	* Records a telemetry log entry if logging is enabled and not in debug mode.
	*
	* @param entry - The telemetry log entry to record.
	*/ recordLog(entry) {
        try {
            if (!this.#shouldRecordLog(entry)) return;
            const levelIsValid = typeof entry?.level === "string" && $77d689860cf967c8$var$VALID_LOG_LEVELS.has(entry.level);
            const messageIsValid = typeof entry?.message === "string" && entry.message.trim().length > 0;
            let normalizedTimestamp = null;
            const timestampInput = entry?.timestamp;
            if (typeof timestampInput === "number" || typeof timestampInput === "string") {
                const candidate = new Date(timestampInput);
                if (!Number.isNaN(candidate.getTime())) normalizedTimestamp = candidate;
            }
            if (!levelIsValid || !messageIsValid || normalizedTimestamp === null) {
                if (this.isDebug && typeof console !== "undefined") console.warn("[clerk/telemetry] Dropping invalid telemetry log entry", {
                    levelIsValid: levelIsValid,
                    messageIsValid: messageIsValid,
                    timestampIsValid: normalizedTimestamp !== null
                });
                return;
            }
            const sdkMetadata = this.#getSDKMetadata();
            const logData = {
                sdk: sdkMetadata.name,
                sdkv: sdkMetadata.version,
                cv: this.#metadata.clerkVersion ?? "",
                lvl: entry.level,
                msg: entry.message,
                ts: normalizedTimestamp.toISOString(),
                pk: this.#metadata.publishableKey || null,
                payload: this.#sanitizeContext(entry.context)
            };
            this.#buffer.push({
                kind: "log",
                value: logData
            });
            this.#scheduleFlush();
        } catch (error) {
            console.error("[clerk/telemetry] Error recording telemetry log entry", error);
        }
    }
    #shouldRecord(preparedPayload, eventSamplingRate) {
        return this.isEnabled && !this.isDebug && this.#shouldBeSampled(preparedPayload, eventSamplingRate);
    }
    #shouldRecordLog(_entry) {
        return true;
    }
    #shouldBeSampled(preparedPayload, eventSamplingRate) {
        const randomSeed = Math.random();
        if (!(randomSeed <= this.#config.samplingRate && (this.#config.perEventSampling === false || typeof eventSamplingRate === "undefined" || randomSeed <= eventSamplingRate))) return false;
        return !this.#eventThrottler.isEventThrottled(preparedPayload);
    }
    #scheduleFlush() {
        if (typeof window === "undefined") {
            this.#flush();
            return;
        }
        if (this.#buffer.length >= this.#config.maxBufferSize) {
            if (this.#pendingFlush) {
                if (typeof cancelIdleCallback !== "undefined") cancelIdleCallback(Number(this.#pendingFlush));
                else clearTimeout(Number(this.#pendingFlush));
            }
            this.#flush();
            return;
        }
        if (this.#pendingFlush) return;
        if ("requestIdleCallback" in window) this.#pendingFlush = requestIdleCallback(()=>{
            this.#flush();
            this.#pendingFlush = null;
        });
        else this.#pendingFlush = setTimeout(()=>{
            this.#flush();
            this.#pendingFlush = null;
        }, 0);
    }
    #flush() {
        const itemsToSend = [
            ...this.#buffer
        ];
        this.#buffer = [];
        this.#pendingFlush = null;
        if (itemsToSend.length === 0) return;
        const eventsToSend = itemsToSend.filter((item)=>item.kind === "event").map((item)=>item.value);
        const logsToSend = itemsToSend.filter((item)=>item.kind === "log").map((item)=>item.value);
        if (eventsToSend.length > 0) {
            const eventsUrl = new URL("/v1/event", this.#config.endpoint);
            fetch(eventsUrl, {
                headers: {
                    "Content-Type": "application/json"
                },
                keepalive: true,
                method: "POST",
                body: JSON.stringify({
                    events: eventsToSend
                })
            }).catch(()=>void 0);
        }
        if (logsToSend.length > 0) {
            const logsUrl = new URL("/v1/logs", this.#config.endpoint);
            fetch(logsUrl, {
                headers: {
                    "Content-Type": "application/json"
                },
                keepalive: true,
                method: "POST",
                body: JSON.stringify({
                    logs: logsToSend
                })
            }).catch(()=>void 0);
        }
    }
    /**
	* If running in debug mode, log the event and its payload to the console.
	*/ #logEvent(event, payload) {
        if (!this.isDebug) return;
        if (typeof console.groupCollapsed !== "undefined") {
            console.groupCollapsed("[clerk/telemetry]", event);
            console.log(payload);
            console.groupEnd();
        } else console.log("[clerk/telemetry]", event, payload);
    }
    /**
	* If in browser, attempt to lazily grab the SDK metadata from the Clerk singleton, otherwise fallback to the initially passed in values.
	*
	* This is necessary because the sdkMetadata can be set by the host SDK after the TelemetryCollector is instantiated.
	*/ #getSDKMetadata() {
        const sdkMetadata = {
            name: this.#metadata.sdk,
            version: this.#metadata.sdkVersion
        };
        if (typeof window !== "undefined") {
            const windowWithClerk = window;
            if (windowWithClerk.Clerk) {
                const windowClerk = windowWithClerk.Clerk;
                if ($77d689860cf967c8$var$isWindowClerkWithMetadata(windowClerk) && windowClerk.constructor.sdkMetadata) {
                    const { name: name, version: version } = windowClerk.constructor.sdkMetadata;
                    if (name !== void 0) sdkMetadata.name = name;
                    if (version !== void 0) sdkMetadata.version = version;
                }
            }
        }
        return sdkMetadata;
    }
    /**
	* Append relevant metadata from the Clerk singleton to the event payload.
	*/ #preparePayload(event, payload) {
        const sdkMetadata = this.#getSDKMetadata();
        return {
            event: event,
            cv: this.#metadata.clerkVersion ?? "",
            it: this.#metadata.instanceType ?? "",
            sdk: sdkMetadata.name,
            sdkv: sdkMetadata.version,
            ...this.#metadata.publishableKey ? {
                pk: this.#metadata.publishableKey
            } : {},
            ...this.#metadata.secretKey ? {
                sk: this.#metadata.secretKey
            } : {},
            payload: payload
        };
    }
    /**
	* Best-effort sanitization of the context payload. Returns a plain object with JSON-serializable
	* values or null when the input is missing or not serializable. Arrays are not accepted.
	*/ #sanitizeContext(context) {
        if (context === null || typeof context === "undefined") return null;
        if (typeof context !== "object") return null;
        try {
            const cleaned = JSON.parse(JSON.stringify(context));
            if (cleaned && typeof cleaned === "object" && !Array.isArray(cleaned)) return cleaned;
            return null;
        } catch  {
            return null;
        }
    }
};
//#endregion
//#region src/telemetry/events/component-mounted.ts
const $77d689860cf967c8$var$EVENT_COMPONENT_MOUNTED = "COMPONENT_MOUNTED";
const $77d689860cf967c8$var$EVENT_COMPONENT_OPENED = "COMPONENT_OPENED";
const $77d689860cf967c8$var$EVENT_SAMPLING_RATE$3 = .1;
/** Increase sampling for high-signal auth components on mount. */ const $77d689860cf967c8$var$AUTH_COMPONENTS = new Set([
    "SignIn",
    "SignUp"
]);
/**
* Returns the per-event sampling rate for component-mounted telemetry events.
* Uses a higher rate for SignIn/SignUp to improve signal quality.
*
*  @internal
*/ function $77d689860cf967c8$var$getComponentMountedSamplingRate(component) {
    return $77d689860cf967c8$var$AUTH_COMPONENTS.has(component) ? 1 : $77d689860cf967c8$var$EVENT_SAMPLING_RATE$3;
}
/**
* Factory for prebuilt component telemetry events.
*
* @internal
*/ function $77d689860cf967c8$var$createPrebuiltComponentEvent(event) {
    return function(component, props, additionalPayload) {
        return {
            event: event,
            eventSamplingRate: event === $77d689860cf967c8$var$EVENT_COMPONENT_MOUNTED ? $77d689860cf967c8$var$getComponentMountedSamplingRate(component) : $77d689860cf967c8$var$EVENT_SAMPLING_RATE$3,
            payload: {
                component: component,
                appearanceProp: Boolean(props?.appearance),
                baseTheme: Boolean(props?.appearance?.baseTheme),
                elements: Boolean(props?.appearance?.elements),
                variables: Boolean(props?.appearance?.variables),
                ...additionalPayload
            }
        };
    };
}
/**
* Helper function for `telemetry.record()`. Create a consistent event object for when a prebuilt (AIO) component is mounted.
*
* @param component - The name of the component.
* @param props - The props passed to the component. Will be filtered to a known list of props.
* @param additionalPayload - Additional data to send with the event.
* @example
* telemetry.record(eventPrebuiltComponentMounted('SignUp', props));
*/ function $77d689860cf967c8$var$eventPrebuiltComponentMounted(component, props, additionalPayload) {
    return $77d689860cf967c8$var$createPrebuiltComponentEvent($77d689860cf967c8$var$EVENT_COMPONENT_MOUNTED)(component, props, additionalPayload);
}
/**
* Helper function for `telemetry.record()`. Create a consistent event object for when a prebuilt (AIO) component is opened as a modal.
*
* @param component - The name of the component.
* @param props - The props passed to the component. Will be filtered to a known list of props.
* @param additionalPayload - Additional data to send with the event.
* @example
* telemetry.record(eventPrebuiltComponentOpened('GoogleOneTap', props));
*/ function $77d689860cf967c8$var$eventPrebuiltComponentOpened(component, props, additionalPayload) {
    return $77d689860cf967c8$var$createPrebuiltComponentEvent($77d689860cf967c8$var$EVENT_COMPONENT_OPENED)(component, props, additionalPayload);
}
/**
* Helper function for `telemetry.record()`. Create a consistent event object for when a component is mounted. Use `eventPrebuiltComponentMounted` for prebuilt components.
*
* **Caution:** Filter the `props` you pass to this function to avoid sending too much data.
*
* @param component - The name of the component.
* @param props - The props passed to the component. Ideally you only pass a handful of props here.
* @example
* telemetry.record(eventComponentMounted('SignUp', props));
*/ function $77d689860cf967c8$var$eventComponentMounted(component, props = {}) {
    return {
        event: $77d689860cf967c8$var$EVENT_COMPONENT_MOUNTED,
        eventSamplingRate: $77d689860cf967c8$var$getComponentMountedSamplingRate(component),
        payload: {
            component: component,
            ...props
        }
    };
}
//#endregion
//#region src/telemetry/events/method-called.ts
const $77d689860cf967c8$var$EVENT_METHOD_CALLED = "METHOD_CALLED";
const $77d689860cf967c8$var$EVENT_SAMPLING_RATE$2 = .1;
/**
* Fired when a helper method is called from a Clerk SDK.
*/ function $77d689860cf967c8$var$eventMethodCalled(method, payload) {
    return {
        event: $77d689860cf967c8$var$EVENT_METHOD_CALLED,
        eventSamplingRate: $77d689860cf967c8$var$EVENT_SAMPLING_RATE$2,
        payload: {
            method: method,
            ...payload
        }
    };
}
//#endregion
//#region src/telemetry/events/framework-metadata.ts
const $77d689860cf967c8$var$EVENT_FRAMEWORK_METADATA = "FRAMEWORK_METADATA";
const $77d689860cf967c8$var$EVENT_SAMPLING_RATE$1 = .1;
/**
* Fired when a helper method is called from a Clerk SDK.
*/ function $77d689860cf967c8$var$eventFrameworkMetadata(payload) {
    return {
        event: $77d689860cf967c8$var$EVENT_FRAMEWORK_METADATA,
        eventSamplingRate: $77d689860cf967c8$var$EVENT_SAMPLING_RATE$1,
        payload: payload
    };
}
//#endregion
//#region src/telemetry/events/theme-usage.ts
const $77d689860cf967c8$var$EVENT_THEME_USAGE = "THEME_USAGE";
const $77d689860cf967c8$var$EVENT_SAMPLING_RATE = 1;
/**
* Helper function for `telemetry.record()`. Create a consistent event object for tracking theme usage in ClerkProvider.
*
* @param appearance - The appearance prop from ClerkProvider.
* @example
* telemetry.record(eventThemeUsage(appearance));
*/ function $77d689860cf967c8$var$eventThemeUsage(appearance) {
    return {
        event: $77d689860cf967c8$var$EVENT_THEME_USAGE,
        eventSamplingRate: $77d689860cf967c8$var$EVENT_SAMPLING_RATE,
        payload: $77d689860cf967c8$var$analyzeThemeUsage(appearance)
    };
}
/**
* Analyzes the appearance prop to extract theme usage information for telemetry.
*
* @internal
*/ function $77d689860cf967c8$var$analyzeThemeUsage(appearance) {
    if (!appearance || typeof appearance !== "object") return {};
    const themeProperty = appearance.theme || appearance.baseTheme;
    if (!themeProperty) return {};
    let themeName;
    if (Array.isArray(themeProperty)) for (const theme of themeProperty){
        const name = $77d689860cf967c8$var$extractThemeName(theme);
        if (name) {
            themeName = name;
            break;
        }
    }
    else themeName = $77d689860cf967c8$var$extractThemeName(themeProperty);
    return {
        themeName: themeName
    };
}
/**
* Extracts the theme name from a theme object.
*
* @internal
*/ function $77d689860cf967c8$var$extractThemeName(theme) {
    if (typeof theme === "string") return theme;
    if (typeof theme === "object" && theme !== null) {
        if ("name" in theme && typeof theme.name === "string") return theme.name;
    }
}
//#endregion
Object.defineProperty($77d689860cf967c8$exports, 'EVENT_SAMPLING_RATE', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$EVENT_SAMPLING_RATE;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'EVENT_THEME_USAGE', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$EVENT_THEME_USAGE;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'TelemetryCollector', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$TelemetryCollector;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'eventComponentMounted', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$eventComponentMounted;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'eventFrameworkMetadata', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$eventFrameworkMetadata;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'eventMethodCalled', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$eventMethodCalled;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'eventPrebuiltComponentMounted', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$eventPrebuiltComponentMounted;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'eventPrebuiltComponentOpened', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$eventPrebuiltComponentOpened;
    }
});
Object.defineProperty($77d689860cf967c8$exports, 'eventThemeUsage', {
    enumerable: true,
    get: function() {
        return $77d689860cf967c8$var$eventThemeUsage;
    }
});



var $acw62 = parcelRequire("acw62");
var $a0ea147aab9dedc4$require$react = $acw62;
$a0ea147aab9dedc4$require$react = $32b1ea291a9463bc$exports.__toESM($a0ea147aab9dedc4$require$react);
var $9ef683e011c31ff0$exports = {};

$parcel$defineInteropFlag($9ef683e011c31ff0$exports);

$parcel$export($9ef683e011c31ff0$exports, "unstable_serialize", () => $9ef683e011c31ff0$export$dbab534a48e651ef);
$parcel$export($9ef683e011c31ff0$exports, "SWRConfig", () => $9ef683e011c31ff0$export$4c7bbecdacc3ca2c);
$parcel$export($9ef683e011c31ff0$exports, "default", () => $9ef683e011c31ff0$export$2e2bcd8739ae039);
$parcel$export($9ef683e011c31ff0$exports, "mutate", () => $fed08f42ac0bbba1$export$35e795649ee09318);
$parcel$export($9ef683e011c31ff0$exports, "preload", () => $73ef0a5623b28096$export$513ccb98c53b8039);
$parcel$export($9ef683e011c31ff0$exports, "useSWRConfig", () => $73ef0a5623b28096$export$f1dc0e282d4c1c0);

var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));



var $acw62 = parcelRequire("acw62");
var $78701249fecd496d$exports = {};

$parcel$export($78701249fecd496d$exports, "FOCUS_EVENT", () => $78701249fecd496d$export$831c820ad60f9d12);
$parcel$export($78701249fecd496d$exports, "RECONNECT_EVENT", () => $78701249fecd496d$export$24e9454cb99a11dc);
$parcel$export($78701249fecd496d$exports, "MUTATE_EVENT", () => $78701249fecd496d$export$75ea288459391154);
$parcel$export($78701249fecd496d$exports, "ERROR_REVALIDATE_EVENT", () => $78701249fecd496d$export$b019c3839228f243);
const $78701249fecd496d$export$831c820ad60f9d12 = 0;
const $78701249fecd496d$export$24e9454cb99a11dc = 1;
const $78701249fecd496d$export$75ea288459391154 = 2;
const $78701249fecd496d$export$b019c3839228f243 = 3;


var $0790fe16af8106e5$var$has = Object.prototype.hasOwnProperty;
function $0790fe16af8106e5$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $0790fe16af8106e5$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($0790fe16af8106e5$var$has.call(foo, ctor) && ++len && !$0790fe16af8106e5$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$0790fe16af8106e5$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


'use client';
// Global state used to deduplicate requests and store listeners
const $fed08f42ac0bbba1$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $fed08f42ac0bbba1$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $fed08f42ac0bbba1$export$ebd11618f299a286();
const $fed08f42ac0bbba1$export$c4ce752e73470fba = Object;
const $fed08f42ac0bbba1$export$f1e1789686576879 = (v)=>v === $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08;
const $fed08f42ac0bbba1$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $fed08f42ac0bbba1$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $fed08f42ac0bbba1$export$ef35774e6d314e91 = (x)=>$fed08f42ac0bbba1$export$407448d2b89b1813(x.then);
const $fed08f42ac0bbba1$var$EMPTY_CACHE = {};
const $fed08f42ac0bbba1$var$INITIAL_CACHE = {};
const $fed08f42ac0bbba1$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $fed08f42ac0bbba1$export$23f2a1d2818174ef = typeof window != $fed08f42ac0bbba1$var$STR_UNDEFINED;
const $fed08f42ac0bbba1$export$efccba1c4a2ef57b = typeof document != $fed08f42ac0bbba1$var$STR_UNDEFINED;
const $fed08f42ac0bbba1$export$d141bba7fdc215a3 = $fed08f42ac0bbba1$export$23f2a1d2818174ef && 'Deno' in window;
const $fed08f42ac0bbba1$export$4a5767248b18ef41 = ()=>$fed08f42ac0bbba1$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $fed08f42ac0bbba1$var$STR_UNDEFINED;
const $fed08f42ac0bbba1$export$df995fae86a55f06 = (cache, key)=>{
    const state = $fed08f42ac0bbba1$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$fed08f42ac0bbba1$export$f1e1789686576879(key) && cache.get(key) || $fed08f42ac0bbba1$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$fed08f42ac0bbba1$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $fed08f42ac0bbba1$var$INITIAL_CACHE)) $fed08f42ac0bbba1$var$INITIAL_CACHE[key] = prev;
                state[5](key, $fed08f42ac0bbba1$export$953cecd6e717a553(prev, info), prev || $fed08f42ac0bbba1$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$fed08f42ac0bbba1$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $fed08f42ac0bbba1$var$INITIAL_CACHE) return $fed08f42ac0bbba1$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$fed08f42ac0bbba1$export$f1e1789686576879(key) && cache.get(key) || $fed08f42ac0bbba1$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $fed08f42ac0bbba1$var$online = true;
const $fed08f42ac0bbba1$var$isOnline = ()=>$fed08f42ac0bbba1$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$fed08f42ac0bbba1$var$onWindowEvent, $fed08f42ac0bbba1$var$offWindowEvent] = $fed08f42ac0bbba1$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $fed08f42ac0bbba1$export$ebd11618f299a286,
    $fed08f42ac0bbba1$export$ebd11618f299a286
];
const $fed08f42ac0bbba1$var$isVisible = ()=>{
    const visibilityState = $fed08f42ac0bbba1$export$efccba1c4a2ef57b && document.visibilityState;
    return $fed08f42ac0bbba1$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $fed08f42ac0bbba1$var$initFocus = (callback)=>{
    // focus revalidate
    if ($fed08f42ac0bbba1$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $fed08f42ac0bbba1$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($fed08f42ac0bbba1$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $fed08f42ac0bbba1$var$offWindowEvent('focus', callback);
    };
};
const $fed08f42ac0bbba1$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $fed08f42ac0bbba1$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $fed08f42ac0bbba1$var$online = false;
    };
    $fed08f42ac0bbba1$var$onWindowEvent('online', onOnline);
    $fed08f42ac0bbba1$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $fed08f42ac0bbba1$var$offWindowEvent('online', onOnline);
        $fed08f42ac0bbba1$var$offWindowEvent('offline', onOffline);
    };
};
const $fed08f42ac0bbba1$export$ffb5f4729a158638 = {
    isOnline: $fed08f42ac0bbba1$var$isOnline,
    isVisible: $fed08f42ac0bbba1$var$isVisible
};
const $fed08f42ac0bbba1$export$9e5f44173e64f162 = {
    initFocus: $fed08f42ac0bbba1$var$initFocus,
    initReconnect: $fed08f42ac0bbba1$var$initReconnect
};
const $fed08f42ac0bbba1$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId;
const $fed08f42ac0bbba1$export$43caf9889c228507 = !$fed08f42ac0bbba1$export$23f2a1d2818174ef || $fed08f42ac0bbba1$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $fed08f42ac0bbba1$export$625550452a3fa3ec = (f)=>$fed08f42ac0bbba1$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $fed08f42ac0bbba1$export$3b14a55fb2447963 = $fed08f42ac0bbba1$export$43caf9889c228507 ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $fed08f42ac0bbba1$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $fed08f42ac0bbba1$export$90a7f3efeed30595 = !$fed08f42ac0bbba1$export$43caf9889c228507 && $fed08f42ac0bbba1$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($fed08f42ac0bbba1$var$navigatorConnection.effectiveType) || $fed08f42ac0bbba1$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $fed08f42ac0bbba1$var$table = new WeakMap();
const $fed08f42ac0bbba1$var$getTypeName = (value)=>$fed08f42ac0bbba1$export$c4ce752e73470fba.prototype.toString.call(value);
const $fed08f42ac0bbba1$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $fed08f42ac0bbba1$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $fed08f42ac0bbba1$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $fed08f42ac0bbba1$var$getTypeName(arg);
    const isDate = $fed08f42ac0bbba1$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $fed08f42ac0bbba1$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $fed08f42ac0bbba1$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($fed08f42ac0bbba1$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $fed08f42ac0bbba1$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$fed08f42ac0bbba1$var$counter + '~';
        $fed08f42ac0bbba1$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $fed08f42ac0bbba1$export$882b5998b3b9117c(arg[index]) + ',';
            $fed08f42ac0bbba1$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $fed08f42ac0bbba1$export$c4ce752e73470fba.keys(arg).sort();
            while(!$fed08f42ac0bbba1$export$f1e1789686576879(index = keys.pop()))if (!$fed08f42ac0bbba1$export$f1e1789686576879(arg[index])) result += index + ':' + $fed08f42ac0bbba1$export$882b5998b3b9117c(arg[index]) + ',';
            $fed08f42ac0bbba1$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $fed08f42ac0bbba1$export$2408f22a0fab9ae5 = (key)=>{
    if ($fed08f42ac0bbba1$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $fed08f42ac0bbba1$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $fed08f42ac0bbba1$var$__timestamp = 0;
const $fed08f42ac0bbba1$export$ae1af26003f05816 = ()=>++$fed08f42ac0bbba1$var$__timestamp;
async function $fed08f42ac0bbba1$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $fed08f42ac0bbba1$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($fed08f42ac0bbba1$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $fed08f42ac0bbba1$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $fed08f42ac0bbba1$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $fed08f42ac0bbba1$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $fed08f42ac0bbba1$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($78701249fecd496d$export$75ea288459391154).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $fed08f42ac0bbba1$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$fed08f42ac0bbba1$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $fed08f42ac0bbba1$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $fed08f42ac0bbba1$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($fed08f42ac0bbba1$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $fed08f42ac0bbba1$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($fed08f42ac0bbba1$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08,
                        _c: $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08,
                    _c: $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $fed08f42ac0bbba1$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $fed08f42ac0bbba1$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $fed08f42ac0bbba1$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$fed08f42ac0bbba1$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $fed08f42ac0bbba1$export$953cecd6e717a553($fed08f42ac0bbba1$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $fed08f42ac0bbba1$export$7ccc53e8f1e7dfc5.bind($fed08f42ac0bbba1$export$3a6d5c9ae78a2c08, provider);
        let unmount = $fed08f42ac0bbba1$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$fed08f42ac0bbba1$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $fed08f42ac0bbba1$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$fed08f42ac0bbba1$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($fed08f42ac0bbba1$export$3a6d5c9ae78a2c08, $fed08f42ac0bbba1$var$revalidateAllKeys.bind($fed08f42ac0bbba1$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $78701249fecd496d$export$831c820ad60f9d12)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($fed08f42ac0bbba1$export$3a6d5c9ae78a2c08, $fed08f42ac0bbba1$var$revalidateAllKeys.bind($fed08f42ac0bbba1$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $78701249fecd496d$export$24e9454cb99a11dc)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $fed08f42ac0bbba1$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $fed08f42ac0bbba1$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $fed08f42ac0bbba1$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$fed08f42ac0bbba1$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $fed08f42ac0bbba1$export$342063e11d6c3cad = (0, $0790fe16af8106e5$export$de8294bb3be0322f);
// Default cache provider
const [$fed08f42ac0bbba1$export$db3b6bfb95261072, $fed08f42ac0bbba1$export$35e795649ee09318] = $fed08f42ac0bbba1$export$dda1d9f60106f0e9(new Map());
// Default config
const $fed08f42ac0bbba1$export$4368d992c4eafac0 = $fed08f42ac0bbba1$export$953cecd6e717a553({
    // events
    onLoadingSlow: $fed08f42ac0bbba1$export$ebd11618f299a286,
    onSuccess: $fed08f42ac0bbba1$export$ebd11618f299a286,
    onError: $fed08f42ac0bbba1$export$ebd11618f299a286,
    onErrorRetry: $fed08f42ac0bbba1$var$onErrorRetry,
    onDiscarded: $fed08f42ac0bbba1$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $fed08f42ac0bbba1$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $fed08f42ac0bbba1$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $fed08f42ac0bbba1$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $fed08f42ac0bbba1$export$db3b6bfb95261072,
    mutate: $fed08f42ac0bbba1$export$35e795649ee09318,
    fallback: {}
}, $fed08f42ac0bbba1$export$ffb5f4729a158638);
const $fed08f42ac0bbba1$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $fed08f42ac0bbba1$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $fed08f42ac0bbba1$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $fed08f42ac0bbba1$export$25ce5a424b770e84 = (0, $acw62.createContext)({});
const $fed08f42ac0bbba1$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $acw62.useContext)($fed08f42ac0bbba1$export$25ce5a424b770e84);
    const isFunctionalConfig = $fed08f42ac0bbba1$export$407448d2b89b1813(value);
    const config = (0, $acw62.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $acw62.useMemo)(()=>isFunctionalConfig ? config : $fed08f42ac0bbba1$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $acw62.useRef)($fed08f42ac0bbba1$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $fed08f42ac0bbba1$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $fed08f42ac0bbba1$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $fed08f42ac0bbba1$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $acw62.createElement)($fed08f42ac0bbba1$export$25ce5a424b770e84.Provider, $fed08f42ac0bbba1$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};



const $31b819a8af02b76f$export$8667f065faedc62c = '$inf$';



var $acw62 = parcelRequire("acw62");

// @ts-expect-error
const $73ef0a5623b28096$var$enableDevtools = (0, $fed08f42ac0bbba1$export$23f2a1d2818174ef) && window.__SWR_DEVTOOLS_USE__;
const $73ef0a5623b28096$var$use = $73ef0a5623b28096$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $73ef0a5623b28096$var$setupDevTools = ()=>{
    if ($73ef0a5623b28096$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
};
const $73ef0a5623b28096$export$a3295358bff77e = (args)=>{
    return (0, $fed08f42ac0bbba1$export$407448d2b89b1813)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $73ef0a5623b28096$export$f1dc0e282d4c1c0 = ()=>{
    return (0, $fed08f42ac0bbba1$export$953cecd6e717a553)((0, $fed08f42ac0bbba1$export$4368d992c4eafac0), (0, $acw62.useContext)((0, $fed08f42ac0bbba1$export$25ce5a424b770e84)));
};
const $73ef0a5623b28096$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $fed08f42ac0bbba1$export$2408f22a0fab9ae5)(key_);
    const [, , , PRELOAD] = (0, $fed08f42ac0bbba1$export$8b22cf2602fb60ce).get((0, $fed08f42ac0bbba1$export$db3b6bfb95261072));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $73ef0a5623b28096$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $fed08f42ac0bbba1$export$2408f22a0fab9ae5)(key_);
            const [, , , PRELOAD] = (0, $fed08f42ac0bbba1$export$8b22cf2602fb60ce).get((0, $fed08f42ac0bbba1$export$db3b6bfb95261072));
            if (key.startsWith((0, $31b819a8af02b76f$export$8667f065faedc62c))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $fed08f42ac0bbba1$export$f1e1789686576879)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $73ef0a5623b28096$var$BUILT_IN_MIDDLEWARE = $73ef0a5623b28096$var$use.concat($73ef0a5623b28096$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $73ef0a5623b28096$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $73ef0a5623b28096$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $73ef0a5623b28096$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $fed08f42ac0bbba1$export$2d1720544b23b823)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($73ef0a5623b28096$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $73ef0a5623b28096$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $73ef0a5623b28096$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $73ef0a5623b28096$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$73ef0a5623b28096$var$setupDevTools();


// Shared state between server components and client components
const $9ef683e011c31ff0$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $9ef683e011c31ff0$var$UNDEFINED = /*#__NOINLINE__*/ $9ef683e011c31ff0$var$noop();
const $9ef683e011c31ff0$var$OBJECT = Object;
const $9ef683e011c31ff0$var$isUndefined = (v)=>v === $9ef683e011c31ff0$var$UNDEFINED;
const $9ef683e011c31ff0$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $9ef683e011c31ff0$var$table = new WeakMap();
const $9ef683e011c31ff0$var$getTypeName = (value)=>$9ef683e011c31ff0$var$OBJECT.prototype.toString.call(value);
const $9ef683e011c31ff0$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $9ef683e011c31ff0$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $9ef683e011c31ff0$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $9ef683e011c31ff0$var$getTypeName(arg);
    const isDate = $9ef683e011c31ff0$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $9ef683e011c31ff0$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $9ef683e011c31ff0$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($9ef683e011c31ff0$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $9ef683e011c31ff0$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$9ef683e011c31ff0$var$counter + '~';
        $9ef683e011c31ff0$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $9ef683e011c31ff0$var$stableHash(arg[index]) + ',';
            $9ef683e011c31ff0$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $9ef683e011c31ff0$var$OBJECT.keys(arg).sort();
            while(!$9ef683e011c31ff0$var$isUndefined(index = keys.pop()))if (!$9ef683e011c31ff0$var$isUndefined(arg[index])) result += index + ':' + $9ef683e011c31ff0$var$stableHash(arg[index]) + ',';
            $9ef683e011c31ff0$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $9ef683e011c31ff0$var$serialize = (key)=>{
    if ($9ef683e011c31ff0$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $9ef683e011c31ff0$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $9ef683e011c31ff0$export$dbab534a48e651ef = (key)=>$9ef683e011c31ff0$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $9ef683e011c31ff0$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $9ef683e011c31ff0$var$WITH_DEDUPE = {
    dedupe: true
};
const $9ef683e011c31ff0$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $fed08f42ac0bbba1$export$8b22cf2602fb60ce).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $fed08f42ac0bbba1$export$2408f22a0fab9ae5)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $acw62.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $acw62.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $acw62.useRef)(key);
    const fetcherRef = (0, $acw62.useRef)(fetcher);
    const configRef = (0, $acw62.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache, key);
    const stateDependencies = (0, $acw62.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $fed08f42ac0bbba1$export$f1e1789686576879)(fallbackData) ? (0, $fed08f42ac0bbba1$export$f1e1789686576879)(config.fallback) ? (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $acw62.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $fed08f42ac0bbba1$export$953cecd6e717a553)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)((0, $acw62.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $fed08f42ac0bbba1$export$f1e1789686576879)(cachedData) ? fallback && (0, $fed08f42ac0bbba1$export$ef35774e6d314e91)(fallback) ? $9ef683e011c31ff0$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $acw62.useRef)(data);
    const returnedData = keepPreviousData ? (0, $fed08f42ac0bbba1$export$f1e1789686576879)(cachedData) ? (0, $fed08f42ac0bbba1$export$f1e1789686576879)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $fed08f42ac0bbba1$export$f1e1789686576879)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $fed08f42ac0bbba1$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $fed08f42ac0bbba1$export$f1e1789686576879)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $fed08f42ac0bbba1$export$f1e1789686576879)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $fed08f42ac0bbba1$export$f1e1789686576879)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $fed08f42ac0bbba1$export$f1e1789686576879)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $acw62.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $fed08f42ac0bbba1$export$9bb611d729802a56) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $fed08f42ac0bbba1$export$f1e1789686576879)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $fed08f42ac0bbba1$export$f1e1789686576879)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $fed08f42ac0bbba1$export$ae1af26003f05816)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $fed08f42ac0bbba1$export$407448d2b89b1813)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $78701249fecd496d$exports).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $acw62.useCallback)((...args)=>{
        return (0, $fed08f42ac0bbba1$export$7ccc53e8f1e7dfc5)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $fed08f42ac0bbba1$export$3b14a55fb2447963)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $fed08f42ac0bbba1$export$3b14a55fb2447963)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08), $9ef683e011c31ff0$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $78701249fecd496d$exports).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $78701249fecd496d$exports).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $78701249fecd496d$exports).MUTATE_EVENT) return revalidate();
            else if (type == (0, $78701249fecd496d$exports).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $73ef0a5623b28096$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $fed08f42ac0bbba1$export$f1e1789686576879)(data) || (0, $fed08f42ac0bbba1$export$43caf9889c228507)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $fed08f42ac0bbba1$export$625550452a3fa3ec)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $fed08f42ac0bbba1$export$3b14a55fb2447963)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $fed08f42ac0bbba1$export$407448d2b89b1813)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($9ef683e011c31ff0$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $acw62.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $fed08f42ac0bbba1$export$f1e1789686576879)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $fed08f42ac0bbba1$export$9bb611d729802a56) && (0, $fed08f42ac0bbba1$export$43caf9889c228507)) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(req)) {
            const promise = boundMutate(req);
            $9ef683e011c31ff0$var$use(promise);
        }
        if ((0, $fed08f42ac0bbba1$export$f1e1789686576879)(error)) {
            const promise = revalidate($9ef683e011c31ff0$var$WITH_DEDUPE);
            if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $9ef683e011c31ff0$var$use(promise);
        } else throw error;
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $9ef683e011c31ff0$export$4c7bbecdacc3ca2c = (0, $fed08f42ac0bbba1$export$c4ce752e73470fba).defineProperty((0, $fed08f42ac0bbba1$export$39b482c5e57630a8), 'defaultValue', {
    value: (0, $fed08f42ac0bbba1$export$4368d992c4eafac0)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $9ef683e011c31ff0$export$2e2bcd8739ae039 = (0, $73ef0a5623b28096$export$84d44e54e14b0133)($9ef683e011c31ff0$var$useSWRHandler);


var $a0ea147aab9dedc4$require$swr = $9ef683e011c31ff0$exports;
$a0ea147aab9dedc4$require$swr = $32b1ea291a9463bc$exports.__toESM($a0ea147aab9dedc4$require$swr);
var $25f67ffa4087bf8c$exports = {};

$parcel$defineInteropFlag($25f67ffa4087bf8c$exports);

$parcel$export($25f67ffa4087bf8c$exports, "unstable_serialize", () => $25f67ffa4087bf8c$export$dbab534a48e651ef);
$parcel$export($25f67ffa4087bf8c$exports, "infinite", () => $25f67ffa4087bf8c$export$f27219e7b43e81d);
$parcel$export($25f67ffa4087bf8c$exports, "default", () => $25f67ffa4087bf8c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");




// Shared state between server components and client components
const $25f67ffa4087bf8c$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $25f67ffa4087bf8c$var$UNDEFINED = /*#__NOINLINE__*/ $25f67ffa4087bf8c$var$noop();
const $25f67ffa4087bf8c$var$OBJECT = Object;
const $25f67ffa4087bf8c$var$isUndefined = (v)=>v === $25f67ffa4087bf8c$var$UNDEFINED;
const $25f67ffa4087bf8c$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $25f67ffa4087bf8c$var$table = new WeakMap();
const $25f67ffa4087bf8c$var$getTypeName = (value)=>$25f67ffa4087bf8c$var$OBJECT.prototype.toString.call(value);
const $25f67ffa4087bf8c$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $25f67ffa4087bf8c$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $25f67ffa4087bf8c$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $25f67ffa4087bf8c$var$getTypeName(arg);
    const isDate = $25f67ffa4087bf8c$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $25f67ffa4087bf8c$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $25f67ffa4087bf8c$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($25f67ffa4087bf8c$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $25f67ffa4087bf8c$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$25f67ffa4087bf8c$var$counter + '~';
        $25f67ffa4087bf8c$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $25f67ffa4087bf8c$var$stableHash(arg[index]) + ',';
            $25f67ffa4087bf8c$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $25f67ffa4087bf8c$var$OBJECT.keys(arg).sort();
            while(!$25f67ffa4087bf8c$var$isUndefined(index = keys.pop()))if (!$25f67ffa4087bf8c$var$isUndefined(arg[index])) result += index + ':' + $25f67ffa4087bf8c$var$stableHash(arg[index]) + ',';
            $25f67ffa4087bf8c$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $25f67ffa4087bf8c$var$serialize = (key)=>{
    if ($25f67ffa4087bf8c$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $25f67ffa4087bf8c$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $25f67ffa4087bf8c$var$getFirstPageKey = (getKey)=>{
    return $25f67ffa4087bf8c$var$serialize(getKey ? getKey(0, null) : null)[0];
};
const $25f67ffa4087bf8c$export$dbab534a48e651ef = (getKey)=>{
    return (0, $31b819a8af02b76f$export$8667f065faedc62c) + $25f67ffa4087bf8c$var$getFirstPageKey(getKey);
};
// We have to several type castings here because `useSWRInfinite` is a special
// hook where `key` and return type are not like the normal `useSWR` types.
const $25f67ffa4087bf8c$var$EMPTY_PROMISE = Promise.resolve();
const $25f67ffa4087bf8c$export$f27219e7b43e81d = (useSWRNext)=>(getKey, fn, config)=>{
        const didMountRef = (0, $acw62.useRef)(false);
        const { cache: cache$1, initialSize: initialSize = 1, revalidateAll: revalidateAll = false, persistSize: persistSize = false, revalidateFirstPage: revalidateFirstPage = true, revalidateOnMount: revalidateOnMount = false, parallel: parallel = false } = config;
        const [, , , PRELOAD] = (0, $fed08f42ac0bbba1$export$8b22cf2602fb60ce).get((0, $fed08f42ac0bbba1$export$db3b6bfb95261072));
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        let infiniteKey;
        try {
            infiniteKey = $25f67ffa4087bf8c$var$getFirstPageKey(getKey);
            if (infiniteKey) infiniteKey = (0, $31b819a8af02b76f$export$8667f065faedc62c) + infiniteKey;
        } catch (err) {
        // Not ready yet.
        }
        const [get, set, subscribeCache] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache$1, infiniteKey);
        const getSnapshot = (0, $acw62.useCallback)(()=>{
            const size = (0, $fed08f42ac0bbba1$export$f1e1789686576879)(get()._l) ? initialSize : get()._l;
            return size;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            cache$1,
            infiniteKey,
            initialSize
        ]);
        (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)((0, $acw62.useCallback)((callback)=>{
            if (infiniteKey) return subscribeCache(infiniteKey, ()=>{
                callback();
            });
            return ()=>{};
        }, [
            cache$1,
            infiniteKey
        ]), getSnapshot, getSnapshot);
        const resolvePageSize = (0, $acw62.useCallback)(()=>{
            const cachedPageSize = get()._l;
            return (0, $fed08f42ac0bbba1$export$f1e1789686576879)(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        const lastPageSizeRef = (0, $acw62.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0, $fed08f42ac0bbba1$export$3b14a55fb2447963)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            // Otherwise, we reset the page size to cached pageSize
            set({
                _l: persistSize ? lastPageSizeRef.current : resolvePageSize()
            });
        // `initialSize` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            cache$1
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        const shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        const swr = useSWRNext(infiniteKey, async (key)=>{
            // get the revalidate context
            const forceRevalidateAll = get()._i;
            const shouldRevalidatePage = get()._r;
            set({
                _r: (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08)
            });
            // return an array of page data
            const data = [];
            const pageSize = resolvePageSize();
            const [getCache] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache$1, key);
            const cacheData = getCache().data;
            const revalidators = [];
            let previousPageData = null;
            for(let i = 0; i < pageSize; ++i){
                const [pageKey, pageArg] = (0, $fed08f42ac0bbba1$export$2408f22a0fab9ae5)(getKey(i, parallel ? null : previousPageData));
                if (!pageKey) break;
                const [getSWRCache, setSWRCache] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache$1, pageKey);
                // Get the cached page data.
                let pageData = getSWRCache().data;
                // should fetch (or revalidate) if:
                // - `revalidateAll` is enabled
                // - `mutate()` called
                // - the cache is missing
                // - it's the first page and it's not the initial render
                // - `revalidateOnMount` is enabled and it's on mount
                // - cache for that page has changed
                const shouldFetchPage = revalidateAll || forceRevalidateAll || (0, $fed08f42ac0bbba1$export$f1e1789686576879)(pageData) || revalidateFirstPage && !i && !(0, $fed08f42ac0bbba1$export$f1e1789686576879)(cacheData) || shouldRevalidateOnMount || cacheData && !(0, $fed08f42ac0bbba1$export$f1e1789686576879)(cacheData[i]) && !config.compare(cacheData[i], pageData);
                if (fn && (typeof shouldRevalidatePage === 'function' ? shouldRevalidatePage(pageData, pageArg) : shouldFetchPage)) {
                    const revalidate = async ()=>{
                        const hasPreloadedRequest = pageKey in PRELOAD;
                        if (!hasPreloadedRequest) pageData = await fn(pageArg);
                        else {
                            const req = PRELOAD[pageKey];
                            // delete the preload cache key before resolving it
                            // in case there's an error
                            delete PRELOAD[pageKey];
                            // get the page data from the preload cache
                            pageData = await req;
                        }
                        setSWRCache({
                            data: pageData,
                            _k: pageArg
                        });
                        data[i] = pageData;
                    };
                    if (parallel) revalidators.push(revalidate);
                    else await revalidate();
                } else data[i] = pageData;
                if (!parallel) previousPageData = pageData;
            }
            // flush all revalidateions in parallel
            if (parallel) await Promise.all(revalidators.map((r)=>r()));
            // once we executed the data fetching based on the context, clear the context
            set({
                _i: (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08)
            });
            // return the data
            return data;
        }, config);
        const mutate = (0, $acw62.useCallback)(function(data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            const options = typeof opts === 'boolean' ? {
                revalidate: opts
            } : opts || {};
            // Default to true.
            const shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $25f67ffa4087bf8c$var$EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0, $fed08f42ac0bbba1$export$f1e1789686576879)(data)) // We only revalidate the pages that are changed
                set({
                    _i: false,
                    _r: options.revalidate
                });
                else // Calling `mutate()`, we revalidate all pages
                set({
                    _i: true,
                    _r: options.revalidate
                });
            }
            return arguments.length ? swr.mutate(data, {
                ...options,
                revalidate: shouldRevalidate
            }) : swr.mutate();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1
        ]);
        // Extend the SWR API
        const setSize = (0, $acw62.useCallback)((arg)=>{
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $25f67ffa4087bf8c$var$EMPTY_PROMISE;
            const [, changeSize] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache$1, infiniteKey);
            let size;
            if ((0, $fed08f42ac0bbba1$export$407448d2b89b1813)(arg)) size = arg(resolvePageSize());
            else if (typeof arg == 'number') size = arg;
            if (typeof size != 'number') return $25f67ffa4087bf8c$var$EMPTY_PROMISE;
            changeSize({
                _l: size
            });
            lastPageSizeRef.current = size;
            // Calculate the page data after the size change.
            const data = [];
            const [getInfiniteCache] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache$1, infiniteKey);
            let previousPageData = null;
            for(let i = 0; i < size; ++i){
                const [pageKey] = (0, $fed08f42ac0bbba1$export$2408f22a0fab9ae5)(getKey(i, previousPageData));
                const [getCache] = (0, $fed08f42ac0bbba1$export$df995fae86a55f06)(cache$1, pageKey);
                // Get the cached page data.
                const pageData = pageKey ? getCache().data : (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08);
                // Call `mutate` with infinte cache data if we can't get it from the page cache.
                if ((0, $fed08f42ac0bbba1$export$f1e1789686576879)(pageData)) return mutate(getInfiniteCache().data);
                data.push(pageData);
                previousPageData = pageData;
            }
            return mutate(data);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1,
            mutate,
            resolvePageSize
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data () {
                return swr.data;
            },
            get error () {
                return swr.error;
            },
            get isValidating () {
                return swr.isValidating;
            },
            get isLoading () {
                return swr.isLoading;
            }
        };
    };
const $25f67ffa4087bf8c$export$2e2bcd8739ae039 = (0, $73ef0a5623b28096$export$525ea7fc6ba00096)((0, $9ef683e011c31ff0$export$2e2bcd8739ae039), $25f67ffa4087bf8c$export$f27219e7b43e81d);


var $a0ea147aab9dedc4$require$swr_infinite = $25f67ffa4087bf8c$exports;
$a0ea147aab9dedc4$require$swr_infinite = $32b1ea291a9463bc$exports.__toESM($a0ea147aab9dedc4$require$swr_infinite);
var $371d31aa64efa655$exports = {};

$parcel$export($371d31aa64efa655$exports, "dequal", () => $371d31aa64efa655$export$de8294bb3be0322f);
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


var $a0ea147aab9dedc4$require$dequal = $371d31aa64efa655$exports;
$a0ea147aab9dedc4$require$dequal = $32b1ea291a9463bc$exports.__toESM($a0ea147aab9dedc4$require$dequal);
var $186063b2cbacd882$exports = {};

$parcel$defineInteropFlag($186063b2cbacd882$exports);

$parcel$export($186063b2cbacd882$exports, "default", () => $186063b2cbacd882$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


const $186063b2cbacd882$var$startTransition = (0, $fed08f42ac0bbba1$export$9bb611d729802a56) ? (cb)=>{
    cb();
} : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).startTransition;
/**
 * An implementation of state with dependency-tracking.
 * @param initialState - The initial state object.
 */ const $186063b2cbacd882$var$useStateWithDeps = (initialState)=>{
    const [, rerender] = (0, $acw62.useState)({});
    const unmountedRef = (0, $acw62.useRef)(false);
    const stateRef = (0, $acw62.useRef)(initialState);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = (0, $acw62.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * Updates state and triggers re-render if necessary.
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = (0, $acw62.useCallback)((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const key in payload)if (Object.prototype.hasOwnProperty.call(payload, key)) {
            const k = key;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) rerender({});
    }, []);
    (0, $fed08f42ac0bbba1$export$3b14a55fb2447963)(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
const $186063b2cbacd882$var$mutation = ()=>(key, fetcher, config = {})=>{
        const { mutate: mutate } = (0, $73ef0a5623b28096$export$f1dc0e282d4c1c0)();
        const keyRef = (0, $acw62.useRef)(key);
        const fetcherRef = (0, $acw62.useRef)(fetcher);
        const configRef = (0, $acw62.useRef)(config);
        // Ditch all mutation results that happened earlier than this timestamp.
        const ditchMutationsUntilRef = (0, $acw62.useRef)(0);
        const [stateRef, stateDependencies, setState] = $186063b2cbacd882$var$useStateWithDeps({
            data: (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08),
            error: (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08),
            isMutating: false
        });
        const currentState = stateRef.current;
        const trigger = (0, $acw62.useCallback)(async (arg, opts)=>{
            const [serializedKey, resolvedKey] = (0, $fed08f42ac0bbba1$export$2408f22a0fab9ae5)(keyRef.current);
            if (!fetcherRef.current) throw new Error("Can\u2019t trigger the mutation: missing fetcher.");
            if (!serializedKey) throw new Error("Can\u2019t trigger the mutation: missing key.");
            // Disable cache population by default.
            const options = (0, $fed08f42ac0bbba1$export$953cecd6e717a553)((0, $fed08f42ac0bbba1$export$953cecd6e717a553)({
                populateCache: false,
                throwOnError: true
            }, configRef.current), opts);
            // Trigger a mutation, and also track the timestamp. Any mutation that happened
            // earlier this timestamp should be ignored.
            const mutationStartedAt = (0, $fed08f42ac0bbba1$export$ae1af26003f05816)();
            ditchMutationsUntilRef.current = mutationStartedAt;
            setState({
                isMutating: true
            });
            try {
                const data = await mutate(serializedKey, fetcherRef.current(resolvedKey, {
                    arg: arg
                }), (0, $fed08f42ac0bbba1$export$953cecd6e717a553)(options, {
                    throwOnError: true
                }));
                // If it's reset after the mutation, we don't broadcast any state change.
                if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                    $186063b2cbacd882$var$startTransition(()=>setState({
                            data: data,
                            isMutating: false,
                            error: undefined
                        }));
                    options.onSuccess == null || options.onSuccess.call(options, data, serializedKey, options);
                }
                return data;
            } catch (error) {
                // If it's reset after the mutation, we don't broadcast any state change
                // or throw because it's discarded.
                if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                    $186063b2cbacd882$var$startTransition(()=>setState({
                            error: error,
                            isMutating: false
                        }));
                    options.onError == null ? undefined : options.onError.call(options, error, serializedKey, options);
                    if (options.throwOnError) throw error;
                }
            }
        }, []);
        const reset = (0, $acw62.useCallback)(()=>{
            ditchMutationsUntilRef.current = (0, $fed08f42ac0bbba1$export$ae1af26003f05816)();
            setState({
                data: (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08),
                error: (0, $fed08f42ac0bbba1$export$3a6d5c9ae78a2c08),
                isMutating: false
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        (0, $fed08f42ac0bbba1$export$3b14a55fb2447963)(()=>{
            keyRef.current = key;
            fetcherRef.current = fetcher;
            configRef.current = config;
        });
        // We don't return `mutate` here as it can be pretty confusing (e.g. people
        // calling `mutate` but they actually mean `trigger`).
        // And also, `mutate` relies on the useSWR hook to exist too.
        return {
            trigger: trigger,
            reset: reset,
            get data () {
                stateDependencies.data = true;
                return currentState.data;
            },
            get error () {
                stateDependencies.error = true;
                return currentState.error;
            },
            get isMutating () {
                stateDependencies.isMutating = true;
                return currentState.isMutating;
            }
        };
    };
/**
 * A hook to define and manually trigger remote mutations like POST, PUT, DELETE and PATCH use cases.
 *
 * @link https://swr.vercel.app/docs/mutation
 * @example
 * ```jsx
 * import useSWRMutation from 'swr/mutation'
 *
 * const {
 *   data,
 *   error,
 *   trigger,
 *   reset,
 *   isMutating
 * } = useSWRMutation(key, fetcher, options?)
 * ```
 */ const $186063b2cbacd882$export$2e2bcd8739ae039 = (0, $73ef0a5623b28096$export$525ea7fc6ba00096)((0, $9ef683e011c31ff0$export$2e2bcd8739ae039), $186063b2cbacd882$var$mutation);


var $a0ea147aab9dedc4$require$swr_mutation = $186063b2cbacd882$exports;
$a0ea147aab9dedc4$require$swr_mutation = $32b1ea291a9463bc$exports.__toESM($a0ea147aab9dedc4$require$swr_mutation);
//#region src/react/hooks/createContextAndHook.ts
/**
* Assert that the context value exists, otherwise throw an error.
*
* @internal
*/ function $a0ea147aab9dedc4$var$assertContextExists(contextVal, msgOrCtx) {
    if (!contextVal) throw typeof msgOrCtx === "string" ? new Error(msgOrCtx) : /* @__PURE__ */ new Error(`${msgOrCtx.displayName} not found`);
}
/**
* Create and return a Context and two hooks that return the context value.
* The Context type is derived from the type passed in by the user.
*
* The first hook returned guarantees that the context exists so the returned value is always `CtxValue`
* The second hook makes no guarantees, so the returned value can be `CtxValue | undefined`
*
* @internal
*/ const $a0ea147aab9dedc4$var$createContextAndHook = (displayName, options)=>{
    const { assertCtxFn: assertCtxFn = $a0ea147aab9dedc4$var$assertContextExists } = options || {};
    const Ctx = $a0ea147aab9dedc4$require$react.default.createContext(void 0);
    Ctx.displayName = displayName;
    const useCtx = ()=>{
        const ctx = $a0ea147aab9dedc4$require$react.default.useContext(Ctx);
        assertCtxFn(ctx, `${displayName} not found`);
        return ctx.value;
    };
    const useCtxWithoutGuarantee = ()=>{
        const ctx = $a0ea147aab9dedc4$require$react.default.useContext(Ctx);
        return ctx ? ctx.value : {};
    };
    return [
        Ctx,
        useCtx,
        useCtxWithoutGuarantee
    ];
};
//#endregion
//#region src/react/providers/SWRConfigCompat.swr.tsx
/**
* @internal
*/ function $a0ea147aab9dedc4$var$SWRConfigCompat({ swrConfig: swrConfig, children: children }) {
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$require$swr.SWRConfig, {
        value: swrConfig
    }, children);
}
//#endregion
//#region src/react/contexts.tsx
const [$a0ea147aab9dedc4$var$ClerkInstanceContext, $a0ea147aab9dedc4$var$useClerkInstanceContext] = $a0ea147aab9dedc4$var$createContextAndHook("ClerkInstanceContext");
const [$a0ea147aab9dedc4$var$UserContext, $a0ea147aab9dedc4$var$useUserContext] = $a0ea147aab9dedc4$var$createContextAndHook("UserContext");
const [$a0ea147aab9dedc4$var$ClientContext, $a0ea147aab9dedc4$var$useClientContext] = $a0ea147aab9dedc4$var$createContextAndHook("ClientContext");
const [$a0ea147aab9dedc4$var$SessionContext, $a0ea147aab9dedc4$var$useSessionContext] = $a0ea147aab9dedc4$var$createContextAndHook("SessionContext");
const $a0ea147aab9dedc4$var$OptionsContext = $a0ea147aab9dedc4$require$react.default.createContext({});
const [$a0ea147aab9dedc4$var$CheckoutContext, $a0ea147aab9dedc4$var$useCheckoutContext] = $a0ea147aab9dedc4$var$createContextAndHook("CheckoutContext");
const $a0ea147aab9dedc4$var$__experimental_CheckoutProvider = ({ children: children, ...rest })=>{
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$CheckoutContext.Provider, {
        value: {
            value: rest
        }
    }, children);
};
/**
* @internal
*/ function $a0ea147aab9dedc4$var$useOptionsContext() {
    const context = $a0ea147aab9dedc4$require$react.default.useContext($a0ea147aab9dedc4$var$OptionsContext);
    if (context === void 0) throw new Error("useOptions must be used within an OptionsContext");
    return context;
}
const [$a0ea147aab9dedc4$var$OrganizationContextInternal, $a0ea147aab9dedc4$var$useOrganizationContext] = $a0ea147aab9dedc4$var$createContextAndHook("OrganizationContext");
const $a0ea147aab9dedc4$var$OrganizationProvider = ({ children: children, organization: organization, swrConfig: swrConfig })=>{
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$SWRConfigCompat, {
        swrConfig: swrConfig
    }, /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$OrganizationContextInternal.Provider, {
        value: {
            value: {
                organization: organization
            }
        }
    }, children));
};
/**
* @internal
*/ function $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider(displayNameOrFn) {
    if (!$a0ea147aab9dedc4$require$react.default.useContext($a0ea147aab9dedc4$var$ClerkInstanceContext)) {
        if (typeof displayNameOrFn === "function") {
            displayNameOrFn();
            return;
        }
        throw new Error(`${displayNameOrFn} can only be used within the <ClerkProvider /> component.

Possible fixes:
1. Ensure that the <ClerkProvider /> is correctly wrapping your application where this component is used.
2. Check for multiple versions of the \`@clerk/shared\` package in your project. Use a tool like \`npm ls @clerk/shared\` to identify multiple versions, and update your dependencies to only rely on one.

Learn more: https://clerk.com/docs/components/clerk-provider`.trim());
    }
}
//#endregion
//#region src/react/stable-keys.ts
const $a0ea147aab9dedc4$var$USER_MEMBERSHIPS_KEY = "userMemberships";
const $a0ea147aab9dedc4$var$USER_INVITATIONS_KEY = "userInvitations";
const $a0ea147aab9dedc4$var$USER_SUGGESTIONS_KEY = "userSuggestions";
const $a0ea147aab9dedc4$var$DOMAINS_KEY = "domains";
const $a0ea147aab9dedc4$var$MEMBERSHIP_REQUESTS_KEY = "membershipRequests";
const $a0ea147aab9dedc4$var$MEMBERSHIPS_KEY = "memberships";
const $a0ea147aab9dedc4$var$INVITATIONS_KEY = "invitations";
const $a0ea147aab9dedc4$var$API_KEYS_KEY = "apiKeys";
const $a0ea147aab9dedc4$var$ORGANIZATION_CREATION_DEFAULTS_KEY = "organizationCreationDefaults";
const $a0ea147aab9dedc4$var$PLANS_KEY = "billing-plans";
const $a0ea147aab9dedc4$var$SUBSCRIPTION_KEY = "billing-subscription";
const $a0ea147aab9dedc4$var$PAYMENT_METHODS_KEY = "billing-payment-methods";
const $a0ea147aab9dedc4$var$PAYMENT_ATTEMPTS_KEY = "billing-payment-attempts";
const $a0ea147aab9dedc4$var$STATEMENTS_KEY = "billing-statements";
const $a0ea147aab9dedc4$var$STABLE_KEYS = {
    USER_MEMBERSHIPS_KEY: $a0ea147aab9dedc4$var$USER_MEMBERSHIPS_KEY,
    USER_INVITATIONS_KEY: $a0ea147aab9dedc4$var$USER_INVITATIONS_KEY,
    USER_SUGGESTIONS_KEY: $a0ea147aab9dedc4$var$USER_SUGGESTIONS_KEY,
    DOMAINS_KEY: $a0ea147aab9dedc4$var$DOMAINS_KEY,
    MEMBERSHIP_REQUESTS_KEY: $a0ea147aab9dedc4$var$MEMBERSHIP_REQUESTS_KEY,
    MEMBERSHIPS_KEY: $a0ea147aab9dedc4$var$MEMBERSHIPS_KEY,
    INVITATIONS_KEY: $a0ea147aab9dedc4$var$INVITATIONS_KEY,
    PLANS_KEY: $a0ea147aab9dedc4$var$PLANS_KEY,
    SUBSCRIPTION_KEY: $a0ea147aab9dedc4$var$SUBSCRIPTION_KEY,
    PAYMENT_METHODS_KEY: $a0ea147aab9dedc4$var$PAYMENT_METHODS_KEY,
    PAYMENT_ATTEMPTS_KEY: $a0ea147aab9dedc4$var$PAYMENT_ATTEMPTS_KEY,
    STATEMENTS_KEY: $a0ea147aab9dedc4$var$STATEMENTS_KEY,
    API_KEYS_KEY: $a0ea147aab9dedc4$var$API_KEYS_KEY,
    ORGANIZATION_CREATION_DEFAULTS_KEY: $a0ea147aab9dedc4$var$ORGANIZATION_CREATION_DEFAULTS_KEY
};
/**
* Internal stable keys for queries only used by our UI components.
* These keys are not used by the hooks themselves.
*/ const $a0ea147aab9dedc4$var$PAYMENT_ATTEMPT_KEY = "billing-payment-attempt";
const $a0ea147aab9dedc4$var$BILLING_PLANS_KEY = "billing-plan";
const $a0ea147aab9dedc4$var$BILLING_STATEMENTS_KEY = "billing-statement";
const $a0ea147aab9dedc4$var$INTERNAL_STABLE_KEYS = {
    PAYMENT_ATTEMPT_KEY: $a0ea147aab9dedc4$var$PAYMENT_ATTEMPT_KEY,
    BILLING_PLANS_KEY: $a0ea147aab9dedc4$var$BILLING_PLANS_KEY,
    BILLING_STATEMENTS_KEY: $a0ea147aab9dedc4$var$BILLING_STATEMENTS_KEY
};
//#endregion
//#region src/react/hooks/createCacheKeys.ts
/**
* @internal
*/ function $a0ea147aab9dedc4$var$createCacheKeys(params) {
    return {
        queryKey: [
            params.stablePrefix,
            params.authenticated,
            params.tracked,
            params.untracked
        ],
        invalidationKey: [
            params.stablePrefix,
            params.authenticated,
            params.tracked
        ],
        stableKey: params.stablePrefix,
        authenticated: params.authenticated
    };
}
/**
* @internal
*/ function $a0ea147aab9dedc4$var$toSWRQuery(keys) {
    const { queryKey: queryKey } = keys;
    return {
        type: queryKey[0],
        ...queryKey[2],
        ...queryKey[3].args
    };
}
//#endregion
//#region src/react/hooks/usePagesOrInfinite.shared.ts
/**
* A hook that safely merges user-provided pagination options with default values.
* It caches initial pagination values (page and size) until component unmount to prevent unwanted rerenders.
*
* @internal
*
* @example
* ```typescript
* // Example 1: With user-provided options
* const userOptions = { initialPage: 2, pageSize: 20, infinite: true };
* const defaults = { initialPage: 1, pageSize: 10, infinite: false };
* useWithSafeValues(userOptions, defaults);
* // Returns { initialPage: 2, pageSize: 20, infinite: true }
*
* // Example 2: With boolean true (use defaults)
* const params = true;
* const defaults = { initialPage: 1, pageSize: 10, infinite: false };
* useWithSafeValues(params, defaults);
* // Returns { initialPage: 1, pageSize: 10, infinite: false }
*
* // Example 3: With undefined options (fallback to defaults)
* const params = undefined;
* const defaults = { initialPage: 1, pageSize: 10, infinite: false };
* useWithSafeValues(params, defaults);
* // Returns { initialPage: 1, pageSize: 10, infinite: false }
* ```
*/ const $a0ea147aab9dedc4$var$useWithSafeValues = (params, defaultValues)=>{
    const shouldUseDefaults = typeof params === "boolean" && params;
    const initialPageRef = (0, $a0ea147aab9dedc4$require$react.useRef)(shouldUseDefaults ? defaultValues.initialPage : params?.initialPage ?? defaultValues.initialPage);
    const pageSizeRef = (0, $a0ea147aab9dedc4$require$react.useRef)(shouldUseDefaults ? defaultValues.pageSize : params?.pageSize ?? defaultValues.pageSize);
    const newObj = {};
    for (const key of Object.keys(defaultValues))newObj[key] = shouldUseDefaults ? defaultValues[key] : params?.[key] ?? defaultValues[key];
    return {
        ...newObj,
        initialPage: initialPageRef.current,
        pageSize: pageSizeRef.current
    };
};
/**
* Returns an object containing only the keys from the first object that are not present in the second object.
* Useful for extracting unique parameters that should be passed to a request while excluding common cache keys.
*
* @internal
*
* @example
* ```typescript
* // Example 1: Basic usage
* const obj1 = { name: 'John', age: 30, city: 'NY' };
* const obj2 = { name: 'John', age: 30 };
* getDifferentKeys(obj1, obj2); // Returns { city: 'NY' }
*
* // Example 2: With cache keys
* const requestParams = { page: 1, limit: 10, userId: '123' };
* const cacheKeys = { userId: '123' };
* getDifferentKeys(requestParams, cacheKeys); // Returns { page: 1, limit: 10 }
* ```
*/ function $a0ea147aab9dedc4$var$getDifferentKeys(obj1, obj2) {
    const keysSet = new Set(Object.keys(obj2));
    const differentKeysObject = {};
    for (const key1 of Object.keys(obj1))if (!keysSet.has(key1)) differentKeysObject[key1] = obj1[key1];
    return differentKeysObject;
}
//#endregion
//#region src/react/hooks/usePreviousValue.ts
/**
* A hook that retains the previous value of a primitive type.
* It uses a ref to prevent causing unnecessary re-renders.
*
* @internal
*
* @example
* ```
* Render 1: value = 'A' → returns null
* Render 2: value = 'B' → returns 'A'
* Render 3: value = 'B' → returns 'A'
* Render 4: value = 'B' → returns 'A'
* Render 5: value = 'C' → returns 'B'
* ```
*/ function $a0ea147aab9dedc4$var$usePreviousValue(value) {
    const currentRef = (0, $a0ea147aab9dedc4$require$react.useRef)(value);
    const previousRef = (0, $a0ea147aab9dedc4$require$react.useRef)(null);
    if (currentRef.current !== value) {
        previousRef.current = currentRef.current;
        currentRef.current = value;
    }
    return previousRef.current;
}
//#endregion
//#region src/react/hooks/usePagesOrInfinite.swr.tsx
const $a0ea147aab9dedc4$var$cachingSWROptions = {
    dedupingInterval: 60000,
    focusThrottleInterval: 120000
};
const $a0ea147aab9dedc4$var$cachingSWRInfiniteOptions = {
    ...$a0ea147aab9dedc4$var$cachingSWROptions,
    revalidateFirstPage: false
};
/**
* A flexible pagination hook that supports both traditional pagination and infinite loading.
* It provides a unified API for handling paginated data fetching, with built-in caching through SWR.
* The hook can operate in two modes:
* - Traditional pagination: Fetches one page at a time with page navigation
* - Infinite loading: Accumulates data as more pages are loaded.
*
* Features:
* - Cache management with SWR
* - Loading and error states
* - Page navigation helpers
* - Data revalidation and updates
* - Support for keeping previous data while loading.
*
* @internal
*/ const $a0ea147aab9dedc4$var$usePagesOrInfinite = (params)=>{
    const { fetcher: fetcher, config: config, keys: keys } = params;
    const [paginatedPage, setPaginatedPage] = (0, $a0ea147aab9dedc4$require$react.useState)(config.initialPage ?? 1);
    const initialPageRef = (0, $a0ea147aab9dedc4$require$react.useRef)(config.initialPage ?? 1);
    const pageSizeRef = (0, $a0ea147aab9dedc4$require$react.useRef)(config.pageSize ?? 10);
    const enabled = config.enabled ?? true;
    const cacheMode = config.__experimental_mode === "cache";
    const triggerInfinite = config.infinite ?? false;
    const keepPreviousData = config.keepPreviousData ?? false;
    const isSignedIn = config.isSignedIn;
    const pagesCacheKey = {
        ...$a0ea147aab9dedc4$var$toSWRQuery(keys),
        initialPage: paginatedPage,
        pageSize: pageSizeRef.current
    };
    const previousIsSignedIn = $a0ea147aab9dedc4$var$usePreviousValue(isSignedIn);
    const shouldFetch = !triggerInfinite && enabled && (!cacheMode ? !!fetcher : true);
    const { data: swrData, isValidating: swrIsValidating, isLoading: swrIsLoading, error: swrError, mutate: swrMutate } = (0, $a0ea147aab9dedc4$require$swr.default)(typeof isSignedIn === "boolean" ? previousIsSignedIn === true && isSignedIn === false ? pagesCacheKey : isSignedIn ? shouldFetch ? pagesCacheKey : null : null : shouldFetch ? pagesCacheKey : null, !cacheMode && !!fetcher ? (cacheKeyParams)=>{
        if (isSignedIn === false || shouldFetch === false) return null;
        return fetcher($a0ea147aab9dedc4$var$getDifferentKeys(cacheKeyParams, {
            type: keys.queryKey[0],
            ...keys.queryKey[2]
        }));
    } : null, {
        keepPreviousData: keepPreviousData,
        ...$a0ea147aab9dedc4$var$cachingSWROptions
    });
    const { data: swrInfiniteData, isLoading: swrInfiniteIsLoading, isValidating: swrInfiniteIsValidating, error: swrInfiniteError, size: size, setSize: setSize, mutate: swrInfiniteMutate } = (0, $a0ea147aab9dedc4$require$swr_infinite.default)((pageIndex)=>{
        if (!triggerInfinite || !enabled || isSignedIn === false) return null;
        return {
            ...$a0ea147aab9dedc4$var$toSWRQuery(keys),
            initialPage: initialPageRef.current + pageIndex,
            pageSize: pageSizeRef.current
        };
    }, (cacheKeyParams)=>{
        const requestParams = $a0ea147aab9dedc4$var$getDifferentKeys(cacheKeyParams, {
            type: keys.queryKey[0],
            ...keys.queryKey[2]
        });
        return fetcher?.(requestParams);
    }, $a0ea147aab9dedc4$var$cachingSWRInfiniteOptions);
    const page = (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        if (triggerInfinite) return size;
        return paginatedPage;
    }, [
        triggerInfinite,
        size,
        paginatedPage
    ]);
    const fetchPage = (0, $a0ea147aab9dedc4$require$react.useCallback)((numberOrgFn)=>{
        if (triggerInfinite) {
            setSize(numberOrgFn);
            return;
        }
        return setPaginatedPage(numberOrgFn);
    }, [
        setSize,
        triggerInfinite
    ]);
    const data = (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        if (triggerInfinite) return swrInfiniteData?.map((a)=>a?.data).flat() ?? [];
        return swrData?.data ?? [];
    }, [
        triggerInfinite,
        swrData,
        swrInfiniteData
    ]);
    const count = (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        if (triggerInfinite) return swrInfiniteData?.[swrInfiniteData?.length - 1]?.total_count || 0;
        return swrData?.total_count ?? 0;
    }, [
        triggerInfinite,
        swrData,
        swrInfiniteData
    ]);
    const isLoading = triggerInfinite ? swrInfiniteIsLoading : swrIsLoading;
    const isFetching = triggerInfinite ? swrInfiniteIsValidating : swrIsValidating;
    const error = (triggerInfinite ? swrInfiniteError : swrError) ?? null;
    const isError = !!error;
    const fetchNext = (0, $a0ea147aab9dedc4$require$react.useCallback)(()=>{
        fetchPage((n)=>Math.max(0, n + 1));
    }, [
        fetchPage
    ]);
    const fetchPrevious = (0, $a0ea147aab9dedc4$require$react.useCallback)(()=>{
        fetchPage((n)=>Math.max(0, n - 1));
    }, [
        fetchPage
    ]);
    const offsetCount = (initialPageRef.current - 1) * pageSizeRef.current;
    return {
        data: data,
        count: count,
        error: error,
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        page: page,
        pageCount: Math.ceil((count - offsetCount) / pageSizeRef.current),
        fetchPage: fetchPage,
        fetchNext: fetchNext,
        fetchPrevious: fetchPrevious,
        hasNextPage: count - offsetCount * pageSizeRef.current > page * pageSizeRef.current,
        hasPreviousPage: (page - 1) * pageSizeRef.current > offsetCount * pageSizeRef.current,
        revalidate: triggerInfinite ? ()=>swrInfiniteMutate() : ()=>swrMutate(),
        setData: triggerInfinite ? (value)=>swrInfiniteMutate(value, {
                revalidate: false
            }) : (value)=>swrMutate(value, {
                revalidate: false
            })
    };
};
//#endregion
//#region src/react/hooks/useAPIKeys.swr.tsx
/**
* @internal
*
* The `useAPIKeys()` hook provides access to paginated API keys for the current user or organization.
*
* @example
* ### Basic usage with default pagination
*
* ```tsx
* const { data, isLoading, page, pageCount, fetchNext, fetchPrevious } = useAPIKeys({
*   subject: 'user_123',
*   pageSize: 10,
*   initialPage: 1,
* });
* ```
*
* @example
* ### With search query
*
* ```tsx
* const [searchValue, setSearchValue] = useState('');
* const debouncedSearch = useDebounce(searchValue, 500);
*
* const { data, isLoading } = useAPIKeys({
*   subject: 'user_123',
*   query: debouncedSearch.trim(),
*   pageSize: 10,
* });
* ```
*
* @example
* ### Infinite scroll
*
* ```tsx
* const { data, isLoading, fetchNext, hasNextPage } = useAPIKeys({
*   subject: 'user_123',
*   infinite: true,
* });
* ```
*/ function $a0ea147aab9dedc4$var$useAPIKeys(params) {
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider("useAPIKeys");
    const safeValues = $a0ea147aab9dedc4$var$useWithSafeValues(params, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false,
        subject: "",
        query: "",
        enabled: true
    });
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled("useAPIKeys"));
    const hookParams = {
        initialPage: safeValues.initialPage,
        pageSize: safeValues.pageSize,
        ...safeValues.subject ? {
            subject: safeValues.subject
        } : {},
        ...safeValues.query ? {
            query: safeValues.query
        } : {}
    };
    const isEnabled = (safeValues.enabled ?? true) && clerk.loaded;
    const result = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: clerk.apiKeys?.getAll ? (params$1)=>clerk.apiKeys.getAll({
                ...params$1,
                subject: safeValues.subject
            }) : void 0,
        config: {
            keepPreviousData: safeValues.keepPreviousData,
            infinite: safeValues.infinite,
            enabled: isEnabled,
            isSignedIn: Boolean(clerk.user),
            initialPage: safeValues.initialPage,
            pageSize: safeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.API_KEYS_KEY,
            authenticated: Boolean(clerk.user),
            tracked: {
                subject: safeValues.subject
            },
            untracked: {
                args: hookParams
            }
        })
    });
    const { mutate: mutate } = (0, $a0ea147aab9dedc4$require$swr.useSWRConfig)();
    const invalidateAll = (0, $a0ea147aab9dedc4$require$react.useCallback)(()=>{
        return mutate((key)=>{
            if (!key || typeof key !== "object") return false;
            return "type" in key && key.type === "apiKeys" && "subject" in key && key.subject === safeValues.subject;
        });
    }, [
        mutate,
        safeValues.subject
    ]);
    return {
        ...result,
        revalidate: invalidateAll
    };
}
//#endregion
//#region src/react/hooks/useClerk.ts
/**
* > [!WARNING]
* > This hook should only be used for advanced use cases, such as building a completely custom OAuth flow or as an escape hatch to access to the `Clerk` object.
*
* The `useClerk()` hook provides access to the [`Clerk`](https://clerk.com/docs/reference/javascript/clerk) object, allowing you to build alternatives to any Clerk Component.
*
* @function
*
* @returns The `useClerk()` hook returns the `Clerk` object, which includes all the methods and properties listed in the [`Clerk` reference](https://clerk.com/docs/reference/javascript/clerk).
*
* @example
*
* The following example uses the `useClerk()` hook to access the `clerk` object. The `clerk` object is used to call the [`openSignIn()`](https://clerk.com/docs/reference/javascript/clerk#sign-in) method to open the sign-in modal.
*
* <Tabs items='React,Next.js'>
* <Tab>
*
* ```tsx {{ filename: 'src/Home.tsx' }}
* import { useClerk } from '@clerk/clerk-react'
*
* export default function Home() {
*   const clerk = useClerk()
*
*   return <button onClick={() => clerk.openSignIn({})}>Sign in</button>
* }
* ```
*
* </Tab>
* <Tab>
*
* {@include ../../../docs/use-clerk.md#nextjs-01}
*
* </Tab>
* </Tabs>
*/ const $a0ea147aab9dedc4$var$useClerk = ()=>{
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider("useClerk");
    return $a0ea147aab9dedc4$var$useClerkInstanceContext();
};
//#endregion
//#region src/react/hooks/useAttemptToEnableOrganizations.ts
/**
* Attempts to enable the organizations environment setting for a given caller
*
* @internal
*/ function $a0ea147aab9dedc4$var$useAttemptToEnableOrganizations(caller) {
    const clerk = $a0ea147aab9dedc4$var$useClerk();
    const hasAttempted = (0, $a0ea147aab9dedc4$require$react.useRef)(false);
    (0, $a0ea147aab9dedc4$require$react.useEffect)(()=>{
        if (hasAttempted.current) return;
        hasAttempted.current = true;
        clerk.__internal_attemptToEnableEnvironmentSetting?.({
            for: "organizations",
            caller: caller
        });
    }, [
        clerk,
        caller
    ]);
}
//#endregion
//#region src/react/hooks/useOrganization.tsx
const $a0ea147aab9dedc4$var$undefinedPaginatedResource$1 = {
    data: void 0,
    count: void 0,
    error: void 0,
    isLoading: false,
    isFetching: false,
    isError: false,
    page: void 0,
    pageCount: void 0,
    fetchPage: void 0,
    fetchNext: void 0,
    fetchPrevious: void 0,
    hasNextPage: false,
    hasPreviousPage: false,
    revalidate: void 0,
    setData: void 0
};
/**
* The `useOrganization()` hook retrieves attributes of the currently Active Organization.
*
* @example
* ### Expand and paginate attributes
*
* To keep network usage to a minimum, developers are required to opt-in by specifying which resource they need to fetch and paginate through. By default, the `memberships`, `invitations`, `membershipRequests`, and `domains` attributes are not populated. You must pass `true` or an object with the desired properties to fetch and paginate the data.
*
* ```tsx
* // invitations.data will never be populated.
* const { invitations } = useOrganization()
*
* // Use default values to fetch invitations, such as initialPage = 1 and pageSize = 10
* const { invitations } = useOrganization({
*   invitations: true,
* })
*
* // Pass your own values to fetch invitations
* const { invitations } = useOrganization({
*   invitations: {
*     pageSize: 20,
*     initialPage: 2, // skips the first page
*   },
* })
*
* // Aggregate pages in order to render an infinite list
* const { invitations } = useOrganization({
*   invitations: {
*     infinite: true,
*   },
* })
* ```
*
* @example
* ### Infinite pagination
*
* The following example demonstrates how to use the `infinite` property to fetch and append new data to the existing list. The `memberships` attribute will be populated with the first page of the Organization's memberships. When the "Load more" button is clicked, the `fetchNext` helper function will be called to append the next page of memberships to the list.
*
* ```tsx
* import { useOrganization } from '@clerk/clerk-react'
*
* export default function MemberList() {
*   const { memberships } = useOrganization({
*     memberships: {
*       infinite: true, // Append new data to the existing list
*       keepPreviousData: true, // Persist the cached data until the new data has been fetched
*     },
*   })
*
*   if (!memberships) {
*     // Handle loading state
*     return null
*   }
*
*   return (
*     <div>
*       <h2>Organization members</h2>
*       <ul>
*         {memberships.data?.map((membership) => (
*           <li key={membership.id}>
*             {membership.publicUserData.firstName} {membership.publicUserData.lastName} <
*             {membership.publicUserData.identifier}> :: {membership.role}
*           </li>
*         ))}
*       </ul>
*
*       <button
*         disabled={!memberships.hasNextPage} // Disable the button if there are no more available pages to be fetched
*         onClick={memberships.fetchNext}
*       >
*         Load more
*       </button>
*     </div>
*   )
* }
* ```
*
* @example
* ### Simple pagination
*
* The following example demonstrates how to use the `fetchPrevious` and `fetchNext` helper functions to paginate through the data. The `memberships` attribute will be populated with the first page of the Organization's memberships. When the "Previous page" or "Next page" button is clicked, the `fetchPrevious` or `fetchNext` helper function will be called to fetch the previous or next page of memberships.
*
* Notice the difference between this example's pagination and the infinite pagination example above.
*
* ```tsx
* import { useOrganization } from '@clerk/clerk-react'
*
* export default function MemberList() {
*   const { memberships } = useOrganization({
*     memberships: {
*       keepPreviousData: true, // Persist the cached data until the new data has been fetched
*     },
*   })
*
*   if (!memberships) {
*     // Handle loading state
*     return null
*   }
*
*   return (
*     <div>
*       <h2>Organization members</h2>
*       <ul>
*         {memberships.data?.map((membership) => (
*           <li key={membership.id}>
*             {membership.publicUserData.firstName} {membership.publicUserData.lastName} <
*             {membership.publicUserData.identifier}> :: {membership.role}
*           </li>
*         ))}
*       </ul>
*
*       <button disabled={!memberships.hasPreviousPage} onClick={memberships.fetchPrevious}>
*         Previous page
*       </button>
*
*       <button disabled={!memberships.hasNextPage} onClick={memberships.fetchNext}>
*         Next page
*       </button>
*     </div>
*   )
* }
* ```
*/ function $a0ea147aab9dedc4$var$useOrganization(params) {
    const { domains: domainListParams, membershipRequests: membershipRequestsListParams, memberships: membersListParams, invitations: invitationsListParams } = params || {};
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider("useOrganization");
    $a0ea147aab9dedc4$var$useAttemptToEnableOrganizations("useOrganization");
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const session = $a0ea147aab9dedc4$var$useSessionContext();
    const domainSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(domainListParams, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false,
        enrollmentMode: void 0
    });
    const membershipRequestSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(membershipRequestsListParams, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const membersSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(membersListParams, {
        initialPage: 1,
        pageSize: 10,
        role: void 0,
        keepPreviousData: false,
        infinite: false,
        query: void 0
    });
    const invitationsSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(invitationsListParams, {
        initialPage: 1,
        pageSize: 10,
        status: [
            "pending"
        ],
        keepPreviousData: false,
        infinite: false
    });
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled("useOrganization"));
    const domainParams = typeof domainListParams === "undefined" ? void 0 : {
        initialPage: domainSafeValues.initialPage,
        pageSize: domainSafeValues.pageSize,
        enrollmentMode: domainSafeValues.enrollmentMode
    };
    const membershipRequestParams = typeof membershipRequestsListParams === "undefined" ? void 0 : {
        initialPage: membershipRequestSafeValues.initialPage,
        pageSize: membershipRequestSafeValues.pageSize,
        status: membershipRequestSafeValues.status
    };
    const membersParams = typeof membersListParams === "undefined" ? void 0 : {
        initialPage: membersSafeValues.initialPage,
        pageSize: membersSafeValues.pageSize,
        role: membersSafeValues.role,
        query: membersSafeValues.query
    };
    const invitationsParams = typeof invitationsListParams === "undefined" ? void 0 : {
        initialPage: invitationsSafeValues.initialPage,
        pageSize: invitationsSafeValues.pageSize,
        status: invitationsSafeValues.status
    };
    const domains = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: organization?.getDomains,
        config: {
            keepPreviousData: domainSafeValues.keepPreviousData,
            infinite: domainSafeValues.infinite,
            enabled: !!domainParams,
            isSignedIn: Boolean(organization),
            initialPage: domainSafeValues.initialPage,
            pageSize: domainSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.DOMAINS_KEY,
            authenticated: Boolean(organization),
            tracked: {
                organizationId: organization?.id
            },
            untracked: {
                args: domainParams
            }
        })
    });
    const membershipRequests = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: organization?.getMembershipRequests,
        config: {
            keepPreviousData: membershipRequestSafeValues.keepPreviousData,
            infinite: membershipRequestSafeValues.infinite,
            enabled: !!membershipRequestParams,
            isSignedIn: Boolean(organization),
            initialPage: membershipRequestSafeValues.initialPage,
            pageSize: membershipRequestSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.MEMBERSHIP_REQUESTS_KEY,
            authenticated: Boolean(organization),
            tracked: {
                organizationId: organization?.id
            },
            untracked: {
                args: membershipRequestParams
            }
        })
    });
    const memberships = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: organization?.getMemberships,
        config: {
            keepPreviousData: membersSafeValues.keepPreviousData,
            infinite: membersSafeValues.infinite,
            enabled: !!membersParams,
            isSignedIn: Boolean(organization),
            initialPage: membersSafeValues.initialPage,
            pageSize: membersSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.MEMBERSHIPS_KEY,
            authenticated: Boolean(organization),
            tracked: {
                organizationId: organization?.id
            },
            untracked: {
                args: membersParams
            }
        })
    });
    const invitations = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: organization?.getInvitations,
        config: {
            keepPreviousData: invitationsSafeValues.keepPreviousData,
            infinite: invitationsSafeValues.infinite,
            enabled: !!invitationsParams,
            isSignedIn: Boolean(organization),
            initialPage: invitationsSafeValues.initialPage,
            pageSize: invitationsSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.INVITATIONS_KEY,
            authenticated: Boolean(organization),
            tracked: {
                organizationId: organization?.id
            },
            untracked: {
                args: invitationsParams
            }
        })
    });
    if (organization === void 0) return {
        isLoaded: false,
        organization: void 0,
        membership: void 0,
        domains: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1,
        membershipRequests: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1,
        memberships: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1,
        invitations: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1
    };
    if (organization === null) return {
        isLoaded: true,
        organization: null,
        membership: null,
        domains: null,
        membershipRequests: null,
        memberships: null,
        invitations: null
    };
    /** In SSR context we include only the organization object when loadOrg is set to true. */ if (!clerk.loaded && organization) return {
        isLoaded: true,
        organization: organization,
        membership: void 0,
        domains: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1,
        membershipRequests: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1,
        memberships: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1,
        invitations: $a0ea147aab9dedc4$var$undefinedPaginatedResource$1
    };
    return {
        isLoaded: clerk.loaded,
        organization: organization,
        membership: $01f5f7558c5f2b61$exports.getCurrentOrganizationMembership(session.user.organizationMemberships, organization.id),
        domains: domains,
        membershipRequests: membershipRequests,
        memberships: memberships,
        invitations: invitations
    };
}
//#endregion
//#region src/react/hooks/useOrganizationCreationDefaults.shared.ts
function $a0ea147aab9dedc4$var$useOrganizationCreationDefaultsCacheKeys(params) {
    const { userId: userId } = params;
    return (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        return $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.ORGANIZATION_CREATION_DEFAULTS_KEY,
            authenticated: Boolean(userId),
            tracked: {
                userId: userId ?? null
            },
            untracked: {
                args: {}
            }
        });
    }, [
        userId
    ]);
}
//#endregion
//#region src/react/hooks/useOrganizationCreationDefaults.swr.tsx
/**
* The `useOrganizationCreationDefaults()` hook retrieves the organization creation defaults for the current user.
*
* @example
* ### Basic usage
*
* ```tsx
* import { useOrganizationCreationDefaults } from '@clerk/clerk-react'
*
* export default function CreateOrganizationForm() {
*   const { data, isLoading } = useOrganizationCreationDefaults()
*
*   if (isLoading) return <div>Loading...</div>
*
*   return (
*     <form>
*       <input defaultValue={data?.form.name} placeholder="Organization name" />
*       <input defaultValue={data?.form.slug} placeholder="Slug" />
*       <button type="submit">Create</button>
*     </form>
*   )
* }
* ```
*/ function $a0ea147aab9dedc4$var$useOrganizationCreationDefaultsHook(params = {}) {
    const { keepPreviousData: keepPreviousData = true, enabled: enabled = true } = params;
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const user = $a0ea147aab9dedc4$var$useUserContext();
    const featureEnabled = clerk.__unstable__environment?.organizationSettings?.organizationCreationDefaults?.enabled ?? false;
    clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled("useOrganizationCreationDefaults"));
    const { queryKey: queryKey } = $a0ea147aab9dedc4$var$useOrganizationCreationDefaultsCacheKeys({
        userId: user?.id ?? null
    });
    const swr$1 = (0, $a0ea147aab9dedc4$require$swr.default)(Boolean(user) && enabled && featureEnabled && clerk.loaded ? queryKey : null, ()=>{
        if (!user) throw new Error("User is required to fetch organization creation defaults");
        return user.getOrganizationCreationDefaults();
    }, {
        dedupingInterval: 60000,
        keepPreviousData: keepPreviousData
    });
    return {
        data: swr$1.data,
        error: swr$1.error ?? null,
        isLoading: swr$1.isLoading,
        isFetching: swr$1.isValidating
    };
}
//#endregion
//#region src/react/hooks/useOrganizationList.tsx
const $a0ea147aab9dedc4$var$undefinedPaginatedResource = {
    data: void 0,
    count: void 0,
    error: void 0,
    isLoading: false,
    isFetching: false,
    isError: false,
    page: void 0,
    pageCount: void 0,
    fetchPage: void 0,
    fetchNext: void 0,
    fetchPrevious: void 0,
    hasNextPage: false,
    hasPreviousPage: false,
    revalidate: void 0,
    setData: void 0
};
/**
* The `useOrganizationList()` hook provides access to the current user's organization memberships, invitations, and suggestions. It also includes methods for creating new organizations and managing the active organization.
*
* @example
* ### Expanding and paginating attributes
*
* To keep network usage to a minimum, developers are required to opt-in by specifying which resource they need to fetch and paginate through. So by default, the `userMemberships`, `userInvitations`, and `userSuggestions` attributes are not populated. You must pass true or an object with the desired properties to fetch and paginate the data.
*
* ```tsx
* // userMemberships.data will never be populated
* const { userMemberships } = useOrganizationList()
*
* // Use default values to fetch userMemberships, such as initialPage = 1 and pageSize = 10
* const { userMemberships } = useOrganizationList({
*   userMemberships: true,
* })
*
* // Pass your own values to fetch userMemberships
* const { userMemberships } = useOrganizationList({
*   userMemberships: {
*     pageSize: 20,
*     initialPage: 2, // skips the first page
*   },
* })
*
* // Aggregate pages in order to render an infinite list
* const { userMemberships } = useOrganizationList({
*   userMemberships: {
*     infinite: true,
*   },
* })
* ```
*
* @example
* ### Infinite pagination
*
* The following example demonstrates how to use the `infinite` property to fetch and append new data to the existing list. The `userMemberships` attribute will be populated with the first page of the user's Organization memberships. When the "Load more" button is clicked, the `fetchNext` helper function will be called to append the next page of memberships to the list.
*
* ```tsx {{ filename: 'src/components/JoinedOrganizations.tsx' }}
* import { useOrganizationList } from '@clerk/clerk-react'
* import React from 'react'
*
* const JoinedOrganizations = () => {
*   const { isLoaded, setActive, userMemberships } = useOrganizationList({
*     userMemberships: {
*       infinite: true,
*     },
*   })
*
*   if (!isLoaded) {
*     return <>Loading</>
*   }
*
*   return (
*     <>
*       <ul>
*         {userMemberships.data?.map((mem) => (
*           <li key={mem.id}>
*             <span>{mem.organization.name}</span>
*             <button onClick={() => setActive({ organization: mem.organization.id })}>Select</button>
*           </li>
*         ))}
*       </ul>
*
*       <button disabled={!userMemberships.hasNextPage} onClick={() => userMemberships.fetchNext()}>
*         Load more
*       </button>
*     </>
*   )
* }
*
* export default JoinedOrganizations
* ```
*
* @example
* ### Simple pagination
*
* The following example demonstrates how to use the `fetchPrevious` and `fetchNext` helper functions to paginate through the data. The `userInvitations` attribute will be populated with the first page of invitations. When the "Previous page" or "Next page" button is clicked, the `fetchPrevious` or `fetchNext` helper function will be called to fetch the previous or next page of invitations.
*
* Notice the difference between this example's pagination and the infinite pagination example above.
*
* ```tsx {{ filename: 'src/components/UserInvitationsTable.tsx' }}
* import { useOrganizationList } from '@clerk/clerk-react'
* import React from 'react'
*
* const UserInvitationsTable = () => {
*   const { isLoaded, userInvitations } = useOrganizationList({
*     userInvitations: {
*       infinite: true,
*       keepPreviousData: true,
*     },
*   })
*
*   if (!isLoaded || userInvitations.isLoading) {
*     return <>Loading</>
*   }
*
*   return (
*     <>
*       <table>
*         <thead>
*           <tr>
*             <th>Email</th>
*             <th>Org name</th>
*           </tr>
*         </thead>
*
*         <tbody>
*           {userInvitations.data?.map((inv) => (
*             <tr key={inv.id}>
*               <th>{inv.emailAddress}</th>
*               <th>{inv.publicOrganizationData.name}</th>
*             </tr>
*           ))}
*         </tbody>
*       </table>
*
*       <button disabled={!userInvitations.hasPreviousPage} onClick={userInvitations.fetchPrevious}>
*         Prev
*       </button>
*       <button disabled={!userInvitations.hasNextPage} onClick={userInvitations.fetchNext}>
*         Next
*       </button>
*     </>
*   )
* }
*
* export default UserInvitationsTable
* ```
*/ function $a0ea147aab9dedc4$var$useOrganizationList(params) {
    const { userMemberships: userMemberships, userInvitations: userInvitations, userSuggestions: userSuggestions } = params || {};
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider("useOrganizationList");
    $a0ea147aab9dedc4$var$useAttemptToEnableOrganizations("useOrganizationList");
    const userMembershipsSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(userMemberships, {
        initialPage: 1,
        pageSize: 10,
        keepPreviousData: false,
        infinite: false
    });
    const userInvitationsSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(userInvitations, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const userSuggestionsSafeValues = $a0ea147aab9dedc4$var$useWithSafeValues(userSuggestions, {
        initialPage: 1,
        pageSize: 10,
        status: "pending",
        keepPreviousData: false,
        infinite: false
    });
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const user = $a0ea147aab9dedc4$var$useUserContext();
    clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled("useOrganizationList"));
    const userMembershipsParams = typeof userMemberships === "undefined" ? void 0 : {
        initialPage: userMembershipsSafeValues.initialPage,
        pageSize: userMembershipsSafeValues.pageSize
    };
    const userInvitationsParams = typeof userInvitations === "undefined" ? void 0 : {
        initialPage: userInvitationsSafeValues.initialPage,
        pageSize: userInvitationsSafeValues.pageSize,
        status: userInvitationsSafeValues.status
    };
    const userSuggestionsParams = typeof userSuggestions === "undefined" ? void 0 : {
        initialPage: userSuggestionsSafeValues.initialPage,
        pageSize: userSuggestionsSafeValues.pageSize,
        status: userSuggestionsSafeValues.status
    };
    const isClerkLoaded = !!(clerk.loaded && user);
    const memberships = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: user?.getOrganizationMemberships,
        config: {
            keepPreviousData: userMembershipsSafeValues.keepPreviousData,
            infinite: userMembershipsSafeValues.infinite,
            enabled: !!userMembershipsParams,
            isSignedIn: Boolean(user),
            initialPage: userMembershipsSafeValues.initialPage,
            pageSize: userMembershipsSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.USER_MEMBERSHIPS_KEY,
            authenticated: Boolean(user),
            tracked: {
                userId: user?.id
            },
            untracked: {
                args: userMembershipsParams
            }
        })
    });
    const invitations = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: user?.getOrganizationInvitations,
        config: {
            keepPreviousData: userInvitationsSafeValues.keepPreviousData,
            infinite: userInvitationsSafeValues.infinite,
            enabled: !!userInvitationsParams,
            isSignedIn: Boolean(user),
            initialPage: userInvitationsSafeValues.initialPage,
            pageSize: userInvitationsSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.USER_INVITATIONS_KEY,
            authenticated: Boolean(user),
            tracked: {
                userId: user?.id
            },
            untracked: {
                args: userInvitationsParams
            }
        })
    });
    const suggestions = $a0ea147aab9dedc4$var$usePagesOrInfinite({
        fetcher: user?.getOrganizationSuggestions,
        config: {
            keepPreviousData: userSuggestionsSafeValues.keepPreviousData,
            infinite: userSuggestionsSafeValues.infinite,
            enabled: !!userSuggestionsParams,
            isSignedIn: Boolean(user),
            initialPage: userSuggestionsSafeValues.initialPage,
            pageSize: userSuggestionsSafeValues.pageSize
        },
        keys: $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.USER_SUGGESTIONS_KEY,
            authenticated: Boolean(user),
            tracked: {
                userId: user?.id
            },
            untracked: {
                args: userSuggestionsParams
            }
        })
    });
    if (!isClerkLoaded) return {
        isLoaded: false,
        createOrganization: void 0,
        setActive: void 0,
        userMemberships: $a0ea147aab9dedc4$var$undefinedPaginatedResource,
        userInvitations: $a0ea147aab9dedc4$var$undefinedPaginatedResource,
        userSuggestions: $a0ea147aab9dedc4$var$undefinedPaginatedResource
    };
    return {
        isLoaded: isClerkLoaded,
        setActive: clerk.setActive,
        createOrganization: clerk.createOrganization,
        userMemberships: memberships,
        userInvitations: invitations,
        userSuggestions: suggestions
    };
}
//#endregion
//#region src/react/hooks/useSafeLayoutEffect.tsx
/**
* @internal
*/ const $a0ea147aab9dedc4$var$useSafeLayoutEffect = typeof window !== "undefined" ? $a0ea147aab9dedc4$require$react.default.useLayoutEffect : $a0ea147aab9dedc4$require$react.default.useEffect;
//#endregion
//#region src/react/hooks/useSession.ts
const $a0ea147aab9dedc4$var$hookName$3 = `useSession`;
/**
* The `useSession()` hook provides access to the current user's [`Session`](https://clerk.com/docs/reference/javascript/session) object, as well as helpers for setting the active session.
*
* @unionReturnHeadings
* ["Initialization", "Signed out", "Signed in"]
*
* @function
*
* @param [options] - An object containing options for the `useSession()` hook.
* @example
* ### Access the `Session` object
*
* The following example uses the `useSession()` hook to access the `Session` object, which has the `lastActiveAt` property. The `lastActiveAt` property is a `Date` object used to show the time the session was last active.
*
* <Tabs items='React,Next.js'>
* <Tab>
*
* ```tsx {{ filename: 'src/Home.tsx' }}
* import { useSession } from '@clerk/clerk-react'
*
* export default function Home() {
*   const { isLoaded, session, isSignedIn } = useSession()
*
*   if (!isLoaded) {
*     // Handle loading state
*     return null
*   }
*   if (!isSignedIn) {
*     // Handle signed out state
*     return null
*   }
*
*   return (
*     <div>
*       <p>This session has been active since {session.lastActiveAt.toLocaleString()}</p>
*     </div>
*   )
* }
* ```
*
* </Tab>
* <Tab>
*
* {@include ../../../docs/use-session.md#nextjs-01}
*
* </Tab>
* </Tabs>
*/ const $a0ea147aab9dedc4$var$useSession = ()=>{
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider($a0ea147aab9dedc4$var$hookName$3);
    const session = $a0ea147aab9dedc4$var$useSessionContext();
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled($a0ea147aab9dedc4$var$hookName$3));
    if (session === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        session: void 0
    };
    if (session === null) return {
        isLoaded: true,
        isSignedIn: false,
        session: null
    };
    return {
        isLoaded: true,
        isSignedIn: clerk.isSignedIn,
        session: session
    };
};
//#endregion
//#region src/react/hooks/useSessionList.ts
const $a0ea147aab9dedc4$var$hookName$2 = "useSessionList";
/**
* The `useSessionList()` hook returns an array of [`Session`](https://clerk.com/docs/reference/javascript/session) objects that have been registered on the client device.
*
* @unionReturnHeadings
* ["Initialization", "Loaded"]
*
* @function
*
* @example
* ### Get a list of sessions
*
* The following example uses `useSessionList()` to get a list of sessions that have been registered on the client device. The `sessions` property is used to show the number of times the user has visited the page.
*
* <Tabs items='React,Next.js'>
* <Tab>
*
* ```tsx {{ filename: 'src/Home.tsx' }}
* import { useSessionList } from '@clerk/clerk-react'
*
* export default function Home() {
*   const { isLoaded, sessions } = useSessionList()
*
*   if (!isLoaded) {
*     // Handle loading state
*     return null
*   }
*
*   return (
*     <div>
*       <p>Welcome back. You've been here {sessions.length} times before.</p>
*     </div>
*   )
* }
* ```
*
* </Tab>
* <Tab>
*
* {@include ../../../docs/use-session-list.md#nextjs-01}
*
* </Tab>
* </Tabs>
*/ const $a0ea147aab9dedc4$var$useSessionList = ()=>{
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider($a0ea147aab9dedc4$var$hookName$2);
    const isomorphicClerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const client = $a0ea147aab9dedc4$var$useClientContext();
    $a0ea147aab9dedc4$var$useClerkInstanceContext().telemetry?.record($77d689860cf967c8$exports.eventMethodCalled($a0ea147aab9dedc4$var$hookName$2));
    if (!client) return {
        isLoaded: false,
        sessions: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        sessions: client.sessions,
        setActive: isomorphicClerk.setActive
    };
};
//#endregion
//#region src/react/hooks/useUser.ts
const $a0ea147aab9dedc4$var$hookName$1 = "useUser";
/**
* The `useUser()` hook provides access to the current user's [`User`](https://clerk.com/docs/reference/javascript/user) object, which contains all the data for a single user in your application and provides methods to manage their account. This hook also allows you to check if the user is signed in and if Clerk has loaded and initialized.
*
* @unionReturnHeadings
* ["Initialization", "Signed out", "Signed in"]
*
* @example
* ### Get the current user
*
* The following example uses the `useUser()` hook to access the [`User`](https://clerk.com/docs/reference/javascript/user) object, which contains the current user's data such as their full name. The `isLoaded` and `isSignedIn` properties are used to handle the loading state and to check if the user is signed in, respectively.
*
* ```tsx {{ filename: 'src/Example.tsx' }}
* import { useUser } from '@clerk/clerk-react'
*
* export default function Example() {
*   const { isSignedIn, user, isLoaded } = useUser()
*
*   if (!isLoaded) {
*     return <div>Loading...</div>
*   }
*
*   if (!isSignedIn) {
*     return <div>Sign in to view this page</div>
*   }
*
*   return <div>Hello {user.firstName}!</div>
* }
* ```
*
* @example
* ### Update user data
*
* The following example uses the `useUser()` hook to access the [`User`](https://clerk.com/docs/reference/javascript/user) object, which calls the [`update()`](https://clerk.com/docs/reference/javascript/user#update) method to update the current user's information.
*
* <Tabs items='React,Next.js'>
* <Tab>
*
* ```tsx {{ filename: 'src/Home.tsx' }}
* import { useUser } from '@clerk/clerk-react'
*
* export default function Home() {
*   const { isSignedIn, isLoaded, user } = useUser()
*
*   if (!isLoaded) {
*     // Handle loading state
*     return null
*   }
*
*   if (!isSignedIn) return null
*
*   const updateUser = async () => {
*     await user.update({
*       firstName: 'John',
*       lastName: 'Doe',
*     })
*   }
*
*   return (
*     <>
*       <button onClick={updateUser}>Update your name</button>
*       <p>user.firstName: {user.firstName}</p>
*       <p>user.lastName: {user.lastName}</p>
*     </>
*   )
* }
* ```
* </Tab>
* <Tab>
*
* {@include ../../../docs/use-user.md#nextjs-01}
*
* </Tab>
* </Tabs>
*
* @example
* ### Reload user data
*
* The following example uses the `useUser()` hook to access the [`User`](https://clerk.com/docs/reference/javascript/user) object, which calls the [`reload()`](https://clerk.com/docs/reference/javascript/user#reload) method to get the latest user's information.
*
* <Tabs items='React,Next.js'>
* <Tab>
*
* ```tsx {{ filename: 'src/Home.tsx' }}
* import { useUser } from '@clerk/clerk-react'
*
* export default function Home() {
*   const { isSignedIn, isLoaded, user } = useUser();
*
*   if (!isLoaded) {
*     // Handle loading state
*     return null;
*   }
*
*   if (!isSignedIn) return null;
*
*   const updateUser = async () => {
*     // Update data via an API endpoint
*     const updateMetadata = await fetch('/api/updateMetadata', {
*       method: 'POST',
*       body: JSON.stringify({
*         role: 'admin'
*       })
*     });
*
*     // Check if the update was successful
*     if ((await updateMetadata.json()).message !== 'success') {
*       throw new Error('Error updating');
*     }
*
*     // If the update was successful, reload the user data
*     await user.reload();
*   };
*
*   return (
*     <>
*       <button onClick={updateUser}>Update your metadata</button>
*       <p>user role: {user.publicMetadata.role}</p>
*     </>
*   );
* }
* ```
*
* </Tab>
* <Tab>
*
* {@include ../../../docs/use-user.md#nextjs-02}
*
* </Tab>
* </Tabs>
*/ function $a0ea147aab9dedc4$var$useUser() {
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider($a0ea147aab9dedc4$var$hookName$1);
    const user = $a0ea147aab9dedc4$var$useUserContext();
    $a0ea147aab9dedc4$var$useClerkInstanceContext().telemetry?.record($77d689860cf967c8$exports.eventMethodCalled($a0ea147aab9dedc4$var$hookName$1));
    if (user === void 0) return {
        isLoaded: false,
        isSignedIn: void 0,
        user: void 0
    };
    if (user === null) return {
        isLoaded: true,
        isSignedIn: false,
        user: null
    };
    return {
        isLoaded: true,
        isSignedIn: true,
        user: user
    };
}
//#endregion
//#region src/react/hooks/useDeepEqualMemo.ts
const $a0ea147aab9dedc4$var$useDeepEqualMemoize = (value)=>{
    const ref = $a0ea147aab9dedc4$require$react.default.useRef(value);
    if (!(0, $a0ea147aab9dedc4$require$dequal.dequal)(value, ref.current)) ref.current = value;
    return $a0ea147aab9dedc4$require$react.default.useMemo(()=>ref.current, [
        ref.current
    ]);
};
/**
* @internal
*/ const $a0ea147aab9dedc4$var$useDeepEqualMemo = (factory, dependencyArray)=>{
    return $a0ea147aab9dedc4$require$react.default.useMemo(factory, $a0ea147aab9dedc4$var$useDeepEqualMemoize(dependencyArray));
};
/**
* @internal
*/ const $a0ea147aab9dedc4$var$isDeeplyEqual = $a0ea147aab9dedc4$require$dequal.dequal;
//#endregion
//#region src/react/hooks/useReverification.ts
const $a0ea147aab9dedc4$var$CLERK_API_REVERIFICATION_ERROR_CODE = "session_reverification_required";
/**
*
*/ async function $a0ea147aab9dedc4$var$resolveResult(result) {
    try {
        const r = await result;
        if (r instanceof Response) return r.json();
        return r;
    } catch (e) {
        if ($1f2575dc6adb407c$exports.isClerkAPIResponseError(e) && e.errors.find(({ code: code })=>code === $a0ea147aab9dedc4$var$CLERK_API_REVERIFICATION_ERROR_CODE)) return $886ddc52c18ced79$exports.reverificationError();
        throw e;
    }
}
/**
*
*/ function $a0ea147aab9dedc4$var$createReverificationHandler(params) {
    /**
	*
	*/ function assertReverification(fetcher) {
        return async (...args)=>{
            let result = await $a0ea147aab9dedc4$var$resolveResult(fetcher(...args));
            if ($886ddc52c18ced79$exports.isReverificationHint(result)) {
                /**
				* Create a promise
				*/ const resolvers = $c4d1cec7f47d93b5$exports.createDeferredPromise();
                const isValidMetadata = $c9f343945e2fea5f$exports.validateReverificationConfig(result.clerk_error.metadata?.reverification);
                const level = isValidMetadata ? isValidMetadata().level : void 0;
                const cancel = ()=>{
                    resolvers.reject(new $1f2575dc6adb407c$exports.ClerkRuntimeError("User cancelled attempted verification", {
                        code: "reverification_cancelled"
                    }));
                };
                const complete = ()=>{
                    resolvers.resolve(true);
                };
                if (params.onNeedsReverification === void 0) /**
				* On success resolve the pending promise
				* On cancel reject the pending promise
				*/ params.openUIComponent?.({
                    level: level,
                    afterVerification: complete,
                    afterVerificationCancelled: cancel
                });
                else params.onNeedsReverification({
                    cancel: cancel,
                    complete: complete,
                    level: level
                });
                /**
				* Wait until the promise from above have been resolved or rejected
				*/ await resolvers.promise;
                /**
				* After the promise resolved successfully try the original request one more time
				*/ result = await $a0ea147aab9dedc4$var$resolveResult(fetcher(...args));
            }
            return result;
        };
    }
    return assertReverification;
}
/**
* > [!WARNING]
* >
* > Depending on the SDK you're using, this feature requires `@clerk/nextjs@6.12.7` or later, `@clerk/clerk-react@5.25.1` or later, and `@clerk/clerk-js@5.57.1` or later.
*
* The `useReverification()` hook is used to handle a session's reverification flow. If a request requires reverification, a modal will display, prompting the user to verify their credentials. Upon successful verification, the original request will automatically retry.
*
* @function
*
* @returns The `useReverification()` hook returns an array with the "enhanced" fetcher.
*
* @example
* ### Handle cancellation of the reverification process
*
* The following example demonstrates how to handle scenarios where a user cancels the reverification flow, such as closing the modal, which might result in `myData` being `null`.
*
* In the following example, `myFetcher` would be a function in your backend that fetches data from the route that requires reverification. See the [guide on how to require reverification](https://clerk.com/docs/guides/secure/reverification) for more information.
*
* ```tsx {{ filename: 'src/components/MyButton.tsx' }}
* import { useReverification } from '@clerk/clerk-react'
* import { isReverificationCancelledError } from '@clerk/clerk-react/error'
*
* type MyData = {
*   balance: number
* }
*
* export function MyButton() {
*   const fetchMyData = () => fetch('/api/balance').then(res=> res.json() as Promise<MyData>)
*   const enhancedFetcher = useReverification(fetchMyData);
*
*   const handleClick = async () => {
*     try {
*       const myData = await enhancedFetcher()
*       //     ^ is types as `MyData`
*     } catch (e) {
*       // Handle error returned from the fetcher here
*
*       // You can also handle cancellation with the following
*       if (isReverificationCancelledError(err)) {
*         // Handle the cancellation error here
*       }
*     }
*   }
*
*   return <button onClick={handleClick}>Update User</button>
* }
* ```
*/ const $a0ea147aab9dedc4$var$useReverification = (fetcher, options)=>{
    const { __internal_openReverification: __internal_openReverification, telemetry: telemetry } = $a0ea147aab9dedc4$var$useClerk();
    const fetcherRef = (0, $a0ea147aab9dedc4$require$react.useRef)(fetcher);
    const optionsRef = (0, $a0ea147aab9dedc4$require$react.useRef)(options);
    telemetry?.record($77d689860cf967c8$exports.eventMethodCalled("useReverification", {
        onNeedsReverification: Boolean(options?.onNeedsReverification)
    }));
    $a0ea147aab9dedc4$var$useSafeLayoutEffect(()=>{
        fetcherRef.current = fetcher;
        optionsRef.current = options;
    });
    return (0, $a0ea147aab9dedc4$require$react.useCallback)((...args)=>{
        return $a0ea147aab9dedc4$var$createReverificationHandler({
            openUIComponent: __internal_openReverification,
            telemetry: telemetry,
            ...optionsRef.current
        })(fetcherRef.current)(...args);
    }, [
        __internal_openReverification,
        telemetry
    ]);
};
//#endregion
//#region src/react/hooks/useBillingHookEnabled.ts
/**
* @internal
*/ function $a0ea147aab9dedc4$var$useBillingHookEnabled(params) {
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const enabledFromParam = params?.enabled ?? true;
    const environment = clerk.__unstable__environment;
    const user = $a0ea147aab9dedc4$var$useUserContext();
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const isOrganization = params?.for === "organization";
    const billingEnabled = isOrganization ? environment?.commerceSettings.billing.organization.enabled : environment?.commerceSettings.billing.user.enabled;
    const requireUserAndOrganizationWhenAuthenticated = params?.authenticated ?? true ? (isOrganization ? Boolean(organization?.id) : true) && Boolean(user?.id) : true;
    return billingEnabled && enabledFromParam && clerk.loaded && requireUserAndOrganizationWhenAuthenticated;
}
//#endregion
//#region src/react/hooks/createBillingPaginatedHook.tsx
/**
* A hook factory that creates paginated data fetching hooks for commerce-related resources.
* It provides a standardized way to create hooks that can fetch either user or Organization resources
* with built-in pagination support.
*
* The generated hooks handle:
* - Clerk authentication context
* - Resource-specific data fetching
* - Pagination (both traditional and infinite scroll)
* - Telemetry tracking
* - Type safety for the specific resource.
*
* @internal
*/ function $a0ea147aab9dedc4$var$createBillingPaginatedHook({ hookName: hookName$4, resourceType: resourceType, useFetcher: useFetcher, options: options }) {
    return function useBillingHook(params) {
        const { for: _for, enabled: externalEnabled, ...paginationParams } = params || {};
        const safeFor = _for || "user";
        $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider(hookName$4);
        const fetchFn = useFetcher(safeFor);
        const safeValues = $a0ea147aab9dedc4$var$useWithSafeValues(paginationParams, {
            initialPage: 1,
            pageSize: 10,
            keepPreviousData: false,
            infinite: false,
            __experimental_mode: void 0
        });
        const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
        const user = $a0ea147aab9dedc4$var$useUserContext();
        const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
        clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled(hookName$4));
        const isForOrganization = safeFor === "organization";
        const billingEnabled = $a0ea147aab9dedc4$var$useBillingHookEnabled({
            for: safeFor,
            enabled: externalEnabled,
            authenticated: !options?.unauthenticated
        });
        const hookParams = typeof paginationParams === "undefined" ? void 0 : {
            initialPage: safeValues.initialPage,
            pageSize: safeValues.pageSize,
            ...options?.unauthenticated ? {} : isForOrganization ? {
                orgId: organization?.id
            } : {}
        };
        const isEnabled = !!hookParams && clerk.loaded && !!billingEnabled;
        return $a0ea147aab9dedc4$var$usePagesOrInfinite({
            fetcher: fetchFn,
            config: {
                keepPreviousData: safeValues.keepPreviousData,
                infinite: safeValues.infinite,
                enabled: isEnabled,
                ...options?.unauthenticated ? {} : {
                    isSignedIn: user !== null
                },
                __experimental_mode: safeValues.__experimental_mode,
                initialPage: safeValues.initialPage,
                pageSize: safeValues.pageSize
            },
            keys: $a0ea147aab9dedc4$var$createCacheKeys({
                stablePrefix: resourceType,
                authenticated: !options?.unauthenticated,
                tracked: options?.unauthenticated ? {
                    for: safeFor
                } : {
                    userId: user?.id,
                    ...isForOrganization ? {
                        ["_orgId"]: organization?.id
                    } : {}
                },
                untracked: {
                    args: hookParams
                }
            })
        });
    };
}
//#endregion
//#region src/react/hooks/useStatements.tsx
/**
* @internal
*/ const $a0ea147aab9dedc4$var$useStatements = $a0ea147aab9dedc4$var$createBillingPaginatedHook({
    hookName: "useStatements",
    resourceType: $a0ea147aab9dedc4$var$STABLE_KEYS.STATEMENTS_KEY,
    useFetcher: ()=>{
        const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
        if (clerk.loaded) return clerk.billing.getStatements;
    }
});
//#endregion
//#region src/react/hooks/usePaymentAttempts.tsx
/**
* @internal
*/ const $a0ea147aab9dedc4$var$usePaymentAttempts = $a0ea147aab9dedc4$var$createBillingPaginatedHook({
    hookName: "usePaymentAttempts",
    resourceType: $a0ea147aab9dedc4$var$STABLE_KEYS.PAYMENT_ATTEMPTS_KEY,
    useFetcher: ()=>{
        const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
        if (clerk.loaded) return clerk.billing.getPaymentAttempts;
    }
});
//#endregion
//#region src/react/hooks/usePaymentMethods.tsx
/**
* @internal
*/ const $a0ea147aab9dedc4$var$usePaymentMethods = $a0ea147aab9dedc4$var$createBillingPaginatedHook({
    hookName: "usePaymentMethods",
    resourceType: $a0ea147aab9dedc4$var$STABLE_KEYS.PAYMENT_METHODS_KEY,
    useFetcher: (resource)=>{
        const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
        const user = $a0ea147aab9dedc4$var$useUserContext();
        if (resource === "organization") return organization?.getPaymentMethods;
        return user?.getPaymentMethods;
    }
});
//#endregion
//#region src/react/hooks/usePlans.tsx
/**
* @internal
*/ const $a0ea147aab9dedc4$var$usePlans = $a0ea147aab9dedc4$var$createBillingPaginatedHook({
    hookName: "usePlans",
    resourceType: $a0ea147aab9dedc4$var$STABLE_KEYS.PLANS_KEY,
    useFetcher: (_for)=>{
        const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
        if (!clerk.loaded) return;
        return (params)=>clerk.billing.getPlans({
                ...params,
                for: _for
            });
    },
    options: {
        unauthenticated: true
    }
});
//#endregion
//#region src/react/hooks/useSubscription.shared.ts
function $a0ea147aab9dedc4$var$useSubscriptionCacheKeys(params) {
    const { userId: userId, orgId: orgId, for: forType } = params;
    return (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        const safeOrgId = forType === "organization" ? orgId : void 0;
        return $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$STABLE_KEYS.SUBSCRIPTION_KEY,
            authenticated: true,
            tracked: {
                userId: userId,
                orgId: safeOrgId
            },
            untracked: {
                args: {
                    orgId: safeOrgId
                }
            }
        });
    }, [
        userId,
        orgId,
        forType
    ]);
}
//#endregion
//#region src/react/hooks/useSubscription.swr.tsx
const $a0ea147aab9dedc4$var$hookName = "useSubscription";
/**
* This is the existing implementation of useSubscription using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$useSubscription(params) {
    $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider($a0ea147aab9dedc4$var$hookName);
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const user = $a0ea147aab9dedc4$var$useUserContext();
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const environment = clerk.__unstable__environment;
    clerk.telemetry?.record($77d689860cf967c8$exports.eventMethodCalled($a0ea147aab9dedc4$var$hookName));
    const billingEnabled = params?.for === "organization" ? environment?.commerceSettings.billing.organization.enabled : environment?.commerceSettings.billing.user.enabled;
    const isEnabled = (params?.enabled ?? true) && billingEnabled;
    const { queryKey: queryKey } = $a0ea147aab9dedc4$var$useSubscriptionCacheKeys({
        userId: user?.id,
        orgId: organization?.id,
        for: params?.for
    });
    const swr$1 = (0, $a0ea147aab9dedc4$require$swr.default)(isEnabled ? {
        queryKey: queryKey
    } : null, ({ queryKey: queryKey$1 })=>{
        const args = queryKey$1[3].args;
        if (queryKey$1[2].userId) return clerk.billing.getSubscription(args);
        return null;
    }, {
        dedupingInterval: 60000,
        keepPreviousData: params?.keepPreviousData
    });
    const revalidate = (0, $a0ea147aab9dedc4$require$react.useCallback)(()=>{
        swr$1.mutate();
    }, [
        swr$1
    ]);
    return {
        data: swr$1.data,
        error: swr$1.error,
        isLoading: swr$1.isLoading,
        isFetching: swr$1.isValidating,
        revalidate: revalidate
    };
}
//#endregion
//#region src/react/hooks/useCheckout.ts
/**
* @function
*
* @param [options] - An object containing the configuration for the checkout flow.
*
* **Required** if the hook is used without a `<CheckoutProvider />` wrapping the component tree.
*/ const $a0ea147aab9dedc4$var$useCheckout = (options)=>{
    const contextOptions = $a0ea147aab9dedc4$var$useCheckoutContext();
    const { for: forOrganization, planId: planId, planPeriod: planPeriod } = options || contextOptions;
    const clerk = $a0ea147aab9dedc4$var$useClerk();
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const { isLoaded: isLoaded, user: user } = $a0ea147aab9dedc4$var$useUser();
    if (!isLoaded) throw new Error("Clerk: Ensure that `useCheckout` is inside a component wrapped with `<ClerkLoaded />`.");
    if (!user) throw new Error("Clerk: Ensure that `useCheckout` is inside a component wrapped with `<SignedIn />`.");
    if (forOrganization === "organization" && !organization) throw new Error("Clerk: Ensure your flow checks for an active organization. Retrieve `orgId` from `useAuth()` and confirm it is defined. For SSR, see: https://clerk.com/docs/reference/backend/types/auth-object#how-to-access-the-auth-object");
    const manager = (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>clerk.__experimental_checkout({
            planId: planId,
            planPeriod: planPeriod,
            for: forOrganization
        }), [
        user.id,
        organization?.id,
        planId,
        planPeriod,
        forOrganization
    ]);
    const managerProperties = (0, $a0ea147aab9dedc4$require$react.useSyncExternalStore)((cb)=>manager.subscribe(cb), ()=>manager.getState(), ()=>manager.getState());
    return {
        checkout: {
            ...(0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
                if (!managerProperties.checkout) return {
                    id: null,
                    externalClientSecret: null,
                    externalGatewayId: null,
                    totals: null,
                    isImmediatePlanChange: null,
                    planPeriod: null,
                    plan: null,
                    paymentMethod: null,
                    freeTrialEndsAt: null,
                    payer: null,
                    needsPaymentMethod: null,
                    planPeriodStart: null
                };
                const { reload: reload, confirm: confirm, pathRoot: pathRoot, ...rest } = managerProperties.checkout;
                return rest;
            }, [
                managerProperties.checkout
            ]),
            getState: manager.getState,
            start: manager.start,
            confirm: manager.confirm,
            clear: manager.clear,
            finalize: manager.finalize,
            isStarting: managerProperties.isStarting,
            isConfirming: managerProperties.isConfirming,
            error: managerProperties.error,
            status: managerProperties.status,
            fetchStatus: managerProperties.fetchStatus
        }
    };
};
//#endregion
//#region src/react/hooks/useStatementQuery.shared.ts
function $a0ea147aab9dedc4$var$useStatementQueryCacheKeys(params) {
    const { statementId: statementId, userId: userId, orgId: orgId, for: forType } = params;
    return (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        return $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$INTERNAL_STABLE_KEYS.BILLING_STATEMENTS_KEY,
            authenticated: true,
            tracked: {
                statementId: statementId,
                forType: forType,
                userId: userId,
                orgId: orgId
            },
            untracked: {
                args: {
                    id: statementId ?? void 0,
                    orgId: orgId ?? void 0
                }
            }
        });
    }, [
        statementId,
        forType,
        userId,
        orgId
    ]);
}
//#endregion
//#region src/react/hooks/useStatementQuery.swr.tsx
/**
* This is the existing implementation of useStatementQuery using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$__internal_useStatementQuery(params = {}) {
    const { statementId: statementId = null, enabled: enabled = true, keepPreviousData: keepPreviousData = false, for: forType = "user" } = params;
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const user = $a0ea147aab9dedc4$var$useUserContext();
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const organizationId = forType === "organization" ? organization?.id ?? null : null;
    const { queryKey: queryKey } = $a0ea147aab9dedc4$var$useStatementQueryCacheKeys({
        statementId: statementId,
        userId: user?.id ?? null,
        orgId: organizationId,
        for: forType
    });
    const swr$1 = (0, $a0ea147aab9dedc4$require$swr.default)(Boolean(statementId) && enabled && (forType !== "organization" || Boolean(organizationId)) ? queryKey : null, ()=>{
        if (!statementId) throw new Error("statementId is required to fetch a statement");
        return clerk.billing.getStatement({
            id: statementId,
            orgId: organizationId ?? void 0
        });
    }, {
        dedupingInterval: 60000,
        keepPreviousData: keepPreviousData
    });
    return {
        data: swr$1.data,
        error: swr$1.error ?? null,
        isLoading: swr$1.isLoading,
        isFetching: swr$1.isValidating
    };
}
//#endregion
//#region src/react/hooks/usePlanDetailsQuery.shared.ts
function $a0ea147aab9dedc4$var$usePlanDetailsQueryCacheKeys(params) {
    const { planId: planId } = params;
    return (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        return $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$INTERNAL_STABLE_KEYS.BILLING_PLANS_KEY,
            authenticated: false,
            tracked: {
                planId: planId ?? null
            },
            untracked: {
                args: {
                    id: planId ?? void 0
                }
            }
        });
    }, [
        planId
    ]);
}
//#endregion
//#region src/react/hooks/usePlanDetailsQuery.swr.tsx
/**
* This is the existing implementation of usePlanDetailsQuery using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$usePlanDetailsQuery(params = {}) {
    const { planId: planId, initialPlan: initialPlan = null, enabled: enabled = true, keepPreviousData: keepPreviousData = true } = params;
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const targetPlanId = planId ?? initialPlan?.id ?? null;
    const { queryKey: queryKey } = $a0ea147aab9dedc4$var$usePlanDetailsQueryCacheKeys({
        planId: targetPlanId
    });
    const swr$1 = (0, $a0ea147aab9dedc4$require$swr.default)(Boolean(targetPlanId) && enabled ? queryKey : null, ()=>{
        if (!targetPlanId) throw new Error("planId is required to fetch plan details");
        return clerk.billing.getPlan({
            id: targetPlanId
        });
    }, {
        dedupingInterval: 60000,
        keepPreviousData: keepPreviousData,
        fallbackData: initialPlan ?? void 0
    });
    return {
        data: swr$1.data,
        error: swr$1.error ?? null,
        isLoading: swr$1.isLoading,
        isFetching: swr$1.isValidating
    };
}
//#endregion
//#region src/react/hooks/usePaymentAttemptQuery.shared.ts
function $a0ea147aab9dedc4$var$usePaymentAttemptQueryCacheKeys(params) {
    const { paymentAttemptId: paymentAttemptId, userId: userId, orgId: orgId, for: forType } = params;
    return (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        return $a0ea147aab9dedc4$var$createCacheKeys({
            stablePrefix: $a0ea147aab9dedc4$var$INTERNAL_STABLE_KEYS.PAYMENT_ATTEMPT_KEY,
            authenticated: true,
            tracked: {
                paymentAttemptId: paymentAttemptId,
                forType: forType,
                userId: userId,
                orgId: orgId
            },
            untracked: {
                args: {
                    id: paymentAttemptId ?? void 0,
                    orgId: orgId ?? void 0
                }
            }
        });
    }, [
        paymentAttemptId,
        forType,
        userId,
        orgId
    ]);
}
//#endregion
//#region src/react/hooks/usePaymentAttemptQuery.swr.tsx
/**
* This is the existing implementation of usePaymentAttemptQuery using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$__internal_usePaymentAttemptQuery(params) {
    const { paymentAttemptId: paymentAttemptId, enabled: enabled = true, keepPreviousData: keepPreviousData = false, for: forType = "user" } = params;
    const clerk = $a0ea147aab9dedc4$var$useClerkInstanceContext();
    const user = $a0ea147aab9dedc4$var$useUserContext();
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const organizationId = forType === "organization" ? organization?.id ?? null : null;
    const { queryKey: queryKey } = $a0ea147aab9dedc4$var$usePaymentAttemptQueryCacheKeys({
        paymentAttemptId: paymentAttemptId,
        userId: user?.id ?? null,
        orgId: organizationId,
        for: forType
    });
    const swr$1 = (0, $a0ea147aab9dedc4$require$swr.default)(Boolean(paymentAttemptId) && enabled && (forType !== "organization" || Boolean(organizationId)) ? {
        queryKey: queryKey
    } : null, ({ queryKey: queryKey$1 })=>{
        const args = queryKey$1[3].args;
        return clerk.billing.getPaymentAttempt(args);
    }, {
        dedupingInterval: 60000,
        keepPreviousData: keepPreviousData
    });
    return {
        data: swr$1.data,
        error: swr$1.error ?? null,
        isLoading: swr$1.isLoading,
        isFetching: swr$1.isValidating
    };
}
//#endregion
//#region src/react/stripe-react/utils.ts
const $a0ea147aab9dedc4$var$usePrevious = (value)=>{
    const ref = (0, $a0ea147aab9dedc4$require$react.useRef)(value);
    (0, $a0ea147aab9dedc4$require$react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $a0ea147aab9dedc4$var$useAttachEvent = (element, event, cb)=>{
    const cbDefined = !!cb;
    const cbRef = (0, $a0ea147aab9dedc4$require$react.useRef)(cb);
    (0, $a0ea147aab9dedc4$require$react.useEffect)(()=>{
        cbRef.current = cb;
    }, [
        cb
    ]);
    (0, $a0ea147aab9dedc4$require$react.useEffect)(()=>{
        if (!cbDefined || !element) return ()=>{};
        const decoratedCb = (...args)=>{
            if (cbRef.current) cbRef.current(...args);
        };
        element.on(event, decoratedCb);
        return ()=>{
            element.off(event, decoratedCb);
        };
    }, [
        cbDefined,
        event,
        element,
        cbRef
    ]);
};
//#endregion
//#region src/react/stripe-react/index.tsx
const $a0ea147aab9dedc4$var$ElementsContext = $a0ea147aab9dedc4$require$react.default.createContext(null);
$a0ea147aab9dedc4$var$ElementsContext.displayName = "ElementsContext";
const $a0ea147aab9dedc4$var$parseElementsContext = (ctx, useCase)=>{
    if (!ctx) throw new Error(`Could not find Elements context; You need to wrap the part of your app that ${useCase} in an <Elements> provider.`);
    return ctx;
};
/**
* The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
* Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
*
* To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
* The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
* Pass the returned `Promise` to `Elements`.
*
* @docs https://stripe.com/docs/stripe-js/react#elements-provider
*/ const $a0ea147aab9dedc4$var$Elements = ({ stripe: rawStripeProp, options: options, children: children })=>{
    const parsed = $a0ea147aab9dedc4$require$react.default.useMemo(()=>$a0ea147aab9dedc4$var$parseStripeProp(rawStripeProp), [
        rawStripeProp
    ]);
    const [ctx, setContext] = $a0ea147aab9dedc4$require$react.default.useState(()=>({
            stripe: parsed.tag === "sync" ? parsed.stripe : null,
            elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
        }));
    $a0ea147aab9dedc4$require$react.default.useEffect(()=>{
        let isMounted = true;
        const safeSetContext = (stripe)=>{
            setContext((ctx$1)=>{
                if (ctx$1.stripe) return ctx$1;
                return {
                    stripe: stripe,
                    elements: stripe.elements(options)
                };
            });
        };
        if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then((stripe)=>{
            if (stripe && isMounted) safeSetContext(stripe);
        });
        else if (parsed.tag === "sync" && !ctx.stripe) safeSetContext(parsed.stripe);
        return ()=>{
            isMounted = false;
        };
    }, [
        parsed,
        ctx,
        options
    ]);
    const prevStripe = $a0ea147aab9dedc4$var$usePrevious(rawStripeProp);
    $a0ea147aab9dedc4$require$react.default.useEffect(()=>{
        if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
    }, [
        prevStripe,
        rawStripeProp
    ]);
    const prevOptions = $a0ea147aab9dedc4$var$usePrevious(options);
    $a0ea147aab9dedc4$require$react.default.useEffect(()=>{
        if (!ctx.elements) return;
        const updates = $a0ea147aab9dedc4$var$extractAllowedOptionsUpdates(options, prevOptions, [
            "clientSecret",
            "fonts"
        ]);
        if (updates) ctx.elements.update(updates);
    }, [
        options,
        prevOptions,
        ctx.elements
    ]);
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$ElementsContext.Provider, {
        value: ctx
    }, children);
};
const $a0ea147aab9dedc4$var$useElementsContextWithUseCase = (useCaseMessage)=>{
    return $a0ea147aab9dedc4$var$parseElementsContext($a0ea147aab9dedc4$require$react.default.useContext($a0ea147aab9dedc4$var$ElementsContext), useCaseMessage);
};
const $a0ea147aab9dedc4$var$useElements = ()=>{
    const { elements: elements } = $a0ea147aab9dedc4$var$useElementsContextWithUseCase("calls useElements()");
    return elements;
};
const $a0ea147aab9dedc4$var$INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
const $a0ea147aab9dedc4$var$validateStripe = (maybeStripe, errorMsg = $a0ea147aab9dedc4$var$INVALID_STRIPE_ERROR)=>{
    if (maybeStripe === null || $a0ea147aab9dedc4$var$isStripe(maybeStripe)) return maybeStripe;
    throw new Error(errorMsg);
};
const $a0ea147aab9dedc4$var$parseStripeProp = (raw, errorMsg = $a0ea147aab9dedc4$var$INVALID_STRIPE_ERROR)=>{
    if ($a0ea147aab9dedc4$var$isPromise(raw)) return {
        tag: "async",
        stripePromise: Promise.resolve(raw).then((result)=>$a0ea147aab9dedc4$var$validateStripe(result, errorMsg))
    };
    const stripe = $a0ea147aab9dedc4$var$validateStripe(raw, errorMsg);
    if (stripe === null) return {
        tag: "empty"
    };
    return {
        tag: "sync",
        stripe: stripe
    };
};
const $a0ea147aab9dedc4$var$isUnknownObject = (raw)=>{
    return raw !== null && typeof raw === "object";
};
const $a0ea147aab9dedc4$var$isPromise = (raw)=>{
    return $a0ea147aab9dedc4$var$isUnknownObject(raw) && typeof raw.then === "function";
};
const $a0ea147aab9dedc4$var$isStripe = (raw)=>{
    return $a0ea147aab9dedc4$var$isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
};
const $a0ea147aab9dedc4$var$extractAllowedOptionsUpdates = (options, prevOptions, immutableKeys)=>{
    if (!$a0ea147aab9dedc4$var$isUnknownObject(options)) return null;
    return Object.keys(options).reduce((newOptions, key)=>{
        const isUpdated = !$a0ea147aab9dedc4$var$isUnknownObject(prevOptions) || !$a0ea147aab9dedc4$var$isEqual(options[key], prevOptions[key]);
        if (immutableKeys.includes(key)) {
            if (isUpdated) console.warn(`Unsupported prop change: options.${key} is not a mutable property.`);
            return newOptions;
        }
        if (!isUpdated) return newOptions;
        return {
            ...newOptions || {},
            [key]: options[key]
        };
    }, null);
};
const $a0ea147aab9dedc4$var$PLAIN_OBJECT_STR = "[object Object]";
const $a0ea147aab9dedc4$var$isEqual = (left, right)=>{
    if (!$a0ea147aab9dedc4$var$isUnknownObject(left) || !$a0ea147aab9dedc4$var$isUnknownObject(right)) return left === right;
    const leftArray = Array.isArray(left);
    if (leftArray !== Array.isArray(right)) return false;
    const leftPlainObject = Object.prototype.toString.call(left) === $a0ea147aab9dedc4$var$PLAIN_OBJECT_STR;
    if (leftPlainObject !== (Object.prototype.toString.call(right) === $a0ea147aab9dedc4$var$PLAIN_OBJECT_STR)) return false;
    if (!leftPlainObject && !leftArray) return left === right;
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) return false;
    const keySet = {};
    for(let i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
    for(let i = 0; i < rightKeys.length; i += 1)keySet[rightKeys[i]] = true;
    const allKeys = Object.keys(keySet);
    if (allKeys.length !== leftKeys.length) return false;
    const l = left;
    const r = right;
    const pred = (key)=>{
        return $a0ea147aab9dedc4$var$isEqual(l[key], r[key]);
    };
    return allKeys.every(pred);
};
const $a0ea147aab9dedc4$var$useStripe = ()=>{
    const { stripe: stripe } = $a0ea147aab9dedc4$var$useElementsOrCheckoutSdkContextWithUseCase("calls useStripe()");
    return stripe;
};
const $a0ea147aab9dedc4$var$useElementsOrCheckoutSdkContextWithUseCase = (useCaseString)=>{
    return $a0ea147aab9dedc4$var$parseElementsContext($a0ea147aab9dedc4$require$react.default.useContext($a0ea147aab9dedc4$var$ElementsContext), useCaseString);
};
const $a0ea147aab9dedc4$var$capitalized = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $a0ea147aab9dedc4$var$createElementComponent = (type, isServer)=>{
    const displayName = `${$a0ea147aab9dedc4$var$capitalized(type)}Element`;
    const ClientElement = ({ id: id, className: className, fallback: fallback, options: options = {}, onBlur: onBlur, onFocus: onFocus, onReady: onReady, onChange: onChange, onEscape: onEscape, onClick: onClick, onLoadError: onLoadError, onLoaderStart: onLoaderStart, onNetworksChange: onNetworksChange, onConfirm: onConfirm, onCancel: onCancel, onShippingAddressChange: onShippingAddressChange, onShippingRateChange: onShippingRateChange })=>{
        const ctx = $a0ea147aab9dedc4$var$useElementsOrCheckoutSdkContextWithUseCase(`mounts <${displayName}>`);
        const elements = "elements" in ctx ? ctx.elements : null;
        const [element, setElement] = $a0ea147aab9dedc4$require$react.default.useState(null);
        const elementRef = $a0ea147aab9dedc4$require$react.default.useRef(null);
        const domNode = $a0ea147aab9dedc4$require$react.default.useRef(null);
        const [isReady, setReady] = (0, $a0ea147aab9dedc4$require$react.useState)(false);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "blur", onBlur);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "focus", onFocus);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "escape", onEscape);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "click", onClick);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "loaderror", onLoadError);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "loaderstart", onLoaderStart);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "networkschange", onNetworksChange);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "confirm", onConfirm);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "cancel", onCancel);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "shippingratechange", onShippingRateChange);
        $a0ea147aab9dedc4$var$useAttachEvent(element, "change", onChange);
        let readyCallback;
        if (onReady) readyCallback = ()=>{
            setReady(true);
            onReady(element);
        };
        $a0ea147aab9dedc4$var$useAttachEvent(element, "ready", readyCallback);
        $a0ea147aab9dedc4$require$react.default.useLayoutEffect(()=>{
            if (elementRef.current === null && domNode.current !== null && elements) {
                let newElement = null;
                if (elements) newElement = elements.create(type, options);
                elementRef.current = newElement;
                setElement(newElement);
                if (newElement) newElement.mount(domNode.current);
            }
        }, [
            elements,
            options
        ]);
        const prevOptions = $a0ea147aab9dedc4$var$usePrevious(options);
        $a0ea147aab9dedc4$require$react.default.useEffect(()=>{
            if (!elementRef.current) return;
            const updates = $a0ea147aab9dedc4$var$extractAllowedOptionsUpdates(options, prevOptions, [
                "paymentRequest"
            ]);
            if (updates && "update" in elementRef.current) elementRef.current.update(updates);
        }, [
            options,
            prevOptions
        ]);
        $a0ea147aab9dedc4$require$react.default.useLayoutEffect(()=>{
            return ()=>{
                if (elementRef.current && typeof elementRef.current.destroy === "function") try {
                    elementRef.current.destroy();
                    elementRef.current = null;
                } catch  {}
            };
        }, []);
        return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$require$react.default.Fragment, null, !isReady && fallback, /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement("div", {
            id: id,
            style: {
                height: isReady ? "unset" : "0px",
                visibility: isReady ? "visible" : "hidden"
            },
            className: className,
            ref: domNode
        }));
    };
    const ServerElement = (props)=>{
        $a0ea147aab9dedc4$var$useElementsOrCheckoutSdkContextWithUseCase(`mounts <${displayName}>`);
        const { id: id, className: className } = props;
        return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement("div", {
            id: id,
            className: className
        });
    };
    const Element = isServer ? ServerElement : ClientElement;
    Element.displayName = displayName;
    Element.__elementType = type;
    return Element;
};
const $a0ea147aab9dedc4$var$PaymentElement$1 = $a0ea147aab9dedc4$var$createElementComponent("payment", typeof window === "undefined");
//#endregion
//#region src/react/billing/useInitializePaymentMethod.swr.tsx
/**
* This is the existing implementation of the payment method initializer using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$useInitializePaymentMethod(options) {
    const { for: forType = "user" } = options ?? {};
    const { organization: organization } = $a0ea147aab9dedc4$var$useOrganizationContext();
    const user = $a0ea147aab9dedc4$var$useUserContext();
    const resource = forType === "organization" ? organization : user;
    const { data: data, trigger: trigger } = (0, $a0ea147aab9dedc4$require$swr_mutation.default)(resource?.id ? {
        key: "billing-payment-method-initialize",
        resourceId: resource.id,
        for: forType
    } : null, ()=>{
        return resource?.initializePaymentMethod({
            gateway: "stripe"
        });
    });
    (0, $a0ea147aab9dedc4$require$react.useEffect)(()=>{
        if (!resource?.id) return;
        trigger().catch(()=>{});
    }, [
        resource?.id,
        trigger
    ]);
    return {
        initializedPaymentMethod: data,
        initializePaymentMethod: trigger
    };
}
//#endregion
//#region src/react/billing/useStripeClerkLibs.swr.tsx
/**
* This is the existing implementation of the Stripe libraries loader using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$useStripeClerkLibs() {
    const clerk = $a0ea147aab9dedc4$var$useClerk();
    return (0, $a0ea147aab9dedc4$require$swr.default)("clerk-stripe-sdk", async ()=>{
        return {
            loadStripe: await clerk.__internal_loadStripeJs()
        };
    }, {
        keepPreviousData: true,
        revalidateOnFocus: false,
        dedupingInterval: Infinity
    }).data ?? null;
}
//#endregion
//#region src/react/billing/useStripeLoader.swr.tsx
/**
* This is the existing implementation of the Stripe instance loader using SWR.
* It is kept here for backwards compatibility until our next major version.
*
* @internal
*/ function $a0ea147aab9dedc4$var$useStripeLoader(options) {
    const { stripeClerkLibs: stripeClerkLibs, externalGatewayId: externalGatewayId, stripePublishableKey: stripePublishableKey } = options;
    return (0, $a0ea147aab9dedc4$require$swr.default)(stripeClerkLibs && externalGatewayId && stripePublishableKey ? {
        key: "stripe-sdk",
        externalGatewayId: externalGatewayId,
        stripePublishableKey: stripePublishableKey
    } : null, ({ stripePublishableKey: stripePublishableKey$1, externalGatewayId: externalGatewayId$1 })=>{
        return stripeClerkLibs?.loadStripe(stripePublishableKey$1, {
            stripeAccount: externalGatewayId$1
        });
    }, {
        keepPreviousData: true,
        revalidateOnFocus: false,
        dedupingInterval: 60000
    }).data;
}
//#endregion
//#region src/react/billing/payment-element.tsx
const $a0ea147aab9dedc4$var$useInternalEnvironment = ()=>{
    return $a0ea147aab9dedc4$var$useClerk().__unstable__environment;
};
const $a0ea147aab9dedc4$var$useLocalization = ()=>{
    const clerk = $a0ea147aab9dedc4$var$useClerk();
    let locale = "en";
    try {
        locale = clerk.__internal_getOption("localization")?.locale || "en";
    } catch  {}
    return locale.split("-")[0];
};
const $a0ea147aab9dedc4$var$usePaymentSourceUtils = (forResource = "user")=>{
    const stripeClerkLibs = $a0ea147aab9dedc4$var$useStripeClerkLibs();
    const environment = $a0ea147aab9dedc4$var$useInternalEnvironment();
    const { initializedPaymentMethod: initializedPaymentMethod, initializePaymentMethod: initializePaymentMethod } = $a0ea147aab9dedc4$var$useInitializePaymentMethod({
        for: forResource
    });
    const stripePublishableKey = environment?.commerceSettings.billing.stripePublishableKey ?? void 0;
    return {
        stripe: $a0ea147aab9dedc4$var$useStripeLoader({
            stripeClerkLibs: stripeClerkLibs,
            externalGatewayId: initializedPaymentMethod?.externalGatewayId,
            stripePublishableKey: stripePublishableKey
        }),
        initializePaymentMethod: initializePaymentMethod,
        externalClientSecret: initializedPaymentMethod?.externalClientSecret,
        paymentMethodOrder: initializedPaymentMethod?.paymentMethodOrder
    };
};
const [$a0ea147aab9dedc4$var$PaymentElementContext, $a0ea147aab9dedc4$var$usePaymentElementContext] = $a0ea147aab9dedc4$var$createContextAndHook("PaymentElementContext");
const [$a0ea147aab9dedc4$var$StripeUtilsContext, $a0ea147aab9dedc4$var$useStripeUtilsContext] = $a0ea147aab9dedc4$var$createContextAndHook("StripeUtilsContext");
const $a0ea147aab9dedc4$var$ValidateStripeUtils = ({ children: children })=>{
    const stripe = $a0ea147aab9dedc4$var$useStripe();
    const elements = $a0ea147aab9dedc4$var$useElements();
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$StripeUtilsContext.Provider, {
        value: {
            value: {
                stripe: stripe,
                elements: elements
            }
        }
    }, children);
};
const $a0ea147aab9dedc4$var$DummyStripeUtils = ({ children: children })=>{
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$StripeUtilsContext.Provider, {
        value: {
            value: {}
        }
    }, children);
};
const $a0ea147aab9dedc4$var$PropsProvider = ({ children: children, ...props })=>{
    const utils = $a0ea147aab9dedc4$var$usePaymentSourceUtils(props.for);
    const [isPaymentElementReady, setIsPaymentElementReady] = (0, $a0ea147aab9dedc4$require$react.useState)(false);
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$PaymentElementContext.Provider, {
        value: {
            value: {
                ...props,
                ...utils,
                setIsPaymentElementReady: setIsPaymentElementReady,
                isPaymentElementReady: isPaymentElementReady
            }
        }
    }, children);
};
const $a0ea147aab9dedc4$var$PaymentElementProvider = ({ children: children, ...props })=>{
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$PropsProvider, props, /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$PaymentElementInternalRoot, null, children));
};
const $a0ea147aab9dedc4$var$PaymentElementInternalRoot = (props)=>{
    const { stripe: stripe, externalClientSecret: externalClientSecret, stripeAppearance: stripeAppearance } = $a0ea147aab9dedc4$var$usePaymentElementContext();
    const locale = $a0ea147aab9dedc4$var$useLocalization();
    if (stripe && externalClientSecret) return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$Elements, {
        key: externalClientSecret,
        stripe: stripe,
        options: {
            loader: "never",
            clientSecret: externalClientSecret,
            appearance: {
                variables: stripeAppearance
            },
            locale: locale
        }
    }, /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$ValidateStripeUtils, null, props.children));
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$DummyStripeUtils, null, props.children);
};
const $a0ea147aab9dedc4$var$PaymentElement = ({ fallback: fallback })=>{
    const { setIsPaymentElementReady: setIsPaymentElementReady, paymentMethodOrder: paymentMethodOrder, checkout: checkout, stripe: stripe, externalClientSecret: externalClientSecret, paymentDescription: paymentDescription, for: _for } = $a0ea147aab9dedc4$var$usePaymentElementContext();
    const environment = $a0ea147aab9dedc4$var$useInternalEnvironment();
    const applePay = (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        if (!checkout || !checkout.totals || !checkout.plan) return;
        return {
            recurringPaymentRequest: {
                paymentDescription: paymentDescription || "",
                managementURL: _for === "organization" ? environment?.displayConfig.organizationProfileUrl || "" : environment?.displayConfig.userProfileUrl || "",
                regularBilling: {
                    amount: checkout.totals.totalDueNow?.amount || checkout.totals.grandTotal.amount,
                    label: checkout.plan.name,
                    recurringPaymentIntervalUnit: checkout.planPeriod === "annual" ? "year" : "month"
                }
            }
        };
    }, [
        checkout,
        paymentDescription,
        _for,
        environment
    ]);
    const options = (0, $a0ea147aab9dedc4$require$react.useMemo)(()=>{
        return {
            layout: {
                type: "tabs",
                defaultCollapsed: false
            },
            paymentMethodOrder: paymentMethodOrder,
            applePay: applePay
        };
    }, [
        applePay,
        paymentMethodOrder
    ]);
    const onReady = (0, $a0ea147aab9dedc4$require$react.useCallback)(()=>{
        setIsPaymentElementReady(true);
    }, [
        setIsPaymentElementReady
    ]);
    if (!stripe || !externalClientSecret) return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$require$react.default.Fragment, null, fallback);
    return /* @__PURE__ */ $a0ea147aab9dedc4$require$react.default.createElement($a0ea147aab9dedc4$var$PaymentElement$1, {
        fallback: fallback,
        onReady: onReady,
        options: options
    });
};
const $a0ea147aab9dedc4$var$throwLibsMissingError = ()=>{
    throw new Error("Clerk: Unable to submit, Stripe libraries are not yet loaded. Be sure to check `isFormReady` before calling `submit`.");
};
const $a0ea147aab9dedc4$var$usePaymentElement = ()=>{
    const { isPaymentElementReady: isPaymentElementReady, initializePaymentMethod: initializePaymentMethod } = $a0ea147aab9dedc4$var$usePaymentElementContext();
    const { stripe: stripe, elements: elements } = $a0ea147aab9dedc4$var$useStripeUtilsContext();
    const { externalClientSecret: externalClientSecret } = $a0ea147aab9dedc4$var$usePaymentElementContext();
    const submit = (0, $a0ea147aab9dedc4$require$react.useCallback)(async ()=>{
        if (!stripe || !elements) return $a0ea147aab9dedc4$var$throwLibsMissingError();
        const { setupIntent: setupIntent, error: error } = await stripe.confirmSetup({
            elements: elements,
            confirmParams: {
                return_url: window.location.href
            },
            redirect: "if_required"
        });
        if (error) return {
            data: null,
            error: {
                gateway: "stripe",
                error: {
                    code: error.code,
                    message: error.message,
                    type: error.type
                }
            }
        };
        return {
            data: {
                gateway: "stripe",
                paymentToken: setupIntent.payment_method
            },
            error: null
        };
    }, [
        stripe,
        elements
    ]);
    const reset = (0, $a0ea147aab9dedc4$require$react.useCallback)(async ()=>{
        if (!stripe || !elements) return $a0ea147aab9dedc4$var$throwLibsMissingError();
        await initializePaymentMethod();
    }, [
        stripe,
        elements,
        initializePaymentMethod
    ]);
    const isProviderReady = Boolean(stripe && externalClientSecret);
    if (!isProviderReady) return {
        submit: $a0ea147aab9dedc4$var$throwLibsMissingError,
        reset: $a0ea147aab9dedc4$var$throwLibsMissingError,
        isFormReady: false,
        provider: void 0,
        isProviderReady: false
    };
    return {
        submit: submit,
        reset: reset,
        isFormReady: isPaymentElementReady,
        provider: {
            name: "stripe"
        },
        isProviderReady: isProviderReady
    };
};
$a0ea147aab9dedc4$export$8aa96e0f8b054cda = $a0ea147aab9dedc4$var$ClerkInstanceContext;
$a0ea147aab9dedc4$export$56e68f8f57ecfde4 = $a0ea147aab9dedc4$var$ClientContext;
$a0ea147aab9dedc4$export$b709306b005c3ef = $a0ea147aab9dedc4$var$OptionsContext;
$a0ea147aab9dedc4$export$4ca575904f5d942 = $a0ea147aab9dedc4$var$OrganizationProvider;
$a0ea147aab9dedc4$export$3285420c698bc605 = $a0ea147aab9dedc4$var$SessionContext;
$a0ea147aab9dedc4$export$38ee920e59704589 = $a0ea147aab9dedc4$var$UserContext;
$a0ea147aab9dedc4$export$7e97d07504ce6dd0 = $a0ea147aab9dedc4$var$__experimental_CheckoutProvider;
$a0ea147aab9dedc4$export$cfeb6784afb9ebba = $a0ea147aab9dedc4$var$PaymentElement;
$a0ea147aab9dedc4$export$2341d27b29acefb0 = $a0ea147aab9dedc4$var$PaymentElementProvider;
$a0ea147aab9dedc4$export$d327cc281423078f = $a0ea147aab9dedc4$var$useAPIKeys;
$a0ea147aab9dedc4$export$88df2e7b0f32010b = $a0ea147aab9dedc4$var$useCheckout;
$a0ea147aab9dedc4$export$e815511d4ebcb06 = $a0ea147aab9dedc4$var$usePaymentAttempts;
$a0ea147aab9dedc4$export$4e9381da774c24d3 = $a0ea147aab9dedc4$var$usePaymentElement;
$a0ea147aab9dedc4$export$38f75eca50e9fd7d = $a0ea147aab9dedc4$var$usePaymentMethods;
$a0ea147aab9dedc4$export$ea1f369b2d9cc9f0 = $a0ea147aab9dedc4$var$usePlans;
$a0ea147aab9dedc4$export$550bdccf43dc8f35 = $a0ea147aab9dedc4$var$useStatements;
$a0ea147aab9dedc4$export$3854fde325b71e8a = $a0ea147aab9dedc4$var$useSubscription;
$a0ea147aab9dedc4$export$25f1ad233bf5fd25 = $a0ea147aab9dedc4$var$__internal_usePaymentAttemptQuery;
$a0ea147aab9dedc4$export$e79b0a7479712bef = $a0ea147aab9dedc4$var$usePlanDetailsQuery;
$a0ea147aab9dedc4$export$81cdd837749204ba = $a0ea147aab9dedc4$var$__internal_useStatementQuery;
$a0ea147aab9dedc4$export$9f6298504fcd4ed = $a0ea147aab9dedc4$var$assertContextExists;
$a0ea147aab9dedc4$export$b4f021037e6d7d3f = $a0ea147aab9dedc4$var$createContextAndHook;
$a0ea147aab9dedc4$export$fbab93d9e79c77b7 = $a0ea147aab9dedc4$var$isDeeplyEqual;
$a0ea147aab9dedc4$export$5c869da50c3fb50 = $a0ea147aab9dedc4$var$useAssertWrappedByClerkProvider;
$a0ea147aab9dedc4$export$3526686d04c8ecc8 = $a0ea147aab9dedc4$var$useAttemptToEnableOrganizations;
$a0ea147aab9dedc4$export$1d7a12f28cf01e2e = $a0ea147aab9dedc4$var$useClerk;
$a0ea147aab9dedc4$export$5ebbb6ccfffc7393 = $a0ea147aab9dedc4$var$useClerkInstanceContext;
$a0ea147aab9dedc4$export$6627e187bf6ba3fd = $a0ea147aab9dedc4$var$useClientContext;
$a0ea147aab9dedc4$export$adf542e9f67b17f = $a0ea147aab9dedc4$var$useDeepEqualMemo;
$a0ea147aab9dedc4$export$47309e171cbac7d = $a0ea147aab9dedc4$var$useOptionsContext;
$a0ea147aab9dedc4$export$ae85931d305e13b1 = $a0ea147aab9dedc4$var$useOrganization;
$a0ea147aab9dedc4$export$7305fb39264bef77 = $a0ea147aab9dedc4$var$useOrganizationContext;
$a0ea147aab9dedc4$export$98614501febd5535 = $a0ea147aab9dedc4$var$useOrganizationCreationDefaultsHook;
$a0ea147aab9dedc4$export$70272151be64739d = $a0ea147aab9dedc4$var$useOrganizationList;
$a0ea147aab9dedc4$export$9497b92f9bd92d3e = $a0ea147aab9dedc4$var$useReverification;
$a0ea147aab9dedc4$export$deebe11a338de063 = $a0ea147aab9dedc4$var$useSafeLayoutEffect;
$a0ea147aab9dedc4$export$ad0a340bf97d63d5 = $a0ea147aab9dedc4$var$useSession;
$a0ea147aab9dedc4$export$a3931362f3958630 = $a0ea147aab9dedc4$var$useSessionContext;
$a0ea147aab9dedc4$export$14add875417b9a72 = $a0ea147aab9dedc4$var$useSessionList;
$a0ea147aab9dedc4$export$23bbbc4533528f03 = $a0ea147aab9dedc4$var$useUser;
$a0ea147aab9dedc4$export$87c54b525b914dab = $a0ea147aab9dedc4$var$useUserContext;



var $8fcdbf2d7a4660c6$var$import_react9 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$isMountProps = (props)=>{
    return "mount" in props;
};
var $8fcdbf2d7a4660c6$var$isOpenProps = (props)=>{
    return "open" in props;
};
var $8fcdbf2d7a4660c6$var$stripMenuItemIconHandlers = (menuItems)=>{
    return menuItems == null ? void 0 : menuItems.map(({ mountIcon: mountIcon, unmountIcon: unmountIcon, ...rest })=>rest);
};
var $8fcdbf2d7a4660c6$var$ClerkHostRenderer = class extends $8fcdbf2d7a4660c6$var$import_react9.default.PureComponent {
    constructor(){
        super(...arguments);
        this.rootRef = $8fcdbf2d7a4660c6$var$import_react9.default.createRef();
    }
    componentDidUpdate(_prevProps) {
        var _a, _b, _c, _d;
        if (!$8fcdbf2d7a4660c6$var$isMountProps(_prevProps) || !$8fcdbf2d7a4660c6$var$isMountProps(this.props)) return;
        const prevProps = (0, $92dfd5d5ab50d7d9$export$5d14bf425b37f49e)(_prevProps.props, "customPages", "customMenuItems", "children");
        const newProps = (0, $92dfd5d5ab50d7d9$export$5d14bf425b37f49e)(this.props.props, "customPages", "customMenuItems", "children");
        const customPagesChanged = ((_a = prevProps.customPages) == null ? void 0 : _a.length) !== ((_b = newProps.customPages) == null ? void 0 : _b.length);
        const customMenuItemsChanged = ((_c = prevProps.customMenuItems) == null ? void 0 : _c.length) !== ((_d = newProps.customMenuItems) == null ? void 0 : _d.length);
        const prevMenuItemsWithoutHandlers = $8fcdbf2d7a4660c6$var$stripMenuItemIconHandlers(_prevProps.props.customMenuItems);
        const newMenuItemsWithoutHandlers = $8fcdbf2d7a4660c6$var$stripMenuItemIconHandlers(this.props.props.customMenuItems);
        if (!(0, $a0ea147aab9dedc4$export$fbab93d9e79c77b7)(prevProps, newProps) || !(0, $a0ea147aab9dedc4$export$fbab93d9e79c77b7)(prevMenuItemsWithoutHandlers, newMenuItemsWithoutHandlers) || customPagesChanged || customMenuItemsChanged) {
            if (this.rootRef.current) this.props.updateProps({
                node: this.rootRef.current,
                props: this.props.props
            });
        }
    }
    componentDidMount() {
        if (this.rootRef.current) {
            if ($8fcdbf2d7a4660c6$var$isMountProps(this.props)) this.props.mount(this.rootRef.current, this.props.props);
            if ($8fcdbf2d7a4660c6$var$isOpenProps(this.props)) this.props.open(this.props.props);
        }
    }
    componentWillUnmount() {
        if (this.rootRef.current) {
            if ($8fcdbf2d7a4660c6$var$isMountProps(this.props)) this.props.unmount(this.rootRef.current);
            if ($8fcdbf2d7a4660c6$var$isOpenProps(this.props)) this.props.close();
        }
    }
    render() {
        const { hideRootHtmlElement: hideRootHtmlElement = false } = this.props;
        const rootAttributes = {
            ref: this.rootRef,
            ...this.props.rootProps,
            ...this.props.component && {
                "data-clerk-component": this.props.component
            }
        };
        return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react9.default.createElement($8fcdbf2d7a4660c6$var$import_react9.default.Fragment, null, !hideRootHtmlElement && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react9.default.createElement("div", {
            ...rootAttributes
        }), this.props.children);
    }
};

// src/components/withClerk.tsx
var $8fcdbf2d7a4660c6$var$import_react12 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));

var $8fcdbf2d7a4660c6$var$IsomorphicClerkContext = $a0ea147aab9dedc4$export$8aa96e0f8b054cda;
var $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext = $a0ea147aab9dedc4$export$5ebbb6ccfffc7393;

var $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider = (source)=>{
    (0, $a0ea147aab9dedc4$export$5c869da50c3fb50)(()=>{
        $8fcdbf2d7a4660c6$var$errorThrower.throwMissingClerkProviderError({
            source: source
        });
    });
};
// src/components/withClerk.tsx
var $8fcdbf2d7a4660c6$var$withClerk = (Component, displayNameOrOptions)=>{
    const passedDisplayedName = typeof displayNameOrOptions === "string" ? displayNameOrOptions : displayNameOrOptions == null ? void 0 : displayNameOrOptions.component;
    const displayName = passedDisplayedName || Component.displayName || Component.name || "Component";
    Component.displayName = displayName;
    const options = typeof displayNameOrOptions === "string" ? void 0 : displayNameOrOptions;
    const HOC = (props)=>{
        $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider(displayName || "withClerk");
        const clerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
        if (!clerk.loaded && !(options == null ? void 0 : options.renderWhileLoading)) return null;
        return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react12.default.createElement(Component, {
            ...props,
            component: displayName,
            clerk: clerk
        });
    };
    HOC.displayName = `withClerk(${displayName})`;
    return HOC;
};
// src/components/uiComponents.tsx
var $8fcdbf2d7a4660c6$var$CustomPortalsRenderer = (props)=>{
    var _a, _b;
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, (_a = props == null ? void 0 : props.customPagesPortals) == null ? void 0 : _a.map((portal, index)=>(0, $8fcdbf2d7a4660c6$var$import_react13.createElement)(portal, {
            key: index
        })), (_b = props == null ? void 0 : props.customMenuItemsPortals) == null ? void 0 : _b.map((portal, index)=>(0, $8fcdbf2d7a4660c6$var$import_react13.createElement)(portal, {
            key: index
        })));
};
var $8fcdbf2d7a4660c6$var$SignIn = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountSignIn,
        unmount: clerk.unmountSignIn,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "SignIn",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$SignUp = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountSignUp,
        unmount: clerk.unmountSignUp,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "SignUp",
    renderWhileLoading: true
});
function $8fcdbf2d7a4660c6$var$UserProfilePage({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userProfilePageRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
function $8fcdbf2d7a4660c6$var$UserProfileLink({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userProfileLinkRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
var $8fcdbf2d7a4660c6$var$_UserProfile = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $8fcdbf2d7a4660c6$var$useUserProfileCustomPages(props.children);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountUserProfile,
        unmount: clerk.unmountUserProfile,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            customPages: customPages
        },
        rootProps: rendererRootProps
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$CustomPortalsRenderer, {
        customPagesPortals: customPagesPortals
    })));
}, {
    component: "UserProfile",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$UserProfile = Object.assign($8fcdbf2d7a4660c6$var$_UserProfile, {
    Page: $8fcdbf2d7a4660c6$var$UserProfilePage,
    Link: $8fcdbf2d7a4660c6$var$UserProfileLink
});
var $8fcdbf2d7a4660c6$var$UserButtonContext = (0, $8fcdbf2d7a4660c6$var$import_react13.createContext)({
    mount: ()=>{},
    unmount: ()=>{},
    updateProps: ()=>{}
});
var $8fcdbf2d7a4660c6$var$_UserButton = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $8fcdbf2d7a4660c6$var$useUserProfileCustomPages(props.children, {
        allowForAnyChildren: !!props.__experimental_asProvider
    });
    const userProfileProps = {
        ...props.userProfileProps,
        customPages: customPages
    };
    const { customMenuItems: customMenuItems, customMenuItemsPortals: customMenuItemsPortals } = $8fcdbf2d7a4660c6$var$useUserButtonCustomMenuItems(props.children, {
        allowForAnyChildren: !!props.__experimental_asProvider
    });
    const sanitizedChildren = $8fcdbf2d7a4660c6$var$useSanitizedChildren(props.children);
    const passableProps = {
        mount: clerk.mountUserButton,
        unmount: clerk.unmountUserButton,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            userProfileProps: userProfileProps,
            customMenuItems: customMenuItems
        }
    };
    const portalProps = {
        customPagesPortals: customPagesPortals,
        customMenuItemsPortals: customMenuItemsPortals
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$UserButtonContext.Provider, {
        value: passableProps
    }, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        ...passableProps,
        hideRootHtmlElement: !!props.__experimental_asProvider,
        rootProps: rendererRootProps
    }, props.__experimental_asProvider ? sanitizedChildren : null, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$CustomPortalsRenderer, {
        ...portalProps
    })));
}, {
    component: "UserButton",
    renderWhileLoading: true
});
function $8fcdbf2d7a4660c6$var$MenuItems({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userButtonMenuItemsRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
function $8fcdbf2d7a4660c6$var$MenuAction({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userButtonMenuActionRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
function $8fcdbf2d7a4660c6$var$MenuLink({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$userButtonMenuLinkRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
function $8fcdbf2d7a4660c6$var$UserButtonOutlet(outletProps) {
    const providerProps = (0, $8fcdbf2d7a4660c6$var$import_react13.useContext)($8fcdbf2d7a4660c6$var$UserButtonContext);
    const portalProps = {
        ...providerProps,
        props: {
            ...providerProps.props,
            ...outletProps
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        ...portalProps
    });
}
var $8fcdbf2d7a4660c6$var$UserButton = Object.assign($8fcdbf2d7a4660c6$var$_UserButton, {
    UserProfilePage: $8fcdbf2d7a4660c6$var$UserProfilePage,
    UserProfileLink: $8fcdbf2d7a4660c6$var$UserProfileLink,
    MenuItems: $8fcdbf2d7a4660c6$var$MenuItems,
    Action: $8fcdbf2d7a4660c6$var$MenuAction,
    Link: $8fcdbf2d7a4660c6$var$MenuLink,
    __experimental_Outlet: $8fcdbf2d7a4660c6$var$UserButtonOutlet
});
function $8fcdbf2d7a4660c6$var$OrganizationProfilePage({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$organizationProfilePageRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
function $8fcdbf2d7a4660c6$var$OrganizationProfileLink({ children: children }) {
    (0, $52b16e2619eaae81$export$dcbd8d97225896c0)($8fcdbf2d7a4660c6$var$organizationProfileLinkRenderedError);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, children);
}
var $8fcdbf2d7a4660c6$var$_OrganizationProfile = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $8fcdbf2d7a4660c6$var$useOrganizationProfileCustomPages(props.children);
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountOrganizationProfile,
        unmount: clerk.unmountOrganizationProfile,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            customPages: customPages
        },
        rootProps: rendererRootProps
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$CustomPortalsRenderer, {
        customPagesPortals: customPagesPortals
    })));
}, {
    component: "OrganizationProfile",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$OrganizationProfile = Object.assign($8fcdbf2d7a4660c6$var$_OrganizationProfile, {
    Page: $8fcdbf2d7a4660c6$var$OrganizationProfilePage,
    Link: $8fcdbf2d7a4660c6$var$OrganizationProfileLink
});
var $8fcdbf2d7a4660c6$var$CreateOrganization = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountCreateOrganization,
        unmount: clerk.unmountCreateOrganization,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "CreateOrganization",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$OrganizationSwitcherContext = (0, $8fcdbf2d7a4660c6$var$import_react13.createContext)({
    mount: ()=>{},
    unmount: ()=>{},
    updateProps: ()=>{}
});
var $8fcdbf2d7a4660c6$var$_OrganizationSwitcher = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    const { customPages: customPages, customPagesPortals: customPagesPortals } = $8fcdbf2d7a4660c6$var$useOrganizationProfileCustomPages(props.children, {
        allowForAnyChildren: !!props.__experimental_asProvider
    });
    const organizationProfileProps = {
        ...props.organizationProfileProps,
        customPages: customPages
    };
    const sanitizedChildren = $8fcdbf2d7a4660c6$var$useSanitizedChildren(props.children);
    const passableProps = {
        mount: clerk.mountOrganizationSwitcher,
        unmount: clerk.unmountOrganizationSwitcher,
        updateProps: clerk.__unstable__updateProps,
        props: {
            ...props,
            organizationProfileProps: organizationProfileProps
        },
        rootProps: rendererRootProps,
        component: component
    };
    clerk.__experimental_prefetchOrganizationSwitcher();
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$OrganizationSwitcherContext.Provider, {
        value: passableProps
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        ...passableProps,
        hideRootHtmlElement: !!props.__experimental_asProvider
    }, props.__experimental_asProvider ? sanitizedChildren : null, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$CustomPortalsRenderer, {
        customPagesPortals: customPagesPortals
    }))));
}, {
    component: "OrganizationSwitcher",
    renderWhileLoading: true
});
function $8fcdbf2d7a4660c6$var$OrganizationSwitcherOutlet(outletProps) {
    const providerProps = (0, $8fcdbf2d7a4660c6$var$import_react13.useContext)($8fcdbf2d7a4660c6$var$OrganizationSwitcherContext);
    const portalProps = {
        ...providerProps,
        props: {
            ...providerProps.props,
            ...outletProps
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        ...portalProps
    });
}
var $8fcdbf2d7a4660c6$var$OrganizationSwitcher = Object.assign($8fcdbf2d7a4660c6$var$_OrganizationSwitcher, {
    OrganizationProfilePage: $8fcdbf2d7a4660c6$var$OrganizationProfilePage,
    OrganizationProfileLink: $8fcdbf2d7a4660c6$var$OrganizationProfileLink,
    __experimental_Outlet: $8fcdbf2d7a4660c6$var$OrganizationSwitcherOutlet
});
var $8fcdbf2d7a4660c6$var$OrganizationList = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountOrganizationList,
        unmount: clerk.unmountOrganizationList,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "OrganizationList",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$GoogleOneTap = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        open: clerk.openGoogleOneTap,
        close: clerk.closeGoogleOneTap,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "GoogleOneTap",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$Waitlist = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountWaitlist,
        unmount: clerk.unmountWaitlist,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "Waitlist",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$PricingTable = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component, {
        // This attribute is added to the PricingTable root element after we've successfully fetched the plans asynchronously.
        selector: '[data-component-status="ready"]'
    });
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountPricingTable,
        unmount: clerk.unmountPricingTable,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "PricingTable",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$APIKeys = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountAPIKeys,
        unmount: clerk.unmountAPIKeys,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "ApiKeys",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$UserAvatar = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountUserAvatar,
        unmount: clerk.unmountUserAvatar,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "UserAvatar",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$TaskChooseOrganization = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountTaskChooseOrganization,
        unmount: clerk.unmountTaskChooseOrganization,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "TaskChooseOrganization",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$TaskResetPassword = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountTaskResetPassword,
        unmount: clerk.unmountTaskResetPassword,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "TaskResetPassword",
    renderWhileLoading: true
});
var $8fcdbf2d7a4660c6$var$TaskSetupMFA = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, component: component, fallback: fallback, ...props })=>{
    const mountingStatus = $8fcdbf2d7a4660c6$var$useWaitForComponentMount(component);
    const shouldShowFallback = mountingStatus === "rendering" || !clerk.loaded;
    const rendererRootProps = {
        ...shouldShowFallback && fallback && {
            style: {
                display: "none"
            }
        }
    };
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$import_react13.default.Fragment, null, shouldShowFallback && fallback, clerk.loaded && /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react13.default.createElement($8fcdbf2d7a4660c6$var$ClerkHostRenderer, {
        component: component,
        mount: clerk.mountTaskSetupMFA,
        unmount: clerk.unmountTaskSetupMFA,
        updateProps: clerk.__unstable__updateProps,
        props: props,
        rootProps: rendererRootProps
    }));
}, {
    component: "TaskSetupMFA",
    renderWhileLoading: true
});
var $10ffe1346e6184d5$export$cdd73fc4100a6ef4;
var $10ffe1346e6184d5$export$ca2885c0904e45dc;
var $10ffe1346e6184d5$export$d68428e00cc00eb4;

var $869fa2048fb73b00$exports = {};

//#region src/deprecated.ts
/**
* Mark class method / function as deprecated.
*
* A console WARNING will be displayed when class method / function is invoked.
*
* Examples
* 1. Deprecate class method
* class Example {
*   getSomething = (arg1, arg2) => {
*       deprecated('Example.getSomething', 'Use `getSomethingElse` instead.');
*       return `getSomethingValue:${arg1 || '-'}:${arg2 || '-'}`;
*   };
* }
*
* 2. Deprecate function
* const getSomething = () => {
*   deprecated('getSomething', 'Use `getSomethingElse` instead.');
*   return 'getSomethingValue';
* };
*/ const $869fa2048fb73b00$var$displayedWarnings = /* @__PURE__ */ new Set();
const $869fa2048fb73b00$var$deprecated = (fnName, warning, key)=>{
    const hideWarning = $66268821e8eb5cee$exports.isTestEnvironment() || $66268821e8eb5cee$exports.isProductionEnvironment();
    const messageId = key ?? fnName;
    if ($869fa2048fb73b00$var$displayedWarnings.has(messageId) || hideWarning) return;
    $869fa2048fb73b00$var$displayedWarnings.add(messageId);
    console.warn(`Clerk - DEPRECATION WARNING: "${fnName}" is deprecated and will be removed in the next major release.\n${warning}`);
};
const $869fa2048fb73b00$var$deprecatedProperty = (cls, propName, warning, isStatic = false)=>{
    const target = isStatic ? cls : cls.prototype;
    let value = target[propName];
    Object.defineProperty(target, propName, {
        get () {
            $869fa2048fb73b00$var$deprecated(propName, warning, `${cls.name}:${propName}`);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};
/**
* Mark object property as deprecated.
*
* A console WARNING will be displayed when object property is being accessed.
*
* 1. Deprecate object property
* const obj = { something: 'aloha' };
*
* deprecatedObjectProperty(obj, 'something', 'Use `somethingElse` instead.');
*/ const $869fa2048fb73b00$var$deprecatedObjectProperty = (obj, propName, warning, key)=>{
    let value = obj[propName];
    Object.defineProperty(obj, propName, {
        get () {
            $869fa2048fb73b00$var$deprecated(propName, warning, key);
            return value;
        },
        set (v) {
            value = v;
        }
    });
};
//#endregion
Object.defineProperty($869fa2048fb73b00$exports, 'deprecated', {
    enumerable: true,
    get: function() {
        return $869fa2048fb73b00$var$deprecated;
    }
});
Object.defineProperty($869fa2048fb73b00$exports, 'deprecatedObjectProperty', {
    enumerable: true,
    get: function() {
        return $869fa2048fb73b00$var$deprecatedObjectProperty;
    }
});
Object.defineProperty($869fa2048fb73b00$exports, 'deprecatedProperty', {
    enumerable: true,
    get: function() {
        return $869fa2048fb73b00$var$deprecatedProperty;
    }
});


$10ffe1346e6184d5$export$cdd73fc4100a6ef4 = $869fa2048fb73b00$exports.deprecated;
$10ffe1346e6184d5$export$ca2885c0904e45dc = $869fa2048fb73b00$exports.deprecatedObjectProperty;
$10ffe1346e6184d5$export$d68428e00cc00eb4 = $869fa2048fb73b00$exports.deprecatedProperty;



var $8fcdbf2d7a4660c6$var$import_react21 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));

var $511b68c7c2788786$export$6ab8587add194729;
var $511b68c7c2788786$export$6cb0e39a8dd8e0cd;
var $511b68c7c2788786$export$f143a0bd61f2115f;
var $511b68c7c2788786$export$c303b521fcf96f9d;

$511b68c7c2788786$export$6ab8587add194729 = $c9f343945e2fea5f$exports.createCheckAuthorization;
$511b68c7c2788786$export$6cb0e39a8dd8e0cd = $c9f343945e2fea5f$exports.resolveAuthState;
$511b68c7c2788786$export$f143a0bd61f2115f = $c9f343945e2fea5f$exports.splitByScope;
$511b68c7c2788786$export$c303b521fcf96f9d = $c9f343945e2fea5f$exports.validateReverificationConfig;


var $90614a09d8ed00cc$export$cac4fd43603a9893;
var $90614a09d8ed00cc$export$1c851175dd2f76a0;
var $90614a09d8ed00cc$export$318866ac934f59ab;
var $90614a09d8ed00cc$export$c9aaca9e75fd1c3e;
var $90614a09d8ed00cc$export$155437781d1ee21;
var $90614a09d8ed00cc$export$308122c89739dc09;
var $90614a09d8ed00cc$export$15fe7f74b54c0909;
var $90614a09d8ed00cc$export$c4c5fd4a6bc1a356;
var $90614a09d8ed00cc$export$1a2a2df10c75c58a;






$90614a09d8ed00cc$export$cac4fd43603a9893 = $77d689860cf967c8$exports.EVENT_SAMPLING_RATE;
$90614a09d8ed00cc$export$1c851175dd2f76a0 = $77d689860cf967c8$exports.EVENT_THEME_USAGE;
$90614a09d8ed00cc$export$318866ac934f59ab = $77d689860cf967c8$exports.TelemetryCollector;
$90614a09d8ed00cc$export$c9aaca9e75fd1c3e = $77d689860cf967c8$exports.eventComponentMounted;
$90614a09d8ed00cc$export$155437781d1ee21 = $77d689860cf967c8$exports.eventFrameworkMetadata;
$90614a09d8ed00cc$export$308122c89739dc09 = $77d689860cf967c8$exports.eventMethodCalled;
$90614a09d8ed00cc$export$15fe7f74b54c0909 = $77d689860cf967c8$exports.eventPrebuiltComponentMounted;
$90614a09d8ed00cc$export$c4c5fd4a6bc1a356 = $77d689860cf967c8$exports.eventPrebuiltComponentOpened;
$90614a09d8ed00cc$export$1a2a2df10c75c58a = $77d689860cf967c8$exports.eventThemeUsage;




var [$8fcdbf2d7a4660c6$var$AuthContext, $8fcdbf2d7a4660c6$var$useAuthContext] = (0, $a0ea147aab9dedc4$export$b4f021037e6d7d3f)("AuthContext");
// src/hooks/utils.ts
var $8fcdbf2d7a4660c6$var$clerkLoaded = (isomorphicClerk)=>{
    return new Promise((resolve)=>{
        const handler = (status)=>{
            if ([
                "ready",
                "degraded"
            ].includes(status)) {
                resolve();
                isomorphicClerk.off("status", handler);
            }
        };
        isomorphicClerk.on("status", handler, {
            notify: true
        });
    });
};
var $8fcdbf2d7a4660c6$var$createGetToken = (isomorphicClerk)=>{
    return async (options)=>{
        await $8fcdbf2d7a4660c6$var$clerkLoaded(isomorphicClerk);
        if (!isomorphicClerk.session) return null;
        return isomorphicClerk.session.getToken(options);
    };
};
var $8fcdbf2d7a4660c6$var$createSignOut = (isomorphicClerk)=>{
    return async (...args)=>{
        await $8fcdbf2d7a4660c6$var$clerkLoaded(isomorphicClerk);
        return isomorphicClerk.signOut(...args);
    };
};
// src/hooks/useAuth.ts
var $8fcdbf2d7a4660c6$var$useAuth = (initialAuthStateOrOptions = {})=>{
    var _a;
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("useAuth");
    const { treatPendingAsSignedOut: treatPendingAsSignedOut, ...rest } = initialAuthStateOrOptions != null ? initialAuthStateOrOptions : {};
    const initialAuthState = rest;
    const authContextFromHook = $8fcdbf2d7a4660c6$var$useAuthContext();
    let authContext = authContextFromHook;
    if (authContext.sessionId === void 0 && authContext.userId === void 0) authContext = initialAuthState != null ? initialAuthState : {};
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    const getToken = (0, (parcelRequire("acw62")).useCallback)($8fcdbf2d7a4660c6$var$createGetToken(isomorphicClerk), [
        isomorphicClerk
    ]);
    const signOut = (0, (parcelRequire("acw62")).useCallback)($8fcdbf2d7a4660c6$var$createSignOut(isomorphicClerk), [
        isomorphicClerk
    ]);
    (_a = isomorphicClerk.telemetry) == null || _a.record((0, $90614a09d8ed00cc$export$308122c89739dc09)("useAuth", {
        treatPendingAsSignedOut: treatPendingAsSignedOut
    }));
    return $8fcdbf2d7a4660c6$var$useDerivedAuth({
        ...authContext,
        getToken: getToken,
        signOut: signOut
    }, {
        treatPendingAsSignedOut: treatPendingAsSignedOut
    });
};
function $8fcdbf2d7a4660c6$var$useDerivedAuth(authObject, { treatPendingAsSignedOut: treatPendingAsSignedOut = true } = {}) {
    const { userId: userId, orgId: orgId, orgRole: orgRole, has: has, signOut: signOut, getToken: getToken, orgPermissions: orgPermissions, factorVerificationAge: factorVerificationAge, sessionClaims: sessionClaims } = authObject != null ? authObject : {};
    const derivedHas = (0, (parcelRequire("acw62")).useCallback)((params)=>{
        if (has) return has(params);
        return (0, $511b68c7c2788786$export$6ab8587add194729)({
            userId: userId,
            orgId: orgId,
            orgRole: orgRole,
            orgPermissions: orgPermissions,
            factorVerificationAge: factorVerificationAge,
            features: (sessionClaims == null ? void 0 : sessionClaims.fea) || "",
            plans: (sessionClaims == null ? void 0 : sessionClaims.pla) || ""
        })(params);
    }, [
        has,
        userId,
        orgId,
        orgRole,
        orgPermissions,
        factorVerificationAge,
        sessionClaims
    ]);
    const payload = (0, $511b68c7c2788786$export$6cb0e39a8dd8e0cd)({
        authObject: {
            ...authObject,
            getToken: getToken,
            signOut: signOut,
            has: derivedHas
        },
        options: {
            treatPendingAsSignedOut: treatPendingAsSignedOut
        }
    });
    if (!payload) return $8fcdbf2d7a4660c6$var$errorThrower.throw($8fcdbf2d7a4660c6$var$invalidStateError);
    return payload;
}

// src/hooks/useEmailLink.ts
var $8fcdbf2d7a4660c6$var$import_react17 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
function $8fcdbf2d7a4660c6$var$useEmailLink(resource) {
    const { startEmailLinkFlow: startEmailLinkFlow, cancelEmailLinkFlow: cancelEmailLinkFlow } = $8fcdbf2d7a4660c6$var$import_react17.default.useMemo(()=>resource.createEmailLinkFlow(), [
        resource
    ]);
    $8fcdbf2d7a4660c6$var$import_react17.default.useEffect(()=>{
        return cancelEmailLinkFlow;
    }, []);
    return {
        startEmailLinkFlow: startEmailLinkFlow,
        cancelEmailLinkFlow: cancelEmailLinkFlow
    };
}


var $8fcdbf2d7a4660c6$var$useSignIn = ()=>{
    var _a;
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("useSignIn");
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    const client = (0, $a0ea147aab9dedc4$export$6627e187bf6ba3fd)();
    (_a = isomorphicClerk.telemetry) == null || _a.record((0, $90614a09d8ed00cc$export$308122c89739dc09)("useSignIn"));
    if (!client) return {
        isLoaded: false,
        signIn: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        signIn: client.signIn,
        setActive: isomorphicClerk.setActive
    };
};


var $8fcdbf2d7a4660c6$var$useSignUp = ()=>{
    var _a;
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("useSignUp");
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    const client = (0, $a0ea147aab9dedc4$export$6627e187bf6ba3fd)();
    (_a = isomorphicClerk.telemetry) == null || _a.record((0, $90614a09d8ed00cc$export$308122c89739dc09)("useSignUp"));
    if (!client) return {
        isLoaded: false,
        signUp: void 0,
        setActive: void 0
    };
    return {
        isLoaded: true,
        signUp: client.signUp,
        setActive: isomorphicClerk.setActive
    };
};

// src/components/controlComponents.tsx
var $8fcdbf2d7a4660c6$var$SignedIn = ({ children: children, treatPendingAsSignedOut: treatPendingAsSignedOut })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("SignedIn");
    const { userId: userId } = $8fcdbf2d7a4660c6$var$useAuth({
        treatPendingAsSignedOut: treatPendingAsSignedOut
    });
    if (userId) return children;
    return null;
};
var $8fcdbf2d7a4660c6$var$SignedOut = ({ children: children, treatPendingAsSignedOut: treatPendingAsSignedOut })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("SignedOut");
    const { userId: userId } = $8fcdbf2d7a4660c6$var$useAuth({
        treatPendingAsSignedOut: treatPendingAsSignedOut
    });
    if (userId === null) return children;
    return null;
};
var $8fcdbf2d7a4660c6$var$ClerkLoaded = ({ children: children })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("ClerkLoaded");
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    if (!isomorphicClerk.loaded) return null;
    return children;
};
var $8fcdbf2d7a4660c6$var$ClerkLoading = ({ children: children })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("ClerkLoading");
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    if (isomorphicClerk.status !== "loading") return null;
    return children;
};
var $8fcdbf2d7a4660c6$var$ClerkFailed = ({ children: children })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("ClerkFailed");
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    if (isomorphicClerk.status !== "error") return null;
    return children;
};
var $8fcdbf2d7a4660c6$var$ClerkDegraded = ({ children: children })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("ClerkDegraded");
    const isomorphicClerk = $8fcdbf2d7a4660c6$var$useIsomorphicClerkContext();
    if (isomorphicClerk.status !== "degraded") return null;
    return children;
};
var $8fcdbf2d7a4660c6$var$Protect = ({ children: children, fallback: fallback, treatPendingAsSignedOut: treatPendingAsSignedOut, ...restAuthorizedParams })=>{
    $8fcdbf2d7a4660c6$var$useAssertWrappedByClerkProvider("Protect");
    const { isLoaded: isLoaded, has: has, userId: userId } = $8fcdbf2d7a4660c6$var$useAuth({
        treatPendingAsSignedOut: treatPendingAsSignedOut
    });
    if (!isLoaded) return null;
    const unauthorized = fallback != null ? fallback : null;
    const authorized = children;
    if (!userId) return unauthorized;
    if (typeof restAuthorizedParams.condition === "function") {
        if (restAuthorizedParams.condition(has)) return authorized;
        return unauthorized;
    }
    if (restAuthorizedParams.role || restAuthorizedParams.permission || restAuthorizedParams.feature || restAuthorizedParams.plan) {
        if (has(restAuthorizedParams)) return authorized;
        return unauthorized;
    }
    return authorized;
};
var $8fcdbf2d7a4660c6$var$RedirectToSignIn = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, ...props })=>{
    const { client: client, session: session } = clerk;
    const hasSignedInSessions = client.signedInSessions ? client.signedInSessions.length > 0 : // Compat for clerk-js<5.54.0 (which was released with the `signedInSessions` property)
    client.activeSessions && client.activeSessions.length > 0;
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        if (session === null && hasSignedInSessions) clerk.redirectToAfterSignOut();
        else clerk.redirectToSignIn(props);
    }, []);
    return null;
}, "RedirectToSignIn");
var $8fcdbf2d7a4660c6$var$RedirectToSignUp = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, ...props })=>{
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        clerk.redirectToSignUp(props);
    }, []);
    return null;
}, "RedirectToSignUp");
var $8fcdbf2d7a4660c6$var$RedirectToTasks = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, ...props })=>{
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        clerk.redirectToTasks(props);
    }, []);
    return null;
}, "RedirectToTasks");
var $8fcdbf2d7a4660c6$var$RedirectToUserProfile = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk })=>{
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        (0, $10ffe1346e6184d5$export$cdd73fc4100a6ef4)("RedirectToUserProfile", "Use the `redirectToUserProfile()` method instead.");
        clerk.redirectToUserProfile();
    }, []);
    return null;
}, "RedirectToUserProfile");
var $8fcdbf2d7a4660c6$var$RedirectToOrganizationProfile = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk })=>{
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        (0, $10ffe1346e6184d5$export$cdd73fc4100a6ef4)("RedirectToOrganizationProfile", "Use the `redirectToOrganizationProfile()` method instead.");
        clerk.redirectToOrganizationProfile();
    }, []);
    return null;
}, "RedirectToOrganizationProfile");
var $8fcdbf2d7a4660c6$var$RedirectToCreateOrganization = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk })=>{
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        (0, $10ffe1346e6184d5$export$cdd73fc4100a6ef4)("RedirectToCreateOrganization", "Use the `redirectToCreateOrganization()` method instead.");
        clerk.redirectToCreateOrganization();
    }, []);
    return null;
}, "RedirectToCreateOrganization");
var $8fcdbf2d7a4660c6$var$AuthenticateWithRedirectCallback = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, ...handleRedirectCallbackParams })=>{
    $8fcdbf2d7a4660c6$var$import_react21.default.useEffect(()=>{
        clerk.handleRedirectCallback(handleRedirectCallbackParams);
    }, []);
    return null;
}, "AuthenticateWithRedirectCallback");

// src/components/SignInButton.tsx
var $8fcdbf2d7a4660c6$var$import_react22 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$SignInButton = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { appearance: // @ts-expect-error - appearance is a valid prop for SignInProps & SignInButtonPropsModal
    appearance, signUpFallbackRedirectUrl: signUpFallbackRedirectUrl, forceRedirectUrl: forceRedirectUrl, fallbackRedirectUrl: fallbackRedirectUrl, signUpForceRedirectUrl: signUpForceRedirectUrl, mode: mode, initialValues: initialValues, withSignUp: withSignUp, oauthFlow: oauthFlow, ...rest } = props;
    children = $8fcdbf2d7a4660c6$var$normalizeWithDefaultValue(children, "Sign in");
    const child = $8fcdbf2d7a4660c6$var$assertSingleChild(children)("SignInButton");
    const clickHandler = ()=>{
        const opts = {
            forceRedirectUrl: forceRedirectUrl,
            fallbackRedirectUrl: fallbackRedirectUrl,
            signUpFallbackRedirectUrl: signUpFallbackRedirectUrl,
            signUpForceRedirectUrl: signUpForceRedirectUrl,
            initialValues: initialValues,
            withSignUp: withSignUp,
            oauthFlow: oauthFlow
        };
        if (mode === "modal") return clerk.openSignIn({
            ...opts,
            appearance: appearance
        });
        return clerk.redirectToSignIn({
            ...opts,
            signInFallbackRedirectUrl: fallbackRedirectUrl,
            signInForceRedirectUrl: forceRedirectUrl
        });
    };
    const wrappedChildClickHandler = async (e)=>{
        if (child && typeof child === "object" && "props" in child) await $8fcdbf2d7a4660c6$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $8fcdbf2d7a4660c6$var$import_react22.default.cloneElement(child, childProps);
}, {
    component: "SignInButton",
    renderWhileLoading: true
});

// src/components/SignInWithMetamaskButton.tsx
var $8fcdbf2d7a4660c6$var$import_react23 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$SignInWithMetamaskButton = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { redirectUrl: redirectUrl, ...rest } = props;
    children = $8fcdbf2d7a4660c6$var$normalizeWithDefaultValue(children, "Sign in with Metamask");
    const child = $8fcdbf2d7a4660c6$var$assertSingleChild(children)("SignInWithMetamaskButton");
    const clickHandler = async ()=>{
        async function authenticate() {
            await clerk.authenticateWithMetamask({
                redirectUrl: redirectUrl || void 0
            });
        }
        authenticate();
    };
    const wrappedChildClickHandler = async (e)=>{
        await $8fcdbf2d7a4660c6$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $8fcdbf2d7a4660c6$var$import_react23.default.cloneElement(child, childProps);
}, {
    component: "SignInWithMetamask",
    renderWhileLoading: true
});

// src/components/SignOutButton.tsx
var $8fcdbf2d7a4660c6$var$import_react24 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$SignOutButton = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { redirectUrl: redirectUrl = "/", signOutOptions: signOutOptions, ...rest } = props;
    children = $8fcdbf2d7a4660c6$var$normalizeWithDefaultValue(children, "Sign out");
    const child = $8fcdbf2d7a4660c6$var$assertSingleChild(children)("SignOutButton");
    const clickHandler = ()=>clerk.signOut({
            redirectUrl: redirectUrl,
            ...signOutOptions
        });
    const wrappedChildClickHandler = async (e)=>{
        await $8fcdbf2d7a4660c6$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $8fcdbf2d7a4660c6$var$import_react24.default.cloneElement(child, childProps);
}, {
    component: "SignOutButton",
    renderWhileLoading: true
});

// src/components/SignUpButton.tsx
var $8fcdbf2d7a4660c6$var$import_react25 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $8fcdbf2d7a4660c6$var$SignUpButton = $8fcdbf2d7a4660c6$var$withClerk(({ clerk: clerk, children: children, ...props })=>{
    const { appearance: // @ts-expect-error - appearance is a valid prop for SignUpProps & SignUpButtonPropsModal
    appearance, unsafeMetadata: // @ts-expect-error - unsafeMetadata is a valid prop for SignUpProps & SignUpButtonPropsModal
    unsafeMetadata, fallbackRedirectUrl: fallbackRedirectUrl, forceRedirectUrl: forceRedirectUrl, signInFallbackRedirectUrl: signInFallbackRedirectUrl, signInForceRedirectUrl: signInForceRedirectUrl, mode: mode, initialValues: initialValues, oauthFlow: oauthFlow, ...rest } = props;
    children = $8fcdbf2d7a4660c6$var$normalizeWithDefaultValue(children, "Sign up");
    const child = $8fcdbf2d7a4660c6$var$assertSingleChild(children)("SignUpButton");
    const clickHandler = ()=>{
        const opts = {
            fallbackRedirectUrl: fallbackRedirectUrl,
            forceRedirectUrl: forceRedirectUrl,
            signInFallbackRedirectUrl: signInFallbackRedirectUrl,
            signInForceRedirectUrl: signInForceRedirectUrl,
            initialValues: initialValues,
            oauthFlow: oauthFlow
        };
        if (mode === "modal") return clerk.openSignUp({
            ...opts,
            appearance: appearance,
            unsafeMetadata: unsafeMetadata
        });
        return clerk.redirectToSignUp({
            ...opts,
            signUpFallbackRedirectUrl: fallbackRedirectUrl,
            signUpForceRedirectUrl: forceRedirectUrl
        });
    };
    const wrappedChildClickHandler = async (e)=>{
        if (child && typeof child === "object" && "props" in child) await $8fcdbf2d7a4660c6$var$safeExecute(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = {
        ...rest,
        onClick: wrappedChildClickHandler
    };
    return $8fcdbf2d7a4660c6$var$import_react25.default.cloneElement(child, childProps);
}, {
    component: "SignUpButton",
    renderWhileLoading: true
});
var $af7e0eb6fefeb2a7$export$dbd57dddc2edde62;
var $af7e0eb6fefeb2a7$export$31072de0539b233;
var $af7e0eb6fefeb2a7$export$52d84fe94e4fd93e;
var $af7e0eb6fefeb2a7$export$85d96f06a34a9d8d;
var $af7e0eb6fefeb2a7$export$a30a343dc8ff4c48;
var $af7e0eb6fefeb2a7$export$38e7653bfea64017;
var $af7e0eb6fefeb2a7$export$d54f964636f02161;
var $af7e0eb6fefeb2a7$export$353fd809954af292;
var $af7e0eb6fefeb2a7$export$e7b0b0686142f5e8;
var $af7e0eb6fefeb2a7$export$e714dbd47ccca8af;




$af7e0eb6fefeb2a7$export$dbd57dddc2edde62 = $6fcb8ff7a3b82d27$exports.buildPublishableKey;
$af7e0eb6fefeb2a7$export$31072de0539b233 = $6fcb8ff7a3b82d27$exports.createDevOrStagingUrlCache;
$af7e0eb6fefeb2a7$export$52d84fe94e4fd93e = $6fcb8ff7a3b82d27$exports.getCookieSuffix;
$af7e0eb6fefeb2a7$export$85d96f06a34a9d8d = $6fcb8ff7a3b82d27$exports.getSuffixedCookieName;
$af7e0eb6fefeb2a7$export$a30a343dc8ff4c48 = $6fcb8ff7a3b82d27$exports.isDevelopmentFromPublishableKey;
$af7e0eb6fefeb2a7$export$38e7653bfea64017 = $6fcb8ff7a3b82d27$exports.isDevelopmentFromSecretKey;
$af7e0eb6fefeb2a7$export$d54f964636f02161 = $6fcb8ff7a3b82d27$exports.isProductionFromPublishableKey;
$af7e0eb6fefeb2a7$export$353fd809954af292 = $6fcb8ff7a3b82d27$exports.isProductionFromSecretKey;
$af7e0eb6fefeb2a7$export$e7b0b0686142f5e8 = $6fcb8ff7a3b82d27$exports.isPublishableKey;
$af7e0eb6fefeb2a7$export$e714dbd47ccca8af = $6fcb8ff7a3b82d27$exports.parsePublishableKey;



var $8fcdbf2d7a4660c6$var$import_react28 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $df9ca5d4039ff5c4$export$485fc5c1dea91f96;
var $5082f3f093624746$exports = {};
//#region src/deriveState.ts
/**
* Derives authentication state based on the current rendering context (SSR or client-side).
*/ const $5082f3f093624746$var$deriveState = (clerkOperational, state, initialState)=>{
    if (!clerkOperational && initialState) return $5082f3f093624746$var$deriveFromSsrInitialState(initialState);
    return $5082f3f093624746$var$deriveFromClientSideState(state);
};
const $5082f3f093624746$var$deriveFromSsrInitialState = (initialState)=>{
    const userId = initialState.userId;
    const user = initialState.user;
    const sessionId = initialState.sessionId;
    const sessionStatus = initialState.sessionStatus;
    const sessionClaims = initialState.sessionClaims;
    return {
        userId: userId,
        user: user,
        sessionId: sessionId,
        session: initialState.session,
        sessionStatus: sessionStatus,
        sessionClaims: sessionClaims,
        organization: initialState.organization,
        orgId: initialState.orgId,
        orgRole: initialState.orgRole,
        orgPermissions: initialState.orgPermissions,
        orgSlug: initialState.orgSlug,
        actor: initialState.actor,
        factorVerificationAge: initialState.factorVerificationAge
    };
};
const $5082f3f093624746$var$deriveFromClientSideState = (state)=>{
    const userId = state.user ? state.user.id : state.user;
    const user = state.user;
    const sessionId = state.session ? state.session.id : state.session;
    const session = state.session;
    const sessionStatus = state.session?.status;
    const sessionClaims = state.session ? state.session.lastActiveToken?.jwt?.claims : null;
    const factorVerificationAge = state.session ? state.session.factorVerificationAge : null;
    const actor = session?.actor;
    const organization = state.organization;
    const orgId = state.organization ? state.organization.id : state.organization;
    const orgSlug = organization?.slug;
    const membership = organization ? user?.organizationMemberships?.find((om)=>om.organization.id === orgId) : organization;
    const orgPermissions = membership ? membership.permissions : membership;
    return {
        userId: userId,
        user: user,
        sessionId: sessionId,
        session: session,
        sessionStatus: sessionStatus,
        sessionClaims: sessionClaims,
        organization: organization,
        orgId: orgId,
        orgRole: membership ? membership.role : membership,
        orgSlug: orgSlug,
        orgPermissions: orgPermissions,
        actor: actor,
        factorVerificationAge: factorVerificationAge
    };
};
//#endregion
Object.defineProperty($5082f3f093624746$exports, 'deriveState', {
    enumerable: true,
    get: function() {
        return $5082f3f093624746$var$deriveState;
    }
});


$df9ca5d4039ff5c4$export$485fc5c1dea91f96 = $5082f3f093624746$exports.deriveState;




var $8fcdbf2d7a4660c6$var$import_react27 = $8fcdbf2d7a4660c6$var$__toESM((parcelRequire("acw62")));
var $3c17c37c0544ec6b$export$620a268685f0ac45;
var $3c17c37c0544ec6b$export$57005382866d8adf;
var $3c17c37c0544ec6b$export$73a23530231203d2;
var $3c17c37c0544ec6b$export$aa41b89db26550c5;
var $3c17c37c0544ec6b$export$ee1feddd3a5d12c9;
var $4ca935466c68ed58$exports = {};
//#region src/browser.ts
/**
* Checks if the window object is defined. You can also use this to check if something is happening on the client side.
* @returns {boolean}
*/ function $4ca935466c68ed58$var$inBrowser() {
    return typeof window !== "undefined";
}
const $4ca935466c68ed58$var$botAgentRegex = new RegExp([
    "bot",
    "spider",
    "crawl",
    "APIs-Google",
    "AdsBot",
    "Googlebot",
    "mediapartners",
    "Google Favicon",
    "FeedFetcher",
    "Google-Read-Aloud",
    "DuplexWeb-Google",
    "googleweblight",
    "bing",
    "yandex",
    "baidu",
    "duckduck",
    "yahoo",
    "ecosia",
    "ia_archiver",
    "facebook",
    "instagram",
    "pinterest",
    "reddit",
    "slack",
    "twitter",
    "whatsapp",
    "youtube",
    "semrush"
].join("|"), "i");
/**
* Checks if the user agent is a bot.
* @param userAgent - Any user agent string
* @returns {boolean}
*/ function $4ca935466c68ed58$var$userAgentIsRobot(userAgent) {
    return !userAgent ? false : $4ca935466c68ed58$var$botAgentRegex.test(userAgent);
}
/**
* Checks if the current environment is a browser and the user agent is not a bot.
* @returns {boolean}
*/ function $4ca935466c68ed58$var$isValidBrowser() {
    const navigator = $4ca935466c68ed58$var$inBrowser() ? window?.navigator : null;
    if (!navigator) return false;
    return !$4ca935466c68ed58$var$userAgentIsRobot(navigator?.userAgent) && !navigator?.webdriver;
}
/**
* Checks if the current environment is a browser and if the navigator is online.
* @returns {boolean}
*/ function $4ca935466c68ed58$var$isBrowserOnline() {
    const navigator = $4ca935466c68ed58$var$inBrowser() ? window?.navigator : null;
    if (!navigator) return false;
    const isNavigatorOnline = navigator?.onLine;
    return navigator?.connection?.rtt !== 0 && navigator?.connection?.downlink !== 0 && isNavigatorOnline;
}
/**
* Runs `isBrowserOnline` and `isValidBrowser` to check if the current environment is a valid browser and if the navigator is online.
* @returns {boolean}
*/ function $4ca935466c68ed58$var$isValidBrowserOnline() {
    return $4ca935466c68ed58$var$isBrowserOnline() && $4ca935466c68ed58$var$isValidBrowser();
}
//#endregion
Object.defineProperty($4ca935466c68ed58$exports, 'inBrowser', {
    enumerable: true,
    get: function() {
        return $4ca935466c68ed58$var$inBrowser;
    }
});
Object.defineProperty($4ca935466c68ed58$exports, 'isBrowserOnline', {
    enumerable: true,
    get: function() {
        return $4ca935466c68ed58$var$isBrowserOnline;
    }
});
Object.defineProperty($4ca935466c68ed58$exports, 'isValidBrowser', {
    enumerable: true,
    get: function() {
        return $4ca935466c68ed58$var$isValidBrowser;
    }
});
Object.defineProperty($4ca935466c68ed58$exports, 'isValidBrowserOnline', {
    enumerable: true,
    get: function() {
        return $4ca935466c68ed58$var$isValidBrowserOnline;
    }
});
Object.defineProperty($4ca935466c68ed58$exports, 'userAgentIsRobot', {
    enumerable: true,
    get: function() {
        return $4ca935466c68ed58$var$userAgentIsRobot;
    }
});


$3c17c37c0544ec6b$export$620a268685f0ac45 = $4ca935466c68ed58$exports.inBrowser;
$3c17c37c0544ec6b$export$57005382866d8adf = $4ca935466c68ed58$exports.isBrowserOnline;
$3c17c37c0544ec6b$export$73a23530231203d2 = $4ca935466c68ed58$exports.isValidBrowser;
$3c17c37c0544ec6b$export$aa41b89db26550c5 = $4ca935466c68ed58$exports.isValidBrowserOnline;
$3c17c37c0544ec6b$export$ee1feddd3a5d12c9 = $4ca935466c68ed58$exports.userAgentIsRobot;


//#endregion
var $221c074b1afc6010$export$204ce3a40a17ab2c;
var $221c074b1afc6010$export$b82c36fc307b0a58;
var $a0feceff7542877b$exports = {};
//#region src/eventBus.ts
/**
* @internal
*/ const $a0feceff7542877b$var$_on = (eventToHandlersMap, latestPayloadMap, event, handler, opts)=>{
    const { notify: notify } = opts || {};
    let handlers = eventToHandlersMap.get(event);
    if (!handlers) {
        handlers = [];
        eventToHandlersMap.set(event, handlers);
    }
    handlers.push(handler);
    if (notify && latestPayloadMap.has(event)) handler(latestPayloadMap.get(event));
};
/**
* @internal
*/ const $a0feceff7542877b$var$_dispatch = (eventToHandlersMap, event, payload)=>(eventToHandlersMap.get(event) || []).map((h)=>h(payload));
/**
* @internal
*/ const $a0feceff7542877b$var$_off = (eventToHandlersMap, event, handler)=>{
    const handlers = eventToHandlersMap.get(event);
    if (handlers) {
        if (handler) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        else eventToHandlersMap.set(event, []);
    }
};
/**
* A ES6/2015 compatible 300 byte event bus
*
* Creates a strongly-typed event bus that enables publish/subscribe communication between components.
*
* @template Events - A record type that maps event names to their payload types
* @returns An EventBus instance with the following methods:
* - `on`: Subscribe to an event
* - `onPreDispatch`: Subscribe to an event, triggered before regular subscribers
* - `emit`: Publish an event with payload
* - `off`: Unsubscribe from an event
* - `offPreDispatch`: Unsubscribe from a pre-dispatch event
*
* @example
* // Define event types
* const eventBus = createEventBus<{
*   'user-login': { userId: string; timestamp: number };
*   'data-updated': { records: any[] };
*   'error': Error;
* }>();
*
* // Subscribe to events
* eventBus.on('user-login', ({ userId, timestamp }) => {
*   console.log(`User ${userId} logged in at ${timestamp}`);
* });
*
* // Subscribe with immediate notification if event was already dispatched
* eventBus.on('user-login', (payload) => {
*   // This will be called immediately if 'user-login' was previously dispatched
* }, { notify: true });
*
* // Publish an event
* eventBus.emit('user-login', { userId: 'abc123', timestamp: Date.now() });
*
* // Unsubscribe from event
* const handler = (payload) => console.log(payload);
* eventBus.on('error', handler);
* // Later...
* eventBus.off('error', handler);
*
* // Unsubscribe all handlers for an event
* eventBus.off('data-updated');
*/ const $a0feceff7542877b$var$createEventBus = ()=>{
    const eventToHandlersMap = /* @__PURE__ */ new Map();
    const latestPayloadMap = /* @__PURE__ */ new Map();
    const eventToPredispatchHandlersMap = /* @__PURE__ */ new Map();
    const emit = (event, payload)=>{
        latestPayloadMap.set(event, payload);
        $a0feceff7542877b$var$_dispatch(eventToPredispatchHandlersMap, event, payload);
        $a0feceff7542877b$var$_dispatch(eventToHandlersMap, event, payload);
    };
    return {
        on: (...args)=>$a0feceff7542877b$var$_on(eventToHandlersMap, latestPayloadMap, ...args),
        prioritizedOn: (...args)=>$a0feceff7542877b$var$_on(eventToPredispatchHandlersMap, latestPayloadMap, ...args),
        emit: emit,
        off: (...args)=>$a0feceff7542877b$var$_off(eventToHandlersMap, ...args),
        prioritizedOff: (...args)=>$a0feceff7542877b$var$_off(eventToPredispatchHandlersMap, ...args),
        internal: {
            retrieveListeners: (event)=>eventToHandlersMap.get(event) || []
        }
    };
};
//#endregion
Object.defineProperty($a0feceff7542877b$exports, 'createEventBus', {
    enumerable: true,
    get: function() {
        return $a0feceff7542877b$var$createEventBus;
    }
});


//#region src/clerkEventBus.ts
const $221c074b1afc6010$var$clerkEvents = {
    Status: "status"
};
const $221c074b1afc6010$var$createClerkEventBus = ()=>{
    return $a0feceff7542877b$exports.createEventBus();
};
$221c074b1afc6010$export$204ce3a40a17ab2c = $221c074b1afc6010$var$clerkEvents;
$221c074b1afc6010$export$b82c36fc307b0a58 = $221c074b1afc6010$var$createClerkEventBus;





var $8fcdbf2d7a4660c6$var$defaultSignInErrors = ()=>({
        fields: {
            identifier: null,
            password: null,
            code: null
        },
        raw: null,
        global: null
    });
var $8fcdbf2d7a4660c6$var$defaultSignUpErrors = ()=>({
        fields: {
            firstName: null,
            lastName: null,
            emailAddress: null,
            phoneNumber: null,
            password: null,
            username: null,
            code: null,
            captcha: null,
            legalAccepted: null
        },
        raw: null,
        global: null
    });
var $8fcdbf2d7a4660c6$var$StateProxy = class {
    constructor(isomorphicClerk){
        this.isomorphicClerk = isomorphicClerk;
        this.signInSignalProxy = this.buildSignInProxy();
        this.signUpSignalProxy = this.buildSignUpProxy();
    }
    signInSignal() {
        return this.signInSignalProxy;
    }
    signUpSignal() {
        return this.signUpSignalProxy;
    }
    buildSignInProxy() {
        const gateProperty = this.gateProperty.bind(this);
        const target = ()=>this.client.signIn.__internal_future;
        return {
            errors: $8fcdbf2d7a4660c6$var$defaultSignInErrors(),
            fetchStatus: "idle",
            signIn: {
                status: "needs_identifier",
                availableStrategies: [],
                isTransferable: false,
                get id () {
                    return gateProperty(target, "id", void 0);
                },
                get supportedFirstFactors () {
                    return gateProperty(target, "supportedFirstFactors", []);
                },
                get supportedSecondFactors () {
                    return gateProperty(target, "supportedSecondFactors", []);
                },
                get secondFactorVerification () {
                    return gateProperty(target, "secondFactorVerification", {
                        status: null,
                        error: null,
                        expireAt: null,
                        externalVerificationRedirectURL: null,
                        nonce: null,
                        attempts: null,
                        message: null,
                        strategy: null,
                        verifiedAtClient: null,
                        verifiedFromTheSameClient: ()=>false,
                        __internal_toSnapshot: ()=>{
                            throw new Error("__internal_toSnapshot called before Clerk is loaded");
                        },
                        pathRoot: "",
                        reload: ()=>{
                            throw new Error("__internal_toSnapshot called before Clerk is loaded");
                        }
                    });
                },
                get identifier () {
                    return gateProperty(target, "identifier", null);
                },
                get createdSessionId () {
                    return gateProperty(target, "createdSessionId", null);
                },
                get userData () {
                    return gateProperty(target, "userData", {});
                },
                get firstFactorVerification () {
                    return gateProperty(target, "firstFactorVerification", {
                        status: null,
                        error: null,
                        expireAt: null,
                        externalVerificationRedirectURL: null,
                        nonce: null,
                        attempts: null,
                        message: null,
                        strategy: null,
                        verifiedAtClient: null,
                        verifiedFromTheSameClient: ()=>false,
                        __internal_toSnapshot: ()=>{
                            throw new Error("__internal_toSnapshot called before Clerk is loaded");
                        },
                        pathRoot: "",
                        reload: ()=>{
                            throw new Error("__internal_toSnapshot called before Clerk is loaded");
                        }
                    });
                },
                create: this.gateMethod(target, "create"),
                password: this.gateMethod(target, "password"),
                sso: this.gateMethod(target, "sso"),
                finalize: this.gateMethod(target, "finalize"),
                emailCode: this.wrapMethods(()=>target().emailCode, [
                    "sendCode",
                    "verifyCode"
                ]),
                emailLink: this.wrapStruct(()=>target().emailLink, [
                    "sendLink",
                    "waitForVerification"
                ], [
                    "verification"
                ], {
                    verification: null
                }),
                resetPasswordEmailCode: this.wrapMethods(()=>target().resetPasswordEmailCode, [
                    "sendCode",
                    "verifyCode",
                    "submitPassword"
                ]),
                phoneCode: this.wrapMethods(()=>target().phoneCode, [
                    "sendCode",
                    "verifyCode"
                ]),
                mfa: this.wrapMethods(()=>target().mfa, [
                    "sendPhoneCode",
                    "verifyPhoneCode",
                    "verifyTOTP",
                    "verifyBackupCode"
                ]),
                ticket: this.gateMethod(target, "ticket"),
                passkey: this.gateMethod(target, "passkey"),
                web3: this.gateMethod(target, "web3")
            }
        };
    }
    buildSignUpProxy() {
        const gateProperty = this.gateProperty.bind(this);
        const gateMethod = this.gateMethod.bind(this);
        const wrapMethods = this.wrapMethods.bind(this);
        const target = ()=>this.client.signUp.__internal_future;
        return {
            errors: $8fcdbf2d7a4660c6$var$defaultSignUpErrors(),
            fetchStatus: "idle",
            signUp: {
                get id () {
                    return gateProperty(target, "id", void 0);
                },
                get requiredFields () {
                    return gateProperty(target, "requiredFields", []);
                },
                get optionalFields () {
                    return gateProperty(target, "optionalFields", []);
                },
                get missingFields () {
                    return gateProperty(target, "missingFields", []);
                },
                get username () {
                    return gateProperty(target, "username", null);
                },
                get firstName () {
                    return gateProperty(target, "firstName", null);
                },
                get lastName () {
                    return gateProperty(target, "lastName", null);
                },
                get emailAddress () {
                    return gateProperty(target, "emailAddress", null);
                },
                get phoneNumber () {
                    return gateProperty(target, "phoneNumber", null);
                },
                get web3Wallet () {
                    return gateProperty(target, "web3Wallet", null);
                },
                get hasPassword () {
                    return gateProperty(target, "hasPassword", false);
                },
                get unsafeMetadata () {
                    return gateProperty(target, "unsafeMetadata", {});
                },
                get createdSessionId () {
                    return gateProperty(target, "createdSessionId", null);
                },
                get createdUserId () {
                    return gateProperty(target, "createdUserId", null);
                },
                get abandonAt () {
                    return gateProperty(target, "abandonAt", null);
                },
                get legalAcceptedAt () {
                    return gateProperty(target, "legalAcceptedAt", null);
                },
                get locale () {
                    return gateProperty(target, "locale", null);
                },
                get status () {
                    return gateProperty(target, "status", "missing_requirements");
                },
                get unverifiedFields () {
                    return gateProperty(target, "unverifiedFields", []);
                },
                get isTransferable () {
                    return gateProperty(target, "isTransferable", false);
                },
                create: gateMethod(target, "create"),
                update: gateMethod(target, "update"),
                sso: gateMethod(target, "sso"),
                password: gateMethod(target, "password"),
                ticket: gateMethod(target, "ticket"),
                web3: gateMethod(target, "web3"),
                finalize: gateMethod(target, "finalize"),
                verifications: wrapMethods(()=>target().verifications, [
                    "sendEmailCode",
                    "verifyEmailCode",
                    "sendPhoneCode",
                    "verifyPhoneCode"
                ])
            }
        };
    }
    __internal_effect(_) {
        throw new Error("__internal_effect called before Clerk is loaded");
    }
    __internal_computed(_) {
        throw new Error("__internal_computed called before Clerk is loaded");
    }
    get client() {
        const c = this.isomorphicClerk.client;
        if (!c) throw new Error("Clerk client not ready");
        return c;
    }
    gateProperty(getTarget, key, defaultValue) {
        return (()=>{
            if (!(0, $3c17c37c0544ec6b$export$620a268685f0ac45)() || !this.isomorphicClerk.loaded) return defaultValue;
            const t = getTarget();
            return t[key];
        })();
    }
    gateMethod(getTarget, key) {
        return async (...args)=>{
            if (!(0, $3c17c37c0544ec6b$export$620a268685f0ac45)()) return $8fcdbf2d7a4660c6$var$errorThrower.throw(`Attempted to call a method (${key}) that is not supported on the server.`);
            if (!this.isomorphicClerk.loaded) await new Promise((resolve)=>this.isomorphicClerk.addOnLoaded(resolve));
            const t = getTarget();
            return t[key].apply(t, args);
        };
    }
    wrapMethods(getTarget, keys) {
        return Object.fromEntries(keys.map((k)=>[
                k,
                this.gateMethod(getTarget, k)
            ]));
    }
    wrapStruct(getTarget, methods, getters, fallbacks) {
        const out = {};
        for (const m of methods)out[m] = this.gateMethod(getTarget, m);
        for (const g of getters)Object.defineProperty(out, g, {
            get: ()=>this.gateProperty(getTarget, g, fallbacks[g]),
            enumerable: true
        });
        return out;
    }
};
// src/isomorphicClerk.ts
if (typeof globalThis.__BUILD_DISABLE_RHC__ === "undefined") globalThis.__BUILD_DISABLE_RHC__ = false;
var $8fcdbf2d7a4660c6$var$SDK_METADATA = {
    name: "@clerk/clerk-react",
    version: "5.61.6",
    environment: "production"
};
var $8fcdbf2d7a4660c6$var$_status, $8fcdbf2d7a4660c6$var$_domain, $8fcdbf2d7a4660c6$var$_proxyUrl, $8fcdbf2d7a4660c6$var$_publishableKey, $8fcdbf2d7a4660c6$var$_eventBus, $8fcdbf2d7a4660c6$var$_stateProxy, $8fcdbf2d7a4660c6$var$_instance, $8fcdbf2d7a4660c6$var$_IsomorphicClerk_instances, $8fcdbf2d7a4660c6$var$waitForClerkJS_fn;
var $8fcdbf2d7a4660c6$var$_IsomorphicClerk = class _IsomorphicClerk {
    constructor(options){
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_IsomorphicClerk_instances);
        this.clerkjs = null;
        this.preopenOneTap = null;
        this.preopenUserVerification = null;
        this.preopenEnableOrganizationsPrompt = null;
        this.preopenSignIn = null;
        this.preopenCheckout = null;
        this.preopenPlanDetails = null;
        this.preopenSubscriptionDetails = null;
        this.preopenSignUp = null;
        this.preopenUserProfile = null;
        this.preopenOrganizationProfile = null;
        this.preopenCreateOrganization = null;
        this.preOpenWaitlist = null;
        this.premountSignInNodes = /* @__PURE__ */ new Map();
        this.premountSignUpNodes = /* @__PURE__ */ new Map();
        this.premountUserAvatarNodes = /* @__PURE__ */ new Map();
        this.premountUserProfileNodes = /* @__PURE__ */ new Map();
        this.premountUserButtonNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationProfileNodes = /* @__PURE__ */ new Map();
        this.premountCreateOrganizationNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationSwitcherNodes = /* @__PURE__ */ new Map();
        this.premountOrganizationListNodes = /* @__PURE__ */ new Map();
        this.premountMethodCalls = /* @__PURE__ */ new Map();
        this.premountWaitlistNodes = /* @__PURE__ */ new Map();
        this.premountPricingTableNodes = /* @__PURE__ */ new Map();
        this.premountAPIKeysNodes = /* @__PURE__ */ new Map();
        this.premountOAuthConsentNodes = /* @__PURE__ */ new Map();
        this.premountTaskChooseOrganizationNodes = /* @__PURE__ */ new Map();
        this.premountTaskResetPasswordNodes = /* @__PURE__ */ new Map();
        this.premountTaskSetupMFANodes = /* @__PURE__ */ new Map();
        // A separate Map of `addListener` method calls to handle multiple listeners.
        this.premountAddListenerCalls = /* @__PURE__ */ new Map();
        this.loadedListeners = [];
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_status, "loading");
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_domain);
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_proxyUrl);
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_publishableKey);
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_eventBus, (0, $221c074b1afc6010$export$b82c36fc307b0a58)());
        $8fcdbf2d7a4660c6$var$__privateAdd(this, $8fcdbf2d7a4660c6$var$_stateProxy);
        this.buildSignInUrl = (opts)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignInUrl(opts)) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildSignInUrl", callback);
        };
        this.buildSignUpUrl = (opts)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignUpUrl(opts)) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildSignUpUrl", callback);
        };
        this.buildAfterSignInUrl = (...args)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignInUrl(...args)) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildAfterSignInUrl", callback);
        };
        this.buildAfterSignUpUrl = (...args)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignUpUrl(...args)) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildAfterSignUpUrl", callback);
        };
        this.buildAfterSignOutUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignOutUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildAfterSignOutUrl", callback);
        };
        this.buildNewSubscriptionRedirectUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildNewSubscriptionRedirectUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildNewSubscriptionRedirectUrl", callback);
        };
        this.buildAfterMultiSessionSingleSignOutUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterMultiSessionSingleSignOutUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildAfterMultiSessionSingleSignOutUrl", callback);
        };
        this.buildUserProfileUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildUserProfileUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildUserProfileUrl", callback);
        };
        this.buildCreateOrganizationUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildCreateOrganizationUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildCreateOrganizationUrl", callback);
        };
        this.buildOrganizationProfileUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildOrganizationProfileUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildOrganizationProfileUrl", callback);
        };
        this.buildWaitlistUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildWaitlistUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildWaitlistUrl", callback);
        };
        this.buildTasksUrl = ()=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildTasksUrl()) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildTasksUrl", callback);
        };
        this.buildUrlWithAuth = (to)=>{
            const callback = ()=>{
                var _a;
                return ((_a = this.clerkjs) == null ? void 0 : _a.buildUrlWithAuth(to)) || "";
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("buildUrlWithAuth", callback);
        };
        this.handleUnauthenticated = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleUnauthenticated();
            };
            if (this.clerkjs && this.loaded) callback();
            else this.premountMethodCalls.set("handleUnauthenticated", callback);
        };
        this.on = (...args)=>{
            var _a;
            if ((_a = this.clerkjs) == null ? void 0 : _a.on) return this.clerkjs.on(...args);
            else $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).on(...args);
        };
        this.off = (...args)=>{
            var _a;
            if ((_a = this.clerkjs) == null ? void 0 : _a.off) return this.clerkjs.off(...args);
            else $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).off(...args);
        };
        /**
     * @deprecated Please use `addStatusListener`. This api will be removed in the next major.
     */ this.addOnLoaded = (cb)=>{
            this.loadedListeners.push(cb);
            if (this.loaded) this.emitLoaded();
        };
        /**
     * @deprecated Please use `__internal_setStatus`. This api will be removed in the next major.
     */ this.emitLoaded = ()=>{
            this.loadedListeners.forEach((cb)=>cb());
            this.loadedListeners = [];
        };
        this.beforeLoad = (clerkjs)=>{
            if (!clerkjs) throw new Error("Failed to hydrate latest Clerk JS");
        };
        this.hydrateClerkJS = (clerkjs)=>{
            var _a, _b;
            if (!clerkjs) throw new Error("Failed to hydrate latest Clerk JS");
            this.clerkjs = clerkjs;
            this.premountMethodCalls.forEach((cb)=>cb());
            this.premountAddListenerCalls.forEach((listenerHandlers, listener)=>{
                listenerHandlers.nativeUnsubscribe = clerkjs.addListener(listener);
            });
            (_a = $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).internal.retrieveListeners("status")) == null || _a.forEach((listener)=>{
                this.on("status", listener, {
                    notify: true
                });
            });
            (_b = $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).internal.retrieveListeners("queryClientStatus")) == null || _b.forEach((listener)=>{
                this.on("queryClientStatus", listener, {
                    notify: true
                });
            });
            if (this.preopenSignIn !== null) clerkjs.openSignIn(this.preopenSignIn);
            if (this.preopenCheckout !== null) clerkjs.__internal_openCheckout(this.preopenCheckout);
            if (this.preopenPlanDetails !== null) clerkjs.__internal_openPlanDetails(this.preopenPlanDetails);
            if (this.preopenSubscriptionDetails !== null) clerkjs.__internal_openSubscriptionDetails(this.preopenSubscriptionDetails);
            if (this.preopenSignUp !== null) clerkjs.openSignUp(this.preopenSignUp);
            if (this.preopenUserProfile !== null) clerkjs.openUserProfile(this.preopenUserProfile);
            if (this.preopenUserVerification !== null) clerkjs.__internal_openReverification(this.preopenUserVerification);
            if (this.preopenOneTap !== null) clerkjs.openGoogleOneTap(this.preopenOneTap);
            if (this.preopenOrganizationProfile !== null) clerkjs.openOrganizationProfile(this.preopenOrganizationProfile);
            if (this.preopenCreateOrganization !== null) clerkjs.openCreateOrganization(this.preopenCreateOrganization);
            if (this.preOpenWaitlist !== null) clerkjs.openWaitlist(this.preOpenWaitlist);
            if (this.preopenEnableOrganizationsPrompt) clerkjs.__internal_openEnableOrganizationsPrompt(this.preopenEnableOrganizationsPrompt);
            this.premountSignInNodes.forEach((props, node)=>{
                clerkjs.mountSignIn(node, props);
            });
            this.premountSignUpNodes.forEach((props, node)=>{
                clerkjs.mountSignUp(node, props);
            });
            this.premountUserProfileNodes.forEach((props, node)=>{
                clerkjs.mountUserProfile(node, props);
            });
            this.premountUserAvatarNodes.forEach((props, node)=>{
                clerkjs.mountUserAvatar(node, props);
            });
            this.premountUserButtonNodes.forEach((props, node)=>{
                clerkjs.mountUserButton(node, props);
            });
            this.premountOrganizationListNodes.forEach((props, node)=>{
                clerkjs.mountOrganizationList(node, props);
            });
            this.premountWaitlistNodes.forEach((props, node)=>{
                clerkjs.mountWaitlist(node, props);
            });
            this.premountPricingTableNodes.forEach((props, node)=>{
                clerkjs.mountPricingTable(node, props);
            });
            this.premountAPIKeysNodes.forEach((props, node)=>{
                clerkjs.mountAPIKeys(node, props);
            });
            this.premountOAuthConsentNodes.forEach((props, node)=>{
                clerkjs.__internal_mountOAuthConsent(node, props);
            });
            this.premountTaskChooseOrganizationNodes.forEach((props, node)=>{
                clerkjs.mountTaskChooseOrganization(node, props);
            });
            this.premountTaskResetPasswordNodes.forEach((props, node)=>{
                clerkjs.mountTaskResetPassword(node, props);
            });
            this.premountTaskSetupMFANodes.forEach((props, node)=>{
                clerkjs.mountTaskSetupMFA(node, props);
            });
            if (typeof this.clerkjs.status === "undefined") $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).emit($221c074b1afc6010$export$204ce3a40a17ab2c.Status, "ready");
            this.emitLoaded();
            return this.clerkjs;
        };
        this.__experimental_checkout = (...args)=>{
            var _a;
            return (_a = this.clerkjs) == null ? void 0 : _a.__experimental_checkout(...args);
        };
        // TODO @userland-errors:
        this.__unstable__updateProps = async (props)=>{
            const clerkjs = await $8fcdbf2d7a4660c6$var$__privateMethod(this, $8fcdbf2d7a4660c6$var$_IsomorphicClerk_instances, $8fcdbf2d7a4660c6$var$waitForClerkJS_fn).call(this);
            if (clerkjs && "__unstable__updateProps" in clerkjs) return clerkjs.__unstable__updateProps(props);
        };
        /**
     * `setActive` can be used to set the active session and/or organization.
     */ this.setActive = (params)=>{
            if (this.clerkjs) return this.clerkjs.setActive(params);
            else return Promise.reject();
        };
        this.openSignIn = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openSignIn(props);
            else this.preopenSignIn = props;
        };
        this.closeSignIn = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeSignIn();
            else this.preopenSignIn = null;
        };
        this.__internal_openCheckout = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_openCheckout(props);
            else this.preopenCheckout = props;
        };
        this.__internal_closeCheckout = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_closeCheckout();
            else this.preopenCheckout = null;
        };
        this.__internal_openPlanDetails = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_openPlanDetails(props);
            else this.preopenPlanDetails = props;
        };
        this.__internal_closePlanDetails = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_closePlanDetails();
            else this.preopenPlanDetails = null;
        };
        this.__internal_openSubscriptionDetails = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_openSubscriptionDetails(props);
            else this.preopenSubscriptionDetails = props != null ? props : null;
        };
        this.__internal_closeSubscriptionDetails = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_closeSubscriptionDetails();
            else this.preopenSubscriptionDetails = null;
        };
        this.__internal_openReverification = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_openReverification(props);
            else this.preopenUserVerification = props;
        };
        this.__internal_closeReverification = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_closeReverification();
            else this.preopenUserVerification = null;
        };
        this.__internal_openEnableOrganizationsPrompt = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_openEnableOrganizationsPrompt(props);
            else this.preopenEnableOrganizationsPrompt = props;
        };
        this.__internal_closeEnableOrganizationsPrompt = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_closeEnableOrganizationsPrompt();
            else this.preopenEnableOrganizationsPrompt = null;
        };
        this.openGoogleOneTap = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openGoogleOneTap(props);
            else this.preopenOneTap = props;
        };
        this.closeGoogleOneTap = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeGoogleOneTap();
            else this.preopenOneTap = null;
        };
        this.openUserProfile = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openUserProfile(props);
            else this.preopenUserProfile = props;
        };
        this.closeUserProfile = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeUserProfile();
            else this.preopenUserProfile = null;
        };
        this.openOrganizationProfile = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openOrganizationProfile(props);
            else this.preopenOrganizationProfile = props;
        };
        this.closeOrganizationProfile = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeOrganizationProfile();
            else this.preopenOrganizationProfile = null;
        };
        this.openCreateOrganization = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openCreateOrganization(props);
            else this.preopenCreateOrganization = props;
        };
        this.closeCreateOrganization = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeCreateOrganization();
            else this.preopenCreateOrganization = null;
        };
        this.openWaitlist = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openWaitlist(props);
            else this.preOpenWaitlist = props;
        };
        this.closeWaitlist = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeWaitlist();
            else this.preOpenWaitlist = null;
        };
        this.openSignUp = (props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.openSignUp(props);
            else this.preopenSignUp = props;
        };
        this.closeSignUp = ()=>{
            if (this.clerkjs && this.loaded) this.clerkjs.closeSignUp();
            else this.preopenSignUp = null;
        };
        this.mountSignIn = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountSignIn(node, props);
            else this.premountSignInNodes.set(node, props);
        };
        this.unmountSignIn = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountSignIn(node);
            else this.premountSignInNodes.delete(node);
        };
        this.mountSignUp = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountSignUp(node, props);
            else this.premountSignUpNodes.set(node, props);
        };
        this.unmountSignUp = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountSignUp(node);
            else this.premountSignUpNodes.delete(node);
        };
        this.mountUserAvatar = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountUserAvatar(node, props);
            else this.premountUserAvatarNodes.set(node, props);
        };
        this.unmountUserAvatar = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountUserAvatar(node);
            else this.premountUserAvatarNodes.delete(node);
        };
        this.mountUserProfile = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountUserProfile(node, props);
            else this.premountUserProfileNodes.set(node, props);
        };
        this.unmountUserProfile = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountUserProfile(node);
            else this.premountUserProfileNodes.delete(node);
        };
        this.mountOrganizationProfile = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountOrganizationProfile(node, props);
            else this.premountOrganizationProfileNodes.set(node, props);
        };
        this.unmountOrganizationProfile = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountOrganizationProfile(node);
            else this.premountOrganizationProfileNodes.delete(node);
        };
        this.mountCreateOrganization = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountCreateOrganization(node, props);
            else this.premountCreateOrganizationNodes.set(node, props);
        };
        this.unmountCreateOrganization = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountCreateOrganization(node);
            else this.premountCreateOrganizationNodes.delete(node);
        };
        this.mountOrganizationSwitcher = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountOrganizationSwitcher(node, props);
            else this.premountOrganizationSwitcherNodes.set(node, props);
        };
        this.unmountOrganizationSwitcher = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountOrganizationSwitcher(node);
            else this.premountOrganizationSwitcherNodes.delete(node);
        };
        this.__experimental_prefetchOrganizationSwitcher = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.__experimental_prefetchOrganizationSwitcher();
            };
            if (this.clerkjs && this.loaded) callback();
            else this.premountMethodCalls.set("__experimental_prefetchOrganizationSwitcher", callback);
        };
        this.mountOrganizationList = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountOrganizationList(node, props);
            else this.premountOrganizationListNodes.set(node, props);
        };
        this.unmountOrganizationList = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountOrganizationList(node);
            else this.premountOrganizationListNodes.delete(node);
        };
        this.mountUserButton = (node, userButtonProps)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountUserButton(node, userButtonProps);
            else this.premountUserButtonNodes.set(node, userButtonProps);
        };
        this.unmountUserButton = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountUserButton(node);
            else this.premountUserButtonNodes.delete(node);
        };
        this.mountWaitlist = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountWaitlist(node, props);
            else this.premountWaitlistNodes.set(node, props);
        };
        this.unmountWaitlist = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountWaitlist(node);
            else this.premountWaitlistNodes.delete(node);
        };
        this.mountPricingTable = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountPricingTable(node, props);
            else this.premountPricingTableNodes.set(node, props);
        };
        this.unmountPricingTable = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountPricingTable(node);
            else this.premountPricingTableNodes.delete(node);
        };
        this.mountAPIKeys = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountAPIKeys(node, props);
            else this.premountAPIKeysNodes.set(node, props);
        };
        this.unmountAPIKeys = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountAPIKeys(node);
            else this.premountAPIKeysNodes.delete(node);
        };
        this.__internal_mountOAuthConsent = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_mountOAuthConsent(node, props);
            else this.premountOAuthConsentNodes.set(node, props);
        };
        this.__internal_unmountOAuthConsent = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.__internal_unmountOAuthConsent(node);
            else this.premountOAuthConsentNodes.delete(node);
        };
        this.mountTaskChooseOrganization = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountTaskChooseOrganization(node, props);
            else this.premountTaskChooseOrganizationNodes.set(node, props);
        };
        this.unmountTaskChooseOrganization = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountTaskChooseOrganization(node);
            else this.premountTaskChooseOrganizationNodes.delete(node);
        };
        this.mountTaskResetPassword = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountTaskResetPassword(node, props);
            else this.premountTaskResetPasswordNodes.set(node, props);
        };
        this.unmountTaskResetPassword = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountTaskResetPassword(node);
            else this.premountTaskResetPasswordNodes.delete(node);
        };
        this.mountTaskSetupMFA = (node, props)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.mountTaskSetupMFA(node, props);
            else this.premountTaskSetupMFANodes.set(node, props);
        };
        this.unmountTaskSetupMFA = (node)=>{
            if (this.clerkjs && this.loaded) this.clerkjs.unmountTaskSetupMFA(node);
            else this.premountTaskSetupMFANodes.delete(node);
        };
        this.addListener = (listener)=>{
            if (this.clerkjs) return this.clerkjs.addListener(listener);
            else {
                const unsubscribe = ()=>{
                    var _a;
                    const listenerHandlers = this.premountAddListenerCalls.get(listener);
                    if (listenerHandlers) {
                        (_a = listenerHandlers.nativeUnsubscribe) == null || _a.call(listenerHandlers);
                        this.premountAddListenerCalls.delete(listener);
                    }
                };
                this.premountAddListenerCalls.set(listener, {
                    unsubscribe: unsubscribe,
                    nativeUnsubscribe: void 0
                });
                return unsubscribe;
            }
        };
        this.navigate = (to)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.navigate(to);
            };
            if (this.clerkjs && this.loaded) callback();
            else this.premountMethodCalls.set("navigate", callback);
        };
        this.redirectWithAuth = async (...args)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectWithAuth(...args);
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectWithAuth", callback);
                return;
            }
        };
        this.redirectToSignIn = async (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignIn(opts);
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToSignIn", callback);
                return;
            }
        };
        this.redirectToSignUp = async (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignUp(opts);
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToSignUp", callback);
                return;
            }
        };
        this.redirectToUserProfile = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToUserProfile();
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToUserProfile", callback);
                return;
            }
        };
        this.redirectToAfterSignUp = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignUp();
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("redirectToAfterSignUp", callback);
        };
        this.redirectToAfterSignIn = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignIn();
            };
            if (this.clerkjs && this.loaded) callback();
            else this.premountMethodCalls.set("redirectToAfterSignIn", callback);
        };
        this.redirectToAfterSignOut = ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignOut();
            };
            if (this.clerkjs && this.loaded) callback();
            else this.premountMethodCalls.set("redirectToAfterSignOut", callback);
        };
        this.redirectToOrganizationProfile = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToOrganizationProfile();
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToOrganizationProfile", callback);
                return;
            }
        };
        this.redirectToCreateOrganization = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToCreateOrganization();
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToCreateOrganization", callback);
                return;
            }
        };
        this.redirectToWaitlist = async ()=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToWaitlist();
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToWaitlist", callback);
                return;
            }
        };
        this.redirectToTasks = async (opts)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.redirectToTasks(opts);
            };
            if (this.clerkjs && this.loaded) return callback();
            else {
                this.premountMethodCalls.set("redirectToTasks", callback);
                return;
            }
        };
        this.handleRedirectCallback = async (params)=>{
            var _a;
            const callback = ()=>{
                var _a2;
                return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleRedirectCallback(params);
            };
            if (this.clerkjs && this.loaded) (_a = callback()) == null || _a.catch(()=>{});
            else this.premountMethodCalls.set("handleRedirectCallback", callback);
        };
        this.handleGoogleOneTapCallback = async (signInOrUp, params)=>{
            var _a;
            const callback = ()=>{
                var _a2;
                return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleGoogleOneTapCallback(signInOrUp, params);
            };
            if (this.clerkjs && this.loaded) (_a = callback()) == null || _a.catch(()=>{});
            else this.premountMethodCalls.set("handleGoogleOneTapCallback", callback);
        };
        this.handleEmailLinkVerification = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.handleEmailLinkVerification(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("handleEmailLinkVerification", callback);
        };
        this.authenticateWithMetamask = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithMetamask(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("authenticateWithMetamask", callback);
        };
        this.authenticateWithCoinbaseWallet = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithCoinbaseWallet(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("authenticateWithCoinbaseWallet", callback);
        };
        this.authenticateWithBase = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithBase(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("authenticateWithBase", callback);
        };
        this.authenticateWithOKXWallet = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithOKXWallet(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("authenticateWithOKXWallet", callback);
        };
        this.authenticateWithSolana = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithSolana(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("authenticateWithSolana", callback);
        };
        this.authenticateWithWeb3 = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithWeb3(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("authenticateWithWeb3", callback);
        };
        this.authenticateWithGoogleOneTap = async (params)=>{
            const clerkjs = await $8fcdbf2d7a4660c6$var$__privateMethod(this, $8fcdbf2d7a4660c6$var$_IsomorphicClerk_instances, $8fcdbf2d7a4660c6$var$waitForClerkJS_fn).call(this);
            return clerkjs.authenticateWithGoogleOneTap(params);
        };
        this.__internal_loadStripeJs = async ()=>{
            const clerkjs = await $8fcdbf2d7a4660c6$var$__privateMethod(this, $8fcdbf2d7a4660c6$var$_IsomorphicClerk_instances, $8fcdbf2d7a4660c6$var$waitForClerkJS_fn).call(this);
            return clerkjs.__internal_loadStripeJs();
        };
        this.createOrganization = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.createOrganization(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("createOrganization", callback);
        };
        this.getOrganization = async (organizationId)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.getOrganization(organizationId);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("getOrganization", callback);
        };
        this.joinWaitlist = async (params)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.joinWaitlist(params);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("joinWaitlist", callback);
        };
        this.signOut = async (...args)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.signOut(...args);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("signOut", callback);
        };
        this.__internal_attemptToEnableEnvironmentSetting = (options)=>{
            const callback = ()=>{
                var _a;
                return (_a = this.clerkjs) == null ? void 0 : _a.__internal_attemptToEnableEnvironmentSetting(options);
            };
            if (this.clerkjs && this.loaded) return callback();
            else this.premountMethodCalls.set("__internal_attemptToEnableEnvironmentSetting", callback);
        };
        const { Clerk: Clerk = null, publishableKey: publishableKey } = options || {};
        $8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_publishableKey, publishableKey);
        $8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_proxyUrl, options == null ? void 0 : options.proxyUrl);
        $8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_domain, options == null ? void 0 : options.domain);
        this.options = options;
        this.Clerk = Clerk;
        this.mode = (0, $3c17c37c0544ec6b$export$620a268685f0ac45)() ? "browser" : "server";
        $8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_stateProxy, new $8fcdbf2d7a4660c6$var$StateProxy(this));
        if (!this.options.sdkMetadata) this.options.sdkMetadata = $8fcdbf2d7a4660c6$var$SDK_METADATA;
        $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).emit($221c074b1afc6010$export$204ce3a40a17ab2c.Status, "loading");
        $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).prioritizedOn($221c074b1afc6010$export$204ce3a40a17ab2c.Status, (status)=>$8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_status, status));
        if ($8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_publishableKey)) this.loadClerkJS();
    }
    get publishableKey() {
        return $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_publishableKey);
    }
    get loaded() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.loaded) || false;
    }
    get status() {
        var _a;
        if (!this.clerkjs) return $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_status);
        return ((_a = this.clerkjs) == null ? void 0 : _a.status) || /**
     * Support older clerk-js versions.
     * If clerk-js is available but `.status` is missing it we need to fallback to `.loaded`.
     * Since "degraded" an "error" did not exist before,
     * map "loaded" to "ready" and "not loaded" to "loading".
     */ (this.clerkjs.loaded ? "ready" : "loading");
    }
    static getOrCreateInstance(options) {
        if (!(0, $3c17c37c0544ec6b$export$620a268685f0ac45)() || !$8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_instance) || options.Clerk && $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_instance).Clerk !== options.Clerk || // Allow hot swapping PKs on the client
        $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_instance).publishableKey !== options.publishableKey) $8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_instance, new _IsomorphicClerk(options));
        return $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_instance);
    }
    static clearInstance() {
        $8fcdbf2d7a4660c6$var$__privateSet(this, $8fcdbf2d7a4660c6$var$_instance, null);
    }
    get domain() {
        if (typeof window !== "undefined" && window.location) return (0, $52b16e2619eaae81$export$af80d780caaebdea)($8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_domain), new URL(window.location.href), "");
        if (typeof $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_domain) === "function") return $8fcdbf2d7a4660c6$var$errorThrower.throw($8fcdbf2d7a4660c6$var$unsupportedNonBrowserDomainOrProxyUrlFunction);
        return $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_domain) || "";
    }
    get proxyUrl() {
        if (typeof window !== "undefined" && window.location) return (0, $52b16e2619eaae81$export$af80d780caaebdea)($8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_proxyUrl), new URL(window.location.href), "");
        if (typeof $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_proxyUrl) === "function") return $8fcdbf2d7a4660c6$var$errorThrower.throw($8fcdbf2d7a4660c6$var$unsupportedNonBrowserDomainOrProxyUrlFunction);
        return $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_proxyUrl) || "";
    }
    /**
   * Accesses private options from the `Clerk` instance and defaults to
   * `IsomorphicClerk` options when in SSR context.
   *  @internal
   */ __internal_getOption(key) {
        var _a, _b;
        return ((_a = this.clerkjs) == null ? void 0 : _a.__internal_getOption) ? (_b = this.clerkjs) == null ? void 0 : _b.__internal_getOption(key) : this.options[key];
    }
    get sdkMetadata() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.sdkMetadata) || this.options.sdkMetadata || void 0;
    }
    get instanceType() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.instanceType;
    }
    get frontendApi() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.frontendApi) || "";
    }
    get isStandardBrowser() {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.isStandardBrowser) || this.options.standardBrowser || false;
    }
    get __internal_queryClient() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.__internal_queryClient;
    }
    get isSatellite() {
        if (typeof window !== "undefined" && window.location) return (0, $52b16e2619eaae81$export$af80d780caaebdea)(this.options.isSatellite, new URL(window.location.href), false);
        if (typeof this.options.isSatellite === "function") return $8fcdbf2d7a4660c6$var$errorThrower.throw($8fcdbf2d7a4660c6$var$unsupportedNonBrowserDomainOrProxyUrlFunction);
        return false;
    }
    async loadClerkJS() {
        var _a;
        if (this.mode !== "browser" || this.loaded) return;
        if (typeof window !== "undefined") {
            window.__clerk_publishable_key = $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_publishableKey);
            window.__clerk_proxy_url = this.proxyUrl;
            window.__clerk_domain = this.domain;
        }
        try {
            if (this.Clerk) {
                let c;
                if ($8fcdbf2d7a4660c6$var$isConstructor(this.Clerk)) {
                    c = new this.Clerk($8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_publishableKey), {
                        proxyUrl: this.proxyUrl,
                        domain: this.domain
                    });
                    this.beforeLoad(c);
                    await c.load(this.options);
                } else {
                    c = this.Clerk;
                    if (!c.loaded) {
                        this.beforeLoad(c);
                        await c.load(this.options);
                    }
                }
                $parcel$global.Clerk = c;
            } else if (!__BUILD_DISABLE_RHC__) {
                if (!$parcel$global.Clerk) await (0, $3aa9b7204540f02e$export$4236f1a239719b87)({
                    ...this.options,
                    publishableKey: $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_publishableKey),
                    proxyUrl: this.proxyUrl,
                    domain: this.domain,
                    nonce: this.options.nonce
                });
                if (!$parcel$global.Clerk) throw new Error("Failed to download latest ClerkJS. Contact support@clerk.com.");
                this.beforeLoad($parcel$global.Clerk);
                await $parcel$global.Clerk.load(this.options);
            }
            if ((_a = $parcel$global.Clerk) == null ? void 0 : _a.loaded) return this.hydrateClerkJS($parcel$global.Clerk);
            return;
        } catch (err) {
            const error = err;
            $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_eventBus).emit($221c074b1afc6010$export$204ce3a40a17ab2c.Status, "error");
            console.error(error.stack || error.message || error);
            return;
        }
    }
    get version() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.version;
    }
    get client() {
        if (this.clerkjs) return this.clerkjs.client;
        else return void 0;
    }
    get session() {
        if (this.clerkjs) return this.clerkjs.session;
        else return void 0;
    }
    get user() {
        if (this.clerkjs) return this.clerkjs.user;
        else return void 0;
    }
    get organization() {
        if (this.clerkjs) return this.clerkjs.organization;
        else return void 0;
    }
    get telemetry() {
        if (this.clerkjs) return this.clerkjs.telemetry;
        else return void 0;
    }
    get __unstable__environment() {
        if (this.clerkjs) return this.clerkjs.__unstable__environment;
        else return void 0;
    }
    get isSignedIn() {
        if (this.clerkjs) return this.clerkjs.isSignedIn;
        else return false;
    }
    get billing() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.billing;
    }
    get __internal_state() {
        return this.loaded && this.clerkjs ? this.clerkjs.__internal_state : $8fcdbf2d7a4660c6$var$__privateGet(this, $8fcdbf2d7a4660c6$var$_stateProxy);
    }
    get apiKeys() {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.apiKeys;
    }
    __unstable__setEnvironment(...args) {
        if (this.clerkjs && "__unstable__setEnvironment" in this.clerkjs) this.clerkjs.__unstable__setEnvironment(args);
        else return void 0;
    }
};
$8fcdbf2d7a4660c6$var$_status = new WeakMap();
$8fcdbf2d7a4660c6$var$_domain = new WeakMap();
$8fcdbf2d7a4660c6$var$_proxyUrl = new WeakMap();
$8fcdbf2d7a4660c6$var$_publishableKey = new WeakMap();
$8fcdbf2d7a4660c6$var$_eventBus = new WeakMap();
$8fcdbf2d7a4660c6$var$_stateProxy = new WeakMap();
$8fcdbf2d7a4660c6$var$_instance = new WeakMap();
$8fcdbf2d7a4660c6$var$_IsomorphicClerk_instances = new WeakSet();
$8fcdbf2d7a4660c6$var$waitForClerkJS_fn = function() {
    return new Promise((resolve)=>{
        this.addOnLoaded(()=>resolve(this.clerkjs));
    });
};
$8fcdbf2d7a4660c6$var$__privateAdd($8fcdbf2d7a4660c6$var$_IsomorphicClerk, $8fcdbf2d7a4660c6$var$_instance);
var $8fcdbf2d7a4660c6$var$IsomorphicClerk = $8fcdbf2d7a4660c6$var$_IsomorphicClerk;
// src/contexts/ClerkContextProvider.tsx
function $8fcdbf2d7a4660c6$var$ClerkContextProvider(props) {
    const { isomorphicClerkOptions: isomorphicClerkOptions, initialState: initialState, children: children } = props;
    const { isomorphicClerk: clerk, clerkStatus: clerkStatus } = $8fcdbf2d7a4660c6$var$useLoadedIsomorphicClerk(isomorphicClerkOptions);
    const [state, setState] = $8fcdbf2d7a4660c6$var$import_react27.default.useState({
        client: clerk.client,
        session: clerk.session,
        user: clerk.user,
        organization: clerk.organization
    });
    $8fcdbf2d7a4660c6$var$import_react27.default.useEffect(()=>{
        return clerk.addListener((e)=>setState({
                ...e
            }));
    }, []);
    const derivedState = (0, $df9ca5d4039ff5c4$export$485fc5c1dea91f96)(clerk.loaded, state, initialState);
    const clerkCtx = $8fcdbf2d7a4660c6$var$import_react27.default.useMemo(()=>({
            value: clerk
        }), [
        // Only update the clerk reference on status change
        clerkStatus
    ]);
    const clientCtx = $8fcdbf2d7a4660c6$var$import_react27.default.useMemo(()=>({
            value: state.client
        }), [
        state.client
    ]);
    const { sessionId: sessionId, sessionStatus: sessionStatus, sessionClaims: sessionClaims, session: session, userId: userId, user: user, orgId: orgId, actor: actor, organization: organization, orgRole: orgRole, orgSlug: orgSlug, orgPermissions: orgPermissions, factorVerificationAge: factorVerificationAge } = derivedState;
    const authCtx = $8fcdbf2d7a4660c6$var$import_react27.default.useMemo(()=>{
        const value = {
            sessionId: sessionId,
            sessionStatus: sessionStatus,
            sessionClaims: sessionClaims,
            userId: userId,
            actor: actor,
            orgId: orgId,
            orgRole: orgRole,
            orgSlug: orgSlug,
            orgPermissions: orgPermissions,
            factorVerificationAge: factorVerificationAge
        };
        return {
            value: value
        };
    }, [
        sessionId,
        sessionStatus,
        userId,
        actor,
        orgId,
        orgRole,
        orgSlug,
        factorVerificationAge,
        sessionClaims == null ? void 0 : sessionClaims.__raw
    ]);
    const sessionCtx = $8fcdbf2d7a4660c6$var$import_react27.default.useMemo(()=>({
            value: session
        }), [
        sessionId,
        session
    ]);
    const userCtx = $8fcdbf2d7a4660c6$var$import_react27.default.useMemo(()=>({
            value: user
        }), [
        userId,
        user
    ]);
    const organizationCtx = $8fcdbf2d7a4660c6$var$import_react27.default.useMemo(()=>{
        const value = {
            organization: organization
        };
        return {
            value: value
        };
    }, [
        orgId,
        organization
    ]);
    return(// @ts-expect-error value passed is of type IsomorphicClerk where the context expects LoadedClerk
    /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($8fcdbf2d7a4660c6$var$IsomorphicClerkContext.Provider, {
        value: clerkCtx
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($a0ea147aab9dedc4$export$56e68f8f57ecfde4.Provider, {
        value: clientCtx
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($a0ea147aab9dedc4$export$3285420c698bc605.Provider, {
        value: sessionCtx
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($a0ea147aab9dedc4$export$4ca575904f5d942, {
        ...organizationCtx.value
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($8fcdbf2d7a4660c6$var$AuthContext.Provider, {
        value: authCtx
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($a0ea147aab9dedc4$export$38ee920e59704589.Provider, {
        value: userCtx
    }, /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react27.default.createElement($a0ea147aab9dedc4$export$7e97d07504ce6dd0, {
        value: void 0
    }, children))))))));
}
var $8fcdbf2d7a4660c6$var$useLoadedIsomorphicClerk = (options)=>{
    const isomorphicClerkRef = $8fcdbf2d7a4660c6$var$import_react27.default.useRef($8fcdbf2d7a4660c6$var$IsomorphicClerk.getOrCreateInstance(options));
    const [clerkStatus, setClerkStatus] = $8fcdbf2d7a4660c6$var$import_react27.default.useState(isomorphicClerkRef.current.status);
    $8fcdbf2d7a4660c6$var$import_react27.default.useEffect(()=>{
        isomorphicClerkRef.current.__unstable__updateProps({
            appearance: options.appearance
        });
    }, [
        options.appearance
    ]);
    $8fcdbf2d7a4660c6$var$import_react27.default.useEffect(()=>{
        isomorphicClerkRef.current.__unstable__updateProps({
            options: options
        });
    }, [
        options.localization
    ]);
    $8fcdbf2d7a4660c6$var$import_react27.default.useEffect(()=>{
        isomorphicClerkRef.current.on("status", setClerkStatus);
        return ()=>{
            if (isomorphicClerkRef.current) isomorphicClerkRef.current.off("status", setClerkStatus);
            $8fcdbf2d7a4660c6$var$IsomorphicClerk.clearInstance();
        };
    }, []);
    return {
        isomorphicClerk: isomorphicClerkRef.current,
        clerkStatus: clerkStatus
    };
};
// src/contexts/ClerkProvider.tsx
function $8fcdbf2d7a4660c6$var$ClerkProviderBase(props) {
    const { initialState: initialState, children: children, __internal_bypassMissingPublishableKey: __internal_bypassMissingPublishableKey, ...restIsomorphicClerkOptions } = props;
    const { publishableKey: publishableKey = "", Clerk: userInitialisedClerk } = restIsomorphicClerkOptions;
    if (!userInitialisedClerk && !__internal_bypassMissingPublishableKey) {
        if (!publishableKey) $8fcdbf2d7a4660c6$var$errorThrower.throwMissingPublishableKeyError();
        else if (publishableKey && !(0, $af7e0eb6fefeb2a7$export$e7b0b0686142f5e8)(publishableKey)) $8fcdbf2d7a4660c6$var$errorThrower.throwInvalidPublishableKeyError({
            key: publishableKey
        });
    }
    return /* @__PURE__ */ $8fcdbf2d7a4660c6$var$import_react28.default.createElement($8fcdbf2d7a4660c6$var$ClerkContextProvider, {
        initialState: initialState,
        isomorphicClerkOptions: restIsomorphicClerkOptions
    }, children);
}
var $8fcdbf2d7a4660c6$var$ClerkProvider = $8fcdbf2d7a4660c6$var$withMaxAllowedInstancesGuard($8fcdbf2d7a4660c6$var$ClerkProviderBase, "ClerkProvider", $8fcdbf2d7a4660c6$var$multipleClerkProvidersError);
$8fcdbf2d7a4660c6$var$ClerkProvider.displayName = "ClerkProvider";
// src/index.ts
$8fcdbf2d7a4660c6$var$setErrorThrowerOptions({
    packageName: "@clerk/clerk-react"
});
(0, $3aa9b7204540f02e$export$b09f006ee485e599)("@clerk/clerk-react");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


/**
 * Clerk authentication configuration
 * 
 * Our approach allows anonymous users to start the trademark filing process
 * but requires authentication for advanced features like portfolio management.
 * 
 * This maximizes lead capture while encouraging users to create accounts
 * for the full SaaS experience.
 */ const $717fd9c50d7f81b3$var$config = {
    // Only these specific routes require authentication
    protectedRoutes: [
        // Portfolio management (viewing all trademarks)
        '/dashboard/portfolio',
        '/dashboard/portfolio/*',
        // Account settings
        '/dashboard/account',
        '/dashboard/account/*',
        // Billing and payment history
        '/dashboard/payments',
        '/dashboard/payments/*',
        // User profile
        '/profile',
        '/profile/*',
        // Marketing Ops Dashboard (admin-only, further gated in MarketingApp)
        '/marketing',
        '/marketing/*'
    ],
    // Routes that are part of the trademark filing process (accessible anonymously)
    // This is just for reference - no auth check is applied to these
    publicFilingRoutes: [
        '/dashboard',
        '/dashboard/upload',
        '/dashboard/business-info',
        '/dashboard/analysis',
        '/dashboard/countries',
        '/dashboard/payment',
        '/dashboard/status'
    ],
    // Clerk appearance customization
    appearance: {
        variables: {
            colorPrimary: '#3B82F6',
            colorText: '#1F2937',
            borderRadius: '0.375rem'
        },
        elements: {
            formButtonPrimary: 'bg-blue-500 hover:bg-blue-600 text-white',
            card: 'bg-white shadow-md rounded-lg'
        }
    }
};
var $717fd9c50d7f81b3$export$2e2bcd8739ae039 = $717fd9c50d7f81b3$var$config;


/**
 * ProtectedRoute component that redirects unauthenticated users to sign in
 * 
 * Only routes specified in authConfig.protectedRoutes require authentication.
 * All other routes are accessible to both anonymous and authenticated users.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render when authenticated
 * @returns {React.ReactNode} Protected route component
 */ const $b3be64279cc34b34$var$ProtectedRoute = ({ children: children })=>{
    const { isLoaded: isLoaded, userId: userId } = (0, $8fcdbf2d7a4660c6$exports.useAuth)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    // Check if the current path requires authentication
    const requiresAuth = (0, $717fd9c50d7f81b3$export$2e2bcd8739ae039).protectedRoutes.some((route)=>{
        if (route.endsWith('/*')) {
            // Handle wildcard routes
            const basePath = route.replace('/*', '');
            return location.pathname.startsWith(basePath);
        }
        return location.pathname === route;
    });
    // If path doesn't require auth, render content regardless of auth status
    if (!requiresAuth) return children;
    // Show loading state while Clerk is initializing
    if (!isLoaded) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center min-h-screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"
        })
    });
    // For protected routes, redirect to sign-in if not authenticated
    if (!userId) // Save the current location to redirect back after sign-in
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/sign-in",
        state: {
            from: location
        },
        replace: true
    });
    // User is authenticated, render the protected content
    return children;
};
var $b3be64279cc34b34$export$2e2bcd8739ae039 = $b3be64279cc34b34$var$ProtectedRoute;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++)objs[i] && $c319b2c832c2914a$var$forEach(objs[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
const $866cce54f6bdfb0c$var$INVALID_HEADER_VALUE_CHARS_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
function $866cce54f6bdfb0c$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$sanitizeHeaderValue(str) {
    return $866cce54f6bdfb0c$var$trimSPorHTAB(str.replace($866cce54f6bdfb0c$var$INVALID_HEADER_VALUE_CHARS_RE, ''));
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : $866cce54f6bdfb0c$var$sanitizeHeaderValue(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
const $4e2395edb77acf3a$var$REDACTED = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$var$REDACTED : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




const $ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ab4625fac3104691$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $ab4625fac3104691$var$encodeUTF8(auth.password) : '')));
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $ab4625fac3104691$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $da69a2069c6136ea$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $da69a2069c6136ea$require$Buffer !== 'undefined' && typeof $da69a2069c6136ea$require$Buffer.byteLength === 'function') return $da69a2069c6136ea$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.16.0";


const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global ?? globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


/**
 * Clerk Token Manager
 * 
 * Manages Clerk authentication tokens for API requests.
 * Provides a way to set tokens from React components using useAuth hook
 * and retrieve them in the axios interceptor.
 */ let $3c65d59c1a1073f7$var$currentToken = null;
let $3c65d59c1a1073f7$var$tokenPromise = null;
function $3c65d59c1a1073f7$export$cacee9aa3f16fd0e(token) {
    $3c65d59c1a1073f7$var$currentToken = token;
}
function $3c65d59c1a1073f7$export$639eec633731141d() {
    return $3c65d59c1a1073f7$var$currentToken;
}
/**
 * Wait for Clerk to be ready (with timeout)
 */ async function $3c65d59c1a1073f7$var$waitForClerk(maxWaitMs = 3000) {
    const startTime = Date.now();
    while(Date.now() - startTime < maxWaitMs){
        if (window.Clerk?.session?.getToken) return true;
        // Wait 100ms before checking again
        await new Promise((resolve)=>setTimeout(resolve, 100));
    }
    return false;
}
async function $3c65d59c1a1073f7$export$54b8fa77939b0cc0() {
    // Prevent multiple simultaneous token fetches
    if ($3c65d59c1a1073f7$var$tokenPromise) return $3c65d59c1a1073f7$var$tokenPromise;
    $3c65d59c1a1073f7$var$tokenPromise = (async ()=>{
        try {
            if (typeof window === 'undefined') return null;
            // Wait for Clerk to be ready if it's not yet
            if (!window.Clerk?.session?.getToken) await $3c65d59c1a1073f7$var$waitForClerk(3000);
            let token = null;
            // Always get a fresh token - Clerk tokens expire quickly (~60 seconds)
            // Method 1: Try window.Clerk.session.getToken() - most reliable
            if (window.Clerk?.session?.getToken) token = await window.Clerk.session.getToken({
                skipCache: true
            });
            else if (window.Clerk?.loaded && window.Clerk?.session) token = await window.Clerk.session.getToken({
                skipCache: true
            });
            else if (window.Clerk?.__unstable__environment?.getSessionToken) token = await window.Clerk.__unstable__environment.getSessionToken();
            if (token) $3c65d59c1a1073f7$var$currentToken = token;
            return token;
        } catch (error) {
            console.error('[ClerkTokenManager] Error fetching token:', error);
            return null;
        } finally{
            $3c65d59c1a1073f7$var$tokenPromise = null;
        }
    })();
    return $3c65d59c1a1073f7$var$tokenPromise;
}
function $3c65d59c1a1073f7$export$ba111104b5f1064a() {
    $3c65d59c1a1073f7$var$currentToken = null;
}


// Define the base URL for all API requests
// REACT_APP_API_URL can override for Container Apps migration
// In production, defaults to relative '/api' for SWA bundled functions
const $78f4fc768f4bd121$var$API_BASE_URL = "https://api.markotm.com/api";
// Create an axios instance with default configuration
const $78f4fc768f4bd121$export$407ca81eb46778dd = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: $78f4fc768f4bd121$var$API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});
// Add a request interceptor for authentication handling
$78f4fc768f4bd121$export$407ca81eb46778dd.interceptors.request.use(async (config)=>{
    // Attach Clerk session token when available
    try {
        const token = await (0, $3c65d59c1a1073f7$export$54b8fa77939b0cc0)();
        if (token) config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`
        };
        else console.warn('[API] No Clerk token available for request');
    } catch (tokenError) {
        console.error('[API] Error retrieving Clerk session token:', tokenError);
    // Don't throw - allow request to proceed without token
    // The backend will return 401 if auth is required
    }
    // Get Clerk user ID if available
    const clerkUser = localStorage.getItem('clerk-user');
    if (clerkUser) try {
        const userData = JSON.parse(clerkUser);
        const userId = userData.id || userData.userId;
        // If method is GET or DELETE, add to params
        if ([
            'get',
            'delete'
        ].includes(config.method)) config.params = {
            ...config.params,
            userId: userId
        };
        else {
            // For POST, PUT, etc., add to request body
            if (config.data && typeof config.data === 'object') config.data = {
                ...config.data,
                userId: userId
            };
            else if (!config.data) config.data = {
                userId: userId
            };
        }
    } catch (error) {
        console.error('Error parsing Clerk user data:', error);
    }
    return config;
}, (error)=>{
    return Promise.reject(error);
});
var // Export as both default and named export for compatibility
$78f4fc768f4bd121$export$2e2bcd8739ae039 = $78f4fc768f4bd121$export$407ca81eb46778dd;


/**
 * Auth utilities for API services
 * 
 * Provides helper functions to get authentication information from Clerk
 * for use in API services where hooks can't be used directly.
 */ /**
 * Get the current user ID from Clerk
 * @returns {string|null} User ID if authenticated, null otherwise
 */ const $d772b9961fd001e4$export$1617268687ac763c = ()=>{
    // Get user ID from Clerk's frontend API
    try {
        if (typeof window !== 'undefined' && window.Clerk && window.Clerk.user && window.Clerk.user.id) {
            // Only log once per session to avoid spam
            if (!window._clerkUserIdLogged) {
                console.log('Using authenticated user ID from Clerk');
                window._clerkUserIdLogged = true;
            }
            return window.Clerk.user.id;
        }
        // Only debug log if we haven't already shown this message
        if (typeof window !== 'undefined' && window.Clerk && !window._clerkDebugLogged) {
            console.debug('Clerk available but user ID not found:', {
                'Clerk.user exists': !!window.Clerk.user,
                'Clerk.user.id exists': window.Clerk.user ? !!window.Clerk.user.id : false
            });
            window._clerkDebugLogged = true;
        }
        // If we need to support anonymous users, use the session ID
        const tempSessionId = localStorage.getItem('tempSessionId');
        if (tempSessionId) {
            console.log('Using temporary session ID');
            return tempSessionId;
        }
        console.warn('Unable to get user ID - user not authenticated and no temporary session');
        return null;
    } catch (error) {
        console.error('Error in getUserId:', error);
        return null;
    }
};
const $d772b9961fd001e4$export$1ae390d25d018ea4 = ()=>{
    return !!localStorage.getItem('clerk-user');
};
const $d772b9961fd001e4$export$93e1ccb4dacd4b3d = ()=>{
    const clerkUser = localStorage.getItem('clerk-user');
    if (clerkUser) try {
        const userData = JSON.parse(clerkUser);
        return userData.primaryEmailAddress?.emailAddress || null;
    } catch (error) {
        console.error('Error parsing Clerk user data:', error);
        return null;
    }
    return null;
};
const $d772b9961fd001e4$export$c1fb9bac27b52cdd = ()=>{
    const clerkUser = localStorage.getItem('clerk-user');
    if (clerkUser) try {
        const userData = JSON.parse(clerkUser);
        return userData.firstName || userData.username || null;
    } catch (error) {
        console.error('Error parsing Clerk user data:', error);
        return null;
    }
    return null;
};


const $b382938de4ad8ceb$export$d9eaa576453a4f6f = {
    /**
   * Get all applications for a user
   * @returns {Promise<Array>} List of user applications
   */ getUserApplications: async ()=>{
        try {
            const userId = (0, $d772b9961fd001e4$export$1617268687ac763c)();
            if (!userId) throw new Error('User not authenticated');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications', {
                params: {
                    userId: userId
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching user applications:', error);
            throw error;
        }
    },
    /**
   * Get a specific application by ID
   * @param {string} applicationId The application ID
   * @returns {Promise<Object>} The application data including business info, trademark, and analysis
   */ getApplicationData: async (applicationId)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications', {
                params: {
                    applicationId: applicationId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching application ${applicationId}:`, error);
            throw error;
        }
    },
    /**
   * Create a new application
   * @param {string} trademarkId Optional trademark ID to associate with this application
   * @param {string} applicationName Optional name for the application
   * @returns {Promise<Object>} The new application with ID and threadId
   */ createApplication: async (trademarkId = null, applicationName = null)=>{
        try {
            const userId = (0, $d772b9961fd001e4$export$1617268687ac763c)();
            if (!userId) throw new Error('User not authenticated');
            console.log('Creating application with userId:', userId, 'trademarkId:', trademarkId, 'and name:', applicationName);
            const payload = {
                userId: userId,
                trademarkId: trademarkId,
                name: applicationName // Include application name
            };
            console.log('Sending payload to /applications:', payload);
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', payload);
            console.log('Received response from /applications:', response);
            console.log('Response data:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error creating new application:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            throw error;
        }
    },
    /**
   * Update an application with trademarkId for bidirectional linking
   * @param {string} applicationId The application ID to update
   * @param {string} trademarkId The trademark ID to link
   * @returns {Promise<Object>} The updated application
   */ updateApplicationWithTrademark: async (applicationId, trademarkId)=>{
        try {
            if (!applicationId || !trademarkId) throw new Error('Application ID and Trademark ID are required');
            console.log('Updating application', applicationId, 'with trademarkId:', trademarkId);
            // Use POST with id in body, following trademark API pattern
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/applications`, {
                id: applicationId,
                trademarkId: trademarkId
            });
            console.log('Application updated successfully:', response.data);
            return response.data;
        } catch (error) {
            console.error(`Error updating application ${applicationId} with trademark ${trademarkId}:`, error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            throw error;
        }
    },
    /**
   * Update an application with any data for bidirectional linking
   * @param {string} applicationId The application ID to update
   * @param {Object} updateData The data to update
   * @returns {Promise<Object>} The updated application
   */ updateApplication: async (applicationId, updateData)=>{
        try {
            if (!applicationId || !updateData) throw new Error('Application ID and update data are required');
            console.log('Updating application', applicationId, 'with data:', updateData);
            // Use POST with id in body, following trademark API pattern
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/applications`, {
                id: applicationId,
                ...updateData
            });
            console.log('Application updated successfully:', response.data);
            return response.data;
        } catch (error) {
            console.error(`Error updating application ${applicationId}:`, error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            throw error;
        }
    },
    /**
   * Cancel an application
   * @param {string} applicationId The application ID to cancel
   * @returns {Promise<Object>} The updated application
   */ cancelApplication: async (applicationId)=>{
        try {
            if (!applicationId) throw new Error('Application ID is required');
            console.log('Cancelling application:', applicationId);
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', {
                id: applicationId,
                status: 'cancelled'
            });
            return response.data;
        } catch (error) {
            console.error(`Error cancelling application ${applicationId}:`, error);
            throw error;
        }
    }
};
var $b382938de4ad8ceb$export$2e2bcd8739ae039 = $b382938de4ad8ceb$export$d9eaa576453a4f6f;



var $acw62 = parcelRequire("acw62");
var $f48ef6896881c1e3$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $f48ef6896881c1e3$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $f48ef6896881c1e3$var$__typeError("Cannot " + msg);
var $f48ef6896881c1e3$export$18a094aefa070634 = (obj, member, getter)=>($f48ef6896881c1e3$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $f48ef6896881c1e3$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $f48ef6896881c1e3$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $f48ef6896881c1e3$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($f48ef6896881c1e3$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $f48ef6896881c1e3$export$fa92d15b718fce20 = (obj, member, method)=>($f48ef6896881c1e3$var$__accessCheck(obj, member, "access private method"), method);
var $f48ef6896881c1e3$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $f48ef6896881c1e3$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $f48ef6896881c1e3$export$18a094aefa070634(obj, member, getter);
        }
    });





// src/timeoutManager.ts
var $f91dfb6f728f333f$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $f91dfb6f728f333f$var$_provider, $f91dfb6f728f333f$var$_providerCalled;
var $f91dfb6f728f333f$export$6336d90323f0ab52 = class {
    constructor(){
        // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
        // type at app boot; and if we leave that type, then any new timer provider
        // would need to support ReturnType<typeof setTimeout>, which is infeasible.
        //
        // We settle for type safety for the TimeoutProvider type, and accept that
        // this class is unsafe internally to allow for extension.
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f91dfb6f728f333f$var$_provider, $f91dfb6f728f333f$export$d235812f9125bf47);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f91dfb6f728f333f$var$_providerCalled, false);
    }
    setTimeoutProvider(provider) {
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f91dfb6f728f333f$var$_provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f91dfb6f728f333f$var$_provider).clearInterval(intervalId);
    }
};
$f91dfb6f728f333f$var$_provider = new WeakMap();
$f91dfb6f728f333f$var$_providerCalled = new WeakMap();
var $f91dfb6f728f333f$export$94a2700736e69372 = new $f91dfb6f728f333f$export$6336d90323f0ab52();
function $f91dfb6f728f333f$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $798266f99c432533$export$7c76da44185e6090 = (0, $f91dfb6f728f333f$export$5086591e51e32a18);
function $798266f99c432533$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $798266f99c432533$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $798266f99c432533$export$520687f44db6e1ab = $798266f99c432533$export$316a8efd03cd1458();






var $002159551d1c4551$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $002159551d1c4551$export$8793edee2d425525() {}
function $002159551d1c4551$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $002159551d1c4551$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $002159551d1c4551$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $002159551d1c4551$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $002159551d1c4551$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $002159551d1c4551$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $002159551d1c4551$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($002159551d1c4551$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $002159551d1c4551$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $002159551d1c4551$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $002159551d1c4551$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$002159551d1c4551$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $002159551d1c4551$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$002159551d1c4551$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $002159551d1c4551$var$hasOwn = Object.prototype.hasOwnProperty;
function $002159551d1c4551$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $002159551d1c4551$export$7a8558113332b71e(a) && $002159551d1c4551$export$7a8558113332b71e(b);
    if (!array && !($002159551d1c4551$export$53b83ca8eaab0383(a) && $002159551d1c4551$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $002159551d1c4551$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $002159551d1c4551$export$77a71fc411098696(aItem, bItem);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $002159551d1c4551$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $002159551d1c4551$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $002159551d1c4551$export$53b83ca8eaab0383(o) {
    if (!$002159551d1c4551$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$002159551d1c4551$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $002159551d1c4551$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $002159551d1c4551$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $f91dfb6f728f333f$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $002159551d1c4551$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $002159551d1c4551$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $002159551d1c4551$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $002159551d1c4551$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $002159551d1c4551$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $002159551d1c4551$export$1aa5a89531b7670d = Symbol();
function $002159551d1c4551$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $002159551d1c4551$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $002159551d1c4551$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}


var $1cb0c2534af8594c$var$_gcTimeout;
var $1cb0c2534af8594c$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1cb0c2534af8594c$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $002159551d1c4551$export$e539f754e934e270)(this.gcTime)) (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, (0, $f91dfb6f728f333f$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout)) {
            (0, $f91dfb6f728f333f$export$94a2700736e69372).clearTimeout((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout));
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
        }
    }
};
$1cb0c2534af8594c$var$_gcTimeout = new WeakMap();





// src/subscribable.ts
var $46c0846a49a6d58e$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $1d15693d13279fb4$var$_focused, $1d15693d13279fb4$var$_cleanup, $1d15693d13279fb4$var$_setup;
var $1d15693d13279fb4$export$86f1af424b2ca4de = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1d15693d13279fb4$var$_focused);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1d15693d13279fb4$var$_cleanup);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $1d15693d13279fb4$var$_setup);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, (onFocus)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) this.setEventListener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, setup);
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) !== focused;
        if (changed) {
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) === "boolean") return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$1d15693d13279fb4$var$_focused = new WeakMap();
$1d15693d13279fb4$var$_cleanup = new WeakMap();
$1d15693d13279fb4$var$_setup = new WeakMap();
var $1d15693d13279fb4$export$6bf54661be5b02cf = new $1d15693d13279fb4$export$86f1af424b2ca4de();





var $9606ae1cfceeea19$var$_online, $9606ae1cfceeea19$var$_cleanup, $9606ae1cfceeea19$var$_setup;
var $9606ae1cfceeea19$export$58774fb55d5ff7fc = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_online, true);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_cleanup);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_setup);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, (onOnline)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) this.setEventListener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, setup);
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online) !== online;
        if (changed) {
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online);
    }
};
$9606ae1cfceeea19$var$_online = new WeakMap();
$9606ae1cfceeea19$var$_cleanup = new WeakMap();
$9606ae1cfceeea19$var$_setup = new WeakMap();
var $9606ae1cfceeea19$export$b113e788b2dd3fdc = new $9606ae1cfceeea19$export$58774fb55d5ff7fc();




function $5a619d4c2df9bf12$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $5a619d4c2df9bf12$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $002159551d1c4551$export$8793edee2d425525))) == null || _a.catch((0, $002159551d1c4551$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $e19f6352d48643a1$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $e19f6352d48643a1$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline() : true;
}
var $e19f6352d48643a1$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $e19f6352d48643a1$export$986cc6445c1d323(value) {
    return value instanceof $e19f6352d48643a1$export$a8430ed4188f35a9;
}
function $e19f6352d48643a1$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new $e19f6352d48643a1$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$e19f6352d48643a1$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $e19f6352d48643a1$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $002159551d1c4551$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


var $96f19558542b246f$var$_client, $96f19558542b246f$var$_observers, $96f19558542b246f$var$_mutationCache, $96f19558542b246f$var$_retryer, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn;
var $96f19558542b246f$export$17b8b19c814bcf56 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_Mutation_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_observers);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_mutationCache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $96f19558542b246f$var$_retryer);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_client, config.client);
        this.mutationId = config.mutationId;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_mutationCache, config.mutationCache);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, []);
        this.state = config.state || $96f19558542b246f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).includes(observer)) {
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const onContinue = ()=>{
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this, mutationFnContext));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables, mutationFnContext));
                if (context !== this.state.context) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).start();
            await ((_f = (_e = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this, mutationFnContext));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context, mutationFnContext));
            await ((_j = (_i = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context, mutationFnContext));
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this, mutationFnContext));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context, mutationFnContext));
                await ((_r = (_q = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context, mutationFnContext));
                throw error;
            } finally{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_Mutation_instances, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).runNext(this);
        }
    }
};
$96f19558542b246f$var$_client = new WeakMap();
$96f19558542b246f$var$_observers = new WeakMap();
$96f19558542b246f$var$_mutationCache = new WeakMap();
$96f19558542b246f$var$_retryer = new WeakMap();
$96f19558542b246f$var$_Mutation_instances = new WeakSet();
$96f19558542b246f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $96f19558542b246f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}





var $8ecfcf98cb47c0ad$var$_client, $8ecfcf98cb47c0ad$var$_currentResult, $8ecfcf98cb47c0ad$var$_currentMutation, $8ecfcf98cb47c0ad$var$_mutateOptions, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn, $8ecfcf98cb47c0ad$var$notify_fn;
var $8ecfcf98cb47c0ad$export$d3c1860ee66f291a = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentResult);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentMutation);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_mutateOptions);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).defaultMutationOptions(options);
        if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $002159551d1c4551$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $002159551d1c4551$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_MutationObserver_instances, $8ecfcf98cb47c0ad$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, options);
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client), this.options));
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).addObserver(this);
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).execute(variables);
    }
};
$8ecfcf98cb47c0ad$var$_client = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentResult = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentMutation = new WeakMap();
$8ecfcf98cb47c0ad$var$_mutateOptions = new WeakMap();
$8ecfcf98cb47c0ad$var$_MutationObserver_instances = new WeakSet();
$8ecfcf98cb47c0ad$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $96f19558542b246f$export$a1659b54bac3252a)();
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$8ecfcf98cb47c0ad$var$notify_fn = function(action) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).variables;
            const onMutateResult = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).context;
            const context = {
                client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, onMutateResult, context);
                (_d = (_c = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, onMutateResult, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, onMutateResult, context);
                (_h = (_g = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, onMutateResult, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult));
        });
    });
};



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $aeeeb04cd6721116$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $aeeeb04cd6721116$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($aeeeb04cd6721116$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $aeeeb04cd6721116$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($aeeeb04cd6721116$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


"use client";
function $417dffbfea982a4c$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $8ecfcf98cb47c0ad$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $002159551d1c4551$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}









var $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$_revertState, $9dc680c629ca4c63$var$_cache, $9dc680c629ca4c63$var$_client, $9dc680c629ca4c63$var$_retryer, $9dc680c629ca4c63$var$_defaultOptions, $9dc680c629ca4c63$var$_abortSignalConsumed, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn;
var $9dc680c629ca4c63$export$62297b13309008b2 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_Query_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_initialState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_revertState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_cache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_retryer);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_defaultOptions);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_abortSignalConsumed);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_client, config.client);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_cache, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $9dc680c629ca4c63$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setData(defaultState.data, {
                    updatedAt: defaultState.dataUpdatedAt,
                    manual: true
                });
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $002159551d1c4551$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $002159551d1c4551$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $002159551d1c4551$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $002159551d1c4551$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                    if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_abortSignalConsumed)) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).continueRetry();
                return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $e19f6352d48643a1$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_f = (_e = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $e19f6352d48643a1$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_Query_instances, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_j = (_i = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$9dc680c629ca4c63$var$_initialState = new WeakMap();
$9dc680c629ca4c63$var$_revertState = new WeakMap();
$9dc680c629ca4c63$var$_cache = new WeakMap();
$9dc680c629ca4c63$var$_client = new WeakMap();
$9dc680c629ca4c63$var$_retryer = new WeakMap();
$9dc680c629ca4c63$var$_defaultOptions = new WeakMap();
$9dc680c629ca4c63$var$_abortSignalConsumed = new WeakMap();
$9dc680c629ca4c63$var$_Query_instances = new WeakSet();
$9dc680c629ca4c63$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$9dc680c629ca4c63$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $9dc680c629ca4c63$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $e19f6352d48643a1$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $9dc680c629ca4c63$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}






var $3aefa839a50a34b3$var$_client, $3aefa839a50a34b3$var$_currentQuery, $3aefa839a50a34b3$var$_currentQueryInitialState, $3aefa839a50a34b3$var$_currentResult, $3aefa839a50a34b3$var$_currentResultState, $3aefa839a50a34b3$var$_currentResultOptions, $3aefa839a50a34b3$var$_currentThenable, $3aefa839a50a34b3$var$_selectError, $3aefa839a50a34b3$var$_selectFn, $3aefa839a50a34b3$var$_selectResult, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, $3aefa839a50a34b3$var$_staleTimeoutId, $3aefa839a50a34b3$var$_refetchIntervalId, $3aefa839a50a34b3$var$_currentRefetchInterval, $3aefa839a50a34b3$var$_trackedProps, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn, $3aefa839a50a34b3$var$updateStaleTimeout_fn, $3aefa839a50a34b3$var$computeRefetchInterval_fn, $3aefa839a50a34b3$var$updateRefetchInterval_fn, $3aefa839a50a34b3$var$updateTimers_fn, $3aefa839a50a34b3$var$clearStaleTimeout_fn, $3aefa839a50a34b3$var$clearRefetchInterval_fn, $3aefa839a50a34b3$var$updateQuery_fn, $3aefa839a50a34b3$var$notify_fn;
var $3aefa839a50a34b3$export$a06cf8c0066f0d4c = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_QueryObserver_instances);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_client);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQuery);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResult);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultState);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentThenable);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectError);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectFn);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_staleTimeoutId);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_refetchIntervalId);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentRefetchInterval);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_client, client);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).addObserver(this);
            if ($3aefa839a50a34b3$var$shouldFetchOnMount((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options)) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        this.options = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $3aefa839a50a34b3$var$shouldFetchOptionally((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)))) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || nextRefetchInterval !== (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval))) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), options);
        const result = this.createResult(query, options);
        if ($3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, result);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
            (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise" && !this.options.experimental_prefetchInRender && (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable).status === "pending") (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const prevResultState = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState);
        const prevResultOptions = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $3aefa839a50a34b3$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $9dc680c629ca4c63$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectFn)) data = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            else try {
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectResult, data);
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
            } catch (selectError) {
                (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, selectError);
            }
        }
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError)) {
            error = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError);
            data = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $3aefa839a50a34b3$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable),
            isEnabled: (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, nextResult.promise = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const nextResult = this.createResult((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState).data !== void 0) (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
        if ((0, $002159551d1c4551$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
    }
};
$3aefa839a50a34b3$var$_client = new WeakMap();
$3aefa839a50a34b3$var$_currentQuery = new WeakMap();
$3aefa839a50a34b3$var$_currentQueryInitialState = new WeakMap();
$3aefa839a50a34b3$var$_currentResult = new WeakMap();
$3aefa839a50a34b3$var$_currentResultState = new WeakMap();
$3aefa839a50a34b3$var$_currentResultOptions = new WeakMap();
$3aefa839a50a34b3$var$_currentThenable = new WeakMap();
$3aefa839a50a34b3$var$_selectError = new WeakMap();
$3aefa839a50a34b3$var$_selectFn = new WeakMap();
$3aefa839a50a34b3$var$_selectResult = new WeakMap();
$3aefa839a50a34b3$var$_lastQueryWithDefinedData = new WeakMap();
$3aefa839a50a34b3$var$_staleTimeoutId = new WeakMap();
$3aefa839a50a34b3$var$_refetchIntervalId = new WeakMap();
$3aefa839a50a34b3$var$_currentRefetchInterval = new WeakMap();
$3aefa839a50a34b3$var$_trackedProps = new WeakMap();
$3aefa839a50a34b3$var$_QueryObserver_instances = new WeakSet();
$3aefa839a50a34b3$var$executeFetch_fn = function(fetchOptions) {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
    let promise = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
    return promise;
};
$3aefa839a50a34b3$var$updateStaleTimeout_fn = function() {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale || !(0, $002159551d1c4551$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $002159551d1c4551$export$811b83d62bcf47f0)((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, (0, $f91dfb6f728f333f$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$3aefa839a50a34b3$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$3aefa839a50a34b3$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, nextInterval);
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) === false || !(0, $002159551d1c4551$export$e539f754e934e270)((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)) || (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval) === 0) return;
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, (0, $f91dfb6f728f333f$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused()) (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
    }, (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)));
};
$3aefa839a50a34b3$var$updateTimers_fn = function() {
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
    (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, (0, $f48ef6896881c1e3$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_QueryObserver_instances, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this));
};
$3aefa839a50a34b3$var$clearStaleTimeout_fn = function() {
    if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId)) {
        (0, $f91dfb6f728f333f$export$94a2700736e69372).clearTimeout((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId));
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
    }
};
$3aefa839a50a34b3$var$clearRefetchInterval_fn = function() {
    if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId)) {
        (0, $f91dfb6f728f333f$export$94a2700736e69372).clearInterval((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId));
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
    }
};
$3aefa839a50a34b3$var$updateQuery_fn = function() {
    const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), this.options);
    if (query === (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) return;
    const prevQuery = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQuery, query);
    (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$3aefa839a50a34b3$var$notify_fn = function(notifyOptions) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult));
        });
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            query: (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $3aefa839a50a34b3$var$shouldFetchOnMount(query, options) {
    return $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $3aefa839a50a34b3$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $3aefa839a50a34b3$var$shouldFetchOn(query, options, field) {
    if ((0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $002159551d1c4551$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $3aefa839a50a34b3$var$isStale(query, options);
    }
    return false;
}
function $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $3aefa839a50a34b3$var$isStale(query, options);
}
function $3aefa839a50a34b3$var$isStale(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $9f918c9537253956$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $9f918c9537253956$var$QueryErrorResetBoundaryContext = $acw62.createContext($9f918c9537253956$var$createValue());
var $9f918c9537253956$export$50dfac555130cafd = ()=>$acw62.useContext($9f918c9537253956$var$QueryErrorResetBoundaryContext);
var $9f918c9537253956$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$9f918c9537253956$var$createValue());
    return /* @__PURE__ */ (0, $ayMG0.jsx)($9f918c9537253956$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $00f18dc4257f8dfa$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $00f18dc4257f8dfa$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $00f18dc4257f8dfa$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $002159551d1c4551$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $acw62 = parcelRequire("acw62");
"use client";
var $dfd30e3a705c285d$var$IsRestoringContext = $acw62.createContext(false);
var $dfd30e3a705c285d$export$4da0178d6b5f553 = ()=>$acw62.useContext($dfd30e3a705c285d$var$IsRestoringContext);
var $dfd30e3a705c285d$export$593807d4e94f9621 = $dfd30e3a705c285d$var$IsRestoringContext.Provider;


// src/suspense.ts
var $6de503da57e511b5$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $6de503da57e511b5$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $6de503da57e511b5$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $6de503da57e511b5$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $6de503da57e511b5$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $1fa9088b80b7d036$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const isRestoring = (0, $dfd30e3a705c285d$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $9f918c9537253956$export$50dfac555130cafd)();
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $6de503da57e511b5$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $00f18dc4257f8dfa$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $00f18dc4257f8dfa$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $002159551d1c4551$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $6de503da57e511b5$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $00f18dc4257f8dfa$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $002159551d1c4551$export$6acf61af03e62db) && (0, $6de503da57e511b5$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $002159551d1c4551$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $82072f1c97bcdd9c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $1fa9088b80b7d036$export$fff0865807e996c5)(options, (0, $3aefa839a50a34b3$export$a06cf8c0066f0d4c), queryClient);
}



function $33dbecf554ae91a9$export$da4506070569a682(userId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'applications',
            userId
        ],
        queryFn: ()=>(0, $b382938de4ad8ceb$export$d9eaa576453a4f6f).getUserApplications(),
        enabled: !!userId,
        // Retry on 401 since Clerk token might not be ready on first attempt
        retry: (failureCount, error)=>{
            // Retry up to 3 times for 401 errors (auth timing issue)
            if (error?.response?.status === 401 && failureCount < 3) return true;
            return false;
        },
        retryDelay: (attemptIndex)=>Math.min(1000 * (attemptIndex + 1), 3000)
    });
}
function $33dbecf554ae91a9$export$b23c64472d01ec80() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ trademarkId: trademarkId, applicationName: applicationName })=>(0, $b382938de4ad8ceb$export$d9eaa576453a4f6f).createApplication(trademarkId, applicationName),
        onSuccess: (_, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'applications',
                    variables.userId
                ]
            });
        }
    });
}
function $33dbecf554ae91a9$export$4dc878ec9b0f4ce0() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, data: data })=>(0, $b382938de4ad8ceb$export$d9eaa576453a4f6f).updateApplication(applicationId, data),
        onSuccess: (updated)=>{
            if (!updated?.id) return;
            // Merge the updated application into every cached applications list so
            // currentApplication reflects the save without a refetch (autosave runs
            // on a debounce — invalidating would refetch on every pause in typing)
            queryClient.setQueriesData({
                queryKey: [
                    'applications'
                ]
            }, (old)=>Array.isArray(old) ? old.map((app)=>app.id === updated.id ? {
                        ...app,
                        ...updated
                    } : app) : old);
        }
    });
}
function $33dbecf554ae91a9$export$9b7e8c6e92e5a1f0() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId })=>(0, $b382938de4ad8ceb$export$d9eaa576453a4f6f).cancelApplication(applicationId),
        onSuccess: ()=>{
            // Invalidate all application queries to force refresh
            queryClient.invalidateQueries({
                queryKey: [
                    'applications'
                ]
            });
        }
    });
}


// Custom event for application changes that other contexts can listen to
const $d266a5731496cc13$var$APPLICATION_CHANGED_EVENT = 'application_changed';
// Helper to dispatch the application changed event
function $d266a5731496cc13$var$dispatchApplicationChangedEvent(applicationId, threadId, trademarkId) {
    const event = new CustomEvent($d266a5731496cc13$var$APPLICATION_CHANGED_EVENT, {
        detail: {
            applicationId: applicationId,
            threadId: threadId,
            trademarkId: trademarkId
        }
    });
    window.dispatchEvent(event);
    console.log('Dispatched application changed event:', {
        applicationId: applicationId,
        threadId: threadId,
        trademarkId: trademarkId
    });
}
// Initial state
const $d266a5731496cc13$var$initialState = {
    currentApplicationId: sessionStorage.getItem('currentApplicationId') || null,
    currentThreadId: (()=>{
        const stored = sessionStorage.getItem('currentThreadId');
        return stored && stored !== 'null' ? stored : null;
    })(),
    applicationMode: sessionStorage.getItem('applicationMode') || 'new',
    loading: false,
    error: null
};
// Actions
const $d266a5731496cc13$var$actions = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    SET_CURRENT_APPLICATION: 'SET_CURRENT_APPLICATION',
    SET_APPLICATION_MODE: 'SET_APPLICATION_MODE',
    RESET: 'RESET'
};
// Reducer
function $d266a5731496cc13$var$userApplicationReducer(state, action) {
    switch(action.type){
        case $d266a5731496cc13$var$actions.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case $d266a5731496cc13$var$actions.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case $d266a5731496cc13$var$actions.SET_CURRENT_APPLICATION:
            // Store in sessionStorage when setting current application
            sessionStorage.setItem('currentApplicationId', action.payload.applicationId);
            // Only store threadId if it's not null to avoid storing "null" string
            if (action.payload.threadId) sessionStorage.setItem('currentThreadId', action.payload.threadId);
            else sessionStorage.removeItem('currentThreadId');
            if (action.payload.mode) sessionStorage.setItem('applicationMode', action.payload.mode);
            return {
                ...state,
                currentApplicationId: action.payload.applicationId,
                currentThreadId: action.payload.threadId,
                applicationMode: action.payload.mode || state.applicationMode,
                loading: false
            };
        case $d266a5731496cc13$var$actions.SET_APPLICATION_MODE:
            // Store in sessionStorage when setting application mode
            sessionStorage.setItem('applicationMode', action.payload);
            return {
                ...state,
                applicationMode: action.payload
            };
        case $d266a5731496cc13$var$actions.RESET:
            return $d266a5731496cc13$var$initialState;
        default:
            return state;
    }
}
// Create context
const $d266a5731496cc13$var$UserApplicationContext = /*#__PURE__*/ (0, $acw62.createContext)();
function $d266a5731496cc13$export$2601991d4c6a8be8({ children: children }) {
    const [state, dispatch] = (0, $acw62.useReducer)($d266a5731496cc13$var$userApplicationReducer, $d266a5731496cc13$var$initialState);
    const { user: user, isSignedIn: isSignedIn } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const createApplicationMutation = (0, $33dbecf554ae91a9$export$b23c64472d01ec80)();
    const cancelApplicationMutation = (0, $33dbecf554ae91a9$export$9b7e8c6e92e5a1f0)();
    const { data: applicationsData, isLoading: applicationsQueryLoading, isFetching: applicationsQueryFetching, error: applicationsQueryError, refetch: refetchApplications } = (0, $33dbecf554ae91a9$export$da4506070569a682)(user?.id);
    const applications = applicationsData || [];
    const applicationsLoading = applicationsQueryLoading || applicationsQueryFetching;
    const applicationsError = applicationsQueryError;
    (0, $acw62.useEffect)(()=>{
        if (!isSignedIn) dispatch({
            type: $d266a5731496cc13$var$actions.RESET
        });
    }, [
        isSignedIn
    ]);
    const setCurrentApplication = (0, $acw62.useCallback)(({ applicationId: applicationId, threadId: threadId, mode: mode, trademarkId: trademarkId })=>{
        dispatch({
            type: $d266a5731496cc13$var$actions.SET_CURRENT_APPLICATION,
            payload: {
                applicationId: applicationId,
                threadId: threadId,
                mode: mode
            }
        });
        const fallbackTrademarkId = trademarkId || applications.find((app)=>app.id === applicationId)?.trademarkId || null;
        $d266a5731496cc13$var$dispatchApplicationChangedEvent(applicationId, threadId, fallbackTrademarkId);
    }, [
        applications
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!applicationsLoading && !state.currentApplicationId && applications.length > 0 && !applicationsError) {
            // Auto-select the most recently updated application so multi-app users
            // land on the live one (the API returns applications unordered)
            const sortedApps = [
                ...applications
            ].sort((a, b)=>new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0));
            const firstApp = sortedApps[0];
            setCurrentApplication({
                applicationId: firstApp.id,
                threadId: firstApp.threadId,
                mode: state.applicationMode,
                trademarkId: firstApp.trademarkId
            });
        }
    }, [
        applications,
        applicationsError,
        applicationsLoading,
        setCurrentApplication,
        state.applicationMode,
        state.currentApplicationId
    ]);
    const loadUserApplications = (0, $acw62.useCallback)(async ()=>{
        return refetchApplications();
    }, [
        refetchApplications
    ]);
    // Create a new application
    const createNewApplication = (0, $acw62.useCallback)(async (trademarkId = null, applicationName = null)=>{
        if (!user?.id) throw new Error('User not authenticated');
        dispatch({
            type: $d266a5731496cc13$var$actions.SET_LOADING,
            payload: true
        });
        dispatch({
            type: $d266a5731496cc13$var$actions.SET_APPLICATION_MODE,
            payload: 'new'
        });
        try {
            const payload = {
                userId: user.id,
                trademarkId: trademarkId,
                applicationName: applicationName
            };
            const newApplication = await createApplicationMutation.mutateAsync(payload);
            await refetchApplications();
            const applicationId = newApplication.id || newApplication.applicationId;
            const threadId = newApplication.threadId || null;
            setCurrentApplication({
                applicationId: applicationId,
                threadId: threadId,
                mode: 'new',
                trademarkId: newApplication.trademarkId || trademarkId || null
            });
            return newApplication;
        } catch (error) {
            console.error('Failed to create application', error);
            dispatch({
                type: $d266a5731496cc13$var$actions.SET_ERROR,
                payload: error.message
            });
            throw error;
        } finally{
            dispatch({
                type: $d266a5731496cc13$var$actions.SET_LOADING,
                payload: false
            });
        }
    }, [
        createApplicationMutation,
        refetchApplications,
        setCurrentApplication,
        user?.id
    ]);
    // Cancel an application
    const cancelApplication = (0, $acw62.useCallback)(async (applicationId)=>{
        if (!user?.id) throw new Error('User not authenticated');
        dispatch({
            type: $d266a5731496cc13$var$actions.SET_LOADING,
            payload: true
        });
        try {
            await cancelApplicationMutation.mutateAsync({
                applicationId: applicationId
            });
            await refetchApplications();
        // If current application was cancelled, reset current? 
        // No, keep it selected but user will see it's cancelled status.
        } catch (error) {
            console.error('Failed to cancel application', error);
            dispatch({
                type: $d266a5731496cc13$var$actions.SET_ERROR,
                payload: error.message
            });
            throw error;
        } finally{
            dispatch({
                type: $d266a5731496cc13$var$actions.SET_LOADING,
                payload: false
            });
        }
    }, [
        cancelApplicationMutation,
        refetchApplications,
        user?.id
    ]);
    // Load a specific application
    const loadApplication = (0, $acw62.useCallback)(async (applicationId)=>{
        if (!applicationId) return;
        dispatch({
            type: $d266a5731496cc13$var$actions.SET_LOADING,
            payload: true
        });
        dispatch({
            type: $d266a5731496cc13$var$actions.SET_APPLICATION_MODE,
            payload: 'existing'
        });
        try {
            const applicationData = await (0, $b382938de4ad8ceb$export$d9eaa576453a4f6f).getApplicationData(applicationId);
            const threadId = applicationData.threadId || applicationData.application?.threadId || null;
            const trademarkId = applicationData.trademarkId || applicationData.trademark?.id || null;
            setCurrentApplication({
                applicationId: applicationId,
                threadId: threadId,
                mode: 'existing',
                trademarkId: trademarkId
            });
            return applicationData;
        } catch (error) {
            console.error(`Failed to load application ${applicationId}`, error);
            dispatch({
                type: $d266a5731496cc13$var$actions.SET_ERROR,
                payload: error.message
            });
            throw error;
        } finally{
            dispatch({
                type: $d266a5731496cc13$var$actions.SET_LOADING,
                payload: false
            });
        }
    }, [
        setCurrentApplication
    ]);
    // Helper to determine if we should create new application or update existing
    const shouldCreateNewApplication = (0, $acw62.useCallback)(()=>{
        return state.applicationMode === 'new' || !state.currentApplicationId;
    }, [
        state.applicationMode,
        state.currentApplicationId
    ]);
    // Helper to get current application context for trademark upload
    const getApplicationContext = (0, $acw62.useCallback)(()=>{
        return {
            applicationId: state.currentApplicationId,
            threadId: state.currentThreadId,
            mode: state.applicationMode,
            shouldCreateNew: shouldCreateNewApplication()
        };
    }, [
        shouldCreateNewApplication,
        state.applicationMode,
        state.currentApplicationId,
        state.currentThreadId
    ]);
    const currentApplication = (0, $acw62.useMemo)(()=>{
        if (!state.currentApplicationId) return null;
        return applications.find((app)=>app.id === state.currentApplicationId) || null;
    }, [
        applications,
        state.currentApplicationId
    ]);
    // 🔄 FORCE REFRESH: Reload applications data from backend (bypasses cache)
    const refreshApplications = (0, $acw62.useCallback)(async ()=>{
        if (!user?.id) return;
        await refetchApplications();
    }, [
        refetchApplications,
        user?.id
    ]);
    const combinedLoading = state.loading || applicationsLoading;
    const combinedError = state.error || applicationsError?.message || null;
    // Value to be provided - MEMOIZED to prevent infinite remounts
    const contextValue = (0, $acw62.useMemo)(()=>({
            applications: applications,
            currentApplication: currentApplication,
            currentApplicationId: state.currentApplicationId,
            currentThreadId: state.currentThreadId,
            applicationMode: state.applicationMode,
            loading: combinedLoading,
            error: combinedError,
            loadUserApplications: loadUserApplications,
            loadApplication: loadApplication,
            createNewApplication: createNewApplication,
            cancelApplication: cancelApplication,
            shouldCreateNewApplication: shouldCreateNewApplication,
            getApplicationContext: getApplicationContext,
            refreshApplications: refreshApplications,
            setCurrentApplication: setCurrentApplication
        }), [
        applications,
        combinedError,
        combinedLoading,
        createNewApplication,
        cancelApplication,
        currentApplication,
        getApplicationContext,
        loadApplication,
        loadUserApplications,
        refreshApplications,
        setCurrentApplication,
        state.currentApplicationId,
        state.currentThreadId,
        state.applicationMode,
        shouldCreateNewApplication
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d266a5731496cc13$var$UserApplicationContext.Provider, {
        value: contextValue,
        children: children
    });
}
function $d266a5731496cc13$export$3ea719c054b5ac49() {
    const context = (0, $acw62.useContext)($d266a5731496cc13$var$UserApplicationContext);
    if (!context) throw new Error('useUserApplication must be used within a UserApplicationProvider');
    return context;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $673ff3dfc4a496de$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $673ff3dfc4a496de$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$673ff3dfc4a496de$var$PATH_KEY]: path } = selector($673ff3dfc4a496de$var$createProxy());
    return path.join(opts?.keySeparator ?? '.');
}
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
const $673ff3dfc4a496de$var$shouldHandleAsObject = (res)=>!$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
        const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $673ff3dfc4a496de$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$673ff3dfc4a496de$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($673ff3dfc4a496de$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$673ff3dfc4a496de$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $673ff3dfc4a496de$var$regexSafe(this.escape(val)) : $673ff3dfc4a496de$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($673ff3dfc4a496de$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $673ff3dfc4a496de$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($673ff3dfc4a496de$var$getCleanedCode(l), o)(v);
class $673ff3dfc4a496de$var$Formatter {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $673ff3dfc4a496de$var$createCachedFormatter : $673ff3dfc4a496de$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $673ff3dfc4a496de$var$noop) {
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $673ff3dfc4a496de$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($673ff3dfc4a496de$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $673ff3dfc4a496de$var$I18n(options, callback);
        instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $673ff3dfc4a496de$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) clone.services.interpolator = new $673ff3dfc4a496de$var$Interpolator(mergedOptions);
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg) && $cfb6e0167e0b350d$var$alreadyWarned[msg]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg)) $cfb6e0167e0b350d$var$alreadyWarned[msg] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;



const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $acffcb171536f8e9$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $acffcb171536f8e9$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $acffcb171536f8e9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $acffcb171536f8e9$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${escapedString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const INTERNAL_DYNAMIC_MARKER = 'data-i18n-is-dynamic-list';
            const override = {
                key: i,
                [INTERNAL_DYNAMIC_MARKER]: undefined
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children' || k === 'i18nIsDynamicList' || k === INTERNAL_DYNAMIC_MARKER) return;
                override[k] = c.props[k];
            });
            return (0, $acw62.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(val)) props[p] = (0, $d7f2d92b0368699f$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
const $acffcb171536f8e9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $acw62.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
    }
    return (0, $acw62.createElement)(Componentized, {
        key: componentKey
    });
};
const $acffcb171536f8e9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$acffcb171536f8e9$var$fixComponentProps(c, index, translation));
const $acffcb171536f8e9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $acffcb171536f8e9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $acffcb171536f8e9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $acffcb171536f8e9$var$generateArrayComponents(components, translation);
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(components)) return $acffcb171536f8e9$var$generateObjectComponents(components, translation);
    (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $acffcb171536f8e9$var$isComponentsMap = (object)=>{
    if (!(0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $673ff3dfc4a496de$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $acffcb171536f8e9$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $acffcb171536f8e9$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($acffcb171536f8e9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $acffcb171536f8e9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


class $e0c19337b294ccec$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e0c19337b294ccec$export$aa9e222d9ffc5d1b);
    }
}


const $1ddf6027fecc0115$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $1ddf6027fecc0115$var$entityPattern = new RegExp(Object.keys($1ddf6027fecc0115$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $1ddf6027fecc0115$export$5cfeaa4af6841c8f = (text)=>text.replace($1ddf6027fecc0115$var$entityPattern, (match)=>$1ddf6027fecc0115$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $5f107391742a83a7$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $acw62 = parcelRequire("acw62");



const $54962d9d09845ed9$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, ...children);
};
const $54962d9d09845ed9$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5f107391742a83a7$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $1ddf6027fecc0115$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $54962d9d09845ed9$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $e917e4d32765654d$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $54962d9d09845ed9$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, translation);
    }
}
$e917e4d32765654d$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $60cfc2270f17f8cc$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $e917e4d32765654d$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$60cfc2270f17f8cc$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $acw62 = parcelRequire("acw62");



const $3765cebd031b52c0$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    return Array.isArray(k) ? k[k.length - 1] : k;
};
const $3765cebd031b52c0$var$notReadySnapshot = {
    t: $3765cebd031b52c0$var$notReadyT,
    ready: false
};
const $3765cebd031b52c0$var$dummySubscribe = ()=>()=>{};
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $acw62.useMemo)(()=>({
            ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $acw62.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $acw62.useRef)(0);
    const subscribe = (0, $acw62.useCallback)((callback)=>{
        if (!i18n) return $3765cebd031b52c0$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $acw62.useRef)();
    const getSnapshot = (0, $acw62.useCallback)(()=>{
        if (!i18n) return $3765cebd031b52c0$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $acw62.useState)(0);
    const { t: t, ready: ready } = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $acw62.useRef)(null);
    const wrapperLangRef = (0, $acw62.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $acw62.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const arr = [
            t,
            i18nWrapper,
            ready
        ];
        arr.t = t;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
    });
    return ret;
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleAlert", $5415d98bde6b29f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $75957e2fe5dd6cb2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.268 21a2 2 0 0 0 3.464 0",
            key: "vwvbt9"
        }
    ],
    [
        "path",
        {
            d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
            key: "11g9vi"
        }
    ]
];
const $75957e2fe5dd6cb2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Bell", $75957e2fe5dd6cb2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1cfd183b457f6f1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 7v14",
            key: "1akyts"
        }
    ],
    [
        "path",
        {
            d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
            key: "ruj8y"
        }
    ]
];
const $e1cfd183b457f6f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("BookOpen", $e1cfd183b457f6f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3f86240925e7a9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleCheckBig", $e3f86240925e7a9e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronDown", $4f88028b3cc726f6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("FileText", $adb270212de20834$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d456d8ec70b00bbe$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
            key: "j76jl0"
        }
    ],
    [
        "path",
        {
            d: "M22 10v6",
            key: "1lu8f3"
        }
    ],
    [
        "path",
        {
            d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5",
            key: "1r8lef"
        }
    ]
];
const $d456d8ec70b00bbe$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("GraduationCap", $d456d8ec70b00bbe$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d41f89c0dd165c13$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $d41f89c0dd165c13$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleHelp", $d41f89c0dd165c13$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5473793717b51056$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 21 12 16 7",
            key: "1gabdz"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ]
];
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LogOut", $5473793717b51056$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6fe951f3901e9a6$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
            key: "1ocrg3"
        }
    ]
];
const $d6fe951f3901e9a6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Mail", $d6fe951f3901e9a6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b66c39b6083b2b9$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "12",
            y2: "12",
            key: "1e0a9i"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "6",
            y2: "6",
            key: "1owob3"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "18",
            y2: "18",
            key: "yk5zj1"
        }
    ]
];
const $4b66c39b6083b2b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Menu", $4b66c39b6083b2b9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $960b709ecb4ade55$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
];
const $960b709ecb4ade55$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Shield", $960b709ecb4ade55$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0f45c1e8ae52ad76$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("User", $0f45c1e8ae52ad76$export$3efd853dbb351e94);


var $b16e332ddae306fa$exports = {};
$b16e332ddae306fa$exports = import.meta.resolve("iqH3F");


// Re-export all common components from a single entry point
// Button component
parcelRequire("fYgYF");
parcelRequire("67mnf");
parcelRequire("2Q0xG");
parcelRequire("e5fs2");
parcelRequire("h4Kcn");
parcelRequire("3oCiM");
parcelRequire("9a5LV");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $b59a4b217a27027a$export$42a852a2b6b56249 = ({ children: children, className: className = '', size: size = 'md', as: Component = 'div', ...props })=>{
    const sizes = {
        sm: 'max-w-3xl',
        md: 'max-w-5xl',
        lg: 'max-w-7xl',
        xl: 'max-w-screen-2xl',
        full: 'max-w-full'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('mx-auto px-4 sm:px-6 lg:px-8', sizes[size], className),
        ...props,
        children: children
    });
};
const $b59a4b217a27027a$export$694e0d28c7ffc90c = ({ children: children, className: className = '', space: space = 'md', as: Component = 'div', divider: divider = false, ...props })=>{
    const spaces = {
        xs: 'space-y-2',
        sm: 'space-y-4',
        md: 'space-y-6',
        lg: 'space-y-8',
        xl: 'space-y-12'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('flex flex-col', spaces[space], divider && 'divide-y divide-gray-200 dark:divide-gray-800', className),
        ...props,
        children: children
    });
};
const $b59a4b217a27027a$export$ef2184bd89960b14 = ({ children: children, className: className = '', cols: cols = {
    default: 1,
    sm: 2,
    md: 3,
    lg: 4
}, gap: gap = 'md', as: Component = 'div', ...props })=>{
    // Construct responsive column classes
    const colClasses = Object.entries(cols).map(([breakpoint, count])=>{
        if (breakpoint === 'default') return `grid-cols-${count}`;
        return `${breakpoint}:grid-cols-${count}`;
    }).join(' ');
    const gaps = {
        xs: 'gap-2',
        sm: 'gap-4',
        md: 'gap-6',
        lg: 'gap-8',
        xl: 'gap-12'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('grid', colClasses, gaps[gap], className),
        ...props,
        children: children
    });
};
const $b59a4b217a27027a$export$f51f4c4ede09e011 = ({ children: children, className: className = '', direction: direction = 'row', wrap: wrap = false, justify: justify = 'start', items: items = 'start', gap: gap = 'md', as: Component = 'div', ...props })=>{
    const directions = {
        row: 'flex-row',
        'row-reverse': 'flex-row-reverse',
        col: 'flex-col',
        'col-reverse': 'flex-col-reverse'
    };
    const justifyOptions = {
        start: 'justify-start',
        end: 'justify-end',
        center: 'justify-center',
        between: 'justify-between',
        around: 'justify-around',
        evenly: 'justify-evenly'
    };
    const itemsOptions = {
        start: 'items-start',
        end: 'items-end',
        center: 'items-center',
        baseline: 'items-baseline',
        stretch: 'items-stretch'
    };
    const gaps = {
        xs: 'gap-2',
        sm: 'gap-4',
        md: 'gap-6',
        lg: 'gap-8',
        xl: 'gap-12'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)('flex', directions[direction], wrap && 'flex-wrap', justifyOptions[justify], itemsOptions[items], gaps[gap], className),
        ...props,
        children: children
    });
};
const $b59a4b217a27027a$export$e71c4d32a2263218 = ({ children: children, className: className = '', as: Component = 'div', p: p, px: px, py: py, pt: pt, pr: pr, pb: pb, pl: pl, m: m, mx: mx, my: my, mt: mt, mr: mr, mb: mb, ml: ml, width: width, height: height, bg: bg, color: color, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor, borderStyle: borderStyle, overflow: overflow, display: display, position: position, top: top, right: right, bottom: bottom, left: left, flex: flex, ...props })=>{
    // Map values to tailwind classes
    const paddingClasses = {
        p: p && `p-${p}`,
        px: px && `px-${px}`,
        py: py && `py-${py}`,
        pt: pt && `pt-${pt}`,
        pr: pr && `pr-${pr}`,
        pb: pb && `pb-${pb}`,
        pl: pl && `pl-${pl}`
    };
    const marginClasses = {
        m: m && `m-${m}`,
        mx: mx && `mx-${mx}`,
        my: my && `my-${my}`,
        mt: mt && `mt-${mt}`,
        mr: mr && `mr-${mr}`,
        mb: mb && `mb-${mb}`,
        ml: ml && `ml-${ml}`
    };
    const dimensionClasses = {
        width: width && (width === 'full' ? 'w-full' : `w-${width}`),
        height: height && (height === 'full' ? 'h-full' : `h-${height}`)
    };
    const appearanceClasses = {
        bg: bg && (bg === 'transparent' ? 'bg-transparent' : `bg-${bg}`),
        color: color && `text-${color}`,
        borderRadius: borderRadius && `rounded${borderRadius === 'md' ? '-md' : borderRadius === 'lg' ? '-lg' : borderRadius === 'full' ? '-full' : ''}`,
        borderWidth: borderWidth && (borderWidth === '1' ? 'border' : `border-${borderWidth}`),
        borderColor: borderColor && `border-${borderColor}`,
        borderStyle: borderStyle && `border-${borderStyle}`
    };
    const layoutClasses = {
        overflow: overflow && `overflow-${overflow}`,
        display: display,
        position: position,
        top: top !== undefined && `top-${top}`,
        right: right !== undefined && `right-${right}`,
        bottom: bottom !== undefined && `bottom-${bottom}`,
        left: left !== undefined && `left-${left}`,
        flex: flex !== undefined && `flex-${flex}`
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, $9QePP.default)(Object.values(paddingClasses).filter(Boolean), Object.values(marginClasses).filter(Boolean), Object.values(dimensionClasses).filter(Boolean), Object.values(appearanceClasses).filter(Boolean), Object.values(layoutClasses).filter(Boolean), className),
        ...props,
        children: children
    });
};
const $b59a4b217a27027a$export$2e0a83ec2e27ecbb = ({ className: className = '', ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
        className: (0, $9QePP.default)('border-t border-gray-200 my-4', className),
        ...props
    });
};











































var // Export a default object with all components for easy access
$8283f3e274584315$export$2e2bcd8739ae039 = {
    // Button variants
    Button: (parcelRequire("fYgYF")).Button,
    Primary: (parcelRequire("fYgYF")).Primary,
    Secondary: (parcelRequire("fYgYF")).Secondary,
    Outline: (parcelRequire("fYgYF")).Outline,
    Ghost: (parcelRequire("fYgYF")).Ghost,
    Danger: (parcelRequire("fYgYF")).Danger,
    Success: (parcelRequire("fYgYF")).Success,
    // Card components
    Card: (parcelRequire("67mnf")).Card,
    CardHeader: (parcelRequire("67mnf")).CardHeader,
    CardTitle: (parcelRequire("67mnf")).CardTitle,
    CardDescription: (parcelRequire("67mnf")).CardDescription,
    CardContent: (parcelRequire("67mnf")).CardContent,
    CardFooter: (parcelRequire("67mnf")).CardFooter,
    // Typography components
    Heading: (parcelRequire("2Q0xG")).Heading,
    H1: (parcelRequire("2Q0xG")).H1,
    H2: (parcelRequire("2Q0xG")).H2,
    H3: (parcelRequire("2Q0xG")).H3,
    H4: (parcelRequire("2Q0xG")).H4,
    H5: (parcelRequire("2Q0xG")).H5,
    H6: (parcelRequire("2Q0xG")).H6,
    Text: (parcelRequire("2Q0xG")).Text,
    Lead: (parcelRequire("2Q0xG")).Lead,
    Muted: (parcelRequire("2Q0xG")).Muted,
    Small: (parcelRequire("2Q0xG")).Small,
    Link: (parcelRequire("2Q0xG")).Link,
    // Form components
    Input: (parcelRequire("e5fs2")).Input,
    TextField: (parcelRequire("e5fs2")).TextField,
    Select: (parcelRequire("h4Kcn")).Select,
    // Feedback components
    Badge: (parcelRequire("3oCiM")).Badge,
    Modal: (parcelRequire("9a5LV")).Modal,
    SmallModal: (parcelRequire("9a5LV")).SmallModal,
    MediumModal: (parcelRequire("9a5LV")).MediumModal,
    LargeModal: (parcelRequire("9a5LV")).LargeModal,
    ExtraLargeModal: (parcelRequire("9a5LV")).ExtraLargeModal,
    ModalContent: (parcelRequire("9a5LV")).ModalContent,
    ModalFooter: (parcelRequire("9a5LV")).ModalFooter,
    // Layout components
    Container: (parcelRequire("knNQ8")).Container,
    Stack: (parcelRequire("knNQ8")).Stack,
    Grid: (parcelRequire("knNQ8")).Grid,
    Flex: (parcelRequire("knNQ8")).Flex,
    Divider: (parcelRequire("knNQ8")).Divider
};


var $fYgYF = parcelRequire("fYgYF");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $ca2195b404f36d61$var$languages = [
    {
        code: 'en',
        name: 'English',
        short: 'EN'
    },
    {
        code: 'es',
        name: "Espa\xf1ol",
        short: 'ES'
    },
    {
        code: 'de',
        name: 'Deutsch',
        short: 'DE'
    },
    {
        code: 'zh',
        name: "\u4E2D\u6587",
        short: "\u4E2D\u6587"
    }
];
function $ca2195b404f36d61$export$ddd501dda1f62236() {
    const { i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const currentLang = $ca2195b404f36d61$var$languages.find((l)=>l.code === (i18n.language?.split('-')[0] || 'en')) || $ca2195b404f36d61$var$languages[0];
    // Close dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleLanguageChange = (langCode)=>{
        i18n.changeLanguage(langCode);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "relative",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: ()=>setIsOpen(!isOpen),
                className: "flex items-center gap-1 px-2 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-100 transition-colors",
                "aria-label": "Select language",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: currentLang.short
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        className: `h-3.5 w-3.5 transition-transform ${isOpen ? 'rotate-180' : ''}`
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute right-0 mt-1 py-1 bg-white rounded-lg shadow-lg border border-gray-200 z-50 min-w-[120px]",
                children: $ca2195b404f36d61$var$languages.map((lang)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleLanguageChange(lang.code),
                        className: `w-full px-3 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between ${currentLang.code === lang.code ? 'text-teal-600 font-medium bg-teal-50' : 'text-gray-700'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: lang.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-xs text-gray-400",
                                children: lang.short
                            })
                        ]
                    }, lang.code))
            })
        ]
    });
}
var $ca2195b404f36d61$export$2e2bcd8739ae039 = $ca2195b404f36d61$export$ddd501dda1f62236;



/**
 * Notification Service
 * Handles API calls for notifications
 */ 
const $239a2fbc292443b5$var$notificationService = {
    /**
   * Get notifications for the current user
   * @param {object} options Query options
   * @returns {Promise<object>} Notifications response
   */ async getNotifications (options = {}) {
        const params = new URLSearchParams();
        if (options.unreadOnly) params.append('unreadOnly', 'true');
        if (options.limit) params.append('limit', options.limit.toString());
        if (options.offset) params.append('offset', options.offset.toString());
        const queryString = params.toString();
        const url = queryString ? `/notifications?${queryString}` : '/notifications';
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(url);
        return response.data;
    },
    /**
   * Get unread notification count
   * @returns {Promise<object>} Count response
   */ async getUnreadCount () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/notifications/count');
        return response.data;
    },
    /**
   * Get a single notification by ID
   * @param {string} id Notification ID
   * @returns {Promise<object>} Notification
   */ async getNotification (id) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/notifications/${id}`);
        return response.data;
    },
    /**
   * Mark a notification as read
   * @param {string} id Notification ID
   * @returns {Promise<object>} Updated notification
   */ async markAsRead (id) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).patch(`/notifications/${id}`, {
            action: 'read'
        });
        return response.data;
    },
    /**
   * Mark all notifications as read
   * @returns {Promise<object>} Result
   */ async markAllAsRead () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/notifications', {
            action: 'markAllRead'
        });
        return response.data;
    },
    /**
   * Dismiss a notification
   * @param {string} id Notification ID
   * @returns {Promise<object>} Updated notification
   */ async dismiss (id) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).patch(`/notifications/${id}`, {
            action: 'dismiss'
        });
        return response.data;
    }
};
var $239a2fbc292443b5$export$2e2bcd8739ae039 = $239a2fbc292443b5$var$notificationService;


const $9a2aa97e168cad7f$export$87340cf3b68810a6 = [
    'notifications'
];
const $9a2aa97e168cad7f$export$3871083ef318a187 = [
    'notifications',
    'count'
];
function $9a2aa97e168cad7f$export$53d5ca6c3f53e109(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$9a2aa97e168cad7f$export$87340cf3b68810a6,
            options
        ],
        queryFn: ()=>(0, $239a2fbc292443b5$export$2e2bcd8739ae039).getNotifications(options),
        staleTime: 30000,
        refetchOnWindowFocus: true
    });
}
function $9a2aa97e168cad7f$export$bc7c0b865d38394e() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $9a2aa97e168cad7f$export$3871083ef318a187,
        queryFn: ()=>(0, $239a2fbc292443b5$export$2e2bcd8739ae039).getUnreadCount(),
        staleTime: 30000,
        refetchInterval: 60000 // Refetch every minute
    });
}
function $9a2aa97e168cad7f$export$9949bd9c713ba425(id) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$9a2aa97e168cad7f$export$87340cf3b68810a6,
            id
        ],
        queryFn: ()=>(0, $239a2fbc292443b5$export$2e2bcd8739ae039).getNotification(id),
        enabled: !!id,
        staleTime: 60000
    });
}
function $9a2aa97e168cad7f$export$449b31cdde239e3() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $239a2fbc292443b5$export$2e2bcd8739ae039).markAsRead(id),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $9a2aa97e168cad7f$export$87340cf3b68810a6
            });
            queryClient.invalidateQueries({
                queryKey: $9a2aa97e168cad7f$export$3871083ef318a187
            });
        }
    });
}
function $9a2aa97e168cad7f$export$b2e3457257157b65() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $239a2fbc292443b5$export$2e2bcd8739ae039).markAllAsRead(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $9a2aa97e168cad7f$export$87340cf3b68810a6
            });
            queryClient.invalidateQueries({
                queryKey: $9a2aa97e168cad7f$export$3871083ef318a187
            });
        }
    });
}
function $9a2aa97e168cad7f$export$a87a5db5802e8349() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $239a2fbc292443b5$export$2e2bcd8739ae039).dismiss(id),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $9a2aa97e168cad7f$export$87340cf3b68810a6
            });
            queryClient.invalidateQueries({
                queryKey: $9a2aa97e168cad7f$export$3871083ef318a187
            });
        }
    });
}
var $9a2aa97e168cad7f$export$2e2bcd8739ae039 = {
    useNotifications: $9a2aa97e168cad7f$export$53d5ca6c3f53e109,
    useUnreadCount: $9a2aa97e168cad7f$export$bc7c0b865d38394e,
    useNotification: $9a2aa97e168cad7f$export$9949bd9c713ba425,
    useMarkAsRead: $9a2aa97e168cad7f$export$449b31cdde239e3,
    useMarkAllAsRead: $9a2aa97e168cad7f$export$b2e3457257157b65,
    useDismissNotification: $9a2aa97e168cad7f$export$a87a5db5802e8349
};



const $8e62364690990d03$var$MARKOTM_ORG_ID = "org_3CyO9qq1lkFxNXGHwC73GC52pTB";
const $8e62364690990d03$var$DashboardHeader = ({ userName: userName, onMenuClick: onMenuClick })=>{
    const [openMenu, setOpenMenu] = (0, $acw62.useState)(null);
    const { isSignedIn: isSignedIn, user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { signOut: signOut } = (0, $8fcdbf2d7a4660c6$exports.useClerk)();
    const [hasAdminAccess, setHasAdminAccess] = (0, $acw62.useState)(false);
    const handleSignOut = async ()=>{
        setOpenMenu(null);
        (0, $dcc07888711c910b$export$8321f7adb8c682ab).signOut();
        await signOut({
            redirectUrl: '/sign-in'
        });
    };
    // Real notifications from API
    const { data: notificationsData } = (0, $9a2aa97e168cad7f$export$53d5ca6c3f53e109)({
        limit: 10
    });
    const { data: unreadCountData } = (0, $9a2aa97e168cad7f$export$bc7c0b865d38394e)();
    const markAsReadMutation = (0, $9a2aa97e168cad7f$export$449b31cdde239e3)();
    const markAllAsReadMutation = (0, $9a2aa97e168cad7f$export$b2e3457257157b65)();
    const notifications = notificationsData?.notifications || [];
    const hasUnreadNotifications = (unreadCountData?.count || 0) > 0;
    // Check admin access
    (0, $acw62.useEffect)(()=>{
        const checkAdminAccess = async ()=>{
            if (user && user.organizationMemberships) try {
                // Find MarkoTM organization by ID (from env var)
                const markoTMOrg = user.organizationMemberships.find((membership)=>membership.organization.id === $8e62364690990d03$var$MARKOTM_ORG_ID);
                const isMarkoTMAdmin = markoTMOrg?.role === 'org:admin';
                // STRICT: Only show admin button if user is admin in MarkoTM organization
                setHasAdminAccess(isMarkoTMAdmin);
            } catch (error) {
                console.error('Error checking admin access:', error);
                setHasAdminAccess(false);
            }
            else console.log("\u23F3 Admin Access: Waiting for user/org to load", {
                user: !!user,
                hasOrgMemberships: !!user?.organizationMemberships
            });
        };
        checkAdminAccess();
    }, [
        user
    ]); // Removed redundant user?.organizationMemberships to prevent excessive re-renders
    // Academy resources dropdown items - links to marketing site
    const MARKETING_URL = 'https://www.markotm.com';
    const academyResources = [
        {
            title: 'Trademark Academy',
            description: 'Learn about trademark fundamentals and strategies',
            icon: (0, $d456d8ec70b00bbe$export$2e2bcd8739ae039),
            link: `${MARKETING_URL}/resources/academy`
        },
        {
            title: 'Country Guides',
            description: 'Specific trademark requirements by country',
            icon: (0, $e1cfd183b457f6f1$export$2e2bcd8739ae039),
            link: `${MARKETING_URL}/resources/country-guide`
        },
        {
            title: 'Trademark Dictionary',
            description: 'Definitions of common trademark terms',
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
            link: `${MARKETING_URL}/resources/dictionary`
        },
        {
            title: 'Help Center',
            description: 'Get assistance with your application',
            icon: (0, $d41f89c0dd165c13$export$2e2bcd8739ae039),
            link: `${MARKETING_URL}/resources/help`
        }
    ];
    // Helper to format notification time
    const formatNotificationTime = (dateString)=>{
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffMins < 60) return `${diffMins} min ago`;
        if (diffHours < 24) return `${diffHours} hours ago`;
        if (diffDays === 1) return 'Yesterday';
        if (diffDays < 7) return `${diffDays} days ago`;
        return date.toLocaleDateString();
    };
    // Map notification urgency/category to type for icon styling
    const getNotificationType = (notification)=>{
        if (notification.urgency === 'critical' || notification.urgency === 'high') return 'warning';
        if (notification.category === 'office_action' || notification.category === 'deadline') return 'warning';
        if (notification.category === 'status_change' || notification.category === 'filing_update') return 'success';
        if (notification.category === 'correspondence') return 'info';
        return 'info';
    };
    // Settings menu items
    const settingsItems = [
        {
            title: 'Account Settings',
            description: 'Update your profile and preferences',
            icon: (0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039),
            action: ()=>window.location.hash = 'settings'
        },
        {
            title: 'Notification Preferences',
            description: 'Control what updates you receive',
            icon: (0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039),
            action: ()=>window.location.hash = 'settings'
        },
        {
            title: 'Billing & Payments',
            description: 'Manage payment methods and invoices',
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
            action: ()=>window.location.hash = 'settings'
        }
    ];
    // Dropdown menu components
    const ResourceDropdown = ({ isOpen: isOpen })=>{
        if (!isOpen) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fixed inset-x-3 top-[4.5rem] sm:absolute sm:inset-x-auto sm:top-full sm:right-0 sm:mt-1 sm:w-72 bg-white rounded-lg shadow-lg overflow-hidden z-50",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 bg-gray-50 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-medium text-gray-900",
                            children: "Resources"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-sm text-gray-600",
                            children: "Helpful tools for your trademark journey"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-2",
                    children: academyResources.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            href: item.link,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "flex items-start p-3 rounded-md hover:bg-gray-50 transition-colors",
                            onClick: ()=>setOpenMenu(null),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex-shrink-0 p-1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(item.icon, {
                                        className: "w-5 h-5 text-[#00695c]"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "ml-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "text-sm font-medium text-gray-900",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-xs text-gray-600",
                                            children: item.description
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        });
    };
    const NotificationsDropdown = ({ isOpen: isOpen })=>{
        if (!isOpen) return null;
        const handleMarkAllAsRead = (e)=>{
            e.stopPropagation();
            markAllAsReadMutation.mutate();
        };
        const handleNotificationClick = (notification)=>{
            if (!notification.read) markAsReadMutation.mutate(notification.id);
            setOpenMenu(null);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fixed inset-x-3 top-[4.5rem] sm:absolute sm:inset-x-auto sm:top-full sm:right-0 sm:mt-1 sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden z-50",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "font-medium text-gray-900",
                                    children: "Notifications"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-gray-600",
                                    children: "Your trademark activity updates"
                                })
                            ]
                        }),
                        hasUnreadNotifications && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: handleMarkAllAsRead,
                            className: "text-xs text-teal-600 hover:text-teal-800 font-medium",
                            disabled: markAllAsReadMutation.isPending,
                            children: markAllAsReadMutation.isPending ? 'Marking...' : 'Mark all as read'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overflow-y-auto max-h-80",
                    children: notifications.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: notifications.map((notification)=>{
                            const notificationType = getNotificationType(notification);
                            let Icon = (0, $e3f86240925e7a9e$export$2e2bcd8739ae039);
                            let iconColor = 'text-green-500';
                            if (notificationType === 'warning') {
                                Icon = (0, $5415d98bde6b29f1$export$2e2bcd8739ae039);
                                iconColor = 'text-amber-500';
                            } else if (notificationType === 'info') {
                                Icon = (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039);
                                iconColor = 'text-blue-500';
                            }
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `p-3 border-b border-gray-100 hover:bg-gray-50 flex items-start cursor-pointer ${!notification.read ? 'bg-teal-50' : ''}`,
                                onClick: ()=>handleNotificationClick(notification),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `flex-shrink-0 ${iconColor}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                            className: "h-5 w-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "ml-3 flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-between items-start",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: `text-sm font-medium ${!notification.read ? 'text-gray-900' : 'text-gray-700'}`,
                                                        children: notification.title
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-xs text-gray-500",
                                                        children: formatNotificationTime(notification.createdAt)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-xs text-gray-600 mt-0.5",
                                                children: notification.message
                                            })
                                        ]
                                    }),
                                    !notification.read && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "ml-2 flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h-2 w-2 rounded-full bg-teal-500"
                                        })
                                    })
                                ]
                            }, notification.id);
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-8 text-center text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039), {
                                className: "h-8 w-8 mx-auto mb-2 opacity-50"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "No notifications yet"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs mt-1",
                                children: "We'll notify you about important updates"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-3 border-t border-gray-200 bg-gray-50",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/notifications",
                        className: "block text-center text-sm text-teal-600 hover:text-teal-800 font-medium",
                        onClick: ()=>setOpenMenu(null),
                        children: "View all notifications"
                    })
                })
            ]
        });
    };
    const SettingsDropdown = ({ isOpen: isOpen })=>{
        if (!isOpen) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fixed inset-x-3 top-[4.5rem] sm:absolute sm:inset-x-auto sm:top-full sm:right-0 sm:mt-1 sm:w-72 bg-white rounded-lg shadow-lg overflow-hidden z-50",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p-4 bg-gray-50 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-medium text-gray-900",
                            children: "Settings"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-sm text-gray-600",
                            children: "Manage your account and preferences"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-2",
                    children: settingsItems.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "w-full text-left flex items-start p-3 rounded-md hover:bg-gray-50 transition-colors",
                            onClick: ()=>{
                                item.action();
                                setOpenMenu(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex-shrink-0 p-1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(item.icon, {
                                        className: "w-5 h-5 text-[#00695c]"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "ml-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "text-sm font-medium text-gray-900",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-xs text-gray-600",
                                            children: item.description
                                        })
                                    ]
                                })
                            ]
                        }, index))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-2 border-t border-gray-200",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "w-full text-left flex items-start p-3 rounded-md hover:bg-red-50 transition-colors",
                        onClick: handleSignOut,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-shrink-0 p-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-red-600"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-sm font-medium text-red-600",
                                        children: "Log Out"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-xs text-gray-600",
                                        children: "Sign out of your account"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: "bg-gradient-to-r from-[#004d40] via-[#00695c] to-[#00796b] shadow-md z-20 h-16 fixed top-0 w-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-4 h-full flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                variant: "ghost",
                                size: "icon",
                                className: "md:hidden text-white hover:bg-white/10 min-h-[44px] min-w-[44px]",
                                onClick: onMenuClick,
                                "aria-label": "Open navigation menu",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/",
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b16e332ddae306fa$exports))),
                                    alt: "MarkoTM",
                                    className: "h-9 w-auto brightness-0 invert"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        className: "p-2 rounded-full hover:bg-[#00897b] text-white relative",
                                        onClick: ()=>setOpenMenu(openMenu === 'notifications' ? null : 'notifications'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5"
                                            }),
                                            hasUnreadNotifications && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "absolute top-1 right-1 h-2.5 w-2.5 bg-red-500 rounded-full border border-[#00695c]"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(NotificationsDropdown, {
                                        isOpen: openMenu === 'notifications'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "p-2 rounded-full hover:bg-white/10 text-white flex items-center transition-colors",
                                        onClick: ()=>setOpenMenu(openMenu === 'resources' ? null : 'resources'),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d41f89c0dd165c13$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(ResourceDropdown, {
                                        isOpen: openMenu === 'resources'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca2195b404f36d61$export$ddd501dda1f62236), {}),
                            hasAdminAccess && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/admin",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "p-2 rounded-full bg-red-500/20 hover:bg-red-500/30 text-white flex items-center gap-1 transition-colors",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    })
                                })
                            }),
                            isSignedIn ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 ml-2 pl-2 border-l border-white/20",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        className: "flex items-center gap-2 p-1.5 rounded-full hover:bg-white/10 transition-colors",
                                        onClick: ()=>setOpenMenu(openMenu === 'settings' ? null : 'settings'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "h-8 w-8 rounded-full bg-white/20 flex items-center justify-center overflow-hidden ring-2 ring-white/30",
                                                children: user?.imageUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: user.imageUrl,
                                                    alt: "Profile",
                                                    className: "h-full w-full object-cover"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4 text-white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                className: `h-4 w-4 text-white/70 transition-transform ${openMenu === 'settings' ? 'rotate-180' : ''}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(SettingsDropdown, {
                                        isOpen: openMenu === 'settings'
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex items-center gap-2 ml-2 pl-2 border-l border-white/20",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-white/60 text-sm",
                                    children: "Guest"
                                })
                            })
                        ]
                    })
                ]
            }),
            openMenu && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/10 backdrop-blur-sm z-10",
                onClick: ()=>setOpenMenu(null)
            })
        ]
    });
};
var $8e62364690990d03$export$2e2bcd8739ae039 = $8e62364690990d03$var$DashboardHeader;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34c3e517ec92034a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Briefcase", $34c3e517ec92034a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30050f52d874b8f2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $30050f52d874b8f2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Calendar", $30050f52d874b8f2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronRight", $7979593adeba180b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1299b0a605d22052$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
];
const $1299b0a605d22052$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CreditCard", $1299b0a605d22052$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c52b562f10363bcd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "3",
            rx: "1",
            key: "1g98yp"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "3",
            rx: "1",
            key: "6d4xhi"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "14",
            y: "14",
            rx: "1",
            key: "nxv5o0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "7",
            x: "3",
            y: "14",
            rx: "1",
            key: "1bb6yr"
        }
    ]
];
const $c52b562f10363bcd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LayoutGrid", $c52b562f10363bcd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e20ffdae2aa9b33f$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $e20ffdae2aa9b33f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Lock", $e20ffdae2aa9b33f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $198f0fcb2df6a37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
            key: "1lielz"
        }
    ]
];
const $198f0fcb2df6a37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("MessageSquare", $198f0fcb2df6a37f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Settings", $da03c070d837b197$export$3efd853dbb351e94);






/**
 * Application status helpers — single source of truth for client-facing
 * status labels across the dashboard (Sidebar, Home, Portfolio, Payments).
 *
 * Full status enum (see "Free Report Funnel" implementation plan):
 *   active → quote_requested → quote_sent → (paid) → pending_attorney_filing
 *     → filing_in_progress → filed → registered
 *   plus: completed, cancelled, refunded, partially_refunded
 */ // status → [i18n key (dashboard namespace), English fallback]
const $dc60fa0fe0f6ea60$var$STATUS_LABELS = {
    active: [
        'status.inProgress',
        'In Progress'
    ],
    draft: [
        'status.inProgress',
        'In Progress'
    ],
    quote_requested: [
        'status.quoteRequested',
        'Preparing your report'
    ],
    quote_sent: [
        'status.quoteSent',
        'Quote ready'
    ],
    payment_pending: [
        'status.paymentPending',
        'Payment Pending'
    ],
    payment_completed: [
        'status.paymentComplete',
        'Payment Complete'
    ],
    pending_attorney_filing: [
        'status.pendingFiling',
        'Pending Filing'
    ],
    filing_in_progress: [
        'status.filingInProgress',
        'Filing in Progress'
    ],
    filed: [
        'status.filed',
        'Filed'
    ],
    registered: [
        'status.registered',
        'Registered'
    ],
    completed: [
        'status.completed',
        'Completed'
    ],
    cancelled: [
        'status.cancelled',
        'Cancelled'
    ],
    refunded: [
        'status.refunded',
        'Refunded'
    ],
    partially_refunded: [
        'status.partiallyRefunded',
        'Partially Refunded'
    ]
};
function $dc60fa0fe0f6ea60$export$489c297e3a119321(status, t) {
    const entry = $dc60fa0fe0f6ea60$var$STATUS_LABELS[status];
    if (!entry) {
        // Unknown status — humanise the snake_case rather than rendering it raw
        if (status) return status.replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
        return t ? t('status.inProgress', 'In Progress') : 'In Progress';
    }
    return t ? t(entry[0], entry[1]) : entry[1];
}
function $dc60fa0fe0f6ea60$export$b3e57d64388d46af(status) {
    return status === 'quote_requested' || status === 'quote_sent';
}
function $dc60fa0fe0f6ea60$export$e7288b3232a7b847(app) {
    if (!app) return false;
    return app.paymentStatus === 'paid' || [
        'payment_completed',
        'pending_attorney_filing',
        'filing_in_progress',
        'filed',
        'registered',
        'completed'
    ].includes(app.status);
}
function $dc60fa0fe0f6ea60$export$817691802b5d05c5(app) {
    if (!app) return false;
    return app.status === 'completed' || app.status === 'registered';
}
const $dc60fa0fe0f6ea60$export$64d4a5b91c97bf11 = `${"https://www.markotm.com"}/file-trademark`;


const $e25cb8ac1431c627$var$MARKOTM_ORG_ID = "org_3CyO9qq1lkFxNXGHwC73GC52pTB";
/**
 * Dashboard sidebar navigation component
 * Clean, modern design with brand colors
 *
 * Desktop (md+): static 256px column, always visible (unchanged).
 * Mobile (<md): overlay drawer under the fixed header, opened via the
 * hamburger in DashboardHeader; backdrop click closes it.
 *
 * @param {Object} props
 * @param {string} props.activeSection - Currently active section ID
 * @param {Function} props.onSectionChange - Callback when section is changed
 * @param {boolean} props.mobileOpen - Whether the mobile drawer is open
 * @param {Function} props.onClose - Close the mobile drawer
 * @returns {JSX.Element}
 */ const $e25cb8ac1431c627$var$Sidebar = ({ activeSection: activeSection, onSectionChange: onSectionChange, mobileOpen: mobileOpen = false, onClose: onClose })=>{
    const { currentApplication: currentApplication } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { organization: organization } = (0, $8fcdbf2d7a4660c6$exports.useOrganization)();
    // Check if user is part of MarkoTM organization (internal staff)
    const isInternalUser = organization?.id === $e25cb8ac1431c627$var$MARKOTM_ORG_ID;
    const sections = [
        {
            id: 'home',
            label: t('sidebar.dashboard', 'Dashboard'),
            description: t('sidebar.overview', 'Overview'),
            icon: (0, $c52b562f10363bcd$export$2e2bcd8739ae039)
        },
        {
            id: 'payments',
            label: t('sidebar.quoteAndPayment', 'Quote & Payment'),
            description: t('sidebar.quoteAndPaymentDesc', 'Review your quote and pay'),
            icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039)
        },
        {
            id: 'portfolio',
            label: t('sidebar.myPortfolio', 'My Portfolio'),
            description: t('sidebar.viewTrademarks', 'View your trademarks'),
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039)
        },
        {
            id: 'messages',
            label: t('sidebar.messages', 'Messages'),
            description: t('sidebar.attorneyMessages', 'Attorney communications'),
            icon: (0, $198f0fcb2df6a37f$export$2e2bcd8739ae039)
        },
        {
            id: 'renewals',
            label: t('sidebar.renewals', 'Renewals'),
            description: t('sidebar.upcomingDeadlines', 'Upcoming deadlines'),
            icon: (0, $30050f52d874b8f2$export$2e2bcd8739ae039),
            comingSoon: true
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            mobileOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 top-16 z-30 bg-black/40 md:hidden touch-none",
                onClick: onClose,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `bg-white border-r border-gray-200 shadow-sm w-64 flex-shrink-0 tutorial-sidebar flex flex-col overflow-y-auto
      fixed top-16 bottom-0 left-0 z-40 transform transition-transform duration-200 ease-in-out
      ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}
      md:static md:h-full md:z-auto md:translate-x-0 md:transition-none`,
                children: [
                    currentApplication && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "p-4 border-b border-gray-100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-gradient-to-br from-[#e0f2f1] to-[#b2dfdb] rounded-xl p-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-xs font-medium text-[#004d40] uppercase tracking-wide mb-1",
                                    children: t('sidebar.currentApplication', 'Current Application')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "font-semibold text-[#004d40] truncate",
                                    children: currentApplication.name || currentApplication.trademarkName || 'New Application'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-xs text-[#00796b] mt-1",
                                    children: (0, $dc60fa0fe0f6ea60$export$489c297e3a119321)(currentApplication.status, t)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                        className: "flex-1 p-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                            className: "space-y-1",
                            children: sections.map((section)=>{
                                const isActive = activeSection === section.id;
                                const Icon = section.icon;
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>!section.comingSoon && onSectionChange(section.id),
                                        disabled: section.comingSoon,
                                        className: `
                    w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left transition-all duration-200
                    ${isActive ? 'bg-[#004d40] text-white shadow-md' : section.comingSoon ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'}
                  `,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `
                    w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0
                    ${isActive ? 'bg-white/20' : section.comingSoon ? 'bg-gray-100' : 'bg-[#e0f2f1]'}
                  `,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                    className: `w-4 h-4 ${isActive ? 'text-white' : section.comingSoon ? 'text-gray-400' : 'text-[#00796b]'}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex-1 min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `text-sm font-medium ${isActive ? 'text-white' : ''}`,
                                                                children: section.label
                                                            }),
                                                            section.comingSoon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                                className: "w-3 h-3 text-gray-400"
                                                            })
                                                        ]
                                                    }),
                                                    !section.comingSoon && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: `text-xs truncate ${isActive ? 'text-white/70' : 'text-gray-500'}`,
                                                        children: section.description
                                                    })
                                                ]
                                            }),
                                            isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 text-white/70"
                                            })
                                        ]
                                    })
                                }, section.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-4 border-t border-gray-100 space-y-1",
                        children: [
                            isInternalUser && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>navigate('/attorney'),
                                className: "w-full flex items-center gap-3 px-3 py-2 rounded-lg text-[#00796b] hover:bg-[#e0f2f1] transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34c3e517ec92034a$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-sm font-medium",
                                        children: t('sidebar.attorneyDashboard', 'Attorney Dashboard')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>onSectionChange('settings'),
                                className: "w-full flex items-center gap-3 px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-sm",
                                        children: t('sidebar.settings', 'Settings')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e25cb8ac1431c627$export$2e2bcd8739ae039 = $e25cb8ac1431c627$var$Sidebar;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00824d397ec63c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("TriangleAlert", $00824d397ec63c04$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9e50e5a44fb11e0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowRight", $f9e50e5a44fb11e0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16 14",
            key: "68esgv"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Clock", $200392fae49ddb7e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c35b0991cad9668$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const $3c35b0991cad9668$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ExternalLink", $3c35b0991cad9668$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Plus", $dbde4c3396582d11$export$3efd853dbb351e94);



var $fYgYF = parcelRequire("fYgYF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $a7c475f60523fba3$var$RecentActivity = ({ currentApplication: currentApplication })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-2xl p-6 shadow-sm border border-gray-200",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                className: "font-bold text-gray-900 mb-4 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-gray-500"
                    }),
                    "Recent Activity"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "relative pl-4 border-l-2 border-gray-100 space-y-6 my-2",
                children: currentApplication ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-green-500 ring-4 ring-white shadow-sm"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-sm font-bold text-gray-900",
                                            children: "Application Updated"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "text-xs text-gray-500 mt-1",
                                            children: [
                                                "Your application for ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "font-medium text-gray-700",
                                                    children: [
                                                        '"',
                                                        currentApplication.trademarkName || 'Untitled',
                                                        '"'
                                                    ]
                                                }),
                                                " was saved."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-400 mt-1 font-medium",
                                            children: new Date(currentApplication.updatedAt || Date.now()).toLocaleDateString()
                                        })
                                    ]
                                })
                            ]
                        }),
                        currentApplication.analysisCompleted && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-purple-500 ring-4 ring-white shadow-sm"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-sm font-bold text-gray-900",
                                            children: "Analysis Completed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-500 mt-1",
                                            children: "Marko AI finished analyzing your trademark for conflicts."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-blue-500 ring-4 ring-white shadow-sm"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-sm font-bold text-gray-900",
                                            children: "Application Started"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-500 mt-1",
                                            children: "You started a new trademark application."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-xs text-gray-400 mt-1 font-medium",
                                            children: new Date(currentApplication.createdAt || Date.now()).toLocaleDateString()
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-gray-300 ring-4 ring-white shadow-sm"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-sm font-bold text-gray-900",
                                    children: "Account Created"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-xs text-gray-500 mt-1",
                                    children: "Welcome to Marko! Your journey begins here."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $a7c475f60523fba3$export$2e2bcd8739ae039 = $a7c475f60523fba3$var$RecentActivity;



// Ken's hosted photo — same hotlinked asset the email signatures use
// (see backend/api/shared/services/senders.js)
const $2dd5be37ad88fb1e$var$KEN_PHOTO_URL = 'https://www.markotm.com/assets/images/ken-mcinnes.png';
const $2dd5be37ad88fb1e$var$DashboardHome = ({ onNavigate: onNavigate })=>{
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const { currentApplication: currentApplication, applications: applications = [] } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const [kenPhotoFailed, setKenPhotoFailed] = (0, $acw62.useState)(false);
    // Calculate stats using real data.
    // Quote-stage leads are NOT "Active Filings" — a filing only becomes active once paid.
    const stats = (0, $acw62.useMemo)(()=>{
        const active = applications.filter((app)=>(0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(app) && !(0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(app) && app.status !== 'cancelled').length;
        const completed = applications.filter((app)=>(0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(app)).length;
        // "Action Required": a confirmed quote awaiting payment, explicit action states,
        // or a pending payment.
        const actionRequired = applications.filter((app)=>{
            if (app.status === 'quote_sent' && !(0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(app)) return true;
            if (app.status === 'action_required' || app.status === 'rejected' || app.status === 'payment_pending') return true;
            return false;
        }).length;
        return {
            active: active,
            completed: completed,
            actionRequired: actionRequired
        };
    }, [
        applications
    ]);
    // Progress for the current application — status-driven (quote-first funnel)
    const currentAppProgress = (0, $acw62.useMemo)(()=>{
        if (!currentApplication) return 0;
        const status = currentApplication.status;
        if ((0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(currentApplication)) return 100;
        if (status === 'filed') return 90;
        if (status === 'filing_in_progress') return 80;
        if ((0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(currentApplication)) return 70;
        if (status === 'quote_sent') return 50;
        if (status === 'quote_requested') return 35;
        // Legacy/active applications that predate the quote flow
        if (currentApplication.pricingId) return 50;
        if (currentApplication.analysisId || currentApplication.analysisCompleted) return 30;
        return 15;
    }, [
        currentApplication
    ]);
    // Generate dynamic Marko Insights — status-aware for the quote-first funnel
    const insights = (0, $acw62.useMemo)(()=>{
        const items = [];
        if (currentApplication) {
            const status = currentApplication.status;
            if ((0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(currentApplication) && !(0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(currentApplication)) items.push({
                type: 'success',
                title: t('home.insights.filingInProgress', 'Filing In Progress'),
                message: t('home.insights.filingInProgressMsg', 'Your payment is complete. Your trademark application is being prepared for filing.'),
                action: ()=>onNavigate('payments')
            });
            else if (status === 'quote_requested') items.push({
                type: 'info',
                title: t('home.insights.reportPreparing', 'Report On Its Way'),
                message: t('home.insights.reportPreparingMsg', 'We are preparing your trademark report and quote. Expect an email within 24 hours.'),
                action: ()=>onNavigate('payments')
            });
            else if (status === 'quote_sent') items.push({
                type: 'warning',
                title: t('home.insights.quoteReady', 'Your Quote Is Ready'),
                message: t('home.insights.quoteReadyMsg', 'Your attorney-confirmed quote is ready. Review it and pay to start your filing.'),
                action: ()=>onNavigate('payments')
            });
            else if (status === 'payment_pending') items.push({
                type: 'warning',
                title: t('home.insights.paymentPending', 'Payment Pending'),
                message: t('home.insights.paymentPendingMsg', 'Your application is ready for filing. Complete payment to proceed.'),
                action: ()=>onNavigate('payments')
            });
            else if (!(0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(currentApplication) && status !== 'cancelled') items.push({
                type: 'info',
                title: t('home.insights.appInProgress', 'Application in Progress'),
                message: t('home.insights.appInProgressMsg', 'Check your quote and payment status to move your application forward.'),
                action: ()=>onNavigate('payments')
            });
        } else items.push({
            type: 'info',
            title: t('home.insights.startJourney', 'Start Your Journey'),
            message: t('home.insights.startJourneyMsg', "Get a free trademark check and quote on our website \u2014 no payment required upfront."),
            action: ()=>{
                window.location.href = (0, $dc60fa0fe0f6ea60$export$64d4a5b91c97bf11);
            }
        });
        // Analysis insight — only when relevant and not already covered above
        if (currentApplication && (currentApplication.analysisId || currentApplication.analysisCompleted)) {
            const alreadyShownFilingProgress = (0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(currentApplication);
            if (!alreadyShownFilingProgress && !(0, $dc60fa0fe0f6ea60$export$b3e57d64388d46af)(currentApplication.status)) items.push({
                type: 'success',
                title: t('home.insights.analysisComplete', 'Analysis Completed'),
                message: t('home.insights.analysisCompleteMsg', 'Marko has analysed your trademark. Check the report for potential conflicts.'),
                action: ()=>onNavigate('payments')
            });
        }
        // Dynamic status based on app count
        const totalApps = applications?.length || 0;
        const completedApps = applications?.filter((0, $dc60fa0fe0f6ea60$export$817691802b5d05c5))?.length || 0;
        if (completedApps > 0) items.push({
            type: 'success',
            title: `${completedApps} Trademark${completedApps > 1 ? 's' : ''} Protected`,
            message: `You have ${completedApps} registered trademark${completedApps > 1 ? 's' : ''} in your portfolio.`,
            action: ()=>onNavigate('portfolio')
        });
        else if (totalApps === 0) items.push({
            type: 'system',
            title: t('home.insights.systemOp', 'Ready to Help'),
            message: 'Marko is ready to guide you through the trademark process.'
        });
        else items.push({
            type: 'system',
            title: t('home.insights.systemOp', 'System Operational'),
            message: t('home.insights.systemOpMsg', 'All monitoring systems active')
        });
        return items;
    }, [
        currentApplication,
        applications,
        onNavigate,
        t
    ]);
    // Continue-CTA label for the current application card
    const continueLabel = (0, $acw62.useMemo)(()=>{
        if (!currentApplication) return t('home.continueFiling', 'View Quote & Payment');
        if (currentApplication.status === 'quote_sent' && !(0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(currentApplication)) return t('home.payAndFile', 'Pay & File');
        if (currentApplication.status === 'quote_requested') return t('home.viewQuoteStatus', 'View Status');
        if ((0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(currentApplication)) return t('home.viewFilingStatus', 'View Filing Status');
        return t('home.continueFiling', 'View Quote & Payment');
    }, [
        currentApplication,
        t
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6 animate-in fade-in duration-500",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col md:flex-row justify-between items-start md:items-end gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-2xl md:text-3xl font-bold text-gray-900 tracking-tight",
                                children: t('home.welcome', 'Welcome back, {{name}}', {
                                    name: user?.firstName || t('home.guest', 'Guest')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-600 mt-2 text-base md:text-lg",
                                children: t('home.subtitle', "Here's what's happening with your intellectual property today.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                        onClick: ()=>{
                            window.location.href = (0, $dc60fa0fe0f6ea60$export$64d4a5b91c97bf11);
                        },
                        className: "w-full md:w-auto justify-center flex items-center gap-2 shadow-lg hover:shadow-xl transition-all bg-[#004d40] hover:bg-[#00695c] text-white px-6 py-3 rounded-xl",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "h-5 w-5"
                            }),
                            t('home.newFiling', 'New Trademark Check')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2dd5be37ad88fb1e$var$StatsCard, {
                        title: t('home.activeFilings', 'Active Filings'),
                        value: stats.active,
                        icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                        color: "blue",
                        onClick: ()=>onNavigate('portfolio')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2dd5be37ad88fb1e$var$StatsCard, {
                        title: t('home.actionRequired', 'Action Required'),
                        value: stats.actionRequired,
                        icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039),
                        color: "amber",
                        onClick: ()=>onNavigate('payments')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2dd5be37ad88fb1e$var$StatsCard, {
                        title: t('home.protectedAssets', 'Protected Assets'),
                        value: stats.completed,
                        icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                        color: "green",
                        onClick: ()=>onNavigate('portfolio')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lg:col-span-2 space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-xl font-bold text-gray-900",
                                        children: t('home.currentApplication')
                                    }),
                                    currentApplication && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>onNavigate('portfolio'),
                                        className: "text-sm font-medium text-[#00695c] hover:text-[#004d40] flex items-center gap-1",
                                        children: [
                                            t('home.viewAll', 'View All'),
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            currentApplication ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-all cursor-pointer group relative overflow-hidden",
                                onClick: ()=>onNavigate('payments'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                            className: "h-32 w-32 text-gray-400 transform rotate-12"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative z-10",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-wrap justify-between items-start gap-3 mb-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-3 md:gap-4 min-w-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "h-12 w-12 md:h-14 md:w-14 rounded-2xl bg-[#e0f2f1] flex items-center justify-center text-[#00695c] flex-shrink-0",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                    className: "h-6 w-6 md:h-7 md:w-7"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "min-w-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "text-lg md:text-xl font-bold text-gray-900 group-hover:text-[#00695c] transition-colors break-words",
                                                                        children: currentApplication.trademarkName || 'New Trademark Application'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "text-sm text-gray-500 mt-1",
                                                                        children: [
                                                                            "Application ID: ",
                                                                            currentApplication.id?.slice(0, 8).toUpperCase()
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `px-4 py-1.5 rounded-full text-sm font-medium border whitespace-nowrap flex-shrink-0 ${(0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(currentApplication) ? 'bg-green-50 text-green-700 border-green-100' : currentApplication.status === 'quote_sent' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-blue-50 text-blue-700 border-blue-100'}`,
                                                        children: (0, $dc60fa0fe0f6ea60$export$489c297e3a119321)(currentApplication.status, t)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mb-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex justify-between text-sm mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "text-gray-600",
                                                                children: t('home.applicationProgress')
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "font-medium text-gray-900",
                                                                children: [
                                                                    currentAppProgress,
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "h-2 w-full bg-gray-100 rounded-full overflow-hidden",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "h-full bg-[#00695c] rounded-full transition-all duration-1000",
                                                            style: {
                                                                width: `${currentAppProgress}%`
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-wrap items-center justify-between gap-2 pt-4 border-t border-gray-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-2 text-sm text-gray-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: t('home.lastUpdated', 'Last updated: {{date}}', {
                                                                    date: new Date(currentApplication.updatedAt || Date.now()).toLocaleDateString()
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-1 text-[#00695c] font-bold text-sm group-hover:gap-2 transition-all",
                                                        children: [
                                                            continueLabel,
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-white rounded-2xl p-10 shadow-sm border border-gray-200 text-center relative overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#004d40] to-[#00796b]"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mx-auto h-20 w-20 bg-gray-50 rounded-full flex items-center justify-center mb-6",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                            className: "h-10 w-10 text-gray-400"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: t('home.noActiveApplications')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-gray-500 mb-8 max-w-md mx-auto leading-relaxed",
                                        children: t('home.startProtecting', "Start with a free trademark check on our website. You will get a detailed report and an attorney-confirmed quote within 24 hours \u2014 no payment needed upfront.")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                        onClick: ()=>{
                                            window.location.href = (0, $dc60fa0fe0f6ea60$export$64d4a5b91c97bf11);
                                        },
                                        className: "px-8 py-3 text-lg rounded-xl shadow-lg bg-[#004d40] hover:bg-[#00695c] inline-flex items-center gap-2",
                                        children: [
                                            t('home.startNewApp', 'Start Your Free Check'),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-white rounded-2xl p-6 shadow-sm border border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "font-bold text-gray-900 mb-4",
                                        children: t('home.quickActions')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>onNavigate('payments'),
                                                className: "text-left p-4 rounded-xl bg-gray-50 hover:bg-[#e0f2f1] border border-transparent hover:border-[#b2dfdb] transition-all group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "bg-white w-10 h-10 rounded-lg flex items-center justify-center mb-3 shadow-sm group-hover:scale-110 transition-transform",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-600 group-hover:text-[#00695c]"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "font-medium text-gray-900 block mb-1",
                                                        children: t('home.resumeFiling')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-xs text-gray-500",
                                                        children: t('home.resumeFilingDesc')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>onNavigate('settings'),
                                                className: "text-left p-4 rounded-xl bg-gray-50 hover:bg-[#e0f2f1] border border-transparent hover:border-[#b2dfdb] transition-all group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "bg-white w-10 h-10 rounded-lg flex items-center justify-center mb-3 shadow-sm group-hover:scale-110 transition-transform",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-600 group-hover:text-[#00695c]"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "font-medium text-gray-900 block mb-1",
                                                        children: t('home.paymentHistory')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-xs text-gray-500",
                                                        children: t('home.paymentHistoryDesc')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>onNavigate('messages'),
                                                className: "text-left p-4 rounded-xl bg-gray-50 hover:bg-[#e0f2f1] border border-transparent hover:border-[#b2dfdb] transition-all group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "bg-white w-10 h-10 rounded-lg flex items-center justify-center mb-3 shadow-sm group-hover:scale-110 transition-transform",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $198f0fcb2df6a37f$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-600 group-hover:text-[#00695c]"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "font-medium text-gray-900 block mb-1",
                                                        children: t('home.contactSupport')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-xs text-gray-500",
                                                        children: t('home.contactSupportDesc')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                className: "text-xl font-bold text-gray-900 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-[#00695c]"
                                    }),
                                    t('home.fromYourAttorney', 'From Your Attorney')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg-white rounded-2xl p-6 shadow-sm border border-gray-200 relative overflow-hidden tutorial-marko-chat",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#004d40] to-[#00796b]"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-start gap-4 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    kenPhotoFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "h-12 w-12 rounded-full bg-[#e0f2f1] border-2 border-white shadow-md flex items-center justify-center text-sm font-bold text-[#00695c]",
                                                        children: "KM"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: $2dd5be37ad88fb1e$var$KEN_PHOTO_URL,
                                                        alt: t('attorney.name', 'Ken McInnes'),
                                                        onError: ()=>setKenPhotoFailed(true),
                                                        className: "h-12 w-12 rounded-full object-cover border-2 border-white shadow-md"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "absolute bottom-0 right-0 h-3 w-3 bg-green-500 border-2 border-white rounded-full"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-sm font-bold text-gray-900",
                                                        children: t('attorney.name', 'Ken McInnes')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs text-gray-500",
                                                        children: t('attorney.title', 'Head of Trademark Strategy')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "bg-teal-50 rounded-xl p-4 mb-4 border border-teal-100",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-gray-800 text-sm leading-relaxed",
                                            children: t('attorney.greeting', "Welcome to your secure IP dashboard. You can follow your trade mark's progress here, and it makes it easy to stay in touch with your assigned trade mark attorney at every step.")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "space-y-3",
                                        children: insights.map((insight, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                onClick: insight.action,
                                                className: `flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100 ${insight.action ? 'cursor-pointer' : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${insight.type === 'success' ? 'bg-green-50 text-green-600' : insight.type === 'warning' ? 'bg-amber-50 text-amber-600' : insight.type === 'info' ? 'bg-blue-50 text-blue-600' : 'bg-[#e0f2f1] text-[#00695c]'}`,
                                                        children: insight.type === 'success' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }) : insight.type === 'warning' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }) : insight.type === 'info' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "font-medium text-gray-900",
                                                                children: insight.title
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "text-gray-500 text-xs mt-0.5",
                                                                children: insight.message
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7c475f60523fba3$export$2e2bcd8739ae039), {
                                currentApplication: currentApplication
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $2dd5be37ad88fb1e$var$StatsCard = ({ title: title, value: value, icon: Icon, color: color })=>{
    const colorStyles = {
        blue: 'bg-blue-50 text-blue-600',
        green: 'bg-green-50 text-green-600',
        amber: 'bg-amber-50 text-amber-600'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-2xl p-6 shadow-sm border border-gray-200 flex items-center gap-4 hover:shadow-md transition-shadow",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `h-14 w-14 rounded-2xl flex items-center justify-center ${colorStyles[color]} transition-transform hover:scale-110`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                    className: "h-7 w-7"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-gray-500 text-sm font-medium mb-1",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-3xl font-bold text-gray-900",
                        children: value
                    })
                ]
            })
        ]
    });
};
var $2dd5be37ad88fb1e$export$2e2bcd8739ae039 = $2dd5be37ad88fb1e$var$DashboardHome;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bf452017d8c279bd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v4",
            key: "3427ic"
        }
    ],
    [
        "path",
        {
            d: "m16.2 7.8 2.9-2.9",
            key: "r700ao"
        }
    ],
    [
        "path",
        {
            d: "M18 12h4",
            key: "wj9ykh"
        }
    ],
    [
        "path",
        {
            d: "m16.2 16.2 2.9 2.9",
            key: "1bxg5t"
        }
    ],
    [
        "path",
        {
            d: "M12 18v4",
            key: "jadmvz"
        }
    ],
    [
        "path",
        {
            d: "m4.9 19.1 2.9-2.9",
            key: "bwix9q"
        }
    ],
    [
        "path",
        {
            d: "M2 12h4",
            key: "j09sii"
        }
    ],
    [
        "path",
        {
            d: "m4.9 4.9 2.9 2.9",
            key: "giyufr"
        }
    ]
];
const $bf452017d8c279bd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Loader", $bf452017d8c279bd$export$3efd853dbb351e94);



const $15ebc391a13b5e97$export$c9cfb16a57b0f583 = {
    /**
   * Create a Stripe checkout session
   */ async createCheckoutSession (sessionData) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/payments?action=create-checkout-session', sessionData);
            return response.data;
        } catch (error) {
            console.error('Error creating checkout session:', error);
            throw error;
        }
    },
    /**
   * Get payment status
   */ async getPaymentStatus (paymentId) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/payments?action=status&paymentId=${paymentId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting payment status:', error);
            throw error;
        }
    },
    /**
   * Get payment for application
   */ async getApplicationPayment (applicationId) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/payments?action=application&applicationId=${applicationId}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 404) return null;
            console.error('Error getting application payment:', error);
            throw error;
        }
    },
    /**
   * Get payment history for a user
   */ async getPaymentHistory (userId) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/payments?action=history&userId=${userId}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 404) return [];
            console.error('Error getting payment history:', error);
            throw error;
        }
    },
    /**
   * Verify payment session (after Stripe redirect)
   */ async verifySession (sessionId) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/payments?action=verify-session', {
                sessionId: sessionId
            });
            return response.data;
        } catch (error) {
            console.error('Error verifying payment session:', error);
            throw error;
        }
    },
    /**
   * Process refund (admin function)
   */ async processRefund (paymentId, refundData) {
        try {
            const requestData = {
                paymentId: paymentId,
                ...refundData
            };
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/payments?action=refund', requestData);
            return response.data;
        } catch (error) {
            console.error('Error processing refund:', error);
            throw error;
        }
    },
    /**
   * Get payment statistics (admin function)
   */ async getPaymentStats () {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/payments?action=stats');
            return response.data;
        } catch (error) {
            console.error('Error getting payment stats:', error);
            throw error;
        }
    },
    /**
   * Get all payments (admin function)
   */ async getAllPayments (limit = 50, offset = 0) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/payments?action=list&admin=true&limit=${limit}&offset=${offset}`);
            // Ensure we return the payments array, not the wrapper object
            const data = response.data;
            if (data && data.payments && Array.isArray(data.payments)) return data.payments;
            else if (Array.isArray(data)) return data;
            else {
                console.warn('Unexpected response format from getAllPayments:', data);
                return [];
            }
        } catch (error) {
            console.error('Error getting all payments:', error);
            // Return empty array instead of throwing to prevent frontend crashes
            return [];
        }
    },
    /**
   * Create a temporary cart for pricing calculations
   */ async calculatePrice (trademarkId, countries, classes) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/payments?action=calculate-price', {
                trademarkId: trademarkId,
                countries: countries,
                classes: classes
            });
            return response.data;
        } catch (error) {
            console.error('Error calculating price:', error);
            throw error;
        }
    },
    /**
   * Get receipt URL for a payment
   */ async getReceiptUrl (paymentId) {
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/payments?action=receipt&paymentId=${paymentId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting receipt URL:', error);
            throw error;
        }
    }
};
var $15ebc391a13b5e97$export$2e2bcd8739ae039 = $15ebc391a13b5e97$export$c9cfb16a57b0f583;


const $5a64351ecfb9093b$var$Settings = ()=>{
    const { user: user, isLoaded: isLoaded } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const [payments, setPayments] = (0, $acw62.useState)([]);
    const [loadingPayments, setLoadingPayments] = (0, $acw62.useState)(false);
    const [receiptLoading, setReceiptLoading] = (0, $acw62.useState)(null);
    const [preferences, setPreferences] = (0, $acw62.useState)({
        emailNotifications: true,
        marketingUpdates: false
    });
    const [savingPreferences, setSavingPreferences] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (isLoaded && user) {
            // Load preferences from Clerk metadata
            if (user.unsafeMetadata?.preferences) setPreferences(user.unsafeMetadata.preferences);
            if (user.id) {
                console.log('Loading payment history for user:', user.id);
                loadPaymentHistory();
            }
        }
    }, [
        isLoaded,
        user
    ]);
    const loadPaymentHistory = async ()=>{
        if (!user?.id) return;
        setLoadingPayments(true);
        try {
            const response = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getPaymentHistory(user.id);
            console.log('Payment history loaded:', response);
            // Handle both array and object response formats
            const historyData = Array.isArray(response) ? response : response.payments || [];
            setPayments(historyData);
        } catch (error) {
            console.error('Failed to load payment history:', error);
        } finally{
            setLoadingPayments(false);
        }
    };
    const handlePreferenceChange = async (key)=>{
        if (!user) return;
        const newPreferences = {
            ...preferences,
            [key]: !preferences[key]
        };
        setPreferences(newPreferences);
        setSavingPreferences(true);
        try {
            await user.update({
                unsafeMetadata: {
                    ...user.unsafeMetadata,
                    preferences: newPreferences
                }
            });
        } catch (error) {
            console.error('Failed to save preferences:', error);
            // Revert on error
            setPreferences(preferences);
        } finally{
            setSavingPreferences(false);
        }
    };
    const handleViewReceipt = async (paymentId)=>{
        setReceiptLoading(paymentId);
        try {
            const { receiptUrl: receiptUrl } = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getReceiptUrl(paymentId);
            if (receiptUrl) window.open(receiptUrl, '_blank');
            else alert('Receipt not available yet. Please try again later.');
        } catch (error) {
            console.error('Failed to get receipt URL:', error);
            alert('Could not retrieve receipt. Please contact support.');
        } finally{
            setReceiptLoading(null);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "max-w-4xl mx-auto space-y-6 animate-in fade-in duration-500",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "text-2xl font-bold text-gray-900",
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.UserProfile), {
                    appearance: {
                        elements: {
                            rootBox: "w-full",
                            card: "shadow-none border-none w-full",
                            navbar: "hidden",
                            pageScrollBox: "p-6",
                            headerTitle: "hidden",
                            headerSubtitle: "hidden"
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-white rounded-xl shadow-sm border border-gray-200 p-6",
                id: "billing",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-gray-500"
                            }),
                            "Billing & Payment History"
                        ]
                    }),
                    loadingPayments ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf452017d8c279bd$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 text-gray-400 animate-spin"
                        })
                    }) : payments.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-x-auto rounded-lg border border-gray-200",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "min-w-full divide-y divide-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "bg-gray-50",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Amount"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 sm:px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Receipt"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-200",
                                    children: payments.map((payment)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: "hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                                    children: new Date(payment.createdAt).toLocaleDateString()
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "px-4 sm:px-6 py-4 text-sm text-gray-900",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "font-medium",
                                                            children: "Trademark Filing"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "text-gray-500 text-xs",
                                                            children: payment.applicationId ? `App ID: ${payment.applicationId.slice(0, 8).toUpperCase()}` : 'New Application'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "px-4 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                                                    children: [
                                                        "$",
                                                        (payment.amount / 100).toFixed(2)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 sm:px-6 py-4 whitespace-nowrap",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${payment.status === 'succeeded' ? 'bg-green-100 text-green-800' : payment.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'}`,
                                                        children: payment.status === 'succeeded' ? 'Paid' : payment.status
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 sm:px-6 py-4 whitespace-nowrap text-right text-sm font-medium",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onClick: ()=>handleViewReceipt(payment.id),
                                                        disabled: receiptLoading === payment.id,
                                                        className: "text-[#00695c] hover:text-[#004d40] inline-flex items-center gap-1 transition-colors disabled:opacity-50",
                                                        children: [
                                                            receiptLoading === payment.id ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf452017d8c279bd$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 animate-spin"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            }),
                                                            "View Receipt"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, payment.id))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-center py-8 bg-gray-50 rounded-lg border border-gray-100 border-dashed",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                className: "mx-auto h-8 w-8 text-gray-300 mb-2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-500",
                                children: "No payment history found"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-white rounded-xl shadow-sm border border-gray-200 p-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-gray-500"
                            }),
                            "Notification Preferences",
                            savingPreferences && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf452017d8c279bd$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 animate-spin text-gray-400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between py-3 border-b border-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "font-medium text-gray-900",
                                                children: "Email Notifications"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-sm text-gray-500",
                                                children: "Receive updates about your trademark status"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "relative inline-flex items-center cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only peer",
                                                checked: preferences.emailNotifications,
                                                onChange: ()=>handlePreferenceChange('emailNotifications'),
                                                disabled: savingPreferences
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#00695c]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between py-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "font-medium text-gray-900",
                                                children: "Marketing Updates"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-sm text-gray-500",
                                                children: "Receive news about new features and promotions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "relative inline-flex items-center cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only peer",
                                                checked: preferences.marketingUpdates,
                                                onChange: ()=>handlePreferenceChange('marketingUpdates'),
                                                disabled: savingPreferences
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#00695c]"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5a64351ecfb9093b$export$2e2bcd8739ae039 = $5a64351ecfb9093b$var$Settings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $a05168b77183bb44$var$NotificationContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $a05168b77183bb44$export$186b91822010e97f({ children: children }) {
    const { isSignedIn: isSignedIn } = (0, $8fcdbf2d7a4660c6$exports.useAuth)();
    const [notifications, setNotifications] = (0, $acw62.useState)([]);
    const [unreadCount, setUnreadCount] = (0, $acw62.useState)(0);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // Fetch notifications
    const fetchNotifications = (0, $acw62.useCallback)(async (options = {})=>{
        if (!isSignedIn) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $239a2fbc292443b5$export$2e2bcd8739ae039).getNotifications(options);
            setNotifications(response.notifications);
            setUnreadCount(response.unreadCount);
        } catch (err) {
            setError(err.message);
            console.error('Failed to fetch notifications:', err);
        } finally{
            setLoading(false);
        }
    }, [
        isSignedIn
    ]);
    // Fetch unread count only
    const fetchUnreadCount = (0, $acw62.useCallback)(async ()=>{
        if (!isSignedIn) return;
        try {
            const response = await (0, $239a2fbc292443b5$export$2e2bcd8739ae039).getUnreadCount();
            setUnreadCount(response.count);
        } catch (err) {
            console.error('Failed to fetch unread count:', err);
        }
    }, [
        isSignedIn
    ]);
    // Mark notification as read
    const markAsRead = (0, $acw62.useCallback)(async (notificationId)=>{
        try {
            await (0, $239a2fbc292443b5$export$2e2bcd8739ae039).markAsRead(notificationId);
            setNotifications((prev)=>prev.map((n)=>n.id === notificationId ? {
                        ...n,
                        read: true,
                        readAt: new Date().toISOString()
                    } : n));
            setUnreadCount((prev)=>Math.max(0, prev - 1));
        } catch (err) {
            console.error('Failed to mark as read:', err);
        }
    }, []);
    // Mark all as read
    const markAllAsRead = (0, $acw62.useCallback)(async ()=>{
        try {
            await (0, $239a2fbc292443b5$export$2e2bcd8739ae039).markAllAsRead();
            setNotifications((prev)=>prev.map((n)=>({
                        ...n,
                        read: true,
                        readAt: new Date().toISOString()
                    })));
            setUnreadCount(0);
        } catch (err) {
            console.error('Failed to mark all as read:', err);
        }
    }, []);
    // Dismiss notification
    const dismissNotification = (0, $acw62.useCallback)(async (notificationId)=>{
        try {
            await (0, $239a2fbc292443b5$export$2e2bcd8739ae039).dismiss(notificationId);
            setNotifications((prev)=>prev.filter((n)=>n.id !== notificationId));
            // Update count if it was unread
            const notification = notifications.find((n)=>n.id === notificationId);
            if (notification && !notification.read) setUnreadCount((prev)=>Math.max(0, prev - 1));
        } catch (err) {
            console.error('Failed to dismiss notification:', err);
        }
    }, [
        notifications
    ]);
    // Poll for unread count updates
    // Note: SSE is not supported with current Azure Functions + Container Apps setup
    // Using polling as a reliable alternative (every 60 seconds)
    (0, $acw62.useEffect)(()=>{
        if (!isSignedIn) return;
        // Poll immediately on mount
        fetchUnreadCount();
        // Set up polling interval (60 seconds)
        const pollInterval = setInterval(()=>{
            fetchUnreadCount();
        }, 60000);
        // Cleanup on unmount
        return ()=>{
            clearInterval(pollInterval);
        };
    }, [
        isSignedIn,
        fetchUnreadCount
    ]);
    // Initial fetch
    (0, $acw62.useEffect)(()=>{
        if (isSignedIn) fetchNotifications();
    }, [
        isSignedIn,
        fetchNotifications
    ]);
    // Add a new notification (for internal use, e.g., from other contexts)
    const addNotification = (0, $acw62.useCallback)((notification)=>{
        setNotifications((prev)=>[
                notification,
                ...prev
            ]);
        if (!notification.read) setUnreadCount((prev)=>prev + 1);
    }, []);
    const value = {
        notifications: notifications,
        unreadCount: unreadCount,
        loading: loading,
        error: error,
        fetchNotifications: fetchNotifications,
        fetchUnreadCount: fetchUnreadCount,
        markAsRead: markAsRead,
        markAllAsRead: markAllAsRead,
        dismissNotification: dismissNotification,
        addNotification: addNotification
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a05168b77183bb44$var$NotificationContext.Provider, {
        value: value,
        children: children
    });
}
function $a05168b77183bb44$export$53d5ca6c3f53e109() {
    const context = (0, $acw62.useContext)($a05168b77183bb44$var$NotificationContext);
    if (!context) throw new Error('useNotifications must be used within a NotificationProvider');
    return context;
}
var $a05168b77183bb44$export$2e2bcd8739ae039 = $a05168b77183bb44$var$NotificationContext;


/**
 * Client Messages Hooks
 * React Query hooks for client-side message handling
 */ 

const $c248b87178d92d03$export$485248acd428f444 = {
    all: [
        'client-messages'
    ],
    messages: ()=>[
            ...$c248b87178d92d03$export$485248acd428f444.all,
            'messages'
        ],
    message: (id)=>[
            ...$c248b87178d92d03$export$485248acd428f444.messages(),
            id
        ]
};
function $c248b87178d92d03$export$ce6cef46a7dc214a() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $c248b87178d92d03$export$485248acd428f444.messages(),
        queryFn: async ()=>{
            // Get messages for the current user (client perspective)
            const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get('/messages');
            return response;
        }
    });
}
function $c248b87178d92d03$export$cfa365f6296813fb(id) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $c248b87178d92d03$export$485248acd428f444.message(id),
        queryFn: async ()=>{
            const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/messages/${id}`);
            return response;
        },
        enabled: !!id
    });
}
function $c248b87178d92d03$export$3d659386d9ca19c5() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async ({ messageId: messageId, responseData: responseData })=>{
            const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/messages/${messageId}/respond`, {
                items: responseData.items,
                attachments: responseData.attachments,
                message: responseData.message,
                clientName: responseData.clientName
            });
            return response;
        },
        onSuccess: ()=>{
            // Invalidate messages queries to refetch
            queryClient.invalidateQueries({
                queryKey: $c248b87178d92d03$export$485248acd428f444.messages()
            });
        }
    });
}
function $c248b87178d92d03$export$5e0fc0ed4c3a47fb() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$c248b87178d92d03$export$485248acd428f444.all,
            'unread-count'
        ],
        queryFn: async ()=>{
            const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get('/messages/pending');
            return response?.messages?.length || 0;
        }
    });
}
var $c248b87178d92d03$export$2e2bcd8739ae039 = {
    useClientMessages: $c248b87178d92d03$export$ce6cef46a7dc214a,
    useClientMessage: $c248b87178d92d03$export$cfa365f6296813fb,
    useRespondToMessage: $c248b87178d92d03$export$3d659386d9ca19c5,
    useUnreadMessageCount: $c248b87178d92d03$export$5e0fc0ed4c3a47fb
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $51016c5c7c896de3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.234 20.252 21 12.3",
            key: "1cbrk9"
        }
    ],
    [
        "path",
        {
            d: "m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486",
            key: "1pkts6"
        }
    ]
];
const $51016c5c7c896de3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Paperclip", $51016c5c7c896de3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f68e7f5ef2ab511$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "17 8 12 3 7 8",
            key: "t8dd8p"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "3",
            y2: "15",
            key: "widbto"
        }
    ]
];
const $4f68e7f5ef2ab511$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Upload", $4f68e7f5ef2ab511$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("X", $cfb3b3013a649f15$export$3efd853dbb351e94);


/**
 * Message Response Modal
 * Allows clients to respond to attorney messages with text and file uploads.
 */ function $501e0a97b18f1045$var$MessageResponseModal({ isOpen: isOpen, onClose: onClose, message: message }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const respondMutation = (0, $c248b87178d92d03$export$3d659386d9ca19c5)();
    const [formData, setFormData] = (0, $acw62.useState)({
        message: '',
        items: [],
        attachments: []
    });
    const [uploadingFiles, setUploadingFiles] = (0, $acw62.useState)(false);
    // Initialize items from message request data
    (0, $acw62.useEffect)(()=>{
        if (message?.requestData?.items) setFormData((prev)=>({
                ...prev,
                items: message.requestData.items.map((item)=>({
                        ...item,
                        response: item.response || ''
                    }))
            }));
    }, [
        message
    ]);
    const handleItemChange = (index, value)=>{
        setFormData((prev)=>({
                ...prev,
                items: prev.items.map((item, i)=>i === index ? {
                        ...item,
                        response: value
                    } : item)
            }));
    };
    const handleFileUpload = async (e)=>{
        const files = Array.from(e.target.files);
        if (files.length === 0) return;
        setUploadingFiles(true);
        try {
            // In a real implementation, this would upload to blob storage
            // For now, we'll store file metadata
            const newAttachments = files.map((file)=>({
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    // In production, this would be the blob URL after upload
                    blobUrl: URL.createObjectURL(file)
                }));
            setFormData((prev)=>({
                    ...prev,
                    attachments: [
                        ...prev.attachments,
                        ...newAttachments
                    ]
                }));
        } catch (error) {
            console.error('Error uploading files:', error);
            alert('Error uploading files. Please try again.');
        } finally{
            setUploadingFiles(false);
        }
    };
    const removeAttachment = (index)=>{
        setFormData((prev)=>({
                ...prev,
                attachments: prev.attachments.filter((_, i)=>i !== index)
            }));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // Validate required items
        const hasRequiredMissing = formData.items.some((item)=>item.required && !item.response?.trim());
        if (hasRequiredMissing) {
            alert(t('messages.requiredFieldsMissing', 'Please fill in all required fields.'));
            return;
        }
        try {
            await respondMutation.mutateAsync({
                messageId: message.id,
                responseData: {
                    items: formData.items,
                    attachments: formData.attachments,
                    message: formData.message,
                    clientName: user?.fullName || user?.firstName || 'Client'
                }
            });
            onClose();
        } catch (error) {
            console.error('Error submitting response:', error);
            alert(`Error submitting response: ${error.message}`);
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-xl",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-between p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "text-xl font-semibold text-gray-900",
                                    children: t('messages.respondTo', 'Respond to Message')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-gray-600 mt-1",
                                    children: message.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: onClose,
                            className: "p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "w-5 h-5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p-6 space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-gray-50 rounded-lg p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "text-sm font-medium text-gray-700 mb-2",
                                            children: t('messages.originalMessage', 'Original Message')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-gray-600 text-sm whitespace-pre-wrap",
                                            children: message.message
                                        })
                                    ]
                                }),
                                formData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "text-sm font-medium text-gray-700 mb-3",
                                            children: t('messages.provideInformation', 'Please provide the following information')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "space-y-4",
                                            children: formData.items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "bg-white border border-gray-200 rounded-lg p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            className: "block text-sm font-medium text-gray-700 mb-2",
                                                            children: [
                                                                item.label,
                                                                item.required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-red-500 ml-1",
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        item.type === 'text' && /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "text",
                                                            value: item.response || '',
                                                            onChange: (e)=>handleItemChange(index, e.target.value),
                                                            placeholder: t('messages.enterResponse', 'Enter your response...'),
                                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500",
                                                            required: item.required
                                                        }),
                                                        item.type === 'date' && /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "date",
                                                            value: item.response || '',
                                                            onChange: (e)=>handleItemChange(index, e.target.value),
                                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500",
                                                            required: item.required
                                                        }),
                                                        item.type === 'file_upload' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "file",
                                                                    onChange: handleFileUpload,
                                                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "text-xs text-gray-500 mt-1",
                                                                    children: t('messages.fileUploadHint', 'Upload the requested document')
                                                                })
                                                            ]
                                                        }),
                                                        item.type === 'select' && item.options && /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                            value: item.response || '',
                                                            onChange: (e)=>handleItemChange(index, e.target.value),
                                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500",
                                                            required: item.required,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "",
                                                                    children: t('messages.selectOption', 'Select an option...')
                                                                }),
                                                                item.options.map((opt, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                        value: opt,
                                                                        children: opt
                                                                    }, i))
                                                            ]
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-2",
                                            children: [
                                                t('messages.additionalComments', 'Additional Comments'),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "text-gray-500 font-normal ml-1",
                                                    children: [
                                                        "(",
                                                        t('common.optional', 'optional'),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            value: formData.message,
                                            onChange: (e)=>setFormData((prev)=>({
                                                        ...prev,
                                                        message: e.target.value
                                                    })),
                                            placeholder: t('messages.additionalCommentsPlaceholder', 'Any additional information you would like to share...'),
                                            rows: 4,
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-2",
                                            children: [
                                                t('messages.attachFiles', 'Attach Files'),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "text-gray-500 font-normal ml-1",
                                                    children: [
                                                        "(",
                                                        t('common.optional', 'optional'),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        formData.attachments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "mb-3 space-y-2",
                                            children: formData.attachments.map((file, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    className: "flex items-center justify-between p-2 bg-gray-50 rounded-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51016c5c7c896de3$export$2e2bcd8739ae039), {
                                                                    className: "w-4 h-4 text-gray-400"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-sm text-gray-700",
                                                                    children: file.name
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>removeAttachment(index),
                                                            className: "text-red-500 hover:text-red-700",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                className: "w-4 h-4"
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-teal-500 hover:bg-teal-50/50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5 text-gray-400"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-sm text-gray-600",
                                                    children: uploadingFiles ? t('messages.uploading', 'Uploading...') : t('messages.clickToUpload', 'Click to upload files')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "file",
                                                    multiple: true,
                                                    onChange: handleFileUpload,
                                                    className: "hidden",
                                                    disabled: uploadingFiles
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: onClose,
                                    className: "px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                                    children: t('common.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    disabled: respondMutation.isPending,
                                    className: "px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2",
                                    children: respondMutation.isPending ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                                            }),
                                            t('messages.sending', 'Sending...')
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            t('messages.submitResponse', 'Submit Response')
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $501e0a97b18f1045$export$2e2bcd8739ae039 = $501e0a97b18f1045$var$MessageResponseModal;


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Check", $8240f8fcfc513968$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b397e876e35a9277$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronUp", $b397e876e35a9277$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3206cd97f03c9458$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "22 12 16 12 14 15 10 15 8 12 2 12",
            key: "o97t9d"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ]
];
const $3206cd97f03c9458$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Inbox", $3206cd97f03c9458$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d957a6b316cfc10$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "polyline",
        {
            points: "16 11 18 13 22 9",
            key: "1pwet4"
        }
    ]
];
const $0d957a6b316cfc10$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UserCheck", $0d957a6b316cfc10$export$3efd853dbb351e94);


/**
 * Client Messages Section
 * Shows all notifications and messages from MarkoTM attorneys.
 * Combines notifications (status updates) and messages (requiring response).
 */ function $be5b81ecbab21f1e$var$ClientMessagesSection() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const [activeTab, setActiveTab] = (0, $acw62.useState)('all');
    const [selectedMessage, setSelectedMessage] = (0, $acw62.useState)(null);
    // Get both notifications and messages
    const { notifications: notifications, unreadCount: unreadCount, markAsRead: markAsRead, markAllAsRead: markAllAsRead } = (0, $a05168b77183bb44$export$53d5ca6c3f53e109)();
    const { data: messagesData, isLoading: isLoadingMessages } = (0, $c248b87178d92d03$export$ce6cef46a7dc214a)();
    const messages = messagesData?.messages || [];
    // Categories that clients should see (exclude internal attorney operations)
    const CLIENT_VISIBLE_CATEGORIES = [
        'status_change',
        'filing_update',
        'deadline',
        'correspondence',
        'payment',
        'client_response' // When attorney responds to client
    ];
    // Categories to hide from clients (internal attorney operations)
    const INTERNAL_CATEGORIES = [
        'assignment',
        'recall',
        'transfer',
        'approval',
        'internal_request',
        'new_filing',
        'filing_queue' // Filing queue notifications (for attorneys)
    ];
    // Combine notifications and messages
    const allItems = (0, $acw62.useMemo)(()=>{
        // Messages that require response
        const messageItems = messages.map((m)=>({
                ...m,
                itemType: 'message',
                isMessage: true,
                displayTitle: m.title || m.subject,
                displayMessage: m.message || m.body,
                createdAt: m.createdAt
            }));
        // Notifications - only show client-visible categories
        const messageIds = new Set(messages.map((m)=>m.id));
        const notificationItems = notifications.filter((n)=>{
            // Skip if already shown as a message
            if (messageIds.has(n.id)) return false;
            // Skip client_message category (these come through as messages)
            if (n.category === 'client_message') return false;
            // Skip internal attorney categories
            if (INTERNAL_CATEGORIES.includes(n.category)) return false;
            // Also filter by title patterns for any miscategorized notifications
            const title = (n.title || '').toLowerCase();
            if (title.includes('recalled') || title.includes('attorney assigned') || title.includes('transferred') || title.includes('assignment') || title.includes('new filing ready') || title.includes('filing ready')) return false;
            return true;
        }).map((n)=>({
                ...n,
                itemType: 'notification',
                isMessage: false,
                displayTitle: n.title,
                displayMessage: n.message || n.body,
                createdAt: n.createdAt
            }));
        // Combine and sort by date
        return [
            ...messageItems,
            ...notificationItems
        ].sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    }, [
        messages,
        notifications
    ]);
    // Filter items based on tab
    const pendingMessages = messages.filter((m)=>m.responseStatus === 'pending' && m.responseRequired);
    const unreadItems = allItems.filter((item)=>!item.read && !item.readAt);
    const displayItems = activeTab === 'pending' ? pendingMessages : activeTab === 'unread' ? unreadItems : allItems;
    const handleMarkAllRead = async ()=>{
        await markAllAsRead();
    };
    const handleMarkAsRead = async (itemId)=>{
        await markAsRead(itemId);
    };
    if (!user) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-lg shadow-sm p-8 text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                className: "w-12 h-12 text-gray-400 mx-auto mb-4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-xl font-semibold text-gray-900 mb-2",
                children: t('messages.signInRequired', 'Sign in Required')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-gray-600",
                children: t('messages.signInToView', 'Please sign in to view your messages.')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white rounded-lg shadow-sm",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4 sm:p-6 border-b border-gray-200",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: t('messages.title', 'Messages')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-600 mt-1",
                                    children: t('messages.subtitle', 'Notifications and messages from your trademark attorney')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-3",
                            children: [
                                pendingMessages.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 bg-amber-50 text-amber-700 px-4 py-2 rounded-full",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "font-medium",
                                            children: [
                                                pendingMessages.length,
                                                " ",
                                                t('messages.actionRequired', 'response required')
                                            ]
                                        })
                                    ]
                                }),
                                unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: handleMarkAllRead,
                                    className: "text-sm text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4"
                                        }),
                                        t('messages.markAllRead', 'Mark all as read')
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex border-b border-gray-200 overflow-x-auto",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setActiveTab('pending'),
                        className: `px-4 sm:px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0 min-h-[44px] ${activeTab === 'pending' ? 'border-teal-600 text-teal-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`,
                        children: [
                            t('messages.pendingTab', 'Awaiting Response'),
                            pendingMessages.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml-2 bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full text-xs",
                                children: pendingMessages.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setActiveTab('unread'),
                        className: `px-4 sm:px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0 min-h-[44px] ${activeTab === 'unread' ? 'border-teal-600 text-teal-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`,
                        children: [
                            t('messages.unreadTab', 'Unread'),
                            unreadItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml-2 bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full text-xs",
                                children: unreadItems.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setActiveTab('all'),
                        className: `px-4 sm:px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0 min-h-[44px] ${activeTab === 'all' ? 'border-teal-600 text-teal-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`,
                        children: [
                            t('messages.allTab', 'All Messages'),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml-2 text-gray-400 text-xs",
                                children: allItems.length
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4 sm:p-6",
                children: isLoadingMessages ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center py-12",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "animate-spin w-8 h-8 border-2 border-teal-600 border-t-transparent rounded-full mx-auto mb-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-600",
                            children: t('messages.loading', 'Loading messages...')
                        })
                    ]
                }) : displayItems.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center py-12",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3206cd97f03c9458$export$2e2bcd8739ae039), {
                            className: "w-12 h-12 text-gray-400 mx-auto mb-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-medium text-gray-900 mb-2",
                            children: activeTab === 'pending' ? t('messages.noPending', 'No messages requiring response') : activeTab === 'unread' ? t('messages.noUnread', 'All caught up!') : t('messages.noMessages', 'No messages yet')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-600",
                            children: activeTab === 'pending' ? t('messages.emptyStateHint', 'Your attorney will contact you here if they need any information.') : t('messages.allReadHint', 'You have no unread notifications.')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "space-y-3",
                    children: displayItems.map((item)=>item.isMessage ? /*#__PURE__*/ (0, $ayMG0.jsx)($be5b81ecbab21f1e$var$MessageCard, {
                            message: item,
                            onRespond: ()=>setSelectedMessage(item),
                            onMarkRead: ()=>handleMarkAsRead(item.id)
                        }, item.id) : /*#__PURE__*/ (0, $ayMG0.jsx)($be5b81ecbab21f1e$var$NotificationCard, {
                            notification: item,
                            onMarkRead: ()=>handleMarkAsRead(item.id)
                        }, item.id))
                })
            }),
            selectedMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $501e0a97b18f1045$export$2e2bcd8739ae039), {
                isOpen: !!selectedMessage,
                onClose: ()=>setSelectedMessage(null),
                message: selectedMessage
            })
        ]
    });
}
/**
 * Notification Card Component (for status updates, not requiring response)
 */ function $be5b81ecbab21f1e$var$NotificationCard({ notification: notification, onMarkRead: onMarkRead }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const isUnread = !notification.read && !notification.readAt;
    const getCategoryIcon = (category)=>{
        switch(category){
            case 'status_change':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                    className: "w-5 h-5"
                });
            case 'assignment':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d957a6b316cfc10$export$2e2bcd8739ae039), {
                    className: "w-5 h-5"
                });
            case 'deadline':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                    className: "w-5 h-5"
                });
            case 'correspondence':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                    className: "w-5 h-5"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039), {
                    className: "w-5 h-5"
                });
        }
    };
    const getCategoryColor = (category)=>{
        switch(category){
            case 'status_change':
                return 'bg-blue-100 text-blue-600';
            case 'assignment':
                return 'bg-purple-100 text-purple-600';
            case 'deadline':
                return 'bg-amber-100 text-amber-600';
            case 'correspondence':
                return 'bg-teal-100 text-teal-600';
            default:
                return 'bg-gray-100 text-gray-600';
        }
    };
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const now = new Date();
        const diffMs = now - date;
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffHours < 1) return t('messages.justNow', 'Just now');
        if (diffHours < 24) return `${diffHours} ${t('messages.hoursAgo', 'hours ago')}`;
        if (diffDays < 7) return `${diffDays} ${t('messages.daysAgo', 'days ago')}`;
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    };
    const handleClick = ()=>{
        if (isUnread) onMarkRead();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `border rounded-lg p-4 transition-colors cursor-pointer ${isUnread ? 'border-teal-200 bg-teal-50/30' : 'border-gray-200 hover:bg-gray-50'}`,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-start gap-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `w-10 h-10 rounded-full flex items-center justify-center ${getCategoryColor(notification.category)}`,
                    children: getCategoryIcon(notification.category)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 min-w-0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-start justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: `font-medium ${isUnread ? 'text-gray-900' : 'text-gray-700'}`,
                                        children: notification.displayTitle
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-gray-600 mt-0.5 line-clamp-2",
                                        children: notification.displayMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs text-gray-500",
                                        children: formatDate(notification.createdAt)
                                    }),
                                    isUnread && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w-2 h-2 bg-teal-500 rounded-full"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/**
 * Message Card Component (for messages requiring response)
 */ function $be5b81ecbab21f1e$var$MessageCard({ message: message, onRespond: onRespond, onMarkRead: onMarkRead }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const urgencyStyles = {
        low: 'bg-gray-100 text-gray-700',
        medium: 'bg-blue-100 text-blue-700',
        high: 'bg-amber-100 text-amber-700',
        critical: 'bg-red-100 text-red-700'
    };
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    const isPending = message.responseRequired && message.responseStatus === 'pending';
    const isUnread = !message.read && !message.readAt;
    const handleToggle = ()=>{
        if (isUnread && !expanded) onMarkRead();
        setExpanded(!expanded);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `border rounded-lg ${isPending ? 'border-amber-200 bg-amber-50/30' : isUnread ? 'border-teal-200 bg-teal-50/30' : 'border-gray-200'}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4 cursor-pointer hover:bg-gray-50/50 transition-colors",
                onClick: handleToggle,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-start gap-3 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isPending ? 'bg-amber-100' : 'bg-teal-100'}`,
                                    children: isPending ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-amber-600"
                                    }) : message.responseStatus === 'responded' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-teal-600"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-teal-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "font-medium text-gray-900 break-words",
                                                    children: message.displayTitle || message.title
                                                }),
                                                isUnread && !isPending && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w-2 h-2 bg-teal-500 rounded-full"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "text-sm text-gray-600 mt-0.5",
                                            children: [
                                                t('messages.from', 'From'),
                                                ": ",
                                                message.senderName || 'MarkoTM Attorney'
                                            ]
                                        }),
                                        message.applicationId && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "text-xs text-gray-500 mt-0.5",
                                            children: [
                                                t('messages.application', 'Application'),
                                                ": ",
                                                message.applicationId
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2 sm:gap-3 flex-shrink-0",
                            children: [
                                isPending && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-xs font-medium px-2 py-1 rounded bg-amber-100 text-amber-700",
                                    children: t('messages.responseRequired', 'Response Required')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `text-xs font-medium px-2 py-1 rounded ${urgencyStyles[message.urgency] || urgencyStyles.medium}`,
                                    children: message.urgency
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-xs text-gray-500",
                                    children: formatDate(message.createdAt)
                                }),
                                expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-gray-400"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-gray-400"
                                })
                            ]
                        })
                    ]
                })
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-4 pb-4 pt-2 border-t border-gray-100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "text-sm font-medium text-gray-700 mb-2",
                                children: t('messages.messageLabel', 'Message')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-gray-600 whitespace-pre-wrap",
                                children: message.displayMessage || message.message
                            })
                        ]
                    }),
                    message.requestData?.items && message.requestData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "text-sm font-medium text-gray-700 mb-2",
                                children: t('messages.requestedInfo', 'Information Requested')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                className: "space-y-2",
                                children: message.requestData.items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "flex items-start gap-2 p-3 bg-white rounded border border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded",
                                                children: item.type
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-gray-700",
                                                children: item.label
                                            }),
                                            item.required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-red-500 font-bold",
                                                children: "*"
                                            }),
                                            item.response && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "ml-auto text-teal-600 bg-teal-50 px-2 py-0.5 rounded text-sm",
                                                children: item.response
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }),
                    message.attachments && message.attachments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "text-sm font-medium text-gray-700 mb-2",
                                children: t('messages.attachments', 'Attachments')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                className: "space-y-1",
                                children: message.attachments.map((att, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: att.blobUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "flex items-center gap-2 text-teal-600 hover:text-teal-700",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51016c5c7c896de3$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4"
                                                }),
                                                att.name
                                            ]
                                        })
                                    }, idx))
                            })
                        ]
                    }),
                    message.responseStatus === 'responded' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-teal-50 rounded-lg p-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2 text-teal-700 mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "font-medium",
                                    children: t('messages.youResponded', 'You responded')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-sm text-teal-600",
                                    children: formatDate(message.respondedAt)
                                })
                            ]
                        })
                    }) : message.responseRequired ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: (e)=>{
                                e.stopPropagation();
                                onRespond();
                            },
                            className: "bg-teal-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-teal-700 transition-colors",
                            children: t('messages.respond', 'Respond')
                        })
                    }) : null
                ]
            })
        ]
    });
}
var $be5b81ecbab21f1e$export$2e2bcd8739ae039 = $be5b81ecbab21f1e$var$ClientMessagesSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0811c1891b547863$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            key: "7g6ntu"
        }
    ],
    [
        "path",
        {
            d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            key: "ijws7r"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ],
    [
        "path",
        {
            d: "M12 3v18",
            key: "108xh3"
        }
    ],
    [
        "path",
        {
            d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2",
            key: "3gwbw2"
        }
    ]
];
const $0811c1891b547863$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Scale", $0811c1891b547863$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Search", $9ad14973a512851d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $84e37213187279fb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $84e37213187279fb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Send", $84e37213187279fb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleX", $839eea37a960d2b1$export$3efd853dbb351e94);




var $fYgYF = parcelRequire("fYgYF");

/**
 * Application Portfolio component
 * Shows list of user's applications with ability to select or cancel.
 *
 * Quote-first funnel: new applications start on the marketing wizard
 * (markotm.com/file-trademark) — there is no self-serve "create application"
 * here any more. Continuing an application goes to the Quote & Payment section.
 */ const $b2e35e2c86fd4509$var$ApplicationPortfolio = ()=>{
    const { applications: applications, loading: loading, loadApplication: loadApplication, cancelApplication: cancelApplication } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const [showCancelModal, setShowCancelModal] = (0, $acw62.useState)(false);
    const [applicationToCancel, setApplicationToCancel] = (0, $acw62.useState)(null);
    const [cancelLoading, setCancelLoading] = (0, $acw62.useState)(false);
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)('');
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)('all'); // 'all', 'quote', 'in-filing', 'completed', 'cancelled'
    const handleStartNew = ()=>{
        window.location.href = (0, $dc60fa0fe0f6ea60$export$64d4a5b91c97bf11);
    };
    const confirmCancel = (app, e)=>{
        e.stopPropagation(); // Prevent card click
        setApplicationToCancel(app);
        setShowCancelModal(true);
    };
    const handleCancelSubmit = async ()=>{
        if (!applicationToCancel) return;
        setCancelLoading(true);
        try {
            await cancelApplication(applicationToCancel.id);
            setShowCancelModal(false);
            setApplicationToCancel(null);
        } catch (error) {
            console.error('Failed to cancel application:', error);
        } finally{
            setCancelLoading(false);
        }
    };
    // Status-aware navigation: everything post-wizard lives in Quote & Payment
    const handleContinueApplication = async (application)=>{
        console.log('Portfolio: Continuing application:', application.id);
        await loadApplication(application.id);
        window.location.hash = '#payments';
    };
    const calculateProgress = (app)=>{
        if (app.status === 'cancelled') return 0;
        if ((0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(app)) return 100;
        if (app.status === 'filed') return 90;
        if (app.status === 'filing_in_progress') return 80;
        if ((0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(app)) return 70;
        if (app.status === 'quote_sent') return 50;
        if (app.status === 'quote_requested') return 35;
        // Legacy applications that predate the quote flow
        let progress = 15;
        if (app.businessInfoId || app.businessName) progress += 10;
        if (app.analysisId || app.analysisCompleted) progress += 10;
        if (app.pricingId) progress += 15;
        return Math.min(progress, 100);
    };
    const getApplicationStatus = (app)=>{
        if (app.status === 'cancelled') return {
            icon: (0, $839eea37a960d2b1$export$2e2bcd8739ae039),
            text: 'Cancelled',
            color: 'text-gray-400',
            bg: 'bg-gray-100',
            border: 'border-gray-200'
        };
        if ((0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(app)) return {
            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
            text: 'Complete',
            color: 'text-green-600',
            bg: 'bg-green-50',
            border: 'border-green-100'
        };
        if (app.status === 'filed') return {
            icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
            text: 'Filed',
            color: 'text-green-600',
            bg: 'bg-green-50',
            border: 'border-green-100'
        };
        if (app.status === 'filing_in_progress') return {
            icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
            text: 'Filing in Progress',
            color: 'text-blue-600',
            bg: 'bg-blue-50',
            border: 'border-blue-100'
        };
        if (app.status === 'pending_attorney_filing' || app.status === 'payment_completed' || (0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(app)) return {
            icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
            text: 'Pending Filing',
            color: 'text-blue-600',
            bg: 'bg-blue-50',
            border: 'border-blue-100'
        };
        if (app.status === 'quote_sent') return {
            icon: (0, $84e37213187279fb$export$2e2bcd8739ae039),
            text: 'Quote Ready',
            color: 'text-amber-600',
            bg: 'bg-amber-50',
            border: 'border-amber-100'
        };
        if (app.status === 'quote_requested') return {
            icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
            text: 'Preparing Report',
            color: 'text-blue-600',
            bg: 'bg-blue-50',
            border: 'border-blue-100'
        };
        if (app.status === 'payment_pending') return {
            icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039),
            text: 'Payment Pending',
            color: 'text-amber-600',
            bg: 'bg-amber-50',
            border: 'border-amber-100'
        };
        if (app.status === 'refunded') return {
            icon: (0, $839eea37a960d2b1$export$2e2bcd8739ae039),
            text: 'Refunded',
            color: 'text-orange-600',
            bg: 'bg-orange-50',
            border: 'border-orange-100'
        };
        return {
            icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
            text: 'In Progress',
            color: 'text-blue-600',
            bg: 'bg-blue-50',
            border: 'border-blue-100'
        };
    };
    const getApplicationName = (app)=>{
        return app.trademarkName || app.name || app.businessName || `Application ${app.id?.slice(0, 8).toUpperCase()}`;
    };
    const getTrademarkImage = (app)=>{
        // Try to find an image source
        if (app.trademarkFileUrl) return app.trademarkFileUrl;
        if (app.trademarkFileData) return app.trademarkFileData;
        if (app.trademarkContent) {
            if (typeof app.trademarkContent === 'string') return app.trademarkContent;
            if (app.trademarkContent.data) return app.trademarkContent.data;
        }
        return null;
    };
    const filteredApplications = (0, $acw62.useMemo)(()=>{
        return applications.filter((app)=>{
            // Search filter
            const name = getApplicationName(app).toLowerCase();
            const matchesSearch = name.includes(searchQuery.toLowerCase());
            // Status filter
            let matchesStatus = true;
            if (statusFilter !== 'all') {
                const status = app.status || 'active';
                if (statusFilter === 'quote') matchesStatus = status === 'quote_requested' || status === 'quote_sent';
                else if (statusFilter === 'in-filing') matchesStatus = (0, $dc60fa0fe0f6ea60$export$e7288b3232a7b847)(app) && !(0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(app);
                else if (statusFilter === 'completed') matchesStatus = (0, $dc60fa0fe0f6ea60$export$817691802b5d05c5)(app);
                else if (statusFilter === 'cancelled') matchesStatus = status === 'cancelled';
                else matchesStatus = status === statusFilter;
            }
            return matchesSearch && matchesStatus;
        });
    }, [
        applications,
        searchQuery,
        statusFilter
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "p-4 space-y-4",
        children: [
            1,
            2,
            3
        ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "animate-pulse bg-white p-4 rounded-lg border border-gray-200",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w-12 h-12 bg-gray-200 rounded-xl"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex-1 space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-4 bg-gray-200 rounded w-1/3"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-2 bg-gray-200 rounded w-full"
                                })
                            ]
                        })
                    ]
                })
            }, i))
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative flex-1 w-full sm:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                placeholder: "Search applications...",
                                value: searchQuery,
                                onChange: (e)=>setSearchQuery(e.target.value),
                                className: "w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-2 w-full sm:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: statusFilter,
                                onChange: (e)=>setStatusFilter(e.target.value),
                                className: "flex-1 sm:flex-initial min-w-0 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-teal-500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: "All Status"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "quote",
                                        children: "Quote Stage"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "in-filing",
                                        children: "In Filing"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "payment_pending",
                                        children: "Payment Pending"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "completed",
                                        children: "Completed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "cancelled",
                                        children: "Cancelled"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                onClick: handleStartNew,
                                className: "whitespace-nowrap flex items-center gap-2 bg-teal-600 hover:bg-teal-700",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    "New Application"
                                ]
                            })
                        ]
                    })
                ]
            }),
            filteredApplications.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                        size: 48,
                        className: "mx-auto mb-4 text-gray-300"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "text-lg font-medium text-gray-900 mb-2",
                        children: "No Applications Found"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm text-gray-500 mb-6",
                        children: searchQuery || statusFilter !== 'all' ? "Try adjusting your search or filters" : "Start with a free trademark check on our website"
                    }),
                    searchQuery || statusFilter !== 'all' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                        variant: "outline",
                        onClick: ()=>{
                            setSearchQuery('');
                            setStatusFilter('all');
                        },
                        children: "Clear Filters"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                        onClick: handleStartNew,
                        children: "Start Your Free Check"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col gap-3",
                children: filteredApplications.map((app)=>{
                    const status = getApplicationStatus(app);
                    const StatusIcon = status.icon;
                    const appName = getApplicationName(app);
                    const progress = calculateProgress(app);
                    const trademarkImage = getTrademarkImage(app);
                    const isCancelled = app.status === 'cancelled';
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `group bg-white p-4 rounded-xl border border-gray-200 shadow-sm relative overflow-hidden transition-all duration-200 ${isCancelled ? 'opacity-60 bg-gray-50' : 'hover:shadow-md'}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col sm:flex-row items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `shrink-0 ${trademarkImage ? 'h-12 w-12 rounded-lg border border-gray-100 overflow-hidden bg-gray-50' : `p-3 rounded-xl ${status.bg}`}`,
                                    children: trademarkImage ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: trademarkImage,
                                        alt: appName,
                                        className: `h-full w-full object-contain ${isCancelled ? 'grayscale' : ''}`,
                                        onError: (e)=>{
                                            e.target.style.display = 'none';
                                            e.target.parentElement.classList.remove('h-12', 'w-12', 'border', 'border-gray-100', 'bg-gray-50', 'overflow-hidden');
                                            e.target.parentElement.classList.add('p-3', 'rounded-xl', status.bg);
                                            e.target.parentElement.innerHTML = '<div class="flex items-center justify-center w-full h-full text-xs text-gray-400">IMG</div>';
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)(StatusIcon, {
                                        className: `h-6 w-6 ${status.color}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex-1 min-w-0 w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex justify-between items-center mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-2 overflow-hidden",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                            className: `font-semibold truncate ${isCancelled ? 'text-gray-500 line-through' : 'text-gray-900'}`,
                                                            children: appName
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "text-xs text-gray-400 font-mono hidden sm:inline-block",
                                                            children: [
                                                                "\u2022 ",
                                                                app.id?.slice(0, 8).toUpperCase()
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `text-xs font-medium px-2 py-0.5 rounded-full ${status.bg} ${status.color}`,
                                                    children: status.text
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `h-full rounded-full transition-all duration-500 ease-out ${isCancelled ? 'bg-gray-300' : status.text === 'Complete' ? 'bg-green-500' : 'bg-teal-500'}`,
                                                        style: {
                                                            width: `${progress}%`
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "text-xs text-gray-400 font-medium w-8 text-right tabular-nums",
                                                    children: [
                                                        progress,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 w-full sm:w-auto border-t sm:border-t-0 border-gray-100 pt-3 sm:pt-0 mt-1 sm:mt-0 justify-end sm:pl-4 sm:border-l",
                                    children: [
                                        !isCancelled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                            variant: "ghost",
                                            size: "sm",
                                            onClick: (e)=>confirmCancel(app, e),
                                            className: "text-gray-400 hover:text-red-600 hover:bg-red-50 h-9",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                            onClick: ()=>handleContinueApplication(app),
                                            variant: "outline",
                                            className: `h-9 px-4 text-sm bg-white hover:bg-gray-50 text-gray-700 border-gray-200 shadow-sm shrink-0 ${isCancelled ? 'opacity-50 cursor-not-allowed' : ''}`,
                                            disabled: isCancelled,
                                            children: [
                                                status.text === 'Complete' ? 'View' : app.status === 'quote_sent' ? 'View Quote & Pay' : 'View',
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    size: 14,
                                                    className: "ml-2"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, app.id);
                })
            }),
            showCancelModal && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg-white rounded-2xl shadow-xl max-w-sm w-full overflow-hidden animate-in zoom-in-95 duration-200",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mx-auto w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 text-red-600"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-lg font-bold text-gray-900 mb-2",
                                children: "Cancel Application?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-sm text-gray-500 mb-6",
                                children: [
                                    "Are you sure you want to cancel ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "font-semibold text-gray-900",
                                        children: [
                                            '"',
                                            applicationToCancel ? getApplicationName(applicationToCancel) : 'this application',
                                            '"'
                                        ]
                                    }),
                                    "? It will be marked as inactive."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex gap-3 justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                        variant: "outline",
                                        onClick: ()=>setShowCancelModal(false),
                                        disabled: cancelLoading,
                                        className: "w-full",
                                        children: "Go Back"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                        onClick: handleCancelSubmit,
                                        disabled: cancelLoading,
                                        className: "w-full bg-red-600 hover:bg-red-700 text-white border-transparent",
                                        children: cancelLoading ? 'Cancelling...' : 'Cancel App'
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $b2e35e2c86fd4509$export$2e2bcd8739ae039 = $b2e35e2c86fd4509$var$ApplicationPortfolio;


/**
 * PaymentsSection — "Quote & Payment" dashboard section (#payments).
 *
 * Replaces the deleted File Trademark wizard. In the quote-first funnel the
 * marketing wizard is the intake; this section is where a visitor lands (via
 * the report email's magic link) to review their confirmed quote, sign the
 * declaration, and pay.
 *
 * UI states are driven by application.status:
 *   - quote_requested  → "Your report is being prepared" (24-hour promise)
 *   - quote_sent       → invoice-style quote document + collapsible report +
 *                        applicant details (name + postal address, autosaved
 *                        as they type — IP Australia requires both to file) +
 *                        single-checkbox declaration + Stripe Embedded
 *                        Checkout, which loads immediately and is soft-gated
 *                        by an overlay until the applicant essentials are in
 *                        AND the declaration is ticked
 *   - paid / post-paid → payment completion card + filing status (ApplicationStatusCard)
 *
 * Data comes from TanStack Query (usePricingQuery / useDeclarationQuery) and
 * PaymentContext — no wizard contexts. Rendering discipline: checkoutOptions and
 * line items are memoized and the Embedded Checkout is keyed by clientSecret so
 * unrelated re-renders never remount it mid-session. The report lives in its
 * own components (CollapsibleReport/ReportView) with their own queries so
 * report fetches and expansion toggles never touch the payment cards.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const { slice: $60196a4650e96cb1$var$slice, forEach: $60196a4650e96cb1$var$forEach } = [];
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$forEach.call($60196a4650e96cb1$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $60196a4650e96cb1$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $60196a4650e96cb1$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $60196a4650e96cb1$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $60196a4650e96cb1$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $60196a4650e96cb1$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $60196a4650e96cb1$var$hasLocalStorageSupport = null;
const $60196a4650e96cb1$var$localStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$60196a4650e96cb1$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $60196a4650e96cb1$var$hasSessionStorageSupport = null;
const $60196a4650e96cb1$var$sessionStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$60196a4650e96cb1$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $60196a4650e96cb1$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $60196a4650e96cb1$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $60196a4650e96cb1$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$60196a4650e96cb1$var$canCookies) $60196a4650e96cb1$var$order.splice(1, 1);
const $60196a4650e96cb1$var$getDefaults = ()=>({
        order: $60196a4650e96cb1$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $60196a4650e96cb1$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($60196a4650e96cb1$var$cookie$1);
        this.addDetector($60196a4650e96cb1$var$querystring);
        this.addDetector($60196a4650e96cb1$var$localStorage);
        this.addDetector($60196a4650e96cb1$var$sessionStorage);
        this.addDetector($60196a4650e96cb1$var$navigator$1);
        this.addDetector($60196a4650e96cb1$var$htmlTag);
        this.addDetector($60196a4650e96cb1$var$path);
        this.addDetector($60196a4650e96cb1$var$subdomain);
        this.addDetector($60196a4650e96cb1$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$60196a4650e96cb1$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$60196a4650e96cb1$export$2e2bcd8739ae039.type = 'languageDetector';


var $eb5ecdf737dc9de6$exports = {};
$eb5ecdf737dc9de6$exports = JSON.parse('{"buttons":{"save":"Save","cancel":"Cancel","continue":"Continue","back":"Back","submit":"Submit","delete":"Delete","edit":"Edit","close":"Close","confirm":"Confirm","next":"Next","previous":"Previous","upload":"Upload","download":"Download","refresh":"Refresh","retry":"Retry","learnMore":"Learn More","getStarted":"Get Started","viewDetails":"View Details","saveChanges":"Save Changes"},"labels":{"email":"Email","name":"Name","firstName":"First Name","lastName":"Last Name","phone":"Phone","company":"Company","companyName":"Company Name","country":"Country","address":"Address","city":"City","state":"State","postcode":"Postcode","website":"Website","description":"Description","date":"Date","status":"Status","actions":"Actions","type":"Type","category":"Category","notes":"Notes"},"status":{"loading":"Loading...","saving":"Saving...","success":"Success!","error":"An error occurred","pending":"Pending","completed":"Completed","inProgress":"In Progress","draft":"Draft","active":"Active","inactive":"Inactive"},"validation":{"required":"This field is required","invalidEmail":"Please enter a valid email","minLength":"Must be at least {{min}} characters","maxLength":"Must be no more than {{max}} characters","invalidPhone":"Please enter a valid phone number","invalidUrl":"Please enter a valid URL"},"errors":{"generic":"Something went wrong. Please try again.","network":"Network error. Please check your connection.","unauthorized":"You are not authorised to perform this action.","notFound":"The requested resource was not found.","serverError":"Server error. Please try again later."},"navigation":{"home":"Home","dashboard":"Dashboard","settings":"Settings","profile":"Profile","logout":"Log Out","login":"Log In","signUp":"Sign Up","help":"Help","support":"Support"},"time":{"today":"Today","yesterday":"Yesterday","lastWeek":"Last Week","lastMonth":"Last Month","ago":"ago","minutes":"minutes","hours":"hours","days":"days"},"language":{"select":"Select Language","en":"English","es":"Espa\xf1ol","de":"Deutsch","zh":"\u4E2D\u6587"}}');


var $14a2bf24f626d959$exports = {};
$14a2bf24f626d959$exports = JSON.parse('{"home":{"title":"Dashboard","welcome":"Welcome back, {{name}}","guest":"Guest","subtitle":"Here\'s what\'s happening with your intellectual property today.","currentApplication":"Current Application","applicationProgress":"Application Progress","noActiveApplications":"No Active Applications","createFirst":"Create your first trademark application to get started.","quickActions":"Quick Actions","resumeFiling":"Quote & Payment","resumeFilingDesc":"View your quote and pay","paymentHistory":"Payment History","paymentHistoryDesc":"View receipts & invoices","contactSupport":"Contact Support","contactSupportDesc":"Get help from our team","lastUpdated":"Last updated: {{date}}","newFiling":"New Trademark Check","viewAll":"View All","continueFiling":"View Quote & Payment","payAndFile":"Pay & File","viewQuoteStatus":"View Status","viewFilingStatus":"View Filing Status","activeFilings":"Active Filings","actionRequired":"Action Required","protectedAssets":"Protected Assets","startProtecting":"Start with a free trademark check on our website. You will get a detailed report and an attorney-confirmed quote within 24 hours \u2014 no payment needed upfront.","startNewApp":"Start Your Free Check","fromYourAttorney":"From Your Attorney","unnamedTrademark":"Unnamed Trademark","insights":{"appInProgress":"Application in Progress","appInProgressMsg":"Check your quote and payment status to move your application forward.","reportPreparing":"Report On Its Way","reportPreparingMsg":"We are preparing your trademark report and quote. Expect an email within 24 hours.","quoteReady":"Your Quote Is Ready","quoteReadyMsg":"Your attorney-confirmed quote is ready. Review it and pay to start your filing.","filingInProgress":"Filing In Progress","filingInProgressMsg":"Your payment is complete. Your trademark application is being prepared for filing.","paymentPending":"Payment Pending","paymentPendingMsg":"Your application is ready for filing. Complete payment to proceed.","startJourney":"Start Your Journey","startJourneyMsg":"Get a free trademark check and quote on our website \u2014 no payment required upfront.","analysisComplete":"Analysis Completed","analysisCompleteMsg":"Marko has analysed your trademark. Check the report for potential conflicts.","systemOp":"System Operational","systemOpMsg":"All monitoring systems active"}},"status":{"inProgress":"In Progress","quoteRequested":"Preparing your report","quoteSent":"Quote ready","paymentPending":"Payment Pending","paymentComplete":"Payment Complete","pendingFiling":"Pending Filing","filingInProgress":"Filing in Progress","filed":"Filed","registered":"Registered","completed":"Completed","cancelled":"Cancelled","refunded":"Refunded","partiallyRefunded":"Partially Refunded"},"payments":{"sectionTitle":"Quote & Payment","sectionSubtitle":"Review your quote, sign the declaration, and complete payment","noApplicationTitle":"No application yet","noApplicationMsg":"Start with a free trademark check on our website. We will email you a detailed report and quote within 24 hours.","startFreeCheck":"Start your free check","reportPreparingTitle":"Your report is being prepared","reportPreparingMsg":"Our team is reviewing your trademark and preparing your detailed report and quote. We will email it to you within 24 hours.","reportForTrademark":"Trademark: {{name}}","loadingQuote":"Loading your quote\u2026","noQuoteTitle":"Your quote is not ready yet","noQuoteMsg":"We are still finalising the quote for this application. You will receive an email as soon as it is ready. If you think this is a mistake, reply to any of our emails and we will sort it out.","quoteTitle":"Your quote","quoteSubtitle":"Review your filing fees and complete payment","quoteSubtitleConfirmed":"Confirmed by our attorneys \u2014 this is the exact amount you will be charged.","breakdown":"Quote breakdown","countries":"Countries","classes":"Classes","serviceFee":"Service fee","governmentFees":"Government filing fees","filingFee":"Trademark filing","discount":"Multi-country discount","total":"Total","chargedIn":"Charged in {{currency}}","pendingRetry":"A previous payment attempt is pending. You can proceed to try again.","attorneyServiceFee":"Trade mark attorney service fee","quoteDocTitle":"Quote","dateOfIssue":"Date of issue","quoteValidity":"Valid for 30 days","trademarkDetails":"Trade mark details","markName":"Trade mark","markType":"Type","applicant":"Applicant","viewFullReport":"View your full report","hideFullReport":"Hide your full report","reportExpanderHint":"The trademark report our team prepared for you","settingUpPayment":"Setting up secure payment\u2026","paymentRetry":"Try again","overlayUnlock":"Tick the declaration above to pay","overlayUnlockApplicant":"Add your applicant details above to pay","overlayUnlockBoth":"Add your applicant details and tick the declaration above to pay","applicantTbc":"To be confirmed","applicantDetails":{"title":"Applicant details","subtitle":"The trade mark will be registered in this name. The trade mark office requires the applicant\u2019s name and postal address to file.","nameLabel":"Applicant name","namePlaceholder":"Full legal name or company name","streetLabel":"Street address","streetPlaceholder":"123 Example Street","cityLabel":"Suburb / City","stateLabel":"State","optional":"(optional)","zipLabel":"Postcode","countryLabel":"Country","saving":"Saving\u2026","saved":"Saved","saveError":"Could not save your details. They will be saved again as you keep typing."},"declaration":{"loading":"Loading declaration\u2026","title":"Authorisation & Declaration","subtitle":"Required before we can file your trademark application on your behalf","combined":"I confirm I am authorised to file this trade mark, that the information in this application is true and accurate, and I appoint MarkoTM as my agent to file and manage this application on my behalf. I accept the","signedBy":"Signed by","signedOn":"on {{date}}","saveError":"Could not save your declaration. Please try again."},"report":{"title":"Your trademark report","subtitle":"Prepared by our team","preparedOn":"Prepared by our team on {{date}}","sections":{"overview":"Overview","markAssessment":"Mark assessment","registerFindings":"Register findings","coverageRationale":"Coverage rationale","ourRecommendation":"Our recommendation","nextSteps":"Next steps"},"matchesTitle":"IP Australia register results","matchName":"Mark","matchNumber":"Number","matchStatus":"Status","matchClasses":"Classes"}},"sidebar":{"dashboard":"Dashboard","overview":"Overview","quoteAndPayment":"Quote & Payment","quoteAndPaymentDesc":"Review your quote and pay","myPortfolio":"My Portfolio","viewTrademarks":"View your trademarks","renewals":"Renewals","upcomingDeadlines":"Upcoming deadlines","currentApplication":"Current Application","settings":"Settings","portfolio":"My Portfolio","newApplication":"New Application","filingProgress":"Filing Progress","documents":"Documents","billing":"Billing"},"header":{"notifications":"Notifications","profile":"Profile","logout":"Log Out"},"attorney":{"name":"Ken McInnes","title":"Head of Trademark Strategy","greeting":"Welcome to your secure IP dashboard. You can follow your trade mark\'s progress here, and it makes it easy to stay in touch with your assigned trade mark attorney at every step."},"marko":{"analysisComplete":"I\'ve analysed your trademark! Click to see my recommendations.","multiCountry":"Filing in multiple countries? I\'ll help you prioritise.","thinking":"Marko is thinking...","askMe":"Ask me anything about trademarks","clickToChat":"Click to chat \u2192"},"application":{"create":"Create Application","createNew":"Create New Application","name":"Application Name","namePlaceholder":"Give your trademark application a name","nameHelp":"This helps organise your IP portfolio and keeps track of your filing progress.","delete":"Delete Application","deleteConfirm":"Are you sure you want to delete this application? This action cannot be undone.","status":"Application Status","progress":"Progress"}}');


var $af97b3988b6ba46c$exports = {};
$af97b3988b6ba46c$exports = JSON.parse("{\"upload\":{\"title\":\"Your Trademark\",\"subtitle\":\"Upload your trademark image or enter a word mark\",\"selectType\":\"Which option best describes your trademark?\",\"logoTrademark\":\"Logo trademark\",\"logoDescription\":\"Brand logo including text\",\"figurativeTrademark\":\"Figurative trademark\",\"figurativeDescription\":\"Graphical elements of the brand without text\",\"wordTrademark\":\"Word trademark\",\"wordDescription\":\"Brand name or slogan\",\"uploadYour\":\"Upload your {{type}} trademark\",\"dragDrop\":\"Drag and drop your image here, or\",\"browseFiles\":\"browse files\",\"supportedFormats\":\"Supported formats: PNG, JPG, GIF\",\"enterWordMark\":\"Enter your word trademark\",\"wordPlaceholder\":\"Enter your trademark text\",\"uploadWordMark\":\"Upload Word Mark\",\"removeImage\":\"Remove Image\",\"uploading\":\"Uploading trademark...\",\"uploadSuccess\":\"Trademark uploaded successfully!\",\"imageSuccess\":\"Image trademark uploaded successfully\",\"uploadDifferent\":\"Upload Different Trademark\",\"selectImage\":\"Select an image to upload automatically\",\"uploadError\":\"Failed to upload trademark. Please try again.\"},\"analysis\":{\"title\":\"AI-Powered Analysis\",\"subtitle\":\"Our AI will analyse your trademark for distinctiveness, potential conflicts, and registration strategy\",\"readyTitle\":\"Ready for AI-Powered Trademark Analysis\",\"readySubtitle\":\"Our AI will analyse your trademark for distinctiveness, potential conflicts, and registration strategy\",\"yourTrademark\":\"Your Trademark\",\"trademarkRequired\":\"Trademark Required\",\"businessProfile\":\"Business Profile\",\"businessRequired\":\"Business Profile Required\",\"trademarkName\":\"Trademark Name\",\"trademarkNameDesc\":\"This is the name or text that will be protected under your trademark registration\",\"trademarkType\":\"Trademark Type\",\"logoTypeDesc\":\"A visual design or logo that represents your brand\",\"wordTypeDesc\":\"A word or phrase that identifies your goods or services\",\"detailedDescription\":\"Detailed Description\",\"trademarkDescription\":\"Trademark Description\",\"viewDescription\":\"View detailed trademark description\",\"descriptionHelp\":\"This description helps our AI understand the visual and conceptual elements of your trademark\",\"descRequired\":\"Description Required\",\"descRequiredMsg\":\"Please add a detailed description of your trademark to proceed with analysis\",\"descRequiredHelp\":\"A good description includes colors, design elements, fonts, and overall appearance\",\"noTrademark\":\"No Trademark Selected\",\"noTrademarkMsg\":\"Please complete the trademark upload step first\",\"noTrademarkHelp\":\"You need to upload your trademark before we can analyse it\",\"readyToAnalyse\":\"Ready to Analyse\",\"analyseButton\":\"Analyse My Trademark\",\"analysing\":\"Analysing your trademark...\",\"analysisComplete\":\"Analysis Complete\",\"viewReport\":\"View Full Report\",\"overallScore\":\"Overall Score\",\"distinctiveness\":\"Distinctiveness\",\"conflictRisk\":\"Conflict Risk\",\"registrability\":\"Registrability\",\"recommendations\":\"Recommendations\",\"potentialConflicts\":\"Potential Conflicts\",\"noConflicts\":\"No significant conflicts found\",\"needsUpload\":\"You need to upload your trademark before we can analyse it\",\"classRecommendations\":\"Class Recommendations\",\"suggestedClasses\":\"Suggested Nice Classes\"},\"business\":{\"title\":\"Business Information\",\"complete\":\"Business Information Complete\",\"completeDescription\":\"Your business information has been successfully saved and will be used to provide accurate trademark recommendations.\",\"subtitle\":\"Tell us about your business so Marko can provide personalised recommendations\",\"ownerType\":\"Trademark Owner Type\",\"individual\":\"Individual\",\"company\":\"Company\",\"partnership\":\"Partnership\",\"businessName\":\"Business Name\",\"tradingAs\":\"Trading As\",\"registrationNumber\":\"Registration Number\",\"industry\":\"Industry\",\"selectIndustry\":\"Select your industry\",\"goodsServices\":\"Goods & Services\",\"describeGoodsServices\":\"Describe the goods or services your trademark will cover\",\"markoAnalyse\":\"Marko will analyse your information for completeness as you type.\",\"analysed\":\"I've analysed your trademark\"},\"classes\":{\"title\":\"Nice Classification\",\"subtitle\":\"Select the classes that best describe your goods and services\",\"selectedClasses\":\"Selected Classes\",\"noClassesSelected\":\"No classes selected\",\"addClass\":\"Add Class\",\"removeClass\":\"Remove Class\",\"searchClasses\":\"Search classes...\",\"classNumber\":\"Class {{number}}\",\"viewDetails\":\"View class details\"}}");


var $57a6497ce12eaa72$exports = {};
$57a6497ce12eaa72$exports = JSON.parse("{\"title\":\"Payment\",\"subtitle\":\"Complete your trademark registration payment\",\"summary\":{\"title\":\"Order Summary\",\"countries\":\"Countries Selected\",\"classes\":\"Nice Classes\",\"subtotal\":\"Subtotal\",\"governmentFees\":\"Government Fees\",\"serviceFee\":\"Service Fee\",\"total\":\"Total\",\"taxNote\":\"Prices include applicable taxes\"},\"methods\":{\"title\":\"Payment Method\",\"card\":\"Credit/Debit Card\",\"cardNumber\":\"Card Number\",\"expiry\":\"Expiry Date\",\"cvc\":\"CVC\",\"nameOnCard\":\"Name on Card\",\"secure\":\"Secure Payment\",\"stripeTitle\":\"Stripe Secure Checkout\",\"stripeDesc\":\"Your payment is processed securely through Stripe. We never store your credit card information.\",\"ssl\":\"256-bit SSL encryption\",\"pci\":\"PCI DSS compliant\",\"cards\":\"Accepts all major credit cards\"},\"status\":{\"processing\":\"Processing payment...\",\"success\":\"Payment Successful!\",\"failed\":\"Payment Failed\",\"tryAgain\":\"Please try again or use a different payment method.\",\"pending\":\"Payment Pending\",\"refunded\":\"Refunded\"},\"confirmation\":{\"title\":\"Payment Confirmed\",\"thankYou\":\"Thank you for your payment!\",\"receiptSent\":\"A receipt has been sent to {{email}}\",\"nextSteps\":\"Next Steps\",\"applicationSubmitted\":\"Your trademark application has been submitted for processing.\",\"viewStatus\":\"View Filing Status\",\"downloadReceipt\":\"Download Receipt\"},\"buttons\":{\"pay\":\"Pay {{amount}}\",\"payNow\":\"Pay Now\",\"reviewOrder\":\"Review Order\",\"proceedToPayment\":\"Proceed to Payment\",\"payAmount\":\"Pay ${{amount}} - Proceed to Secure Checkout\",\"agreeTerms\":\"I agree to the\",\"terms\":\"Terms of Service\",\"and\":\"and\",\"privacy\":\"Privacy Policy\"}}");


var $0ed43b940ffab8e5$exports = {};
$0ed43b940ffab8e5$exports = JSON.parse("{\"attorney\":{\"header\":{\"title\":\"Attorney Dashboard\"},\"nav\":{\"filingQueue\":\"Filing Queue\",\"approvalQueue\":\"Approval Queue\",\"clients\":\"My Clients\",\"correspondence\":\"Correspondence\",\"deadlines\":\"Deadlines\",\"jurisdictions\":\"Jurisdictions\",\"assignments\":\"Manage Assignments\",\"backToDashboard\":\"Back to Dashboard\"},\"filingQueue\":{\"title\":\"Filing Queue\",\"loading\":\"Loading filing queue...\",\"error\":\"Error loading filing queue\",\"empty\":\"No filings in queue\",\"allCountries\":\"All Countries\",\"allStatuses\":\"All Statuses\",\"statusPending\":\"Pending\",\"statusFiled\":\"Filed\",\"refresh\":\"Refresh\"},\"filingCard\":{\"allFiled\":\"All filed\",\"partiallyFiled\":\"In progress\",\"pending\":\"Pending\",\"client\":\"Client\",\"classes\":\"Classes\",\"country\":\"Country\",\"status\":\"Status\",\"ipOfficeRef\":\"IP Office Ref\",\"actions\":\"Actions\",\"jurisdictionsFiled\":\"jurisdictions filed\"},\"jurisdiction\":{\"pending\":\"Pending\",\"filed\":\"Filed\",\"accepted\":\"Accepted\",\"registered\":\"Registered\",\"rejected\":\"Rejected\",\"fileNow\":\"File Now\",\"viewDocs\":\"View Docs\",\"view\":\"View\",\"editRef\":\"Edit Ref\"},\"fileNowModal\":{\"title\":\"File in {{country}}\",\"applicationRef\":\"Application Reference\",\"useReference\":\"Use this reference in all IP Office forms:\",\"copy\":\"Copy\",\"copied\":\"Copied!\",\"ipOfficePortal\":\"IP Office Portal\",\"openPortal\":\"Open Portal\",\"instructions\":\"Instructions\",\"step1\":\"Log in to {{office}} portal\",\"step2\":\"Start new trademark application\",\"step3\":\"Enter \\\"{{appId}}\\\" in \\\"Your Reference\\\" field\",\"step4\":\"Upload the generated filing document\",\"step5\":\"Complete payment on IP Office\",\"step6\":\"Note the {{office}} reference number\",\"documents\":\"Documents\",\"afterFiling\":\"After filing, enter the IP Office reference number:\",\"cancel\":\"Cancel\",\"markAsFiled\":\"Mark as Filed\",\"marking\":\"Marking...\"},\"approvalQueue\":{\"title\":\"Approval Queue\",\"loading\":\"Loading approval queue...\",\"error\":\"Error loading approval queue\",\"empty\":\"No tasks awaiting approval\",\"allTypes\":\"All Types\",\"officeAction\":\"Office Action Responses\",\"opposition\":\"Opposition Responses\",\"renewal\":\"Renewal Applications\",\"refresh\":\"Refresh\"},\"approvalCard\":{\"officeAction\":\"Office Action Response\",\"opposition\":\"Opposition Response\",\"renewal\":\"Renewal Application\",\"urgent\":\"Urgent\",\"high\":\"High\",\"medium\":\"Medium\",\"low\":\"Low\",\"successLikelihood\":\"Success Likelihood\",\"noSummary\":\"No summary available\",\"daysLeft\":\"{{days}} days left\",\"overdue\":\"Overdue!\",\"review\":\"Review Draft\"},\"draftReview\":{\"title\":\"Review AI Draft\",\"summary\":\"Summary\",\"estimatedSuccess\":\"Estimated Success\",\"keyArguments\":\"Key Arguments\",\"similarCases\":\"Similar Cases Referenced\",\"draftContent\":\"Draft Content\",\"view\":\"View\",\"edit\":\"Edit\",\"editPlaceholder\":\"Edit the draft...\",\"rejectReason\":\"Reason for Rejection\",\"rejectPlaceholder\":\"Explain why this draft is being rejected...\",\"back\":\"Back\",\"reject\":\"Reject\",\"confirmReject\":\"Confirm Rejection\",\"rejecting\":\"Rejecting...\",\"approve\":\"Approve\",\"approveWithChanges\":\"Approve with Changes\",\"approving\":\"Approving...\"},\"correspondence\":{\"title\":\"Correspondence\",\"loading\":\"Loading correspondence...\",\"error\":\"Failed to load correspondence\",\"retry\":\"Retry\",\"refresh\":\"Refresh\",\"empty\":\"No correspondence found\",\"emptyHint\":\"Correspondence will appear here when emails are synced from the docketing mailbox.\",\"filter\":{\"all\":\"All\",\"unprocessed\":\"Unprocessed\",\"needsMatching\":\"Needs Matching\",\"processed\":\"Processed\"},\"types\":{\"officeAction\":\"Office Action\",\"acceptance\":\"Acceptance\",\"opposition\":\"Opposition\",\"renewal\":\"Renewal Notice\",\"registration\":\"Registration\",\"general\":\"General\"},\"notLinked\":\"Not linked to application\",\"from\":\"From\",\"received\":\"Received\",\"classification\":\"Classification\",\"jurisdiction\":\"Jurisdiction\",\"application\":\"Application\",\"summary\":\"Summary\",\"body\":\"Email Body\",\"manualMatch\":\"Manual Match\",\"linkToApplication\":\"Link to Application\",\"markProcessed\":\"Mark as Processed\",\"processing\":\"Processing...\"},\"manualMatch\":{\"title\":\"Manual Match\",\"selectApplication\":\"Select Application\",\"searchPlaceholder\":\"Search by application ID or trademark name...\",\"searching\":\"Searching...\",\"or\":\"or enter manually\",\"change\":\"Change\",\"classificationDetails\":\"Classification & Details\",\"classification\":\"Classification\",\"subType\":\"Sub-Type\",\"selectSubType\":\"Select sub-type...\",\"notApplicable\":\"N/A\",\"jurisdiction\":\"Jurisdiction\",\"selectJurisdiction\":\"Select jurisdiction...\",\"deadline\":\"Deadline\",\"ipOfficeRef\":\"IP Office Reference\",\"ipOfficeRefPlaceholder\":\"e.g., TM2025/12345\",\"aiLearning\":\"AI Learning Feedback\",\"aiLearningDesc\":\"Help the AI learn from this correction to improve future matching.\",\"whyFailed\":\"Why did automatic matching fail?\",\"selectFailure\":\"Select a reason...\",\"whereFound\":\"Where did you find the correct information?\",\"notes\":\"Notes (optional)\",\"notesPlaceholder\":\"Any additional context that might help the AI...\",\"cancel\":\"Cancel\",\"saveMatch\":\"Save Match\",\"saving\":\"Saving...\",\"failures\":{\"unusualFormat\":\"Unusual Email Format\",\"newIpOffice\":\"New IP Office Format\",\"pdfFailed\":\"PDF Extraction Failed\",\"noReference\":\"No Reference Found\",\"ambiguous\":\"Ambiguous Reference\",\"inAttachment\":\"Reference in Attachment Only\",\"newSender\":\"New Sender/Domain\",\"other\":\"Other\"},\"locations\":{\"subjectLine\":\"Subject Line\",\"emailBody\":\"Email Body\",\"pdfAttachment\":\"PDF Attachment\",\"imageAttachment\":\"Image Attachment\",\"senderDomain\":\"Sender Domain\"},\"errors\":{\"applicationRequired\":\"Please select an application\",\"saveFailed\":\"Failed to save manual match. Please try again.\"}}}}");


var $8e3f93ea3216cf21$exports = {};
$8e3f93ea3216cf21$exports = JSON.parse("{\"notifications\":{\"title\":\"Notifications\",\"markAllRead\":\"Mark all as read\",\"viewAll\":\"View all notifications\",\"empty\":\"No notifications\",\"emptyDescription\":\"You're all caught up!\",\"new\":\"new\",\"today\":\"Today\",\"yesterday\":\"Yesterday\",\"earlier\":\"Earlier\",\"justNow\":\"Just now\",\"minutesAgo\":\"{{count}} minute ago\",\"minutesAgo_plural\":\"{{count}} minutes ago\",\"hoursAgo\":\"{{count}} hour ago\",\"hoursAgo_plural\":\"{{count}} hours ago\",\"daysAgo\":\"{{count}} day ago\",\"daysAgo_plural\":\"{{count}} days ago\",\"categories\":{\"status_change\":\"Status Update\",\"correspondence\":\"Correspondence\",\"deadline\":\"Deadline\",\"approval_needed\":\"Approval Needed\",\"filing_complete\":\"Filing Complete\",\"new_filing\":\"New Filing\",\"office_action\":\"Office Action\",\"system\":\"System\"},\"urgency\":{\"low\":\"Low\",\"medium\":\"Medium\",\"high\":\"High\",\"critical\":\"Critical\"},\"actions\":{\"view\":\"View\",\"dismiss\":\"Dismiss\",\"markRead\":\"Mark as read\"}}}");


var $218087a50620c012$exports = {};
$218087a50620c012$exports = JSON.parse('{"buttons":{"save":"Guardar","cancel":"Cancelar","continue":"Continuar","back":"Atr\xe1s","submit":"Enviar","delete":"Eliminar","edit":"Editar","close":"Cerrar","confirm":"Confirmar","next":"Siguiente","previous":"Anterior","upload":"Subir","download":"Descargar","refresh":"Actualizar","retry":"Reintentar","learnMore":"M\xe1s informaci\xf3n","getStarted":"Comenzar","viewDetails":"Ver detalles","saveChanges":"Guardar cambios"},"labels":{"email":"Correo electr\xf3nico","name":"Nombre","firstName":"Nombre","lastName":"Apellido","phone":"Tel\xe9fono","company":"Empresa","companyName":"Nombre de la empresa","country":"Pa\xeds","address":"Direcci\xf3n","city":"Ciudad","state":"Provincia","postcode":"C\xf3digo postal","website":"Sitio web","description":"Descripci\xf3n","date":"Fecha","status":"Estado","actions":"Acciones","type":"Tipo","category":"Categor\xeda","notes":"Notas"},"status":{"loading":"Cargando...","saving":"Guardando...","success":"\xa1\xc9xito!","error":"Se produjo un error","pending":"Pendiente","completed":"Completado","inProgress":"En progreso","draft":"Borrador","active":"Activo","inactive":"Inactivo"},"validation":{"required":"Este campo es obligatorio","invalidEmail":"Por favor ingrese un correo electr\xf3nico v\xe1lido","minLength":"Debe tener al menos {{min}} caracteres","maxLength":"No debe tener m\xe1s de {{max}} caracteres","invalidPhone":"Por favor ingrese un n\xfamero de tel\xe9fono v\xe1lido","invalidUrl":"Por favor ingrese una URL v\xe1lida"},"errors":{"generic":"Algo sali\xf3 mal. Por favor intente de nuevo.","network":"Error de red. Por favor verifique su conexi\xf3n.","unauthorized":"No est\xe1 autorizado para realizar esta acci\xf3n.","notFound":"El recurso solicitado no fue encontrado.","serverError":"Error del servidor. Por favor intente m\xe1s tarde."},"navigation":{"home":"Inicio","dashboard":"Panel de control","settings":"Configuraci\xf3n","profile":"Perfil","logout":"Cerrar sesi\xf3n","login":"Iniciar sesi\xf3n","signUp":"Registrarse","help":"Ayuda","support":"Soporte"},"time":{"today":"Hoy","yesterday":"Ayer","lastWeek":"La semana pasada","lastMonth":"El mes pasado","ago":"hace","minutes":"minutos","hours":"horas","days":"d\xedas"},"language":{"select":"Seleccionar idioma","en":"English","es":"Espa\xf1ol","de":"Deutsch","zh":"\u4E2D\u6587"}}');


var $63cdd656a11131a5$exports = {};
$63cdd656a11131a5$exports = JSON.parse('{"home":{"title":"Panel de control","welcome":"Bienvenido de nuevo, {{name}}","guest":"Invitado","subtitle":"Esto es lo que est\xe1 pasando con su propiedad intelectual hoy.","currentApplication":"Solicitud actual","applicationProgress":"Progreso de la solicitud","noActiveApplications":"Sin solicitudes activas","createFirst":"Cree su primera solicitud de marca para comenzar.","quickActions":"Acciones r\xe1pidas","resumeFiling":"Presupuesto y pago","resumeFilingDesc":"Vea su presupuesto y pague","paymentHistory":"Historial de pagos","paymentHistoryDesc":"Ver recibos y facturas","contactSupport":"Contactar soporte","contactSupportDesc":"Obtenga ayuda de nuestro equipo","lastUpdated":"\xdaltima actualizaci\xf3n: {{date}}","newFiling":"Nueva verificaci\xf3n de marca","viewAll":"Ver todo","continueFiling":"Ver presupuesto y pago","payAndFile":"Pagar y registrar","viewQuoteStatus":"Ver estado","viewFilingStatus":"Ver estado del registro","activeFilings":"Solicitudes activas","actionRequired":"Acci\xf3n requerida","protectedAssets":"Activos protegidos","startProtecting":"Comience con una verificaci\xf3n gratuita de su marca en nuestro sitio web. Recibir\xe1 un informe detallado y un presupuesto confirmado por abogados en 24 horas, sin pago por adelantado.","startNewApp":"Comience su verificaci\xf3n gratuita","fromYourAttorney":"De su abogado de marcas","unnamedTrademark":"Marca sin nombre","insights":{"appInProgress":"Solicitud en progreso","appInProgressMsg":"Revise su presupuesto y el estado del pago para avanzar con su solicitud.","reportPreparing":"Su informe est\xe1 en camino","reportPreparingMsg":"Estamos preparando su informe de marca y presupuesto. Recibir\xe1 un correo en 24 horas.","quoteReady":"Su presupuesto est\xe1 listo","quoteReadyMsg":"Su presupuesto confirmado por abogados est\xe1 listo. Rev\xedselo y pague para iniciar su registro.","filingInProgress":"Registro en curso","filingInProgressMsg":"Su pago se ha completado. Su solicitud de marca se est\xe1 preparando para el registro.","paymentPending":"Pago pendiente","paymentPendingMsg":"Su solicitud est\xe1 lista para registrar. Complete el pago para continuar.","startJourney":"Comience su viaje","startJourneyMsg":"Obtenga una verificaci\xf3n gratuita de su marca y un presupuesto en nuestro sitio web, sin pago por adelantado.","analysisComplete":"An\xe1lisis completado","analysisCompleteMsg":"Marko ha analizado su marca. Revise el informe para posibles conflictos.","systemOp":"Sistema operativo","systemOpMsg":"Todos los sistemas de monitoreo activos"}},"status":{"inProgress":"En progreso","quoteRequested":"Preparando su informe","quoteSent":"Presupuesto listo","paymentPending":"Pago pendiente","paymentComplete":"Pago completado","pendingFiling":"Registro pendiente","filingInProgress":"Registro en curso","filed":"Registrada","registered":"Concedida","completed":"Completada","cancelled":"Cancelada","refunded":"Reembolsada","partiallyRefunded":"Reembolso parcial"},"payments":{"sectionTitle":"Presupuesto y pago","sectionSubtitle":"Revise su presupuesto, firme la declaraci\xf3n y complete el pago","noApplicationTitle":"A\xfan no hay solicitud","noApplicationMsg":"Comience con una verificaci\xf3n gratuita de su marca en nuestro sitio web. Le enviaremos por correo un informe detallado y un presupuesto en 24 horas.","startFreeCheck":"Comience su verificaci\xf3n gratuita","reportPreparingTitle":"Su informe se est\xe1 preparando","reportPreparingMsg":"Nuestro equipo est\xe1 revisando su marca y preparando su informe detallado y presupuesto. Se lo enviaremos por correo en 24 horas.","reportForTrademark":"Marca: {{name}}","loadingQuote":"Cargando su presupuesto\u2026","noQuoteTitle":"Su presupuesto a\xfan no est\xe1 listo","noQuoteMsg":"Todav\xeda estamos finalizando el presupuesto de esta solicitud. Recibir\xe1 un correo en cuanto est\xe9 listo. Si cree que se trata de un error, responda a cualquiera de nuestros correos y lo resolveremos.","quoteTitle":"Su presupuesto","quoteSubtitle":"Revise las tarifas de registro y complete el pago","quoteSubtitleConfirmed":"Confirmado por nuestros abogados: este es el importe exacto que se le cobrar\xe1.","breakdown":"Desglose del presupuesto","countries":"Pa\xedses","classes":"Clases","serviceFee":"Tarifa de servicio","governmentFees":"Tasas oficiales de registro","filingFee":"Registro de marca","discount":"Descuento por varios pa\xedses","total":"Total","chargedIn":"Se cobra en {{currency}}","pendingRetry":"Un intento de pago anterior est\xe1 pendiente. Puede continuar e intentarlo de nuevo.","attorneyServiceFee":"Honorarios del abogado de marcas","quoteDocTitle":"Presupuesto","dateOfIssue":"Fecha de emisi\xf3n","quoteValidity":"V\xe1lido por 30 d\xedas","trademarkDetails":"Datos de la marca","markName":"Marca","markType":"Tipo","applicant":"Solicitante","viewFullReport":"Ver su informe completo","hideFullReport":"Ocultar su informe completo","reportExpanderHint":"El informe de marca que nuestro equipo prepar\xf3 para usted","settingUpPayment":"Preparando el pago seguro\u2026","paymentRetry":"Intentar de nuevo","overlayUnlock":"Marque la declaraci\xf3n anterior para pagar","overlayUnlockApplicant":"A\xf1ada los datos del solicitante arriba para pagar","overlayUnlockBoth":"A\xf1ada los datos del solicitante y marque la declaraci\xf3n anterior para pagar","applicantTbc":"Por confirmar","applicantDetails":{"title":"Datos del solicitante","subtitle":"La marca se registrar\xe1 a este nombre. La oficina de marcas requiere el nombre y la direcci\xf3n postal del solicitante para presentar la solicitud.","nameLabel":"Nombre del solicitante","namePlaceholder":"Nombre legal completo o raz\xf3n social","streetLabel":"Direcci\xf3n (calle)","streetPlaceholder":"Calle Ejemplo 123","cityLabel":"Ciudad / Localidad","stateLabel":"Estado / Provincia","optional":"(opcional)","zipLabel":"C\xf3digo postal","countryLabel":"Pa\xeds","saving":"Guardando\u2026","saved":"Guardado","saveError":"No se pudieron guardar sus datos. Se guardar\xe1n de nuevo mientras siga escribiendo."},"declaration":{"loading":"Cargando la declaraci\xf3n\u2026","title":"Autorizaci\xf3n y declaraci\xf3n","subtitle":"Obligatorio antes de que podamos presentar su solicitud de marca en su nombre","combined":"Confirmo que estoy autorizado a registrar esta marca, que la informaci\xf3n de esta solicitud es verdadera y exacta, y que designo a MarkoTM como mi agente para presentar y gestionar esta solicitud en mi nombre. Acepto los","signedBy":"Firmado por","signedOn":"el {{date}}","saveError":"No se pudo guardar su declaraci\xf3n. Int\xe9ntelo de nuevo."},"report":{"title":"Su informe de marca","subtitle":"Preparado por nuestro equipo","preparedOn":"Preparado por nuestro equipo el {{date}}","sections":{"overview":"Resumen","markAssessment":"Evaluaci\xf3n de la marca","registerFindings":"Resultados del registro","coverageRationale":"Justificaci\xf3n de la cobertura","ourRecommendation":"Nuestra recomendaci\xf3n","nextSteps":"Pr\xf3ximos pasos"},"matchesTitle":"Resultados del registro de IP Australia","matchName":"Marca","matchNumber":"N\xfamero","matchStatus":"Estado","matchClasses":"Clases"}},"sidebar":{"dashboard":"Panel de control","overview":"Resumen","quoteAndPayment":"Presupuesto y pago","quoteAndPaymentDesc":"Vea su presupuesto y pague","myPortfolio":"Mi portafolio","viewTrademarks":"Ver sus marcas","renewals":"Renovaciones","upcomingDeadlines":"Pr\xf3ximas fechas l\xedmite","currentApplication":"Solicitud actual","settings":"Configuraci\xf3n","portfolio":"Mi portafolio","newApplication":"Nueva solicitud","filingProgress":"Progreso de registro","documents":"Documentos","billing":"Facturaci\xf3n"},"header":{"notifications":"Notificaciones","profile":"Perfil","logout":"Cerrar sesi\xf3n"},"attorney":{"name":"Ken McInnes","title":"Director de Estrategia de Marcas","greeting":"Bienvenido a su panel seguro de PI. Aqu\xed puede seguir el progreso de su marca y mantenerse f\xe1cilmente en contacto con su abogado de marcas asignado en cada paso."},"marko":{"analysisComplete":"\xa1He analizado su marca! Haga clic para ver mis recomendaciones.","multiCountry":"\xbfRegistrando en varios pa\xedses? Le ayudar\xe9 a priorizar.","thinking":"Marko est\xe1 pensando...","askMe":"Preg\xfanteme sobre marcas registradas","clickToChat":"Haga clic para chatear \u2192"},"application":{"create":"Crear solicitud","createNew":"Crear nueva solicitud","name":"Nombre de la solicitud","namePlaceholder":"D\xe9 un nombre a su solicitud de marca","nameHelp":"Esto ayuda a organizar su portafolio de PI y seguir el progreso de su registro.","delete":"Eliminar solicitud","deleteConfirm":"\xbfEst\xe1 seguro de que desea eliminar esta solicitud? Esta acci\xf3n no se puede deshacer.","status":"Estado de la solicitud","progress":"Progreso"}}');


var $01ecfdd02617fc9e$exports = {};
$01ecfdd02617fc9e$exports = JSON.parse('{"upload":{"title":"Su marca","subtitle":"Suba la imagen de su marca o ingrese una marca de texto","selectType":"\xbfCu\xe1l opci\xf3n describe mejor su marca?","logoTrademark":"Marca con logo","logoDescription":"Logo de marca incluyendo texto","figurativeTrademark":"Marca figurativa","figurativeDescription":"Elementos gr\xe1ficos de la marca sin texto","wordTrademark":"Marca de palabra","wordDescription":"Nombre de marca o eslogan","uploadYour":"Suba su marca {{type}}","dragDrop":"Arrastre y suelte su imagen aqu\xed, o","browseFiles":"buscar archivos","supportedFormats":"Formatos soportados: PNG, JPG, GIF","enterWordMark":"Ingrese su marca de palabra","wordPlaceholder":"Ingrese el texto de su marca","uploadWordMark":"Subir marca de palabra","removeImage":"Eliminar imagen","uploading":"Subiendo marca...","uploadSuccess":"\xa1Marca subida exitosamente!","imageSuccess":"Imagen de marca subida exitosamente","uploadDifferent":"Subir otra marca","selectImage":"Seleccione una imagen para subir autom\xe1ticamente","uploadError":"Error al subir la marca. Por favor intente de nuevo."},"analysis":{"title":"An\xe1lisis con IA","subtitle":"Nuestra IA analizar\xe1 su marca en busca de distintividad, conflictos potenciales y estrategia de registro","readyTitle":"Listo para el an\xe1lisis de marca con IA","readySubtitle":"Nuestra IA analizar\xe1 su marca en busca de distintividad, conflictos potenciales y estrategia de registro","yourTrademark":"Su marca","trademarkRequired":"Marca requerida","businessProfile":"Perfil empresarial","businessRequired":"Perfil empresarial requerido","trademarkName":"Nombre de la marca","trademarkNameDesc":"Este es el nombre o texto que estar\xe1 protegido bajo su registro de marca","trademarkType":"Tipo de marca","logoTypeDesc":"Un dise\xf1o visual o logotipo que representa su marca","wordTypeDesc":"Una palabra o frase que identifica sus bienes o servicios","detailedDescription":"Descripci\xf3n detallada","trademarkDescription":"Descripci\xf3n de la marca","viewDescription":"Ver descripci\xf3n detallada de la marca","descriptionHelp":"Esta descripci\xf3n ayuda a nuestra IA a comprender los elementos visuales y conceptuales de su marca","descRequired":"Descripci\xf3n requerida","descRequiredMsg":"Por favor agregue una descripci\xf3n detallada de su marca para continuar con el an\xe1lisis","descRequiredHelp":"Una buena descripci\xf3n incluye colores, elementos de dise\xf1o, fuentes y apariencia general","noTrademark":"Ninguna marca seleccionada","noTrademarkMsg":"Por favor complete el paso de carga de marca primero","noTrademarkHelp":"Necesita cargar su marca antes de que podamos analizarla","readyToAnalyse":"Listo para analizar","analyseButton":"Analizar mi marca","analysing":"Analizando su marca...","analysisComplete":"An\xe1lisis completado","viewReport":"Ver informe completo","overallScore":"Puntuaci\xf3n general","distinctiveness":"Distintividad","conflictRisk":"Riesgo de conflicto","registrability":"Registrabilidad","recommendations":"Recomendaciones","potentialConflicts":"Conflictos potenciales","noConflicts":"No se encontraron conflictos significativos","needsUpload":"Necesita subir su marca antes de que podamos analizarla","classRecommendations":"Recomendaciones de clase","suggestedClasses":"Clases de Niza sugeridas"},"business":{"title":"Informaci\xf3n comercial","complete":"Informaci\xf3n comercial completada","completeDescription":"Su informaci\xf3n comercial se ha guardado correctamente y se utilizar\xe1 para proporcionar recomendaciones precisas de marcas.","subtitle":"Cu\xe9ntenos sobre su negocio para que Marko pueda proporcionar recomendaciones personalizadas","ownerType":"Tipo de propietario de marca","individual":"Individual","company":"Empresa","partnership":"Sociedad","businessName":"Nombre comercial","tradingAs":"Operando como","registrationNumber":"N\xfamero de registro","industry":"Industria","selectIndustry":"Seleccione su industria","goodsServices":"Bienes y servicios","describeGoodsServices":"Describa los bienes o servicios que cubrir\xe1 su marca","markoAnalyse":"Marko analizar\xe1 su informaci\xf3n mientras escribe.","analysed":"He analizado su marca"},"classes":{"title":"Clasificaci\xf3n de Niza","subtitle":"Seleccione las clases que mejor describan sus bienes y servicios","selectedClasses":"Clases seleccionadas","noClassesSelected":"No hay clases seleccionadas","addClass":"Agregar clase","removeClass":"Eliminar clase","searchClasses":"Buscar clases...","classNumber":"Clase {{number}}","viewDetails":"Ver detalles de la clase"}}');


var $b7e252cd4df25524$exports = {};
$b7e252cd4df25524$exports = JSON.parse('{"title":"Pago","subtitle":"Complete el pago del registro de su marca","summary":{"title":"Resumen del pedido","countries":"Pa\xedses seleccionados","classes":"Clases de Niza","subtotal":"Subtotal","governmentFees":"Tasas gubernamentales","serviceFee":"Tarifa de servicio","total":"Total","taxNote":"Los precios incluyen impuestos aplicables"},"methods":{"title":"M\xe9todo de pago","card":"Tarjeta de cr\xe9dito/d\xe9bito","cardNumber":"N\xfamero de tarjeta","expiry":"Fecha de vencimiento","cvc":"CVC","nameOnCard":"Nombre en la tarjeta","secure":"Pago seguro","stripeTitle":"Pago seguro con Stripe","stripeDesc":"Su pago se procesa de forma segura a trav\xe9s de Stripe. Nunca almacenamos la informaci\xf3n de su tarjeta.","ssl":"Cifrado SSL de 256 bits","pci":"Cumple con PCI DSS","cards":"Acepta todas las tarjetas principales"},"status":{"processing":"Procesando pago...","success":"\xa1Pago exitoso!","failed":"Pago fallido","tryAgain":"Por favor intente de nuevo o use otro m\xe9todo de pago.","pending":"Pago pendiente","refunded":"Reembolsado"},"confirmation":{"title":"Pago confirmado","thankYou":"\xa1Gracias por su pago!","receiptSent":"Se ha enviado un recibo a {{email}}","nextSteps":"Pr\xf3ximos pasos","applicationSubmitted":"Su solicitud de marca ha sido enviada para procesamiento.","viewStatus":"Ver estado del registro","downloadReceipt":"Descargar recibo"},"buttons":{"pay":"Pagar {{amount}}","payNow":"Pagar ahora","reviewOrder":"Revisar pedido","proceedToPayment":"Proceder al pago","payAmount":"Pagar ${{amount}} - Proceder al pago seguro","agreeTerms":"Acepto los","terms":"T\xe9rminos de servicio","and":"y la","privacy":"Pol\xedtica de privacidad"}}');


var $cb3e156155c1f6ea$exports = {};
$cb3e156155c1f6ea$exports = JSON.parse('{"attorney":{"header":{"title":"Panel de Abogado"},"nav":{"filingQueue":"Cola de Registro","approvalQueue":"Cola de Aprobaci\xf3n","clients":"Mis Clientes","correspondence":"Correspondencia","deadlines":"Fechas L\xedmite","jurisdictions":"Jurisdicciones","assignments":"Gestionar Asignaciones","backToDashboard":"Volver al Panel"},"filingQueue":{"title":"Cola de Registro","loading":"Cargando cola de registro...","error":"Error al cargar la cola de registro","empty":"No hay registros en cola","allCountries":"Todos los Pa\xedses","allStatuses":"Todos los Estados","statusPending":"Pendiente","statusFiled":"Registrado","refresh":"Actualizar"},"filingCard":{"allFiled":"Todo registrado","partiallyFiled":"En progreso","pending":"Pendiente","client":"Cliente","classes":"Clases","country":"Pa\xeds","status":"Estado","ipOfficeRef":"Ref. Oficina de PI","actions":"Acciones","jurisdictionsFiled":"jurisdicciones registradas"},"jurisdiction":{"pending":"Pendiente","filed":"Registrado","accepted":"Aceptado","registered":"Registrado","rejected":"Rechazado","fileNow":"Registrar Ahora","viewDocs":"Ver Docs","view":"Ver","editRef":"Editar Ref"},"fileNowModal":{"title":"Registrar en {{country}}","applicationRef":"Referencia de Solicitud","useReference":"Use esta referencia en todos los formularios de la Oficina de PI:","copy":"Copiar","copied":"\xa1Copiado!","ipOfficePortal":"Portal de la Oficina de PI","openPortal":"Abrir Portal","instructions":"Instrucciones","step1":"Inicie sesi\xf3n en el portal de {{office}}","step2":"Inicie una nueva solicitud de marca","step3":"Ingrese \\"{{appId}}\\" en el campo \\"Su Referencia\\"","step4":"Cargue el documento de registro generado","step5":"Complete el pago en la Oficina de PI","step6":"Anote el n\xfamero de referencia de {{office}}","documents":"Documentos","afterFiling":"Despu\xe9s del registro, ingrese el n\xfamero de referencia de la Oficina de PI:","cancel":"Cancelar","markAsFiled":"Marcar como Registrado","marking":"Marcando..."},"approvalQueue":{"title":"Cola de Aprobaci\xf3n","loading":"Cargando cola de aprobaci\xf3n...","error":"Error al cargar la cola de aprobaci\xf3n","empty":"No hay tareas pendientes de aprobaci\xf3n","allTypes":"Todos los Tipos","officeAction":"Respuestas a Acciones de Oficina","opposition":"Respuestas a Oposiciones","renewal":"Solicitudes de Renovaci\xf3n","refresh":"Actualizar"},"approvalCard":{"officeAction":"Respuesta a Acci\xf3n de Oficina","opposition":"Respuesta a Oposici\xf3n","renewal":"Solicitud de Renovaci\xf3n","urgent":"Urgente","high":"Alta","medium":"Media","low":"Baja","successLikelihood":"Probabilidad de \xc9xito","noSummary":"Sin resumen disponible","daysLeft":"{{days}} d\xedas restantes","overdue":"\xa1Vencido!","review":"Revisar Borrador"},"draftReview":{"title":"Revisar Borrador de IA","summary":"Resumen","estimatedSuccess":"\xc9xito Estimado","keyArguments":"Argumentos Clave","similarCases":"Casos Similares Referenciados","draftContent":"Contenido del Borrador","view":"Ver","edit":"Editar","editPlaceholder":"Editar el borrador...","rejectReason":"Motivo del Rechazo","rejectPlaceholder":"Explique por qu\xe9 se rechaza este borrador...","back":"Volver","reject":"Rechazar","confirmReject":"Confirmar Rechazo","rejecting":"Rechazando...","approve":"Aprobar","approveWithChanges":"Aprobar con Cambios","approving":"Aprobando..."}}}');


var $7136658354ea3e09$exports = {};
$7136658354ea3e09$exports = JSON.parse('{"notifications":{"title":"Notificaciones","markAllRead":"Marcar todo como le\xeddo","viewAll":"Ver todas las notificaciones","empty":"Sin notificaciones","emptyDescription":"\xa1Est\xe1s al d\xeda!","new":"nueva","today":"Hoy","yesterday":"Ayer","earlier":"Anteriores","justNow":"Ahora mismo","minutesAgo":"Hace {{count}} minuto","minutesAgo_plural":"Hace {{count}} minutos","hoursAgo":"Hace {{count}} hora","hoursAgo_plural":"Hace {{count}} horas","daysAgo":"Hace {{count}} d\xeda","daysAgo_plural":"Hace {{count}} d\xedas","categories":{"status_change":"Actualizaci\xf3n de Estado","correspondence":"Correspondencia","deadline":"Fecha L\xedmite","approval_needed":"Aprobaci\xf3n Necesaria","filing_complete":"Registro Completo","new_filing":"Nuevo Registro","office_action":"Acci\xf3n de Oficina","system":"Sistema"},"urgency":{"low":"Baja","medium":"Media","high":"Alta","critical":"Cr\xedtica"},"actions":{"view":"Ver","dismiss":"Descartar","markRead":"Marcar como le\xeddo"}}}');


var $e38949a8072d2fa2$exports = {};
$e38949a8072d2fa2$exports = JSON.parse('{"buttons":{"save":"Speichern","cancel":"Abbrechen","continue":"Fortfahren","back":"Zur\xfcck","submit":"Absenden","delete":"L\xf6schen","edit":"Bearbeiten","close":"Schlie\xdfen","confirm":"Best\xe4tigen","next":"Weiter","previous":"Zur\xfcck","upload":"Hochladen","download":"Herunterladen","refresh":"Aktualisieren","retry":"Erneut versuchen","learnMore":"Mehr erfahren","getStarted":"Loslegen","viewDetails":"Details anzeigen","saveChanges":"\xc4nderungen speichern"},"labels":{"email":"E-Mail","name":"Name","firstName":"Vorname","lastName":"Nachname","phone":"Telefon","company":"Unternehmen","companyName":"Firmenname","country":"Land","address":"Adresse","city":"Stadt","state":"Bundesland","postcode":"Postleitzahl","website":"Webseite","description":"Beschreibung","date":"Datum","status":"Status","actions":"Aktionen","type":"Typ","category":"Kategorie","notes":"Notizen"},"status":{"loading":"Laden...","saving":"Speichern...","success":"Erfolgreich!","error":"Ein Fehler ist aufgetreten","pending":"Ausstehend","completed":"Abgeschlossen","inProgress":"In Bearbeitung","draft":"Entwurf","active":"Aktiv","inactive":"Inaktiv"},"validation":{"required":"Dieses Feld ist erforderlich","invalidEmail":"Bitte geben Sie eine g\xfcltige E-Mail-Adresse ein","minLength":"Muss mindestens {{min}} Zeichen haben","maxLength":"Darf nicht mehr als {{max}} Zeichen haben","invalidPhone":"Bitte geben Sie eine g\xfcltige Telefonnummer ein","invalidUrl":"Bitte geben Sie eine g\xfcltige URL ein"},"errors":{"generic":"Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.","network":"Netzwerkfehler. Bitte \xfcberpr\xfcfen Sie Ihre Verbindung.","unauthorized":"Sie sind nicht berechtigt, diese Aktion durchzuf\xfchren.","notFound":"Die angeforderte Ressource wurde nicht gefunden.","serverError":"Serverfehler. Bitte versuchen Sie es sp\xe4ter erneut."},"navigation":{"home":"Startseite","dashboard":"Dashboard","settings":"Einstellungen","profile":"Profil","logout":"Abmelden","login":"Anmelden","signUp":"Registrieren","help":"Hilfe","support":"Support"},"time":{"today":"Heute","yesterday":"Gestern","lastWeek":"Letzte Woche","lastMonth":"Letzter Monat","ago":"vor","minutes":"Minuten","hours":"Stunden","days":"Tagen"},"language":{"select":"Sprache ausw\xe4hlen","en":"English","es":"Espa\xf1ol","de":"Deutsch","zh":"\u4E2D\u6587"}}');


var $fa8265a128182669$exports = {};
$fa8265a128182669$exports = JSON.parse('{"home":{"title":"Dashboard","welcome":"Willkommen zur\xfcck, {{name}}","guest":"Gast","subtitle":"Das passiert heute mit Ihrem geistigen Eigentum.","currentApplication":"Aktuelle Anmeldung","applicationProgress":"Anmeldungsfortschritt","noActiveApplications":"Keine aktiven Anmeldungen","createFirst":"Erstellen Sie Ihre erste Markenanmeldung, um zu beginnen.","quickActions":"Schnellaktionen","resumeFiling":"Angebot & Zahlung","resumeFilingDesc":"Angebot ansehen und bezahlen","paymentHistory":"Zahlungsverlauf","paymentHistoryDesc":"Belege und Rechnungen anzeigen","contactSupport":"Support kontaktieren","contactSupportDesc":"Hilfe von unserem Team erhalten","lastUpdated":"Zuletzt aktualisiert: {{date}}","newFiling":"Neue Markenpr\xfcfung","viewAll":"Alle anzeigen","continueFiling":"Angebot & Zahlung ansehen","payAndFile":"Bezahlen & anmelden","viewQuoteStatus":"Status anzeigen","viewFilingStatus":"Anmeldestatus anzeigen","activeFilings":"Aktive Anmeldungen","actionRequired":"Aktion erforderlich","protectedAssets":"Gesch\xfctzte Verm\xf6genswerte","startProtecting":"Beginnen Sie mit einer kostenlosen Markenpr\xfcfung auf unserer Website. Sie erhalten innerhalb von 24 Stunden einen ausf\xfchrlichen Bericht und ein von Anw\xe4lten best\xe4tigtes Angebot \u2014 ohne Vorauszahlung.","startNewApp":"Kostenlose Pr\xfcfung starten","fromYourAttorney":"Von Ihrem Markenanwalt","unnamedTrademark":"Unbenannte Marke","insights":{"appInProgress":"Anmeldung in Bearbeitung","appInProgressMsg":"Pr\xfcfen Sie Ihr Angebot und den Zahlungsstatus, um Ihre Anmeldung voranzubringen.","reportPreparing":"Ihr Bericht ist unterwegs","reportPreparingMsg":"Wir erstellen gerade Ihren Markenbericht und Ihr Angebot. Sie erhalten innerhalb von 24 Stunden eine E-Mail.","quoteReady":"Ihr Angebot ist fertig","quoteReadyMsg":"Ihr von Anw\xe4lten best\xe4tigtes Angebot ist fertig. Pr\xfcfen Sie es und bezahlen Sie, um Ihre Anmeldung zu starten.","filingInProgress":"Anmeldung l\xe4uft","filingInProgressMsg":"Ihre Zahlung ist abgeschlossen. Ihre Markenanmeldung wird f\xfcr die Einreichung vorbereitet.","paymentPending":"Zahlung ausstehend","paymentPendingMsg":"Ihre Anmeldung ist bereit zur Einreichung. Schlie\xdfen Sie die Zahlung ab, um fortzufahren.","startJourney":"Starten Sie Ihre Reise","startJourneyMsg":"Erhalten Sie eine kostenlose Markenpr\xfcfung und ein Angebot auf unserer Website \u2014 ohne Vorauszahlung.","analysisComplete":"Analyse abgeschlossen","analysisCompleteMsg":"Marko hat Ihre Marke analysiert. Pr\xfcfen Sie den Bericht auf m\xf6gliche Konflikte.","systemOp":"System betriebsbereit","systemOpMsg":"Alle \xdcberwachungssysteme aktiv"}},"status":{"inProgress":"In Bearbeitung","quoteRequested":"Bericht wird erstellt","quoteSent":"Angebot bereit","paymentPending":"Zahlung ausstehend","paymentComplete":"Zahlung abgeschlossen","pendingFiling":"Einreichung ausstehend","filingInProgress":"Anmeldung l\xe4uft","filed":"Eingereicht","registered":"Eingetragen","completed":"Abgeschlossen","cancelled":"Storniert","refunded":"Erstattet","partiallyRefunded":"Teilweise erstattet"},"payments":{"sectionTitle":"Angebot & Zahlung","sectionSubtitle":"Pr\xfcfen Sie Ihr Angebot, unterzeichnen Sie die Erkl\xe4rung und schlie\xdfen Sie die Zahlung ab","noApplicationTitle":"Noch keine Anmeldung","noApplicationMsg":"Beginnen Sie mit einer kostenlosen Markenpr\xfcfung auf unserer Website. Wir senden Ihnen innerhalb von 24 Stunden einen ausf\xfchrlichen Bericht und ein Angebot per E-Mail.","startFreeCheck":"Kostenlose Pr\xfcfung starten","reportPreparingTitle":"Ihr Bericht wird erstellt","reportPreparingMsg":"Unser Team pr\xfcft Ihre Marke und erstellt Ihren ausf\xfchrlichen Bericht und Ihr Angebot. Wir senden es Ihnen innerhalb von 24 Stunden per E-Mail.","reportForTrademark":"Marke: {{name}}","loadingQuote":"Ihr Angebot wird geladen\u2026","noQuoteTitle":"Ihr Angebot ist noch nicht fertig","noQuoteMsg":"Wir stellen das Angebot f\xfcr diese Anmeldung noch fertig. Sie erhalten eine E-Mail, sobald es bereit ist. Wenn Sie glauben, dass dies ein Fehler ist, antworten Sie einfach auf eine unserer E-Mails.","quoteTitle":"Ihr Angebot","quoteSubtitle":"Pr\xfcfen Sie Ihre Anmeldegeb\xfchren und schlie\xdfen Sie die Zahlung ab","quoteSubtitleConfirmed":"Von unseren Anw\xe4lten best\xe4tigt \u2014 genau dieser Betrag wird Ihnen berechnet.","breakdown":"Angebotsaufstellung","countries":"L\xe4nder","classes":"Klassen","serviceFee":"Servicegeb\xfchr","governmentFees":"Amtliche Anmeldegeb\xfchren","filingFee":"Markenanmeldung","discount":"Mehrl\xe4nder-Rabatt","total":"Gesamt","chargedIn":"Abrechnung in {{currency}}","pendingRetry":"Ein fr\xfcherer Zahlungsversuch ist noch ausstehend. Sie k\xf6nnen es erneut versuchen.","attorneyServiceFee":"Honorar des Markenanwalts","quoteDocTitle":"Angebot","dateOfIssue":"Ausstellungsdatum","quoteValidity":"30 Tage g\xfcltig","trademarkDetails":"Markendetails","markName":"Marke","markType":"Typ","applicant":"Anmelder","viewFullReport":"Ihren vollst\xe4ndigen Bericht ansehen","hideFullReport":"Ihren vollst\xe4ndigen Bericht ausblenden","reportExpanderHint":"Der Markenbericht, den unser Team f\xfcr Sie erstellt hat","settingUpPayment":"Sichere Zahlung wird eingerichtet\u2026","paymentRetry":"Erneut versuchen","overlayUnlock":"Haken Sie oben die Erkl\xe4rung an, um zu bezahlen","overlayUnlockApplicant":"Erg\xe4nzen Sie oben die Anmelderdaten, um zu bezahlen","overlayUnlockBoth":"Erg\xe4nzen Sie oben die Anmelderdaten und haken Sie die Erkl\xe4rung an, um zu bezahlen","applicantTbc":"Wird noch best\xe4tigt","applicantDetails":{"title":"Anmelderdaten","subtitle":"Die Marke wird auf diesen Namen eingetragen. Das Markenamt ben\xf6tigt f\xfcr die Anmeldung den Namen und die Postanschrift des Anmelders.","nameLabel":"Name des Anmelders","namePlaceholder":"Vollst\xe4ndiger rechtlicher Name oder Firmenname","streetLabel":"Stra\xdfe und Hausnummer","streetPlaceholder":"Beispielstra\xdfe 123","cityLabel":"Ort / Stadt","stateLabel":"Bundesland / Region","optional":"(optional)","zipLabel":"Postleitzahl","countryLabel":"Land","saving":"Wird gespeichert\u2026","saved":"Gespeichert","saveError":"Ihre Daten konnten nicht gespeichert werden. Sie werden beim Weitertippen erneut gespeichert."},"declaration":{"loading":"Erkl\xe4rung wird geladen\u2026","title":"Vollmacht & Erkl\xe4rung","subtitle":"Erforderlich, bevor wir Ihre Markenanmeldung in Ihrem Namen einreichen k\xf6nnen","combined":"Ich best\xe4tige, dass ich berechtigt bin, diese Marke anzumelden, dass die Angaben in dieser Anmeldung wahr und richtig sind, und dass ich MarkoTM als meinen Vertreter f\xfcr die Einreichung und Verwaltung dieser Anmeldung benenne. Ich akzeptiere die","signedBy":"Unterzeichnet von","signedOn":"am {{date}}","saveError":"Ihre Erkl\xe4rung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut."},"report":{"title":"Ihr Markenbericht","subtitle":"Von unserem Team erstellt","preparedOn":"Von unserem Team erstellt am {{date}}","sections":{"overview":"\xdcberblick","markAssessment":"Bewertung der Marke","registerFindings":"Registerergebnisse","coverageRationale":"Begr\xfcndung des Schutzumfangs","ourRecommendation":"Unsere Empfehlung","nextSteps":"N\xe4chste Schritte"},"matchesTitle":"Ergebnisse aus dem Register von IP Australia","matchName":"Marke","matchNumber":"Nummer","matchStatus":"Status","matchClasses":"Klassen"}},"sidebar":{"dashboard":"Dashboard","overview":"\xdcbersicht","quoteAndPayment":"Angebot & Zahlung","quoteAndPaymentDesc":"Angebot ansehen und bezahlen","myPortfolio":"Mein Portfolio","viewTrademarks":"Ihre Marken anzeigen","renewals":"Verl\xe4ngerungen","upcomingDeadlines":"Anstehende Fristen","currentApplication":"Aktuelle Anmeldung","settings":"Einstellungen","portfolio":"Mein Portfolio","newApplication":"Neue Anmeldung","filingProgress":"Anmeldungsfortschritt","documents":"Dokumente","billing":"Abrechnung"},"header":{"notifications":"Benachrichtigungen","profile":"Profil","logout":"Abmelden"},"attorney":{"name":"Ken McInnes","title":"Leiter Markenstrategie","greeting":"Willkommen in Ihrem sicheren IP-Dashboard. Hier k\xf6nnen Sie den Fortschritt Ihrer Marke verfolgen und bleiben in jedem Schritt ganz einfach mit Ihrem zugewiesenen Markenanwalt in Kontakt."},"marko":{"analysisComplete":"Ich habe Ihre Marke analysiert! Klicken Sie, um meine Empfehlungen zu sehen.","multiCountry":"Anmeldung in mehreren L\xe4ndern? Ich helfe Ihnen bei der Priorisierung.","thinking":"Marko denkt nach...","askMe":"Fragen Sie mich zu Marken","clickToChat":"Klicken zum Chatten \u2192"},"application":{"create":"Anmeldung erstellen","createNew":"Neue Anmeldung erstellen","name":"Anmeldungsname","namePlaceholder":"Geben Sie Ihrer Markenanmeldung einen Namen","nameHelp":"Dies hilft, Ihr IP-Portfolio zu organisieren und den Fortschritt Ihrer Anmeldung zu verfolgen.","delete":"Anmeldung l\xf6schen","deleteConfirm":"Sind Sie sicher, dass Sie diese Anmeldung l\xf6schen m\xf6chten? Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","status":"Anmeldungsstatus","progress":"Fortschritt"}}');


var $982f81968710d651$exports = {};
$982f81968710d651$exports = JSON.parse('{"upload":{"title":"Ihre Marke","subtitle":"Laden Sie Ihr Markenbild hoch oder geben Sie eine Wortmarke ein","selectType":"Welche Option beschreibt Ihre Marke am besten?","logoTrademark":"Logo-Marke","logoDescription":"Markenlogo einschlie\xdflich Text","figurativeTrademark":"Bildmarke","figurativeDescription":"Grafische Elemente der Marke ohne Text","wordTrademark":"Wortmarke","wordDescription":"Markenname oder Slogan","uploadYour":"Laden Sie Ihre {{type}}-Marke hoch","dragDrop":"Ziehen Sie Ihr Bild hierher oder","browseFiles":"Dateien durchsuchen","supportedFormats":"Unterst\xfctzte Formate: PNG, JPG, GIF","enterWordMark":"Geben Sie Ihre Wortmarke ein","wordPlaceholder":"Geben Sie Ihren Markentext ein","uploadWordMark":"Wortmarke hochladen","removeImage":"Bild entfernen","uploading":"Marke wird hochgeladen...","uploadSuccess":"Marke erfolgreich hochgeladen!","imageSuccess":"Bildmarke erfolgreich hochgeladen","uploadDifferent":"Andere Marke hochladen","selectImage":"W\xe4hlen Sie ein Bild zum automatischen Hochladen","uploadError":"Fehler beim Hochladen der Marke. Bitte versuchen Sie es erneut."},"analysis":{"title":"KI-gest\xfctzte Analyse","subtitle":"Unsere KI analysiert Ihre Marke auf Unterscheidungskraft, potenzielle Konflikte und Registrierungsstrategie","readyTitle":"Bereit f\xfcr die KI-gest\xfctzte Markenanalyse","readySubtitle":"Unsere KI analysiert Ihre Marke auf Unterscheidungskraft, potenzielle Konflikte und Registrierungsstrategie","yourTrademark":"Ihre Marke","trademarkRequired":"Marke erforderlich","businessProfile":"Unternehmensprofil","businessRequired":"Unternehmensprofil erforderlich","trademarkName":"Markenname","trademarkNameDesc":"Dies ist der Name oder Text, der unter Ihrer Markenregistrierung gesch\xfctzt wird","trademarkType":"Markentyp","logoTypeDesc":"Ein visuelles Design oder Logo, das Ihre Marke repr\xe4sentiert","wordTypeDesc":"Ein Wort oder eine Phrase, die Ihre Waren oder Dienstleistungen identifiziert","detailedDescription":"Detaillierte Beschreibung","trademarkDescription":"Markenbeschreibung","viewDescription":"Detaillierte Markenbeschreibung anzeigen","descriptionHelp":"Diese Beschreibung hilft unserer KI, die visuellen und konzeptuellen Elemente Ihrer Marke zu verstehen","descRequired":"Beschreibung erforderlich","descRequiredMsg":"Bitte f\xfcgen Sie eine detaillierte Beschreibung Ihrer Marke hinzu, um mit der Analyse fortzufahren","descRequiredHelp":"Eine gute Beschreibung enth\xe4lt Farben, Designelemente, Schriftarten und das allgemeine Erscheinungsbild","noTrademark":"Keine Marke ausgew\xe4hlt","noTrademarkMsg":"Bitte vervollst\xe4ndigen Sie zuerst den Marken-Upload-Schritt","noTrademarkHelp":"Sie m\xfcssen Ihre Marke hochladen, bevor wir sie analysieren k\xf6nnen","readyToAnalyse":"Bereit zur Analyse","analyseButton":"Meine Marke analysieren","analysing":"Analyse Ihrer Marke...","analysisComplete":"Analyse abgeschlossen","viewReport":"Vollst\xe4ndigen Bericht anzeigen","overallScore":"Gesamtbewertung","distinctiveness":"Unterscheidungskraft","conflictRisk":"Konfliktrisiko","registrability":"Registrierbarkeit","recommendations":"Empfehlungen","potentialConflicts":"Potenzielle Konflikte","noConflicts":"Keine signifikanten Konflikte gefunden","needsUpload":"Sie m\xfcssen Ihre Marke hochladen, bevor wir sie analysieren k\xf6nnen","classRecommendations":"Klassenempfehlungen","suggestedClasses":"Empfohlene Nizza-Klassen"},"business":{"title":"Gesch\xe4ftsinformationen","complete":"Gesch\xe4ftsinformationen vollst\xe4ndig","completeDescription":"Ihre Gesch\xe4ftsinformationen wurden erfolgreich gespeichert und werden verwendet, um genaue Markenempfehlungen zu geben.","subtitle":"Erz\xe4hlen Sie uns von Ihrem Unternehmen, damit Marko personalisierte Empfehlungen geben kann","ownerType":"Markeninhabertyp","individual":"Einzelperson","company":"Unternehmen","partnership":"Partnerschaft","businessName":"Firmenname","tradingAs":"Handelsname","registrationNumber":"Registrierungsnummer","industry":"Branche","selectIndustry":"W\xe4hlen Sie Ihre Branche","goodsServices":"Waren und Dienstleistungen","describeGoodsServices":"Beschreiben Sie die Waren oder Dienstleistungen, die Ihre Marke abdecken wird","markoAnalyse":"Marko analysiert Ihre Informationen w\xe4hrend Sie tippen.","analysed":"Ich habe Ihre Marke analysiert"},"classes":{"title":"Nizza-Klassifikation","subtitle":"W\xe4hlen Sie die Klassen, die Ihre Waren und Dienstleistungen am besten beschreiben","selectedClasses":"Ausgew\xe4hlte Klassen","noClassesSelected":"Keine Klassen ausgew\xe4hlt","addClass":"Klasse hinzuf\xfcgen","removeClass":"Klasse entfernen","searchClasses":"Klassen suchen...","classNumber":"Klasse {{number}}","viewDetails":"Klassendetails anzeigen"}}');


var $b515faada0e05d26$exports = {};
$b515faada0e05d26$exports = JSON.parse('{"title":"Zahlung","subtitle":"Schlie\xdfen Sie die Zahlung f\xfcr Ihre Markenregistrierung ab","summary":{"title":"Bestell\xfcbersicht","countries":"Ausgew\xe4hlte L\xe4nder","classes":"Nizza-Klassen","subtotal":"Zwischensumme","governmentFees":"Beh\xf6rdengeb\xfchren","serviceFee":"Servicegeb\xfchr","total":"Gesamt","taxNote":"Preise inkl. anfallender Steuern"},"methods":{"title":"Zahlungsmethode","card":"Kredit-/Debitkarte","cardNumber":"Kartennummer","expiry":"Ablaufdatum","cvc":"CVC","nameOnCard":"Name auf der Karte","secure":"Sichere Zahlung","stripeTitle":"Sichere Zahlung mit Stripe","stripeDesc":"Ihre Zahlung wird sicher \xfcber Stripe verarbeitet. Wir speichern niemals Ihre Kreditkarteninformationen.","ssl":"256-Bit SSL-Verschl\xfcsselung","pci":"PCI DSS konform","cards":"Akzeptiert alle g\xe4ngigen Kreditkarten"},"status":{"processing":"Zahlung wird verarbeitet...","success":"Zahlung erfolgreich!","failed":"Zahlung fehlgeschlagen","tryAgain":"Bitte versuchen Sie es erneut oder verwenden Sie eine andere Zahlungsmethode.","pending":"Zahlung ausstehend","refunded":"Erstattet"},"confirmation":{"title":"Zahlung best\xe4tigt","thankYou":"Vielen Dank f\xfcr Ihre Zahlung!","receiptSent":"Eine Quittung wurde an {{email}} gesendet","nextSteps":"N\xe4chste Schritte","applicationSubmitted":"Ihre Markenanmeldung wurde zur Bearbeitung eingereicht.","viewStatus":"Anmeldungsstatus anzeigen","downloadReceipt":"Quittung herunterladen"},"buttons":{"pay":"{{amount}} bezahlen","payNow":"Jetzt bezahlen","reviewOrder":"Bestellung \xfcberpr\xfcfen","proceedToPayment":"Zur Zahlung","payAmount":"${{amount}} bezahlen - Zur sicheren Kasse","agreeTerms":"Ich stimme den","terms":"Nutzungsbedingungen","and":"und der","privacy":"Datenschutzrichtlinie"}}');


var $75452841b0fac32b$exports = {};
$75452841b0fac32b$exports = JSON.parse('{"attorney":{"header":{"title":"Anwalts-Dashboard"},"nav":{"filingQueue":"Anmeldewarteschlange","approvalQueue":"Genehmigungswarteschlange","clients":"Meine Mandanten","correspondence":"Korrespondenz","deadlines":"Fristen","jurisdictions":"Zust\xe4ndigkeiten","assignments":"Zuweisungen verwalten","backToDashboard":"Zur\xfcck zum Dashboard"},"filingQueue":{"title":"Anmeldewarteschlange","loading":"Anmeldewarteschlange wird geladen...","error":"Fehler beim Laden der Anmeldewarteschlange","empty":"Keine Anmeldungen in der Warteschlange","allCountries":"Alle L\xe4nder","allStatuses":"Alle Status","statusPending":"Ausstehend","statusFiled":"Eingereicht","refresh":"Aktualisieren"},"filingCard":{"allFiled":"Alle eingereicht","partiallyFiled":"In Bearbeitung","pending":"Ausstehend","client":"Mandant","classes":"Klassen","country":"Land","status":"Status","ipOfficeRef":"IP-Amt Ref.","actions":"Aktionen","jurisdictionsFiled":"Zust\xe4ndigkeiten eingereicht"},"jurisdiction":{"pending":"Ausstehend","filed":"Eingereicht","accepted":"Akzeptiert","registered":"Registriert","rejected":"Abgelehnt","fileNow":"Jetzt einreichen","viewDocs":"Dokumente ansehen","view":"Ansehen","editRef":"Ref. bearbeiten"},"fileNowModal":{"title":"Einreichung in {{country}}","applicationRef":"Anmeldereferenz","useReference":"Verwenden Sie diese Referenz in allen IP-Amt-Formularen:","copy":"Kopieren","copied":"Kopiert!","ipOfficePortal":"IP-Amt Portal","openPortal":"Portal \xf6ffnen","instructions":"Anleitung","step1":"Melden Sie sich beim {{office}}-Portal an","step2":"Starten Sie eine neue Markenanmeldung","step3":"Geben Sie \\"{{appId}}\\" im Feld \\"Ihre Referenz\\" ein","step4":"Laden Sie das generierte Anmeldedokument hoch","step5":"Schlie\xdfen Sie die Zahlung beim IP-Amt ab","step6":"Notieren Sie die {{office}}-Referenznummer","documents":"Dokumente","afterFiling":"Nach der Einreichung geben Sie die IP-Amt-Referenznummer ein:","cancel":"Abbrechen","markAsFiled":"Als eingereicht markieren","marking":"Wird markiert..."},"approvalQueue":{"title":"Genehmigungswarteschlange","loading":"Genehmigungswarteschlange wird geladen...","error":"Fehler beim Laden der Genehmigungswarteschlange","empty":"Keine Aufgaben warten auf Genehmigung","allTypes":"Alle Typen","officeAction":"Amtsbescheidantworten","opposition":"Widerspruchsantworten","renewal":"Verl\xe4ngerungsantr\xe4ge","refresh":"Aktualisieren"},"approvalCard":{"officeAction":"Amtsbescheidantwort","opposition":"Widerspruchsantwort","renewal":"Verl\xe4ngerungsantrag","urgent":"Dringend","high":"Hoch","medium":"Mittel","low":"Niedrig","successLikelihood":"Erfolgswahrscheinlichkeit","noSummary":"Keine Zusammenfassung verf\xfcgbar","daysLeft":"{{days}} Tage verbleibend","overdue":"\xdcberf\xe4llig!","review":"Entwurf pr\xfcfen"},"draftReview":{"title":"KI-Entwurf \xfcberpr\xfcfen","summary":"Zusammenfassung","estimatedSuccess":"Gesch\xe4tzter Erfolg","keyArguments":"Kernargumente","similarCases":"Referenzierte \xe4hnliche F\xe4lle","draftContent":"Entwurfsinhalt","view":"Ansehen","edit":"Bearbeiten","editPlaceholder":"Entwurf bearbeiten...","rejectReason":"Ablehnungsgrund","rejectPlaceholder":"Erkl\xe4ren Sie, warum dieser Entwurf abgelehnt wird...","back":"Zur\xfcck","reject":"Ablehnen","confirmReject":"Ablehnung best\xe4tigen","rejecting":"Wird abgelehnt...","approve":"Genehmigen","approveWithChanges":"Mit \xc4nderungen genehmigen","approving":"Wird genehmigt..."}}}');


var $90e39169afa8a9d1$exports = {};
$90e39169afa8a9d1$exports = JSON.parse('{"notifications":{"title":"Benachrichtigungen","markAllRead":"Alle als gelesen markieren","viewAll":"Alle Benachrichtigungen anzeigen","empty":"Keine Benachrichtigungen","emptyDescription":"Sie sind auf dem neuesten Stand!","new":"neu","today":"Heute","yesterday":"Gestern","earlier":"Fr\xfcher","justNow":"Gerade eben","minutesAgo":"Vor {{count}} Minute","minutesAgo_plural":"Vor {{count}} Minuten","hoursAgo":"Vor {{count}} Stunde","hoursAgo_plural":"Vor {{count}} Stunden","daysAgo":"Vor {{count}} Tag","daysAgo_plural":"Vor {{count}} Tagen","categories":{"status_change":"Statusaktualisierung","correspondence":"Korrespondenz","deadline":"Frist","approval_needed":"Genehmigung erforderlich","filing_complete":"Einreichung abgeschlossen","new_filing":"Neue Einreichung","office_action":"Amtsbescheid","system":"System"},"urgency":{"low":"Niedrig","medium":"Mittel","high":"Hoch","critical":"Kritisch"},"actions":{"view":"Ansehen","dismiss":"Verwerfen","markRead":"Als gelesen markieren"}}}');


var $21418db4c4686a83$exports = {};
$21418db4c4686a83$exports = JSON.parse('{"buttons":{"save":"\u4FDD\u5B58","cancel":"\u53D6\u6D88","continue":"\u7EE7\u7EED","back":"\u8FD4\u56DE","submit":"\u63D0\u4EA4","delete":"\u5220\u9664","edit":"\u7F16\u8F91","close":"\u5173\u95ED","confirm":"\u786E\u8BA4","next":"\u4E0B\u4E00\u6B65","previous":"\u4E0A\u4E00\u6B65","upload":"\u4E0A\u4F20","download":"\u4E0B\u8F7D","refresh":"\u5237\u65B0","retry":"\u91CD\u8BD5","learnMore":"\u4E86\u89E3\u66F4\u591A","getStarted":"\u5F00\u59CB\u4F7F\u7528","viewDetails":"\u67E5\u770B\u8BE6\u60C5","saveChanges":"\u4FDD\u5B58\u66F4\u6539"},"labels":{"email":"\u7535\u5B50\u90AE\u4EF6","name":"\u59D3\u540D","firstName":"\u540D","lastName":"\u59D3","phone":"\u7535\u8BDD","company":"\u516C\u53F8","companyName":"\u516C\u53F8\u540D\u79F0","country":"\u56FD\u5BB6","address":"\u5730\u5740","city":"\u57CE\u5E02","state":"\u7701\u4EFD","postcode":"\u90AE\u7F16","website":"\u7F51\u7AD9","description":"\u63CF\u8FF0","date":"\u65E5\u671F","status":"\u72B6\u6001","actions":"\u64CD\u4F5C","type":"\u7C7B\u578B","category":"\u7C7B\u522B","notes":"\u5907\u6CE8"},"status":{"loading":"\u52A0\u8F7D\u4E2D...","saving":"\u4FDD\u5B58\u4E2D...","success":"\u6210\u529F\uFF01","error":"\u53D1\u751F\u9519\u8BEF","pending":"\u5F85\u5904\u7406","completed":"\u5DF2\u5B8C\u6210","inProgress":"\u8FDB\u884C\u4E2D","draft":"\u8349\u7A3F","active":"\u6D3B\u8DC3","inactive":"\u975E\u6D3B\u8DC3"},"validation":{"required":"\u6B64\u5B57\u6BB5\u4E3A\u5FC5\u586B\u9879","invalidEmail":"\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740","minLength":"\u81F3\u5C11\u9700\u8981{{min}}\u4E2A\u5B57\u7B26","maxLength":"\u4E0D\u80FD\u8D85\u8FC7{{max}}\u4E2A\u5B57\u7B26","invalidPhone":"\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u8BDD\u53F7\u7801","invalidUrl":"\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7F51\u5740"},"errors":{"generic":"\u51FA\u73B0\u95EE\u9898\uFF0C\u8BF7\u91CD\u8BD5\u3002","network":"\u7F51\u7EDC\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u60A8\u7684\u8FDE\u63A5\u3002","unauthorized":"\u60A8\u65E0\u6743\u6267\u884C\u6B64\u64CD\u4F5C\u3002","notFound":"\u672A\u627E\u5230\u8BF7\u6C42\u7684\u8D44\u6E90\u3002","serverError":"\u670D\u52A1\u5668\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002"},"navigation":{"home":"\u9996\u9875","dashboard":"\u63A7\u5236\u9762\u677F","settings":"\u8BBE\u7F6E","profile":"\u4E2A\u4EBA\u8D44\u6599","logout":"\u9000\u51FA\u767B\u5F55","login":"\u767B\u5F55","signUp":"\u6CE8\u518C","help":"\u5E2E\u52A9","support":"\u652F\u6301"},"time":{"today":"\u4ECA\u5929","yesterday":"\u6628\u5929","lastWeek":"\u4E0A\u5468","lastMonth":"\u4E0A\u6708","ago":"\u524D","minutes":"\u5206\u949F","hours":"\u5C0F\u65F6","days":"\u5929"},"language":{"select":"\u9009\u62E9\u8BED\u8A00","en":"English","es":"Espa\xf1ol","de":"Deutsch","zh":"\u4E2D\u6587"}}');


var $c694897d1c409d27$exports = {};
$c694897d1c409d27$exports = JSON.parse('{"home":{"title":"\u63A7\u5236\u9762\u677F","welcome":"\u6B22\u8FCE\u56DE\u6765\uFF0C{{name}}","guest":"\u8BBF\u5BA2","subtitle":"\u8FD9\u662F\u60A8\u4ECA\u5929\u7684\u77E5\u8BC6\u4EA7\u6743\u52A8\u6001\u3002","currentApplication":"\u5F53\u524D\u7533\u8BF7","applicationProgress":"\u7533\u8BF7\u8FDB\u5EA6","noActiveApplications":"\u6682\u65E0\u6D3B\u8DC3\u7533\u8BF7","createFirst":"\u521B\u5EFA\u60A8\u7684\u7B2C\u4E00\u4E2A\u5546\u6807\u7533\u8BF7\u4EE5\u5F00\u59CB\u3002","quickActions":"\u5FEB\u6377\u64CD\u4F5C","resumeFiling":"\u62A5\u4EF7\u4E0E\u652F\u4ED8","resumeFilingDesc":"\u67E5\u770B\u62A5\u4EF7\u5E76\u4ED8\u6B3E","paymentHistory":"\u652F\u4ED8\u8BB0\u5F55","paymentHistoryDesc":"\u67E5\u770B\u6536\u636E\u548C\u53D1\u7968","contactSupport":"\u8054\u7CFB\u5BA2\u670D","contactSupportDesc":"\u83B7\u53D6\u6211\u4EEC\u56E2\u961F\u7684\u5E2E\u52A9","lastUpdated":"\u6700\u540E\u66F4\u65B0\uFF1A{{date}}","newFiling":"\u65B0\u5546\u6807\u67E5\u8BE2","viewAll":"\u67E5\u770B\u5168\u90E8","continueFiling":"\u67E5\u770B\u62A5\u4EF7\u4E0E\u652F\u4ED8","payAndFile":"\u4ED8\u6B3E\u5E76\u63D0\u4EA4","viewQuoteStatus":"\u67E5\u770B\u72B6\u6001","viewFilingStatus":"\u67E5\u770B\u63D0\u4EA4\u72B6\u6001","activeFilings":"\u6D3B\u8DC3\u7533\u8BF7","actionRequired":"\u9700\u8981\u64CD\u4F5C","protectedAssets":"\u53D7\u4FDD\u62A4\u8D44\u4EA7","startProtecting":"\u4ECE\u6211\u4EEC\u7F51\u7AD9\u4E0A\u7684\u514D\u8D39\u5546\u6807\u67E5\u8BE2\u5F00\u59CB\u3002\u60A8\u5C06\u572824\u5C0F\u65F6\u5185\u6536\u5230\u8BE6\u7EC6\u62A5\u544A\u548C\u7531\u5F8B\u5E08\u786E\u8BA4\u7684\u62A5\u4EF7\uFF0C\u65E0\u9700\u9884\u5148\u4ED8\u6B3E\u3002","startNewApp":"\u5F00\u59CB\u514D\u8D39\u67E5\u8BE2","fromYourAttorney":"\u6765\u81EA\u60A8\u7684\u5546\u6807\u5F8B\u5E08","unnamedTrademark":"\u672A\u547D\u540D\u5546\u6807","insights":{"appInProgress":"\u7533\u8BF7\u8FDB\u884C\u4E2D","appInProgressMsg":"\u67E5\u770B\u60A8\u7684\u62A5\u4EF7\u548C\u4ED8\u6B3E\u72B6\u6001\uFF0C\u4EE5\u63A8\u8FDB\u60A8\u7684\u7533\u8BF7\u3002","reportPreparing":"\u62A5\u544A\u5373\u5C06\u9001\u8FBE","reportPreparingMsg":"\u6211\u4EEC\u6B63\u5728\u51C6\u5907\u60A8\u7684\u5546\u6807\u62A5\u544A\u548C\u62A5\u4EF7\u300224\u5C0F\u65F6\u5185\u60A8\u5C06\u6536\u5230\u90AE\u4EF6\u3002","quoteReady":"\u60A8\u7684\u62A5\u4EF7\u5DF2\u5C31\u7EEA","quoteReadyMsg":"\u60A8\u7684\u5F8B\u5E08\u786E\u8BA4\u62A5\u4EF7\u5DF2\u5C31\u7EEA\u3002\u8BF7\u67E5\u770B\u5E76\u4ED8\u6B3E\u4EE5\u5F00\u59CB\u63D0\u4EA4\u7533\u8BF7\u3002","filingInProgress":"\u63D0\u4EA4\u8FDB\u884C\u4E2D","filingInProgressMsg":"\u60A8\u7684\u4ED8\u6B3E\u5DF2\u5B8C\u6210\u3002\u60A8\u7684\u5546\u6807\u7533\u8BF7\u6B63\u5728\u51C6\u5907\u63D0\u4EA4\u3002","paymentPending":"\u5F85\u652F\u4ED8","paymentPendingMsg":"\u60A8\u7684\u7533\u8BF7\u5DF2\u51C6\u5907\u597D\u63D0\u4EA4\u3002\u5B8C\u6210\u652F\u4ED8\u4EE5\u7EE7\u7EED\u3002","startJourney":"\u5F00\u59CB\u60A8\u7684\u65C5\u7A0B","startJourneyMsg":"\u5728\u6211\u4EEC\u7684\u7F51\u7AD9\u4E0A\u83B7\u53D6\u514D\u8D39\u5546\u6807\u67E5\u8BE2\u548C\u62A5\u4EF7\uFF0C\u65E0\u9700\u9884\u5148\u4ED8\u6B3E\u3002","analysisComplete":"\u5206\u6790\u5B8C\u6210","analysisCompleteMsg":"Marko\u5DF2\u5206\u6790\u60A8\u7684\u5546\u6807\u3002\u67E5\u770B\u62A5\u544A\u4E86\u89E3\u6F5C\u5728\u51B2\u7A81\u3002","systemOp":"\u7CFB\u7EDF\u6B63\u5E38","systemOpMsg":"\u6240\u6709\u76D1\u63A7\u7CFB\u7EDF\u8FD0\u884C\u6B63\u5E38"}},"status":{"inProgress":"\u8FDB\u884C\u4E2D","quoteRequested":"\u62A5\u544A\u51C6\u5907\u4E2D","quoteSent":"\u62A5\u4EF7\u5DF2\u5C31\u7EEA","paymentPending":"\u5F85\u652F\u4ED8","paymentComplete":"\u652F\u4ED8\u5B8C\u6210","pendingFiling":"\u5F85\u63D0\u4EA4","filingInProgress":"\u63D0\u4EA4\u8FDB\u884C\u4E2D","filed":"\u5DF2\u63D0\u4EA4","registered":"\u5DF2\u6CE8\u518C","completed":"\u5DF2\u5B8C\u6210","cancelled":"\u5DF2\u53D6\u6D88","refunded":"\u5DF2\u9000\u6B3E","partiallyRefunded":"\u90E8\u5206\u9000\u6B3E"},"payments":{"sectionTitle":"\u62A5\u4EF7\u4E0E\u652F\u4ED8","sectionSubtitle":"\u67E5\u770B\u62A5\u4EF7\u3001\u7B7E\u7F72\u58F0\u660E\u5E76\u5B8C\u6210\u652F\u4ED8","noApplicationTitle":"\u6682\u65E0\u7533\u8BF7","noApplicationMsg":"\u4ECE\u6211\u4EEC\u7F51\u7AD9\u4E0A\u7684\u514D\u8D39\u5546\u6807\u67E5\u8BE2\u5F00\u59CB\u3002\u6211\u4EEC\u5C06\u572824\u5C0F\u65F6\u5185\u901A\u8FC7\u90AE\u4EF6\u53D1\u9001\u8BE6\u7EC6\u62A5\u544A\u548C\u62A5\u4EF7\u3002","startFreeCheck":"\u5F00\u59CB\u514D\u8D39\u67E5\u8BE2","reportPreparingTitle":"\u60A8\u7684\u62A5\u544A\u6B63\u5728\u51C6\u5907\u4E2D","reportPreparingMsg":"\u6211\u4EEC\u7684\u56E2\u961F\u6B63\u5728\u5BA1\u6838\u60A8\u7684\u5546\u6807\uFF0C\u5E76\u51C6\u5907\u8BE6\u7EC6\u62A5\u544A\u548C\u62A5\u4EF7\u3002\u6211\u4EEC\u5C06\u572824\u5C0F\u65F6\u5185\u901A\u8FC7\u90AE\u4EF6\u53D1\u9001\u7ED9\u60A8\u3002","reportForTrademark":"\u5546\u6807\uFF1A{{name}}","loadingQuote":"\u6B63\u5728\u52A0\u8F7D\u60A8\u7684\u62A5\u4EF7\u2026","noQuoteTitle":"\u60A8\u7684\u62A5\u4EF7\u5C1A\u672A\u5C31\u7EEA","noQuoteMsg":"\u6211\u4EEC\u4ECD\u5728\u4E3A\u8BE5\u7533\u8BF7\u6572\u5B9A\u62A5\u4EF7\u3002\u62A5\u4EF7\u5C31\u7EEA\u540E\u60A8\u5C06\u7ACB\u5373\u6536\u5230\u90AE\u4EF6\u3002\u5982\u679C\u60A8\u8BA4\u4E3A\u8FD9\u662F\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u56DE\u590D\u6211\u4EEC\u7684\u4EFB\u610F\u90AE\u4EF6\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u5904\u7406\u3002","quoteTitle":"\u60A8\u7684\u62A5\u4EF7","quoteSubtitle":"\u67E5\u770B\u7533\u8BF7\u8D39\u7528\u5E76\u5B8C\u6210\u652F\u4ED8","quoteSubtitleConfirmed":"\u5DF2\u7531\u6211\u4EEC\u7684\u5F8B\u5E08\u786E\u8BA4\u2014\u2014\u8FD9\u662F\u60A8\u5C06\u88AB\u6536\u53D6\u7684\u786E\u5207\u91D1\u989D\u3002","breakdown":"\u62A5\u4EF7\u660E\u7EC6","countries":"\u56FD\u5BB6/\u5730\u533A","classes":"\u7C7B\u522B","serviceFee":"\u670D\u52A1\u8D39","governmentFees":"\u5B98\u65B9\u7533\u8BF7\u8D39","filingFee":"\u5546\u6807\u7533\u8BF7","discount":"\u591A\u56FD\u6298\u6263","total":"\u603B\u8BA1","chargedIn":"\u4EE5{{currency}}\u7ED3\u7B97","pendingRetry":"\u4E0A\u4E00\u6B21\u4ED8\u6B3E\u5C1D\u8BD5\u4ECD\u5728\u5904\u7406\u4E2D\u3002\u60A8\u53EF\u4EE5\u7EE7\u7EED\u91CD\u8BD5\u3002","attorneyServiceFee":"\u5546\u6807\u5F8B\u5E08\u670D\u52A1\u8D39","quoteDocTitle":"\u62A5\u4EF7\u5355","dateOfIssue":"\u5F00\u5177\u65E5\u671F","quoteValidity":"\u6709\u6548\u671F30\u5929","trademarkDetails":"\u5546\u6807\u8BE6\u60C5","markName":"\u5546\u6807","markType":"\u7C7B\u578B","applicant":"\u7533\u8BF7\u4EBA","viewFullReport":"\u67E5\u770B\u5B8C\u6574\u62A5\u544A","hideFullReport":"\u6536\u8D77\u5B8C\u6574\u62A5\u544A","reportExpanderHint":"\u6211\u4EEC\u7684\u56E2\u961F\u4E3A\u60A8\u51C6\u5907\u7684\u5546\u6807\u62A5\u544A","settingUpPayment":"\u6B63\u5728\u51C6\u5907\u5B89\u5168\u652F\u4ED8\u2026","paymentRetry":"\u91CD\u8BD5","overlayUnlock":"\u52FE\u9009\u4E0A\u65B9\u58F0\u660E\u540E\u5373\u53EF\u4ED8\u6B3E","overlayUnlockApplicant":"\u8BF7\u5148\u5728\u4E0A\u65B9\u586B\u5199\u7533\u8BF7\u4EBA\u4FE1\u606F\uFF0C\u7136\u540E\u4ED8\u6B3E","overlayUnlockBoth":"\u8BF7\u5148\u5728\u4E0A\u65B9\u586B\u5199\u7533\u8BF7\u4EBA\u4FE1\u606F\u5E76\u52FE\u9009\u58F0\u660E\uFF0C\u7136\u540E\u4ED8\u6B3E","applicantTbc":"\u5F85\u786E\u8BA4","applicantDetails":{"title":"\u7533\u8BF7\u4EBA\u4FE1\u606F","subtitle":"\u5546\u6807\u5C06\u4EE5\u6B64\u540D\u4E49\u6CE8\u518C\u3002\u5546\u6807\u5C40\u8981\u6C42\u63D0\u4F9B\u7533\u8BF7\u4EBA\u540D\u79F0\u548C\u90AE\u653F\u5730\u5740\u624D\u80FD\u63D0\u4EA4\u7533\u8BF7\u3002","nameLabel":"\u7533\u8BF7\u4EBA\u540D\u79F0","namePlaceholder":"\u5B8C\u6574\u6CD5\u5B9A\u59D3\u540D\u6216\u516C\u53F8\u540D\u79F0","streetLabel":"\u8857\u9053\u5730\u5740","streetPlaceholder":"\u793A\u4F8B\u8857 123 \u53F7","cityLabel":"\u57CE\u5E02 / \u533A","stateLabel":"\u5DDE / \u7701","optional":"\uFF08\u53EF\u9009\uFF09","zipLabel":"\u90AE\u653F\u7F16\u7801","countryLabel":"\u56FD\u5BB6/\u5730\u533A","saving":"\u4FDD\u5B58\u4E2D\u2026","saved":"\u5DF2\u4FDD\u5B58","saveError":"\u65E0\u6CD5\u4FDD\u5B58\u60A8\u7684\u4FE1\u606F\u3002\u60A8\u7EE7\u7EED\u8F93\u5165\u65F6\u5C06\u518D\u6B21\u5C1D\u8BD5\u4FDD\u5B58\u3002"},"declaration":{"loading":"\u6B63\u5728\u52A0\u8F7D\u58F0\u660E\u2026","title":"\u6388\u6743\u4E0E\u58F0\u660E","subtitle":"\u5728\u6211\u4EEC\u4EE3\u60A8\u63D0\u4EA4\u5546\u6807\u7533\u8BF7\u4E4B\u524D\u5FC5\u987B\u5B8C\u6210","combined":"\u672C\u4EBA\u786E\u8BA4\u6709\u6743\u7533\u8BF7\u8BE5\u5546\u6807\uFF0C\u672C\u7533\u8BF7\u4E2D\u7684\u4FE1\u606F\u771F\u5B9E\u51C6\u786E\uFF0C\u5E76\u6307\u5B9AMarkoTM\u4F5C\u4E3A\u672C\u4EBA\u7684\u4EE3\u7406\u4EBA\u4EE3\u4E3A\u63D0\u4EA4\u548C\u7BA1\u7406\u672C\u7533\u8BF7\u3002\u672C\u4EBA\u63A5\u53D7","signedBy":"\u7B7E\u7F72\u4EBA","signedOn":"\u4E8E {{date}}","saveError":"\u65E0\u6CD5\u4FDD\u5B58\u60A8\u7684\u58F0\u660E\u3002\u8BF7\u91CD\u8BD5\u3002"},"report":{"title":"\u60A8\u7684\u5546\u6807\u62A5\u544A","subtitle":"\u7531\u6211\u4EEC\u7684\u56E2\u961F\u51C6\u5907","preparedOn":"\u7531\u6211\u4EEC\u7684\u56E2\u961F\u4E8E{{date}}\u51C6\u5907","sections":{"overview":"\u6982\u8FF0","markAssessment":"\u5546\u6807\u8BC4\u4F30","registerFindings":"\u6CE8\u518C\u7C3F\u68C0\u7D22\u7ED3\u679C","coverageRationale":"\u4FDD\u62A4\u8303\u56F4\u8BF4\u660E","ourRecommendation":"\u6211\u4EEC\u7684\u5EFA\u8BAE","nextSteps":"\u540E\u7EED\u6B65\u9AA4"},"matchesTitle":"\u6FB3\u5927\u5229\u4E9A\u77E5\u8BC6\u4EA7\u6743\u5C40\u6CE8\u518C\u7C3F\u68C0\u7D22\u7ED3\u679C","matchName":"\u5546\u6807","matchNumber":"\u7F16\u53F7","matchStatus":"\u72B6\u6001","matchClasses":"\u7C7B\u522B"}},"sidebar":{"dashboard":"\u63A7\u5236\u9762\u677F","overview":"\u6982\u89C8","quoteAndPayment":"\u62A5\u4EF7\u4E0E\u652F\u4ED8","quoteAndPaymentDesc":"\u67E5\u770B\u62A5\u4EF7\u5E76\u4ED8\u6B3E","myPortfolio":"\u6211\u7684\u4F5C\u54C1\u96C6","viewTrademarks":"\u67E5\u770B\u60A8\u7684\u5546\u6807","renewals":"\u7EED\u5C55","upcomingDeadlines":"\u5373\u5C06\u5230\u671F","currentApplication":"\u5F53\u524D\u7533\u8BF7","settings":"\u8BBE\u7F6E","portfolio":"\u6211\u7684\u4F5C\u54C1\u96C6","newApplication":"\u65B0\u5EFA\u7533\u8BF7","filingProgress":"\u7533\u8BF7\u8FDB\u5EA6","documents":"\u6587\u6863","billing":"\u8D26\u5355"},"header":{"notifications":"\u901A\u77E5","profile":"\u4E2A\u4EBA\u8D44\u6599","logout":"\u9000\u51FA\u767B\u5F55"},"attorney":{"name":"Ken McInnes","title":"\u5546\u6807\u6218\u7565\u4E3B\u7BA1","greeting":"\u6B22\u8FCE\u6765\u5230\u60A8\u7684\u5B89\u5168\u77E5\u8BC6\u4EA7\u6743\u4EEA\u8868\u677F\u3002\u60A8\u53EF\u4EE5\u5728\u6B64\u67E5\u770B\u5546\u6807\u7533\u8BF7\u7684\u8FDB\u5C55\uFF0C\u5E76\u5728\u6BCF\u4E2A\u73AF\u8282\u8F7B\u677E\u4E0E\u60A8\u6307\u5B9A\u7684\u5546\u6807\u5F8B\u5E08\u4FDD\u6301\u8054\u7CFB\u3002"},"marko":{"analysisComplete":"\u6211\u5DF2\u5206\u6790\u60A8\u7684\u5546\u6807\uFF01\u70B9\u51FB\u67E5\u770B\u6211\u7684\u5EFA\u8BAE\u3002","multiCountry":"\u5728\u591A\u4E2A\u56FD\u5BB6\u7533\u8BF7\uFF1F\u6211\u4F1A\u5E2E\u60A8\u786E\u5B9A\u4F18\u5148\u987A\u5E8F\u3002","thinking":"Marko\u6B63\u5728\u601D\u8003...","askMe":"\u5411\u6211\u54A8\u8BE2\u5546\u6807\u76F8\u5173\u95EE\u9898","clickToChat":"\u70B9\u51FB\u804A\u5929 \u2192"},"application":{"create":"\u521B\u5EFA\u7533\u8BF7","createNew":"\u521B\u5EFA\u65B0\u7533\u8BF7","name":"\u7533\u8BF7\u540D\u79F0","namePlaceholder":"\u4E3A\u60A8\u7684\u5546\u6807\u7533\u8BF7\u547D\u540D","nameHelp":"\u8FD9\u6709\u52A9\u4E8E\u6574\u7406\u60A8\u7684\u77E5\u8BC6\u4EA7\u6743\u7EC4\u5408\u5E76\u8DDF\u8E2A\u7533\u8BF7\u8FDB\u5EA6\u3002","delete":"\u5220\u9664\u7533\u8BF7","deleteConfirm":"\u60A8\u786E\u5B9A\u8981\u5220\u9664\u6B64\u7533\u8BF7\u5417\uFF1F\u6B64\u64CD\u4F5C\u65E0\u6CD5\u64A4\u9500\u3002","status":"\u7533\u8BF7\u72B6\u6001","progress":"\u8FDB\u5EA6"}}');


var $40d30cf332e502da$exports = {};
$40d30cf332e502da$exports = JSON.parse('{"upload":{"title":"\u60A8\u7684\u5546\u6807","subtitle":"\u4E0A\u4F20\u60A8\u7684\u5546\u6807\u56FE\u7247\u6216\u8F93\u5165\u6587\u5B57\u5546\u6807","selectType":"\u54EA\u4E2A\u9009\u9879\u6700\u80FD\u63CF\u8FF0\u60A8\u7684\u5546\u6807\uFF1F","logoTrademark":"\u6807\u5FD7\u5546\u6807","logoDescription":"\u5305\u542B\u6587\u5B57\u7684\u54C1\u724C\u6807\u5FD7","figurativeTrademark":"\u56FE\u5F62\u5546\u6807","figurativeDescription":"\u4E0D\u5305\u542B\u6587\u5B57\u7684\u54C1\u724C\u56FE\u5F62\u5143\u7D20","wordTrademark":"\u6587\u5B57\u5546\u6807","wordDescription":"\u54C1\u724C\u540D\u79F0\u6216\u6807\u8BED","uploadYour":"\u4E0A\u4F20\u60A8\u7684{{type}}\u5546\u6807","dragDrop":"\u5C06\u56FE\u7247\u62D6\u653E\u5230\u6B64\u5904\uFF0C\u6216","browseFiles":"\u6D4F\u89C8\u6587\u4EF6","supportedFormats":"\u652F\u6301\u683C\u5F0F\uFF1APNG\u3001JPG\u3001GIF","enterWordMark":"\u8F93\u5165\u60A8\u7684\u6587\u5B57\u5546\u6807","wordPlaceholder":"\u8F93\u5165\u60A8\u7684\u5546\u6807\u6587\u5B57","uploadWordMark":"\u4E0A\u4F20\u6587\u5B57\u5546\u6807","removeImage":"\u79FB\u9664\u56FE\u7247","uploading":"\u6B63\u5728\u4E0A\u4F20\u5546\u6807...","uploadSuccess":"\u5546\u6807\u4E0A\u4F20\u6210\u529F\uFF01","imageSuccess":"\u56FE\u7247\u5546\u6807\u4E0A\u4F20\u6210\u529F","uploadDifferent":"\u4E0A\u4F20\u5176\u4ED6\u5546\u6807","selectImage":"\u9009\u62E9\u56FE\u7247\u81EA\u52A8\u4E0A\u4F20","uploadError":"\u5546\u6807\u4E0A\u4F20\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u3002"},"analysis":{"title":"AI\u9A71\u52A8\u5206\u6790","subtitle":"\u6211\u4EEC\u7684AI\u5C06\u5206\u6790\u60A8\u7684\u5546\u6807\u7684\u72EC\u7279\u6027\u3001\u6F5C\u5728\u51B2\u7A81\u548C\u6CE8\u518C\u7B56\u7565","readyTitle":"\u51C6\u5907\u8FDB\u884CAI\u9A71\u52A8\u7684\u5546\u6807\u5206\u6790","readySubtitle":"\u6211\u4EEC\u7684AI\u5C06\u5206\u6790\u60A8\u7684\u5546\u6807\u7684\u72EC\u7279\u6027\u3001\u6F5C\u5728\u51B2\u7A81\u548C\u6CE8\u518C\u7B56\u7565","yourTrademark":"\u60A8\u7684\u5546\u6807","trademarkRequired":"\u9700\u8981\u5546\u6807","businessProfile":"\u4F01\u4E1A\u8D44\u6599","businessRequired":"\u9700\u8981\u4F01\u4E1A\u8D44\u6599","trademarkName":"\u5546\u6807\u540D\u79F0","trademarkNameDesc":"\u8FD9\u662F\u5C06\u5728\u60A8\u7684\u5546\u6807\u6CE8\u518C\u4E0B\u53D7\u4FDD\u62A4\u7684\u540D\u79F0\u6216\u6587\u5B57","trademarkType":"\u5546\u6807\u7C7B\u578B","logoTypeDesc":"\u4EE3\u8868\u60A8\u54C1\u724C\u7684\u89C6\u89C9\u8BBE\u8BA1\u6216\u6807\u5FD7","wordTypeDesc":"\u6807\u8BC6\u60A8\u5546\u54C1\u6216\u670D\u52A1\u7684\u8BCD\u8BED\u6216\u77ED\u8BED","detailedDescription":"\u8BE6\u7EC6\u63CF\u8FF0","trademarkDescription":"\u5546\u6807\u63CF\u8FF0","viewDescription":"\u67E5\u770B\u8BE6\u7EC6\u5546\u6807\u63CF\u8FF0","descriptionHelp":"\u6B64\u63CF\u8FF0\u5E2E\u52A9\u6211\u4EEC\u7684AI\u7406\u89E3\u60A8\u5546\u6807\u7684\u89C6\u89C9\u548C\u6982\u5FF5\u5143\u7D20","descRequired":"\u9700\u8981\u63CF\u8FF0","descRequiredMsg":"\u8BF7\u6DFB\u52A0\u5546\u6807\u7684\u8BE6\u7EC6\u63CF\u8FF0\u4EE5\u7EE7\u7EED\u5206\u6790","descRequiredHelp":"\u597D\u7684\u63CF\u8FF0\u5305\u62EC\u989C\u8272\u3001\u8BBE\u8BA1\u5143\u7D20\u3001\u5B57\u4F53\u548C\u6574\u4F53\u5916\u89C2","noTrademark":"\u672A\u9009\u62E9\u5546\u6807","noTrademarkMsg":"\u8BF7\u5148\u5B8C\u6210\u5546\u6807\u4E0A\u4F20\u6B65\u9AA4","noTrademarkHelp":"\u60A8\u9700\u8981\u5148\u4E0A\u4F20\u5546\u6807\u624D\u80FD\u8FDB\u884C\u5206\u6790","readyToAnalyse":"\u51C6\u5907\u5206\u6790","analyseButton":"\u5206\u6790\u6211\u7684\u5546\u6807","analysing":"\u6B63\u5728\u5206\u6790\u60A8\u7684\u5546\u6807...","analysisComplete":"\u5206\u6790\u5B8C\u6210","viewReport":"\u67E5\u770B\u5B8C\u6574\u62A5\u544A","overallScore":"\u7EFC\u5408\u8BC4\u5206","distinctiveness":"\u72EC\u7279\u6027","conflictRisk":"\u51B2\u7A81\u98CE\u9669","registrability":"\u53EF\u6CE8\u518C\u6027","recommendations":"\u5EFA\u8BAE","potentialConflicts":"\u6F5C\u5728\u51B2\u7A81","noConflicts":"\u672A\u53D1\u73B0\u91CD\u5927\u51B2\u7A81","needsUpload":"\u60A8\u9700\u8981\u5148\u4E0A\u4F20\u5546\u6807\u624D\u80FD\u8FDB\u884C\u5206\u6790","classRecommendations":"\u7C7B\u522B\u5EFA\u8BAE","suggestedClasses":"\u5EFA\u8BAE\u7684\u5C3C\u65AF\u5206\u7C7B"},"business":{"title":"\u4F01\u4E1A\u4FE1\u606F","complete":"\u4F01\u4E1A\u4FE1\u606F\u5DF2\u5B8C\u6210","completeDescription":"\u60A8\u7684\u4F01\u4E1A\u4FE1\u606F\u5DF2\u6210\u529F\u4FDD\u5B58\uFF0C\u5C06\u7528\u4E8E\u63D0\u4F9B\u51C6\u786E\u7684\u5546\u6807\u5EFA\u8BAE\u3002","subtitle":"\u544A\u8BC9\u6211\u4EEC\u60A8\u7684\u4E1A\u52A1\u60C5\u51B5\uFF0C\u4EE5\u4FBFMarko\u63D0\u4F9B\u4E2A\u6027\u5316\u5EFA\u8BAE","ownerType":"\u5546\u6807\u6240\u6709\u4EBA\u7C7B\u578B","individual":"\u4E2A\u4EBA","company":"\u516C\u53F8","partnership":"\u5408\u4F19\u4F01\u4E1A","businessName":"\u4F01\u4E1A\u540D\u79F0","tradingAs":"\u5546\u53F7","registrationNumber":"\u6CE8\u518C\u53F7","industry":"\u884C\u4E1A","selectIndustry":"\u9009\u62E9\u60A8\u7684\u884C\u4E1A","goodsServices":"\u5546\u54C1\u548C\u670D\u52A1","describeGoodsServices":"\u63CF\u8FF0\u60A8\u7684\u5546\u6807\u5C06\u6DB5\u76D6\u7684\u5546\u54C1\u6216\u670D\u52A1","markoAnalyse":"Marko\u4F1A\u5728\u60A8\u8F93\u5165\u65F6\u5206\u6790\u60A8\u7684\u4FE1\u606F\u3002","analysed":"\u6211\u5DF2\u5206\u6790\u60A8\u7684\u5546\u6807"},"classes":{"title":"\u5C3C\u65AF\u5206\u7C7B","subtitle":"\u9009\u62E9\u6700\u80FD\u63CF\u8FF0\u60A8\u7684\u5546\u54C1\u548C\u670D\u52A1\u7684\u7C7B\u522B","selectedClasses":"\u5DF2\u9009\u7C7B\u522B","noClassesSelected":"\u672A\u9009\u62E9\u7C7B\u522B","addClass":"\u6DFB\u52A0\u7C7B\u522B","removeClass":"\u79FB\u9664\u7C7B\u522B","searchClasses":"\u641C\u7D22\u7C7B\u522B...","classNumber":"\u7B2C{{number}}\u7C7B","viewDetails":"\u67E5\u770B\u7C7B\u522B\u8BE6\u60C5"}}');


var $1e2b0030f271b92b$exports = {};
$1e2b0030f271b92b$exports = JSON.parse('{"title":"\u652F\u4ED8","subtitle":"\u5B8C\u6210\u60A8\u7684\u5546\u6807\u6CE8\u518C\u4ED8\u6B3E","summary":{"title":"\u8BA2\u5355\u6458\u8981","countries":"\u5DF2\u9009\u56FD\u5BB6","classes":"\u5C3C\u65AF\u5206\u7C7B","subtotal":"\u5C0F\u8BA1","governmentFees":"\u653F\u5E9C\u8D39\u7528","serviceFee":"\u670D\u52A1\u8D39","total":"\u603B\u8BA1","taxNote":"\u4EF7\u683C\u5305\u542B\u9002\u7528\u7A0E\u8D39"},"methods":{"title":"\u652F\u4ED8\u65B9\u5F0F","card":"\u4FE1\u7528\u5361/\u501F\u8BB0\u5361","cardNumber":"\u5361\u53F7","expiry":"\u6709\u6548\u671F","cvc":"\u5B89\u5168\u7801","nameOnCard":"\u6301\u5361\u4EBA\u59D3\u540D","secure":"\u5B89\u5168\u652F\u4ED8","stripeTitle":"Stripe\u5B89\u5168\u7ED3\u8D26","stripeDesc":"\u60A8\u7684\u4ED8\u6B3E\u901A\u8FC7Stripe\u5B89\u5168\u5904\u7406\u3002\u6211\u4EEC\u4ECE\u4E0D\u5B58\u50A8\u60A8\u7684\u4FE1\u7528\u5361\u4FE1\u606F\u3002","ssl":"256\u4F4DSSL\u52A0\u5BC6","pci":"\u7B26\u5408PCI DSS\u6807\u51C6","cards":"\u63A5\u53D7\u6240\u6709\u4E3B\u6D41\u4FE1\u7528\u5361"},"status":{"processing":"\u6B63\u5728\u5904\u7406\u652F\u4ED8...","success":"\u652F\u4ED8\u6210\u529F\uFF01","failed":"\u652F\u4ED8\u5931\u8D25","tryAgain":"\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u3002","pending":"\u652F\u4ED8\u5F85\u5904\u7406","refunded":"\u5DF2\u9000\u6B3E"},"confirmation":{"title":"\u652F\u4ED8\u5DF2\u786E\u8BA4","thankYou":"\u611F\u8C22\u60A8\u7684\u4ED8\u6B3E\uFF01","receiptSent":"\u6536\u636E\u5DF2\u53D1\u9001\u81F3{{email}}","nextSteps":"\u540E\u7EED\u6B65\u9AA4","applicationSubmitted":"\u60A8\u7684\u5546\u6807\u7533\u8BF7\u5DF2\u63D0\u4EA4\u5904\u7406\u3002","viewStatus":"\u67E5\u770B\u7533\u8BF7\u72B6\u6001","downloadReceipt":"\u4E0B\u8F7D\u6536\u636E"},"buttons":{"pay":"\u652F\u4ED8{{amount}}","payNow":"\u7ACB\u5373\u652F\u4ED8","reviewOrder":"\u67E5\u770B\u8BA2\u5355","proceedToPayment":"\u524D\u5F80\u652F\u4ED8","payAmount":"\u652F\u4ED8${{amount}} - \u524D\u5F80\u5B89\u5168\u7ED3\u8D26","agreeTerms":"\u6211\u540C\u610F","terms":"\u670D\u52A1\u6761\u6B3E","and":"\u548C","privacy":"\u9690\u79C1\u653F\u7B56"}}');


var $aa20d60493dda8d4$exports = {};
$aa20d60493dda8d4$exports = JSON.parse('{"attorney":{"header":{"title":"\u5F8B\u5E08\u4EEA\u8868\u677F"},"nav":{"filingQueue":"\u7533\u62A5\u961F\u5217","approvalQueue":"\u5BA1\u6279\u961F\u5217","clients":"\u6211\u7684\u5BA2\u6237","correspondence":"\u5F80\u6765\u4FE1\u4EF6","deadlines":"\u622A\u6B62\u65E5\u671F","jurisdictions":"\u7BA1\u8F96\u533A\u57DF","assignments":"\u7BA1\u7406\u5206\u914D","backToDashboard":"\u8FD4\u56DE\u4EEA\u8868\u677F"},"filingQueue":{"title":"\u7533\u62A5\u961F\u5217","loading":"\u6B63\u5728\u52A0\u8F7D\u7533\u62A5\u961F\u5217...","error":"\u52A0\u8F7D\u7533\u62A5\u961F\u5217\u65F6\u51FA\u9519","empty":"\u961F\u5217\u4E2D\u6CA1\u6709\u7533\u62A5","allCountries":"\u6240\u6709\u56FD\u5BB6","allStatuses":"\u6240\u6709\u72B6\u6001","statusPending":"\u5F85\u5904\u7406","statusFiled":"\u5DF2\u63D0\u4EA4","refresh":"\u5237\u65B0"},"filingCard":{"allFiled":"\u5168\u90E8\u5DF2\u63D0\u4EA4","partiallyFiled":"\u8FDB\u884C\u4E2D","pending":"\u5F85\u5904\u7406","client":"\u5BA2\u6237","classes":"\u7C7B\u522B","country":"\u56FD\u5BB6","status":"\u72B6\u6001","ipOfficeRef":"\u77E5\u8BC6\u4EA7\u6743\u5C40\u7F16\u53F7","actions":"\u64CD\u4F5C","jurisdictionsFiled":"\u4E2A\u7BA1\u8F96\u533A\u5DF2\u63D0\u4EA4"},"jurisdiction":{"pending":"\u5F85\u5904\u7406","filed":"\u5DF2\u63D0\u4EA4","accepted":"\u5DF2\u63A5\u53D7","registered":"\u5DF2\u6CE8\u518C","rejected":"\u5DF2\u62D2\u7EDD","fileNow":"\u7ACB\u5373\u63D0\u4EA4","viewDocs":"\u67E5\u770B\u6587\u6863","view":"\u67E5\u770B","editRef":"\u7F16\u8F91\u7F16\u53F7"},"fileNowModal":{"title":"\u5728{{country}}\u63D0\u4EA4","applicationRef":"\u7533\u8BF7\u7F16\u53F7","useReference":"\u5728\u6240\u6709\u77E5\u8BC6\u4EA7\u6743\u5C40\u8868\u683C\u4E2D\u4F7F\u7528\u6B64\u7F16\u53F7\uFF1A","copy":"\u590D\u5236","copied":"\u5DF2\u590D\u5236\uFF01","ipOfficePortal":"\u77E5\u8BC6\u4EA7\u6743\u5C40\u95E8\u6237","openPortal":"\u6253\u5F00\u95E8\u6237","instructions":"\u64CD\u4F5C\u8BF4\u660E","step1":"\u767B\u5F55{{office}}\u95E8\u6237","step2":"\u5F00\u59CB\u65B0\u7684\u5546\u6807\u7533\u8BF7","step3":"\u5728\u300C\u60A8\u7684\u7F16\u53F7\u300D\u5B57\u6BB5\u4E2D\u8F93\u5165\u300C{{appId}}\u300D","step4":"\u4E0A\u4F20\u751F\u6210\u7684\u7533\u62A5\u6587\u4EF6","step5":"\u5728\u77E5\u8BC6\u4EA7\u6743\u5C40\u5B8C\u6210\u4ED8\u6B3E","step6":"\u8BB0\u5F55{{office}}\u7684\u53C2\u8003\u7F16\u53F7","documents":"\u6587\u6863","afterFiling":"\u63D0\u4EA4\u540E\uFF0C\u8F93\u5165\u77E5\u8BC6\u4EA7\u6743\u5C40\u7684\u53C2\u8003\u7F16\u53F7\uFF1A","cancel":"\u53D6\u6D88","markAsFiled":"\u6807\u8BB0\u4E3A\u5DF2\u63D0\u4EA4","marking":"\u6B63\u5728\u6807\u8BB0..."},"approvalQueue":{"title":"\u5BA1\u6279\u961F\u5217","loading":"\u6B63\u5728\u52A0\u8F7D\u5BA1\u6279\u961F\u5217...","error":"\u52A0\u8F7D\u5BA1\u6279\u961F\u5217\u65F6\u51FA\u9519","empty":"\u6CA1\u6709\u7B49\u5F85\u5BA1\u6279\u7684\u4EFB\u52A1","allTypes":"\u6240\u6709\u7C7B\u578B","officeAction":"\u5B98\u65B9\u901A\u77E5\u56DE\u590D","opposition":"\u5F02\u8BAE\u56DE\u590D","renewal":"\u7EED\u5C55\u7533\u8BF7","refresh":"\u5237\u65B0"},"approvalCard":{"officeAction":"\u5B98\u65B9\u901A\u77E5\u56DE\u590D","opposition":"\u5F02\u8BAE\u56DE\u590D","renewal":"\u7EED\u5C55\u7533\u8BF7","urgent":"\u7D27\u6025","high":"\u9AD8","medium":"\u4E2D","low":"\u4F4E","successLikelihood":"\u6210\u529F\u53EF\u80FD\u6027","noSummary":"\u65E0\u53EF\u7528\u6458\u8981","daysLeft":"\u5269\u4F59{{days}}\u5929","overdue":"\u5DF2\u8FC7\u671F\uFF01","review":"\u5BA1\u6838\u8349\u7A3F"},"draftReview":{"title":"\u5BA1\u6838AI\u8349\u7A3F","summary":"\u6458\u8981","estimatedSuccess":"\u9884\u4F30\u6210\u529F\u7387","keyArguments":"\u5173\u952E\u8BBA\u70B9","similarCases":"\u53C2\u8003\u7684\u7C7B\u4F3C\u6848\u4F8B","draftContent":"\u8349\u7A3F\u5185\u5BB9","view":"\u67E5\u770B","edit":"\u7F16\u8F91","editPlaceholder":"\u7F16\u8F91\u8349\u7A3F...","rejectReason":"\u62D2\u7EDD\u539F\u56E0","rejectPlaceholder":"\u8BF4\u660E\u62D2\u7EDD\u6B64\u8349\u7A3F\u7684\u539F\u56E0...","back":"\u8FD4\u56DE","reject":"\u62D2\u7EDD","confirmReject":"\u786E\u8BA4\u62D2\u7EDD","rejecting":"\u6B63\u5728\u62D2\u7EDD...","approve":"\u6279\u51C6","approveWithChanges":"\u6279\u51C6\u5E76\u4FEE\u6539","approving":"\u6B63\u5728\u6279\u51C6..."}}}');


var $8a100cb7965c71c1$exports = {};
$8a100cb7965c71c1$exports = JSON.parse('{"notifications":{"title":"\u901A\u77E5","markAllRead":"\u5168\u90E8\u6807\u4E3A\u5DF2\u8BFB","viewAll":"\u67E5\u770B\u6240\u6709\u901A\u77E5","empty":"\u6CA1\u6709\u901A\u77E5","emptyDescription":"\u60A8\u5DF2\u5168\u90E8\u4E86\u89E3\uFF01","new":"\u65B0","today":"\u4ECA\u5929","yesterday":"\u6628\u5929","earlier":"\u66F4\u65E9","justNow":"\u521A\u521A","minutesAgo":"{{count}}\u5206\u949F\u524D","minutesAgo_plural":"{{count}}\u5206\u949F\u524D","hoursAgo":"{{count}}\u5C0F\u65F6\u524D","hoursAgo_plural":"{{count}}\u5C0F\u65F6\u524D","daysAgo":"{{count}}\u5929\u524D","daysAgo_plural":"{{count}}\u5929\u524D","categories":{"status_change":"\u72B6\u6001\u66F4\u65B0","correspondence":"\u5F80\u6765\u4FE1\u4EF6","deadline":"\u622A\u6B62\u65E5\u671F","approval_needed":"\u9700\u8981\u5BA1\u6279","filing_complete":"\u7533\u62A5\u5B8C\u6210","new_filing":"\u65B0\u7533\u62A5","office_action":"\u5B98\u65B9\u901A\u77E5","system":"\u7CFB\u7EDF"},"urgency":{"low":"\u4F4E","medium":"\u4E2D","high":"\u9AD8","critical":"\u7D27\u6025"},"actions":{"view":"\u67E5\u770B","dismiss":"\u5FFD\u7565","markRead":"\u6807\u4E3A\u5DF2\u8BFB"}}}');


(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).init({
    resources: {
        en: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($eb5ecdf737dc9de6$exports))),
            dashboard: (0, (/*@__PURE__*/$parcel$interopDefault($14a2bf24f626d959$exports))),
            trademark: (0, (/*@__PURE__*/$parcel$interopDefault($af97b3988b6ba46c$exports))),
            payment: (0, (/*@__PURE__*/$parcel$interopDefault($57a6497ce12eaa72$exports))),
            attorney: (0, (/*@__PURE__*/$parcel$interopDefault($0ed43b940ffab8e5$exports))),
            notifications: (0, (/*@__PURE__*/$parcel$interopDefault($8e3f93ea3216cf21$exports)))
        },
        es: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($218087a50620c012$exports))),
            dashboard: (0, (/*@__PURE__*/$parcel$interopDefault($63cdd656a11131a5$exports))),
            trademark: (0, (/*@__PURE__*/$parcel$interopDefault($01ecfdd02617fc9e$exports))),
            payment: (0, (/*@__PURE__*/$parcel$interopDefault($b7e252cd4df25524$exports))),
            attorney: (0, (/*@__PURE__*/$parcel$interopDefault($cb3e156155c1f6ea$exports))),
            notifications: (0, (/*@__PURE__*/$parcel$interopDefault($7136658354ea3e09$exports)))
        },
        de: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($e38949a8072d2fa2$exports))),
            dashboard: (0, (/*@__PURE__*/$parcel$interopDefault($fa8265a128182669$exports))),
            trademark: (0, (/*@__PURE__*/$parcel$interopDefault($982f81968710d651$exports))),
            payment: (0, (/*@__PURE__*/$parcel$interopDefault($b515faada0e05d26$exports))),
            attorney: (0, (/*@__PURE__*/$parcel$interopDefault($75452841b0fac32b$exports))),
            notifications: (0, (/*@__PURE__*/$parcel$interopDefault($90e39169afa8a9d1$exports)))
        },
        zh: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($21418db4c4686a83$exports))),
            dashboard: (0, (/*@__PURE__*/$parcel$interopDefault($c694897d1c409d27$exports))),
            trademark: (0, (/*@__PURE__*/$parcel$interopDefault($40d30cf332e502da$exports))),
            payment: (0, (/*@__PURE__*/$parcel$interopDefault($1e2b0030f271b92b$exports))),
            attorney: (0, (/*@__PURE__*/$parcel$interopDefault($aa20d60493dda8d4$exports))),
            notifications: (0, (/*@__PURE__*/$parcel$interopDefault($8a100cb7965c71c1$exports)))
        }
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: [
            'localStorage',
            'navigator'
        ],
        caches: [
            'localStorage'
        ],
        lookupLocalStorage: 'i18nextLng'
    }
});
var $53cebf01a6481b81$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LoaderCircle", $39f04136db3724b2$export$3efd853dbb351e94);


var $2110bf72a86f956f$var$RELEASE_TRAIN = 'basil';
var $2110bf72a86f956f$var$runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var $2110bf72a86f956f$var$ORIGIN = 'https://js.stripe.com';
var $2110bf72a86f956f$var$STRIPE_JS_URL = "".concat($2110bf72a86f956f$var$ORIGIN, "/").concat($2110bf72a86f956f$var$RELEASE_TRAIN, "/stripe.js");
var $2110bf72a86f956f$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $2110bf72a86f956f$var$STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var $2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $2110bf72a86f956f$var$isStripeJSURL = function isStripeJSURL(url) {
    return $2110bf72a86f956f$var$V3_URL_REGEX.test(url) || $2110bf72a86f956f$var$STRIPE_JS_URL_REGEX.test(url);
};
var $2110bf72a86f956f$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($2110bf72a86f956f$var$ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$2110bf72a86f956f$var$isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var $2110bf72a86f956f$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($2110bf72a86f956f$var$STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $2110bf72a86f956f$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "7.4.0",
        startTime: startTime
    });
};
var $2110bf72a86f956f$var$stripePromise$1 = null;
var $2110bf72a86f956f$var$onErrorListener = null;
var $2110bf72a86f956f$var$onLoadListener = null;
var $2110bf72a86f956f$var$onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var $2110bf72a86f956f$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $2110bf72a86f956f$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($2110bf72a86f956f$var$stripePromise$1 !== null) return $2110bf72a86f956f$var$stripePromise$1;
    $2110bf72a86f956f$var$stripePromise$1 = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $2110bf72a86f956f$var$findScript();
            if (script && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $2110bf72a86f956f$var$injectScript(params);
            else if (script && $2110bf72a86f956f$var$onLoadListener !== null && $2110bf72a86f956f$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $2110bf72a86f956f$var$onLoadListener);
                script.removeEventListener('error', $2110bf72a86f956f$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $2110bf72a86f956f$var$injectScript(params);
            }
            $2110bf72a86f956f$var$onLoadListener = $2110bf72a86f956f$var$onLoad(resolve, reject);
            $2110bf72a86f956f$var$onErrorListener = $2110bf72a86f956f$var$onError(reject);
            script.addEventListener('load', $2110bf72a86f956f$var$onLoadListener);
            script.addEventListener('error', $2110bf72a86f956f$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $2110bf72a86f956f$var$stripePromise$1["catch"](function(error) {
        $2110bf72a86f956f$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
};
var $2110bf72a86f956f$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = $2110bf72a86f956f$var$runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = $2110bf72a86f956f$var$RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("7.4.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    $2110bf72a86f956f$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $2110bf72a86f956f$var$stripePromise;
var $2110bf72a86f956f$var$loadCalled = false;
var $2110bf72a86f956f$var$getStripePromise = function getStripePromise() {
    if ($2110bf72a86f956f$var$stripePromise) return $2110bf72a86f956f$var$stripePromise;
    $2110bf72a86f956f$var$stripePromise = $2110bf72a86f956f$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $2110bf72a86f956f$var$stripePromise = null;
        return Promise.reject(error);
    });
    return $2110bf72a86f956f$var$stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $2110bf72a86f956f$var$getStripePromise();
})["catch"](function(error) {
    if (!$2110bf72a86f956f$var$loadCalled) console.warn(error);
});
var $2110bf72a86f956f$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $2110bf72a86f956f$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $2110bf72a86f956f$var$getStripePromise().then(function(maybeStripe) {
        return $2110bf72a86f956f$var$initStripe(maybeStripe, args, startTime);
    });
};




var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "3.7.0"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "3.7.0",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded$1 = [
        "on",
        "session"
    ];
    var CheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CheckoutSdkContext.displayName = 'CheckoutSdkContext';
    var parseCheckoutSdkContext = function parseCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CheckoutProvider> provider."));
        return ctx;
    };
    var CheckoutContext = /*#__PURE__*/ React.createContext(null);
    CheckoutContext.displayName = 'CheckoutContext';
    var extractCheckoutContextValue = function extractCheckoutContextValue(checkoutSdk, sessionState) {
        if (!checkoutSdk) return null;
        checkoutSdk.on;
        checkoutSdk.session;
        var actions = _objectWithoutProperties(checkoutSdk, _excluded$1);
        if (!sessionState) return Object.assign(checkoutSdk.session(), actions);
        return Object.assign(sessionState, actions);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CheckoutProvider = function CheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                checkoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, checkoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.checkoutSdk) return ctx;
                return {
                    stripe: stripe,
                    checkoutSdk: checkoutSdk
                };
            });
        }; // Ref used to avoid calling initCheckout multiple times when options changes
        var initCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCheckoutCalledRef.current = true;
                    stripe.initCheckout(options).then(function(checkoutSdk) {
                        if (checkoutSdk) {
                            safeSetContext(stripe, checkoutSdk);
                            checkoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCheckoutCalledRef.current) {
                initCheckoutCalledRef.current = true;
                parsed.stripe.initCheckout(options).then(function(checkoutSdk) {
                    if (checkoutSdk) {
                        safeSetContext(parsed.stripe, checkoutSdk);
                        checkoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        var prevCheckoutSdk = usePrevious(ctx.checkoutSdk);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            // Ignore changes while checkout sdk is not initialized.
            if (!ctx.checkoutSdk) return;
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            var hasAppearanceChanged = !isEqual(currentAppearance, previousAppearance);
            var hasSdkLoaded = !prevCheckoutSdk && ctx.checkoutSdk;
            if (currentAppearance && (hasAppearanceChanged || hasSdkLoaded)) ctx.checkoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.checkoutSdk,
            prevCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var checkoutContextValue = React.useMemo(function() {
            return extractCheckoutContextValue(ctx.checkoutSdk, session);
        }, [
            ctx.checkoutSdk,
            session
        ]);
        if (!ctx.checkoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CheckoutContext.Provider, {
            value: checkoutContextValue
        }, children));
    };
    CheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            fetchClientSecret: PropTypes.func.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCheckoutSdkContextWithUseCase = function useCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CheckoutSdkContext);
        return parseCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCheckoutSdkContextWithUseCase = function useElementsOrCheckoutSdkContextWithUseCase(useCaseString) {
        var checkoutSdkContext = React.useContext(CheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (checkoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CheckoutProvider> and <Elements> providers."));
        if (checkoutSdkContext) return parseCheckoutSdkContext(checkoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCheckout = function useCheckout() {
        // ensure it's in CheckoutProvider
        useCheckoutSdkContextWithUseCase('calls useCheckout()');
        var ctx = React.useContext(CheckoutContext);
        if (!ctx) throw new Error('Could not find Checkout Context; You need to wrap the part of your app that calls useCheckout() in an <CheckoutProvider> provider.');
        return ctx;
    };
    var _excluded = [
        "mode"
    ];
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var checkoutSdk = 'checkoutSdk' in ctx ? ctx.checkoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                    var newElement = null;
                    if (checkoutSdk) switch(type){
                        case 'payment':
                            newElement = checkoutSdk.createPaymentElement(options);
                            break;
                        case 'address':
                            if ('mode' in options) {
                                var mode = options.mode, restOptions = _objectWithoutProperties(options, _excluded);
                                if (mode === 'shipping') newElement = checkoutSdk.createShippingAddressElement(restOptions);
                                else if (mode === 'billing') newElement = checkoutSdk.createBillingAddressElement(restOptions);
                                else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                            } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                            break;
                        case 'expressCheckout':
                            newElement = checkoutSdk.createExpressCheckoutElement(options);
                            break;
                        case 'currencySelector':
                            newElement = checkoutSdk.createCurrencySelectorElement();
                            break;
                        default:
                            throw new Error("Invalid Element type ".concat(displayName, ". You must use either the <PaymentElement />, <AddressElement options={{mode: 'shipping'}} />, <AddressElement options={{mode: 'billing'}} />, or <ExpressCheckoutElement />."));
                    }
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                checkoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCheckou = useElementsOrCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CheckoutProvider = CheckoutProvider;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCheckout = useCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});



var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




function $b26c3cb173b27338$export$9b0a72d3a81842dd(applicationId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'payment',
            applicationId
        ],
        queryFn: ()=>(0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getApplicationPayment(applicationId),
        enabled: !!applicationId,
        // Retry on 401 since Clerk token might not be ready on first attempt
        retry: (failureCount, error)=>{
            if (error?.response?.status === 401 && failureCount < 3) return true;
            return false;
        },
        retryDelay: (attemptIndex)=>Math.min(1000 * (attemptIndex + 1), 3000)
    });
}
function $b26c3cb173b27338$export$367aefbbe3d98c46(userId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'paymentHistory',
            userId
        ],
        queryFn: ()=>(0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getPaymentHistory(userId),
        enabled: !!userId,
        // Retry on 401 since Clerk token might not be ready on first attempt
        retry: (failureCount, error)=>{
            if (error?.response?.status === 401 && failureCount < 3) return true;
            return false;
        },
        retryDelay: (attemptIndex)=>Math.min(1000 * (attemptIndex + 1), 3000)
    });
}
function $b26c3cb173b27338$export$821b8441ff8e0b28() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (payload)=>(0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).createCheckoutSession(payload),
        onSuccess: (data, variables)=>{
            if (variables?.applicationId) queryClient.invalidateQueries({
                queryKey: [
                    'payment',
                    variables.applicationId
                ]
            });
            if (variables?.userId) queryClient.invalidateQueries({
                queryKey: [
                    'applications',
                    variables.userId
                ]
            });
        }
    });
}
function $b26c3cb173b27338$export$75ea99d8e9e7143c() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ sessionId: sessionId })=>(0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).verifySession(sessionId),
        onSuccess: (data, variables)=>{
            if (variables?.applicationId) queryClient.invalidateQueries({
                queryKey: [
                    'payment',
                    variables.applicationId
                ]
            });
            if (variables?.userId) queryClient.invalidateQueries({
                queryKey: [
                    'applications',
                    variables.userId
                ]
            });
        }
    });
}


function $021a46440bcc72ce$export$95506c204c060a3(error, fallback = 'Unexpected error') {
    if (!error) return null;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message || fallback;
    if (typeof error === 'object') {
        if ('message' in error && typeof error.message === 'string') return error.message;
        try {
            return JSON.stringify(error);
        } catch  {
            return fallback;
        }
    }
    return fallback;
}


const $df0f5973e96e353e$var$PaymentContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $df0f5973e96e353e$var$initialState = {
    status: 'idle',
    error: null,
    // clientSecret is always stored together with the application it was minted
    // for, so a secret can never be adopted by a different application's checkout.
    clientSecret: null,
    clientSecretApplicationId: null
};
function $df0f5973e96e353e$var$reducer(state, action) {
    switch(action.type){
        case 'SET_STATUS':
            return {
                ...state,
                status: action.payload
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload
            };
        case 'SET_CLIENT_SECRET':
            return {
                ...state,
                clientSecret: action.payload.clientSecret,
                clientSecretApplicationId: action.payload.applicationId
            };
        case 'CLEAR_CLIENT_SECRET':
            return {
                ...state,
                clientSecret: null,
                clientSecretApplicationId: null
            };
        case 'RESET':
            return $df0f5973e96e353e$var$initialState;
        default:
            return state;
    }
}
const $df0f5973e96e353e$export$202bc391a3eb96a = ({ children: children })=>{
    const [state, dispatch] = (0, $acw62.useReducer)($df0f5973e96e353e$var$reducer, $df0f5973e96e353e$var$initialState);
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { currentApplicationId: currentApplicationId, refreshApplications: refreshApplications } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const { data: paymentData, isLoading: paymentQueryLoading, isFetching: paymentQueryFetching, error: paymentQueryError, refetch: refetchPayment } = (0, $b26c3cb173b27338$export$9b0a72d3a81842dd)(currentApplicationId);
    const { data: paymentHistoryData, isLoading: paymentHistoryLoading, isFetching: paymentHistoryFetching, refetch: refetchPaymentHistory } = (0, $b26c3cb173b27338$export$367aefbbe3d98c46)(user?.id);
    const createCheckoutSessionMutation = (0, $b26c3cb173b27338$export$821b8441ff8e0b28)();
    const verifyPaymentSessionMutation = (0, $b26c3cb173b27338$export$75ea99d8e9e7143c)();
    const setStatus = (0, $acw62.useCallback)((status)=>dispatch({
            type: 'SET_STATUS',
            payload: status
        }), []);
    const setError = (0, $acw62.useCallback)((message)=>dispatch({
            type: 'SET_ERROR',
            payload: message
        }), []);
    const clearPaymentData = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: 'RESET'
        });
    }, []);
    // Drop any held client secret as soon as the active application changes —
    // a Stripe session minted for one application must never leak into another.
    (0, $acw62.useEffect)(()=>{
        if (state.clientSecret && state.clientSecretApplicationId !== currentApplicationId) dispatch({
            type: 'CLEAR_CLIENT_SECRET'
        });
    }, [
        currentApplicationId,
        state.clientSecret,
        state.clientSecretApplicationId
    ]);
    const createCheckoutSession = (0, $acw62.useCallback)(async (sessionData)=>{
        if (!user?.id || !currentApplicationId) throw new Error('User and application must be selected before starting checkout');
        setStatus('processing');
        setError(null);
        try {
            const response = await createCheckoutSessionMutation.mutateAsync({
                ...sessionData,
                applicationId: currentApplicationId,
                userId: user.id
            });
            if (response?.clientSecret) dispatch({
                type: 'SET_CLIENT_SECRET',
                payload: {
                    clientSecret: response.clientSecret,
                    applicationId: currentApplicationId
                }
            });
            setStatus('completed');
            // Don't await these - let them run in background after checkout is displayed
            // The Stripe webhook will handle the actual payment completion update
            // Refreshing synchronously causes re-renders that disrupt the Stripe checkout
            Promise.all([
                refreshApplications(),
                refetchPayment()
            ]).catch((err)=>{
                console.warn('Background refresh after checkout session creation failed:', err);
            });
            return response;
        } catch (err) {
            const message = (0, $021a46440bcc72ce$export$95506c204c060a3)(err, 'Failed to create checkout session');
            setError(message);
            setStatus('error');
            throw err;
        }
    }, [
        createCheckoutSessionMutation,
        currentApplicationId,
        refetchPayment,
        refreshApplications,
        setError,
        setStatus,
        user?.id
    ]);
    const verifyPaymentSession = (0, $acw62.useCallback)(async (sessionId)=>{
        if (!currentApplicationId || !user?.id) throw new Error('Missing application or user information');
        setStatus('processing');
        setError(null);
        try {
            const response = await verifyPaymentSessionMutation.mutateAsync({
                sessionId: sessionId,
                applicationId: currentApplicationId,
                userId: user.id
            });
            await refreshApplications();
            await refetchPayment();
            await refetchPaymentHistory();
            setStatus('completed');
            return response;
        } catch (err) {
            const message = (0, $021a46440bcc72ce$export$95506c204c060a3)(err, 'Failed to verify payment session');
            setError(message);
            setStatus('error');
            throw err;
        }
    }, [
        currentApplicationId,
        refetchPayment,
        refetchPaymentHistory,
        refreshApplications,
        setError,
        setStatus,
        user?.id,
        verifyPaymentSessionMutation
    ]);
    const loadPaymentHistory = (0, $acw62.useCallback)(async ()=>{
        if (!user?.id) return;
        await refetchPaymentHistory();
    }, [
        refetchPaymentHistory,
        user?.id
    ]);
    const refreshPaymentData = (0, $acw62.useCallback)(async ()=>{
        await refetchPayment();
    }, [
        refetchPayment
    ]);
    const queryErrorMessage = (0, $021a46440bcc72ce$export$95506c204c060a3)(paymentQueryError);
    (0, $acw62.useEffect)(()=>{
        if (queryErrorMessage) {
            if (state.error !== queryErrorMessage) {
                setError(queryErrorMessage);
                setStatus('error');
            }
        } else if (state.error) {
            setError(null);
            if (state.status === 'error') setStatus('idle');
        }
    }, [
        queryErrorMessage,
        setError,
        setStatus,
        state.error,
        state.status
    ]);
    const combinedError = state.error ?? queryErrorMessage ?? null;
    const isBusy = paymentQueryLoading || paymentQueryFetching || paymentHistoryLoading || paymentHistoryFetching || createCheckoutSessionMutation.isPending || verifyPaymentSessionMutation.isPending;
    const value = (0, $acw62.useMemo)(()=>({
            paymentData: paymentData || null,
            paymentHistory: paymentHistoryData || [],
            isLoading: isBusy,
            status: state.status,
            error: combinedError,
            hasError: Boolean(combinedError),
            // Only expose the secret when it belongs to the active application
            clientSecret: state.clientSecretApplicationId === currentApplicationId ? state.clientSecret : null,
            clientSecretApplicationId: state.clientSecretApplicationId,
            createCheckoutSession: createCheckoutSession,
            verifyPaymentSession: verifyPaymentSession,
            loadPaymentHistory: loadPaymentHistory,
            clearPaymentData: clearPaymentData,
            refreshPaymentData: refreshPaymentData,
            hasPayment: !!paymentData,
            isPaid: paymentData?.status === 'paid' || paymentData?.paymentStatus === 'paid',
            isPending: paymentData?.status === 'pending',
            paymentAmount: paymentData?.amount || 0,
            paymentCurrency: paymentData?.currency || 'USD'
        }), [
        clearPaymentData,
        createCheckoutSession,
        createCheckoutSessionMutation.isPending,
        loadPaymentHistory,
        combinedError,
        isBusy,
        paymentData,
        paymentHistoryData,
        refreshPaymentData,
        currentApplicationId,
        state.clientSecret,
        state.clientSecretApplicationId,
        state.error,
        state.status,
        verifyPaymentSession,
        verifyPaymentSessionMutation.isPending
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($df0f5973e96e353e$var$PaymentContext.Provider, {
        value: value,
        children: children
    });
};
const $df0f5973e96e353e$export$9906a9e4771cbdf1 = ()=>{
    const context = (0, $acw62.useContext)($df0f5973e96e353e$var$PaymentContext);
    if (!context) throw new Error('usePaymentContext must be used within a PaymentProvider');
    return context;
};
var $df0f5973e96e353e$export$2e2bcd8739ae039 = $df0f5973e96e353e$export$202bc391a3eb96a;





async function $9595828c9f2a4e5d$var$postPricing(applicationId, data, userId) {
    const authUserId = userId || (0, $d772b9961fd001e4$export$1617268687ac763c)();
    if (!authUserId) throw new Error('User not authenticated');
    if (!applicationId) throw new Error('Application ID is required');
    // Send data flat - don't wrap in preferences key
    // Include id if present for updates
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/pricing', {
        id: data.id,
        applicationId: applicationId,
        ...data,
        userId: authUserId
    });
    return response.data;
}
async function $9595828c9f2a4e5d$var$fetchPricingByApplication(applicationId) {
    if (!applicationId) throw new Error('Application ID is required');
    try {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/pricing', {
            params: {
                applicationId: applicationId
            }
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) return null;
        throw error;
    }
}
const $9595828c9f2a4e5d$export$491c434587fdd454 = {
    /**
   * Save pricing preferences to the database
   */ savePricingPreferences: async (preferences, userId = null)=>{
        try {
            const { applicationId: applicationId, userId: ignoredUserId, ...data } = preferences;
            // Keep id in data for updates
            return await $9595828c9f2a4e5d$var$postPricing(applicationId, data, userId);
        } catch (error) {
            console.error('Error saving pricing preferences:', error);
            throw error;
        }
    },
    /**
   * Update pricing preferences for an application
   */ update: async (applicationId, data, userId = null)=>{
        try {
            return await $9595828c9f2a4e5d$var$postPricing(applicationId, data, userId);
        } catch (error) {
            console.error('Error updating pricing preferences:', error);
            throw error;
        }
    },
    /**
   * Get saved pricing preferences for a user
   */ getPricingPreferences: async (userId = null)=>{
        try {
            const authUserId = userId || (0, $d772b9961fd001e4$export$1617268687ac763c)();
            if (!authUserId) throw new Error('User not authenticated');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/pricing', {
                params: {
                    userId: authUserId
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error getting pricing preferences:', error);
            throw error;
        }
    },
    /**
   * Get pricing preferences by direct pricingId (CANONICAL PATTERN)
   */ getById: async (pricingId)=>{
        try {
            if (!pricingId) return null;
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/pricing/${pricingId}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 404) return null;
            console.error('Error fetching pricing preferences by ID:', error);
            throw error;
        }
    },
    /**
   * Get saved pricing preferences by application ID (LEGACY METHOD - TO BE DEPRECATED)
   */ getPricingPreferencesByApplicationId: async (applicationId)=>{
        try {
            return await $9595828c9f2a4e5d$var$fetchPricingByApplication(applicationId);
        } catch (error) {
            console.error('Error getting pricing preferences by applicationId:', error);
            throw error;
        }
    },
    /**
   * Canonical helper for application lookup
   */ getByApplicationId: async (applicationId)=>{
        try {
            return await $9595828c9f2a4e5d$var$fetchPricingByApplication(applicationId);
        } catch (error) {
            console.error('Error fetching pricing by applicationId:', error);
            throw error;
        }
    }
};
var $9595828c9f2a4e5d$export$2e2bcd8739ae039 = $9595828c9f2a4e5d$export$491c434587fdd454;


function $fc365aecf7cdcb03$export$1afbd6db87ead9a4(applicationId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'pricing',
            applicationId
        ],
        queryFn: ()=>(0, $9595828c9f2a4e5d$export$491c434587fdd454).getByApplicationId(applicationId),
        enabled: !!applicationId
    });
}
function $fc365aecf7cdcb03$export$dce29b72a05b857() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, data: data })=>(0, $9595828c9f2a4e5d$export$491c434587fdd454).update(applicationId, data),
        onSuccess: (_, { applicationId: applicationId })=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'pricing',
                    applicationId
                ]
            });
        }
    });
}


/**
 * Declaration Query Hooks
 * TanStack Query hooks for POA and Declaration operations
 */ 
/**
 * Declaration Service
 * Handles POA and Declaration API operations for trademark applications
 */ 
/**
 * Get declaration by application ID
 * @param {string} applicationId - The application ID
 * @returns {object|null} Declaration data or null if not found
 */ async function $d0f33224e8c08ff8$var$getDeclarationByApplication(applicationId) {
    if (!applicationId) throw new Error('Application ID is required');
    try {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/declaration', {
            params: {
                applicationId: applicationId
            }
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) return null;
        throw error;
    }
}
/**
 * Save declaration (POA + Declaration signatures)
 * @param {string} applicationId - The application ID
 * @param {object} data - Declaration data including signatures
 * @returns {object} Saved declaration data
 */ async function $d0f33224e8c08ff8$var$saveDeclaration(applicationId, data) {
    if (!applicationId) throw new Error('Application ID is required');
    // Send data flat with applicationId
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/declaration', {
        id: data.id,
        applicationId: applicationId,
        ...data
    });
    return response.data;
}
const $d0f33224e8c08ff8$export$26e2ea4105c375b1 = {
    /**
   * Get declaration for an application
   */ getByApplication: $d0f33224e8c08ff8$var$getDeclarationByApplication,
    /**
   * Save declaration (creates or updates)
   */ save: $d0f33224e8c08ff8$var$saveDeclaration,
    saveDeclaration: /**
   * Alias for save
   */ $d0f33224e8c08ff8$var$saveDeclaration
};
var $d0f33224e8c08ff8$export$2e2bcd8739ae039 = $d0f33224e8c08ff8$export$26e2ea4105c375b1;


function $1e32eae54241321e$export$59a5292a95405cc(applicationId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'declaration',
            applicationId
        ],
        queryFn: ()=>(0, $d0f33224e8c08ff8$export$26e2ea4105c375b1).getByApplication(applicationId),
        enabled: !!applicationId,
        // Retry on 401 (auth timing), but not on 404 (no declaration yet is valid)
        retry: (failureCount, error)=>{
            if (error?.response?.status === 401 && failureCount < 3) return true;
            return false;
        },
        retryDelay: (attemptIndex)=>Math.min(1000 * (attemptIndex + 1), 3000)
    });
}
function $1e32eae54241321e$export$ba4f97c67c0692ad() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, data: data })=>(0, $d0f33224e8c08ff8$export$26e2ea4105c375b1).save(applicationId, data),
        onSuccess: (_, { applicationId: applicationId })=>{
            // Invalidate declaration query to refetch
            queryClient.invalidateQueries({
                queryKey: [
                    'declaration',
                    applicationId
                ]
            });
            // Also invalidate applications to update declarationId link
            queryClient.invalidateQueries({
                queryKey: [
                    'applications'
                ]
            });
        }
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $a67c2ce7b4a11aa3$var$JURISDICTION_FLAGS = {
    AU: '\uD83C\uDDE6\uD83C\uDDFA',
    US: '\uD83C\uDDFA\uD83C\uDDF8',
    EU: '\uD83C\uDDEA\uD83C\uDDFA',
    UK: '\uD83C\uDDEC\uD83C\uDDE7',
    NZ: '\uD83C\uDDF3\uD83C\uDDFF',
    CA: '\uD83C\uDDE8\uD83C\uDDE6',
    SG: '\uD83C\uDDF8\uD83C\uDDEC',
    JP: '\uD83C\uDDEF\uD83C\uDDF5',
    CN: '\uD83C\uDDE8\uD83C\uDDF3',
    KR: '\uD83C\uDDF0\uD83C\uDDF7',
    IN: '\uD83C\uDDEE\uD83C\uDDF3',
    BR: '\uD83C\uDDE7\uD83C\uDDF7',
    MX: '\uD83C\uDDF2\uD83C\uDDFD'
};
const $a67c2ce7b4a11aa3$var$JURISDICTION_NAMES = {
    AU: 'Australia',
    US: 'United States',
    EU: 'European Union',
    UK: 'United Kingdom',
    NZ: 'New Zealand',
    CA: 'Canada',
    SG: 'Singapore',
    JP: 'Japan',
    CN: 'China',
    KR: 'South Korea',
    IN: 'India',
    BR: 'Brazil',
    MX: 'Mexico'
};
function $a67c2ce7b4a11aa3$var$FilingProgressBar({ filing: filing }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('notifications');
    if (!filing) return null;
    const { jurisdiction: jurisdiction, status: status, ipOfficeRef: ipOfficeRef, filedAt: filedAt } = filing;
    const getStatusInfo = ()=>{
        switch(status){
            case 'registered':
                return {
                    icon: '\u2713',
                    text: t('filingStatus.registered', 'Registered'),
                    color: 'success'
                };
            case 'accepted':
                return {
                    icon: '\u2713',
                    text: t('filingStatus.accepted', 'Accepted'),
                    color: 'success'
                };
            case 'filed':
                return {
                    icon: '\u2713',
                    text: t('filingStatus.filed', 'Filed'),
                    color: 'info'
                };
            case 'pending':
                return {
                    icon: '\u23F3',
                    text: t('filingStatus.pending', 'Pending'),
                    color: 'warning'
                };
            case 'rejected':
                return {
                    icon: '\u2717',
                    text: t('filingStatus.rejected', 'Rejected'),
                    color: 'error'
                };
            default:
                return {
                    icon: '\u2022',
                    text: status || t('filingStatus.unknown', 'Unknown'),
                    color: 'default'
                };
        }
    };
    const statusInfo = getStatusInfo();
    const flag = $a67c2ce7b4a11aa3$var$JURISDICTION_FLAGS[jurisdiction] || '\uD83C\uDFF3\uFE0F';
    const name = $a67c2ce7b4a11aa3$var$JURISDICTION_NAMES[jurisdiction] || jurisdiction;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `filing-progress-bar status-${statusInfo.color}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-jurisdiction",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "jurisdiction-flag",
                        children: flag
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "jurisdiction-code",
                        children: jurisdiction
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "jurisdiction-name",
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "filing-status",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: `status-indicator status-${statusInfo.color}`,
                    children: [
                        statusInfo.icon,
                        " ",
                        statusInfo.text
                    ]
                })
            }),
            ipOfficeRef && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-ref",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ref-label",
                        children: [
                            t('filings.refNumber', 'Ref'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ref-value",
                        children: ipOfficeRef
                    })
                ]
            }),
            filedAt && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "filing-date",
                children: new Date(filedAt).toLocaleDateString()
            })
        ]
    });
}
var $a67c2ce7b4a11aa3$export$2e2bcd8739ae039 = $a67c2ce7b4a11aa3$var$FilingProgressBar;



const $af220be3e136bc64$var$STATUS_STEPS = [
    {
        key: 'payment_completed',
        label: 'Payment complete'
    },
    {
        key: 'documents_generated',
        label: 'Documents generated'
    },
    {
        key: 'filing_in_progress',
        label: 'Filing in progress'
    },
    {
        key: 'registered',
        label: 'Registration'
    }
];
function $af220be3e136bc64$var$ApplicationStatusCard({ application: application }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('notifications');
    if (!application) return null;
    const { status: status, filings: filings = [], applicationId: applicationId, trademarkName: trademarkName } = application;
    // Determine which steps are complete based on status
    const getStepStatus = (stepKey)=>{
        const statusMap = {
            'payment_completed': [
                'payment_completed',
                'pending_attorney_filing',
                'filing_in_progress',
                'filed',
                'registered'
            ],
            'documents_generated': [
                'pending_attorney_filing',
                'filing_in_progress',
                'filed',
                'registered'
            ],
            'filing_in_progress': [
                'filing_in_progress',
                'filed',
                'registered'
            ],
            'registered': [
                'registered'
            ]
        };
        const completedStatuses = statusMap[stepKey] || [];
        return completedStatuses.includes(status) ? 'completed' : 'pending';
    };
    // Check if all filings are complete
    const allFilingsComplete = filings.length > 0 && filings.every((f)=>f.status === 'filed' || f.status === 'registered');
    const someFilingsComplete = filings.some((f)=>f.status === 'filed' || f.status === 'registered');
    // Get overall status display
    const getStatusDisplay = ()=>{
        if (status === 'registered' || allFilingsComplete) return {
            text: t('status.registered', 'Registered'),
            color: 'success'
        };
        if (status === 'filing_in_progress' || someFilingsComplete) return {
            text: t('status.filingInProgress', 'Filing in Progress'),
            color: 'warning'
        };
        if (status === 'pending_attorney_filing') return {
            text: t('status.pendingFiling', 'Pending Filing'),
            color: 'info'
        };
        if (status === 'payment_completed') return {
            text: t('status.paymentComplete', 'Payment Complete'),
            color: 'info'
        };
        return {
            text: t('status.inProgress', 'In Progress'),
            color: 'default'
        };
    };
    const statusDisplay = getStatusDisplay();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "application-status-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "application-status-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "application-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "application-id",
                                children: applicationId || application.id?.slice(0, 8)
                            }),
                            trademarkName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "trademark-name",
                                children: trademarkName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `status-badge status-${statusDisplay.color}`,
                        children: statusDisplay.text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "status-progress",
                children: $af220be3e136bc64$var$STATUS_STEPS.map((step, index)=>{
                    const stepStatus = getStepStatus(step.key);
                    const isActive = stepStatus === 'completed';
                    const isCurrent = index === $af220be3e136bc64$var$STATUS_STEPS.findIndex((s)=>getStepStatus(s.key) === 'pending') - 1;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `status-step ${isActive ? 'completed' : ''} ${isCurrent ? 'current' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "step-indicator",
                                children: isActive ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    width: "16",
                                    height: "16",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "step-number",
                                    children: index + 1
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "step-label",
                                children: t(`steps.${step.key}`, step.label)
                            }),
                            index < $af220be3e136bc64$var$STATUS_STEPS.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "step-connector"
                            })
                        ]
                    }, step.key);
                })
            }),
            filings.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filings-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "filings-title",
                        children: t('filings.title', 'Filing Status by Jurisdiction')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "filings-list",
                        children: filings.map((filing, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a67c2ce7b4a11aa3$export$2e2bcd8739ae039), {
                                filing: filing
                            }, filing.jurisdiction || index))
                    })
                ]
            })
        ]
    });
}
var $af220be3e136bc64$export$2e2bcd8739ae039 = $af220be3e136bc64$var$ApplicationStatusCard;





/**
 * PaymentStatusBadge Component
 *
 * Displays payment status with appropriate styling and icons.
 * Ported from IPFiling/Payment (wizard removal) with multi-currency display support.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6e669e1fd7e7ff8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $c6e669e1fd7e7ff8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("RotateCcw", $c6e669e1fd7e7ff8$export$3efd853dbb351e94);



var $2Q0xG = parcelRequire("2Q0xG");
const $74a5c7a7fc417eec$var$ZERO_DECIMAL_CURRENCIES = [
    'JPY',
    'KRW'
];
const $74a5c7a7fc417eec$var$PaymentStatusBadge = ({ paymentStatus: paymentStatus, status: status, amount: amount, currency: currency = 'USD', paymentDate: paymentDate, refundAmount: refundAmount, className: className = '' })=>{
    const getPaymentStatusInfo = ()=>{
        // Check for refund statuses first
        if (status === 'refunded' || paymentStatus === 'refunded') return {
            icon: (0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039),
            text: 'Refund Issued',
            bgColor: 'bg-orange-100',
            textColor: 'text-orange-800',
            iconColor: 'text-orange-600'
        };
        if (status === 'partially_refunded' || paymentStatus === 'partially_refunded') return {
            icon: (0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039),
            text: 'Partial Refund Issued',
            bgColor: 'bg-orange-100',
            textColor: 'text-orange-800',
            iconColor: 'text-orange-600'
        };
        // Check for completed payment using both paymentStatus and overall status
        const isPaymentCompleted = paymentStatus === 'paid' || status === 'payment_completed';
        if (isPaymentCompleted) return {
            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
            text: 'Payment Completed',
            bgColor: 'bg-green-100',
            textColor: 'text-green-800',
            iconColor: 'text-green-600'
        };
        if (paymentStatus === 'pending') return {
            icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
            text: 'Payment Pending',
            bgColor: 'bg-yellow-100',
            textColor: 'text-yellow-800',
            iconColor: 'text-yellow-600'
        };
        if (paymentStatus === 'failed') return {
            icon: (0, $839eea37a960d2b1$export$2e2bcd8739ae039),
            text: 'Payment Failed',
            bgColor: 'bg-red-100',
            textColor: 'text-red-800',
            iconColor: 'text-red-600'
        };
        // Default: No payment yet
        return {
            icon: (0, $5415d98bde6b29f1$export$2e2bcd8739ae039),
            text: 'Payment Required',
            bgColor: 'bg-gray-100',
            textColor: 'text-gray-800',
            iconColor: 'text-gray-600'
        };
    };
    const statusInfo = getPaymentStatusInfo();
    const StatusIcon = statusInfo.icon;
    const formatCurrency = (minorUnits)=>{
        if (!minorUnits) return '';
        const code = (currency || 'USD').toUpperCase();
        const divisor = $74a5c7a7fc417eec$var$ZERO_DECIMAL_CURRENCIES.includes(code) ? 1 : 100;
        try {
            return new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: code
            }).format(minorUnits / divisor);
        } catch (e) {
            return `${(minorUnits / divisor).toFixed(2)} ${code}`;
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `inline-flex items-center px-3 py-2 rounded-lg ${statusInfo.bgColor} ${className}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(StatusIcon, {
                className: `h-4 w-4 mr-2 ${statusInfo.iconColor}`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                        className: `text-sm font-medium ${statusInfo.textColor}`,
                        children: statusInfo.text
                    }),
                    amount && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                        className: `text-xs ${statusInfo.textColor} opacity-75`,
                        children: [
                            refundAmount && (status === 'refunded' || status === 'partially_refunded') ? `${formatCurrency(refundAmount)} refunded of ${formatCurrency(amount)}` : formatCurrency(amount),
                            paymentDate && ` \u{2022} ${formatDate(paymentDate)}`
                        ]
                    })
                ]
            })
        ]
    });
};
var $74a5c7a7fc417eec$export$2e2bcd8739ae039 = $74a5c7a7fc417eec$var$PaymentStatusBadge;


/**
 * PaymentCompletionCard Component
 *
 * Displays payment completion information and next steps.
 * Ported from IPFiling/Payment (wizard removal) with multi-currency display support.
 * Replaces the payment form when payment has been completed (or refunded).
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cab856bf30f1b37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
            key: "q3az6g"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 17.5v-11",
            key: "1jc1ny"
        }
    ]
];
const $cab856bf30f1b37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Receipt", $cab856bf30f1b37f$export$3efd853dbb351e94);



var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");

const $153792c6c913a9fe$var$ZERO_DECIMAL_CURRENCIES = [
    'JPY',
    'KRW'
];
const $153792c6c913a9fe$var$PaymentCompletionCard = ({ application: application, paymentAmount: paymentAmount, paymentCurrency: paymentCurrency = 'USD', paymentDate: paymentDate, isRefunded: isRefunded = false, isPartiallyRefunded: isPartiallyRefunded = false, onViewReceipt: onViewReceipt })=>{
    const formatCurrency = (minorUnits)=>{
        if (!minorUnits) return 'N/A';
        const code = (paymentCurrency || 'USD').toUpperCase();
        const divisor = $153792c6c913a9fe$var$ZERO_DECIMAL_CURRENCIES.includes(code) ? 1 : 100;
        try {
            return new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: code
            }).format(minorUnits / divisor);
        } catch (e) {
            return `${(minorUnits / divisor).toFixed(2)} ${code}`;
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    // Determine card styling and content based on refund status
    const getCardInfo = ()=>{
        if (isRefunded) return {
            cardClass: "border-orange-200 bg-orange-50",
            iconBgClass: "bg-orange-100",
            iconClass: "text-orange-600",
            titleClass: "text-orange-900",
            textClass: "text-orange-700",
            icon: (0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039),
            title: "Refund Issued",
            subtitle: "Your payment has been refunded"
        };
        if (isPartiallyRefunded) return {
            cardClass: "border-orange-200 bg-orange-50",
            iconBgClass: "bg-orange-100",
            iconClass: "text-orange-600",
            titleClass: "text-orange-900",
            textClass: "text-orange-700",
            icon: (0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039),
            title: "Partial Refund Issued",
            subtitle: "A partial refund has been processed"
        };
        // Default: Payment completed
        return {
            cardClass: "border-green-200 bg-green-50",
            iconBgClass: "bg-green-100",
            iconClass: "text-green-600",
            titleClass: "text-green-900",
            textClass: "text-green-700",
            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
            title: "Payment Completed Successfully",
            subtitle: "Your trademark application payment has been processed"
        };
    };
    const cardInfo = getCardInfo();
    const CardIcon = cardInfo.icon;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
        className: cardInfo.cardClass,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                className: "pb-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `p-2 ${cardInfo.iconBgClass} rounded-full`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CardIcon, {
                                        className: `h-6 w-6 ${cardInfo.iconClass}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                            className: cardInfo.titleClass,
                                            children: cardInfo.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: `${cardInfo.textClass} mt-1`,
                                            children: cardInfo.subtitle
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74a5c7a7fc417eec$export$2e2bcd8739ae039), {
                            paymentStatus: application?.paymentStatus,
                            status: application?.status,
                            amount: paymentAmount,
                            currency: paymentCurrency,
                            paymentDate: paymentDate,
                            refundAmount: application?.refundAmount
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-lg p-4 border border-gray-200",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.H3), {
                                className: "text-gray-900 mb-3 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5"
                                    }),
                                    isRefunded || isPartiallyRefunded ? 'Payment & Refund Details' : 'Payment Details'
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-700",
                                                children: "Original Amount"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-lg font-semibold text-gray-900",
                                                children: formatCurrency(paymentAmount)
                                            })
                                        ]
                                    }),
                                    (isRefunded || isPartiallyRefunded) && application?.refundAmount && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-700",
                                                children: "Refund Amount"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-lg font-semibold text-orange-600",
                                                children: formatCurrency(application.refundAmount)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-700",
                                                children: isRefunded || isPartiallyRefunded ? 'Transaction Date' : 'Payment Date'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-lg font-semibold text-gray-900",
                                                children: formatDate(paymentDate)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-700",
                                                children: "Application ID"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-gray-600 font-mono break-all",
                                                children: application?.id || 'N/A'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-700",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: `text-sm font-medium ${isRefunded || isPartiallyRefunded ? 'text-orange-600' : 'text-green-600'}`,
                                                children: isRefunded ? 'Payment Refunded' : isPartiallyRefunded ? 'Partially Refunded' : 'Processing Application'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    onViewReceipt && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-col sm:flex-row gap-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                            onClick: onViewReceipt,
                            variant: "outline",
                            className: "flex items-center gap-2 border-green-300 text-green-700 hover:bg-green-100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                }),
                                "View Receipt"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $153792c6c913a9fe$export$2e2bcd8739ae039 = $153792c6c913a9fe$var$PaymentCompletionCard;


/**
 * DeclarationCard Component
 *
 * Single-checkbox combined declaration for the Payments section (same pattern
 * the guest checkout used): one tick covers Power of Attorney, the accuracy
 * declaration and the Terms/Privacy acceptance, and the signature is
 * auto-filled from the signed-in Clerk user's full name — no typed inputs.
 *
 * Server state via the existing declaration query/mutation hooks (TanStack
 * Query); ticking the box saves immediately. If no declaration record exists
 * (e.g. legacy guest declarations that were not migrated), it is simply
 * collected again here.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $67mnf = parcelRequire("67mnf");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f36710bd138be5d0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleCheck", $f36710bd138be5d0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b33d9013e1e2b0b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ]
];
const $b33d9013e1e2b0b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Pen", $b33d9013e1e2b0b6$export$3efd853dbb351e94);



const $4f634b80d4ecef54$var$DeclarationCard = ({ applicationId: applicationId, declaration: declaration, isLoading: isLoading, signerName: signerName })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const { t: tPayment } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('payment');
    const saveDeclarationMutation = (0, $1e32eae54241321e$export$ba4f97c67c0692ad)();
    const poaProvided = declaration?.poaProvided || false;
    const declarationProvided = declaration?.declarationProvided || false;
    const isCompleted = poaProvided && declarationProvided;
    const isSaving = saveDeclarationMutation.isPending;
    const handleToggle = (0, $acw62.useCallback)(async (event)=>{
        // The declaration is a signed record: it can only be granted here, never
        // un-granted by unticking.
        if (!event.target.checked || isCompleted || isSaving || !applicationId) return;
        const signature = (signerName || '').trim();
        const now = new Date().toISOString();
        try {
            await saveDeclarationMutation.mutateAsync({
                applicationId: applicationId,
                data: {
                    id: declaration?.id,
                    // Power of Attorney
                    poaProvided: true,
                    poaSignature: signature,
                    poaSignedAt: now,
                    poaAcceptedTerms: true,
                    // Declaration
                    declarationProvided: true,
                    declarationSignature: signature,
                    declarationSignedAt: now,
                    declarationAcceptedTerms: true
                }
            });
        } catch (err) {
            console.error('Error saving declaration:', err);
        }
    }, [
        applicationId,
        declaration?.id,
        isCompleted,
        isSaving,
        saveDeclarationMutation,
        signerName
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        className: "border border-gray-200",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "flex items-center justify-center py-8",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 animate-spin text-gray-400 mr-3"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-gray-500",
                    children: t('payments.declaration.loading', "Loading declaration\u2026")
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
        className: isCompleted ? 'border-2 border-emerald-300 bg-emerald-50/30' : 'border-2 border-gray-200',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardHeader), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                        className: "text-lg flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b33d9013e1e2b0b6$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-purple-600"
                            }),
                            t('payments.declaration.title', 'Authorisation & Declaration'),
                            isCompleted && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-emerald-600 ml-auto"
                            })
                        ]
                    }),
                    !isCompleted && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardDescription), {
                        children: t('payments.declaration.subtitle', 'Required before we can file your trademark application on your behalf')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: `flex items-start gap-3 py-1 ${isCompleted ? '' : 'cursor-pointer'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "relative flex-shrink-0 p-2 -m-2 mt-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        checked: isCompleted || isSaving,
                                        onChange: handleToggle,
                                        disabled: isCompleted || isSaving,
                                        className: "h-6 w-6 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded disabled:opacity-70"
                                    }),
                                    isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                        className: "absolute inset-0 m-auto h-4 w-4 animate-spin text-emerald-600"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-sm text-gray-700 leading-relaxed",
                                children: [
                                    t('payments.declaration.combined', 'I confirm I am authorised to file this trade mark, that the information in this application is true and accurate, and I appoint MarkoTM as my agent to file and manage this application on my behalf. I accept the'),
                                    ' ',
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "https://markotm.com/legal/terms-of-service",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-teal-700 hover:underline",
                                        children: tPayment('buttons.terms', 'Terms of Service')
                                    }),
                                    ' ',
                                    tPayment('buttons.and', 'and'),
                                    ' ',
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "https://markotm.com/legal/privacy-policy",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-teal-700 hover:underline",
                                        children: tPayment('buttons.privacy', 'Privacy Policy')
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    isCompleted && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-sm text-gray-700 pl-8",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "font-medium",
                                children: [
                                    t('payments.declaration.signedBy', 'Signed by'),
                                    ":"
                                ]
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-serif italic",
                                children: declaration?.declarationSignature || declaration?.poaSignature || signerName
                            }),
                            declaration?.declarationSignedAt && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-xs text-gray-500 ml-2",
                                children: t('payments.declaration.signedOn', 'on {{date}}', {
                                    date: new Date(declaration.declarationSignedAt).toLocaleDateString()
                                })
                            })
                        ]
                    }),
                    saveDeclarationMutation.isError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: t('payments.declaration.saveError', 'Could not save your declaration. Please try again.')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4f634b80d4ecef54$export$2e2bcd8739ae039 = $4f634b80d4ecef54$var$DeclarationCard;


/**
 * ApplicantDetailsCard — applicant name + postal address capture for the
 * Payments section.
 *
 * The quote-first funnel never collects owner details before payment, but
 * IP Australia requires the applicant's name and postal address to file.
 * This card sits above the declaration and autosaves as the user types
 * (900ms debounce + flush on blur — the same pattern the old guest checkout
 * used), writing the SAME fields that wizard wrote via the applications
 * update endpoint: ownerName + ownerAddress {street, city, state, zip,
 * country} (ownerType preserved, defaulting to 'business'). No new record
 * shapes.
 *
 * Country is fixed to the quote's first country (display-only). The parent
 * receives live { name, complete } updates via onApplicantChange so the
 * quote card's Applicant row and the payment overlay gate can react.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $67mnf = parcelRequire("67mnf");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0740549741641712$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
];
const $0740549741641712$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UserRound", $0740549741641712$export$3efd853dbb351e94);



const $33cbb63f0ed5fdf2$var$AUTOSAVE_DEBOUNCE_MS = 900;
// Same base styling as the shared Input component, with a taller touch
// target (~44px) for mobile
const $33cbb63f0ed5fdf2$var$FIELD_CLASSES = 'block w-full min-h-[44px] rounded-md border-0 px-3 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-teal-600 sm:text-sm sm:leading-6';
const $33cbb63f0ed5fdf2$var$Field = ({ label: label, value: value, onChange: onChange, onBlur: onBlur, name: name, placeholder: placeholder, autoComplete: autoComplete, required: required, optionalHint: optionalHint })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                htmlFor: `applicant-${name}`,
                className: "block text-sm font-medium mb-1 text-gray-900",
                children: [
                    label,
                    required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-red-500 ml-1",
                        children: "*"
                    }),
                    optionalHint && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-gray-400 font-normal ml-1",
                        children: optionalHint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                id: `applicant-${name}`,
                type: "text",
                name: name,
                value: value,
                onChange: onChange,
                onBlur: onBlur,
                placeholder: placeholder,
                autoComplete: autoComplete,
                className: $33cbb63f0ed5fdf2$var$FIELD_CLASSES
            })
        ]
    });
const $33cbb63f0ed5fdf2$var$emptyForm = {
    name: '',
    street: '',
    city: '',
    state: '',
    zip: ''
};
const $33cbb63f0ed5fdf2$var$ApplicantDetailsCard = ({ applicationId: applicationId, application: application, fallbackName: fallbackName, countryName: countryName, onApplicantChange: onApplicantChange })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const updateApplicationMutation = (0, $33dbecf554ae91a9$export$4dc878ec9b0f4ce0)();
    const [form, setForm] = (0, $acw62.useState)($33cbb63f0ed5fdf2$var$emptyForm);
    // 'idle' | 'saving' | 'saved' | 'error'
    const [saveState, setSaveState] = (0, $acw62.useState)('idle');
    const formRef = (0, $acw62.useRef)(form);
    formRef.current = form;
    const dirtyRef = (0, $acw62.useRef)(false);
    const saveTimerRef = (0, $acw62.useRef)(null);
    const saveSeqRef = (0, $acw62.useRef)(0);
    const mutationRef = (0, $acw62.useRef)(updateApplicationMutation);
    mutationRef.current = updateApplicationMutation;
    // Rehydrate from the application record (ownerName/ownerAddress written on a
    // previous visit) or fall back to the Clerk account name, which for
    // quote-flow accounts is exactly the name typed at the end of the wizard.
    // Deliberately NOT businessName: for most visitors that is just the trade
    // mark name again, which is the wrong applicant. The applications query may
    // resolve after mount, so fill any field the user has not typed in yet
    // whenever record data arrives.
    const ownerAddress = application?.ownerAddress;
    (0, $acw62.useEffect)(()=>{
        setForm((prev)=>{
            const next = {
                name: prev.name || application?.ownerName || fallbackName || '',
                street: prev.street || ownerAddress?.street || '',
                city: prev.city || ownerAddress?.city || '',
                state: prev.state || ownerAddress?.state || '',
                zip: prev.zip || ownerAddress?.zip || ''
            };
            const changed = Object.keys(next).some((key)=>next[key] !== prev[key]);
            return changed ? next : prev;
        });
    }, [
        application?.ownerName,
        fallbackName,
        ownerAddress
    ]);
    // Report live to the parent (quote card Applicant row + overlay gating)
    (0, $acw62.useEffect)(()=>{
        if (!onApplicantChange) return;
        onApplicantChange({
            name: form.name.trim(),
            complete: Boolean(form.name.trim() && form.street.trim() && form.city.trim() && form.zip.trim())
        });
    }, [
        form,
        onApplicantChange
    ]);
    const persist = (0, $acw62.useCallback)(async ()=>{
        if (!applicationId) return;
        const snapshot = formRef.current;
        const seq = ++saveSeqRef.current;
        setSaveState('saving');
        try {
            await mutationRef.current.mutateAsync({
                applicationId: applicationId,
                data: {
                    // Preserve an existing ownerType; the quote-first funnel defaults
                    // to business applicants (same field set the old wizard wrote)
                    ownerType: application?.ownerType || 'business',
                    ownerName: snapshot.name.trim(),
                    ownerAddress: {
                        street: snapshot.street.trim(),
                        city: snapshot.city.trim(),
                        state: snapshot.state.trim(),
                        zip: snapshot.zip.trim(),
                        country: countryName || ''
                    }
                }
            });
            if (seq === saveSeqRef.current) {
                dirtyRef.current = false;
                setSaveState('saved');
            }
        } catch (err) {
            console.error('Error saving applicant details:', err);
            if (seq === saveSeqRef.current) setSaveState('error');
        }
    }, [
        applicationId,
        application?.ownerType,
        countryName
    ]);
    const scheduleSave = (0, $acw62.useCallback)(()=>{
        if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
        saveTimerRef.current = setTimeout(()=>{
            saveTimerRef.current = null;
            persist();
        }, $33cbb63f0ed5fdf2$var$AUTOSAVE_DEBOUNCE_MS);
    }, [
        persist
    ]);
    const handleChange = (0, $acw62.useCallback)((field)=>(event)=>{
            const value = event.target.value;
            dirtyRef.current = true;
            setForm((prev)=>({
                    ...prev,
                    [field]: value
                }));
            scheduleSave();
        }, [
        scheduleSave
    ]);
    // Blur flushes a pending debounce immediately so nothing is lost when the
    // user tabs straight down to the declaration / payment
    const handleBlur = (0, $acw62.useCallback)(()=>{
        if (!dirtyRef.current) return;
        if (saveTimerRef.current) {
            clearTimeout(saveTimerRef.current);
            saveTimerRef.current = null;
        }
        persist();
    }, [
        persist
    ]);
    // Flush unsaved edits on unmount (fire-and-forget). Refs keep this a true
    // unmount-only cleanup regardless of persist identity changes.
    const persistRef = (0, $acw62.useRef)(persist);
    persistRef.current = persist;
    (0, $acw62.useEffect)(()=>()=>{
            if (saveTimerRef.current) {
                clearTimeout(saveTimerRef.current);
                saveTimerRef.current = null;
                if (dirtyRef.current) persistRef.current();
            }
        }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
        className: "border-2 border-gray-200",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardHeader), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                        className: "text-lg flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0740549741641712$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-teal-700"
                            }),
                            t('payments.applicantDetails.title', 'Applicant details'),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "ml-auto inline-flex items-center gap-1.5 text-xs font-normal",
                                "aria-live": "polite",
                                children: [
                                    saveState === 'saving' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                className: "h-3.5 w-3.5 animate-spin text-gray-400"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-gray-500",
                                                children: t('payments.applicantDetails.saving', "Saving\u2026")
                                            })
                                        ]
                                    }),
                                    saveState === 'saved' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                className: "h-3.5 w-3.5 text-emerald-600"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-emerald-700",
                                                children: t('payments.applicantDetails.saved', 'Saved')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardDescription), {
                        children: t('payments.applicantDetails.subtitle', "The trade mark will be registered in this name. The trade mark office requires the applicant\u2019s name and postal address to file.")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($33cbb63f0ed5fdf2$var$Field, {
                        label: t('payments.applicantDetails.nameLabel', 'Applicant name'),
                        name: "name",
                        value: form.name,
                        onChange: handleChange('name'),
                        onBlur: handleBlur,
                        placeholder: t('payments.applicantDetails.namePlaceholder', 'Full legal name or company name'),
                        autoComplete: "name",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($33cbb63f0ed5fdf2$var$Field, {
                        label: t('payments.applicantDetails.streetLabel', 'Street address'),
                        name: "street",
                        value: form.street,
                        onChange: handleChange('street'),
                        onBlur: handleBlur,
                        placeholder: t('payments.applicantDetails.streetPlaceholder', '123 Example Street'),
                        autoComplete: "street-address",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($33cbb63f0ed5fdf2$var$Field, {
                                label: t('payments.applicantDetails.cityLabel', 'Suburb / City'),
                                name: "city",
                                value: form.city,
                                onChange: handleChange('city'),
                                onBlur: handleBlur,
                                autoComplete: "address-level2",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($33cbb63f0ed5fdf2$var$Field, {
                                label: t('payments.applicantDetails.stateLabel', 'State'),
                                name: "state",
                                value: form.state,
                                onChange: handleChange('state'),
                                onBlur: handleBlur,
                                autoComplete: "address-level1",
                                optionalHint: t('payments.applicantDetails.optional', '(optional)')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($33cbb63f0ed5fdf2$var$Field, {
                                label: t('payments.applicantDetails.zipLabel', 'Postcode'),
                                name: "zip",
                                value: form.zip,
                                onChange: handleChange('zip'),
                                onBlur: handleBlur,
                                autoComplete: "postal-code",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "block text-sm font-medium mb-1 text-gray-900",
                                        children: t('payments.applicantDetails.countryLabel', 'Country')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex items-center min-h-[44px] rounded-md px-3 py-2.5 bg-gray-50 ring-1 ring-inset ring-gray-200 text-gray-700 sm:text-sm",
                                        children: countryName || "\u2014"
                                    })
                                ]
                            })
                        ]
                    }),
                    saveState === 'error' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: t('payments.applicantDetails.saveError', 'Could not save your details. They will be saved again as you keep typing.')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $33cbb63f0ed5fdf2$export$2e2bcd8739ae039 = $33cbb63f0ed5fdf2$var$ApplicantDetailsCard;


/**
 * ReportView — the client's free trademark report, rendered in the Payments
 * section above the quote/pay card.
 *
 * Owns its own useReportQuery so report fetches/refetches never re-render
 * PaymentsSection (whose Embedded Checkout must not remount mid-session) —
 * it is rendered as a SIBLING of the payment cards, never as a wrapper.
 * Absence or failure of the report renders nothing: the payment UI is
 * completely unaffected either way.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");


const $0d78b9e6e9dfa37e$export$5f46dee45509e330 = {
    /**
   * Get the report for an application. Returns null when no report exists.
   */ getByApplicationId: async (applicationId)=>{
        if (!applicationId) return null;
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/reports', {
                params: {
                    applicationId: applicationId
                }
            });
            return response.data;
        } catch (error) {
            if (error.response?.status === 404) return null;
            console.error('Error fetching report by applicationId:', error);
            throw error;
        }
    }
};
var $0d78b9e6e9dfa37e$export$2e2bcd8739ae039 = $0d78b9e6e9dfa37e$export$5f46dee45509e330;


function $fb1a3582065e0bac$export$9c6757f6264d316c(applicationId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'report',
            applicationId
        ],
        queryFn: ()=>(0, $0d78b9e6e9dfa37e$export$5f46dee45509e330).getByApplicationId(applicationId),
        enabled: !!applicationId,
        staleTime: 60000,
        retry: false
    });
}


// Section order mirrors the emailed report (reportsRepository shape)
const $b151568da1b1e5e5$var$SECTION_KEYS = [
    'overview',
    'markAssessment',
    'registerFindings',
    'coverageRationale',
    'ourRecommendation',
    'nextSteps'
];
const $b151568da1b1e5e5$var$formatClasses = (classes)=>{
    if (!Array.isArray(classes) || classes.length === 0) return "\u2014";
    return classes.join(', ');
};
const $b151568da1b1e5e5$var$ReportView = ({ applicationId: applicationId })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const { data: report } = (0, $fb1a3582065e0bac$export$9c6757f6264d316c)(applicationId);
    if (!report) return null;
    const sections = report.sections || {};
    const sectionEntries = $b151568da1b1e5e5$var$SECTION_KEYS.map((key)=>({
            key: key,
            text: sections[key]
        })).filter(({ text: text })=>typeof text === 'string' && text.trim().length > 0);
    const matches = [
        ...report.registerSearch?.exactMatches || [],
        ...report.registerSearch?.nearMatches || []
    ];
    if (sectionEntries.length === 0 && matches.length === 0) return null;
    const reportDate = report.sentAt || report.generatedAt;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
        className: "mb-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h-10 w-10 bg-teal-50 rounded-full flex items-center justify-center flex-shrink-0 mt-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-[#00796b]"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                    children: t('payments.report.title', 'Your trademark report')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardDescription), {
                                    children: reportDate ? t('payments.report.preparedOn', 'Prepared by our team on {{date}}', {
                                        date: new Date(reportDate).toLocaleDateString()
                                    }) : t('payments.report.subtitle', 'Prepared by our team')
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "space-y-5",
                    children: [
                        sectionEntries.map(({ key: key, text: text })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                        className: "mb-1 text-sm font-semibold uppercase tracking-wide text-gray-500",
                                        children: t(`payments.report.sections.${key}`)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                        className: "text-gray-700 whitespace-pre-line",
                                        children: text
                                    })
                                ]
                            }, key)),
                        matches.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                    className: "mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500",
                                    children: t('payments.report.matchesTitle', 'IP Australia register results')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overflow-x-auto rounded-md border border-gray-200",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                        className: "w-full text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    className: "bg-gray-50 text-left text-xs uppercase text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "px-3 py-2 font-medium",
                                                            children: t('payments.report.matchName', 'Mark')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "px-3 py-2 font-medium",
                                                            children: t('payments.report.matchNumber', 'Number')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "px-3 py-2 font-medium",
                                                            children: t('payments.report.matchStatus', 'Status')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "px-3 py-2 font-medium",
                                                            children: t('payments.report.matchClasses', 'Classes')
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                children: matches.map((match, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        className: "border-t border-gray-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "px-3 py-2 font-medium text-gray-900",
                                                                children: match.name || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "px-3 py-2 text-gray-600",
                                                                children: match.number || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "px-3 py-2 text-gray-600",
                                                                children: match.status || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "px-3 py-2 text-gray-600",
                                                                children: $b151568da1b1e5e5$var$formatClasses(match.classes)
                                                            })
                                                        ]
                                                    }, `${match.number || match.name || 'match'}-${index}`))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $b151568da1b1e5e5$export$2e2bcd8739ae039 = $b151568da1b1e5e5$var$ReportView;


/**
 * CollapsibleReport — collapsed-by-default wrapper around ReportView for the
 * quote/payment screen ("View your full report" expander).
 *
 * Owns its own expansion state AND its own useReportQuery subscription so
 * neither toggling nor report fetches ever re-render PaymentsSection (whose
 * Embedded Checkout must not remount mid-session). Rendered as a SIBLING of
 * the payment cards, never a wrapper. Absence or failure of the report
 * renders nothing: the payment UI is completely unaffected either way.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");


const $a6fa0e4a322719a9$var$CollapsibleReport = ({ applicationId: applicationId })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const { data: report } = (0, $fb1a3582065e0bac$export$9c6757f6264d316c)(applicationId);
    if (!report) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                padding: "none",
                className: expanded ? 'mb-4' : '',
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setExpanded((value)=>!value),
                    "aria-expanded": expanded,
                    className: "w-full flex items-center justify-between gap-3 px-4 py-4 sm:gap-4 sm:px-6 text-left hover:bg-gray-50 transition-colors min-h-[44px]",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "h-9 w-9 bg-teal-50 rounded-full flex items-center justify-center flex-shrink-0",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-[#00796b]"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "font-medium text-gray-900",
                                            children: expanded ? t('payments.hideFullReport', 'Hide your full report') : t('payments.viewFullReport', 'View your full report')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-gray-500",
                                            children: t('payments.reportExpanderHint', 'The trademark report our team prepared for you')
                                        })
                                    ]
                                })
                            ]
                        }),
                        expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-gray-400 flex-shrink-0"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-gray-400 flex-shrink-0"
                        })
                    ]
                })
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b151568da1b1e5e5$export$2e2bcd8739ae039), {
                applicationId: applicationId
            })
        ]
    });
};
var $a6fa0e4a322719a9$export$2e2bcd8739ae039 = $a6fa0e4a322719a9$var$CollapsibleReport;



// Initialize Stripe once at module scope
const $b21acdbc7983064f$var$stripePromise = (0, $2110bf72a86f956f$export$de80f7562c3fd6b1)("pk_live_51TRhPc3MQfE2DpvRVG2ON56VP3F3Gi546JrO99GdZANPITuhOiS6xRySuWdr2qS3zkQMRoTf1RhsiasbiY6J0sj600QY0iAeuq");
const $b21acdbc7983064f$var$ZERO_DECIMAL_CURRENCIES = [
    'JPY',
    'KRW'
];
// Full names for the postal-address country (same set the old guest checkout
// offered); falls back to the uppercase code for anything else
const $b21acdbc7983064f$var$COUNTRY_FULL_NAMES = {
    au: 'Australia',
    us: 'United States',
    uk: 'United Kingdom',
    gb: 'United Kingdom',
    eu: 'European Union',
    ca: 'Canada',
    nz: 'New Zealand',
    sg: 'Singapore',
    jp: 'Japan',
    cn: 'China',
    in: 'India'
};
const $b21acdbc7983064f$var$countryFullName = (country)=>{
    if (!country) return '';
    if (typeof country === 'object') {
        const code = (country.code || country.countryId || '').toLowerCase();
        return country.name || $b21acdbc7983064f$var$COUNTRY_FULL_NAMES[code] || (code ? code.toUpperCase() : '');
    }
    const code = String(country).toLowerCase();
    return $b21acdbc7983064f$var$COUNTRY_FULL_NAMES[code] || String(country).toUpperCase();
};
const $b21acdbc7983064f$var$countryDisplayName = (country)=>{
    if (!country) return '';
    if (typeof country === 'string') return country.toUpperCase();
    return country.name || (country.code ? country.code.toUpperCase() : '') || (country.countryId ? country.countryId.toUpperCase() : '');
};
const $b21acdbc7983064f$var$classDisplayLabel = (cls)=>{
    if (cls === null || cls === undefined) return '';
    if (typeof cls === 'number' || typeof cls === 'string') return `Class ${cls}`;
    const number = cls.classNumber ?? cls.number;
    return cls.className ? `Class ${number}: ${cls.className}` : `Class ${number}`;
};
const $b21acdbc7983064f$var$capitalize = (str)=>str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
const $b21acdbc7983064f$var$PaymentsSection = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    const { t: tPayment } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('payment');
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { currentApplication: currentApplication, currentApplicationId: currentApplicationId } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const { createCheckoutSession: startCheckoutSession, clientSecret: contextClientSecret, clientSecretApplicationId: contextClientSecretApplicationId } = (0, $df0f5973e96e353e$export$9906a9e4771cbdf1)();
    const { data: pricingRecord, isLoading: pricingLoading, isError: pricingError } = (0, $fc365aecf7cdcb03$export$1afbd6db87ead9a4)(currentApplicationId);
    const { data: declaration, isLoading: declarationLoading } = (0, $1e32eae54241321e$export$59a5292a95405cc)(currentApplicationId);
    const [clientSecret, setClientSecret] = (0, $acw62.useState)(()=>contextClientSecret && contextClientSecretApplicationId === currentApplicationId ? contextClientSecret : '');
    const [isCreatingSession, setIsCreatingSession] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const checkoutInitialized = (0, $acw62.useRef)(false);
    const autoInitAttempted = (0, $acw62.useRef)(false);
    const declarationRef = (0, $acw62.useRef)(null);
    const applicantRef = (0, $acw62.useRef)(null);
    // Live applicant state reported up from ApplicantDetailsCard — drives the
    // quote card's Applicant row and the payment overlay gate
    const [applicantInfo, setApplicantInfo] = (0, $acw62.useState)({
        name: '',
        complete: false
    });
    const handleApplicantChange = (0, $acw62.useCallback)((info)=>{
        setApplicantInfo((prev)=>prev.name === info.name && prev.complete === info.complete ? prev : info);
    }, []);
    // If the active application changes, discard any checkout state that was
    // created for the previous application.
    const clientSecretAppIdRef = (0, $acw62.useRef)(currentApplicationId);
    (0, $acw62.useEffect)(()=>{
        if (clientSecretAppIdRef.current !== currentApplicationId) {
            clientSecretAppIdRef.current = currentApplicationId;
            setClientSecret('');
            checkoutInitialized.current = false;
            autoInitAttempted.current = false;
            setError(null);
        }
    }, [
        currentApplicationId
    ]);
    // Sync with a client secret already held by PaymentContext (e.g. re-entry) —
    // only when it was minted for the currently active application.
    (0, $acw62.useEffect)(()=>{
        if (contextClientSecret && contextClientSecretApplicationId === currentApplicationId && !clientSecret && !checkoutInitialized.current) {
            setClientSecret(contextClientSecret);
            checkoutInitialized.current = true;
        }
    }, [
        contextClientSecret,
        contextClientSecretApplicationId,
        currentApplicationId,
        clientSecret
    ]);
    // ---- Derived application state -----------------------------------------
    const status = currentApplication?.status;
    const isRefunded = currentApplication?.paymentStatus === 'refunded' || status === 'refunded';
    const isPartiallyRefunded = currentApplication?.paymentStatus === 'partially_refunded' || status === 'partially_refunded';
    const isPaid = !isRefunded && !isPartiallyRefunded && (currentApplication?.paymentStatus === 'paid' || [
        'payment_completed',
        'pending_attorney_filing',
        'filing_in_progress',
        'filed',
        'registered',
        'completed'
    ].includes(status));
    const declarationCompleted = Boolean(declaration?.poaProvided && declaration?.declarationProvided);
    // Signature auto-fill for the single-checkbox declaration — the signed-in
    // Clerk user's full name (same pattern the old guest checkout used with
    // the contact name)
    const signerName = user?.fullName || [
        user?.firstName,
        user?.lastName
    ].filter(Boolean).join(' ') || user?.primaryEmailAddress?.emailAddress || '';
    // Applicant-name prefill deliberately excludes the email fallback — an
    // email address is never a filing applicant name
    const applicantFallbackName = user?.fullName || [
        user?.firstName,
        user?.lastName
    ].filter(Boolean).join(' ') || '';
    // ---- Quote / pricing derivations (all memoized) ------------------------
    const currency = (pricingRecord?.currency || 'USD').toUpperCase();
    const zeroDecimal = $b21acdbc7983064f$var$ZERO_DECIMAL_CURRENCIES.includes(currency);
    const formatAmount = (0, $acw62.useCallback)((amount)=>{
        if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return "\u2014";
        try {
            return new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: currency
            }).format(Number(amount));
        } catch (e) {
            return `${Number(amount).toFixed(2)} ${currency}`;
        }
    }, [
        currency
    ]);
    const quoteTotal = (0, $acw62.useMemo)(()=>{
        const total = Number(pricingRecord?.pricing?.total);
        return Number.isFinite(total) && total > 0 ? total : null;
    }, [
        pricingRecord?.pricing?.total
    ]);
    const lineItems = (0, $acw62.useMemo)(()=>{
        if (!pricingRecord || !quoteTotal) return [];
        const items = [];
        const totals = pricingRecord.pricing || {};
        const discount = Number(totals.discount) || 0;
        const classCount = pricingRecord.classCount || pricingRecord.selectedClasses?.length || 1;
        const classText = classCount > 1 ? `${classCount} classes` : '1 class';
        if (pricingRecord.serviceFeeTotal != null || pricingRecord.govFeeTotal != null) {
            if (pricingRecord.serviceFeeTotal != null) items.push({
                description: t('payments.attorneyServiceFee', 'Trade mark attorney service fee'),
                amount: Number(pricingRecord.serviceFeeTotal) || 0
            });
            if (pricingRecord.govFeeTotal != null) items.push({
                description: `${t('payments.governmentFees', 'Government filing fees')} (${classText})`,
                amount: Number(pricingRecord.govFeeTotal) || 0
            });
        } else {
            const breakdown = Array.isArray(pricingRecord.countryBreakdown) ? pricingRecord.countryBreakdown : null;
            if (breakdown && breakdown.length > 0) breakdown.forEach((row)=>{
                items.push({
                    description: `${row.countryName || $b21acdbc7983064f$var$countryDisplayName(row.countryId)} filing (${classText})`,
                    amount: Number(row.price) || 0
                });
            });
            else {
                const countries = pricingRecord.selectedCountries || [];
                const countryText = countries.length > 0 ? countries.map($b21acdbc7983064f$var$countryDisplayName).filter(Boolean).join(', ') : null;
                items.push({
                    description: countryText ? `${t('payments.filingFee', 'Trademark filing')} \u{2014} ${countryText} (${classText})` : `${t('payments.filingFee', 'Trademark filing')} (${classText})`,
                    amount: quoteTotal + discount
                });
            }
        }
        if (discount > 0) items.push({
            description: t('payments.discount', 'Multi-country discount'),
            amount: -discount
        });
        return items;
    }, [
        pricingRecord,
        quoteTotal,
        t
    ]);
    const expectedAmountMinor = (0, $acw62.useMemo)(()=>{
        if (!quoteTotal) return null;
        return Math.round(quoteTotal * (zeroDecimal ? 1 : 100));
    }, [
        quoteTotal,
        zeroDecimal
    ]);
    // Memoized so re-renders never reinitialize the Embedded Checkout
    const checkoutOptions = (0, $acw62.useMemo)(()=>{
        if (!clientSecret) return null;
        return {
            clientSecret: clientSecret
        };
    }, [
        clientSecret
    ]);
    // Postal-address country is fixed to the quote's first country
    const quoteCountryName = (0, $acw62.useMemo)(()=>$b21acdbc7983064f$var$countryFullName(pricingRecord?.selectedCountries?.[0]), [
        pricingRecord?.selectedCountries
    ]);
    // Quote document derivations. A re-quoted client (a class added, say) has a
    // revision suffix, and this has to match the numbering on the PDF they were
    // emailed — see quotePdfService.
    const quoteRevision = Number(pricingRecord?.quoteRevision) || 1;
    const quoteNumber = currentApplicationId ? `Q-${String(currentApplicationId).slice(0, 8).toUpperCase()}${quoteRevision > 1 ? `-R${quoteRevision}` : ''}` : '';
    const quoteDate = pricingRecord?.updatedAt || pricingRecord?.createdAt || null;
    // ---- Handlers ----------------------------------------------------------
    const handlePay = (0, $acw62.useCallback)(async ()=>{
        if (!user || !currentApplicationId || !expectedAmountMinor) {
            setError('Missing application or pricing information');
            return;
        }
        setIsCreatingSession(true);
        setError(null);
        try {
            const stripeLocaleMap = {
                en: 'en',
                es: 'es',
                de: 'de',
                zh: 'zh'
            };
            const sessionData = {
                applicationId: currentApplicationId,
                // The backend recomputes the charge from the pricing record and rejects
                // any mismatch — this amount is informational/validated, never trusted.
                amount: expectedAmountMinor,
                currency: currency.toLowerCase(),
                customerEmail: user.emailAddresses?.[0]?.emailAddress,
                pricing: lineItems,
                locale: stripeLocaleMap[(0, $53cebf01a6481b81$export$2e2bcd8739ae039).language] || 'auto'
            };
            const response = await startCheckoutSession(sessionData);
            setClientSecret(response.clientSecret);
            checkoutInitialized.current = true;
        } catch (err) {
            console.error('Error creating checkout session:', err);
            setError(err?.response?.data?.message || err.message || 'Failed to initialize payment');
        } finally{
            setIsCreatingSession(false);
        }
    }, [
        currency,
        currentApplicationId,
        expectedAmountMinor,
        lineItems,
        startCheckoutSession,
        user
    ]);
    // Payment loads immediately: create the checkout session as soon as the
    // quote screen can render (status quote_sent / legacy unpaid with a stored
    // quote, pricing loaded, user present). The declaration does NOT gate
    // session creation — the rendered checkout is soft-gated by the overlay
    // below until the declaration is ticked.
    (0, $acw62.useEffect)(()=>{
        if (autoInitAttempted.current) return;
        if (!currentApplication || isPaid || isRefunded || isPartiallyRefunded) return;
        if (status === 'quote_requested') return;
        if (!user || !currentApplicationId || !expectedAmountMinor) return;
        if (clientSecret || checkoutInitialized.current) return;
        autoInitAttempted.current = true;
        handlePay();
    }, [
        currentApplication,
        isPaid,
        isRefunded,
        isPartiallyRefunded,
        status,
        user,
        currentApplicationId,
        expectedAmountMinor,
        clientSecret,
        handlePay
    ]);
    const handleViewReceipt = (0, $acw62.useCallback)(async ()=>{
        try {
            if (!currentApplication?.paymentId) {
                alert('Receipt not available - no payment ID found');
                return;
            }
            const receiptData = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getReceiptUrl(currentApplication.paymentId);
            if (receiptData.receiptUrl) window.open(receiptData.receiptUrl, '_blank');
            else alert('Receipt not available yet. Please try again later.');
        } catch (err) {
            console.error('Error fetching receipt:', err);
            alert('Unable to load receipt. Please try again later.');
        }
    }, [
        currentApplication?.paymentId
    ]);
    // Scroll to whatever is still blocking payment: applicant details first,
    // then the declaration
    const scrollToBlocking = (0, $acw62.useCallback)(()=>{
        const target = !applicantInfo.complete ? applicantRef.current : declarationRef.current;
        target?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, [
        applicantInfo.complete
    ]);
    // ---- Render states -----------------------------------------------------
    // No application at all — the marketing wizard is the intake
    if (!currentApplication) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        className: "mb-6",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "text-center py-12",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                    className: "h-12 w-12 text-gray-300 mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                    className: "mb-2",
                    children: t('payments.noApplicationTitle', 'No application yet')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    className: "text-gray-600 mb-6 max-w-md mx-auto",
                    children: t('payments.noApplicationMsg', 'Start with a free trademark check on our website. We will email you a detailed report and quote within 24 hours.')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                    onClick: ()=>{
                        window.location.href = (0, $dc60fa0fe0f6ea60$export$64d4a5b91c97bf11);
                    },
                    className: "bg-[#004d40] hover:bg-[#00695c] text-white px-6 py-3 rounded-xl inline-flex items-center gap-2",
                    children: [
                        t('payments.startFreeCheck', 'Start your free check'),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                            className: "h-4 w-4"
                        })
                    ]
                })
            ]
        })
    });
    // Paid (or refunded) — completion card + filing status
    if (isPaid || isRefunded || isPartiallyRefunded) {
        const paymentAmountMinor = expectedAmountMinor || (quoteTotal ? Math.round(quoteTotal * 100) : null);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "space-y-6",
            children: [
                isPaid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b151568da1b1e5e5$export$2e2bcd8739ae039), {
                    applicationId: currentApplicationId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $153792c6c913a9fe$export$2e2bcd8739ae039), {
                    application: currentApplication,
                    paymentAmount: paymentAmountMinor,
                    paymentCurrency: currency,
                    paymentDate: currentApplication?.paidAt || currentApplication?.updatedAt || currentApplication?.createdAt,
                    isRefunded: isRefunded,
                    isPartiallyRefunded: isPartiallyRefunded,
                    onViewReceipt: handleViewReceipt
                }),
                !isRefunded && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af220be3e136bc64$export$2e2bcd8739ae039), {
                    application: currentApplication
                })
            ]
        });
    }
    // Report requested — quote not sent yet
    if (status === 'quote_requested') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        className: "mb-6 border-blue-200 bg-blue-50/40",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "text-center py-12",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mx-auto h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center mb-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                        className: "h-8 w-8 text-blue-600"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                    className: "mb-2",
                    children: t('payments.reportPreparingTitle', 'Your report is being prepared')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    className: "text-gray-600 max-w-md mx-auto",
                    children: t('payments.reportPreparingMsg', 'Our team is reviewing your trademark and preparing your detailed report and quote. We will email it to you within 24 hours.')
                }),
                currentApplication?.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    className: "text-sm text-gray-500 mt-4",
                    children: t('payments.reportForTrademark', 'Trademark: {{name}}', {
                        name: currentApplication.trademarkName
                    })
                })
            ]
        })
    });
    // Pricing still loading — but once a checkout session exists, the quote
    // screen below must keep rendering so a background pricing refetch can
    // never unmount a mounted Stripe Embedded Checkout mid-payment.
    if (pricingLoading && !clientSecret) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        className: "mb-6",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "flex items-center justify-center py-12",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                    className: "h-8 w-8 animate-spin text-[#00796b] mr-3"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    children: t('payments.loadingQuote', "Loading your quote\u2026")
                })
            ]
        })
    });
    // Pricing failed or no quote on the record yet (never once checkout is live)
    if ((pricingError || !quoteTotal) && !clientSecret) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        className: "mb-6",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "text-center py-12",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    className: "h-10 w-10 text-amber-500 mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                    className: "mb-2",
                    children: t('payments.noQuoteTitle', 'Your quote is not ready yet')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    className: "text-gray-600 max-w-md mx-auto",
                    children: t('payments.noQuoteMsg', 'We are still finalising the quote for this application. You will receive an email as soon as it is ready. If you think this is a mistake, reply to any of our emails and we will sort it out.')
                })
            ]
        })
    });
    // quote_sent (and legacy unpaid statuses with a stored quote):
    // invoice-style quote document → collapsible report → declaration → payment
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                        divided: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                            className: "text-xl",
                                            children: t('payments.quoteDocTitle', 'Quote')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardDescription), {
                                            children: status === 'quote_sent' ? t('payments.quoteSubtitleConfirmed', "Confirmed by our attorneys \u2014 this is the exact amount you will be charged.") : t('payments.quoteSubtitle', 'Review your filing fees and complete payment')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "sm:text-right flex-shrink-0",
                                    children: [
                                        currentApplication?.paymentStatus && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74a5c7a7fc417eec$export$2e2bcd8739ae039), {
                                            paymentStatus: currentApplication.paymentStatus,
                                            status: status,
                                            className: "mb-2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm font-semibold text-gray-900",
                                            children: quoteNumber
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                            className: "text-xs text-gray-500",
                                            children: [
                                                t('payments.dateOfIssue', 'Date of issue'),
                                                ":",
                                                ' ',
                                                new Date(quoteDate || Date.now()).toLocaleDateString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-xs text-gray-500",
                                            children: t('payments.quoteValidity', 'Valid for 30 days')
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                        className: "mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500",
                                        children: t('payments.trademarkDetails', 'Trade mark details')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "bg-gray-50 p-4 rounded-md",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b59a4b217a27027a$export$694e0d28c7ffc90c), {
                                            spacing: 2,
                                            children: [
                                                currentApplication?.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex justify-between gap-4 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-600 flex-shrink-0",
                                                            children: t('payments.markName', 'Trade mark')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "font-medium text-gray-900 text-right break-words min-w-0",
                                                            children: currentApplication.trademarkName
                                                        })
                                                    ]
                                                }),
                                                currentApplication?.trademarkType && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex justify-between gap-4 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-600 flex-shrink-0",
                                                            children: t('payments.markType', 'Type')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-900 text-right",
                                                            children: $b21acdbc7983064f$var$capitalize(currentApplication.trademarkType)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex justify-between gap-4 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-600 flex-shrink-0",
                                                            children: t('payments.applicant', 'Applicant')
                                                        }),
                                                        applicantInfo.name ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-900 text-right break-words min-w-0",
                                                            children: applicantInfo.name
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-400 italic text-right min-w-0",
                                                            children: t('payments.applicantTbc', 'To be confirmed')
                                                        })
                                                    ]
                                                }),
                                                pricingRecord?.selectedCountries?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-col gap-0.5 text-sm sm:flex-row sm:justify-between sm:gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-600 flex-shrink-0",
                                                            children: t('payments.countries', 'Countries')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-900 sm:text-right break-words min-w-0",
                                                            children: pricingRecord.selectedCountries.map($b21acdbc7983064f$var$countryDisplayName).filter(Boolean).join(', ')
                                                        })
                                                    ]
                                                }),
                                                pricingRecord?.selectedClasses?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-col gap-0.5 text-sm sm:flex-row sm:justify-between sm:gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-600 flex-shrink-0",
                                                            children: t('payments.classes', 'Classes')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-900 sm:text-right break-words min-w-0",
                                                            children: pricingRecord.selectedClasses.map($b21acdbc7983064f$var$classDisplayLabel).filter(Boolean).join(', ')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                className: "mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500",
                                children: t('payments.breakdown', 'Quote breakdown')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bg-gray-50 p-4 rounded-md",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b59a4b217a27027a$export$694e0d28c7ffc90c), {
                                    spacing: 3,
                                    children: [
                                        lineItems.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-between gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                        className: "min-w-0 break-words",
                                                        children: item.description
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                                        className: `text-right whitespace-nowrap flex-shrink-0 ${item.amount < 0 ? 'text-green-600' : ''}`,
                                                        children: [
                                                            item.amount < 0 ? '-' : '',
                                                            formatAmount(Math.abs(item.amount))
                                                        ]
                                                    })
                                                ]
                                            }, index)),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b59a4b217a27027a$export$2e0a83ec2e27ecbb), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex justify-between gap-4 font-semibold text-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                    children: t('payments.total', 'Total')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                    className: "whitespace-nowrap",
                                                    children: formatAmount(quoteTotal)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-xs text-gray-500",
                                            children: t('payments.chargedIn', 'Charged in {{currency}}', {
                                                currency: currency
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            status === 'quote_sent' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6fa0e4a322719a9$export$2e2bcd8739ae039), {
                applicationId: currentApplicationId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: applicantRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33cbb63f0ed5fdf2$export$2e2bcd8739ae039), {
                    applicationId: currentApplicationId,
                    application: currentApplication,
                    fallbackName: applicantFallbackName,
                    countryName: quoteCountryName,
                    onApplicantChange: handleApplicantChange
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: declarationRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f634b80d4ecef54$export$2e2bcd8739ae039), {
                    applicationId: currentApplicationId,
                    declaration: declaration,
                    isLoading: declarationLoading,
                    signerName: signerName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardHeader), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                children: tPayment('title', 'Complete Payment')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardDescription), {
                                children: tPayment('subtitle', 'Secure payment processing powered by Stripe')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                        children: [
                            currentApplication?.paymentStatus === 'pending' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 text-blue-700",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm font-medium",
                                            children: t('payments.pendingRetry', 'A previous payment attempt is pending. You can proceed to try again.')
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "p-4 bg-red-50 border border-red-200 rounded-md",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-red-500 flex-shrink-0 mt-0.5"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm text-red-700",
                                                            children: error
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                                            onClick: handlePay,
                                                            disabled: isCreatingSession,
                                                            className: "mt-3 px-4 py-2 bg-[#004d40] hover:bg-[#00695c] text-white text-sm font-medium rounded-md",
                                                            children: t('payments.paymentRetry', 'Try again')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : checkoutOptions ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.EmbeddedCheckoutProvider), {
                                        stripe: $b21acdbc7983064f$var$stripePromise,
                                        options: checkoutOptions,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.EmbeddedCheckout), {})
                                    }, clientSecret) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "py-10 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                className: "h-8 w-8 text-[#00796b] animate-spin mx-auto mb-3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-gray-600",
                                                children: t('payments.settingUpPayment', "Setting up secure payment\u2026")
                                            })
                                        ]
                                    }),
                                    (!declarationCompleted || !applicantInfo.complete) && !error && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: scrollToBlocking,
                                        className: "absolute inset-0 z-10 w-full rounded-md bg-white/70 backdrop-blur-[2px] flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "text-center px-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-gray-400 mx-auto mb-2"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "block font-medium text-gray-800",
                                                    children: !applicantInfo.complete && !declarationCompleted ? t('payments.overlayUnlockBoth', 'Add your applicant details and tick the declaration above to pay') : !applicantInfo.complete ? t('payments.overlayUnlockApplicant', 'Add your applicant details above to pay') : t('payments.overlayUnlock', 'Tick the declaration above to pay')
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b21acdbc7983064f$export$2e2bcd8739ae039 = $b21acdbc7983064f$var$PaymentsSection;


// Valid dashboard sections (URL hash → section)
const $391aa6d316dff2c7$var$VALID_SECTIONS = [
    'home',
    'portfolio',
    'payments',
    'renewals',
    'settings',
    'messages'
];
const $391aa6d316dff2c7$export$fe82a520fc33e5f4 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('dashboard');
    // Access Clerk user and authentication state
    const { isSignedIn: isSignedIn, isLoaded: isLoaded, user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const userName = isSignedIn && user ? user.firstName || user.username : null;
    // Track the current dashboard section (home, portfolio, payments, etc.)
    const [activeSection, setActiveSection] = (0, $acw62.useState)('home');
    // Mobile sidebar drawer (hamburger in the header, <768px only)
    const [sidebarOpen, setSidebarOpen] = (0, $acw62.useState)(false);
    const { currentApplication: currentApplication } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    // Lock body scroll while the mobile drawer is open
    (0, $acw62.useEffect)(()=>{
        if (!sidebarOpen) return;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.body.style.overflow = previousOverflow;
        };
    }, [
        sidebarOpen
    ]);
    // A client arriving with no specific destination and an unpaid quote lands
    // on Quote & Payment (covers every sign-in path, incl. accounts resolved
    // rather than created by the quote flow). Runs once per mount so normal
    // navigation is never hijacked afterwards.
    const autoRoutedRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (autoRoutedRef.current) return;
        if (window.location.hash) return; // explicit destination wins
        if (currentApplication && currentApplication.status === 'quote_sent' && currentApplication.paymentStatus !== 'paid') {
            autoRoutedRef.current = true;
            setActiveSection('payments');
            window.location.hash = 'payments';
        }
    }, [
        currentApplication
    ]);
    // Handle URL hash for section selection (e.g. #payments)
    (0, $acw62.useEffect)(()=>{
        const handleHashChange = ()=>{
            const hash = window.location.hash.slice(1); // Remove #
            // Old wizard links/emails deep-link to #ipfiling — redirect to Payments
            if (hash === 'ipfiling' || hash.startsWith('ipfiling?')) {
                setActiveSection('payments');
                return;
            }
            const section = hash.split('?')[0];
            if ($391aa6d316dff2c7$var$VALID_SECTIONS.includes(section)) setActiveSection(section);
        };
        // Set initial section from hash
        handleHashChange();
        // Listen for hash changes
        window.addEventListener('hashchange', handleHashChange);
        return ()=>window.removeEventListener('hashchange', handleHashChange);
    }, []);
    // Handle section change from sidebar
    const handleSectionChange = (section)=>{
        setActiveSection(section);
        setSidebarOpen(false); // close the mobile drawer on navigation
        window.location.hash = section;
    };
    // Create auth redirect URL for Clerk modal
    const getAuthRedirectUrl = ()=>{
        return window.location.origin + '/dashboard';
    };
    // Auto-trigger Clerk modal when component mounts and user isn't signed in
    (0, $acw62.useEffect)(()=>{
        // Only try to show the modal if Clerk auth is fully loaded
        // and the user is not already signed in
        if (isLoaded && !isSignedIn) {
            // Find the modal-trigger button and programmatically click it
            const triggerButton = document.getElementById('clerk-auth-trigger');
            if (triggerButton) triggerButton.click();
        }
    }, [
        isSignedIn,
        isLoaded
    ]);
    // Handle Clerk modal being closed without authentication
    (0, $acw62.useEffect)(()=>{
        // Only redirect if user explicitly closes the modal using the X button
        const handleClerkModalClosed = (event)=>{
            // Check if the user is not signed in and clicked the close button
            // The close button has a specific class 'cl-modalCloseButton'
            if (!isSignedIn && (event.target.classList.contains('cl-modalCloseButton') || event.target.closest('.cl-modalCloseButton'))) window.location.href = '/';
        };
        document.addEventListener('click', handleClerkModalClosed);
        return ()=>{
            document.removeEventListener('click', handleClerkModalClosed);
        };
    }, [
        isSignedIn
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "min-h-screen flex flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e62364690990d03$export$2e2bcd8739ae039), {
                    userName: userName,
                    onMenuClick: ()=>setSidebarOpen((open)=>!open)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-1 overflow-hidden mt-16",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e25cb8ac1431c627$export$2e2bcd8739ae039), {
                            activeSection: activeSection,
                            onSectionChange: handleSectionChange,
                            mobileOpen: sidebarOpen,
                            onClose: ()=>setSidebarOpen(false)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                            className: "flex-1 overflow-y-auto p-4 md:p-6 bg-gradient-to-br from-gray-50 to-gray-100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "max-w-6xl mx-auto",
                                children: activeSection === 'home' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2dd5be37ad88fb1e$export$2e2bcd8739ae039), {
                                    onNavigate: handleSectionChange
                                }) : activeSection === 'portfolio' ? // Portfolio Section - Show application portfolio
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg-white rounded-lg shadow-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "p-6 border-b border-gray-200",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                    className: "text-2xl font-bold text-gray-900",
                                                    children: "My IP Portfolio"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-gray-600 mt-1",
                                                    children: "Manage your trademark applications and intellectual property"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e35e2c86fd4509$export$2e2bcd8739ae039), {})
                                    ]
                                }) : activeSection === 'payments' ? // Quote & Payment Section
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb-6",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                    className: "text-2xl font-bold text-gray-900",
                                                    children: t('payments.sectionTitle', 'Quote & Payment')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-gray-600 mt-1",
                                                    children: t('payments.sectionSubtitle', 'Review your quote, sign the declaration, and complete payment')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b21acdbc7983064f$export$2e2bcd8739ae039), {})
                                    ]
                                }) : activeSection === 'settings' ? // Settings Section
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a64351ecfb9093b$export$2e2bcd8739ae039), {}) : activeSection === 'messages' ? // Messages Section
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be5b81ecbab21f1e$export$2e2bcd8739ae039), {}) : // Other sections (renewals) - Coming soon placeholder
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-lg shadow-sm p-12 text-center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "max-w-md mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "text-6xl mb-4",
                                                children: "\uD83D\uDEA7"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "text-2xl font-bold text-gray-900 mb-2",
                                                children: "Coming Soon"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-gray-600",
                                                children: "This section is currently under development. Please check back later!"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignInButton), {
                        mode: "modal",
                        "data-redirect-url": getAuthRedirectUrl(),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            id: "clerk-auth-trigger",
                            children: "Sign In"
                        })
                    })
                })
            ]
        })
    });
};
var $391aa6d316dff2c7$export$2e2bcd8739ae039 = $391aa6d316dff2c7$export$fe82a520fc33e5f4;


/**
 * AdminDashboard Component
 * 
 * Main admin dashboard for managing payments, refunds, and trademark applications
 * Styled to match the main dashboard with brand colors
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowLeft", $7b20c5205e441d74$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $be189782912469dc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M18 17V9",
            key: "2bz60n"
        }
    ],
    [
        "path",
        {
            d: "M13 17V5",
            key: "1frdt8"
        }
    ],
    [
        "path",
        {
            d: "M8 17v-3",
            key: "17ska0"
        }
    ]
];
const $be189782912469dc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChartColumn", $be189782912469dc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $224502d93617e0e1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
];
const $224502d93617e0e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Building2", $224502d93617e0e1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9921f4f81a419f0$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "22 7 13.5 15.5 8.5 10.5 2 17",
            key: "126l90"
        }
    ],
    [
        "polyline",
        {
            points: "16 7 22 7 22 13",
            key: "kwv8wd"
        }
    ]
];
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("TrendingUp", $c9921f4f81a419f0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c38b5b11d1e2b813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "path",
        {
            d: "M16 3.13a4 4 0 0 1 0 7.75",
            key: "1da9ce"
        }
    ]
];
const $c38b5b11d1e2b813$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Users", $c38b5b11d1e2b813$export$3efd853dbb351e94);



var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");
/**
 * PaymentManagement Component
 * 
 * Main payment management interface for admins
 * Includes payment list, details, and refund capabilities
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $52885985d1db6c06$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "2",
            y2: "22",
            key: "7eqyqh"
        }
    ],
    [
        "path",
        {
            d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
            key: "1b0p4s"
        }
    ]
];
const $52885985d1db6c06$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("DollarSign", $52885985d1db6c06$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d252ca8c87a49232$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "7 10 12 15 17 10",
            key: "2ggqvy"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "15",
            y2: "3",
            key: "1vk2je"
        }
    ]
];
const $d252ca8c87a49232$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Download", $d252ca8c87a49232$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Eye", $b285ef0f6f9bf8bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $05e483c418a01d8d$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
            key: "1yg77f"
        }
    ]
];
const $05e483c418a01d8d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Filter", $05e483c418a01d8d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("RefreshCw", $8a800148d042d893$export$3efd853dbb351e94);



var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");
/**
 * PaymentsList Component
 * 
 * Displays a table of payments with filtering and pagination
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $fYgYF = parcelRequire("fYgYF");

var $2Q0xG = parcelRequire("2Q0xG");
const $f40f2a58923f69a0$var$PaymentsList = ({ payments: payments, isLoading: isLoading, onPaymentSelect: onPaymentSelect })=>{
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount / 100);
    };
    const formatDate = (dateString)=>{
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    const getStatusIcon = (status)=>{
        switch(status){
            case 'succeeded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-green-500"
                });
            case 'pending':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-yellow-500"
                });
            case 'failed':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-red-500"
                });
            case 'refunded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-blue-500"
                });
            case 'partially_refunded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-orange-500"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-gray-500"
                });
        }
    };
    const getStatusColor = (status)=>{
        switch(status){
            case 'succeeded':
                return 'bg-green-100 text-green-800';
            case 'pending':
                return 'bg-yellow-100 text-yellow-800';
            case 'failed':
                return 'bg-red-100 text-red-800';
            case 'refunded':
                return 'bg-blue-100 text-blue-800';
            case 'partially_refunded':
                return 'bg-orange-100 text-orange-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "space-y-4",
        children: [
            ...Array(5)
        ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "animate-pulse",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-16 bg-gray-200 rounded-lg"
                })
            }, i))
    });
    if (payments.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "text-center py-12",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                className: "h-12 w-12 text-gray-400 mx-auto mb-4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                className: "text-lg font-medium text-gray-900 mb-2",
                children: "No payments found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                className: "text-gray-500",
                children: "No payments match your current search criteria."
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden md:block overflow-x-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "min-w-full divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            className: "bg-gray-50",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                        children: "Payment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                        children: "Customer"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                        children: "Amount"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                        children: "Date"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            className: "bg-white divide-y divide-gray-200",
                            children: payments.map((payment)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "hover:bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-6 py-4 whitespace-nowrap",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                            className: "h-8 w-8 text-gray-400"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "ml-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: [
                                                                    "#",
                                                                    payment.id.substring(0, 8)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "text-sm text-gray-500",
                                                                children: [
                                                                    "App: ",
                                                                    payment.applicationId
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-6 py-4 whitespace-nowrap",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 text-gray-400 mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: payment.customerEmail
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "text-sm text-gray-500",
                                                                children: payment.userId
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "px-6 py-4 whitespace-nowrap",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "text-sm font-medium text-gray-900",
                                                    children: formatCurrency(payment.amount)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "text-sm text-gray-500",
                                                    children: payment.currency.toUpperCase()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-6 py-4 whitespace-nowrap",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    getStatusIcon(payment.status),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `ml-2 inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(payment.status)}`,
                                                        children: payment.status.replace('_', ' ')
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 mr-2"
                                                    }),
                                                    formatDate(payment.createdAt)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-6 py-4 whitespace-nowrap text-sm font-medium",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                                onClick: ()=>onPaymentSelect(payment),
                                                variant: "outline",
                                                size: "sm",
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    "View"
                                                ]
                                            })
                                        })
                                    ]
                                }, payment.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "md:hidden space-y-4",
                children: payments.map((payment)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white border border-gray-200 rounded-lg p-4 shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 text-gray-400 mr-2"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                                        className: "font-medium",
                                                        children: [
                                                            "#",
                                                            payment.id.substring(0, 8)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                        className: "text-sm text-gray-500",
                                                        children: payment.applicationId
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            getStatusIcon(payment.status),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `ml-2 px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(payment.status)}`,
                                                children: payment.status.replace('_', ' ')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "space-y-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-gray-500",
                                                children: "Customer:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium",
                                                children: payment.customerEmail
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-gray-500",
                                                children: "Amount:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium",
                                                children: formatCurrency(payment.amount)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-gray-500",
                                                children: "Date:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm",
                                                children: formatDate(payment.createdAt)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                onClick: ()=>onPaymentSelect(payment),
                                variant: "outline",
                                size: "sm",
                                className: "w-full flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "View Details"
                                ]
                            })
                        ]
                    }, payment.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between pt-4 border-t",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                        className: "text-sm text-gray-700",
                        children: [
                            "Showing ",
                            payments.length,
                            " payments"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                disabled: true,
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                disabled: true,
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f40f2a58923f69a0$export$2e2bcd8739ae039 = $f40f2a58923f69a0$var$PaymentsList;


/**
 * PaymentDetails Component
 * 
 * Detailed view of a single payment with all metadata and actions
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Copy", $68d48ea6a6653ccd$export$3efd853dbb351e94);



var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");
/**
 * RefundDialog Component
 * 
 * Modal dialog for processing refunds with amount and reason selection
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");

const $8cdb0e05ee407659$var$RefundDialog = ({ payment: payment, maxRefundAmount: maxRefundAmount, onClose: onClose, onSuccess: onSuccess })=>{
    const [refundAmount, setRefundAmount] = (0, $acw62.useState)(maxRefundAmount || 0);
    const [refundReason, setRefundReason] = (0, $acw62.useState)('requested_by_customer');
    const [isProcessing, setIsProcessing] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    if (!payment || !payment.id) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "text-center py-12 text-gray-500",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                className: "h-8 w-8 mx-auto mb-3 text-gray-300"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "font-medium",
                children: "No payment selected"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-sm mt-1",
                children: "Select a payment from the list to process a refund."
            })
        ]
    });
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount / 100);
    };
    const refundReasons = [
        {
            value: 'requested_by_customer',
            label: 'Requested by customer'
        },
        {
            value: 'duplicate',
            label: 'Duplicate payment'
        },
        {
            value: 'fraudulent',
            label: 'Fraudulent transaction'
        },
        {
            value: 'subscription_cancelled',
            label: 'Subscription cancelled'
        },
        {
            value: 'product_unacceptable',
            label: 'Product unacceptable'
        },
        {
            value: 'product_not_received',
            label: 'Product not received'
        },
        {
            value: 'unrecognised',
            label: 'Unrecognised transaction'
        },
        {
            value: 'credit_not_processed',
            label: 'Credit not processed'
        },
        {
            value: 'general',
            label: 'General'
        },
        {
            value: 'processing_error',
            label: 'Processing error'
        }
    ];
    const handleRefund = async ()=>{
        if (refundAmount <= 0 || refundAmount > maxRefundAmount) {
            setError('Invalid refund amount');
            return;
        }
        setIsProcessing(true);
        setError('');
        try {
            const result = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).processRefund(payment.id, {
                amount: refundAmount,
                reason: refundReason
            });
            if (result.refund || result.payment) onSuccess(result.payment || {
                ...payment,
                status: 'refunded'
            });
            else if (result.success === false) setError(result.error || 'Failed to process refund');
            else onSuccess(result);
        } catch (err) {
            console.error('Refund error:', err);
            setError('Failed to process refund. Please try again.');
        } finally{
            setIsProcessing(false);
        }
    };
    const isFullRefund = refundAmount === maxRefundAmount;
    const isPartialRefund = refundAmount > 0 && refundAmount < maxRefundAmount;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
            className: "w-full max-w-md max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardHeader), {
                    className: "flex flex-row items-center justify-between space-y-0 pb-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5"
                                }),
                                "Process Refund"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: onClose,
                            className: "text-gray-400 hover:text-gray-600 transition-colors",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "h-5 w-5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                    className: "space-y-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-gray-50 p-4 rounded-lg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center justify-between mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-gray-600",
                                            children: "Payment ID:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                            className: "text-sm font-mono",
                                            children: [
                                                "#",
                                                payment.id.substring(0, 8)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center justify-between mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-gray-600",
                                            children: "Customer:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm",
                                            children: payment.customerEmail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center justify-between mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-gray-600",
                                            children: "Original Amount:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm font-medium",
                                            children: formatCurrency(payment.amount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-gray-600",
                                            children: "Available to Refund:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm font-medium text-green-600",
                                            children: formatCurrency(maxRefundAmount)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    htmlFor: "refundAmount",
                                    className: "block text-sm font-medium text-gray-700 mb-2",
                                    children: "Refund Amount"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                            className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "refundAmount",
                                            type: "number",
                                            min: "1",
                                            max: maxRefundAmount,
                                            step: "1",
                                            value: refundAmount,
                                            onChange: (e)=>setRefundAmount(parseInt(e.target.value) || 0),
                                            className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                            placeholder: "Enter amount in cents"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mt-2 flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>setRefundAmount(maxRefundAmount),
                                            className: "text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded",
                                            children: [
                                                "Full Refund (",
                                                formatCurrency(maxRefundAmount),
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>setRefundAmount(Math.floor(maxRefundAmount / 2)),
                                            className: "text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded",
                                            children: [
                                                "Half (",
                                                formatCurrency(Math.floor(maxRefundAmount / 2)),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                    className: "text-xs text-gray-500 mt-1",
                                    children: [
                                        "Amount in cents. Preview: ",
                                        formatCurrency(refundAmount)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    htmlFor: "refundReason",
                                    className: "block text-sm font-medium text-gray-700 mb-2",
                                    children: "Refund Reason"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                    id: "refundReason",
                                    value: refundReason,
                                    onChange: (e)=>setRefundReason(e.target.value),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                    children: refundReasons.map((reason)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: reason.value,
                                            children: reason.label
                                        }, reason.value))
                                })
                            ]
                        }),
                        isPartialRefund && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-yellow-50 border border-yellow-200 rounded-lg p-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 text-yellow-800",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm font-medium",
                                            children: "Partial Refund"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                    className: "text-xs text-yellow-700 mt-1",
                                    children: [
                                        "This will refund ",
                                        formatCurrency(refundAmount),
                                        " of the original ",
                                        formatCurrency(payment.amount),
                                        " payment. The remaining ",
                                        formatCurrency(maxRefundAmount - refundAmount),
                                        " will still be available for future refunds."
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-red-50 border border-red-200 rounded-lg p-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 text-red-800",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm font-medium",
                                            children: "Error"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                    className: "text-xs text-red-700 mt-1",
                                    children: error
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-3 pt-4 border-t",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                    onClick: onClose,
                                    variant: "outline",
                                    className: "flex-1",
                                    disabled: isProcessing,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                    onClick: handleRefund,
                                    className: "flex-1 flex items-center justify-center gap-2",
                                    disabled: isProcessing || refundAmount <= 0 || refundAmount > maxRefundAmount,
                                    children: isProcessing ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 animate-spin"
                                            }),
                                            "Processing..."
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            isFullRefund ? 'Full Refund' : 'Partial Refund'
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $8cdb0e05ee407659$export$2e2bcd8739ae039 = $8cdb0e05ee407659$var$RefundDialog;


const $54a3940106cc90b2$var$PaymentDetails = ({ payment: payment, onBack: onBack })=>{
    const [showRefundDialog, setShowRefundDialog] = (0, $acw62.useState)(false);
    const [copiedField, setCopiedField] = (0, $acw62.useState)('');
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount / 100);
    };
    const formatDate = (dateString)=>{
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    const copyToClipboard = async (text, field)=>{
        try {
            await navigator.clipboard.writeText(text);
            setCopiedField(field);
            setTimeout(()=>setCopiedField(''), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };
    const getStatusColor = (status)=>{
        switch(status){
            case 'succeeded':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'failed':
                return 'bg-red-100 text-red-800 border-red-200';
            case 'refunded':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'partially_refunded':
                return 'bg-orange-100 text-orange-800 border-orange-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };
    const getStatusIcon = (status)=>{
        switch(status){
            case 'succeeded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-green-500"
                });
            case 'pending':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-yellow-500"
                });
            case 'failed':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-red-500"
                });
            case 'refunded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-blue-500"
                });
            case 'partially_refunded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-orange-500"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-gray-500"
                });
        }
    };
    const canRefund = payment.status === 'succeeded' || payment.status === 'partially_refunded';
    const totalRefunded = payment.refunds?.reduce((sum, refund)=>sum + (refund.amount || 0), 0) || 0;
    const refundableAmount = payment.amount - totalRefunded;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                onClick: onBack,
                                variant: "outline",
                                size: "sm",
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Back to List"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                        children: "Payment Details"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                        className: "text-gray-600",
                                        children: [
                                            "#",
                                            payment.id
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            getStatusIcon(payment.status),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `px-3 py-1 text-sm font-medium rounded-full border ${getStatusColor(payment.status)}`,
                                children: payment.status.replace('_', ' ').toUpperCase()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lg:col-span-2 space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                "Payment Information"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                                        className: "space-y-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "Payment ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-mono text-sm",
                                                                    children: payment.id
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>copyToClipboard(payment.id, 'id'),
                                                                    className: "text-gray-400 hover:text-gray-600",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                copiedField === 'id' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-green-600 text-xs",
                                                                    children: "Copied!"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "Stripe Payment Intent"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-mono text-sm",
                                                                    children: payment.stripePaymentIntentId
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>copyToClipboard(payment.stripePaymentIntentId, 'stripe'),
                                                                    className: "text-gray-400 hover:text-gray-600",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                copiedField === 'stripe' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-green-600 text-xs",
                                                                    children: "Copied!"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    href: `https://dashboard.stripe.com/payments/${payment.stripePaymentIntentId}`,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "text-[#00796b] hover:text-[#004d40]",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "Amount"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-lg font-semibold",
                                                            children: formatCurrency(payment.amount)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "Currency"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "uppercase",
                                                            children: payment.currency
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                "Customer Information"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                                        className: "space-y-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            children: payment.customerEmail
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "User ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-mono text-sm",
                                                                    children: payment.userId
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>copyToClipboard(payment.userId, 'userId'),
                                                                    className: "text-gray-400 hover:text-gray-600",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                copiedField === 'userId' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-green-600 text-xs",
                                                                    children: "Copied!"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm font-medium text-gray-500 mb-1",
                                                            children: "Application ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-mono text-sm",
                                                                    children: payment.applicationId
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>copyToClipboard(payment.applicationId, 'appId'),
                                                                    className: "text-gray-400 hover:text-gray-600",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                copiedField === 'appId' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-green-600 text-xs",
                                                                    children: "Copied!"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                "Timeline"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "space-y-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w-2 h-2 bg-blue-500 rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-medium",
                                                                    children: "Payment Created"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "text-sm text-gray-500",
                                                                    children: formatDate(payment.createdAt)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                payment.paidAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-3 p-3 bg-green-50 rounded-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w-2 h-2 bg-green-500 rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-medium",
                                                                    children: "Payment Succeeded"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "text-sm text-gray-500",
                                                                    children: formatDate(payment.paidAt)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                payment.refundedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-3 p-3 bg-blue-50 rounded-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w-2 h-2 bg-blue-500 rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-medium",
                                                                    children: "Payment Refunded"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "text-sm text-gray-500",
                                                                    children: formatDate(payment.refundedAt)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                            children: "Actions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                                        className: "space-y-3",
                                        children: [
                                            canRefund && refundableAmount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                                onClick: ()=>setShowRefundDialog(true),
                                                className: "w-full flex items-center gap-2",
                                                variant: "outline",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    "Process Refund"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                                onClick: ()=>window.open(`https://dashboard.stripe.com/payments/${payment.stripePaymentIntentId}`, '_blank'),
                                                className: "w-full flex items-center gap-2",
                                                variant: "outline",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    "View in Stripe"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            payment.refunds && payment.refunds.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                            children: "Refunds"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "space-y-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex justify-between text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-500",
                                                            children: "Total Refunded:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                                            className: "font-medium text-red-600",
                                                            children: [
                                                                "-",
                                                                formatCurrency(totalRefunded)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex justify-between text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-gray-500",
                                                            children: "Refundable:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "font-medium",
                                                            children: formatCurrency(refundableAmount)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "border-t pt-3 space-y-2",
                                                    children: payment.refunds.map((refund, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex justify-between text-sm",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "text-gray-500",
                                                                    children: formatDate(refund.createdAt)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                                                    className: "font-medium text-red-600",
                                                                    children: [
                                                                        "-",
                                                                        formatCurrency(refund.amount)
                                                                    ]
                                                                })
                                                            ]
                                                        }, index))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            payment.metadata && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                            children: "Metadata"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                            className: "text-xs bg-gray-50 p-3 rounded-lg overflow-x-auto",
                                            children: JSON.stringify(payment.metadata, null, 2)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showRefundDialog && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cdb0e05ee407659$export$2e2bcd8739ae039), {
                payment: payment,
                maxRefundAmount: refundableAmount,
                onClose: ()=>setShowRefundDialog(false),
                onSuccess: (updatedPayment)=>{
                    setShowRefundDialog(false);
                // Payment would be updated by parent component
                }
            })
        ]
    });
};
var $54a3940106cc90b2$export$2e2bcd8739ae039 = $54a3940106cc90b2$var$PaymentDetails;




const $9d0faa6baab94642$var$PaymentManagement = ()=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)('list');
    const [selectedPayment, setSelectedPayment] = (0, $acw62.useState)(null);
    const [payments, setPayments] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)('all');
    (0, $acw62.useEffect)(()=>{
        fetchPayments();
    }, []);
    const fetchPayments = async ()=>{
        try {
            setIsLoading(true);
            setError(null);
            // Fetch all payments for admin dashboard
            const response = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getAllPayments();
            // paymentService now returns array directly, not wrapped in payments property
            setPayments(Array.isArray(response) ? response : []);
        } catch (err) {
            console.error('Error fetching payments:', err);
            setError('Failed to load payments');
        } finally{
            setIsLoading(false);
        }
    };
    const handlePaymentSelect = (payment)=>{
        setSelectedPayment(payment);
        setActiveTab('details');
    };
    const handleRefundSuccess = (updatedPayment)=>{
        setPayments(payments.map((p)=>p.id === updatedPayment.id ? updatedPayment : p));
        setSelectedPayment(updatedPayment);
    };
    const filteredPayments = payments.filter((payment)=>{
        const matchesSearch = !searchTerm || payment.customerEmail.toLowerCase().includes(searchTerm.toLowerCase()) || payment.applicationId.toLowerCase().includes(searchTerm.toLowerCase()) || payment.id.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === 'all' || payment.status === statusFilter;
        return matchesSearch && matchesStatus;
    });
    const tabs = [
        {
            id: 'list',
            label: 'All Payments',
            icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039)
        },
        {
            id: 'details',
            label: 'Payment Details',
            icon: (0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039),
            disabled: !selectedPayment
        },
        {
            id: 'refunds',
            label: 'Refund Manager',
            icon: (0, $8a800148d042d893$export$2e2bcd8739ae039)
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                className: "mb-2",
                                children: "Payment Management"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-gray-600",
                                children: "Manage payments, process refunds, and view transaction details"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                onClick: fetchPayments,
                                variant: "outline",
                                size: "sm",
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Refresh"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Export"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                    className: "p-0",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "border-b",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                                className: "flex space-x-8 px-6",
                                children: tabs.map((tab)=>{
                                    const Icon = tab.icon;
                                    const isActive = activeTab === tab.id;
                                    const isDisabled = tab.disabled;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>!isDisabled && setActiveTab(tab.id),
                                        disabled: isDisabled,
                                        className: `flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${isActive ? 'border-[#00796b] text-[#00796b]' : isDisabled ? 'border-transparent text-gray-400 cursor-not-allowed' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                className: "h-4 w-4"
                                            }),
                                            tab.label
                                        ]
                                    }, tab.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p-6",
                            children: [
                                activeTab === 'list' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-6 flex flex-col sm:flex-row gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex-1 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                    className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Search by email, application ID, or payment ID...",
                                                    value: searchTerm,
                                                    onChange: (e)=>setSearchTerm(e.target.value),
                                                    className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#00796b] focus:border-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05e483c418a01d8d$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4 text-gray-400"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: statusFilter,
                                                    onChange: (e)=>setStatusFilter(e.target.value),
                                                    className: "border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "all",
                                                            children: "All Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "pending",
                                                            children: "Pending"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "succeeded",
                                                            children: "Succeeded"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "failed",
                                                            children: "Failed"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "refunded",
                                                            children: "Refunded"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "partially_refunded",
                                                            children: "Partially Refunded"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mb-6 p-4 bg-red-50 border border-red-200 rounded-md",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 text-red-700",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                children: error
                                            })
                                        ]
                                    })
                                }),
                                activeTab === 'list' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f40f2a58923f69a0$export$2e2bcd8739ae039), {
                                    payments: filteredPayments,
                                    isLoading: isLoading,
                                    onPaymentSelect: handlePaymentSelect
                                }),
                                activeTab === 'details' && selectedPayment && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54a3940106cc90b2$export$2e2bcd8739ae039), {
                                    payment: selectedPayment,
                                    onBack: ()=>setActiveTab('list')
                                }),
                                activeTab === 'refunds' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cdb0e05ee407659$export$2e2bcd8739ae039), {
                                    payments: payments.filter((p)=>p.status === 'succeeded' || p.status === 'partially_refunded'),
                                    onRefundSuccess: handleRefundSuccess
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $9d0faa6baab94642$export$2e2bcd8739ae039 = $9d0faa6baab94642$var$PaymentManagement;


/**
 * TrademarkManagement Component
 * 
 * Admin interface for managing trademark applications and analysis
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");


const $0d82ad204011931d$export$47765fe28c1215f7 = {
    // Get applications for a specific user
    getApplicationsByUser: async (userId)=>{
        try {
            if (!userId) throw new Error('User ID is required');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications', {
                params: {
                    userId: userId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching applications for user ${userId}:`, error);
            throw error;
        }
    },
    // Get all applications (admin only)
    getAllApplications: async ()=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications?admin=true');
            // Ensure we return an array, handle different response formats
            const data = response.data;
            if (Array.isArray(data)) return data;
            else if (data && Array.isArray(data.applications)) return data.applications;
            else {
                console.warn('Unexpected response format from getAllApplications:', data);
                return [];
            }
        } catch (error) {
            console.error('Error fetching all applications:', error);
            // Return empty array instead of throwing to prevent frontend crashes
            return [];
        }
    },
    // Get applications for a trademark
    getApplications: async (trademarkId)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications', {
                params: {
                    trademarkId: trademarkId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching applications for trademark ${trademarkId}:`, error);
            throw error;
        }
    },
    // Get a specific application
    getApplication: async (applicationId)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications', {
                params: {
                    id: applicationId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching application ${applicationId}:`, error);
            throw error;
        }
    },
    // Create a new application (supports legacy and dashboard payloads)
    createApplication: async (...args)=>{
        try {
            if (args.length === 1 && typeof args[0] === 'object' && !Array.isArray(args[0])) {
                const payload = args[0];
                if (!payload.userId) payload.userId = (0, $d772b9961fd001e4$export$1617268687ac763c)();
                if (!payload.userId) throw new Error('User not authenticated');
                const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', payload);
                return response.data;
            }
            const [trademarkId, country, classNumbers] = args;
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', {
                trademarkId: trademarkId,
                country: country,
                filingDetails: {
                    classes: classNumbers
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error creating application:', error);
            throw error;
        }
    },
    // Get country-specific requirements
    getCountryRequirements: async (country)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications', {
                params: {
                    countryRequirements: country
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching requirements for ${country}:`, error);
            throw error;
        }
    },
    // Country specialist methods for detailed country-specific info
    countrySpecialist: {
        // Get country-specific requirements for trademark filing
        getRequirements: async (countryCode, trademark, sessionId)=>{
            try {
                const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/countries/requirements', {
                    params: {
                        countryCode: countryCode,
                        trademarkId: trademark?.id,
                        sessionId: sessionId
                    }
                });
                return response.data;
            } catch (error) {
                console.error(`Error fetching requirements for ${countryCode}:`, error);
                throw error;
            }
        }
    },
    // Update trademark application with selected countries, classes, etc.
    updateTrademarkApplication: async (trademarkId, countries, classes, descriptions, totalPrice, userId = null)=>{
        try {
            // Get authenticated user ID
            const authUserId = userId || (0, $d772b9961fd001e4$export$1617268687ac763c)();
            if (!authUserId) throw new Error('User not authenticated');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', {
                trademarkId: trademarkId,
                countries: countries,
                classes: classes,
                descriptions: descriptions,
                totalPrice: totalPrice,
                userId: authUserId,
                timestamp: new Date().toISOString()
            });
            return response.data;
        } catch (error) {
            console.error(`Error updating trademark application ${trademarkId}:`, error);
            throw error;
        }
    },
    // Update application status
    updateApplicationStatus: async (applicationId, status, details = {})=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', {
                id: applicationId,
                status: status,
                ...details
            });
            return response.data;
        } catch (error) {
            console.error(`Error updating application ${applicationId} status:`, error);
            throw error;
        }
    },
    // Update trademark filing details (country and class selections)
    updateFilingDetails: async (trademarkId, countries, classes, goodsServices)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/Database/trademarks/update', {
                id: trademarkId,
                filing: {
                    selectedCountries: countries,
                    selectedClasses: classes,
                    goodsServices: goodsServices
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error updating filing details for trademark ${trademarkId}:`, error);
            throw error;
        }
    },
    // Cancel an application
    cancelApplication: async (applicationId)=>{
        try {
            if (!applicationId) throw new Error('Application ID is required');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/applications', {
                id: applicationId,
                status: 'cancelled'
            });
            return response.data;
        } catch (error) {
            console.error(`Error cancelling application ${applicationId}:`, error);
            throw error;
        }
    },
    // Get filing statuses for a trademark across multiple countries
    getFilingStatuses: async (trademarkId, countries, userId = null)=>{
        try {
            // Get authenticated user ID
            const authUserId = userId || (0, $d772b9961fd001e4$export$1617268687ac763c)();
            if (!authUserId) throw new Error('User not authenticated');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/applications/status', {
                params: {
                    trademarkId: trademarkId,
                    countries: countries.join(','),
                    userId: authUserId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching filing statuses for trademark ${trademarkId}:`, error);
            throw error;
        }
    }
};
var $0d82ad204011931d$export$2e2bcd8739ae039 = $0d82ad204011931d$export$47765fe28c1215f7;




const $c6f15fd1cca43850$export$c886523079b18bf8 = {
    // Update a trademark with application ID to ensure bidirectional linking
    updateTrademarkApplication: async (trademarkId, applicationId)=>{
        try {
            if (!trademarkId || !applicationId) throw new Error('Trademark ID and Application ID are required');
            console.log('Updating trademark', trademarkId, 'with applicationId:', applicationId);
            // Use POST with id in body, following trademark API pattern
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/trademarks`, {
                id: trademarkId,
                applicationId: applicationId
            });
            console.log('Trademark updated successfully:', response.data);
            return response.data;
        } catch (error) {
            console.error(`Error updating trademark ${trademarkId} with application ${applicationId}:`, error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            throw error;
        }
    },
    // Get all trademarks for the current user
    getTrademarks: async (userId = null)=>{
        try {
            // Get user ID from auth utility if not provided
            const identifier = userId || (0, $d772b9961fd001e4$export$1617268687ac763c)();
            if (!identifier) throw new Error('User not authenticated');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/trademarks', {
                params: {
                    userId: identifier
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching trademarks:', error);
            throw error;
        }
    },
    // Get trademarks for a specific application
    getTrademarksByApplication: async (applicationId)=>{
        try {
            if (!applicationId) throw new Error('Application ID is required');
            console.log("\uD83D\uDD0D trademarkService.getTrademarksByApplication called with:", applicationId); // This will show the full call stack
            console.log("\uD83D\uDD0D Making API call: GET /trademarks with params:", {
                applicationId: applicationId
            });
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/trademarks', {
                params: {
                    applicationId: applicationId
                }
            });
            console.log("\uD83D\uDD0D trademarkService API response:", response.data);
            return response.data;
        } catch (error) {
            console.error(`Error fetching trademarks for application ${applicationId}:`, error);
            throw error;
        }
    },
    // Process trademark with Vision API
    processWithVisionAPI: async (trademarkId)=>{
        try {
            if (!trademarkId) throw new Error('Trademark ID is required');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/visionapi', {
                trademarkId: trademarkId
            });
            return response.data;
        } catch (error) {
            console.error(`Error processing trademark ${trademarkId} with Vision API:`, error);
            throw error;
        }
    },
    // Get vision analysis results for a trademark
    getVisionAnalysis: async (trademarkId)=>{
        try {
            if (!trademarkId) throw new Error('Trademark ID is required');
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/visionAnalysis?trademarkId=${trademarkId}`);
            return response.data;
        } catch (error) {
            console.error(`Error getting vision analysis for trademark ${trademarkId}:`, error);
            throw error;
        }
    },
    // Get a specific trademark by ID
    getTrademark: async (id)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/trademarks`, {
                params: {
                    id: id
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching trademark ${id}:`, error);
            throw error;
        }
    },
    // Create a new trademark
    createTrademark: async (data)=>{
        try {
            // Make sure we have the applicationId from sessionStorage if not provided
            const applicationId = data.applicationId || sessionStorage.getItem('currentApplicationId');
            const payload = {
                ...data,
                applicationId: applicationId
            };
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/trademarks', payload);
            return response.data;
        } catch (error) {
            console.error('Error creating trademark:', error);
            throw error;
        }
    },
    // Update an existing trademark
    updateTrademark: async (id, data)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/trademarks', {
                id: id,
                ...data
            });
            return response.data;
        } catch (error) {
            console.error(`Error updating trademark ${id}:`, error);
            throw error;
        }
    },
    // Delete a trademark
    deleteTrademark: async (id)=>{
        try {
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/Database/trademarks/delete', {
                id: id
            });
            return response.data;
        } catch (error) {
            console.error(`Error deleting trademark ${id}:`, error);
            throw error;
        }
    },
    // Upload a trademark image
    uploadTrademarkImage: async (id, file)=>{
        try {
            // Convert file to base64 for JSON transmission
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = async ()=>{
                    try {
                        // Get the base64 data
                        const base64data = reader.result;
                        // Create payload for the trademarks API
                        const payload = {
                            id: id,
                            type: 'figurative',
                            content: {
                                data: base64data,
                                name: file.name
                            }
                        };
                        // Get user ID - authentication is required
                        const userId = (0, $d772b9961fd001e4$export$1617268687ac763c)();
                        if (!userId) throw new Error('User not authenticated');
                        // Add authentication info
                        payload.userId = userId;
                        // Use the main trademarks API
                        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/trademarks', payload, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            timeout: 30000 // 30 second timeout for large image uploads
                        });
                        resolve(response.data);
                    } catch (error) {
                        console.error(`Error uploading image for trademark ${id}:`, error);
                        reject(error);
                    }
                };
                reader.onerror = (error)=>{
                    console.error('Error reading file:', error);
                    reject(error);
                };
            });
        } catch (error) {
            console.error(`Error uploading image for trademark ${id}:`, error);
            throw error;
        }
    },
    // Upload a trademark (word mark or logo)
    uploadTrademark: async (trademarkData)=>{
        try {
            console.log('Uploading trademark with data:', trademarkData);
            // Get user ID from input or auth utility
            let userId = trademarkData.userId || (0, $d772b9961fd001e4$export$1617268687ac763c)();
            const threadId = trademarkData.threadId; // Get threadId if provided
            const applicationId = trademarkData.applicationId || sessionStorage.getItem('currentApplicationId'); // Get applicationId
            if (!userId) throw new Error('User not authenticated');
            console.log("\uD83D\uDCDD uploadTrademark: IDs being used:", {
                userId: userId,
                threadId: threadId,
                applicationId: applicationId,
                trademarkType: trademarkData.type
            });
            // Prepare data for upload based on trademark type
            let dataToSend;
            if (trademarkData.type === 'word') // For word trademarks, use simple data structure
            dataToSend = {
                id: trademarkData.id || undefined,
                userId: userId,
                threadId: threadId,
                applicationId: applicationId,
                type: 'word',
                content: trademarkData.content,
                name: trademarkData.content,
                timestamp: trademarkData.timestamp || new Date().toISOString(),
                status: trademarkData.status || 'pending'
            };
            else // For image trademarks, ensure proper content structure
            dataToSend = {
                id: trademarkData.id || undefined,
                userId: userId,
                threadId: threadId,
                applicationId: applicationId,
                type: trademarkData.type,
                content: {
                    name: trademarkData.content?.name || 'image.png',
                    type: trademarkData.content?.type || 'image/png',
                    size: trademarkData.content?.size,
                    data: trademarkData.content?.data
                },
                name: trademarkData.content?.name || 'Trademark Image',
                timestamp: trademarkData.timestamp || new Date().toISOString(),
                status: trademarkData.status || 'pending'
            };
            // Use the main trademarks endpoint directly for all uploads
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/trademarks', dataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000 // 30 second timeout for large image uploads
            });
            const savedTrademark = response.data;
            console.log('Trademark upload successful:', savedTrademark.id);
            // Automatically trigger Vision API processing in the background if it's a logo or figurative trademark
            if ((dataToSend.type === 'logo' || dataToSend.type === 'figurative' || dataToSend.type === 'word') && savedTrademark.id) {
                console.log('Queuing Vision API processing for trademark:', savedTrademark.id, 'type:', dataToSend.type);
                // Fire and forget - don't await the response but implement retry logic
                setTimeout(async ()=>{
                    // Prepare the payload with all necessary context
                    const payload = {
                        trademark: savedTrademark,
                        threadId: threadId || savedTrademark.threadId,
                        applicationId: dataToSend.applicationId || savedTrademark.applicationId,
                        userId: savedTrademark.userId || dataToSend.userId
                    };
                    // Logging the full context being sent for vision processing
                    console.log('Vision API context being sent:', {
                        trademarkId: savedTrademark.id,
                        threadId: payload.threadId,
                        applicationId: payload.applicationId,
                        userId: payload.userId
                    });
                    // Implement retry logic for better resilience
                    let retries = 0;
                    const maxRetries = 3;
                    let success = false;
                    while(retries < maxRetries && !success)try {
                        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/visionapi', payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            timeout: 120000 // 2 minute timeout for vision processing
                        });
                        console.log('Background Vision API processing successful:', response.data);
                        console.log("\uD83D\uDD04 Vision API completed during upload, notifying TrademarkContext to reload");
                        const event = new CustomEvent('trademark_vision_completed', {
                            detail: {
                                trademarkId: savedTrademark.id
                            }
                        });
                        window.dispatchEvent(event);
                        success = true;
                    } catch (visionError) {
                        retries++;
                        console.error(`Vision API processing attempt ${retries} failed:`, visionError.message);
                        if (retries < maxRetries) {
                            // Wait before retry with exponential backoff
                            await new Promise((resolve)=>setTimeout(resolve, 1000 * Math.pow(2, retries)));
                            console.log(`Retrying Vision API processing (attempt ${retries + 1} of ${maxRetries})`);
                        } else console.error('Vision API processing failed after maximum retries');
                    }
                }, 100); // Small delay to ensure upload completes first
            }
            return savedTrademark;
        } catch (error) {
            console.error('Error uploading trademark:', error);
            throw error;
        }
    },
    // Update a trademark with user ID (used for transferring from session to user)
    updateTrademarkUser: async (id, userId)=>{
        try {
            console.log(`Updating trademark ${id} with user ID ${userId}`);
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/Database/trademarks/update', {
                id: id,
                userId: userId,
                sessionId: null // Clear session ID when assigning to a user
            });
            return response.data;
        } catch (error) {
            console.error(`Error updating trademark user ${id}:`, error);
            throw error;
        }
    }
};
var $c6f15fd1cca43850$export$2e2bcd8739ae039 = $c6f15fd1cca43850$export$c886523079b18bf8;


const $e4e9f08291f7c6e2$var$TrademarkManagement = ()=>{
    const [applications, setApplications] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)('all');
    (0, $acw62.useEffect)(()=>{
        fetchApplications();
    }, []);
    const fetchApplications = async ()=>{
        try {
            setIsLoading(true);
            setError(null);
            // Fetch all applications from backend
            const response = await (0, $0d82ad204011931d$export$47765fe28c1215f7).getAllApplications();
            // API returns array directly, not wrapped in applications property
            setApplications(Array.isArray(response) ? response : []);
        } catch (err) {
            console.error('Error fetching applications:', err);
            setError('Failed to load trademark applications');
        } finally{
            setIsLoading(false);
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const getStatusIcon = (status)=>{
        switch(status){
            case 'completed':
            case 'registered':
            case 'filed':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-green-500"
                });
            case 'pending':
            case 'quote_requested':
            case 'quote_sent':
            case 'payment_pending':
            case 'pending_attorney_filing':
            case 'filing_in_progress':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-yellow-500"
                });
            case 'failed':
            case 'rejected':
            case 'cancelled':
            case 'refunded':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-red-500"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 text-gray-500"
                });
        }
    };
    const getStatusColor = (status)=>{
        switch(status){
            case 'completed':
            case 'registered':
            case 'filed':
                return 'bg-green-100 text-green-800';
            case 'quote_requested':
                return 'bg-blue-100 text-blue-800';
            case 'quote_sent':
                return 'bg-amber-100 text-amber-800';
            case 'pending':
            case 'payment_pending':
            case 'pending_attorney_filing':
            case 'filing_in_progress':
                return 'bg-yellow-100 text-yellow-800';
            case 'failed':
            case 'rejected':
            case 'cancelled':
            case 'refunded':
                return 'bg-red-100 text-red-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };
    const STATUS_LABELS = {
        active: 'Active',
        draft: 'Draft',
        quote_requested: 'Quote Requested',
        quote_sent: 'Quote Sent',
        payment_pending: 'Payment Pending',
        payment_completed: 'Payment Completed',
        pending_attorney_filing: 'Pending Filing',
        filing_in_progress: 'Filing in Progress',
        filed: 'Filed',
        registered: 'Registered',
        completed: 'Completed',
        cancelled: 'Cancelled',
        refunded: 'Refunded'
    };
    const getStatusLabel = (status)=>STATUS_LABELS[status] || status || 'pending';
    const filteredApplications = applications.filter((app)=>{
        const matchesSearch = !searchTerm || app.trademarkName?.toLowerCase().includes(searchTerm.toLowerCase()) || app.applicantName?.toLowerCase().includes(searchTerm.toLowerCase()) || app.id?.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === 'all' || app.status === statusFilter;
        return matchesSearch && matchesStatus;
    });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "space-y-4",
        children: [
            ...Array(5)
        ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "animate-pulse",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "h-16 bg-gray-200 rounded-lg"
                })
            }, i))
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "text-center py-8",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    className: "h-12 w-12 text-red-500 mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                    className: "mb-2 text-red-900",
                    children: "Error Loading Applications"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    className: "text-gray-600 mb-4",
                    children: error
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                    onClick: fetchApplications,
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                            className: "h-4 w-4"
                        }),
                        "Retry"
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                className: "mb-2",
                                children: "Trademark Applications"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-gray-600",
                                children: "Manage and monitor all trademark applications"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                onClick: fetchApplications,
                                variant: "outline",
                                size: "sm",
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Refresh"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Export"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                    className: "p-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-1 relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search by trademark name, applicant, or ID...",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        className: "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#00796b] focus:border-transparent"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05e483c418a01d8d$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: statusFilter,
                                        onChange: (e)=>setStatusFilter(e.target.value),
                                        className: "border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "all",
                                                children: "All Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "active",
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "quote_requested",
                                                children: "Quote Requested"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "quote_sent",
                                                children: "Quote Sent"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "pending_attorney_filing",
                                                children: "Pending Filing"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "filing_in_progress",
                                                children: "Filing in Progress"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "filed",
                                                children: "Filed"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "registered",
                                                children: "Registered"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "completed",
                                                children: "Completed"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "cancelled",
                                                children: "Cancelled"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "refunded",
                                                children: "Refunded"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                    className: "p-0",
                    children: filteredApplications.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-center py-12",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                className: "h-12 w-12 text-gray-400 mx-auto mb-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-lg font-medium text-gray-900 mb-2",
                                children: "No applications found"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-gray-500",
                                children: "No trademark applications match your current search criteria."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "min-w-full divide-y divide-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "bg-gray-50",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Application"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Applicant"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Created"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-200",
                                    children: filteredApplications.map((application)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: "hover:bg-gray-50",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex-shrink-0",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                    className: "h-8 w-8 text-gray-400"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "ml-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "text-sm font-medium text-gray-900",
                                                                        children: application.trademarkName || 'Unnamed Trademark'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "text-sm text-gray-500",
                                                                        children: [
                                                                            "ID: ",
                                                                            application.id
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 text-gray-400 mr-2"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "text-sm font-medium text-gray-900",
                                                                        children: application.applicantName || 'N/A'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "text-sm text-gray-500",
                                                                        children: application.applicantEmail || 'N/A'
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            getStatusIcon(application.status),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `ml-2 inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(application.status)}`,
                                                                children: getStatusLabel(application.status)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 mr-2"
                                                            }),
                                                            formatDate(application.createdAt)
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm font-medium",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                                        variant: "outline",
                                                        size: "sm",
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            }),
                                                            "View"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, application.id))
                                })
                            ]
                        })
                    })
                })
            }),
            filteredApplications.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                        className: "text-sm text-gray-700",
                        children: [
                            "Showing ",
                            filteredApplications.length,
                            " applications"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                disabled: true,
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                disabled: true,
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e4e9f08291f7c6e2$export$2e2bcd8739ae039 = $e4e9f08291f7c6e2$var$TrademarkManagement;


/**
 * UserManagement Component
 *
 * Admin interface for managing MarkoTM organization users
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ce27ddd7f5ebc71c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
            key: "1vdc57"
        }
    ],
    [
        "path",
        {
            d: "M5 21h14",
            key: "11awu3"
        }
    ]
];
const $ce27ddd7f5ebc71c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Crown", $ce27ddd7f5ebc71c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Trash2", $1d55a58c47e43a5b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $09365e579c2377bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "19",
            y1: "8",
            y2: "14",
            key: "1bvyxn"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "11",
            y2: "11",
            key: "1shjgl"
        }
    ]
];
const $09365e579c2377bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UserPlus", $09365e579c2377bf$export$3efd853dbb351e94);



var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");

// API functions
const $f2bd98c8edc05283$var$fetchAdminUsers = async ()=>{
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/admin/users');
    return response.data;
};
const $f2bd98c8edc05283$var$inviteUser = async ({ email: email, role: role })=>{
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/admin/users/invite', {
        email: email,
        role: role
    });
    return response.data;
};
const $f2bd98c8edc05283$var$removeUser = async (userId)=>{
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).delete(`/admin/users/${userId}`);
    return response.data;
};
const $f2bd98c8edc05283$var$updateUserRole = async ({ userId: userId, role: role })=>{
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).patch(`/admin/users/${userId}/role`, {
        role: role
    });
    return response.data;
};
const $f2bd98c8edc05283$var$UserManagement = ()=>{
    const { user: currentUser } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [showInviteModal, setShowInviteModal] = (0, $acw62.useState)(false);
    const [inviteEmail, setInviteEmail] = (0, $acw62.useState)('');
    const [inviteRole, setInviteRole] = (0, $acw62.useState)('org:member');
    const [confirmRemove, setConfirmRemove] = (0, $acw62.useState)(null);
    const [confirmRoleChange, setConfirmRoleChange] = (0, $acw62.useState)(null);
    // Fetch users query
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'adminUsers'
        ],
        queryFn: $f2bd98c8edc05283$var$fetchAdminUsers
    });
    // Invite mutation
    const inviteMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: $f2bd98c8edc05283$var$inviteUser,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'adminUsers'
                ]
            });
            setShowInviteModal(false);
            setInviteEmail('');
            setInviteRole('org:member');
        }
    });
    // Remove mutation
    const removeMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: $f2bd98c8edc05283$var$removeUser,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'adminUsers'
                ]
            });
            setConfirmRemove(null);
        }
    });
    // Update role mutation
    const updateRoleMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: $f2bd98c8edc05283$var$updateUserRole,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'adminUsers'
                ]
            });
            setConfirmRoleChange(null);
        }
    });
    const members = data?.members || [];
    const invitations = data?.invitations || [];
    const handleInvite = async (e)=>{
        e.preventDefault();
        if (!inviteEmail.trim()) return;
        inviteMutation.mutate({
            email: inviteEmail.trim(),
            role: inviteRole
        });
    };
    const handleRemove = (userId)=>{
        removeMutation.mutate(userId);
    };
    const handleRoleChange = (userId, newRole)=>{
        updateRoleMutation.mutate({
            userId: userId,
            role: newRole
        });
    };
    const getRoleLabel = (role)=>{
        switch(role){
            case 'org:admin':
                return 'Admin';
            case 'org:member':
                return 'Member';
            default:
                return role;
        }
    };
    const getRoleBadgeClass = (role)=>{
        switch(role){
            case 'org:admin':
                return 'bg-purple-100 text-purple-800';
            case 'org:member':
                return 'bg-gray-100 text-gray-800';
            default:
                return 'bg-gray-100 text-gray-600';
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-between items-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                            className: "mb-2",
                            children: "User Management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                            className: "text-gray-600",
                            children: "Manage MarkoTM organization users"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                    className: "p-8 flex justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                            className: "h-8 w-8 animate-spin text-[#00796b]"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ml-3 text-gray-600",
                            children: "Loading users..."
                        })
                    ]
                })
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-between items-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                            className: "mb-2",
                            children: "User Management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                            className: "text-gray-600",
                            children: "Manage MarkoTM organization users"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                className: "border-red-200 bg-red-50",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                    className: "p-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-red-600"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "font-medium text-red-900",
                                            children: "Failed to load users"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-red-700",
                                            children: error.message
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                            variant: "outline",
                            size: "sm",
                            className: "mt-4",
                            onClick: ()=>refetch(),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 mr-2"
                                }),
                                "Retry"
                            ]
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                className: "mb-2",
                                children: "User Management"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-gray-600",
                                children: "Manage MarkoTM organization users and their roles"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                        onClick: ()=>setShowInviteModal(true),
                        className: "bg-[#00796b] hover:bg-[#00695c] text-white",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09365e579c2377bf$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 mr-2"
                            }),
                            "Invite User"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-3 gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "bg-[#e0f2f1] p-2 rounded-full mr-3",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-[#00796b]"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-500",
                                                children: "Total Members"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-lg font-bold",
                                                children: members.length
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "bg-purple-50 p-2 rounded-full mr-3",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce27ddd7f5ebc71c$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-purple-600"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-500",
                                                children: "Admins"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-lg font-bold",
                                                children: members.filter((m)=>m.role === 'org:admin').length
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "bg-amber-50 p-2 rounded-full mr-3",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-amber-600"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm font-medium text-gray-500",
                                                children: "Pending Invitations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-lg font-bold",
                                                children: invitations.length
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                        className: "border-b border-gray-200",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-[#00796b]"
                                }),
                                "Team Members (",
                                members.length,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                        className: "p-0",
                        children: members.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p-8 text-center text-gray-500",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                    className: "h-12 w-12 mx-auto mb-3 opacity-50"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                    children: "No team members yet"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                    className: "text-sm mt-1",
                                    children: "Invite users to get started"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "divide-y divide-gray-100",
                            children: members.map((member)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "p-4 flex items-center justify-between hover:bg-gray-50 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h-10 w-10 rounded-full bg-[#e0f2f1] flex items-center justify-center text-[#00796b] font-semibold",
                                                    children: (member.name || member.email || '?')[0].toUpperCase()
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                                    className: "font-medium text-gray-900",
                                                                    children: member.name || member.email
                                                                }),
                                                                member.isCurrentUser && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "text-sm text-gray-500",
                                                            children: member.email
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                member.isCurrentUser ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `px-2.5 py-1 rounded-full text-xs font-medium ${getRoleBadgeClass(member.role)}`,
                                                    children: getRoleLabel(member.role)
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: member.role,
                                                    onChange: (e)=>setConfirmRoleChange({
                                                            userId: member.userId,
                                                            name: member.name || member.email,
                                                            newRole: e.target.value,
                                                            currentRole: member.role
                                                        }),
                                                    className: "text-sm border border-gray-200 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[#00796b]",
                                                    disabled: updateRoleMutation.isPending,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "org:admin",
                                                            children: "Admin"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "org:member",
                                                            children: "Member"
                                                        })
                                                    ]
                                                }),
                                                !member.isCurrentUser && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                                    variant: "ghost",
                                                    size: "sm",
                                                    className: "text-red-600 hover:text-red-800 hover:bg-red-50",
                                                    onClick: ()=>setConfirmRemove(member),
                                                    disabled: removeMutation.isPending,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, member.userId))
                        })
                    })
                ]
            }),
            invitations.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                        className: "border-b border-gray-200",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-amber-600"
                                }),
                                "Pending Invitations (",
                                invitations.length,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                        className: "p-0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "divide-y divide-gray-100",
                            children: invitations.map((invitation)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "p-4 flex items-center justify-between hover:bg-gray-50 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h-10 w-10 rounded-full bg-amber-50 flex items-center justify-center text-amber-600",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                            className: "font-medium text-gray-900",
                                                            children: invitation.email
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                                            className: "text-sm text-gray-500",
                                                            children: [
                                                                "Sent ",
                                                                formatDate(invitation.createdAt)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `px-2.5 py-1 rounded-full text-xs font-medium ${getRoleBadgeClass(invitation.role)}`,
                                                    children: getRoleLabel(invitation.role)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "px-2.5 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800",
                                                    children: "Pending"
                                                })
                                            ]
                                        })
                                    ]
                                }, invitation.id))
                        })
                    })
                ]
            }),
            showInviteModal && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-xl max-w-md w-full",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p-6 border-b border-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "text-lg font-semibold text-gray-900",
                                            children: "Invite User"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>setShowInviteModal(false),
                                            className: "text-gray-400 hover:text-gray-600",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-gray-600 mt-1",
                                    children: "Invite a new user to the MarkoTM organization"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleInvite,
                            className: "p-6 space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Email Address"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "email",
                                            value: inviteEmail,
                                            onChange: (e)=>setInviteEmail(e.target.value),
                                            placeholder: "user@example.com",
                                            required: true,
                                            autoFocus: true,
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#00796b] focus:border-transparent"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: inviteRole,
                                            onChange: (e)=>setInviteRole(e.target.value),
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "org:member",
                                                    children: "Member - Basic access"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "org:admin",
                                                    children: "Admin - Full administrative access"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-gray-50 rounded-md p-3",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-start gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 text-gray-500 mt-0.5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "An email invitation will be sent to join the MarkoTM organization. They'll receive a link to sign up or sign in."
                                            })
                                        ]
                                    })
                                }),
                                inviteMutation.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-red-50 border border-red-200 rounded-md p-3",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 text-red-600"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-sm text-red-700",
                                                children: inviteMutation.error.response?.data?.message || inviteMutation.error.message
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex gap-3 pt-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                            type: "button",
                                            variant: "outline",
                                            className: "flex-1",
                                            onClick: ()=>setShowInviteModal(false),
                                            disabled: inviteMutation.isPending,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                            type: "submit",
                                            className: "flex-1 bg-[#00796b] hover:bg-[#00695c] text-white",
                                            disabled: !inviteEmail.trim() || inviteMutation.isPending,
                                            children: inviteMutation.isPending ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 mr-2 animate-spin"
                                                    }),
                                                    "Sending..."
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 mr-2"
                                                    }),
                                                    "Send Invitation"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            confirmRemove && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-xl max-w-md w-full p-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3 mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-10 w-10 rounded-full bg-red-100 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-red-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "text-lg font-semibold text-gray-900",
                                            children: "Remove User"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-600",
                                            children: "This action cannot be undone"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "text-gray-700 mb-6",
                            children: [
                                "Are you sure you want to remove ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: confirmRemove.name || confirmRemove.email
                                }),
                                " from the MarkoTM organization?"
                            ]
                        }),
                        removeMutation.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 border border-red-200 rounded-md p-3 mb-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-red-600"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-red-700",
                                        children: removeMutation.error.response?.data?.message || removeMutation.error.message
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                    variant: "outline",
                                    className: "flex-1",
                                    onClick: ()=>setConfirmRemove(null),
                                    disabled: removeMutation.isPending,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                    className: "flex-1 bg-red-600 hover:bg-red-700 text-white",
                                    onClick: ()=>handleRemove(confirmRemove.userId),
                                    disabled: removeMutation.isPending,
                                    children: removeMutation.isPending ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 mr-2 animate-spin"
                                            }),
                                            "Removing..."
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 mr-2"
                                            }),
                                            "Remove User"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            confirmRoleChange && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-xl max-w-md w-full p-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3 mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-purple-600"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "text-lg font-semibold text-gray-900",
                                            children: "Change Role"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-600",
                                            children: "Update user permissions"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "text-gray-700 mb-6",
                            children: [
                                "Change ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: confirmRoleChange.name
                                }),
                                "'s role from",
                                ' ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `px-1.5 py-0.5 rounded text-xs font-medium ${getRoleBadgeClass(confirmRoleChange.currentRole)}`,
                                    children: getRoleLabel(confirmRoleChange.currentRole)
                                }),
                                ' ',
                                "to",
                                ' ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `px-1.5 py-0.5 rounded text-xs font-medium ${getRoleBadgeClass(confirmRoleChange.newRole)}`,
                                    children: getRoleLabel(confirmRoleChange.newRole)
                                }),
                                "?"
                            ]
                        }),
                        updateRoleMutation.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 border border-red-200 rounded-md p-3 mb-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-red-600"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-red-700",
                                        children: updateRoleMutation.error.response?.data?.message || updateRoleMutation.error.message
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                    variant: "outline",
                                    className: "flex-1",
                                    onClick: ()=>setConfirmRoleChange(null),
                                    disabled: updateRoleMutation.isPending,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                                    className: "flex-1 bg-[#00796b] hover:bg-[#00695c] text-white",
                                    onClick: ()=>handleRoleChange(confirmRoleChange.userId, confirmRoleChange.newRole),
                                    disabled: updateRoleMutation.isPending,
                                    children: updateRoleMutation.isPending ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 mr-2 animate-spin"
                                            }),
                                            "Updating..."
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 mr-2"
                                            }),
                                            "Confirm Change"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $f2bd98c8edc05283$export$2e2bcd8739ae039 = $f2bd98c8edc05283$var$UserManagement;


/**
 * AdminStats Component
 * 
 * Dashboard overview with key metrics and statistics
 * Styled to match the main dashboard brand
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $88e75a6fb6edc067$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
];
const $88e75a6fb6edc067$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Activity", $88e75a6fb6edc067$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e71d8988c230db1b$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "22 17 13.5 8.5 8.5 13.5 2 7",
            key: "1r2t7k"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 22 17 22 11",
            key: "11uiuu"
        }
    ]
];
const $e71d8988c230db1b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("TrendingDown", $e71d8988c230db1b$export$3efd853dbb351e94);




const $09ef4b8aedd4818a$export$d7320aeb450304a3 = {
    getAnalytics: async ()=>{
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/dashboard-analytics');
        return response.data;
    },
    getSystemHealth: async ()=>{
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/systemhealth');
        return response.data;
    }
};




function $3cc09c88986124b6$export$af6ac6f08cd62b11() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'admin',
            'analytics'
        ],
        queryFn: ()=>(0, $09ef4b8aedd4818a$export$d7320aeb450304a3).getAnalytics(),
        staleTime: 300000,
        retry: false
    });
}


const $17866d942c2ee08d$var$AdminStats = ()=>{
    const [recentPayments, setRecentPayments] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [systemHealth, setSystemHealth] = (0, $acw62.useState)(null);
    const [healthLoading, setHealthLoading] = (0, $acw62.useState)(true);
    const { data: analyticsData } = (0, $3cc09c88986124b6$export$af6ac6f08cd62b11)();
    (0, $acw62.useEffect)(()=>{
        fetchRecentPayments();
        fetchSystemHealth();
    }, []);
    const fetchSystemHealth = async ()=>{
        try {
            setHealthLoading(true);
            const health = await (0, $09ef4b8aedd4818a$export$d7320aeb450304a3).getSystemHealth();
            setSystemHealth(health);
        } catch (error) {
            console.error('Error fetching system health:', error);
            // Set fallback data on error
            setSystemHealth({
                overall: 'warning',
                overallMessage: 'Unable to fetch health status',
                services: []
            });
        } finally{
            setHealthLoading(false);
        }
    };
    const fetchRecentPayments = async ()=>{
        try {
            setLoading(true);
            const payments = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getAllPayments();
            // Get the 3 most recent payments
            const recent = payments.sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 3);
            setRecentPayments(recent);
        } catch (error) {
            console.error('Error fetching recent payments:', error);
        } finally{
            setLoading(false);
        }
    };
    const formatAmount = (amount)=>{
        return `$${(amount / 100).toFixed(2)}`;
    };
    const formatDate = (dateString)=>{
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffMins < 60) return `${diffMins} minutes ago`;
        if (diffHours < 24) return `${diffHours} hours ago`;
        return `${diffDays} days ago`;
    };
    const [stats, setStats] = (0, $acw62.useState)({
        totalPayments: 0,
        totalAmount: 0,
        monthlyPayments: 0,
        monthlyAmount: 0,
        totalUsers: 0,
        totalApplications: 0
    });
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        fetchStats();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (analyticsData && analyticsData.summary) setStats((prev)=>({
                ...prev,
                totalUsers: analyticsData.summary.totalUsers || 0,
                totalApplications: analyticsData.summary.totalApplications || 0
            }));
    }, [
        analyticsData
    ]);
    const fetchStats = async ()=>{
        try {
            setIsLoading(true);
            const paymentStats = await (0, $15ebc391a13b5e97$export$c9cfb16a57b0f583).getPaymentStats();
            // Update payment stats while preserving other stats (like those from analytics)
            setStats((prev)=>({
                    ...prev,
                    totalPayments: paymentStats.totalPayments || 0,
                    totalAmount: paymentStats.totalAmount || 0,
                    monthlyPayments: paymentStats.monthlyPayments || 0,
                    monthlyAmount: paymentStats.monthlyAmount || 0
                }));
        } catch (err) {
            console.error('Error fetching admin stats:', err);
            setError('Failed to load statistics');
        } finally{
            setIsLoading(false);
        }
    };
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount / 100); // Convert from cents
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "space-y-6",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6",
            children: [
                ...Array(4)
            ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                    className: "animate-pulse",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h-4 bg-gray-200 rounded w-3/4 mb-2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h-8 bg-gray-200 rounded w-1/2"
                            })
                        ]
                    })
                }, i))
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "text-center py-8",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    className: "h-12 w-12 text-red-500 mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                    className: "mb-2 text-red-900",
                    children: "Error Loading Stats"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    className: "text-gray-600 mb-4",
                    children: error
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: fetchStats,
                    className: "bg-[#004d40] hover:bg-[#00695c] text-white px-4 py-2 rounded-md",
                    children: "Retry"
                })
            ]
        })
    });
    // Get real change values from analytics data
    const revenueChange = analyticsData?.summary?.revenueChange || '+0%';
    const monthlyRevenueChange = analyticsData?.summary?.monthlyRevenueChange || '+0%';
    const userChange = analyticsData?.summary?.userChange || '+0%';
    const appChange = analyticsData?.summary?.appChange || '+0%';
    const statCards = [
        {
            title: 'Total Revenue',
            value: formatCurrency(stats.totalAmount),
            change: revenueChange,
            changeType: revenueChange.startsWith('-') ? 'negative' : 'positive',
            icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
            subtitle: `From ${stats.totalPayments} payments`
        },
        {
            title: 'Monthly Revenue',
            value: formatCurrency(stats.monthlyAmount),
            change: monthlyRevenueChange,
            changeType: monthlyRevenueChange.startsWith('-') ? 'negative' : 'positive',
            icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
            subtitle: `From ${stats.monthlyPayments} payments this month`
        },
        {
            title: 'Total Users',
            value: stats.totalUsers.toLocaleString(),
            change: userChange,
            changeType: userChange.startsWith('-') ? 'negative' : 'positive',
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            subtitle: 'Registered users'
        },
        {
            title: 'Applications',
            value: stats.totalApplications.toLocaleString(),
            change: appChange,
            changeType: appChange.startsWith('-') ? 'negative' : 'positive',
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
            subtitle: 'Trademark applications'
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4",
                children: statCards.map((stat, index)=>{
                    const Icon = stat.icon;
                    const isPositive = stat.changeType === 'positive';
                    const ChangeIcon = isPositive ? (0, $c9921f4f81a419f0$export$2e2bcd8739ae039) : (0, $e71d8988c230db1b$export$2e2bcd8739ae039);
                    // Different accent colors for each card
                    const colors = [
                        {
                            bg: 'bg-[#e0f2f1]',
                            icon: 'text-[#00796b]',
                            ring: 'ring-[#00796b]/20'
                        },
                        {
                            bg: 'bg-emerald-50',
                            icon: 'text-emerald-600',
                            ring: 'ring-emerald-500/20'
                        },
                        {
                            bg: 'bg-cyan-50',
                            icon: 'text-cyan-600',
                            ring: 'ring-cyan-500/20'
                        },
                        {
                            bg: 'bg-purple-50',
                            icon: 'text-purple-600',
                            ring: 'ring-purple-500/20'
                        }
                    ];
                    const color = colors[index % colors.length];
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-shadow",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-sm font-medium text-gray-500 mb-1",
                                                children: stat.title
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "text-2xl font-bold text-gray-900 mb-2",
                                                children: stat.value
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: `flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs font-medium ${isPositive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)(ChangeIcon, {
                                                                className: "h-3 w-3"
                                                            }),
                                                            stat.change
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-xs text-gray-400",
                                                        children: "vs last month"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `${color.bg} p-3 rounded-xl ring-4 ${color.ring}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                            className: `h-5 w-5 ${color.icon}`
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-gray-500 mt-3 pt-3 border-t border-gray-100",
                                children: stat.subtitle
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-xl border border-gray-200 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "px-5 py-4 border-b border-gray-100 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 bg-[#e0f2f1] rounded-lg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4 text-[#00796b]"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "font-semibold text-gray-900",
                                                children: "Recent Payments"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "text-sm text-[#00796b] hover:text-[#004d40] font-medium",
                                        children: "View all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "divide-y divide-gray-100",
                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center py-8",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "animate-spin rounded-full h-6 w-6 border-2 border-[#00796b] border-t-transparent mx-auto mb-2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: "Loading payments..."
                                        })
                                    ]
                                }) : recentPayments.length > 0 ? recentPayments.map((payment)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "px-5 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `w-8 h-8 rounded-full flex items-center justify-center ${payment.refunded ? 'bg-red-100' : 'bg-green-100'}`,
                                                        children: payment.refunded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4 text-red-600"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4 text-green-600"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: [
                                                                    "#",
                                                                    payment.id.slice(-8)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "text-xs text-gray-500",
                                                                children: formatDate(payment.createdAt)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "text-right",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: `text-sm font-semibold ${payment.refunded ? 'text-red-600' : 'text-green-600'}`,
                                                        children: [
                                                            payment.refunded ? '-' : '+',
                                                            formatAmount(payment.refunded ? payment.refundAmount : payment.amount)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs text-gray-500",
                                                        children: payment.refunded ? 'Refunded' : 'Succeeded'
                                                    })
                                                ]
                                            })
                                        ]
                                    }, payment.id)) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center py-8",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                            className: "w-8 h-8 text-gray-300 mx-auto mb-2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: "No recent payments"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-white rounded-xl border border-gray-200 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "px-5 py-4 border-b border-gray-100 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 bg-emerald-50 rounded-lg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4 text-emerald-600"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "font-semibold text-gray-900",
                                                children: "System Health"
                                            })
                                        ]
                                    }),
                                    healthLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "px-2 py-1 bg-gray-100 text-gray-500 text-xs font-medium rounded-full",
                                        children: "Checking..."
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `px-2 py-1 text-xs font-medium rounded-full ${systemHealth?.overall === 'healthy' ? 'bg-green-100 text-green-700' : systemHealth?.overall === 'warning' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`,
                                        children: systemHealth?.overallMessage || 'Unknown'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "divide-y divide-gray-100",
                                children: healthLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center py-8",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "animate-spin rounded-full h-6 w-6 border-2 border-[#00796b] border-t-transparent mx-auto mb-2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: "Checking system health..."
                                        })
                                    ]
                                }) : systemHealth?.services?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        systemHealth.apiResponseTime && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "px-5 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w-2.5 h-2.5 rounded-full bg-green-500",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w-full h-full rounded-full bg-green-500 animate-ping opacity-75"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-sm text-gray-700",
                                                            children: "API Response Time"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-sm font-medium text-green-600",
                                                    children: systemHealth.apiResponseTime
                                                })
                                            ]
                                        }),
                                        systemHealth.services.map((service, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "px-5 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: `w-2.5 h-2.5 rounded-full ${service.status === 'healthy' ? 'bg-green-500' : service.status === 'warning' ? 'bg-yellow-500' : 'bg-red-500'}`,
                                                                children: service.status === 'healthy' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w-full h-full rounded-full bg-green-500 animate-ping opacity-75"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "text-sm text-gray-700",
                                                                children: service.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `text-sm font-medium ${service.status === 'healthy' ? 'text-green-600' : service.status === 'warning' ? 'text-yellow-600' : 'text-red-600'}`,
                                                        children: service.value
                                                    })
                                                ]
                                            }, idx))
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center py-8",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                            className: "w-8 h-8 text-gray-300 mx-auto mb-2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: "Unable to fetch health status"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $17866d942c2ee08d$export$2e2bcd8739ae039 = $17866d942c2ee08d$var$AdminStats;


/**
 * Analytics Component
 * 
 * Marketing analytics and application funnel visualization
 * Helps admins understand user drop-off points and conversion rates
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $32e2a0bac378de78$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
            key: "pzmjnu"
        }
    ],
    [
        "path",
        {
            d: "M21.21 15.89A10 10 0 1 1 8 2.83",
            key: "k2fpak"
        }
    ]
];
const $32e2a0bac378de78$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChartPie", $32e2a0bac378de78$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ee6f13a46cf9100a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
const $ee6f13a46cf9100a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShoppingCart", $ee6f13a46cf9100a$export$3efd853dbb351e94);



var $fYgYF = parcelRequire("fYgYF");
var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");

const $ae6686149e425d40$var$Analytics = ()=>{
    const [applications, setApplications] = (0, $acw62.useState)([]);
    const [summary, setSummary] = (0, $acw62.useState)(null);
    const [aiUsage, setAiUsage] = (0, $acw62.useState)(null);
    const [aiTokenUsage, setAiTokenUsage] = (0, $acw62.useState)(null);
    const [businessMetrics, setBusinessMetrics] = (0, $acw62.useState)(null);
    const [contactCapturedAppIds, setContactCapturedAppIds] = (0, $acw62.useState)([]);
    const [funnelData, setFunnelData] = (0, $acw62.useState)([]);
    const [quoteLeadCount, setQuoteLeadCount] = (0, $acw62.useState)(0);
    const [timeRange, setTimeRange] = (0, $acw62.useState)('all'); // 'week', 'month', 'year', 'all'
    const { data: stats, isLoading: isLoading, error: error, refetch: refetch } = (0, $3cc09c88986124b6$export$af6ac6f08cd62b11)();
    const formatDuration = (ms)=>{
        if (!ms) return '-';
        const minutes = Math.floor(ms / 60000);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        if (days > 0) return `${days}d ${hours % 24}h`;
        if (hours > 0) return `${hours}h ${minutes % 60}m`;
        if (minutes > 0) return `${minutes}m`;
        return '< 1m';
    };
    (0, $acw62.useEffect)(()=>{
        if (stats) {
            const apps = Array.isArray(stats.applications) ? stats.applications : [];
            // Only show marketing wizard applications in the funnel
            const wizardApps = apps.filter((app)=>app.source === 'wizard');
            setApplications(wizardApps);
            setSummary(stats.summary);
            setAiUsage(stats.aiUsage);
            setAiTokenUsage(stats.aiTokenUsage);
            setBusinessMetrics(stats.businessMetrics);
            setContactCapturedAppIds(stats.contactCapturedAppIds || []);
            // Compute funnel data from wizard applications only
            computeFunnel(wizardApps, stats);
        }
    }, [
        stats
    ]);
    (0, $acw62.useEffect)(()=>{
        if (applications.length > 0) computeFunnel(applications, stats);
    }, [
        timeRange,
        applications
    ]);
    const computeFunnel = (apps, data)=>{
        // Filter by time range if needed
        let filteredApps = apps;
        const now = new Date();
        if (timeRange === 'week') {
            const weekAgo = new Date(now.setDate(now.getDate() - 7));
            filteredApps = apps.filter((app)=>new Date(app.createdAt) >= weekAgo);
        } else if (timeRange === 'month') {
            const monthAgo = new Date(now.setMonth(now.getMonth() - 1));
            filteredApps = apps.filter((app)=>new Date(app.createdAt) >= monthAgo);
        } else if (timeRange === 'year') {
            const yearAgo = new Date(now.setFullYear(now.getFullYear() - 1));
            filteredApps = apps.filter((app)=>new Date(app.createdAt) >= yearAgo);
        }
        // Quote-first funnel: quote-stage leads (report requested / quote sent, not
        // yet paid) are excluded from the payment-conversion funnel so they don't
        // crater the displayed conversion rate. They are surfaced as a separate count.
        const isQuoteLead = (app)=>(app.status === 'quote_requested' || app.status === 'quote_sent') && app.paymentStatus !== 'paid';
        setQuoteLeadCount(filteredApps.filter(isQuoteLead).length);
        filteredApps = filteredApps.filter((app)=>!isQuoteLead(app));
        // Define Funnel Steps (Marketing Wizard flow)
        const steps = [
            {
                id: 'start',
                label: 'Landed on Wizard',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'trademark',
                label: 'Trademark Entered',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'business',
                label: 'Business Info',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'analysis',
                label: 'AI Analysis Complete',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'contact',
                label: 'Contact Captured',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'countries',
                label: 'Countries & Classes',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'payment',
                label: 'Payment',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            },
            {
                id: 'completed',
                label: 'Filing Complete',
                count: 0,
                totalDuration: 0,
                durationCount: 0
            }
        ];
        // Set of applicationIds with captured contacts (from backend)
        const contactAppIds = new Set(data?.contactCapturedAppIds || []);
        filteredApps.forEach((app)=>{
            // Step 1: Started (All apps)
            steps[0].count++;
            // Step 2: Trademark Info (has trademarkId or name)
            if (app.trademarkId || app.trademarkName && app.trademarkName !== 'Unnamed Trademark') steps[1].count++;
            else return; // Drop off
            // Step 3: Business Info
            if (app.businessInfoId || app.businessName) steps[2].count++;
            else return;
            // Step 4: AI Analysis
            if (app.analysisId) steps[3].count++;
            else return;
            // Step 5: Contact Captured
            if (contactAppIds.has(app.id)) steps[4].count++;
            else return;
            // Step 6: Country Selection (Pricing)
            if (app.pricingId) steps[5].count++;
            else return;
            // Step 7: Payment
            if (app.paymentId || app.paymentStatus === 'paid' || app.status === 'completed' || app.status === 'registered') steps[6].count++;
            else return;
            // Step 8: Completed
            if (app.status === 'completed' || app.status === 'registered') steps[7].count++;
            // Accumulate Durations
            if (app.stepDurations) {
                if (app.stepDurations.startToTrademark) {
                    steps[1].totalDuration += app.stepDurations.startToTrademark;
                    steps[1].durationCount++;
                }
                if (app.stepDurations.trademarkToBusiness) {
                    steps[2].totalDuration += app.stepDurations.trademarkToBusiness;
                    steps[2].durationCount++;
                }
                if (app.stepDurations.businessToAnalysis) {
                    steps[3].totalDuration += app.stepDurations.businessToAnalysis;
                    steps[3].durationCount++;
                }
                if (app.stepDurations.totalToCompletion) {
                    steps[6].totalDuration += app.stepDurations.totalToCompletion;
                    steps[6].durationCount++;
                }
            }
        });
        // Calculate conversion rates and averages
        const funnelWithRates = steps.map((step, index)=>{
            const prevCount = index > 0 ? steps[index - 1].count : step.count;
            const conversionRate = prevCount > 0 ? (step.count / prevCount * 100).toFixed(1) : 0;
            const dropOffRate = (100 - conversionRate).toFixed(1);
            const totalConversion = steps[0].count > 0 ? (step.count / steps[0].count * 100).toFixed(1) : 0;
            const avgDuration = step.durationCount > 0 ? step.totalDuration / step.durationCount : 0;
            return {
                ...step,
                conversionRate: conversionRate,
                dropOffRate: dropOffRate,
                totalConversion: totalConversion,
                avgDurationFormatted: avgDuration > 0 ? formatDuration(avgDuration) : null
            };
        });
        setFunnelData(funnelWithRates);
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "animate-pulse h-64 bg-gray-200 rounded-xl"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "animate-pulse h-48 bg-gray-200 rounded-xl"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "animate-pulse h-48 bg-gray-200 rounded-xl"
                    })
                ]
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
            className: "text-center py-12",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-red-500 mb-4",
                    children: error.message || 'Failed to load analytics data'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgYF.Button), {
                    onClick: ()=>refetch(),
                    children: "Retry"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                children: "Marketing Analytics"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-gray-500",
                                children: "Track application progress and conversion funnel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: timeRange,
                                        onChange: (e)=>setTimeRange(e.target.value),
                                        className: "pl-9 pr-4 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#00796b]",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "all",
                                                children: "All Time"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "year",
                                                children: "Past Year"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "month",
                                                children: "Past Month"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "week",
                                                children: "Past Week"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30050f52d874b8f2$export$2e2bcd8739ae039), {
                                        className: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fYgYF.Button), {
                                variant: "outline",
                                size: "sm",
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Export Report"
                                ]
                            })
                        ]
                    })
                ]
            }),
            businessMetrics && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                        className: "text-gray-900",
                        children: "Business Performance"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                                    className: "p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "p-2 bg-green-50 rounded-lg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-green-600"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "font-medium text-gray-600",
                                                    children: "Total Revenue"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.H3), {
                                            children: [
                                                "$",
                                                businessMetrics.revenue.total.toFixed(2)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "text-sm text-gray-500 mt-1",
                                            children: [
                                                businessMetrics.revenue.count,
                                                " Orders"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                                    className: "p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "p-2 bg-blue-50 rounded-lg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee6f13a46cf9100a$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-blue-600"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "font-medium text-gray-600",
                                                    children: "Avg Order Value"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.H3), {
                                            children: [
                                                "$",
                                                businessMetrics.revenue.avgOrderValue.toFixed(2)
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                                    className: "p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "p-2 bg-purple-50 rounded-lg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32e2a0bac378de78$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-purple-600"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "font-medium text-gray-600",
                                                    children: "Top Market"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                            children: Object.entries(businessMetrics.insights.countries).sort((a, b)=>b[1] - a[1])[0]?.[0] || 'N/A'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm text-gray-500 mt-1",
                                            children: "Most filings"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                className: "overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardHeader), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be189782912469dc$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-[#00796b]"
                                    }),
                                    "Application Funnel"
                                ]
                            }),
                            quoteLeadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                className: "text-sm text-gray-500 mt-1",
                                children: [
                                    quoteLeadCount,
                                    " quote-stage lead",
                                    quoteLeadCount === 1 ? '' : 's',
                                    " (report requested / quote sent, unpaid) excluded from conversion totals"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "space-y-6",
                            children: funnelData.map((step, index)=>{
                                // Calculate width relative to start count (max width)
                                const widthPercentage = funnelData[0].count > 0 ? step.count / funnelData[0].count * 100 : 0;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex justify-between items-end mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "w-6 h-6 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-xs font-bold",
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-medium text-gray-700",
                                                            children: step.label
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "text-right",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-bold text-gray-900",
                                                            children: step.count
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-xs text-gray-500 ml-1",
                                                            children: "users"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h-4 w-full bg-gray-100 rounded-full overflow-hidden flex",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `h-full rounded-full transition-all duration-1000 ease-out ${index === 0 ? 'bg-[#004d40]' : index === funnelData.length - 1 ? 'bg-green-500' : 'bg-[#00796b]'}`,
                                                style: {
                                                    width: `${Math.max(widthPercentage, 1)}%`
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt-1 flex justify-between text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        index > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-1 text-green-600",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                                    className: "h-3 w-3"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    children: [
                                                                        step.conversionRate,
                                                                        "% conversion"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        step.avgDurationFormatted && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-1 text-gray-500 bg-gray-50 px-1.5 py-0.5 rounded",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-[10px]",
                                                                    children: "\u23F1\uFE0F"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: step.avgDurationFormatted
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                index > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-1 text-red-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                            className: "h-3 w-3"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                step.dropOffRate,
                                                                "% drop-off"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, step.id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "p-2 bg-blue-50 rounded-lg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-blue-600"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "font-medium text-gray-600",
                                            children: "Active Users"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                    children: summary?.totalUsers || 0
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-gray-500 mt-1",
                                    children: "Engaged users (Active or Contact)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "p-2 bg-green-50 rounded-lg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-green-600"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "font-medium text-gray-600",
                                            children: "Completion Rate"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.H3), {
                                    children: [
                                        funnelData[funnelData.length - 1]?.totalConversion || 0,
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-gray-500 mt-1",
                                    children: "Start to Finish conversion"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                            className: "p-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "p-2 bg-amber-50 rounded-lg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05e483c418a01d8d$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-amber-600"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "font-medium text-gray-600",
                                            children: "Highest Drop-off"
                                        })
                                    ]
                                }),
                                (()=>{
                                    // Find step with highest drop-off rate
                                    let maxDropStep = null;
                                    let maxDropRate = -1;
                                    funnelData.slice(1).forEach((step)=>{
                                        const dropRate = parseFloat(step.dropOffRate);
                                        if (dropRate > maxDropRate) {
                                            maxDropRate = dropRate;
                                            maxDropStep = step;
                                        }
                                    });
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                                children: maxDropStep ? maxDropStep.label : 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-sm text-red-500 mt-1",
                                                children: maxDropRate > 0 ? `${maxDropRate}% users leave here` : 'No drop-off data'
                                            })
                                        ]
                                    });
                                })()
                            ]
                        })
                    })
                ]
            }),
            aiUsage && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-1.5 bg-purple-100 rounded-lg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-purple-600"
                                    })
                                }),
                                "AI Analysis Usage"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-4 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center p-4 bg-gray-50 rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                            children: aiUsage.totalAnalyses
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-gray-500",
                                            children: "Total Analyses"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center p-4 bg-green-50 rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                            children: aiUsage.riskBreakdown?.low || 0
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-green-600 font-medium",
                                            children: "Low Risk"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center p-4 bg-amber-50 rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                            children: aiUsage.riskBreakdown?.medium || 0
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-amber-600 font-medium",
                                            children: "Medium Risk"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center p-4 bg-red-50 rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                            children: aiUsage.riskBreakdown?.high || 0
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                            className: "text-sm text-red-600 font-medium",
                                            children: "High Risk"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            aiTokenUsage && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-1.5 bg-indigo-100 rounded-lg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be189782912469dc$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-indigo-600"
                                    })
                                }),
                                "OpenAI Token Usage"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-2 md:grid-cols-4 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "text-center p-4 bg-gray-50 rounded-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                                children: aiTokenUsage.totalRequests || 0
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-gray-500",
                                                children: "Total API Calls"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "text-center p-4 bg-indigo-50 rounded-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                                children: (aiTokenUsage.totalTokens || 0).toLocaleString()
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-sm text-indigo-600 font-medium",
                                                children: "Total Tokens"
                                            })
                                        ]
                                    }),
                                    Object.entries(aiTokenUsage.byType || {}).map(([type, data])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-center p-4 bg-blue-50 rounded-xl capitalize",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                                                    children: data.requests
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2Q0xG.Text), {
                                                    className: "text-sm text-blue-600 font-medium",
                                                    children: [
                                                        type,
                                                        " Requests"
                                                    ]
                                                })
                                            ]
                                        }, type))
                                ]
                            }),
                            aiTokenUsage.byModel && Object.keys(aiTokenUsage.byModel).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mt-6",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-sm font-medium text-gray-700 mb-3",
                                        children: "Model Breakdown"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                            className: "min-w-full text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                    className: "bg-gray-50",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                className: "px-4 py-2 text-left text-gray-500 font-medium rounded-l-lg",
                                                                children: "Model"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                className: "px-4 py-2 text-right text-gray-500 font-medium",
                                                                children: "Requests"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                className: "px-4 py-2 text-right text-gray-500 font-medium rounded-r-lg",
                                                                children: "Tokens Used"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                    children: Object.entries(aiTokenUsage.byModel).map(([model, data])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            className: "border-b border-gray-100 last:border-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 font-medium text-gray-900",
                                                                    children: model
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 text-right text-gray-600",
                                                                    children: data.requests
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 text-right text-gray-600",
                                                                    children: data.tokens.toLocaleString()
                                                                })
                                                            ]
                                                        }, model))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ae6686149e425d40$export$2e2bcd8739ae039 = $ae6686149e425d40$var$Analytics;


/**
 * LawFirmManagement Component
 * Admin interface for managing law firms in the multi-tenant system
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $737c279b45d43939$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
            key: "1m0v6g"
        }
    ],
    [
        "path",
        {
            d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
            key: "ohrbg2"
        }
    ]
];
const $737c279b45d43939$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("SquarePen", $737c279b45d43939$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b51f4920eac1ba0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
];
const $9b51f4920eac1ba0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Globe", $9b51f4920eac1ba0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e325251f2797f6cf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $e325251f2797f6cf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShieldCheck", $e325251f2797f6cf$export$3efd853dbb351e94);



var $67mnf = parcelRequire("67mnf");

var $2Q0xG = parcelRequire("2Q0xG");

/**
 * Law Firms Service
 * Handles API calls for multi-tenant attorney system
 */ 
const $d7f36a3fcd2db9d4$var$lawFirmsService = {
    /**
   * Get current user's law firm info
   * Used to determine access level in attorney dashboard
   * @returns {Promise<object>} Firm info or null
   */ async getCurrentFirm () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/law-firms/current');
        return response.data;
    },
    /**
   * Get list of external law firms (for transfer dropdown)
   * Only attorneyadmin can use this
   * @returns {Promise<Array>} List of external firms
   */ async getExternalFirms () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/law-firms/external');
        return response.data;
    },
    /**
   * Get all law firms (admin only)
   * @param {object} options Query options
   * @returns {Promise<Array>} List of all firms
   */ async getAllFirms (options = {}) {
        const params = new URLSearchParams();
        if (options.activeOnly !== undefined) params.append('activeOnly', options.activeOnly.toString());
        const queryString = params.toString();
        const url = queryString ? `/law-firms?${queryString}` : '/law-firms';
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(url);
        return response.data;
    },
    /**
   * Get a single law firm by ID (admin only)
   * @param {string} id Law firm ID
   * @returns {Promise<object>} Law firm
   */ async getFirm (id) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/law-firms/${id}`);
        return response.data;
    },
    /**
   * Create a new law firm (admin only)
   * @param {object} data Law firm data
   * @returns {Promise<object>} Created law firm
   */ async createFirm (data) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/law-firms', data);
        return response.data;
    },
    /**
   * Update a law firm (admin only)
   * @param {string} id Law firm ID
   * @param {object} data Fields to update
   * @returns {Promise<object>} Updated law firm
   */ async updateFirm (id, data) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).put(`/law-firms/${id}`, data);
        return response.data;
    },
    /**
   * Seed MarkoTM as the first law firm (admin only, one-time setup)
   * @returns {Promise<object>} MarkoTM firm
   */ async seedMarkoTM () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/law-firms', {
            action: 'seed'
        });
        return response.data;
    },
    /**
   * Upload an agreement for a law firm
   * @param {string} firmId Law firm ID
   * @param {object} data Agreement data { name, fileData (base64), contentType, signedAt }
   * @returns {Promise<object>} Result with uploaded agreement
   */ async uploadAgreement (firmId, data) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/law-firms/${firmId}/agreements`, data);
        return response.data;
    },
    /**
   * Remove an agreement from a law firm
   * @param {string} firmId Law firm ID
   * @param {string} agreementId Agreement ID
   * @returns {Promise<object>} Result
   */ async removeAgreement (firmId, agreementId) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).delete(`/law-firms/${firmId}/agreements/${agreementId}`);
        return response.data;
    }
};
var $d7f36a3fcd2db9d4$export$2e2bcd8739ae039 = $d7f36a3fcd2db9d4$var$lawFirmsService;


const $8d1d9ca1d65e0e94$export$cca53ebae17f7adc = [
    'lawFirms'
];
const $8d1d9ca1d65e0e94$export$715bf760e463e602 = [
    'lawFirms',
    'current'
];
function $8d1d9ca1d65e0e94$export$45e2f284f78f9fbf() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8d1d9ca1d65e0e94$export$715bf760e463e602,
        queryFn: ()=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).getCurrentFirm(),
        staleTime: 300000,
        refetchOnWindowFocus: false
    });
}
function $8d1d9ca1d65e0e94$export$fee0a9ee3b6cc0cb(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$8d1d9ca1d65e0e94$export$cca53ebae17f7adc,
            'all',
            options
        ],
        queryFn: ()=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).getAllFirms(options),
        staleTime: 60000,
        enabled: options.enabled !== false
    });
}
function $8d1d9ca1d65e0e94$export$882ee090b3654030(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$8d1d9ca1d65e0e94$export$cca53ebae17f7adc,
            'external'
        ],
        queryFn: ()=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).getExternalFirms(),
        staleTime: 60000,
        enabled: options.enabled !== false
    });
}
function $8d1d9ca1d65e0e94$export$74b827d052ed468b() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (data)=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).createFirm(data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8d1d9ca1d65e0e94$export$cca53ebae17f7adc
            });
        }
    });
}
function $8d1d9ca1d65e0e94$export$a10bf1874baa97ac() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ id: id, data: data })=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).updateFirm(id, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8d1d9ca1d65e0e94$export$cca53ebae17f7adc
            });
        }
    });
}
function $8d1d9ca1d65e0e94$export$793e75962b57d1ef() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).seedMarkoTM(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8d1d9ca1d65e0e94$export$cca53ebae17f7adc
            });
        }
    });
}
function $8d1d9ca1d65e0e94$export$17397b83a6436a96() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ firmId: firmId, data: data })=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).uploadAgreement(firmId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8d1d9ca1d65e0e94$export$cca53ebae17f7adc
            });
        }
    });
}
function $8d1d9ca1d65e0e94$export$7001b73584db3985() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ firmId: firmId, agreementId: agreementId })=>(0, $d7f36a3fcd2db9d4$export$2e2bcd8739ae039).removeAgreement(firmId, agreementId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8d1d9ca1d65e0e94$export$cca53ebae17f7adc
            });
        }
    });
}
var $8d1d9ca1d65e0e94$export$2e2bcd8739ae039 = {
    useCurrentFirm: $8d1d9ca1d65e0e94$export$45e2f284f78f9fbf,
    useLawFirms: $8d1d9ca1d65e0e94$export$fee0a9ee3b6cc0cb,
    useExternalFirms: $8d1d9ca1d65e0e94$export$882ee090b3654030,
    useCreateFirm: $8d1d9ca1d65e0e94$export$74b827d052ed468b,
    useUpdateFirm: $8d1d9ca1d65e0e94$export$a10bf1874baa97ac,
    useSeedMarkoTM: $8d1d9ca1d65e0e94$export$793e75962b57d1ef,
    useUploadAgreement: $8d1d9ca1d65e0e94$export$17397b83a6436a96,
    useRemoveAgreement: $8d1d9ca1d65e0e94$export$7001b73584db3985
};


const $921f70e5609fca69$var$LawFirmManagement = ()=>{
    const [showAddModal, setShowAddModal] = (0, $acw62.useState)(false);
    const [editingFirm, setEditingFirm] = (0, $acw62.useState)(null);
    const [expandedFirm, setExpandedFirm] = (0, $acw62.useState)(null);
    const [uploadingFor, setUploadingFor] = (0, $acw62.useState)(null);
    // TanStack Query hooks
    const { data: firmsData, isLoading: loading, error: queryError, refetch: refetch } = (0, $8d1d9ca1d65e0e94$export$fee0a9ee3b6cc0cb)({
        activeOnly: false
    });
    const seedMutation = (0, $8d1d9ca1d65e0e94$export$793e75962b57d1ef)();
    const createMutation = (0, $8d1d9ca1d65e0e94$export$74b827d052ed468b)();
    const updateMutation = (0, $8d1d9ca1d65e0e94$export$a10bf1874baa97ac)();
    const uploadAgreementMutation = (0, $8d1d9ca1d65e0e94$export$17397b83a6436a96)();
    const removeAgreementMutation = (0, $8d1d9ca1d65e0e94$export$7001b73584db3985)();
    const firms = firmsData?.firms || [];
    const error = queryError?.message || seedMutation.error?.message || uploadAgreementMutation.error?.message || null;
    const handleSeedMarkoTM = ()=>{
        seedMutation.mutate();
    };
    const getStatusBadge = (status)=>{
        const styles = {
            active: 'bg-green-100 text-green-800',
            suspended: 'bg-red-100 text-red-800',
            pending: 'bg-yellow-100 text-yellow-800'
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `px-2 py-1 rounded-full text-xs font-medium ${styles[status] || 'bg-gray-100 text-gray-800'}`,
            children: status
        });
    };
    const getTypeBadge = (type)=>{
        const isInternal = type === 'internal';
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `px-2 py-1 rounded-full text-xs font-medium ${isInternal ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'}`,
            children: isInternal ? 'Internal' : 'External'
        });
    };
    const getAccessBadge = (accessLevel)=>{
        const isFull = accessLevel === 'full';
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `px-2 py-1 rounded-full text-xs font-medium ${isFull ? 'bg-teal-100 text-teal-800' : 'bg-orange-100 text-orange-800'}`,
            children: isFull ? 'Full Access' : 'Assigned Only'
        });
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center py-12",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
            className: "h-8 w-8 animate-spin text-[#00796b]"
        })
    });
    const hasMarkoTM = firms.some((f)=>f.id === 'firm_markotm' || f.type === 'internal');
    const seeding = seedMutation.isPending;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-lg font-semibold text-gray-900",
                                children: "Law Firms"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                className: "text-gray-500",
                                children: "Manage law firms for the multi-tenant attorney system"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            !hasMarkoTM && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: handleSeedMarkoTM,
                                disabled: seeding,
                                className: "flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors disabled:opacity-50",
                                children: [
                                    seeding ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 animate-spin"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Seed MarkoTM"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>setShowAddModal(true),
                                className: "flex items-center gap-2 px-4 py-2 bg-[#004d40] hover:bg-[#00695c] text-white rounded-lg transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Add Law Firm"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>refetch(),
                                className: "flex items-center gap-2 px-4 py-2 border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    "Refresh"
                                ]
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-red-500 flex-shrink-0"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                        className: "text-red-700",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            seedMutation.reset();
                            createMutation.reset();
                            updateMutation.reset();
                            uploadAgreementMutation.reset();
                            removeAgreementMutation.reset();
                        },
                        className: "ml-auto text-red-500 hover:text-red-700",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                            className: "h-4 w-4"
                        })
                    })
                ]
            }),
            firms.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                    className: "py-12 text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                            className: "h-12 w-12 text-gray-400 mx-auto mb-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-lg font-medium text-gray-900 mb-2",
                            children: "No Law Firms"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                            className: "text-gray-500 mb-4",
                            children: "Get started by seeding MarkoTM as the internal firm."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: handleSeedMarkoTM,
                            disabled: seeding,
                            className: "flex items-center gap-2 px-4 py-2 bg-[#004d40] hover:bg-[#00695c] text-white rounded-lg transition-colors mx-auto disabled:opacity-50",
                            children: [
                                seeding ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 animate-spin"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                }),
                                "Seed MarkoTM"
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grid gap-4",
                children: firms.map((firm)=>{
                    const isExpanded = expandedFirm === firm.id;
                    const agreements = firm.agreements || [];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
                        className: "hover:shadow-md transition-shadow",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                            className: "py-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-start justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-start gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `p-3 rounded-lg ${firm.type === 'internal' ? 'bg-blue-100' : 'bg-purple-100'}`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                                        className: `h-6 w-6 ${firm.type === 'internal' ? 'text-blue-600' : 'text-purple-600'}`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                            className: "font-semibold text-gray-900",
                                                            children: firm.name
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2 mt-1 text-sm text-gray-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: firm.id
                                                                })
                                                            ]
                                                        }),
                                                        firm.primaryContact && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2 mt-1 text-sm text-gray-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    children: [
                                                                        firm.primaryContact.name,
                                                                        " - ",
                                                                        firm.primaryContact.email
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2 mt-2",
                                                            children: [
                                                                getTypeBadge(firm.type),
                                                                getStatusBadge(firm.status),
                                                                getAccessBadge(firm.accessLevel),
                                                                agreements.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700",
                                                                    children: [
                                                                        agreements.length,
                                                                        " agreement",
                                                                        agreements.length !== 1 ? 's' : ''
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>setExpandedFirm(isExpanded ? null : firm.id),
                                                    className: "p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors",
                                                    title: isExpanded ? 'Collapse' : 'Expand',
                                                    children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>setEditingFirm(firm),
                                                    className: "p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors",
                                                    title: "Edit",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $737c279b45d43939$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mt-4 pt-4 border-t border-gray-200",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "text-sm font-medium text-gray-700",
                                                    children: "Agreements"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>setUploadingFor(firm.id),
                                                    className: "flex items-center gap-1 px-3 py-1.5 text-sm bg-[#004d40] hover:bg-[#00695c] text-white rounded-lg transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                            className: "h-3.5 w-3.5"
                                                        }),
                                                        "Upload"
                                                    ]
                                                })
                                            ]
                                        }),
                                        agreements.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-center py-6 bg-gray-50 rounded-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                    className: "h-8 w-8 text-gray-400 mx-auto mb-2"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                    className: "text-gray-500 text-sm",
                                                    children: "No agreements uploaded yet"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "space-y-2",
                                            children: agreements.map((agreement)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center justify-between p-3 bg-gray-50 rounded-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-gray-500"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "font-medium text-sm text-gray-900",
                                                                            children: agreement.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "text-xs text-gray-500",
                                                                            children: [
                                                                                "Uploaded ",
                                                                                new Date(agreement.uploadedAt).toLocaleDateString(),
                                                                                agreement.signedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "ml-2 text-green-600",
                                                                                    children: [
                                                                                        "\u2022 Signed ",
                                                                                        new Date(agreement.signedAt).toLocaleDateString()
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    href: agreement.blobUrl,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded transition-colors",
                                                                    title: "View",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        if (window.confirm('Remove this agreement?')) removeAgreementMutation.mutate({
                                                                            firmId: firm.id,
                                                                            agreementId: agreement.id
                                                                        });
                                                                    },
                                                                    disabled: removeAgreementMutation.isPending,
                                                                    className: "p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors disabled:opacity-50",
                                                                    title: "Remove",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, agreement.id))
                                        })
                                    ]
                                })
                            ]
                        })
                    }, firm.id);
                })
            }),
            (showAddModal || editingFirm) && /*#__PURE__*/ (0, $ayMG0.jsx)($921f70e5609fca69$var$LawFirmModal, {
                firm: editingFirm,
                onClose: ()=>{
                    setShowAddModal(false);
                    setEditingFirm(null);
                },
                onSave: (data)=>{
                    if (editingFirm) updateMutation.mutate({
                        id: editingFirm.id,
                        data: data
                    }, {
                        onSuccess: ()=>{
                            setShowAddModal(false);
                            setEditingFirm(null);
                        }
                    });
                    else createMutation.mutate(data, {
                        onSuccess: ()=>{
                            setShowAddModal(false);
                            setEditingFirm(null);
                        }
                    });
                },
                isPending: createMutation.isPending || updateMutation.isPending,
                mutationError: createMutation.error?.message || updateMutation.error?.message
            }),
            uploadingFor && /*#__PURE__*/ (0, $ayMG0.jsx)($921f70e5609fca69$var$AgreementUploadModal, {
                firmId: uploadingFor,
                onClose: ()=>setUploadingFor(null),
                onUpload: (data)=>{
                    uploadAgreementMutation.mutate({
                        firmId: uploadingFor,
                        data: data
                    }, {
                        onSuccess: ()=>{
                            setUploadingFor(null);
                        }
                    });
                },
                isPending: uploadAgreementMutation.isPending,
                mutationError: uploadAgreementMutation.error?.message
            })
        ]
    });
};
/**
 * Modal for adding/editing law firms
 */ const $921f70e5609fca69$var$LawFirmModal = ({ firm: firm, onClose: onClose, onSave: onSave, isPending: isPending, mutationError: mutationError })=>{
    const [formData, setFormData] = (0, $acw62.useState)({
        name: firm?.name || '',
        type: firm?.type || 'external',
        status: firm?.status || 'active',
        accessLevel: firm?.accessLevel || 'assigned_only',
        primaryContact: {
            name: firm?.primaryContact?.name || '',
            email: firm?.primaryContact?.email || ''
        }
    });
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSave(formData);
    };
    const saving = isPending;
    const error = mutationError;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-xl max-w-lg w-full mx-4 max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-6 border-b border-gray-200",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-xl font-semibold text-gray-900",
                        children: firm ? 'Edit Law Firm' : 'Add Law Firm'
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "p-6 space-y-4",
                    children: [
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 border border-red-200 rounded-lg p-3 text-red-700 text-sm",
                            children: error
                        }),
                        !firm && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-blue-50 border border-blue-200 rounded-lg p-3 text-blue-700 text-sm",
                            children: "A Clerk organization will be automatically created for this law firm."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Firm Name *"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    value: formData.name,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            name: e.target.value
                                        }),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                    placeholder: "Law Firm Name",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: formData.type,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    type: e.target.value,
                                                    accessLevel: e.target.value === 'internal' ? 'full' : 'assigned_only'
                                                }),
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                            disabled: !!firm,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "external",
                                                    children: "External"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "internal",
                                                    children: "Internal"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: formData.status,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    status: e.target.value
                                                }),
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "active",
                                                    children: "Active"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "suspended",
                                                    children: "Suspended"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "pending",
                                                    children: "Pending"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Access Level"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: formData.accessLevel,
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            accessLevel: e.target.value
                                        }),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "assigned_only",
                                            children: "Assigned Only (can only see assigned apps)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "full",
                                            children: "Full Access (can see all apps)"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "border-t border-gray-200 pt-4 mt-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "text-sm font-medium text-gray-700 mb-3",
                                    children: "Primary Contact"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid grid-cols-2 gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-sm text-gray-600 mb-1",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    value: formData.primaryContact.name,
                                                    onChange: (e)=>setFormData({
                                                            ...formData,
                                                            primaryContact: {
                                                                ...formData.primaryContact,
                                                                name: e.target.value
                                                            }
                                                        }),
                                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                                    placeholder: "Contact Name"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-sm text-gray-600 mb-1",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "email",
                                                    value: formData.primaryContact.email,
                                                    onChange: (e)=>setFormData({
                                                            ...formData,
                                                            primaryContact: {
                                                                ...formData.primaryContact,
                                                                email: e.target.value
                                                            }
                                                        }),
                                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                                    placeholder: "contact@lawfirm.com"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-end gap-3 pt-4 border-t border-gray-200 mt-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: onClose,
                                    className: "px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "submit",
                                    disabled: saving,
                                    className: "flex items-center gap-2 px-4 py-2 bg-[#004d40] hover:bg-[#00695c] text-white rounded-lg transition-colors disabled:opacity-50",
                                    children: [
                                        saving ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 animate-spin"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        firm ? 'Update' : 'Create'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * Modal for uploading agreements
 */ const $921f70e5609fca69$var$AgreementUploadModal = ({ firmId: firmId, onClose: onClose, onUpload: onUpload, isPending: isPending, mutationError: mutationError })=>{
    const [agreementName, setAgreementName] = (0, $acw62.useState)('');
    const [selectedFile, setSelectedFile] = (0, $acw62.useState)(null);
    const [signedAt, setSignedAt] = (0, $acw62.useState)('');
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleFileSelect = (e)=>{
        const file = e.target.files?.[0];
        if (file) {
            // Validate file type
            const allowedTypes = [
                'application/pdf',
                'image/png',
                'image/jpeg',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            ];
            if (!allowedTypes.includes(file.type)) {
                alert('Invalid file type. Please upload a PDF, PNG, JPEG, DOC, or DOCX file.');
                return;
            }
            // Validate file size (20MB)
            if (file.size > 20971520) {
                alert('File too large. Maximum size is 20MB.');
                return;
            }
            setSelectedFile(file);
            // Auto-fill name from filename if empty
            if (!agreementName) {
                const nameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
                setAgreementName(nameWithoutExt);
            }
        }
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!selectedFile || !agreementName) return;
        // Convert file to base64
        const reader = new FileReader();
        reader.onload = ()=>{
            const base64Data = reader.result;
            onUpload({
                name: agreementName,
                fileData: base64Data,
                contentType: selectedFile.type,
                signedAt: signedAt || null
            });
        };
        reader.readAsDataURL(selectedFile);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-xl max-w-lg w-full mx-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-6 border-b border-gray-200",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "text-xl font-semibold text-gray-900",
                        children: "Upload Agreement"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "p-6 space-y-4",
                    children: [
                        mutationError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg-red-50 border border-red-200 rounded-lg p-3 text-red-700 text-sm",
                            children: mutationError
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Agreement Name *"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    value: agreementName,
                                    onChange: (e)=>setAgreementName(e.target.value),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent",
                                    placeholder: "e.g., Service Agreement 2025",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Agreement File *"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "file",
                                    ref: fileInputRef,
                                    onChange: handleFileSelect,
                                    accept: ".pdf,.png,.jpg,.jpeg,.doc,.docx",
                                    className: "hidden"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    onClick: ()=>fileInputRef.current?.click(),
                                    className: "w-full px-4 py-6 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-[#00796b] transition-colors text-center",
                                    children: selectedFile ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-[#00796b]"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-gray-700",
                                                children: selectedFile.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "text-gray-500 text-sm",
                                                children: [
                                                    "(",
                                                    (selectedFile.size / 1024).toFixed(1),
                                                    " KB)"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                className: "h-8 w-8 text-gray-400 mx-auto mb-2"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-gray-500",
                                                children: "Click to select a file"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                                className: "text-gray-400 text-xs mt-1",
                                                children: "PDF, PNG, JPEG, DOC, DOCX (max 20MB)"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: "Signed Date (optional)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "date",
                                    value: signedAt,
                                    onChange: (e)=>setSignedAt(e.target.value),
                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00796b] focus:border-transparent"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mt-1 text-xs text-gray-500",
                                    children: "Leave empty if the agreement is pending signature"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-end gap-3 pt-4 border-t border-gray-200 mt-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: onClose,
                                    className: "px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "submit",
                                    disabled: isPending || !selectedFile || !agreementName,
                                    className: "flex items-center gap-2 px-4 py-2 bg-[#004d40] hover:bg-[#00695c] text-white rounded-lg transition-colors disabled:opacity-50",
                                    children: [
                                        isPending ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 animate-spin"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        }),
                                        "Upload"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $921f70e5609fca69$export$2e2bcd8739ae039 = $921f70e5609fca69$var$LawFirmManagement;


var $0464764db0eee9cb$exports = {};
$0464764db0eee9cb$exports = import.meta.resolve("3Ybhi");


const $b3a550605ce2db2b$var$MARKOTM_ORG_ID = "org_3CyO9qq1lkFxNXGHwC73GC52pTB";
const $b3a550605ce2db2b$var$AdminDashboard = ()=>{
    const { user: user, isLoaded: isLoaded } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const [activeSection, setActiveSection] = (0, $acw62.useState)('stats');
    const [hasAdminAccess, setHasAdminAccess] = (0, $acw62.useState)(false);
    // Check admin access only when component mounts (when /admin route is accessed)
    (0, $acw62.useEffect)(()=>{
        const checkAdminAccess = ()=>{
            if (user && user.organizationMemberships) try {
                // Find MarkoTM organization by ID (from env var)
                const markoTMOrg = user.organizationMemberships.find((membership)=>membership.organization.id === $b3a550605ce2db2b$var$MARKOTM_ORG_ID);
                const isMarkoTMAdmin = markoTMOrg?.role === 'org:admin';
                console.log("\uD83D\uDD0D AdminDashboard Access Check (on route access):", {
                    isMarkoTMAdmin: isMarkoTMAdmin,
                    markoTMFound: !!markoTMOrg,
                    markoTMRole: markoTMOrg?.role,
                    organizationCount: user.organizationMemberships?.length || 0,
                    organizationNames: user.organizationMemberships?.map((m)=>m.organization.name) || []
                });
                // STRICT: Only allow admin access if user is admin in MarkoTM organization
                setHasAdminAccess(isMarkoTMAdmin);
            } catch (error) {
                console.error('Error checking admin access:', error);
                setHasAdminAccess(false);
            }
            else setHasAdminAccess(false);
        };
        // Only check when user data is loaded and component mounts
        if (isLoaded) checkAdminAccess();
    }, []); // Empty dependency array - only run on mount when /admin route is accessed
    // If not loaded or no admin access, show appropriate message
    if (!isLoaded) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen bg-gray-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "animate-spin rounded-full h-12 w-12 border-b-2 border-[#00796b] mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                    children: "Loading..."
                })
            ]
        })
    });
    if (!hasAdminAccess) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen bg-gray-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.Card), {
            className: "max-w-md w-full",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.CardContent), {
                className: "text-center py-8",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                        className: "h-16 w-16 text-red-500 mx-auto mb-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.H3), {
                        className: "mb-2 text-red-900",
                        children: "Access Denied"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                        className: "text-gray-600 mb-4",
                        children: "You don't have permission to access the admin dashboard. Please contact your administrator if you believe this is an error."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>window.location.href = '/dashboard',
                        className: "bg-[#004d40] hover:bg-[#00695c] text-white px-4 py-2 rounded-md",
                        children: "Return to Dashboard"
                    })
                ]
            })
        })
    });
    const navigationItems = [
        {
            id: 'stats',
            label: 'Overview',
            icon: (0, $be189782912469dc$export$2e2bcd8739ae039),
            description: 'Dashboard statistics and metrics'
        },
        {
            id: 'analytics',
            label: 'Marketing Analytics',
            icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
            description: 'Application funnel & conversion'
        },
        {
            id: 'payments',
            label: 'Payment Management',
            icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
            description: 'Manage payments and refunds'
        },
        {
            id: 'trademarks',
            label: 'Trademark Applications',
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
            description: 'Manage trademark applications'
        },
        {
            id: 'users',
            label: 'User Management',
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            description: 'Manage user accounts'
        },
        {
            id: 'lawfirms',
            label: 'Law Firms',
            icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039),
            description: 'Manage law firm access'
        },
        {
            id: 'settings',
            label: 'Settings',
            icon: (0, $da03c070d837b197$export$2e2bcd8739ae039),
            description: 'System configuration'
        }
    ];
    const renderContent = ()=>{
        switch(activeSection){
            case 'stats':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17866d942c2ee08d$export$2e2bcd8739ae039), {});
            case 'analytics':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae6686149e425d40$export$2e2bcd8739ae039), {});
            case 'payments':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d0faa6baab94642$export$2e2bcd8739ae039), {});
            case 'trademarks':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4e9f08291f7c6e2$export$2e2bcd8739ae039), {});
            case 'users':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f2bd98c8edc05283$export$2e2bcd8739ae039), {});
            case 'lawfirms':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $921f70e5609fca69$export$2e2bcd8739ae039), {});
            case 'settings':
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67mnf.Card), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardHeader), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardTitle), {
                                children: "System Settings"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67mnf.CardContent), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q0xG.Text), {
                                children: "Settings panel coming soon..."
                            })
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17866d942c2ee08d$export$2e2bcd8739ae039), {});
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "min-h-screen bg-gray-100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                className: "bg-gradient-to-r from-[#004d40] via-[#00695c] to-[#00796b] shadow-md z-20 h-16 fixed top-0 w-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px-4 h-full flex items-center justify-between max-w-7xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/dashboard",
                                    className: "flex items-center gap-2 text-white/80 hover:text-white transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "hidden sm:inline text-sm",
                                            children: "Dashboard"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-6 w-px bg-white/20"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "p-1.5 bg-red-500/20 rounded-lg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "hidden sm:block",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "font-bold text-lg text-white",
                                                    children: "Admin"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-white/60 text-xs font-medium ml-1",
                                                    children: "Panel"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-right hidden md:block",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-sm font-medium text-white",
                                            children: user?.firstName || 'Administrator'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-xs text-white/60",
                                            children: "Admin Access"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-9 w-9 rounded-full bg-white/20 flex items-center justify-center overflow-hidden ring-2 ring-white/30",
                                    children: user?.imageUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: user.imageUrl,
                                        alt: "Profile",
                                        className: "h-full w-full object-cover"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-white"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pt-16 flex min-h-screen",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w-64 bg-white border-r border-gray-200 shadow-sm flex-shrink-0 fixed left-0 top-16 bottom-0 overflow-y-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                            className: "p-3 space-y-1",
                            children: navigationItems.map((item)=>{
                                const Icon = item.icon;
                                const isActive = activeSection === item.id;
                                const isComingSoon = item.id === 'settings';
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>!isComingSoon && setActiveSection(item.id),
                                    disabled: isComingSoon,
                                    className: `
                    w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left transition-all duration-200
                    ${isActive ? 'bg-[#004d40] text-white shadow-md' : isComingSoon ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'}
                  `,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `
                    w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0
                    ${isActive ? 'bg-white/20' : isComingSoon ? 'bg-gray-100' : 'bg-[#e0f2f1]'}
                  `,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                className: `w-4 h-4 ${isActive ? 'text-white' : isComingSoon ? 'text-gray-400' : 'text-[#00796b]'}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex-1 min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `text-sm font-medium ${isActive ? 'text-white' : ''}`,
                                                            children: item.label
                                                        }),
                                                        isComingSoon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                            className: "w-3 h-3 text-gray-400"
                                                        })
                                                    ]
                                                }),
                                                !isComingSoon && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: `text-xs truncate ${isActive ? 'text-white/70' : 'text-gray-500'}`,
                                                    children: item.description
                                                })
                                            ]
                                        }),
                                        isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4 text-white/70"
                                        })
                                    ]
                                }, item.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                        className: "flex-1 ml-64 p-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "max-w-6xl mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "text-2xl font-bold text-gray-900",
                                            children: navigationItems.find((item)=>item.id === activeSection)?.label || 'Overview'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-gray-500 mt-1",
                                            children: navigationItems.find((item)=>item.id === activeSection)?.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bg-white rounded-2xl shadow-lg border border-gray-200 p-6",
                                    children: renderContent()
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $b3a550605ce2db2b$export$2e2bcd8739ae039 = $b3a550605ce2db2b$var$AdminDashboard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




/**
 * NotificationItem Component
 * Single notification item
 */ function $e7f69d097fb114f6$var$NotificationItem({ notification: notification, onClick: onClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('notifications');
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { markAsRead: markAsRead, dismissNotification: dismissNotification } = (0, $a05168b77183bb44$export$53d5ca6c3f53e109)();
    // Detect if we're in the attorney dashboard
    const isAttorneyDashboard = location.pathname.startsWith('/attorney');
    const messagesPath = isAttorneyDashboard ? '/attorney/client-messages' : '/dashboard#messages';
    const handleClick = async ()=>{
        // Mark as read
        if (!notification.read) await markAsRead(notification.id);
        // Navigate to messages page
        navigate(messagesPath);
        if (onClick) onClick();
    };
    const handleDismiss = async (e)=>{
        e.stopPropagation();
        await dismissNotification(notification.id);
    };
    const getTimeAgo = (dateString)=>{
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffMins < 1) return t('notifications.time.justNow', 'Just now');
        if (diffMins < 60) return t('notifications.time.minutesAgo', '{{count}} min ago', {
            count: diffMins
        });
        if (diffHours < 24) return t('notifications.time.hoursAgo', '{{count}} hr ago', {
            count: diffHours
        });
        if (diffDays < 7) return t('notifications.time.daysAgo', '{{count}} days ago', {
            count: diffDays
        });
        return date.toLocaleDateString();
    };
    const getUrgencyClass = ()=>{
        switch(notification.urgency){
            case 'critical':
                return 'urgency-critical';
            case 'high':
                return 'urgency-high';
            case 'medium':
                return 'urgency-medium';
            default:
                return 'urgency-low';
        }
    };
    const getCategoryIcon = ()=>{
        switch(notification.category){
            case 'status_change':
                return "\uD83D\uDCCB";
            case 'office_action':
                return "\u26A0\uFE0F";
            case 'filing_update':
                return "\uD83D\uDCDD";
            case 'deadline':
                return "\u23F0";
            case 'correspondence':
                return "\uD83D\uDCE7";
            case 'approval_required':
                return "\u270B";
            case 'task_approved':
                return "\u2705";
            default:
                return "\uD83D\uDD14";
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: `notification-item ${notification.read ? 'read' : 'unread'} ${getUrgencyClass()}`,
        onClick: handleClick,
        role: "button",
        tabIndex: 0,
        onKeyPress: (e)=>e.key === 'Enter' && handleClick(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "notification-icon",
                children: getCategoryIcon()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "notification-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "notification-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "notification-title",
                                children: notification.title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "notification-time",
                                children: getTimeAgo(notification.createdAt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "notification-message",
                        children: notification.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "notification-dismiss",
                onClick: handleDismiss,
                "aria-label": t('notifications.dismiss', 'Dismiss'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                        })
                    ]
                })
            }),
            !notification.read && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notification-unread-dot"
            })
        ]
    });
}
var $e7f69d097fb114f6$export$2e2bcd8739ae039 = $e7f69d097fb114f6$var$NotificationItem;



/**
 * NotificationList Component
 * Renders a list of notifications
 */ function $ae4f681125250232$var$NotificationList({ notifications: notifications, onNotificationClick: onNotificationClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('notifications');
    if (!notifications || notifications.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "notification-list-empty",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            children: t('notifications.empty', 'No notifications')
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "notification-list",
        children: notifications.map((notification)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7f69d097fb114f6$export$2e2bcd8739ae039), {
                notification: notification,
                onClick: onNotificationClick
            }, notification.id))
    });
}
var $ae4f681125250232$export$2e2bcd8739ae039 = $ae4f681125250232$var$NotificationList;



// Categories that are internal (attorney-only) and should not show to clients
const $a8e412ed09c5e4e2$var$INTERNAL_CATEGORIES = [
    'assignment',
    'recall',
    'transfer',
    'approval',
    'internal_request',
    'new_filing',
    'filing_queue'
];
// Title patterns that indicate internal notifications
const $a8e412ed09c5e4e2$var$INTERNAL_TITLE_PATTERNS = [
    'recalled',
    'attorney assigned',
    'transferred',
    'assignment',
    'new filing ready',
    'filing ready'
];
/**
 * NotificationBell Component
 * Bell icon with unread count badge and dropdown
 */ function $a8e412ed09c5e4e2$var$NotificationBell() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('notifications');
    const { unreadCount: unreadCount, notifications: notifications, markAllAsRead: markAllAsRead } = (0, $a05168b77183bb44$export$53d5ca6c3f53e109)();
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    // Detect if we're in the attorney dashboard
    const isAttorneyDashboard = location.pathname.startsWith('/attorney');
    const viewAllLink = isAttorneyDashboard ? '/attorney/client-messages' : '/dashboard#messages';
    // Filter out internal notifications for client view
    const clientNotifications = (0, $acw62.useMemo)(()=>{
        return notifications.filter((notification)=>{
            // Check category
            if ($a8e412ed09c5e4e2$var$INTERNAL_CATEGORIES.includes(notification.category)) return false;
            // Check title patterns
            const title = (notification.title || '').toLowerCase();
            for (const pattern of $a8e412ed09c5e4e2$var$INTERNAL_TITLE_PATTERNS){
                if (title.includes(pattern)) return false;
            }
            return true;
        });
    }, [
        notifications
    ]);
    // Calculate client-visible unread count
    const clientUnreadCount = (0, $acw62.useMemo)(()=>{
        return clientNotifications.filter((n)=>!n.read).length;
    }, [
        clientNotifications
    ]);
    // Close dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const toggleDropdown = ()=>{
        setIsOpen(!isOpen);
    };
    const handleMarkAllRead = async (e)=>{
        e.stopPropagation();
        await markAllAsRead();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "notification-bell-container",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "notification-bell-button",
                onClick: toggleDropdown,
                "aria-label": t('notifications.bell.label', 'Notifications'),
                "aria-haspopup": "true",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "notification-bell-icon",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M13.73 21a2 2 0 0 1-3.46 0"
                            })
                        ]
                    }),
                    clientUnreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notification-badge",
                        "aria-label": `${clientUnreadCount} unread`,
                        children: clientUnreadCount > 99 ? '99+' : clientUnreadCount
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "notification-dropdown",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "notification-dropdown-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: t('notifications.title', 'Notifications')
                            }),
                            clientUnreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "mark-all-read-button",
                                onClick: handleMarkAllRead,
                                children: t('notifications.markAllRead', 'Mark all as read')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "notification-dropdown-content",
                        children: clientNotifications.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "notification-empty",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: t('notifications.empty', 'No notifications')
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae4f681125250232$export$2e2bcd8739ae039), {
                            notifications: clientNotifications.slice(0, 5),
                            onNotificationClick: ()=>setIsOpen(false)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "notification-dropdown-footer",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: viewAllLink,
                            onClick: ()=>setIsOpen(false),
                            children: t('notifications.viewAll', 'View all notifications')
                        })
                    })
                ]
            })
        ]
    });
}
var $a8e412ed09c5e4e2$export$2e2bcd8739ae039 = $a8e412ed09c5e4e2$var$NotificationBell;







var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $b08fe6cb05501eb7$var$AttorneyContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $b08fe6cb05501eb7$export$c0d08ae70116d5f0({ children: children }) {
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const [selectedClient, setSelectedClient] = (0, $acw62.useState)(null);
    // Get firm and permissions from API (already fetched by AttorneyApp, will use cache)
    const { data: firmData } = (0, $8d1d9ca1d65e0e94$export$45e2f284f78f9fbf)();
    // Extract values from API response
    const firm = firmData?.firm || null;
    const permissions = firmData?.permissions || {};
    const role = firmData?.role || null;
    // Role checks from API
    const isAdmin = permissions.isAdmin || false;
    const isAttorneyAdmin = permissions.isAttorneyAdmin || false;
    const isAttorney = firmData?.hasAccess || false;
    const isInternal = firm?.isInternal || false;
    // Permission checks from API
    const canManageJurisdictions = isAdmin;
    const canManageAssignments = permissions.canManageAssignments || false;
    const canTransferToFirm = permissions.canTransferToFirm || false;
    const canRecallFromFirm = permissions.canRecallFromFirm || false;
    const canReassign = permissions.canReassign || false;
    // Messaging permissions - only MarkoTM (internal) can message clients directly
    const canMessageClients = isInternal;
    const canCreateInternalRequests = !isInternal; // External attorneys use internal requests
    const canProcessInternalRequests = isInternal && (isAdmin || isAttorneyAdmin);
    // User metadata from Clerk
    const specializations = user?.publicMetadata?.specializations || [];
    const assignedClients = user?.publicMetadata?.assigned_clients || [];
    // canAccessClient - check against firm's access level
    const canAccessClient = (0, $acw62.useCallback)((clientUserId)=>{
        // Full access firms can see all
        if (firm?.accessLevel === 'full') return true;
        // Admin and attorneyadmin can access all
        if (isAdmin || isAttorneyAdmin) return true;
        // Otherwise check assigned list
        return assignedClients.includes(clientUserId);
    }, [
        firm?.accessLevel,
        isAdmin,
        isAttorneyAdmin,
        assignedClients
    ]);
    const value = {
        isAdmin: // Role checks
        isAdmin,
        isAttorneyAdmin: isAttorneyAdmin,
        isAttorney: isAttorney,
        isInternal: isInternal,
        memberRole: role,
        canAccessClient: // Permission checks
        canAccessClient,
        canManageJurisdictions: canManageJurisdictions,
        canManageAssignments: canManageAssignments,
        canTransferToFirm: canTransferToFirm,
        canRecallFromFirm: canRecallFromFirm,
        canReassign: canReassign,
        canMessageClients: // Messaging permissions
        canMessageClients,
        canCreateInternalRequests: canCreateInternalRequests,
        canProcessInternalRequests: canProcessInternalRequests,
        specializations: // User data
        specializations,
        assignedClients: assignedClients,
        attorneyName: user?.fullName || user?.firstName || 'Attorney',
        attorneyId: user?.id,
        firm: // Firm data
        firm,
        firmName: firm?.firmName || 'Law Firm',
        accessLevel: firm?.accessLevel || 'assigned_only',
        selectedClient: // UI state
        selectedClient,
        setSelectedClient: setSelectedClient,
        // Legacy (for backwards compatibility)
        organizationName: firm?.firmName || 'Law Firm',
        isMarkoTM: isInternal // Legacy alias
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b08fe6cb05501eb7$var$AttorneyContext.Provider, {
        value: value,
        children: children
    });
}
function $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0() {
    const context = (0, $acw62.useContext)($b08fe6cb05501eb7$var$AttorneyContext);
    if (!context) throw new Error('useAttorney must be used within an AttorneyProvider');
    return context;
}
var $b08fe6cb05501eb7$export$2e2bcd8739ae039 = $b08fe6cb05501eb7$var$AttorneyContext;



/**
 * Attorney Header Component
 * Top header bar for attorney dashboard
 */ function $eb18e2edf7df7908$var$AttorneyHeader() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { attorneyName: attorneyName, organizationName: organizationName } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
        className: "bg-gradient-to-r from-[#004d40] via-[#00695c] to-[#00796b] shadow-md z-20 h-16 fixed top-0 w-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "px-6 h-full flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center gap-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        href: "/attorney",
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0464764db0eee9cb$exports))),
                                alt: "MarkoTM",
                                className: "h-9 w-9 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "text-lg font-bold text-white",
                                        children: "Attorney Dashboard"
                                    }),
                                    organizationName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs text-white/60",
                                        children: organizationName
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-white",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8e412ed09c5e4e2$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h-8 w-px bg-white/20 hidden sm:block"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-right hidden sm:block",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-sm font-medium text-white",
                                            children: attorneyName || user?.firstName || 'Attorney'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-xs text-white/60",
                                            children: "Attorney"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h-9 w-9 rounded-full bg-white/20 flex items-center justify-center overflow-hidden ring-2 ring-white/30",
                                    children: user?.imageUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: user.imageUrl,
                                        alt: "Profile",
                                        className: "h-full w-full object-cover"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-white"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $eb18e2edf7df7908$export$2e2bcd8739ae039 = $eb18e2edf7df7908$var$AttorneyHeader;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


/**
 * @license lucide-react v0.471.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c879de12ab6f91f5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5",
            key: "1uzm8b"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $c879de12ab6f91f5$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("SquareCheckBig", $c879de12ab6f91f5$export$3efd853dbb351e94);



/**
 * Attorney Sidebar Component
 * Navigation sidebar for attorney dashboard - styled to match admin dashboard
 */ function $a47e8ab21058ca50$var$AttorneySidebar() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { isAdmin: isAdmin, isInternal: isInternal, canMessageClients: canMessageClients, canProcessInternalRequests: canProcessInternalRequests } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    // Base nav items for all attorneys
    const navItems = [
        {
            path: '/attorney/filing-queue',
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
            label: t('attorney.nav.filingQueue', 'Filing Queue'),
            description: 'Pending trademark filings'
        },
        {
            path: '/attorney/approval-queue',
            icon: (0, $c879de12ab6f91f5$export$2e2bcd8739ae039),
            label: t('attorney.nav.approvalQueue', 'Approval Queue'),
            description: 'AI drafts for review'
        },
        ...canMessageClients ? [
            {
                path: '/attorney/client-messages',
                icon: (0, $75957e2fe5dd6cb2$export$2e2bcd8739ae039),
                label: t('attorney.nav.notifications', 'Notifications'),
                description: 'Messages and alerts'
            }
        ] : [],
        ...!isInternal ? [
            {
                path: '/attorney/markotm-responses',
                icon: (0, $198f0fcb2df6a37f$export$2e2bcd8739ae039),
                label: t('attorney.nav.markotmResponses', 'MarkoTM Responses'),
                description: 'Responses from MarkoTM'
            }
        ] : [],
        {
            path: '/attorney/correspondence',
            icon: (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039),
            label: t('attorney.nav.correspondence', 'Correspondence'),
            description: 'Email communications'
        },
        {
            path: '/attorney/deadlines',
            icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
            label: t('attorney.nav.deadlines', 'Deadlines'),
            description: 'Upcoming due dates'
        }
    ];
    // Internal requests queue - only for MarkoTM attorneyadmins
    const attorneyAdminItems = canProcessInternalRequests ? [
        {
            path: '/attorney/internal-requests',
            icon: (0, $3206cd97f03c9458$export$2e2bcd8739ae039),
            label: t('attorney.nav.internalRequests', 'Internal Requests'),
            description: 'Requests from external firms'
        }
    ] : [];
    const adminItems = [
        ...isInternal ? [
            {
                path: '/attorney/clients',
                icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                label: t('attorney.nav.clients', 'My Clients'),
                description: 'Client management'
            }
        ] : [],
        {
            path: '/attorney/my-team',
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            label: t('attorney.nav.myTeam', 'My Team'),
            description: 'Team members'
        },
        {
            path: '/attorney/jurisdictions',
            icon: (0, $9b51f4920eac1ba0$export$2e2bcd8739ae039),
            label: t('attorney.nav.jurisdictions', 'Jurisdictions'),
            description: 'IP office information'
        }
    ];
    const renderNavItem = (item)=>{
        const Icon = item.icon;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
            to: item.path,
            className: ({ isActive: isActive })=>`
          w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left transition-all duration-200
          ${isActive ? 'bg-[#004d40] text-white shadow-md' : 'text-gray-700 hover:bg-gray-50'}
        `,
            children: ({ isActive: isActive })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `
              w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0
              ${isActive ? 'bg-white/20' : 'bg-[#e0f2f1]'}
            `,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                className: `w-4 h-4 ${isActive ? 'text-white' : 'text-[#00796b]'}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex-1 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex items-center gap-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `text-sm font-medium ${isActive ? 'text-white' : ''}`,
                                        children: item.label
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `text-xs ${isActive ? 'text-white/70' : 'text-gray-500'}`,
                                    children: item.description
                                })
                            ]
                        }),
                        isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                            className: "w-4 h-4 text-white/60 flex-shrink-0"
                        })
                    ]
                })
        }, item.path);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("aside", {
        className: "w-64 bg-white border-r border-gray-200 shadow-sm flex-shrink-0 fixed left-0 top-16 bottom-0 flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                className: "p-3 space-y-1 flex-1 overflow-y-auto",
                children: [
                    navItems.map(renderNavItem),
                    attorneyAdminItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "my-3 border-t border-gray-200"
                            }),
                            attorneyAdminItems.map(renderNavItem)
                        ]
                    }),
                    isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "my-3 border-t border-gray-200"
                            }),
                            adminItems.map(renderNavItem)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-3 border-t border-gray-200",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/dashboard",
                    className: "flex items-center gap-2 px-3 py-2.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-colors",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                            className: "w-4 h-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: t('attorney.nav.clientDashboard', 'Client Dashboard')
                        })
                    ]
                })
            })
        ]
    });
}
var $a47e8ab21058ca50$export$2e2bcd8739ae039 = $a47e8ab21058ca50$var$AttorneySidebar;


/**
 * Attorney Layout Component
 * Main layout wrapper for attorney dashboard - styled to match admin dashboard
 */ function $b2d994a14c968c0b$var$AttorneyLayout({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "min-h-screen bg-gray-100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb18e2edf7df7908$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pt-16 flex min-h-screen",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a47e8ab21058ca50$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                        className: "ml-64 flex-1 p-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "max-w-6xl mx-auto",
                            children: children
                        })
                    })
                ]
            })
        ]
    });
}
var $b2d994a14c968c0b$export$2e2bcd8739ae039 = $b2d994a14c968c0b$var$AttorneyLayout;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


async function $edfde963f351996f$export$ad382ebb541c7105(options = {}) {
    const params = new URLSearchParams();
    if (options.status) params.append('status', options.status);
    if (options.jurisdiction) params.append('jurisdiction', options.jurisdiction);
    if (options.assignmentFilter) params.append('assignmentFilter', options.assignmentFilter);
    const queryString = params.toString();
    const url = queryString ? `/attorney/filing-queue?${queryString}` : '/attorney/filing-queue';
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(url);
    return response.data;
}
async function $edfde963f351996f$export$e9cab7834b216ca4(applicationId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/attorney/filing-queue/${applicationId}`);
    return response.data;
}
async function $edfde963f351996f$export$740b73fa0865e842(applicationId, data) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/filing/${applicationId}/${data.jurisdiction}/mark-filed`, {
        ipOfficeRef: data.ipOfficeRef,
        filedAt: data.filedAt || new Date().toISOString(),
        notes: data.notes
    });
    return response.data;
}
async function $edfde963f351996f$export$86d89fe525629606(applicationId, jurisdiction, status, data = {}) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).patch(`/attorney/filing-queue/${applicationId}/filing`, {
        jurisdiction: jurisdiction,
        status: status,
        ...data
    });
    return response.data;
}
async function $edfde963f351996f$export$966683d9da513acb(applicationId, jurisdiction, ipOfficeRef) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/filing/${applicationId}/${jurisdiction}/mark-filed`, {
        ipOfficeRef: ipOfficeRef
    });
    return response.data;
}
async function $edfde963f351996f$export$d4f421db7b866fe(applicationId, attorneyId = null) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/assign`, {
        attorneyId: attorneyId
    });
    return response.data;
}
async function $edfde963f351996f$export$6f385a37cfc52db5(applicationId, targetOrgId, reason = null) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/transfer`, {
        targetOrgId: targetOrgId,
        reason: reason
    });
    return response.data;
}
async function $edfde963f351996f$export$e2f0700c62f7f46e(applicationId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/unassign`);
    return response.data;
}
async function $edfde963f351996f$export$eb5e18faa607eccf(applicationId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/recall`);
    return response.data;
}
async function $edfde963f351996f$export$a2670e543b269e94() {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/attorney/org-members');
    return response.data;
}
async function $edfde963f351996f$export$704e37ec25e80010(applicationId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/attorney/filing/${applicationId}/summary-pdf`, {
        responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([
        response.data
    ], {
        type: 'application/pdf'
    }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Application-Summary-${applicationId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
async function $edfde963f351996f$export$a89494d4eab9a0ee(applicationId, data) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/amend`, data);
    return response.data;
}
async function $edfde963f351996f$export$9ad66c58466a1774(applicationId, data) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/send-amendment-email`, data);
    return response.data;
}
async function $edfde963f351996f$export$58e20af09090f01d(applicationId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/attorney/applications/${applicationId}/amendments`);
    return response.data;
}
async function $edfde963f351996f$export$f02ee9b4604e1fd7(applicationId, amendmentId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/attorney/applications/${applicationId}/amend/approve`, amendmentId ? {
        amendmentId: amendmentId
    } : {});
    return response.data;
}
var $edfde963f351996f$export$2e2bcd8739ae039 = {
    getFilingQueue: $edfde963f351996f$export$ad382ebb541c7105,
    getFilingApplication: $edfde963f351996f$export$e9cab7834b216ca4,
    markAsFiled: $edfde963f351996f$export$740b73fa0865e842,
    updateFilingStatus: $edfde963f351996f$export$86d89fe525629606,
    updateIpOfficeRef: $edfde963f351996f$export$966683d9da513acb,
    assignApplication: $edfde963f351996f$export$d4f421db7b866fe,
    transferApplication: $edfde963f351996f$export$6f385a37cfc52db5,
    unassignApplication: $edfde963f351996f$export$e2f0700c62f7f46e,
    recallApplication: $edfde963f351996f$export$eb5e18faa607eccf,
    getOrgMembers: $edfde963f351996f$export$a2670e543b269e94,
    downloadFilingPdf: $edfde963f351996f$export$704e37ec25e80010,
    amendApplication: $edfde963f351996f$export$a89494d4eab9a0ee,
    sendAmendmentEmail: $edfde963f351996f$export$9ad66c58466a1774,
    getAmendments: $edfde963f351996f$export$58e20af09090f01d,
    approveAmendment: $edfde963f351996f$export$f02ee9b4604e1fd7
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

// Country flag emojis
const $0378d3260046065e$var$countryFlags = {
    AU: "\uD83C\uDDE6\uD83C\uDDFA",
    US: "\uD83C\uDDFA\uD83C\uDDF8",
    EU: "\uD83C\uDDEA\uD83C\uDDFA",
    UK: "\uD83C\uDDEC\uD83C\uDDE7",
    NZ: "\uD83C\uDDF3\uD83C\uDDFF",
    CA: "\uD83C\uDDE8\uD83C\uDDE6",
    SG: "\uD83C\uDDF8\uD83C\uDDEC",
    JP: "\uD83C\uDDEF\uD83C\uDDF5",
    CN: "\uD83C\uDDE8\uD83C\uDDF3",
    KR: "\uD83C\uDDF0\uD83C\uDDF7",
    IN: "\uD83C\uDDEE\uD83C\uDDF3",
    BR: "\uD83C\uDDE7\uD83C\uDDF7",
    MX: "\uD83C\uDDF2\uD83C\uDDFD"
};
/**
 * Jurisdiction Row Component
 * Single row in the filing table showing jurisdiction status
 */ function $0378d3260046065e$var$JurisdictionRow({ filing: filing, onFileNow: onFileNow, onView: onView, onEditRef: onEditRef }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const getStatusDisplay = ()=>{
        switch(filing.status){
            case 'pending':
                return {
                    icon: "\u23F3",
                    text: t('attorney.jurisdiction.pending', 'Pending'),
                    className: 'status-pending'
                };
            case 'filed':
                return {
                    icon: "\u2705",
                    text: t('attorney.jurisdiction.filed', 'Filed'),
                    className: 'status-filed'
                };
            case 'accepted':
                return {
                    icon: "\u2713",
                    text: t('attorney.jurisdiction.accepted', 'Accepted'),
                    className: 'status-accepted'
                };
            case 'registered':
                return {
                    icon: "\uD83C\uDFC6",
                    text: t('attorney.jurisdiction.registered', 'Registered'),
                    className: 'status-registered'
                };
            case 'rejected':
                return {
                    icon: "\u274C",
                    text: t('attorney.jurisdiction.rejected', 'Rejected'),
                    className: 'status-rejected'
                };
            default:
                return {
                    icon: "\u2753",
                    text: filing.status,
                    className: 'status-unknown'
                };
        }
    };
    const status = getStatusDisplay();
    const flag = $0378d3260046065e$var$countryFlags[filing.jurisdiction] || "\uD83C\uDF10";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
        className: "jurisdiction-row",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                className: "jurisdiction-country",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "country-flag",
                        children: flag
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "country-code",
                        children: filing.jurisdiction
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                className: `jurisdiction-status ${status.className}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "status-icon",
                        children: status.icon
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "status-text",
                        children: status.text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "jurisdiction-ref",
                children: filing.ipOfficeRef || "\u2014"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "jurisdiction-actions",
                children: filing.status === 'pending' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "btn-file-now",
                    onClick: onFileNow,
                    children: t('attorney.jurisdiction.fileNow', 'File Now')
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "btn-view",
                            onClick: onView,
                            children: t('attorney.jurisdiction.view', 'View')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "btn-edit-ref",
                            onClick: onEditRef,
                            children: t('attorney.jurisdiction.editRef', 'Edit Ref')
                        })
                    ]
                })
            })
        ]
    });
}
var $0378d3260046065e$export$2e2bcd8739ae039 = $0378d3260046065e$var$JurisdictionRow;



/**
 * Filing Card Component
 * Displays a single application with its jurisdiction filing statuses
 */ function $1c28c9ffd26ebadb$var$FilingCard({ application: application, onFileNow: onFileNow, onViewFiling: onViewFiling, onEditRef: onEditRef, isHighlighted: isHighlighted, onAssignToMe: onAssignToMe, onUnassign: onUnassign, onTransfer: onTransfer, onRecall: onRecall, onAssignToStaff: onAssignToStaff, canTransferToFirm: canTransferToFirm, canRecallFromFirm: canRecallFromFirm, canReassign: canReassign, currentAttorneyId: currentAttorneyId, isAssigning: isAssigning, isUnassigning: isUnassigning, isRecalling: isRecalling }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [isDownloadingPdf, setIsDownloadingPdf] = (0, $acw62.useState)(false);
    const handleDownloadPdf = async ()=>{
        setIsDownloadingPdf(true);
        try {
            await (0, $edfde963f351996f$export$704e37ec25e80010)(application.id);
        } catch (err) {
            console.error('PDF download failed:', err);
        } finally{
            setIsDownloadingPdf(false);
        }
    };
    // Assignment info
    const assignment = application.assignment || {};
    const isAssignedToMe = assignment.attorneyId === currentAttorneyId;
    const isAssigned = assignment.isAssigned;
    const isTransferred = assignment.isTransferred;
    const pendingCount = application.filings?.filter((f)=>f.status === 'pending').length || 0;
    const filedCount = application.filings?.filter((f)=>f.status === 'filed').length || 0;
    const totalCount = application.filings?.length || 0;
    const getStatusIndicator = ()=>{
        if (pendingCount === 0) return {
            emoji: "\uD83D\uDFE2",
            text: t('attorney.filingCard.allFiled', 'All filed')
        };
        if (filedCount > 0) return {
            emoji: "\uD83D\uDFE1",
            text: t('attorney.filingCard.partiallyFiled', 'In progress')
        };
        return {
            emoji: "\uD83D\uDFE0",
            text: t('attorney.filingCard.pending', 'Pending')
        };
    };
    const status = getStatusIndicator();
    // Get classes from amended data first, then fall back to original
    const effectiveClassification = {
        ...application.classification || {},
        ...application.amendments?.classification || {}
    };
    const classNumbers = effectiveClassification.selectedClasses?.length > 0 ? effectiveClassification.selectedClasses.map((cls)=>cls.classNumber || cls.number || cls.class).filter(Boolean) : effectiveClassification.niceClasses || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `filing-card ${isHighlighted ? 'filing-card-highlighted' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-card-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "filing-card-title",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "filing-card-status-indicator",
                                children: status.emoji
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "filing-card-info",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "filing-card-app-id",
                                        children: application.applicationId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "filing-card-trademark-name",
                                        children: application.trademark?.name || 'Unknown'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "filing-card-status-text",
                        children: status.text
                    }),
                    application.amendmentStatus === 'pending_approval' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "filing-card-amendment-badge filing-card-amendment-pending",
                        children: "\u23F3 Pending Approval"
                    }),
                    application.amendmentStatus === 'query_received' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "filing-card-amendment-badge filing-card-amendment-query",
                        children: "\u2753 Customer Query"
                    }),
                    application.amendmentStatus === 'approved' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "filing-card-amendment-badge filing-card-amendment-approved",
                        children: "\u2713 Changes Approved"
                    }),
                    !application.amendmentStatus && application.amendmentHistory && application.amendmentHistory.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "filing-card-amendment-badge",
                        children: [
                            "\u270F ",
                            application.amendmentHistory.length,
                            " ",
                            application.amendmentHistory.length === 1 ? 'change' : 'changes'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-card-meta",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "filing-card-client",
                        children: [
                            t('attorney.filingCard.client', 'Client'),
                            ": ",
                            application.clientName || 'Unknown'
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "filing-card-classes",
                        children: [
                            t('attorney.filingCard.classes', 'Classes'),
                            ": ",
                            classNumbers.length > 0 ? classNumbers.join(', ') : '-'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-card-assignment",
                children: [
                    isTransferred && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "assignment-badge assignment-transferred",
                        children: [
                            t('attorney.filingCard.transferredTo', 'Transferred to'),
                            ": ",
                            assignment.orgName
                        ]
                    }),
                    isAssigned ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `assignment-badge ${isAssignedToMe ? 'assignment-mine' : 'assignment-other'}`,
                        children: isAssignedToMe ? t('attorney.filingCard.assignedToYou', 'Assigned to you') : `${t('attorney.filingCard.assignedTo', 'Assigned to')}: ${assignment.attorneyName || 'Unknown'}`
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "assignment-badge assignment-unassigned",
                        children: t('attorney.filingCard.unassigned', 'Unassigned')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "filing-card-jurisdictions",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "jurisdiction-table",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: t('attorney.filingCard.country', 'Country')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: t('attorney.filingCard.status', 'Status')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: t('attorney.filingCard.ipOfficeRef', 'IP Office Ref')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: t('attorney.filingCard.actions', 'Actions')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: application.filings?.map((filing)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0378d3260046065e$export$2e2bcd8739ae039), {
                                    filing: filing,
                                    onFileNow: ()=>onFileNow(application, filing),
                                    onView: ()=>onViewFiling(application, filing),
                                    onEditRef: ()=>onEditRef(application, filing)
                                }, filing.jurisdiction))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-card-footer",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "filing-card-progress",
                        children: [
                            filedCount,
                            "/",
                            totalCount,
                            " ",
                            t('attorney.filingCard.jurisdictionsFiled', 'jurisdictions filed')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "filing-card-actions",
                        children: [
                            !isAssigned && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-action-btn assign-btn",
                                onClick: ()=>onAssignToMe(application.id),
                                disabled: isAssigning,
                                children: isAssigning ? t('attorney.filingCard.assigning', 'Assigning...') : t('attorney.filingCard.assignToMe', 'Assign to Me')
                            }),
                            isAssignedToMe && canReassign && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-action-btn unassign-btn",
                                onClick: ()=>onUnassign(application.id),
                                disabled: isUnassigning,
                                children: isUnassigning ? t('attorney.filingCard.unassigning', 'Unassigning...') : t('attorney.filingCard.unassign', 'Unassign')
                            }),
                            canTransferToFirm && !isTransferred && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-action-btn transfer-btn",
                                onClick: ()=>onTransfer(application),
                                children: t('attorney.filingCard.transfer', 'Transfer to Firm')
                            }),
                            canRecallFromFirm && isTransferred && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-action-btn recall-btn",
                                onClick: ()=>onRecall(application),
                                disabled: isRecalling,
                                children: isRecalling ? t('attorney.filingCard.recalling', 'Recalling...') : t('attorney.filingCard.recall', 'Recall to MarkoTM')
                            }),
                            canReassign && onAssignToStaff && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-action-btn assign-staff-btn",
                                onClick: ()=>onAssignToStaff(application),
                                children: t('attorney.filingCard.assignToStaff', 'Assign to Staff')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-action-btn pdf-btn",
                                onClick: handleDownloadPdf,
                                disabled: isDownloadingPdf,
                                title: t('attorney.filingCard.downloadPdf', 'Download Application Summary PDF'),
                                children: isDownloadingPdf ? t('attorney.filingCard.downloading', 'Downloading...') : t('attorney.filingCard.downloadPdf', 'Download PDF')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $1c28c9ffd26ebadb$export$2e2bcd8739ae039 = $1c28c9ffd26ebadb$var$FilingCard;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



async function $84b306191205d4ef$export$3573d7628f2e20d7(options = {}) {
    const params = new URLSearchParams();
    if (options.active !== undefined) params.append('active', options.active);
    const queryString = params.toString();
    const url = queryString ? `/jurisdictions?${queryString}` : '/jurisdictions';
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(url);
    return response.data;
}
async function $84b306191205d4ef$export$58e6504a05729717(code) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/jurisdictions/${code}`);
    return response.data;
}
async function $84b306191205d4ef$export$446483cbbafcb31f(data) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post('/jurisdictions', data);
    return response.data;
}
async function $84b306191205d4ef$export$5d950eb79e1148fb(code, data) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).patch(`/jurisdictions/${code}`, data);
    return response.data;
}
async function $84b306191205d4ef$export$e5b70f7a29d8eb7e(code) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).delete(`/jurisdictions/${code}`);
    return response.data;
}
var $84b306191205d4ef$export$2e2bcd8739ae039 = {
    getJurisdictions: $84b306191205d4ef$export$3573d7628f2e20d7,
    getJurisdiction: $84b306191205d4ef$export$58e6504a05729717,
    createJurisdiction: $84b306191205d4ef$export$446483cbbafcb31f,
    updateJurisdiction: $84b306191205d4ef$export$5d950eb79e1148fb,
    deleteJurisdiction: $84b306191205d4ef$export$e5b70f7a29d8eb7e
};




const $ab1744d38d56125b$export$c8d831ea9b7879bd = [
    'attorney',
    'filing-queue'
];
const $ab1744d38d56125b$export$8b630d47d4081367 = [
    'attorney',
    'org-members'
];
function $ab1744d38d56125b$export$d6cbc586237c3e93(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$ab1744d38d56125b$export$c8d831ea9b7879bd,
            options
        ],
        queryFn: ()=>(0, $edfde963f351996f$export$2e2bcd8739ae039).getFilingQueue(options),
        staleTime: 120000,
        refetchOnWindowFocus: true
    });
}
function $ab1744d38d56125b$export$30f98089ffa85d4e(applicationId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$ab1744d38d56125b$export$c8d831ea9b7879bd,
            applicationId
        ],
        queryFn: ()=>(0, $edfde963f351996f$export$2e2bcd8739ae039).getFilingApplication(applicationId),
        enabled: !!applicationId,
        staleTime: 120000
    });
}
function $ab1744d38d56125b$export$570ff2e9d11fe70a() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, data: data })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).markAsFiled(applicationId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$bc5e7b3f268ad43d() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, jurisdiction: jurisdiction, status: status, data: data })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).updateFilingStatus(applicationId, jurisdiction, status, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$3fa37cff68589f54() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, attorneyId: attorneyId })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).assignApplication(applicationId, attorneyId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$5301a6f9f87bfb3e() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, targetOrgId: targetOrgId, reason: reason })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).transferApplication(applicationId, targetOrgId, reason),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$e4f94caa39769749() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (applicationId)=>(0, $edfde963f351996f$export$2e2bcd8739ae039).unassignApplication(applicationId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$706227e398c34fc3() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (applicationId)=>(0, $edfde963f351996f$export$2e2bcd8739ae039).recallApplication(applicationId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$c4d3b480ebf8ba52(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $ab1744d38d56125b$export$8b630d47d4081367,
        queryFn: ()=>(0, $edfde963f351996f$export$2e2bcd8739ae039).getOrgMembers(),
        staleTime: 300000,
        enabled: options.enabled !== false
    });
}
function $ab1744d38d56125b$export$6fe1e18638226e1b() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, data: data })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).amendApplication(applicationId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$37605fd17336b015() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, data: data })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).sendAmendmentEmail(applicationId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
function $ab1744d38d56125b$export$41900ff64287345c() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, amendmentId: amendmentId })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).approveAmendment(applicationId, amendmentId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $ab1744d38d56125b$export$c8d831ea9b7879bd
            });
        }
    });
}
var $ab1744d38d56125b$export$2e2bcd8739ae039 = {
    useFilingQueue: $ab1744d38d56125b$export$d6cbc586237c3e93,
    useFilingApplication: $ab1744d38d56125b$export$30f98089ffa85d4e,
    useMarkAsFiled: $ab1744d38d56125b$export$570ff2e9d11fe70a,
    useUpdateFilingStatus: $ab1744d38d56125b$export$bc5e7b3f268ad43d,
    useAssignApplication: $ab1744d38d56125b$export$3fa37cff68589f54,
    useTransferApplication: $ab1744d38d56125b$export$5301a6f9f87bfb3e,
    useUnassignApplication: $ab1744d38d56125b$export$e4f94caa39769749,
    useRecallApplication: $ab1744d38d56125b$export$706227e398c34fc3,
    useOrgMembers: $ab1744d38d56125b$export$c4d3b480ebf8ba52,
    useAmendApplication: $ab1744d38d56125b$export$6fe1e18638226e1b,
    useSendAmendmentEmail: $ab1744d38d56125b$export$37605fd17336b015,
    useApproveAmendment: $ab1744d38d56125b$export$41900ff64287345c
};




// Country flag emojis
const $ff1990a980e20e67$var$countryFlags = {
    AU: "\uD83C\uDDE6\uD83C\uDDFA",
    US: "\uD83C\uDDFA\uD83C\uDDF8",
    EU: "\uD83C\uDDEA\uD83C\uDDFA",
    UK: "\uD83C\uDDEC\uD83C\uDDE7",
    NZ: "\uD83C\uDDF3\uD83C\uDDFF",
    CA: "\uD83C\uDDE8\uD83C\uDDE6",
    SG: "\uD83C\uDDF8\uD83C\uDDEC"
};
/**
 * File Now Modal Component
 * Complete filing review with all application data for attorney
 */ function $ff1990a980e20e67$var$FileNowModal({ application: application, jurisdiction: jurisdiction, onClose: onClose, onMarkFiled: onMarkFiled, isLoading: isLoading, viewMode: viewMode = false }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { isAttorneyAdmin: isAttorneyAdmin, isAdmin: isAdmin } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const canEdit = isAttorneyAdmin || isAdmin;
    const [ipOfficeRef, setIpOfficeRef] = (0, $acw62.useState)('');
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const [activeTab, setActiveTab] = (0, $acw62.useState)('overview');
    // Edit mode state
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [editData, setEditData] = (0, $acw62.useState)(null);
    const [editNote, setEditNote] = (0, $acw62.useState)('');
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    // Email compose state
    const [emailSubject, setEmailSubject] = (0, $acw62.useState)('');
    const [emailBody, setEmailBody] = (0, $acw62.useState)('');
    const [includeChangesSummary, setIncludeChangesSummary] = (0, $acw62.useState)(true);
    const [includeApprovalButtons, setIncludeApprovalButtons] = (0, $acw62.useState)(true);
    const [isSendingEmail, setIsSendingEmail] = (0, $acw62.useState)(false);
    const [emailSent, setEmailSent] = (0, $acw62.useState)(false);
    // Mutations
    const amendMutation = (0, $ab1744d38d56125b$export$6fe1e18638226e1b)();
    const sendEmailMutation = (0, $ab1744d38d56125b$export$37605fd17336b015)();
    const approveMutation = (0, $ab1744d38d56125b$export$41900ff64287345c)();
    // Fetch jurisdiction details
    const { data: jurisdictionData } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'jurisdiction',
            jurisdiction.jurisdiction
        ],
        queryFn: ()=>(0, $84b306191205d4ef$export$2e2bcd8739ae039).getJurisdiction(jurisdiction.jurisdiction)
    });
    const handleCopyAppId = ()=>{
        navigator.clipboard.writeText(application.applicationId);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    const handleCopyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (ipOfficeRef.trim()) onMarkFiled(ipOfficeRef.trim());
    };
    // --- Edit mode helpers ---
    const startEditing = ()=>{
        // Initialize edit data from current effective values (amendments overlay applied)
        const effectiveTrademark = {
            ...application.trademark || {},
            ...application.amendments?.trademark || {}
        };
        const effectiveApplicant = {
            ...application.applicant || {},
            ...application.amendments?.applicant || {}
        };
        const effectiveClassification = {
            ...application.classification || {},
            ...application.amendments?.classification || {}
        };
        setEditData({
            trademark: {
                name: effectiveTrademark.name || '',
                type: effectiveTrademark.type || '',
                description: effectiveTrademark.description || ''
            },
            applicant: {
                applicantName: effectiveApplicant.applicantName || '',
                applicantType: effectiveApplicant.applicantType || '',
                businessIdentifier: effectiveApplicant.businessIdentifier || '',
                email: effectiveApplicant.email || '',
                phone: effectiveApplicant.phone || '',
                address: {
                    street: effectiveApplicant.address?.street || '',
                    city: effectiveApplicant.address?.city || '',
                    state: effectiveApplicant.address?.state || '',
                    postalCode: effectiveApplicant.address?.postalCode || '',
                    country: effectiveApplicant.address?.country || ''
                }
            },
            classification: {
                selectedClasses: (effectiveClassification.selectedClasses || []).map((cls)=>({
                        classNumber: cls.classNumber || cls.number || cls.class,
                        className: cls.className || cls.name || '',
                        goodsServices: [
                            ...cls.goodsServices || []
                        ].map((gs)=>typeof gs === 'string' ? gs : gs.description || gs.term || '')
                    }))
            }
        });
        setEditNote('');
        setIsEditing(true);
    };
    const cancelEditing = ()=>{
        setIsEditing(false);
        setEditData(null);
        setEditNote('');
    };
    const computeChanges = ()=>{
        if (!editData) return [];
        const changes = [];
        const orig = application;
        // Trademark changes
        const origTm = {
            ...orig.trademark || {},
            ...orig.amendments?.trademark || {}
        };
        if (editData.trademark.name !== (origTm.name || '')) changes.push({
            section: 'trademark',
            field: 'name',
            oldValue: origTm.name || '',
            newValue: editData.trademark.name
        });
        if (editData.trademark.type !== (origTm.type || '')) changes.push({
            section: 'trademark',
            field: 'type',
            oldValue: origTm.type || '',
            newValue: editData.trademark.type
        });
        if (editData.trademark.description !== (origTm.description || '')) changes.push({
            section: 'trademark',
            field: 'description',
            oldValue: origTm.description || '',
            newValue: editData.trademark.description
        });
        // Applicant changes — check all fields
        const origApp = {
            ...orig.applicant || {},
            ...orig.amendments?.applicant || {}
        };
        const applicantFields = [
            'applicantName',
            'applicantType',
            'businessIdentifier',
            'email',
            'phone'
        ];
        applicantFields.forEach((field)=>{
            if (editData.applicant[field] !== (origApp[field] || '')) changes.push({
                section: 'applicant',
                field: field,
                oldValue: origApp[field] || '',
                newValue: editData.applicant[field]
            });
        });
        // Address sub-fields
        const origAddr = origApp.address || {};
        const editAddr = editData.applicant.address || {};
        const addressFields = [
            'street',
            'city',
            'state',
            'postalCode',
            'country'
        ];
        addressFields.forEach((field)=>{
            if ((editAddr[field] || '') !== (origAddr[field] || '')) changes.push({
                section: 'applicant',
                field: `address.${field}`,
                oldValue: origAddr[field] || '',
                newValue: editAddr[field] || ''
            });
        });
        // Classification changes (simplified — check if goods/services arrays differ)
        const origCls = {
            ...orig.classification || {},
            ...orig.amendments?.classification || {}
        };
        const origClasses = origCls.selectedClasses || [];
        const newClasses = editData.classification.selectedClasses || [];
        if (JSON.stringify(origClasses) !== JSON.stringify(newClasses)) changes.push({
            section: 'classification',
            field: 'selectedClasses',
            oldValue: origClasses,
            newValue: newClasses
        });
        return changes;
    };
    const saveAmendments = async ()=>{
        if (!editData) return;
        const changes = computeChanges();
        if (changes.length === 0) {
            cancelEditing();
            return;
        }
        setIsSaving(true);
        try {
            await amendMutation.mutateAsync({
                applicationId: application.id,
                data: {
                    amendments: editData,
                    note: editNote,
                    changes: changes
                }
            });
            setIsEditing(false);
            setEditData(null);
            // Pre-populate email tab with defaults only if not already drafted
            if (!emailSubject) {
                const appId = application.applicationId || application.id;
                setEmailSubject(`Update on your trademark application \u{2014} ${appId}`);
            }
            if (!emailBody) setEmailBody(`Hi {firstName},\n\nI've completed my review of your trademark application for {trademarkName} and have made some updates to strengthen your filing.\n\n${editNote || 'Please review the changes summary below.'}\n\nIf you have any questions, please don't hesitate to reach out.`);
        } catch (err) {
            console.error('Failed to save amendments:', err);
        } finally{
            setIsSaving(false);
        }
    };
    const handleSendEmail = async ()=>{
        setIsSendingEmail(true);
        try {
            // Get latest amendment ID
            const latestAmendment = application.amendmentHistory?.[application.amendmentHistory.length - 1];
            const changesSummary = computeChangesSummaryText();
            await sendEmailMutation.mutateAsync({
                applicationId: application.id,
                data: {
                    amendmentId: latestAmendment?.id || null,
                    subject: emailSubject,
                    emailBody: emailBody,
                    changesSummary: changesSummary,
                    includeChangesSummary: includeChangesSummary,
                    includeApprovalButtons: includeApprovalButtons
                }
            });
            setEmailSent(true);
        } catch (err) {
            console.error('Failed to send email:', err);
        } finally{
            setIsSendingEmail(false);
        }
    };
    const computeChangesSummaryText = ()=>{
        const history = application.amendmentHistory || [];
        // Collect changes from ALL unapproved history entries
        const allChanges = [];
        for (const entry of history){
            if (entry.customerResponse === 'approved') continue;
            if (entry.changes) allChanges.push(...entry.changes);
        }
        if (allChanges.length === 0) return [];
        const summaryLines = allChanges.map((c)=>{
            if (c.section === 'trademark' && c.field === 'name') return `Trademark name: updated to "${c.newValue}"`;
            if (c.section === 'trademark' && c.field === 'type') return `Trademark type: updated to "${c.newValue}"`;
            if (c.section === 'trademark' && c.field === 'description') return `Trademark description: updated`;
            if (c.section === 'applicant' && c.field === 'applicantName') return `Applicant name: updated to "${c.newValue}"`;
            if (c.section === 'applicant' && c.field === 'applicantType') return `Applicant type: updated to "${c.newValue}"`;
            if (c.section === 'applicant' && c.field === 'email') return `Applicant email: updated to "${c.newValue}"`;
            if (c.section === 'applicant' && c.field === 'phone') return `Applicant phone: updated to "${c.newValue}"`;
            if (c.section === 'applicant' && c.field === 'businessIdentifier') return `Business identifier: updated to "${c.newValue}"`;
            if (c.section === 'applicant' && c.field.startsWith('address.')) return `Applicant address: updated`;
            if (c.section === 'classification') return `Classes & goods/services: updated`;
            return `${c.section}.${c.field}: updated`;
        });
        // Deduplicate (e.g. multiple address fields → single "Applicant address: updated")
        return [
            ...new Set(summaryLines)
        ];
    };
    // Edit helpers for classification
    const addServiceToClass = (classIndex, service)=>{
        if (!service.trim() || !editData) return;
        const newClasses = [
            ...editData.classification.selectedClasses
        ];
        newClasses[classIndex] = {
            ...newClasses[classIndex],
            goodsServices: [
                ...newClasses[classIndex].goodsServices,
                service.trim()
            ]
        };
        setEditData({
            ...editData,
            classification: {
                ...editData.classification,
                selectedClasses: newClasses
            }
        });
    };
    const removeServiceFromClass = (classIndex, serviceIndex)=>{
        if (!editData) return;
        const newClasses = [
            ...editData.classification.selectedClasses
        ];
        const newServices = [
            ...newClasses[classIndex].goodsServices
        ];
        newServices.splice(serviceIndex, 1);
        newClasses[classIndex] = {
            ...newClasses[classIndex],
            goodsServices: newServices
        };
        setEditData({
            ...editData,
            classification: {
                ...editData.classification,
                selectedClasses: newClasses
            }
        });
    };
    const removeClass = (classIndex)=>{
        if (!editData) return;
        const newClasses = [
            ...editData.classification.selectedClasses
        ];
        newClasses.splice(classIndex, 1);
        setEditData({
            ...editData,
            classification: {
                ...editData.classification,
                selectedClasses: newClasses
            }
        });
    };
    const addNewClass = ()=>{
        if (!editData) return;
        const newClasses = [
            ...editData.classification.selectedClasses,
            {
                classNumber: '',
                className: '',
                goodsServices: []
            }
        ];
        setEditData({
            ...editData,
            classification: {
                ...editData.classification,
                selectedClasses: newClasses
            }
        });
    };
    const flag = $ff1990a980e20e67$var$countryFlags[jurisdiction.jurisdiction] || "\uD83C\uDF10";
    const portal = jurisdictionData?.portal || {};
    // Effective data (original + amendments overlay)
    const trademark = (0, $acw62.useMemo)(()=>({
            ...application.trademark || {},
            ...application.amendments?.trademark || {}
        }), [
        application
    ]);
    const applicant = (0, $acw62.useMemo)(()=>({
            ...application.applicant || {},
            ...application.amendments?.applicant || {}
        }), [
        application
    ]);
    const classification = (0, $acw62.useMemo)(()=>({
            ...application.classification || {},
            ...application.amendments?.classification || {}
        }), [
        application
    ]);
    // Format address
    const formatAddress = (addr)=>{
        if (!addr) return 'Not provided';
        const parts = [
            addr.street,
            addr.city,
            addr.state,
            addr.postalCode,
            addr.country
        ].filter(Boolean);
        return parts.length > 0 ? parts.join(', ') : 'Not provided';
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "file-now-modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "file-now-modal file-now-modal-large",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "file-now-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "file-now-modal-close",
                            onClick: onClose,
                            children: "\u2715"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            children: [
                                flag,
                                " ",
                                viewMode ? t('attorney.fileNowModal.viewTitle', 'Filing Details - {{country}}', {
                                    country: jurisdictionData?.name || jurisdiction.jurisdiction
                                }) : t('attorney.fileNowModal.title', 'File in {{country}}', {
                                    country: jurisdictionData?.name || jurisdiction.jurisdiction
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "file-now-modal-subtitle",
                            children: [
                                trademark.name,
                                " \u2022 ",
                                application.applicationId,
                                viewMode && jurisdiction.ipOfficeRef && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        " \u2022 ",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                            children: [
                                                "Ref: ",
                                                jurisdiction.ipOfficeRef
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "file-now-tabs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'overview' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('overview'),
                            children: "Overview"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'trademark' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('trademark'),
                            children: "Trademark"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'applicant' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('applicant'),
                            children: "Applicant"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'classes' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('classes'),
                            children: "Classes & Goods"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'all' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('all'),
                            children: "All Info"
                        }),
                        canEdit && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'email' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('email'),
                            children: "\u2709 Send to Customer"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'history' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('history'),
                            children: "\uD83D\uDCCB History"
                        }),
                        application.amendmentStatus && application.amendmentStatus !== 'approved' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `file-now-tab ${activeTab === 'pending' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('pending'),
                            children: "\u23F3 Pending"
                        }),
                        canEdit && !isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "file-now-tab file-now-edit-btn",
                            onClick: startEditing,
                            children: "\u270F Edit"
                        }),
                        isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "file-now-tab file-now-edit-btn editing",
                            onClick: cancelEditing,
                            children: "\u2715 Cancel Edit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "file-now-modal-content",
                    children: [
                        activeTab === 'overview' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Application Reference"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "section-description",
                                            children: "Use this reference in all IP Office forms:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "reference-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "reference-value",
                                                    children: application.applicationId
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "btn-copy",
                                                    onClick: handleCopyAppId,
                                                    children: copied ? 'Copied!' : 'Copy'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Filing Summary"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "summary-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "summary-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-label",
                                                            children: "Trademark"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-value",
                                                            children: trademark.name || 'Unknown'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "summary-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-label",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-value",
                                                            children: trademark.type || 'Figurative'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "summary-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-label",
                                                            children: "Applicant"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-value",
                                                            children: applicant.applicantName || application.clientName || 'Unknown'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "summary-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-label",
                                                            children: "Classes"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "summary-value",
                                                            children: classification.selectedClasses?.length > 0 ? classification.selectedClasses.map((cls)=>cls.classNumber || cls.number || cls.class).filter(Boolean).join(', ') : classification.niceClasses?.length > 0 ? classification.niceClasses.join(', ') : 'Not specified'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "IP Office Portal"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "portal-info",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "portal-flag",
                                                    children: flag
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "portal-name",
                                                    children: jurisdictionData?.office || 'IP Office'
                                                })
                                            ]
                                        }),
                                        portal.url && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: portal.filingUrl || portal.url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "btn-open-portal",
                                            children: "Open Portal \u2192"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Filing Steps"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                            className: "instructions-list",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        "Log in to ",
                                                        jurisdictionData?.office || 'IP Office',
                                                        " portal"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    children: "Start new trademark application"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        'Enter "',
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: application.applicationId
                                                        }),
                                                        '" in "Your Reference" field'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    children: "Enter applicant details (see Applicant tab)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    children: "Upload trademark image (see Trademark tab)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    children: "Enter goods/services (see Classes tab)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    children: "Complete payment on IP Office"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        "Note the ",
                                                        jurisdictionData?.office || 'office',
                                                        " reference number"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'trademark' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Trademark Details"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: trademark.name || 'Not provided'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(trademark.name),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: trademark.type || 'Figurative'
                                                        })
                                                    ]
                                                }),
                                                trademark.description && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Description"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: trademark.description
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(trademark.description),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                trademark.colors && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Colors"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: trademark.colors
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Trademark Image"
                                        }),
                                        trademark.imageUrl ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "trademark-image-container",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: trademark.imageUrl,
                                                    alt: trademark.name,
                                                    className: "trademark-image-preview"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "trademark-image-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: trademark.imageUrl,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "btn-download",
                                                            children: "Download Image"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "file-name",
                                                            children: trademark.fileName || 'trademark-image.png'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "no-data",
                                            children: "No trademark image available"
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'applicant' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Applicant Details"
                                        }),
                                        isEditing && editData ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-grid edit-mode",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.applicantName,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        applicantName: e.target.value
                                                                    }
                                                                })
                                                        }),
                                                        editData.applicant.applicantName !== (applicant.applicantName || '') && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "amendment-badge",
                                                            children: [
                                                                'Changed from: "',
                                                                applicant.applicantName,
                                                                '"'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                            className: "edit-input",
                                                            value: editData.applicant.applicantType,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        applicantType: e.target.value
                                                                    }
                                                                }),
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select type"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "individual",
                                                                    children: "Individual"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "business",
                                                                    children: "Business"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "company",
                                                                    children: "Company"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "trust",
                                                                    children: "Trust"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "partnership",
                                                                    children: "Partnership"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Business ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.businessIdentifier,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        businessIdentifier: e.target.value
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Street"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.address.street,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        address: {
                                                                            ...editData.applicant.address,
                                                                            street: e.target.value
                                                                        }
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "City"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.address.city,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        address: {
                                                                            ...editData.applicant.address,
                                                                            city: e.target.value
                                                                        }
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "State"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.address.state,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        address: {
                                                                            ...editData.applicant.address,
                                                                            state: e.target.value
                                                                        }
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Postal Code"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.address.postalCode,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        address: {
                                                                            ...editData.applicant.address,
                                                                            postalCode: e.target.value
                                                                        }
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Country"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.address.country,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        address: {
                                                                            ...editData.applicant.address,
                                                                            country: e.target.value
                                                                        }
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.email,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        email: e.target.value
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Phone"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input",
                                                            value: editData.applicant.phone,
                                                            onChange: (e)=>setEditData({
                                                                    ...editData,
                                                                    applicant: {
                                                                        ...editData.applicant,
                                                                        phone: e.target.value
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : applicant.applicantName ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: applicant.applicantName
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(applicant.applicantName),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                applicant.applicantType && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: applicant.applicantType
                                                        })
                                                    ]
                                                }),
                                                applicant.businessIdentifier && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: applicant.businessIdentifierType || 'Business ID'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: applicant.businessIdentifier
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(applicant.businessIdentifier),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Address"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: formatAddress(applicant.address)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(formatAddress(applicant.address)),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                applicant.email && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: applicant.email
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(applicant.email),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                applicant.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Phone"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: applicant.phone
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(applicant.phone),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "no-data",
                                            children: "No applicant information available"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Client Contact"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Client Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: application.clientName || 'Unknown'
                                                        })
                                                    ]
                                                }),
                                                application.clientEmail && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "data-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-label",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "data-value",
                                                            children: application.clientEmail
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'classes' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: isEditing && editData ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    editData.classification.selectedClasses.map((cls, classIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                            className: "file-now-section",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input edit-input-inline",
                                                            value: cls.classNumber,
                                                            onChange: (e)=>{
                                                                const newClasses = [
                                                                    ...editData.classification.selectedClasses
                                                                ];
                                                                newClasses[classIdx] = {
                                                                    ...newClasses[classIdx],
                                                                    classNumber: e.target.value
                                                                };
                                                                setEditData({
                                                                    ...editData,
                                                                    classification: {
                                                                        ...editData.classification,
                                                                        selectedClasses: newClasses
                                                                    }
                                                                });
                                                            },
                                                            placeholder: "Class #",
                                                            style: {
                                                                width: '60px',
                                                                display: 'inline-block',
                                                                marginRight: '8px'
                                                            }
                                                        }),
                                                        "\u2014",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "edit-input edit-input-inline",
                                                            value: cls.className,
                                                            onChange: (e)=>{
                                                                const newClasses = [
                                                                    ...editData.classification.selectedClasses
                                                                ];
                                                                newClasses[classIdx] = {
                                                                    ...newClasses[classIdx],
                                                                    className: e.target.value
                                                                };
                                                                setEditData({
                                                                    ...editData,
                                                                    classification: {
                                                                        ...editData.classification,
                                                                        selectedClasses: newClasses
                                                                    }
                                                                });
                                                            },
                                                            placeholder: "Class name",
                                                            style: {
                                                                width: '200px',
                                                                display: 'inline-block',
                                                                marginLeft: '8px'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-remove-class",
                                                            onClick: ()=>removeClass(classIdx),
                                                            title: "Remove this entire class",
                                                            children: "\u2715 Remove Class"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "goods-services-list edit-mode",
                                                    children: [
                                                        cls.goodsServices.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "goods-item edit-mode",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "goods-text",
                                                                        children: item
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        className: "btn-remove-small",
                                                                        onClick: ()=>removeServiceFromClass(classIdx, i),
                                                                        children: "\u2715 Remove"
                                                                    })
                                                                ]
                                                            }, i)),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "goods-add-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    className: "edit-input",
                                                                    placeholder: "+ Add service...",
                                                                    onKeyDown: (e)=>{
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            addServiceToClass(classIdx, e.target.value);
                                                                            e.target.value = '';
                                                                        }
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: "btn-add-small",
                                                                    onClick: (e)=>{
                                                                        const input = e.target.previousSibling;
                                                                        addServiceToClass(classIdx, input.value);
                                                                        input.value = '';
                                                                    },
                                                                    children: "Add"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, classIdx)),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-add-class",
                                        onClick: addNewClass,
                                        children: "+ Add New Class"
                                    })
                                ]
                            }) : classification.selectedClasses?.length > 0 ? classification.selectedClasses.map((cls, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            children: [
                                                "Class ",
                                                cls.classNumber || cls.number || cls.class,
                                                cls.className || cls.name ? ` \u{2014} ${cls.className || cls.name}` : ''
                                            ]
                                        }),
                                        cls.goodsServices?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "goods-services-list",
                                            children: cls.goodsServices.map((item, i)=>{
                                                const text = typeof item === 'string' ? item : item.description || item.term || JSON.stringify(item);
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "goods-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "goods-text",
                                                            children: text
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "btn-copy-small",
                                                            onClick: ()=>handleCopyText(text),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "no-data",
                                            children: "No goods/services specified for this class"
                                        })
                                    ]
                                }, idx)) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                        className: "file-now-section",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: "Nice Classes"
                                            }),
                                            classification.niceClasses?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "classes-list",
                                                children: classification.niceClasses.map((classNum)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "class-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "class-number",
                                                                children: [
                                                                    "Class ",
                                                                    classNum
                                                                ]
                                                            }),
                                                            classification.classDescriptions?.[classNum] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "class-description",
                                                                children: classification.classDescriptions[classNum]
                                                            })
                                                        ]
                                                    }, classNum))
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "no-data",
                                                children: "No classes specified"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                        className: "file-now-section",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: "Goods & Services"
                                            }),
                                            classification.goodsServices?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "goods-services-list",
                                                children: classification.goodsServices.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "goods-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "goods-text",
                                                                children: typeof item === 'string' ? item : item.description || JSON.stringify(item)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                className: "btn-copy-small",
                                                                onClick: ()=>handleCopyText(typeof item === 'string' ? item : item.description),
                                                                children: "Copy"
                                                            })
                                                        ]
                                                    }, index))
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "no-data",
                                                children: "No goods/services descriptions available"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        activeTab === 'all' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Trademark"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "all-info-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: trademark.name || 'Not provided'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: trademark.type || 'Figurative'
                                                        })
                                                    ]
                                                }),
                                                trademark.imageUrl && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item all-info-item-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Image"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: trademark.imageUrl,
                                                            alt: trademark.name,
                                                            className: "all-info-image"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Applicant"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "all-info-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: applicant.applicantName || application.clientName || 'Not provided'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: applicant.applicantType || 'Not specified'
                                                        })
                                                    ]
                                                }),
                                                applicant.businessIdentifier && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: applicant.businessIdentifierType || 'Business ID'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: applicant.businessIdentifier
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item all-info-item-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Address"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: formatAddress(applicant.address)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: applicant.email || application.clientEmail || 'Not provided'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Phone"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: applicant.phone || 'Not provided'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Classification"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "all-info-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Nice Classes"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: classification.niceClasses?.length > 0 ? classification.niceClasses.join(', ') : 'Not specified'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Countries"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: classification.countries?.length > 0 ? classification.countries.map((c)=>c.code || c.name || c).join(', ') : 'Not specified'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        classification.selectedClasses?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "all-info-classes",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    children: "Class Details"
                                                }),
                                                classification.selectedClasses.map((cls, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "all-info-class-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                                children: [
                                                                    "Class ",
                                                                    cls.classNumber || cls.number || cls.class || cls,
                                                                    cls.className || cls.name ? ` \u{2014} ${cls.className || cls.name}` : ''
                                                                ]
                                                            }),
                                                            cls.description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                children: cls.description
                                                            }),
                                                            Array.isArray(cls.goodsServices) ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                style: {
                                                                    margin: '4px 0 0 16px',
                                                                    padding: 0
                                                                },
                                                                children: cls.goodsServices.map((gs, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                        style: {
                                                                            fontSize: '13px',
                                                                            color: '#555'
                                                                        },
                                                                        children: typeof gs === 'string' ? gs : gs.term || gs.description || JSON.stringify(gs)
                                                                    }, i))
                                                            }) : cls.goodsServices ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                children: cls.goodsServices
                                                            }) : null
                                                        ]
                                                    }, idx))
                                            ]
                                        })
                                    ]
                                }),
                                application.analysis && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Risk Analysis"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "all-info-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Risk Level"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `all-info-value risk-${application.analysis.riskLevel?.toLowerCase()}`,
                                                            children: application.analysis.riskLevel || 'Not assessed'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item all-info-item-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Summary"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: application.analysis.summary || 'No summary available'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    className: "file-now-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Application Details"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "all-info-grid",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Application ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: application.applicationId
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: application.status
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Created"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: application.createdAt ? new Date(application.createdAt).toLocaleDateString() : 'Unknown'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "all-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-label",
                                                            children: "Payment Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "all-info-value",
                                                            children: application.paymentCompletedAt ? new Date(application.paymentCompletedAt).toLocaleDateString() : 'Unknown'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        viewMode && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "file-now-section file-now-section-form",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Filing Details"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "data-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "data-label",
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "data-value",
                                                    style: {
                                                        color: 'var(--success, #10b981)',
                                                        fontWeight: 600
                                                    },
                                                    children: "\u2705 Filed"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "data-label",
                                                    children: "IP Office Ref"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "data-value",
                                                    children: jurisdiction.ipOfficeRef || 'Not recorded'
                                                }),
                                                jurisdiction.ipOfficeRef && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "btn-copy-small",
                                                    onClick: ()=>handleCopyText(jurisdiction.ipOfficeRef),
                                                    children: "Copy"
                                                })
                                            ]
                                        }),
                                        jurisdiction.filedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "data-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "data-label",
                                                    children: "Filed Date"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "data-value",
                                                    children: new Date(jurisdiction.filedAt).toLocaleDateString()
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "file-now-modal-actions",
                                    style: {
                                        marginTop: '16px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "btn-cancel",
                                        onClick: onClose,
                                        children: "Close"
                                    })
                                })
                            ]
                        }),
                        !viewMode && application.amendmentStatus === 'pending_approval' && activeTab !== 'email' && activeTab !== 'history' && /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                            className: "file-now-section amendment-pending-banner",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "\u23F3 ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Awaiting Customer Approval"
                                    }),
                                    " \u2014 This application has pending amendments that the customer has not yet approved. Filing should wait until they confirm."
                                ]
                            })
                        }),
                        !viewMode && application.amendmentStatus === 'query_received' && activeTab !== 'email' && activeTab !== 'history' && /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                            className: "file-now-section amendment-pending-banner amendment-query-banner",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "\u2753 ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Customer Has a Question"
                                    }),
                                    " \u2014 The customer responded with a question about the amendments. Please resolve before filing."
                                ]
                            })
                        }),
                        !viewMode && activeTab !== 'email' && activeTab !== 'history' && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "file-now-section file-now-section-form",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Mark as Filed"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "section-description",
                                    children: "After submitting at the IP Office, enter the reference number you received:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: ipOfficeRef,
                                            onChange: (e)=>setIpOfficeRef(e.target.value),
                                            placeholder: jurisdictionData?.referenceFormat?.example || 'e.g., TM2025/12345',
                                            className: "ip-office-ref-input"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "file-now-modal-actions",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    className: "btn-cancel",
                                                    onClick: onClose,
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "submit",
                                                    className: "btn-mark-filed",
                                                    disabled: !ipOfficeRef.trim() || isLoading || application.amendmentStatus === 'pending_approval' || application.amendmentStatus === 'query_received',
                                                    children: isLoading ? 'Marking...' : application.amendmentStatus === 'pending_approval' ? 'Awaiting Approval...' : application.amendmentStatus === 'query_received' ? 'Query Pending...' : 'Mark as Filed'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'email' && canEdit && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "file-now-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "\u2709 Send to Customer"
                                }),
                                emailSent ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "amendment-success",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            style: {
                                                fontSize: '18px',
                                                color: '#059669',
                                                fontWeight: 600
                                            },
                                            children: "\u2713 Email sent successfully"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "The customer has been notified about the changes."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "btn-cancel",
                                            onClick: ()=>setEmailSent(false),
                                            style: {
                                                marginTop: '12px'
                                            },
                                            children: "Send Another"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "email-compose-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: "To:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "email-compose-to",
                                                    children: application.clientEmail || 'Customer email'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "email-compose-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: "Subject:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    value: emailSubject,
                                                    onChange: (e)=>setEmailSubject(e.target.value),
                                                    placeholder: "Update on your trademark application",
                                                    className: "email-compose-input"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "email-compose-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: "Body:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    value: emailBody,
                                                    onChange: (e)=>setEmailBody(e.target.value),
                                                    placeholder: "Hi {firstName},  I've completed my review of your trademark application...",
                                                    className: "email-compose-textarea",
                                                    rows: 10
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "email-compose-hint",
                                                    children: [
                                                        "Use ",
                                                        '{firstName}',
                                                        " and ",
                                                        '{trademarkName}',
                                                        " as placeholders. They'll be replaced automatically."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "email-compose-options",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "email-compose-checkbox",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: includeChangesSummary,
                                                            onChange: (e)=>setIncludeChangesSummary(e.target.checked)
                                                        }),
                                                        "Include changes summary block (auto-generated)"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "email-compose-checkbox",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: includeApprovalButtons,
                                                            onChange: (e)=>setIncludeApprovalButtons(e.target.checked)
                                                        }),
                                                        "Include approval buttons (Approve / Ask a Question)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "email-compose-signature",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "signature-label",
                                                    children: "Signature (auto-appended):"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "signature-preview",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Ken McInnes"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Head of Trademark Strategy"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Registered Patent & Trade Marks Attorney"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "\uD83D\uDCDE +61 2 8267 7300 | \u2709 support@markotm.com"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "\uD83D\uDCCD Sydney | Madrid | London"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "file-now-modal-actions",
                                            style: {
                                                marginTop: '16px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    className: "btn-cancel",
                                                    onClick: onClose,
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "btn-mark-filed",
                                                    onClick: handleSendEmail,
                                                    disabled: isSendingEmail || !emailBody.trim(),
                                                    children: isSendingEmail ? 'Sending...' : 'Send Email & Notify Customer'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'history' && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "file-now-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "\uD83D\uDCCB Change History"
                                }),
                                application.amendmentHistory && application.amendmentHistory.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "amendment-history-list",
                                    children: [
                                        ...application.amendmentHistory
                                    ].reverse().map((entry, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "amendment-history-item",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "amendment-history-header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "amendment-history-dot",
                                                            children: "\u25CF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "amendment-history-date",
                                                            children: [
                                                                new Date(entry.changedAt).toLocaleDateString(),
                                                                " \u2014 ",
                                                                entry.changedByName || 'Unknown'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "amendment-history-body",
                                                    children: [
                                                        entry.changes && entry.changes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "amendment-history-changes",
                                                            children: [
                                                                "Changed: ",
                                                                entry.changes.map((c)=>`${c.section}.${c.field}`).join(', ')
                                                            ]
                                                        }),
                                                        entry.note && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "amendment-history-note",
                                                            children: [
                                                                'Note: "',
                                                                entry.note,
                                                                '"'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "amendment-history-status",
                                                            children: [
                                                                entry.customerNotified && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "badge badge-sent",
                                                                    children: "Emailed \u2713"
                                                                }),
                                                                entry.customerResponse === 'approved' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "badge badge-approved",
                                                                    children: "Approved \u2713"
                                                                }),
                                                                entry.customerResponse === 'query' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "badge badge-query",
                                                                    children: "Query received"
                                                                }),
                                                                entry.customerNotified && !entry.customerResponse && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "badge badge-pending",
                                                                    children: "Awaiting response"
                                                                }),
                                                                !entry.customerNotified && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "badge badge-draft",
                                                                    children: "Not sent"
                                                                })
                                                            ]
                                                        }),
                                                        entry.customerMessage && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "amendment-history-message",
                                                            children: [
                                                                'Customer: "',
                                                                entry.customerMessage,
                                                                '"'
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, entry.id || idx))
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "no-data",
                                    children: "No amendment history yet"
                                }),
                                application.assignment && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "amendment-history-item",
                                    style: {
                                        marginTop: '16px',
                                        opacity: 0.7
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "amendment-history-header",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "amendment-history-dot",
                                                    children: "\u25CF"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "amendment-history-date",
                                                    children: [
                                                        application.assignment.assignedAt ? new Date(application.assignment.assignedAt).toLocaleDateString() : 'Unknown date',
                                                        " \u2014 System"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "amendment-history-body",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "amendment-history-changes",
                                                children: [
                                                    "Application assigned to ",
                                                    application.assignment.attorneyName || 'attorney'
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'pending' && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "file-now-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "\u23F3 Pending Changes"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "section-description",
                                    children: "These changes are awaiting customer approval before filing can proceed."
                                }),
                                application.amendmentHistory && application.amendmentHistory.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pending-changes-list",
                                    children: application.amendmentHistory.filter((entry)=>!entry.customerResponse || entry.customerResponse !== 'approved').map((entry, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pending-change-item",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pending-change-header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "pending-change-date",
                                                            children: [
                                                                new Date(entry.changedAt).toLocaleDateString(),
                                                                " \u2014 ",
                                                                entry.changedByName || 'Unknown'
                                                            ]
                                                        }),
                                                        entry.customerNotified && !entry.customerResponse && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "badge badge-pending",
                                                            children: "Emailed, awaiting response"
                                                        }),
                                                        entry.customerResponse === 'query' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "badge badge-query",
                                                            children: "Customer has a question"
                                                        }),
                                                        !entry.customerNotified && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "badge badge-draft",
                                                            children: "Not yet sent to customer"
                                                        })
                                                    ]
                                                }),
                                                entry.note && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "pending-change-note",
                                                    children: [
                                                        '"',
                                                        entry.note,
                                                        '"'
                                                    ]
                                                }),
                                                entry.changes && entry.changes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    className: "pending-change-details",
                                                    children: entry.changes.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                                    children: [
                                                                        c.field,
                                                                        ":"
                                                                    ]
                                                                }),
                                                                ' ',
                                                                typeof c.oldValue === 'string' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("s", {
                                                                            style: {
                                                                                color: '#9ca3af'
                                                                            },
                                                                            children: c.oldValue
                                                                        }),
                                                                        " \u2192 ",
                                                                        c.newValue
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "updated"
                                                                })
                                                            ]
                                                        }, i))
                                                }),
                                                entry.customerMessage && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pending-change-customer-msg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Customer message:"
                                                        }),
                                                        ' "',
                                                        entry.customerMessage,
                                                        '"'
                                                    ]
                                                }),
                                                canEdit && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "btn-approve-single",
                                                    onClick: ()=>approveMutation.mutate({
                                                            applicationId: application.id,
                                                            amendmentId: entry.id
                                                        }),
                                                    disabled: approveMutation.isPending,
                                                    children: approveMutation.isPending ? 'Approving...' : "\u2713 Approve"
                                                })
                                            ]
                                        }, entry.id || idx))
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "no-data",
                                    children: "No pending changes"
                                }),
                                canEdit && application.amendmentHistory && application.amendmentHistory.filter((e)=>!e.customerResponse || e.customerResponse !== 'approved').length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pending-approve-section",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-mark-filed",
                                        onClick: ()=>approveMutation.mutate({
                                                applicationId: application.id
                                            }),
                                        disabled: approveMutation.isPending,
                                        children: approveMutation.isPending ? 'Approving...' : "\u2713 Approve All Changes"
                                    })
                                })
                            ]
                        }),
                        isEditing && activeTab !== 'email' && activeTab !== 'history' && activeTab !== 'pending' && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "file-now-section file-now-section-form amendment-save-bar",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "email-compose-field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Note (optional):"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: editNote,
                                            onChange: (e)=>setEditNote(e.target.value),
                                            placeholder: "e.g., Corrected applicant name to match ABN registration",
                                            className: "email-compose-input"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "file-now-modal-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "btn-cancel",
                                            onClick: cancelEditing,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "btn-mark-filed",
                                            onClick: saveAmendments,
                                            disabled: isSaving,
                                            children: isSaving ? 'Saving...' : 'Save Changes'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $ff1990a980e20e67$export$2e2bcd8739ae039 = $ff1990a980e20e67$var$FileNowModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * Transfer to Firm Modal
 * Allows attorneyadmin to transfer an application to an external law firm
 */ function $61fe632a80558f45$var$TransferToFirmModal({ application: application, externalFirms: externalFirms, onClose: onClose, onTransfer: onTransfer, isLoading: isLoading }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [selectedFirmId, setSelectedFirmId] = (0, $acw62.useState)('');
    const [reason, setReason] = (0, $acw62.useState)('');
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!selectedFirmId) return;
        onTransfer(application.id, selectedFirmId, reason || null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "transfer-modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "transfer-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "transfer-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.transfer.title', 'Transfer Application')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "transfer-modal-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "transfer-modal-body",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "transfer-app-info",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "transfer-app-id",
                                    children: application.applicationId
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "transfer-app-name",
                                    children: application.trademark?.name || 'Unknown'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "transfer-app-client",
                                    children: [
                                        t('attorney.transfer.client', 'Client'),
                                        ": ",
                                        application.clientName
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "transfer-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: "targetFirm",
                                            children: t('attorney.transfer.selectFirm', 'Select External Law Firm')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            id: "targetFirm",
                                            value: selectedFirmId,
                                            onChange: (e)=>setSelectedFirmId(e.target.value),
                                            required: true,
                                            disabled: isLoading,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: t('attorney.transfer.chooseFirm', '-- Choose a firm --')
                                                }),
                                                externalFirms.map((firm)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: firm.clerkOrgId,
                                                        children: firm.name
                                                    }, firm.clerkOrgId))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "transfer-form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: "reason",
                                            children: t('attorney.transfer.reason', 'Reason for Transfer (optional)')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            id: "reason",
                                            value: reason,
                                            onChange: (e)=>setReason(e.target.value),
                                            placeholder: t('attorney.transfer.reasonPlaceholder', 'e.g., Specializes in this jurisdiction...'),
                                            rows: 3,
                                            disabled: isLoading
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "transfer-warning",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "warning-icon",
                                            children: "\u26A0\uFE0F"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: t('attorney.transfer.warning', 'This will transfer the application to the selected firm. The current attorney assignment will be cleared.')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "transfer-modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "transfer-cancel-btn",
                                            onClick: onClose,
                                            disabled: isLoading,
                                            children: t('common.cancel', 'Cancel')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "submit",
                                            className: "transfer-submit-btn",
                                            disabled: !selectedFirmId || isLoading,
                                            children: isLoading ? t('attorney.transfer.transferring', 'Transferring...') : t('attorney.transfer.confirmTransfer', 'Transfer Application')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $61fe632a80558f45$export$2e2bcd8739ae039 = $61fe632a80558f45$var$TransferToFirmModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * Assign To Staff Modal
 * Modal for org admins to assign applications to staff members
 */ function $43d401fdef2145b2$var$AssignToStaffModal({ application: application, staffMembers: staffMembers = [], onClose: onClose, onAssign: onAssign, isLoading: isLoading, currentUserId: currentUserId }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [selectedStaffId, setSelectedStaffId] = (0, $acw62.useState)('');
    // Filter out current user from staff list (can't assign to self via this modal)
    const availableStaff = staffMembers.filter((m)=>m.userId !== currentUserId);
    const handleAssign = ()=>{
        if (selectedStaffId) onAssign(application.id, selectedStaffId);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "assign-staff-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "assign-staff-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.assignStaff.title', 'Assign to Staff')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "modal-close-btn",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "assign-staff-modal-content",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "assign-staff-app-info",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "assign-staff-app-id",
                                    children: application.applicationId
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "assign-staff-trademark",
                                    children: application.trademark?.name || 'Unknown'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: t('attorney.assignStaff.selectStaff', 'Select Staff Member')
                                }),
                                availableStaff.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "assign-staff-empty",
                                    children: t('attorney.assignStaff.noStaff', 'No other staff members available for assignment')
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: selectedStaffId,
                                    onChange: (e)=>setSelectedStaffId(e.target.value),
                                    className: "assign-staff-select",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: t('attorney.assignStaff.selectPlaceholder', '-- Select an attorney --')
                                        }),
                                        availableStaff.map((staff)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                value: staff.userId,
                                                children: [
                                                    staff.name,
                                                    " (",
                                                    staff.email,
                                                    ")"
                                                ]
                                            }, staff.userId))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "assign-staff-modal-footer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "btn-cancel",
                            onClick: onClose,
                            disabled: isLoading,
                            children: t('attorney.assignStaff.cancel', 'Cancel')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "btn-assign",
                            onClick: handleAssign,
                            disabled: !selectedStaffId || isLoading,
                            children: isLoading ? t('attorney.assignStaff.assigning', 'Assigning...') : t('attorney.assignStaff.assign', 'Assign')
                        })
                    ]
                })
            ]
        })
    });
}
var $43d401fdef2145b2$export$2e2bcd8739ae039 = $43d401fdef2145b2$var$AssignToStaffModal;







/**
 * Filing Queue Component
 * Main view for attorneys to see pending filings
 * Supports ?app={applicationId} URL param to highlight a specific application
 */ function $bfe99e1fb704439a$var$FilingQueue() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const { canTransferToFirm: canTransferToFirm, canRecallFromFirm: canRecallFromFirm, canReassign: canReassign, attorneyId: attorneyId, isAttorneyAdmin: isAttorneyAdmin } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)('all');
    const [selectedStatus, setSelectedStatus] = (0, $acw62.useState)('pending');
    const [assignmentFilter, setAssignmentFilter] = (0, $acw62.useState)('all');
    const [selectedFiling, setSelectedFiling] = (0, $acw62.useState)(null);
    const [viewMode, setViewMode] = (0, $acw62.useState)(false); // true when viewing filed jurisdiction
    const [editingRef, setEditingRef] = (0, $acw62.useState)(null); // { application, jurisdiction } when editing ref
    const [highlightedAppId, setHighlightedAppId] = (0, $acw62.useState)(null);
    const [transferModalApp, setTransferModalApp] = (0, $acw62.useState)(null);
    const [assignStaffModalApp, setAssignStaffModalApp] = (0, $acw62.useState)(null);
    const highlightedRef = (0, $acw62.useRef)(null);
    // Assignment mutations
    const assignMutation = (0, $ab1744d38d56125b$export$3fa37cff68589f54)();
    const unassignMutation = (0, $ab1744d38d56125b$export$e4f94caa39769749)();
    const transferMutation = (0, $ab1744d38d56125b$export$5301a6f9f87bfb3e)();
    const recallMutation = (0, $ab1744d38d56125b$export$706227e398c34fc3)();
    // External firms for transfer dropdown
    const { data: externalFirmsData } = (0, $8d1d9ca1d65e0e94$export$882ee090b3654030)({
        enabled: canTransferToFirm
    });
    // Org members for staff assignment dropdown (admins only)
    const { data: orgMembersData } = (0, $ab1744d38d56125b$export$c4d3b480ebf8ba52)({
        enabled: canReassign
    });
    // Read URL params on mount
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const appId = urlParams.get('app');
        if (appId) {
            setHighlightedAppId(appId);
            // Show all statuses to ensure we can find the app
            setSelectedStatus('all');
        }
    }, []);
    // Fetch filing queue using service layer
    const { data: data, isLoading: isLoading, error: error } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...(0, $ab1744d38d56125b$export$c8d831ea9b7879bd),
            selectedCountry,
            selectedStatus,
            assignmentFilter
        ],
        queryFn: ()=>(0, $edfde963f351996f$export$2e2bcd8739ae039).getFilingQueue({
                jurisdiction: selectedCountry !== 'all' ? selectedCountry : undefined,
                status: selectedStatus !== 'all' ? selectedStatus : undefined,
                assignmentFilter: assignmentFilter !== 'all' ? assignmentFilter : undefined
            })
    });
    // Extract queue from response
    const filings = data?.queue || [];
    // Scroll to highlighted app when data loads
    (0, $acw62.useEffect)(()=>{
        if (highlightedAppId && filings.length > 0 && highlightedRef.current) highlightedRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, [
        highlightedAppId,
        filings
    ]);
    // Mark as filed mutation using service layer
    const markFiledMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, jurisdiction: jurisdiction, ipOfficeRef: ipOfficeRef })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).markAsFiled(applicationId, {
                jurisdiction: jurisdiction,
                ipOfficeRef: ipOfficeRef
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: (0, $ab1744d38d56125b$export$c8d831ea9b7879bd)
            });
            setSelectedFiling(null);
            setViewMode(false);
        }
    });
    // Update IP Office ref mutation
    const updateRefMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, jurisdiction: jurisdiction, ipOfficeRef: ipOfficeRef })=>(0, $edfde963f351996f$export$2e2bcd8739ae039).updateIpOfficeRef(applicationId, jurisdiction, ipOfficeRef),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: (0, $ab1744d38d56125b$export$c8d831ea9b7879bd)
            });
            setEditingRef(null);
        }
    });
    const handleFileNow = (application, jurisdiction)=>{
        setSelectedFiling({
            application: application,
            jurisdiction: jurisdiction
        });
        setViewMode(false);
    };
    const handleViewFiling = (application, jurisdiction)=>{
        setSelectedFiling({
            application: application,
            jurisdiction: jurisdiction
        });
        setViewMode(true);
    };
    const handleEditRef = (application, jurisdiction)=>{
        const newRef = window.prompt(t('attorney.filingQueue.editRefPrompt', 'Enter new IP Office reference:'), jurisdiction.ipOfficeRef || '');
        if (newRef !== null && newRef.trim() !== '') updateRefMutation.mutate({
            applicationId: application.id,
            jurisdiction: jurisdiction.jurisdiction,
            ipOfficeRef: newRef.trim()
        });
    };
    const handleMarkFiled = (ipOfficeRef)=>{
        if (selectedFiling) markFiledMutation.mutate({
            applicationId: selectedFiling.application.id,
            jurisdiction: selectedFiling.jurisdiction.jurisdiction,
            ipOfficeRef: ipOfficeRef
        });
    };
    const handleCloseModal = ()=>{
        setSelectedFiling(null);
        setViewMode(false);
    };
    // Assignment handlers
    const handleAssignToMe = (applicationId)=>{
        assignMutation.mutate({
            applicationId: applicationId,
            attorneyId: null
        }); // null = assign to self
    };
    const handleUnassign = (applicationId)=>{
        unassignMutation.mutate(applicationId);
    };
    const handleOpenTransferModal = (application)=>{
        setTransferModalApp(application);
    };
    const handleCloseTransferModal = ()=>{
        setTransferModalApp(null);
    };
    const handleTransfer = (applicationId, targetOrgId, reason)=>{
        transferMutation.mutate({
            applicationId: applicationId,
            targetOrgId: targetOrgId,
            reason: reason
        }, {
            onSuccess: ()=>{
                setTransferModalApp(null);
            }
        });
    };
    // Recall handler - removes org transfer AND attorney assignment
    const handleRecall = (application)=>{
        if (window.confirm('Recall this application back to MarkoTM? This will remove the external firm assignment and unassign the attorney.')) recallMutation.mutate(application.id);
    };
    // Staff assignment handlers
    const handleOpenAssignStaffModal = (application)=>{
        setAssignStaffModalApp(application);
    };
    const handleCloseAssignStaffModal = ()=>{
        setAssignStaffModalApp(null);
    };
    const handleAssignToStaff = (applicationId, attorneyId)=>{
        assignMutation.mutate({
            applicationId: applicationId,
            attorneyId: attorneyId
        }, {
            onSuccess: ()=>{
                setAssignStaffModalApp(null);
            }
        });
    };
    // Get unique countries from filings
    const countries = [
        ...new Set(filings.flatMap((f)=>f.filings?.map((j)=>j.jurisdiction) || []))
    ];
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "filing-queue",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "filing-queue-loading",
            children: t('attorney.filingQueue.loading', 'Loading filing queue...')
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "filing-queue",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "filing-queue-error",
            children: t('attorney.filingQueue.error', 'Error loading filing queue')
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "filing-queue",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "filing-queue-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.filingQueue.title', 'Filing Queue')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "filing-queue-filters",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: selectedCountry,
                                onChange: (e)=>setSelectedCountry(e.target.value),
                                className: "filing-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.filingQueue.allCountries', 'All Countries')
                                    }),
                                    countries.map((country)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: country,
                                            children: country
                                        }, country))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: selectedStatus,
                                onChange: (e)=>setSelectedStatus(e.target.value),
                                className: "filing-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.filingQueue.allStatuses', 'All Statuses')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "pending",
                                        children: t('attorney.filingQueue.statusPending', 'Pending')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "filed",
                                        children: t('attorney.filingQueue.statusFiled', 'Filed')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: assignmentFilter,
                                onChange: (e)=>setAssignmentFilter(e.target.value),
                                className: "filing-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.filingQueue.allAssignments', 'All Assignments')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "unassigned",
                                        children: t('attorney.filingQueue.unassigned', 'Unassigned')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "mine",
                                        children: t('attorney.filingQueue.assignedToMe', 'Assigned to Me')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "my_firm",
                                        children: t('attorney.filingQueue.myFirm', 'My Firm')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "filing-refresh-btn",
                                onClick: ()=>queryClient.invalidateQueries({
                                        queryKey: (0, $ab1744d38d56125b$export$c8d831ea9b7879bd)
                                    }),
                                children: t('attorney.filingQueue.refresh', 'Refresh')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "filing-queue-content",
                children: filings.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "filing-queue-empty",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "filing-queue-empty-icon",
                            children: "\uD83D\uDCCB"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: t('attorney.filingQueue.empty', 'No filings in queue')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "filing-cards",
                    children: filings.map((application)=>{
                        const isHighlighted = highlightedAppId && (application.id === highlightedAppId || application.applicationId === highlightedAppId);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: isHighlighted ? highlightedRef : null,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c28c9ffd26ebadb$export$2e2bcd8739ae039), {
                                application: application,
                                onFileNow: handleFileNow,
                                onViewFiling: handleViewFiling,
                                onEditRef: handleEditRef,
                                isHighlighted: isHighlighted,
                                onAssignToMe: handleAssignToMe,
                                onUnassign: handleUnassign,
                                onTransfer: handleOpenTransferModal,
                                onRecall: handleRecall,
                                onAssignToStaff: canReassign ? handleOpenAssignStaffModal : null,
                                canTransferToFirm: canTransferToFirm,
                                canRecallFromFirm: canRecallFromFirm,
                                canReassign: canReassign,
                                currentAttorneyId: attorneyId,
                                isAssigning: assignMutation.isPending,
                                isUnassigning: unassignMutation.isPending,
                                isRecalling: recallMutation.isPending
                            })
                        }, application.id);
                    })
                })
            }),
            selectedFiling && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff1990a980e20e67$export$2e2bcd8739ae039), {
                application: selectedFiling.application,
                jurisdiction: selectedFiling.jurisdiction,
                onClose: handleCloseModal,
                onMarkFiled: handleMarkFiled,
                isLoading: markFiledMutation.isPending,
                viewMode: viewMode
            }),
            transferModalApp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $61fe632a80558f45$export$2e2bcd8739ae039), {
                application: transferModalApp,
                externalFirms: externalFirmsData?.firms || [],
                onClose: handleCloseTransferModal,
                onTransfer: handleTransfer,
                isLoading: transferMutation.isPending
            }),
            assignStaffModalApp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $43d401fdef2145b2$export$2e2bcd8739ae039), {
                application: assignStaffModalApp,
                staffMembers: orgMembersData?.members || [],
                onClose: handleCloseAssignStaffModal,
                onAssign: handleAssignToStaff,
                isLoading: assignMutation.isPending,
                currentUserId: attorneyId
            })
        ]
    });
}
var $bfe99e1fb704439a$export$2e2bcd8739ae039 = $bfe99e1fb704439a$var$FilingQueue;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


/**
 * Approval Card Component
 * Displays a single AI task awaiting approval
 */ function $00cef1b0e7bd6dbc$var$ApprovalCard({ task: task, onReview: onReview, isHighlighted: isHighlighted }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    // Normalize success likelihood to 0-100 scale
    const getSuccessPercentage = ()=>{
        const value = task.successLikelihood ?? task.result?.successLikelihood;
        if (value === undefined || value === null) return null;
        // If value is > 1, it's already 0-100 scale; otherwise multiply by 100
        return value > 1 ? Math.round(value) : Math.round(value * 100);
    };
    // Build a proper title from correspondence/task data
    const getTaskTitle = ()=>{
        const classification = task.input?.classification?.subType || task.input?.classification?.classification;
        const ipRef = task.correspondence?.ipOfficeRef || task.input?.correspondence?.ipOfficeRef;
        const trademarkName = task.trademarkName || task.input?.correspondence?.trademarkName;
        // Build title like "Adverse Report - TM2025/00147 - HEALTHEX"
        let title = '';
        if (classification === 'adverse_examination') title = 'Adverse Report';
        else if (classification === 'office_action') title = 'Office Action';
        else if (classification === 'opposition') title = 'Opposition';
        else title = classification || 'Response Required';
        if (ipRef) title += ` - ${ipRef}`;
        if (trademarkName) title += ` - ${trademarkName}`;
        return title;
    };
    const getTypeDisplay = ()=>{
        const classification = task.input?.classification?.subType || task.input?.classification?.classification;
        switch(classification){
            case 'adverse_examination':
            case 'office_action':
                return {
                    icon: "\uD83D\uDCDD",
                    label: t('attorney.approvalCard.officeAction', 'Office Action Response'),
                    className: 'type-office-action'
                };
            case 'opposition':
                return {
                    icon: "\u2694\uFE0F",
                    label: t('attorney.approvalCard.opposition', 'Opposition Response'),
                    className: 'type-opposition'
                };
            case 'renewal':
                return {
                    icon: "\uD83D\uDD04",
                    label: t('attorney.approvalCard.renewal', 'Renewal Application'),
                    className: 'type-renewal'
                };
            default:
                return {
                    icon: "\uD83D\uDCCB",
                    label: task.taskType || classification || 'Task',
                    className: 'type-default'
                };
        }
    };
    const getPriorityDisplay = ()=>{
        switch(task.priority){
            case 'urgent':
                return {
                    label: t('attorney.approvalCard.urgent', 'Urgent'),
                    className: 'priority-urgent'
                };
            case 'high':
                return {
                    label: t('attorney.approvalCard.high', 'High'),
                    className: 'priority-high'
                };
            case 'medium':
                return {
                    label: t('attorney.approvalCard.medium', 'Medium'),
                    className: 'priority-medium'
                };
            default:
                return {
                    label: t('attorney.approvalCard.low', 'Low'),
                    className: 'priority-low'
                };
        }
    };
    const getStatusDisplay = ()=>{
        switch(task.status){
            case 'approved':
                return {
                    label: t('attorney.approvalCard.approved', 'Approved'),
                    className: 'status-approved',
                    icon: "\u2713"
                };
            case 'rejected':
                return {
                    label: t('attorney.approvalCard.rejected', 'Rejected'),
                    className: 'status-rejected',
                    icon: "\u2715"
                };
            case 'awaiting_approval':
            default:
                return {
                    label: t('attorney.approvalCard.pending', 'Pending'),
                    className: 'status-pending',
                    icon: "\u23F3"
                };
        }
    };
    const isCompleted = task.status === 'approved' || task.status === 'rejected';
    const type = getTypeDisplay();
    const priority = getPriorityDisplay();
    const status = getStatusDisplay();
    // Format deadline
    const deadlineDate = task.deadline ? new Date(task.deadline) : null;
    const daysUntilDeadline = deadlineDate ? Math.ceil((deadlineDate - new Date()) / 86400000) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `approval-card ${priority.className} ${isHighlighted ? 'approval-card-highlighted' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "approval-card-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "approval-card-type",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "type-icon",
                                children: type.icon
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `type-label ${type.className}`,
                                children: type.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "approval-card-badges",
                        children: [
                            isCompleted && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: `approval-card-status ${status.className}`,
                                children: [
                                    status.icon,
                                    " ",
                                    status.label
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `approval-card-priority ${priority.className}`,
                                children: priority.label
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "approval-card-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "approval-card-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "approval-card-title",
                                children: getTaskTitle()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "approval-card-app-id",
                                children: task.applicationId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "approval-card-summary",
                        children: task.summary || task.result?.summary || task.context?.issueDescription || t('attorney.approvalCard.noSummary', 'No summary available')
                    }),
                    getSuccessPercentage() !== null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "approval-card-confidence",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "confidence-label",
                                children: [
                                    t('attorney.approvalCard.successLikelihood', 'Success Likelihood'),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "confidence-value",
                                children: [
                                    getSuccessPercentage(),
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "approval-card-footer",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "approval-card-meta",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "approval-card-client",
                                children: task.clientName || 'Unknown Client'
                            }),
                            deadlineDate && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `approval-card-deadline ${daysUntilDeadline <= 7 ? 'deadline-urgent' : ''}`,
                                children: daysUntilDeadline > 0 ? t('attorney.approvalCard.daysLeft', '{{days}} days left', {
                                    days: daysUntilDeadline
                                }) : t('attorney.approvalCard.overdue', 'Overdue!')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `btn-review ${isCompleted ? 'btn-view' : ''}`,
                        onClick: ()=>onReview(task),
                        children: isCompleted ? t('attorney.approvalCard.viewDetails', 'View Details') : t('attorney.approvalCard.review', 'Review Draft')
                    })
                ]
            })
        ]
    });
}
var $00cef1b0e7bd6dbc$export$2e2bcd8739ae039 = $00cef1b0e7bd6dbc$var$ApprovalCard;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



async function $3fe75b1e3c7ea1b3$export$136eaa5f8c67792a(options = {}) {
    const params = new URLSearchParams();
    if (options.daysAhead) params.append('daysAhead', options.daysAhead);
    if (options.urgentOnly) params.append('urgentOnly', options.urgentOnly);
    if (options.applicationId) params.append('applicationId', options.applicationId);
    if (options.assignmentFilter) params.append('assignmentFilter', options.assignmentFilter);
    const queryString = params.toString();
    const url = queryString ? `/attorney/deadlines?${queryString}` : '/attorney/deadlines';
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(url);
    return response.data;
}
async function $3fe75b1e3c7ea1b3$export$92e0b24873cd17d6(deadlineId) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/attorney/deadlines/${deadlineId}`);
    return response.data;
}
async function $3fe75b1e3c7ea1b3$export$f3258aa9f576f43b(deadlineId, data = {}) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/attorney/deadlines/${deadlineId}/complete`, {
        notes: data.notes
    });
    return response.data;
}
async function $3fe75b1e3c7ea1b3$export$60263ebfa6c3647c(deadlineId, data) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).patch(`/attorney/deadlines/${deadlineId}`, {
        action: 'update',
        ...data
    });
    return response.data;
}
async function $3fe75b1e3c7ea1b3$export$97b396de0f3e763a(data) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post('/attorney/deadlines', data);
    return response.data;
}
var $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039 = {
    getDeadlines: $3fe75b1e3c7ea1b3$export$136eaa5f8c67792a,
    getDeadline: $3fe75b1e3c7ea1b3$export$92e0b24873cd17d6,
    completeDeadline: $3fe75b1e3c7ea1b3$export$f3258aa9f576f43b,
    updateDeadline: $3fe75b1e3c7ea1b3$export$60263ebfa6c3647c,
    createDeadline: $3fe75b1e3c7ea1b3$export$97b396de0f3e763a
};




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * Messaging Hooks
 * React Query hooks for attorney-client messaging
 */ 
/**
 * Messaging Service
 * Handles attorney-client messaging with access control
 *
 * Access control:
 * - MarkoTM (internal) attorneys: Can message clients directly
 * - External attorneys: Must use internal requests through MarkoTM
 */ 
async function $d33e8685a667431e$export$8c20ab16ac9cf14f(options = {}) {
    const { limit: limit = 50, offset: offset = 0 } = options;
    const params = new URLSearchParams({
        limit: limit,
        offset: offset
    });
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/messages?${params}`);
}
async function $d33e8685a667431e$export$3b47cd0f0b0f335e() {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get('/messages/pending');
}
async function $d33e8685a667431e$export$1c0ca0f2ca071590(id) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/messages/${id}`);
}
async function $d33e8685a667431e$export$a162bbb49c2fe72e(threadId) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/messages/thread/${threadId}`);
}
async function $d33e8685a667431e$export$e578968c488a22db(applicationId) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/messages/application/${applicationId}`);
}
async function $d33e8685a667431e$export$ae12d28ca2f3a8f5(applicationId, messageData) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post('/messages', {
        applicationId: applicationId,
        type: messageData.type || 'info_request',
        subject: messageData.subject,
        body: messageData.body,
        requestData: messageData.requestData,
        attachments: messageData.attachments,
        urgency: messageData.urgency || 'medium',
        responseRequired: messageData.responseRequired ?? true,
        senderName: messageData.senderName,
        threadId: messageData.threadId,
        agentTaskId: messageData.agentTaskId
    });
}
async function $d33e8685a667431e$export$b090fc9092634f91(messageId, responseData) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/messages/${messageId}/respond`, {
        items: responseData.items,
        attachments: responseData.attachments,
        message: responseData.message,
        clientName: responseData.clientName
    });
}
async function $d33e8685a667431e$export$b02ca5bc5f67d9be(applicationId, requestData) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post('/internal-requests', {
        applicationId: applicationId,
        type: requestData.type || 'info_request',
        subject: requestData.subject,
        body: requestData.body,
        requestData: requestData.requestData,
        attachments: requestData.attachments,
        urgency: requestData.urgency || 'medium',
        senderName: requestData.senderName
    });
}
async function $d33e8685a667431e$export$35fcce4aff4c9b91(status = 'all') {
    const params = status !== 'all' ? `?status=${status}` : '';
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/internal-requests${params}`);
}
async function $d33e8685a667431e$export$55a9aafbc3302827() {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get('/internal-requests/mine');
}
async function $d33e8685a667431e$export$ef2c95cf0af5add0() {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get('/internal-requests/forwarded');
}
async function $d33e8685a667431e$export$76681986a101c10e(id) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/internal-requests/${id}`);
}
async function $d33e8685a667431e$export$5dc3a4b55df451f1(requestId, messageData) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/internal-requests/${requestId}/contact-client`, {
        type: messageData.type || 'info_request',
        subject: messageData.subject,
        body: messageData.body,
        requestData: messageData.requestData,
        attachments: messageData.attachments,
        urgency: messageData.urgency,
        senderName: messageData.senderName
    });
}
async function $d33e8685a667431e$export$1b238c69f39452af(requestId, forwardData) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/internal-requests/${requestId}/forward`, {
        clientMessageId: forwardData.clientMessageId,
        summary: forwardData.summary,
        items: forwardData.items,
        attachments: forwardData.attachments,
        senderName: forwardData.senderName
    });
}
async function $d33e8685a667431e$export$b52365699a925473(requestId, reason) {
    return (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/internal-requests/${requestId}/decline`, {
        reason: reason
    });
}
var $d33e8685a667431e$export$2e2bcd8739ae039 = {
    getMessages: // Messages
    $d33e8685a667431e$export$8c20ab16ac9cf14f,
    getPendingMessages: $d33e8685a667431e$export$3b47cd0f0b0f335e,
    getMessageById: $d33e8685a667431e$export$1c0ca0f2ca071590,
    getMessageThread: $d33e8685a667431e$export$a162bbb49c2fe72e,
    getMessagesByApplication: $d33e8685a667431e$export$e578968c488a22db,
    createClientMessage: $d33e8685a667431e$export$ae12d28ca2f3a8f5,
    respondToMessage: $d33e8685a667431e$export$b090fc9092634f91,
    createInternalRequest: // Internal requests
    $d33e8685a667431e$export$b02ca5bc5f67d9be,
    getInternalRequests: $d33e8685a667431e$export$35fcce4aff4c9b91,
    getMyInternalRequests: $d33e8685a667431e$export$55a9aafbc3302827,
    getForwardedResponses: $d33e8685a667431e$export$ef2c95cf0af5add0,
    getInternalRequestById: $d33e8685a667431e$export$76681986a101c10e,
    contactClientForRequest: $d33e8685a667431e$export$5dc3a4b55df451f1,
    forwardResponseToExternal: $d33e8685a667431e$export$1b238c69f39452af,
    declineInternalRequest: $d33e8685a667431e$export$b52365699a925473
};


const $8ef7a68274816bdb$export$56c9e3a9f3301fd8 = {
    all: [
        'messaging'
    ],
    messages: ()=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.all,
            'messages'
        ],
    messagesList: (filters)=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages(),
            filters
        ],
    pending: ()=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages(),
            'pending'
        ],
    thread: (threadId)=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages(),
            'thread',
            threadId
        ],
    application: (appId)=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages(),
            'application',
            appId
        ],
    message: (id)=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages(),
            id
        ],
    internalRequests: ()=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.all,
            'internal-requests'
        ],
    internalRequestsList: (status)=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.internalRequests(),
            status
        ],
    myRequests: ()=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.all,
            'my-requests'
        ],
    forwardedResponses: ()=>[
            ...$8ef7a68274816bdb$export$56c9e3a9f3301fd8.all,
            'forwarded-responses'
        ]
};
function $8ef7a68274816bdb$export$4d17e2d9c5348842(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.messagesList(options),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getMessages(options)
    });
}
function $8ef7a68274816bdb$export$589caff7e2cb2583() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.pending(),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getPendingMessages()
    });
}
function $8ef7a68274816bdb$export$414e41559af5a852(id) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.message(id),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getMessageById(id),
        enabled: !!id
    });
}
function $8ef7a68274816bdb$export$708108bcb7301ffe(threadId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.thread(threadId),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getMessageThread(threadId),
        enabled: !!threadId
    });
}
function $8ef7a68274816bdb$export$11c6e26f22e9ac25(applicationId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.application(applicationId),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getMessagesByApplication(applicationId),
        enabled: !!applicationId
    });
}
function $8ef7a68274816bdb$export$7f42cf2fec41534() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, messageData: messageData })=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).createClientMessage(applicationId, messageData),
        onSuccess: (data, { applicationId: applicationId })=>{
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages()
            });
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.application(applicationId)
            });
        }
    });
}
function $8ef7a68274816bdb$export$3d659386d9ca19c5() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ messageId: messageId, responseData: responseData })=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).respondToMessage(messageId, responseData),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages()
            });
        }
    });
}
function $8ef7a68274816bdb$export$f25d8437adfe58b9(status = 'all') {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.internalRequestsList(status),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getInternalRequests(status)
    });
}
function $8ef7a68274816bdb$export$3d0ac7bc84565bd6() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.myRequests(),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getMyInternalRequests()
    });
}
function $8ef7a68274816bdb$export$7c2902ea70fac050() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.forwardedResponses(),
        queryFn: ()=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).getForwardedResponses()
    });
}
function $8ef7a68274816bdb$export$2636af7d2fc73660() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ applicationId: applicationId, requestData: requestData })=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).createInternalRequest(applicationId, requestData),
        onSuccess: ()=>{
            // External attorneys might want to see their pending requests
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.messages()
            });
        }
    });
}
function $8ef7a68274816bdb$export$dd61971fef3fb811() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ requestId: requestId, messageData: messageData })=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).contactClientForRequest(requestId, messageData),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.internalRequests()
            });
        }
    });
}
function $8ef7a68274816bdb$export$a5008aa1d676def5() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ requestId: requestId, forwardData: forwardData })=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).forwardResponseToExternal(requestId, forwardData),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.internalRequests()
            });
        }
    });
}
function $8ef7a68274816bdb$export$df77496e55efdd5() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ requestId: requestId, reason: reason })=>(0, $d33e8685a667431e$export$2e2bcd8739ae039).declineInternalRequest(requestId, reason),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $8ef7a68274816bdb$export$56c9e3a9f3301fd8.internalRequests()
            });
        }
    });
}
var $8ef7a68274816bdb$export$2e2bcd8739ae039 = {
    useMessages: // Queries
    $8ef7a68274816bdb$export$4d17e2d9c5348842,
    usePendingMessages: $8ef7a68274816bdb$export$589caff7e2cb2583,
    useMessage: $8ef7a68274816bdb$export$414e41559af5a852,
    useMessageThread: $8ef7a68274816bdb$export$708108bcb7301ffe,
    useApplicationMessages: $8ef7a68274816bdb$export$11c6e26f22e9ac25,
    useInternalRequests: $8ef7a68274816bdb$export$f25d8437adfe58b9,
    useMyInternalRequests: $8ef7a68274816bdb$export$3d0ac7bc84565bd6,
    useForwardedResponses: $8ef7a68274816bdb$export$7c2902ea70fac050,
    useCreateClientMessage: // Mutations
    $8ef7a68274816bdb$export$7f42cf2fec41534,
    useRespondToMessage: $8ef7a68274816bdb$export$3d659386d9ca19c5,
    useCreateInternalRequest: $8ef7a68274816bdb$export$2636af7d2fc73660,
    useContactClientForRequest: $8ef7a68274816bdb$export$dd61971fef3fb811,
    useForwardResponse: $8ef7a68274816bdb$export$a5008aa1d676def5,
    useDeclineInternalRequest: $8ef7a68274816bdb$export$df77496e55efdd5
};




async function $823e3a400142202d$export$565a37ea1ade2d86(options = {}) {
    const params = new URLSearchParams();
    if (options.search) params.append('search', options.search);
    if (options.status) params.append('status', options.status);
    if (options.assignmentFilter) params.append('assignmentFilter', options.assignmentFilter);
    const queryString = params.toString();
    const url = queryString ? `/attorney/clients?${queryString}` : '/attorney/clients';
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(url);
    return response.data;
}
async function $823e3a400142202d$export$6bb76d6eba7e258c(clientId) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/attorney/clients/${clientId}`);
    return response.data;
}
var $823e3a400142202d$export$2e2bcd8739ae039 = {
    getClients: $823e3a400142202d$export$565a37ea1ade2d86,
    getClient: $823e3a400142202d$export$6bb76d6eba7e258c
};


const $c8f2794f3cd67c4a$export$d332404a5ed12c0c = [
    'attorney',
    'clients'
];
function $c8f2794f3cd67c4a$export$4823a6cc022cca16(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$c8f2794f3cd67c4a$export$d332404a5ed12c0c,
            options
        ],
        queryFn: ()=>(0, $823e3a400142202d$export$2e2bcd8739ae039).getClients(options),
        staleTime: 300000,
        refetchOnWindowFocus: true
    });
}
function $c8f2794f3cd67c4a$export$95f99d327bc8fbbd(clientId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$c8f2794f3cd67c4a$export$d332404a5ed12c0c,
            clientId
        ],
        queryFn: ()=>(0, $823e3a400142202d$export$2e2bcd8739ae039).getClient(clientId),
        enabled: !!clientId,
        staleTime: 300000
    });
}
var $c8f2794f3cd67c4a$export$2e2bcd8739ae039 = {
    useClients: $c8f2794f3cd67c4a$export$4823a6cc022cca16,
    useClient: $c8f2794f3cd67c4a$export$95f99d327bc8fbbd
};




/**
 * Message Compose Modal
 * For MarkoTM attorneys to compose messages to clients
 *
 * External attorneys should not see this modal - they use RequestViaMarkoTMModal instead.
 */ function $afd9ebad085eb41d$var$MessageComposeModal({ isOpen: isOpen, onClose: onClose, applicationId: initialAppId, clientName: initialClientName, clientEmail: clientEmail }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { canMessageClients: canMessageClients, attorneyName: attorneyName } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const createMessage = (0, $8ef7a68274816bdb$export$7f42cf2fec41534)();
    const { data: clientsData, isLoading: isLoadingClients } = (0, $c8f2794f3cd67c4a$export$4823a6cc022cca16)();
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)('');
    const [showClientPicker, setShowClientPicker] = (0, $acw62.useState)(!initialAppId);
    const [selectedClient, setSelectedClient] = (0, $acw62.useState)(null);
    const [selectedApplication, setSelectedApplication] = (0, $acw62.useState)(null);
    const [formData, setFormData] = (0, $acw62.useState)({
        applicationId: initialAppId || '',
        type: 'info_request',
        subject: '',
        body: '',
        urgency: 'medium'
    });
    // Access check
    if (!canMessageClients) return null;
    // Filter clients based on search query
    const filteredClients = (0, $acw62.useMemo)(()=>{
        if (!clientsData?.clients) return [];
        if (!searchQuery.trim()) return clientsData.clients;
        const query = searchQuery.toLowerCase();
        return clientsData.clients.filter((client)=>{
            // Search by client name or email
            if (client.name?.toLowerCase().includes(query)) return true;
            if (client.email?.toLowerCase().includes(query)) return true;
            // Search by application ID or trademark name
            return client.applications?.some((app)=>app.applicationId?.toLowerCase().includes(query) || app.trademarkName?.toLowerCase().includes(query));
        });
    }, [
        clientsData?.clients,
        searchQuery
    ]);
    const handleChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const handleSelectApplication = (client, application)=>{
        setSelectedClient(client);
        setSelectedApplication(application);
        setFormData((prev)=>({
                ...prev,
                applicationId: application.applicationId || application.id
            }));
        setShowClientPicker(false);
    };
    const handleClearSelection = ()=>{
        setSelectedClient(null);
        setSelectedApplication(null);
        setFormData((prev)=>({
                ...prev,
                applicationId: ''
            }));
        setShowClientPicker(true);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!formData.applicationId || !formData.subject || !formData.body) {
            alert('Please fill in all required fields');
            return;
        }
        try {
            await createMessage.mutateAsync({
                applicationId: formData.applicationId,
                messageData: {
                    type: formData.type,
                    subject: formData.subject,
                    body: formData.body,
                    urgency: formData.urgency,
                    responseRequired: formData.type !== 'general',
                    senderName: attorneyName
                }
            });
            onClose();
        } catch (error) {
            console.error('Error sending message:', error);
            alert(`Error sending message: ${error.message}`);
        }
    };
    if (!isOpen) return null;
    // Display name for the recipient - clean up trademark name
    const displayClientName = selectedClient?.name || initialClientName;
    const displayClientEmail = selectedClient?.email || clientEmail;
    // Get a cleaner trademark name (remove file extensions, etc.)
    let displayTrademarkName = selectedApplication?.trademarkName || '';
    // Remove common file extensions from trademark name display
    displayTrademarkName = displayTrademarkName.replace(/[-_](image|logo|tm)?\d*\.(png|jpg|jpeg|gif|svg|webp)$/i, '');
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "modal-content message-compose-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.compose.title', 'Message Client')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "modal-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                !initialAppId && showClientPicker ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "client-picker-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            children: [
                                                t('attorney.compose.selectClient', 'Select Client & Application'),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "client-search",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                value: searchQuery,
                                                onChange: (e)=>setSearchQuery(e.target.value),
                                                placeholder: t('attorney.compose.searchPlaceholder', 'Search by client name, email, or trademark...'),
                                                autoFocus: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "client-list",
                                            children: isLoadingClients ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "client-list-loading",
                                                children: t('common.loading', 'Loading...')
                                            }) : filteredClients.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "client-list-empty",
                                                children: searchQuery ? t('attorney.compose.noResultsFound', 'No clients or applications found') : t('attorney.compose.noClients', 'No clients available')
                                            }) : filteredClients.map((client)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "client-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "client-header",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "client-name",
                                                                    children: client.name || 'Unknown'
                                                                }),
                                                                client.email && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "client-email",
                                                                    children: client.email
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "client-app-count",
                                                                    children: [
                                                                        client.applications?.length || 0,
                                                                        " ",
                                                                        t('attorney.compose.applications', 'applications')
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        client.applications && client.applications.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "client-applications",
                                                            children: client.applications.map((app)=>{
                                                                // Clean up trademark name for display
                                                                let cleanName = app.trademarkName || 'Untitled';
                                                                cleanName = cleanName.replace(/[-_](image|logo|tm)?\d*\.(png|jpg|jpeg|gif|svg|webp)$/i, '');
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "application-item",
                                                                    onClick: ()=>handleSelectApplication(client, app),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "app-trademark",
                                                                            children: cleanName
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: `app-status status-${app.status}`,
                                                                            children: app.status
                                                                        })
                                                                    ]
                                                                }, app.id);
                                                            })
                                                        })
                                                    ]
                                                }, client.userId))
                                        })
                                    ]
                                }) : /* Selected Application Display */ /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "selected-recipient",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "recipient-info",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "recipient-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            children: [
                                                                t('attorney.compose.to', 'To'),
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "recipient-details",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "recipient-name",
                                                                    children: displayClientName || 'Client'
                                                                }),
                                                                displayClientEmail && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "recipient-email",
                                                                    children: displayClientEmail
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                displayTrademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "recipient-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            children: [
                                                                t('attorney.compose.regarding', 'Regarding'),
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "recipient-trademark",
                                                            children: displayTrademarkName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !initialAppId && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "btn-change-recipient",
                                            onClick: handleClearSelection,
                                            children: t('attorney.compose.change', 'Change')
                                        })
                                    ]
                                }),
                                (formData.applicationId || initialAppId) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    htmlFor: "type",
                                                    children: t('attorney.compose.messageType', 'Message Type')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    id: "type",
                                                    name: "type",
                                                    value: formData.type,
                                                    onChange: handleChange,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "info_request",
                                                            children: t('attorney.compose.infoRequest', 'Request Information')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "general",
                                                            children: t('attorney.compose.generalUpdate', 'General Update')
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    htmlFor: "subject",
                                                    children: [
                                                        t('attorney.compose.subject', 'Subject'),
                                                        " *"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    id: "subject",
                                                    name: "subject",
                                                    value: formData.subject,
                                                    onChange: handleChange,
                                                    placeholder: "e.g., Information needed for your trademark filing",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    htmlFor: "body",
                                                    children: [
                                                        t('attorney.compose.message', 'Message'),
                                                        " *"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    id: "body",
                                                    name: "body",
                                                    value: formData.body,
                                                    onChange: handleChange,
                                                    rows: 8,
                                                    placeholder: "Enter your message to the client...",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    htmlFor: "urgency",
                                                    children: t('attorney.compose.urgency', 'Priority')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    id: "urgency",
                                                    name: "urgency",
                                                    value: formData.urgency,
                                                    onChange: handleChange,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "low",
                                                            children: t('attorney.compose.urgencyLow', 'Low')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "medium",
                                                            children: t('attorney.compose.urgencyMedium', 'Normal')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "high",
                                                            children: t('attorney.compose.urgencyHigh', 'High')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-secondary",
                                    onClick: onClose,
                                    children: t('common.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    disabled: createMessage.isPending || !formData.applicationId,
                                    children: createMessage.isPending ? t('common.sending', 'Sending...') : t('attorney.compose.send', 'Send Message')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $afd9ebad085eb41d$export$2e2bcd8739ae039 = $afd9ebad085eb41d$var$MessageComposeModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




/**
 * Request via MarkoTM Modal
 * Allows external attorneys to submit requests to MarkoTM
 * to contact clients on their behalf.
 */ function $aa40c3a1ec1fe38e$var$RequestViaMarkoTMModal({ isOpen: isOpen, onClose: onClose, applicationId: initialAppId, clientName: clientName }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { canCreateInternalRequests: canCreateInternalRequests, firmName: firmName, attorneyName: attorneyName } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const createRequest = (0, $8ef7a68274816bdb$export$2636af7d2fc73660)();
    const [formData, setFormData] = (0, $acw62.useState)({
        applicationId: initialAppId || '',
        title: '',
        message: '',
        urgency: 'medium',
        items: []
    });
    const [newItem, setNewItem] = (0, $acw62.useState)({
        type: 'text',
        label: '',
        required: true
    });
    // Access check
    if (!canCreateInternalRequests) return null;
    const handleChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const handleAddItem = ()=>{
        if (!newItem.label.trim()) return;
        setFormData((prev)=>({
                ...prev,
                items: [
                    ...prev.items,
                    {
                        ...newItem,
                        id: `item_${Date.now()}`
                    }
                ]
            }));
        setNewItem({
            type: 'text',
            label: '',
            required: true
        });
    };
    const handleRemoveItem = (index)=>{
        setFormData((prev)=>({
                ...prev,
                items: prev.items.filter((_, i)=>i !== index)
            }));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!formData.applicationId || !formData.title || !formData.message) {
            alert('Please fill in all required fields');
            return;
        }
        try {
            await createRequest.mutateAsync({
                applicationId: formData.applicationId,
                requestData: {
                    title: formData.title,
                    message: formData.message,
                    urgency: formData.urgency,
                    items: formData.items
                }
            });
            onClose();
        } catch (error) {
            console.error('Error submitting request:', error);
            alert(`Error submitting request: ${error.message}`);
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "modal-content request-via-markotm-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.requestViaMarkoTM.title', 'Request via MarkoTM')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "modal-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "info-box",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "info-icon",
                                            children: "\uD83D\uDCA1"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: t('attorney.requestViaMarkoTM.info', 'Your request will be reviewed by MarkoTM, who will then contact the client on your behalf. You will receive the client\'s response once it\'s forwarded to you.')
                                        })
                                    ]
                                }),
                                clientName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "request-for",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            children: [
                                                t('attorney.requestViaMarkoTM.for', 'For'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: clientName
                                        })
                                    ]
                                }),
                                !initialAppId && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            htmlFor: "applicationId",
                                            children: [
                                                t('attorney.requestViaMarkoTM.application', 'Application ID'),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            id: "applicationId",
                                            name: "applicationId",
                                            value: formData.applicationId,
                                            onChange: handleChange,
                                            placeholder: "MTM-2025-00123",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "form-hint",
                                            children: t('attorney.requestViaMarkoTM.applicationHint', 'Enter the MarkoTM application ID')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            htmlFor: "title",
                                            children: [
                                                t('attorney.requestViaMarkoTM.requestTitle', 'Request Title'),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            id: "title",
                                            name: "title",
                                            value: formData.title,
                                            onChange: handleChange,
                                            placeholder: "Information needed for trademark filing",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            htmlFor: "message",
                                            children: [
                                                t('attorney.requestViaMarkoTM.details', 'Request Details'),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            id: "message",
                                            name: "message",
                                            value: formData.message,
                                            onChange: handleChange,
                                            rows: 5,
                                            placeholder: "Please describe what information you need from the client and why...",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: "urgency",
                                            children: t('attorney.requestViaMarkoTM.urgency', 'Urgency')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            id: "urgency",
                                            name: "urgency",
                                            value: formData.urgency,
                                            onChange: handleChange,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "low",
                                                    children: t('attorney.urgency.low', 'Low - No rush')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "medium",
                                                    children: t('attorney.urgency.medium', 'Medium - Standard timing')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "high",
                                                    children: t('attorney.urgency.high', 'High - Time sensitive')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "urgent",
                                                    children: t('attorney.urgency.urgent', 'Urgent - Deadline approaching')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: t('attorney.requestViaMarkoTM.specificItems', 'Specific Items Needed')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "form-hint",
                                            children: t('attorney.requestViaMarkoTM.itemsHint', 'Add specific items you need from the client')
                                        }),
                                        formData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "items-list",
                                            children: formData.items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    className: "item-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "item-type",
                                                            children: [
                                                                "[",
                                                                item.type,
                                                                "]"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "item-label",
                                                            children: item.label
                                                        }),
                                                        item.required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "item-required",
                                                            children: "*"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "item-remove",
                                                            onClick: ()=>handleRemoveItem(index),
                                                            children: "\xd7"
                                                        })
                                                    ]
                                                }, index))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "add-item-form",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: newItem.type,
                                                    onChange: (e)=>setNewItem((prev)=>({
                                                                ...prev,
                                                                type: e.target.value
                                                            })),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "text",
                                                            children: t('attorney.itemType.text', 'Text Input')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "file_upload",
                                                            children: t('attorney.itemType.file', 'File Upload')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "date",
                                                            children: t('attorney.itemType.date', 'Date')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "select",
                                                            children: t('attorney.itemType.select', 'Selection')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    value: newItem.label,
                                                    onChange: (e)=>setNewItem((prev)=>({
                                                                ...prev,
                                                                label: e.target.value
                                                            })),
                                                    placeholder: "e.g., 'Current business address'"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "checkbox-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: newItem.required,
                                                            onChange: (e)=>setNewItem((prev)=>({
                                                                        ...prev,
                                                                        required: e.target.checked
                                                                    }))
                                                        }),
                                                        "Required"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    className: "btn btn-secondary",
                                                    onClick: handleAddItem,
                                                    children: "+ Add"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-secondary",
                                    onClick: onClose,
                                    children: t('common.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    disabled: createRequest.isPending,
                                    children: createRequest.isPending ? t('common.submitting', 'Submitting...') : t('attorney.requestViaMarkoTM.submit', 'Submit Request')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $aa40c3a1ec1fe38e$export$2e2bcd8739ae039 = $aa40c3a1ec1fe38e$var$RequestViaMarkoTMModal;



/**
 * MarkoTM Responses Component
 * For external attorneys to:
 * 1. See their pending requests to MarkoTM
 * 2. See responses forwarded back from clients
 * 3. Submit new requests to MarkoTM
 *
 * External attorneys cannot message clients directly - all communication goes through MarkoTM.
 */ function $3245c8611efb19e6$var$MarkoTMResponses() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { canCreateInternalRequests: canCreateInternalRequests, canMessageClients: canMessageClients, firmName: firmName } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [activeTab, setActiveTab] = (0, $acw62.useState)('pending');
    const [isRequestModalOpen, setIsRequestModalOpen] = (0, $acw62.useState)(false);
    const { data: myRequestsData, isLoading: requestsLoading } = (0, $8ef7a68274816bdb$export$3d0ac7bc84565bd6)();
    const { data: forwardedData, isLoading: forwardedLoading } = (0, $8ef7a68274816bdb$export$7c2902ea70fac050)();
    const myRequests = myRequestsData?.requests || [];
    const forwardedResponses = forwardedData?.messages || [];
    const pendingRequests = myRequests.filter((r)=>r.status === 'pending' || r.status === 'client_contacted');
    const completedRequests = myRequests.filter((r)=>r.status === 'response_forwarded' || r.status === 'declined');
    // Access check - only external attorneys see this page
    if (canMessageClients) // MarkoTM attorneys should use Client Messages instead
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "markotm-responses-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "access-info",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Internal Attorney"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: 'As a MarkoTM attorney, you can message clients directly. Please use the "Client Messages" section instead.'
                })
            ]
        })
    });
    if (!canCreateInternalRequests) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "markotm-responses-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "access-denied",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Access Restricted"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "You don't have permission to view this page."
                })
            ]
        })
    });
    const isLoading = requestsLoading || forwardedLoading;
    const displayItems = activeTab === 'pending' ? pendingRequests : activeTab === 'completed' ? completedRequests : forwardedResponses;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "markotm-responses-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "header-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: t('attorney.markoTMResponses.title', 'MarkoTM Responses')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "page-subtitle",
                                children: t('attorney.markoTMResponses.subtitle', 'Request client information through MarkoTM')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn btn-primary",
                        onClick: ()=>setIsRequestModalOpen(true),
                        children: t('attorney.markoTMResponses.newRequest', 'Request via MarkoTM')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "info-banner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "info-icon",
                        children: "\u2139\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: t('attorney.markoTMResponses.infoBanner', 'As an external attorney, client communication goes through MarkoTM. Submit your information requests here, and MarkoTM will contact the client on your behalf.')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "responses-tabs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `tab-btn ${activeTab === 'pending' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('pending'),
                        children: [
                            t('attorney.markoTMResponses.pendingRequests', 'Pending Requests'),
                            pendingRequests.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tab-badge",
                                children: pendingRequests.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `tab-btn ${activeTab === 'responses' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('responses'),
                        children: [
                            t('attorney.markoTMResponses.clientResponses', 'Client Responses'),
                            forwardedResponses.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tab-badge success",
                                children: forwardedResponses.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `tab-btn ${activeTab === 'completed' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('completed'),
                        children: t('attorney.markoTMResponses.completed', 'Completed')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "responses-list",
                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "loading-state",
                    children: "Loading..."
                }) : displayItems.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "empty-state",
                    children: activeTab === 'pending' ? t('attorney.markoTMResponses.noPending', 'No pending requests to MarkoTM') : activeTab === 'responses' ? t('attorney.markoTMResponses.noResponses', 'No client responses yet') : t('attorney.markoTMResponses.noCompleted', 'No completed requests')
                }) : displayItems.map((item)=>activeTab === 'responses' ? /*#__PURE__*/ (0, $ayMG0.jsx)($3245c8611efb19e6$var$ForwardedResponseCard, {
                        response: item
                    }, item.id) : /*#__PURE__*/ (0, $ayMG0.jsx)($3245c8611efb19e6$var$RequestCard, {
                        request: item
                    }, item.id))
            }),
            isRequestModalOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa40c3a1ec1fe38e$export$2e2bcd8739ae039), {
                isOpen: isRequestModalOpen,
                onClose: ()=>setIsRequestModalOpen(false)
            })
        ]
    });
}
/**
 * Request Card - shows pending/completed requests
 */ function $3245c8611efb19e6$var$RequestCard({ request: request }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const statusLabels = {
        pending: {
            icon: "\u23F3",
            label: 'Pending MarkoTM Action',
            color: 'status-pending'
        },
        client_contacted: {
            icon: "\uD83D\uDCE7",
            label: 'Client Contacted',
            color: 'status-progress'
        },
        response_forwarded: {
            icon: "\u2705",
            label: 'Response Received',
            color: 'status-success'
        },
        declined: {
            icon: "\u274C",
            label: 'Declined',
            color: 'status-declined'
        }
    };
    const status = statusLabels[request.status] || statusLabels.pending;
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `request-card ${expanded ? 'expanded' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "request-card-header",
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: `request-status ${status.color}`,
                                children: [
                                    status.icon,
                                    " ",
                                    status.label
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "request-title",
                                children: request.title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "request-application",
                                children: [
                                    "Application: ",
                                    request.applicationId,
                                    request.metadata?.clientName && ` - ${request.metadata.clientName}`
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "request-date",
                        children: formatDate(request.createdAt)
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "request-card-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.markoTMResponses.yourRequest', 'Your Request')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: request.message
                            })
                        ]
                    }),
                    request.requestData?.items && request.requestData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-items",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.markoTMResponses.requestedItems', 'Requested Items')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: request.requestData.items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "item-type",
                                                children: [
                                                    "[",
                                                    item.type,
                                                    "]"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-label",
                                                children: item.label
                                            }),
                                            item.required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-required",
                                                children: "*"
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }),
                    request.status === 'declined' && request.declineReason && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "decline-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.markoTMResponses.declineReason', 'Decline Reason')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: request.declineReason
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/**
 * Forwarded Response Card - shows client responses forwarded by MarkoTM
 */ function $3245c8611efb19e6$var$ForwardedResponseCard({ response: response }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `response-card ${expanded ? 'expanded' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "response-card-header",
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "response-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "response-icon",
                                children: "\uD83D\uDCEC"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "response-meta",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "response-title",
                                        children: response.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "response-application",
                                        children: [
                                            "Application: ",
                                            response.applicationId,
                                            response.metadata?.clientName && ` - ${response.metadata.clientName}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "response-date",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "date-label",
                                children: t('attorney.markoTMResponses.forwardedOn', 'Forwarded')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: formatDate(response.forwardedAt)
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "response-card-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "response-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.markoTMResponses.clientResponse', 'Client Response')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: response.responseMessage || 'No message provided'
                            })
                        ]
                    }),
                    response.requestData?.items && response.requestData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "response-items",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.markoTMResponses.providedInformation', 'Provided Information')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: response.requestData.items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: item.response ? 'item-answered' : '',
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-label",
                                                children: item.label
                                            }),
                                            item.response ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-response",
                                                children: item.response
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-empty",
                                                children: "Not provided"
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }),
                    response.responseAttachments && response.responseAttachments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "response-attachments",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.markoTMResponses.attachments', 'Attachments')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: response.responseAttachments.map((att, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: att.blobUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                "\uD83D\uDCCE ",
                                                att.name
                                            ]
                                        })
                                    }, idx))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $3245c8611efb19e6$export$2e2bcd8739ae039 = $3245c8611efb19e6$var$MarkoTMResponses;






/**
 * Feedback categories for AI Learning
 * When attorney modifies a draft, capture what needed improvement
 */ const $99f4b8369c21308e$var$FEEDBACK_CATEGORIES = {
    content: [
        {
            id: 'missing_argument',
            label: 'Missing key argument'
        },
        {
            id: 'wrong_argument',
            label: 'Wrong reasoning'
        },
        {
            id: 'irrelevant_content',
            label: 'Irrelevant content'
        },
        {
            id: 'missing_evidence_request',
            label: 'Missing evidence request'
        }
    ],
    tone: [
        {
            id: 'tone_too_formal',
            label: 'Too formal'
        },
        {
            id: 'tone_too_casual',
            label: 'Too casual'
        },
        {
            id: 'tone_too_aggressive',
            label: 'Too aggressive'
        },
        {
            id: 'tone_too_weak',
            label: 'Not assertive enough'
        }
    ],
    structure: [
        {
            id: 'wrong_format',
            label: 'Wrong format'
        },
        {
            id: 'too_long',
            label: 'Too verbose'
        },
        {
            id: 'too_short',
            label: 'Too brief'
        },
        {
            id: 'missing_sections',
            label: 'Missing sections'
        }
    ],
    accuracy: [
        {
            id: 'wrong_facts',
            label: 'Wrong facts'
        },
        {
            id: 'wrong_dates',
            label: 'Wrong dates'
        },
        {
            id: 'wrong_references',
            label: 'Wrong legal references'
        }
    ]
};
const $99f4b8369c21308e$var$SEVERITY_LEVELS = [
    {
        id: 'minor',
        label: 'Minor - small tweaks, would have been OK'
    },
    {
        id: 'moderate',
        label: 'Moderate - needed improvement but approach was right'
    },
    {
        id: 'major',
        label: 'Major - significant rewrite needed'
    },
    {
        id: 'rewrite',
        label: 'Complete rewrite - had to start over'
    }
];
/**
 * Draft Review Modal Component
 * Modal for reviewing, editing, approving or rejecting AI-generated drafts
 */ function $99f4b8369c21308e$var$DraftReviewModal({ task: task, onClose: onClose, onApprove: onApprove, onReject: onReject, isApproving: isApproving, isRejecting: isRejecting }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const { canMessageClients: canMessageClients } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [mode, setMode] = (0, $acw62.useState)('view'); // view, edit, reject
    const [deadlineCreated, setDeadlineCreated] = (0, $acw62.useState)(false);
    const [showRequestInfoModal, setShowRequestInfoModal] = (0, $acw62.useState)(false);
    // Create deadline mutation
    const createDeadlineMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (deadlineData)=>(0, $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039).createDeadline(deadlineData),
        onSuccess: ()=>{
            setDeadlineCreated(true);
            queryClient.invalidateQueries({
                queryKey: [
                    'deadlines'
                ]
            });
        }
    });
    const handleCreateDeadline = ()=>{
        // Calculate default deadline: 60 days from now
        const defaultDeadline = new Date();
        defaultDeadline.setDate(defaultDeadline.getDate() + 60);
        const deadlineData = {
            action: 'create',
            userId: task.userId,
            applicationId: task.applicationId,
            taskId: task.id,
            correspondenceId: task.correspondenceId,
            type: 'response_deadline',
            title: `Response Deadline - ${getTaskTitle()}`,
            description: taskSummary || 'Office action response deadline',
            dueDate: defaultDeadline.toISOString(),
            jurisdiction: task.correspondence?.jurisdiction || task.input?.correspondence?.jurisdiction || null
        };
        createDeadlineMutation.mutate(deadlineData);
    };
    // Support both task.result?.X and task.X field locations
    const taskDraft = task.draft || task.result?.draft || '';
    const taskSummary = task.summary || task.result?.summary || '';
    const rawSuccessLikelihood = task.successLikelihood ?? task.result?.successLikelihood;
    // Normalize to 0-100 scale (handle both 0-1 and 0-100 inputs)
    const taskSuccessLikelihood = rawSuccessLikelihood !== undefined ? rawSuccessLikelihood > 1 ? rawSuccessLikelihood : rawSuccessLikelihood * 100 : undefined;
    const taskKeyArguments = task.keyArguments || task.result?.keyArguments || [];
    const taskSimilarCases = task.similarCasesUsed || task.result?.similarCasesUsed || [];
    // Build proper title from task data
    const getTaskTitle = ()=>{
        const classification = task.input?.classification?.subType || task.input?.classification?.classification;
        const ipRef = task.correspondence?.ipOfficeRef || task.input?.correspondence?.ipOfficeRef;
        const trademarkName = task.trademarkName || task.input?.correspondence?.trademarkName;
        let title = '';
        if (classification === 'adverse_examination') title = 'Adverse Report';
        else if (classification === 'office_action') title = 'Office Action';
        else if (classification === 'opposition') title = 'Opposition';
        else title = classification || 'Response';
        if (ipRef) title += ` - ${ipRef}`;
        if (trademarkName) title += ` - ${trademarkName}`;
        return title;
    };
    const [editedDraft, setEditedDraft] = (0, $acw62.useState)(taskDraft);
    const [rejectReason, setRejectReason] = (0, $acw62.useState)('');
    // AI Learning feedback state
    const [selectedCategories, setSelectedCategories] = (0, $acw62.useState)([]);
    const [severity, setSeverity] = (0, $acw62.useState)('');
    const [learningNotes, setLearningNotes] = (0, $acw62.useState)('');
    const hasChanges = editedDraft !== taskDraft;
    // Toggle a feedback category
    const toggleCategory = (categoryId)=>{
        setSelectedCategories((prev)=>prev.includes(categoryId) ? prev.filter((c)=>c !== categoryId) : [
                ...prev,
                categoryId
            ]);
    };
    const handleApprove = ()=>{
        // Build modifications object with feedback for AI learning
        let modifications = null;
        if (hasChanges) modifications = {
            modifiedDraft: editedDraft,
            originalDraft: taskDraft,
            // AI Learning feedback
            feedback: {
                categories: selectedCategories,
                severity: severity || 'minor',
                notes: learningNotes.trim() || null
            }
        };
        onApprove(modifications);
    };
    // Check if feedback is required (when there are changes)
    const canApproveWithChanges = !hasChanges || severity && selectedCategories.length > 0;
    const handleReject = ()=>{
        if (rejectReason.trim()) onReject(rejectReason.trim());
    };
    const similarCases = taskSimilarCases;
    const keyArguments = taskKeyArguments;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "draft-review-modal-overlay",
        onClick: onClose,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "draft-review-modal",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "draft-review-modal-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "draft-review-modal-close",
                                onClick: onClose,
                                children: "\u2715"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: getTaskTitle() || t('attorney.draftReview.title', 'Review AI Draft')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "draft-review-meta",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "draft-review-app-id",
                                        children: task.applicationId
                                    }),
                                    task.clientName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "draft-review-client",
                                        children: task.clientName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "draft-review-modal-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "draft-review-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t('attorney.draftReview.summary', 'Summary')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "draft-summary",
                                        children: taskSummary || 'No summary available'
                                    }),
                                    taskSuccessLikelihood !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "success-likelihood",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "likelihood-label",
                                                children: [
                                                    t('attorney.draftReview.estimatedSuccess', 'Estimated Success'),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "likelihood-bar",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "likelihood-fill",
                                                    style: {
                                                        width: `${taskSuccessLikelihood}%`
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "likelihood-value",
                                                children: [
                                                    Math.round(taskSuccessLikelihood),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    !task.deadlineId && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "create-deadline-section",
                                        children: [
                                            deadlineCreated ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "deadline-created-badge",
                                                children: t('attorney.draftReview.deadlineCreated', 'Deadline Created')
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "btn-create-deadline",
                                                onClick: handleCreateDeadline,
                                                disabled: createDeadlineMutation.isPending,
                                                children: createDeadlineMutation.isPending ? t('attorney.draftReview.creatingDeadline', 'Creating...') : t('attorney.draftReview.createDeadline', 'Create Deadline (60 days)')
                                            }),
                                            createDeadlineMutation.isError && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "deadline-error",
                                                children: t('attorney.draftReview.deadlineError', 'Failed to create deadline')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            keyArguments.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "draft-review-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t('attorney.draftReview.keyArguments', 'Key Arguments')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "key-arguments-list",
                                        children: keyArguments.map((arg, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: arg
                                            }, index))
                                    })
                                ]
                            }),
                            similarCases.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "draft-review-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t('attorney.draftReview.similarCases', 'Similar Cases Referenced')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "similar-cases",
                                        children: similarCases.map((caseId, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "similar-case-tag",
                                                children: caseId
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "draft-review-section draft-content-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "draft-content-header",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: t('attorney.draftReview.draftContent', 'Draft Content')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "draft-mode-tabs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: `mode-tab ${mode === 'view' ? 'active' : ''}`,
                                                        onClick: ()=>setMode('view'),
                                                        children: t('attorney.draftReview.view', 'View')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: `mode-tab ${mode === 'edit' ? 'active' : ''}`,
                                                        onClick: ()=>setMode('edit'),
                                                        children: t('attorney.draftReview.edit', 'Edit')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    mode === 'view' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "draft-view",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                            children: taskDraft || 'No draft content available'
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        className: "draft-edit",
                                        value: editedDraft,
                                        onChange: (e)=>setEditedDraft(e.target.value),
                                        placeholder: t('attorney.draftReview.editPlaceholder', 'Edit the draft...')
                                    })
                                ]
                            }),
                            mode === 'edit' && hasChanges && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "draft-review-section feedback-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                        children: [
                                            t('attorney.draftReview.feedbackTitle', 'AI Improvement Feedback'),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "required-badge",
                                                children: t('attorney.draftReview.required', 'Required')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "feedback-description",
                                        children: t('attorney.draftReview.feedbackDescription', 'Help the AI learn by explaining what needed improvement.')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "feedback-categories",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "feedback-category-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: t('attorney.draftReview.content', 'Content')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "category-checkboxes",
                                                        children: $99f4b8369c21308e$var$FEEDBACK_CATEGORIES.content.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "category-checkbox",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedCategories.includes(cat.id),
                                                                        onChange: ()=>toggleCategory(cat.id)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        children: t(`attorney.draftReview.feedback.${cat.id}`, cat.label)
                                                                    })
                                                                ]
                                                            }, cat.id))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "feedback-category-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: t('attorney.draftReview.toneStyle', 'Tone & Style')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "category-checkboxes",
                                                        children: $99f4b8369c21308e$var$FEEDBACK_CATEGORIES.tone.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "category-checkbox",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedCategories.includes(cat.id),
                                                                        onChange: ()=>toggleCategory(cat.id)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        children: t(`attorney.draftReview.feedback.${cat.id}`, cat.label)
                                                                    })
                                                                ]
                                                            }, cat.id))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "feedback-category-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: t('attorney.draftReview.structure', 'Structure')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "category-checkboxes",
                                                        children: $99f4b8369c21308e$var$FEEDBACK_CATEGORIES.structure.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "category-checkbox",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedCategories.includes(cat.id),
                                                                        onChange: ()=>toggleCategory(cat.id)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        children: t(`attorney.draftReview.feedback.${cat.id}`, cat.label)
                                                                    })
                                                                ]
                                                            }, cat.id))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "feedback-category-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: t('attorney.draftReview.accuracy', 'Accuracy')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "category-checkboxes",
                                                        children: $99f4b8369c21308e$var$FEEDBACK_CATEGORIES.accuracy.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "category-checkbox",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedCategories.includes(cat.id),
                                                                        onChange: ()=>toggleCategory(cat.id)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        children: t(`attorney.draftReview.feedback.${cat.id}`, cat.label)
                                                                    })
                                                                ]
                                                            }, cat.id))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "feedback-severity",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                children: t('attorney.draftReview.severityQuestion', 'How significant were your changes?')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "severity-options",
                                                children: $99f4b8369c21308e$var$SEVERITY_LEVELS.map((level)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "severity-option",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "radio",
                                                                name: "severity",
                                                                value: level.id,
                                                                checked: severity === level.id,
                                                                onChange: ()=>setSeverity(level.id)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: t(`attorney.draftReview.severity.${level.id}`, level.label)
                                                            })
                                                        ]
                                                    }, level.id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "feedback-notes",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                children: t('attorney.draftReview.learningNotesTitle', 'What should the AI learn from this?')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                className: "learning-notes-input",
                                                value: learningNotes,
                                                onChange: (e)=>setLearningNotes(e.target.value),
                                                placeholder: t('attorney.draftReview.learningNotesPlaceholder', 'Optional: Explain what the AI should do differently next time...')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            mode === 'reject' && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "draft-review-section reject-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t('attorney.draftReview.rejectReason', 'Reason for Rejection')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        className: "reject-reason-input",
                                        value: rejectReason,
                                        onChange: (e)=>setRejectReason(e.target.value),
                                        placeholder: t('attorney.draftReview.rejectPlaceholder', 'Explain why this draft is being rejected...')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "draft-review-modal-footer",
                        children: mode === 'reject' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-back",
                                    onClick: ()=>setMode('view'),
                                    children: t('attorney.draftReview.back', 'Back')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-confirm-reject",
                                    onClick: handleReject,
                                    disabled: !rejectReason.trim() || isRejecting,
                                    children: isRejecting ? t('attorney.draftReview.rejecting', 'Rejecting...') : t('attorney.draftReview.confirmReject', 'Confirm Rejection')
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-request-info",
                                    onClick: ()=>setShowRequestInfoModal(true),
                                    disabled: isApproving || isRejecting,
                                    children: canMessageClients ? t('attorney.draftReview.requestClientInfo', 'Request Client Info') : t('attorney.draftReview.requestViaMarkoTM', 'Request via MarkoTM')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-reject",
                                    onClick: ()=>setMode('reject'),
                                    disabled: isApproving || isRejecting,
                                    children: t('attorney.draftReview.reject', 'Reject')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-approve",
                                    onClick: handleApprove,
                                    disabled: isApproving || isRejecting || hasChanges && !canApproveWithChanges,
                                    title: hasChanges && !canApproveWithChanges ? t('attorney.draftReview.feedbackRequired', 'Please provide feedback on what needed improvement') : '',
                                    children: isApproving ? t('attorney.draftReview.approving', 'Approving...') : hasChanges ? t('attorney.draftReview.approveWithChanges', 'Approve with Changes') : t('attorney.draftReview.approve', 'Approve')
                                })
                            ]
                        })
                    })
                ]
            }),
            showRequestInfoModal && (canMessageClients ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $afd9ebad085eb41d$export$2e2bcd8739ae039), {
                isOpen: showRequestInfoModal,
                onClose: ()=>setShowRequestInfoModal(false),
                applicationId: task.applicationId,
                clientName: task.clientName
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa40c3a1ec1fe38e$export$2e2bcd8739ae039), {
                isOpen: showRequestInfoModal,
                onClose: ()=>setShowRequestInfoModal(false),
                applicationId: task.applicationId,
                clientName: task.clientName
            }))
        ]
    });
}
var $99f4b8369c21308e$export$2e2bcd8739ae039 = $99f4b8369c21308e$var$DraftReviewModal;



async function $5d4ea61971698ebc$export$5bbb8bc0e6db4950(options = {}) {
    const params = new URLSearchParams();
    if (options.status) params.append('status', options.status);
    if (options.agent) params.append('agent', options.agent);
    if (options.priority) params.append('priority', options.priority);
    const queryString = params.toString();
    const url = queryString ? `/attorney/approval-queue?${queryString}` : '/attorney/approval-queue';
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(url);
    return response.data;
}
async function $5d4ea61971698ebc$export$98eeb63664f32ec(taskId) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/attorney/approval-queue/${taskId}`);
    return response.data;
}
async function $5d4ea61971698ebc$export$be74afa88aacbbce(taskId, data = {}) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/attorney/approval-queue/${taskId}`, {
        action: 'approve',
        notes: data.notes,
        modifications: data.modifications
    });
    return response.data;
}
async function $5d4ea61971698ebc$export$47e6ba95edb9e5bb(taskId, data) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/attorney/approval-queue/${taskId}`, {
        action: 'reject',
        reason: data.reason,
        notes: data.notes
    });
    return response.data;
}
async function $5d4ea61971698ebc$export$13ce2202561ee22c(taskId, data = {}) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/attorney/approval-queue/${taskId}`, {
        action: 'assign',
        assignTo: data.assignTo
    });
    return response.data;
}
var $5d4ea61971698ebc$export$2e2bcd8739ae039 = {
    getApprovalQueue: $5d4ea61971698ebc$export$5bbb8bc0e6db4950,
    getApprovalTask: $5d4ea61971698ebc$export$98eeb63664f32ec,
    approveTask: $5d4ea61971698ebc$export$be74afa88aacbbce,
    rejectTask: $5d4ea61971698ebc$export$47e6ba95edb9e5bb,
    assignTask: $5d4ea61971698ebc$export$13ce2202561ee22c
};



/**
 * Approval Queue Component
 * Main view for attorneys to review and approve AI-generated drafts
 * Supports ?task={taskId} URL param to auto-open a specific task for review
 */ function $ccbe50d6f4411b39$var$ApprovalQueue() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    const [selectedTask, setSelectedTask] = (0, $acw62.useState)(null);
    const [filterType, setFilterType] = (0, $acw62.useState)('all');
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)('awaiting_approval');
    const [highlightedTaskId, setHighlightedTaskId] = (0, $acw62.useState)(null);
    const highlightedRef = (0, $acw62.useRef)(null);
    const initialLoadDone = (0, $acw62.useRef)(false);
    // Read URL params on mount
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const taskId = urlParams.get('task');
        if (taskId) {
            setHighlightedTaskId(taskId);
            setFilterType('all'); // Show all types to ensure we can find it
        }
    }, []);
    // Fetch approval queue using service layer
    const { data: data, isLoading: isLoading, error: error } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'approvalQueue',
            filterType,
            filterStatus
        ],
        queryFn: ()=>(0, $5d4ea61971698ebc$export$2e2bcd8739ae039).getApprovalQueue({
                agent: filterType !== 'all' ? filterType : undefined,
                status: filterStatus !== 'all' ? filterStatus : undefined
            })
    });
    // Extract tasks from response
    const tasks = data?.tasks || [];
    // Auto-open highlighted task when data loads
    (0, $acw62.useEffect)(()=>{
        if (highlightedTaskId && tasks.length > 0 && !initialLoadDone.current) {
            const task = tasks.find((t)=>t.id === highlightedTaskId);
            if (task) {
                setSelectedTask(task);
                initialLoadDone.current = true;
            }
            // Scroll to highlighted card
            if (highlightedRef.current) highlightedRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [
        highlightedTaskId,
        tasks
    ]);
    // Approve mutation using service layer
    const approveMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ taskId: taskId, modifications: modifications })=>(0, $5d4ea61971698ebc$export$2e2bcd8739ae039).approveTask(taskId, {
                modifications: modifications
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'approvalQueue'
                ]
            });
            setSelectedTask(null);
        }
    });
    // Reject mutation using service layer
    const rejectMutation = (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ taskId: taskId, reason: reason })=>(0, $5d4ea61971698ebc$export$2e2bcd8739ae039).rejectTask(taskId, {
                reason: reason
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'approvalQueue'
                ]
            });
            setSelectedTask(null);
        }
    });
    const handleReview = (task)=>{
        setSelectedTask(task);
    };
    const handleApprove = (modifications)=>{
        if (selectedTask) approveMutation.mutate({
            taskId: selectedTask.id,
            modifications: modifications
        });
    };
    const handleReject = (reason)=>{
        if (selectedTask) rejectMutation.mutate({
            taskId: selectedTask.id,
            reason: reason
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "approval-queue",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "approval-queue-loading",
            children: t('attorney.approvalQueue.loading', 'Loading approval queue...')
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "approval-queue",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "approval-queue-error",
            children: t('attorney.approvalQueue.error', 'Error loading approval queue')
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "approval-queue",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "approval-queue-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.approvalQueue.title', 'Approval Queue')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "approval-queue-filters",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: filterStatus,
                                onChange: (e)=>setFilterStatus(e.target.value),
                                className: "approval-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "awaiting_approval",
                                        children: t('attorney.approvalQueue.statusPending', 'Pending')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "approved",
                                        children: t('attorney.approvalQueue.statusApproved', 'Approved')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "rejected",
                                        children: t('attorney.approvalQueue.statusRejected', 'Rejected')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.approvalQueue.statusAll', 'All Status')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: filterType,
                                onChange: (e)=>setFilterType(e.target.value),
                                className: "approval-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.approvalQueue.allTypes', 'All Types')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "office_action_response",
                                        children: t('attorney.approvalQueue.officeAction', 'Office Action Responses')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "opposition_response",
                                        children: t('attorney.approvalQueue.opposition', 'Opposition Responses')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "renewal",
                                        children: t('attorney.approvalQueue.renewal', 'Renewal Applications')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "approval-refresh-btn",
                                onClick: ()=>queryClient.invalidateQueries({
                                        queryKey: [
                                            'approvalQueue'
                                        ]
                                    }),
                                children: t('attorney.approvalQueue.refresh', 'Refresh')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "approval-queue-content",
                children: tasks.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "approval-queue-empty",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "approval-queue-empty-icon",
                            children: filterStatus === 'awaiting_approval' ? "\u2705" : "\uD83D\uDCCB"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: filterStatus === 'awaiting_approval' ? t('attorney.approvalQueue.empty', 'No tasks awaiting approval') : filterStatus === 'approved' ? t('attorney.approvalQueue.emptyApproved', 'No approved tasks found') : filterStatus === 'rejected' ? t('attorney.approvalQueue.emptyRejected', 'No rejected tasks found') : t('attorney.approvalQueue.emptyAll', 'No tasks found')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "approval-cards",
                    children: tasks.map((task)=>{
                        const isHighlighted = task.id === highlightedTaskId;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: isHighlighted ? highlightedRef : null,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00cef1b0e7bd6dbc$export$2e2bcd8739ae039), {
                                task: task,
                                onReview: handleReview,
                                isHighlighted: isHighlighted
                            })
                        }, task.id);
                    })
                })
            }),
            selectedTask && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99f4b8369c21308e$export$2e2bcd8739ae039), {
                task: selectedTask,
                onClose: ()=>setSelectedTask(null),
                onApprove: handleApprove,
                onReject: handleReject,
                isApproving: approveMutation.isPending,
                isRejecting: rejectMutation.isPending
            })
        ]
    });
}
var $ccbe50d6f4411b39$export$2e2bcd8739ae039 = $ccbe50d6f4411b39$var$ApprovalQueue;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




/**
 * Clients Component
 * Shows all clients and their applications
 */ function $ef8b176a7ebb4685$var$Clients() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { isInternal: isInternal, isAttorneyAdmin: isAttorneyAdmin } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [selectedClientId, setSelectedClientId] = (0, $acw62.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [assignmentFilter, setAssignmentFilter] = (0, $acw62.useState)('all');
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $c8f2794f3cd67c4a$export$4823a6cc022cca16)({
        assignmentFilter: assignmentFilter
    });
    const clients = data?.clients || [];
    const stats = data?.stats || {};
    // Filter clients by search term
    const filteredClients = clients.filter((client)=>{
        if (!searchTerm) return true;
        const search = searchTerm.toLowerCase();
        return client.name?.toLowerCase().includes(search) || client.email?.toLowerCase().includes(search) || client.applications?.some((app)=>app.trademarkName?.toLowerCase().includes(search) || app.applicationId?.toLowerCase().includes(search));
    });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clients-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.clients.loading', 'Loading clients...')
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clients-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.clients.error', 'Failed to load clients')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                children: t('attorney.clients.retry', 'Retry')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clients-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clients-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.clients.title', 'My Clients')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clients-filters",
                        children: [
                            isInternal && /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: assignmentFilter,
                                onChange: (e)=>setAssignmentFilter(e.target.value),
                                className: "clients-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.clients.allClients', 'All Clients')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "mine",
                                        children: t('attorney.clients.assignedToMe', 'Assigned to Me')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "my_firm",
                                        children: t('attorney.clients.myFirm', 'My Firm')
                                    }),
                                    isAttorneyAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "transferred",
                                        children: t('attorney.clients.transferred', 'Transferred to External')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clients-search",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    placeholder: t('attorney.clients.searchPlaceholder', 'Search clients, trademarks...'),
                                    value: searchTerm,
                                    onChange: (e)=>setSearchTerm(e.target.value)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clients-stats",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.totalClients || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.clients.stats.totalClients', 'Total Clients')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.activeClients || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.clients.stats.activeClients', 'Active (30d)')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.totalApplications || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.clients.stats.totalApplications', 'Applications')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.totalPendingFilings || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.clients.stats.pendingFilings', 'Pending Filings')
                            })
                        ]
                    })
                ]
            }),
            filteredClients.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "clients-empty",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: searchTerm ? t('attorney.clients.noResults', 'No clients match your search') : t('attorney.clients.empty', 'No clients yet')
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "clients-list",
                children: filteredClients.map((client)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ef8b176a7ebb4685$var$ClientCard, {
                        client: client,
                        isExpanded: selectedClientId === client.userId,
                        onToggle: ()=>setSelectedClientId(selectedClientId === client.userId ? null : client.userId)
                    }, client.userId))
            })
        ]
    });
}
function $ef8b176a7ebb4685$var$ClientCard({ client: client, isExpanded: isExpanded, onToggle: onToggle }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const formatDate = (dateString)=>{
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const getStatusClass = (app)=>{
        // Check for special conditions first
        if (app.hasAdverseReport) return 'status-warning';
        if (app.hasTask) return 'status-attention';
        switch(app.status){
            case 'registered':
                return 'status-success';
            case 'filed':
                return 'status-filed';
            case 'pending_attorney_filing':
            case 'filing_in_progress':
                return 'status-pending';
            case 'payment_complete':
                return 'status-ready';
            case 'active':
            case 'draft':
                return 'status-draft';
            default:
                return 'status-draft';
        }
    };
    const getStatusLabel = (app)=>{
        // Show adverse report status if applicable
        if (app.hasAdverseReport) return 'Adverse Report';
        switch(app.status){
            case 'registered':
                return 'Registered';
            case 'filed':
                return 'Filed';
            case 'pending_attorney_filing':
                return 'Pending Filing';
            case 'filing_in_progress':
                return 'Filing in Progress';
            case 'payment_complete':
                return 'Ready to File';
            case 'active':
                // Check if it's actually a draft (not submitted for payment)
                return 'Draft';
            case 'draft':
                return 'Draft';
            default:
                return app.status || 'Draft';
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `client-card ${isExpanded ? 'expanded' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "client-header",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "client-avatar",
                        children: client.name?.charAt(0)?.toUpperCase() || '?'
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "client-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "client-name",
                                children: client.name || 'Unknown Client'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "client-email",
                                children: client.email || 'No email'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "client-summary",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "summary-item",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: client.totalApplications
                                    }),
                                    " ",
                                    t('attorney.clients.applications', 'applications')
                                ]
                            }),
                            client.pendingFilings > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "summary-item pending",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: client.pendingFilings
                                    }),
                                    " ",
                                    t('attorney.clients.pendingFilings', 'pending filings')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "client-expand",
                        children: isExpanded ? "\u25BC" : "\u25B6"
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "client-details",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "client-meta",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "meta-item",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "meta-label",
                                        children: [
                                            t('attorney.clients.lastActivity', 'Last Activity'),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "meta-value",
                                        children: formatDate(client.lastActivity)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "meta-item",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "meta-label",
                                        children: [
                                            t('attorney.clients.activeTrademarks', 'Active Trademarks'),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "meta-value",
                                        children: client.activeTrademarks
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: t('attorney.clients.applicationsTitle', 'Applications')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "applications-list",
                        children: client.applications.map((app)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "application-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "application-row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "app-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "app-name",
                                                        children: app.trademarkName
                                                    }),
                                                    app.businessName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "app-business",
                                                        children: app.businessName
                                                    }),
                                                    app.applicationId && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "app-id",
                                                        children: app.applicationId
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `app-status ${getStatusClass(app)}`,
                                                children: getStatusLabel(app)
                                            }),
                                            app.assignment?.isTransferred && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "app-assignment transferred",
                                                children: app.assignment.orgName || 'External Firm'
                                            }),
                                            app.assignment?.attorneyName && !app.assignment?.isTransferred && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "app-assignment assigned",
                                                children: app.assignment.attorneyName
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "app-filings",
                                                children: app.filings?.map((filing)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `filing-badge ${filing.status}`,
                                                        title: `${filing.jurisdiction}: ${filing.status}`,
                                                        children: filing.jurisdiction
                                                    }, filing.jurisdiction))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "app-date",
                                                children: formatDate(app.createdAt)
                                            }),
                                            app.status && ![
                                                'draft',
                                                'active'
                                            ].includes(app.status) && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: `/attorney/filing-queue?app=${app.id}`,
                                                className: "app-link",
                                                onClick: (e)=>e.stopPropagation(),
                                                children: [
                                                    t('attorney.clients.view', 'View'),
                                                    " \u2192"
                                                ]
                                            })
                                        ]
                                    }),
                                    app.linkedItems && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            app.linkedItems.correspondence?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "linked-section",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "linked-section-header correspondence",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "linked-icon",
                                                                children: "\u2709"
                                                            }),
                                                            "Correspondence (",
                                                            app.linkedItems.correspondence.length,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "linked-list",
                                                        children: app.linkedItems.correspondence.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: `/attorney/correspondence?id=${c.id}`,
                                                                className: "linked-list-item linked-list-item-clickable",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "linked-item-title",
                                                                        children: c.subject || 'No subject'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `linked-item-badge ${c.classification}`,
                                                                        children: c.subType || c.classification || 'General'
                                                                    }),
                                                                    c.jurisdiction && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "linked-item-jurisdiction",
                                                                        children: c.jurisdiction
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "linked-item-date",
                                                                        children: formatDate(c.receivedAt)
                                                                    })
                                                                ]
                                                            }, c.id))
                                                    })
                                                ]
                                            }),
                                            app.linkedItems.deadlines?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "linked-section",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "linked-section-header deadlines",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "linked-icon",
                                                                children: "\u23F0"
                                                            }),
                                                            "Deadlines (",
                                                            app.linkedItems.deadlines.length,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "linked-list",
                                                        children: app.linkedItems.deadlines.map((d)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: `/attorney/deadlines?id=${d.id}`,
                                                                className: "linked-list-item linked-list-item-clickable",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "linked-item-title",
                                                                        children: d.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `linked-item-badge urgency-${d.urgency}`,
                                                                        children: d.urgency
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "linked-item-date",
                                                                        children: [
                                                                            "Due: ",
                                                                            formatDate(d.dueDate)
                                                                        ]
                                                                    })
                                                                ]
                                                            }, d.id))
                                                    })
                                                ]
                                            }),
                                            app.linkedItems.tasks?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "linked-section",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "linked-section-header tasks",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "linked-icon",
                                                                children: "\u2713"
                                                            }),
                                                            "Tasks (",
                                                            app.linkedItems.tasks.length,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "linked-list",
                                                        children: app.linkedItems.tasks.map((task)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: `/attorney/approval-queue?task=${task.id}`,
                                                                className: "linked-list-item linked-list-item-clickable",
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "linked-item-title",
                                                                        children: task.summary || task.agent
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `linked-item-badge priority-${task.priority}`,
                                                                        children: task.priority
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `linked-item-badge status-${task.status}`,
                                                                        children: task.status?.replace(/_/g, ' ')
                                                                    })
                                                                ]
                                                            }, task.id))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, app.id))
                    })
                ]
            })
        ]
    });
}
var $ef8b176a7ebb4685$export$2e2bcd8739ae039 = $ef8b176a7ebb4685$var$Clients;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






/**
 * Client Messages Component
 * Shows notifications and messages sent to clients with their responses
 *
 * Combines:
 * - System notifications (status updates, assignments, deadlines)
 * - Client messages (info requests, responses)
 *
 * Only visible to MarkoTM (internal) attorneys who can message clients directly.
 * External attorneys see "MarkoTM Responses" instead.
 */ function $74a3a60f5db40811$var$ClientMessages() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { canMessageClients: canMessageClients } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [activeTab, setActiveTab] = (0, $acw62.useState)('all');
    const [isComposeOpen, setIsComposeOpen] = (0, $acw62.useState)(false);
    // Get notifications from context
    const { notifications: notifications, unreadCount: unreadCount, markAsRead: markAsRead, markAllAsRead: markAllAsRead } = (0, $a05168b77183bb44$export$53d5ca6c3f53e109)();
    // Get messages from API
    const { data: pendingData, isLoading: pendingLoading } = (0, $8ef7a68274816bdb$export$589caff7e2cb2583)();
    const { data: allData, isLoading: allLoading } = (0, $8ef7a68274816bdb$export$4d17e2d9c5348842)();
    const pendingMessages = pendingData?.messages || [];
    const allMessages = allData?.messages || [];
    // Combine notifications and messages
    const allItems = (0, $acw62.useMemo)(()=>{
        // Messages sent to clients
        const messageItems = allMessages.map((m)=>({
                ...m,
                itemType: 'message',
                isMessage: true,
                displayTitle: m.title || m.subject,
                displayMessage: m.message || m.body,
                createdAt: m.createdAt
            }));
        // Notifications (exclude ones that are also in messages to avoid duplicates)
        const messageIds = new Set(allMessages.map((m)=>m.id));
        const notificationItems = notifications.filter((n)=>!messageIds.has(n.id)).map((n)=>({
                ...n,
                itemType: 'notification',
                isMessage: false,
                displayTitle: n.title,
                displayMessage: n.message || n.body,
                createdAt: n.createdAt
            }));
        // Combine and sort by date
        return [
            ...messageItems,
            ...notificationItems
        ].sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    }, [
        allMessages,
        notifications
    ]);
    // Filter items based on tab
    const unreadItems = allItems.filter((item)=>!item.read && !item.readAt);
    const displayItems = activeTab === 'pending' ? pendingMessages.map((m)=>({
            ...m,
            itemType: 'message',
            isMessage: true,
            displayTitle: m.title || m.subject,
            displayMessage: m.message || m.body
        })) : activeTab === 'unread' ? unreadItems : allItems;
    const handleMarkAllRead = async ()=>{
        await markAllAsRead();
    };
    const handleMarkAsRead = async (itemId)=>{
        await markAsRead(itemId);
    };
    // Access check
    if (!canMessageClients) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "client-messages-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "access-denied",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Access Restricted"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: 'Only MarkoTM attorneys can message clients directly. External attorneys should use "Request via MarkoTM" to request information.'
                })
            ]
        })
    });
    const isLoading = pendingLoading || allLoading;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "client-messages-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: t('attorney.notifications.title', 'Notifications')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "page-subtitle",
                                children: t('attorney.notifications.subtitle', 'System alerts and client message responses')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "header-actions",
                        children: [
                            unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "btn btn-text",
                                onClick: handleMarkAllRead,
                                children: [
                                    "\u2713 ",
                                    t('attorney.notifications.markAllRead', 'Mark all as read')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "btn btn-primary",
                                onClick: ()=>setIsComposeOpen(true),
                                children: t('attorney.clientMessages.compose', 'New Message')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "messages-tabs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `tab-btn ${activeTab === 'pending' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('pending'),
                        children: [
                            t('attorney.clientMessages.awaitingResponse', 'Awaiting Response'),
                            pendingMessages.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tab-badge",
                                children: pendingMessages.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `tab-btn ${activeTab === 'unread' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('unread'),
                        children: [
                            t('attorney.notifications.unread', 'Unread'),
                            unreadItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tab-badge tab-badge-blue",
                                children: unreadItems.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `tab-btn ${activeTab === 'all' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('all'),
                        children: [
                            t('attorney.notifications.all', 'All'),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tab-count",
                                children: allItems.length
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "messages-list",
                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "loading-state",
                    children: "Loading..."
                }) : displayItems.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "empty-state-icon",
                            children: activeTab === 'pending' ? "\uD83D\uDCE8" : activeTab === 'unread' ? "\u2705" : "\uD83D\uDCED"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            children: activeTab === 'pending' ? t('attorney.clientMessages.noPending', 'No messages awaiting response') : activeTab === 'unread' ? t('attorney.notifications.noUnread', 'All caught up!') : t('attorney.notifications.noNotifications', 'No notifications yet')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: activeTab === 'pending' ? t('attorney.clientMessages.noPendingHint', 'Messages you send to clients will appear here until they respond.') : activeTab === 'unread' ? t('attorney.notifications.noUnreadHint', 'You have no unread notifications.') : t('attorney.notifications.noNotificationsHint', 'System alerts and client responses will appear here.')
                        })
                    ]
                }) : displayItems.map((item)=>item.isMessage ? /*#__PURE__*/ (0, $ayMG0.jsx)($74a3a60f5db40811$var$MessageCard, {
                        message: item,
                        onMarkRead: ()=>handleMarkAsRead(item.id)
                    }, item.id) : /*#__PURE__*/ (0, $ayMG0.jsx)($74a3a60f5db40811$var$NotificationCard, {
                        notification: item,
                        onMarkRead: ()=>handleMarkAsRead(item.id)
                    }, item.id))
            }),
            isComposeOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $afd9ebad085eb41d$export$2e2bcd8739ae039), {
                isOpen: isComposeOpen,
                onClose: ()=>setIsComposeOpen(false)
            })
        ]
    });
}
/**
 * Notification Card Component (for status updates, assignments, etc.)
 */ function $74a3a60f5db40811$var$NotificationCard({ notification: notification, onMarkRead: onMarkRead }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const isUnread = !notification.read && !notification.readAt;
    const getCategoryIcon = (category)=>{
        switch(category){
            case 'status_change':
                return "\uD83D\uDCCB";
            case 'assignment':
                return "\uD83D\uDC64";
            case 'deadline':
                return "\u23F0";
            case 'correspondence':
                return "\uD83D\uDCE7";
            case 'approval':
                return "\u2705";
            case 'filing':
                return "\uD83D\uDCC1";
            case 'client_response':
                return "\uD83D\uDCAC";
            default:
                return "\uD83D\uDD14";
        }
    };
    const getCategoryLabel = (category)=>{
        switch(category){
            case 'status_change':
                return t('attorney.notifications.statusChange', 'Status Update');
            case 'assignment':
                return t('attorney.notifications.assignment', 'Assignment');
            case 'deadline':
                return t('attorney.notifications.deadline', 'Deadline');
            case 'correspondence':
                return t('attorney.notifications.correspondence', 'Correspondence');
            case 'approval':
                return t('attorney.notifications.approval', 'Approval');
            case 'filing':
                return t('attorney.notifications.filing', 'Filing');
            case 'client_response':
                return t('attorney.notifications.clientResponse', 'Client Response');
            default:
                return t('attorney.notifications.system', 'System');
        }
    };
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const now = new Date();
        const diffMs = now - date;
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffHours < 1) return t('attorney.notifications.justNow', 'Just now');
        if (diffHours < 24) return `${diffHours}h ago`;
        if (diffDays < 7) return `${diffDays}d ago`;
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    };
    const handleClick = ()=>{
        if (isUnread) onMarkRead();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `notification-card ${isUnread ? 'unread' : ''}`,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "notification-icon",
                children: getCategoryIcon(notification.category)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "notification-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "notification-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "notification-category",
                                children: getCategoryLabel(notification.category)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "notification-time",
                                children: formatDate(notification.createdAt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "notification-title",
                        children: notification.displayTitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "notification-message",
                        children: notification.displayMessage
                    }),
                    notification.linkType && notification.linkId && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "notification-action",
                        children: [
                            t('attorney.notifications.viewDetails', 'View details'),
                            " \u2192"
                        ]
                    })
                ]
            }),
            isUnread && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "unread-dot"
            })
        ]
    });
}
/**
 * Message Card Component (for client messages)
 */ function $74a3a60f5db40811$var$MessageCard({ message: message, onMarkRead: onMarkRead }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const isUnread = !message.read && !message.readAt;
    const statusColors = {
        pending: 'status-pending',
        responded: 'status-success',
        expired: 'status-error'
    };
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };
    const handleToggle = ()=>{
        if (isUnread && !expanded) onMarkRead();
        setExpanded(!expanded);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `message-card ${expanded ? 'expanded' : ''} ${isUnread ? 'unread' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "message-card-header",
                onClick: handleToggle,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "message-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `message-status ${statusColors[message.responseStatus] || ''}`,
                                children: message.responseStatus === 'pending' ? "\uD83D\uDCE8" : "\u2705"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "message-meta",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "message-title",
                                        children: message.displayTitle || message.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "message-application",
                                        children: [
                                            t('attorney.clientMessages.re', 'Re'),
                                            ": ",
                                            message.applicationId || 'Application'
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "message-header-right",
                        children: [
                            message.responseStatus === 'pending' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "response-badge",
                                children: t('attorney.clientMessages.awaitingResponse', 'Awaiting Response')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "message-date",
                                children: formatDate(message.createdAt)
                            }),
                            isUnread && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "unread-dot"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "expand-icon",
                                children: expanded ? "\u25BC" : "\u25B6"
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "message-card-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "message-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.clientMessages.yourMessage', 'Your Message')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: message.displayMessage || message.message
                            })
                        ]
                    }),
                    message.requestData?.items && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "message-items",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.clientMessages.requestedItems', 'Requested Items')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: message.requestData.items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: item.response ? 'item-responded' : '',
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-label",
                                                children: item.label
                                            }),
                                            item.response && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-response",
                                                children: item.response
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }),
                    message.responseAttachments?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "message-attachments",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.clientMessages.clientAttachments', 'Client Attachments')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: message.responseAttachments.map((att, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: att.blobUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                "\uD83D\uDCCE ",
                                                att.name
                                            ]
                                        })
                                    }, idx))
                            })
                        ]
                    }),
                    message.responseStatus === 'responded' && message.respondedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "response-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "response-success",
                                children: [
                                    "\u2705 ",
                                    t('attorney.clientMessages.clientResponded', 'Client responded')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "response-date",
                                children: formatDate(message.respondedAt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "message-actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "btn btn-secondary",
                                children: t('attorney.clientMessages.viewThread', 'View Thread')
                            }),
                            message.responseStatus === 'responded' && message.metadata?.originatedFromInternalRequest && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "btn btn-primary",
                                children: t('attorney.clientMessages.forwardToExternal', 'Forward to External Attorney')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $74a3a60f5db40811$export$2e2bcd8739ae039 = $74a3a60f5db40811$var$ClientMessages;






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * Contact Client Modal
 * Allows MarkoTM attorneys to compose a message to the client
 * based on an external attorney's internal request.
 */ function $d141440a72796cf9$var$ContactClientModal({ isOpen: isOpen, onClose: onClose, request: request }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const contactClient = (0, $8ef7a68274816bdb$export$dd61971fef3fb811)();
    const [formData, setFormData] = (0, $acw62.useState)({
        subject: '',
        body: '',
        urgency: 'medium',
        items: []
    });
    const [newItem, setNewItem] = (0, $acw62.useState)({
        type: 'text',
        label: '',
        required: true
    });
    // Pre-populate from request data
    (0, $acw62.useEffect)(()=>{
        if (request) setFormData({
            subject: request.title || '',
            body: request.message || '',
            urgency: request.urgency || 'medium',
            items: request.requestData?.items || []
        });
    }, [
        request
    ]);
    const handleChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const handleAddItem = ()=>{
        if (!newItem.label.trim()) return;
        setFormData((prev)=>({
                ...prev,
                items: [
                    ...prev.items,
                    {
                        ...newItem,
                        id: `item_${Date.now()}`
                    }
                ]
            }));
        setNewItem({
            type: 'text',
            label: '',
            required: true
        });
    };
    const handleRemoveItem = (index)=>{
        setFormData((prev)=>({
                ...prev,
                items: prev.items.filter((_, i)=>i !== index)
            }));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!formData.subject || !formData.body) {
            alert('Please fill in subject and message');
            return;
        }
        try {
            await contactClient.mutateAsync({
                requestId: request.id,
                messageData: {
                    subject: formData.subject,
                    body: formData.body,
                    urgency: formData.urgency,
                    items: formData.items
                }
            });
            onClose();
        } catch (error) {
            console.error('Error contacting client:', error);
            alert(`Error sending message: ${error.message}`);
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "modal-content contact-client-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.contactClient.title', 'Contact Client')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "modal-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "original-request-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    children: [
                                                        t('attorney.contactClient.originalRequest', 'Original Request From'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        request.metadata?.requestingAttorneyName,
                                                        request.metadata?.requestingFirmName && ` (${request.metadata.requestingFirmName})`
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    children: [
                                                        t('attorney.contactClient.application', 'Application'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: request.applicationId
                                                })
                                            ]
                                        }),
                                        request.metadata?.clientName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "info-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    children: [
                                                        t('attorney.contactClient.client', 'Client'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: request.metadata.clientName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            htmlFor: "subject",
                                            children: [
                                                t('attorney.contactClient.subject', 'Subject'),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            id: "subject",
                                            name: "subject",
                                            value: formData.subject,
                                            onChange: handleChange,
                                            placeholder: "Information needed for your trademark application",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            htmlFor: "body",
                                            children: [
                                                t('attorney.contactClient.message', 'Message to Client'),
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            id: "body",
                                            name: "body",
                                            value: formData.body,
                                            onChange: handleChange,
                                            rows: 6,
                                            placeholder: "Dear Client, we need the following information...",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "form-hint",
                                            children: t('attorney.contactClient.hint', 'This message will be sent to the client on behalf of MarkoTM. The external attorney will receive the response once the client replies.')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            htmlFor: "urgency",
                                            children: t('attorney.contactClient.urgency', 'Urgency')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            id: "urgency",
                                            name: "urgency",
                                            value: formData.urgency,
                                            onChange: handleChange,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "low",
                                                    children: t('attorney.urgency.low', 'Low')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "medium",
                                                    children: t('attorney.urgency.medium', 'Medium')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "high",
                                                    children: t('attorney.urgency.high', 'High')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "urgent",
                                                    children: t('attorney.urgency.urgent', 'Urgent')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: t('attorney.contactClient.requestItems', 'Request Items')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "form-hint",
                                            children: t('attorney.contactClient.itemsHint', 'Add specific items for the client to provide')
                                        }),
                                        formData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "items-list",
                                            children: formData.items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    className: "item-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "item-type",
                                                            children: [
                                                                "[",
                                                                item.type,
                                                                "]"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "item-label",
                                                            children: item.label
                                                        }),
                                                        item.required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "item-required",
                                                            children: "*"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "item-remove",
                                                            onClick: ()=>handleRemoveItem(index),
                                                            children: "\xd7"
                                                        })
                                                    ]
                                                }, index))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "add-item-form",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: newItem.type,
                                                    onChange: (e)=>setNewItem((prev)=>({
                                                                ...prev,
                                                                type: e.target.value
                                                            })),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "text",
                                                            children: t('attorney.itemType.text', 'Text Input')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "file_upload",
                                                            children: t('attorney.itemType.file', 'File Upload')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "date",
                                                            children: t('attorney.itemType.date', 'Date')
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "select",
                                                            children: t('attorney.itemType.select', 'Selection')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    value: newItem.label,
                                                    onChange: (e)=>setNewItem((prev)=>({
                                                                ...prev,
                                                                label: e.target.value
                                                            })),
                                                    placeholder: "Item label (e.g., 'Business address')"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "checkbox-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: newItem.required,
                                                            onChange: (e)=>setNewItem((prev)=>({
                                                                        ...prev,
                                                                        required: e.target.checked
                                                                    }))
                                                        }),
                                                        "Required"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    className: "btn btn-secondary",
                                                    onClick: handleAddItem,
                                                    children: "+ Add"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-secondary",
                                    onClick: onClose,
                                    children: t('common.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    disabled: contactClient.isPending,
                                    children: contactClient.isPending ? t('common.sending', 'Sending...') : t('attorney.contactClient.send', 'Send to Client')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $d141440a72796cf9$export$2e2bcd8739ae039 = $d141440a72796cf9$var$ContactClientModal;



/**
 * Internal Requests Queue
 * Shows pending requests from external attorneys that need MarkoTM action.
 * Only visible to MarkoTM attorneyadmins.
 */ function $7acd9994b5cfab93$var$InternalRequests() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { canProcessInternalRequests: canProcessInternalRequests, firmName: firmName } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [activeTab, setActiveTab] = (0, $acw62.useState)('pending');
    const [selectedRequest, setSelectedRequest] = (0, $acw62.useState)(null);
    const { data: requestsData, isLoading: isLoading } = (0, $8ef7a68274816bdb$export$f25d8437adfe58b9)(activeTab);
    const requests = requestsData?.requests || [];
    // Access check - only MarkoTM attorneyadmins can see this
    if (!canProcessInternalRequests) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "internal-requests-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "access-denied",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Access Restricted"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "Only MarkoTM administrators can process internal requests."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "internal-requests-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.internalRequests.title', 'Internal Requests')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "page-subtitle",
                        children: t('attorney.internalRequests.subtitle', 'Requests from external attorneys that need MarkoTM action')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "requests-tabs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `tab-btn ${activeTab === 'pending' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('pending'),
                        children: [
                            t('attorney.internalRequests.pending', 'Pending'),
                            requests.length > 0 && activeTab === 'pending' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tab-badge",
                                children: requests.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `tab-btn ${activeTab === 'processed' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('processed'),
                        children: t('attorney.internalRequests.processed', 'Processed')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `tab-btn ${activeTab === 'declined' ? 'active' : ''}`,
                        onClick: ()=>setActiveTab('declined'),
                        children: t('attorney.internalRequests.declined', 'Declined')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "requests-list",
                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "loading-state",
                    children: "Loading requests..."
                }) : requests.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "empty-state",
                    children: activeTab === 'pending' ? t('attorney.internalRequests.noPending', 'No pending requests from external attorneys') : activeTab === 'processed' ? t('attorney.internalRequests.noProcessed', 'No processed requests') : t('attorney.internalRequests.noDeclined', 'No declined requests')
                }) : requests.map((request)=>/*#__PURE__*/ (0, $ayMG0.jsx)($7acd9994b5cfab93$var$InternalRequestCard, {
                        request: request,
                        onContactClient: ()=>setSelectedRequest(request),
                        showActions: activeTab === 'pending'
                    }, request.id))
            }),
            selectedRequest && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d141440a72796cf9$export$2e2bcd8739ae039), {
                isOpen: !!selectedRequest,
                onClose: ()=>setSelectedRequest(null),
                request: selectedRequest
            })
        ]
    });
}
/**
 * Internal Request Card Component
 */ function $7acd9994b5cfab93$var$InternalRequestCard({ request: request, onContactClient: onContactClient, showActions: showActions }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const declineRequest = (0, $8ef7a68274816bdb$export$df77496e55efdd5)();
    const [declineReason, setDeclineReason] = (0, $acw62.useState)('');
    const [showDeclineForm, setShowDeclineForm] = (0, $acw62.useState)(false);
    const urgencyColors = {
        low: 'urgency-low',
        medium: 'urgency-medium',
        high: 'urgency-high',
        urgent: 'urgency-urgent'
    };
    const statusIcons = {
        pending: "\uD83D\uDCCB",
        client_contacted: "\uD83D\uDCE7",
        response_forwarded: "\u2705",
        declined: "\u274C"
    };
    const formatDate = (dateStr)=>{
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    const handleDecline = async ()=>{
        if (!declineReason.trim()) {
            alert('Please provide a reason for declining');
            return;
        }
        try {
            await declineRequest.mutateAsync({
                requestId: request.id,
                reason: declineReason
            });
            setShowDeclineForm(false);
            setDeclineReason('');
        } catch (error) {
            alert(`Error declining request: ${error.message}`);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `request-card ${expanded ? 'expanded' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "request-card-header",
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "request-status-icon",
                                children: statusIcons[request.status] || "\uD83D\uDCCB"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "request-meta",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "request-title",
                                        children: request.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "request-from",
                                        children: [
                                            "From: ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: request.metadata?.requestingAttorneyName || 'External Attorney'
                                            }),
                                            request.metadata?.requestingFirmName && ` (${request.metadata.requestingFirmName})`
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "request-application",
                                        children: [
                                            t('attorney.internalRequests.re', 'Re'),
                                            ": ",
                                            request.applicationId || 'Application',
                                            request.metadata?.clientName && ` - ${request.metadata.clientName}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-right",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `urgency-badge ${urgencyColors[request.urgency] || ''}`,
                                children: request.urgency
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "request-date",
                                children: formatDate(request.createdAt)
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "request-card-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.internalRequests.requestDetails', 'Request Details')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: request.message
                            })
                        ]
                    }),
                    request.requestData?.items && request.requestData.items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "request-items",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.internalRequests.requestedItems', 'Information Requested')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: request.requestData.items.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "item-type",
                                                children: [
                                                    "[",
                                                    item.type,
                                                    "]"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-label",
                                                children: item.label
                                            }),
                                            item.required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "item-required",
                                                children: "*"
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }),
                    request.status === 'declined' && request.declineReason && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "decline-reason",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: t('attorney.internalRequests.declineReason', 'Decline Reason')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: request.declineReason
                            })
                        ]
                    }),
                    showActions && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "request-actions",
                        children: !showDeclineForm ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn btn-primary",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        onContactClient();
                                    },
                                    children: t('attorney.internalRequests.contactClient', 'Contact Client')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn btn-secondary",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        setShowDeclineForm(true);
                                    },
                                    children: t('attorney.internalRequests.decline', 'Decline')
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "decline-form",
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    placeholder: "Reason for declining this request...",
                                    value: declineReason,
                                    onChange: (e)=>setDeclineReason(e.target.value),
                                    rows: 3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "decline-form-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "btn btn-secondary",
                                            onClick: ()=>{
                                                setShowDeclineForm(false);
                                                setDeclineReason('');
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "btn btn-danger",
                                            onClick: handleDecline,
                                            disabled: declineRequest.isPending,
                                            children: declineRequest.isPending ? 'Declining...' : 'Confirm Decline'
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    request.status === 'response_forwarded' && request.forwardedAt && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "forwarded-info",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "success-badge",
                            children: [
                                t('attorney.internalRequests.forwarded', 'Response forwarded on'),
                                " ",
                                formatDate(request.forwardedAt)
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $7acd9994b5cfab93$export$2e2bcd8739ae039 = $7acd9994b5cfab93$var$InternalRequests;







var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



async function $713cd3b02046eda9$export$eeecf79af3d1a26c(options = {}) {
    const params = new URLSearchParams();
    if (options.status) params.append('status', options.status);
    if (options.classification) params.append('classification', options.classification);
    if (options.applicationId) params.append('applicationId', options.applicationId);
    if (options.limit) params.append('limit', options.limit);
    const queryString = params.toString();
    const url = queryString ? `/correspondence?${queryString}` : '/correspondence';
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(url);
    return response.data;
}
async function $713cd3b02046eda9$export$5a71d6aea0ee4a2d(id) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/correspondence/${id}`);
    return response.data;
}
async function $713cd3b02046eda9$export$b41bbec70dfa1ef9(correspondenceId, applicationId) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/correspondence/${correspondenceId}/link`, {
        applicationId: applicationId
    });
    return response.data;
}
async function $713cd3b02046eda9$export$d9444e18fbd7f5ee(correspondenceId, notes) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).post(`/correspondence/${correspondenceId}/process`, {
        notes: notes
    });
    return response.data;
}
async function $713cd3b02046eda9$export$411ff3c08ea2858f(correspondenceId, matchData) {
    const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).patch(`/correspondence/${correspondenceId}`, {
        action: 'manual_match',
        ...matchData
    });
    return response.data;
}
var $713cd3b02046eda9$export$2e2bcd8739ae039 = {
    getCorrespondence: $713cd3b02046eda9$export$eeecf79af3d1a26c,
    getCorrespondenceItem: $713cd3b02046eda9$export$5a71d6aea0ee4a2d,
    linkCorrespondence: $713cd3b02046eda9$export$b41bbec70dfa1ef9,
    markProcessed: $713cd3b02046eda9$export$d9444e18fbd7f5ee,
    manualMatch: $713cd3b02046eda9$export$411ff3c08ea2858f
};


const $2862573dda58250c$export$916423cdf1274ee8 = [
    'attorney',
    'correspondence'
];
function $2862573dda58250c$export$d1475ac3e70e9497(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$2862573dda58250c$export$916423cdf1274ee8,
            options
        ],
        queryFn: ()=>(0, $713cd3b02046eda9$export$2e2bcd8739ae039).getCorrespondence(options),
        staleTime: 300000,
        refetchOnWindowFocus: true
    });
}
function $2862573dda58250c$export$f9b28882102bc961(id) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$2862573dda58250c$export$916423cdf1274ee8,
            id
        ],
        queryFn: ()=>(0, $713cd3b02046eda9$export$2e2bcd8739ae039).getCorrespondenceItem(id),
        enabled: !!id,
        staleTime: 300000
    });
}
function $2862573dda58250c$export$5747bc4016ba276a() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ correspondenceId: correspondenceId, applicationId: applicationId })=>(0, $713cd3b02046eda9$export$2e2bcd8739ae039).linkCorrespondence(correspondenceId, applicationId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $2862573dda58250c$export$916423cdf1274ee8
            });
        }
    });
}
function $2862573dda58250c$export$e8960581ee4df3d() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ correspondenceId: correspondenceId, notes: notes })=>(0, $713cd3b02046eda9$export$2e2bcd8739ae039).markProcessed(correspondenceId, notes),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $2862573dda58250c$export$916423cdf1274ee8
            });
        }
    });
}
function $2862573dda58250c$export$bb117e4dead9ae0() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ correspondenceId: correspondenceId, correct: correct, feedback: feedback })=>(0, $713cd3b02046eda9$export$2e2bcd8739ae039).manualMatch(correspondenceId, {
                correct: correct,
                feedback: feedback
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $2862573dda58250c$export$916423cdf1274ee8
            });
        }
    });
}
var $2862573dda58250c$export$2e2bcd8739ae039 = {
    useCorrespondence: $2862573dda58250c$export$d1475ac3e70e9497,
    useCorrespondenceItem: $2862573dda58250c$export$f9b28882102bc961,
    useLinkCorrespondence: $2862573dda58250c$export$5747bc4016ba276a,
    useMarkProcessed: $2862573dda58250c$export$e8960581ee4df3d,
    useManualMatch: $2862573dda58250c$export$bb117e4dead9ae0
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * ManualMatchModal Component
 * Modal for attorneys to manually match unmatched correspondence
 * Captures AI learning feedback for the Triage Agent
 */ function $0a00ee6f496c4aaf$var$ManualMatchModal({ correspondence: correspondence, onClose: onClose, onSubmit: onSubmit, isSubmitting: isSubmitting }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    // Form state - correct values
    const [applicationId, setApplicationId] = (0, $acw62.useState)(correspondence?.applicationId || '');
    const [classification, setClassification] = (0, $acw62.useState)(correspondence?.classification || 'general');
    const [subType, setSubType] = (0, $acw62.useState)(correspondence?.subType || '');
    const [jurisdiction, setJurisdiction] = (0, $acw62.useState)(correspondence?.jurisdiction || '');
    const [deadline, setDeadline] = (0, $acw62.useState)(correspondence?.deadline ? correspondence.deadline.split('T')[0] : '');
    const [ipOfficeRef, setIpOfficeRef] = (0, $acw62.useState)(correspondence?.ipOfficeRef || '');
    // Form state - feedback for AI learning
    const [failureCategory, setFailureCategory] = (0, $acw62.useState)('');
    const [infoLocations, setInfoLocations] = (0, $acw62.useState)([]);
    const [notes, setNotes] = (0, $acw62.useState)('');
    // Application search state
    const [applicationSearch, setApplicationSearch] = (0, $acw62.useState)('');
    const [searchResults, setSearchResults] = (0, $acw62.useState)([]);
    const [isSearching, setIsSearching] = (0, $acw62.useState)(false);
    const [selectedApplication, setSelectedApplication] = (0, $acw62.useState)(null);
    // Classification options
    const classificationOptions = [
        {
            value: 'office_action',
            label: t('attorney.correspondence.types.officeAction', 'Office Action')
        },
        {
            value: 'acceptance',
            label: t('attorney.correspondence.types.acceptance', 'Acceptance')
        },
        {
            value: 'opposition',
            label: t('attorney.correspondence.types.opposition', 'Opposition')
        },
        {
            value: 'renewal_notice',
            label: t('attorney.correspondence.types.renewal', 'Renewal Notice')
        },
        {
            value: 'registration',
            label: t('attorney.correspondence.types.registration', 'Registration')
        },
        {
            value: 'general',
            label: t('attorney.correspondence.types.general', 'General')
        }
    ];
    // Sub-type options based on classification
    const subTypeOptions = {
        office_action: [
            {
                value: 'descriptiveness',
                label: 'Descriptiveness'
            },
            {
                value: 'likelihood_of_confusion',
                label: 'Likelihood of Confusion'
            },
            {
                value: 'specimen_issues',
                label: 'Specimen Issues'
            },
            {
                value: 'goods_services',
                label: 'Goods/Services Classification'
            },
            {
                value: 'formality',
                label: 'Formality Issues'
            },
            {
                value: 'other',
                label: 'Other'
            }
        ],
        opposition: [
            {
                value: 'likelihood_of_confusion',
                label: 'Likelihood of Confusion'
            },
            {
                value: 'dilution',
                label: 'Dilution'
            },
            {
                value: 'bad_faith',
                label: 'Bad Faith'
            },
            {
                value: 'other',
                label: 'Other'
            }
        ]
    };
    // Jurisdiction options
    const jurisdictionOptions = [
        {
            value: 'AU',
            label: 'Australia'
        },
        {
            value: 'US',
            label: 'United States'
        },
        {
            value: 'EU',
            label: 'European Union'
        },
        {
            value: 'UK',
            label: 'United Kingdom'
        },
        {
            value: 'NZ',
            label: 'New Zealand'
        },
        {
            value: 'CA',
            label: 'Canada'
        },
        {
            value: 'SG',
            label: 'Singapore'
        }
    ];
    // Failure category options - why the AI failed to match
    const failureCategoryOptions = [
        {
            value: 'unusual_email_format',
            label: t('attorney.manualMatch.failures.unusualFormat', 'Unusual Email Format')
        },
        {
            value: 'new_ip_office',
            label: t('attorney.manualMatch.failures.newIpOffice', 'New IP Office Format')
        },
        {
            value: 'pdf_extraction_failed',
            label: t('attorney.manualMatch.failures.pdfFailed', 'PDF Extraction Failed')
        },
        {
            value: 'no_reference_found',
            label: t('attorney.manualMatch.failures.noReference', 'No Reference Found')
        },
        {
            value: 'ambiguous_reference',
            label: t('attorney.manualMatch.failures.ambiguous', 'Ambiguous Reference')
        },
        {
            value: 'reference_in_attachment',
            label: t('attorney.manualMatch.failures.inAttachment', 'Reference in Attachment Only')
        },
        {
            value: 'new_sender',
            label: t('attorney.manualMatch.failures.newSender', 'New Sender/Domain')
        },
        {
            value: 'other',
            label: t('attorney.manualMatch.failures.other', 'Other')
        }
    ];
    // Info location options - where the correct information was found
    const infoLocationOptions = [
        {
            value: 'subject_line',
            label: t('attorney.manualMatch.locations.subjectLine', 'Subject Line')
        },
        {
            value: 'email_body',
            label: t('attorney.manualMatch.locations.emailBody', 'Email Body')
        },
        {
            value: 'pdf_attachment',
            label: t('attorney.manualMatch.locations.pdfAttachment', 'PDF Attachment')
        },
        {
            value: 'image_attachment',
            label: t('attorney.manualMatch.locations.imageAttachment', 'Image Attachment')
        },
        {
            value: 'sender_domain',
            label: t('attorney.manualMatch.locations.senderDomain', 'Sender Domain')
        }
    ];
    // Search for applications
    (0, $acw62.useEffect)(()=>{
        const searchApplications = async ()=>{
            if (applicationSearch.length < 3) {
                setSearchResults([]);
                return;
            }
            setIsSearching(true);
            try {
                const response = await (0, $78f4fc768f4bd121$export$407ca81eb46778dd).get(`/applications?search=${encodeURIComponent(applicationSearch)}&limit=10`);
                setSearchResults(response.data?.applications || response.data || []);
            } catch (error) {
                console.error('Error searching applications:', error);
                setSearchResults([]);
            } finally{
                setIsSearching(false);
            }
        };
        const debounce = setTimeout(searchApplications, 300);
        return ()=>clearTimeout(debounce);
    }, [
        applicationSearch
    ]);
    // Handle application selection
    const handleSelectApplication = (app)=>{
        setSelectedApplication(app);
        setApplicationId(app.applicationId || app.id);
        setSearchResults([]);
        setApplicationSearch('');
    };
    // Handle info location toggle
    const handleInfoLocationToggle = (location)=>{
        setInfoLocations((prev)=>prev.includes(location) ? prev.filter((l)=>l !== location) : [
                ...prev,
                location
            ]);
    };
    // Handle form submission
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!applicationId) {
            alert(t('attorney.manualMatch.errors.applicationRequired', 'Please select an application'));
            return;
        }
        const matchData = {
            correct: {
                applicationId: applicationId,
                userId: selectedApplication?.userId,
                classification: classification,
                subType: subType || undefined,
                jurisdiction: jurisdiction || undefined,
                deadline: deadline ? new Date(deadline).toISOString() : undefined,
                ipOfficeRef: ipOfficeRef || undefined
            },
            feedback: {
                failureCategory: failureCategory || undefined,
                infoLocations: infoLocations.length > 0 ? infoLocations : undefined,
                notes: notes || undefined
            }
        };
        onSubmit(matchData);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "manual-match-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.manualMatch.title', 'Manual Match')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "modal-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-section email-summary",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "summary-item",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "summary-label",
                                            children: [
                                                t('attorney.correspondence.from', 'From'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "summary-value",
                                            children: correspondence?.from
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "summary-item",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "summary-label",
                                            children: [
                                                t('attorney.correspondence.subject', 'Subject'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "summary-value",
                                            children: correspondence?.subject
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: t('attorney.manualMatch.selectApplication', 'Select Application')
                                }),
                                selectedApplication ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "selected-application",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "selected-app-info",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "app-id",
                                                    children: selectedApplication.applicationId || selectedApplication.id
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "app-name",
                                                    children: selectedApplication.trademarkName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "btn-change",
                                            onClick: ()=>{
                                                setSelectedApplication(null);
                                                setApplicationId('');
                                            },
                                            children: t('attorney.manualMatch.change', 'Change')
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "search-input",
                                            placeholder: t('attorney.manualMatch.searchPlaceholder', 'Search by application ID or trademark name...'),
                                            value: applicationSearch,
                                            onChange: (e)=>setApplicationSearch(e.target.value)
                                        }),
                                        isSearching && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "search-loading",
                                            children: t('attorney.manualMatch.searching', 'Searching...')
                                        }),
                                        searchResults.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "search-results",
                                            children: searchResults.map((app)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "search-result-item",
                                                    onClick: ()=>handleSelectApplication(app),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "result-id",
                                                            children: app.applicationId || app.id
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "result-name",
                                                            children: app.trademarkName
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "result-client",
                                                            children: app.clientName || app.ownerName
                                                        })
                                                    ]
                                                }, app.id))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "manual-id-entry",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "or-divider",
                                                    children: t('attorney.manualMatch.or', 'or enter manually')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    className: "form-input",
                                                    placeholder: "MTM-2025-00123",
                                                    value: applicationId,
                                                    onChange: (e)=>setApplicationId(e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: t('attorney.manualMatch.classificationDetails', 'Classification & Details')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.manualMatch.classification', 'Classification')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                    value: classification,
                                                    onChange: (e)=>{
                                                        setClassification(e.target.value);
                                                        setSubType(''); // Reset sub-type when classification changes
                                                    },
                                                    className: "form-select",
                                                    children: classificationOptions.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: opt.value,
                                                            children: opt.label
                                                        }, opt.value))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.manualMatch.subType', 'Sub-Type')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: subType,
                                                    onChange: (e)=>setSubType(e.target.value),
                                                    className: "form-select",
                                                    disabled: !subTypeOptions[classification],
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "",
                                                            children: subTypeOptions[classification] ? t('attorney.manualMatch.selectSubType', 'Select sub-type...') : t('attorney.manualMatch.notApplicable', 'N/A')
                                                        }),
                                                        (subTypeOptions[classification] || []).map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: opt.value,
                                                                children: opt.label
                                                            }, opt.value))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.manualMatch.jurisdiction', 'Jurisdiction')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: jurisdiction,
                                                    onChange: (e)=>setJurisdiction(e.target.value),
                                                    className: "form-select",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "",
                                                            children: t('attorney.manualMatch.selectJurisdiction', 'Select jurisdiction...')
                                                        }),
                                                        jurisdictionOptions.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: opt.value,
                                                                children: opt.label
                                                            }, opt.value))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.manualMatch.deadline', 'Deadline')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "date",
                                                    value: deadline,
                                                    onChange: (e)=>setDeadline(e.target.value),
                                                    className: "form-input"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group full-width",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.manualMatch.ipOfficeRef', 'IP Office Reference')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    value: ipOfficeRef,
                                                    onChange: (e)=>setIpOfficeRef(e.target.value),
                                                    className: "form-input",
                                                    placeholder: t('attorney.manualMatch.ipOfficeRefPlaceholder', 'e.g., TM2025/12345')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-section learning-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: t('attorney.manualMatch.aiLearning', 'AI Learning Feedback')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "section-description",
                                    children: t('attorney.manualMatch.aiLearningDesc', 'Help the AI learn from this correction to improve future matching.')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.manualMatch.whyFailed', 'Why did automatic matching fail?')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: failureCategory,
                                            onChange: (e)=>setFailureCategory(e.target.value),
                                            className: "form-select",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: t('attorney.manualMatch.selectFailure', 'Select a reason...')
                                                }),
                                                failureCategoryOptions.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: opt.value,
                                                        children: opt.label
                                                    }, opt.value))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.manualMatch.whereFound', 'Where did you find the correct information?')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "checkbox-group",
                                            children: infoLocationOptions.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "checkbox-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: infoLocations.includes(opt.value),
                                                            onChange: ()=>handleInfoLocationToggle(opt.value)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: opt.label
                                                        })
                                                    ]
                                                }, opt.value))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.manualMatch.notes', 'Notes (optional)')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            value: notes,
                                            onChange: (e)=>setNotes(e.target.value),
                                            className: "form-textarea",
                                            placeholder: t('attorney.manualMatch.notesPlaceholder', 'Any additional context that might help the AI...'),
                                            rows: 3
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "btn-cancel",
                                    onClick: onClose,
                                    children: t('attorney.manualMatch.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "btn-submit",
                                    disabled: isSubmitting || !applicationId,
                                    children: isSubmitting ? t('attorney.manualMatch.saving', 'Saving...') : t('attorney.manualMatch.saveMatch', 'Save Match')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $0a00ee6f496c4aaf$export$2e2bcd8739ae039 = $0a00ee6f496c4aaf$var$ManualMatchModal;



/**
 * Correspondence Component
 * Shows all incoming IP Office correspondence
 * Supports ?id={correspondenceId} URL param to auto-open a specific item
 */ function $1298f71ea7b8a407$var$Correspondence() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const [filter, setFilter] = (0, $acw62.useState)('all');
    const [selectedItem, setSelectedItem] = (0, $acw62.useState)(null);
    const [highlightedId, setHighlightedId] = (0, $acw62.useState)(null);
    const highlightedRef = (0, $acw62.useRef)(null);
    const initialLoadDone = (0, $acw62.useRef)(false);
    // Read URL params on mount
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        if (id) {
            setHighlightedId(id);
            setFilter('all'); // Show all to ensure we can find it
        }
    }, []);
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $2862573dda58250c$export$d1475ac3e70e9497)({
        status: filter === 'all' ? undefined : filter
    });
    const markProcessedMutation = (0, $2862573dda58250c$export$e8960581ee4df3d)();
    const manualMatchMutation = (0, $2862573dda58250c$export$bb117e4dead9ae0)();
    const [showManualMatch, setShowManualMatch] = (0, $acw62.useState)(false);
    const correspondence = data?.correspondence || data || [];
    // Auto-open and scroll to highlighted item when data loads
    (0, $acw62.useEffect)(()=>{
        if (highlightedId && correspondence.length > 0 && !initialLoadDone.current) {
            const item = correspondence.find((c)=>c.id === highlightedId);
            if (item) {
                setSelectedItem(item);
                initialLoadDone.current = true;
            }
            // Scroll to highlighted card
            if (highlightedRef.current) highlightedRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [
        highlightedId,
        correspondence
    ]);
    const handleMarkProcessed = async (id, notes)=>{
        try {
            await markProcessedMutation.mutateAsync({
                correspondenceId: id,
                notes: notes
            });
            setSelectedItem(null);
        } catch (err) {
            console.error('Failed to mark as processed:', err);
        }
    };
    const handleManualMatch = async (matchData)=>{
        if (!selectedItem) return;
        try {
            await manualMatchMutation.mutateAsync({
                correspondenceId: selectedItem.id,
                ...matchData
            });
            setShowManualMatch(false);
            setSelectedItem(null);
        } catch (err) {
            console.error('Failed to manual match:', err);
            alert(t('attorney.manualMatch.errors.saveFailed', 'Failed to save manual match. Please try again.'));
        }
    };
    const getClassificationIcon = (classification)=>{
        switch(classification){
            case 'office_action':
                return "\u26A0\uFE0F";
            case 'acceptance':
                return "\u2705";
            case 'opposition':
                return "\u2694\uFE0F";
            case 'renewal_notice':
                return "\uD83D\uDD04";
            case 'registration':
                return "\uD83C\uDF89";
            default:
                return "\uD83D\uDCE7";
        }
    };
    const getClassificationLabel = (classification)=>{
        switch(classification){
            case 'office_action':
                return t('attorney.correspondence.types.officeAction', 'Office Action');
            case 'acceptance':
                return t('attorney.correspondence.types.acceptance', 'Acceptance');
            case 'opposition':
                return t('attorney.correspondence.types.opposition', 'Opposition');
            case 'renewal_notice':
                return t('attorney.correspondence.types.renewal', 'Renewal Notice');
            case 'registration':
                return t('attorney.correspondence.types.registration', 'Registration');
            default:
                return t('attorney.correspondence.types.general', 'General');
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "correspondence-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.correspondence.loading', 'Loading correspondence...')
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "correspondence-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.correspondence.error', 'Failed to load correspondence')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                children: t('attorney.correspondence.retry', 'Retry')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "correspondence-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "correspondence-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.correspondence.title', 'Correspondence')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "correspondence-controls",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: filter,
                                onChange: (e)=>setFilter(e.target.value),
                                className: "filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.correspondence.filter.all', 'All')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "unprocessed",
                                        children: t('attorney.correspondence.filter.unprocessed', 'Unprocessed')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "needs_manual_matching",
                                        children: t('attorney.correspondence.filter.needsMatching', 'Needs Matching')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "processed",
                                        children: t('attorney.correspondence.filter.processed', 'Processed')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>refetch(),
                                className: "refresh-btn",
                                children: t('attorney.correspondence.refresh', 'Refresh')
                            })
                        ]
                    })
                ]
            }),
            correspondence.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "correspondence-empty",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "empty-icon",
                        children: "\uD83D\uDCED"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: t('attorney.correspondence.empty', 'No correspondence found')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "empty-hint",
                        children: t('attorney.correspondence.emptyHint', 'Correspondence will appear here when emails are synced from the docketing mailbox.')
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "correspondence-list",
                children: correspondence.map((item)=>{
                    const isHighlighted = item.id === highlightedId;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: isHighlighted ? highlightedRef : null,
                        className: `correspondence-card ${item.status === 'processed' ? 'processed' : ''} ${isHighlighted ? 'highlighted' : ''}`,
                        onClick: ()=>setSelectedItem(item),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "correspondence-icon",
                                children: getClassificationIcon(item.classification)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "correspondence-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "correspondence-row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "correspondence-subject",
                                                children: item.subject || 'No Subject'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "correspondence-date",
                                                children: formatDate(item.receivedAt)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "correspondence-row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "correspondence-from",
                                                children: item.from
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `correspondence-classification ${item.classification}`,
                                                children: getClassificationLabel(item.classification)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "correspondence-row",
                                        children: [
                                            item.applicationId ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "correspondence-linked",
                                                children: [
                                                    "Linked: ",
                                                    item.applicationId
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "correspondence-unlinked",
                                                children: t('attorney.correspondence.notLinked', 'Not linked to application')
                                            }),
                                            item.jurisdiction && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "correspondence-jurisdiction",
                                                children: item.jurisdiction
                                            })
                                        ]
                                    }),
                                    item.summary && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "correspondence-summary",
                                        children: item.summary
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "correspondence-status",
                                children: item.status === 'processed' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "status-badge processed",
                                    children: "Processed"
                                }) : item.status === 'needs_manual_matching' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "status-badge needs-matching",
                                    children: "Needs Matching"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "status-badge unprocessed",
                                    children: "Unprocessed"
                                })
                            })
                        ]
                    }, item.id);
                })
            }),
            selectedItem && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setSelectedItem(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: selectedItem.subject || 'No Subject'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "modal-close",
                                    onClick: ()=>setSelectedItem(null),
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-meta",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "meta-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "meta-label",
                                            children: [
                                                t('attorney.correspondence.from', 'From'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "meta-value",
                                            children: selectedItem.from
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "meta-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "meta-label",
                                            children: [
                                                t('attorney.correspondence.received', 'Received'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "meta-value",
                                            children: formatDate(selectedItem.receivedAt)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "meta-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "meta-label",
                                            children: [
                                                t('attorney.correspondence.classification', 'Classification'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "meta-value",
                                            children: getClassificationLabel(selectedItem.classification)
                                        })
                                    ]
                                }),
                                selectedItem.jurisdiction && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "meta-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "meta-label",
                                            children: [
                                                t('attorney.correspondence.jurisdiction', 'Jurisdiction'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "meta-value",
                                            children: selectedItem.jurisdiction
                                        })
                                    ]
                                }),
                                selectedItem.applicationId && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "meta-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "meta-label",
                                            children: [
                                                t('attorney.correspondence.application', 'Application'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "meta-value",
                                            children: selectedItem.applicationId
                                        })
                                    ]
                                })
                            ]
                        }),
                        selectedItem.summary && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: t('attorney.correspondence.summary', 'Summary')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: selectedItem.summary
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: t('attorney.correspondence.body', 'Email Body')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "email-body",
                                    children: selectedItem.bodyText || 'No content available'
                                })
                            ]
                        }),
                        selectedItem.status !== 'processed' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                !selectedItem.applicationId && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-link",
                                    onClick: ()=>setShowManualMatch(true),
                                    children: t('attorney.correspondence.manualMatch', 'Manual Match')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-process",
                                    onClick: ()=>handleMarkProcessed(selectedItem.id, ''),
                                    disabled: markProcessedMutation.isPending,
                                    children: markProcessedMutation.isPending ? t('attorney.correspondence.processing', 'Processing...') : t('attorney.correspondence.markProcessed', 'Mark as Processed')
                                })
                            ]
                        })
                    ]
                })
            }),
            showManualMatch && selectedItem && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a00ee6f496c4aaf$export$2e2bcd8739ae039), {
                correspondence: selectedItem,
                onClose: ()=>setShowManualMatch(false),
                onSubmit: handleManualMatch,
                isSubmitting: manualMatchMutation.isPending
            })
        ]
    });
}
var $1298f71ea7b8a407$export$2e2bcd8739ae039 = $1298f71ea7b8a407$var$Correspondence;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $33b799b450350680$export$2beb7dd4279faaf7 = [
    'attorney',
    'deadlines'
];
function $33b799b450350680$export$5853c040e2913a96(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$33b799b450350680$export$2beb7dd4279faaf7,
            options
        ],
        queryFn: ()=>(0, $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039).getDeadlines(options),
        staleTime: 300000,
        refetchOnWindowFocus: true
    });
}
function $33b799b450350680$export$d7799cb127e7a969(deadlineId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$33b799b450350680$export$2beb7dd4279faaf7,
            deadlineId
        ],
        queryFn: ()=>(0, $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039).getDeadline(deadlineId),
        enabled: !!deadlineId,
        staleTime: 300000
    });
}
function $33b799b450350680$export$da2ecf998738219b() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ deadlineId: deadlineId, data: data })=>(0, $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039).completeDeadline(deadlineId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $33b799b450350680$export$2beb7dd4279faaf7
            });
        }
    });
}
function $33b799b450350680$export$f09abd9bf9400c64() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ deadlineId: deadlineId, data: data })=>(0, $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039).updateDeadline(deadlineId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $33b799b450350680$export$2beb7dd4279faaf7
            });
        }
    });
}
function $33b799b450350680$export$ec44b94078c9ae21() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (data)=>(0, $3fe75b1e3c7ea1b3$export$2e2bcd8739ae039).createDeadline(data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $33b799b450350680$export$2beb7dd4279faaf7
            });
        }
    });
}
var $33b799b450350680$export$2e2bcd8739ae039 = {
    useDeadlines: $33b799b450350680$export$5853c040e2913a96,
    useDeadline: $33b799b450350680$export$d7799cb127e7a969,
    useCompleteDeadline: $33b799b450350680$export$da2ecf998738219b,
    useUpdateDeadline: $33b799b450350680$export$f09abd9bf9400c64,
    useCreateDeadline: $33b799b450350680$export$ec44b94078c9ae21
};




/**
 * Deadlines Component
 * Shows all upcoming deadlines for attorney review
 * Supports ?id={deadlineId} URL param to highlight a specific deadline
 */ function $bac860ebd05cf0d2$var$Deadlines() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { isAdmin: isAdmin, isInternal: isInternal, isAttorneyAdmin: isAttorneyAdmin } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [daysAhead, setDaysAhead] = (0, $acw62.useState)(30);
    const [assignmentFilter, setAssignmentFilter] = (0, $acw62.useState)('all');
    const [selectedDeadline, setSelectedDeadline] = (0, $acw62.useState)(null);
    const [completionNotes, setCompletionNotes] = (0, $acw62.useState)('');
    const [editingDeadline, setEditingDeadline] = (0, $acw62.useState)(null);
    const [editDate, setEditDate] = (0, $acw62.useState)('');
    const [highlightedId, setHighlightedId] = (0, $acw62.useState)(null);
    const highlightedRef = (0, $acw62.useRef)(null);
    // Read URL params on mount
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        if (id) {
            setHighlightedId(id);
            setDaysAhead(365); // Show all deadlines to ensure we can find it
        }
    }, []);
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $33b799b450350680$export$5853c040e2913a96)({
        daysAhead: daysAhead,
        assignmentFilter: assignmentFilter
    });
    const completeDeadlineMutation = (0, $33b799b450350680$export$da2ecf998738219b)();
    const updateDeadlineMutation = (0, $33b799b450350680$export$f09abd9bf9400c64)();
    // Extract data early so we can use it in useEffect
    const { deadlines: deadlines = [], stats: stats = {} } = data || {};
    // Scroll to highlighted deadline when data loads
    (0, $acw62.useEffect)(()=>{
        if (highlightedId && deadlines.length > 0 && highlightedRef.current) highlightedRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, [
        highlightedId,
        deadlines.length
    ]); // Use .length to avoid re-running on every render
    const handleComplete = async (deadlineId)=>{
        try {
            await completeDeadlineMutation.mutateAsync({
                deadlineId: deadlineId,
                data: {
                    notes: completionNotes
                }
            });
            setSelectedDeadline(null);
            setCompletionNotes('');
        } catch (err) {
            console.error('Failed to complete deadline:', err);
        }
    };
    const handleEditClick = (deadline)=>{
        // Format the date for the input (YYYY-MM-DD)
        const date = new Date(deadline.dueDate);
        const formattedDate = date.toISOString().split('T')[0];
        setEditDate(formattedDate);
        setEditingDeadline(deadline);
    };
    const handleSaveDate = async ()=>{
        if (editingDeadline && editDate) try {
            await updateDeadlineMutation.mutateAsync({
                deadlineId: editingDeadline.id,
                data: {
                    dueDate: new Date(editDate).toISOString()
                }
            });
            setEditingDeadline(null);
            setEditDate('');
        } catch (err) {
            console.error('Failed to update deadline:', err);
        }
    };
    const getUrgencyClass = (urgency)=>{
        switch(urgency){
            case 'overdue':
                return 'urgency-overdue';
            case 'critical':
                return 'urgency-critical';
            case 'high':
                return 'urgency-high';
            case 'medium':
                return 'urgency-medium';
            default:
                return 'urgency-low';
        }
    };
    const getUrgencyLabel = (urgency)=>{
        switch(urgency){
            case 'overdue':
                return t('attorney.deadlines.urgency.overdue', 'OVERDUE');
            case 'critical':
                return t('attorney.deadlines.urgency.critical', 'Critical');
            case 'high':
                return t('attorney.deadlines.urgency.high', 'High');
            case 'medium':
                return t('attorney.deadlines.urgency.medium', 'Medium');
            default:
                return t('attorney.deadlines.urgency.low', 'Low');
        }
    };
    const formatDate = (dateString)=>{
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const getDaysRemaining = (dueDate)=>{
        const now = new Date();
        const due = new Date(dueDate);
        const days = Math.ceil((due - now) / 86400000);
        if (days < 0) return `${Math.abs(days)} days overdue`;
        if (days === 0) return 'Due today';
        if (days === 1) return '1 day remaining';
        return `${days} days remaining`;
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "deadlines-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.deadlines.loading', 'Loading deadlines...')
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "deadlines-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.deadlines.error', 'Failed to load deadlines')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                children: t('attorney.deadlines.retry', 'Retry')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "deadlines-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "deadlines-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.deadlines.title', 'Deadlines')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "deadlines-controls",
                        children: [
                            isInternal && /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: assignmentFilter,
                                onChange: (e)=>setAssignmentFilter(e.target.value),
                                className: "assignment-filter-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "all",
                                        children: t('attorney.deadlines.allAssignments', 'All Assignments')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "mine",
                                        children: t('attorney.deadlines.assignedToMe', 'Assigned to Me')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "my_firm",
                                        children: t('attorney.deadlines.myFirm', 'My Firm')
                                    }),
                                    isAttorneyAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "transferred",
                                        children: t('attorney.deadlines.transferred', 'Transferred to External')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: daysAhead,
                                onChange: (e)=>setDaysAhead(Number(e.target.value)),
                                className: "days-ahead-select",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 7,
                                        children: t('attorney.deadlines.next7days', 'Next 7 days')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 14,
                                        children: t('attorney.deadlines.next14days', 'Next 14 days')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 30,
                                        children: t('attorney.deadlines.next30days', 'Next 30 days')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 60,
                                        children: t('attorney.deadlines.next60days', 'Next 60 days')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 90,
                                        children: t('attorney.deadlines.next90days', 'Next 90 days')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 365,
                                        children: t('attorney.deadlines.next365days', 'Next 365 days')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 9999,
                                        children: t('attorney.deadlines.all', 'All deadlines')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>refetch(),
                                className: "refresh-btn",
                                children: t('attorney.deadlines.refresh', 'Refresh')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "deadlines-stats",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card stat-overdue",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.overdue || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.deadlines.stats.overdue', 'Overdue')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card stat-critical",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.critical || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.deadlines.stats.critical', 'Critical')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card stat-high",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.high || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.deadlines.stats.high', 'High')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stat-card stat-total",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-value",
                                children: stats.total || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "stat-label",
                                children: t('attorney.deadlines.stats.total', 'Total')
                            })
                        ]
                    })
                ]
            }),
            deadlines.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "deadlines-empty",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: t('attorney.deadlines.empty', 'No upcoming deadlines')
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "deadlines-list",
                children: deadlines.map((deadline)=>{
                    const isHighlighted = deadline.id === highlightedId;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: isHighlighted ? highlightedRef : null,
                        className: `deadline-card ${getUrgencyClass(deadline.urgency)} ${isHighlighted ? 'deadline-highlighted' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "deadline-urgency-badge",
                                children: getUrgencyLabel(deadline.urgency)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "deadline-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "deadline-header",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "deadline-title",
                                                children: deadline.title
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "deadline-type",
                                                children: deadline.type
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "deadline-details",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "deadline-date",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "deadline-due-date",
                                                        children: formatDate(deadline.dueDate)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "deadline-remaining",
                                                        children: getDaysRemaining(deadline.dueDate)
                                                    })
                                                ]
                                            }),
                                            deadline.jurisdiction && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "deadline-jurisdiction",
                                                children: deadline.jurisdiction
                                            }),
                                            deadline.assignment?.isTransferred && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "deadline-assignment transferred",
                                                children: deadline.assignment.orgName || 'External Firm'
                                            })
                                        ]
                                    }),
                                    deadline.description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "deadline-description",
                                        children: deadline.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "deadline-actions",
                                children: [
                                    deadline.applicationId && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-view",
                                        onClick: ()=>window.open(`/attorney/filing-queue?app=${deadline.applicationId}`, '_blank'),
                                        children: t('attorney.deadlines.viewApplication', 'View Application')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-edit",
                                        onClick: ()=>handleEditClick(deadline),
                                        children: t('attorney.deadlines.editDate', 'Edit Date')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-complete",
                                        onClick: ()=>setSelectedDeadline(deadline),
                                        children: t('attorney.deadlines.markComplete', 'Mark Complete')
                                    })
                                ]
                            })
                        ]
                    }, deadline.id);
                })
            }),
            selectedDeadline && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setSelectedDeadline(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.deadlines.completeTitle', 'Complete Deadline')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "modal-deadline-title",
                            children: selectedDeadline.title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: t('attorney.deadlines.completionNotes', 'Completion Notes')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: completionNotes,
                                    onChange: (e)=>setCompletionNotes(e.target.value),
                                    placeholder: t('attorney.deadlines.notesPlaceholder', 'Add any notes about how this deadline was handled...'),
                                    rows: 4
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setSelectedDeadline(null),
                                    children: t('attorney.deadlines.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-confirm",
                                    onClick: ()=>handleComplete(selectedDeadline.id),
                                    disabled: completeDeadlineMutation.isPending,
                                    children: completeDeadlineMutation.isPending ? t('attorney.deadlines.completing', 'Completing...') : t('attorney.deadlines.confirm', 'Confirm Complete')
                                })
                            ]
                        })
                    ]
                })
            }),
            editingDeadline && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setEditingDeadline(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.deadlines.editDateTitle', 'Edit Deadline Date')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "modal-deadline-title",
                            children: editingDeadline.title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "edit-date-warning",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "warning-icon",
                                    children: "\u26A0\uFE0F"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: t('attorney.deadlines.editWarning', 'This deadline was automatically generated. Please verify the correct due date with the official correspondence before saving.')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: t('attorney.deadlines.newDueDate', 'New Due Date')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "date",
                                    value: editDate,
                                    onChange: (e)=>setEditDate(e.target.value),
                                    className: "date-input"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setEditingDeadline(null),
                                    children: t('attorney.deadlines.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-confirm",
                                    onClick: handleSaveDate,
                                    disabled: !editDate || updateDeadlineMutation.isPending,
                                    children: updateDeadlineMutation.isPending ? t('attorney.deadlines.saving', 'Saving...') : t('attorney.deadlines.saveDate', 'Save Date')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $bac860ebd05cf0d2$export$2e2bcd8739ae039 = $bac860ebd05cf0d2$var$Deadlines;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $7dfe2c1f25ac3803$export$3addece91dd05ff4 = [
    'jurisdictions'
];
function $7dfe2c1f25ac3803$export$aa429abf4550cb71(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$7dfe2c1f25ac3803$export$3addece91dd05ff4,
            options
        ],
        queryFn: ()=>(0, $84b306191205d4ef$export$2e2bcd8739ae039).getJurisdictions(options),
        staleTime: 1800000,
        cacheTime: 3600000 // 1 hour
    });
}
function $7dfe2c1f25ac3803$export$4329dee5c174f13c(code) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$7dfe2c1f25ac3803$export$3addece91dd05ff4,
            code
        ],
        queryFn: ()=>(0, $84b306191205d4ef$export$2e2bcd8739ae039).getJurisdiction(code),
        enabled: !!code,
        staleTime: 1800000
    });
}
function $7dfe2c1f25ac3803$export$2abd2363e38f8a5f() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (data)=>(0, $84b306191205d4ef$export$2e2bcd8739ae039).createJurisdiction(data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $7dfe2c1f25ac3803$export$3addece91dd05ff4
            });
        }
    });
}
function $7dfe2c1f25ac3803$export$726b31d1fc131a52() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ code: code, data: data })=>(0, $84b306191205d4ef$export$2e2bcd8739ae039).updateJurisdiction(code, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $7dfe2c1f25ac3803$export$3addece91dd05ff4
            });
        }
    });
}
function $7dfe2c1f25ac3803$export$d11f0cb0e9b4d3aa() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (code)=>(0, $84b306191205d4ef$export$2e2bcd8739ae039).deleteJurisdiction(code),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $7dfe2c1f25ac3803$export$3addece91dd05ff4
            });
        }
    });
}
var $7dfe2c1f25ac3803$export$2e2bcd8739ae039 = {
    useJurisdictions: $7dfe2c1f25ac3803$export$aa429abf4550cb71,
    useJurisdiction: $7dfe2c1f25ac3803$export$4329dee5c174f13c,
    useCreateJurisdiction: $7dfe2c1f25ac3803$export$2abd2363e38f8a5f,
    useUpdateJurisdiction: $7dfe2c1f25ac3803$export$726b31d1fc131a52,
    useDeleteJurisdiction: $7dfe2c1f25ac3803$export$d11f0cb0e9b4d3aa
};




/**
 * Jurisdictions Component
 * Admin view for managing IP Office jurisdiction data
 */ function $0ea39fadcc63652e$var$Jurisdictions() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { isAdmin: isAdmin } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [selectedJurisdiction, setSelectedJurisdiction] = (0, $acw62.useState)(null);
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $7dfe2c1f25ac3803$export$aa429abf4550cb71)();
    const createMutation = (0, $7dfe2c1f25ac3803$export$2abd2363e38f8a5f)();
    const updateMutation = (0, $7dfe2c1f25ac3803$export$726b31d1fc131a52)();
    const jurisdictions = data?.jurisdictions || data || [];
    const handleEdit = (jurisdiction)=>{
        setSelectedJurisdiction(jurisdiction);
        setIsEditing(true);
    };
    const handleSave = async (formData)=>{
        try {
            if (selectedJurisdiction?.id) await updateMutation.mutateAsync({
                code: selectedJurisdiction.code,
                data: formData
            });
            else await createMutation.mutateAsync(formData);
            setIsEditing(false);
            setSelectedJurisdiction(null);
        } catch (err) {
            console.error('Failed to save jurisdiction:', err);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "jurisdictions-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.jurisdictions.loading', 'Loading jurisdictions...')
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "jurisdictions-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.jurisdictions.error', 'Failed to load jurisdictions')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                children: t('attorney.jurisdictions.retry', 'Retry')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "jurisdictions-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdictions-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('attorney.jurisdictions.title', 'Jurisdictions')
                    }),
                    isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn-add",
                        onClick: ()=>{
                            setSelectedJurisdiction(null);
                            setIsEditing(true);
                        },
                        children: t('attorney.jurisdictions.addNew', 'Add Jurisdiction')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "jurisdictions-description",
                children: t('attorney.jurisdictions.description', 'Manage IP Office information and filing portals for each jurisdiction.')
            }),
            jurisdictions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdictions-empty",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: t('attorney.jurisdictions.empty', 'No jurisdictions configured')
                    }),
                    isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn-seed",
                        onClick: async ()=>{
                            try {
                                await fetch('/api/jurisdictions/seed', {
                                    method: 'POST'
                                });
                                refetch();
                            } catch (err) {
                                console.error('Failed to seed jurisdictions:', err);
                            }
                        },
                        children: t('attorney.jurisdictions.seedData', 'Load Default Jurisdictions')
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "jurisdictions-grid",
                children: jurisdictions.map((jurisdiction)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0ea39fadcc63652e$var$JurisdictionCard, {
                        jurisdiction: jurisdiction,
                        onEdit: ()=>handleEdit(jurisdiction),
                        isAdmin: isAdmin
                    }, jurisdiction.id))
            }),
            isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)($0ea39fadcc63652e$var$JurisdictionModal, {
                jurisdiction: selectedJurisdiction,
                onSave: handleSave,
                onClose: ()=>{
                    setIsEditing(false);
                    setSelectedJurisdiction(null);
                },
                isLoading: createMutation.isPending || updateMutation.isPending
            })
        ]
    });
}
function $0ea39fadcc63652e$var$JurisdictionCard({ jurisdiction: jurisdiction, onEdit: onEdit, isAdmin: isAdmin }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "jurisdiction-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdiction-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "jurisdiction-flag",
                        children: $0ea39fadcc63652e$var$getFlagEmoji(jurisdiction.code)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "jurisdiction-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "jurisdiction-name",
                                children: jurisdiction.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "jurisdiction-code",
                                children: jurisdiction.code
                            })
                        ]
                    }),
                    jurisdiction.active ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "jurisdiction-status active",
                        children: "Active"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "jurisdiction-status inactive",
                        children: "Inactive"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdiction-office",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "label",
                        children: [
                            t('attorney.jurisdictions.office', 'IP Office'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "value",
                        children: jurisdiction.office
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdiction-portal",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "label",
                        children: [
                            t('attorney.jurisdictions.portal', 'Filing Portal'),
                            ":"
                        ]
                    }),
                    jurisdiction.portal?.filingUrl ? /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        href: jurisdiction.portal.filingUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            t('attorney.jurisdictions.openPortal', 'Open Portal'),
                            " \u2192"
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "no-data",
                        children: "Not configured"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdiction-fees",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "label",
                        children: [
                            t('attorney.jurisdictions.fees', 'Fees'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "value",
                        children: [
                            jurisdiction.fees?.currency,
                            " ",
                            jurisdiction.fees?.baseFee,
                            " base + ",
                            jurisdiction.fees?.perClassFee,
                            "/class"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdiction-deadlines",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "label",
                        children: [
                            t('attorney.jurisdictions.deadlines', 'Deadlines'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "deadline-list",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Office Action: ",
                                    jurisdiction.deadlines?.officeActionResponse,
                                    " days"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Opposition: ",
                                    jurisdiction.deadlines?.oppositionPeriod,
                                    " days"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jurisdiction-contact",
                children: [
                    jurisdiction.contact?.email && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: `mailto:${jurisdiction.contact.email}`,
                        className: "contact-link",
                        children: jurisdiction.contact.email
                    }),
                    jurisdiction.contact?.phone && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "contact-phone",
                        children: jurisdiction.contact.phone
                    })
                ]
            }),
            isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "jurisdiction-actions",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: onEdit,
                    className: "btn-edit",
                    children: t('attorney.jurisdictions.edit', 'Edit')
                })
            })
        ]
    });
}
function $0ea39fadcc63652e$var$JurisdictionModal({ jurisdiction: jurisdiction, onSave: onSave, onClose: onClose, isLoading: isLoading }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const isNew = !jurisdiction?.id;
    const [formData, setFormData] = (0, $acw62.useState)({
        code: jurisdiction?.code || '',
        name: jurisdiction?.name || '',
        office: jurisdiction?.office || '',
        portal: {
            url: jurisdiction?.portal?.url || '',
            loginUrl: jurisdiction?.portal?.loginUrl || '',
            filingUrl: jurisdiction?.portal?.filingUrl || '',
            instructions: jurisdiction?.portal?.instructions || ''
        },
        fees: {
            baseFee: jurisdiction?.fees?.baseFee || 0,
            perClassFee: jurisdiction?.fees?.perClassFee || 0,
            currency: jurisdiction?.fees?.currency || 'USD'
        },
        deadlines: {
            officeActionResponse: jurisdiction?.deadlines?.officeActionResponse || 60,
            oppositionPeriod: jurisdiction?.deadlines?.oppositionPeriod || 30,
            renewalWindow: jurisdiction?.deadlines?.renewalWindow || 365
        },
        contact: {
            email: jurisdiction?.contact?.email || '',
            phone: jurisdiction?.contact?.phone || ''
        },
        active: jurisdiction?.active !== false
    });
    const handleChange = (path, value)=>{
        setFormData((prev)=>{
            const newData = {
                ...prev
            };
            switch(path){
                case 'code':
                case 'name':
                case 'office':
                case 'active':
                    newData[path] = value;
                    break;
                case 'portal.filingUrl':
                    newData.portal = {
                        ...newData.portal,
                        filingUrl: value
                    };
                    break;
                case 'portal.instructions':
                    newData.portal = {
                        ...newData.portal,
                        instructions: value
                    };
                    break;
                case 'fees.currency':
                    newData.fees = {
                        ...newData.fees,
                        currency: value
                    };
                    break;
                case 'fees.baseFee':
                    newData.fees = {
                        ...newData.fees,
                        baseFee: value
                    };
                    break;
                case 'fees.perClassFee':
                    newData.fees = {
                        ...newData.fees,
                        perClassFee: value
                    };
                    break;
                case 'deadlines.officeActionResponse':
                    newData.deadlines = {
                        ...newData.deadlines,
                        officeActionResponse: value
                    };
                    break;
                case 'deadlines.oppositionPeriod':
                    newData.deadlines = {
                        ...newData.deadlines,
                        oppositionPeriod: value
                    };
                    break;
                case 'deadlines.renewalWindow':
                    newData.deadlines = {
                        ...newData.deadlines,
                        renewalWindow: value
                    };
                    break;
                case 'contact.email':
                    newData.contact = {
                        ...newData.contact,
                        email: value
                    };
                    break;
                case 'contact.phone':
                    newData.contact = {
                        ...newData.contact,
                        phone: value
                    };
                    break;
                default:
                    break;
            }
            return newData;
        });
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSave(formData);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "modal-content jurisdiction-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: isNew ? t('attorney.jurisdictions.addTitle', 'Add Jurisdiction') : t('attorney.jurisdictions.editTitle', 'Edit Jurisdiction')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "form-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.jurisdictions.form.code', 'Code (2 letters)')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: formData.code,
                                            onChange: (e)=>handleChange('code', e.target.value.toUpperCase()),
                                            maxLength: 2,
                                            required: true,
                                            disabled: !isNew
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.jurisdictions.form.name', 'Country Name')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: formData.name,
                                            onChange: (e)=>handleChange('name', e.target.value),
                                            required: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: t('attorney.jurisdictions.form.office', 'IP Office Name')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    value: formData.office,
                                    onChange: (e)=>handleChange('office', e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                            className: "form-fieldset",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    children: t('attorney.jurisdictions.form.portalSection', 'Filing Portal')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.jurisdictions.form.filingUrl', 'Filing URL')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "url",
                                            value: formData.portal.filingUrl,
                                            onChange: (e)=>handleChange('portal.filingUrl', e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.jurisdictions.form.instructions', 'Filing Instructions')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            value: formData.portal.instructions,
                                            onChange: (e)=>handleChange('portal.instructions', e.target.value),
                                            rows: 2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                            className: "form-fieldset",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    children: t('attorney.jurisdictions.form.feesSection', 'Fees')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.currency', 'Currency')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: formData.fees.currency,
                                                    onChange: (e)=>handleChange('fees.currency', e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "USD",
                                                            children: "USD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "EUR",
                                                            children: "EUR"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "GBP",
                                                            children: "GBP"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "AUD",
                                                            children: "AUD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "NZD",
                                                            children: "NZD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "CAD",
                                                            children: "CAD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "SGD",
                                                            children: "SGD"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.baseFee', 'Base Fee')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "number",
                                                    value: formData.fees.baseFee,
                                                    onChange: (e)=>handleChange('fees.baseFee', Number(e.target.value))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.perClassFee', 'Per Class Fee')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "number",
                                                    value: formData.fees.perClassFee,
                                                    onChange: (e)=>handleChange('fees.perClassFee', Number(e.target.value))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                            className: "form-fieldset",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    children: t('attorney.jurisdictions.form.deadlinesSection', 'Response Deadlines (days)')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.officeAction', 'Office Action')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "number",
                                                    value: formData.deadlines.officeActionResponse,
                                                    onChange: (e)=>handleChange('deadlines.officeActionResponse', Number(e.target.value))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.opposition', 'Opposition')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "number",
                                                    value: formData.deadlines.oppositionPeriod,
                                                    onChange: (e)=>handleChange('deadlines.oppositionPeriod', Number(e.target.value))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                            className: "form-fieldset",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                                    children: t('attorney.jurisdictions.form.contactSection', 'Contact')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.email', 'Email')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "email",
                                                    value: formData.contact.email,
                                                    onChange: (e)=>handleChange('contact.email', e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    children: t('attorney.jurisdictions.form.phone', 'Phone')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "tel",
                                                    value: formData.contact.phone,
                                                    onChange: (e)=>handleChange('contact.phone', e.target.value)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "form-group checkbox-group",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        checked: formData.active,
                                        onChange: (e)=>handleChange('active', e.target.checked)
                                    }),
                                    t('attorney.jurisdictions.form.active', 'Active')
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "btn-cancel",
                                    onClick: onClose,
                                    children: t('attorney.jurisdictions.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "btn-save",
                                    disabled: isLoading,
                                    children: isLoading ? t('attorney.jurisdictions.saving', 'Saving...') : t('attorney.jurisdictions.save', 'Save')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $0ea39fadcc63652e$var$getFlagEmoji(countryCode) {
    const flags = {
        AU: "\uD83C\uDDE6\uD83C\uDDFA",
        US: "\uD83C\uDDFA\uD83C\uDDF8",
        EU: "\uD83C\uDDEA\uD83C\uDDFA",
        UK: "\uD83C\uDDEC\uD83C\uDDE7",
        NZ: "\uD83C\uDDF3\uD83C\uDDFF",
        CA: "\uD83C\uDDE8\uD83C\uDDE6",
        SG: "\uD83C\uDDF8\uD83C\uDDEC",
        JP: "\uD83C\uDDEF\uD83C\uDDF5",
        CN: "\uD83C\uDDE8\uD83C\uDDF3",
        KR: "\uD83C\uDDF0\uD83C\uDDF7"
    };
    return flags[countryCode] || "\uD83C\uDF0D";
}
var $0ea39fadcc63652e$export$2e2bcd8739ae039 = $0ea39fadcc63652e$var$Jurisdictions;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



async function $e0e0e3569976fb21$export$491fe77f22ab2b51() {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/attorney/team');
    return response.data;
}
async function $e0e0e3569976fb21$export$348cc448ded6dc4b(email, role = 'org:attorney') {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/attorney/team/invite', {
        email: email,
        role: role
    });
    return response.data;
}
async function $e0e0e3569976fb21$export$cafad30d42313f2e(invitationId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).delete(`/attorney/team/invitations/${invitationId}`);
    return response.data;
}
async function $e0e0e3569976fb21$export$57b1164dbe7b642f(userId) {
    const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).delete(`/attorney/team/members/${userId}`);
    return response.data;
}
var $e0e0e3569976fb21$export$2e2bcd8739ae039 = {
    getTeam: $e0e0e3569976fb21$export$491fe77f22ab2b51,
    inviteMember: $e0e0e3569976fb21$export$348cc448ded6dc4b,
    cancelInvitation: $e0e0e3569976fb21$export$cafad30d42313f2e,
    removeMember: $e0e0e3569976fb21$export$57b1164dbe7b642f
};


const $d2519d55369fb5d8$export$4f7b553db5a7a93a = [
    'attorney',
    'team'
];
function $d2519d55369fb5d8$export$b71084872e577b6c(options = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: $d2519d55369fb5d8$export$4f7b553db5a7a93a,
        queryFn: ()=>(0, $e0e0e3569976fb21$export$2e2bcd8739ae039).getTeam(),
        staleTime: 120000,
        enabled: options.enabled !== false
    });
}
function $d2519d55369fb5d8$export$55306614ccda40e1() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ email: email, role: role })=>(0, $e0e0e3569976fb21$export$2e2bcd8739ae039).inviteMember(email, role),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $d2519d55369fb5d8$export$4f7b553db5a7a93a
            });
        }
    });
}
function $d2519d55369fb5d8$export$8e5dedf1a9b8dd51() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (invitationId)=>(0, $e0e0e3569976fb21$export$2e2bcd8739ae039).cancelInvitation(invitationId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $d2519d55369fb5d8$export$4f7b553db5a7a93a
            });
        }
    });
}
function $d2519d55369fb5d8$export$e8dcf8c8aba5c0ca() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (userId)=>(0, $e0e0e3569976fb21$export$2e2bcd8739ae039).removeMember(userId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $d2519d55369fb5d8$export$4f7b553db5a7a93a
            });
        }
    });
}
var $d2519d55369fb5d8$export$2e2bcd8739ae039 = {
    useTeam: $d2519d55369fb5d8$export$b71084872e577b6c,
    useInviteMember: $d2519d55369fb5d8$export$55306614ccda40e1,
    useCancelInvitation: $d2519d55369fb5d8$export$8e5dedf1a9b8dd51,
    useRemoveMember: $d2519d55369fb5d8$export$e8dcf8c8aba5c0ca
};




/**
 * MyTeam Component
 * Allows org admins to manage their team members and invitations
 */ function $ec7b412700ffd565$var$MyTeam() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('attorney');
    const { isAdmin: isAdmin, firmName: firmName } = (0, $b08fe6cb05501eb7$export$5c7c8f3b54bb1df0)();
    const [showInviteModal, setShowInviteModal] = (0, $acw62.useState)(false);
    const [inviteEmail, setInviteEmail] = (0, $acw62.useState)('');
    const [inviteRole, setInviteRole] = (0, $acw62.useState)('org:attorney');
    const [confirmRemove, setConfirmRemove] = (0, $acw62.useState)(null);
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $d2519d55369fb5d8$export$b71084872e577b6c)();
    const inviteMutation = (0, $d2519d55369fb5d8$export$55306614ccda40e1)();
    const cancelInvitationMutation = (0, $d2519d55369fb5d8$export$8e5dedf1a9b8dd51)();
    const removeMemberMutation = (0, $d2519d55369fb5d8$export$e8dcf8c8aba5c0ca)();
    const members = data?.members || [];
    const invitations = data?.invitations || [];
    const handleInvite = async (e)=>{
        e.preventDefault();
        if (!inviteEmail.trim()) return;
        try {
            await inviteMutation.mutateAsync({
                email: inviteEmail.trim(),
                role: inviteRole
            });
            setInviteEmail('');
            setInviteRole('org:attorney');
            setShowInviteModal(false);
        } catch (err) {
        // Error handled by mutation
        }
    };
    const handleCancelInvitation = async (invitationId)=>{
        try {
            await cancelInvitationMutation.mutateAsync(invitationId);
        } catch (err) {
        // Error handled by mutation
        }
    };
    const handleRemoveMember = async (userId)=>{
        try {
            await removeMemberMutation.mutateAsync(userId);
            setConfirmRemove(null);
        } catch (err) {
        // Error handled by mutation
        }
    };
    const getRoleLabel = (role)=>{
        switch(role){
            case 'org:admin':
                return t('attorney.team.roleAdmin', 'Admin');
            case 'org:attorney':
                return t('attorney.team.roleAttorney', 'Attorney');
            case 'org:member':
                return t('attorney.team.roleMember', 'Member');
            default:
                return role;
        }
    };
    const formatDate = (dateString)=>{
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    if (!isAdmin) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "myteam-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "myteam-no-access",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t('attorney.team.noAccess', 'Only organization admins can manage team members.')
            })
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "myteam-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "myteam-loading",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "loading-spinner"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: t('attorney.team.loading', 'Loading team...')
                })
            ]
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "myteam-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "myteam-error",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: t('attorney.team.error', 'Failed to load team')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: ()=>refetch(),
                    children: t('attorney.team.retry', 'Retry')
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "myteam-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "myteam-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: t('attorney.team.title', 'My Team')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "myteam-subtitle",
                                children: firmName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn-invite",
                        onClick: ()=>setShowInviteModal(true),
                        children: t('attorney.team.inviteMember', 'Invite Member')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "myteam-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        children: [
                            t('attorney.team.members', 'Team Members'),
                            " (",
                            members.length,
                            ")"
                        ]
                    }),
                    members.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "myteam-empty",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: t('attorney.team.noMembers', 'No team members yet')
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "myteam-list",
                        children: members.map((member)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "team-member-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "member-avatar",
                                        children: (member.name || member.email || '?')[0].toUpperCase()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "member-info",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "member-name",
                                                children: [
                                                    member.name || member.email,
                                                    member.isCurrentUser && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "member-you",
                                                        children: t('attorney.team.you', '(you)')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "member-email",
                                                children: member.email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `member-role role-${member.role?.replace(':', '-')}`,
                                        children: getRoleLabel(member.role)
                                    }),
                                    !member.isCurrentUser && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-remove",
                                        onClick: ()=>setConfirmRemove(member),
                                        disabled: removeMemberMutation.isPending,
                                        children: t('attorney.team.remove', 'Remove')
                                    })
                                ]
                            }, member.userId))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "myteam-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        children: [
                            t('attorney.team.pendingInvitations', 'Pending Invitations'),
                            " (",
                            invitations.length,
                            ")"
                        ]
                    }),
                    invitations.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "myteam-empty",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: t('attorney.team.noInvitations', 'No pending invitations')
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "myteam-list",
                        children: invitations.map((invitation)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "invitation-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "invitation-icon",
                                        children: "\u2709\uFE0F"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "invitation-info",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "invitation-email",
                                                children: invitation.email
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "invitation-meta",
                                                children: [
                                                    t('attorney.team.sentOn', 'Sent'),
                                                    ": ",
                                                    formatDate(invitation.createdAt)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `member-role role-${invitation.role?.replace(':', '-')}`,
                                        children: getRoleLabel(invitation.role)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "btn-cancel-invite",
                                        onClick: ()=>handleCancelInvitation(invitation.id),
                                        disabled: cancelInvitationMutation.isPending,
                                        children: t('attorney.team.cancelInvite', 'Cancel')
                                    })
                                ]
                            }, invitation.id))
                    })
                ]
            }),
            showInviteModal && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setShowInviteModal(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "invite-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "invite-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: t('attorney.team.inviteTitle', 'Invite Team Member')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "modal-close-btn",
                                    onClick: ()=>setShowInviteModal(false),
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleInvite,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.team.emailLabel', 'Email Address')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "email",
                                            value: inviteEmail,
                                            onChange: (e)=>setInviteEmail(e.target.value),
                                            placeholder: t('attorney.team.emailPlaceholder', 'attorney@example.com'),
                                            required: true,
                                            autoFocus: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: t('attorney.team.roleLabel', 'Role')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: inviteRole,
                                            onChange: (e)=>setInviteRole(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                    value: "org:attorney",
                                                    children: [
                                                        t('attorney.team.roleAttorney', 'Attorney'),
                                                        " - ",
                                                        t('attorney.team.roleAttorneyDesc', 'Can view and work on assigned cases')
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                    value: "org:admin",
                                                    children: [
                                                        t('attorney.team.roleAdmin', 'Admin'),
                                                        " - ",
                                                        t('attorney.team.roleAdminDesc', 'Can manage team and assign work')
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "invite-info",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: t('attorney.team.inviteInfo', 'An email with a magic link will be sent to invite them to join your organization.')
                                    })
                                }),
                                inviteMutation.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "invite-error",
                                    children: inviteMutation.error.response?.data?.message || inviteMutation.error.message
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "invite-modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "btn-cancel",
                                            onClick: ()=>setShowInviteModal(false),
                                            disabled: inviteMutation.isPending,
                                            children: t('attorney.team.cancel', 'Cancel')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "submit",
                                            className: "btn-send-invite",
                                            disabled: !inviteEmail.trim() || inviteMutation.isPending,
                                            children: inviteMutation.isPending ? t('attorney.team.sending', 'Sending...') : t('attorney.team.sendInvite', 'Send Invitation')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            confirmRemove && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setConfirmRemove(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "confirm-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t('attorney.team.confirmRemoveTitle', 'Remove Team Member')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: t('attorney.team.confirmRemoveMessage', 'Are you sure you want to remove {{name}} from the organization?', {
                                name: confirmRemove.name || confirmRemove.email
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "confirm-modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setConfirmRemove(null),
                                    disabled: removeMemberMutation.isPending,
                                    children: t('attorney.team.cancel', 'Cancel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "btn-confirm-remove",
                                    onClick: ()=>handleRemoveMember(confirmRemove.userId),
                                    disabled: removeMemberMutation.isPending,
                                    children: removeMemberMutation.isPending ? t('attorney.team.removing', 'Removing...') : t('attorney.team.confirmRemove', 'Remove')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $ec7b412700ffd565$export$2e2bcd8739ae039 = $ec7b412700ffd565$var$MyTeam;








/**
 * Attorney Dashboard Application
 * Main entry point for the attorney portal
 *
 * Access is determined by checking if user's org is registered in law_firms table.
 * This allows both internal (MarkoTM) and external law firm attorneys to access.
 */ function $f5fe3691fadd7ea4$var$AttorneyApp() {
    const { isLoaded: isLoaded, isSignedIn: isSignedIn } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    // Check access via law_firms table lookup (TanStack Query)
    const { data: firmData, isLoading: firmLoading, error: firmError } = (0, $8d1d9ca1d65e0e94$export$45e2f284f78f9fbf)();
    // Derive access from API response
    const hasAttorneyAccess = firmData?.hasAccess === true;
    const isAdmin = firmData?.permissions?.isAdmin === true;
    // Wait for auth and firm data to load
    if (!isLoaded || firmLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "attorney-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading..."
            })
        ]
    });
    // Redirect if not signed in
    if (!isSignedIn) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/sign-in",
        replace: true
    });
    if (!hasAttorneyAccess) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "attorney-access-denied",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Access Denied"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: firmError ? 'Unable to verify access. Please try again later.' : 'Your organization is not registered for attorney access. Please contact your administrator.'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "/dashboard",
                children: "Return to Dashboard"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a05168b77183bb44$export$186b91822010e97f), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b08fe6cb05501eb7$export$c0d08ae70116d5f0), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2d994a14c968c0b$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "filing-queue",
                                replace: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "filing-queue",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfe99e1fb704439a$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "approval-queue",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccbe50d6f4411b39$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "clients",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef8b176a7ebb4685$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "client-messages",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74a3a60f5db40811$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "internal-requests",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7acd9994b5cfab93$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "markotm-responses",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3245c8611efb19e6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "correspondence",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1298f71ea7b8a407$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "deadlines",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bac860ebd05cf0d2$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "jurisdictions",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ea39fadcc63652e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "my-team",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ec7b412700ffd565$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "filing-queue",
                                replace: true
                            })
                        })
                    ]
                })
            })
        })
    });
}
var $f5fe3691fadd7ea4$export$2e2bcd8739ae039 = $f5fe3691fadd7ea4$var$AttorneyApp;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * React Query hooks for Marketing Ops Dashboard
 */ 
/**
 * Marketing Ops Dashboard Service
 * API calls for the marketing pipeline CRM
 */ 
const $7e53e8fdf8fe9e90$var$marketingService = {
    /**
   * Get pipeline data (all visitors grouped by stage)
   * @param {object} params Query params (days, stage, country, source)
   * @returns {Promise<object>} { pipeline, summary, totalCount }
   */ async getPipeline (params = {}) {
        const query = new URLSearchParams();
        if (params.days) query.append('days', params.days);
        if (params.maxStep) query.append('maxStep', params.maxStep);
        if (params.source) query.append('source', params.source);
        if (params.quietDays) query.append('quietDays', params.quietDays);
        if (params.activeWithinDays) query.append('activeWithinDays', params.activeWithinDays);
        if (params.startDate) query.append('startDate', params.startDate);
        if (params.endDate) query.append('endDate', params.endDate);
        const qs = query.toString();
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/pipeline${qs ? `?${qs}` : ''}`);
        return response.data;
    },
    /**
   * Get visitor detail (full profile + timeline)
   * @param {string} visitorId Application ID
   * @returns {Promise<object>} Full visitor detail
   */ async getVisitorDetail (visitorId) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/visitors/${visitorId}`);
        return response.data;
    },
    /**
   * Get visitor feedback (checkout prompt + email one-tap answers)
   * @param {object} params Query params (days)
   * @returns {Promise<object>} { entries, summary }
   */ async getFeedback (params = {}) {
        const query = new URLSearchParams();
        if (params.days) query.append('days', params.days);
        const qs = query.toString();
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/feedback${qs ? `?${qs}` : ''}`);
        return response.data;
    },
    /**
   * Search people by name, email, phone, trademark or business
   * @param {string} q Search term (min 2 chars)
   * @returns {Promise<object>} { results }
   */ async searchPeople (q) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/search?q=${encodeURIComponent(q)}`);
        return response.data;
    },
    /**
   * TM Watch: register presence for every watched trade mark
   * @returns {Promise<object>} { configured, entries, summary }
   */ async getTmWatch () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/marketing/tmwatch');
        return response.data;
    },
    /**
   * Ask the AI reporting assistant (read-only over marketing data)
   * @param {Array<{role: string, content: string}>} messages Chat history ending with the user question
   * @returns {Promise<object>} { reply }
   */ async askAssistant (messages) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/assistant', {
            messages: messages
        });
        return response.data;
    },
    /**
   * Send the feedback-ask email to many visitors at once.
   * The backend skips DNC/paid, anyone who already gave feedback, and
   * anyone asked within the last 30 days.
   * @param {string[]} visitorIds
   * @returns {Promise<object>} { sent, skipped, failed, summary }
   */ async bulkFeedback (visitorIds) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/bulk-feedback', {
            visitorIds: visitorIds
        });
        return response.data;
    },
    /**
   * Add a note to a visitor
   * @param {string} visitorId Application ID
   * @param {string} content Note content
   * @returns {Promise<object>} Created note
   */ async addNote (visitorId, content) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/add-note', {
            visitorId: visitorId,
            content: content
        });
        return response.data;
    },
    /**
   * Send follow-up email to a visitor.
   * @param {string} visitorId Visitor tracking ID
   * @param {object} compose Optional composer fields:
   *   { subject, bodyText, includeBlocks, templateOverride, customMessage }
   * @returns {Promise<object>} Result
   */ async sendFollowUp (visitorId, compose = {}) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/send-follow-up', {
            visitorId: visitorId,
            ...compose
        });
        return response.data;
    },
    /**
   * Update visitor follow-up status
   * @param {string} visitorId Application ID
   * @param {string} status New status
   * @returns {Promise<object>} Result
   */ async updateStatus (visitorId, status) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/update-status', {
            visitorId: visitorId,
            status: status
        });
        return response.data;
    },
    /**
   * Preview outreach email — returns rendered HTML, the editable draft
   * (subject + bodyText + blocks) and sender info, without sending.
   * @param {string} visitorId Visitor tracking ID
   * @param {object} compose Optional composer fields:
   *   { subject, bodyText, includeBlocks, templateOverride, customMessage }
   * @returns {Promise<object>} { templateName, subject, draft, sender, html, ... }
   */ async previewEmail (visitorId, compose = {}) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/preview-email', {
            visitorId: visitorId,
            ...compose
        });
        return response.data;
    },
    /**
   * Set (or clear) a follow-up reminder for a visitor.
   * @param {string} visitorId Visitor tracking ID
   * @param {number} days Days from now (0/null clears the reminder)
   */ async setReminder (visitorId, days) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/set-reminder', {
            visitorId: visitorId,
            days: days
        });
        return response.data;
    },
    /**
   * List generated reports (the 24-hour SLA queue)
   * @param {object} params Optional { status }
   * @returns {Promise<object>} { reports, pendingCount }
   */ async getReports (params = {}) {
        const query = new URLSearchParams();
        if (params.status) query.append('status', params.status);
        const qs = query.toString();
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/reports${qs ? `?${qs}` : ''}`);
        return response.data;
    },
    /**
   * Get a single report (full sections + register search + quote)
   * @param {string} reportId
   * @returns {Promise<object>} { report, application }
   */ async getReport (reportId) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/reports/${reportId}`);
        return response.data;
    },
    /**
   * Re-run the report generator for a report
   * @param {string} reportId
   */ async regenerateReport (reportId) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/marketing/reports/${reportId}/regenerate`);
        return response.data;
    },
    /**
   * Save edits to a report (sections and/or email subject/body overrides)
   * @param {string} reportId
   * @param {object} updates { sections?, emailSubject?, emailBodyText? }
   */ async updateReport (reportId, updates) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/marketing/reports/${reportId}/update`, updates);
        return response.data;
    },
    /**
   * Edit the quote — writes back to the pricing record (quoteStatus: confirmed).
   * Editing a quote whose report has already been sent creates a revision.
   * @param {string} reportId
   * @param {object} quote { countries?, classes?, autoPrice?, serviceFeeTotal?,
   *                         govFeeTotal?, discount?, total?, currency? }
   */ async updateReportQuote (reportId, quote) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/marketing/reports/${reportId}/update-quote`, quote);
        return response.data;
    },
    /**
   * Price a prospective quote scope without saving it (live total in the editor)
   * @param {string} reportId
   * @param {object} scope { countries?, classCount?, currency? }
   * @returns {Promise<object>} { quote }
   */ async priceReportQuote (reportId, scope) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/marketing/reports/${reportId}/price-quote`, scope);
        return response.data;
    },
    /**
   * Send the report + quote email with a fresh dashboard magic link
   * @param {string} reportId
   * @param {object} compose Optional { subject, bodyText }
   */ async sendReport (reportId, compose = {}) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/send-report', {
            reportId: reportId,
            ...compose
        });
        return response.data;
    },
    /**
   * Send a revised quote to a client who already has their report
   * @param {string} reportId
   * @param {object} compose Optional { subject, bodyText }
   */ async sendQuoteRevision (reportId, compose = {}) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/send-quote-revision', {
            reportId: reportId,
            ...compose
        });
        return response.data;
    },
    /**
   * The visitor's uploaded logo as a blob. Fetched through the API rather than
   * linked directly: the stored URL's SAS token expires, and an <img> tag
   * can't send our auth header.
   * @param {string} applicationId
   * @returns {Promise<Blob>}
   */ async downloadTrademarkImage (applicationId) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/trademark-image?applicationId=${encodeURIComponent(applicationId)}`, {
            responseType: 'blob'
        });
        return response.data;
    },
    /**
   * Country/pricing reference table (public endpoint) — the authoritative
   * country list for the quote editor's country picker
   */ async getPricingConfig () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/pricing-config');
        return response.data;
    },
    /**
   * Class reference for the quote class picker. Terms come from the IP
   * Australia picklist, so anything picked keeps the $250/class filing fee.
   * @param {object} params Optional { classNumber, q, limit }
   */ async getClassTerms (params = {}) {
        const query = new URLSearchParams();
        if (params.classNumber) query.append('class', params.classNumber);
        if (params.q) query.append('q', params.q);
        if (params.limit) query.append('limit', params.limit);
        const qs = query.toString();
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get(`/marketing/class-terms${qs ? `?${qs}` : ''}`);
        return response.data;
    },
    /**
   * AI-suggested goods/services for a class, snapped to the picklist
   * @param {string} reportId
   * @param {number} classNumber
   */ async suggestGoodsServices (reportId, classNumber) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/marketing/reports/${reportId}/suggest-goods`, {
            classNumber: classNumber
        });
        return response.data;
    },
    /**
   * Propose picklist replacements for wording that isn't on the picklist.
   * Returns proposals only — nothing is saved until the quote is saved.
   * @param {string} reportId
   * @param {number} [classNumber] omit to cover every affected class
   */ async fixPicklistTerms (reportId, classNumber) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post(`/marketing/reports/${reportId}/fix-terms`, classNumber != null ? {
            classNumber: classNumber
        } : {});
        return response.data;
    },
    /**
   * Download the printable call sheet PDF (one A4 page per Call-list lead,
   * capped at 50 server-side).
   * @returns {Promise<Blob>} PDF blob
   */ async downloadCallSheet () {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/marketing/call-sheet', {
            responseType: 'blob'
        });
        return response.data;
    },
    async updateContactStatus (visitorId, contactStatus) {
        const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).post('/marketing/actions/update-status', {
            visitorId: visitorId,
            status: contactStatus
        });
        return response.data;
    }
};
var $7e53e8fdf8fe9e90$export$2e2bcd8739ae039 = $7e53e8fdf8fe9e90$var$marketingService;


const $4878203aaaa5eb61$export$7fd57dde59492be5 = [
    'marketing',
    'pipeline'
];
const $4878203aaaa5eb61$export$2b5513f358ba834e = [
    'marketing',
    'visitor'
];
const $4878203aaaa5eb61$export$4c0c4bf9d4c62867 = [
    'marketing',
    'feedback'
];
const $4878203aaaa5eb61$export$e958e115397d187d = [
    'marketing',
    'reports'
];
function $4878203aaaa5eb61$export$fa3120960baf4ea2(params = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$4878203aaaa5eb61$export$e958e115397d187d,
            params
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getReports(params),
        staleTime: 30000,
        refetchInterval: 60000
    });
}
function $4878203aaaa5eb61$export$335080e14d32489b(reportId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$4878203aaaa5eb61$export$e958e115397d187d,
            'detail',
            reportId
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getReport(reportId),
        enabled: !!reportId,
        staleTime: 15000
    });
}
function $4878203aaaa5eb61$export$7685313327762392() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (reportId)=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).regenerateReport(reportId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$e958e115397d187d
            });
        }
    });
}
function $4878203aaaa5eb61$export$e2711b9b8da2c4d8() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, ...updates })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).updateReport(reportId, updates),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$e958e115397d187d
            });
        }
    });
}
function $4878203aaaa5eb61$export$14d6cc65c682619e() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, ...quote })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).updateReportQuote(reportId, quote),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$e958e115397d187d
            });
        }
    });
}
function $4878203aaaa5eb61$export$5813f3cac7cac59f() {
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, ...scope })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).priceReportQuote(reportId, scope)
    });
}
function $4878203aaaa5eb61$export$f1fbd11d4001b56b() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, ...compose })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).sendReport(reportId, compose),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$e958e115397d187d
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
        }
    });
}
function $4878203aaaa5eb61$export$a5a177c19391712e() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, ...compose })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).sendQuoteRevision(reportId, compose),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$e958e115397d187d
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
        }
    });
}
function $4878203aaaa5eb61$export$384d8c9ea6fb5aa4(enabled = true) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'marketing',
            'class-terms'
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getClassTerms(),
        enabled: enabled,
        staleTime: Infinity
    });
}
function $4878203aaaa5eb61$export$e510b38eddd847e8() {
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, classNumber: classNumber })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).suggestGoodsServices(reportId, classNumber)
    });
}
function $4878203aaaa5eb61$export$b7768dbefa548d58() {
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ reportId: reportId, classNumber: classNumber })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).fixPicklistTerms(reportId, classNumber)
    });
}
function $4878203aaaa5eb61$export$3f6edacb3381ddb2(enabled = true) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'marketing',
            'pricing-config'
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getPricingConfig(),
        enabled: enabled,
        staleTime: Infinity
    });
}
function $4878203aaaa5eb61$export$ec63733f05f94041(classNumber, q) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'marketing',
            'class-terms',
            classNumber,
            q || ''
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getClassTerms({
                classNumber: classNumber,
                q: q
            }),
        enabled: !!classNumber,
        staleTime: 600000
    });
}
function $4878203aaaa5eb61$export$a19b0125be4d32b3(params = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$4878203aaaa5eb61$export$4c0c4bf9d4c62867,
            params
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getFeedback(params),
        staleTime: 30000,
        refetchInterval: 60000
    });
}
function $4878203aaaa5eb61$export$88523eff58ffa0ce(params = {}) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$4878203aaaa5eb61$export$7fd57dde59492be5,
            params
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getPipeline(params),
        staleTime: 30000,
        refetchInterval: 60000
    });
}
function $4878203aaaa5eb61$export$9b251f761e09847a(visitorId) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            ...$4878203aaaa5eb61$export$2b5513f358ba834e,
            visitorId
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getVisitorDetail(visitorId),
        enabled: !!visitorId,
        staleTime: 30000
    });
}
function $4878203aaaa5eb61$export$d443a927de736110(q) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'marketing',
            'search',
            q
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).searchPeople(q),
        enabled: (q || '').trim().length >= 2,
        staleTime: 30000
    });
}
function $4878203aaaa5eb61$export$120815dedd6f182a() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: (visitorIds)=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).bulkFeedback(visitorIds),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$4c0c4bf9d4c62867
            });
        }
    });
}
function $4878203aaaa5eb61$export$47da257c0181caef() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ visitorId: visitorId, content: content })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).addNote(visitorId, content),
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    ...$4878203aaaa5eb61$export$2b5513f358ba834e,
                    variables.visitorId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
        }
    });
}
function $4878203aaaa5eb61$export$7ae2b0d15126cc6e() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ visitorId: visitorId, ...compose })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).sendFollowUp(visitorId, compose),
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    ...$4878203aaaa5eb61$export$2b5513f358ba834e,
                    variables.visitorId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
        }
    });
}
function $4878203aaaa5eb61$export$94a11939e0d05a57() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ visitorId: visitorId, days: days })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).setReminder(visitorId, days),
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    ...$4878203aaaa5eb61$export$2b5513f358ba834e,
                    variables.visitorId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
        }
    });
}
function $4878203aaaa5eb61$export$d91fdd4f78c535ff() {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: ({ visitorId: visitorId, status: status })=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).updateStatus(visitorId, status),
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    ...$4878203aaaa5eb61$export$2b5513f358ba834e,
                    variables.visitorId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: $4878203aaaa5eb61$export$7fd57dde59492be5
            });
        }
    });
}


function $d052347a7c901b65$var$MarketingSidebar() {
    // Pending-count badge: the 24-hour report SLA queue (draft/generating/failed)
    const { data: reportsData } = (0, $4878203aaaa5eb61$export$fa3120960baf4ea2)();
    const pendingReports = reportsData?.pendingCount || 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("aside", {
        className: "mkt-sidebar",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-sidebar-brand",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "MarkoTM"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-sidebar-badge",
                        children: "Marketing Ops"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                className: "mkt-sidebar-nav",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/pipeline",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83D\uDCCA"
                            }),
                            "Pipeline"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/funnel",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83D\uDD3B"
                            }),
                            "Funnel"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/reports",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83D\uDCC4"
                            }),
                            "Reports",
                            pendingReports > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-count",
                                children: pendingReports
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/feedback",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83D\uDCAC"
                            }),
                            "Feedback"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/search",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83D\uDD0D"
                            }),
                            "Search"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/assistant",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83E\uDD16"
                            }),
                            "Ask AI"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/marketing/tmwatch",
                        className: ({ isActive: isActive })=>`mkt-nav-item ${isActive ? 'active' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\xae\uFE0F"
                            }),
                            "TM Watch"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-sidebar-footer",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/attorney",
                        className: "mkt-nav-item mkt-nav-secondary",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\u2696\uFE0F"
                            }),
                            "Attorney Dashboard"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/dashboard",
                        className: "mkt-nav-item mkt-nav-secondary",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-nav-icon",
                                children: "\uD83C\uDFE0"
                            }),
                            "Main App"
                        ]
                    })
                ]
            })
        ]
    });
}
var $d052347a7c901b65$export$2e2bcd8739ae039 = $d052347a7c901b65$var$MarketingSidebar;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $c06fd6656ee2cd5e$var$MarketingHeader() {
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: "mkt-header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-header-left",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "mkt-header-title",
                    children: "Marketing Ops"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-header-right",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "mkt-header-user",
                    children: user?.firstName || 'Admin'
                })
            })
        ]
    });
}
var $c06fd6656ee2cd5e$export$2e2bcd8739ae039 = $c06fd6656ee2cd5e$var$MarketingHeader;


function $32ae0b7b7002cb4d$var$MarketingLayout({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-layout",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d052347a7c901b65$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c06fd6656ee2cd5e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-content",
                        children: children
                    })
                ]
            })
        ]
    });
}
var $32ae0b7b7002cb4d$export$2e2bcd8739ae039 = $32ae0b7b7002cb4d$var$MarketingLayout;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $69776ea6eb0ca5c8$var$TEMPLATE_LABELS = {
    wizard_follow_up: 'First Contact',
    wizard_second_follow_up: 'Final Note',
    wizard_report_follow_up: 'Analysis Report',
    wizard_checkout_follow_up: 'Checkout Nudge',
    wizard_feedback: 'Feedback Ask',
    quote_report: 'Report & Quote',
    quote_follow_up: 'Quote Nudge',
    quote_revised: 'Updated Quote'
};
// quote_report and quote_revised are deliberately NOT offered here — sending
// the formal report or a re-quote (each with its PDF and magic link) goes
// through the Reports section, not the composer
const $69776ea6eb0ca5c8$var$TEMPLATE_OPTIONS = [
    {
        value: 'wizard_follow_up',
        label: "\uD83D\uDC4B First Contact"
    },
    {
        value: 'wizard_report_follow_up',
        label: "\uD83D\uDCCA Analysis Report"
    },
    {
        value: 'quote_follow_up',
        label: "\uD83D\uDCB3 Quote Nudge"
    },
    {
        value: 'wizard_checkout_follow_up',
        label: "\uD83D\uDED2 Checkout Nudge (legacy)"
    },
    {
        value: 'wizard_second_follow_up',
        label: "\u23F0 Final Note"
    },
    {
        value: 'wizard_feedback',
        label: "\uD83D\uDCAC Feedback Ask"
    }
];
const $69776ea6eb0ca5c8$var$BLOCK_LABELS = {
    analysis: 'Include their analysis report',
    summary: 'Include their filing summary',
    feedback: 'Include one-tap reason links',
    report: 'Include their formal report & quote'
};
/**
 * OutreachModal — compose, personalise & send outreach emails as yourself.
 *
 * The recommended template only provides the starting draft: subject and
 * body are fully editable, optional content blocks (analysis report /
 * filing summary) can be toggled, and the live preview shows exactly what
 * the recipient will receive — sent from the outreach sender's own mailbox
 * with their personal signature.
 */ function $69776ea6eb0ca5c8$var$OutreachModal({ visitor: visitor, isOpen: isOpen, onClose: onClose }) {
    const sendFollowUp = (0, $4878203aaaa5eb61$export$7ae2b0d15126cc6e)();
    const [selectedTemplate, setSelectedTemplate] = (0, $acw62.useState)(null); // null = recommended
    const [subject, setSubject] = (0, $acw62.useState)('');
    const [bodyText, setBodyText] = (0, $acw62.useState)('');
    const [includeBlocks, setIncludeBlocks] = (0, $acw62.useState)([]);
    const [activeTab, setActiveTab] = (0, $acw62.useState)('compose');
    const [preview, setPreview] = (0, $acw62.useState)(null);
    const [previewLoading, setPreviewLoading] = (0, $acw62.useState)(false);
    const [previewError, setPreviewError] = (0, $acw62.useState)(null);
    const draftReady = (0, $acw62.useRef)(false);
    // Load the starting draft for the (recommended or selected) template and
    // prefill the composer with it.
    const loadDraft = (0, $acw62.useCallback)(async (templateOverride)=>{
        if (!visitor?.id) return;
        setPreviewLoading(true);
        setPreviewError(null);
        draftReady.current = false;
        try {
            const result = await (0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).previewEmail(visitor.id, {
                templateOverride: templateOverride
            });
            setPreview(result);
            setSubject(result.draft?.subject || result.subject || '');
            setBodyText(result.draft?.bodyText || '');
            setIncludeBlocks(result.draft?.defaultBlocks || []);
            draftReady.current = true;
        } catch (err) {
            console.error('Draft load failed:', err);
            setPreviewError(err.message || 'Failed to load draft');
        } finally{
            setPreviewLoading(false);
        }
    }, [
        visitor?.id
    ]);
    // Re-render the preview with the composer's current content.
    const refreshPreview = (0, $acw62.useCallback)(async ()=>{
        if (!visitor?.id || !draftReady.current) return;
        setPreviewLoading(true);
        setPreviewError(null);
        try {
            const result = await (0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).previewEmail(visitor.id, {
                templateOverride: selectedTemplate || undefined,
                subject: subject || undefined,
                bodyText: bodyText || undefined,
                includeBlocks: includeBlocks
            });
            setPreview(result);
        } catch (err) {
            console.error('Preview failed:', err);
            setPreviewError(err.message || 'Failed to load preview');
        } finally{
            setPreviewLoading(false);
        }
    }, [
        visitor?.id,
        selectedTemplate,
        subject,
        bodyText,
        includeBlocks
    ]);
    // Load draft on open
    (0, $acw62.useEffect)(()=>{
        if (isOpen && visitor?.id) {
            setSelectedTemplate(null);
            setActiveTab('compose');
            loadDraft(undefined);
        }
    }, [
        isOpen,
        visitor?.id
    ]);
    // Debounce preview updates while editing
    (0, $acw62.useEffect)(()=>{
        if (!isOpen || !visitor?.id || !draftReady.current) return;
        const timer = setTimeout(()=>{
            refreshPreview();
        }, 800);
        return ()=>clearTimeout(timer);
    }, [
        subject,
        bodyText,
        includeBlocks
    ]);
    if (!isOpen || !visitor) return null;
    const templateLabel = preview ? $69776ea6eb0ca5c8$var$TEMPLATE_LABELS[preview.templateName] || preview.templateName : 'Loading...';
    const firstName = (visitor.name || '').split(' ')[0] || 'them';
    const sender = preview?.sender;
    const outreachCount = visitor.outreachLog?.length || 0;
    const availableBlocks = Object.keys(preview?.draft?.availableBlocks || {}).filter((k)=>preview.draft.availableBlocks[k]);
    const handleTemplateChange = (val)=>{
        const override = val === preview?.recommendedTemplate ? null : val;
        setSelectedTemplate(override);
        // Switching template replaces the draft (subject + body + blocks)
        loadDraft(override || undefined);
    };
    const toggleBlock = (block)=>{
        setIncludeBlocks((prev)=>prev.includes(block) ? prev.filter((b)=>b !== block) : [
                ...prev,
                block
            ]);
    };
    const handleSend = async ()=>{
        try {
            await sendFollowUp.mutateAsync({
                visitorId: visitor.id,
                templateOverride: selectedTemplate || undefined,
                subject: subject || undefined,
                bodyText: bodyText || undefined,
                includeBlocks: includeBlocks
            });
            onClose();
        } catch (err) {
            console.error('Failed to send outreach:', err);
            alert(`Failed to send: ${err.message}`);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mkt-modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mkt-modal mkt-modal-wide",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            children: [
                                "Email ",
                                visitor.name || visitor.email,
                                " \u2014 ",
                                templateLabel
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "mkt-modal-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-modal-tabs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `mkt-modal-tab ${activeTab === 'compose' ? 'active' : ''}`,
                            onClick: ()=>setActiveTab('compose'),
                            children: "Compose"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `mkt-modal-tab ${activeTab === 'preview' ? 'active' : ''}`,
                            onClick: ()=>{
                                setActiveTab('preview');
                                refreshPreview();
                            },
                            children: "Preview Email"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-modal-body",
                    children: [
                        activeTab === 'compose' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-modal-section mkt-modal-crib",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            className: "mkt-modal-section-title",
                                            children: [
                                                "About ",
                                                firstName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-modal-crib-grid",
                                            style: {
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                                                gap: '4px 16px',
                                                fontSize: '13px',
                                                color: '#334155'
                                            },
                                            children: [
                                                visitor.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Trademark: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                            children: [
                                                                "\u201C",
                                                                visitor.trademarkName,
                                                                "\u201D"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                visitor.businessName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Business: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: visitor.businessName
                                                        })
                                                    ]
                                                }),
                                                visitor.industry && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Industry: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: visitor.industry
                                                        })
                                                    ]
                                                }),
                                                visitor.currentStep && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Stopped at: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: visitor.currentStep
                                                        }),
                                                        " ",
                                                        visitor.updatedAt ? `(${$69776ea6eb0ca5c8$var$getTimeAgo(visitor.updatedAt)})` : ''
                                                    ]
                                                }),
                                                visitor.riskLevel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Analysis risk: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: visitor.riskLevel
                                                        })
                                                    ]
                                                }),
                                                visitor.cartValue > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Cart value: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                            children: [
                                                                "$",
                                                                visitor.cartValue.toLocaleString()
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        visitor.businessDescription && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mkt-modal-hint",
                                            style: {
                                                marginTop: '6px'
                                            },
                                            children: [
                                                "\u201C",
                                                visitor.businessDescription.length > 180 ? visitor.businessDescription.substring(0, 180) + "\u2026" : visitor.businessDescription,
                                                "\u201D"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-modal-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-modal-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-modal-label",
                                                    children: "To"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-modal-value",
                                                    children: visitor.name ? `${visitor.name} <${visitor.email}>` : visitor.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-modal-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-modal-label",
                                                    children: "From"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-modal-value",
                                                    children: sender ? `${sender.name} <${sender.email}>` : "\u2026"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-modal-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-modal-label",
                                                    children: "Template"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "mkt-modal-value",
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        flexWrap: 'wrap'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                            className: "mkt-template-select",
                                                            value: preview?.templateName || '',
                                                            onChange: (e)=>handleTemplateChange(e.target.value),
                                                            style: {
                                                                padding: '4px 8px',
                                                                borderRadius: '6px',
                                                                border: '1px solid #d1d5db',
                                                                fontSize: '13px',
                                                                fontWeight: 600,
                                                                cursor: 'pointer'
                                                            },
                                                            children: $69776ea6eb0ca5c8$var$TEMPLATE_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: opt.value,
                                                                    children: opt.label
                                                                }, opt.value))
                                                        }),
                                                        preview?.recommendedTemplate && preview.templateName === preview.recommendedTemplate && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                color: '#16a34a',
                                                                fontWeight: 500
                                                            },
                                                            children: "\u2713 Recommended"
                                                        }),
                                                        preview?.recommendedTemplate && preview.templateName !== preview.recommendedTemplate && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                color: '#d97706',
                                                                fontWeight: 500
                                                            },
                                                            children: [
                                                                "Recommended: ",
                                                                $69776ea6eb0ca5c8$var$TEMPLATE_LABELS[preview.recommendedTemplate]
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "mkt-btn mkt-btn-ghost",
                                                            style: {
                                                                fontSize: '11px',
                                                                padding: '2px 8px'
                                                            },
                                                            onClick: ()=>loadDraft(selectedTemplate || undefined),
                                                            title: "Discard your edits and restore the template draft",
                                                            children: "\u21BA Reset to template"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-modal-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "mkt-modal-section-title",
                                            children: "Your Message"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "mkt-modal-hint",
                                            children: "This is your starting draft \u2014 edit anything. Adding one personal line about their business makes all the difference. The continue link and your signature are added automatically."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: {
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                color: '#475569',
                                                display: 'block',
                                                margin: '8px 0 4px'
                                            },
                                            children: "Subject"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            className: "mkt-modal-subject-input",
                                            style: {
                                                width: '100%',
                                                padding: '8px 10px',
                                                borderRadius: '6px',
                                                border: '1px solid #d1d5db',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            },
                                            value: subject,
                                            onChange: (e)=>setSubject(e.target.value),
                                            disabled: !draftReady.current && previewLoading
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: {
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                color: '#475569',
                                                display: 'block',
                                                margin: '10px 0 4px'
                                            },
                                            children: "Body"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            className: "mkt-modal-textarea",
                                            value: bodyText,
                                            onChange: (e)=>setBodyText(e.target.value),
                                            rows: 12,
                                            disabled: !draftReady.current && previewLoading,
                                            style: {
                                                width: '100%',
                                                boxSizing: 'border-box',
                                                fontSize: '14px',
                                                lineHeight: 1.5
                                            }
                                        }),
                                        availableBlocks.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                marginTop: '8px',
                                                display: 'flex',
                                                gap: '16px',
                                                flexWrap: 'wrap'
                                            },
                                            children: availableBlocks.map((block)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    style: {
                                                        fontSize: '13px',
                                                        color: '#334155',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: includeBlocks.includes(block),
                                                            onChange: ()=>toggleBlock(block)
                                                        }),
                                                        $69776ea6eb0ca5c8$var$BLOCK_LABELS[block] || block
                                                    ]
                                                }, block))
                                        })
                                    ]
                                }),
                                outreachCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-modal-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            className: "mkt-modal-section-title",
                                            children: [
                                                "Previous Outreach (",
                                                outreachCount,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mkt-modal-outreach-log",
                                            children: visitor.outreachLog.map((entry, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mkt-modal-outreach-entry",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-modal-outreach-type",
                                                            children: $69776ea6eb0ca5c8$var$TEMPLATE_LABELS[entry.template] || entry.type
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-modal-outreach-date",
                                                            children: new Date(entry.sentAt).toLocaleDateString()
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-modal-outreach-to",
                                                            children: entry.subject || entry.recipientEmail
                                                        }),
                                                        entry.sentByName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "mkt-modal-outreach-by",
                                                            children: [
                                                                "by ",
                                                                entry.sentByName
                                                            ]
                                                        })
                                                    ]
                                                }, entry.id || i))
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === 'preview' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mkt-modal-preview-pane",
                            children: [
                                previewLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mkt-modal-preview-loading",
                                    children: "Loading preview..."
                                }),
                                previewError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-modal-preview-error",
                                    children: [
                                        "Failed to load preview: ",
                                        previewError
                                    ]
                                }),
                                preview?.html && !previewLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-modal-preview-frame",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-modal-preview-subject",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Subject:"
                                                }),
                                                " ",
                                                subject || preview.subject
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                            title: "Email Preview",
                                            srcDoc: preview.html,
                                            className: "mkt-modal-preview-iframe",
                                            sandbox: "allow-same-origin"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "mkt-modal-hint",
                                            style: {
                                                marginTop: '6px'
                                            },
                                            children: "The button link becomes a personal \u201Ccontinue where you left off\u201D link when sent."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-modal-footer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "mkt-btn mkt-btn-secondary",
                            onClick: onClose,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "mkt-btn mkt-btn-primary",
                            onClick: handleSend,
                            disabled: sendFollowUp.isPending || !preview || !bodyText.trim(),
                            children: sendFollowUp.isPending ? 'Sending...' : `Send to ${firstName}`
                        })
                    ]
                })
            ]
        })
    });
}
function $69776ea6eb0ca5c8$var$getTimeAgo(dateStr) {
    if (!dateStr) return '';
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${Math.max(mins, 1)}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days === 1) return 'yesterday';
    return `${days}d ago`;
}
var $69776ea6eb0ca5c8$export$2e2bcd8739ae039 = $69776ea6eb0ca5c8$var$OutreachModal;


const $3acfea597997146f$var$CLARITY_PROJECT_ID = 'wrbd6q0evd';
const $3acfea597997146f$var$COUNTRY_FLAGS = {
    AU: "\uD83C\uDDE6\uD83C\uDDFA",
    US: "\uD83C\uDDFA\uD83C\uDDF8",
    UK: "\uD83C\uDDEC\uD83C\uDDE7",
    GB: "\uD83C\uDDEC\uD83C\uDDE7",
    ES: "\uD83C\uDDEA\uD83C\uDDF8",
    DE: "\uD83C\uDDE9\uD83C\uDDEA",
    EU: "\uD83C\uDDEA\uD83C\uDDFA",
    NZ: "\uD83C\uDDF3\uD83C\uDDFF",
    CA: "\uD83C\uDDE8\uD83C\uDDE6",
    JP: "\uD83C\uDDEF\uD83C\uDDF5",
    CN: "\uD83C\uDDE8\uD83C\uDDF3",
    KR: "\uD83C\uDDF0\uD83C\uDDF7"
};
const $3acfea597997146f$var$STEP_LABELS = {
    paid: 'Paid',
    quote: 'Quote',
    checkout: 'Checkout',
    details: 'Details',
    countries: 'Countries',
    analysis: 'Analysis',
    business: 'Business',
    start: 'Start',
    landing: 'Landing'
};
const $3acfea597997146f$var$REPORT_BADGES = {
    generating: {
        label: "\uD83D\uDCC4 Report generating",
        background: '#eff6ff',
        color: '#1d4ed8'
    },
    draft: {
        label: "\uD83D\uDCC4 Report ready to review",
        background: '#fffbeb',
        color: '#b45309'
    },
    sent: {
        label: "\uD83D\uDCC4 Report sent",
        background: '#ecfdf5',
        color: '#047857'
    },
    failed: {
        label: "\uD83D\uDCC4 Report failed",
        background: '#fef2f2',
        color: '#dc2626'
    }
};
const $3acfea597997146f$var$REASON_LABELS = {
    price: 'Price',
    not_ready: 'Not ready',
    comparing: 'Comparing',
    question: 'Question',
    other: 'Other'
};
function $3acfea597997146f$var$VisitorCard({ visitor: visitor, selectMode: selectMode, isSelected: isSelected, onToggleSelect: onToggleSelect }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [outreachOpen, setOutreachOpen] = (0, $acw62.useState)(false);
    const updateStatus = (0, $4878203aaaa5eb61$export$d91fdd4f78c535ff)();
    const setReminder = (0, $4878203aaaa5eb61$export$94a11939e0d05a57)();
    const handleClick = ()=>{
        if (selectMode) {
            onToggleSelect?.(visitor.id);
            return;
        }
        navigate(`/marketing/visitor/${visitor.id}`);
    };
    // Engagement signals — visible at a glance so nobody gets double-asked
    const feedbackAskedAt = visitor.feedbackAskedAt || (visitor.outreachLog || []).filter((e)=>e.template === 'wizard_feedback').map((e)=>e.sentAt).sort().pop() || null;
    const hasOpenedEmail = !!visitor.emailOpenedAt || (visitor.outreachLog || []).some((e)=>e.openedAt || e.clickedAt);
    // Next-email guidance is computed by the pipeline endpoint (single source
    // of truth in outreachStages.js) — null when this visitor shouldn't
    // receive outreach.
    const outreachStage = visitor.nextOutreach || null;
    const clarityId = (visitor.userId || '').replace(/^guest:/, '');
    const clarityUrl = `https://clarity.microsoft.com/projects/view/${$3acfea597997146f$var$CLARITY_PROJECT_ID}/impressions?CustomUserId=is%3B${encodeURIComponent(clarityId)}&date=Last%2030%20days`;
    const timeAgo = $3acfea597997146f$var$getTimeAgo(visitor.updatedAt || visitor.createdAt);
    const source = $3acfea597997146f$var$formatSource(visitor.trafficSource, visitor.utmMedium);
    const stepLabel = $3acfea597997146f$var$STEP_LABELS[visitor.currentStep] || visitor.currentStep;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `mkt-card ${selectMode ? 'mkt-card-selectable' : ''} ${isSelected ? 'mkt-card-selected' : ''}`,
        onClick: handleClick,
        children: [
            selectMode && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: `mkt-card-checkbox ${isSelected ? 'checked' : ''}`,
                children: isSelected ? "\u2713" : ''
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-identity",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-card-name",
                        children: visitor.name || visitor.email
                    }),
                    visitor.followUpDue && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-card-due-badge",
                        style: {
                            background: '#fef3c7',
                            color: '#b45309',
                            border: '1px solid #fcd34d',
                            borderRadius: '4px',
                            fontSize: '10px',
                            fontWeight: 700,
                            padding: '1px 6px'
                        },
                        title: "Due for a follow-up",
                        children: "\uD83D\uDD14 DUE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `mkt-card-step-badge mkt-step-${visitor.currentStep}`,
                        title: "Furthest wizard step",
                        children: stepLabel
                    }),
                    visitor.reportStatus && $3acfea597997146f$var$REPORT_BADGES[visitor.reportStatus] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            background: $3acfea597997146f$var$REPORT_BADGES[visitor.reportStatus].background,
                            color: $3acfea597997146f$var$REPORT_BADGES[visitor.reportStatus].color,
                            borderRadius: '4px',
                            fontSize: '10px',
                            fontWeight: 700,
                            padding: '1px 6px',
                            cursor: visitor.reportId ? 'pointer' : 'default'
                        },
                        title: visitor.reportId ? 'Review report' : 'Report status',
                        onClick: (e)=>{
                            if (!visitor.reportId) return;
                            e.stopPropagation();
                            navigate(`/marketing/reports/${visitor.reportId}`);
                        },
                        children: $3acfea597997146f$var$REPORT_BADGES[visitor.reportStatus].label
                    })
                ]
            }),
            visitor.email && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-card-email",
                children: visitor.email
            }),
            visitor.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: `tel:${visitor.phone}`,
                className: "mkt-card-phone",
                onClick: (e)=>e.stopPropagation(),
                title: "Call them",
                children: [
                    "\uD83D\uDCDE ",
                    visitor.phone
                ]
            }),
            visitor.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-trademark",
                children: [
                    "\u201C",
                    visitor.trademarkName,
                    "\u201D",
                    visitor.trademarkType === 'logo' && " \uD83D\uDDBC"
                ]
            }),
            visitor.businessName && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-card-business",
                children: visitor.businessName
            }),
            visitor.industry && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-card-industry",
                children: visitor.industry
            }),
            visitor.businessDescription && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-card-description",
                title: visitor.businessDescription,
                children: visitor.businessDescription.length > 80 ? visitor.businessDescription.substring(0, 80) + '...' : visitor.businessDescription
            }),
            visitor.analysisSummary && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-analysis",
                title: visitor.analysisSummary,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-card-analysis-label",
                        children: "AI:"
                    }),
                    ' ',
                    visitor.analysisSummary.length > 60 ? visitor.analysisSummary.substring(0, 60) + '...' : visitor.analysisSummary
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-meta",
                children: [
                    visitor.countries?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-card-countries",
                        children: visitor.countries.map((c)=>$3acfea597997146f$var$COUNTRY_FLAGS[c?.toUpperCase?.()] || c).join(' ')
                    }),
                    visitor.classCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "mkt-card-classes",
                        children: [
                            visitor.classCount,
                            " class",
                            visitor.classCount !== 1 ? 'es' : ''
                        ]
                    })
                ]
            }),
            visitor.cartValue > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-value",
                children: [
                    "$",
                    visitor.cartValue.toLocaleString()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-badges",
                children: [
                    visitor.riskLevel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `mkt-card-risk mkt-risk-${visitor.riskLevel.toLowerCase()}`,
                        children: visitor.riskLevel
                    }),
                    visitor.isReturning && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-badge mkt-badge-returning",
                        title: "Returning visitor",
                        children: "Returning"
                    }),
                    hasOpenedEmail && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-badge mkt-badge-opened",
                        title: `Opened an email${visitor.lastEmailOpenedAt ? ` (${$3acfea597997146f$var$getTimeAgo(visitor.lastEmailOpenedAt)})` : ''}`,
                        children: "\u2709\uFE0F Opened"
                    }),
                    visitor.feedbackReason && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "mkt-badge mkt-badge-feedback-given",
                        title: "Gave feedback \u2014 see the Feedback tab",
                        children: [
                            "\uD83D\uDCAC ",
                            $3acfea597997146f$var$REASON_LABELS[visitor.feedbackReason] || visitor.feedbackReason
                        ]
                    }),
                    !visitor.feedbackReason && feedbackAskedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "mkt-badge mkt-badge-feedback-asked",
                        title: `Feedback requested ${$3acfea597997146f$var$getTimeAgo(feedbackAskedAt)} \u{2014} bulk send skips them for 30 days`,
                        children: [
                            "\uD83D\uDCAC Asked ",
                            $3acfea597997146f$var$getTimeAgo(feedbackAskedAt)
                        ]
                    })
                ]
            }),
            visitor.previousSessions?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-prev-visit",
                title: visitor.previousSessions.map((p)=>`${$3acfea597997146f$var$getTimeAgo(p.visitedAt)}: reached ${$3acfea597997146f$var$STEP_LABELS[p.step] || p.step || '?'}${p.trademarkName ? ` \u{2014} \u{201C}${p.trademarkName}\u{201D}` : ''}`).join('\n'),
                children: [
                    "\u21A9 Last visit ",
                    $3acfea597997146f$var$getTimeAgo(visitor.previousSessions[0].lastActiveAt || visitor.previousSessions[0].visitedAt),
                    ":",
                    ' ',
                    "reached ",
                    $3acfea597997146f$var$STEP_LABELS[visitor.previousSessions[0].step] || visitor.previousSessions[0].step || '?',
                    visitor.previousSessions[0].trademarkName && visitor.previousSessions[0].trademarkName !== visitor.trademarkName ? ` (\u{201C}${visitor.previousSessions[0].trademarkName}\u{201D})` : '',
                    visitor.previousSessions.length > 1 ? ` \xb7 +${visitor.previousSessions.length - 1} earlier` : ''
                ]
            }),
            visitor.lastContactedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-contacted",
                children: [
                    "Contacted ",
                    $3acfea597997146f$var$getTimeAgo(visitor.lastContactedAt),
                    visitor.outreachLog?.length > 0 && ` (${visitor.outreachLog.length}\xd7)`
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-footer",
                children: [
                    source && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-card-source",
                        children: source
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-card-time",
                        children: timeAgo
                    })
                ]
            }),
            outreachStage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-card-outreach-stage",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "mkt-card-send-btn",
                    onClick: (e)=>{
                        e.stopPropagation();
                        setOutreachOpen(true);
                    },
                    title: `Compose: ${outreachStage.label}`,
                    children: [
                        "\u2709\uFE0F Email ",
                        visitor.name ? visitor.name.split(' ')[0] : 'them'
                    ]
                })
            }),
            ![
                'paid',
                'do_not_contact',
                'not_serious'
            ].includes(visitor.contactStatus) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-quick-actions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-card-quick-btn mkt-quick-snooze",
                        onClick: (e)=>{
                            e.stopPropagation();
                            setReminder.mutate({
                                visitorId: visitor.id,
                                days: 3
                            });
                        },
                        title: "Snooze \u2014 remind me again in 3 days",
                        children: "\u23F0 3d"
                    }),
                    visitor.contactStatus !== 'call' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-card-quick-btn mkt-quick-call",
                        onClick: (e)=>{
                            e.stopPropagation();
                            updateStatus.mutate({
                                visitorId: visitor.id,
                                status: 'call'
                            });
                        },
                        title: "Move to the Call list \u2014 Ali will phone them",
                        children: "\uD83D\uDCDE \u2192 Call list"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-card-quick-btn mkt-quick-not-serious",
                        onClick: (e)=>{
                            e.stopPropagation();
                            if (window.confirm('Mark as Not Serious? This will move them out of the active pipeline.')) updateStatus.mutate({
                                visitorId: visitor.id,
                                status: 'not_serious'
                            });
                        },
                        title: "Not Serious \u2014 just clicking around",
                        children: "\uD83D\uDEAB Not Serious"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-card-quick-btn mkt-quick-dnc",
                        onClick: (e)=>{
                            e.stopPropagation();
                            if (window.confirm('Mark as Do Not Contact? They asked not to be messaged.')) updateStatus.mutate({
                                visitorId: visitor.id,
                                status: 'do_not_contact'
                            });
                        },
                        title: "Do Not Contact \u2014 asked not to be messaged",
                        children: "\u26D4 DNC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card-actions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: clarityUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: (e)=>e.stopPropagation(),
                        className: "mkt-card-action",
                        title: "Watch Clarity session",
                        children: "\uD83D\uDC41"
                    }),
                    visitor.websiteUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: visitor.websiteUrl.startsWith('http') ? visitor.websiteUrl : `https://${visitor.websiteUrl}`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: (e)=>e.stopPropagation(),
                        className: "mkt-card-action",
                        title: "Visit website",
                        children: "\uD83C\uDF10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69776ea6eb0ca5c8$export$2e2bcd8739ae039), {
                visitor: visitor,
                isOpen: outreachOpen,
                onClose: ()=>setOutreachOpen(false)
            })
        ]
    });
}
function $3acfea597997146f$var$formatSource(source, medium) {
    if (!source || source === 'unknown') return null;
    if (source === 'google_ads') return 'Google Ads';
    if (source === 'google_organic') return 'Organic';
    if (source === 'direct') return 'Direct';
    if (medium === 'cpc') return `${source}/cpc`;
    return source;
}
function $3acfea597997146f$var$getTimeAgo(dateStr) {
    if (!dateStr) return '';
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days === 1) return 'yesterday';
    return `${days}d ago`;
}
var $3acfea597997146f$export$2e2bcd8739ae039 = $3acfea597997146f$var$VisitorCard;



function $2127914e5793b91b$var$PipelineColumn({ stage: stage, visitors: visitors, selectMode: selectMode, selected: selected, onToggleSelect: onToggleSelect }) {
    const [downloading, setDownloading] = (0, $acw62.useState)(false);
    // Printable call sheet for the Call list column (one page per lead)
    const handleCallSheet = async (e)=>{
        e.stopPropagation();
        if (downloading) return;
        setDownloading(true);
        try {
            const blob = await (0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).downloadCallSheet();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `MarkoTM Call Sheet ${new Date().toISOString().slice(0, 10)}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            window.alert(`Call sheet download failed: ${err.message}`);
        } finally{
            setDownloading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `mkt-column ${stage.muted ? 'mkt-column-muted' : ''}`,
        style: stage.muted ? {
            opacity: 0.8
        } : undefined,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-column-header",
                style: {
                    borderTopColor: stage.color
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-column-title",
                        children: stage.label
                    }),
                    stage.key === 'call' && visitors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-secondary",
                        style: {
                            fontSize: '11px',
                            padding: '2px 8px',
                            marginLeft: '6px',
                            whiteSpace: 'nowrap'
                        },
                        onClick: handleCallSheet,
                        disabled: downloading,
                        title: "Download the printable call sheet (one page per lead, max 50)",
                        children: downloading ? "\u23F3\u2026" : `\u{1F4C4} Call sheet (${visitors.length})`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-column-count",
                        children: visitors.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-column-body",
                children: visitors.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mkt-column-empty",
                    children: "No visitors"
                }) : visitors.map((visitor)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3acfea597997146f$export$2e2bcd8739ae039), {
                        visitor: visitor,
                        stageColor: stage.color,
                        selectMode: selectMode,
                        isSelected: selected?.has(visitor.id),
                        onToggleSelect: onToggleSelect
                    }, visitor.id))
            })
        ]
    });
}
var $2127914e5793b91b$export$2e2bcd8739ae039 = $2127914e5793b91b$var$PipelineColumn;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $380ada94429c8e90$var$TIME_OPTIONS = [
    {
        value: '',
        label: 'All Time'
    },
    {
        value: '7',
        label: 'Last 7 Days'
    },
    {
        value: '14',
        label: 'Last 14 Days'
    },
    {
        value: '30',
        label: 'Last 30 Days'
    },
    {
        value: '90',
        label: 'Last 90 Days'
    },
    {
        value: 'custom',
        label: "Custom Dates\u2026"
    }
];
const $380ada94429c8e90$var$STEP_OPTIONS = [
    {
        value: '',
        label: 'All Steps'
    },
    {
        value: 'quote',
        label: 'Requested Quote'
    },
    {
        value: 'checkout',
        label: 'Reached Checkout'
    },
    {
        value: 'analysis',
        label: 'Reached Analysis'
    },
    {
        value: 'business',
        label: 'Reached Business'
    },
    {
        value: 'start',
        label: 'Started Only'
    }
];
const $380ada94429c8e90$var$SOURCE_OPTIONS = [
    {
        value: '',
        label: 'All Sources'
    },
    {
        value: 'google_ads',
        label: 'Google Ads'
    },
    {
        value: 'google_organic',
        label: 'Google Organic'
    },
    {
        value: 'direct',
        label: 'Direct'
    },
    {
        value: 'facebook',
        label: 'Facebook'
    },
    {
        value: 'linkedin',
        label: 'LinkedIn'
    }
];
// value formats: '' any · 'N' quiet ≥N days · 'N-M' active between N and M days ago
const $380ada94429c8e90$var$ACTIVITY_OPTIONS = [
    {
        value: '',
        label: 'Any Activity'
    },
    {
        value: '2',
        label: 'Quiet 2+ Days'
    },
    {
        value: '3',
        label: 'Quiet 3+ Days'
    },
    {
        value: '7',
        label: 'Quiet 7+ Days'
    },
    {
        value: '14',
        label: 'Quiet 14+ Days'
    },
    {
        value: '30',
        label: 'Quiet 30+ Days'
    },
    {
        value: '30-60',
        label: "30\u201360 Days Ago"
    },
    {
        value: '60-90',
        label: "60\u201390 Days Ago"
    },
    {
        value: 'custom',
        label: "Custom Range\u2026"
    }
];
function $380ada94429c8e90$var$PipelineFilters({ filters: filters, onChange: onChange }) {
    const [timeMode, setTimeMode] = (0, $acw62.useState)(filters.startDate ? 'custom' : filters.days || '');
    const [activityMode, setActivityMode] = (0, $acw62.useState)(()=>{
        if (filters.quietDays && filters.activeWithinDays) {
            const preset = `${filters.quietDays}-${filters.activeWithinDays}`;
            return $380ada94429c8e90$var$ACTIVITY_OPTIONS.some((o)=>o.value === preset) ? preset : 'custom';
        }
        return filters.quietDays || '';
    });
    const [customFrom, setCustomFrom] = (0, $acw62.useState)(filters.quietDays || '');
    const [customTo, setCustomTo] = (0, $acw62.useState)(filters.activeWithinDays || '');
    const apply = (patch, removals = [])=>{
        const next = {
            ...filters
        };
        removals.forEach((k)=>delete next[k]);
        Object.entries(patch).forEach(([k, v])=>{
            if (v) next[k] = v;
            else delete next[k];
        });
        onChange(next);
    };
    const handleChange = (key, value)=>apply({
            [key]: value
        });
    const handleTimeMode = (value)=>{
        setTimeMode(value);
        if (value === 'custom') // Wait for both dates before applying
        apply({}, [
            'days'
        ]);
        else apply({
            days: value
        }, [
            'startDate',
            'endDate'
        ]);
    };
    const handleCustomDates = (which, value)=>{
        const startDate = which === 'start' ? value : filters.startDate;
        const endDate = which === 'end' ? value : filters.endDate;
        apply({
            startDate: startDate,
            endDate: endDate
        }, [
            'days'
        ]);
    };
    const handleActivityMode = (value)=>{
        setActivityMode(value);
        if (value === 'custom') {
            if (customFrom && customTo) apply({
                quietDays: customFrom,
                activeWithinDays: customTo
            });
            return;
        }
        if (value.includes('-')) {
            const [from, to] = value.split('-');
            apply({
                quietDays: from,
                activeWithinDays: to
            });
        } else apply({
            quietDays: value
        }, [
            'activeWithinDays'
        ]);
    };
    const handleCustomActivity = (which, value)=>{
        const from = which === 'from' ? value : customFrom;
        const to = which === 'to' ? value : customTo;
        if (which === 'from') setCustomFrom(value);
        else setCustomTo(value);
        // Apply once at least the lower bound is set; upper bound optional
        if (from) apply({
            quietDays: from,
            activeWithinDays: to || ''
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-filters",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-filter-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mkt-filter-label",
                        children: "Time"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        className: "mkt-filter-select",
                        value: timeMode,
                        onChange: (e)=>handleTimeMode(e.target.value),
                        children: $380ada94429c8e90$var$TIME_OPTIONS.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, o.value))
                    })
                ]
            }),
            timeMode === 'custom' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-filter-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mkt-filter-label",
                        children: "Created Between"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-filter-inline",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "date",
                                className: "mkt-date-input",
                                value: filters.startDate || '',
                                onChange: (e)=>handleCustomDates('start', e.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "\u2013"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "date",
                                className: "mkt-date-input",
                                value: filters.endDate || '',
                                onChange: (e)=>handleCustomDates('end', e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-filter-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mkt-filter-label",
                        children: "Wizard Step"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        className: "mkt-filter-select",
                        value: filters.maxStep || '',
                        onChange: (e)=>handleChange('maxStep', e.target.value),
                        children: $380ada94429c8e90$var$STEP_OPTIONS.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, o.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-filter-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mkt-filter-label",
                        children: "Source"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        className: "mkt-filter-select",
                        value: filters.source || '',
                        onChange: (e)=>handleChange('source', e.target.value),
                        children: $380ada94429c8e90$var$SOURCE_OPTIONS.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, o.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-filter-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mkt-filter-label",
                        children: "Last Activity"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        className: "mkt-filter-select",
                        value: activityMode,
                        onChange: (e)=>handleActivityMode(e.target.value),
                        children: $380ada94429c8e90$var$ACTIVITY_OPTIONS.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, o.value))
                    })
                ]
            }),
            activityMode === 'custom' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-filter-group",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mkt-filter-label",
                        children: "Between (Days Ago)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-filter-inline",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "number",
                                min: "0",
                                placeholder: "30",
                                className: "mkt-days-input",
                                value: customFrom,
                                onChange: (e)=>handleCustomActivity('from', e.target.value),
                                title: "Last activity at least this many days ago"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "\u2013"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "number",
                                min: "0",
                                placeholder: "60",
                                className: "mkt-days-input",
                                value: customTo,
                                onChange: (e)=>handleCustomActivity('to', e.target.value),
                                title: "Last activity at most this many days ago"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $380ada94429c8e90$export$2e2bcd8739ae039 = $380ada94429c8e90$var$PipelineFilters;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $63f5d9cd2bc49fc9$var$PipelineSummary({ summary: summary }) {
    const formatCurrency = (val)=>{
        if (!val && val !== 0) return '$0';
        return `$${val.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })}`;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-summary",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: summary.totalLeads || 0
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Total Leads"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card mkt-summary-alert",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: summary.notContacted || 0
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Awaiting Report"
                    })
                ]
            }),
            summary.callList > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: summary.callList
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Call List"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: summary.reachedCheckout || 0
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Reached Checkout"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: summary.returningVisitors || 0
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Returning"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card mkt-summary-success",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: summary.paid || 0
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Paid"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card mkt-summary-success",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-value",
                        children: formatCurrency(summary.revenue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Revenue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-summary-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-value",
                        children: [
                            summary.conversionRate || 0,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-summary-label",
                        children: "Lead Conversion"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-sub",
                        children: [
                            "paid, of ",
                            summary.totalLeads || 0,
                            " people who gave their details"
                        ]
                    })
                ]
            })
        ]
    });
}
var $63f5d9cd2bc49fc9$export$2e2bcd8739ae039 = $63f5d9cd2bc49fc9$var$PipelineSummary;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $c09132995329457b$var$OUTREACH_STAGES = [
    {
        key: 'intro',
        icon: "\uD83D\uDC4B",
        label: 'First Contact (legacy)',
        template: 'wizard_follow_up',
        color: '#3b82f6',
        trigger: 'LEGACY: pre-report-first visitors who started the wizard but hadn\'t completed analysis',
        description: "A short personal hello \u2014 you saw they started, everything is saved, and you're happy to help. Edit the draft to mention something about their business.",
        sends: 'Editable personal note + continue link + your signature'
    },
    {
        key: 'report',
        icon: "\uD83D\uDCCA",
        label: 'Analysis Report',
        template: 'wizard_report_follow_up',
        color: '#0f766e',
        trigger: 'Visitor completed AI analysis but didn\'t proceed to file',
        description: "Their trademark report, delivered personally \u2014 risk level, conflicts, classes, recommendation, with an offer to walk them through it.",
        sends: 'Editable personal note + full analysis report card (toggleable) + continue link + your signature'
    },
    {
        key: 'quote_report',
        icon: "\uD83D\uDCC4",
        label: 'Report & Quote',
        template: 'quote_report',
        color: '#0f766e',
        trigger: "Visitor requested their free report \u2014 sent from the Reports section after review (24h SLA)",
        description: 'The formal report: live IP Australia register findings, coverage rationale and their confirmed quote, with a dashboard sign-in link (no password needed). Competing outreach is suppressed while a report is in the queue.',
        sends: 'Editable personal note + full report & quote card + fresh dashboard magic link + your signature'
    },
    {
        key: 'quote_nudge',
        icon: "\uD83D\uDCB3",
        label: 'First Nudge',
        template: 'quote_follow_up',
        color: '#d97706',
        trigger: 'Report sent but no payment after a few days',
        description: 'A gentle reminder that their report and confirmed quote are waiting in their dashboard, with the first-to-file rationale and an offer to resend the sign-in link.',
        sends: 'Editable personal note + dashboard link + your signature'
    },
    {
        key: 'checkout',
        icon: "\uD83D\uDED2",
        label: 'Checkout Nudge (legacy)',
        template: 'wizard_checkout_follow_up',
        color: '#d97706',
        trigger: 'LEGACY: pre-quote-first visitors who reached countries/details/checkout but didn\'t pay. Not recommended for new-flow visitors.',
        description: 'A friendly "you were almost done" \u2014 their selections are saved, attorney review reassurance, and an invitation to ask what held them back.',
        sends: 'Editable personal note + their filing summary (toggleable) + continue link + your signature'
    },
    {
        key: 'second',
        icon: "\u23F0",
        label: 'Second Nudge (final note)',
        template: 'wizard_second_follow_up',
        color: '#8b5cf6',
        trigger: "Already nudged once \u2014 this is the last email in the sequence",
        description: 'A respectful sign-off: "this will be my last note". Mentions first-to-file and any flagged conflicts, without pressure tactics.',
        sends: 'Editable personal note + first-to-file context + continue link + your signature'
    }
];
function $c09132995329457b$var$OutreachStageLegend() {
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-outreach-legend",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-outreach-legend-header",
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "mkt-outreach-legend-title",
                        children: [
                            "Outreach Stages",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "mkt-outreach-legend-count",
                                children: [
                                    $c09132995329457b$var$OUTREACH_STAGES.length,
                                    " templates"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-outreach-legend-toggle",
                        children: expanded ? "\u25BE Hide" : "\u25B8 Show Guide"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-outreach-legend-badges",
                children: [
                    $c09132995329457b$var$OUTREACH_STAGES.map((stage)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "mkt-outreach-legend-badge",
                            style: {
                                background: stage.color + '12',
                                color: stage.color,
                                borderColor: stage.color + '30'
                            },
                            title: stage.trigger,
                            children: [
                                stage.icon,
                                " ",
                                stage.label
                            ]
                        }, stage.key)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-outreach-legend-arrow",
                        children: "\u2192"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-outreach-legend-badge",
                        style: {
                            background: '#0ea5e912',
                            color: '#0ea5e9',
                            borderColor: '#0ea5e930'
                        },
                        title: "No email \u2014 worked by phone via the printable call sheet",
                        children: "\uD83D\uDCDE Call list"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-outreach-legend-badge",
                        style: {
                            background: '#64748b12',
                            color: '#64748b',
                            borderColor: '#64748b30'
                        },
                        title: "Feedback asked \u2014 waiting on their answer, no further nudges",
                        children: "\uD83D\uDCAC Feedback"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-outreach-legend-arrow",
                        children: "\u2192"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mkt-outreach-legend-badge",
                        style: {
                            background: '#22c55e15',
                            color: '#16a34a',
                            borderColor: '#22c55e30'
                        },
                        children: "\u2705 Paid"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-outreach-legend-detail",
                children: [
                    $c09132995329457b$var$OUTREACH_STAGES.map((stage)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mkt-outreach-legend-item",
                            style: {
                                borderLeftColor: stage.color
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-outreach-legend-item-header",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mkt-outreach-legend-item-icon",
                                            children: stage.icon
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    className: "mkt-outreach-legend-item-label",
                                                    children: stage.label
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                                    className: "mkt-outreach-legend-item-template",
                                                    children: stage.template
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-outreach-legend-item-trigger",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "When:"
                                        }),
                                        " ",
                                        stage.trigger
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mkt-outreach-legend-item-desc",
                                    children: stage.description
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-outreach-legend-item-sends",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Includes:"
                                        }),
                                        " ",
                                        stage.sends
                                    ]
                                })
                            ]
                        }, stage.key)),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-outreach-legend-note",
                        children: [
                            "Emails go out ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "signed as you"
                            }),
                            " \u2014 the sending address is shown in the composer, and replies land in that inbox. Every template is just a starting draft: edit anything before sending. All emails include a ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "continue token"
                            }),
                            " \u2014 clicking the CTA auto-restores the visitor's session to their exact wizard step. No login required."
                        ]
                    })
                ]
            })
        ]
    });
}
var $c09132995329457b$export$2e2bcd8739ae039 = $c09132995329457b$var$OutreachStageLegend;


// Report-first workflow. Legacy `first_contact` records are bucketed into
// the Report sent column by the pipeline endpoint (stored values are never
// rewritten). `not_contacted` = quote-requesters awaiting their report —
// actioned via the Reports queue, so the column renders muted.
const $8007d7fb2c6943e7$var$STAGES = [
    {
        key: 'not_contacted',
        label: 'Awaiting report',
        color: '#f59e0b',
        muted: true
    },
    {
        key: 'report_sent',
        label: 'Report sent',
        color: '#0f766e'
    },
    {
        key: 'checkout_nudge',
        label: 'First nudge',
        color: '#d97706'
    },
    {
        key: 'second_contact',
        label: 'Second nudge',
        color: '#8b5cf6'
    },
    {
        key: 'call',
        label: 'Call list',
        color: '#0ea5e9'
    },
    {
        key: 'feedback',
        label: 'Feedback',
        color: '#64748b'
    },
    {
        key: 'responded',
        label: 'Responded',
        color: '#10b981'
    },
    {
        key: 'paid',
        label: 'Paid',
        color: '#22c55e'
    },
    {
        key: 'do_not_contact',
        label: 'Do Not Contact',
        color: '#ef4444'
    },
    {
        key: 'not_serious',
        label: 'Not Serious',
        color: '#94a3b8'
    }
];
function $8007d7fb2c6943e7$var$Pipeline() {
    const [filters, setFilters] = (0, $acw62.useState)({});
    const [dueOnly, setDueOnly] = (0, $acw62.useState)(false);
    const [selectMode, setSelectMode] = (0, $acw62.useState)(false);
    const [selected, setSelected] = (0, $acw62.useState)(()=>new Set());
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $4878203aaaa5eb61$export$88523eff58ffa0ce)(filters);
    const bulkFeedback = (0, $4878203aaaa5eb61$export$120815dedd6f182a)();
    const boardRef = (0, $acw62.useRef)(null);
    const scrollBoard = (dir)=>{
        boardRef.current?.scrollBy({
            left: dir * 640,
            behavior: 'smooth'
        });
    };
    const toggleSelect = (visitorId)=>{
        setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(visitorId)) next.delete(visitorId);
            else next.add(visitorId);
            return next;
        });
    };
    const exitSelectMode = ()=>{
        setSelectMode(false);
        setSelected(new Set());
    };
    const handleBulkSend = async ()=>{
        const ids = Array.from(selected);
        if (ids.length === 0) return;
        if (!window.confirm(`Send the feedback-ask email to ${ids.length} selected ${ids.length === 1 ? 'person' : 'people'}?\n\nAnyone already asked in the last 30 days, who already gave feedback, or who is DNC/paid will be skipped automatically.`)) return;
        try {
            const result = await bulkFeedback.mutateAsync(ids);
            const { summary: summary, skipped: skipped } = result;
            const skippedDetail = (skipped || []).slice(0, 8).map((s)=>`\u{2022} ${s.email || s.visitorId}: ${s.reason}`).join('\n');
            window.alert(`Feedback ask sent to ${summary.sent} ${summary.sent === 1 ? 'person' : 'people'}.\nSkipped ${summary.skipped}, failed ${summary.failed}.${skippedDetail ? `\n\nSkipped:\n${skippedDetail}` : ''}`);
            exitSelectMode();
        } catch (err) {
            window.alert(`Bulk send failed: ${err.message}`);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-pipeline-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading pipeline..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-pipeline-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Failed to load pipeline data"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                className: "mkt-btn mkt-btn-secondary",
                children: "Retry"
            })
        ]
    });
    const { pipeline: pipeline = {}, summary: summary = {} } = data || {};
    const dueCount = summary.followUpsDue || 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-pipeline",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-pipeline-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $380ada94429c8e90$export$2e2bcd8739ae039), {
                        filters: filters,
                        onChange: setFilters
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>selectMode ? exitSelectMode() : setSelectMode(true),
                        className: `mkt-btn ${selectMode ? 'mkt-btn-primary' : 'mkt-btn-secondary'}`,
                        title: "Select people to send a bulk feedback ask",
                        style: {
                            whiteSpace: 'nowrap'
                        },
                        children: selectMode ? "\u2715 Cancel selection" : "\u2611\uFE0F Bulk select"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>refetch(),
                        className: "mkt-btn mkt-btn-icon",
                        title: "Refresh",
                        children: "\uD83D\uDD04"
                    })
                ]
            }),
            selectMode && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-bulk-bar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: selected.size
                            }),
                            " selected \u2014 tap cards to select. Tip: use the",
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                children: "Last Activity"
                            }),
                            " filter to find people who went quiet a while ago."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-primary",
                        disabled: selected.size === 0 || bulkFeedback.isPending,
                        onClick: handleBulkSend,
                        children: bulkFeedback.isPending ? "Sending\u2026" : `\u{1F4AC} Send feedback ask (${selected.size})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-pipeline-due-banner",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    margin: '8px 0',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    background: dueCount > 0 ? '#fffbeb' : '#f8fafc',
                    border: `1px solid ${dueCount > 0 ? '#fcd34d' : '#e2e8f0'}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '14px',
                            color: '#334155'
                        },
                        children: dueCount > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                    children: [
                                        "\uD83D\uDD14 ",
                                        dueCount,
                                        " ",
                                        dueCount === 1 ? 'person needs' : 'people need',
                                        " a follow-up"
                                    ]
                                }),
                                " \u2014 they're sorted to the top of each column."
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "\u2705 No follow-ups due right now."
                        })
                    }),
                    dueCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-secondary",
                        style: {
                            marginLeft: 'auto',
                            fontSize: '12px',
                            padding: '4px 12px'
                        },
                        onClick: ()=>setDueOnly(!dueOnly),
                        children: dueOnly ? 'Show everyone' : 'Show only due'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63f5d9cd2bc49fc9$export$2e2bcd8739ae039), {
                summary: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c09132995329457b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-board-wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-board-arrow left",
                        onClick: ()=>scrollBoard(-1),
                        "aria-label": "Scroll board left",
                        children: "\u2039"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-pipeline-board",
                        ref: boardRef,
                        children: $8007d7fb2c6943e7$var$STAGES.map((stage)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2127914e5793b91b$export$2e2bcd8739ae039), {
                                stage: stage,
                                visitors: (pipeline[stage.key] || []).filter((v)=>!dueOnly || v.followUpDue),
                                selectMode: selectMode,
                                selected: selected,
                                onToggleSelect: toggleSelect
                            }, stage.key))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-board-arrow right",
                        onClick: ()=>scrollBoard(1),
                        "aria-label": "Scroll board right",
                        children: "\u203A"
                    })
                ]
            })
        ]
    });
}
var $8007d7fb2c6943e7$export$2e2bcd8739ae039 = $8007d7fb2c6943e7$var$Pipeline;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $e66b5f48c3a9961f$var$DATE_PRESETS = [
    {
        label: '24h',
        value: '1'
    },
    {
        label: '48h',
        value: '2'
    },
    {
        label: '3 days',
        value: '3'
    },
    {
        label: '7 days',
        value: '7'
    },
    {
        label: '30 days',
        value: '30'
    },
    {
        label: '90 days',
        value: '90'
    },
    {
        label: 'Custom',
        value: 'custom'
    }
];
function $e66b5f48c3a9961f$var$Funnel() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [selectedPreset, setSelectedPreset] = (0, $acw62.useState)('30');
    const [customStart, setCustomStart] = (0, $acw62.useState)('');
    const [customEnd, setCustomEnd] = (0, $acw62.useState)('');
    const [expandedStep, setExpandedStep] = (0, $acw62.useState)(null);
    const [campaignFilter, setCampaignFilter] = (0, $acw62.useState)('');
    const [selectedTile, setSelectedTile] = (0, $acw62.useState)(null);
    const fetchFunnel = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const params = {};
            if (selectedPreset === 'custom' && customStart && customEnd) {
                params.startDate = customStart;
                params.endDate = customEnd;
            } else params.days = selectedPreset;
            const response = await (0, $78f4fc768f4bd121$export$2e2bcd8739ae039).get('/marketing/funnel', {
                params: params
            });
            setData(response.data);
        } catch (err) {
            setError(err.message);
        } finally{
            setLoading(false);
        }
    }, [
        selectedPreset,
        customStart,
        customEnd
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedPreset !== 'custom' || customStart && customEnd) fetchFunnel();
    }, [
        fetchFunnel
    ]);
    const handlePresetChange = (val)=>{
        setSelectedPreset(val);
        setExpandedStep(null);
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading funnel data..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-funnel-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Failed to load funnel: ",
                    error
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: fetchFunnel,
                className: "mkt-btn mkt-btn-primary",
                children: "Retry"
            })
        ]
    });
    const { funnel: funnel = [], summary: summary = {} } = data || {};
    // Campaign filter options come from the loaded visitors (ad-resolved
    // campaign preferred, UTM campaign as fallback)
    const campaigns = [
        ...new Set(funnel.flatMap((s)=>(s.visitors || []).map((v)=>v.adCampaign || v.utmCampaign).filter(Boolean)))
    ].sort();
    const matchesCampaign = (v)=>!campaignFilter || (v.adCampaign || v.utmCampaign) === campaignFilter;
    // Flattened people with their furthest-step index, for tile drill-downs
    const allPeople = funnel.flatMap((s, i)=>(s.visitors || []).map((v)=>({
                ...v,
                stepIndex: i,
                stepId: s.id,
                stepName: s.name
            })));
    // Tiles are keyed by step id, resolved against the funnel the API returned —
    // no positional index literals (inserting a funnel step must never shift these).
    const stepIndexById = Object.fromEntries(funnel.map((s, i)=>[
            s.id,
            i
        ]));
    const stepById = Object.fromEntries(funnel.map((s)=>[
            s.id,
            s
        ]));
    const TILES = [
        {
            key: 'landed',
            label: 'Landed',
            stepId: 'landing'
        },
        {
            key: 'started',
            label: 'Started',
            stepId: 'start'
        },
        {
            key: 'business',
            label: 'Business',
            stepId: 'business'
        },
        {
            key: 'analysis',
            label: 'Analysis',
            stepId: 'analysis'
        },
        {
            key: 'quote',
            label: 'Quote',
            stepId: 'quote'
        },
        {
            key: 'paid',
            label: 'Paid',
            stepId: 'paid'
        },
        {
            key: 'returning',
            label: 'Returning',
            stepId: null
        }
    ];
    const tileCohort = (tile)=>{
        if (!tile) return [];
        if (tile.key === 'returning') return allPeople.filter((p)=>p.isReturning);
        return allPeople.filter((p)=>p.stepIndex >= (stepIndexById[tile.stepId] ?? Infinity));
    };
    const tileCount = (tile)=>tile.key === 'returning' ? summary.returningVisitors || 0 : stepById[tile.stepId]?.reached ?? 0;
    const tilePct = (tile)=>tile.key === 'returning' || tile.key === 'landed' ? null : summary.pctOfLanded?.[tile.key] ?? null;
    const activeTile = TILES.find((t)=>t.key === selectedTile) || null;
    // Keyword × stage matrix: how many visitors on each search keyword reached
    // each funnel stage (cumulative, same semantics as the summary tiles).
    // Campaign filter applies; visitors with no keyword aren't shown.
    const keywordSteps = TILES.filter((t)=>t.stepId !== null);
    const paidCol = keywordSteps.findIndex((t)=>t.key === 'paid');
    const keywordRows = (()=>{
        const byKw = new Map();
        for (const p of allPeople){
            if (!matchesCampaign(p)) continue;
            const kw = p.adKeyword || p.utmTerm;
            if (!kw) continue;
            let row = byKw.get(kw);
            if (!row) {
                row = {
                    keyword: kw,
                    adGroup: p.adGroup || null,
                    counts: Array(keywordSteps.length).fill(0)
                };
                byKw.set(kw, row);
            }
            // Count this person into every tile column at or below their furthest step
            keywordSteps.forEach((t, i)=>{
                if ((stepIndexById[t.stepId] ?? Infinity) <= p.stepIndex) row.counts[i]++;
            });
        }
        return [
            ...byKw.values()
        ].sort((a, b)=>b.counts[0] - a.counts[0] || b.counts[paidCol] - a.counts[paidCol]);
    })();
    // Registration likelihood badge (values like HIGH / MODERATE / LOW / VERY_LOW)
    const likelihoodStyle = (val)=>{
        const v = String(val).toLowerCase();
        if (v.includes('very_low') || v.includes('very low') || v.includes('low')) return {
            background: '#fef2f2',
            color: '#dc2626'
        };
        if (v.includes('moderate') || v.includes('medium')) return {
            background: '#fffbeb',
            color: '#b45309'
        };
        if (v.includes('high') || v.includes('likely')) return {
            background: '#ecfdf5',
            color: '#047857'
        };
        return {
            background: '#f1f5f9',
            color: '#64748b'
        };
    };
    const websiteChip = (v, reachedStart)=>{
        if (v.websiteUrl) {
            const domain = v.websiteUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: v.websiteUrl.startsWith('http') ? v.websiteUrl : `https://${v.websiteUrl}`,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (e)=>e.stopPropagation(),
                className: "mkt-visitor-mode",
                style: {
                    background: '#f0fdfa',
                    color: '#0f766e',
                    textDecoration: 'none'
                },
                title: "Open their website",
                children: [
                    "\uD83C\uDF10 ",
                    domain.length > 30 ? domain.slice(0, 30) + "\u2026" : domain
                ]
            });
        }
        // Only meaningful once they passed the "do you have a website?" step
        if (reachedStart) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "mkt-visitor-mode",
            style: {
                color: '#94a3b8'
            },
            children: "no website"
        });
        return null;
    };
    const contactLabel = (p)=>{
        if (p.contactStatus === 'do_not_contact') return "\u26D4 DNC";
        if (p.outreachCount > 0) return `\u{2709}\u{FE0F} Contacted ${p.outreachCount}\xd7${p.lastContactedAt ? ` \xb7 ${$e66b5f48c3a9961f$var$timeAgoShort(p.lastContactedAt)}` : ''}`;
        return 'Not contacted';
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-funnel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Wizard Funnel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-funnel-filters",
                        children: [
                            $e66b5f48c3a9961f$var$DATE_PRESETS.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `mkt-filter-btn ${selectedPreset === p.value ? 'active' : ''}`,
                                    onClick: ()=>handlePresetChange(p.value),
                                    children: p.label
                                }, p.value)),
                            campaigns.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                className: "mkt-filter-select",
                                value: campaignFilter,
                                onChange: (e)=>setCampaignFilter(e.target.value),
                                title: "Filter visitor lists by ad campaign",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "All Campaigns"
                                    }),
                                    campaigns.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                            value: c,
                                            children: [
                                                "\uD83D\uDCE2 ",
                                                c
                                            ]
                                        }, c))
                                ]
                            })
                        ]
                    })
                ]
            }),
            selectedPreset === 'custom' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-custom-dates",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "date",
                        value: customStart,
                        onChange: (e)=>setCustomStart(e.target.value),
                        className: "mkt-date-input"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "to"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "date",
                        value: customEnd,
                        onChange: (e)=>setCustomEnd(e.target.value),
                        className: "mkt-date-input"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-primary",
                        onClick: fetchFunnel,
                        disabled: !customStart || !customEnd,
                        children: "Apply"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-summary",
                children: [
                    TILES.map((tile)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `mkt-summary-card mkt-feedback-card ${selectedTile === tile.key ? 'active' : ''}`,
                            onClick: ()=>setSelectedTile(selectedTile === tile.key ? null : tile.key),
                            title: "Click to see who",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mkt-summary-label",
                                    children: tile.label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mkt-summary-value",
                                    children: tileCount(tile).toLocaleString()
                                }),
                                tilePct(tile) !== null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "mkt-summary-rate",
                                    children: [
                                        tilePct(tile),
                                        "% of landed"
                                    ]
                                }),
                                tile.key === 'landed' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mkt-summary-rate",
                                    children: "everyone who arrived"
                                }),
                                tile.key !== 'returning' && tile.key !== 'paid' && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "mkt-summary-rate",
                                    style: {
                                        color: '#dc2626'
                                    },
                                    children: [
                                        (stepById[tile.stepId]?.count ?? 0).toLocaleString(),
                                        " stopped here"
                                    ]
                                })
                            ]
                        }, tile.key)),
                    summary.ga4Traffic?.sessions > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-label",
                                children: "GA4 Sessions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-value",
                                children: summary.ga4Traffic.sessions.toLocaleString()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "mkt-summary-rate",
                                children: [
                                    summary.ga4Traffic.users,
                                    " users"
                                ]
                            })
                        ]
                    })
                ]
            }),
            activeTile && (()=>{
                const cohort = tileCohort(activeTile).filter(matchesCampaign).sort((a, b)=>b.stepIndex - a.stepIndex || new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-funnel-visitors",
                    style: {
                        marginBottom: '16px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mkt-funnel-visitors-header",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        activeTile.key === 'returning' ? 'Returning visitors' : `Reached ${activeTile.label}`,
                                        " (",
                                        cohort.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-btn mkt-btn-secondary",
                                    style: {
                                        fontSize: '12px',
                                        padding: '2px 10px'
                                    },
                                    onClick: ()=>setSelectedTile(null),
                                    children: "\u2715 Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mkt-funnel-visitors-list",
                            children: cohort.slice(0, 100).map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-funnel-visitor-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-funnel-visitor-info",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-visitor-name",
                                                    children: p.name || p.email || p.trademarkName || (p.tempUserId || p.browseId || '').slice(0, 12)
                                                }),
                                                p.email && p.name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-visitor-date",
                                                    children: p.email
                                                }),
                                                p.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-visitor-tm",
                                                    children: p.trademarkName
                                                }),
                                                websiteChip(p, p.stepIndex >= 1),
                                                p.registrationLikelihood && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "mkt-visitor-mode",
                                                    style: likelihoodStyle(p.registrationLikelihood),
                                                    title: "AI registration likelihood",
                                                    children: [
                                                        "AI: ",
                                                        String(p.registrationLikelihood).replace(/_/g, ' ')
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-visitor-mode",
                                                    children: p.stepName
                                                }),
                                                p.isReturning && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-badge mkt-badge-returning",
                                                    children: "Returning"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "mkt-visitor-date",
                                                    style: p.outreachCount > 0 ? {
                                                        color: '#047857',
                                                        fontWeight: 600
                                                    } : {
                                                        color: '#b45309'
                                                    },
                                                    children: contactLabel(p)
                                                }),
                                                (p.adName || p.adGroup || p.adCampaign || p.utmCampaign) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "mkt-visitor-mode",
                                                    style: {
                                                        background: '#eff6ff',
                                                        color: '#1d4ed8'
                                                    },
                                                    children: [
                                                        "\uD83D\uDCE2 ",
                                                        p.adName || p.adGroup || p.adCampaign || p.utmCampaign
                                                    ]
                                                }),
                                                (p.adKeyword || p.utmTerm) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "mkt-visitor-mode",
                                                    style: {
                                                        background: '#f0fdf4',
                                                        color: '#15803d'
                                                    },
                                                    title: p.adMatchType ? `Search keyword (${String(p.adMatchType).toLowerCase()} match)` : 'Search keyword',
                                                    children: [
                                                        "\uD83D\uDD0D ",
                                                        p.adKeyword || p.utmTerm
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mkt-funnel-visitor-actions",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "mkt-btn-icon",
                                                onClick: ()=>navigate(`/marketing/visitor/${p.id}`),
                                                title: "View profile",
                                                children: "\u2192"
                                            })
                                        })
                                    ]
                                }, p.id))
                        })
                    ]
                });
            })(),
            keywordRows.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-visitors",
                style: {
                    marginBottom: '16px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-funnel-visitors-header",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                "\uD83D\uDD0D Keywords (",
                                keywordRows.length,
                                campaignFilter ? ` \u{2014} ${campaignFilter}` : '',
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            overflowX: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            style: {
                                width: '100%',
                                borderCollapse: 'collapse',
                                fontSize: '13px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            color: '#64748b'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                style: {
                                                    textAlign: 'left',
                                                    padding: '8px 12px',
                                                    fontWeight: 600
                                                },
                                                children: "Keyword"
                                            }),
                                            keywordSteps.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        textAlign: 'right',
                                                        padding: '8px 12px',
                                                        fontWeight: 600
                                                    },
                                                    children: s.label
                                                }, s.key)),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                style: {
                                                    textAlign: 'right',
                                                    padding: '8px 12px',
                                                    fontWeight: 600
                                                },
                                                title: "Paid as % of landed",
                                                children: "Paid %"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: keywordRows.map((r)=>{
                                        const paidPct = r.counts[0] ? Math.round(r.counts[paidCol] / r.counts[0] * 100) : 0;
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            style: {
                                                borderTop: '1px solid #f1f5f9'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    style: {
                                                        padding: '8px 12px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                color: '#15803d',
                                                                fontWeight: 600
                                                            },
                                                            children: r.keyword
                                                        }),
                                                        r.adGroup && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                color: '#94a3b8',
                                                                marginLeft: '8px',
                                                                fontSize: '12px'
                                                            },
                                                            children: r.adGroup
                                                        })
                                                    ]
                                                }),
                                                r.counts.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            textAlign: 'right',
                                                            padding: '8px 12px',
                                                            color: c ? i === paidCol ? '#047857' : '#0f172a' : '#cbd5e1',
                                                            fontWeight: i === paidCol && c ? 700 : 400
                                                        },
                                                        children: c || "\u2013"
                                                    }, i)),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        textAlign: 'right',
                                                        padding: '8px 12px',
                                                        color: paidPct ? '#047857' : '#cbd5e1',
                                                        fontWeight: paidPct ? 700 : 400
                                                    },
                                                    children: paidPct ? `${paidPct}%` : "\u2013"
                                                })
                                            ]
                                        }, r.keyword);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-funnel-steps",
                children: funnel.map((step, i)=>{
                    const isExpanded = expandedStep === step.id;
                    const maxCount = funnel[0]?.reached || funnel[0]?.count || 1;
                    const barWidth = Math.max(5, (step.reached ?? step.count) / maxCount * 100);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-funnel-step-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mkt-funnel-step ${isExpanded ? 'expanded' : ''}`,
                                onClick: ()=>setExpandedStep(isExpanded ? null : step.id),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-funnel-step-info",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-step-index",
                                                children: step.index + 1
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-step-name",
                                                children: [
                                                    step.name,
                                                    step.id === 'checkout' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            marginLeft: '6px',
                                                            fontSize: '11px',
                                                            fontWeight: 400,
                                                            color: '#94a3b8',
                                                            cursor: 'help'
                                                        },
                                                        title: "Legacy pre-quote-first step. Its cumulative reached count includes quote-flow visitors who never saw Review & Pay; only the stopped-here drop-off is checkout-specific.",
                                                        children: "\u24D8 count includes quote-flow"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-step-count",
                                                children: [
                                                    (step.reached ?? step.count).toLocaleString(),
                                                    step.ga4Events > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "mkt-step-ga4",
                                                        title: "GA4 events",
                                                        children: [
                                                            "(",
                                                            step.ga4Events.toLocaleString(),
                                                            " GA4)"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mkt-funnel-bar-container",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mkt-funnel-bar",
                                            style: {
                                                width: `${barWidth}%`
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-funnel-step-meta",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-step-rate",
                                                children: [
                                                    step.conversionRate,
                                                    "%"
                                                ]
                                            }),
                                            i > 0 && step.dropOff > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-step-dropoff",
                                                children: [
                                                    "\u2193 ",
                                                    step.dropOff,
                                                    " dropped (",
                                                    step.dropOffRate,
                                                    "%)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isExpanded && step.visitors.filter(matchesCampaign).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-funnel-visitors",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mkt-funnel-visitors-header",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                "Stopped at this step (",
                                                step.visitors.filter(matchesCampaign).length,
                                                campaignFilter ? ` of ${step.visitors.length} \u{2014} ${campaignFilter}` : '',
                                                ")"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mkt-funnel-visitors-list",
                                        children: step.visitors.filter(matchesCampaign).slice(0, 50).map((v)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mkt-funnel-visitor-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mkt-funnel-visitor-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mkt-visitor-name",
                                                                children: v.name || v.email || v.trademarkName || v.browseId?.slice(0, 12) || v.tempUserId?.slice(0, 12)
                                                            }),
                                                            v.isReturning && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mkt-badge mkt-badge-returning",
                                                                title: "Returning visitor",
                                                                children: "Returning"
                                                            }),
                                                            v.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mkt-visitor-tm",
                                                                children: v.trademarkName
                                                            }),
                                                            websiteChip(v, step.index >= 1),
                                                            v.registrationLikelihood && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "mkt-visitor-mode",
                                                                style: likelihoodStyle(v.registrationLikelihood),
                                                                title: "AI registration likelihood",
                                                                children: [
                                                                    "AI: ",
                                                                    String(v.registrationLikelihood).replace(/_/g, ' ')
                                                                ]
                                                            }),
                                                            v.trafficSource && v.trafficSource !== 'direct' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mkt-visitor-mode",
                                                                children: v.trafficSource
                                                            }),
                                                            (v.adName || v.adGroup || v.adCampaign || v.utmCampaign) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "mkt-visitor-mode",
                                                                style: {
                                                                    background: '#eff6ff',
                                                                    color: '#1d4ed8'
                                                                },
                                                                title: [
                                                                    v.adCampaign,
                                                                    v.adGroup
                                                                ].filter(Boolean).join(" \xb7 ") || 'Ad campaign',
                                                                children: [
                                                                    "\uD83D\uDCE2 ",
                                                                    v.adName || v.adGroup || v.adCampaign || v.utmCampaign
                                                                ]
                                                            }),
                                                            (v.adKeyword || v.utmTerm) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "mkt-visitor-mode",
                                                                style: {
                                                                    background: '#f0fdf4',
                                                                    color: '#15803d'
                                                                },
                                                                title: v.adMatchType ? `Search keyword (${String(v.adMatchType).toLowerCase()} match)` : 'Search keyword',
                                                                children: [
                                                                    "\uD83D\uDD0D ",
                                                                    v.adKeyword || v.utmTerm
                                                                ]
                                                            }),
                                                            v.wizardMode && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mkt-visitor-mode",
                                                                children: v.wizardMode
                                                            }),
                                                            v.createdAt && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mkt-visitor-date",
                                                                children: new Date(v.createdAt).toLocaleDateString()
                                                            }),
                                                            v.cartValue && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "mkt-visitor-value",
                                                                children: [
                                                                    "$",
                                                                    v.cartValue
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mkt-funnel-visitor-actions",
                                                        children: [
                                                            v.clarityUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                href: v.clarityUrl,
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                className: "mkt-btn-icon",
                                                                title: "Watch Clarity session",
                                                                children: "\uD83D\uDC41"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                className: "mkt-btn-icon",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    navigate(`/marketing/visitor/${v.id}`);
                                                                },
                                                                title: "View profile",
                                                                children: "\u2192"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, v.id))
                                    })
                                ]
                            }),
                            isExpanded && step.visitors.filter(matchesCampaign).length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mkt-funnel-visitors",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mkt-funnel-empty",
                                    children: campaignFilter ? `No users from ${campaignFilter} at this step` : 'No users currently at this step'
                                })
                            })
                        ]
                    }, step.id);
                })
            })
        ]
    });
}
function $e66b5f48c3a9961f$var$timeAgoShort(dateStr) {
    const diff = Date.now() - new Date(dateStr).getTime();
    const days = Math.floor(diff / 86400000);
    if (days < 1) return 'today';
    if (days === 1) return 'yesterday';
    return `${days}d ago`;
}
var $e66b5f48c3a9961f$export$2e2bcd8739ae039 = $e66b5f48c3a9961f$var$Funnel;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $adec85e0c38f4c10$var$DATE_PRESETS = [
    {
        label: '7 days',
        value: '7'
    },
    {
        label: '30 days',
        value: '30'
    },
    {
        label: '90 days',
        value: '90'
    },
    {
        label: 'All time',
        value: ''
    }
];
const $adec85e0c38f4c10$var$REASON_META = {
    price: {
        label: 'Price',
        icon: "\uD83D\uDCB0",
        color: '#d97706'
    },
    not_ready: {
        label: 'Not ready',
        icon: "\u23F3",
        color: '#3b82f6'
    },
    comparing: {
        label: 'Comparing',
        icon: "\uD83D\uDD0D",
        color: '#8b5cf6'
    },
    question: {
        label: 'Question',
        icon: "\u2753",
        color: '#0f766e'
    },
    just_wanted_report: {
        label: 'Just wanted report',
        icon: "\uD83D\uDCC4",
        color: '#0891b2'
    },
    report_concerns: {
        label: 'Report concerns',
        icon: "\u26A0\uFE0F",
        color: '#dc2626'
    },
    other: {
        label: 'Other',
        icon: "\uD83D\uDCAC",
        color: '#64748b'
    },
    comment_only: {
        label: 'Comment only',
        icon: "\uD83D\uDCDD",
        color: '#64748b'
    }
};
const $adec85e0c38f4c10$var$SOURCE_LABELS = {
    checkout_prompt: 'Checkout prompt',
    email: 'Email link'
};
const $adec85e0c38f4c10$var$TEMPLATE_LABELS = {
    wizard_follow_up: "\uD83D\uDC4B First Contact",
    wizard_report_follow_up: "\uD83D\uDCCA Analysis Report",
    wizard_checkout_follow_up: "\uD83D\uDED2 Checkout Nudge",
    wizard_second_follow_up: "\u23F0 Final Note",
    wizard_feedback: "\uD83D\uDCAC Feedback Ask",
    quote_report: "\uD83D\uDCC4 Report & Quote",
    quote_follow_up: "\uD83D\uDCB3 Quote Nudge",
    quote_revised: "\uD83E\uDDFE Updated Quote"
};
function $adec85e0c38f4c10$var$reasonMeta(reason) {
    return $adec85e0c38f4c10$var$REASON_META[reason || 'comment_only'] || $adec85e0c38f4c10$var$REASON_META.other;
}
function $adec85e0c38f4c10$var$timeAgo(iso) {
    const diff = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${Math.max(mins, 1)}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d ago`;
    return new Date(iso).toLocaleDateString();
}
function $adec85e0c38f4c10$var$Feedback() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [days, setDays] = (0, $acw62.useState)('30');
    const [reasonFilter, setReasonFilter] = (0, $acw62.useState)(null);
    const [tab, setTab] = (0, $acw62.useState)('feedback');
    // null | 'opened' | 'clicked' — set by clicking the summary tiles
    const [emailFilter, setEmailFilter] = (0, $acw62.useState)(null);
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $4878203aaaa5eb61$export$a19b0125be4d32b3)(days ? {
        days: days
    } : {});
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading feedback..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-funnel-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Failed to load feedback: ",
                    error.message
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                className: "mkt-btn mkt-btn-primary",
                children: "Retry"
            })
        ]
    });
    const { entries: entries = [], summary: summary = {}, emails: emails = [], emailSummary: emailSummary = {} } = data || {};
    const filtered = reasonFilter ? entries.filter((e)=>(e.reason || 'comment_only') === reasonFilter) : entries;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-feedback",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Visitor Feedback"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-funnel-filters",
                        children: $adec85e0c38f4c10$var$DATE_PRESETS.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `mkt-filter-btn ${days === p.value ? 'active' : ''}`,
                                onClick: ()=>setDays(p.value),
                                children: p.label
                            }, p.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-feedback-tabs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `mkt-filter-btn ${tab === 'feedback' ? 'active' : ''}`,
                        onClick: ()=>setTab('feedback'),
                        children: [
                            "\uD83D\uDCAC Feedback (",
                            summary.total || 0,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `mkt-filter-btn ${tab === 'emails' ? 'active' : ''}`,
                        onClick: ()=>setTab('emails'),
                        children: [
                            "\u2709\uFE0F Email opens (",
                            emailSummary.opened || 0,
                            "/",
                            emailSummary.trackableSent ?? emailSummary.sent ?? 0,
                            " tracked)"
                        ]
                    })
                ]
            }),
            tab === 'emails' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-funnel-summary",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mkt-summary-card mkt-feedback-card ${emailFilter === null ? 'active' : ''}`,
                                onClick: ()=>setEmailFilter(null),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-label",
                                        children: "\u2709\uFE0F Emails sent"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-value",
                                        children: emailSummary.sent || 0
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-summary-rate",
                                        children: [
                                            emailSummary.recipients || 0,
                                            " people \xb7 ",
                                            emailSummary.trackableSent || 0,
                                            " with open tracking"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mkt-summary-card mkt-feedback-card ${emailFilter === 'opened' ? 'active' : ''}`,
                                onClick: ()=>setEmailFilter(emailFilter === 'opened' ? null : 'opened'),
                                title: "Click to see who opened",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-label",
                                        children: "\uD83D\uDC40 Opened"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-value",
                                        children: emailSummary.opened || 0
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-summary-rate",
                                        children: [
                                            emailSummary.openRate || 0,
                                            "% of ",
                                            emailSummary.trackableSent || 0,
                                            " tracked"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mkt-summary-card mkt-feedback-card ${emailFilter === 'clicked' ? 'active' : ''}`,
                                onClick: ()=>setEmailFilter(emailFilter === 'clicked' ? null : 'clicked'),
                                title: "Click to see who clicked",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-label",
                                        children: "\uD83D\uDD17 Clicked through"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-value",
                                        children: emailSummary.clicked || 0
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mkt-feedback-note",
                        children: "Opens come from a tracking pixel and from link clicks (a click always counts as an open). Apple Mail pre-loads images (overcounts) and some clients block them (undercounts) \u2014 treat as a signal, not an exact measure. Emails sent before open tracking shipped (21 July) can never show opens; if that visitor clicked a link, the row shows \u201CNo open data\u201D instead."
                    }),
                    (()=>{
                        const shownEmails = emailFilter === 'opened' ? emails.filter((m)=>m.openedAt) : emailFilter === 'clicked' ? emails.filter((m)=>m.clickedAt || m.visitorClickedAnyLink) : emails;
                        return shownEmails.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mkt-feedback-empty",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    emailFilter === 'opened' && 'No opened emails in this period.',
                                    emailFilter === 'clicked' && 'No clicked emails in this period.',
                                    !emailFilter && 'No outreach emails sent in this period.'
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mkt-feedback-list",
                            children: shownEmails.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mkt-feedback-row",
                                    onClick: ()=>m.visitorId && navigate(`/marketing/visitor/${m.visitorId}`),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mkt-feedback-row-main",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mkt-feedback-row-top",
                                                    children: [
                                                        m.openedAt ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "mkt-feedback-reason",
                                                            style: {
                                                                background: '#0f766e18',
                                                                color: '#0f766e'
                                                            },
                                                            children: [
                                                                "\uD83D\uDC40 Opened",
                                                                m.clickedAt && m.openCount === 0 ? ' (via click)' : m.openCount > 1 ? ` \xd7${m.openCount}` : ''
                                                            ]
                                                        }) : m.visitorClickedAnyLink ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-feedback-reason",
                                                            style: {
                                                                background: '#d9770618',
                                                                color: '#d97706'
                                                            },
                                                            title: "Sent before per-email tracking: this visitor clicked a link in one of their emails, but we can't tell which",
                                                            children: "\u2014 No open data"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-feedback-reason",
                                                            style: {
                                                                background: '#64748b18',
                                                                color: '#64748b'
                                                            },
                                                            children: "\u2014 Not opened"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-feedback-who",
                                                            children: m.name || m.email || 'Unknown'
                                                        }),
                                                        m.email && m.name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-feedback-email",
                                                            children: m.email
                                                        }),
                                                        m.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "mkt-visitor-tm",
                                                            children: [
                                                                "\u201C",
                                                                m.trademarkName,
                                                                "\u201D"
                                                            ]
                                                        }),
                                                        m.clickedAt ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-badge mkt-badge-returning",
                                                            children: "Clicked this email"
                                                        }) : m.visitorClickedAnyLink ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-badge mkt-badge-feedback-asked",
                                                            title: "Clicked a link in one of their emails (sent before per-email attribution)",
                                                            children: "Clicked an email"
                                                        }) : null,
                                                        m.gaveFeedback && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mkt-badge mkt-badge-feedback-given",
                                                            children: "\uD83D\uDCAC Gave feedback"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mkt-feedback-row-meta",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: $adec85e0c38f4c10$var$TEMPLATE_LABELS[m.template] || m.template || 'email'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                "\xb7 sent ",
                                                                $adec85e0c38f4c10$var$timeAgo(m.sentAt)
                                                            ]
                                                        }),
                                                        m.openedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                "\xb7 opened ",
                                                                $adec85e0c38f4c10$var$timeAgo(m.openedAt)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mkt-feedback-row-arrow",
                                            children: "\u2192"
                                        })
                                    ]
                                }, m.id))
                        });
                    })()
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-funnel-summary",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mkt-summary-card mkt-feedback-card ${reasonFilter === null ? 'active' : ''}`,
                                onClick: ()=>setReasonFilter(null),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-label",
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-value",
                                        children: summary.total || 0
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-summary-rate",
                                        children: [
                                            summary.visitors || 0,
                                            " visitors"
                                        ]
                                    })
                                ]
                            }),
                            Object.entries($adec85e0c38f4c10$var$REASON_META).filter(([key])=>(summary.byReason || {})[key]).map(([key, meta])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `mkt-summary-card mkt-feedback-card ${reasonFilter === key ? 'active' : ''}`,
                                    onClick: ()=>setReasonFilter(reasonFilter === key ? null : key),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "mkt-summary-label",
                                            children: [
                                                meta.icon,
                                                " ",
                                                meta.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mkt-summary-value",
                                            style: {
                                                color: meta.color
                                            },
                                            children: summary.byReason[key]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "mkt-summary-rate",
                                            children: [
                                                summary.total ? Math.round(summary.byReason[key] / summary.total * 100) : 0,
                                                "%"
                                            ]
                                        })
                                    ]
                                }, key)),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-summary-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-label",
                                        children: "\uD83D\uDCAC With comments"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-summary-value",
                                        children: summary.withComment || 0
                                    })
                                ]
                            })
                        ]
                    }),
                    filtered.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-feedback-empty",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "No feedback ",
                                    reasonFilter ? 'for this reason ' : '',
                                    "in this period."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mkt-feedback-empty-hint",
                                children: "Feedback arrives from the checkout prompt and the one-tap links in the feedback email."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-feedback-list",
                        children: filtered.map((e)=>{
                            const meta = $adec85e0c38f4c10$var$reasonMeta(e.reason);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-feedback-row",
                                onClick: ()=>e.visitorId && navigate(`/marketing/visitor/${e.visitorId}`),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-feedback-row-main",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mkt-feedback-row-top",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "mkt-feedback-reason",
                                                        style: {
                                                            background: `${meta.color}18`,
                                                            color: meta.color
                                                        },
                                                        children: [
                                                            meta.icon,
                                                            " ",
                                                            meta.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mkt-feedback-who",
                                                        children: e.name || e.email || 'Unknown visitor'
                                                    }),
                                                    e.email && e.name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mkt-feedback-email",
                                                        children: e.email
                                                    }),
                                                    e.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "mkt-visitor-tm",
                                                        children: [
                                                            "\u201C",
                                                            e.trademarkName,
                                                            "\u201D"
                                                        ]
                                                    }),
                                                    e.paid && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mkt-badge mkt-badge-returning",
                                                        children: "Paid anyway"
                                                    })
                                                ]
                                            }),
                                            e.comment && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "mkt-feedback-comment",
                                                children: [
                                                    "\u201C",
                                                    e.comment,
                                                    "\u201D"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mkt-feedback-row-meta",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: $adec85e0c38f4c10$var$SOURCE_LABELS[e.source] || e.source || 'unknown source'
                                                    }),
                                                    e.stage && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xb7 at ",
                                                            e.stage
                                                        ]
                                                    }),
                                                    e.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                        href: `tel:${e.phone}`,
                                                        onClick: (ev)=>ev.stopPropagation(),
                                                        style: {
                                                            color: '#0f766e'
                                                        },
                                                        children: [
                                                            "\xb7 \uD83D\uDCDE ",
                                                            e.phone
                                                        ]
                                                    }),
                                                    e.trigger && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xb7 ",
                                                            e.trigger.replace('_', ' ')
                                                        ]
                                                    }),
                                                    e.cartValue && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xb7 $",
                                                            Number(e.cartValue).toLocaleString(),
                                                            " cart"
                                                        ]
                                                    }),
                                                    e.trafficSource && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xb7 ",
                                                            e.trafficSource
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xb7 ",
                                                            $adec85e0c38f4c10$var$timeAgo(e.createdAt)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-feedback-row-arrow",
                                        children: "\u2192"
                                    })
                                ]
                            }, e.id);
                        })
                    })
                ]
            })
        ]
    });
}
var $adec85e0c38f4c10$export$2e2bcd8739ae039 = $adec85e0c38f4c10$var$Feedback;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $74c80190aff99a39$var$STATUS_LABELS = {
    not_contacted: 'Awaiting report',
    first_contact: 'First contact (legacy)',
    report_sent: 'Report sent',
    checkout_nudge: 'First nudge',
    second_contact: 'Second nudge',
    call: 'Call list',
    feedback: 'Feedback',
    responded: 'Responded',
    paid: 'Paid',
    do_not_contact: 'Do not contact',
    not_serious: 'Not serious'
};
function $74c80190aff99a39$var$Search() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [input, setInput] = (0, $acw62.useState)('');
    const [query, setQuery] = (0, $acw62.useState)('');
    const updateStatus = (0, $4878203aaaa5eb61$export$d91fdd4f78c535ff)();
    // Debounce typing → query
    (0, $acw62.useEffect)(()=>{
        const t = setTimeout(()=>setQuery(input.trim()), 300);
        return ()=>clearTimeout(t);
    }, [
        input
    ]);
    const { data: data, isFetching: isFetching } = (0, $4878203aaaa5eb61$export$d443a927de736110)(query);
    const results = data?.results || [];
    const markStatus = (person, status, label)=>{
        if (!window.confirm(`Mark ${person.name || person.email} as ${label}?`)) return;
        updateStatus.mutate({
            visitorId: person.id,
            status: status
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-feedback",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-funnel-header",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Search People"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                autoFocus: true,
                className: "mkt-search-input",
                placeholder: "Search by name, email, phone, trademark or business\u2026",
                value: input,
                onChange: (e)=>setInput(e.target.value)
            }),
            query.length >= 2 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mkt-feedback-note",
                children: isFetching ? "Searching\u2026" : `${results.length} ${results.length === 1 ? 'match' : 'matches'}${results.length === 25 ? ' (showing first 25)' : ''}`
            }),
            query.length >= 2 && !isFetching && results.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-feedback-empty",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "No one matches \u201C",
                            query,
                            "\u201D."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mkt-feedback-empty-hint",
                        children: "Searches name, email, phone, trademark and business name."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-feedback-list",
                children: results.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-feedback-row",
                        onClick: ()=>navigate(`/marketing/visitor/${p.id}`),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-feedback-row-main",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-feedback-row-top",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-feedback-who",
                                                children: p.name || p.email || 'Unknown'
                                            }),
                                            p.email && p.name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-feedback-email",
                                                children: p.email
                                            }),
                                            p.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-visitor-tm",
                                                children: [
                                                    "\u201C",
                                                    p.trademarkName,
                                                    "\u201D"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `mkt-badge ${p.contactStatus === 'do_not_contact' ? 'mkt-badge-feedback-asked' : 'mkt-badge-returning'}`,
                                                children: $74c80190aff99a39$var$STATUS_LABELS[p.contactStatus] || p.contactStatus
                                            }),
                                            p.paid && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-badge mkt-badge-feedback-given",
                                                children: "Paid"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-feedback-row-meta",
                                        children: [
                                            p.businessName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: p.businessName
                                            }),
                                            p.phone && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: `tel:${p.phone}`,
                                                onClick: (e)=>e.stopPropagation(),
                                                style: {
                                                    color: '#0f766e'
                                                },
                                                children: [
                                                    "\xb7 \uD83D\uDCDE ",
                                                    p.phone
                                                ]
                                            }),
                                            p.currentStep && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\xb7 step: ",
                                                    p.currentStep
                                                ]
                                            }),
                                            p.cartValue && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\xb7 $",
                                                    Number(p.cartValue).toLocaleString(),
                                                    " cart"
                                                ]
                                            }),
                                            p.feedbackReason && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\xb7 \uD83D\uDCAC ",
                                                    p.feedbackReason.replace('_', ' ')
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-search-actions",
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    p.contactStatus !== 'do_not_contact' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "mkt-card-quick-btn mkt-quick-dnc",
                                        onClick: ()=>markStatus(p, 'do_not_contact', 'Do Not Contact'),
                                        title: "They asked not to be messaged",
                                        children: "\u26D4 DNC"
                                    }),
                                    ![
                                        'not_serious',
                                        'do_not_contact',
                                        'paid'
                                    ].includes(p.contactStatus) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "mkt-card-quick-btn mkt-quick-not-serious",
                                        onClick: ()=>markStatus(p, 'not_serious', 'Not Serious'),
                                        children: "\uD83D\uDEAB Not serious"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-feedback-row-arrow",
                                        children: "\u2192"
                                    })
                                ]
                            })
                        ]
                    }, p.id))
            })
        ]
    });
}
var $74c80190aff99a39$export$2e2bcd8739ae039 = $74c80190aff99a39$var$Search;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $76facf3a000d9da6$var$SUGGESTIONS = [
    'Who reached checkout in the last 14 days but was never emailed?',
    "Show me everyone who opened an email but hasn\u2019t paid",
    'How many leads came from Google Ads, and how many of those paid?',
    'Who gave "price" as their feedback reason?',
    'Which leads went quiet 30 to 60 days ago?'
];
function $76facf3a000d9da6$var$Assistant() {
    const [messages, setMessages] = (0, $acw62.useState)([]);
    const [input, setInput] = (0, $acw62.useState)('');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const bottomRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        bottomRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        messages,
        busy
    ]);
    const ask = async (question)=>{
        const q = (question || input).trim();
        if (!q || busy) return;
        setError(null);
        setInput('');
        const nextMessages = [
            ...messages,
            {
                role: 'user',
                content: q
            }
        ];
        setMessages(nextMessages);
        setBusy(true);
        try {
            const result = await (0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).askAssistant(nextMessages);
            setMessages([
                ...nextMessages,
                {
                    role: 'assistant',
                    content: result.reply
                }
            ]);
        } catch (err) {
            setError(err.message || 'Assistant request failed');
            setMessages(messages); // roll back the optimistic user message
            setInput(q);
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-feedback mkt-assistant",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Ask AI"
                    }),
                    messages.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-secondary",
                        onClick: ()=>setMessages([]),
                        children: "New conversation"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mkt-feedback-note",
                children: "Read-only access to the marketing data (leads, funnel steps, outreach, opens, feedback). It looks things up live and can't change or send anything."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-assistant-thread",
                children: [
                    messages.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-assistant-suggestions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Try asking:"
                            }),
                            $76facf3a000d9da6$var$SUGGESTIONS.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-assistant-suggestion",
                                    onClick: ()=>ask(s),
                                    children: s
                                }, s))
                        ]
                    }),
                    messages.map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `mkt-assistant-msg ${m.role}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mkt-assistant-bubble",
                                children: m.content
                            })
                        }, i)),
                    busy && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-assistant-msg assistant",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mkt-assistant-bubble mkt-assistant-thinking",
                            children: "Looking that up\u2026"
                        })
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-assistant-msg assistant",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mkt-assistant-bubble",
                            style: {
                                color: '#dc2626'
                            },
                            children: error
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: bottomRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                className: "mkt-assistant-composer",
                onSubmit: (e)=>{
                    e.preventDefault();
                    ask();
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        className: "mkt-search-input",
                        placeholder: "Ask about your leads, funnel, emails, feedback\u2026",
                        value: input,
                        onChange: (e)=>setInput(e.target.value),
                        disabled: busy
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "submit",
                        className: "mkt-btn mkt-btn-primary",
                        disabled: busy || !input.trim(),
                        children: busy ? "\u2026" : 'Ask'
                    })
                ]
            })
        ]
    });
}
var $76facf3a000d9da6$export$2e2bcd8739ae039 = $76facf3a000d9da6$var$Assistant;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $0b9a1699a3a56a1a$var$SIGNAL_META = {
    third_party_match: {
        label: 'Third-party match',
        icon: "\u26A0\uFE0F",
        color: '#dc2626',
        bg: '#fef2f2'
    },
    our_filing_visible: {
        label: 'Filing visible',
        icon: "\u2705",
        color: '#047857',
        bg: '#ecfdf5'
    },
    not_found: {
        label: 'Not on register',
        icon: "\u2014",
        color: '#64748b',
        bg: '#f1f5f9'
    }
};
function $0b9a1699a3a56a1a$var$timeAgo(iso) {
    if (!iso) return '';
    const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
    if (days < 1) return 'today';
    if (days === 1) return 'yesterday';
    return `${days}d ago`;
}
function $0b9a1699a3a56a1a$var$TmWatch() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { data: data, isLoading: isLoading, error: error, refetch: refetch, isFetching: isFetching } = (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'marketing',
            'tmwatch'
        ],
        queryFn: ()=>(0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).getTmWatch(),
        staleTime: 60000
    });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading TM Watch..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-funnel-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Failed to load TM Watch: ",
                    error.message
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>refetch(),
                className: "mkt-btn mkt-btn-primary",
                children: "Retry"
            })
        ]
    });
    const { configured: configured, apiError: apiError, checkedThisLoad: checkedThisLoad, entries: entries = [], summary: summary = {} } = data || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-feedback",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "TM Watch"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-secondary",
                        onClick: ()=>refetch(),
                        disabled: isFetching,
                        children: isFetching ? "Checking\u2026" : "\uD83D\uDD04 Check more"
                    })
                ]
            }),
            !configured && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-tmwatch-setup",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: "IP Australia isn't connected yet."
                    }),
                    " Register at",
                    ' ',
                    "portal.api.ipaustralia.gov.au, subscribe to the Trade Mark Search API, then add",
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                        children: "IPA_CLIENT_ID"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                        children: "IPA_CLIENT_SECRET"
                    }),
                    " to the API containers. The register checks start automatically once the keys are in."
                ]
            }),
            configured && apiError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-tmwatch-setup",
                style: {
                    borderColor: '#fecaca',
                    background: '#fef2f2'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: "Register check failed:"
                    }),
                    " ",
                    apiError,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '12px',
                            marginTop: '4px',
                            color: '#64748b'
                        },
                        children: "If this mentions a 404 or unexpected shape, the API paths may need calibrating (IPA_TOKEN_URL / IPA_SEARCH_URL env overrides)."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-funnel-summary",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-label",
                                children: "Watched marks"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-value",
                                children: summary.watched || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "mkt-summary-rate",
                                children: [
                                    summary.checked || 0,
                                    " checked \xb7 ",
                                    summary.unchecked || 0,
                                    " pending"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-label",
                                children: "\u26A0\uFE0F Third-party matches"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-value",
                                style: {
                                    color: '#dc2626'
                                },
                                children: summary.thirdPartyMatches || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-rate",
                                children: "someone else holds their name"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-label",
                                children: "\u2705 Our filings visible"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-value",
                                style: {
                                    color: '#047857'
                                },
                                children: summary.ourFilingsVisible || 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-summary-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-label",
                                children: "Not on register"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-value",
                                children: summary.notFound || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-summary-rate",
                                children: "names still free"
                            })
                        ]
                    })
                ]
            }),
            configured && checkedThisLoad > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "mkt-feedback-note",
                children: [
                    "Checked ",
                    checkedThisLoad,
                    " marks against the register this load; marks are rechecked weekly."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-feedback-list",
                children: entries.map((e)=>{
                    const meta = e.tmWatch ? $0b9a1699a3a56a1a$var$SIGNAL_META[e.tmWatch.signal] : null;
                    const top = e.tmWatch?.exactMatches?.[0] || null;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-feedback-row",
                        onClick: ()=>navigate(`/marketing/visitor/${e.visitorId}`),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-feedback-row-main",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-feedback-row-top",
                                        children: [
                                            meta ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-feedback-reason",
                                                style: {
                                                    background: meta.bg,
                                                    color: meta.color
                                                },
                                                children: [
                                                    meta.icon,
                                                    " ",
                                                    meta.label
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-feedback-reason",
                                                style: {
                                                    background: '#f1f5f9',
                                                    color: '#94a3b8'
                                                },
                                                children: "\u23F3 Not checked yet"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-visitor-tm",
                                                children: [
                                                    "\u201C",
                                                    e.trademarkName,
                                                    "\u201D"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-feedback-who",
                                                children: e.name || e.email || 'Unknown'
                                            }),
                                            e.paid && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-badge mkt-badge-feedback-given",
                                                children: "Customer"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-feedback-row-meta",
                                        children: [
                                            top && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    top.number ? `#${top.number}` : '',
                                                    " ",
                                                    top.status ? `\xb7 ${top.status}` : '',
                                                    top.ownerName ? ` \xb7 owner: ${top.ownerName}` : '',
                                                    top.filedDate ? ` \xb7 filed ${top.filedDate}` : ''
                                                ]
                                            }),
                                            e.tmWatch && !top && e.tmWatch.matchCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    e.tmWatch.matchCount,
                                                    " similar marks, none exact"
                                                ]
                                            }),
                                            e.currentStep && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\xb7 step: ",
                                                    e.currentStep
                                                ]
                                            }),
                                            e.tmWatch && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "\xb7 checked ",
                                                    $0b9a1699a3a56a1a$var$timeAgo(e.tmWatch.checkedAt)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-feedback-row-arrow",
                                children: "\u2192"
                            })
                        ]
                    }, e.visitorId);
                })
            })
        ]
    });
}
var $0b9a1699a3a56a1a$export$2e2bcd8739ae039 = $0b9a1699a3a56a1a$var$TmWatch;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $2f18fe9aa2e75117$export$561598fdff96527c = {
    generating: {
        background: '#eff6ff',
        color: '#1d4ed8',
        label: 'Generating'
    },
    draft: {
        background: '#fffbeb',
        color: '#b45309',
        label: "Draft \u2014 review & send"
    },
    sent: {
        background: '#ecfdf5',
        color: '#047857',
        label: 'Sent'
    },
    failed: {
        background: '#fef2f2',
        color: '#dc2626',
        label: 'Failed'
    }
};
const $2f18fe9aa2e75117$var$SIGNAL_LABELS = {
    not_found: {
        label: 'Register clear',
        color: '#047857'
    },
    our_filing_visible: {
        label: 'Own filing visible',
        color: '#0f766e'
    },
    third_party_match: {
        label: 'Third-party match',
        color: '#dc2626'
    },
    unavailable: {
        label: 'Search unavailable',
        color: '#b45309'
    }
};
const $2f18fe9aa2e75117$var$FILTERS = [
    {
        key: '',
        label: 'All'
    },
    {
        key: 'draft',
        label: 'Draft'
    },
    {
        key: 'generating',
        label: 'Generating'
    },
    {
        key: 'failed',
        label: 'Failed'
    },
    {
        key: 'sent',
        label: 'Sent'
    }
];
function $2f18fe9aa2e75117$var$timeAgo(iso) {
    if (!iso) return '';
    const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
}
/**
 * Reports — the 24-hour SLA queue for the quote-first funnel.
 * Draft reports need a human review + send; failed ones need a regenerate.
 */ function $2f18fe9aa2e75117$var$Reports() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)('');
    const { data: data, isLoading: isLoading, error: error } = (0, $4878203aaaa5eb61$export$fa3120960baf4ea2)(statusFilter ? {
        status: statusFilter
    } : {});
    const reports = data?.reports || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-page-header",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            children: "Reports"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mkt-page-subtitle",
                            children: "Free report queue \u2014 visitors are promised their report and confirmed quote within 24 hours of requesting it."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: '8px',
                    marginBottom: '16px',
                    flexWrap: 'wrap'
                },
                children: $2f18fe9aa2e75117$var$FILTERS.map((f)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setStatusFilter(f.key),
                        className: `mkt-filter-pill${statusFilter === f.key ? ' active' : ''}`,
                        children: f.label
                    }, f.key))
            }),
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-loading",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-loading-spinner"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Loading reports..."
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                style: {
                    color: '#dc2626'
                },
                children: [
                    "Failed to load reports: ",
                    error.message
                ]
            }),
            !isLoading && reports.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                style: {
                    color: '#64748b'
                },
                children: [
                    "No reports",
                    statusFilter ? ` with status "${statusFilter}"` : '',
                    " yet."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                },
                children: reports.map((r)=>{
                    const { label: statusLabel, ...statusStyle } = $2f18fe9aa2e75117$export$561598fdff96527c[r.status] || {};
                    const signal = r.registerSignal ? $2f18fe9aa2e75117$var$SIGNAL_LABELS[r.registerSignal] : null;
                    const waitingSince = r.requestedAt || r.generatedAt;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-card",
                        style: {
                            cursor: 'pointer'
                        },
                        onClick: ()=>navigate(`/marketing/reports/${r.id}`),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-card-name",
                                        children: r.trademarkName ? `"${r.trademarkName}"` : r.applicationId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...statusStyle,
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            padding: '2px 8px'
                                        },
                                        children: statusLabel || r.status
                                    }),
                                    signal && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            background: `${signal.color}12`,
                                            color: signal.color,
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            padding: '2px 8px'
                                        },
                                        children: signal.label
                                    }),
                                    r.quoteMismatch && (r.quoteManual ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            background: '#f1f5f9',
                                            color: '#475569',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            padding: '2px 8px'
                                        },
                                        title: r.quoteExpectedTotal != null ? `Priced by hand. Standard price would be ${r.quoteCurrency || 'AUD'} $${Number(r.quoteExpectedTotal).toLocaleString()}` : 'Priced by hand',
                                        children: "Custom price"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            background: '#fef2f2',
                                            color: '#dc2626',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            padding: '2px 8px'
                                        },
                                        title: "Stored quote total does not match the server recompute",
                                        children: "Quote mismatch"
                                    })),
                                    r.quoteRevisionPending && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            background: '#fffbeb',
                                            color: '#b45309',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            padding: '2px 8px'
                                        },
                                        title: "A revised quote has been saved but not sent to the client",
                                        children: [
                                            "Revision ",
                                            r.quoteRevision,
                                            " unsent"
                                        ]
                                    }),
                                    r.provisioningError && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            background: '#fef2f2',
                                            color: '#dc2626',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            padding: '2px 8px'
                                        },
                                        title: r.provisioningError,
                                        children: "Provisioning failed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            marginLeft: 'auto',
                                            color: '#94a3b8',
                                            fontSize: '12px'
                                        },
                                        children: r.status === 'sent' ? `Sent ${$2f18fe9aa2e75117$var$timeAgo(r.sentAt)}` : waitingSince ? `Requested ${$2f18fe9aa2e75117$var$timeAgo(waitingSince)}` : ''
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '14px',
                                    marginTop: '6px',
                                    color: '#64748b',
                                    fontSize: '13px',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    r.contact?.name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: r.contact.name
                                    }),
                                    r.contact?.email && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: r.contact.email
                                    }),
                                    r.businessName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: r.businessName
                                    }),
                                    r.quoteTotal != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            fontWeight: 600,
                                            color: '#0f766e'
                                        },
                                        children: [
                                            r.quoteCurrency || '',
                                            " $",
                                            Number(r.quoteTotal).toLocaleString()
                                        ]
                                    })
                                ]
                            }),
                            r.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    marginTop: '6px',
                                    color: '#dc2626',
                                    fontSize: '12px'
                                },
                                children: r.error
                            })
                        ]
                    }, r.id);
                })
            })
        ]
    });
}
var $2f18fe9aa2e75117$export$2e2bcd8739ae039 = $2f18fe9aa2e75117$var$Reports;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * QuoteEditor — the quote card on a report.
 *
 * Covers the whole quote, not just the money: countries and classes are
 * editable here, which is how a client asking to "add class 35 and re-quote
 * me" is served. Prices are recomputed server-side from the same table the
 * wizard used, so nobody hand-types a total.
 *
 * Editing a quote whose report has already been sent creates a REVISION: the
 * new quote carries its own number (Q-XXXXXXXX-R2) and the superseded figures
 * are archived. Saving takes effect immediately — the client's dashboard and
 * the amount they would be charged both follow the pricing record — so the
 * send step tells them about a change that has already happened.
 */ function $24b7a719c4d48354$var$QuoteEditor({ report: report, quote: quote, onError: onError }) {
    const updateQuote = (0, $4878203aaaa5eb61$export$14d6cc65c682619e)();
    const priceQuote = (0, $4878203aaaa5eb61$export$5813f3cac7cac59f)();
    const sendRevision = (0, $4878203aaaa5eb61$export$a5a177c19391712e)();
    const fixTerms = (0, $4878203aaaa5eb61$export$b7768dbefa548d58)();
    const [draft, setDraft] = (0, $acw62.useState)(null);
    const [preview, setPreview] = (0, $acw62.useState)(null);
    const [pricingError, setPricingError] = (0, $acw62.useState)(null);
    const [pickerOpen, setPickerOpen] = (0, $acw62.useState)(false);
    const [termsOpenFor, setTermsOpenFor] = (0, $acw62.useState)(null);
    const [confirmSend, setConfirmSend] = (0, $acw62.useState)(false);
    const [sendResult, setSendResult] = (0, $acw62.useState)(null);
    const [pricing, setPricing] = (0, $acw62.useState)(false);
    const [fixNote, setFixNote] = (0, $acw62.useState)(null);
    // Every scope change fires its own pricing call; only the newest answer may
    // land, or a slow earlier one would leave a price that isn't the draft's
    const priceSeq = (0, $acw62.useRef)(0);
    const { data: pricingConfig } = (0, $4878203aaaa5eb61$export$3f6edacb3381ddb2)(!!draft);
    const knownCountries = pricingConfig?.allCountries || [];
    // A quote can carry a country the price table no longer lists. Show it
    // anyway, or it would be unpriceable *and* invisible — impossible to remove.
    const extraCountries = (draft?.countries || []).filter((id)=>knownCountries.length > 0 && !knownCountries.some((c)=>c.id === id)).map((id)=>({
            id: id,
            name: `${id.toUpperCase()} (no price configured)`,
            icon: "\u26A0\uFE0F"
        }));
    const countryOptions = [
        ...knownCountries,
        ...extraCountries
    ];
    const alreadySent = report.status === 'sent';
    const revision = quote?.revision || 1;
    const currency = (quote?.currency || 'AUD').toUpperCase();
    const money = (n)=>`$${Number(n || 0).toLocaleString()}`;
    const startEdit = ()=>{
        setPricingError(null);
        setPreview(null);
        const next = {
            countries: [
                ...quote.countries || []
            ],
            classes: (quote.classes || []).map((c)=>({
                    classNumber: c.classNumber ?? c.number,
                    className: c.className || c.name || '',
                    goodsServices: [
                        ...c.goodsServices || []
                    ]
                })),
            autoPrice: true,
            serviceFeeTotal: quote.serviceFeeTotal ?? '',
            govFeeTotal: quote.govFeeTotal ?? '',
            discount: quote.discount ?? 0,
            total: quote.total ?? ''
        };
        setDraft(next);
        refreshPrice(next);
    };
    /**
   * Server-side price for the draft scope — never computed in the browser.
   * Runs even in manual mode: the fee split and per-country breakdown have to
   * describe the scope being saved, so a scope change re-baselines the
   * numbers the admin is about to override.
   */ const refreshPrice = (nextDraft)=>{
        const seq = ++priceSeq.current;
        setPricingError(null);
        setPricing(true);
        priceQuote.mutate({
            reportId: report.id,
            countries: nextDraft.countries,
            classCount: nextDraft.classes.length,
            currency: currency
        }, {
            onSuccess: (res)=>{
                if (seq !== priceSeq.current) return; // a newer scope is in flight
                setPreview(res.quote);
                setPricing(false);
                // In manual mode the inputs were seeded from the previous scope;
                // re-baseline them so the admin edits numbers that describe the
                // countries and classes actually being saved
                if (!nextDraft.autoPrice) setDraft((prev)=>prev ? {
                        ...prev,
                        serviceFeeTotal: res.quote.serviceFeeTotal,
                        govFeeTotal: res.quote.govFeeTotal,
                        discount: res.quote.discount,
                        total: res.quote.total
                    } : prev);
            },
            onError: (e)=>{
                if (seq !== priceSeq.current) return;
                setPricingError(e.response?.data?.error || e.message);
                setPricing(false);
            }
        });
    };
    const applyDraft = (changes)=>{
        const next = {
            ...draft,
            ...changes
        };
        setDraft(next);
        refreshPrice(next);
    };
    const toggleCountry = (id)=>{
        const has = draft.countries.includes(id);
        const countries = has ? draft.countries.filter((c)=>c !== id) : [
            ...draft.countries,
            id
        ];
        if (countries.length === 0) return; // a quote needs at least one country
        applyDraft({
            countries: countries
        });
    };
    const addClass = (cls)=>{
        if (draft.classes.some((c)=>c.classNumber === cls.classNumber)) return;
        applyDraft({
            classes: [
                ...draft.classes,
                {
                    classNumber: cls.classNumber,
                    className: cls.shortName || '',
                    goodsServices: []
                }
            ]
        });
        setPickerOpen(false);
    };
    const removeClass = (classNumber)=>{
        if (draft.classes.length <= 1) return; // a quote needs at least one class
        applyDraft({
            classes: draft.classes.filter((c)=>c.classNumber !== classNumber)
        });
        if (termsOpenFor === classNumber) setTermsOpenFor(null);
    };
    // Class name and goods/services don't affect price, so they skip the recompute
    const editClass = (classNumber, changes)=>{
        setDraft((prev)=>({
                ...prev,
                classes: prev.classes.map((c)=>c.classNumber === classNumber ? {
                        ...c,
                        ...changes
                    } : c)
            }));
    };
    const save = ()=>{
        const payload = {
            reportId: report.id,
            countries: draft.countries,
            classes: draft.classes,
            autoPrice: !!draft.autoPrice,
            currency: currency
        };
        if (!draft.autoPrice) {
            payload.serviceFeeTotal = draft.serviceFeeTotal;
            payload.govFeeTotal = draft.govFeeTotal;
            payload.discount = draft.discount;
            payload.total = draft.total;
        }
        updateQuote.mutate(payload, {
            onSuccess: ()=>{
                setDraft(null);
                setPreview(null);
            },
            onError: (e)=>onError(e.response?.data?.error || e.message)
        });
    };
    /**
   * One click from "this wording costs us $150/class" to a reviewable fix:
   * open the editor with picklist replacements already applied, and say what
   * changed and what still needs a human. Nothing is saved until Save.
   */ const runFixTerms = ()=>{
        setFixNote(null);
        fixTerms.mutate({
            reportId: report.id
        }, {
            onSuccess: (res)=>{
                const byClass = new Map((res.classes || []).map((c)=>[
                        c.classNumber,
                        c.replacements || []
                    ]));
                let applied = 0;
                const unresolved = [];
                const next = {
                    countries: [
                        ...quote.countries || []
                    ],
                    classes: (quote.classes || []).map((c)=>{
                        const classNumber = c.classNumber ?? c.number;
                        const replacements = byClass.get(classNumber) || [];
                        const terms = [
                            ...c.goodsServices || []
                        ];
                        for (const r of replacements){
                            const at = terms.indexOf(r.term);
                            if (at === -1) continue;
                            if (r.replacement) {
                                terms[at] = r.replacement;
                                applied += 1;
                            } else unresolved.push(`class ${classNumber}: "${r.term}"`);
                        }
                        return {
                            classNumber: classNumber,
                            className: c.className || c.name || '',
                            goodsServices: [
                                ...new Set(terms)
                            ]
                        };
                    }),
                    autoPrice: !quote.manualPrice,
                    serviceFeeTotal: quote.serviceFeeTotal ?? '',
                    govFeeTotal: quote.govFeeTotal ?? '',
                    discount: quote.discount ?? 0,
                    total: quote.total ?? ''
                };
                setPreview(null);
                setPricingError(null);
                setDraft(next);
                refreshPrice(next);
                setFixNote({
                    applied: applied,
                    unresolved: unresolved,
                    text: applied > 0 ? `Replaced ${applied} term${applied > 1 ? 's' : ''} with picklist wording. Check them, then save.` : 'No picklist wording preserved the meaning of these terms, so nothing was changed.'
                });
            },
            onError: (e)=>onError(e.response?.data?.error || e.message)
        });
    };
    const doSendRevision = ()=>{
        sendRevision.mutate({
            reportId: report.id
        }, {
            onSuccess: (res)=>{
                setConfirmSend(false);
                setSendResult({
                    quoteNumber: res?.quoteNumber || '',
                    email: res?.email || report.contact?.email || 'the client'
                });
            },
            onError: (e)=>{
                setConfirmSend(false);
                onError(e.response?.data?.error || e.message);
            }
        });
    };
    const shownTotal = draft?.autoPrice && preview ? preview.total : Number(draft?.total);
    // An unsent revision is refined in place rather than renumbered, so the
    // label has to match what the server will actually do
    const nextRevision = report.quoteRevisionPending ? revision : revision + 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-card",
        style: {
            marginBottom: '10px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        style: {
                            margin: 0,
                            fontSize: '13px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            color: '#475569'
                        },
                        children: [
                            "Quote ",
                            quote?.quoteStatus === 'confirmed' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#047857'
                                },
                                children: "\xb7 confirmed"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#b45309'
                                },
                                children: "\xb7 estimate"
                            }),
                            revision > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    color: '#64748b'
                                },
                                children: [
                                    " \xb7 revision ",
                                    revision
                                ]
                            })
                        ]
                    }),
                    quote && !draft && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-secondary",
                        onClick: startEdit,
                        children: alreadySent ? 'Revise quote' : 'Edit quote'
                    })
                ]
            }),
            !quote ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    color: '#94a3b8',
                    fontSize: '13px',
                    margin: '8px 0 0'
                },
                children: "No pricing record linked."
            }) : draft ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: '12px'
                },
                children: [
                    alreadySent && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#fffbeb',
                            border: '1px solid #fde68a',
                            color: '#92400e',
                            borderRadius: '8px',
                            padding: '8px 12px',
                            fontSize: '13px',
                            marginBottom: '12px'
                        },
                        children: [
                            "This client already has quote ",
                            `Q-${String(report.applicationId).slice(0, 8).toUpperCase()}`,
                            revision > 1 ? `-R${revision}` : '',
                            ". Saving issues revision ",
                            nextRevision,
                            " and takes effect straight away, including what they would be charged in their dashboard, so send the update once you are happy with it."
                        ]
                    }),
                    fixNote && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#f0fdfa',
                            border: '1px solid #99f6e4',
                            borderRadius: '8px',
                            padding: '8px 12px',
                            fontSize: '13px',
                            marginBottom: '12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    margin: 0,
                                    color: '#0f766e',
                                    fontWeight: 600
                                },
                                children: fixNote.text
                            }),
                            fixNote.unresolved.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                style: {
                                    margin: '4px 0 0',
                                    color: '#92400e',
                                    fontSize: '12px'
                                },
                                children: [
                                    "Still needs you: ",
                                    fixNote.unresolved.join(', '),
                                    ". Open Goods & services on that class and pick a term, or remove it."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            marginBottom: '14px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#475569',
                                    margin: '0 0 6px'
                                },
                                children: "Countries"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '6px'
                                },
                                children: [
                                    countryOptions.map((c)=>{
                                        const on = draft.countries.includes(c.id);
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>toggleCountry(c.id),
                                            style: {
                                                border: `1px solid ${on ? '#0f766e' : '#cbd5e1'}`,
                                                background: on ? '#f0fdfa' : 'white',
                                                color: on ? '#0f766e' : '#64748b',
                                                fontWeight: on ? 600 : 400,
                                                borderRadius: '999px',
                                                padding: '4px 12px',
                                                fontSize: '12px',
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                c.icon,
                                                " ",
                                                c.name
                                            ]
                                        }, c.id);
                                    }),
                                    countryOptions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#94a3b8'
                                        },
                                        children: "Loading countries..."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            marginBottom: '14px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        style: {
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#475569',
                                            margin: '0 0 6px'
                                        },
                                        children: [
                                            "Classes (",
                                            draft.classes.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "mkt-btn mkt-btn-secondary",
                                        style: {
                                            fontSize: '12px'
                                        },
                                        onClick: ()=>setPickerOpen((v)=>!v),
                                        children: pickerOpen ? 'Close' : '+ Add class'
                                    })
                                ]
                            }),
                            pickerOpen && /*#__PURE__*/ (0, $ayMG0.jsx)($24b7a719c4d48354$var$ClassPicker, {
                                existing: draft.classes.map((c)=>c.classNumber),
                                onPick: addClass
                            }),
                            draft.classes.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    fontSize: '12px',
                                    color: '#b45309',
                                    margin: '4px 0'
                                },
                                children: "This quote has no classes recorded. Add at least one before saving."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: '8px',
                                    marginTop: '6px'
                                },
                                children: draft.classes.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '8px',
                                            padding: '10px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    flexWrap: 'wrap'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            fontWeight: 700,
                                                            color: '#0f766e',
                                                            fontSize: '13px'
                                                        },
                                                        children: [
                                                            "Class ",
                                                            c.classNumber
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        value: c.className,
                                                        onChange: (e)=>editClass(c.classNumber, {
                                                                className: e.target.value
                                                            }),
                                                        placeholder: "Class name shown on the quote",
                                                        style: {
                                                            flex: 1,
                                                            minWidth: '180px',
                                                            padding: '5px 8px',
                                                            border: '1px solid #cbd5e1',
                                                            borderRadius: '6px',
                                                            fontSize: '13px'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "mkt-btn mkt-btn-secondary",
                                                        style: {
                                                            fontSize: '12px'
                                                        },
                                                        onClick: ()=>setTermsOpenFor(termsOpenFor === c.classNumber ? null : c.classNumber),
                                                        children: [
                                                            "Goods & services (",
                                                            c.goodsServices.length,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "mkt-btn mkt-btn-secondary",
                                                        style: {
                                                            fontSize: '12px',
                                                            color: '#dc2626'
                                                        },
                                                        disabled: draft.classes.length <= 1,
                                                        onClick: ()=>removeClass(c.classNumber),
                                                        children: "Remove"
                                                    })
                                                ]
                                            }),
                                            termsOpenFor === c.classNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($24b7a719c4d48354$var$TermsEditor, {
                                                classNumber: c.classNumber,
                                                terms: c.goodsServices,
                                                reportId: report.id,
                                                onChange: (goodsServices)=>editClass(c.classNumber, {
                                                        goodsServices: goodsServices
                                                    })
                                            })
                                        ]
                                    }, c.classNumber))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            borderTop: '1px solid #e2e8f0',
                            paddingTop: '12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontSize: '13px',
                                    color: '#475569',
                                    marginBottom: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        checked: !!draft.autoPrice,
                                        onChange: (e)=>applyDraft({
                                                autoPrice: e.target.checked
                                            })
                                    }),
                                    "Price automatically from the countries and classes above"
                                ]
                            }),
                            pricingError && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    color: '#dc2626',
                                    fontSize: '13px',
                                    margin: '0 0 8px'
                                },
                                children: pricingError
                            }),
                            draft.autoPrice ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: '14px',
                                    color: '#334155'
                                },
                                children: [
                                    pricing && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: '#94a3b8'
                                        },
                                        children: "Pricing..."
                                    }),
                                    !pricing && !pricingError && preview && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: '18px',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "Service: ",
                                                    money(preview.serviceFeeTotal)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "Gov fees: ",
                                                    money(preview.govFeeTotal)
                                                ]
                                            }),
                                            preview.discount ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "Discount: -",
                                                    money(preview.discount)
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    fontWeight: 700,
                                                    color: '#0f766e'
                                                },
                                                children: [
                                                    "New total: ",
                                                    currency,
                                                    " ",
                                                    money(preview.total)
                                                ]
                                            }),
                                            quote.total != null && preview.total !== quote.total && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    color: '#64748b'
                                                },
                                                children: [
                                                    "(was ",
                                                    currency,
                                                    " ",
                                                    money(quote.total),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                                    gap: '10px',
                                    maxWidth: '640px'
                                },
                                children: [
                                    [
                                        'serviceFeeTotal',
                                        'Service fees'
                                    ],
                                    [
                                        'govFeeTotal',
                                        'Government fees'
                                    ],
                                    [
                                        'discount',
                                        'Discount'
                                    ],
                                    [
                                        'total',
                                        'Total (charged)'
                                    ]
                                ].map(([field, label])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#475569'
                                        },
                                        children: [
                                            label,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "number",
                                                value: draft[field],
                                                onChange: (e)=>setDraft((prev)=>({
                                                            ...prev,
                                                            [field]: e.target.value
                                                        })),
                                                style: {
                                                    display: 'block',
                                                    width: '100%',
                                                    marginTop: '4px',
                                                    padding: '6px 8px',
                                                    border: '1px solid #cbd5e1',
                                                    borderRadius: '6px'
                                                }
                                            })
                                        ]
                                    }, field))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '8px',
                                    marginTop: '14px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "mkt-btn mkt-btn-secondary",
                                        onClick: ()=>{
                                            setDraft(null);
                                            setPreview(null);
                                            setFixNote(null);
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "mkt-btn mkt-btn-primary",
                                        disabled: updateQuote.isPending || draft.classes.length === 0 || !(shownTotal > 0) || draft.autoPrice && (pricing || !!pricingError),
                                        onClick: save,
                                        children: updateQuote.isPending ? 'Saving...' : alreadySent ? `Save revision ${nextRevision}` : 'Confirm quote'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#334155'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '18px',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Countries: ",
                                    (quote.countries || []).join(', ').toUpperCase() || '?'
                                ]
                            }),
                            quote.serviceFeeTotal != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Service: ",
                                    money(quote.serviceFeeTotal)
                                ]
                            }),
                            quote.govFeeTotal != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Gov fees: ",
                                    money(quote.govFeeTotal)
                                ]
                            }),
                            quote.discount ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Discount: -",
                                    money(quote.discount)
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontWeight: 700,
                                    color: '#0f766e'
                                },
                                children: [
                                    "Total: ",
                                    currency,
                                    " ",
                                    money(quote.total)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            marginTop: '6px',
                            fontSize: '13px',
                            color: '#475569'
                        },
                        children: [
                            "Classes: ",
                            (quote.classes || []).length > 0 ? (quote.classes || []).map((c)=>`${c.classNumber ?? c.number}${c.className || c.name ? ` (${c.className || c.name})` : ''}`).join(', ') : quote.classCount || '?'
                        ]
                    }),
                    quote.validation?.mismatch && (quote.manualPrice ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#64748b',
                            fontSize: '12px',
                            margin: '6px 0 0'
                        },
                        children: [
                            "Custom price. The standard price for this scope is ",
                            currency,
                            " ",
                            money(quote.validation.expectedTotal),
                            ", and ",
                            currency,
                            " ",
                            money(quote.total),
                            " is what the client is charged."
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#dc2626',
                            fontSize: '12px',
                            margin: '6px 0 0'
                        },
                        children: [
                            "Stored total does not match the standard price for this scope (expected ",
                            currency,
                            " ",
                            money(quote.validation.expectedTotal),
                            "). Review before sending."
                        ]
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($24b7a719c4d48354$var$PicklistWarning, {
                        classes: quote.classes,
                        onFix: runFixTerms,
                        fixing: fixTerms.isPending
                    })
                ]
            }),
            report.quoteRevisionPending && alreadySent && !draft && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: '12px',
                    background: '#fffbeb',
                    border: '1px solid #fde68a',
                    borderRadius: '8px',
                    padding: '10px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            fontSize: '13px',
                            color: '#92400e'
                        },
                        children: [
                            "Revision ",
                            revision,
                            " has not been sent yet. The client still has the earlier quote."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-primary",
                        disabled: sendRevision.isPending,
                        onClick: ()=>setConfirmSend(true),
                        children: sendRevision.isPending ? 'Sending...' : 'Send updated quote'
                    })
                ]
            }),
            sendResult && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                style: {
                    marginTop: '10px',
                    fontSize: '13px',
                    color: '#047857'
                },
                children: [
                    "Updated quote ",
                    sendResult.quoteNumber,
                    " emailed to ",
                    sendResult.email,
                    "."
                ]
            }),
            confirmSend && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(15, 23, 42, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 50
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        background: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        maxWidth: '440px',
                        width: '90%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            style: {
                                margin: '0 0 8px'
                            },
                            children: "Send the updated quote?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            style: {
                                color: '#475569',
                                fontSize: '14px'
                            },
                            children: [
                                "This emails the revised quote to ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: report.contact?.email
                                }),
                                " with the new PDF attached and a sign-in link to their dashboard, where the new total is what they will be charged. The report itself is not resent, and the pipeline stage does not change."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '8px',
                                marginTop: '16px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-btn mkt-btn-secondary",
                                    onClick: ()=>setConfirmSend(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-btn mkt-btn-primary",
                                    disabled: sendRevision.isPending,
                                    onClick: doSendRevision,
                                    children: sendRevision.isPending ? 'Sending...' : 'Send it'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/**
 * Fee risk, in plain terms: we quote IP Australia's $250/class picklist rate,
 * but a class containing wording that isn't an exact picklist entry is filed
 * at $400/class. The difference comes out of our margin, so it has to be
 * visible before the quote goes out rather than discovered at filing.
 */ function $24b7a719c4d48354$var$PicklistWarning({ classes: classes, onFix: onFix, fixing: fixing }) {
    const list = classes || [];
    const failing = list.filter((c)=>c.picklistVerified === false);
    const unknown = list.filter((c)=>c.picklistVerified == null && (c.goodsServices || []).length === 0);
    if (failing.length === 0 && unknown.length === 0) {
        if (list.length > 0 && list.every((c)=>c.picklistVerified === true)) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            style: {
                color: '#047857',
                fontSize: '12px',
                margin: '6px 0 0'
            },
            children: "\u2713 All goods and services are exact IP Australia picklist terms ($250 per class)."
        });
        return null;
    }
    const extraCost = failing.length * 150;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            background: '#fffbeb',
            border: '1px solid #fde68a',
            borderRadius: '8px',
            padding: '8px 12px',
            margin: '8px 0 0'
        },
        children: [
            failing.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#92400e',
                            fontSize: '12px',
                            margin: 0,
                            fontWeight: 600
                        },
                        children: [
                            failing.length,
                            " class",
                            failing.length > 1 ? 'es' : '',
                            " contain",
                            failing.length > 1 ? '' : 's',
                            " wording that is not on the IP Australia picklist, so filing costs $400 per class instead of $250 (about $",
                            extraCost,
                            " more, which we absorb)."
                        ]
                    }),
                    failing.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            style: {
                                color: '#92400e',
                                fontSize: '11px',
                                margin: '4px 0 0'
                            },
                            children: [
                                "Class ",
                                c.classNumber,
                                ": ",
                                (c.nonPicklistTerms || []).map((t)=>t.suggestion ? `"${t.term}" (closest: "${t.suggestion}")` : `"${t.term}"`).join(', ')
                            ]
                        }, c.classNumber)),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginTop: '8px',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "mkt-btn mkt-btn-secondary",
                                style: {
                                    fontSize: '12px'
                                },
                                disabled: fixing,
                                onClick: onFix,
                                children: fixing ? 'Finding picklist wording...' : "\uD83D\uDEE0 Fix wording for me"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#92400e',
                                    fontSize: '11px'
                                },
                                children: "Picks the closest picklist term for each, for you to review before saving."
                            })
                        ]
                    })
                ]
            }),
            unknown.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                style: {
                    color: '#92400e',
                    fontSize: '11px',
                    margin: failing.length ? '6px 0 0' : 0
                },
                children: [
                    "No goods or services recorded for class",
                    unknown.length > 1 ? 'es' : '',
                    ' ',
                    unknown.map((c)=>c.classNumber).join(', '),
                    ", so the filing wording still has to be chosen."
                ]
            })
        ]
    });
}
/** Searchable list of the 45 NICE classes. */ function $24b7a719c4d48354$var$ClassPicker({ existing: existing, onPick: onPick }) {
    const [search, setSearch] = (0, $acw62.useState)('');
    const { data: data, isLoading: isLoading } = (0, $4878203aaaa5eb61$export$384d8c9ea6fb5aa4)(true);
    const classes = data?.classes || [];
    const term = search.trim().toLowerCase();
    const filtered = term ? classes.filter((c)=>String(c.classNumber) === term || (c.heading || '').toLowerCase().includes(term) || (c.shortName || '').toLowerCase().includes(term)) : classes;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            border: '1px solid #cbd5e1',
            borderRadius: '8px',
            padding: '10px',
            margin: '6px 0',
            background: '#f8fafc'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                autoFocus: true,
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                placeholder: "Search classes, e.g. retail or 35",
                style: {
                    width: '100%',
                    padding: '6px 8px',
                    border: '1px solid #cbd5e1',
                    borderRadius: '6px',
                    fontSize: '13px',
                    marginBottom: '8px'
                }
            }),
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    fontSize: '12px',
                    color: '#94a3b8',
                    margin: 0
                },
                children: "Loading classes..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    maxHeight: '220px',
                    overflowY: 'auto',
                    display: 'grid',
                    gap: '4px'
                },
                children: filtered.map((c)=>{
                    const already = existing.includes(c.classNumber);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        disabled: already,
                        onClick: ()=>onPick(c),
                        style: {
                            textAlign: 'left',
                            border: '1px solid #e2e8f0',
                            background: already ? '#f1f5f9' : 'white',
                            borderRadius: '6px',
                            padding: '6px 10px',
                            cursor: already ? 'default' : 'pointer',
                            color: already ? '#94a3b8' : '#334155',
                            fontSize: '12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                children: [
                                    "Class ",
                                    c.classNumber
                                ]
                            }),
                            " \xb7 ",
                            c.shortName,
                            already && ' (already on the quote)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: 'block',
                                    color: '#94a3b8',
                                    fontSize: '11px'
                                },
                                children: [
                                    (c.heading || '').slice(0, 110),
                                    "..."
                                ]
                            })
                        ]
                    }, c.classNumber);
                })
            })
        ]
    });
}
/**
 * Goods/services for one class.
 *
 * Terms are chosen from the IP AUSTRALIA PICKLIST, not typed. That is a
 * margin decision: IP Australia charges $250/class when every term is an
 * exact picklist entry and $400/class when any term is not, and our quote
 * always assumes $250. "Suggest with AI" proposes terms for this specific
 * applicant and snaps them to the picklist before they are offered.
 */ function $24b7a719c4d48354$var$TermsEditor({ classNumber: classNumber, terms: terms, onChange: onChange, reportId: reportId }) {
    const [search, setSearch] = (0, $acw62.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, $acw62.useState)('');
    const [aiSuggestions, setAiSuggestions] = (0, $acw62.useState)(null);
    const [aiError, setAiError] = (0, $acw62.useState)(null);
    const suggest = (0, $4878203aaaa5eb61$export$e510b38eddd847e8)();
    // Each search scans thousands of picklist terms server-side, so wait for a
    // pause in typing rather than firing a request per keystroke
    (0, $acw62.useEffect)(()=>{
        const t = setTimeout(()=>setDebouncedSearch(search.trim()), 250);
        return ()=>clearTimeout(t);
    }, [
        search
    ]);
    const { data: data, isFetching: isFetching } = (0, $4878203aaaa5eb61$export$ec63733f05f94041)(classNumber, debouncedSearch || undefined);
    const picklistTerms = (data?.terms || []).filter((t)=>!terms.includes(t)).slice(0, 15);
    const totalMatches = data?.termCount ?? null;
    const runSuggest = ()=>{
        setAiError(null);
        suggest.mutate({
            reportId: reportId,
            classNumber: classNumber
        }, {
            onSuccess: (res)=>setAiSuggestions(res),
            onError: (e)=>setAiError(e.response?.data?.error || e.message)
        });
    };
    const addTerm = (t)=>{
        if (terms.includes(t)) return;
        onChange([
            ...terms,
            t
        ]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginTop: '10px',
            borderTop: '1px dashed #e2e8f0',
            paddingTop: '10px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                rows: Math.min(8, Math.max(3, terms.length + 1)),
                value: terms.join('\n'),
                onChange: (e)=>onChange(e.target.value.split('\n').map((t)=>t.trim()).filter(Boolean)),
                placeholder: "One term per line. Pick from the picklist below rather than typing, or the filing costs $400/class instead of $250.",
                style: {
                    width: '100%',
                    padding: '6px 8px',
                    border: '1px solid #cbd5e1',
                    borderRadius: '6px',
                    fontSize: '13px',
                    fontFamily: 'inherit'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '6px',
                    marginTop: '6px',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        value: search,
                        onChange: (e)=>setSearch(e.target.value),
                        placeholder: `Search the IP Australia picklist for class ${classNumber}`,
                        style: {
                            flex: 1,
                            padding: '6px 8px',
                            border: '1px solid #cbd5e1',
                            borderRadius: '6px',
                            fontSize: '12px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "mkt-btn mkt-btn-secondary",
                        style: {
                            fontSize: '12px',
                            whiteSpace: 'nowrap'
                        },
                        disabled: suggest.isPending,
                        onClick: runSuggest,
                        children: suggest.isPending ? 'Thinking...' : "\u2728 Suggest with AI"
                    })
                ]
            }),
            totalMatches != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                style: {
                    fontSize: '11px',
                    color: '#94a3b8',
                    margin: '4px 0 0'
                },
                children: [
                    totalMatches.toLocaleString(),
                    " picklist term",
                    totalMatches === 1 ? '' : 's',
                    debouncedSearch ? ` match "${debouncedSearch}"` : ` in class ${classNumber}`,
                    data?.truncated ? ', showing the closest' : ''
                ]
            }),
            aiError && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    fontSize: '12px',
                    color: '#dc2626',
                    margin: '6px 0 0'
                },
                children: aiError
            }),
            aiSuggestions && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: '8px',
                    background: '#f0fdfa',
                    border: '1px solid #99f6e4',
                    borderRadius: '8px',
                    padding: '8px 10px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            fontSize: '11px',
                            color: '#0f766e',
                            margin: '0 0 6px',
                            fontWeight: 600
                        },
                        children: [
                            "Suggested for this business",
                            aiSuggestions.rationale ? `: ${aiSuggestions.rationale}` : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '4px'
                        },
                        children: [
                            aiSuggestions.suggestions.filter((s)=>!terms.includes(s.term)).map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>addTerm(s.term),
                                    title: "Exact IP Australia picklist term",
                                    style: {
                                        border: '1px solid #0f766e',
                                        background: 'white',
                                        borderRadius: '999px',
                                        padding: '3px 10px',
                                        fontSize: '11px',
                                        cursor: 'pointer',
                                        color: '#0f766e'
                                    },
                                    children: [
                                        "+ ",
                                        s.term
                                    ]
                                }, s.term)),
                            aiSuggestions.suggestions.length > 0 && aiSuggestions.suggestions.every((s)=>terms.includes(s.term)) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '11px',
                                    color: '#0f766e'
                                },
                                children: "All ready-to-use suggestions added."
                            }),
                            aiSuggestions.suggestions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '11px',
                                    color: '#0f766e'
                                },
                                children: "Nothing matched the picklist exactly, so pick from the options below."
                            })
                        ]
                    }),
                    (aiSuggestions.needsChoice || []).map((n)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                marginTop: '8px',
                                borderTop: '1px dashed #99f6e4',
                                paddingTop: '6px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    style: {
                                        fontSize: '11px',
                                        color: '#0f766e',
                                        margin: '0 0 4px'
                                    },
                                    children: [
                                        "\u201C",
                                        n.aiTerm,
                                        "\u201D is not a picklist term on its own.",
                                        n.searchQuery && n.searchQuery !== n.aiTerm ? ` Closest ${n.optionCount.toLocaleString()} for "${n.searchQuery}":` : ` Closest of ${n.optionCount.toLocaleString()}:`
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '4px'
                                    },
                                    children: [
                                        n.options.filter((o)=>!terms.includes(o)).map((o)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>addTerm(o),
                                                style: {
                                                    border: '1px solid #cbd5e1',
                                                    background: 'white',
                                                    borderRadius: '999px',
                                                    padding: '3px 10px',
                                                    fontSize: '11px',
                                                    cursor: 'pointer',
                                                    color: '#475569'
                                                },
                                                children: [
                                                    "+ ",
                                                    o
                                                ]
                                            }, o)),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>setSearch(n.searchQuery || n.aiTerm),
                                            style: {
                                                border: 'none',
                                                background: 'transparent',
                                                fontSize: '11px',
                                                cursor: 'pointer',
                                                color: '#0f766e',
                                                textDecoration: 'underline'
                                            },
                                            children: [
                                                "search all ",
                                                n.optionCount.toLocaleString()
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, n.aiTerm))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px',
                    marginTop: '6px'
                },
                children: [
                    isFetching && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '11px',
                            color: '#94a3b8'
                        },
                        children: "Searching..."
                    }),
                    picklistTerms.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>addTerm(t),
                            style: {
                                border: '1px solid #cbd5e1',
                                background: 'white',
                                borderRadius: '999px',
                                padding: '3px 10px',
                                fontSize: '11px',
                                cursor: 'pointer',
                                color: '#475569'
                            },
                            children: [
                                "+ ",
                                t
                            ]
                        }, t))
                ]
            })
        ]
    });
}
var $24b7a719c4d48354$export$2e2bcd8739ae039 = $24b7a719c4d48354$var$QuoteEditor;


const $cb608f7a192aafc4$var$SECTION_TITLES = {
    overview: 'Overview',
    markAssessment: 'Our Assessment of the Mark',
    registerFindings: 'Register Findings',
    coverageRationale: 'Protection Coverage',
    ourRecommendation: 'Our Recommendation',
    nextSteps: 'Next Steps'
};
/**
 * ReportDetail — review, edit and send a generated report.
 * - Sections editable per block (saved to the reports row)
 * - Register matches table (real IP Australia hits)
 * - Quote card (QuoteEditor): countries, classes and price, and revising the
 *   quote after the client already has it
 * - Send mints a fresh Clerk magic link server-side and emails the report
 */ function $cb608f7a192aafc4$var$ReportDetail() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { data: data, isLoading: isLoading, error: error } = (0, $4878203aaaa5eb61$export$335080e14d32489b)(id);
    const regenerate = (0, $4878203aaaa5eb61$export$7685313327762392)();
    const updateReport = (0, $4878203aaaa5eb61$export$e2711b9b8da2c4d8)();
    const sendReport = (0, $4878203aaaa5eb61$export$f1fbd11d4001b56b)();
    const report = data?.report || null;
    const application = data?.application || null;
    const [sections, setSections] = (0, $acw62.useState)({});
    const [editingSection, setEditingSection] = (0, $acw62.useState)(null);
    const [confirmSend, setConfirmSend] = (0, $acw62.useState)(false);
    const [actionError, setActionError] = (0, $acw62.useState)(null);
    // Rehydrate section text from the server copy, but never while a section
    // is being edited — a refetch (e.g. after a quote save invalidates the
    // query) must not wipe in-progress edits.
    (0, $acw62.useEffect)(()=>{
        if (report?.sections && !editingSection) setSections(report.sections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        report?.sections
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading report..."
            })
        ]
    });
    if (error || !report) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    color: '#dc2626'
                },
                children: "Report not found."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: "/marketing/reports",
                children: "Back to reports"
            })
        ]
    });
    const { label: statusLabel, ...statusStyle } = (0, $2f18fe9aa2e75117$export$561598fdff96527c)[report.status] || {};
    const quote = report.quote || null;
    const rs = report.registerSearch || null;
    const matches = rs ? [
        ...rs.exactMatches || [],
        ...rs.nearMatches || []
    ] : [];
    const saveSection = (key)=>{
        updateReport.mutate({
            reportId: report.id,
            sections: {
                [key]: sections[key]
            }
        }, {
            onSuccess: ()=>setEditingSection(null),
            onError: (e)=>setActionError(e.message)
        });
    };
    const doSend = ()=>{
        setActionError(null);
        sendReport.mutate({
            reportId: report.id
        }, {
            onSuccess: ()=>{
                setConfirmSend(false);
                navigate('/marketing/reports');
            },
            onError: (e)=>{
                setConfirmSend(false);
                setActionError(e.response?.data?.error || e.message);
            }
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-page-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/marketing/reports",
                                style: {
                                    fontSize: '13px',
                                    color: '#0f766e'
                                },
                                children: "\u2190 Reports"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    report.trademarkName ? `"${report.trademarkName}"` : report.applicationId,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...statusStyle,
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            fontWeight: 700,
                                            padding: '2px 10px'
                                        },
                                        children: statusLabel || report.status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mkt-page-subtitle",
                                children: [
                                    report.contact?.name || '',
                                    " ",
                                    report.contact?.email ? `\xb7 ${report.contact.email}` : '',
                                    report.contact?.phone ? ` \xb7 ${report.contact.phone}` : '',
                                    application?.status ? ` \xb7 application: ${application.status}` : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'flex-start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "mkt-btn mkt-btn-secondary",
                                disabled: regenerate.isPending || report.status === 'generating',
                                onClick: ()=>regenerate.mutate(report.id, {
                                        onError: (e)=>setActionError(e.message)
                                    }),
                                children: regenerate.isPending ? 'Regenerating...' : 'Regenerate'
                            }),
                            report.status === 'sent' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "mkt-btn mkt-btn-primary",
                                disabled: sendReport.isPending,
                                onClick: ()=>setConfirmSend(true),
                                children: sendReport.isPending ? 'Sending...' : 'Resend with fresh link'
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "mkt-btn mkt-btn-primary",
                                disabled: sendReport.isPending || report.status !== 'draft',
                                onClick: ()=>setConfirmSend(true),
                                children: sendReport.isPending ? 'Sending...' : 'Send report & quote'
                            })
                        ]
                    })
                ]
            }),
            actionError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    background: '#fef2f2',
                    border: '1px solid #fecaca',
                    color: '#dc2626',
                    borderRadius: '8px',
                    padding: '10px 14px',
                    marginBottom: '14px',
                    fontSize: '13px'
                },
                children: actionError
            }),
            report.error && report.status === 'failed' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: '#fef2f2',
                    border: '1px solid #fecaca',
                    color: '#dc2626',
                    borderRadius: '8px',
                    padding: '10px 14px',
                    marginBottom: '14px',
                    fontSize: '13px'
                },
                children: [
                    "Generation failed: ",
                    report.error
                ]
            }),
            report.provisioningError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: '#fffbeb',
                    border: '1px solid #fcd34d',
                    color: '#b45309',
                    borderRadius: '8px',
                    padding: '10px 14px',
                    marginBottom: '14px',
                    fontSize: '13px'
                },
                children: [
                    "Account provisioning failed at quote request (",
                    report.provisioningError,
                    "). Sending will retry provisioning automatically."
                ]
            }),
            Object.keys($cb608f7a192aafc4$var$SECTION_TITLES).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-card",
                    style: {
                        marginBottom: '10px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    style: {
                                        margin: 0,
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        color: '#475569'
                                    },
                                    children: $cb608f7a192aafc4$var$SECTION_TITLES[key]
                                }),
                                editingSection === key ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '6px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "mkt-btn mkt-btn-secondary",
                                            onClick: ()=>{
                                                setSections(report.sections || {});
                                                setEditingSection(null);
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "mkt-btn mkt-btn-secondary",
                                            style: {
                                                color: '#0f766e',
                                                fontWeight: 600
                                            },
                                            disabled: updateReport.isPending,
                                            onClick: ()=>saveSection(key),
                                            children: updateReport.isPending ? 'Saving...' : 'Save'
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-btn mkt-btn-secondary",
                                    onClick: ()=>setEditingSection(key),
                                    children: "Edit"
                                })
                            ]
                        }),
                        editingSection === key ? /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            value: sections[key] || '',
                            onChange: (e)=>setSections((prev)=>({
                                        ...prev,
                                        [key]: e.target.value
                                    })),
                            rows: 5,
                            style: {
                                width: '100%',
                                marginTop: '8px',
                                fontSize: '14px',
                                lineHeight: 1.6,
                                padding: '10px',
                                border: '1px solid #cbd5e1',
                                borderRadius: '8px'
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                margin: '8px 0 0',
                                color: '#334155',
                                fontSize: '14px',
                                lineHeight: 1.6
                            },
                            children: sections[key] || /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                style: {
                                    color: '#94a3b8'
                                },
                                children: "Empty"
                            })
                        })
                    ]
                }, key)),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-card",
                style: {
                    marginBottom: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        style: {
                            margin: '0 0 8px',
                            fontSize: '13px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            color: '#475569'
                        },
                        children: [
                            "IP Australia Register Search",
                            rs?.checkedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                    letterSpacing: 0,
                                    color: '#94a3b8'
                                },
                                children: [
                                    " \xb7 checked ",
                                    new Date(rs.checkedAt).toLocaleString()
                                ]
                            })
                        ]
                    }),
                    !rs || rs.unavailable ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#b45309',
                            fontSize: '13px',
                            margin: 0
                        },
                        children: [
                            "Register search was unavailable",
                            rs?.error ? ` (${rs.error})` : '',
                            ". Regenerate to retry."
                        ]
                    }) : matches.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            color: '#047857',
                            fontSize: '13px',
                            margin: 0
                        },
                        children: "No matches found on the register."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        style: {
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontSize: '13px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    style: {
                                        color: '#64748b',
                                        textAlign: 'left'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: "Mark"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: "Number"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: "Owner"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: "Classes"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: "Match"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: matches.map((m, i)=>{
                                    const exact = (rs.exactMatches || []).includes(m);
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            borderTop: '1px solid #f1f5f9'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '6px 8px',
                                                    fontWeight: 600
                                                },
                                                children: m.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '6px 8px',
                                                    color: '#64748b'
                                                },
                                                children: m.number
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '6px 8px',
                                                    color: '#64748b'
                                                },
                                                children: m.status
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '6px 8px',
                                                    color: '#64748b'
                                                },
                                                children: m.ownerName
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '6px 8px',
                                                    color: '#64748b'
                                                },
                                                children: (m.classes || []).join(', ')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '6px 8px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        background: exact ? '#fef2f2' : '#f1f5f9',
                                                        color: exact ? '#dc2626' : '#64748b',
                                                        borderRadius: '4px',
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        padding: '1px 6px'
                                                    },
                                                    children: exact ? 'exact' : 'near'
                                                })
                                            })
                                        ]
                                    }, `${m.number || i}`);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24b7a719c4d48354$export$2e2bcd8739ae039), {
                report: report,
                quote: quote,
                onError: setActionError
            }),
            confirmSend && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(15, 23, 42, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 50
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        background: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        maxWidth: '440px',
                        width: '90%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            style: {
                                margin: '0 0 8px'
                            },
                            children: "Send report & quote?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            style: {
                                color: '#475569',
                                fontSize: '14px'
                            },
                            children: [
                                "This emails the report to ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: report.contact?.email
                                }),
                                " with a fresh dashboard sign-in link, confirms the quote, and moves the pipeline to Report Sent."
                            ]
                        }),
                        quote?.quoteStatus !== 'confirmed' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                color: '#b45309',
                                fontSize: '13px'
                            },
                            children: "The quote is still an estimate. It will be marked confirmed as-is when sent."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '8px',
                                marginTop: '16px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-btn mkt-btn-secondary",
                                    onClick: ()=>setConfirmSend(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mkt-btn mkt-btn-primary",
                                    disabled: sendReport.isPending,
                                    onClick: doSend,
                                    children: sendReport.isPending ? 'Sending...' : 'Send it'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $cb608f7a192aafc4$export$2e2bcd8739ae039 = $cb608f7a192aafc4$var$ReportDetail;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




/**
 * The logo the visitor uploaded, shown and downloadable.
 *
 * Fetched as a blob through the authenticated API rather than linked: the
 * stored blob URL carries a SAS token that expires a year after upload, and
 * an <img> tag can't send our auth header. The same blob backs the preview
 * and the download, so the file is only pulled once.
 */ function $163f137fdcc9a190$var$LogoPreview({ applicationId: applicationId, fileName: fileName }) {
    const [objectUrl, setObjectUrl] = (0, $acw62.useState)(null);
    const [blob, setBlob] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!applicationId) return undefined;
        let url = null;
        let cancelled = false;
        (0, $7e53e8fdf8fe9e90$export$2e2bcd8739ae039).downloadTrademarkImage(applicationId).then((data)=>{
            if (cancelled) return;
            url = window.URL.createObjectURL(data);
            setBlob(data);
            setObjectUrl(url);
        }).catch((e)=>{
            if (!cancelled) setError(e.response?.status === 404 ? 'No logo stored' : 'Could not load the logo');
        });
        return ()=>{
            cancelled = true;
            if (url) window.URL.revokeObjectURL(url);
        };
    }, [
        applicationId
    ]);
    const handleDownload = ()=>{
        if (!blob) return;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'trademark-logo.png';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginTop: '14px',
            borderTop: '1px solid #e2e8f0',
            paddingTop: '14px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mkt-field-label",
                children: "Logo"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    color: '#94a3b8',
                    fontSize: '13px',
                    margin: '6px 0 0'
                },
                children: error
            }),
            !error && !objectUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    color: '#94a3b8',
                    fontSize: '13px',
                    margin: '6px 0 0'
                },
                children: "Loading logo..."
            }),
            objectUrl && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '14px',
                    marginTop: '8px',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: objectUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        title: "Open full size",
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '140px',
                            height: '140px',
                            padding: '8px',
                            background: 'white',
                            border: '1px solid #e2e8f0',
                            borderRadius: '10px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: objectUrl,
                            alt: fileName || 'Uploaded logo',
                            style: {
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '6px'
                        },
                        children: [
                            fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '12px',
                                    color: '#64748b',
                                    wordBreak: 'break-all'
                                },
                                children: fileName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "mkt-btn mkt-btn-secondary",
                                onClick: handleDownload,
                                children: "Download logo"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Mirrors the pipeline's report-first column order. `first_contact` is a
// legacy value (bucketed into Report sent on the board) — kept here so old
// records still render a labelled option.
const $163f137fdcc9a190$var$STATUS_OPTIONS = [
    {
        value: 'not_contacted',
        label: 'Awaiting Report'
    },
    {
        value: 'first_contact',
        label: 'First Contact (legacy)'
    },
    {
        value: 'report_sent',
        label: 'Report Sent'
    },
    {
        value: 'checkout_nudge',
        label: 'First Nudge'
    },
    {
        value: 'second_contact',
        label: 'Second Nudge'
    },
    {
        value: 'call',
        label: 'Call List'
    },
    {
        value: 'feedback',
        label: 'Feedback'
    },
    {
        value: 'responded',
        label: 'Responded'
    },
    {
        value: 'paid',
        label: 'Paid'
    },
    {
        value: 'do_not_contact',
        label: 'Do Not Contact'
    },
    {
        value: 'not_serious',
        label: 'Not Serious'
    }
];
const $163f137fdcc9a190$var$TIMELINE_ICONS = {
    visitor_landed: "\uD83D\uDD17",
    tracking_captured: "\uD83D\uDD17",
    wizard_started: "\uD83D\uDE80",
    step_start: "\u25B6\uFE0F",
    step_business: "\uD83C\uDFE2",
    step_analysis: "\uD83D\uDD0D",
    step_contact: "\uD83D\uDCE7",
    step_countries: "\uD83C\uDF0D",
    step_details: "\uD83D\uDCCB",
    step_checkout: "\uD83D\uDCB3",
    analysis_triggered: "\uD83D\uDD0D",
    analysis_completed: "\u2705",
    contact_captured: "\uD83D\uDCE7",
    countries_selected: "\uD83C\uDF0D",
    payment_complete: "\uD83D\uDCB0",
    ai_cost: "\uD83E\uDD16",
    note_added: "\uD83D\uDCDD",
    follow_up_sent: "\uD83D\uDCE4",
    status_change: "\uD83D\uDD04"
};
function $163f137fdcc9a190$var$VisitorProfile() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { data: visitor, isLoading: isLoading, error: error } = (0, $4878203aaaa5eb61$export$9b251f761e09847a)(id);
    const addNote = (0, $4878203aaaa5eb61$export$47da257c0181caef)();
    const updateStatus = (0, $4878203aaaa5eb61$export$d91fdd4f78c535ff)();
    const setReminder = (0, $4878203aaaa5eb61$export$94a11939e0d05a57)();
    const [noteText, setNoteText] = (0, $acw62.useState)('');
    const [outreachOpen, setOutreachOpen] = (0, $acw62.useState)(false);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-profile-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading visitor profile..."
            })
        ]
    });
    if (error || !visitor) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-profile-error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Visitor not found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>navigate('/marketing/pipeline'),
                className: "mkt-btn mkt-btn-secondary",
                children: "Back to Pipeline"
            })
        ]
    });
    const handleAddNote = async ()=>{
        if (!noteText.trim()) return;
        await addNote.mutateAsync({
            visitorId: id,
            content: noteText.trim()
        });
        setNoteText('');
    };
    const handleStatusChange = async (status)=>{
        await updateStatus.mutateAsync({
            visitorId: id,
            status: status
        });
    };
    // The compose modal reads flat fields (like pipeline cards) — the detail
    // endpoint nests analysis, so flatten what the composer's crib panel uses.
    const composeVisitor = {
        ...visitor,
        riskLevel: visitor.riskLevel || visitor.analysis?.riskLevel || null,
        analysisSummary: visitor.analysisSummary || visitor.analysis?.summary || null
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-profile",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>navigate('/marketing/pipeline'),
                className: "mkt-btn mkt-btn-back",
                children: "\u2190 Back to Pipeline"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-identity",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "mkt-profile-name",
                                children: visitor.name || visitor.browseId?.substring(0, 16) || visitor.tempUserId?.substring(0, 16)
                            }),
                            visitor.email && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mkt-profile-email",
                                children: visitor.email
                            }),
                            visitor.phone && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mkt-profile-phone",
                                children: visitor.phone
                            }),
                            visitor.isReturning && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-badge mkt-badge-returning",
                                children: "Returning Visitor"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-stage",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `mkt-stage-badge mkt-stage-${visitor.currentStep || 'landing'}`,
                                children: $163f137fdcc9a190$var$formatStage(visitor.currentStep || 'landing')
                            }),
                            visitor.wizardMode && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mkt-visitor-mode",
                                style: {
                                    marginLeft: 8
                                },
                                children: visitor.wizardMode
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-profile-section mkt-profile-actions",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mkt-action-buttons",
                    children: [
                        visitor.email && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>setOutreachOpen(true),
                            className: "mkt-btn mkt-btn-primary",
                            children: [
                                "\u2709\uFE0F Email ",
                                (visitor.name || '').split(' ')[0] || 'visitor'
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                            className: "mkt-status-select",
                            value: visitor.contactStatus || visitor.followUpStatus || 'not_contacted',
                            onChange: (e)=>handleStatusChange(e.target.value),
                            disabled: updateStatus.isPending,
                            children: $163f137fdcc9a190$var$STATUS_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: opt.value,
                                    children: opt.label
                                }, opt.value))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                fontSize: '12px',
                                color: '#64748b',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px'
                            },
                            children: [
                                "Remind me in:",
                                [
                                    1,
                                    3,
                                    7
                                ].map((d)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        className: "mkt-btn mkt-btn-ghost",
                                        style: {
                                            fontSize: '12px',
                                            padding: '2px 8px'
                                        },
                                        disabled: setReminder.isPending,
                                        onClick: ()=>setReminder.mutate({
                                                visitorId: id,
                                                days: d
                                            }),
                                        children: [
                                            d,
                                            "d"
                                        ]
                                    }, d)),
                                visitor.nextTouchAt && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                color: '#b45309'
                                            },
                                            children: [
                                                "\u23F0 ",
                                                new Date(visitor.nextTouchAt).toLocaleDateString('en-AU')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "mkt-btn mkt-btn-ghost",
                                            style: {
                                                fontSize: '12px',
                                                padding: '2px 8px'
                                            },
                                            onClick: ()=>setReminder.mutate({
                                                    visitorId: id,
                                                    days: 0
                                                }),
                                            children: "clear"
                                        })
                                    ]
                                })
                            ]
                        }),
                        visitor.clarityUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: visitor.clarityUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "mkt-btn mkt-btn-secondary",
                            children: "\uD83D\uDC41 Watch Session"
                        })
                    ]
                })
            }),
            visitor.trademarkName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Trademark"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-grid",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value",
                                        children: [
                                            "\u201C",
                                            visitor.trademarkName,
                                            "\u201D"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.trademarkType || 'word'
                                    })
                                ]
                            }),
                            visitor.selectedCountries?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Countries"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.selectedCountries.join(', ')
                                    })
                                ]
                            }),
                            visitor.classCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Classes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.classCount
                                    })
                                ]
                            }),
                            visitor.cartValue > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Cart Value"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value mkt-value-highlight",
                                        children: [
                                            "$",
                                            visitor.cartValue.toLocaleString()
                                        ]
                                    })
                                ]
                            }),
                            visitor.transactionValue > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Paid"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value mkt-value-highlight",
                                        children: [
                                            "$",
                                            visitor.transactionValue.toLocaleString(),
                                            " ",
                                            visitor.currency || ''
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    visitor.hasTrademarkImage && /*#__PURE__*/ (0, $ayMG0.jsx)($163f137fdcc9a190$var$LogoPreview, {
                        applicationId: visitor.applicationId,
                        fileName: visitor.trademarkFileName
                    })
                ]
            }),
            (visitor.businessName || visitor.businessDescription || visitor.industry || visitor.websiteUrl || visitor.intendedUse) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Business Information"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-grid",
                        children: [
                            visitor.businessName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Business Name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.businessName
                                    })
                                ]
                            }),
                            visitor.industry && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Industry"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.industry
                                    })
                                ]
                            }),
                            visitor.websiteUrl && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Website"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: visitor.websiteUrl.startsWith('http') ? visitor.websiteUrl : `https://${visitor.websiteUrl}`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: visitor.websiteUrl
                                        })
                                    })
                                ]
                            }),
                            visitor.intendedUse && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Intended Use"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.intendedUse
                                    })
                                ]
                            }),
                            visitor.businessDescription && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field mkt-field-wide",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.businessDescription
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            visitor.previousSessions?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Previous Sessions"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-funnel-visitors-list",
                        children: visitor.previousSessions.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-funnel-visitor-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-funnel-visitor-info",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-visitor-name",
                                                children: s.trademarkName || s.currentStep
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-visitor-date",
                                                children: $163f137fdcc9a190$var$formatDate(s.createdAt)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-visitor-mode",
                                                children: s.currentStep
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mkt-funnel-visitor-actions",
                                        children: s.clarityUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: s.clarityUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "mkt-btn-icon",
                                            title: "Clarity",
                                            children: "\uD83D\uDC41"
                                        })
                                    })
                                ]
                            }, s.id))
                    })
                ]
            }),
            visitor.attribution && (visitor.attribution.trafficSource || visitor.attribution.utmSource || visitor.attribution.gclid) && /*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("summary", {
                        style: {
                            cursor: 'pointer',
                            fontWeight: 600,
                            color: '#475569',
                            fontSize: '14px'
                        },
                        children: "Marketing details (source, campaign, tracking)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-grid",
                        style: {
                            marginTop: '10px'
                        },
                        children: [
                            visitor.attribution.trafficSource && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Traffic Source"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.attribution.trafficSource
                                    })
                                ]
                            }),
                            visitor.attribution.utmSource && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Source / Medium"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value",
                                        children: [
                                            visitor.attribution.utmSource,
                                            visitor.attribution.utmMedium ? ` / ${visitor.attribution.utmMedium}` : ''
                                        ]
                                    })
                                ]
                            }),
                            (visitor.attribution.adCampaign || visitor.attribution.utmCampaign) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Campaign"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.attribution.adCampaign || visitor.attribution.utmCampaign
                                    })
                                ]
                            }),
                            visitor.attribution.adGroup && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Ad Group"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.attribution.adGroup
                                    })
                                ]
                            }),
                            visitor.attribution.adName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Ad"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.attribution.adName
                                    })
                                ]
                            }),
                            (visitor.attribution.adKeyword || visitor.attribution.utmTerm) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Keyword"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value",
                                        children: [
                                            visitor.attribution.adKeyword || visitor.attribution.utmTerm,
                                            visitor.attribution.adMatchType ? ` (${String(visitor.attribution.adMatchType).toLowerCase()} match)` : ''
                                        ]
                                    })
                                ]
                            }),
                            visitor.attribution.gclid && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Google Click ID"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value mkt-field-mono",
                                        children: [
                                            visitor.attribution.gclid.substring(0, 20),
                                            "..."
                                        ]
                                    })
                                ]
                            }),
                            visitor.attribution.landingPage && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Landing Page"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.attribution.landingPage
                                    })
                                ]
                            }),
                            visitor.attribution.referrer && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Referrer"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.attribution.referrer
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            visitor.analysis && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "AI Trademark Analysis"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-grid",
                        children: [
                            visitor.analysis.riskLevel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Risk Level"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `mkt-field-value mkt-risk-badge mkt-risk-${visitor.analysis.riskLevel.toLowerCase()}`,
                                        children: visitor.analysis.riskLevel
                                    })
                                ]
                            }),
                            visitor.analysis.registrationLikelihood && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Registration Likelihood"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.analysis.registrationLikelihood
                                    })
                                ]
                            }),
                            visitor.analysis.distinctivenessScore != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Distinctiveness"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "mkt-field-value",
                                        children: [
                                            visitor.analysis.distinctivenessScore,
                                            "/100 (",
                                            visitor.analysis.distinctivenessRating || '',
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            visitor.analysis.estimatedTimeline && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Est. Timeline"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.analysis.estimatedTimeline
                                    })
                                ]
                            }),
                            visitor.analysis.summary && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field mkt-field-wide",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "AI Summary"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value mkt-analysis-text",
                                        children: visitor.analysis.summary
                                    })
                                ]
                            }),
                            visitor.analysis.recommendation && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field mkt-field-wide",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Recommendation"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value mkt-analysis-text",
                                        children: visitor.analysis.recommendation
                                    })
                                ]
                            })
                        ]
                    }),
                    visitor.analysis.conflicts?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-analysis-subsection",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                children: [
                                    "Potential Conflicts (",
                                    visitor.analysis.conflicts.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mkt-conflicts-list",
                                children: visitor.analysis.conflicts.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-conflict-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `mkt-conflict-risk mkt-risk-${c.risk}`,
                                                children: c.risk
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-conflict-name",
                                                children: c.name
                                            }),
                                            c.class && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-conflict-class",
                                                children: [
                                                    "Class ",
                                                    c.class
                                                ]
                                            }),
                                            c.jurisdiction && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-conflict-jurisdiction",
                                                children: c.jurisdiction
                                            }),
                                            c.notes && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mkt-conflict-notes",
                                                children: c.notes
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    visitor.analysis.recommendedClasses?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-analysis-subsection",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: "Recommended Classes"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mkt-classes-list",
                                children: visitor.analysis.recommendedClasses.map((cls, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-class-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "mkt-class-number",
                                                children: [
                                                    "Class ",
                                                    cls.classNumber || cls.class
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-class-name",
                                                children: cls.className || cls.name
                                            }),
                                            cls.relevance && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-class-relevance",
                                                children: cls.relevance
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    })
                ]
            }),
            visitor.aiScanResult && typeof visitor.aiScanResult === 'object' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Website Scan (AI)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-grid",
                        children: [
                            visitor.aiScanResult.businessName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Detected Business"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.aiScanResult.businessName
                                    })
                                ]
                            }),
                            visitor.aiScanResult.industry && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Detected Industry"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.aiScanResult.industry
                                    })
                                ]
                            }),
                            visitor.aiScanResult.products && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Products/Services"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.aiScanResult.products
                                    })
                                ]
                            }),
                            visitor.aiScanResult.suggestedTrademarkUse && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Suggested Use"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: visitor.aiScanResult.suggestedTrademarkUse
                                    })
                                ]
                            }),
                            visitor.aiScanResult.businessDescription && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field mkt-field-wide",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "AI Description"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value mkt-analysis-text",
                                        children: visitor.aiScanResult.businessDescription
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            visitor.aiScanResult && typeof visitor.aiScanResult === 'string' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Website Scan (AI)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-profile-grid",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mkt-profile-field mkt-field-wide",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mkt-field-label",
                                    children: "Result"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mkt-field-value mkt-analysis-text",
                                    children: visitor.aiScanResult
                                })
                            ]
                        })
                    })
                ]
            }),
            visitor.outreachLog?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Outreach History"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-outreach-log",
                        children: visitor.outreachLog.map((entry, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-outreach-entry",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-outreach-header",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-outreach-type",
                                                children: entry.type?.replace(/_/g, ' ')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-outreach-date",
                                                children: $163f137fdcc9a190$var$formatDate(entry.sentAt)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-outreach-details",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "To: ",
                                                    entry.recipientEmail
                                                ]
                                            }),
                                            entry.sentByName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    " \xb7 By: ",
                                                    entry.sentByName
                                                ]
                                            }),
                                            entry.subject && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mkt-outreach-subject",
                                                children: [
                                                    "Subject: ",
                                                    entry.subject
                                                ]
                                            }),
                                            entry.customMessage && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mkt-outreach-custom",
                                                children: [
                                                    '"',
                                                    entry.customMessage,
                                                    '"'
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, entry.id || i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Key Dates"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-profile-grid",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "First Seen"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: $163f137fdcc9a190$var$formatDate(visitor.createdAt)
                                    })
                                ]
                            }),
                            visitor.updatedAt && visitor.updatedAt !== visitor.createdAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Last Activity"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: $163f137fdcc9a190$var$formatDate(visitor.updatedAt)
                                    })
                                ]
                            }),
                            visitor.contactCapturedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Contact Captured"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: $163f137fdcc9a190$var$formatDate(visitor.contactCapturedAt)
                                    })
                                ]
                            }),
                            visitor.paidAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-profile-field",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-label",
                                        children: "Paid"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mkt-field-value",
                                        children: $163f137fdcc9a190$var$formatDate(visitor.paidAt)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mkt-note-form",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                className: "mkt-textarea",
                                placeholder: "Add a note...",
                                value: noteText,
                                onChange: (e)=>setNoteText(e.target.value),
                                rows: 2
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: handleAddNote,
                                className: "mkt-btn mkt-btn-secondary",
                                disabled: !noteText.trim() || addNote.isPending,
                                children: addNote.isPending ? 'Adding...' : 'Add Note'
                            })
                        ]
                    }),
                    visitor.notes?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-notes-list",
                        children: visitor.notes.map((note)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-note",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-note-header",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-note-author",
                                                children: note.authorName
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mkt-note-time",
                                                children: $163f137fdcc9a190$var$formatDate(note.createdAt)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mkt-note-content",
                                        children: note.content
                                    })
                                ]
                            }, note.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mkt-profile-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Timeline"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mkt-timeline",
                        children: (visitor.timeline || []).map((event, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mkt-timeline-event",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mkt-timeline-icon",
                                        children: $163f137fdcc9a190$var$TIMELINE_ICONS[event.type] || "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mkt-timeline-body",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mkt-timeline-title",
                                                children: $163f137fdcc9a190$var$formatEventType(event.type)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mkt-timeline-time",
                                                children: $163f137fdcc9a190$var$formatDate(event.timestamp)
                                            }),
                                            event.data && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mkt-timeline-data",
                                                children: $163f137fdcc9a190$var$renderEventData(event)
                                            })
                                        ]
                                    })
                                ]
                            }, idx))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69776ea6eb0ca5c8$export$2e2bcd8739ae039), {
                visitor: composeVisitor,
                isOpen: outreachOpen,
                onClose: ()=>setOutreachOpen(false)
            })
        ]
    });
}
function $163f137fdcc9a190$var$formatStage(stage) {
    const labels = {
        landing: 'Landed',
        start: 'Start Page',
        business: 'Business Info',
        analysis: 'Analysis & Contact',
        contact: 'Analysis & Contact',
        countries: 'Countries',
        details: 'Details',
        checkout: 'Checkout',
        quote: 'Quote Requested',
        paid: 'Paid',
        anonymous: 'Anonymous',
        dropped_off: 'Dropped Off'
    };
    return labels[stage] || stage;
}
function $163f137fdcc9a190$var$formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}
function $163f137fdcc9a190$var$formatEventType(type) {
    const labels = {
        visitor_landed: 'Visitor Landed',
        tracking_captured: 'Tracking Captured',
        wizard_started: 'Wizard Started',
        step_start: 'Get Started Clicked',
        step_business: 'Business Step',
        step_analysis: 'Analysis Step',
        step_contact: 'Contact Captured',
        step_countries: 'Countries Step',
        step_details: 'Details Step',
        step_checkout: 'Checkout Step',
        step_quote: 'Quote Requested',
        analysis_triggered: 'Analysis Triggered',
        analysis_completed: 'Analysis Completed',
        contact_captured: 'Contact Captured',
        countries_selected: 'Countries Selected',
        payment_complete: 'Payment Complete',
        ai_cost: 'AI Usage',
        note_added: 'Note Added',
        follow_up_sent: 'Follow-up Sent',
        status_change: 'Status Changed'
    };
    return labels[type] || type;
}
function $163f137fdcc9a190$var$renderEventData(event) {
    const { type: type, data: data } = event;
    if (!data) return null;
    switch(type){
        case 'visitor_landed':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    data.trafficSource && `Source: ${data.trafficSource}`,
                    data.landingPage && ` \xb7 Page: ${data.landingPage}`,
                    data.isReturning && " \xb7 Returning"
                ]
            });
        case 'tracking_captured':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    data.source && `Source: ${data.source}`,
                    data.campaign && ` \xb7 Campaign: ${data.campaign}`,
                    data.landingPage && ` \xb7 Page: ${data.landingPage}`
                ]
            });
        case 'wizard_started':
            return data.trademarkName ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    "Trademark: \u201C",
                    data.trademarkName,
                    "\u201D"
                ]
            }) : null;
        case 'analysis_completed':
            return data.riskLevel ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    "Risk: ",
                    data.riskLevel
                ]
            }) : null;
        case 'contact_captured':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    data.name,
                    " \xb7 ",
                    data.email
                ]
            });
        case 'countries_selected':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    data.countries?.join(', '),
                    data.total ? ` \xb7 $${data.total.toLocaleString()}` : ''
                ]
            });
        case 'payment_complete':
            return data.transactionValue ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    "$",
                    data.transactionValue.toLocaleString(),
                    " ",
                    data.currency || ''
                ]
            }) : data.amount ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    "$",
                    data.amount.toLocaleString()
                ]
            }) : null;
        case 'ai_cost':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    data.type,
                    " \xb7 ",
                    data.model,
                    " \xb7 $",
                    (data.cost || 0).toFixed(3)
                ]
            });
        case 'note_added':
            return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: data.content
            });
        default:
            return null;
    }
}
var $163f137fdcc9a190$export$2e2bcd8739ae039 = $163f137fdcc9a190$var$VisitorProfile;



/**
 * Marketing Ops Dashboard
 * Admin-only access — redirects non-admins to /dashboard (no error page, no 403).
 * Same pattern as AttorneyApp but gated on admin role instead of law firm.
 */ function $7d0ad7c6fc12ac7c$var$MarketingApp() {
    const { isLoaded: isLoaded, isSignedIn: isSignedIn } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { data: firmData, isLoading: firmLoading } = (0, $8d1d9ca1d65e0e94$export$45e2f284f78f9fbf)();
    // Must be admin (internal MarkoTM org member with admin role)
    const isAdmin = firmData?.permissions?.isAdmin === true;
    const isInternal = firmData?.firm?.isInternal === true;
    const hasAccess = isAdmin && isInternal;
    if (!isLoaded || firmLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mkt-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mkt-loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Loading..."
            })
        ]
    });
    // Non-admin or not signed in → redirect to dashboard (404-like, don't reveal route)
    if (!isSignedIn || !hasAccess) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/dashboard",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32ae0b7b7002cb4d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: "pipeline",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "pipeline",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8007d7fb2c6943e7$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "funnel",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e66b5f48c3a9961f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "feedback",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adec85e0c38f4c10$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "search",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c80190aff99a39$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "assistant",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76facf3a000d9da6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "tmwatch",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b9a1699a3a56a1a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "reports",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f18fe9aa2e75117$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "reports/:id",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb608f7a192aafc4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "visitor/:id",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163f137fdcc9a190$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                        to: "pipeline",
                        replace: true
                    })
                })
            ]
        })
    });
}
var $7d0ad7c6fc12ac7c$export$2e2bcd8739ae039 = $7d0ad7c6fc12ac7c$var$MarketingApp;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



// Create context
const $87786cc7e09b5647$var$TrademarkContext = /*#__PURE__*/ (0, $acw62.createContext)();
// Initial state - integrated with application system
const $87786cc7e09b5647$var$initialState = {
    trademarks: [],
    activeTrademark: null,
    userInfo: null,
    loading: false,
    error: null,
    clerkUserId: null,
    visionAnalysisStatus: null,
    visionAnalysisError: null
};
// Reducer function - simplified to focus only on trademark management
const $87786cc7e09b5647$var$trademarkReducer = (state, action)=>{
    switch(action.type){
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.payload
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case 'SET_USER_INFO':
            return {
                ...state,
                userInfo: action.payload,
                loading: false
            };
        case 'UPDATE_USER_INFO':
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    ...action.payload
                },
                loading: false
            };
        case 'SET_TRADEMARKS':
            return {
                ...state,
                trademarks: action.payload,
                // Automatically set the first trademark as active if there isn't already an active one
                activeTrademark: state.activeTrademark || (action.payload && action.payload.length > 0 ? action.payload[0] : null),
                loading: false
            };
        case 'ADD_TRADEMARK':
            // Ensure we don't add duplicates
            const isDuplicate = state.trademarks.some((tm)=>tm.id === action.payload.id);
            if (isDuplicate) return state;
            // Add the new trademark to the array
            return {
                ...state,
                trademarks: [
                    ...state.trademarks,
                    action.payload
                ],
                loading: false
            };
        case 'SET_ACTIVE_TRADEMARK':
            return {
                ...state,
                activeTrademark: action.payload,
                loading: false
            };
        case 'SET_CLERK_USER_ID':
            return {
                ...state,
                clerkUserId: action.payload
            };
        case 'SET_VISION_ANALYSIS_STATUS':
            return {
                ...state,
                visionAnalysisStatus: action.payload.status,
                visionAnalysisError: action.payload.error
            };
        case 'UPDATE_TRADEMARK':
            return {
                ...state,
                trademarks: state.trademarks.map((trademark)=>trademark.id === action.payload.id ? action.payload : trademark),
                activeTrademark: state.activeTrademark?.id === action.payload.id ? action.payload : state.activeTrademark,
                loading: false
            };
        case 'RESET_STATE':
            return {
                ...$87786cc7e09b5647$var$initialState
            };
        default:
            return state;
    }
};
const $87786cc7e09b5647$export$4b695f6ea9b332d9 = ({ children: children })=>{
    const [state, dispatch] = (0, $acw62.useReducer)($87786cc7e09b5647$var$trademarkReducer, $87786cc7e09b5647$var$initialState);
    // Get current application ID and thread ID from user application context
    const { currentApplicationId: currentApplicationId, currentThreadId: currentThreadId } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    // 🔐 CANONICAL AUTH GUARD: Load trademarks with proper auth guards
    (0, $acw62.useEffect)(()=>{
        // Multi-stage auth readiness check
        const authReady = user?.id && user.isLoading !== true; // Fix: Handle undefined Clerk properties
        const appReady = currentApplicationId;
        console.log("\uD83D\uDD0D TrademarkContext useEffect triggered (CANONICAL PATTERN):", {
            'user?.id': user?.id,
            'user.isLoading': user?.isLoading,
            'user.isSignedIn': user?.isSignedIn,
            'authReady': authReady,
            'currentApplicationId': currentApplicationId,
            'appReady': appReady,
            'readyToLoad': authReady && appReady
        });
        if (authReady && appReady) {
            console.log("\u2705 TrademarkContext: Auth and app ready, loading trademarks for application:", currentApplicationId);
            loadTrademarksForApplication(currentApplicationId);
        } else if (!currentApplicationId) {
            console.log("\u274C TrademarkContext: No currentApplicationId, clearing data");
            dispatch({
                type: 'SET_TRADEMARKS',
                payload: []
            });
            dispatch({
                type: 'SET_ACTIVE_TRADEMARK',
                payload: null
            });
        } else console.log("\uD83D\uDD04 TrademarkContext: Waiting for auth or app context to be ready...");
    }, [
        user?.id,
        user?.isLoading,
        user?.isSignedIn,
        currentApplicationId
    ]);
    // Separate useEffect for Vision API completion event handling
    (0, $acw62.useEffect)(()=>{
        const handleTrademarkVisionCompleted = async (event)=>{
            const { trademarkId: trademarkId } = event.detail;
            console.log("\uD83D\uDD04 TrademarkContext: Vision API completed for trademark:", trademarkId);
            // Reload the specific trademark to get updated textDescription
            try {
                const updatedTrademark = await (0, $c6f15fd1cca43850$export$c886523079b18bf8).getTrademark(trademarkId);
                console.log("\uD83D\uDD04 Reloaded trademark after vision processing - FULL OBJECT:", JSON.stringify(updatedTrademark, null, 2));
                console.log("\uD83D\uDD04 textDescription specifically:", updatedTrademark.textDescription);
                console.log("\uD83D\uDD04 Current activeTrademark before update:", state.activeTrademark);
                dispatch({
                    type: 'UPDATE_TRADEMARK',
                    payload: updatedTrademark
                });
                // If this is the active trademark, update it too
                if (state.activeTrademark?.id === trademarkId) {
                    console.log("\uD83D\uDD04 Updating activeTrademark because IDs match:", trademarkId);
                    dispatch({
                        type: 'SET_ACTIVE_TRADEMARK',
                        payload: updatedTrademark
                    });
                } else console.log("\uD83D\uDD04 Not updating activeTrademark - IDs do not match:", {
                    activeId: state.activeTrademark?.id,
                    updatedId: trademarkId
                });
                console.log("\uD83D\uDD04 activeTrademark after update should have textDescription:", updatedTrademark.textDescription);
            } catch (error) {
                console.error('Error reloading trademark after vision processing:', error);
            }
        };
        window.addEventListener('trademark_vision_completed', handleTrademarkVisionCompleted);
        return ()=>{
            window.removeEventListener('trademark_vision_completed', handleTrademarkVisionCompleted);
        };
    }, [
        user?.id
    ]); // Only depend on user?.id, not currentApplicationId
    // Load trademarks for a specific application - EXACT SAME PATTERN AS BusinessContext
    const loadTrademarksForApplication = async (applicationId)=>{
        try {
            if (!applicationId) {
                console.error('loadTrademarksForApplication called with empty applicationId!');
                return;
            }
            console.log("\uD83D\uDD0D TrademarkContext: loadTrademarksForApplication called with:", applicationId); // This will show the full call stack
            dispatch({
                type: 'SET_LOADING',
                payload: true
            });
            const trademarkData = await (0, $c6f15fd1cca43850$export$c886523079b18bf8).getTrademarksByApplication(applicationId);
            dispatch({
                type: 'SET_TRADEMARKS',
                payload: trademarkData
            });
            // Set the first trademark as active if available
            if (trademarkData && trademarkData.length > 0) dispatch({
                type: 'SET_ACTIVE_TRADEMARK',
                payload: trademarkData[0]
            });
            else dispatch({
                type: 'SET_ACTIVE_TRADEMARK',
                payload: null
            });
            dispatch({
                type: 'SET_LOADING',
                payload: false
            });
        } catch (error) {
            console.error('TrademarkContext: Error loading trademarks for application:', error);
            dispatch({
                type: 'SET_ERROR',
                payload: error.message
            });
            dispatch({
                type: 'SET_LOADING',
                payload: false
            });
        }
    };
    // Get a specific trademark by ID
    const getTrademark = async (id)=>{
        try {
            dispatch({
                type: 'SET_LOADING',
                payload: true
            });
            const trademark = await (0, $c6f15fd1cca43850$export$c886523079b18bf8).getTrademark(id);
            dispatch({
                type: 'SET_ACTIVE_TRADEMARK',
                payload: trademark
            });
            return trademark;
        } catch (error) {
            dispatch({
                type: 'SET_ERROR',
                payload: error.message || 'Error fetching trademark'
            });
            // Don't throw error - let UI continue functioning
            return null;
        }
    };
    // Upload a new trademark (image or name)
    const uploadTrademark = async (data)=>{
        try {
            dispatch({
                type: 'SET_LOADING',
                payload: true
            });
            // Ensure we have a file or name - should never happen due to UI validation
            if (!data.file && !data.name) throw new Error('No file or trademark name provided');
            // Add application ID to the trademark data
            const applicationId = currentApplicationId || sessionStorage.getItem('currentApplicationId');
            const trademarkData = {
                ...data,
                applicationId: applicationId
            };
            // Create the trademark
            const trademark = await (0, $c6f15fd1cca43850$export$c886523079b18bf8).createTrademark(trademarkData);
            // If we have a file, upload it
            if (data.file) {
                await (0, $c6f15fd1cca43850$export$c886523079b18bf8).uploadImage(trademark.id, data.file);
                // Trigger Vision API processing in the background
                dispatch({
                    type: 'UPDATE_USER_INFO',
                    payload: {
                        visionAnalysisStatus: 'pending',
                        visionAnalysisError: null
                    }
                });
                // Process with Vision API in the background
                processTrademarkWithVisionAPI(trademark.id);
            }
            dispatch({
                type: 'ADD_TRADEMARK',
                payload: trademark
            });
            dispatch({
                type: 'SET_ACTIVE_TRADEMARK',
                payload: trademark
            });
            return trademark;
        } catch (error) {
            dispatch({
                type: 'SET_ERROR',
                payload: error.message || 'Error uploading trademark'
            });
            // Create a temporary local trademark object with minimal data
            // This allows the UI flow to continue without a backend
            const tempTrademark = {
                id: 'temp-' + Date.now(),
                name: data.name || 'Untitled Trademark',
                createdAt: new Date().toISOString(),
                status: 'draft'
            };
            dispatch({
                type: 'ADD_TRADEMARK',
                payload: tempTrademark
            });
            dispatch({
                type: 'SET_ACTIVE_TRADEMARK',
                payload: tempTrademark
            });
            return tempTrademark;
        }
    };
    // Update user info
    const updateUserInfo = (info)=>{
        dispatch({
            type: 'UPDATE_USER_INFO',
            payload: info
        });
        return info;
    };
    // Reset state (e.g., when starting a new trademark)
    const resetState = ()=>{
        dispatch({
            type: 'RESET_STATE'
        });
    };
    // Update Clerk User ID
    const setClerkUserId = (userId)=>{
        dispatch({
            type: 'SET_CLERK_USER_ID',
            payload: userId
        });
        // No need to transfer session data since we're using authentication-only approach
        return userId;
    };
    // Process trademark with Vision API
    const processTrademarkWithVisionAPI = async (trademarkId)=>{
        try {
            await (0, $c6f15fd1cca43850$export$c886523079b18bf8).processWithVisionAPI(trademarkId);
            // Update the active trademark if it matches the processed trademark
            if (state.activeTrademark && state.activeTrademark.id === trademarkId) {
                const updatedTrademark = await (0, $c6f15fd1cca43850$export$c886523079b18bf8).getTrademark(trademarkId);
                dispatch({
                    type: 'SET_ACTIVE_TRADEMARK',
                    payload: updatedTrademark
                });
            }
            dispatch({
                type: 'SET_VISION_ANALYSIS_STATUS',
                payload: {
                    status: 'complete',
                    error: null
                }
            });
        } catch (error) {
            dispatch({
                type: 'SET_VISION_ANALYSIS_STATUS',
                payload: {
                    status: 'error',
                    error: error.message || 'Error analyzing trademark image'
                }
            });
        }
    };
    const value = (0, $acw62.useMemo)(()=>({
            state: state,
            dispatch: dispatch,
            loadTrademarksForApplication: loadTrademarksForApplication,
            getTrademark: getTrademark,
            uploadTrademark: uploadTrademark,
            updateUserInfo: updateUserInfo,
            resetState: resetState,
            setClerkUserId: setClerkUserId,
            processTrademarkWithVisionAPI: processTrademarkWithVisionAPI
        }), [
        state,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($87786cc7e09b5647$var$TrademarkContext.Provider, {
        value: value,
        children: children
    });
};
const $87786cc7e09b5647$export$ff93b4e94bcf9bc = ()=>{
    const context = (0, $acw62.useContext)($87786cc7e09b5647$var$TrademarkContext);
    if (!context) throw new Error('useTrademark must be used within a TrademarkProvider');
    return context;
};
const $87786cc7e09b5647$export$86880524d6f6c834 = ()=>{
    const { userId: userId, isSignedIn: isSignedIn } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const [hasInitialized, setHasInitialized] = (0, $acw62.useState)(false);
    const previousUserIdRef = (0, $acw62.useRef)(null);
    // Extract only what we need from the context to avoid dependency issues
    const { setClerkUserId: setClerkUserId } = $87786cc7e09b5647$export$ff93b4e94bcf9bc();
    // Effect to handle Clerk authentication state changes
    (0, $acw62.useEffect)(()=>{
        const currentUserId = userId;
        const prevUserId = previousUserIdRef.current;
        // Skip if the user ID hasn't changed
        if (currentUserId === prevUserId) return;
        // Update ref to current userId for future comparisons
        previousUserIdRef.current = currentUserId;
        if (isSignedIn && currentUserId) // Set the user ID in context
        setClerkUserId(currentUserId);
        else if (!isSignedIn && prevUserId !== null) // User logged out
        setClerkUserId(null);
    }, [
        userId,
        isSignedIn,
        setClerkUserId
    ]);
    return null;
};












var $c3b25629722ddda6$var$_queries;
var $c3b25629722ddda6$export$5dde0cd941da8468 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $c3b25629722ddda6$var$_queries);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $c3b25629722ddda6$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $9dc680c629ca4c63$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).has(query.queryHash)) {
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$c3b25629722ddda6$var$_queries = new WeakMap();







var $faef27284cfa645e$var$_mutations, $faef27284cfa645e$var$_scopes, $faef27284cfa645e$var$_mutationId;
var $faef27284cfa645e$export$1fcfd9a244434844 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutations);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $faef27284cfa645e$var$_scopes);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutationId);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutations, /* @__PURE__ */ new Set());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_scopes, /* @__PURE__ */ new Map());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $96f19558542b246f$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++(0, $f48ef6896881c1e3$export$b1fe7cbb4502036b)(this, $faef27284cfa645e$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).add(mutation);
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).delete(mutation)) {
            const scope = $faef27284cfa645e$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).clear();
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $002159551d1c4551$export$8793edee2d425525)))));
    }
};
$faef27284cfa645e$var$_mutations = new WeakMap();
$faef27284cfa645e$var$_scopes = new WeakMap();
$faef27284cfa645e$var$_mutationId = new WeakMap();
function $faef27284cfa645e$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $45a641ae9a292711$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $002159551d1c4551$export$8c6246b73dd61f4a) : (0, $002159551d1c4551$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $45a641ae9a292711$var$getPreviousPageParam : $45a641ae9a292711$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $45a641ae9a292711$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $45a641ae9a292711$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $45a641ae9a292711$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $45a641ae9a292711$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $45a641ae9a292711$var$getNextPageParam(options, data) != null;
}
function $45a641ae9a292711$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $45a641ae9a292711$var$getPreviousPageParam(options, data) != null;
}


var $f71a9ec256bb1e8c$var$_queryCache, $f71a9ec256bb1e8c$var$_mutationCache, $f71a9ec256bb1e8c$var$_defaultOptions, $f71a9ec256bb1e8c$var$_queryDefaults, $f71a9ec256bb1e8c$var$_mutationDefaults, $f71a9ec256bb1e8c$var$_mountCount, $f71a9ec256bb1e8c$var$_unsubscribeFocus, $f71a9ec256bb1e8c$var$_unsubscribeOnline;
var $f71a9ec256bb1e8c$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationCache);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryDefaults);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationDefaults);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mountCount);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus);
        (0, $f48ef6896881c1e3$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryCache, config.queryCache || new (0, $c3b25629722ddda6$export$5dde0cd941da8468)());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationCache, config.mutationCache || new (0, $faef27284cfa645e$export$1fcfd9a244434844)());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, config.defaultOptions || {});
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mountCount, 0);
    }
    mount() {
        (0, $f48ef6896881c1e3$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._++;
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 1) return;
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, (0, $1d15693d13279fb4$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onFocus();
            }
        }));
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $f48ef6896881c1e3$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._--;
        if ((0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 0) return;
        (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (_b = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $002159551d1c4551$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
    }
    getMutationCache() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $f48ef6896881c1e3$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).clear();
        (0, $f48ef6896881c1e3$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).clear();
    }
};
$f71a9ec256bb1e8c$var$_queryCache = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationCache = new WeakMap();
$f71a9ec256bb1e8c$var$_defaultOptions = new WeakMap();
$f71a9ec256bb1e8c$var$_queryDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mountCount = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeFocus = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeOnline = new WeakMap();



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


/**
 * Login component that handles user authentication using Clerk
 * @param {Object} props Component props
 * @param {string} props.mode - 'sign-in' or 'sign-up' mode
 * @param {string} props.redirectUrl - URL to redirect after successful authentication
 * @returns {React.ReactNode} Login component
 */ const $0d79683c929c66dc$var$Login = ({ mode: mode = 'sign-in', redirectUrl: redirectUrl = '/dashboard' })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "max-w-md w-full space-y-8",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "mt-6 text-center text-3xl font-extrabold text-gray-900",
                        children: mode === 'sign-in' ? 'Sign in to your account' : 'Create your account'
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignedIn), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-4",
                                children: "You're already signed in!"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>navigate(redirectUrl),
                                className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                                children: "Go to Dashboard"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignedOut), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10",
                        children: mode === 'sign-in' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignIn), {
                            routing: "path",
                            path: "/sign-in",
                            signUpUrl: "/sign-up",
                            afterSignInUrl: redirectUrl
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignUp), {
                            routing: "path",
                            path: "/sign-up",
                            signInUrl: "/sign-in",
                            afterSignUpUrl: redirectUrl
                        })
                    })
                })
            ]
        })
    });
};

const $0d79683c929c66dc$export$b78a3abd8101bea6 = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    // Import the Button component from common
    const Button = (parcelRequire("fYgYF")).Button;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignedIn), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.UserButton), {
                    afterSignOutUrl: "/"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fcdbf2d7a4660c6$exports.SignedOut), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Button, {
                    onClick: ()=>navigate('/sign-in'),
                    variant: "solid",
                    color: "primary",
                    children: "Sign In"
                })
            })
        ]
    });
};
var $0d79683c929c66dc$export$2e2bcd8739ae039 = $0d79683c929c66dc$var$Login;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * AuthRedirect Component
 * Routes users to the appropriate dashboard after sign-in/sign-up
 *
 * - Attorneys (in law_firms table) → /attorney
 * - Regular users → /dashboard
 */ function $9e6d6ac980f99a6a$var$AuthRedirect() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { isLoaded: userLoaded, isSignedIn: isSignedIn, user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const { data: firmData, isLoading: firmLoading, isFetched: isFetched } = (0, $8d1d9ca1d65e0e94$export$45e2f284f78f9fbf)();
    (0, $acw62.useEffect)(()=>{
        // Wait for auth to load
        if (!userLoaded) return;
        // Not signed in - send to sign-in
        if (!isSignedIn) {
            navigate('/sign-in', {
                replace: true
            });
            return;
        }
        // Wait for firm check to complete
        if (firmLoading || !isFetched) return;
        // Check if user has attorney access
        if (firmData?.hasAccess) navigate('/attorney', {
            replace: true
        });
        else if (user?.publicMetadata?.source === 'quote_request') // Quote-flow users (provisioned at report request, arriving via the
        // report email's magic link) land directly on Quote & Payment
        navigate('/dashboard#payments', {
            replace: true
        });
        else navigate('/dashboard', {
            replace: true
        });
    }, [
        userLoaded,
        isSignedIn,
        firmLoading,
        isFetched,
        firmData,
        user,
        navigate
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "auth-redirect-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-spinner"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Redirecting..."
            })
        ]
    });
}
var $9e6d6ac980f99a6a$export$2e2bcd8739ae039 = $9e6d6ac980f99a6a$var$AuthRedirect;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $2fb01d92d77652d7$var$PaymentSuccess = ()=>{
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [sessionId, setSessionId] = (0, $acw62.useState)('');
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [paymentAmount, setPaymentAmount] = (0, $acw62.useState)(null);
    const { currentApplicationId: currentApplicationId } = (0, $d266a5731496cc13$export$3ea719c054b5ac49)();
    const { user: user } = (0, $8fcdbf2d7a4660c6$exports.useUser)();
    const verifyPaymentMutation = (0, $b26c3cb173b27338$export$75ea99d8e9e7143c)();
    (0, $acw62.useEffect)(()=>{
        const sessionIdFromUrl = searchParams.get('session_id');
        if (sessionIdFromUrl) {
            setSessionId(sessionIdFromUrl);
            // Verify payment status with backend
            verifyPaymentStatus(sessionIdFromUrl);
        } else // No session ID, redirect to dashboard
        navigate('/dashboard');
    }, [
        searchParams,
        navigate
    ]);
    const verifyPaymentStatus = async (sessionId)=>{
        try {
            console.log("\uD83D\uDD0D PaymentSuccess: Starting payment verification for session:", sessionId);
            const result = await verifyPaymentMutation.mutateAsync({
                sessionId: sessionId,
                applicationId: currentApplicationId,
                userId: user?.id
            });
            if (result?.session?.amount_total) {
                const amountInDollars = (result.session.amount_total / 100).toFixed(2);
                setPaymentAmount(amountInDollars);
                console.log("\uD83D\uDCB0 PaymentSuccess: Payment amount set to:", amountInDollars);
            }
            if (result?.paymentStatus === 'paid') console.log("\uD83C\uDF89 PaymentSuccess: Payment confirmed as paid!");
            else console.log("\u26A0\uFE0F PaymentSuccess: Payment not yet paid, status:", result?.paymentStatus);
        } catch (error) {
            console.error("\uD83D\uDCA5 PaymentSuccess: Error verifying payment:", error);
        } finally{
            setIsLoading(false);
        }
    };
    const handleReturnToDashboard = ()=>{
        // Navigate to the Quote & Payment section (shows filing status once paid)
        navigate('/dashboard#payments');
    };
    if (isLoading || verifyPaymentMutation.isPending) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen bg-gray-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-gray-600",
                    children: "Processing your payment..."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen bg-gray-50 flex items-center justify-center p-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                            className: "h-16 w-16 text-green-500 mx-auto mb-4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-900 mb-2",
                            children: "Payment Successful!"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-gray-600",
                            children: "Your trademark application payment has been processed successfully."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg-gray-50 p-4 rounded-lg mb-6 text-left",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "font-semibold text-gray-900 mb-2",
                            children: "Payment Details"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-1 text-sm text-gray-600",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Amount:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-medium",
                                            children: paymentAmount ? `$${paymentAmount} USD` : 'Loading...'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Transaction ID:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "font-mono text-xs",
                                            children: sessionId.slice(-12)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Status:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-green-600 font-medium",
                                            children: "Completed"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-6 text-left",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-semibold text-gray-900 mb-3",
                            children: "What's Next?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-2 text-sm text-gray-600",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-start space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "You'll receive a confirmation email with your receipt"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-start space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Your trademark application will be processed and filed"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-start space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Track your application status in your dashboard"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: handleReturnToDashboard,
                    className: "w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center space-x-2 font-medium",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "View Filing Status"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            className: "h-4 w-4"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "mt-6 text-xs text-gray-500",
                    children: [
                        "Questions? Contact our support team at",
                        ' ',
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "mailto:support@markotm.com",
                            className: "text-blue-600 hover:underline",
                            children: "support@markotm.com"
                        })
                    ]
                })
            ]
        })
    });
};
var $2fb01d92d77652d7$export$2e2bcd8739ae039 = $2fb01d92d77652d7$var$PaymentSuccess;



var $acw62 = parcelRequire("acw62");


function $341366160282dc54$export$6474d2e7155d1a73() {
    const { getToken: getToken, isSignedIn: isSignedIn } = (0, $8fcdbf2d7a4660c6$exports.useAuth)();
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        async function syncToken() {
            if (!isSignedIn) {
                (0, $3c65d59c1a1073f7$export$ba111104b5f1064a)();
                return;
            }
            try {
                const token = await getToken();
                if (mounted && token) (0, $3c65d59c1a1073f7$export$cacee9aa3f16fd0e)(token);
            } catch (error) {
                console.error('[ClerkTokenSync] Error getting token:', error);
            }
        }
        syncToken();
        // Refresh token periodically (every 30 seconds)
        const interval = setInterval(syncToken, 30000);
        return ()=>{
            mounted = false;
            clearInterval(interval);
        };
    }, [
        getToken,
        isSignedIn
    ]);
    return null; // This component doesn't render anything
}



// Direct use of Clerk Publishable Key
const $1b8e0994176c9ade$var$CLERK_PUBLISHABLE_KEY = "pk_live_Y2xlcmsubWFya290bS5jb20k";
if (!$1b8e0994176c9ade$var$CLERK_PUBLISHABLE_KEY) throw new Error("Missing Clerk Publishable Key");
// Initialize telemetry on app load
(0, $dcc07888711c910b$export$f96764aa1ab48e76)();
const $1b8e0994176c9ade$var$queryClient = new (0, $f71a9ec256bb1e8c$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 30000
        }
    }
});
function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa7071e0f713f419$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aeeeb04cd6721116$export$45604f0cc8ae667b), {
            client: $1b8e0994176c9ade$var$queryClient,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8fcdbf2d7a4660c6$exports.ClerkProvider), {
                publishableKey: $1b8e0994176c9ade$var$CLERK_PUBLISHABLE_KEY,
                appearance: (0, $717fd9c50d7f81b3$export$2e2bcd8739ae039).appearance,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $341366160282dc54$export$6474d2e7155d1a73), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d266a5731496cc13$export$2601991d4c6a8be8), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87786cc7e09b5647$export$4b695f6ea9b332d9), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df0f5973e96e353e$export$202bc391a3eb96a), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a05168b77183bb44$export$186b91822010e97f), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87786cc7e09b5647$export$86880524d6f6c834), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "min-h-screen flex flex-col",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                                                to: "/dashboard",
                                                                replace: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/sign-in/*",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d79683c929c66dc$export$2e2bcd8739ae039), {
                                                                mode: "sign-in",
                                                                redirectUrl: "/auth-redirect"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/sign-up/*",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d79683c929c66dc$export$2e2bcd8739ae039), {
                                                                mode: "sign-up",
                                                                redirectUrl: "/auth-redirect"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/auth-redirect",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9e6d6ac980f99a6a$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/dashboard/*",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $391aa6d316dff2c7$export$fe82a520fc33e5f4), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/payment/success",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fb01d92d77652d7$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/admin",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3be64279cc34b34$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3a550605ce2db2b$export$2e2bcd8739ae039), {})
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/attorney/*",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3be64279cc34b34$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe3691fadd7ea4$export$2e2bcd8739ae039), {})
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "/marketing/*",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3be64279cc34b34$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d0ad7c6fc12ac7c$export$2e2bcd8739ae039), {})
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                                            path: "*",
                                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                                                to: "/dashboard",
                                                                replace: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}




const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=IamSafeIP.7b2a12a2.js.map
